"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from2, except, desc) => {
  if (from2 && typeof from2 === "object" || typeof from2 === "function") {
    for (let key of __getOwnPropNames(from2))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from2[key], enumerable: !(desc = __getOwnPropDesc(from2, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// index.ts
var src_exports = {};
__export(src_exports, {
  Banner: () => Banner,
  Button: () => Button2,
  ButtonScroll: () => ButtonScroll,
  Card: () => Card,
  Cartesian: () => Cartesian,
  Checkbox: () => Checkbox,
  CodeEditor: () => CodeEditor,
  CodeSnippet: () => CodeSnippet2,
  Collapse: () => Collapse,
  DatePicker: () => DatePicker,
  DateTimePicker: () => DateTimePicker2,
  Dialog: () => Dialog,
  Drawer: () => Drawer,
  Dropdown: () => Dropdown,
  Expander: () => Expander,
  FEATURE_FLAG_LIGHT_THEME: () => FEATURE_FLAG_LIGHT_THEME,
  FlowMap: () => FlowMap2,
  FocusManager: () => FocusManager3,
  Form: () => Form4,
  Grid: () => Grid,
  Heading: () => Heading3,
  HealthBar: () => HealthBar,
  Icon: () => Icon,
  Illustration: () => Illustration2,
  Input: () => Input2,
  Layout: () => Layout,
  Legend: () => Legend2,
  List: () => List5,
  Loading: () => Loading2,
  Lookup: () => Lookup,
  MAGNETIC_TOKENS: () => MAGNETIC_TOKENS,
  MONACO: () => MONACO,
  Measurer: () => Measurer9,
  Menu: () => Menu3,
  Overlay: () => Overlay8,
  Pill: () => Pill,
  Popover: () => Popover7,
  QuickFilter: () => QuickFilter,
  Radio: () => Radio2,
  Repeater: () => Repeater,
  ResizeBox: () => ResizeBox,
  ScrollBox: () => ScrollBox9,
  SearchBox: () => SearchBox3,
  Select: () => Select3,
  SelectionTile: () => SelectionTile,
  Slider: () => Slider4,
  SparkGraph: () => SparkGraph,
  Spinner: () => Spinner,
  TOKENS: () => TOKENS,
  TabList: () => TabList,
  Tag: () => Tag9,
  Textarea: () => Textarea,
  ThemeSwitch: () => ThemeSwitch,
  TimePicker: () => TimePicker2,
  TimeRangeSelector: () => TimeRangeSelector,
  TimelineBar: () => TimelineBar,
  Toggle: () => Toggle2,
  ToggleSwitch: () => ToggleSwitch,
  Tooltip: () => Tooltip7,
  Uik: () => Uik,
  Wizard: () => Wizard,
  css: () => css,
  format: () => format,
  toast: () => toast,
  utils: () => utils_exports
});
module.exports = __toCommonJS(src_exports);

// utils/index.ts
var utils_exports = {};
__export(utils_exports, {
  FOCUSABLE_SELECTOR: () => FOCUSABLE_SELECTOR,
  color: () => color,
  do: () => import_utils5.Do,
  focusFirst: () => focusFirst,
  isVisible: () => isVisible,
  let: () => import_utils5.Let,
  useReducer: () => useReducer,
  useUnmountedRef: () => useUnmountedRef
});

// utils/color/parse/hex.ts
var import_utils3 = require("@appd/utils");

// utils/color/parse/clampAndRound/hsl.ts
var import_utils = require("@appd/utils");
function hsl(color2, checkFinite) {
  const { a, h, l, s } = color2;
  return checkFinite && !(isFinite(h) && isFinite(s) && isFinite(l) && isFinite(a)) ? null : {
    a: (0, import_utils.clamp)(Math.round(1e3 * a) / 1e3, [0, 1]),
    h: (Math.round(h) % 360 + 360) % 360,
    l: (0, import_utils.clamp)(Math.round(100 * l) / 100, [0, 1]),
    s: (0, import_utils.clamp)(Math.round(100 * s) / 100, [0, 1])
  };
}
__name(hsl, "hsl");

// utils/color/parse/clampAndRound/rgb.ts
var import_utils2 = require("@appd/utils");
function rgb(color2, checkFinite) {
  const { a, b, g, r } = color2;
  return checkFinite && !(isFinite(r) && isFinite(g) && isFinite(b) && isFinite(a)) ? null : {
    a: (0, import_utils2.clamp)(Math.round(1e3 * a) / 1e3, [0, 1]),
    b: (0, import_utils2.clamp)(Math.round(b), [0, 255]),
    g: (0, import_utils2.clamp)(Math.round(g), [0, 255]),
    r: (0, import_utils2.clamp)(Math.round(r), [0, 255])
  };
}
__name(rgb, "rgb");

// utils/color/parse/clampAndRound/clampAndRound.ts
var clampAndRound = {
  hsl,
  rgb
};

// utils/color/parse/hex.ts
function hex(color2) {
  if (color2.startsWith("#")) {
    const value = (0, import_utils3.clamp)(parseInt(color2.slice(1), 16), [0]);
    if (isFinite(value)) {
      switch (color2.length) {
        case 4:
          return {
            a: 1,
            b: 17 * (15 & value),
            g: 17 * ((240 & value) >>> 4),
            r: 17 * ((3840 & value) >>> 8)
          };
        case 5:
          return clampAndRound.rgb(
            {
              a: 17 * (15 & value) / 255,
              b: 17 * (240 & value) >>> 4,
              g: 17 * (3840 & value) >>> 8,
              r: 17 * (61440 & value) >>> 12
            },
            false
          );
        case 7: {
          return {
            a: 1,
            b: 255 & value,
            g: (65280 & value) >>> 8,
            r: (16711680 & value) >>> 16
          };
        }
        case 9: {
          return clampAndRound.rgb(
            {
              a: (255 & value) / 255,
              b: (65280 & value) >>> 8,
              g: (16711680 & value) >>> 16,
              r: (4278190080 & value) >>> 24
            },
            false
          );
        }
        default:
      }
    }
  }
  return null;
}
__name(hex, "hex");

// utils/color/parse/angle.ts
function angle(angle2) {
  const rawValue = parseFloat(angle2);
  if (isFinite(rawValue)) {
    if (angle2.endsWith("deg")) {
      return rawValue;
    } else if (angle2.endsWith("grad")) {
      return rawValue * 0.9;
    } else if (angle2.endsWith("rad")) {
      return rawValue / Math.PI * 180;
    } else if (angle2.endsWith("turn")) {
      return rawValue * 360;
    }
  }
  return null;
}
__name(angle, "angle");

// utils/color/parse/argsList.ts
function argsList(args) {
  args = args.trim();
  const containsComma = args.includes(",");
  const containsSlash = args.includes("/");
  const checkLength = /* @__PURE__ */ __name((parts) => parts.length === 3 || parts.length === 4 ? parts : [], "checkLength");
  if (containsComma && !containsSlash) {
    return checkLength(args.split(/ *, */));
  } else if (!containsComma) {
    const [threeOrFourParts, lastPart, junk] = args.split(/ *\/ */);
    if (threeOrFourParts && !junk) {
      const leftParts = threeOrFourParts.split(/ +/);
      if (containsSlash && lastPart && leftParts.length === 3) {
        return [...leftParts, lastPart];
      } else if (!containsSlash) {
        return checkLength(leftParts);
      }
    }
  }
  return [];
}
__name(argsList, "argsList");

// utils/color/parse/percent.ts
function percent(percent3) {
  const rawValue = parseFloat(percent3);
  if (isFinite(rawValue) && percent3.endsWith("%")) {
    return rawValue / 100;
  }
  return null;
}
__name(percent, "percent");

// utils/color/parse/transform/hslToRgb.ts
function hslToRgb(color2) {
  const { a, h, l, s } = clampAndRound.hsl(color2, false);
  const offset = /* @__PURE__ */ __name((n) => (n + h / 30) % 12, "offset");
  const scale = s * Math.min(l, 1 - l);
  const f = /* @__PURE__ */ __name((n) => {
    const k = offset(n);
    return 255 * (l - scale * Math.max(-1, Math.min(k - 3, 9 - k, 1)));
  }, "f");
  return clampAndRound.rgb(
    {
      a,
      b: f(4),
      g: f(8),
      r: f(0)
    },
    false
  );
}
__name(hslToRgb, "hslToRgb");

// utils/color/parse/transform/rgbToHsl.ts
function rgbToHsl(color2) {
  const { a, b: rawB, g: rawG, r: rawR } = clampAndRound.rgb(color2, false);
  const [r, g, b] = [rawR, rawG, rawB].map((component) => component / 255);
  const xMax = Math.max(r, g, b);
  const xMin = Math.min(r, g, b);
  const l = (xMax + xMin) / 2;
  const c = xMax - xMin;
  const h = 60 * (() => {
    switch (xMax) {
      case xMin:
        return 0;
      case r:
        return (g - b) / c;
      case g:
        return 2 + (b - r) / c;
      case b:
        return 4 + (r - g) / c;
      default:
        return NaN;
    }
  })();
  const s = l === 0 || l === 1 ? 0 : (xMax - l) / Math.min(l, 1 - l);
  return clampAndRound.hsl(
    {
      a,
      h,
      l,
      s
    },
    false
  );
}
__name(rgbToHsl, "rgbToHsl");

// utils/color/parse/transform/transform.ts
var transform = {
  hslToRgb,
  rgbToHsl
};

// utils/color/parse/hsl.ts
function hsl2(color2) {
  if (color2.startsWith("hsl") && color2.endsWith(")")) {
    const rawArgsList = color2.slice(color2.indexOf("(") + 1, -1);
    const args = argsList(rawArgsList);
    if (args.length) {
      const [rawH, rawS, rawL, rawA = "1"] = args;
      const h = angle(rawH) ?? parseFloat(rawH);
      const s = percent(rawS);
      const l = percent(rawL);
      const ifDefined = /* @__PURE__ */ __name((value, defaultValue) => value !== null ? value : defaultValue, "ifDefined");
      const a = ifDefined(percent(rawA), parseFloat(rawA));
      if (isFinite(h) && s !== null && l !== null) {
        return clampAndRound.rgb(
          transform.hslToRgb({
            a,
            h,
            l,
            s
          }),
          true
        );
      }
    }
  }
  return null;
}
__name(hsl2, "hsl");

// utils/color/parse/keyword.ts
var import_utils4 = require("@appd/utils");

// utils/color/KEYWORDS.ts
var KEYWORDS;
((KEYWORDS2) => {
  KEYWORDS2.black = "#000000";
  KEYWORDS2.silver = "#c0c0c0";
  KEYWORDS2.gray = "#808080";
  KEYWORDS2.white = "#ffffff";
  KEYWORDS2.maroon = "#800000";
  KEYWORDS2.red = "#ff0000";
  KEYWORDS2.purple = "#800080";
  KEYWORDS2.fuchsia = "#ff00ff";
  KEYWORDS2.green = "#008000";
  KEYWORDS2.lime = "#00ff00";
  KEYWORDS2.olive = "#808000";
  KEYWORDS2.yellow = "#ffff00";
  KEYWORDS2.navy = "#000080";
  KEYWORDS2.blue = "#0000ff";
  KEYWORDS2.teal = "#008080";
  KEYWORDS2.aqua = "#00ffff";
  KEYWORDS2.orange = "#ffa500";
  KEYWORDS2.aliceblue = "#f0f8ff";
  KEYWORDS2.antiquewhite = "#faebd7";
  KEYWORDS2.aquamarine = "#7fffd4";
  KEYWORDS2.azure = "#f0ffff";
  KEYWORDS2.beige = "#f5f5dc";
  KEYWORDS2.bisque = "#ffe4c4";
  KEYWORDS2.blanchedalmond = "#ffebcd";
  KEYWORDS2.blueviolet = "#8a2be2";
  KEYWORDS2.brown = "#a52a2a";
  KEYWORDS2.burlywood = "#deb887";
  KEYWORDS2.cadetblue = "#5f9ea0";
  KEYWORDS2.chartreuse = "#7fff00";
  KEYWORDS2.chocolate = "#d2691e";
  KEYWORDS2.coral = "#ff7f50";
  KEYWORDS2.cornflowerblue = "#6495ed";
  KEYWORDS2.cornsilk = "#fff8dc";
  KEYWORDS2.crimson = "#dc143c";
  KEYWORDS2.cyan = KEYWORDS2.aqua;
  KEYWORDS2.darkblue = "#00008b";
  KEYWORDS2.darkcyan = "#008b8b";
  KEYWORDS2.darkgoldenrod = "#b8860b";
  KEYWORDS2.darkgray = "#a9a9a9";
  KEYWORDS2.darkgreen = "#006400";
  KEYWORDS2.darkgrey = KEYWORDS2.darkgray;
  KEYWORDS2.darkkhaki = "#bdb76b";
  KEYWORDS2.darkmagenta = "#8b008b";
  KEYWORDS2.darkolivegreen = "#556b2f";
  KEYWORDS2.darkorange = "#ff8c00";
  KEYWORDS2.darkorchid = "#9932cc";
  KEYWORDS2.darkred = "#8b0000";
  KEYWORDS2.darksalmon = "#e9967a";
  KEYWORDS2.darkseagreen = "#8fbc8f";
  KEYWORDS2.darkslateblue = "#483d8b";
  KEYWORDS2.darkslategray = "#2f4f4f";
  KEYWORDS2.darkslategrey = KEYWORDS2.darkslategray;
  KEYWORDS2.darkturquoise = "#00ced1";
  KEYWORDS2.darkviolet = "#9400d3";
  KEYWORDS2.deeppink = "#ff1493";
  KEYWORDS2.deepskyblue = "#00bfff";
  KEYWORDS2.dimgray = "#696969";
  KEYWORDS2.dimgrey = KEYWORDS2.dimgray;
  KEYWORDS2.dodgerblue = "#1e90ff";
  KEYWORDS2.firebrick = "#b22222";
  KEYWORDS2.floralwhite = "#fffaf0";
  KEYWORDS2.forestgreen = "#228b22";
  KEYWORDS2.gainsboro = "#dcdcdc";
  KEYWORDS2.ghostwhite = "#f8f8ff";
  KEYWORDS2.gold = "#ffd700";
  KEYWORDS2.goldenrod = "#daa520";
  KEYWORDS2.greenyellow = "#adff2f";
  KEYWORDS2.grey = KEYWORDS2.gray;
  KEYWORDS2.honeydew = "#f0fff0";
  KEYWORDS2.hotpink = "#ff69b4";
  KEYWORDS2.indianred = "#cd5c5c";
  KEYWORDS2.indigo = "#4b0082";
  KEYWORDS2.ivory = "#fffff0";
  KEYWORDS2.khaki = "#f0e68c";
  KEYWORDS2.lavender = "#e6e6fa";
  KEYWORDS2.lavenderblush = "#fff0f5";
  KEYWORDS2.lawngreen = "#7cfc00";
  KEYWORDS2.lemonchiffon = "#fffacd";
  KEYWORDS2.lightblue = "#add8e6";
  KEYWORDS2.lightcoral = "#f08080";
  KEYWORDS2.lightcyan = "#e0ffff";
  KEYWORDS2.lightgoldenrodyellow = "#fafad2";
  KEYWORDS2.lightgray = "#d3d3d3";
  KEYWORDS2.lightgreen = "#90ee90";
  KEYWORDS2.lightgrey = KEYWORDS2.lightgray;
  KEYWORDS2.lightpink = "#ffb6c1";
  KEYWORDS2.lightsalmon = "#ffa07a";
  KEYWORDS2.lightseagreen = "#20b2aa";
  KEYWORDS2.lightskyblue = "#87cefa";
  KEYWORDS2.lightslategray = "#778899";
  KEYWORDS2.lightslategrey = KEYWORDS2.lightslategray;
  KEYWORDS2.lightsteelblue = "#b0c4de";
  KEYWORDS2.lightyellow = "#ffffe0";
  KEYWORDS2.limegreen = "#32cd32";
  KEYWORDS2.linen = "#faf0e6";
  KEYWORDS2.magenta = KEYWORDS2.fuchsia;
  KEYWORDS2.mediumaquamarine = "#66cdaa";
  KEYWORDS2.mediumblue = "#0000cd";
  KEYWORDS2.mediumorchid = "#ba55d3";
  KEYWORDS2.mediumpurple = "#9370db";
  KEYWORDS2.mediumseagreen = "#3cb371";
  KEYWORDS2.mediumslateblue = "#7b68ee";
  KEYWORDS2.mediumspringgreen = "#00fa9a";
  KEYWORDS2.mediumturquoise = "#48d1cc";
  KEYWORDS2.mediumvioletred = "#c71585";
  KEYWORDS2.midnightblue = "#191970";
  KEYWORDS2.mintcream = "#f5fffa";
  KEYWORDS2.mistyrose = "#ffe4e1";
  KEYWORDS2.moccasin = "#ffe4b5";
  KEYWORDS2.navajowhite = "#ffdead";
  KEYWORDS2.oldlace = "#fdf5e6";
  KEYWORDS2.olivedrab = "#6b8e23";
  KEYWORDS2.orangered = "#ff4500";
  KEYWORDS2.orchid = "#da70d6";
  KEYWORDS2.palegoldenrod = "#eee8aa";
  KEYWORDS2.palegreen = "#98fb98";
  KEYWORDS2.paleturquoise = "#afeeee";
  KEYWORDS2.palevioletred = "#db7093";
  KEYWORDS2.papayawhip = "#ffefd5";
  KEYWORDS2.peachpuff = "#ffdab9";
  KEYWORDS2.peru = "#cd853f";
  KEYWORDS2.pink = "#ffc0cb";
  KEYWORDS2.plum = "#dda0dd";
  KEYWORDS2.powderblue = "#b0e0e6";
  KEYWORDS2.rosybrown = "#bc8f8f";
  KEYWORDS2.royalblue = "#4169e1";
  KEYWORDS2.saddlebrown = "#8b4513";
  KEYWORDS2.salmon = "#fa8072";
  KEYWORDS2.sandybrown = "#f4a460";
  KEYWORDS2.seagreen = "#2e8b57";
  KEYWORDS2.seashell = "#fff5ee";
  KEYWORDS2.sienna = "#a0522d";
  KEYWORDS2.skyblue = "#87ceeb";
  KEYWORDS2.slateblue = "#6a5acd";
  KEYWORDS2.slategray = "#708090";
  KEYWORDS2.slategrey = KEYWORDS2.slategray;
  KEYWORDS2.snow = "#fffafa";
  KEYWORDS2.springgreen = "#00ff7f";
  KEYWORDS2.steelblue = "#4682b4";
  KEYWORDS2.tan = "#d2b48c";
  KEYWORDS2.thistle = "#d8bfd8";
  KEYWORDS2.tomato = "#ff6347";
  KEYWORDS2.transparent = "#00000000";
  KEYWORDS2.turquoise = "#40e0d0";
  KEYWORDS2.violet = "#ee82ee";
  KEYWORDS2.wheat = "#f5deb3";
  KEYWORDS2.whitesmoke = "#f5f5f5";
  KEYWORDS2.yellowgreen = "#9acd32";
  KEYWORDS2.rebeccapurple = "#663399";
})(KEYWORDS || (KEYWORDS = {}));

// utils/color/parse/keyword.ts
function keyword(color2) {
  const hexColor = (0, import_utils4.maybeGet)(KEYWORDS, color2);
  if (hexColor) {
    return hex(hexColor);
  }
  return null;
}
__name(keyword, "keyword");

// utils/color/parse/rgb.ts
function rgb2(color2) {
  if (color2.startsWith("rgb") && color2.endsWith(")")) {
    const rawArgsList = color2.slice(color2.indexOf("(") + 1, -1);
    const args = argsList(rawArgsList);
    if (args.length) {
      const [rPercent, gPercent, bPercent, aPercent = null] = args.map(percent);
      const a = aPercent !== null ? aPercent : parseFloat(args[3] ?? "1");
      if (rPercent !== null && gPercent !== null && bPercent !== null) {
        return clampAndRound.rgb(
          {
            a,
            b: 255 * bPercent,
            g: 255 * gPercent,
            r: 255 * rPercent
          },
          true
        );
      } else if (rPercent === null && gPercent === null && bPercent === null) {
        const [r, g, b] = args.map(parseFloat);
        return clampAndRound.rgb(
          {
            a,
            b,
            g,
            r
          },
          true
        );
      }
    }
  }
  return null;
}
__name(rgb2, "rgb");

// utils/color/parse/parse.ts
function parse(color2) {
  return hex(color2) ?? rgb2(color2) ?? hsl2(color2) ?? keyword(color2);
}
__name(parse, "parse");
parse.transform = transform;

// utils/color/as/hex.ts
function hex2(color2) {
  const rgb4 = parse(color2);
  if (rgb4 === null) {
    return null;
  } else {
    const { a, b, g, r } = rgb4;
    return ["#", ...[r, g, b, 255 * a].map((x) => Math.round(x).toString(16).padStart(2, "0"))].join("");
  }
}
__name(hex2, "hex");

// utils/color/as/hsl.ts
function hsl3(color2) {
  const rgb4 = parse(color2);
  if (rgb4 === null) {
    return null;
  } else {
    const { a, h, l, s } = parse.transform.rgbToHsl(rgb4);
    return `hsla(${h}deg, ${100 * s}%, ${100 * l}%, ${a})`;
  }
}
__name(hsl3, "hsl");

// utils/color/as/rgb.ts
function rgb3(color2) {
  const rgb4 = parse(color2);
  if (rgb4 === null) {
    return null;
  } else {
    const { a, b, g, r } = rgb4;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
  }
}
__name(rgb3, "rgb");

// utils/color/as/as.ts
var as = {
  hex: hex2,
  hsl: hsl3,
  rgb: rgb3
};

// utils/color/color.ts
var color = {
  KEYWORDS,
  as,
  parse
};

// utils/FOCUSABLE_SELECTOR.ts
var FOCUSABLE = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]"
];
var FOCUSABLE_SELECTOR = `${FOCUSABLE.join(
  `:not([hidden]):not([tabindex^="-"]),`
)}, [tabindex]:not([tabindex^="-"]):not([disabled]):not([hidden])`;

// utils/isVisible.ts
var isVisible = /* @__PURE__ */ __name((element) => {
  const { display, visibility } = window.getComputedStyle(element);
  return element instanceof HTMLElement && !element.hasAttribute("hidden") ? display !== "none" && visibility !== "hidden" : false;
}, "isVisible");

// utils/focusFirst.ts
var focusFirst = /* @__PURE__ */ __name((ref) => {
  const current = ref.current;
  if (!current) {
    return;
  }
  const walker = document.createTreeWalker(current, NodeFilter.SHOW_ELEMENT, (node) => {
    const nodeElement = node;
    return nodeElement.matches(FOCUSABLE_SELECTOR) && isVisible(nodeElement) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
  });
  walker.nextNode()?.focus();
}, "focusFirst");

// utils/useReducer.ts
var import_react = __toESM(require("react"));
var useReducer = /* @__PURE__ */ __name((REDUCERS4, VERBOSE) => {
  const [state, dispatch] = import_react.default.useReducer((old, [event, payload]) => {
    if (VERBOSE) {
      console.group(
        `%c%s`,
        [
          "background-color: #4E3EB1",
          "border-radius: 1.5px",
          "display: block",
          "font-weight: bold",
          "margin-bottom: 1.5px",
          "padding: 1.5px 6px .5px 6px"
        ].join(";"),
        ...payload ? [event, payload] : [event]
      );
    }
    const reduced = REDUCERS4[event](old, payload);
    const result = REDUCERS4.$AFTER_EACH?.reduce((result2, f) => f(result2, old, [event, payload]), reduced) ?? reduced;
    if (VERBOSE) {
      console.groupEnd();
    }
    return result;
  }, REDUCERS4.$INITIAL_STATE);
  return [state, (0, import_react.useCallback)((...args) => dispatch(args), [])];
}, "useReducer");

// utils/useUnmountedRef.ts
var import_react2 = require("@appd/utils/@react");
var import_react3 = require("react");
var useUnmountedRef = /* @__PURE__ */ __name(() => {
  const unmountedRef = (0, import_react3.useRef)(false);
  (0, import_react2.useLayoutEffect)(
    () => () => {
      unmountedRef.current = true;
    },
    []
  );
  return unmountedRef;
}, "useUnmountedRef");

// utils/index.ts
__reExport(utils_exports, require("@appd/utils"));
var import_utils5 = require("@appd/utils");
__reExport(utils_exports, require("@appd/utils/@react"));

// FEATURE_FLAG_LIGHT_THEME.ts
var hasLocalStorage = typeof globalThis.localStorage?.["next-ui-feature-flags-store"] != "undefined";
var flagValue = hasLocalStorage ? JSON.parse(globalThis.localStorage?.["next-ui-feature-flags-store"])["LIGHT_THEME"] : void 0;
var FEATURE_FLAG_LIGHT_THEME = Boolean(
  flagValue != void 0 ? flagValue?.overriddenValue != void 0 ? flagValue?.overriddenValue : flagValue?.value != void 0 ? flagValue?.value : flagValue?.defaultValue : true
);

// utils/color/parse/transform/applyAlphaToHex.ts
var import_uik = require("@appd/uik");
function applyAlphaToHex(color2, alpha) {
  if (color2.startsWith("#")) {
    const value = import_uik.utils.clamp(parseInt(color2.slice(1), 16), [0]);
    const aa = alpha.toString(16).padStart(2, "0");
    if (isFinite(value)) {
      switch (color2.length) {
        case 4:
          return `#${color2[1]}${color2[1]}${color2[2]}${color2[2]}${color2[3]}${color2[3]}${aa}`;
        case 7: {
          return `${color2}${aa}`;
        }
        default:
      }
    }
  }
  throw Error(`Color is unparsable: ${color2}`);
}
__name(applyAlphaToHex, "applyAlphaToHex");

// TOKENS.ts
var TOKENS;
((TOKENS2) => {
  let COLOR;
  ((COLOR2) => {
    let BRAND;
    ((BRAND2) => {
      BRAND2.DARK_GRAY = "#535860";
      BRAND2.DEEP_PURPLE = "#4e3eb1";
      BRAND2.DEEP_SPACE = "#19212b";
      BRAND2.GREEN = "#6abf4b";
      BRAND2.LIGHT_GRAY = "#ebedf1";
      BRAND2.MEDIUM_GRAY = "#8c9095";
      BRAND2.ORANGE = "#fbab17";
      BRAND2.PINK = "#df1b95";
      BRAND2.RED = "#e2231b";
      BRAND2.SKY_BLUE = "#01bced";
    })(BRAND = COLOR2.BRAND || (COLOR2.BRAND = {}));
    let PRODUCT;
    ((PRODUCT2) => {
      PRODUCT2.WHITE = "#ffffff";
      PRODUCT2.BLACK = "#000000";
      PRODUCT2.PRIMARY = {
        0: PRODUCT2.BLACK,
        // ** @deprecated use PRIMARY.35 **/
        10: "#154EB0",
        100: PRODUCT2.WHITE,
        // ** @deprecated use PRIMARY.35 **/
        20: "#154EB0",
        // ** @deprecated use PRIMARY.35 **/
        30: "#154EB0",
        35: "#154EB0",
        // ** @deprecated use PRIMARY.35 **/
        38: "#154EB0",
        // ** @deprecated use PRIMARY.45 **/
        40: "#306ACF",
        45: "#306ACF",
        // ** @deprecated use PRIMARY.45 **/
        48: "#306ACF",
        50: "#3972D4",
        55: "#4983E5",
        // ** @deprecated use PRIMARY.55 **/
        57: "#4983E5",
        // ** @deprecated use PRIMARY.65 **/
        60: "#6C9EF5",
        65: "#6C9EF5",
        // ** @deprecated use PRIMARY.65 **/
        69: "#6C9EF5",
        // TODO: Replace with `utils.color` and use absolute values not hex.
        "69_30": applyAlphaToHex("#6C9EF5", ~~(30 / 100 * 255)),
        // TODO: Replace with `utils.color` and use absolute values not hex.
        "69_60": applyAlphaToHex("#6C9EF5", ~~(60 / 100 * 255)),
        70: "#81ACF7",
        "70_30": applyAlphaToHex("#81ACF7", ~~(30 / 100 * 255)),
        // ** @deprecated use PRIMARY.70 **/
        75: "#81ACF7",
        80: "#ABC9FC",
        // ** @deprecated use PRIMARY.80 **/
        82: "#ABC9FC",
        // ** @deprecated use PRIMARY.90 **/
        89: "#CFE0FF",
        90: "#CFE0FF",
        95: "#E3EEFF",
        // ** @deprecated use PRIMARY.95 **/
        96: "#E3EEFF",
        // ** @deprecated use PRIMARY.95 **/
        99: "#E3EEFF"
      };
      PRODUCT2.SECONDARY = {
        0: PRODUCT2.BLACK,
        // ** @deprecated use SECONDARY.5 **/
        10: "#16192a",
        100: PRODUCT2.WHITE,
        // ** @deprecated use SECONDARY.15 **/
        13: "#23282E",
        15: "#23282E",
        // ** @deprecated use SECONDARY.15 **/
        19: "#23282E",
        // ** @deprecated use SECONDARY.25 **/
        20: "#373C42",
        // ** @deprecated use SECONDARY.25 **/
        23: "#373C42",
        25: "#373C42",
        // ** @deprecated use SECONDARY.25 **/
        27: "#373C42",
        // ** @deprecated use SECONDARY.35 **/
        30: "#464C54",
        35: "#464C54",
        40: "#596069",
        // ** @deprecated use SECONDARY.40 **/
        47: "#596069",
        5: "#0F1214",
        50: "#6F7680",
        60: "#889099",
        // ** @deprecated use SECONDARY.60 **/
        62: "#889099",
        70: "#A7ADB5",
        // ** @deprecated use SECONDARY.70 **/
        76: "#A7ADB5",
        // ** @deprecated use SECONDARY.70 **/
        80: "#A7ADB5",
        // ** @deprecated use SECONDARY.90 **/
        89: "#E1E4E8",
        90: "#E1E4E8",
        // ** @deprecated use SECONDARY.95 **/
        93: "#F0F1F2",
        95: "#F0F1F2",
        98: "#F7F7F7",
        // ** @deprecated use SECONDARY.100 **/
        99: PRODUCT2.WHITE
      };
      let NEUTRAL;
      ((NEUTRAL2) => {
        NEUTRAL2.BLACK = {
          // TODO: Replace with `utils.color` and use absolute values not hex.
          0: applyAlphaToHex(PRODUCT2.BLACK, ~~(0 / 100 * 255)),
          // TODO: Replace with `utils.color` and use absolute values not hex.
          10: applyAlphaToHex(PRODUCT2.BLACK, ~~(10 / 100 * 255)),
          100: PRODUCT2.BLACK,
          // TODO: Replace with `utils.color` and use absolute values not hex.
          15: applyAlphaToHex(PRODUCT2.BLACK, ~~(15 / 100 * 255)),
          // ** @deprecated, use BLACK.25 **/
          20: applyAlphaToHex(PRODUCT2.BLACK, ~~(20 / 100 * 255)),
          // TODO: Replace with `utils.color` and use absolute values not hex.
          25: applyAlphaToHex(PRODUCT2.BLACK, ~~(25 / 100 * 255)),
          // ** @deprecated, use BLACK.34 **/
          30: applyAlphaToHex(PRODUCT2.BLACK, ~~(30 / 100 * 255)),
          // TODO: Replace with `utils.color` and use absolute values not hex.
          34: applyAlphaToHex(PRODUCT2.BLACK, ~~(34 / 100 * 255)),
          // TODO: Replace with `utils.color` and use absolute values not hex.
          38: applyAlphaToHex(PRODUCT2.BLACK, ~~(38 / 100 * 255)),
          // TODO: Replace with `utils.color` and use absolute values not hex.
          40: applyAlphaToHex(PRODUCT2.BLACK, ~~(40 / 100 * 255)),
          // ** @deprecated, use BLACK.6 **/
          5: applyAlphaToHex(PRODUCT2.BLACK, ~~(5 / 100 * 255)),
          // TODO: Replace with `utils.color` and use absolute values not hex.
          50: applyAlphaToHex(PRODUCT2.BLACK, ~~(50 / 100 * 255)),
          // TODO: Replace with `utils.color` and use absolute values not hex.
          6: applyAlphaToHex(PRODUCT2.BLACK, ~~(6 / 100 * 255)),
          // ** @deprecated, use BLACK.64 **/
          60: applyAlphaToHex(PRODUCT2.BLACK, ~~(60 / 100 * 255)),
          // TODO: Replace with `utils.color` and use absolute values not hex.
          64: applyAlphaToHex(PRODUCT2.BLACK, ~~(64 / 100 * 255)),
          // TODO: Replace with `utils.color` and use absolute values not hex.
          70: applyAlphaToHex(PRODUCT2.BLACK, ~~(70 / 100 * 255)),
          // ** @deprecated, use BLACK.70 **/
          75: applyAlphaToHex(PRODUCT2.BLACK, ~~(70 / 100 * 255)),
          // ** @deprecated, use BLACK.84 **/
          80: applyAlphaToHex(PRODUCT2.BLACK, ~~(80 / 100 * 255)),
          // TODO: Replace with `utils.color` and use absolute values not hex.
          84: applyAlphaToHex(PRODUCT2.BLACK, ~~(84 / 100 * 255)),
          // TODO: Replace with `utils.color` and use absolute values not hex.
          90: applyAlphaToHex(PRODUCT2.BLACK, ~~(90 / 100 * 255)),
          // TODO: Replace with `utils.color` and use absolute values not hex.
          94: applyAlphaToHex(PRODUCT2.BLACK, ~~(94 / 100 * 255))
        };
        NEUTRAL2.WHITE = {
          // TODO: Replace with `utils.color` and use absolute values not hex.
          0: applyAlphaToHex(PRODUCT2.WHITE, ~~(0 / 100 * 255)),
          // TODO: Replace with `utils.color` and use absolute values not hex.
          10: applyAlphaToHex(PRODUCT2.WHITE, ~~(10 / 100 * 255)),
          100: PRODUCT2.WHITE,
          // TODO: Replace with `utils.color` and use absolute values not hex.
          15: applyAlphaToHex(PRODUCT2.WHITE, ~~(15 / 100 * 255)),
          // TODO: Replace with `utils.color` and use absolute values not hex.
          25: applyAlphaToHex(PRODUCT2.WHITE, ~~(25 / 100 * 255)),
          // TODO: Replace with `utils.color` and use absolute values not hex.
          30: applyAlphaToHex(PRODUCT2.WHITE, ~~(30 / 100 * 255)),
          // TODO: Replace with `utils.color` and use absolute values not hex.
          34: applyAlphaToHex(PRODUCT2.WHITE, ~~(34 / 100 * 255)),
          // TODO: Replace with `utils.color` and use absolute values not hex.
          38: applyAlphaToHex(PRODUCT2.WHITE, ~~(38 / 100 * 255)),
          // TODO: Replace with `utils.color` and use absolute values not hex.
          50: applyAlphaToHex(PRODUCT2.WHITE, ~~(50 / 100 * 255)),
          // TODO: Replace with `utils.color` and use absolute values not hex.
          6: applyAlphaToHex(PRODUCT2.WHITE, ~~(6 / 100 * 255)),
          // TODO: Replace with `utils.color` and use absolute values not hex.
          64: applyAlphaToHex(PRODUCT2.WHITE, ~~(64 / 100 * 255)),
          // TODO: Replace with `utils.color` and use absolute values not hex.
          70: applyAlphaToHex(PRODUCT2.WHITE, ~~(70 / 100 * 255)),
          // TODO: Replace with `utils.color` and use absolute values not hex.
          84: applyAlphaToHex(PRODUCT2.WHITE, ~~(84 / 100 * 255)),
          // TODO: Replace with `utils.color` and use absolute values not hex.
          94: applyAlphaToHex(PRODUCT2.WHITE, ~~(94 / 100 * 255))
        };
      })(NEUTRAL = PRODUCT2.NEUTRAL || (PRODUCT2.NEUTRAL = {}));
      let STATUS2;
      ((STATUS3) => {
        STATUS3.CRITICAL = {
          0: PRODUCT2.BLACK,
          // ** @deprecated use CRITICAL.35 **/
          10: "#A01D26",
          100: PRODUCT2.WHITE,
          // ** @deprecated use CRITICAL.35 **/
          20: "#A01D26",
          30: "#A01D26",
          // ** @deprecated use CRITICAL.35 **/
          "30_30": applyAlphaToHex("#A01D26", ~~(30 / 100 * 255)),
          35: "#A01D26",
          40: "#B2242D",
          50: "#D93843",
          // ** @deprecated use CRITICAL.50 **/
          52: "#D93843",
          // ** @deprecated use CRITICAL.50 **/
          54: "#D93843",
          60: "#FA5762",
          "60_20": applyAlphaToHex("#FA5762", ~~(20 / 100 * 255)),
          "60_30": applyAlphaToHex("#FA5762", ~~(30 / 100 * 255)),
          // ** @deprecated use CRITICAL.65 **/
          64: "#FF6E72",
          65: "#FF6E72",
          // ** @deprecated use CRITICAL.65 **/
          66: "#FF6E72",
          // ** @deprecated use CRITICAL.65 **/
          "66_20": applyAlphaToHex("#FF6E72", ~~(20 / 100 * 255)),
          // ** @deprecated use CRITICAL.65 **/
          "66_30": applyAlphaToHex("#FF6E72", ~~(30 / 100 * 255)),
          70: "#FF878B",
          // ** @deprecated use CRITICAL.70 **/
          74: "#FA7A7E",
          80: "#FFB2B5",
          90: "#FFD4D5",
          95: "#FFE8E9",
          // ** @deprecated use CRITICAL.95 **/
          99: "#FFE8E9"
        };
        STATUS3.NORMAL = {
          0: PRODUCT2.BLACK,
          // ** @deprecated use NORMAL.50 **/
          10: "#0F874C",
          100: PRODUCT2.WHITE,
          // ** @deprecated use NORMAL.50 **/
          20: "#0F874C",
          // ** @deprecated use NORMAL.50 **/
          30: "#0F874C",
          // ** @deprecated use NORMAL.50 **/
          "30_30": applyAlphaToHex("#0F874C", ~~(30 / 100 * 255)),
          // ** @deprecated use NORMAL.50 **/
          40: "#0F874C",
          // ** @deprecated use NORMAL.50 **/
          50: "#0F874C",
          55: "#169855",
          // ** @deprecated use NORMAL.55 **/
          56: "#169855",
          // ** @deprecated use NORMAL.55 **/
          57: "#169855",
          // ** @deprecated use NORMAL.55 **/
          "57_30": applyAlphaToHex("#169855", ~~(30 / 100 * 255)),
          60: "#21A65F",
          65: "#36B26E",
          70: "#4CBF7F",
          "70_30": applyAlphaToHex("#4CBF7F", ~~(30 / 100 * 255)),
          80: "#75D9A0",
          85: "#97E5B8",
          90: "#B7EDCC",
          // ** @deprecated use NORMAL.90 **/,
          92: "#B7EDCC",
          95: "#D4F5E1",
          // ** @deprecated use NORMAL.95 **/
          99: "#D4F5E1"
        };
        STATUS3.WARNING = {
          0: PRODUCT2.BLACK,
          // ** @deprecated use WARNING.50 **/
          10: "#B06004",
          100: PRODUCT2.WHITE,
          // ** @deprecated use WARNING.50 **/
          20: "#B06004",
          // ** @deprecated use WARNING.50 **/
          30: "#B06004",
          // ** @deprecated use WARNING.50 **/
          "30_30": applyAlphaToHex("#B06004", ~~(30 / 100 * 255)),
          // ** @deprecated use WARNING.50 **/
          40: "#B06004",
          // ** @deprecated use WARNING.50 **/
          47: "#B06004",
          50: "#B06004",
          55: "#BD7202",
          // ** @deprecated use WARNING.55 **/
          57: "#BD7202",
          // ** @deprecated use WARNING.60 **/
          58: "#CC8604",
          60: "#CC8604",
          65: "#D6900D",
          70: "#E0A419",
          // TODO: Replace with `utils.color` and use absolute values not hex.
          "70_30": applyAlphaToHex("#E0A419", ~~(30 / 100 * 255)),
          80: "#F0C243",
          "80_30": applyAlphaToHex("#F0C243", ~~(30 / 100 * 255)),
          85: "#F2D268",
          90: "#F5E08E",
          95: "#FAEFB9",
          // ** @deprecated use WARNING.95 **/
          99: "#FAEFB9"
        };
        STATUS3.INFO = {
          0: PRODUCT2.BLACK,
          // ** @deprecated, use INFO.40 **/
          10: "#03639C",
          100: PRODUCT2.WHITE,
          20: "#03639C",
          // ** @deprecated, use INFO.40 **/
          30: "#03639C",
          // ** @deprecated, use INFO.40 **/
          "30_30": applyAlphaToHex("#03639C", ~~(30 / 100 * 255)),
          40: "#03639C",
          45: "#0570AD",
          50: "#087ABD",
          55: "#0D8BD4",
          // ** @deprecated, use INFO.55 **/
          57: "#0D8BD4",
          // ** @deprecated, use INFO.60 **/
          58: "#139CEB",
          60: "#139CEB",
          65: "#24A7ED",
          70: "#3FB6F2",
          // TODO: Replace with `utils.color` and use absolute values not hex.
          "70_30": applyAlphaToHex("#3FB6F2", ~~(30 / 100 * 255)),
          80: "#79D1FD",
          90: "#B8E7FF",
          // ** @deprecated, use INFO.60 **/
          95: "#B8E7FF",
          // ** @deprecated, use INFO.60 **/
          99: "#B8E7FF"
        };
      })(STATUS2 = PRODUCT2.STATUS || (PRODUCT2.STATUS = {}));
      let CHART;
      ((CHART2) => {
        CHART2.ACCENT_A = {
          // ** @deprecated, use ACCENT_A.35 **/
          20: "#3B47B2",
          // ** @deprecated, use ACCENT_A.35 **/
          30: "#3B47B2",
          35: "#3B47B2",
          40: "#4653C7",
          45: "#505ED9",
          50: "#5A68E5",
          55: "#6977F0",
          60: "#7D8AFF",
          65: "#8A95FF",
          70: "#9CA6FF",
          80: "#BAC1FF",
          85: "#CCD1FF",
          90: "#D9DDFF",
          95: "#EBEDFF"
        };
        CHART2.ACCENT_B_C = {
          // ** @deprecated, use ACCENT_B_C.35 **/
          20: "#991D53",
          // ** @deprecated, use ACCENT_B_C.35 **/
          30: "#991D53",
          35: "#991D53",
          40: "#B02863",
          45: "#C2306F",
          50: "#CF3A7A",
          55: "#E3447C",
          60: "#F2638C",
          65: "#F57398",
          70: "#FF87A9",
          80: "#FCB3C8",
          85: "#FFC4D5",
          90: "#FFD4E0",
          95: "#FFE8EF"
        };
        CHART2.ACCENT_D = {
          // ** @deprecated, use ACCENT_D.35 **/
          20: "#6732B8",
          // ** @deprecated, use ACCENT_D.35 **/
          30: "#6732B8",
          35: "#6732B8",
          40: "#753BCC",
          45: "#864AE0",
          50: "#8D4EED",
          55: "#9B5FF5",
          60: "#A974F7",
          65: "#B587FA",
          70: "#C299FF",
          80: "#D6BAFF",
          85: "#E0CCFF",
          90: "#E8D9FF",
          95: "#F3EBFF"
        };
        CHART2.ACCENT_E = {
          // ** @deprecated, use ACCENT_E.35 **/
          20: "#335C04",
          // ** @deprecated, use ACCENT_E.35 **/
          30: "#335C04",
          35: "#335C04",
          40: "#3B6906",
          45: "#45780B",
          50: "#4D8212",
          55: "#5A911C",
          60: "#6BA32A",
          65: "#74AD36",
          70: "#85BD46",
          80: "#A6D472",
          85: "#BCDE95",
          90: "#D1E8B7",
          95: "#EBF5E0"
        };
        CHART2.ACCENT_F = {
          // ** @deprecated, use ACCENT_F.35 **/
          20: "#942E03",
          // ** @deprecated, use ACCENT_F.35 **/
          30: "#942E03",
          35: "#942E03",
          40: "#AD3907",
          45: "#BA400B",
          50: "#C44F14",
          55: "#D95A1A",
          60: "#F26722",
          65: "#F7782F",
          70: "#FC8D4C",
          80: "#FCB88D",
          85: "#FCC9A7",
          90: "#FFD9BF",
          95: "#FFEADB"
        };
        CHART2.ACCENT_G_H = {
          // ** @deprecated, use ACCENT_G_H.35 **/
          20: "#005C66",
          // ** @deprecated, use ACCENT_G_H.35 **/
          30: "#005C66",
          35: "#005C66",
          40: "#006773",
          45: "#017580",
          50: "#01818C",
          55: "#028E99",
          60: "#01818C",
          65: "#0BB2B8",
          70: "#17C2C2",
          80: "#4AD9D9",
          85: "#84E3E3",
          90: "#A9EBEB",
          95: "#D5F5F5"
        };
        CHART2.ACCENT_I = {
          // ** @deprecated, use ACCENT_I.35 **/
          20: "#941B76",
          // ** @deprecated, use ACCENT_I.35 **/
          30: "#941B76",
          35: "#941B76",
          40: "#A62686",
          45: "#B53394",
          50: "#C23EA1",
          55: "#D64BB3",
          60: "#E85FC6",
          65: "#F26DD1",
          70: "#F582D8",
          80: "#F7B0E5",
          85: "#FAC5ED",
          90: "#FFD1F3",
          95: "#FFE8EE"
        };
        CHART2.ACCENT_J = {
          // ** @deprecated, use ACCENT_J.35 **/
          20: "#484F7A",
          // ** @deprecated, use ACCENT_J.35 **/
          30: "#484F7A",
          35: "#484F7A",
          40: "#545C8A",
          45: "#5D6596",
          50: "#6871A3",
          55: "#767EB2",
          60: "#868EC2",
          65: "#959CCC",
          70: "#A3AAD6",
          80: "#C1C6E8",
          85: "#CED3F2",
          90: "#D9DEFA",
          95: "#EBEDFF"
        };
        CHART2.ACCENT_K = {
          // ** @deprecated, use ACCENT_K.35 **/
          20: "#075E39",
          // ** @deprecated, use ACCENT_K.35 **/
          30: "#075E39",
          35: "#075E39",
          40: "#087041",
          45: "#0B7B46",
          50: "#0F874C",
          55: "#169855",
          60: "#21A65F",
          65: "#36B26E",
          70: "#4CBF7F",
          80: "#75D9A0",
          85: "#97E5B8",
          90: "#B6EDCC",
          95: "#D4F5E1"
        };
        CHART2.ACCENT_L = {
          50: "#B06004",
          55: "#BD7202",
          60: "#CC8604",
          65: "#D6900D",
          70: "#E0A419",
          80: "#F0C243",
          85: "#F2D268",
          90: "#F5E08E",
          95: "#FAEFB9"
        };
      })(CHART = PRODUCT2.CHART || (PRODUCT2.CHART = {}));
      PRODUCT2.HEALTH = {
        ACTIVE: STATUS2.INFO[70],
        CRITICAL: STATUS2.CRITICAL[60],
        INACTIVE: PRODUCT2.SECONDARY[50],
        NORMAL: STATUS2.NORMAL[56],
        TERMINATED: CHART.ACCENT_B_C[85],
        UNKNOWN: PRODUCT2.SECONDARY[70],
        WARNING: STATUS2.WARNING[80]
      };
    })(PRODUCT = COLOR2.PRODUCT || (COLOR2.PRODUCT = {}));
  })(COLOR = TOKENS2.COLOR || (TOKENS2.COLOR = {}));
  let EFFECT;
  ((EFFECT2) => {
    let SHADOW5;
    ((SHADOW6) => {
      SHADOW6.DEFAULT = "0 5px 15px 0 #0000004d";
      SHADOW6.DEFAULT_RLTB = "0 0 15px -1px #0000004d";
      SHADOW6.ELEVATED = "0 10px 30px 0 #0000004d";
      SHADOW6.LIGHT = "0 1px 2px 0 #0000004d";
    })(SHADOW5 = EFFECT2.SHADOW || (EFFECT2.SHADOW = {}));
  })(EFFECT = TOKENS2.EFFECT || (TOKENS2.EFFECT = {}));
  let FONT4;
  ((FONT5) => {
    FONT5.ROBOTO = {
      400: {
        fontDisplay: "fallback",
        fontFamily: "Roboto",
        fontWeight: 400,
        src: "Roboto.latin.400.woff2",
        unicodeRange: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
      },
      500: {
        fontDisplay: "fallback",
        fontFamily: "Roboto",
        fontWeight: 500,
        src: "Roboto.latin.500.woff2",
        unicodeRange: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
      },
      700: {
        fontDisplay: "fallback",
        fontFamily: "Roboto",
        fontWeight: 700,
        src: "Roboto.latin.700.woff2",
        unicodeRange: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
      },
      fontFamily: "Roboto"
    };
    FONT5.SOURCE_CODE_PRO = {
      fontDisplay: "fallback",
      fontFamily: "Source Code Pro",
      fontWeight: 400,
      src: "SourceCodePro.latin.wght.woff2",
      unicodeRange: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    };
  })(FONT4 = TOKENS2.FONT || (TOKENS2.FONT = {}));
  let LINE;
  ((LINE2) => {
    LINE2.DEFAULT = 1;
    LINE2.FAT = 4;
    LINE2.MEDIUM = 2;
    LINE2.THICK = 3;
  })(LINE = TOKENS2.LINE || (TOKENS2.LINE = {}));
  let MOTION2;
  ((MOTION3) => {
    let DURATION3;
    ((DURATION4) => {
      DURATION4.FAST = "100ms";
      DURATION4.LAZY = "600ms";
      DURATION4.MEDIUM = "200ms";
      DURATION4.SLOW = "400ms";
    })(DURATION3 = MOTION3.DURATION || (MOTION3.DURATION = {}));
    let EASING3;
    ((EASING4) => {
      EASING4.LINEAR = "cubic-bezier(0, 0, 1, 1)";
      EASING4.STANDARD = "cubic-bezier(0.4, 0, 0.2, 1)";
      EASING4.DECELERATE = "cubic-bezier(0, 0, 0.2, 1)";
      EASING4.ACCELERATE = "cubic-bezier(0.4, 0, 1, 1)";
    })(EASING3 = MOTION3.EASING || (MOTION3.EASING = {}));
    let INTERACTIONS;
    ((INTERACTIONS2) => {
      INTERACTIONS2.BAR_ACTIVE = {
        DURATION: DURATION3.MEDIUM,
        EASING: EASING3.STANDARD
      };
      INTERACTIONS2.BAR_DEFAULT = INTERACTIONS2.BAR_ACTIVE;
      INTERACTIONS2.BAR_TRANSLATION = INTERACTIONS2.BAR_ACTIVE;
      INTERACTIONS2.COLOR_CHANGE = {
        DURATION: DURATION3.FAST,
        EASING: EASING3.STANDARD
      };
      INTERACTIONS2.DISCLOSE_IN = {
        DURATION: DURATION3.MEDIUM,
        EASING: EASING3.LINEAR
      };
      INTERACTIONS2.DISCLOSE_OUT = INTERACTIONS2.DISCLOSE_IN;
      INTERACTIONS2.DRAGGABLE = INTERACTIONS2.BAR_ACTIVE;
      INTERACTIONS2.FADE_IN = {
        DURATION: DURATION3.MEDIUM,
        EASING: EASING3.DECELERATE
      };
      INTERACTIONS2.FADE_OUT = {
        DURATION: DURATION3.MEDIUM,
        EASING: EASING3.ACCELERATE
      };
      INTERACTIONS2.PROGRESS_DETERMINATE = {
        DURATION: DURATION3.SLOW,
        EASING: EASING3.DECELERATE
      };
      INTERACTIONS2.PROGRESS_INDETERMINATE = {
        DURATION: "1s",
        EASING: EASING3.STANDARD
      };
      INTERACTIONS2.RIPPLE = {
        DURATION: DURATION3.LAZY,
        EASING: EASING3.STANDARD
      };
      INTERACTIONS2.RIPPLE_BUSY = {
        DURATION: DURATION3.SLOW,
        EASING: EASING3.STANDARD
      };
      INTERACTIONS2.ROTATE = INTERACTIONS2.DISCLOSE_IN;
      INTERACTIONS2.SHIMMER = INTERACTIONS2.BAR_ACTIVE;
      INTERACTIONS2.SLIDE_IN = INTERACTIONS2.FADE_IN;
      INTERACTIONS2.SLIDE_OUT = INTERACTIONS2.FADE_OUT;
      INTERACTIONS2.SPINNER = {
        DURATION: "1.25s",
        EASING: EASING3.STANDARD
      };
      INTERACTIONS2.STROKE_BACKWARD = INTERACTIONS2.RIPPLE_BUSY;
      INTERACTIONS2.STROKE_FORWARD = INTERACTIONS2.RIPPLE_BUSY;
      INTERACTIONS2.TRANSLATE_FAST = {
        DURATION: DURATION3.FAST,
        EASING: EASING3.LINEAR
      };
    })(INTERACTIONS = MOTION3.INTERACTIONS || (MOTION3.INTERACTIONS = {}));
  })(MOTION2 = TOKENS2.MOTION || (TOKENS2.MOTION = {}));
  let RADIUS32;
  ((RADIUS33) => {
    RADIUS33.DEFAULT = 3;
    RADIUS33.FULL = "50%";
    RADIUS33.HEAVY = 6;
  })(RADIUS32 = TOKENS2.RADIUS || (TOKENS2.RADIUS = {}));
  TOKENS2.SPACING = [0, 4, 8, 12, 16, 20, 24];
  let GRID;
  ((GRID2) => {
    GRID2.MD_LG = {
      columnGap: TOKENS2.SPACING[2],
      display: "grid",
      gridTemplateColumns: "repeat(12, 1fr)",
      marginLeft: TOKENS2.SPACING[3],
      marginRight: TOKENS2.SPACING[3]
    };
    GRID2.S = {
      ...GRID2.MD_LG,
      gridTemplateColumns: "repeat(8, 1fr)"
    };
    GRID2.XS = { gridTemplateColumns: "repeat(4, 1fr)" };
    GRID2.BREAKPOINTS = [
      {
        start: 0,
        value: GRID2.XS
      },
      {
        start: 600,
        value: GRID2.S
      },
      {
        start: 905,
        value: GRID2.MD_LG
      },
      {
        start: 1240,
        value: GRID2.MD_LG
      }
    ];
  })(GRID = TOKENS2.GRID || (TOKENS2.GRID = {}));
  let TYPOGRAPHY2;
  ((TYPOGRAPHY3) => {
    let A;
    ((A2) => {
      A2.DEFAULT = {
        fontFamily: FONT4.ROBOTO.fontFamily,
        fontSize: 13,
        fontWeight: 400,
        lineHeight: "15.6px"
      };
      A2.HOVER = {
        ...A2.DEFAULT,
        textDecoration: "underline"
      };
      A2.SMALL = {
        ...A2.DEFAULT,
        fontSize: 11,
        lineHeight: "13px"
      };
      A2.SMALL_HOVER = {
        ...A2.SMALL,
        textDecoration: "underline"
      };
    })(A = TYPOGRAPHY3.A || (TYPOGRAPHY3.A = {}));
    let BODY2;
    ((BODY3) => {
      BODY3.DEFAULT = {
        fontFamily: FONT4.ROBOTO.fontFamily,
        fontSize: 13,
        fontWeight: 400,
        lineHeight: "15px"
      };
      BODY3.FIXED_WIDTH = {
        ...BODY3.DEFAULT,
        fontFamily: FONT4.SOURCE_CODE_PRO.fontFamily
      };
      BODY3.SMALL = {
        ...BODY3.DEFAULT,
        fontSize: 11,
        lineHeight: "13px"
      };
      BODY3.SMALL_LABEL = {
        ...BODY3.SMALL,
        fontWeight: 500
      };
    })(BODY2 = TYPOGRAPHY3.BODY || (TYPOGRAPHY3.BODY = {}));
    let HEADINGS;
    ((HEADINGS2) => {
      HEADINGS2.H1 = {
        fontFamily: FONT4.ROBOTO.fontFamily,
        fontSize: 28,
        fontWeight: 500,
        lineHeight: "33px"
      };
      HEADINGS2.GRID = {
        ...HEADINGS2.H1,
        fontSize: 13,
        lineHeight: "15px"
      };
      HEADINGS2.H2 = {
        ...HEADINGS2.H1,
        fontSize: 24,
        fontWeight: 400,
        lineHeight: "28px"
      };
      HEADINGS2.H3 = {
        ...HEADINGS2.H1,
        fontSize: 22,
        fontWeight: 400,
        lineHeight: "25px"
      };
      HEADINGS2.H4 = {
        ...HEADINGS2.H1,
        fontSize: 18,
        lineHeight: "21px"
      };
      HEADINGS2.PANEL = {
        ...HEADINGS2.H1,
        fontSize: 11,
        lineHeight: "13.2px",
        textTransform: "uppercase"
      };
      HEADINGS2.SECTION = {
        ...HEADINGS2.H1,
        fontSize: 13,
        lineHeight: "15.6px",
        textTransform: "uppercase"
      };
      HEADINGS2.SUBTITLE = {
        ...HEADINGS2.H1,
        fontSize: 16,
        lineHeight: "19px"
      };
    })(HEADINGS = TYPOGRAPHY3.HEADINGS || (TYPOGRAPHY3.HEADINGS = {}));
    let TEXT4;
    ((TEXT5) => {
      let ACTION;
      ((ACTION2) => {
        ACTION2.DEFAULT = {
          fontFamily: FONT4.ROBOTO.fontFamily,
          fontSize: 14,
          fontWeight: 500,
          lineHeight: "16px"
        };
        ACTION2.DISABLED = {
          ...ACTION2.DEFAULT,
          fontWeight: 400
        };
      })(ACTION = TEXT5.ACTION || (TEXT5.ACTION = {}));
      TEXT5.DEFAULT = {
        fontFamily: FONT4.ROBOTO.fontFamily,
        fontSize: 13,
        fontWeight: 500,
        lineHeight: "15px"
      };
      TEXT5.GREY_HOVER_DISABLED_PLACEHOLDER = {
        ...TEXT5.DEFAULT,
        fontWeight: 400
      };
      TEXT5.HINT = {
        ...TEXT5.GREY_HOVER_DISABLED_PLACEHOLDER,
        fontSize: 11,
        lineHeight: "13px"
      };
      TEXT5.LARGE = {
        ...TEXT5.GREY_HOVER_DISABLED_PLACEHOLDER,
        fontSize: 28,
        lineHeight: "33px"
      };
      TEXT5.SELECTED_HOVER = {
        ...TEXT5.DEFAULT,
        lineHeight: "15.6px",
        textDecoration: "underline"
      };
      TEXT5.VALIDATION = TEXT5.HINT;
    })(TEXT4 = TYPOGRAPHY3.TEXT || (TYPOGRAPHY3.TEXT = {}));
    let ELLIPSES26;
    ((ELLIPSES27) => {
      ELLIPSES27.END = {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      };
      ELLIPSES27.START = {
        ...ELLIPSES27.END,
        direction: "rtl",
        textAlign: "left"
      };
    })(ELLIPSES26 = TYPOGRAPHY3.ELLIPSES || (TYPOGRAPHY3.ELLIPSES = {}));
  })(TYPOGRAPHY2 = TOKENS2.TYPOGRAPHY || (TOKENS2.TYPOGRAPHY = {}));
})(TOKENS || (TOKENS = {}));

// MAGNETIC_TOKENS.ts
var MAGNETIC_TOKENS;
((MAGNETIC_TOKENS125) => {
  let COLORS;
  ((COLORS2) => {
    COLORS2.ACCENT_A = "var(--accent-a)";
    COLORS2.ACCENT_A_HOVER = "var(--accent-a-hover)";
    COLORS2.ACCENT_A_WEAK = "var(--accent-a-weak)";
    COLORS2.ACCENT_B = "var(--accent-b)";
    COLORS2.ACCENT_B_HOVER = "var(--accent-b-hover)";
    COLORS2.ACCENT_B_WEAK = "var(--accent-b-weak)";
    COLORS2.ACCENT_C = "var(--accent-c)";
    COLORS2.ACCENT_C_HOVER = "var(--accent-c-hover)";
    COLORS2.ACCENT_C_WEAK = "var(--accent-c-weak)";
    COLORS2.ACCENT_D = "var(--accent-d)";
    COLORS2.ACCENT_D_HOVER = "var(--accent-d-hover)";
    COLORS2.ACCENT_D_WEAK = "var(--accent-d-weak)";
    COLORS2.ACCENT_E = "var(--accent-e)";
    COLORS2.ACCENT_E_HOVER = "var(--accent-e-hover)";
    COLORS2.ACCENT_E_WEAK = "var(--accent-e-weak)";
    COLORS2.ACCENT_F = "var(--accent-f)";
    COLORS2.ACCENT_F_HOVER = "var(--accent-f-hover)";
    COLORS2.ACCENT_F_WEAK = "var(--accent-f-weak)";
    COLORS2.ACCENT_G = "var(--accent-g)";
    COLORS2.ACCENT_G_HOVER = "var(--accent-g-hover)";
    COLORS2.ACCENT_G_WEAK = "var(--accent-g-weak)";
    COLORS2.ACCENT_H = "var(--accent-h)";
    COLORS2.ACCENT_H_HOVER = "var(--accent-h-hover)";
    COLORS2.ACCENT_H_WEAK = "var(--accent-h-weak)";
    COLORS2.ACCENT_I = "var(--accent-i)";
    COLORS2.ACCENT_I_HOVER = "var(--accent-i-hover)";
    COLORS2.ACCENT_I_WEAK = "var(--accent-i-weak)";
    COLORS2.ACCENT_J = "var(--accent-j)";
    COLORS2.ACCENT_J_HOVER = "var(--accent-j-hover)";
    COLORS2.ACCENT_J_WEAK = "var(--accent-j-weak)";
    COLORS2.ACCENT_K = "var(--accent-k)";
    COLORS2.ACCENT_K_HOVER = "var(--accent-k-hover)";
    COLORS2.ACCENT_K_WEAK = "var(--accent-k-weak)";
    COLORS2.BRAND_ACCENT_BORDER = "var(--brand-accent-border)";
    COLORS2.BRAND_ACCENT_BORDER_ACTIVE = "var(--brand-accent-border-active)";
    COLORS2.BRAND_ACCENT_BORDER_FOCUS = "var(--brand-accent-border-focus)";
    COLORS2.BRAND_ACCENT_BORDER_HOVER = "var(--brand-accent-border-hover)";
    COLORS2.BRAND_ACCENT_BORDER_MEDIUM = "var(--brand-accent-border-medium)";
    COLORS2.BRAND_ACCENT_BORDER_MEDIUM_ACTIVE = "var(--brand-accent-border-medium-active)";
    COLORS2.BRAND_ACCENT_BORDER_MEDIUM_DISABLED = "var(--brand-accent-border-medium-disabled)";
    COLORS2.BRAND_ACCENT_BORDER_MEDIUM_FOCUS = "var(--brand-accent-border-medium-focus)";
    COLORS2.BRAND_ACCENT_BORDER_MEDIUM_HOVER = "var(--brand-accent-border-medium-hover)";
    COLORS2.BRAND_ACCENT_BORDER_STRONG = "var(--brand-accent-border-strong)";
    COLORS2.BRAND_ACCENT_BORDER_STRONG_ACTIVE = "var(--brand-accent-border-strong-active)";
    COLORS2.BRAND_ACCENT_BORDER_STRONG_DISABLED = "var(--brand-accent-border-strong-disabled)";
    COLORS2.BRAND_ACCENT_BORDER_STRONG_FOCUS = "var(--brand-accent-border-strong-focus)";
    COLORS2.BRAND_ACCENT_BORDER_STRONG_HOVER = "var(--brand-accent-border-strong-hover)";
    COLORS2.BRAND_ACCENT_BORDER_WEAK = "var(--brand-accent-border-weak)";
    COLORS2.BRAND_ACCENT_BORDER_WEAK_ACTIVE = "var(--brand-accent-border-weak-active)";
    COLORS2.BRAND_ACCENT_BORDER_WEAK_DISABLED = "var(--brand-accent-border-weak-disabled)";
    COLORS2.BRAND_ACCENT_BORDER_WEAK_FOCUS = "var(--brand-accent-border-weak-focus)";
    COLORS2.BRAND_ACCENT_BORDER_WEAK_HOVER = "var(--brand-accent-border-weak-hover)";
    COLORS2.BRAND_ACCENT_ICON = "var(--brand-accent-icon)";
    COLORS2.BRAND_ACCENT_ICON_ACTIVE = "var(--brand-accent-icon-active)";
    COLORS2.BRAND_ACCENT_ICON_DISABLED = "var(--brand-accent-icon-disabled)";
    COLORS2.BRAND_ACCENT_ICON_FOCUS = "var(--brand-accent-icon-focus)";
    COLORS2.BRAND_ACCENT_ICON_MEDIUM = "var(--brand-accent-icon-medium)";
    COLORS2.BRAND_ACCENT_ICON_MEDIUM_ACTIVE = "var(--brand-accent-icon-medium-active)";
    COLORS2.BRAND_ACCENT_ICON_MEDIUM_DISABLED = "var(--brand-accent-icon-medium-disabled)";
    COLORS2.BRAND_ACCENT_ICON_MEDIUM_FOCUS = "var(--brand-accent-icon-medium-focus)";
    COLORS2.BRAND_ACCENT_ICON_WEAK = "var(--brand-accent-icon-weak)";
    COLORS2.BRAND_ACCENT_ICON_WEAK_ACTIVE = "var(--brand-accent-icon-weak-active)";
    COLORS2.BRAND_ACCENT_ICON_WEAK_DISABLED = "var(--brand-accent-icon-weak-disabled)";
    COLORS2.BRAND_ACCENT_ICON_WEAK_FOCUS = "var(--brand-accent-icon-weak-focus)";
    COLORS2.BRAND_BG = "var(--brand-bg)";
    COLORS2.BRAND_BG_ACTIVE = "var(--brand-bg-active)";
    COLORS2.BRAND_BG_DISABLED = "var(--brand-bg-disabled)";
    COLORS2.BRAND_BG_FOCUS = "var(--brand-bg-focus)";
    COLORS2.BRAND_BG_GRADIENT_END = "var(--brand-bg-gradient-end)";
    COLORS2.BRAND_BG_GRADIENT_START = "var(--brand-bg-gradient-start)";
    COLORS2.BRAND_BG_HOVER = "var(--brand-bg-hover)";
    COLORS2.BRAND_TEXT = "var(--brand-text)";
    COLORS2.BRAND_TEXT_STRONG = "var(--brand-text-strong)";
    COLORS2.BRAND_TEXT_WEAK = "var(--brand-text-weak)";
    COLORS2.CONTROL_BG = "var(--control-bg)";
    COLORS2.CONTROL_BG_ACTIVE = "var(--control-bg-active)";
    COLORS2.CONTROL_BG_DISABLED = "var(--control-bg-disabled)";
    COLORS2.CONTROL_BG_FOCUS = "var(--control-bg-focus)";
    COLORS2.CONTROL_BG_HOVER = "var(--control-bg-hover)";
    COLORS2.CONTROL_BG_MEDIUM = "var(--control-bg-medium)";
    COLORS2.CONTROL_BG_MEDIUM_ACTIVE = "var(--control-bg-medium-active)";
    COLORS2.CONTROL_BG_MEDIUM_DISABLED = "var(--control-bg-medium-disabled)";
    COLORS2.CONTROL_BG_MEDIUM_FOCUS = "var(--control-bg-medium-focus)";
    COLORS2.CONTROL_BG_MEDIUM_HOVER = "var(--control-bg-medium-hover)";
    COLORS2.CONTROL_BG_STRONG = "var(--control-bg-strong)";
    COLORS2.CONTROL_BG_STRONG_ACTIVE = "var(--control-bg-strong-active)";
    COLORS2.CONTROL_BG_STRONG_DISABLED = "var(--control-bg-strong-disabled)";
    COLORS2.CONTROL_BG_STRONG_FOCUS = "var(--control-bg-strong-focus)";
    COLORS2.CONTROL_BG_STRONG_HOVER = "var(--control-bg-strong-hover)";
    COLORS2.CONTROL_BG_WEAK = "var(--control-bg-weak)";
    COLORS2.CONTROL_BG_WEAK_ACTIVE = "var(--control-bg-weak-active)";
    COLORS2.CONTROL_BG_WEAK_DISABLED = "var(--control-bg-weak-disabled)";
    COLORS2.CONTROL_BG_WEAK_FOCUS = "var(--control-bg-weak-focus)";
    COLORS2.CONTROL_BG_WEAK_HOVER = "var(--control-bg-weak-hover)";
    COLORS2.CONTROL_BORDER = "var(--control-border)";
    COLORS2.CONTROL_BORDER_ACTIVE = "var(--control-border-active)";
    COLORS2.CONTROL_BORDER_DISABLED = "var(--control-border-disabled)";
    COLORS2.CONTROL_BORDER_FOCUS = "var(--control-border-focus)";
    COLORS2.CONTROL_BORDER_HOVER = "var(--control-border-hover)";
    COLORS2.CONTROL_BORDER_MEDIUM = "var(--control-border-medium)";
    COLORS2.CONTROL_BORDER_MEDIUM_ACTIVE = "var(--control-border-medium-active)";
    COLORS2.CONTROL_BORDER_MEDIUM_DISABLED = "var(--control-border-medium-disabled)";
    COLORS2.CONTROL_BORDER_MEDIUM_FOCUS = "var(--control-border-medium-focus)";
    COLORS2.CONTROL_BORDER_MEDIUM_HOVER = "var(--control-border-medium-hover)";
    COLORS2.CONTROL_BORDER_STRONG = "var(--control-border-strong)";
    COLORS2.CONTROL_BORDER_STRONG_ACTIVE = "var(--control-border-strong-active)";
    COLORS2.CONTROL_BORDER_STRONG_DISABLED = "var(--control-border-strong-disabled)";
    COLORS2.CONTROL_BORDER_STRONG_FOCUS = "var(--control-border-strong-focus)";
    COLORS2.CONTROL_BORDER_STRONG_HOVER = "var(--control-border-strong-hover)";
    COLORS2.CONTROL_BORDER_WEAK = "var(--control-border-weak)";
    COLORS2.CONTROL_BORDER_WEAK_ACTIVE = "var(--control-border-weak-active)";
    COLORS2.CONTROL_BORDER_WEAK_DISABLED = "var(--control-border-weak-disabled)";
    COLORS2.CONTROL_BORDER_WEAK_FOCUS = "var(--control-border-weak-focus)";
    COLORS2.CONTROL_BORDER_WEAK_HOVER = "var(--control-border-weak-hover)";
    COLORS2.CONTROL_ICON = "var(--control-icon)";
    COLORS2.CONTROL_ICON_ACTIVE = "var(--control-icon-active)";
    COLORS2.CONTROL_ICON_DISABLED = "var(--control-icon-disabled)";
    COLORS2.CONTROL_ICON_FOCUS = "var(--control-icon-focus)";
    COLORS2.CONTROL_ICON_HOVER = "var(--control-icon-hover)";
    COLORS2.CONTROL_ICON_IN = "var(--control-icon-in)";
    COLORS2.CONTROL_ICON_IN_ACTIVE = "var(--control-icon-in-active)";
    COLORS2.CONTROL_ICON_IN_DISABLED = "var(--control-icon-in-disabled)";
    COLORS2.CONTROL_ICON_IN_FOCUS = "var(--control-icon-in-focus)";
    COLORS2.CONTROL_ICON_IN_HOVER = "var(--control-icon-in-hover)";
    COLORS2.CONTROL_ICON_IN_STRONG = "var(--control-icon-in-strong)";
    COLORS2.CONTROL_ICON_IN_STRONG_ACTIVE = "var(--control-icon-in-strong-active)";
    COLORS2.CONTROL_ICON_IN_STRONG_DISABLED = "var(--control-icon-in-strong-disabled)";
    COLORS2.CONTROL_ICON_IN_STRONG_FOCUS = "var(--control-icon-in-strong-focus)";
    COLORS2.CONTROL_ICON_IN_STRONG_HOVER = "var(--control-icon-in-strong-hover)";
    COLORS2.CONTROL_ICON_MEDIUM = "var(--control-icon-medium)";
    COLORS2.CONTROL_ICON_MEDIUM_ACTIVE = "var(--control-icon-medium-active)";
    COLORS2.CONTROL_ICON_MEDIUM_DISABLED = "var(--control-icon-medium-disabled)";
    COLORS2.CONTROL_ICON_MEDIUM_FOCUS = "var(--control-icon-medium-focus)";
    COLORS2.CONTROL_ICON_MEDIUM_HOVER = "var(--control-icon-medium-hover)";
    COLORS2.CONTROL_ICON_STRONG = "var(--control-icon-strong)";
    COLORS2.CONTROL_ICON_STRONG_ACTIVE = "var(--control-icon-strong-active)";
    COLORS2.CONTROL_ICON_STRONG_DISABLED = "var(--control-icon-strong-disabled)";
    COLORS2.CONTROL_ICON_STRONG_FOCUS = "var(--control-icon-strong-focus)";
    COLORS2.CONTROL_ICON_STRONG_HOVER = "var(--control-icon-strong-hover)";
    COLORS2.CONTROL_ICON_WEAK = "var(--control-icon-weak)";
    COLORS2.CONTROL_ICON_WEAK_ACTIVE = "var(--control-icon-weak-active)";
    COLORS2.CONTROL_ICON_WEAK_DISABLED = "var(--control-icon-weak-disabled)";
    COLORS2.CONTROL_ICON_WEAK_FOCUS = "var(--control-icon-weak-focus)";
    COLORS2.CONTROL_ICON_WEAK_HOVER = "var(--control-icon-weak-hover)";
    COLORS2.DEFAULT_BG = "var(--default-bg)";
    COLORS2.DEFAULT_BG_ACTIVE = "var(--default-bg-active)";
    COLORS2.DEFAULT_BG_DISABLED = "var(--default-bg-disabled)";
    COLORS2.DEFAULT_BG_HOVER = "var(--default-bg-hover)";
    COLORS2.DEFAULT_BG_MEDIUM = "var(--default-bg-medium)";
    COLORS2.DEFAULT_BG_STRONG = "var(--default-bg-strong)";
    COLORS2.DEFAULT_BG_STRONG_ACTIVE = "var(--default-bg-strong-active)";
    COLORS2.DEFAULT_BG_STRONG_DISABLED = "var(--default-bg-strong-disabled)";
    COLORS2.DEFAULT_BG_STRONG_FOCUS = "var(--default-bg-strong-focus)";
    COLORS2.DEFAULT_BG_STRONG_HOVER = "var(--default-bg-strong-hover)";
    COLORS2.DEFAULT_BG_WEAK = "var(--default-bg-weak)";
    COLORS2.DEFAULT_BG_WEAK_ACTIVE = "var(--default-bg-weak-active)";
    COLORS2.DEFAULT_BG_WEAK_DISABLED = "var(--default-bg-weak-disabled)";
    COLORS2.DEFAULT_BG_WEAK_HOVER = "var(--default-bg-weak-hover)";
    COLORS2.DEFAULT_BORDER = "var(--default-border)";
    COLORS2.DEFAULT_BORDER_MEDIUM = "var(--default-border-medium)";
    COLORS2.DEFAULT_BORDER_STRONG = "var(--default-border-strong)";
    COLORS2.DEFAULT_BORDER_WEAK = "var(--default-border-weak)";
    COLORS2.DEFAULT_ICON_IN = "var(--default-icon-in)";
    COLORS2.DEFAULT_ICON_IN_ACTIVE = "var(--default-icon-in-active)";
    COLORS2.DEFAULT_ICON_IN_DISABLED = "var(--default-icon-in-disabled)";
    COLORS2.DEFAULT_ICON_IN_FOCUS = "var(--default-icon-in-focus)";
    COLORS2.DEFAULT_ICON_IN_HOVER = "var(--default-icon-in-hover)";
    COLORS2.DEFAULT_TEXT = "var(--default-text)";
    COLORS2.DEFAULT_TEXT_DISABLED = "var(--default-text-disabled)";
    COLORS2.DEFAULT_TEXT_IN = "var(--default-text-in)";
    COLORS2.DEFAULT_TEXT_IN_ACTIVE = "var(--default-text-in-active)";
    COLORS2.DEFAULT_TEXT_IN_DISABLED = "var(--default-text-in-disabled)";
    COLORS2.DEFAULT_TEXT_IN_FOCUS = "var(--default-text-in-focus)";
    COLORS2.DEFAULT_TEXT_IN_HOVER = "var(--default-text-in-hover)";
    COLORS2.DEFAULT_TEXT_IN_WEAK = "var(--default-text-in-weak)";
    COLORS2.DEFAULT_TEXT_MEDIUM = "var(--default-text-medium)";
    COLORS2.DEFAULT_TEXT_MEDIUM_DISABLED = "var(--default-text-medium-disabled)";
    COLORS2.DEFAULT_TEXT_STRONG = "var(--default-text-strong)";
    COLORS2.DEFAULT_TEXT_STRONG_DISABLED = "var(--default-text-strong-disabled)";
    COLORS2.DEFAULT_TEXT_WEAK = "var(--default-text-weak)";
    COLORS2.DEFAULT_TEXT_WEAK_DISABLED = "var(--default-text-weak-disabled)";
    COLORS2.DORMANT_BG = "var(--dormant-bg)";
    COLORS2.DORMANT_BG_DISABLED = "var(--dormant-bg-disabled)";
    COLORS2.DORMANT_BG_MEDIUM = "var(--dormant-bg-medium)";
    COLORS2.DORMANT_BG_MEDIUM_DISABLED = "var(--dormant-bg-medium-disabled)";
    COLORS2.DORMANT_BORDER = "var(--dormant-border)";
    COLORS2.DORMANT_BORDER_DISABLED = "var(--dormant-border-disabled)";
    COLORS2.DORMANT_ICON = "var(--dormant-icon)";
    COLORS2.DORMANT_ICON_DISABLED = "var(--dormant-icon-disabled)";
    COLORS2.DORMANT_ICON_IN = "var(--dormant-icon-in)";
    COLORS2.DORMANT_ICON_IN_DISABLED = "var(--dormant-icon-in-disabled)";
    COLORS2.DORMANT_ICON_IN_MEDIUM = "var(--dormant-icon-in-medium)";
    COLORS2.DORMANT_ICON_MEDIUM = "var(--dormant-icon-medium)";
    COLORS2.INFO_BG = "var(--info-bg)";
    COLORS2.INFO_BG_ACTIVE = "var(--info-bg-active)";
    COLORS2.INFO_BG_DISABLED = "var(--info-bg-disabled)";
    COLORS2.INFO_BG_FOCUS = "var(--info-bg-focus)";
    COLORS2.INFO_BG_HOVER = "var(--info-bg-hover)";
    COLORS2.INFO_BG_MEDIUM = "var(--info-bg-medium)";
    COLORS2.INFO_BG_MEDIUM_ACTIVE = "var(--info-bg-medium-active)";
    COLORS2.INFO_BG_MEDIUM_DISABLED = "var(--info-bg-medium-disabled)";
    COLORS2.INFO_BG_MEDIUM_FOCUS = "var(--info-bg-medium-focus)";
    COLORS2.INFO_BG_MEDIUM_HOVER = "var(--info-bg-medium-hover)";
    COLORS2.INFO_BG_STRONG = "var(--info-bg-strong)";
    COLORS2.INFO_BG_WEAK = "var(--info-bg-weak)";
    COLORS2.INFO_BG_WEAK_ACTIVE = "var(--info-bg-weak-active)";
    COLORS2.INFO_BG_WEAK_DISABLED = "var(--info-bg-weak-disabled)";
    COLORS2.INFO_BG_WEAK_FOCUS = "var(--info-bg-weak-focus)";
    COLORS2.INFO_BG_WEAK_HOVER = "var(--info-bg-weak-hover)";
    COLORS2.INFO_BORDER = "var(--info-border)";
    COLORS2.INFO_BORDER_ACTIVE = "var(--info-border-active)";
    COLORS2.INFO_BORDER_DISABLED = "var(--info-border-disabled)";
    COLORS2.INFO_BORDER_FOCUS = "var(--info-border-focus)";
    COLORS2.INFO_BORDER_HOVER = "var(--info-border-hover)";
    COLORS2.INFO_BORDER_WEAK = "var(--info-border-weak)";
    COLORS2.INFO_BORDER_WEAK_ACTIVE = "var(--info-border-weak-active)";
    COLORS2.INFO_BORDER_WEAK_DISABLED = "var(--info-border-weak-disabled)";
    COLORS2.INFO_BORDER_WEAK_FOCUS = "var(--info-border-weak-focus)";
    COLORS2.INFO_BORDER_WEAK_HOVER = "var(--info-border-weak-hover)";
    COLORS2.INFO_ICON = "var(--info-icon)";
    COLORS2.INFO_ICON_ACTIVE = "var(--info-icon-active)";
    COLORS2.INFO_ICON_DISABLED = "var(--info-icon-disabled)";
    COLORS2.INFO_ICON_FOCUS = "var(--info-icon-focus)";
    COLORS2.INFO_ICON_HOVER = "var(--info-icon-hover)";
    COLORS2.INFO_ICON_IN = "var(--info-icon-in)";
    COLORS2.INFO_ICON_IN_ACTIVE = "var(--info-icon-in-active)";
    COLORS2.INFO_ICON_IN_DISABLED = "var(--info-icon-in-disabled)";
    COLORS2.INFO_ICON_IN_FOCUS = "var(--info-icon-in-focus)";
    COLORS2.INFO_ICON_IN_HOVER = "var(--info-icon-in-hover)";
    COLORS2.INFO_ICON_WEAK = "var(--info-icon-weak)";
    COLORS2.INFO_ICON_WEAK_ACTIVE = "var(--info-icon-weak-active)";
    COLORS2.INFO_ICON_WEAK_DISABLED = "var(--info-icon-weak-disabled)";
    COLORS2.INFO_ICON_WEAK_FOCUS = "var(--info-icon-weak-focus)";
    COLORS2.INFO_ICON_WEAK_HOVER = "var(--info-icon-weak-hover)";
    COLORS2.INTERACT_BG = "var(--interact-bg)";
    COLORS2.INTERACT_BG_ACTIVE = "var(--interact-bg-active)";
    COLORS2.INTERACT_BG_DISABLED = "var(--interact-bg-disabled)";
    COLORS2.INTERACT_BG_FOCUS = "var(--interact-bg-focus)";
    COLORS2.INTERACT_BG_HOVER = "var(--interact-bg-hover)";
    COLORS2.INTERACT_BG_MEDIUM = "var(--interact-bg-medium)";
    COLORS2.INTERACT_BG_WEAK = "var(--interact-bg-weak)";
    COLORS2.INTERACT_BG_WEAK_ACTIVE = "var(--interact-bg-weak-active)";
    COLORS2.INTERACT_BG_WEAK_DISABLED = "var(--interact-bg-weak-disabled)";
    COLORS2.INTERACT_BG_WEAK_FOCUS = "var(--interact-bg-weak-focus)";
    COLORS2.INTERACT_BG_WEAK_HOVER = "var(--interact-bg-weak-hover)";
    COLORS2.INTERACT_BORDER = "var(--interact-border)";
    COLORS2.INTERACT_BORDER_ACTIVE = "var(--interact-border-active)";
    COLORS2.INTERACT_BORDER_DISABLED = "var(--interact-border-disabled)";
    COLORS2.INTERACT_BORDER_FOCUS = "var(--interact-border-focus)";
    COLORS2.INTERACT_BORDER_HOVER = "var(--interact-border-hover)";
    COLORS2.INTERACT_BORDER_MEDIUM = "var(--interact-border-medium)";
    COLORS2.INTERACT_BORDER_MEDIUM_ACTIVE = "var(--interact-border-medium-active)";
    COLORS2.INTERACT_BORDER_MEDIUM_DISABLED = "var(--interact-border-medium-disabled)";
    COLORS2.INTERACT_BORDER_MEDIUM_FOCUS = "var(--interact-border-medium-focus)";
    COLORS2.INTERACT_BORDER_MEDIUM_HOVER = "var(--interact-border-medium-hover)";
    COLORS2.INTERACT_BORDER_WEAK = "var(--interact-border-weak)";
    COLORS2.INTERACT_BORDER_WEAK_ACTIVE = "var(--interact-border-weak-active)";
    COLORS2.INTERACT_BORDER_WEAK_DISABLED = "var(--interact-border-weak-disabled)";
    COLORS2.INTERACT_BORDER_WEAK_FOCUS = "var(--interact-border-weak-focus)";
    COLORS2.INTERACT_BORDER_WEAK_HOVER = "var(--interact-border-weak-hover)";
    COLORS2.INTERACT_ICON = "var(--interact-icon)";
    COLORS2.INTERACT_ICON_ACTIVE = "var(--interact-icon-active)";
    COLORS2.INTERACT_ICON_DISABLED = "var(--interact-icon-disabled)";
    COLORS2.INTERACT_ICON_FOCUS = "var(--interact-icon-focus)";
    COLORS2.INTERACT_ICON_HOVER = "var(--interact-icon-hover)";
    COLORS2.INTERACT_ICON_IN = "var(--interact-icon-in)";
    COLORS2.INTERACT_ICON_IN_ACTIVE = "var(--interact-icon-in-active)";
    COLORS2.INTERACT_ICON_IN_DISABLED = "var(--interact-icon-in-disabled)";
    COLORS2.INTERACT_ICON_IN_FOCUS = "var(--interact-icon-in-focus)";
    COLORS2.INTERACT_ICON_IN_HOVER = "var(--interact-icon-in-hover)";
    COLORS2.INTERACT_ICON_MEDIUM = "var(--interact-icon-medium)";
    COLORS2.INTERACT_ICON_MEDIUM_ACTIVE = "var(--interact-icon-medium-active)";
    COLORS2.INTERACT_ICON_MEDIUM_DISABLED = "var(--interact-icon-medium-disabled)";
    COLORS2.INTERACT_ICON_MEDIUM_FOCUS = "var(--interact-icon-medium-focus)";
    COLORS2.INTERACT_ICON_MEDIUM_HOVER = "var(--interact-icon-medium-hover)";
    COLORS2.INTERACT_ICON_WEAK = "var(--interact-icon-weak)";
    COLORS2.INTERACT_ICON_WEAK_ACTIVE = "var(--interact-icon-weak-active)";
    COLORS2.INTERACT_ICON_WEAK_DISABLED = "var(--interact-icon-weak-disabled)";
    COLORS2.INTERACT_ICON_WEAK_FOCUS = "var(--interact-icon-weak-focus)";
    COLORS2.INTERACT_ICON_WEAK_HOVER = "var(--interact-icon-weak-hover)";
    COLORS2.INTERACT_TEXT = "var(--interact-text)";
    COLORS2.INTERACT_TEXT_ACTIVE = "var(--interact-text-active)";
    COLORS2.INTERACT_TEXT_DISABLED = "var(--interact-text-disabled)";
    COLORS2.INTERACT_TEXT_FOCUS = "var(--interact-text-focus)";
    COLORS2.INTERACT_TEXT_HOVER = "var(--interact-text-hover)";
    COLORS2.INTERACT_TEXT_IN = "var(--interact-text-in)";
    COLORS2.INTERACT_TEXT_IN_ACTIVE = "var(--interact-text-in-active)";
    COLORS2.INTERACT_TEXT_IN_DISABLED = "var(--interact-text-in-disabled)";
    COLORS2.INTERACT_TEXT_IN_FOCUS = "var(--interact-text-in-focus)";
    COLORS2.INTERACT_TEXT_IN_HOVER = "var(--interact-text-in-hover)";
    COLORS2.INTERACT_TEXT_WEAK = "var(--interact-text-weak)";
    COLORS2.INTERACT_TEXT_WEAK_ACTIVE = "var(--interact-text-weak-active)";
    COLORS2.INTERACT_TEXT_WEAK_DISABLED = "var(--interact-text-weak-disabled)";
    COLORS2.INTERACT_TEXT_WEAK_FOCUS = "var(--interact-text-weak-focus)";
    COLORS2.INTERACT_TEXT_WEAK_HOVER = "var(--interact-text-weak-hover)";
    COLORS2.INVERSE_BG = "var(--inverse-bg)";
    COLORS2.INVERSE_BG_ACTIVE = "var(--inverse-bg-active)";
    COLORS2.INVERSE_BG_DISABLED = "var(--inverse-bg-disabled)";
    COLORS2.INVERSE_BG_FOCUS = "var(--inverse-bg-focus)";
    COLORS2.INVERSE_BG_GRADIENT_END = "var(--inverse-bg-gradient-end)";
    COLORS2.INVERSE_BG_GRADIENT_START = "var(--inverse-bg-gradient-start)";
    COLORS2.INVERSE_BG_HOVER = "var(--inverse-bg-hover)";
    COLORS2.INVERSE_BG_WEAK = "var(--inverse-bg-weak)";
    COLORS2.INVERSE_BORDER = "var(--inverse-border)";
    COLORS2.INVERSE_BORDER_ACTIVE = "var(--inverse-border-active)";
    COLORS2.INVERSE_BORDER_DISABLED = "var(--inverse-border-disabled)";
    COLORS2.INVERSE_BORDER_FOCUS = "var(--inverse-border-focus)";
    COLORS2.INVERSE_BORDER_HOVER = "var(--inverse-border-hover)";
    COLORS2.INVERSE_ICON = "var(--inverse-icon)";
    COLORS2.INVERSE_ICON_ACTIVE = "var(--inverse-icon-active)";
    COLORS2.INVERSE_ICON_DISABLED = "var(--inverse-icon-disabled)";
    COLORS2.INVERSE_ICON_FOCUS = "var(--inverse-icon-focus)";
    COLORS2.INVERSE_ICON_HOVER = "var(--inverse-icon-hover)";
    COLORS2.INVERSE_ICON_STRONG = "var(--inverse-icon-strong)";
    COLORS2.INVERSE_ICON_STRONG_ACTIVE = "var(--inverse-icon-strong-active)";
    COLORS2.INVERSE_ICON_STRONG_DISABLED = "var(--inverse-icon-strong-disabled)";
    COLORS2.INVERSE_ICON_STRONG_FOCUS = "var(--inverse-icon-strong-focus)";
    COLORS2.INVERSE_ICON_STRONG_HOVER = "var(--inverse-icon-strong-hover)";
    COLORS2.INVERSE_TEXT = "var(--inverse-text)";
    COLORS2.INVERSE_TEXT_ACTIVE = "var(--inverse-text-active)";
    COLORS2.INVERSE_TEXT_DISABLED = "var(--inverse-text-disabled)";
    COLORS2.INVERSE_TEXT_FOCUS = "var(--inverse-text-focus)";
    COLORS2.INVERSE_TEXT_HOVER = "var(--inverse-text-hover)";
    COLORS2.INVERSE_TEXT_MEDIUM = "var(--inverse-text-medium)";
    COLORS2.INVERSE_TEXT_MEDIUM_DISABLED = "var(--inverse-text-medium-disabled)";
    COLORS2.NEGATIVE_BG = "var(--negative-bg)";
    COLORS2.NEGATIVE_BG_ACTIVE = "var(--negative-bg-active)";
    COLORS2.NEGATIVE_BG_DISABLED = "var(--negative-bg-disabled)";
    COLORS2.NEGATIVE_BG_FOCUS = "var(--negative-bg-focus)";
    COLORS2.NEGATIVE_BG_HOVER = "var(--negative-bg-hover)";
    COLORS2.NEGATIVE_BG_MEDIUM = "var(--negative-bg-medium)";
    COLORS2.NEGATIVE_BG_MEDIUM_ACTIVE = "var(--negative-bg-medium-active)";
    COLORS2.NEGATIVE_BG_MEDIUM_DISABLED = "var(--negative-bg-medium-disabled)";
    COLORS2.NEGATIVE_BG_MEDIUM_FOCUS = "var(--negative-bg-medium-focus)";
    COLORS2.NEGATIVE_BG_MEDIUM_HOVER = "var(--negative-bg-medium-hover)";
    COLORS2.NEGATIVE_BG_STRONG = "var(--negative-bg-strong)";
    COLORS2.NEGATIVE_BG_WEAK = "var(--negative-bg-weak)";
    COLORS2.NEGATIVE_BG_WEAK_ACTIVE = "var(--negative-bg-weak-active)";
    COLORS2.NEGATIVE_BG_WEAK_DISABLED = "var(--negative-bg-weak-disabled)";
    COLORS2.NEGATIVE_BG_WEAK_FOCUS = "var(--negative-bg-weak-focus)";
    COLORS2.NEGATIVE_BG_WEAK_HOVER = "var(--negative-bg-weak-hover)";
    COLORS2.NEGATIVE_BORDER = "var(--negative-border)";
    COLORS2.NEGATIVE_BORDER_ACTIVE = "var(--negative-border-active)";
    COLORS2.NEGATIVE_BORDER_DISABLED = "var(--negative-border-disabled)";
    COLORS2.NEGATIVE_BORDER_FOCUS = "var(--negative-border-focus)";
    COLORS2.NEGATIVE_BORDER_HOVER = "var(--negative-border-hover)";
    COLORS2.NEGATIVE_BORDER_MEDIUM = "var(--negative-border-medium)";
    COLORS2.NEGATIVE_BORDER_MEDIUM_ACTIVE = "var(--negative-border-medium-active)";
    COLORS2.NEGATIVE_BORDER_MEDIUM_DISABLED = "var(--negative-border-medium-disabled)";
    COLORS2.NEGATIVE_BORDER_MEDIUM_FOCUS = "var(--negative-border-medium-focus)";
    COLORS2.NEGATIVE_BORDER_MEDIUM_HOVER = "var(--negative-border-medium-hover)";
    COLORS2.NEGATIVE_BORDER_STRONG = "var(--negative-border-strong)";
    COLORS2.NEGATIVE_BORDER_STRONG_ACTIVE = "var(--negative-border-strong-active)";
    COLORS2.NEGATIVE_BORDER_STRONG_DISABLED = "var(--negative-border-strong-disabled)";
    COLORS2.NEGATIVE_BORDER_STRONG_FOCUS = "var(--negative-border-strong-focus)";
    COLORS2.NEGATIVE_BORDER_STRONG_HOVER = "var(--negative-border-strong-hover)";
    COLORS2.NEGATIVE_BORDER_WEAK = "var(--negative-border-weak)";
    COLORS2.NEGATIVE_BORDER_WEAK_ACTIVE = "var(--negative-border-weak-active)";
    COLORS2.NEGATIVE_BORDER_WEAK_DISABLED = "var(--negative-border-weak-disabled)";
    COLORS2.NEGATIVE_BORDER_WEAK_FOCUS = "var(--negative-border-weak-focus)";
    COLORS2.NEGATIVE_BORDER_WEAK_HOVER = "var(--negative-border-weak-hover)";
    COLORS2.NEGATIVE_ICON = "var(--negative-icon)";
    COLORS2.NEGATIVE_ICON_ACTIVE = "var(--negative-icon-active)";
    COLORS2.NEGATIVE_ICON_DISABLED = "var(--negative-icon-disabled)";
    COLORS2.NEGATIVE_ICON_FOCUS = "var(--negative-icon-focus)";
    COLORS2.NEGATIVE_ICON_HOVER = "var(--negative-icon-hover)";
    COLORS2.NEGATIVE_ICON_IN = "var(--negative-icon-in)";
    COLORS2.NEGATIVE_ICON_IN_ACTIVE = "var(--negative-icon-in-active)";
    COLORS2.NEGATIVE_ICON_IN_DISABLED = "var(--negative-icon-in-disabled)";
    COLORS2.NEGATIVE_ICON_IN_FOCUS = "var(--negative-icon-in-focus)";
    COLORS2.NEGATIVE_ICON_IN_HOVER = "var(--negative-icon-in-hover)";
    COLORS2.NEGATIVE_ICON_WEAK = "var(--negative-icon-weak)";
    COLORS2.NEGATIVE_ICON_WEAK_ACTIVE = "var(--negative-icon-weak-active)";
    COLORS2.NEGATIVE_ICON_WEAK_DISABLED = "var(--negative-icon-weak-disabled)";
    COLORS2.NEGATIVE_ICON_WEAK_FOCUS = "var(--negative-icon-weak-focus)";
    COLORS2.NEGATIVE_ICON_WEAK_HOVER = "var(--negative-icon-weak-hover)";
    COLORS2.NEGATIVE_TEXT = "var(--negative-text)";
    COLORS2.NEGATIVE_TEXT_ACTIVE = "var(--negative-text-active)";
    COLORS2.NEGATIVE_TEXT_DISABLED = "var(--negative-text-disabled)";
    COLORS2.NEGATIVE_TEXT_FOCUS = "var(--negative-text-focus)";
    COLORS2.NEGATIVE_TEXT_HOVER = "var(--negative-text-hover)";
    COLORS2.NEGATIVE_TEXT_IN = "var(--negative-text-in)";
    COLORS2.NEGATIVE_TEXT_IN_ACTIVE = "var(--negative-text-in-active)";
    COLORS2.NEGATIVE_TEXT_IN_DISABLED = "var(--negative-text-in-disabled)";
    COLORS2.NEGATIVE_TEXT_IN_FOCUS = "var(--negative-text-in-focus)";
    COLORS2.NEGATIVE_TEXT_IN_HOVER = "var(--negative-text-in-hover)";
    COLORS2.POSITIVE_BG = "var(--positive-bg)";
    COLORS2.POSITIVE_BG_ACTIVE = "var(--positive-bg-active)";
    COLORS2.POSITIVE_BG_DISABLED = "var(--positive-bg-disabled)";
    COLORS2.POSITIVE_BG_FOCUS = "var(--positive-bg-focus)";
    COLORS2.POSITIVE_BG_HOVER = "var(--positive-bg-hover)";
    COLORS2.POSITIVE_BG_MEDIUM = "var(--positive-bg-medium)";
    COLORS2.POSITIVE_BG_MEDIUM_ACTIVE = "var(--positive-bg-medium-active)";
    COLORS2.POSITIVE_BG_MEDIUM_DISABLED = "var(--positive-bg-medium-disabled)";
    COLORS2.POSITIVE_BG_MEDIUM_FOCUS = "var(--positive-bg-medium-focus)";
    COLORS2.POSITIVE_BG_MEDIUM_HOVER = "var(--positive-bg-medium-hover)";
    COLORS2.POSITIVE_BG_STRONG = "var(--positive-bg-strong)";
    COLORS2.POSITIVE_BG_WEAK = "var(--positive-bg-weak)";
    COLORS2.POSITIVE_BG_WEAK_ACTIVE = "var(--positive-bg-weak-active)";
    COLORS2.POSITIVE_BG_WEAK_DISABLED = "var(--positive-bg-weak-disabled)";
    COLORS2.POSITIVE_BG_WEAK_FOCUS = "var(--positive-bg-weak-focus)";
    COLORS2.POSITIVE_BG_WEAK_HOVER = "var(--positive-bg-weak-hover)";
    COLORS2.POSITIVE_BORDER = "var(--positive-border)";
    COLORS2.POSITIVE_BORDER_ACTIVE = "var(--positive-border-active)";
    COLORS2.POSITIVE_BORDER_DISABLED = "var(--positive-border-disabled)";
    COLORS2.POSITIVE_BORDER_FOCUS = "var(--positive-border-focus)";
    COLORS2.POSITIVE_BORDER_HOVER = "var(--positive-border-hover)";
    COLORS2.POSITIVE_BORDER_STRONG = "var(--positive-border-strong)";
    COLORS2.POSITIVE_BORDER_STRONG_ACTIVE = "var(--positive-border-strong-active)";
    COLORS2.POSITIVE_BORDER_STRONG_DISABLED = "var(--positive-border-strong-disabled)";
    COLORS2.POSITIVE_BORDER_STRONG_FOCUS = "var(--positive-border-strong-focus)";
    COLORS2.POSITIVE_BORDER_STRONG_HOVER = "var(--positive-border-strong-hover)";
    COLORS2.POSITIVE_BORDER_WEAK = "var(--positive-border-weak)";
    COLORS2.POSITIVE_BORDER_WEAK_ACTIVE = "var(--positive-border-weak-active)";
    COLORS2.POSITIVE_BORDER_WEAK_DISABLED = "var(--positive-border-weak-disabled)";
    COLORS2.POSITIVE_BORDER_WEAK_FOCUS = "var(--positive-border-weak-focus)";
    COLORS2.POSITIVE_BORDER_WEAK_HOVER = "var(--positive-border-weak-hover)";
    COLORS2.POSITIVE_ICON = "var(--positive-icon)";
    COLORS2.POSITIVE_ICON_ACTIVE = "var(--positive-icon-active)";
    COLORS2.POSITIVE_ICON_DISABLED = "var(--positive-icon-disabled)";
    COLORS2.POSITIVE_ICON_FOCUS = "var(--positive-icon-focus)";
    COLORS2.POSITIVE_ICON_HOVER = "var(--positive-icon-hover)";
    COLORS2.POSITIVE_ICON_IN = "var(--positive-icon-in)";
    COLORS2.POSITIVE_ICON_IN_ACTIVE = "var(--positive-icon-in-active)";
    COLORS2.POSITIVE_ICON_IN_DISABLED = "var(--positive-icon-in-disabled)";
    COLORS2.POSITIVE_ICON_IN_FOCUS = "var(--positive-icon-in-focus)";
    COLORS2.POSITIVE_ICON_IN_HOVER = "var(--positive-icon-in-hover)";
    COLORS2.POSITIVE_ICON_STRONG = "var(--positive-icon-strong)";
    COLORS2.POSITIVE_ICON_STRONG_ACTIVE = "var(--positive-icon-strong-active)";
    COLORS2.POSITIVE_ICON_STRONG_DISABLED = "var(--positive-icon-strong-disabled)";
    COLORS2.POSITIVE_ICON_STRONG_FOCUS = "var(--positive-icon-strong-focus)";
    COLORS2.POSITIVE_ICON_STRONG_HOVER = "var(--positive-icon-strong-hover)";
    COLORS2.POSITIVE_ICON_WEAK = "var(--positive-icon-weak)";
    COLORS2.POSITIVE_ICON_WEAK_ACTIVE = "var(--positive-icon-weak-active)";
    COLORS2.POSITIVE_ICON_WEAK_DISABLED = "var(--positive-icon-weak-disabled)";
    COLORS2.POSITIVE_ICON_WEAK_FOCUS = "var(--positive-icon-weak-focus)";
    COLORS2.POSITIVE_ICON_WEAK_HOVER = "var(--positive-icon-weak-hover)";
    COLORS2.POSITIVE_TEXT_IN = "var(--positive-text-in)";
    COLORS2.POSITIVE_TEXT_IN_ACTIVE = "var(--positive-text-in-active)";
    COLORS2.POSITIVE_TEXT_IN_DISABLED = "var(--positive-text-in-disabled)";
    COLORS2.POSITIVE_TEXT_IN_FOCUS = "var(--positive-text-in-focus)";
    COLORS2.POSITIVE_TEXT_IN_HOVER = "var(--positive-text-in-hover)";
    COLORS2.SEVERE_WARNING_BG = "var(--severe-warning-bg)";
    COLORS2.SEVERE_WARNING_BG_ACTIVE = "var(--severe-warning-bg-active)";
    COLORS2.SEVERE_WARNING_BG_DISABLED = "var(--severe-warning-bg-disabled)";
    COLORS2.SEVERE_WARNING_BG_FOCUS = "var(--severe-warning-bg-focus)";
    COLORS2.SEVERE_WARNING_BG_HOVER = "var(--severe-warning-bg-hover)";
    COLORS2.SEVERE_WARNING_BG_MEDIUM = "var(--severe-warning-bg-medium)";
    COLORS2.SEVERE_WARNING_BG_MEDIUM_ACTIVE = "var(--severe-warning-bg-medium-active)";
    COLORS2.SEVERE_WARNING_BG_MEDIUM_DISABLED = "var(--severe-warning-bg-medium-disabled)";
    COLORS2.SEVERE_WARNING_BG_MEDIUM_FOCUS = "var(--severe-warning-bg-medium-focus)";
    COLORS2.SEVERE_WARNING_BG_MEDIUM_HOVER = "var(--severe-warning-bg-medium-hover)";
    COLORS2.SEVERE_WARNING_BG_STRONG = "var(--severe-warning-bg-strong)";
    COLORS2.SEVERE_WARNING_BG_WEAK = "var(--severe-warning-bg-weak)";
    COLORS2.SEVERE_WARNING_BG_WEAK_ACTIVE = "var(--severe-warning-bg-weak-active)";
    COLORS2.SEVERE_WARNING_BG_WEAK_DISABLED = "var(--severe-warning-bg-weak-disabled)";
    COLORS2.SEVERE_WARNING_BG_WEAK_FOCUS = "var(--severe-warning-bg-weak-focus)";
    COLORS2.SEVERE_WARNING_BG_WEAK_HOVER = "var(--severe-warning-bg-weak-hover)";
    COLORS2.SEVERE_WARNING_BORDER = "var(--severe-warning-border)";
    COLORS2.SEVERE_WARNING_BORDER_ACTIVE = "var(--severe-warning-border-active)";
    COLORS2.SEVERE_WARNING_BORDER_DISABLED = "var(--severe-warning-border-disabled)";
    COLORS2.SEVERE_WARNING_BORDER_FOCUS = "var(--severe-warning-border-focus)";
    COLORS2.SEVERE_WARNING_BORDER_HOVER = "var(--severe-warning-border-hover)";
    COLORS2.SEVERE_WARNING_BORDER_WEAK = "var(--severe-warning-border-weak)";
    COLORS2.SEVERE_WARNING_BORDER_WEAK_ACTIVE = "var(--severe-warning-border-weak-active)";
    COLORS2.SEVERE_WARNING_BORDER_WEAK_DISABLED = "var(--severe-warning-border-weak-disabled)";
    COLORS2.SEVERE_WARNING_BORDER_WEAK_FOCUS = "var(--severe-warning-border-weak-focus)";
    COLORS2.SEVERE_WARNING_BORDER_WEAK_HOVER = "var(--severe-warning-border-weak-hover)";
    COLORS2.SEVERE_WARNING_ICON = "var(--severe-warning-icon)";
    COLORS2.SEVERE_WARNING_ICON_ACTIVE = "var(--severe-warning-icon-active)";
    COLORS2.SEVERE_WARNING_ICON_DISABLED = "var(--severe-warning-icon-disabled)";
    COLORS2.SEVERE_WARNING_ICON_FOCUS = "var(--severe-warning-icon-focus)";
    COLORS2.SEVERE_WARNING_ICON_HOVER = "var(--severe-warning-icon-hover)";
    COLORS2.SEVERE_WARNING_ICON_IN = "var(--severe-warning-icon-in)";
    COLORS2.SEVERE_WARNING_ICON_IN_ACTIVE = "var(--severe-warning-icon-in-active)";
    COLORS2.SEVERE_WARNING_ICON_IN_DISABLED = "var(--severe-warning-icon-in-disabled)";
    COLORS2.SEVERE_WARNING_ICON_IN_FOCUS = "var(--severe-warning-icon-in-focus)";
    COLORS2.SEVERE_WARNING_ICON_IN_HOVER = "var(--severe-warning-icon-in-hover)";
    COLORS2.SEVERE_WARNING_ICON_STRONG = "var(--severe-warning-icon-strong)";
    COLORS2.SEVERE_WARNING_ICON_STRONG_ACTIVE = "var(--severe-warning-icon-strong-active)";
    COLORS2.SEVERE_WARNING_ICON_STRONG_DISABLED = "var(--severe-warning-icon-strong-disabled)";
    COLORS2.SEVERE_WARNING_ICON_STRONG_FOCUS = "var(--severe-warning-icon-strong-focus)";
    COLORS2.SEVERE_WARNING_ICON_STRONG_HOVER = "var(--severe-warning-icon-strong-hover)";
    COLORS2.WARNING_BG = "var(--warning-bg)";
    COLORS2.WARNING_BG_ACTIVE = "var(--warning-bg-active)";
    COLORS2.WARNING_BG_DISABLED = "var(--warning-bg-disabled)";
    COLORS2.WARNING_BG_FOCUS = "var(--warning-bg-focus)";
    COLORS2.WARNING_BG_HOVER = "var(--warning-bg-hover)";
    COLORS2.WARNING_BG_MEDIUM = "var(--warning-bg-medium)";
    COLORS2.WARNING_BG_MEDIUM_ACTIVE = "var(--warning-bg-medium-active)";
    COLORS2.WARNING_BG_MEDIUM_DISABLED = "var(--warning-bg-medium-disabled)";
    COLORS2.WARNING_BG_MEDIUM_FOCUS = "var(--warning-bg-medium-focus)";
    COLORS2.WARNING_BG_MEDIUM_HOVER = "var(--warning-bg-medium-hover)";
    COLORS2.WARNING_BG_STRONG = "var(--warning-bg-strong)";
    COLORS2.WARNING_BG_WEAK = "var(--warning-bg-weak)";
    COLORS2.WARNING_BG_WEAK_ACTIVE = "var(--warning-bg-weak-active)";
    COLORS2.WARNING_BG_WEAK_DISABLED = "var(--warning-bg-weak-disabled)";
    COLORS2.WARNING_BG_WEAK_FOCUS = "var(--warning-bg-weak-focus)";
    COLORS2.WARNING_BG_WEAK_HOVER = "var(--warning-bg-weak-hover)";
    COLORS2.WARNING_BORDER = "var(--warning-border)";
    COLORS2.WARNING_BORDER_ACTIVE = "var(--warning-border-active)";
    COLORS2.WARNING_BORDER_DISABLED = "var(--warning-border-disabled)";
    COLORS2.WARNING_BORDER_FOCUS = "var(--warning-border-focus)";
    COLORS2.WARNING_BORDER_HOVER = "var(--warning-border-hover)";
    COLORS2.WARNING_BORDER_STRONG = "var(--warning-border-strong)";
    COLORS2.WARNING_BORDER_STRONG_ACTIVE = "var(--warning-border-strong-active)";
    COLORS2.WARNING_BORDER_STRONG_DISABLED = "var(--warning-border-strong-disabled)";
    COLORS2.WARNING_BORDER_STRONG_FOCUS = "var(--warning-border-strong-focus)";
    COLORS2.WARNING_BORDER_STRONG_HOVER = "var(--warning-border-strong-hover)";
    COLORS2.WARNING_BORDER_WEAK = "var(--warning-border-weak)";
    COLORS2.WARNING_BORDER_WEAK_ACTIVE = "var(--warning-border-weak-active)";
    COLORS2.WARNING_BORDER_WEAK_DISABLED = "var(--warning-border-weak-disabled)";
    COLORS2.WARNING_BORDER_WEAK_FOCUS = "var(--warning-border-weak-focus)";
    COLORS2.WARNING_BORDER_WEAK_HOVER = "var(--warning-border-weak-hover)";
    COLORS2.WARNING_ICON = "var(--warning-icon)";
    COLORS2.WARNING_ICON_ACTIVE = "var(--warning-icon-active)";
    COLORS2.WARNING_ICON_DISABLED = "var(--warning-icon-disabled)";
    COLORS2.WARNING_ICON_FOCUS = "var(--warning-icon-focus)";
    COLORS2.WARNING_ICON_HOVER = "var(--warning-icon-hover)";
    COLORS2.WARNING_ICON_IN = "var(--warning-icon-in)";
    COLORS2.WARNING_ICON_IN_ACTIVE = "var(--warning-icon-in-active)";
    COLORS2.WARNING_ICON_IN_DISABLED = "var(--warning-icon-in-disabled)";
    COLORS2.WARNING_ICON_IN_FOCUS = "var(--warning-icon-in-focus)";
    COLORS2.WARNING_ICON_IN_HOVER = "var(--warning-icon-in-hover)";
    COLORS2.WARNING_ICON_STRONG = "var(--warning-icon-strong)";
    COLORS2.WARNING_ICON_STRONG_ACTIVE = "var(--warning-icon-strong-active)";
    COLORS2.WARNING_ICON_STRONG_DISABLED = "var(--warning-icon-strong-disabled)";
    COLORS2.WARNING_ICON_STRONG_FOCUS = "var(--warning-icon-strong-focus)";
    COLORS2.WARNING_ICON_STRONG_HOVER = "var(--warning-icon-strong-hover)";
    COLORS2.WARNING_TEXT_IN = "var(--warning-text-in)";
    COLORS2.WARNING_TEXT_IN_ACTIVE = "var(--warning-text-in-active)";
    COLORS2.WARNING_TEXT_IN_DISABLED = "var(--warning-text-in-disabled)";
    COLORS2.WARNING_TEXT_IN_FOCUS = "var(--warning-text-in-focus)";
    COLORS2.WARNING_TEXT_IN_HOVER = "var(--warning-text-in-hover)";
  })(COLORS = MAGNETIC_TOKENS125.COLORS || (MAGNETIC_TOKENS125.COLORS = {}));
  let PARTICLE;
  ((PARTICLE2) => {
    PARTICLE2.COLOR_SCHEME = "var(--particle-color-scheme)";
    PARTICLE2.ACTIVE_ICON = "var(--particle-active-icon)";
    PARTICLE2.INACTIVE_ICON = "var(--particle-inactive-icon)";
    PARTICLE2.TERMINATED_ICON = "var(--particle-terminated-icon)";
    PARTICLE2.UNKNOWN_ICON = "var(--particle-unknown-icon)";
    PARTICLE2.UNKNOWN_ICON_ACTIVE = "var(--particle-unknown-icon-active)";
    let EFFECTS2;
    ((EFFECTS3) => {
      EFFECTS3.SHADOW = "var(--particle-effects-shadow)";
    })(EFFECTS2 = PARTICLE2.EFFECTS || (PARTICLE2.EFFECTS = {}));
  })(PARTICLE = MAGNETIC_TOKENS125.PARTICLE || (MAGNETIC_TOKENS125.PARTICLE = {}));
  let STATIC;
  ((STATIC2) => {
    STATIC2.ACTIVE = "#3FB6F2";
    STATIC2.CRITICAL = "#FA5762";
    STATIC2.HEADER_BG = "#23282E";
    STATIC2.HEADER_ICON = "#F7F7F7";
    STATIC2.INACTIVE = "#6F7680";
    STATIC2.MODAL_BACKDROP = "#0000007f";
    STATIC2.NORMAL = "#0F874C";
    STATIC2.PROFILE_ICON = "#E3EEFF";
    STATIC2.PROFILE_ICON_FILL = "#6C9EF5";
    STATIC2.RESIZE_BOX = "#000";
    STATIC2.TERMINATED = "#FFC4D5";
    STATIC2.UNKNOWN = "#A7ADB5";
    STATIC2.WARNING = "#F0C243";
    STATIC2.CARD_LEFT_BORDER = "#6977F0";
  })(STATIC = MAGNETIC_TOKENS125.STATIC || (MAGNETIC_TOKENS125.STATIC = {}));
  let EFFECTS;
  ((EFFECTS2) => {
    EFFECTS2.TRANSITION = "all 0.1s cubic-bezier(0.7, 0.3, 0.1, 1)";
    EFFECTS2.SHADOW_FLOATING = "0 4px 12px 0px rgba(0, 0, 0, 0.18)";
    EFFECTS2.SHADOW_FLOATING_REVERSE = "0 -4px 12px #000000e6";
    EFFECTS2.SHADOW_RAISED = "0 4px 12px #0000001f";
    EFFECTS2.SHADOW_RAISED_REVERSE = "0 -4px 12px #0000001f";
    EFFECTS2.SHAODW_LIFTED = "0 3px 8px #00000014";
    EFFECTS2.SHADOW_LIFTED_REVERSE = "0 -3px 8px #00000014";
    EFFECTS2.SHADOW_SUBTLE = "0 2px 5px #0000000d";
    EFFECTS2.SHADOW_SUBTLE_REVERSE = "0 -2px 5px #0000000d";
    EFFECTS2.SHADOW_FOCUS = "0 0 0 2px var(--interact-bg-weak-active), 0 0 0 4px var(--control-border-focus)";
    EFFECTS2.SHADOW_FOCUS_NEGATIVE = "0 0 0 2px var(--negative-bg-weak-active), 0 0 0 4px var(--negative-border-medium)";
  })(EFFECTS = MAGNETIC_TOKENS125.EFFECTS || (MAGNETIC_TOKENS125.EFFECTS = {}));
  let EFFECT;
  ((EFFECT2) => {
    let SHADOW5;
    ((SHADOW6) => {
      SHADOW6.DEFAULT = "0 5px 15px 0 #0000004d";
      SHADOW6.DEFAULT_RLTB = "0 0 15px -1px #0000004d";
      SHADOW6.ELEVATED = "0 10px 30px 0 #0000004d";
      SHADOW6.LIGHT = "0 1px 2px 0 #0000004d";
    })(SHADOW5 = EFFECT2.SHADOW || (EFFECT2.SHADOW = {}));
  })(EFFECT = MAGNETIC_TOKENS125.EFFECT || (MAGNETIC_TOKENS125.EFFECT = {}));
  let FONT4;
  ((FONT5) => {
    FONT5.ROBOTO = {
      400: {
        fontDisplay: "fallback",
        fontFamily: "Roboto",
        fontWeight: 400,
        src: "Roboto.latin.400.woff2",
        unicodeRange: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
      },
      500: {
        fontDisplay: "fallback",
        fontFamily: "Roboto",
        fontWeight: 500,
        src: "Roboto.latin.500.woff2",
        unicodeRange: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
      },
      700: {
        fontDisplay: "fallback",
        fontFamily: "Roboto",
        fontWeight: 700,
        src: "Roboto.latin.700.woff2",
        unicodeRange: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
      },
      fontFamily: "Roboto"
    };
    FONT5.ROBOTO_MONO = {
      400: {
        fontDisplay: "fallback",
        fontFamily: "Roboto Mono",
        fontWeight: 400,
        src: "RobotoMono.latin.400.woff2",
        unicodeRange: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
      },
      fontFamily: "Roboto Mono"
    };
    FONT5.INTER = {
      400: {
        fontDisplay: "fallback",
        fontFamily: "Inter",
        fontStyle: "normal",
        fontWeight: 400,
        src: "Inter.latin.400.woff2",
        unicodeRange: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
      },
      600: {
        fontDisplay: "fallback",
        fontFamily: "Inter",
        fontWeight: 600,
        src: "Inter.latin.600.woff2",
        unicodeRange: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
      },
      700: {
        fontDisplay: "fallback",
        fontFamily: "Inter",
        fontWeight: 700,
        src: "Inter.latin.700.woff2",
        unicodeRange: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
      },
      fontFamily: "Inter"
    };
    FONT5.SHARP_SANS = {
      700: {
        fontDisplay: "fallback",
        fontFamily: "Sharp Sans",
        fontWeight: 700,
        src: "SharpSans.latin.700.woff2"
      },
      fontFamily: "Sharp Sans"
    };
    FONT5.SOURCE_CODE_PRO = {
      fontDisplay: "fallback",
      fontFamily: "Source Code Pro",
      fontWeight: 400,
      src: "SourceCodePro.latin.wght.woff2",
      unicodeRange: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    };
  })(FONT4 = MAGNETIC_TOKENS125.FONT || (MAGNETIC_TOKENS125.FONT = {}));
  let LINE;
  ((LINE2) => {
    LINE2.DEFAULT = 1;
    LINE2.FAT = 4;
    LINE2.MEDIUM = 2;
    LINE2.THICK = 3;
  })(LINE = MAGNETIC_TOKENS125.LINE || (MAGNETIC_TOKENS125.LINE = {}));
  let MOTION2;
  ((MOTION3) => {
    let DURATION3;
    ((DURATION4) => {
      DURATION4.FAST = "100ms";
      DURATION4.LAZY = "600ms";
      DURATION4.MEDIUM = "200ms";
      DURATION4.SLOW = "400ms";
    })(DURATION3 = MOTION3.DURATION || (MOTION3.DURATION = {}));
    let EASING3;
    ((EASING4) => {
      EASING4.LINEAR = "cubic-bezier(0, 0, 1, 1)";
      EASING4.STANDARD = "cubic-bezier(0.4, 0, 0.2, 1)";
      EASING4.DECELERATE = "cubic-bezier(0, 0, 0.2, 1)";
      EASING4.ACCELERATE = "cubic-bezier(0.4, 0, 1, 1)";
    })(EASING3 = MOTION3.EASING || (MOTION3.EASING = {}));
    let INTERACTIONS;
    ((INTERACTIONS2) => {
      INTERACTIONS2.BAR_ACTIVE = {
        DURATION: DURATION3.MEDIUM,
        EASING: EASING3.STANDARD
      };
      INTERACTIONS2.BAR_DEFAULT = INTERACTIONS2.BAR_ACTIVE;
      INTERACTIONS2.BAR_TRANSLATION = INTERACTIONS2.BAR_ACTIVE;
      INTERACTIONS2.COLOR_CHANGE = {
        DURATION: DURATION3.FAST,
        EASING: EASING3.STANDARD
      };
      INTERACTIONS2.DISCLOSE_IN = {
        DURATION: DURATION3.MEDIUM,
        EASING: EASING3.LINEAR
      };
      INTERACTIONS2.DISCLOSE_OUT = INTERACTIONS2.DISCLOSE_IN;
      INTERACTIONS2.DRAGGABLE = INTERACTIONS2.BAR_ACTIVE;
      INTERACTIONS2.FADE_IN = {
        DURATION: DURATION3.MEDIUM,
        EASING: EASING3.DECELERATE
      };
      INTERACTIONS2.FADE_OUT = {
        DURATION: DURATION3.MEDIUM,
        EASING: EASING3.ACCELERATE
      };
      INTERACTIONS2.PROGRESS_DETERMINATE = {
        DURATION: DURATION3.SLOW,
        EASING: EASING3.DECELERATE
      };
      INTERACTIONS2.PROGRESS_INDETERMINATE = {
        DURATION: "1s",
        EASING: EASING3.STANDARD
      };
      INTERACTIONS2.RIPPLE = {
        DURATION: DURATION3.LAZY,
        EASING: EASING3.STANDARD
      };
      INTERACTIONS2.RIPPLE_BUSY = {
        DURATION: DURATION3.SLOW,
        EASING: EASING3.STANDARD
      };
      INTERACTIONS2.ROTATE = INTERACTIONS2.DISCLOSE_IN;
      INTERACTIONS2.SHIMMER = INTERACTIONS2.BAR_ACTIVE;
      INTERACTIONS2.SLIDE_IN = INTERACTIONS2.FADE_IN;
      INTERACTIONS2.SLIDE_OUT = INTERACTIONS2.FADE_OUT;
      INTERACTIONS2.SPINNER = {
        DURATION: "1.25s",
        EASING: EASING3.STANDARD
      };
      INTERACTIONS2.STROKE_BACKWARD = INTERACTIONS2.RIPPLE_BUSY;
      INTERACTIONS2.STROKE_FORWARD = INTERACTIONS2.RIPPLE_BUSY;
      INTERACTIONS2.TRANSLATE_FAST = {
        DURATION: DURATION3.FAST,
        EASING: EASING3.LINEAR
      };
    })(INTERACTIONS = MOTION3.INTERACTIONS || (MOTION3.INTERACTIONS = {}));
  })(MOTION2 = MAGNETIC_TOKENS125.MOTION || (MAGNETIC_TOKENS125.MOTION = {}));
  let RADIUS32;
  ((RADIUS33) => {
    RADIUS33.DEFAULT = 4;
    RADIUS33.FULL = "50%";
    RADIUS33.HEAVY = 6;
  })(RADIUS32 = MAGNETIC_TOKENS125.RADIUS || (MAGNETIC_TOKENS125.RADIUS = {}));
  MAGNETIC_TOKENS125.SPACING = [0, 4, 8, 12, 16, 20, 24];
  let GRID;
  ((GRID2) => {
    GRID2.MD_LG = {
      columnGap: MAGNETIC_TOKENS125.SPACING[2],
      display: "grid",
      gridTemplateColumns: "repeat(12, 1fr)",
      marginLeft: MAGNETIC_TOKENS125.SPACING[3],
      marginRight: MAGNETIC_TOKENS125.SPACING[3]
    };
    GRID2.S = {
      ...GRID2.MD_LG,
      gridTemplateColumns: "repeat(8, 1fr)"
    };
    GRID2.XS = { gridTemplateColumns: "repeat(4, 1fr)" };
    GRID2.BREAKPOINTS = [
      {
        start: 0,
        value: GRID2.XS
      },
      {
        start: 600,
        value: GRID2.S
      },
      {
        start: 905,
        value: GRID2.MD_LG
      },
      {
        start: 1240,
        value: GRID2.MD_LG
      }
    ];
  })(GRID = MAGNETIC_TOKENS125.GRID || (MAGNETIC_TOKENS125.GRID = {}));
  let TYPOGRAPHY2;
  ((TYPOGRAPHY3) => {
    TYPOGRAPHY3.FONT_BODY = "var(--typography-font-body)";
    TYPOGRAPHY3.FONT_CODE = "var(--typography-font-code)";
    TYPOGRAPHY3.FONT_FALLBACK = "var(--typography-font-fallback)";
    TYPOGRAPHY3.FONT_HEADING = "var(--typography-font-heading)";
    TYPOGRAPHY3.HEADING_PRIMARY = "var(--typography-heading-primary)";
    TYPOGRAPHY3.HEADING_SECTION = "var(--typography-heading-section)";
    TYPOGRAPHY3.HEADING_SMALLEST = "var(--typography-heading-smallest)";
    TYPOGRAPHY3.HEADING_SUB_SECTION = "var(--typography-heading-sub-section)";
    TYPOGRAPHY3.LINE_HEIGHT_HEADING_PRIMARY = "var(--typography-line-height-heading-primary)";
    TYPOGRAPHY3.LINE_HEIGHT_HEADING_SECTION = "var(--typography-line-height-heading-section)";
    TYPOGRAPHY3.LINE_HEIGHT_HEADING_SMALLEST = "var(--typography-line-height-heading-smallest)";
    TYPOGRAPHY3.LINE_HEIGHT_HEADING_SUB_SECTION = "var(--typography-line-height-heading-sub-section)";
    TYPOGRAPHY3.LINE_HEIGHT_P1 = "var(--typography-line-height-p1)";
    TYPOGRAPHY3.LINE_HEIGHT_P2 = "var(--typography-line-height-p2)";
    TYPOGRAPHY3.LINE_HEIGHT_P3 = "var(--typography-line-height-p3)";
    TYPOGRAPHY3.LINE_HEIGHT_P4 = "var(--typography-line-height-p4)";
    TYPOGRAPHY3.MONOSPACE_DEFAULT = "var(--typography-monospace-default)";
    TYPOGRAPHY3.P1_BOLD = "var(--typography-p1-bold)";
    TYPOGRAPHY3.P1_DEFAULT = "var(--typography-p1-default)";
    TYPOGRAPHY3.P1_EMPHASIS = "var(--typography-p1-emphasis)";
    TYPOGRAPHY3.P2_BOLD = "var(--typography-p2-bold)";
    TYPOGRAPHY3.P2_DEFAULT = "var(--typography-p2-default)";
    TYPOGRAPHY3.P2_EMPHASIS = "var(--typography-p2-emphasis)";
    TYPOGRAPHY3.P3_BOLD = "var(--typography-p3-bold)";
    TYPOGRAPHY3.P3_DEFAULT = "var(--typography-p3-default)";
    TYPOGRAPHY3.P3_EMPHASIS = "var(--typography-p3-emphasis)";
    TYPOGRAPHY3.P4_DEFAULT = "var(--typography-p4-default)";
    TYPOGRAPHY3.P4_EMPHASIS = "var(--typography-p4-emphasis)";
    TYPOGRAPHY3.SIZE_HEADING_PRIMARY = "var(--typography-size-heading-primary)";
    TYPOGRAPHY3.SIZE_HEADING_SECTION = "var(--typography-size-heading-section)";
    TYPOGRAPHY3.SIZE_HEADING_SMALLEST = "var(--typography-size-heading-smallest)";
    TYPOGRAPHY3.SIZE_HEADING_SUB_SECTION = "var(--typography-size-heading-sub-section)";
    TYPOGRAPHY3.SIZE_P1 = "var(--typography-size-p1)";
    TYPOGRAPHY3.SIZE_P2 = "var(--typography-size-p2)";
    TYPOGRAPHY3.SIZE_P3 = "var(--typography-size-p3)";
    TYPOGRAPHY3.SIZE_P4 = "var(--typography-size-p4)";
    TYPOGRAPHY3.WEIGHT_BOLD = "var(--typography-weight-bold)";
    TYPOGRAPHY3.WEIGHT_DEFAULT = "var(--typography-weight-default)";
    TYPOGRAPHY3.WEIGHT_EMPHASIS = "var(--typography-weight-emphasis)";
    let A;
    ((A2) => {
      A2.DEFAULT = {
        ...FONT4.INTER[400],
        fontSize: 13,
        lineHeight: "15.6px"
      };
      A2.HOVER = {
        ...A2.DEFAULT,
        textDecoration: "underline"
      };
      A2.SMALL = {
        ...A2.DEFAULT,
        fontSize: 11,
        lineHeight: "13px"
      };
      A2.SMALL_HOVER = {
        ...A2.SMALL,
        textDecoration: "underline"
      };
    })(A = TYPOGRAPHY3.A || (TYPOGRAPHY3.A = {}));
    let BODY2;
    ((BODY3) => {
      BODY3.DEFAULT = {
        ...FONT4.INTER[400],
        fontSize: 13,
        lineHeight: "15px"
      };
      BODY3.FIXED_WIDTH = {
        ...BODY3.DEFAULT,
        fontFamily: FONT4.SOURCE_CODE_PRO.fontFamily
      };
      BODY3.SMALL = {
        ...BODY3.DEFAULT,
        fontSize: 11,
        lineHeight: "13px"
      };
      BODY3.SMALL_LABEL = {
        ...BODY3.SMALL,
        fontWeight: 500
      };
    })(BODY2 = TYPOGRAPHY3.BODY || (TYPOGRAPHY3.BODY = {}));
    let HEADINGS;
    ((HEADINGS2) => {
      HEADINGS2.H1 = {
        ...FONT4.INTER[600],
        fontSize: 28,
        lineHeight: "33px"
      };
      HEADINGS2.GRID = {
        ...HEADINGS2.H1,
        fontSize: 13,
        lineHeight: "15px"
      };
      HEADINGS2.H2 = {
        ...HEADINGS2.H1,
        fontSize: 24,
        fontWeight: 400,
        lineHeight: "28px"
      };
      HEADINGS2.H3 = {
        ...HEADINGS2.H1,
        fontSize: 22,
        fontWeight: 400,
        lineHeight: "25px"
      };
      HEADINGS2.H4 = {
        ...HEADINGS2.H1,
        fontSize: 18,
        lineHeight: "21px"
      };
      HEADINGS2.PANEL = {
        ...HEADINGS2.H1,
        fontSize: 11,
        lineHeight: "13.2px",
        textTransform: "uppercase"
      };
      HEADINGS2.SECTION = {
        ...HEADINGS2.H1,
        fontSize: 13,
        lineHeight: "15.6px",
        textTransform: "uppercase"
      };
      HEADINGS2.SUBTITLE = {
        ...HEADINGS2.H1,
        fontSize: 16,
        lineHeight: "19px"
      };
    })(HEADINGS = TYPOGRAPHY3.HEADINGS || (TYPOGRAPHY3.HEADINGS = {}));
    let TEXT4;
    ((TEXT5) => {
      let ACTION;
      ((ACTION2) => {
        ACTION2.DEFAULT = {
          ...FONT4.INTER[600],
          fontSize: 14,
          lineHeight: "16px"
        };
        ACTION2.DISABLED = {
          ...ACTION2.DEFAULT,
          fontWeight: 400
        };
      })(ACTION = TEXT5.ACTION || (TEXT5.ACTION = {}));
      TEXT5.DEFAULT = {
        ...FONT4.INTER[600],
        fontSize: 13,
        lineHeight: "15px"
      };
      TEXT5.GREY_HOVER_DISABLED_PLACEHOLDER = {
        ...TEXT5.DEFAULT,
        fontWeight: 400
      };
      TEXT5.HINT = {
        ...TEXT5.GREY_HOVER_DISABLED_PLACEHOLDER,
        fontSize: 11,
        lineHeight: "13px"
      };
      TEXT5.LARGE = {
        ...TEXT5.GREY_HOVER_DISABLED_PLACEHOLDER,
        fontSize: 28,
        lineHeight: "33px"
      };
      TEXT5.SELECTED_HOVER = {
        ...TEXT5.DEFAULT,
        lineHeight: "15.6px",
        textDecoration: "underline"
      };
      TEXT5.VALIDATION = TEXT5.HINT;
    })(TEXT4 = TYPOGRAPHY3.TEXT || (TYPOGRAPHY3.TEXT = {}));
    let ELLIPSES26;
    ((ELLIPSES27) => {
      ELLIPSES27.END = {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      };
      ELLIPSES27.START = {
        ...ELLIPSES27.END,
        direction: "rtl",
        textAlign: "left"
      };
    })(ELLIPSES26 = TYPOGRAPHY3.ELLIPSES || (TYPOGRAPHY3.ELLIPSES = {}));
  })(TYPOGRAPHY2 = MAGNETIC_TOKENS125.TYPOGRAPHY || (MAGNETIC_TOKENS125.TYPOGRAPHY = {}));
})(MAGNETIC_TOKENS || (MAGNETIC_TOKENS = {}));

// css/css.ts
var import_uik10 = require("@appd/uik");

// css/parseJSON.ts
var parseJSON = /* @__PURE__ */ __name((json) => {
  if (json == void 0) {
    return;
  }
  const mapping = flatten(json, [], {});
  return Object.keys(mapping).map((key) => {
    const varKey = `--${key.replace(/\./g, "-")}`;
    const value = mapping[key];
    return `${varKey}:${value}`;
  });
}, "parseJSON");
var flatten = /* @__PURE__ */ __name((json, prefix, current) => {
  const _prefix = prefix || [];
  const _current = current || {};
  if (typeof json === "object" && json !== null) {
    Object.keys(json).forEach((key) => {
      flatten(json[key], prefix.concat(key), current);
    });
  } else if (typeof json === "string") {
    const key = _prefix.join(".");
    _current[key] = json;
  }
  return current;
}, "flatten");

// css/RENDERER/RENDERER.ts
var import_uik4 = require("@appd/uik");
var import_fela = require("fela");
var import_fela_dom = require("fela-dom");
var import_fela_enforce_longhands = __toESM(require("fela-enforce-longhands"));
var import_fela_monolithic = __toESM(require("fela-monolithic"));
var import_fela_plugin_embedded = __toESM(require("fela-plugin-embedded"));
var import_fela_plugin_prefixer = __toESM(require("fela-plugin-prefixer"));
var import_fela_plugin_unit = __toESM(require("fela-plugin-unit"));
var import_react_fela = require("react-fela");

// css/RENDERER/debug.ts
var debug = /* @__PURE__ */ __name(() => ({ _, ...styles }) => ((typeof _ === "function" ? _ : void 0)?.(styles), styles), "debug");

// css/RENDERER/multipleSelectors.ts
var import_uik2 = require("@appd/uik");
var multipleSelectors = /* @__PURE__ */ __name((isObject = (x) => x !== null && typeof x === "object" && !Array.isArray(x), merge = (a, b) => isObject(a) && isObject(b) ? {
  ...a,
  ...import_uik2.utils.transform(b).by(
    (entries) => entries.map(([key, value]) => [key, merge(import_uik2.utils.maybeGet(a, key), value)])
  )
} : b, transform2 = (styles) => import_uik2.utils.transform(styles).by(
  (entries) => [
    ...import_uik2.utils.group(
      entries.flatMap(([key, value]) => {
        const transformed = isObject(value) ? transform2(value) : value;
        return typeof key === "string" ? key.split(",").map((key2) => key2.trim()).map((key2) => [key2, transformed]) : [[key, transformed]];
      })
    ).by(
      ([key]) => key,
      ([, value]) => value
    ).entries()
  ].map(([key, values]) => [key, values.reduce((a, b) => merge(a, b))])
)) => transform2, "multipleSelectors");

// css/RENDERER/unwrapWebpackDefaultExport.ts
var import_uik3 = require("@appd/uik");
var unwrapWebpackDefaultExport = /* @__PURE__ */ __name((module2) => (
  // @ts-expect-error
  // Conditional generics can't be inferred.
  import_uik3.utils.maybeGet(module2, "default") ? unwrapWebpackDefaultExport(import_uik3.utils.maybeGet(module2, "default")) : module2
), "unwrapWebpackDefaultExport");

// css/disableCssInheritance.ts
var disableCssInheritance = /* @__PURE__ */ __name((styles, type = "RULE") => type === "RULE" ? {
  all: "revert",
  ...styles
} : styles, "disableCssInheritance");

// css/RENDERER/RENDERER.ts
var RENDERER = Object.assign(
  // @ts-expect-error
  // Expression produces a union type that is too complex to represent.ts(2590)
  (0, import_fela.createRenderer)({
    devMode: import_uik4.utils.IS_DEV_MODE,
    enhancers: [
      /**
       * Handles the caveat about "longhand" (`padding: 0 0 0 0`) vs. "shorthand" (`padding-left: 0`) property
       * precedence.
       * (https://fela.js.org/docs/latest/intro/caveats#shorthand-&-longhand-properties)
       * (https://github.com/robinweser/fela/tree/master/packages/fela-enforce-longhands)
       */
      unwrapWebpackDefaultExport(import_fela_enforce_longhands.default)(),
      import_uik4.utils.IS_JEST && unwrapWebpackDefaultExport(import_fela_monolithic.default)()
    ].filter(import_uik4.utils.Boolean),
    filterClassName: (cls) => cls !== "vs",
    /** ⚠️ Careful: {@link https://fela.js.org/docs/latest/advanced/plugins#order-matters Order Matters}. */
    plugins: [
      /**
       * Enables defining keyframes and new fonts more intuitively (inline).
       * (https://github.com/robinweser/fela/tree/master/packages/fela-plugin-embedded)
       */
      unwrapWebpackDefaultExport(import_fela_plugin_embedded.default)(),
      /**
       * Enables
       * ```
       * {
       *   "& .hello, & .world": {
       *     color: "blue"
       *   }
       * }
       * ```
       * instead of
       * ```
       * {
       *   "& .hello": {
       *     color: "blue"
       *   },
       *   "& .world": {
       *     color: "blue"
       *   }
       * }
       * ```
       * (https://github.com/robinweser/fela/tree/master/packages/fela-plugin-multiple-selectors)
       *
       * Overridden in `./multipleSelectors` due to TMNT-4920.
       */
      multipleSelectors(),
      disableCssInheritance,
      /**
       * Enables `{ width: 100 }` instead of `{ width: "100px" }`.
       * (https://github.com/robinweser/fela/tree/master/packages/fela-plugin-unit)
       *
       * See unitless properties here:
       * (https://github.com/robinweser/css-in-js-utils/blob/a486596c740c441fcb071a18a0133921992df5d6/modules/isUnitlessProperty.ts#L3-L24)
       */
      unwrapWebpackDefaultExport(import_fela_plugin_unit.default)(),
      /**
       * Adds browser prefixes to CSS properties and values.
       * (https://github.com/robinweser/fela/tree/master/packages/fela-plugin-prefixer)
       */
      unwrapWebpackDefaultExport(import_fela_plugin_prefixer.default)(),
      // @ts-expect-error
      // Type '...' is not assignable to type 'TPlugin<Record<string, unknown>>'.ts(2322)
      debug()
    ]
  }),
  {
    // @ts-expect-error
    // Expression produces a union type that is too complex to represent.ts(2590)
    renderToMarkup: () => (0, import_fela_dom.renderToMarkup)(RENDERER),
    // @ts-expect-error
    // ... is not assignable to parameter of type 'IRenderer'.ts(2345)
    renderToNodeList: () => (0, import_react_fela.renderToNodeList)(RENDERER),
    // @ts-expect-error
    // ... is not assignable to parameter of type 'IRenderer'.ts(2345)
    renderToSheetList: () => (0, import_fela_dom.renderToSheetList)(RENDERER),
    // Needed for `combineRules()` behavior of `css()` to work.
    // See detailed explanation at:
    // https://codesandbox.io/s/prefix-based-combinerules-7kfevw?file=/src/index.js
    ruleOrder: []
  }
);

// css/applyTheme.ts
var applyTheme = /* @__PURE__ */ __name((name, json) => {
  if (typeof json !== "object" || json === null) {
    return;
  }
  const themeVars = parseJSON(json);
  RENDERER.renderStatic(`
      :root[uik="${name}"] {
          ${themeVars?.join(";\n")}
      }
    `);
}, "applyTheme");

// css/cache/cache.ts
var import_css_in_js_utils = require("css-in-js-utils");

// css/cache/toJson.ts
var toJson = /* @__PURE__ */ __name(() => [...cache.data].map(([className2, reconstruct]) => reconstruct(`.${className2}`)), "toJson");

// css/cache/cache.ts
var cache = {
  data: /* @__PURE__ */ new Map(),
  next: (entry) => {
    if (entry.type === "CLEAR") {
      return cache.data.clear();
    } else if (entry.type !== "RULE" || // Ignore `all:revert`, because don't want it to ever gain higher precedence.
    // It becomes too powerful.
    entry.declaration === "all:revert" || // Already exists.
    cache.data.has(entry.className)) {
      return;
    }
    const { className: className2, declaration, media, pseudo: rawPseudo, support } = entry;
    const block = Object.fromEntries(
      declaration.split(";").map((entry2) => entry2.split(":")).map(([property, value]) => [(0, import_css_in_js_utils.camelCaseProperty)(property), value])
    );
    const pseudo = rawPseudo.replace(/^(:where[(][^)]+[)])+/, "");
    cache.data.set(
      className2,
      // Reconstruct the rule back into a fully-qualified `Styles` object, with the additional `where` qualifier.
      (where) => [where + pseudo, media, support].reduce(
        (child, selector) => selector ? {
          all: void 0,
          [selector]: child
        } : child,
        block
      )
    );
  },
  toJson
};

// css/CONTEXT.tsx
var import_react4 = require("react");
var CONTEXT = (0, import_react4.createContext)({
  // TODO Make this CONSTANT_CASE ("LIGHT" / "DARK")
  currentTheme: "light",
  setCurrentTheme: () => {
  },
  themes: []
});

// css/hydrate.ts
var import_uik5 = require("@appd/uik");
var import_fela_dom2 = require("fela-dom");
var hydrate = /* @__PURE__ */ __name(() => {
  if (import_uik5.utils.CAN_USE_DOM) {
    (0, import_fela_dom2.rehydrate)(
      /* Compatible JS API */
      RENDERER
    );
  }
  Object.values(RENDERER.cache).forEach(cache.next);
  RENDERER.subscribe(cache.next);
}, "hydrate");

// css/Provider.tsx
var import_uik7 = require("@appd/uik");
var import_react5 = require("react");

// css/applyJSON.ts
var applyJSON = /* @__PURE__ */ __name((json) => {
  if (typeof json !== "object" || json === null) {
    return;
  }
  const vars2 = parseJSON(json);
  RENDERER.renderStatic(`
      :root {
          ${vars2?.join(";\n")}
      }
    `);
}, "applyJSON");

// css/dark.json
var dark_default = {
  "accent-a": "#9ca6ff",
  "accent-a-hover": "#8a95ff",
  "accent-a-weak": "#4d5477",
  "accent-b": "#e3447c",
  "accent-b-hover": "#cf3a7a",
  "accent-b-weak": "#704959",
  "accent-c": "#fcb3c8",
  "accent-c-hover": "#ff87a9",
  "accent-c-weak": "#6f5964",
  "accent-d": "#9b5ff5",
  "accent-d-hover": "#8d4eed",
  "accent-d-weak": "#5b5077",
  "accent-e": "#9dba4c",
  "accent-e-hover": "#89ab2c",
  "accent-e-weak": "#4e5b39",
  "accent-f": "#d95a1a",
  "accent-f-hover": "#c44f14",
  "accent-f-weak": "#6f4b39",
  "accent-g": "#4ad9d9",
  "accent-g-hover": "#17c2c2",
  "accent-g-weak": "#1f5e62",
  "accent-h": "#028e99",
  "accent-h-hover": "#01818c",
  "accent-h-weak": "#45696d",
  "accent-i": "#f582d8",
  "accent-i-hover": "#f26dd1",
  "accent-i-weak": "#6d486a",
  "accent-j": "#767eb2",
  "accent-j-hover": "#6871a3",
  "accent-j-weak": "#505669",
  "accent-k": "#4cbf7f",
  "accent-k-hover": "#36b26e",
  "accent-k-weak": "#315d4a",
  "brand-accent-border": "#52a62b",
  "brand-accent-border-active": "#52a62b",
  "brand-accent-border-focus": "#52a62b",
  "brand-accent-border-hover": "#7e868f",
  "brand-accent-border-medium": "#596069",
  "brand-accent-border-medium-active": "#2b7a0c",
  "brand-accent-border-medium-disabled": "#fff",
  "brand-accent-border-medium-focus": "#fff",
  "brand-accent-border-medium-hover": "#fff",
  "brand-accent-border-strong": "#0f1214",
  "brand-accent-border-strong-active": "#0f1214",
  "brand-accent-border-strong-disabled": "#fff",
  "brand-accent-border-strong-focus": "#fff",
  "brand-accent-border-strong-hover": "#fff",
  "brand-accent-border-weak": "#d0d4d9",
  "brand-accent-border-weak-active": "#398519",
  "brand-accent-border-weak-disabled": "#fff",
  "brand-accent-border-weak-focus": "#fff",
  "brand-accent-border-weak-hover": "#fff",
  "brand-accent-icon": "#c1c6cc",
  "brand-accent-icon-active": "#6bbf41",
  "brand-accent-icon-disabled": "#6f7680",
  "brand-accent-icon-focus": "#fff",
  "brand-accent-icon-medium": "#979fa8",
  "brand-accent-icon-medium-active": "#52a62b",
  "brand-accent-icon-medium-disabled": "#fff",
  "brand-accent-icon-medium-focus": "#fff",
  "brand-accent-icon-weak": "#6f7680",
  "brand-accent-icon-weak-active": "#398519",
  "brand-accent-icon-weak-disabled": "#fff",
  "brand-accent-icon-weak-focus": "#fff",
  "brand-bg": "#373c42",
  "brand-bg-active": "#464c54",
  "brand-bg-disabled": "#e1e4e8",
  "brand-bg-focus": "#464c54",
  "brand-bg-gradient-end": "#0f1214",
  "brand-bg-gradient-start": "#373c42",
  "brand-bg-hover": "#373c42",
  "brand-border-active": "#cce1ff",
  "brand-icon": "#f7f7f7",
  "brand-icon-active": "#fff",
  "brand-icon-hover": "#fff",
  "brand-text": "#f7f7f7",
  "brand-text-active": "#f7f7f7",
  "brand-text-hover": "#f7f7f7",
  "brand-text-strong": "#f0f1f2",
  "brand-text-weak": "#889099",
  "control-bg": "#23282e",
  "control-bg-active": "#2a3442",
  "control-bg-disabled": "#373c42",
  "control-bg-focus": "#2a3442",
  "control-bg-hover": "#2a3442",
  "control-bg-medium": "#23282e",
  "control-bg-medium-active": "#2a3442",
  "control-bg-medium-disabled": "#373c42",
  "control-bg-medium-focus": "#979fa8",
  "control-bg-medium-hover": "#373c42",
  "control-bg-strong": "#649ef5",
  "control-bg-strong-active": "#7cadf7",
  "control-bg-strong-disabled": "#596069",
  "control-bg-strong-focus": "#7cadf7",
  "control-bg-strong-hover": "#7cadf7",
  "control-bg-weak": "#23282e",
  "control-bg-weak-active": "#2a3442",
  "control-bg-weak-disabled": "#373c42",
  "control-bg-weak-focus": "#23282e",
  "control-bg-weak-hover": "#373c42",
  "control-border": "#7e868f",
  "control-border-active": "#7cadf7",
  "control-border-disabled": "#596069",
  "control-border-focus": "#7cadf7",
  "control-border-hover": "#7cadf7",
  "control-border-medium": "#649ef5",
  "control-border-medium-active": "#649ef5",
  "control-border-medium-disabled": "#596069",
  "control-border-medium-focus": "#649ef5",
  "control-border-medium-hover": "#649ef5",
  "control-border-strong": "#c1c6cc",
  "control-border-strong-active": "#649ef5",
  "control-border-strong-disabled": "#596069",
  "control-border-strong-focus": "#656c75",
  "control-border-strong-hover": "#656c75",
  "control-border-weak": "#656c75",
  "control-border-weak-active": "#7cadf7",
  "control-border-weak-disabled": "#596069",
  "control-border-weak-focus": "#7cadf7",
  "control-border-weak-hover": "#7cadf7",
  "control-icon": "#649ef5",
  "control-icon-active": "#7cadf7",
  "control-icon-disabled": "#cce1ff",
  "control-icon-focus": "#7cadf7",
  "control-icon-hover": "#7cadf7",
  "control-icon-in": "#23282e",
  "control-icon-in-active": "#23282e",
  "control-icon-in-disabled": "#6f7680",
  "control-icon-in-focus": "#23282e",
  "control-icon-in-hover": "#23282e",
  "control-icon-in-strong": "#649ef5",
  "control-icon-in-strong-active": "#7cadf7",
  "control-icon-in-strong-disabled": "#6f7680",
  "control-icon-in-strong-focus": "#7cadf7",
  "control-icon-in-strong-hover": "#7cadf7",
  "control-icon-medium": "#649ef5",
  "control-icon-medium-active": "#889099",
  "control-icon-medium-disabled": "#e1e4e8",
  "control-icon-medium-focus": "#979fa8",
  "control-icon-medium-hover": "#979fa8",
  "control-icon-strong": "#d0d4d9",
  "control-icon-strong-active": "#649ef5",
  "control-icon-strong-disabled": "#6f7680",
  "control-icon-strong-focus": "#649ef5",
  "control-icon-strong-hover": "#f0f1f2",
  "control-icon-weak": "#c1c6cc",
  "control-icon-weak-active": "#649ef5",
  "control-icon-weak-disabled": "#6f7680",
  "control-icon-weak-focus": "#649ef5",
  "control-icon-weak-hover": "#649ef5",
  "default-bg": "#0f1214",
  "default-bg-active": "#0f1214",
  "default-bg-disabled": "#464c54",
  "default-bg-hover": "#0f1214",
  "default-bg-medium": "#373c42",
  "default-bg-strong": "#a7adb5",
  "default-bg-strong-active": "#d0d4d9",
  "default-bg-strong-disabled": "#596069",
  "default-bg-strong-focus": "#d0d4d9",
  "default-bg-strong-hover": "#d0d4d9",
  "default-bg-weak": "#23282e",
  "default-bg-weak-active": "#23282e",
  "default-bg-weak-disabled": "#464c54",
  "default-bg-weak-hover": "#373c42",
  "default-border": "#596069",
  "default-border-medium": "#464c54",
  "default-border-strong": "#c1c6cc",
  "default-border-weak": "#23282e",
  "default-icon-in": "#23282e",
  "default-icon-in-active": "#23282e",
  "default-icon-in-disabled": "#6f7680",
  "default-icon-in-focus": "#23282e",
  "default-icon-in-hover": "#23282e",
  "default-text": "#f7f7f7",
  "default-text-disabled": "#6f7680",
  "default-text-in": "#23282e",
  "default-text-in-active": "#23282e",
  "default-text-in-disabled": "#23282e",
  "default-text-in-focus": "#23282e",
  "default-text-in-hover": "#23282e",
  "default-text-in-weak": "#fff",
  "default-text-medium": "#d0d4d9",
  "default-text-medium-disabled": "#6f7680",
  "default-text-strong": "#f0f1f2",
  "default-text-strong-disabled": "#6f7680",
  "default-text-weak": "#889099",
  "default-text-weak-disabled": "#6f7680",
  "dormant-bg": "#6f7680",
  "dormant-bg-disabled": "#6f7680",
  "dormant-bg-medium": "#464c54",
  "dormant-bg-medium-disabled": "#373c42",
  "dormant-border": "#a7adb5",
  "dormant-border-disabled": "#596069",
  "dormant-icon": "#c1c6cc",
  "dormant-icon-disabled": "#596069",
  "dormant-icon-in": "#23282e",
  "dormant-icon-in-disabled": "#23282e",
  "dormant-icon-in-medium": "#23282e",
  "dormant-icon-medium": "#fff",
  "info-bg": "#7cadf7",
  "info-bg-active": "#7cadf7",
  "info-bg-disabled": "#7cadf7",
  "info-bg-focus": "#7cadf7",
  "info-bg-hover": "#7cadf7",
  "info-bg-medium": "#3e506a",
  "info-bg-medium-active": "#3e506a",
  "info-bg-medium-disabled": "#373c42",
  "info-bg-medium-focus": "#3e506a",
  "info-bg-medium-hover": "#3e506a",
  "info-bg-strong": "#283648",
  "info-bg-weak": "#23282e",
  "info-bg-weak-active": "#23282e",
  "info-bg-weak-disabled": "#23282e",
  "info-bg-weak-focus": "#23282e",
  "info-bg-weak-hover": "#23282e",
  "info-border": "#7cadf7",
  "info-border-active": "#7cadf7",
  "info-border-disabled": "#7cadf7",
  "info-border-focus": "#7cadf7",
  "info-border-hover": "#7cadf7",
  "info-border-weak": "#23282e",
  "info-border-weak-active": "#23282e",
  "info-border-weak-disabled": "#596069",
  "info-border-weak-focus": "#23282e",
  "info-border-weak-hover": "#23282e",
  "info-icon": "#7cadf7",
  "info-icon-active": "#7cadf7",
  "info-icon-disabled": "#596069",
  "info-icon-focus": "#7cadf7",
  "info-icon-hover": "#7cadf7",
  "info-icon-in": "#23282e",
  "info-icon-in-active": "#23282e",
  "info-icon-in-disabled": "#23282e",
  "info-icon-in-focus": "#23282e",
  "info-icon-in-hover": "#23282e",
  "info-icon-weak": "#7cadf7",
  "info-icon-weak-active": "#7cadf7",
  "info-icon-weak-disabled": "#596069",
  "info-icon-weak-focus": "#7cadf7",
  "info-icon-weak-hover": "#7cadf7",
  "interact-bg": "#649ef5",
  "interact-bg-active": "#7cadf7",
  "interact-bg-disabled": "#446392",
  "interact-bg-focus": "#7cadf7",
  "interact-bg-hover": "#7cadf7",
  "interact-bg-medium": "#649ef5",
  "interact-bg-weak": "#23282e",
  "interact-bg-weak-active": "#2f3d52",
  "interact-bg-weak-disabled": "#464c54",
  "interact-bg-weak-focus": "#2f3d52",
  "interact-bg-weak-hover": "#2f3d52",
  "interact-border": "#649ef5",
  "interact-border-active": "#7cadf7",
  "interact-border-disabled": "#446392",
  "interact-border-focus": "#7cadf7",
  "interact-border-hover": "#7cadf7",
  "interact-border-medium": "#649ef5",
  "interact-border-medium-active": "#649ef5",
  "interact-border-medium-disabled": "#e1e4e8",
  "interact-border-medium-focus": "#649ef5",
  "interact-border-medium-hover": "#a3c8ff",
  "interact-border-weak": "#656c75",
  "interact-border-weak-active": "#e1e4e8",
  "interact-border-weak-disabled": "#596069",
  "interact-border-weak-focus": "#e1e4e8",
  "interact-border-weak-hover": "#cce1ff",
  "interact-icon": "#649ef5",
  "interact-icon-active": "#7cadf7",
  "interact-icon-disabled": "#446392",
  "interact-icon-focus": "#7cadf7",
  "interact-icon-hover": "#7cadf7",
  "interact-icon-in": "#23282e",
  "interact-icon-in-active": "#23282e",
  "interact-icon-in-disabled": "#23282e",
  "interact-icon-in-focus": "#23282e",
  "interact-icon-in-hover": "#23282e",
  "interact-icon-medium": "#c1c6cc",
  "interact-icon-medium-active": "#649ef5",
  "interact-icon-medium-disabled": "#6f7680",
  "interact-icon-medium-focus": "#649ef5",
  "interact-icon-medium-hover": "#649ef5",
  "interact-icon-weak": "#c1c6cc",
  "interact-icon-weak-active": "#d0d4d9",
  "interact-icon-weak-disabled": "#6f7680",
  "interact-icon-weak-focus": "#d0d4d9",
  "interact-icon-weak-hover": "#d0d4d9",
  "interact-text": "#649ef5",
  "interact-text-active": "#7cadf7",
  "interact-text-disabled": "#446392",
  "interact-text-focus": "#7cadf7",
  "interact-text-hover": "#7cadf7",
  "interact-text-in": "#23282e",
  "interact-text-in-active": "#23282e",
  "interact-text-in-disabled": "#23282e",
  "interact-text-in-focus": "#23282e",
  "interact-text-in-hover": "#23282e",
  "interact-text-weak": "#c1c6cc",
  "interact-text-weak-active": "#649ef5",
  "interact-text-weak-disabled": "#6f7680",
  "interact-text-weak-focus": "#649ef5",
  "interact-text-weak-hover": "#649ef5",
  "inverse-bg": "#373c42",
  "inverse-bg-active": "#464c54",
  "inverse-bg-disabled": "#e1e4e8",
  "inverse-bg-focus": "#464c54",
  "inverse-bg-gradient-end": "#0f1214",
  "inverse-bg-gradient-start": "#373c42",
  "inverse-bg-hover": "#373c42",
  "inverse-bg-weak": "#464c54",
  "inverse-border": "#6f7680",
  "inverse-border-active": "#cce1ff",
  "inverse-border-disabled": "#e1e4e8",
  "inverse-border-focus": "#cce1ff",
  "inverse-border-hover": "#649ef5",
  "inverse-icon": "#f7f7f7",
  "inverse-icon-active": "#fff",
  "inverse-icon-disabled": "#6f7680",
  "inverse-icon-focus": "#fff",
  "inverse-icon-hover": "#fff",
  "inverse-icon-strong": "#fff",
  "inverse-icon-strong-active": "#fff",
  "inverse-icon-strong-disabled": "#6f7680",
  "inverse-icon-strong-focus": "#fff",
  "inverse-icon-strong-hover": "#fff",
  "inverse-text": "#f7f7f7",
  "inverse-text-active": "#f7f7f7",
  "inverse-text-disabled": "#656c75",
  "inverse-text-focus": "#f7f7f7",
  "inverse-text-hover": "#f7f7f7",
  "inverse-text-medium": "#c1c6cc",
  "inverse-text-medium-disabled": "#656c75",
  "negative-bg": "#fa5762",
  "negative-bg-active": "#ff6e72",
  "negative-bg-disabled": "#8f4048",
  "negative-bg-focus": "#ff6e72",
  "negative-bg-hover": "#ff6e72",
  "negative-bg-medium": "#64363e",
  "negative-bg-medium-active": "#64363e",
  "negative-bg-medium-disabled": "#373c42",
  "negative-bg-medium-focus": "#64363e",
  "negative-bg-medium-hover": "#64363e",
  "negative-bg-strong": "#46272a",
  "negative-bg-weak": "#23282e",
  "negative-bg-weak-active": "#994a52",
  "negative-bg-weak-disabled": "#373c42",
  "negative-bg-weak-focus": "#994a52",
  "negative-bg-weak-hover": "#994a52",
  "negative-border": "#fa5762",
  "negative-border-active": "#ff878b",
  "negative-border-disabled": "#8f4048",
  "negative-border-focus": "#ff878b",
  "negative-border-hover": "#ff878b",
  "negative-border-medium": "#eb4651",
  "negative-border-medium-active": "#ff878b",
  "negative-border-medium-disabled": "#8f4048",
  "negative-border-medium-focus": "#ff878b",
  "negative-border-medium-hover": "#ff878b",
  "negative-border-strong": "#f7f7f7",
  "negative-border-strong-active": "#f7f7f7",
  "negative-border-strong-disabled": "#f7f7f7",
  "negative-border-strong-focus": "#f7f7f7",
  "negative-border-strong-hover": "#fff",
  "negative-border-weak": "#23282e",
  "negative-border-weak-active": "#23282e",
  "negative-border-weak-disabled": "#596069",
  "negative-border-weak-focus": "#23282e",
  "negative-border-weak-hover": "#23282e",
  "negative-icon": "#fa5762",
  "negative-icon-active": "#ff878b",
  "negative-icon-disabled": "#8f4048",
  "negative-icon-focus": "#ff878b",
  "negative-icon-hover": "#ff878b",
  "negative-icon-in": "#23282e",
  "negative-icon-in-active": "#23282e",
  "negative-icon-in-disabled": "#23282e",
  "negative-icon-in-focus": "#23282e",
  "negative-icon-in-hover": "#23282e",
  "negative-icon-weak": "#ffb2b5",
  "negative-icon-weak-active": "#ffb2b5",
  "negative-icon-weak-disabled": "#596069",
  "negative-icon-weak-focus": "#ffb2b5",
  "negative-icon-weak-hover": "#ffb2b5",
  "negative-text": "#fa5762",
  "negative-text-active": "#ff878b",
  "negative-text-disabled": "#8f4048",
  "negative-text-focus": "#ff878b",
  "negative-text-hover": "#ff878b",
  "negative-text-in": "#23282e",
  "negative-text-in-active": "#23282e",
  "negative-text-in-disabled": "#23282e",
  "negative-text-in-focus": "#23282e",
  "negative-text-in-hover": "#23282e",
  particle: {
    "active-icon": "#7CADF7",
    "color-scheme": "dark",
    effects: {
      shadow: "0px 3px 8px 0px #0000007A"
    },
    "inactive-icon": "#596069",
    "terminated-icon": "#F7B0E5",
    "unknown-icon": "#A7ADB5",
    "unknown-icon-active": "#A7ADB5"
  },
  "positive-bg": "#6bbf41",
  "positive-bg-active": "#6bbf41",
  "positive-bg-disabled": "#6bbf41",
  "positive-bg-focus": "#6bbf41",
  "positive-bg-hover": "#6bbf41",
  "positive-bg-medium": "#395534",
  "positive-bg-medium-active": "#395534",
  "positive-bg-medium-disabled": "#373c42",
  "positive-bg-medium-focus": "#395534",
  "positive-bg-medium-hover": "#395534",
  "positive-bg-strong": "#23381e",
  "positive-bg-weak": "#23282e",
  "positive-bg-weak-active": "#23282e",
  "positive-bg-weak-disabled": "#23282e",
  "positive-bg-weak-focus": "#23282e",
  "positive-bg-weak-hover": "#23282e",
  "positive-border": "#6bbf41",
  "positive-border-active": "#6bbf41",
  "positive-border-disabled": "#6bbf41",
  "positive-border-focus": "#6bbf41",
  "positive-border-hover": "#6bbf41",
  "positive-border-strong": "#f7f7f7",
  "positive-border-strong-active": "#f7f7f7",
  "positive-border-strong-disabled": "#f7f7f7",
  "positive-border-strong-focus": "#f7f7f7",
  "positive-border-strong-hover": "#f7f7f7",
  "positive-border-weak": "#23282e",
  "positive-border-weak-active": "#6bbf41",
  "positive-border-weak-disabled": "#596069",
  "positive-border-weak-focus": "#6bbf41",
  "positive-border-weak-hover": "#6bbf41",
  "positive-icon": "#6bbf41",
  "positive-icon-active": "#6bbf41",
  "positive-icon-disabled": "#596069",
  "positive-icon-focus": "#6bbf41",
  "positive-icon-hover": "#6bbf41",
  "positive-icon-in": "#23282e",
  "positive-icon-in-active": "#23282e",
  "positive-icon-in-disabled": "#23282e",
  "positive-icon-in-focus": "#23282e",
  "positive-icon-in-hover": "#23282e",
  "positive-icon-strong": "#6bbf41",
  "positive-icon-strong-active": "#6bbf41",
  "positive-icon-strong-disabled": "#477438",
  "positive-icon-strong-focus": "#6bbf41",
  "positive-icon-strong-hover": "#6bbf41",
  "positive-icon-weak": "#6bbf41",
  "positive-icon-weak-active": "#6bbf41",
  "positive-icon-weak-disabled": "#596069",
  "positive-icon-weak-focus": "#6bbf41",
  "positive-icon-weak-hover": "#6bbf41",
  "positive-text-in": "#23282e",
  "positive-text-in-active": "#23282e",
  "positive-text-in-disabled": "#23282e",
  "positive-text-in-focus": "#23282e",
  "positive-text-in-hover": "#23282e",
  "severe-warning-bg": "#f7782f",
  "severe-warning-bg-active": "#f7782f",
  "severe-warning-bg-disabled": "#f7782f",
  "severe-warning-bg-focus": "#f7782f",
  "severe-warning-bg-hover": "#f7782f",
  "severe-warning-bg-medium": "#644637",
  "severe-warning-bg-medium-active": "#644637",
  "severe-warning-bg-medium-disabled": "#373c42",
  "severe-warning-bg-medium-focus": "#644637",
  "severe-warning-bg-medium-hover": "#644637",
  "severe-warning-bg-strong": "#42281a",
  "severe-warning-bg-weak": "#23282e",
  "severe-warning-bg-weak-active": "#23282e",
  "severe-warning-bg-weak-disabled": "#23282e",
  "severe-warning-bg-weak-focus": "#23282e",
  "severe-warning-bg-weak-hover": "#23282e",
  "severe-warning-border": "#f7782f",
  "severe-warning-border-active": "#f7782f",
  "severe-warning-border-disabled": "#f7782f",
  "severe-warning-border-focus": "#f7782f",
  "severe-warning-border-hover": "#f7782f",
  "severe-warning-border-weak": "#23282e",
  "severe-warning-border-weak-active": "#23282e",
  "severe-warning-border-weak-disabled": "#596069",
  "severe-warning-border-weak-focus": "#23282e",
  "severe-warning-border-weak-hover": "#23282e",
  "severe-warning-icon": "#f7782f",
  "severe-warning-icon-active": "#f7782f",
  "severe-warning-icon-disabled": "#596069",
  "severe-warning-icon-focus": "#f7782f",
  "severe-warning-icon-hover": "#f7782f",
  "severe-warning-icon-in": "#23282e",
  "severe-warning-icon-in-active": "#23282e",
  "severe-warning-icon-in-disabled": "#23282e",
  "severe-warning-icon-in-focus": "#23282e",
  "severe-warning-icon-in-hover": "#23282e",
  "severe-warning-icon-strong": "#fc8d4c",
  "severe-warning-icon-strong-active": "#fc8d4c",
  "severe-warning-icon-strong-disabled": "#fc8d4c",
  "severe-warning-icon-strong-focus": "#fc8d4c",
  "severe-warning-icon-strong-hover": "#fc8d4c",
  "warning-bg": "#f0c243",
  "warning-bg-active": "#f0c243",
  "warning-bg-disabled": "#f0c243",
  "warning-bg-focus": "#f0c243",
  "warning-bg-hover": "#f0c243",
  "warning-bg-medium": "#5c4d28",
  "warning-bg-medium-active": "#5c4d28",
  "warning-bg-medium-disabled": "#373c42",
  "warning-bg-medium-focus": "#5c4d28",
  "warning-bg-medium-hover": "#5c4d28",
  "warning-bg-strong": "#35301c",
  "warning-bg-weak": "#23282e",
  "warning-bg-weak-active": "#23282e",
  "warning-bg-weak-disabled": "#23282e",
  "warning-bg-weak-focus": "#23282e",
  "warning-bg-weak-hover": "#23282e",
  "warning-border": "#f0c243",
  "warning-border-active": "#f0c243",
  "warning-border-disabled": "#f0c243",
  "warning-border-focus": "#f0c243",
  "warning-border-hover": "#f0c243",
  "warning-border-strong": "#f7f7f7",
  "warning-border-strong-active": "#f7f7f7",
  "warning-border-strong-disabled": "#f7f7f7",
  "warning-border-strong-focus": "#f7f7f7",
  "warning-border-strong-hover": "#f7f7f7",
  "warning-border-weak": "#23282e",
  "warning-border-weak-active": "#23282e",
  "warning-border-weak-disabled": "#596069",
  "warning-border-weak-focus": "#23282e",
  "warning-border-weak-hover": "#23282e",
  "warning-icon": "#f0c243",
  "warning-icon-active": "#f0c243",
  "warning-icon-disabled": "#596069",
  "warning-icon-focus": "#f0c243",
  "warning-icon-hover": "#f0c243",
  "warning-icon-in": "#23282e",
  "warning-icon-in-active": "#23282e",
  "warning-icon-in-disabled": "#23282e",
  "warning-icon-in-focus": "#23282e",
  "warning-icon-in-hover": "#23282e",
  "warning-icon-strong": "#f0c243",
  "warning-icon-strong-active": "#f0c243",
  "warning-icon-strong-disabled": "#f0c243",
  "warning-icon-strong-focus": "#f0c243",
  "warning-icon-strong-hover": "#f0c243",
  "warning-text-in": "#23282e",
  "warning-text-in-active": "#23282e",
  "warning-text-in-disabled": "#23282e",
  "warning-text-in-focus": "#23282e",
  "warning-text-in-hover": "#23282e"
};

// css/light.json
var light_default = {
  "accent-a": "#7d8aff",
  "accent-a-hover": "#6977f0",
  "accent-a-weak": "#ebedff",
  "accent-b": "#b02863",
  "accent-b-hover": "#991d53",
  "accent-b-weak": "#ffe8ef",
  "accent-c": "#f2638c",
  "accent-c-hover": "#e3447c",
  "accent-c-weak": "#ffd4e0",
  "accent-d": "#753bcc",
  "accent-d-hover": "#6732b8",
  "accent-d-weak": "#f3ebff",
  "accent-e": "#7da11b",
  "accent-e-hover": "#6c8c14",
  "accent-e-weak": "#eaf2d3",
  "accent-f": "#ad3907",
  "accent-f-hover": "#942e03",
  "accent-f-weak": "#ffeadb",
  "accent-g": "#04a4b0",
  "accent-g-hover": "#028e99",
  "accent-g-weak": "#d5f5f5",
  "accent-h": "#006773",
  "accent-h-hover": "#005c66",
  "accent-h-weak": "#a9ebeb",
  "accent-i": "#e85fc6",
  "accent-i-hover": "#d649b3",
  "accent-i-weak": "#ffe8f9",
  "accent-j": "#545c8a",
  "accent-j-hover": "#484f7a",
  "accent-j-weak": "#ebedff",
  "accent-k": "#21a65f",
  "accent-k-hover": "#169855",
  "accent-k-weak": "#d4f5e1",
  "brand-accent-border": "#52a62b",
  "brand-accent-border-active": "#45991f",
  "brand-accent-border-focus": "#45991f",
  "brand-accent-border-hover": "#e1e4e8",
  "brand-accent-border-medium": "#f0f1f2",
  "brand-accent-border-medium-active": "#e0f5d5",
  "brand-accent-border-medium-disabled": "#fff",
  "brand-accent-border-medium-focus": "#fff",
  "brand-accent-border-medium-hover": "#fff",
  "brand-accent-border-strong": "#f7f7f7",
  "brand-accent-border-strong-active": "#f7f7f7",
  "brand-accent-border-strong-disabled": "#fff",
  "brand-accent-border-strong-focus": "#f7f7f7",
  "brand-accent-border-strong-hover": "#f7f7f7",
  "brand-accent-border-weak": "#d0d4d9",
  "brand-accent-border-weak-active": "#6bbf41",
  "brand-accent-border-weak-disabled": "#fff",
  "brand-accent-border-weak-focus": "#fff",
  "brand-accent-border-weak-hover": "#fff",
  "brand-accent-icon": "#7e868f",
  "brand-accent-icon-active": "#45991f",
  "brand-accent-icon-disabled": "#d0d4d9",
  "brand-accent-icon-focus": "#fff",
  "brand-accent-icon-medium": "#a7adb5",
  "brand-accent-icon-medium-active": "#52a62b",
  "brand-accent-icon-medium-disabled": "#d0d4d9",
  "brand-accent-icon-medium-focus": "#fff",
  "brand-accent-icon-weak": "#c1c6cc",
  "brand-accent-icon-weak-active": "#6bbf41",
  "brand-accent-icon-weak-disabled": "#d0d4d9",
  "brand-accent-icon-weak-focus": "#fff",
  "brand-bg": "#373c42",
  "brand-bg-active": "#464c54",
  "brand-bg-disabled": "#e1e4e8",
  "brand-bg-focus": "#464c54",
  "brand-bg-gradient-end": "#0f1214",
  "brand-bg-gradient-start": "#373c42",
  "brand-bg-hover": "#373c42",
  "brand-border-active": "#cce1ff",
  "brand-icon": "#f7f7f7",
  "brand-icon-active": "#fff",
  "brand-icon-hover": "#fff",
  "brand-text": "#f7f7f7",
  "brand-text-active": "#f7f7f7",
  "brand-text-hover": "#f7f7f7",
  "brand-text-strong": "#f0f1f2",
  "brand-text-weak": "#889099",
  "control-bg": "#fff",
  "control-bg-active": "#f0f1f2",
  "control-bg-disabled": "#f7f7f7",
  "control-bg-focus": "#f0f1f2",
  "control-bg-hover": "#e3eeff",
  "control-bg-medium": "#fff",
  "control-bg-medium-active": "#e3eeff",
  "control-bg-medium-disabled": "#e1e4e8",
  "control-bg-medium-focus": "#e3eeff",
  "control-bg-medium-hover": "#f7f7f7",
  "control-bg-strong": "#2774d9",
  "control-bg-strong-active": "#0d5cbd",
  "control-bg-strong-disabled": "#bad6ff",
  "control-bg-strong-focus": "#0d5cbd",
  "control-bg-strong-hover": "#0d5cbd",
  "control-bg-weak": "#fff",
  "control-bg-weak-active": "#e3eeff",
  "control-bg-weak-disabled": "#f7f7f7",
  "control-bg-weak-focus": "#e3eeff",
  "control-bg-weak-hover": "#cce1ff",
  "control-border": "#889099",
  "control-border-active": "#3e84e5",
  "control-border-disabled": "#d0d4d9",
  "control-border-focus": "#3e84e5",
  "control-border-hover": "#3e84e5",
  "control-border-medium": "#2774d9",
  "control-border-medium-active": "#2774d9",
  "control-border-medium-disabled": "#d0d4d9",
  "control-border-medium-focus": "#2774d9",
  "control-border-medium-hover": "#bad6ff",
  "control-border-strong": "#656c75",
  "control-border-strong-active": "#2774d9",
  "control-border-strong-disabled": "#d0d4d9",
  "control-border-strong-focus": "#2774d9",
  "control-border-strong-hover": "#656c75",
  "control-border-weak": "#e1e4e8",
  "control-border-weak-active": "#7cadf7",
  "control-border-weak-disabled": "#d0d4d9",
  "control-border-weak-focus": "#7cadf7",
  "control-border-weak-hover": "#7cadf7",
  "control-icon": "#1d69cc",
  "control-icon-active": "#0d5cbd",
  "control-icon-disabled": "#a3c8ff",
  "control-icon-focus": "#0d5cbd",
  "control-icon-hover": "#0d5cbd",
  "control-icon-in": "#fff",
  "control-icon-in-active": "#fff",
  "control-icon-in-disabled": "#c1c6cc",
  "control-icon-in-focus": "#fff",
  "control-icon-in-hover": "#fff",
  "control-icon-in-strong": "#2774d9",
  "control-icon-in-strong-active": "#2774d9",
  "control-icon-in-strong-disabled": "#c1c6cc",
  "control-icon-in-strong-focus": "#2774d9",
  "control-icon-in-strong-hover": "#2774d9",
  "control-icon-medium": "#2774d9",
  "control-icon-medium-active": "#0d5cbd",
  "control-icon-medium-disabled": "#a3c8ff",
  "control-icon-medium-focus": "#0d5cbd",
  "control-icon-medium-hover": "#0d5cbd",
  "control-icon-strong": "#656c75",
  "control-icon-strong-active": "#1d69cc",
  "control-icon-strong-disabled": "#c1c6cc",
  "control-icon-strong-focus": "#1d69cc",
  "control-icon-strong-hover": "#464c54",
  "control-icon-weak": "#7e868f",
  "control-icon-weak-active": "#2774d9",
  "control-icon-weak-disabled": "#d0d4d9",
  "control-icon-weak-focus": "#2774d9",
  "control-icon-weak-hover": "#2774d9",
  "default-bg": "#f7f7f7",
  "default-bg-active": "#f7f7f7",
  "default-bg-disabled": "#f0f1f2",
  "default-bg-hover": "#f7f7f7",
  "default-bg-medium": "#f7f7f7",
  "default-bg-strong": "#656c75",
  "default-bg-strong-active": "#23282e",
  "default-bg-strong-disabled": "#d0d4d9",
  "default-bg-strong-focus": "#23282e",
  "default-bg-strong-hover": "#23282e",
  "default-bg-weak": "#fff",
  "default-bg-weak-active": "#f0f1f2",
  "default-bg-weak-disabled": "#f0f1f2",
  "default-bg-weak-hover": "#e1e4e8cc",
  "default-border": "#e1e4e8",
  "default-border-medium": "#e1e4e8",
  "default-border-strong": "#656c75",
  "default-border-weak": "#fff",
  "default-icon-in": "#fff",
  "default-icon-in-active": "#fff",
  "default-icon-in-disabled": "#fff",
  "default-icon-in-focus": "#fff",
  "default-icon-in-hover": "#fff",
  "default-text": "#23282e",
  "default-text-disabled": "#c1c6cc",
  "default-text-in": "#fff",
  "default-text-in-active": "#fff",
  "default-text-in-disabled": "#fff",
  "default-text-in-focus": "#fff",
  "default-text-in-hover": "#fff",
  "default-text-in-weak": "#f7f7f7",
  "default-text-medium": "#596069",
  "default-text-medium-disabled": "#c1c6cc",
  "default-text-strong": "#373c42",
  "default-text-strong-disabled": "#c1c6cc",
  "default-text-weak": "#889099",
  "default-text-weak-disabled": "#c1c6cc",
  "dormant-bg": "#6f7680",
  "dormant-bg-disabled": "#6f7680",
  "dormant-bg-medium": "#e1e4e8",
  "dormant-bg-medium-disabled": "#f7f7f7",
  "dormant-border": "#889099",
  "dormant-border-disabled": "#d0d4d9",
  "dormant-icon": "#6f7680",
  "dormant-icon-disabled": "#d0d4d9",
  "dormant-icon-in": "#fff",
  "dormant-icon-in-disabled": "#fff",
  "dormant-icon-in-medium": "#fff",
  "dormant-icon-medium": "#fff",
  "info-bg": "#2774d9",
  "info-bg-active": "#2774d9",
  "info-bg-disabled": "#2774d9",
  "info-bg-focus": "#2774d9",
  "info-bg-hover": "#2774d9",
  "info-bg-medium": "#e3eeff",
  "info-bg-medium-active": "#e3eeff",
  "info-bg-medium-disabled": "#f7f7f7",
  "info-bg-medium-focus": "#e3eeff",
  "info-bg-medium-hover": "#e3eeff",
  "info-bg-strong": "#e3eeff",
  "info-bg-weak": "#fff",
  "info-bg-weak-active": "#fff",
  "info-bg-weak-disabled": "#fff",
  "info-bg-weak-focus": "#fff",
  "info-bg-weak-hover": "#fff",
  "info-border": "#2774d9",
  "info-border-active": "#2774d9",
  "info-border-disabled": "#d0d4d9",
  "info-border-focus": "#2774d9",
  "info-border-hover": "#2774d9",
  "info-border-weak": "#fff",
  "info-border-weak-active": "#fff",
  "info-border-weak-disabled": "#d0d4d9",
  "info-border-weak-focus": "#fff",
  "info-border-weak-hover": "#fff",
  "info-icon": "#2774d9",
  "info-icon-active": "#2774d9",
  "info-icon-disabled": "#d0d4d9",
  "info-icon-focus": "#2774d9",
  "info-icon-hover": "#2774d9",
  "info-icon-in": "#fff",
  "info-icon-in-active": "#fff",
  "info-icon-in-disabled": "#fff",
  "info-icon-in-focus": "#fff",
  "info-icon-in-hover": "#fff",
  "info-icon-weak": "#a3c8ff",
  "info-icon-weak-active": "#a3c8ff",
  "info-icon-weak-disabled": "#a3c8ff",
  "info-icon-weak-focus": "#a3c8ff",
  "info-icon-weak-hover": "#a3c8ff",
  "interact-bg": "#1d69cc",
  "interact-bg-active": "#0d5cbd",
  "interact-bg-disabled": "#a3c8ff",
  "interact-bg-focus": "#0d5cbd",
  "interact-bg-hover": "#0d5cbd",
  "interact-bg-medium": "#2774d9",
  "interact-bg-weak": "#fff",
  "interact-bg-weak-active": "#cce1ff",
  "interact-bg-weak-disabled": "#fff",
  "interact-bg-weak-focus": "#cce1ff",
  "interact-bg-weak-hover": "#cce1ff",
  "interact-border": "#1d69cc",
  "interact-border-active": "#0d5cbd",
  "interact-border-disabled": "#a3c8ff",
  "interact-border-focus": "#0d5cbd",
  "interact-border-hover": "#0d5cbd",
  "interact-border-medium": "#2774d9",
  "interact-border-medium-active": "#2774d9",
  "interact-border-medium-disabled": "#e1e4e8",
  "interact-border-medium-focus": "#2774d9",
  "interact-border-medium-hover": "#bad6ff",
  "interact-border-weak": "#e1e4e8",
  "interact-border-weak-active": "#e1e4e8",
  "interact-border-weak-disabled": "#e1e4e8",
  "interact-border-weak-focus": "#e1e4e8",
  "interact-border-weak-hover": "#cce1ff",
  "interact-icon": "#1d69cc",
  "interact-icon-active": "#0d5cbd",
  "interact-icon-disabled": "#a3c8ff",
  "interact-icon-focus": "#0d5cbd",
  "interact-icon-hover": "#0d5cbd",
  "interact-icon-in": "#fff",
  "interact-icon-in-active": "#fff",
  "interact-icon-in-disabled": "#fff",
  "interact-icon-in-focus": "#fff",
  "interact-icon-in-hover": "#fff",
  "interact-icon-medium": "#7e868f",
  "interact-icon-medium-active": "#2774d9",
  "interact-icon-medium-disabled": "#c1c6cc",
  "interact-icon-medium-focus": "#2774d9",
  "interact-icon-medium-hover": "#2774d9",
  "interact-icon-weak": "#7e868f",
  "interact-icon-weak-active": "#6f7680",
  "interact-icon-weak-disabled": "#d0d4d9",
  "interact-icon-weak-focus": "#6f7680",
  "interact-icon-weak-hover": "#6f7680",
  "interact-text": "#1d69cc",
  "interact-text-active": "#0d5cbd",
  "interact-text-disabled": "#a3c8ff",
  "interact-text-focus": "#0d5cbd",
  "interact-text-hover": "#0d5cbd",
  "interact-text-in": "#fff",
  "interact-text-in-active": "#fff",
  "interact-text-in-disabled": "#fff",
  "interact-text-in-focus": "#fff",
  "interact-text-in-hover": "#fff",
  "interact-text-weak": "#656c75",
  "interact-text-weak-active": "#1d69cc",
  "interact-text-weak-disabled": "#c1c6cc",
  "interact-text-weak-focus": "#1d69cc",
  "interact-text-weak-hover": "#1d69cc",
  "inverse-bg": "#373c42",
  "inverse-bg-active": "#464c54",
  "inverse-bg-disabled": "#e1e4e8",
  "inverse-bg-focus": "#464c54",
  "inverse-bg-gradient-end": "#0f1214",
  "inverse-bg-gradient-start": "#373c42",
  "inverse-bg-hover": "#373c42",
  "inverse-bg-weak": "#373c42",
  "inverse-border": "#6f7680",
  "inverse-border-active": "#cce1ff",
  "inverse-border-disabled": "#e1e4e8",
  "inverse-border-focus": "#cce1ff",
  "inverse-border-hover": "#649ef5",
  "inverse-icon": "#f7f7f7",
  "inverse-icon-active": "#fff",
  "inverse-icon-disabled": "#6f7680",
  "inverse-icon-focus": "#fff",
  "inverse-icon-hover": "#fff",
  "inverse-icon-strong": "#fff",
  "inverse-icon-strong-active": "#fff",
  "inverse-icon-strong-disabled": "#fff",
  "inverse-icon-strong-focus": "#fff",
  "inverse-icon-strong-hover": "#fff",
  "inverse-text": "#f7f7f7",
  "inverse-text-active": "#f7f7f7",
  "inverse-text-disabled": "#656c75",
  "inverse-text-focus": "#f7f7f7",
  "inverse-text-hover": "#f7f7f7",
  "inverse-text-medium": "#c1c6cc",
  "inverse-text-medium-disabled": "#656c75",
  "negative-bg": "#cc2d37",
  "negative-bg-active": "#cc2d37",
  "negative-bg-disabled": "#ffb2b5",
  "negative-bg-focus": "#cc2d37",
  "negative-bg-hover": "#cc2d37",
  "negative-bg-medium": "#ffe8e9",
  "negative-bg-medium-active": "#ffe8e9",
  "negative-bg-medium-disabled": "#f7f7f7",
  "negative-bg-medium-focus": "#ffe8e9",
  "negative-bg-medium-hover": "#ffe8e9",
  "negative-bg-strong": "#ffe8e9",
  "negative-bg-weak": "#fff",
  "negative-bg-weak-active": "#ffd4d5",
  "negative-bg-weak-disabled": "#fff",
  "negative-bg-weak-focus": "#ffd4d5",
  "negative-bg-weak-hover": "#ffd4d5",
  "negative-border": "#cc2d37",
  "negative-border-active": "#b2242d",
  "negative-border-disabled": "#ffb2b5",
  "negative-border-focus": "#b2242d",
  "negative-border-hover": "#b2242d",
  "negative-border-medium": "#d93843",
  "negative-border-medium-active": "#d93843",
  "negative-border-medium-disabled": "#ffb2b5",
  "negative-border-medium-focus": "#d93843",
  "negative-border-medium-hover": "#d93843",
  "negative-border-strong": "#b2242d",
  "negative-border-strong-active": "#b2242d",
  "negative-border-strong-disabled": "#ffb2b5",
  "negative-border-strong-focus": "#b2242d",
  "negative-border-strong-hover": "#b2242d",
  "negative-border-weak": "#fff",
  "negative-border-weak-active": "#fff",
  "negative-border-weak-disabled": "#d0d4d9",
  "negative-border-weak-focus": "#fff",
  "negative-border-weak-hover": "#fff",
  "negative-icon": "#cc2d37",
  "negative-icon-active": "#b2242d",
  "negative-icon-disabled": "#ffb2b5",
  "negative-icon-focus": "#b2242d",
  "negative-icon-hover": "#b2242d",
  "negative-icon-in": "#fff",
  "negative-icon-in-active": "#fff",
  "negative-icon-in-disabled": "#fff",
  "negative-icon-in-focus": "#fff",
  "negative-icon-in-hover": "#fff",
  "negative-icon-weak": "#ffc7c9",
  "negative-icon-weak-active": "#ffc7c9",
  "negative-icon-weak-disabled": "#d0d4d9",
  "negative-icon-weak-focus": "#ffc7c9",
  "negative-icon-weak-hover": "#ffc7c9",
  "negative-text": "#cc2d37",
  "negative-text-active": "#b2242d",
  "negative-text-disabled": "#ffb2b5",
  "negative-text-focus": "#b2242d",
  "negative-text-hover": "#b2242d",
  "negative-text-in": "#fff",
  "negative-text-in-active": "#fff",
  "negative-text-in-disabled": "#fff",
  "negative-text-in-focus": "#fff",
  "negative-text-in-hover": "#fff",
  particle: {
    "active-icon": "#2774D9",
    "color-scheme": "normal",
    effects: {
      shadow: "0px 3px 8px 0px rgba(0, 0, 0, 0.08)"
    },
    "inactive-icon": "#D0D4D9",
    "terminated-icon": "#941B76",
    "unknown-icon": "#596069",
    "unknown-icon-active": "#596069"
  },
  "positive-bg": "#45991f",
  "positive-bg-active": "#45991f",
  "positive-bg-disabled": "#b0e396",
  "positive-bg-focus": "#45991f",
  "positive-bg-hover": "#45991f",
  "positive-bg-medium": "#e0f5d5",
  "positive-bg-medium-active": "#e0f5d5",
  "positive-bg-medium-disabled": "#f7f7f7",
  "positive-bg-medium-focus": "#e0f5d5",
  "positive-bg-medium-hover": "#e0f5d5",
  "positive-bg-strong": "#e0f5d5",
  "positive-bg-weak": "#fff",
  "positive-bg-weak-active": "#fff",
  "positive-bg-weak-disabled": "#fff",
  "positive-bg-weak-focus": "#fff",
  "positive-bg-weak-hover": "#fff",
  "positive-border": "#45991f",
  "positive-border-active": "#45991f",
  "positive-border-disabled": "#d0d4d9",
  "positive-border-focus": "#45991f",
  "positive-border-hover": "#45991f",
  "positive-border-strong": "#398519",
  "positive-border-strong-active": "#398519",
  "positive-border-strong-disabled": "#398519",
  "positive-border-strong-focus": "#398519",
  "positive-border-strong-hover": "#398519",
  "positive-border-weak": "#fff",
  "positive-border-weak-active": "#fff",
  "positive-border-weak-disabled": "#d0d4d9",
  "positive-border-weak-focus": "#fff",
  "positive-border-weak-hover": "#fff",
  "positive-icon": "#45991f",
  "positive-icon-active": "#45991f",
  "positive-icon-disabled": "#d0d4d9",
  "positive-icon-focus": "#45991f",
  "positive-icon-hover": "#45991f",
  "positive-icon-in": "#fff",
  "positive-icon-in-active": "#fff",
  "positive-icon-in-disabled": "#fff",
  "positive-icon-in-focus": "#fff",
  "positive-icon-in-hover": "#fff",
  "positive-icon-strong": "#45991f",
  "positive-icon-strong-active": "#45991f",
  "positive-icon-strong-disabled": "#d0d4d9",
  "positive-icon-strong-focus": "#45991f",
  "positive-icon-strong-hover": "#45991f",
  "positive-icon-weak": "#b0e396",
  "positive-icon-weak-active": "#b0e396",
  "positive-icon-weak-disabled": "#b0e396",
  "positive-icon-weak-focus": "#b0e396",
  "positive-icon-weak-hover": "#b0e396",
  "positive-text-in": "#fff",
  "positive-text-in-active": "#fff",
  "positive-text-in-disabled": "#fff",
  "positive-text-in-focus": "#fff",
  "positive-text-in-hover": "#fff",
  "severe-warning-bg": "#f26722",
  "severe-warning-bg-active": "#f26722",
  "severe-warning-bg-disabled": "#fcc9a7",
  "severe-warning-bg-focus": "#f26722",
  "severe-warning-bg-hover": "#f26722",
  "severe-warning-bg-medium": "#ffeadb",
  "severe-warning-bg-medium-active": "#ffeadb",
  "severe-warning-bg-medium-disabled": "#f7f7f7",
  "severe-warning-bg-medium-focus": "#ffeadb",
  "severe-warning-bg-medium-hover": "#ffeadb",
  "severe-warning-bg-strong": "#ffeadb",
  "severe-warning-bg-weak": "#fff",
  "severe-warning-bg-weak-active": "#fff",
  "severe-warning-bg-weak-disabled": "#fff",
  "severe-warning-bg-weak-focus": "#fff",
  "severe-warning-bg-weak-hover": "#fff",
  "severe-warning-border": "#f26722",
  "severe-warning-border-active": "#f26722",
  "severe-warning-border-disabled": "#f26722",
  "severe-warning-border-focus": "#f26722",
  "severe-warning-border-hover": "#f26722",
  "severe-warning-border-weak": "#fff",
  "severe-warning-border-weak-active": "#fff",
  "severe-warning-border-weak-disabled": "#d0d4d9",
  "severe-warning-border-weak-focus": "#fff",
  "severe-warning-border-weak-hover": "#fff",
  "severe-warning-icon": "#f26722",
  "severe-warning-icon-active": "#c44f14",
  "severe-warning-icon-disabled": "#d0d4d9",
  "severe-warning-icon-focus": "#c44f14",
  "severe-warning-icon-hover": "#d95a1a",
  "severe-warning-icon-in": "#fff",
  "severe-warning-icon-in-active": "#fff",
  "severe-warning-icon-in-disabled": "#fff",
  "severe-warning-icon-in-focus": "#fff",
  "severe-warning-icon-in-hover": "#fff",
  "severe-warning-icon-strong": "#d95a1a",
  "severe-warning-icon-strong-active": "#d95a1a",
  "severe-warning-icon-strong-disabled": "#d95a1a",
  "severe-warning-icon-strong-focus": "#d95a1a",
  "severe-warning-icon-strong-hover": "#d95a1a",
  "warning-bg": "#cc8604",
  "warning-bg-active": "#cc8604",
  "warning-bg-disabled": "#f2d268",
  "warning-bg-focus": "#cc8604",
  "warning-bg-hover": "#cc8604",
  "warning-bg-medium": "#faefb9",
  "warning-bg-medium-active": "#faefb9",
  "warning-bg-medium-disabled": "#f7f7f7",
  "warning-bg-medium-focus": "#faefb9",
  "warning-bg-medium-hover": "#faefb9",
  "warning-bg-strong": "#faefb9",
  "warning-bg-weak": "#fff",
  "warning-bg-weak-active": "#fff",
  "warning-bg-weak-disabled": "#fff",
  "warning-bg-weak-focus": "#fff",
  "warning-bg-weak-hover": "#fff",
  "warning-border": "#cc8604",
  "warning-border-active": "#cc8604",
  "warning-border-disabled": "#d0d4d9",
  "warning-border-focus": "#cc8604",
  "warning-border-hover": "#cc8604",
  "warning-border-strong": "#a65503",
  "warning-border-strong-active": "#a65503",
  "warning-border-strong-disabled": "#a65503",
  "warning-border-strong-focus": "#a65503",
  "warning-border-strong-hover": "#a65503",
  "warning-border-weak": "#fff",
  "warning-border-weak-active": "#fff",
  "warning-border-weak-disabled": "#d0d4d9",
  "warning-border-weak-focus": "#fff",
  "warning-border-weak-hover": "#fff",
  "warning-icon": "#cc8604",
  "warning-icon-active": "#cc8604",
  "warning-icon-disabled": "#d0d4d9",
  "warning-icon-focus": "#cc8604",
  "warning-icon-hover": "#cc8604",
  "warning-icon-in": "#fff",
  "warning-icon-in-active": "#fff",
  "warning-icon-in-disabled": "#fff",
  "warning-icon-in-focus": "#fff",
  "warning-icon-in-hover": "#fff",
  "warning-icon-strong": "#bd7202",
  "warning-icon-strong-active": "#bd7202",
  "warning-icon-strong-disabled": "#d0d4d9",
  "warning-icon-strong-focus": "#bd7202",
  "warning-icon-strong-hover": "#bd7202",
  "warning-text-in": "#fff",
  "warning-text-in-active": "#fff",
  "warning-text-in-disabled": "#fff",
  "warning-text-in-focus": "#fff",
  "warning-text-in-hover": "#fff"
};

// css/typography.json
var typography_default = {
  "typography-font-body": "'Inter', var(--typography-font-fallback)",
  "typography-font-code": "roboto mono, sfmono-regular, consolas,\n    'Liberation Mono', menlo, courier, monospace",
  "typography-font-fallback": "-apple-system, blinkmacsystemfont, 'Segoe UI',\n    roboto, sans-serif",
  "typography-font-heading": "'Sharp Sans', var(--typography-font-fallback)",
  "typography-font-monospace": "'Roboto Mono', var(--typography-font-fallback)",
  "typography-heading-primary": "normal var(--typography-weight-bold)\n    var(--typography-size-heading-primary) /\n    var(--typography-line-height-heading-primary) var(--typography-font-heading)",
  "typography-heading-section": "normal var(--typography-weight-bold)\n    var(--typography-size-heading-section) /\n    var(--typography-line-height-heading-section) var(--typography-font-heading)",
  "typography-heading-smallest": "normal var(--typography-weight-bold)\n    var(--typography-size-heading-sub-section) /\n    var(--typography-line-height-heading-sub-section)\n    var(--typography-font-heading)",
  "typography-heading-sub-section": "normal var(--typography-weight-bold)\n    var(--typography-size-heading-sub-section) /\n    var(--typography-line-height-heading-sub-section)\n    var(--typography-font-heading)",
  "typography-line-height-heading-primary": "34px",
  "typography-line-height-heading-section": "24px",
  "typography-line-height-heading-smallest": "20px",
  "typography-line-height-heading-sub-section": "22px",
  "typography-line-height-p1": "24px",
  "typography-line-height-p2": "22px",
  "typography-line-height-p3": "20px",
  "typography-line-height-p4": "18px",
  "typography-monospace-default": "normal var(--typography-weight-default)\n    var(--typography-size-p4) / var(--typography-line-height-p4)\n    var(--typography-font-monospace)",
  "typography-p1-bold": "normal var(--typography-weight-bold)\n    var(--typography-size-p1) / var(--typography-line-height-p1)\n    var(--typography-font-body)",
  "typography-p1-default": "normal var(--typography-weight-default)\n    var(--typography-size-p1) / var(--typography-line-height-p1)\n    var(--typography-font-body)",
  "typography-p1-emphasis": "normal var(--typography-weight-emphasis)\n    var(--typography-size-p1) / var(--typography-line-height-p1)\n    var(--typography-font-body)",
  "typography-p2-bold": "normal var(--typography-weight-bold)\n    var(--typography-size-p2) / var(--typography-line-height-p2)\n    var(--typography-font-body)",
  "typography-p2-default": "normal var(--typography-weight-default)\n    var(--typography-size-p2) / var(--typography-line-height-p2)\n    var(--typography-font-body)",
  "typography-p2-emphasis": "normal var(--typography-weight-emphasis)\n    var(--typography-size-p2) / var(--typography-line-height-p2)\n    var(--typography-font-body)",
  "typography-p3-bold": "normal var(--typography-weight-bold)\n    var(--typography-size-p3) / var(--typography-line-height-p3)\n    var(--typography-font-body)",
  "typography-p3-default": "normal var(--typography-weight-default)\n    var(--typography-size-p3) / var(--typography-line-height-p3)\n    var(--typography-font-body)",
  "typography-p3-emphasis": "normal var(--typography-weight-emphasis)\n    var(--typography-size-p3) / var(--typography-line-height-p3)\n    var(--typography-font-body)",
  "typography-p4-bold": "normal var(--typography-weight-bold)\n    var(--typography-size-p4) / var(--typography-line-height-p4)\n    var(--typography-font-body)",
  "typography-p4-default": "normal var(--typography-weight-default)\n    var(--typography-size-p4) / var(--typography-line-height-p4)\n    var(--typography-font-body)",
  "typography-p4-emphasis": "normal var(--typography-weight-emphasis)\n    var(--typography-size-p4) / var(--typography-line-height-p4)\n    var(--typography-font-body)",
  "typography-size-heading-primary": "24px",
  "typography-size-heading-section": "18px",
  "typography-size-heading-smallest": "14px",
  "typography-size-heading-sub-section": "16px",
  "typography-size-p1": "18px",
  "typography-size-p2": "16px",
  "typography-size-p3": "14px",
  "typography-size-p4": "12px",
  "typography-weight-bold": "700",
  "typography-weight-default": "400",
  "typography-weight-emphasis": "600"
};

// ASSETS_PATH.ts
var import_uik6 = require("@appd/uik");
var ASSETS_PATH = import_uik6.utils.mutable(
  "/",
  (value) => (
    // Add trailing slash.
    `${value}/`.replaceAll("//", "/")
  )
);

// css/Provider.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var storageKey = "uik-theme";
var Provider = /* @__PURE__ */ __name(({ children }) => {
  const [currentTheme, _setCurrentTheme] = (0, import_react5.useState)("light");
  [
    ROBOTO[400],
    ROBOTO[500],
    ROBOTO[700],
    ROBOTO_MONO[400],
    INTER[700],
    INTER[400],
    INTER[600],
    SHARP_SANS[700],
    SOURCE_CODE_PRO
  ].forEach(({ fontFamily, src, ...rest }) => RENDERER.renderFont(fontFamily, [ASSETS_PATH() + src], rest));
  if (import_uik7.utils.CAN_USE_DOM) {
    const root = document.querySelector(":root");
    const storageTheme = globalThis?.localStorage.getItem(storageKey);
    if (storageTheme == void 0) {
      const defaultTheme = import_uik7.FEATURE_FLAG_LIGHT_THEME ? "light" : "dark";
      _setCurrentTheme(defaultTheme);
      globalThis?.localStorage.setItem(storageKey, defaultTheme);
    } else if (storageTheme != void 0 && storageTheme != currentTheme) {
      _setCurrentTheme(storageTheme);
    }
    root?.setAttribute("uik", currentTheme);
  }
  const setCurrentTheme = /* @__PURE__ */ __name((theme) => {
    _setCurrentTheme(theme);
    if (import_uik7.utils.CAN_USE_DOM) {
      globalThis?.localStorage.setItem(storageKey, theme);
    }
  }, "setCurrentTheme");
  const themesNames = [];
  applyTheme("light", light_default);
  themesNames.push("light");
  applyTheme("dark", dark_default);
  themesNames.push("dark");
  applyJSON(typography_default);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    CONTEXT.Provider,
    {
      value: {
        currentTheme,
        setCurrentTheme,
        themes: themesNames
      },
      children
    }
  );
}, "Provider");
Provider.displayName = "css.Provider";
var {
  FONT: { INTER, ROBOTO, ROBOTO_MONO, SHARP_SANS, SOURCE_CODE_PRO }
} = import_uik7.MAGNETIC_TOKENS;

// css/Styles/Styles.ts
var import_uik8 = require("@appd/uik");
var Styles = import_uik8.utils.identity;

// css/toJson.ts
var toJson2 = /* @__PURE__ */ __name(() => Array.from(RENDERER.nodes.RULE.sheet?.cssRules ?? []).map(({ cssText }) => cssText), "toJson");

// css/withSsr.tsx
var import_uik9 = require("@appd/uik");
var import_jsx_runtime2 = require("react/jsx-runtime");
var withSsr = /* @__PURE__ */ __name(async (renderPage) => {
  const props2 = await renderPage();
  return {
    ...props2,
    head: [
      ...props2.head ?? [],
      // Preload fonts to avoid Flash Of Unstyled Text. (https://web.dev/codelab-preload-web-fonts/)
      [
        ROBOTO2[400],
        ROBOTO2[500],
        ROBOTO2[700],
        ROBOTO_MONO2[400],
        INTER2[700],
        INTER2[400],
        INTER2[600],
        SHARP_SANS2[700],
        SOURCE_CODE_PRO2
      ].map(({ src }) => /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("link", { as: "font", crossOrigin: "anonymous", href: ASSETS_PATH() + src, rel: "preload", type: "font/woff2" }, src))
    ],
    styles: props2.styles instanceof Array ? [...props2.styles, ...RENDERER.renderToNodeList()] : /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)(import_jsx_runtime2.Fragment, { children: [
      props2.styles,
      RENDERER.renderToNodeList()
    ] })
  };
}, "withSsr");
var {
  FONT: { INTER: INTER2, ROBOTO: ROBOTO2, ROBOTO_MONO: ROBOTO_MONO2, SHARP_SANS: SHARP_SANS2, SOURCE_CODE_PRO: SOURCE_CODE_PRO2 }
} = import_uik9.MAGNETIC_TOKENS;

// css/css.ts
var css = /* @__PURE__ */ __name((...classNamesOrStyles) => classNamesOrStyles.filter(import_uik10.utils.Boolean).reduce(
  (prefix, classNamesOrStyles2, i) => [
    prefix,
    ...(typeof classNamesOrStyles2 === "string" ? classNamesOrStyles2.split(/ +/).flatMap((className2) => {
      const rule = cache.data.get(className2);
      return prefix && rule ? RENDERER.renderRule(rule, `:where(${prefix})`).split(" ") : className2;
    }) : RENDERER.renderRule(
      () => i > 0 ? {
        // Don't run `disableCssInheritance` plugin for later arguments. (TMNT-5558)
        all: void 0,
        ...prefix ? { [`:where(${prefix})`]: classNamesOrStyles2 } : classNamesOrStyles2
      } : classNamesOrStyles2,
      void 0
    ).split(" ")).filter(Boolean)
  ].join("."),
  ""
).slice(1).replaceAll(".", " "), "css");
css.applyTheme = applyTheme;
css.CONTEXT = CONTEXT;
css.Provider = Provider;
css.RENDERER = RENDERER;
css.Styles = Styles;
css.cache = cache;
css.toJson = toJson2;
css.withSsr = withSsr;
globalThis.css = css;
hydrate();

// Icon/Icon.tsx
var import_uik426 = require("@appd/uik");

// Icon/Action/Action.ts
var Action_exports = {};
__export(Action_exports, {
  Add: () => Add,
  AddArrow: () => AddArrow,
  AddToDashboard: () => AddToDashboard,
  AddWidget: () => AddWidget,
  Adjust: () => Adjust,
  Align: () => Align,
  AlignVerticalBottom: () => AlignVerticalBottom,
  AlignVerticalCenter: () => AlignVerticalCenter,
  AlignVerticalTop: () => AlignVerticalTop,
  Analyze: () => Analyze,
  AnalyzeArrow: () => AnalyzeArrow,
  Archive: () => Archive,
  AssociateTierNode: () => AssociateTierNode,
  AutoFillFlowMap: () => AutoFillFlowMap,
  AutoLayoutFlowMap: () => AutoLayoutFlowMap,
  AutoRefresh: () => AutoRefresh,
  BottomPanel: () => BottomPanel,
  Calendar: () => Calendar,
  Cancel: () => Cancel,
  CardView: () => CardView,
  CircularViewFlowMap: () => CircularViewFlowMap,
  ClearConsole: () => ClearConsole,
  CompactView: () => CompactView,
  Configure: () => Configure,
  ConfigureArrow: () => ConfigureArrow,
  Copy: () => Copy,
  CreatePolicyManual: () => CreatePolicyManual,
  CustomTimer: () => CustomTimer,
  Delete: () => Delete,
  Disable: () => Disable,
  Download: () => Download,
  Duplicate: () => Duplicate,
  Edit: () => Edit,
  EditArrow: () => EditArrow,
  Enable: () => Enable,
  Export: () => Export,
  FavoriteOff: () => FavoriteOff,
  FavoriteOn: () => FavoriteOn,
  Feedback: () => Feedback,
  Filter: () => Filter,
  FilterOn: () => FilterOn,
  FindSnapEvent: () => FindSnapEvent,
  GenerateSessions: () => GenerateSessions,
  GridView: () => GridView,
  Group: () => Group,
  Group2: () => Group2,
  Help: () => Help,
  HelpCenter: () => HelpCenter,
  Import: () => Import,
  ImportApp: () => ImportApp,
  Info: () => Info,
  LaunchInfo: () => LaunchInfo,
  LinearView: () => LinearView,
  Link: () => Link,
  LinkAlternate: () => LinkAlternate,
  LogarithmicView: () => LogarithmicView,
  Logout: () => Logout,
  Minus: () => Minus,
  MobileInfoPointDynamic: () => MobileInfoPointDynamic,
  Order: () => Order,
  Participants: () => Participants,
  Paste: () => Paste,
  Play: () => Play,
  PopOut: () => PopOut,
  Redo: () => Redo,
  Refresh: () => Refresh,
  Save: () => Save,
  SaveAs: () => SaveAs,
  Search: () => Search,
  SearchSnapshot: () => SearchSnapshot,
  Share: () => Share,
  ShareArrow: () => ShareArrow,
  SidePanel: () => SidePanel,
  Sort: () => Sort,
  SortDown: () => SortDown,
  SortOff: () => SortOff,
  SortUp: () => SortUp,
  Stop: () => Stop,
  Symbolicate: () => Symbolicate,
  SyntheticSessionsCritical: () => SyntheticSessionsCritical,
  SyntheticSessionsNormal: () => SyntheticSessionsNormal,
  SyntheticSessionsWarning: () => SyntheticSessionsWarning,
  TestEmail: () => TestEmail,
  TestHttpRequest: () => TestHttpRequest,
  TextAlignCenter: () => TextAlignCenter,
  TextAlignLeft: () => TextAlignLeft,
  TextAlignRight: () => TextAlignRight,
  ThumbsDown: () => ThumbsDown,
  ThumbsUp: () => ThumbsUp,
  Timer: () => Timer,
  TreeView: () => TreeView,
  TrendDown: () => TrendDown,
  TrendUp: () => TrendUp,
  Undo: () => Undo,
  Ungroup: () => Ungroup,
  Upgrade: () => Upgrade,
  Upload: () => Upload,
  ViewDetails: () => ViewDetails,
  ViewDiagnosticSession: () => ViewDiagnosticSession,
  ViewMobile: () => ViewMobile,
  ViewSnapshot: () => ViewSnapshot,
  WrapText: () => WrapText
});

// Icon/Action/Add.tsx
var import_uik13 = require("@appd/uik");

// Icon/withSize.ts
var import_uik12 = require("@appd/uik");

// Icon/getStyles.tsx
var import_uik11 = require("@appd/uik");
var {
  COLORS: { CONTROL_ICON_WEAK }
} = import_uik11.MAGNETIC_TOKENS;
var getStyles = /* @__PURE__ */ __name(({ fill = CONTROL_ICON_WEAK }) => (0, import_uik11.css)({
  "& path[fill='#fff']": { fill },
  "&[uik='Icon.AgentType.Appd']": { "& path[fill='#F2F2F3']": { fill } },
  "&[uik='Icon.AgentType.Aws'], &[uik='Icon.AgentType.Azure']": { "& path[fill='#fff']": { fill: "#fff" } },
  "&[uik='Icon.Object.MessageProcessor']": { "& path[fill='#DADADA']": { fill } }
}), "getStyles");

// Icon/withSize.ts
var withSize = /* @__PURE__ */ __name(({ className: className2, fill, height: height2, size = "MEDIUM", width, ...props2 }) => ({
  ...props2,
  className: (0, import_uik12.css)(
    {
      height: height2 ?? width ?? SIZE[size],
      width: width ?? height2 ?? SIZE[size]
    },
    ...import_uik12.utils.many(className2),
    // Why is this _after_ `className`? Is this precedence intentional?
    // A more systematic approach I think would be to bind CSS variables during generation script.
    // Then, overriding works by setting the CSS variable. We might not even need a prop for that.
    getStyles({ fill })
  ),
  height: height2 ?? width ?? SIZE[size],
  width: width ?? height2 ?? SIZE[size]
}), "withSize");
var SIZE = {
  LARGE: 48,
  MEDIUM: 24,
  SMALL: 18,
  XLARGE: 150
};

// Icon/Action/Add.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var Add = import_uik13.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Add",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("path", { d: "M19 11h-6V5h-2v6H5v2h6v6h2v-6h6v-2Z", fill: "#fff", fillOpacity: ".94" })
  }
));
Add.displayName = "Icon.Action.Add";

// Icon/Action/AddArrow.tsx
var import_uik14 = require("@appd/uik");
var import_jsx_runtime4 = require("react/jsx-runtime");
var AddArrow = import_uik14.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.AddArrow",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
      "path",
      {
        d: "m16.654 10.616 3.673 3.673L24 10.616h-7.346Zm-3.731-.078H7.385V5H5.538v5.538H0v1.847h5.538v5.538h1.847v-5.538h5.538v-1.847Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
AddArrow.displayName = "Icon.Action.AddArrow";

// Icon/Action/AddToDashboard.tsx
var import_uik15 = require("@appd/uik");
var import_jsx_runtime5 = require("react/jsx-runtime");
var AddToDashboard = import_uik15.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.AddToDashboard",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
      "path",
      {
        d: "M20 15.7h-2.7V13h-1.6v2.7H13v1.6h2.7V20h1.6v-2.7H20v-1.6ZM4 13h6.9v7H4zm0-9v7h16V4",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
AddToDashboard.displayName = "Icon.Action.AddToDashboard";

// Icon/Action/AddWidget.tsx
var import_uik16 = require("@appd/uik");
var import_jsx_runtime6 = require("react/jsx-runtime");
var AddWidget = import_uik16.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime6.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.AddWidget",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("path", { d: "M21 16h-3v-3h-2v3h-3v2h3v3h2v-3h3v-2Z", fill: "#fff", fillOpacity: ".94" }),
      /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
        "path",
        {
          d: "M11 19H5V5h14v6h2V4.49A1.49 1.49 0 0 0 19.51 3h-15A1.49 1.49 0 0 0 3 4.49v15A1.49 1.49 0 0 0 4.49 21H11v-2Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
AddWidget.displayName = "Icon.Action.AddWidget";

// Icon/Action/Adjust.tsx
var import_uik17 = require("@appd/uik");
var import_jsx_runtime7 = require("react/jsx-runtime");
var Adjust = import_uik17.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Adjust",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M9 7v2H3V7h2V3h2v4h2Zm12 4h-2V3h-2v8h-2v2h6v-2ZM7 21H5V11h2v10Zm12 0h-2v-6h2v6Zm-8-4H9v-2h6v2h-2v4h-2v-4Zm2-14h-2v10h2V3Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Adjust.displayName = "Icon.Action.Adjust";

// Icon/Action/Align.tsx
var import_uik18 = require("@appd/uik");
var import_jsx_runtime8 = require("react/jsx-runtime");
var Align = import_uik18.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Align",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
      "path",
      {
        d: "M11 6.6 9.7 5.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l3 3c.4.4 1 .4 1.4 0l3-3c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0L13 6.6V2c0-.6-.4-1-1-1s-1 .4-1 1v4.6Zm2 10.8 1.3 1.3c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4l-3-3c-.4-.4-1-.4-1.4 0l-3 3c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l1.3-1.3V22c0 .6.4 1 1 1s1-.4 1-1v-4.6Zm8-4.4H3v-2h18v2Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
Align.displayName = "Icon.Action.Align";

// Icon/Action/AlignVerticalBottom.tsx
var import_uik19 = require("@appd/uik");
var import_jsx_runtime9 = require("react/jsx-runtime");
var AlignVerticalBottom = import_uik19.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.AlignVerticalBottom",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M13 13h3l-4 4-4-4h3V3h2v10Zm-9 8v-2h16v2H4Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
AlignVerticalBottom.displayName = "Icon.Action.AlignVerticalBottom";

// Icon/Action/AlignVerticalCenter.tsx
var import_uik20 = require("@appd/uik");
var import_jsx_runtime10 = require("react/jsx-runtime");
var AlignVerticalCenter = import_uik20.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.AlignVerticalCenter",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M16 5h-3V1h-2v4H8l4 4 4-4ZM8 19h3v4h2v-4h3l-4-4-4 4Zm-4-6v-2h16v2H4Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
AlignVerticalCenter.displayName = "Icon.Action.AlignVerticalCenter";

// Icon/Action/AlignVerticalTop.tsx
var import_uik21 = require("@appd/uik");
var import_jsx_runtime11 = require("react/jsx-runtime");
var AlignVerticalTop = import_uik21.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.AlignVerticalTop",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M4 5V3h16v2H4Zm7 6H8l4-4 4 4h-3v10h-2V11Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
AlignVerticalTop.displayName = "Icon.Action.AlignVerticalTop";

// Icon/Action/Analyze.tsx
var import_uik22 = require("@appd/uik");
var import_jsx_runtime12 = require("react/jsx-runtime");
var Analyze = import_uik22.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime12.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Analyze",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(
        "path",
        {
          d: "m17.5 9.05 1-1c.5-.5.7-1.1.7-1.7 0-.7-.3-1.3-.7-1.7l-.9-.9c-1-1-2.6-1-3.6 0l-5.7 5.5 4.5 4.3 3.5-3.4c.7.8 1.5 1.8.6 4l-.5.8c-.2.3-.5.6-.8.9H5.9c-.5 0-.9.4-.9.9s.4.9.9.9h8.7l-1.2 1.4h-8v2h13.2v-6.2c.8-1.6.6-3.3-.3-4.7-.3-.4-.6-.8-.8-1.1Zm-6.3.2 4.3-4.1c.2-.2.6-.2.8 0l.9.9c.1.1.2.2.2.4 0 .1-.1.3-.2.4l-4.3 4.1-1.7-1.7Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime12.jsx)("path", { d: "M11 13.55H5.4v1.2H11v-1.2Z", fill: "#fff", fillOpacity: ".94" })
    ]
  }
));
Analyze.displayName = "Icon.Action.Analyze";

// Icon/Action/AnalyzeArrow.tsx
var import_uik23 = require("@appd/uik");
var import_jsx_runtime13 = require("react/jsx-runtime");
var AnalyzeArrow = import_uik23.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.AnalyzeArrow",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "m12.533 8.333-.889.889c.178.266.445.622.711.977.8 1.245.978 2.756.267 4.178v5.511H.89V18.11H8l1.067-1.244H1.333a.797.797 0 0 1-.8-.8c0-.444.356-.8.8-.8h8.623c.266-.267.533-.533.71-.8l.445-.711c.8-1.956.089-2.845-.533-3.556l-3.111 3.023-4-3.823L8.533 4.51a2.253 2.253 0 0 1 3.2 0l.8.8c.356.356.623.89.623 1.512 0 .533-.178 1.066-.623 1.51ZM9.867 5.755 6.044 9.399l1.512 1.511 3.822-3.644c.089-.089.178-.267.178-.356 0-.177-.09-.266-.178-.355l-.8-.8c-.178-.178-.534-.178-.711 0Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
        "path",
        {
          d: "m20.463 14.61-3.537-3.537H24l-3.537 3.537ZM.889 13.222h4.978v1.066H.889v-1.066Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
AnalyzeArrow.displayName = "Icon.Action.AnalyzeArrow";

// Icon/Action/Archive.tsx
var import_uik24 = require("@appd/uik");
var import_jsx_runtime14 = require("react/jsx-runtime");
var Archive = import_uik24.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime14.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Archive",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime14.jsx)("path", { d: "M15.286 13.51v1.883H8.444V13.51h6.841Z", fill: "#fff", fillOpacity: ".94" }),
      /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M19.648 9.345v-3.37h-1.983V3h-11.7v2.974H3.984v3.371H2v10.906h19.73V9.345h-2.082Zm-11.7-4.362h7.833v.991H7.95v-.991Zm9.717 2.974h-11.7v1.388h11.7V7.957Zm2.082 10.311H3.983v-6.94h15.764v6.94Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
Archive.displayName = "Icon.Action.Archive";

// Icon/Action/AssociateTierNode.tsx
var import_uik25 = require("@appd/uik");
var import_jsx_runtime15 = require("react/jsx-runtime");
var AssociateTierNode = import_uik25.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.AssociateTierNode",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M19.803 3.137h-11.1c-.8 0-1.4.6-1.4 1.4v2.2c0 .8.6 1.4 1.4 1.4h11.1c.8 0 1.4-.6 1.4-1.4v-2.3c0-.7-.6-1.3-1.4-1.3ZM4.997 19V5.1h-2V19c0 1.1.9 2 2 2h14v-2h-14Zm3.706-9.963h11.1c.8 0 1.4.6 1.5 1.4v2.2c0 .8-.6 1.4-1.4 1.4h-4.6v1h4.9c.6 0 1 .5 1 1 0 .6-.5 1-1 1h-11.9c-.6 0-1-.5-1-1 0-.6.5-1 1-1h5v-1h-4.6c-.8 0-1.4-.6-1.4-1.4v-2.2c0-.8.6-1.4 1.4-1.4ZM9.1 4.8h10.4v1.5H9.1V4.8Zm10.4 5.9H9.1v1.5h10.4v-1.5Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
AssociateTierNode.displayName = "Icon.Action.AssociateTierNode";

// Icon/Action/AutoFillFlowMap.tsx
var import_uik26 = require("@appd/uik");
var import_jsx_runtime16 = require("react/jsx-runtime");
var AutoFillFlowMap = import_uik26.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime16.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.AutoFillFlowMap",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(
        "path",
        {
          d: "M20 4.1v6h2v-8h-8.2v2H20ZM8.6 11.4a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm0 6.2a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm9-8.7a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm-2.2 8.6a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime16.jsx)("path", { d: "M4 14v6h6.2v2H2v-8h2Z", fill: "#fff", fillOpacity: ".94" })
    ]
  }
));
AutoFillFlowMap.displayName = "Icon.Action.AutoFillFlowMap";

// Icon/Action/AutoLayoutFlowMap.tsx
var import_uik27 = require("@appd/uik");
var import_jsx_runtime17 = require("react/jsx-runtime");
var AutoLayoutFlowMap = import_uik27.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.AutoLayoutFlowMap",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(
      "path",
      {
        d: "M7.9 11.2c1.712 0 3.1-1.344 3.1-3 0-1.658-1.388-3-3.1-3-1.712 0-3.1 1.342-3.1 3 0 1.656 1.388 3 3.1 3Zm0 7.5c1.712 0 3.1-1.344 3.1-3 0-1.658-1.388-3-3.1-3-1.712 0-3.1 1.342-3.1 3 0 1.656 1.388 3 3.1 3Zm11-10.5c0 1.656-1.388 3-3.1 3-1.712 0-3.1-1.344-3.1-3 0-1.658 1.388-3 3.1-3 1.712 0 3.1 1.342 3.1 3Zm-2.8 10.5c1.712 0 3.1-1.344 3.1-3 0-1.658-1.388-3-3.1-3-1.712 0-3.1 1.342-3.1 3 0 1.656 1.388 3 3.1 3Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
AutoLayoutFlowMap.displayName = "Icon.Action.AutoLayoutFlowMap";

// Icon/Action/AutoRefresh.tsx
var import_uik28 = require("@appd/uik");
var import_jsx_runtime18 = require("react/jsx-runtime");
var AutoRefresh = import_uik28.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.AutoRefresh",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(
      "path",
      {
        d: "M22.255 10.835a.998.998 0 1 1 1.404 1.42l-3.011 2.976a.917.917 0 0 1-.203.137 1.872 1.872 0 0 0-.025.013l-.006.003a.995.995 0 0 1-.472.135.996.996 0 0 1-.706-.296l-2.975-3.01a.998.998 0 1 1 1.419-1.404l1.278 1.294.003-.04a6.936 6.936 0 0 0-2.015-4.993c-1.313-1.327-3.062-2.063-4.97-2.074a6.934 6.934 0 0 0-4.845 1.96L5.728 5.537C7.414 3.901 9.625 3 12.03 3a8.921 8.921 0 0 1 6.334 2.667 8.917 8.917 0 0 1 2.592 6.412.673.673 0 0 0-.002.043l1.301-1.287ZM7.01 16.891c1.312 1.328 3.062 2.064 4.969 2.075a6.94 6.94 0 0 0 4.91-2.018l1.402 1.42c-1.693 1.674-3.933 2.594-6.365 2.594a8.922 8.922 0 0 1-6.335-2.668A8.917 8.917 0 0 1 3 11.883l.003-.043L1.7 13.127a.998.998 0 1 1-1.403-1.42l3.01-2.976a.97.97 0 0 1 .383-.221c.109-.037.22-.064.325-.067a.996.996 0 0 1 .704.296l2.976 3.01a.997.997 0 1 1-1.42 1.404l-1.278-1.295a6.939 6.939 0 0 0 2.012 5.033Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
AutoRefresh.displayName = "Icon.Action.AutoRefresh";

// Icon/Action/BottomPanel.tsx
var import_uik29 = require("@appd/uik");
var import_jsx_runtime19 = require("react/jsx-runtime");
var BottomPanel = import_uik29.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.BottomPanel",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M23 19.06V5a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h18a2 2 0 0 0 2-1.94ZM5 12v5h14v-5H5Zm-2 7.08h18V5H3v14.08Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
BottomPanel.displayName = "Icon.Action.BottomPanel";

// Icon/Action/Calendar.tsx
var import_uik30 = require("@appd/uik");
var import_jsx_runtime20 = require("react/jsx-runtime");
var Calendar = import_uik30.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime20.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Calendar",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime20.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M20 3h-1V2a1 1 0 1 0-2 0v1H7V2a1 1 0 1 0-2 0v1H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Zm0 18H4V10h16v11ZM4 8h16V5H4v3Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Calendar.displayName = "Icon.Action.Calendar";

// Icon/Action/Cancel.tsx
var import_uik31 = require("@appd/uik");
var import_jsx_runtime21 = require("react/jsx-runtime");
var Cancel = import_uik31.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Cancel",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M2 11.92C2 6.465 6.464 2 11.92 2c5.457 0 9.921 4.464 9.921 9.92 0 5.457-4.464 9.921-9.92 9.921-5.457 0-9.921-4.464-9.921-9.92Zm13.492 4.961 1.389-1.389-3.572-3.571 3.572-3.572-1.389-1.389-3.571 3.572L8.349 6.96 6.96 8.35l3.572 3.57-3.572 3.572 1.39 1.389 3.57-3.571 3.572 3.571Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Cancel.displayName = "Icon.Action.Cancel";

// Icon/Action/CardView.tsx
var import_uik32 = require("@appd/uik");
var import_jsx_runtime22 = require("react/jsx-runtime");
var CardView = import_uik32.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.CardView",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M9 11H4V5h5v6Zm0 7H4v-6h5v6Zm1 0h5v-6h-5v6Zm11 0h-5v-6h5v6Zm-11-7h5V5h-5v6Zm6 0V5h5v6h-5Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
CardView.displayName = "Icon.Action.CardView";

// Icon/Action/CircularViewFlowMap.tsx
var import_uik33 = require("@appd/uik");
var import_jsx_runtime23 = require("react/jsx-runtime");
var CircularViewFlowMap = import_uik33.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime23.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.CircularViewFlowMap",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime23.jsx)(
      "path",
      {
        d: "M6.5 10.7c2.1 0 3.9-1.7 3.9-3.9 0-2.1-1.7-3.9-3.9-3.9-2.1 0-3.9 1.7-3.9 3.9 0 2.1 1.7 3.9 3.9 3.9Zm14.1 1.9c-.6-.4-1.3-.6-2-.8 0-3.5-2.9-6.4-6.5-6.5-.2-.8-.5-1.4-.9-2h.8c4.7 0 8.6 3.8 8.6 8.6v.7Zm-17.2-.8c.6.4 1.3.7 2 .8.3 3.2 2.9 5.8 6.2 6 .2.7.4 1.4.8 2H12c-4.7 0-8.6-3.8-8.6-8.6v-.2Zm10.1 5.8c0-2.2 1.8-3.9 3.9-3.9 2.1 0 3.9 1.7 3.9 3.9s-1.7 3.9-3.9 3.9-3.9-1.7-3.9-3.9Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
CircularViewFlowMap.displayName = "Icon.Action.CircularViewFlowMap";

// Icon/Action/ClearConsole.tsx
var import_uik34 = require("@appd/uik");
var import_jsx_runtime24 = require("react/jsx-runtime");
var ClearConsole = import_uik34.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.ClearConsole",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M12 22C6.5 22 2 17.5 2 12S6.5 2 12 2s10 4.5 10 10-4.5 10-10 10ZM7.1 5.7C8.5 4.6 10.1 4 12 4c4.4 0 8 3.6 8 8 0 1.8-.6 3.5-1.7 4.9L7.1 5.7ZM4 12c0-1.8.6-3.5 1.7-4.9l11.2 11.2C15.5 19.4 13.8 20 12 20c-4.4 0-8-3.6-8-8Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
ClearConsole.displayName = "Icon.Action.ClearConsole";

// Icon/Action/CompactView.tsx
var import_uik35 = require("@appd/uik");
var import_jsx_runtime25 = require("react/jsx-runtime");
var CompactView = import_uik35.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime25.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.CompactView",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime25.jsx)(
      "path",
      {
        d: "M6 7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm15-1H8v2h13V6ZM4.5 18.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM16 11H3v2h13v-2Zm5 1a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 4H8v2h13v-2Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
CompactView.displayName = "Icon.Action.CompactView";

// Icon/Action/Configure.tsx
var import_uik36 = require("@appd/uik");
var import_jsx_runtime26 = require("react/jsx-runtime");
var Configure = import_uik36.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime26.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Configure",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime26.jsx)(
        "path",
        {
          d: "m21.338 9.912-2.11-.677a8.102 8.102 0 0 0-.149-.362l1.015-1.979a.897.897 0 0 0-.164-1.042l-1.752-1.757a.895.895 0 0 0-1.044-.165l-1.975 1.007a7.738 7.738 0 0 0-.377-.157l-.674-2.11a.896.896 0 0 0-.855-.623h-2.48c-.39 0-.733.25-.854.621l-.682 2.109a7.019 7.019 0 0 0-.377.155l-1.963-1.01a.894.894 0 0 0-1.044.165L4.096 5.848a.897.897 0 0 0-.164 1.042l1 1.962c-.055.124-.106.25-.154.376l-2.098.676a.895.895 0 0 0-.623.852l-.008 2.48a.896.896 0 0 0 .62.856l2.114.687c.047.119.097.24.153.364l-1.008 1.973a.895.895 0 0 0 .163 1.04l1.75 1.757c.278.28.7.345 1.043.166l1.974-1.005c.122.055.245.106.368.154l.686 2.107c.12.37.463.62.853.62h2.48a.896.896 0 0 0 .854-.62l.686-2.109c.124-.048.245-.098.363-.15l1.975 1.008a.894.894 0 0 0 1.041-.165l1.754-1.75a.899.899 0 0 0 .165-1.04l-1.005-1.981c.052-.118.104-.241.152-.37l2.107-.677a.894.894 0 0 0 .624-.854v-2.48a.896.896 0 0 0-.623-.855Zm-1.172 2.68-1.908.614a.9.9 0 0 0-.58.579 5.46 5.46 0 0 1-.39.937.89.89 0 0 0-.015.838l.915 1.8-.83.829-1.785-.91a.902.902 0 0 0-.824-.001c-.295.152-.61.282-.964.398a.902.902 0 0 0-.57.575l-.622 1.909h-1.177l-.62-1.909a.895.895 0 0 0-.583-.578 5.747 5.747 0 0 1-.948-.397.897.897 0 0 0-.823-.004l-1.79.912-.829-.833.912-1.785a.903.903 0 0 0 .003-.81 6.81 6.81 0 0 1-.405-.97.904.904 0 0 0-.577-.579l-1.91-.62.004-1.174 1.91-.615a.897.897 0 0 0 .582-.597c.097-.324.226-.639.385-.935a.895.895 0 0 0 .008-.83l-.908-1.782.834-.835 1.785.918a.9.9 0 0 0 .845-.016c.255-.142.537-.26.942-.392a.9.9 0 0 0 .575-.577l.618-1.91h1.172l.611 1.91a.898.898 0 0 0 .588.585c.34.105.655.238.94.392a.89.89 0 0 0 .836.012l1.795-.916.83.833-.919 1.792a.901.901 0 0 0 .004.825c.14.266.272.583.402.968a.9.9 0 0 0 .577.567l1.904.61v1.172Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime26.jsx)(
        "path",
        {
          d: "M12.45 8.66a3.342 3.342 0 0 0-2.493.664 3.351 3.351 0 0 0-1.295 2.233c-.12.894.116 1.78.662 2.496a3.348 3.348 0 0 0 2.682 1.327 3.388 3.388 0 0 0 3.348-2.932A3.38 3.38 0 0 0 12.45 8.66Zm1.18 3.56c-.058.433-.28.818-.629 1.084a1.624 1.624 0 0 1-1.212.323 1.615 1.615 0 0 1-1.082-.629 1.638 1.638 0 0 1 1.514-2.616 1.64 1.64 0 0 1 1.409 1.837Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
Configure.displayName = "Icon.Action.Configure";

// Icon/Action/ConfigureArrow.tsx
var import_uik37 = require("@appd/uik");
var import_jsx_runtime27 = require("react/jsx-runtime");
var ConfigureArrow = import_uik37.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime27.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.ConfigureArrow",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime27.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M14.107 12.993c.392.31.494.855.248 1.305l-1.233 2.132a1.01 1.01 0 0 1-1.261.454l-1.19-.478a5.446 5.446 0 0 1-.498.29l-.18 1.253a1.008 1.008 0 0 1-1.004.88H6.505c-.506 0-.94-.373-1.002-.867l-.182-1.265a5.24 5.24 0 0 1-.5-.29l-1.21.485c-.46.168-.995-.014-1.23-.446l-1.25-2.164a1.02 1.02 0 0 1 .259-1.291l1.005-.786a4.576 4.576 0 0 1 0-.582l-1.008-.787a1.01 1.01 0 0 1-.248-1.305l1.233-2.133a1.01 1.01 0 0 1 1.261-.454l1.191.479a5.48 5.48 0 0 1 .497-.29l.18-1.254A1.008 1.008 0 0 1 6.505 5H8.99c.507 0 .941.372 1.003.866l.181 1.265c.171.087.338.184.5.29l1.21-.485c.46-.168.996.015 1.23.447l1.251 2.163c.237.435.135.98-.26 1.292l-1.004.785a4.514 4.514 0 0 1 0 .582l1.007.788Zm2.7-1.009 3.08 3.08 3.08-3.08h-6.16Zm-5.197.848 1.351 1.057-.899 1.555-1.59-.639-.317.239a4.056 4.056 0 0 1-.894.52l-.373.153-.244 1.7H6.85l-.243-1.7-.374-.154a3.827 3.827 0 0 1-.886-.514l-.32-.246-1.595.64-.899-1.554 1.351-1.057-.05-.397a4.191 4.191 0 0 1-.037-.52c0-.153.012-.319.038-.522l.05-.397L2.532 9.94l.899-1.555 1.59.638.318-.238c.299-.224.593-.397.893-.52l.374-.153.244-1.7h1.793l.244 1.7.373.153c.313.128.606.299.887.515l.32.245 1.595-.64.898 1.555-1.351 1.056.05.397c.025.207.037.365.037.521 0 .156-.012.314-.037.521l-.05.397Zm-3.863-.019a.9.9 0 0 0 .899-.899.9.9 0 0 0-.899-.899.9.9 0 0 0-.899.9.9.9 0 0 0 .9.898Zm-2.31-.899a2.312 2.312 0 0 0 2.31 2.31 2.312 2.312 0 0 0 2.31-2.31 2.312 2.312 0 0 0-2.31-2.31 2.312 2.312 0 0 0-2.31 2.31Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
ConfigureArrow.displayName = "Icon.Action.ConfigureArrow";

// Icon/Action/Copy.tsx
var import_uik38 = require("@appd/uik");
var import_jsx_runtime28 = require("react/jsx-runtime");
var Copy = import_uik38.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Copy",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M16 1H5c-1.1 0-2 .9-2 2v13h2V3h11V1Zm4 4H9c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2ZM9 21h11V7H9v14Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Copy.displayName = "Icon.Action.Copy";

// Icon/Action/CreatePolicyManual.tsx
var import_uik39 = require("@appd/uik");
var import_jsx_runtime29 = require("react/jsx-runtime");
var CreatePolicyManual = import_uik39.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime29.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.CreatePolicyManual",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime29.jsx)(
        "path",
        {
          d: "m20.4 4-1.5-1.5c-.1-.1-.3-.2-.5-.2-.146 0-.24.054-.357.122-.043.025-.09.052-.143.079l-1.2 1.2 2.4 2.4 1.2-1.2c.3-.2.3-.6.1-.9ZM17 16l-2.9.1V19H6.9l.1-6.3V5h5.6L14 3.7l.6-.6H5.1V21h11l2.9-3V9.2l-2 1.9V16Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime29.jsx)("path", { d: "M11.4 13.9H9v-2.4l7.1-7.1 2.4 2.4-7.1 7.1Z", fill: "#fff", fillOpacity: ".94" })
    ]
  }
));
CreatePolicyManual.displayName = "Icon.Action.CreatePolicyManual";

// Icon/Action/CustomTimer.tsx
var import_uik40 = require("@appd/uik");
var import_jsx_runtime30 = require("react/jsx-runtime");
var CustomTimer = import_uik40.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime30.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.CustomTimer",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime30.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M10.004 1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1 0-2Zm9.75 4.24a1 1 0 0 1 0 1.4l-.75.75a9 9 0 1 1-16 5.37 9.11 9.11 0 0 1 9-8.76 9 9 0 0 1 5.62 2l.73-.76a1 1 0 0 1 1.4 0ZM13.004 14V8h-2v6h2ZM7.06 8.055a7 7 0 1 0 9.9 9.9 7 7 0 0 0-9.9-9.9Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
CustomTimer.displayName = "Icon.Action.CustomTimer";

// Icon/Action/Delete.tsx
var import_uik41 = require("@appd/uik");
var import_jsx_runtime31 = require("react/jsx-runtime");
var Delete = import_uik41.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime31.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Delete",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(
        "path",
        {
          d: "M14.995 4V3h-5.99v1h-5v2h1l1 13c0 .55.2 1.02.59 1.41.39.39.86.59 1.41.59h7.99c.55 0 1.02-.2 1.41-.59.39-.39.59-.86.59-1.41l1-13h1V4h-5Zm1 15h-7.99l-1-13h9.99l-1 13Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(
        "path",
        {
          d: "M13.71 17c.472.03.875-.4.9-.95l.284-7.01c.025-.55-.343-1.02-.815-1.05-.471-.03-.874.4-.9.95l-.283 7.01c-.025.55.343 1.02.815 1.05Zm-3.42 0c.47-.03.84-.49.814-1.05l-.283-7.01c-.026-.55-.42-.98-.9-.95-.472.03-.84.49-.815 1.05l.283 7.01c.026.55.42.98.9.95Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
Delete.displayName = "Icon.Action.Delete";

// Icon/Action/Disable.tsx
var import_uik42 = require("@appd/uik");
var import_jsx_runtime32 = require("react/jsx-runtime");
var Disable = import_uik42.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Disable",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(
      "path",
      {
        d: "m19.1 7.3-1.4-1.4-5.6 5.6-5.6-5.6-1.4 1.4 5.6 5.6-5.6 5.6 1.4 1.4 5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6 5.6-5.6Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
Disable.displayName = "Icon.Action.Disable";

// Icon/Action/Download.tsx
var import_uik43 = require("@appd/uik");
var import_jsx_runtime33 = require("react/jsx-runtime");
var Download = import_uik43.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime33.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Download",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime33.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M8.707 10.293 11 12.586V5a1 1 0 1 1 2 0v7.586l2.293-2.293a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414ZM5.046 18v2h13.963v-2H5.046Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Download.displayName = "Icon.Action.Download";

// Icon/Action/Duplicate.tsx
var import_uik44 = require("@appd/uik");
var import_jsx_runtime34 = require("react/jsx-runtime");
var Duplicate = import_uik44.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime34.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Duplicate",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime34.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M19.5 1h-11c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2Zm-15 7h-2v13c0 1.1.9 2 2 2h11v-2h-11V8Zm4 9h11V3h-11v14Zm7.006-3.51c.55-.321.976-.765 1.278-1.333.303-.567.454-1.21.454-1.925v-.36a4.006 4.006 0 0 0-.47-1.92 3.304 3.304 0 0 0-1.292-1.327c-.551-.313-1.172-.47-1.864-.47h-2.518v7.82h2.572a3.624 3.624 0 0 0 1.84-.486Zm-2.527-5.88v4.915h.655c.54 0 .956-.192 1.246-.577.29-.385.435-.957.435-1.716v-.339c0-.755-.145-1.325-.435-1.708-.29-.383-.713-.574-1.268-.574h-.633Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Duplicate.displayName = "Icon.Action.Duplicate";

// Icon/Action/Edit.tsx
var import_uik45 = require("@appd/uik");
var import_jsx_runtime35 = require("react/jsx-runtime");
var Edit = import_uik45.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime35.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Edit",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime35.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M19.788 6.262c.3.4.3 1 0 1.3l-1.7 1.6-3.3-3.3 1.6-1.6c.4-.3 1-.3 1.3 0l2.1 2Zm-15.8 13.7v-3.3l9.8-9.8 3.3 3.3-9.8 9.8h-3.3Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Edit.displayName = "Icon.Action.Edit";

// Icon/Action/EditArrow.tsx
var import_uik46 = require("@appd/uik");
var import_jsx_runtime36 = require("react/jsx-runtime");
var EditArrow = import_uik46.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.EditArrow",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
      "path",
      {
        d: "M14.632 7.031c.254.338.254.845 0 1.099l-1.437 1.352-2.79-2.789 1.353-1.352c.338-.254.845-.254 1.099 0l1.775 1.69ZM1.277 15.822v2.79h2.79l8.283-8.284-2.79-2.79-8.283 8.284Zm14.961-3.55 3.381 3.38L23 12.273h-6.762Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
EditArrow.displayName = "Icon.Action.EditArrow";

// Icon/Action/Enable.tsx
var import_uik47 = require("@appd/uik");
var import_jsx_runtime37 = require("react/jsx-runtime");
var Enable = import_uik47.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Enable",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(
      "path",
      {
        d: "m19.292 4.996-9.901 9.505-4.683-4.483-1.84 1.766 6.523 6.262L21.13 6.774l-1.839-1.778Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
Enable.displayName = "Icon.Action.Enable";

// Icon/Action/Export.tsx
var import_uik48 = require("@appd/uik");
var import_jsx_runtime38 = require("react/jsx-runtime");
var Export = import_uik48.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Export",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M13 15V7.414l2.293 2.293a1 1 0 0 0 1.414-1.414l-4-4a1 1 0 0 0-1.414 0l-4 4a1 1 0 0 0 1.414 1.414L11 7.414V15a1 1 0 1 0 2 0Zm5.988 0L19 17.4a.606.606 0 0 1-.587.6H5.553c-.338 0-.541-.2-.541-.6L5 15H3v3a2.213 2.213 0 0 0 2.25 2h13.613A2.111 2.111 0 0 0 21 18v-3h-2.012Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Export.displayName = "Icon.Action.Export";

// Icon/Action/FavoriteOff.tsx
var import_uik49 = require("@appd/uik");
var import_jsx_runtime39 = require("react/jsx-runtime");
var FavoriteOff = import_uik49.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime39.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.FavoriteOff",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime39.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "m14.8 8.6 7.2.6-5.3 4.8 1.6 7-6.2-3.7L5.9 21l1.6-7L2 9.2l7.2-.6L12 2l2.8 6.6Zm-6.6 9.1 3.8-2.3 3.8 2.3-1-4.3 3.3-2.9-4.4-.4-1.7-4-1.7 4-4.4.4 3.3 2.9-1 4.3Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
FavoriteOff.displayName = "Icon.Action.FavoriteOff";

// Icon/Action/FavoriteOn.tsx
var import_uik50 = require("@appd/uik");
var import_jsx_runtime40 = require("react/jsx-runtime");
var FavoriteOn = import_uik50.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.FavoriteOn",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(
      "path",
      {
        d: "m22 9.7-7.2-.6L12 2.5 9.2 9.1 2 9.7l5.5 4.8-1.6 7 6.2-3.7 6.2 3.7-1.6-7L22 9.7Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
FavoriteOn.displayName = "Icon.Action.FavoriteOn";

// Icon/Action/Feedback.tsx
var import_uik51 = require("@appd/uik");
var import_jsx_runtime41 = require("react/jsx-runtime");
var Feedback = import_uik51.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime41.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Feedback",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(
        "path",
        {
          d: "M13.986 10.328H7v1.5h6.987v-1.5ZM7 7.266h6.986v1.5H7v-1.5Zm9.002 6.062h-9v1.5h9v-1.5Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M20.809 6.625a3.642 3.642 0 0 0-3.634-3.629l-10.55.008a3.642 3.642 0 0 0-3.63 3.633l.007 8.738a3.63 3.63 0 0 0 1.674 3.044l.002 1.957c0 .56.676.839 1.071.444l1.814-1.817 9.624-.007a3.642 3.642 0 0 0 3.628-3.633l-.006-8.738Zm-3.624 10.371-10.55.008c-.9 0-1.632-.731-1.633-1.63l-.006-8.738c0-.9.73-1.632 1.63-1.632l10.55-.008c.9 0 1.632.731 1.633 1.63l.006 8.738c0 .899-.73 1.631-1.63 1.632Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
Feedback.displayName = "Icon.Action.Feedback";

// Icon/Action/Filter.tsx
var import_uik52 = require("@appd/uik");
var import_jsx_runtime42 = require("react/jsx-runtime");
var Filter = import_uik52.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime42.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Filter",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime42.jsx)(
      "path",
      {
        d: "M6.962 6h10l-5.01 6.3L6.962 6Zm-2.75-.39C6.232 8.2 9.962 13 9.962 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39a.998.998 0 0 0-.79-1.61H5.002c-.83 0-1.3.95-.79 1.61Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
Filter.displayName = "Icon.Action.Filter";

// Icon/Action/FilterOn.tsx
var import_uik53 = require("@appd/uik");
var import_jsx_runtime43 = require("react/jsx-runtime");
var FilterOn = import_uik53.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.FilterOn",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(
      "path",
      {
        d: "M7.005 6h10l-5.01 6.3L7.005 6Zm-2.75-.39c2.02 2.59 5.75 7.39 5.75 7.39v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39a.998.998 0 0 0-.79-1.61H5.045c-.83 0-1.3.95-.79 1.61Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
FilterOn.displayName = "Icon.Action.FilterOn";

// Icon/Action/FindSnapEvent.tsx
var import_uik54 = require("@appd/uik");
var import_jsx_runtime44 = require("react/jsx-runtime");
var FindSnapEvent = import_uik54.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.FindSnapEvent",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M2.756 18.557h6.446c.239.523.541 1.016.916 1.453.057.07.12.132.182.195.035.036.07.071.104.108H2.756A1.76 1.76 0 0 1 1 18.556V4.51c0-.965.79-1.755 1.756-1.755h.878v-.878a.878.878 0 0 1 1.755 0v.878h8.779v-.878a.878.878 0 0 1 1.755 0v.878h.878c.966 0 1.756.79 1.756 1.755v6.344a6.194 6.194 0 0 0-1.756-.853v-1.1H2.756v9.656Zm0-14.046v2.634H16.8V4.51H2.756ZM4.82 12.68h4.785a5.77 5.77 0 0 1 .464-.652 6.227 6.227 0 0 1 1.126-1.038H4.82v1.69Zm3.845 3.583H4.82v-1.69h4c-.107.46-.164.935-.164 1.41-.002.056.001.115.004.174l.005.106Zm12.59 4.7-2.36-2.36a4.57 4.57 0 0 0 .56-3.94 4.64 4.64 0 0 0-1.2-2 4.59 4.59 0 0 0-2-1.16l-.3-.08a4.473 4.473 0 0 0-1-.1 4.94 4.94 0 0 0-2.41.66 4.66 4.66 0 0 0-1.24 1.06 4.23 4.23 0 0 0-.59.94 4.58 4.58 0 0 0-.46 2 4.3 4.3 0 0 0 .09 1 4.51 4.51 0 0 0 1 2 4.63 4.63 0 0 0 2.22 1.51 4.8 4.8 0 0 0 1.4.21 4.62 4.62 0 0 0 2.55-.77l3.48 3.48a.7.7 0 0 0 .25.17 1 1 0 0 0 1.272-.62.844.844 0 0 0-.131-.84l-1.13-1.16Zm-6.28-2.05a2.84 2.84 0 1 0-.02-5.68 2.84 2.84 0 0 0 .02 5.68Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
FindSnapEvent.displayName = "Icon.Action.FindSnapEvent";

// Icon/Action/GenerateSessions.tsx
var import_uik55 = require("@appd/uik");
var import_jsx_runtime45 = require("react/jsx-runtime");
var GenerateSessions = import_uik55.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime45.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.GenerateSessions",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime45.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M13.047 1.5c1.081 0 2.076.758 2.076 1.684v4.211H5.3l.021-4.211c0-.926.884-1.684 1.964-1.684h5.763Zm-1.853 2.948c0 .54.442.982.982.982s.982-.442.982-.982a.986.986 0 0 0-.982-.983.986.986 0 0 0-.982.983Zm-2.948-.983a.986.986 0 0 0-.982.983c0 .54.442.982.982.982s.983-.442.983-.982a.987.987 0 0 0-.983-.983Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime45.jsx)(
        "path",
        {
          d: "M19.053 10.336a7.152 7.152 0 0 0-1.651-.2c-3.951 0-7.166 3.217-7.166 7.172 0 .233.013.464.035.692H6.16v-4.5H4.685v5.143c0 .503-.495.91-1.105.91-.446 0-.826-.22-1-.534a.77.77 0 0 1-.105-.376L2.463 13.5a1.097 1.097 0 0 1-1.093-1.094V9.962c0-.602.492-1.093 1.093-1.093h15.496c.602 0 1.095.491 1.095 1.093v.374ZM6.159 19v.407c0 .602.492 1.093 1.094 1.093h3.742a7.114 7.114 0 0 1-.549-1.5H6.16ZM16.3 15.207l1.8 1.1 1.8 1-1.8 1-1.8 1.1v-4.2Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime45.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M11.936 17.307a5.474 5.474 0 0 1 5.466-5.47 5.48 5.48 0 0 1 5.476 5.47 5.48 5.48 0 0 1-5.476 5.471 5.474 5.474 0 0 1-5.466-5.47Zm5.471 3.927a3.931 3.931 0 0 1-3.927-3.927 3.931 3.931 0 0 1 3.927-3.926 3.931 3.931 0 0 1 3.927 3.927 3.931 3.931 0 0 1-3.927 3.926Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
GenerateSessions.displayName = "Icon.Action.GenerateSessions";

// Icon/Action/GridView.tsx
var import_uik56 = require("@appd/uik");
var import_jsx_runtime46 = require("react/jsx-runtime");
var GridView = import_uik56.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.GridView",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(
      "path",
      {
        d: "M6 6.875H3V5h3v1.875Zm15 0H8V5h13v1.875Zm-18 4h3V9.001H3v1.874Zm18 0H8V9.001h13v1.874Zm-13 4h13V13H8v1.875Zm-2 0H3V13h3v1.875Zm2 4h13v-1.874H8v1.874Zm-2 0H3v-1.874h3v1.874Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
GridView.displayName = "Icon.Action.GridView";

// Icon/Action/Group.tsx
var import_uik57 = require("@appd/uik");
var import_jsx_runtime47 = require("react/jsx-runtime");
var Group = import_uik57.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime47.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Group",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime47.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M17.5 17H9.94v-3.1H6.55V7h7.56v3.1h3.39V17Zm-6.06-1.5v-1.6h2.67v-2.3H16v3.9h-4.56Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime47.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M22 2v4h-1v12h1v4h-4v-1H6v1H2v-4h1V6H2V2h4v1h12V2h4Zm-4 16h1V6h-1V5H6v1H5v12h1v1h12v-1Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
Group.displayName = "Icon.Action.Group";

// Icon/Action/Group2.tsx
var import_uik58 = require("@appd/uik");
var import_jsx_runtime48 = require("react/jsx-runtime");
var Group2 = import_uik58.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime48.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Group2",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime48.jsx)(
        "path",
        {
          d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime48.jsx)(
        "path",
        {
          d: "M8 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm4-6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm4 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
Group2.displayName = "Icon.Action.Group2";

// Icon/Action/Help.tsx
var import_uik59 = require("@appd/uik");
var import_jsx_runtime49 = require("react/jsx-runtime");
var Help = import_uik59.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Help",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12Zm11 4v2h-2v-2h2Zm-1 4c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8ZM8 10c0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.283-.79 1.973-1.56 2.646C13.712 13.283 13 13.905 13 15h-2c0-1.821.942-2.543 1.77-3.178.65-.498 1.23-.943 1.23-1.822 0-1.1-.9-2-2-2s-2 .9-2 2H8Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Help.displayName = "Icon.Action.Help";

// Icon/Action/HelpCenter.tsx
var import_uik60 = require("@appd/uik");
var import_jsx_runtime50 = require("react/jsx-runtime");
var HelpCenter = import_uik60.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime50.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.HelpCenter",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime50.jsx)(
      "path",
      {
        d: "M13.25 16.74c0 .69-.53 1.26-1.25 1.26-.7 0-1.26-.56-1.26-1.26 0-.71.56-1.25 1.26-1.25.71 0 1.25.55 1.25 1.25ZM11.99 6c-1.77 0-2.98 1.15-3.43 2.49l1.64.69c.22-.67.74-1.48 1.8-1.48 1.62 0 1.94 1.52 1.37 2.33-.54.77-1.47 1.29-1.96 2.16-.39.69-.31 1.49-.31 1.98h1.82c0-.93.07-1.12.22-1.41.39-.72 1.11-1.06 1.87-2.17.68-1 .42-2.36-.02-3.08-.51-.84-1.52-1.51-3-1.51ZM19 5H5v14h14V5Zm0-2c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
HelpCenter.displayName = "Icon.Action.HelpCenter";

// Icon/Action/Import.tsx
var import_uik61 = require("@appd/uik");
var import_jsx_runtime51 = require("react/jsx-runtime");
var Import = import_uik61.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime51.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Import",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime51.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M19.047 15 19 17.4c0 .3-.25.6-.587.6H5.587c-.337 0-.603-.194-.603-.594L4.982 15H3v3c0 1 1.013 2 2.25 2h13.613C19.988 20 21 19.1 21 18v-3h-1.953ZM11 5v7.586l-2.293-2.293a1 1 0 1 0-1.414 1.414l4 4a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L13 12.586V5a1 1 0 1 0-2 0Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Import.displayName = "Icon.Action.Import";

// Icon/Action/ImportApp.tsx
var import_uik62 = require("@appd/uik");
var import_jsx_runtime52 = require("react/jsx-runtime");
var ImportApp = import_uik62.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime52.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.ImportApp",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime52.jsx)(
        "path",
        {
          d: "M7.293 11.42a1 1 0 1 1 1.414-1.414L11 12.299V2.713a1 1 0 0 1 .28-.69.992.992 0 0 1 .72-.31c.284 0 .537.12.72.31a1 1 0 0 1 .28.69v9.586l2.293-2.293a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime52.jsx)(
        "path",
        {
          d: "M15 4.024h4.75c1.238 0 2.25 1 2.25 2V18c0 1.1-1.012 2-2.137 2H4.25C3.013 20 2 19 2 18V6.024c0-1.1 1.013-2 2.138-2H9v2H4.925c-.337 0-.675.3-.675.6V17.4c0 .4.338.6.675.6h14.15c.338 0 .675-.3.675-.6V6.624c0-.4-.337-.6-.675-.6H15v-2Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
ImportApp.displayName = "Icon.Action.ImportApp";

// Icon/Action/Info.tsx
var import_uik63 = require("@appd/uik");
var import_jsx_runtime53 = require("react/jsx-runtime");
var Info = import_uik63.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime53.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Info",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime53.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M2.026 12c0-5.52 4.48-10 10-10s10 4.48 10 10-4.48 10-10 10-10-4.48-10-10Zm11-1v6h-2v-6h2Zm-1 9c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Zm1-13v2h-2V7h2Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Info.displayName = "Icon.Action.Info";

// Icon/Action/LaunchInfo.tsx
var import_uik64 = require("@appd/uik");
var import_jsx_runtime54 = require("react/jsx-runtime");
var LaunchInfo = import_uik64.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime54.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.LaunchInfo",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime54.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M4 2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6l-4 4V4a2 2 0 0 1 2-2Zm1.17 14H20V4H4v13.17L5.17 16ZM12 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm-1 6h2v-4h-2v4Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
LaunchInfo.displayName = "Icon.Action.LaunchInfo";

// Icon/Action/LinearView.tsx
var import_uik65 = require("@appd/uik");
var import_jsx_runtime55 = require("react/jsx-runtime");
var LinearView = import_uik65.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.LinearView",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(
      "path",
      {
        d: "M5.014 5.045V6.53h14.024V5.045H5.014Zm0 6.097v1.483h14.024v-1.483H5.014Zm0-3.048h14.024v1.483H5.014V8.094Zm0 6.096v1.484h14.024V14.19H5.014Zm0 3.049h14.024v1.483H5.014V17.24Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
LinearView.displayName = "Icon.Action.LinearView";

// Icon/Action/Link.tsx
var import_uik66 = require("@appd/uik");
var import_jsx_runtime56 = require("react/jsx-runtime");
var Link = import_uik66.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime56.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Link",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime56.jsx)(
        "path",
        {
          d: "M10.05 15.002H7.12c-1.498 0-2.875-.999-3.16-2.455C3.576 10.589 5.088 8.87 7 8.87h3.05c.525 0 .95-.42.95-.94a.944.944 0 0 0-.95-.939H7c-2.76 0-5 2.215-5 4.945 0 2.729 2.24 4.944 5 4.944h3.05c.525 0 .95-.42.95-.939a.945.945 0 0 0-.95-.94ZM17 6.992h-3.05c-.525 0-.95.42-.95.94 0 .519.425.94.95.94H17c1.71 0 3.1 1.374 3.1 3.065 0 1.69-1.39 3.065-3.1 3.065l-3.05.001a.944.944 0 0 0-.95.94c0 .517.425.938.95.938l3.05.001c2.76 0 5-2.216 5-4.945 0-2.73-2.24-4.945-5-4.945Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime56.jsx)(
        "path",
        {
          d: "M9 12.926c-.553 0-1-.443-1-.99a.995.995 0 0 1 1-.989h6c.552.001 1 .444 1 .99s-.448.989-1 .989H9Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
Link.displayName = "Icon.Action.Link";

// Icon/Action/LinkAlternate.tsx
var import_uik67 = require("@appd/uik");
var import_jsx_runtime57 = require("react/jsx-runtime");
var LinkAlternate = import_uik67.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime57.jsxs)(
  "svg",
  {
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ...withSize(props2),
    ref,
    uik: "Icon.Action.LinkAlternate",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime57.jsx)(
        "path",
        {
          d: "M7.64414 4.46254L8.88164 3.22504C9.40558 2.74749 10.0934 2.49019 10.8021 2.5066C11.5108 2.52301 12.186 2.81186 12.6873 3.31315C13.1886 3.81443 13.4774 4.48959 13.4938 5.19832C13.5102 5.90705 13.2529 6.59485 12.7754 7.11879L11.0066 8.88129C10.7517 9.13716 10.4488 9.34018 10.1152 9.47871C9.78169 9.61724 9.42407 9.68855 9.06289 9.68855C8.70171 9.68855 8.34409 9.61724 8.01053 9.47871C7.67698 9.34018 7.37405 9.13716 7.11914 8.88129",
          fill: "none",
          stroke: "#7E868F",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime57.jsx)(
        "path",
        {
          d: "M8.35629 11.5375L7.11879 12.775C6.59485 13.2526 5.90705 13.5099 5.19832 13.4935C4.48959 13.4771 3.81443 13.1882 3.31315 12.6869C2.81186 12.1856 2.52301 11.5105 2.5066 10.8018C2.49019 10.093 2.74749 9.40523 3.22504 8.88128L4.99379 7.11878C5.24871 6.86291 5.55163 6.65989 5.88518 6.52136C6.21874 6.38283 6.57636 6.31152 6.93754 6.31152C7.29872 6.31152 7.65634 6.38283 7.9899 6.52136C8.32346 6.65989 8.62638 6.86291 8.88129 7.11878",
          fill: "none",
          stroke: "#7E868F",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5"
        }
      )
    ]
  }
));
LinkAlternate.displayName = "Icon.Action.LinkAlternate";

// Icon/Action/LogarithmicView.tsx
var import_uik68 = require("@appd/uik");
var import_jsx_runtime58 = require("react/jsx-runtime");
var LogarithmicView = import_uik68.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime58.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.LogarithmicView",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime58.jsx)(
      "path",
      {
        d: "M5.5 4.45h13.01v.927H5.5V4.45Zm13.01 4.945H5.5v2.856h13.01V9.395Zm0 3.955H5.5v5.756h13.01v-5.755Zm0-6.922H5.5v1.885h13.01V6.428Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
LogarithmicView.displayName = "Icon.Action.LogarithmicView";

// Icon/Action/Logout.tsx
var import_uik69 = require("@appd/uik");
var import_jsx_runtime59 = require("react/jsx-runtime");
var Logout = import_uik69.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime59.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Logout",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime59.jsx)(
        "path",
        {
          d: "M5.027 3.007h13.975c1.098 0 1.996.889 1.996 1.975v13.82c0 1.086-.898 1.974-1.996 1.974H5.027a1.986 1.986 0 0 1-1.996-1.974v-3.949h1.996v3.949h13.975V4.982H5.027V8.93H3.031V4.982c0-1.086.888-1.975 1.996-1.975Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime59.jsx)(
        "path",
        {
          d: "m10.81 14.74 1.873-1.861-9.688.002c-.552 0-1-.443-1-.99a.994.994 0 0 1 1-.988l9.688.002-1.873-1.86a.977.977 0 0 1 0-1.392 1.004 1.004 0 0 1 1.41 0l3.688 3.647a.83.83 0 0 1 0 1.183l-3.688 3.648c-.39.384-1.02.384-1.41 0a.976.976 0 0 1 0-1.391Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
Logout.displayName = "Icon.Action.Logout";

// Icon/Action/Minus.tsx
var import_uik70 = require("@appd/uik");
var import_jsx_runtime60 = require("react/jsx-runtime");
var Minus = import_uik70.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime60.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Minus",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime60.jsx)("path", { d: "M5 10.878h14v1.978H5z", fill: "#fff", fillOpacity: ".94" })
  }
));
Minus.displayName = "Icon.Action.Minus";

// Icon/Action/MobileInfoPointDynamic.tsx
var import_uik71 = require("@appd/uik");
var import_jsx_runtime61 = require("react/jsx-runtime");
var MobileInfoPointDynamic = import_uik71.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime61.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.MobileInfoPointDynamic",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime61.jsx)(
        "path",
        {
          d: "M14 2.967h-4c-.552 0-1-.443-1-.99a.995.995 0 0 1 1-.988h4c.553 0 1 .443 1 .989a.994.994 0 0 1-1 .989ZM12.82 13.66v3.39h-1.65v-3.39H7.75v-1.632h3.42V8.643h1.65v3.385h3.43v1.632h-3.43Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime61.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "m19.03 7.308.75-.741a.973.973 0 0 0 .005-1.383 1.003 1.003 0 0 0-1.415-.013l-.75.743a9.021 9.021 0 0 0-5.619-1.958c-4.804-.001-8.875 3.916-8.998 8.667-.13 5.022 3.938 9.134 8.997 9.134 4.98 0 9-3.986 9-8.9 0-2.097-.74-4.026-1.97-5.549Zm-8.399-1.247c-2.758.514-4.982 2.714-5.502 5.441-.931 4.882 3.303 9.07 8.24 8.148 2.758-.514 4.981-2.712 5.501-5.44.932-4.882-3.303-9.07-8.239-8.149Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
MobileInfoPointDynamic.displayName = "Icon.Action.MobileInfoPointDynamic";

// Icon/Action/Order.tsx
var import_uik72 = require("@appd/uik");
var import_jsx_runtime62 = require("react/jsx-runtime");
var Order = import_uik72.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime62.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Order",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime62.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "m11.577 3.155-7.38 5.677a.977.977 0 0 0 0 1.552l.621.48 6.76 5.197a.998.998 0 0 0 1.22-.001l6.75-5.196.626-.48a.976.976 0 0 0 .002-1.554l-7.378-5.675a1.002 1.002 0 0 0-1.221 0Zm7.37 10.68-6.769 5.207-6.76-5.196a.996.996 0 0 0-1.22 0 .977.977 0 0 0 0 1.552l7.38 5.676a1.001 1.001 0 0 0 1.22 0l7.381-5.677a.976.976 0 0 0 .001-1.551.997.997 0 0 0-1.233-.01Zm-6.76.189 5.74-4.419-5.739-4.415-5.744 4.42 5.743 4.415Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Order.displayName = "Icon.Action.Order";

// Icon/Action/Participants.tsx
var import_uik73 = require("@appd/uik");
var import_jsx_runtime63 = require("react/jsx-runtime");
var Participants = import_uik73.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime63.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Participants",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime63.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M7.604 13.41c2.146 0 3.885-1.72 3.885-3.843 0-2.122-1.74-3.842-3.885-3.842-2.146 0-3.885 1.72-3.885 3.842s1.74 3.842 3.885 3.842Zm2.052-3.843c0-1.12-.919-2.03-2.052-2.03a2.041 2.041 0 0 0-2.053 2.03c0 1.121.92 2.03 2.053 2.03a2.041 2.041 0 0 0 2.052-2.03Zm10.433 0c0 2.122-1.74 3.842-3.885 3.842-2.146 0-3.886-1.72-3.886-3.842s1.74-3.842 3.886-3.842c2.145 0 3.885 1.72 3.885 3.842Zm-1.833 0c0-1.12-.919-2.03-2.052-2.03a2.041 2.041 0 0 0-2.053 2.03c0 1.121.92 2.03 2.053 2.03a2.041 2.041 0 0 0 2.052-2.03Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime63.jsx)(
        "path",
        {
          d: "M11.167 14.551H4.04c-2.131 0-3.767 2.08-3.767 4.531h1.833c0-1.536.93-2.718 1.934-2.718h7.127c1.005 0 1.935 1.182 1.935 2.718h1.832c0-2.451-1.635-4.53-3.767-4.53Zm5.037 0h3.563c2.132 0 3.767 2.08 3.767 4.531h-1.832c0-1.536-.93-2.718-1.935-2.718h-3.563V14.55Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
Participants.displayName = "Icon.Action.Participants";

// Icon/Action/Paste.tsx
var import_uik74 = require("@appd/uik");
var import_jsx_runtime64 = require("react/jsx-runtime");
var Paste = import_uik74.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Paste",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M19 2.967h-4.2C14.4 1.78 13.3.989 12 .989c-1.3 0-2.4.791-2.8 1.978H5c-1.1 0-2 .89-2 1.978v15.823c0 1.087.9 1.978 2 1.978h14c1.1 0 2-.89 2-1.978V4.945c0-1.088-.9-1.978-2-1.978Zm-7 0c.6 0 1 .494 1 .989 0 .494-.4.989-1 .989s-1-.495-1-.99c0-.494.4-.988 1-.988Zm-7 17.8h14V4.946h-2V7.91H7V4.945H5v15.823Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Paste.displayName = "Icon.Action.Paste";

// Icon/Action/Play.tsx
var import_uik75 = require("@appd/uik");
var import_jsx_runtime65 = require("react/jsx-runtime");
var Play = import_uik75.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime65.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Play",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime65.jsx)("path", { d: "M7 4.945V18.79l11-6.923L7 4.945Z", fill: "#fff", fillOpacity: ".94" })
  }
));
Play.displayName = "Icon.Action.Play";

// Icon/Action/PopOut.tsx
var import_uik76 = require("@appd/uik");
var import_jsx_runtime66 = require("react/jsx-runtime");
var PopOut = import_uik76.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime66.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.PopOut",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime66.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M18.416 4.93h-2.581a.99.99 0 0 1-.997-.985.99.99 0 0 1 .997-.986h4.426c.858 0 1.553.688 1.553 1.535v4.378a.99.99 0 0 1-.997.985.99.99 0 0 1-.996-.985V6.32l-7.1 7.022a1.002 1.002 0 0 1-1.405 0 .975.975 0 0 1 0-1.39l7.1-7.022ZM4.874 19.712h13.95v-7.884h1.993v7.884c0 1.085-.897 1.97-1.993 1.97H4.874a1.98 1.98 0 0 1-1.993-1.97V5.915a1.98 1.98 0 0 1 1.993-1.97h7.971v1.97H4.874v13.797Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
PopOut.displayName = "Icon.Action.PopOut";

// Icon/Action/Redo.tsx
var import_uik77 = require("@appd/uik");
var import_jsx_runtime67 = require("react/jsx-runtime");
var Redo = import_uik77.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime67.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Redo",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime67.jsx)(
      "path",
      {
        d: "M21.26 13.657 20 14.913v-.079c0-4.881-3.975-8.852-8.91-8.9H11c-4.897-.001-8.897 3.87-9 8.712h2A6.769 6.769 0 0 1 6.1 9.88 7.04 7.04 0 0 1 11 7.902c3.842.032 6.94 3.122 6.94 6.922v.09l-1.24-1.257a1.009 1.009 0 0 0-1.415-.005.982.982 0 0 0-.005 1.4l.27.267 2 1.978.74.741c.185.187.436.293.7.297a.827.827 0 0 0 .31-.07l.16-.069a1.8 1.8 0 0 0 .23-.148l3-2.967a.981.981 0 0 0 .006-1.398c-.416-.41-1.046-.41-1.436-.026Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
Redo.displayName = "Icon.Action.Redo";

// Icon/Action/Refresh.tsx
var import_uik78 = require("@appd/uik");
var import_jsx_runtime68 = require("react/jsx-runtime");
var Refresh = import_uik78.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime68.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Refresh",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime68.jsx)(
      "path",
      {
        d: "M22.633 10.71a1.004 1.004 0 0 0-1.41-.009l-1.299 1.27c0-.03.005-.058.005-.088A8.752 8.752 0 0 0 17.34 5.6a8.955 8.955 0 0 0-6.322-2.633c-2.429 0-4.664.908-6.354 2.56A8.757 8.757 0 0 0 2 11.782a8.752 8.752 0 0 0 2.59 6.283 8.954 8.954 0 0 0 6.323 2.634c2.428 0 4.663-.909 6.354-2.561l-1.4-1.401a6.964 6.964 0 0 1-4.901 1.991c-1.904-.01-3.65-.737-4.96-2.047a6.81 6.81 0 0 1-2.014-4.887A6.812 6.812 0 0 1 6.063 6.93a6.964 6.964 0 0 1 4.9-1.992c1.904.01 3.65.738 4.96 2.048a6.808 6.808 0 0 1 2.014 4.886c0 .028-.004.054-.004.082l-1.276-1.277a1.004 1.004 0 0 0-1.41-.008.977.977 0 0 0-.007 1.393l.272.272 1.961 1.962.737.738a1 1 0 0 0 .705.292c.113 0 .218-.028.32-.062.056-.019.105-.046.157-.074.08-.043.161-.084.227-.149l3.006-2.938a.978.978 0 0 0 .008-1.393Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
Refresh.displayName = "Icon.Action.Refresh";

// Icon/Action/Save.tsx
var import_uik79 = require("@appd/uik");
var import_jsx_runtime69 = require("react/jsx-runtime");
var Save = import_uik79.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime69.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Save",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime69.jsx)("path", { d: "M11 8.9h3V5.934h-3V8.9Z", fill: "#fff", fillOpacity: ".94" }),
      /* @__PURE__ */ (0, import_jsx_runtime69.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M17 2.967H5c-1.11 0-2 .89-2 1.978V18.79c0 1.088.89 1.978 2 1.978h14c1.1 0 2-.89 2-1.978V6.923l-4-3.956ZM6 18.79h12v-5.044c0-.491-.513-.89-1.145-.89H7.142c-.63 0-1.142.398-1.142.888v5.046Zm9-13.845H6v4.944h9V4.945Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
Save.displayName = "Icon.Action.Save";

// Icon/Action/SaveAs.tsx
var import_uik80 = require("@appd/uik");
var import_jsx_runtime70 = require("react/jsx-runtime");
var SaveAs = import_uik80.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime70.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.SaveAs",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime70.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M5 13.746v5.044h2.1v1.978H4c-1.1 0-2-.89-2-1.978V4.945c0-1.088.9-1.978 2-1.978h12l3.4 3.263c-.3.1-.6.297-.9.594l-1.1 1.088-1.3 1.186-3.8 3.758H6.1c-.6 0-1.1.396-1.1.89Zm15 5.044c0 1.088-.9 1.978-2 1.978h-3l5-4.945v2.967Zm1.1-6.527 1.4-1.385a.77.77 0 0 0 0-1.088l-1.8-1.78c-.2-.197-.3-.197-.5-.197H20c-.1 0-.3.099-.4.197l-1.4 1.385 2.9 2.868Zm-9.4 9.395H8.8V18.79l8.6-8.505 2.9 2.868-8.6 8.505ZM14 4.945H5v4.944h9V4.945ZM10 8.9h3V5.934h-3V8.9Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
SaveAs.displayName = "Icon.Action.SaveAs";

// Icon/Action/Search.tsx
var import_uik81 = require("@appd/uik");
var import_jsx_runtime71 = require("react/jsx-runtime");
var Search = import_uik81.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime71.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Search",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime71.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "m17.447 16.774 2.63 2.601a1.038 1.038 0 0 1 0 1.48 1.068 1.068 0 0 1-1.497 0L13.267 15.6c-1.546 1.097-3.561 1.579-5.712.929-2.224-.674-3.958-2.54-4.418-4.795-.936-4.591 3.075-8.558 7.717-7.632a6.445 6.445 0 0 1 4.849 4.37c.657 2.126.17 4.12-.94 5.648l.737.725 1.947 1.93ZM9.5 5.944c-2.49 0-4.5 1.988-4.5 4.45 0 2.463 2.01 4.45 4.5 4.45s4.5-1.987 4.5-4.45c0-2.462-2.01-4.45-4.5-4.45Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Search.displayName = "Icon.Action.Search";

// Icon/Action/SearchSnapshot.tsx
var import_uik82 = require("@appd/uik");
var import_jsx_runtime72 = require("react/jsx-runtime");
var SearchSnapshot = import_uik82.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime72.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.SearchSnapshot",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime72.jsx)(
        "path",
        {
          d: "M3.1 16.317h6.15a3.8 3.8 0 0 1 .008.046c.016.093.032.186.092.271.115.631.335 1.24.65 1.8H1V4.194h5.7l1.5-2.216h6.15l1.55 2.215h5.5v8.366a6.336 6.336 0 0 0-2-2.373V6.23h-4.6l-1.4-2.175H9.2L7.7 6.23H3.1v10.087Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime72.jsx)(
        "path",
        {
          d: "M13.46 9.326A6.189 6.189 0 0 1 15 8.999a4.294 4.294 0 0 0-4.472-2.215 4.257 4.257 0 0 0-3.543 3.491 4.22 4.22 0 0 0 2.225 4.43 6.191 6.191 0 0 1 .34-1.532 2.741 2.741 0 0 1-.942-3.065 2.787 2.787 0 0 1 4.852-.782Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime72.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "m19.53 17.85 3.48 3.442.03.05a.98.98 0 0 1 .174 1.033 1 1 0 0 1-.864.608 1.004 1.004 0 0 1-.67-.326l-3.48-3.452a4.664 4.664 0 0 1-4 .554 4.648 4.648 0 0 1-3.19-3.461 4.615 4.615 0 0 1 1.275-4.248 4.735 4.735 0 0 1 4.295-1.26 4.668 4.668 0 0 1 3.358 2.76 4.584 4.584 0 0 1-.408 4.3Zm-6.542-1.444a2.768 2.768 0 0 1-.218-1.072c0-.361.072-.725.217-1.071a2.83 2.83 0 0 1 2.623-1.723c1.555.005 2.814 1.25 2.82 2.789v.004c-.003 1.54-1.262 2.789-2.82 2.794a2.83 2.83 0 0 1-2.622-1.72Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime72.jsx)(
        "path",
        {
          d: "M16.4 6.923h1.9V8.01h-1.9V6.923ZM11.23 9.88c.243 0 .478.088.66.247-.48.331-.914.724-1.29 1.167-.064.077-.122.158-.18.238l-.07.098a1.058 1.058 0 0 1-.137-1.16c.19-.378.59-.61 1.017-.59Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
SearchSnapshot.displayName = "Icon.Action.SearchSnapshot";

// Icon/Action/Share.tsx
var import_uik83 = require("@appd/uik");
var import_jsx_runtime73 = require("react/jsx-runtime");
var Share = import_uik83.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime73.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Share",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime73.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M14.232 14.21a3.117 3.117 0 0 1 2.38-.985l.05-.02c1.343 0 2.553.8 3.066 2.025a3.247 3.247 0 0 1-.723 3.573 3.348 3.348 0 0 1-3.62.704 3.276 3.276 0 0 1-2.04-3.035 2.321 2.321 0 0 1 0-.58l-3.656-1.683a3.157 3.157 0 0 1-2.381.984C5.48 15.193 4 13.73 4 11.926 4 10.122 5.48 8.66 7.308 8.66a3.137 3.137 0 0 1 2.37.984l3.607-1.909c-.02-.17-.02-.341 0-.511 0-1.803 1.479-3.265 3.304-3.267 1.826-.002 3.308 1.457 3.311 3.26.004 1.803-1.472 3.268-3.297 3.273a3.157 3.157 0 0 1-2.381-.983l-3.657 1.84c.07.36.07.731 0 1.092l3.667 1.771Zm2.883 3.51c.504-.205.833-.69.833-1.228 0-.73-.596-1.323-1.335-1.328a1.345 1.345 0 0 0-1.25.813 1.316 1.316 0 0 0 .285 1.45c.384.383.963.498 1.467.293ZM15.268 7.301c0-.733.602-1.328 1.345-1.328.742 0 1.345.595 1.345 1.328 0 .734-.603 1.329-1.345 1.329a1.344 1.344 0 0 1-.954-.386 1.31 1.31 0 0 1-.391-.943ZM7.81 13.125c.504-.205.833-.69.833-1.228 0-.73-.597-1.323-1.335-1.329a1.345 1.345 0 0 0-1.25.814 1.316 1.316 0 0 0 .285 1.45c.384.382.963.498 1.467.293Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Share.displayName = "Icon.Action.Share";

// Icon/Action/ShareArrow.tsx
var import_uik84 = require("@appd/uik");
var import_jsx_runtime74 = require("react/jsx-runtime");
var ShareArrow = import_uik84.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.ShareArrow",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(
      "path",
      {
        d: "M10.484 15.625a2.131 2.131 0 0 1 1.425-.554c1.171 0 2.124.943 2.124 2.1 0 1.159-.953 2.1-2.124 2.1-1.17 0-2.124-.942-2.124-2.1 0-.158.022-.316.059-.467l-5.179-2.992c-.392.36-.909.583-1.483.583A2.167 2.167 0 0 1 1 12.137c0-1.194.975-2.158 2.182-2.158.574 0 1.09.223 1.483.583l5.128-2.956a2.33 2.33 0 0 1-.066-.504c0-1.194.975-2.157 2.182-2.157 1.207 0 2.182.963 2.182 2.157a2.167 2.167 0 0 1-2.182 2.158 2.19 2.19 0 0 1-1.484-.582l-5.127 2.955c.037.166.066.331.066.504s-.03.338-.066.503l5.186 2.985Zm9.253-1.345-2.894-2.862h5.788l-2.894 2.862Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
ShareArrow.displayName = "Icon.Action.ShareArrow";

// Icon/Action/SidePanel.tsx
var import_uik85 = require("@appd/uik");
var import_jsx_runtime75 = require("react/jsx-runtime");
var SidePanel = import_uik85.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime75.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.SidePanel",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime75.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M22.327 18.594V5.616c0-1.02-.836-1.846-1.867-1.846H3.66a1.857 1.857 0 0 0-1.867 1.846v12.923c0 1.02.836 1.846 1.867 1.846h16.8c1.01 0 1.837-.793 1.867-1.79ZM18.593 7.462h-4.592v9.286h4.592V7.462ZM3.66 18.594h16.8V5.616H3.66v12.978Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
SidePanel.displayName = "Icon.Action.SidePanel";

// Icon/Action/Sort.tsx
var import_uik86 = require("@appd/uik");
var import_jsx_runtime76 = require("react/jsx-runtime");
var Sort = import_uik86.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime76.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Sort",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(
        "path",
        {
          d: "M9.50002 14.5747C9.29779 14.5747 9.11547 14.6965 9.03808 14.8834C8.96068 15.0702 9.00346 15.2853 9.14646 15.4283L12.1464 18.4283C12.2402 18.5221 12.3674 18.5747 12.5 18.5747C12.6326 18.5747 12.7598 18.5221 12.8536 18.4283L15.8536 15.4283C15.9966 15.2853 16.0393 15.0702 15.962 14.8834C15.8846 14.6966 15.7022 14.5747 15.5 14.5747L9.50002 14.5747Z",
          fill: "#7E868F"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(
        "path",
        {
          d: "M12.8536 5.72164C12.7598 5.62787 12.6326 5.5752 12.5 5.5752C12.3674 5.5752 12.2402 5.62788 12.1464 5.72165L9.14646 8.72169C9.00346 8.86469 8.96068 9.07975 9.03808 9.26658C9.11547 9.45342 9.29779 9.57524 9.50002 9.57524L15.5 9.5752C15.7022 9.5752 15.8846 9.45338 15.962 9.26654C16.0393 9.0797 15.9966 8.86465 15.8536 8.72165L12.8536 5.72164Z",
          fill: "#7E868F"
        }
      )
    ]
  }
));
Sort.displayName = "Icon.Action.Sort";

// Icon/Action/SortDown.tsx
var import_uik87 = require("@appd/uik");
var import_jsx_runtime77 = require("react/jsx-runtime");
var SortDown = import_uik87.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime77.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.SortDown",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime77.jsx)(
        "path",
        {
          d: "M9.50002 14.5747C9.29779 14.5747 9.11547 14.6965 9.03808 14.8834C8.96068 15.0702 9.00346 15.2853 9.14646 15.4283L12.1464 18.4283C12.2402 18.5221 12.3674 18.5747 12.5 18.5747C12.6326 18.5747 12.7598 18.5221 12.8536 18.4283L15.8536 15.4283C15.9966 15.2853 16.0393 15.0702 15.962 14.8834C15.8846 14.6966 15.7022 14.5747 15.5 14.5747L9.50002 14.5747Z",
          fill: "#7E868F"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime77.jsx)(
        "path",
        {
          d: "M12.8536 5.72164C12.7598 5.62787 12.6326 5.5752 12.5 5.5752C12.3674 5.5752 12.2402 5.62788 12.1464 5.72165L9.14646 8.72169C9.00346 8.86469 8.96068 9.07975 9.03808 9.26658C9.11547 9.45342 9.29779 9.57524 9.50002 9.57524L15.5 9.5752C15.7022 9.5752 15.8846 9.45338 15.962 9.26654C16.0393 9.0797 15.9966 8.86465 15.8536 8.72165L12.8536 5.72164Z",
          fill: "#D0D4D9"
        }
      )
    ]
  }
));
SortDown.displayName = "Icon.Action.SortDown";

// Icon/Action/SortOff.tsx
var import_uik88 = require("@appd/uik");
var import_jsx_runtime78 = require("react/jsx-runtime");
var SortOff = import_uik88.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime78.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.SortOff",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime78.jsx)(
      "path",
      {
        d: "m20.5 21.9-9.8-9.8v4.35l1.55-1.55 1.45 1.4-4 4-4-4 1.45-1.4 1.55 1.55V10.1L2.1 3.5l1.4-1.4 18.4 18.4-1.4 1.4Zm-3.8-9.45-2-2V6.1l-1.6 1.6-1.4-1.4 4-4 4 4-1.4 1.4-1.6-1.6v6.35Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
SortOff.displayName = "Icon.Action.SortOff";

// Icon/Action/SortUp.tsx
var import_uik89 = require("@appd/uik");
var import_jsx_runtime79 = require("react/jsx-runtime");
var SortUp = import_uik89.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime79.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.SortUp",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
        "path",
        {
          d: "M9.50002 14.5747C9.29779 14.5747 9.11547 14.6965 9.03808 14.8834C8.96068 15.0702 9.00346 15.2853 9.14646 15.4283L12.1464 18.4283C12.2402 18.5221 12.3674 18.5747 12.5 18.5747C12.6326 18.5747 12.7598 18.5221 12.8536 18.4283L15.8536 15.4283C15.9966 15.2853 16.0393 15.0702 15.962 14.8834C15.8846 14.6966 15.7022 14.5747 15.5 14.5747L9.50002 14.5747Z",
          fill: "#D0D4D9"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
        "path",
        {
          d: "M12.8536 5.72164C12.7598 5.62787 12.6326 5.5752 12.5 5.5752C12.3674 5.5752 12.2402 5.62788 12.1464 5.72165L9.14646 8.72169C9.00346 8.86469 8.96068 9.07975 9.03808 9.26658C9.11547 9.45342 9.29779 9.57524 9.50002 9.57524L15.5 9.5752C15.7022 9.5752 15.8846 9.45338 15.962 9.26654C16.0393 9.0797 15.9966 8.86465 15.8536 8.72165L12.8536 5.72164Z",
          fill: "#7E868F"
        }
      )
    ]
  }
));
SortUp.displayName = "Icon.Action.SortUp";

// Icon/Action/Stop.tsx
var import_uik90 = require("@appd/uik");
var import_jsx_runtime80 = require("react/jsx-runtime");
var Stop = import_uik90.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Stop",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime80.jsx)("path", { d: "M6 6h12v12H6V6Z", fill: "#fff", fillOpacity: ".94" })
  }
));
Stop.displayName = "Icon.Action.Stop";

// Icon/Action/Symbolicate.tsx
var import_uik91 = require("@appd/uik");
var import_jsx_runtime81 = require("react/jsx-runtime");
var Symbolicate = import_uik91.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime81.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Symbolicate",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime81.jsx)(
        "path",
        {
          d: "M5 10h3V9H5v1Zm5-2H5V7h5v1ZM5 6h6V5H5v1Zm9.516 10.492h1.955l-.983-2.928-.972 2.928Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime81.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M15 9h5a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2v-1H7l-2-2v-2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v5Zm-8 6v2h2v-2H7Zm2.876-5.63-.186.137c-.104.093-.2.193-.284.305-.304.421-.382.92-.401 1.188H5v1h4v1H4V4h9v5h-2c-.424 0-.805.144-1.124.37Zm7.03 8.427.542 1.611h1.714l-2.928-7.82h-1.493l-2.91 7.82h1.713l.537-1.611h2.825Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
Symbolicate.displayName = "Icon.Action.Symbolicate";

// Icon/Action/SyntheticSessionsCritical.tsx
var import_uik92 = require("@appd/uik");
var import_jsx_runtime82 = require("react/jsx-runtime");
var SyntheticSessionsCritical = import_uik92.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime82.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.SyntheticSessionsCritical",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime82.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M15.123 3.184c0-.926-.995-1.684-2.076-1.684H7.284c-1.08 0-1.964.758-1.964 1.684L5.3 7.395h9.823V3.184ZM8.246 5.43a.985.985 0 0 1-.982-.982c0-.54.442-.983.982-.983s.983.443.983.983-.443.982-.983.982Zm2.948-.982c0 .54.442.982.982.982s.982-.442.982-.982a.986.986 0 0 0-.982-.983.986.986 0 0 0-.982.983Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime82.jsx)(
        "path",
        {
          d: "M17.402 10.137c.569 0 1.12.073 1.651.199v-.374c0-.602-.492-1.093-1.094-1.093H2.463c-.601 0-1.093.491-1.093 1.093v2.444c0 .602.492 1.094 1.093 1.094l.012 5.143c0 .135.04.261.105.376.174.314.554.534 1 .534.61 0 1.105-.407 1.105-.91V13.5h1.474V18h4.112a7.21 7.21 0 0 1-.035-.692c0-3.954 3.215-7.171 7.166-7.171Zm-11.243 9.27V19h4.287c.128.525.313 1.027.55 1.5H7.252a1.097 1.097 0 0 1-1.094-1.093Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime82.jsx)("path", { d: "M17.996 14.686v2.573l2.21 1.312-.614 1.005-2.8-1.68v-3.21h1.204Z", fill: "#FA5762" }),
      /* @__PURE__ */ (0, import_jsx_runtime82.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M17.402 11.836a5.474 5.474 0 0 0-5.466 5.47 5.474 5.474 0 0 0 5.466 5.472 5.48 5.48 0 0 0 5.476-5.471 5.48 5.48 0 0 0-5.476-5.471Zm.005 9.397a3.931 3.931 0 0 1-3.927-3.926 3.931 3.931 0 0 1 3.927-3.927 3.931 3.931 0 0 1 3.927 3.927 3.931 3.931 0 0 1-3.927 3.927Z",
          fill: "#FA5762",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
SyntheticSessionsCritical.displayName = "Icon.Action.SyntheticSessionsCritical";

// Icon/Action/SyntheticSessionsNormal.tsx
var import_uik93 = require("@appd/uik");
var import_jsx_runtime83 = require("react/jsx-runtime");
var SyntheticSessionsNormal = import_uik93.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime83.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.SyntheticSessionsNormal",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime83.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M15.123 3.184c0-.926-.995-1.684-2.076-1.684H7.284c-1.08 0-1.964.758-1.964 1.684L5.3 7.395h9.823V3.184ZM8.246 5.43a.985.985 0 0 1-.982-.982c0-.54.442-.983.982-.983s.983.443.983.983-.443.982-.983.982Zm2.948-.982c0 .54.442.982.982.982s.982-.442.982-.982a.986.986 0 0 0-.982-.983.986.986 0 0 0-.982.983Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime83.jsx)(
        "path",
        {
          d: "M17.402 10.137c.569 0 1.12.073 1.651.199v-.374c0-.602-.492-1.093-1.094-1.093H2.463c-.601 0-1.093.491-1.093 1.093v2.444c0 .602.492 1.094 1.093 1.094l.012 5.143c0 .135.04.261.105.376.174.314.554.534 1 .534.61 0 1.105-.407 1.105-.91V13.5h1.474V18h4.112a7.21 7.21 0 0 1-.035-.692c0-3.954 3.215-7.171 7.166-7.171Zm-11.243 9.27V19h4.287c.128.525.313 1.027.55 1.5H7.252a1.097 1.097 0 0 1-1.094-1.093Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime83.jsx)("path", { d: "M17.996 14.686v2.573l2.21 1.312-.614 1.005-2.8-1.68v-3.21h1.204Z", fill: "#75D9A0" }),
      /* @__PURE__ */ (0, import_jsx_runtime83.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M17.402 11.836a5.474 5.474 0 0 0-5.466 5.47 5.474 5.474 0 0 0 5.466 5.472 5.48 5.48 0 0 0 5.476-5.471 5.48 5.48 0 0 0-5.476-5.471Zm.005 9.397a3.931 3.931 0 0 1-3.927-3.926 3.931 3.931 0 0 1 3.927-3.927 3.931 3.931 0 0 1 3.927 3.927 3.931 3.931 0 0 1-3.927 3.927Z",
          fill: "#75D9A0",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
SyntheticSessionsNormal.displayName = "Icon.Action.SyntheticSessionsNormal";

// Icon/Action/SyntheticSessionsWarning.tsx
var import_uik94 = require("@appd/uik");
var import_jsx_runtime84 = require("react/jsx-runtime");
var SyntheticSessionsWarning = import_uik94.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime84.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.SyntheticSessionsWarning",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M15.123 3.184c0-.926-.995-1.684-2.076-1.684H7.284c-1.08 0-1.964.758-1.964 1.684L5.3 7.395h9.823V3.184ZM8.246 5.43a.985.985 0 0 1-.982-.982c0-.54.442-.983.982-.983s.983.443.983.983-.443.982-.983.982Zm2.948-.982c0 .54.442.982.982.982s.982-.442.982-.982a.986.986 0 0 0-.982-.983.986.986 0 0 0-.982.983Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(
        "path",
        {
          d: "M17.402 10.137c.569 0 1.12.073 1.651.199v-.374c0-.602-.492-1.093-1.094-1.093H2.463c-.601 0-1.093.491-1.093 1.093v2.444c0 .602.492 1.094 1.093 1.094l.012 5.143c0 .135.04.261.105.376.174.314.554.534 1 .534.61 0 1.105-.407 1.105-.91V13.5h1.474V18h4.112a7.21 7.21 0 0 1-.035-.692c0-3.954 3.215-7.171 7.166-7.171Zm-11.243 9.27V19h4.287c.128.525.313 1.027.55 1.5H7.252a1.097 1.097 0 0 1-1.094-1.093Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime84.jsx)("path", { d: "M17.996 14.686v2.573l2.21 1.312-.614 1.005-2.8-1.68v-3.21h1.204Z", fill: "#F0C243" }),
      /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M17.402 11.836a5.474 5.474 0 0 0-5.466 5.47 5.474 5.474 0 0 0 5.466 5.472 5.48 5.48 0 0 0 5.476-5.471 5.48 5.48 0 0 0-5.476-5.471Zm.005 9.397a3.931 3.931 0 0 1-3.927-3.926 3.931 3.931 0 0 1 3.927-3.927 3.931 3.931 0 0 1 3.927 3.927 3.931 3.931 0 0 1-3.927 3.927Z",
          fill: "#F0C243",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
SyntheticSessionsWarning.displayName = "Icon.Action.SyntheticSessionsWarning";

// Icon/Action/TestEmail.tsx
var import_uik95 = require("@appd/uik");
var import_jsx_runtime85 = require("react/jsx-runtime");
var TestEmail = import_uik95.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime85.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.TestEmail",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime85.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M14.339 4.07H3.479c-.747 0-1.351.592-1.351 1.315l-.007 6.187c0 .723.61 1.314 1.357 1.314h10.86c.747 0 1.358-.591 1.358-1.314V5.385c0-.723-.61-1.315-1.357-1.315Zm0 2.63-5.43 3.287L3.479 6.7V5.385l5.43 3.287 5.43-3.287V6.7Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime85.jsx)(
        "path",
        {
          d: "m14.349 18.387 6.558-6.558 1.219 1.227-7.777 7.777-4.32-4.32 1.218-1.22 3.102 3.094Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
TestEmail.displayName = "Icon.Action.TestEmail";

// Icon/Action/TestHttpRequest.tsx
var import_uik96 = require("@appd/uik");
var import_jsx_runtime86 = require("react/jsx-runtime");
var TestHttpRequest = import_uik96.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime86.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.TestHttpRequest",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime86.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M15.267 6.039c-.54-2.28-2.718-3.922-5.227-3.922-1.974 0-3.771 1.004-4.71 2.626-2.157.25-3.773 1.957-3.773 4 0 2.226 1.936 4.037 4.317 4.037H14.9c1.997 0 3.623-1.52 3.623-3.388 0-1.728-1.422-3.181-3.257-3.353Zm5.64 5.79-6.558 6.558-3.102-3.093-1.218 1.218 4.32 4.32 7.777-7.776-1.219-1.227Zm-4.073-2.437c0-.99-.867-1.793-1.933-1.793H13.71v-.474c0-1.882-1.646-3.413-3.669-3.413-1.63 0-3.082 1.022-3.53 2.485l-.033.106h-.603c-1.45 0-2.629 1.095-2.629 2.44 0 1.346 1.18 2.442 2.629 2.442H14.9c1.066 0 1.933-.805 1.933-1.793Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
TestHttpRequest.displayName = "Icon.Action.TestHttpRequest";

// Icon/Action/TextAlignCenter.tsx
var import_uik97 = require("@appd/uik");
var import_jsx_runtime87 = require("react/jsx-runtime");
var TextAlignCenter = import_uik97.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime87.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.TextAlignCenter",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime87.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M3.35 4.92V3h17.28v1.92H3.35Zm3.84 1.92v1.92h9.6V6.84h-9.6Zm13.44 5.76H3.35v-1.92h17.28v1.92ZM7.19 14.52v1.92h9.6v-1.92h-9.6Zm-3.84 5.76h17.28v-1.92H3.35v1.92Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
TextAlignCenter.displayName = "Icon.Action.TextAlignCenter";

// Icon/Action/TextAlignLeft.tsx
var import_uik98 = require("@appd/uik");
var import_jsx_runtime88 = require("react/jsx-runtime");
var TextAlignLeft = import_uik98.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime88.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.TextAlignLeft",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime88.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M3 5V3h17.28v2H3Zm11.52 2H3v2h11.52V7Zm0 8H3v2h11.52v-2Zm5.76-2H3v-2h17.28v2ZM3 21h17.28v-2H3v2Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
TextAlignLeft.displayName = "Icon.Action.TextAlignLeft";

// Icon/Action/TextAlignRight.tsx
var import_uik99 = require("@appd/uik");
var import_jsx_runtime89 = require("react/jsx-runtime");
var TextAlignRight = import_uik99.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime89.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.TextAlignRight",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime89.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M3 5V3h17.28v2H3Zm5.76 4h11.52V7H8.76v2Zm11.52 4H3v-2h17.28v2ZM8.76 17h11.52v-2H8.76v2ZM3 21h17.28v-2H3v2Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
TextAlignRight.displayName = "Icon.Action.TextAlignRight";

// Icon/Action/ThumbsDown.tsx
var import_uik100 = require("@appd/uik");
var import_jsx_runtime90 = require("react/jsx-runtime");
var ThumbsDown = import_uik100.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime90.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.ThumbsDown",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime90.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M17.64 3.863h1.67c.938 0 1.7.762 1.7 1.7v7.87c0 .942-.764 1.706-1.705 1.706h-2.446c-.486 0-.947-.15-1.325-.414-.494.26-1.132.742-1.132 1.505v2.756c0 .682-.438 1.287-1.089 1.504a4.28 4.28 0 0 1-1.293.194c-.787 0-1.502-.22-2.074-.64-.63-.474-1.382-1.405-1.382-3.155v-1.214h-2.19a3.37 3.37 0 0 1-3.37-3.37v-.242l.913-5.688c.248-1.955 1.695-3.17 3.774-3.17h6.657a3.36 3.36 0 0 1 2.356.963c.263-.191.586-.305.935-.305Zm-1.902 8.735V6.575c0-.78-.634-1.39-1.39-1.39H7.69c-1.072 0-1.682.488-1.804 1.463l-.902 5.608v.024c0 .78.634 1.39 1.39 1.39h3.755a.39.39 0 0 1 .39.39v2.829c0 .756.195 1.292.56 1.56.415.293.976.268 1.317.22v-2.414c0-2.653 2.852-3.557 3.15-3.651a.873.873 0 0 0 .02-.006.208.208 0 0 1 .17 0Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
ThumbsDown.displayName = "Icon.Action.ThumbsDown";

// Icon/Action/ThumbsUp.tsx
var import_uik101 = require("@appd/uik");
var import_jsx_runtime91 = require("react/jsx-runtime");
var ThumbsUp = import_uik101.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime91.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.ThumbsUp",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime91.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M15.45 8.214h2.19a3.37 3.37 0 0 1 3.37 3.37v.242l-.912 5.689c-.25 1.955-1.696 3.17-3.775 3.17H9.666a3.359 3.359 0 0 1-2.356-.964 1.581 1.581 0 0 1-.935.305h-1.67a1.7 1.7 0 0 1-1.7-1.7v-7.87c0-.942.763-1.705 1.704-1.705h2.446c.486 0 .947.15 1.325.413.494-.259 1.132-.741 1.132-1.505V4.904c0-.683.438-1.287 1.089-1.504a4.282 4.282 0 0 1 1.293-.195c.788 0 1.502.22 2.074.641.63.473 1.382 1.404 1.382 3.155v1.213Zm2.677 9.027.902-5.608v-.024c0-.78-.634-1.39-1.39-1.39h-3.755a.39.39 0 0 1-.39-.39V7c0-.756-.195-1.293-.56-1.56-.415-.293-.976-.27-1.317-.22v2.414c0 2.652-2.852 3.556-3.15 3.65a1.775 1.775 0 0 0-.02.007.209.209 0 0 1-.17 0v6.022c0 .78.634 1.39 1.39 1.39h6.656c1.072 0 1.682-.488 1.804-1.463Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
ThumbsUp.displayName = "Icon.Action.ThumbsUp";

// Icon/Action/Timer.tsx
var import_uik102 = require("@appd/uik");
var import_jsx_runtime92 = require("react/jsx-runtime");
var Timer = import_uik102.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime92.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Timer",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime92.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M14.179 3.955h-3.786a.946.946 0 0 1 0-1.893h3.786a.946.946 0 1 1 0 1.893Zm-2.84 10.411V8.688h1.893v5.678H11.34Zm7.6-6.256.71-.71a.938.938 0 0 0 .005-1.323l-.013-.014a.938.938 0 0 0-1.326.002l-.71.71a8.479 8.479 0 0 0-5.318-1.873C7.74 4.9 3.887 8.65 3.77 13.196a8.512 8.512 0 0 0 8.515 8.742A8.512 8.512 0 0 0 18.939 8.11Zm-5.357 11.812c2.61-.492 4.714-2.596 5.206-5.207a6.635 6.635 0 0 0-7.798-7.798c-2.61.492-4.715 2.597-5.207 5.207a6.634 6.634 0 0 0 7.798 7.798Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Timer.displayName = "Icon.Action.Timer";

// Icon/Action/TreeView.tsx
var import_uik103 = require("@appd/uik");
var import_jsx_runtime93 = require("react/jsx-runtime");
var TreeView = import_uik103.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime93.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.TreeView",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime93.jsx)(
      "path",
      {
        d: "M22.112 10.026h-9.628v1.28H8.708V8.052H14V4H2v4.052h5.204v9.274c0 .831.674 1.505 1.505 1.505h3.774v1.274h9.629v-4.053h-9.628v1.274H8.708V12.81h3.774v1.268h9.629v-4.052Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
TreeView.displayName = "Icon.Action.TreeView";

// Icon/Action/TrendDown.tsx
var import_uik104 = require("@appd/uik");
var import_jsx_runtime94 = require("react/jsx-runtime");
var TrendDown = import_uik104.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime94.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.TrendDown",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime94.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M1.4545 5.9545C1.89384 5.51517 2.60616 5.51517 3.0455 5.9545L9 11.909L11.9545 8.9545C12.3938 8.51516 13.1062 8.51516 13.5455 8.9545L22.5455 17.9545C22.9848 18.3938 22.9848 19.1062 22.5455 19.5455C22.1062 19.9848 21.3938 19.9848 20.9545 19.5455L12.75 11.341L9.7955 14.2955C9.35616 14.7348 8.64384 14.7348 8.2045 14.2955L1.4545 7.5455C1.01517 7.10616 1.01517 6.39384 1.4545 5.9545Z",
          fill: "#7E868F",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime94.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M21.75 11.625C22.3713 11.625 22.875 12.1287 22.875 12.75V18.75C22.875 19.3713 22.3713 19.875 21.75 19.875H15.75C15.1287 19.875 14.625 19.3713 14.625 18.75C14.625 18.1287 15.1287 17.625 15.75 17.625H20.625V12.75C20.625 12.1287 21.1287 11.625 21.75 11.625Z",
          fill: "#7E868F",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
TrendDown.displayName = "Icon.Action.TrendDown";

// Icon/Action/TrendUp.tsx
var import_uik105 = require("@appd/uik");
var import_jsx_runtime95 = require("react/jsx-runtime");
var TrendUp = import_uik105.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime95.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.TrendUp",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime95.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M22.5455 4.4545C22.9848 4.89384 22.9848 5.60616 22.5455 6.0455L13.5455 15.0455C13.1062 15.4848 12.3938 15.4848 11.9545 15.0455L9 12.091L3.0455 18.0455C2.60616 18.4848 1.89384 18.4848 1.4545 18.0455C1.01517 17.6062 1.01517 16.8938 1.4545 16.4545L8.2045 9.7045C8.64384 9.26516 9.35616 9.26516 9.7955 9.7045L12.75 12.659L20.9545 4.4545C21.3938 4.01517 22.1062 4.01517 22.5455 4.4545Z",
          fill: "#7E868F",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime95.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M14.625 5.25C14.625 4.62868 15.1287 4.125 15.75 4.125H21.75C22.3713 4.125 22.875 4.62868 22.875 5.25V11.25C22.875 11.8713 22.3713 12.375 21.75 12.375C21.1287 12.375 20.625 11.8713 20.625 11.25V6.375H15.75C15.1287 6.375 14.625 5.87132 14.625 5.25Z",
          fill: "#7E868F",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
TrendUp.displayName = "Icon.Action.TrendUp";

// Icon/Action/Undo.tsx
var import_uik106 = require("@appd/uik");
var import_jsx_runtime96 = require("react/jsx-runtime");
var Undo = import_uik106.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime96.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Undo",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime96.jsx)(
      "path",
      {
        d: "m3.731 13.81 1.26 1.27V15a9 9 0 0 1 8.92-9h.08a9 9 0 0 1 9 8.81h-2a7 7 0 0 0-7-6.84 7 7 0 0 0-6.93 7v.09l1.24-1.25a1 1 0 1 1 1.41 1.41l-.27.27-2 2-.74.75a1 1 0 0 1-.7.3.829.829 0 0 1-.32-.07l-.16-.07a1.818 1.818 0 0 1-.23-.15l-3-3a1 1 0 0 1 .003-1.414c.417-.414 1.047-.414 1.437-.026Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
Undo.displayName = "Icon.Action.Undo";

// Icon/Action/Ungroup.tsx
var import_uik107 = require("@appd/uik");
var import_jsx_runtime97 = require("react/jsx-runtime");
var Ungroup = import_uik107.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime97.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Ungroup",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime97.jsx)(
        "path",
        {
          d: "M15.81 15.79h-2.76v-.69H4.77v.69H2.02v-2.76h.69V4.76h-.69V2h2.75v.69h8.28V2h2.76v2.76h-.69v8.27h.69v2.76Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime97.jsx)(
        "path",
        {
          d: "M19.26 8.21h2.76v2.76h-.69v8.27h.69V22h-2.76v-.69h-8.28V22H8.22v-2.76h.69V16.6h1.38v2.64h.69v.69h8.28v-.69h.69v-8.27h-.69v-.69h-2.64V8.9h2.64v-.69Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
Ungroup.displayName = "Icon.Action.Ungroup";

// Icon/Action/Upgrade.tsx
var import_uik108 = require("@appd/uik");
var import_jsx_runtime98 = require("react/jsx-runtime");
var Upgrade = import_uik108.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime98.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Upgrade",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime98.jsx)(
        "path",
        {
          d: "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10c0 4.478-2.943 8.267-7 9.541v-2.128A7.998 7.998 0 0 0 12 4a7.998 7.998 0 0 0-3 15.413v2.128C4.943 20.266 2 16.478 2 12Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime98.jsx)(
        "path",
        {
          d: "M16.15 12.182a1 1 0 0 1-1.414 1.414L13 11.86V22h-2V11.86l-1.736 1.736a1 1 0 0 1-1.414-1.414l3.443-3.443a1 1 0 0 1 1.414 0l3.443 3.443Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
Upgrade.displayName = "Icon.Action.Upgrade";

// Icon/Action/Upload.tsx
var import_uik109 = require("@appd/uik");
var import_jsx_runtime99 = require("react/jsx-runtime");
var Upload = import_uik109.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime99.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.Upload",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime99.jsx)(
      "path",
      {
        d: "M10.994 7.415 8.701 9.708a1 1 0 1 1-1.414-1.414l4-4a.999.999 0 0 1 1.089-.216c.122.05.233.123.325.216l4 4a1 1 0 1 1-1.414 1.414l-2.293-2.293V14a1 1 0 1 1-2 0V7.415Zm8.017 12.575v-2H4.977v2H19.01Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
Upload.displayName = "Icon.Action.Upload";

// Icon/Action/ViewDetails.tsx
var import_uik110 = require("@appd/uik");
var import_jsx_runtime100 = require("react/jsx-runtime");
var ViewDetails = import_uik110.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime100.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.ViewDetails",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime100.jsx)(
      "path",
      {
        d: "M12 6a9.77 9.77 0 0 1 8.82 5.5 9.82 9.82 0 0 1-17.64 0A9.77 9.77 0 0 1 12 6Zm0-2a11.83 11.83 0 0 0-11 7.5 11.82 11.82 0 0 0 22 0A11.83 11.83 0 0 0 12 4Zm0 5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm0-2a4.5 4.5 0 1 0 4.5 4.5A4.51 4.51 0 0 0 12 7Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
ViewDetails.displayName = "Icon.Action.ViewDetails";

// Icon/Action/ViewDiagnosticSession.tsx
var import_uik111 = require("@appd/uik");
var import_jsx_runtime101 = require("react/jsx-runtime");
var ViewDiagnosticSession = import_uik111.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime101.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.ViewDiagnosticSession",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(
        "path",
        {
          d: "m6.91 8.982 1.225-2.121L9.36 8.982H6.91Zm2.45 1.875H6.91v2.188h2.45v-2.188Zm-.062 4.959a1.194 1.194 0 1 1-2.387 0 1.194 1.194 0 0 1 2.387 0Zm7.666-4.472h-6v1h6v-1Zm-6 3.894h6v1h-6v-1Zm6-7.894h-6v1h6v-1Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M3.054 5.275C3.054 4.02 4.056 3 5.294 3h13.404c1.237 0 2.24 1.019 2.24 2.275v13.45c0 1.256-1.003 2.275-2.24 2.275H5.293c-1.237 0-2.24-1.019-2.24-2.275V5.275Zm15.883 13.45V5.275c0-.152-.107-.275-.239-.275H5.293c-.132 0-.24.123-.24.275v13.45c0 .152.108.275.24.275h13.405c.132 0 .24-.123.24-.275Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
ViewDiagnosticSession.displayName = "Icon.Action.ViewDiagnosticSession";

// Icon/Action/ViewMobile.tsx
var import_uik112 = require("@appd/uik");
var import_jsx_runtime102 = require("react/jsx-runtime");
var ViewMobile = import_uik112.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime102.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.ViewMobile",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime102.jsx)("path", { d: "M13.9 5.1h-3v1h3v-1Z", fill: "#fff", fillOpacity: ".94" }),
      /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M16.5 2H8.4C7.6 2 7 2.7 7 3.6v15.8c0 .9.6 1.6 1.4 1.6h8.1c.8 0 1.4-.7 1.4-1.6V3.6c0-.9-.6-1.6-1.4-1.6Zm-.4 17.1H8.8V3.9h7.3v15.2Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
ViewMobile.displayName = "Icon.Action.ViewMobile";

// Icon/Action/ViewSnapshot.tsx
var import_uik113 = require("@appd/uik");
var import_jsx_runtime103 = require("react/jsx-runtime");
var ViewSnapshot = import_uik113.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime103.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.ViewSnapshot",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime103.jsx)("path", { d: "M13.1 12.1a1.1 1.1 0 1 1-2.2 0 1.1 1.1 0 0 1 2.2 0Z", fill: "#fff", fillOpacity: ".94" }),
      /* @__PURE__ */ (0, import_jsx_runtime103.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M14.4 8.202c-4.2-2.3-8.5 2-6.3 6.3.3.6.8 1.1 1.4 1.4 4.2 2.3 8.6-2 6.3-6.3-.3-.5-.8-1-1.4-1.4Zm-4.6 5.5c-1.4-2.1.1-4.4 2.2-4.4 1.5 0 2.8 1.2 2.8 2.7 0 .7-.3 1.4-.8 1.9-.9 1-2.4 1.2-3.7.3-.2-.1-.4-.3-.5-.5Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime103.jsx)("path", { d: "M19.1 8.002h-1.9v1.1h1.9v-1.1Z", fill: "#fff", fillOpacity: ".94" }),
      /* @__PURE__ */ (0, import_jsx_runtime103.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "m15.1 3.002 1.6 2.2h5.5v14.4H1.8v-14.4h5.7l1.5-2.2h6.1Zm-5.1 2.1h4.2l1.4 2.2h4.6v10.2H3.9v-10.2h4.6l1.5-2.2Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
ViewSnapshot.displayName = "Icon.Action.ViewSnapshot";

// Icon/Action/WrapText.tsx
var import_uik114 = require("@appd/uik");
var import_jsx_runtime104 = require("react/jsx-runtime");
var WrapText = import_uik114.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime104.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Action.WrapText",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime104.jsx)(
      "path",
      {
        d: "m14.7 21.212-3.7-3.7 3.7-3.7 1.4 1.45-1.25 1.25h2.4c.48 0 .9-.17 1.24-.51.34-.34.51-.75.51-1.24s-.17-.9-.51-1.24c-.34-.34-.75-.51-1.24-.51H4v-2h13.25c1.05 0 1.94.36 2.66 1.09.72.73 1.09 1.61 1.09 2.66s-.36 1.94-1.09 2.66c-.73.72-1.61 1.09-2.66 1.09h-2.4l1.25 1.25-1.4 1.45ZM4 18.512v-2h5v2H4Zm0-11v-2h16v2H4Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
WrapText.displayName = "Icon.Action.WrapText";

// Icon/AgentType/AgentType.ts
var AgentType_exports = {};
__export(AgentType_exports, {
  Appd: () => Appd,
  Aws: () => Aws,
  Aws_2: () => Aws_2,
  Aws_2Themable: () => Aws_2Themable,
  Azure: () => Azure,
  AzureThemable: () => AzureThemable,
  Azure_2: () => Azure_2,
  GoogleCloud: () => GoogleCloud,
  Snowflake: () => Snowflake,
  ThousandEyes: () => ThousandEyes,
  ThousandEyesThemable: () => ThousandEyesThemable
});

// Icon/AgentType/Appd.tsx
var import_uik115 = require("@appd/uik");
var import_jsx_runtime105 = require("react/jsx-runtime");
var Appd = import_uik115.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime105.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.AgentType.Appd",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime105.jsx)(
      "path",
      {
        d: "M10.18 2.582a10.272 10.272 0 0 0-2.469.298l1.52 3.412a6.663 6.663 0 0 1 5.217 11.713l1.518 3.412a10.29 10.29 0 0 0 4.52-8.529c0-5.691-4.615-10.306-10.307-10.306ZM8.502 13.596 5.909 7.773a6.663 6.663 0 0 0 5.216 11.713l-2.586-5.809-.036-.08Z",
        fill: "#F2F2F3"
      }
    )
  }
));
Appd.displayName = "Icon.AgentType.Appd";

// Icon/AgentType/Aws.tsx
var import_uik116 = require("@appd/uik");
var import_jsx_runtime106 = require("react/jsx-runtime");
var Aws = import_uik116.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime106.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.AgentType.Aws",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime106.jsx)("circle", { cx: "12", cy: "12", fill: "#3B4D63", r: "12" }),
      /* @__PURE__ */ (0, import_jsx_runtime106.jsx)("mask", { height: "6", id: "icon-agent-type-aws__a", maskUnits: "userSpaceOnUse", width: "17", x: "3", y: "8", children: /* @__PURE__ */ (0, import_jsx_runtime106.jsx)("path", { clipRule: "evenodd", d: "M3.625 8.411h16.13v5.344H3.625V8.41Z", fill: "#fff", fillRule: "evenodd" }) }),
      /* @__PURE__ */ (0, import_jsx_runtime106.jsx)("g", { mask: "url(#icon-agent-type-aws__a)", children: /* @__PURE__ */ (0, import_jsx_runtime106.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M16.79 13.652c.292.068.597.103.9.103.299 0 .574-.04.837-.12.251-.074.468-.176.65-.318a1.54 1.54 0 0 0 .426-.5c.1-.194.152-.415.152-.66 0-.295-.088-.563-.269-.796-.181-.233-.485-.414-.907-.545l-.83-.256c-.31-.097-.526-.205-.643-.313a.53.53 0 0 1-.176-.403c0-.233.094-.398.275-.506.182-.108.445-.16.778-.16.415 0 .79.075 1.123.222.1.046.175.069.222.069.088 0 .135-.063.135-.182V9.02a.3.3 0 0 0-.053-.188.501.501 0 0 0-.175-.142 1.294 1.294 0 0 0-.246-.102 4.616 4.616 0 0 0-.333-.091l-.006-.001a6.534 6.534 0 0 0-.375-.062 3.03 3.03 0 0 0-.391-.023c-.258 0-.503.029-.737.097a1.88 1.88 0 0 0-.608.296 1.475 1.475 0 0 0-.422.466 1.237 1.237 0 0 0-.158.63c0 .296.1.575.293.825.193.256.509.449.936.58l.848.255c.286.091.485.188.59.296a.545.545 0 0 1 .158.398.608.608 0 0 1-.304.54c-.199.125-.485.188-.854.188a3.57 3.57 0 0 1-.696-.069 3.24 3.24 0 0 1-.702-.222l-.087-.034a.34.34 0 0 0-.105-.017c-.088 0-.135.057-.135.177v.29c0 .05.012.107.035.159a.43.43 0 0 0 .181.159c.152.085.38.159.673.227Zm-6.837-.108c.047.04.117.057.222.057h.503c.106 0 .188-.017.234-.057.047-.04.082-.113.111-.227l.901-3.66.907 3.666a.403.403 0 0 0 .11.227c.048.04.123.057.235.057h.503c.1 0 .175-.023.222-.057.047-.034.088-.108.123-.222l1.41-4.394a.786.786 0 0 0 .04-.142l.003-.015a.438.438 0 0 0 .009-.076c0-.096-.053-.142-.146-.142h-.544a.389.389 0 0 0-.228.057.482.482 0 0 0-.117.222l-1.012 3.808-.924-3.808c-.024-.108-.065-.188-.111-.222-.047-.04-.123-.057-.234-.057h-.468a.41.41 0 0 0-.234.057c-.047.034-.082.108-.111.222l-.912 3.763-.983-3.763c-.035-.108-.07-.188-.117-.222-.04-.04-.117-.057-.228-.057h-.573c-.094 0-.14.051-.14.142 0 .04.017.114.052.228l1.374 4.394c.035.108.076.187.123.221Zm-4.474-.557c.193 0 .392-.034.603-.102.21-.068.397-.193.555-.364a.893.893 0 0 0 .199-.364c.035-.136.058-.301.058-.494v-.239a5 5 0 0 0-.538-.097 4.52 4.52 0 0 0-.55-.034c-.391 0-.678.074-.87.228-.194.153-.287.37-.287.653 0 .268.07.466.216.603.14.142.345.21.614.21Zm2.439-.358a1.674 1.674 0 0 1-.064-.506h-.012v-1.841c0-.626-.164-1.092-.485-1.399-.328-.307-.837-.46-1.533-.46a3.64 3.64 0 0 0-.912.108 3.426 3.426 0 0 0-.737.256.436.436 0 0 0-.164.119c-.029.04-.04.108-.04.199v.278c0 .12.04.177.122.177a.366.366 0 0 0 .094-.018c.04-.01.11-.034.204-.073.205-.08.416-.142.632-.194.216-.05.427-.074.632-.074.45 0 .766.086.953.262.181.176.275.477.275.91v.414a8.16 8.16 0 0 0-.673-.125 4.749 4.749 0 0 0-.62-.045c-.602 0-1.076.148-1.433.443-.356.296-.532.688-.532 1.171 0 .455.146.819.433 1.091.287.273.678.41 1.17.41.69 0 1.263-.262 1.72-.785.063.131.122.24.18.336.059.09.13.182.211.267.058.051.117.08.175.08.047 0 .1-.018.153-.052l.368-.238c.076-.057.111-.114.111-.171a.242.242 0 0 0-.04-.13 2.992 2.992 0 0 1-.188-.41Z",
          fill: "#fff",
          fillRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ (0, import_jsx_runtime106.jsx)("mask", { height: "4", id: "icon-agent-type-aws__b", maskUnits: "userSpaceOnUse", width: "16", x: "3", y: "15", children: /* @__PURE__ */ (0, import_jsx_runtime106.jsx)("path", { clipRule: "evenodd", d: "M3 15.014h15.556V18.6H3v-3.586Z", fill: "#fff", fillRule: "evenodd" }) }),
      /* @__PURE__ */ (0, import_jsx_runtime106.jsx)("g", { mask: "url(#icon-agent-type-aws__b)", children: /* @__PURE__ */ (0, import_jsx_runtime106.jsx)(
        "path",
        {
          d: "M18.42 16.44c-1.866 1.411-4.578 2.16-6.91 2.16a12.34 12.34 0 0 1-8.434-3.292c-.176-.163-.017-.383.192-.256 2.406 1.429 5.373 2.294 8.441 2.294 2.071 0 4.346-.442 6.439-1.347.312-.146.579.209.272.441Z",
          fill: "#F90"
        }
      ) }),
      /* @__PURE__ */ (0, import_jsx_runtime106.jsx)(
        "path",
        {
          d: "M19.586 15.814c-.221-.289-1.463-.139-2.026-.07-.169.022-.195-.128-.043-.24.99-.708 2.616-.504 2.806-.268.19.24-.053 1.896-.98 2.689-.141.123-.278.059-.215-.102.21-.53.679-1.725.458-2.009Z",
          fill: "#F90"
        }
      )
    ]
  }
));
Aws.displayName = "Icon.AgentType.Aws";

// Icon/AgentType/Aws_2.tsx
var import_uik117 = require("@appd/uik");
var import_jsx_runtime107 = require("react/jsx-runtime");
var Aws_2 = import_uik117.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime107.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.AgentType.Aws_2",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime107.jsx)(
        "path",
        {
          d: "M7.11 10.531c0 .276.03.5.082.664.06.164.134.342.239.536a.33.33 0 0 1 .052.172c0 .074-.045.149-.142.223l-.47.313a.358.358 0 0 1-.193.068c-.075 0-.15-.038-.224-.105a2.304 2.304 0 0 1-.268-.35 5.755 5.755 0 0 1-.231-.44c-.582.686-1.312 1.029-2.192 1.029-.626 0-1.125-.18-1.49-.537-.365-.358-.552-.835-.552-1.431 0-.634.224-1.148.678-1.536.455-.387 1.059-.58 1.827-.58.253 0 .514.021.79.059.275.037.559.097.857.164v-.544c0-.567-.12-.962-.35-1.193-.239-.231-.641-.343-1.215-.343-.261 0-.53.03-.805.097a5.94 5.94 0 0 0-.805.253c-.12.053-.21.082-.261.097a.457.457 0 0 1-.12.023c-.104 0-.156-.075-.156-.231v-.366c0-.119.015-.208.052-.26a.558.558 0 0 1 .209-.157c.26-.134.574-.246.939-.335a4.519 4.519 0 0 1 1.163-.142c.887 0 1.535.201 1.953.604.41.402.618 1.013.618 1.833v2.415h.015Zm-3.026 1.133c.246 0 .5-.044.768-.134a1.66 1.66 0 0 0 .708-.477c.12-.142.209-.298.253-.477a2.66 2.66 0 0 0 .075-.648v-.314a6.224 6.224 0 0 0-.686-.126 5.615 5.615 0 0 0-.7-.045c-.5 0-.865.097-1.111.298-.246.201-.365.485-.365.857 0 .35.089.611.275.79.18.187.44.276.783.276Zm5.985.805c-.134 0-.223-.022-.283-.074-.06-.045-.112-.15-.157-.291L7.878 6.342a1.306 1.306 0 0 1-.067-.298c0-.12.06-.186.179-.186h.73c.142 0 .239.022.29.074.06.045.105.15.15.291l1.252 4.934 1.163-4.934c.037-.149.082-.246.142-.29a.513.513 0 0 1 .298-.075h.596c.141 0 .238.022.298.074.06.045.112.15.142.291l1.177 4.994 1.29-4.994c.044-.149.097-.246.149-.29a.486.486 0 0 1 .29-.075h.694c.119 0 .186.06.186.186 0 .037-.007.075-.015.12a1.066 1.066 0 0 1-.052.186l-1.796 5.761c-.045.15-.097.246-.157.291a.477.477 0 0 1-.283.075h-.641c-.142 0-.239-.023-.298-.075-.06-.052-.112-.149-.142-.298l-1.155-4.808-1.148 4.8c-.037.15-.082.246-.142.299-.06.052-.164.074-.298.074h-.64Zm9.578.201a4.91 4.91 0 0 1-1.148-.134c-.372-.09-.663-.186-.857-.298-.12-.067-.201-.141-.231-.209a.526.526 0 0 1-.045-.208v-.38c0-.157.06-.232.172-.232a.42.42 0 0 1 .134.023c.045.015.112.045.186.074.254.112.53.202.82.261.298.06.589.09.887.09.47 0 .835-.082 1.088-.246a.803.803 0 0 0 .388-.708.726.726 0 0 0-.201-.522c-.134-.142-.388-.268-.753-.388l-1.08-.335c-.545-.171-.948-.425-1.194-.76a1.776 1.776 0 0 1-.372-1.081c0-.313.067-.589.201-.827.134-.239.313-.448.537-.612.223-.171.477-.298.775-.387a3.25 3.25 0 0 1 .94-.127c.163 0 .335.008.498.03.172.022.328.052.485.082.149.037.29.074.425.12.134.044.238.089.313.133.104.06.179.12.224.187.044.06.067.141.067.246v.35c0 .156-.06.238-.172.238a.775.775 0 0 1-.283-.089 3.41 3.41 0 0 0-1.431-.29c-.425 0-.76.066-.991.208-.232.142-.35.358-.35.663 0 .21.074.388.223.53.149.141.425.283.82.41l1.058.335c.537.171.924.41 1.155.715.231.306.343.656.343 1.044 0 .32-.067.611-.194.865a2.004 2.004 0 0 1-.544.655 2.4 2.4 0 0 1-.827.418 3.543 3.543 0 0 1-1.066.156Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime107.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M21.056 16.293c-2.452 1.811-6.015 2.773-9.079 2.773-4.293 0-8.161-1.588-11.083-4.227-.231-.208-.023-.492.253-.328 3.16 1.834 7.059 2.945 11.091 2.945 2.72 0 5.71-.567 8.46-1.73.41-.186.76.269.358.567Z",
          fill: "#EB9E41",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime107.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M22.077 15.13c-.313-.402-2.072-.194-2.87-.097-.238.03-.275-.179-.06-.335 1.402-.984 3.705-.7 3.974-.373.268.336-.075 2.639-1.387 3.742-.201.171-.395.082-.306-.142.299-.738.962-2.4.649-2.795Z",
          fill: "#EB9E41",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
Aws_2.displayName = "Icon.AgentType.Aws_2";

// Icon/AgentType/Aws_2Themable.tsx
var import_uik118 = require("@appd/uik");
var import_jsx_runtime108 = require("react/jsx-runtime");
var Aws_2Themable = import_uik118.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime108.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.AgentType.Aws_2Themable",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime108.jsx)(
        "path",
        {
          d: "M7.11 10.531c0 .276.03.5.082.664.06.164.134.342.239.536a.33.33 0 0 1 .052.172c0 .074-.045.149-.142.223l-.47.313a.358.358 0 0 1-.193.068c-.075 0-.15-.038-.224-.105a2.304 2.304 0 0 1-.268-.35 5.755 5.755 0 0 1-.231-.44c-.582.686-1.312 1.029-2.192 1.029-.626 0-1.125-.18-1.49-.537-.365-.358-.552-.835-.552-1.431 0-.634.224-1.148.678-1.536.455-.387 1.059-.58 1.827-.58.253 0 .514.021.79.059.275.037.559.097.857.164v-.544c0-.567-.12-.962-.35-1.193-.239-.231-.641-.343-1.215-.343-.261 0-.53.03-.805.097a5.94 5.94 0 0 0-.805.253c-.12.053-.21.082-.261.097a.457.457 0 0 1-.12.023c-.104 0-.156-.075-.156-.231v-.366c0-.119.015-.208.052-.26a.558.558 0 0 1 .209-.157c.26-.134.574-.246.939-.335a4.519 4.519 0 0 1 1.163-.142c.887 0 1.535.201 1.953.604.41.402.618 1.013.618 1.833v2.415h.015Zm-3.026 1.133c.246 0 .5-.044.768-.134a1.66 1.66 0 0 0 .708-.477c.12-.142.209-.298.253-.477a2.66 2.66 0 0 0 .075-.648v-.314a6.224 6.224 0 0 0-.686-.126 5.615 5.615 0 0 0-.7-.045c-.5 0-.865.097-1.111.298-.246.201-.365.485-.365.857 0 .35.089.611.275.79.18.187.44.276.783.276Zm5.985.805c-.134 0-.223-.022-.283-.074-.06-.045-.112-.15-.157-.291L7.878 6.342a1.306 1.306 0 0 1-.067-.298c0-.12.06-.186.179-.186h.73c.142 0 .239.022.29.074.06.045.105.15.15.291l1.252 4.934 1.163-4.934c.037-.149.082-.246.142-.29a.513.513 0 0 1 .298-.075h.596c.141 0 .238.022.298.074.06.045.112.15.142.291l1.177 4.994 1.29-4.994c.044-.149.097-.246.149-.29a.486.486 0 0 1 .29-.075h.694c.119 0 .186.06.186.186 0 .037-.007.075-.015.12a1.066 1.066 0 0 1-.052.186l-1.796 5.761c-.045.15-.097.246-.157.291a.477.477 0 0 1-.283.075h-.641c-.142 0-.239-.023-.298-.075-.06-.052-.112-.149-.142-.298l-1.155-4.808-1.148 4.8c-.037.15-.082.246-.142.299-.06.052-.164.074-.298.074h-.64Zm9.578.201a4.91 4.91 0 0 1-1.148-.134c-.372-.09-.663-.186-.857-.298-.12-.067-.201-.141-.231-.209a.526.526 0 0 1-.045-.208v-.38c0-.157.06-.232.172-.232a.42.42 0 0 1 .134.023c.045.015.112.045.186.074.254.112.53.202.82.261.298.06.589.09.887.09.47 0 .835-.082 1.088-.246a.803.803 0 0 0 .388-.708.726.726 0 0 0-.201-.522c-.134-.142-.388-.268-.753-.388l-1.08-.335c-.545-.171-.948-.425-1.194-.76a1.776 1.776 0 0 1-.372-1.081c0-.313.067-.589.201-.827.134-.239.313-.448.537-.612.223-.171.477-.298.775-.387a3.25 3.25 0 0 1 .94-.127c.163 0 .335.008.498.03.172.022.328.052.485.082.149.037.29.074.425.12.134.044.238.089.313.133.104.06.179.12.224.187.044.06.067.141.067.246v.35c0 .156-.06.238-.172.238a.775.775 0 0 1-.283-.089 3.41 3.41 0 0 0-1.431-.29c-.425 0-.76.066-.991.208-.232.142-.35.358-.35.663 0 .21.074.388.223.53.149.141.425.283.82.41l1.058.335c.537.171.924.41 1.155.715.231.306.343.656.343 1.044 0 .32-.067.611-.194.865a2.004 2.004 0 0 1-.544.655 2.4 2.4 0 0 1-.827.418 3.543 3.543 0 0 1-1.066.156Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime108.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M21.056 16.293c-2.452 1.811-6.015 2.773-9.079 2.773-4.293 0-8.161-1.588-11.083-4.227-.231-.208-.023-.492.253-.328 3.16 1.834 7.059 2.945 11.091 2.945 2.72 0 5.71-.567 8.46-1.73.41-.186.76.269.358.567Z",
          fill: "#fff",
          fillOpacity: ".64",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime108.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M22.077 15.13c-.313-.402-2.072-.194-2.87-.097-.238.03-.275-.179-.06-.335 1.402-.984 3.705-.7 3.974-.373.268.336-.075 2.639-1.387 3.742-.201.171-.395.082-.306-.142.299-.738.962-2.4.649-2.795Z",
          fill: "#fff",
          fillOpacity: ".64",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
Aws_2Themable.displayName = "Icon.AgentType.Aws_2Themable";

// Icon/AgentType/Azure.tsx
var import_uik119 = require("@appd/uik");
var import_jsx_runtime109 = require("react/jsx-runtime");
var Azure = import_uik119.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime109.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.AgentType.Azure",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime109.jsx)(
        "path",
        {
          d: "M19.586 15.64c-.221-.287-1.463-.138-2.026-.07-.169.022-.195-.127-.043-.238.99-.7 2.616-.498 2.806-.265.19.239-.053 1.876-.98 2.66-.141.122-.278.058-.215-.101.21-.524.679-1.706.458-1.987Z",
          fill: "#F90"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime109.jsx)("ellipse", { cx: "12", cy: "11.867", fill: "#139CEB", rx: "12", ry: "11.867" }),
      /* @__PURE__ */ (0, import_jsx_runtime109.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M10.965 11.697V6.84l6.668-.906v5.763h-6.668Zm-5.564 0-.001-4.1 5.011-.682v4.782h-5.01Zm5.564.612v4.803l6.668.906v-5.709h-6.668Zm-5.564 4.048v-4.048h5.01v4.728l-5.01-.68Z",
          fill: "#fff",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
Azure.displayName = "Icon.AgentType.Azure";

// Icon/AgentType/Azure_2.tsx
var import_uik120 = require("@appd/uik");
var import_jsx_runtime110 = require("react/jsx-runtime");
var Azure_2 = import_uik120.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime110.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.AgentType.Azure_2",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime110.jsx)(
        "path",
        {
          d: "M8.01 1.641h6.22L7.775 20.774a.992.992 0 0 1-.94.675H1.993a.992.992 0 0 1-.939-1.307L7.07 2.316a.992.992 0 0 1 .94-.675Z",
          fill: "url(#icon-agent-type-azure-2__a)"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime110.jsx)(
        "path",
        {
          d: "M17.05 14.474H7.185a.457.457 0 0 0-.311.79l6.338 5.917a.997.997 0 0 0 .68.268h5.586l-2.428-6.975Z",
          fill: "#0078D4"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime110.jsx)(
        "path",
        {
          d: "M8.01 1.641a.984.984 0 0 0-.942.688L1.062 20.125a.99.99 0 0 0 .933 1.324h4.966a1.063 1.063 0 0 0 .815-.693l1.198-3.53 4.279 3.99c.179.149.404.23.637.233h5.564l-2.44-6.975-7.115.002L14.254 1.64H8.01Z",
          fill: "url(#icon-agent-type-azure-2__b)"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime110.jsx)(
        "path",
        {
          d: "M15.956 2.315a.99.99 0 0 0-.939-.674H8.084a.99.99 0 0 1 .939.674l6.017 17.827a.991.991 0 0 1-.939 1.307h6.933a.992.992 0 0 0 .938-1.307L15.955 2.315Z",
          fill: "url(#icon-agent-type-azure-2__c)"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime110.jsxs)("defs", { children: [
        /* @__PURE__ */ (0, import_jsx_runtime110.jsxs)(
          "linearGradient",
          {
            gradientUnits: "userSpaceOnUse",
            id: "icon-agent-type-azure-2__a",
            x1: "10.278",
            x2: "3.817",
            y1: "3.109",
            y2: "22.194",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime110.jsx)("stop", { stopColor: "#114A8B" }),
              /* @__PURE__ */ (0, import_jsx_runtime110.jsx)("stop", { offset: "1", stopColor: "#0669BC" })
            ]
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime110.jsxs)(
          "linearGradient",
          {
            gradientUnits: "userSpaceOnUse",
            id: "icon-agent-type-azure-2__b",
            x1: "12.296",
            x2: "10.801",
            y1: "12.003",
            y2: "12.508",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime110.jsx)("stop", { stopOpacity: ".3" }),
              /* @__PURE__ */ (0, import_jsx_runtime110.jsx)("stop", { offset: ".071", stopOpacity: ".2" }),
              /* @__PURE__ */ (0, import_jsx_runtime110.jsx)("stop", { offset: ".321", stopOpacity: ".1" }),
              /* @__PURE__ */ (0, import_jsx_runtime110.jsx)("stop", { offset: ".623", stopOpacity: ".05" }),
              /* @__PURE__ */ (0, import_jsx_runtime110.jsx)("stop", { offset: "1", stopOpacity: "0" })
            ]
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime110.jsxs)(
          "linearGradient",
          {
            gradientUnits: "userSpaceOnUse",
            id: "icon-agent-type-azure-2__c",
            x1: "11.474",
            x2: "18.565",
            y1: "2.552",
            y2: "21.445",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime110.jsx)("stop", { stopColor: "#3CCBF4" }),
              /* @__PURE__ */ (0, import_jsx_runtime110.jsx)("stop", { offset: "1", stopColor: "#2892DF" })
            ]
          }
        )
      ] })
    ]
  }
));
Azure_2.displayName = "Icon.AgentType.Azure_2";

// Icon/AgentType/AzureThemable.tsx
var import_uik121 = require("@appd/uik");
var import_jsx_runtime111 = require("react/jsx-runtime");
var AzureThemable = import_uik121.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime111.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.AgentType.AzureThemable",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime111.jsx)(
        "path",
        {
          d: "M8.254 1.636h6.51L8.006 21.658a1.038 1.038 0 0 1-.983.706H1.957a1.036 1.036 0 0 1-.982-1.367L7.271 2.341c.142-.422.538-.706.983-.706Z",
          fill: "url(#icon-agent-type-azure-themable__a)",
          opacity: ".4"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime111.jsx)(
        "path",
        {
          d: "M17.714 15.066H7.39a.478.478 0 0 0-.326.827l6.633 6.19c.193.18.447.281.711.281h5.845l-2.54-7.299Z",
          fill: "#fff",
          opacity: ".6"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime111.jsx)(
        "path",
        {
          d: "M16.569 2.341a1.036 1.036 0 0 0-.982-.705H8.332c.445 0 .84.284.982.705l6.296 18.655a1.037 1.037 0 0 1-.982 1.368h7.255a1.037 1.037 0 0 0 .982-1.368L16.569 2.341Z",
          fill: "url(#icon-agent-type-azure-themable__b)"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime111.jsxs)("defs", { children: [
        /* @__PURE__ */ (0, import_jsx_runtime111.jsxs)(
          "linearGradient",
          {
            gradientUnits: "userSpaceOnUse",
            id: "icon-agent-type-azure-themable__a",
            x1: "10.627",
            x2: "3.867",
            y1: "3.172",
            y2: "23.144",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime111.jsx)("stop", { stopColor: "#fff" }),
              /* @__PURE__ */ (0, import_jsx_runtime111.jsx)("stop", { offset: "1", stopColor: "#fff" })
            ]
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime111.jsxs)(
          "linearGradient",
          {
            gradientUnits: "userSpaceOnUse",
            id: "icon-agent-type-azure-themable__b",
            x1: "11.927",
            x2: "19.348",
            y1: "2.572",
            y2: "22.342",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime111.jsx)("stop", { offset: "0", stopColor: "#fff" }),
              /* @__PURE__ */ (0, import_jsx_runtime111.jsx)("stop", { offset: "1", stopColor: "#fff" })
            ]
          }
        )
      ] })
    ]
  }
));
AzureThemable.displayName = "Icon.AgentType.AzureThemable";

// Icon/AgentType/GoogleCloud.tsx
var import_uik122 = require("@appd/uik");
var import_jsx_runtime112 = require("react/jsx-runtime");
var GoogleCloud = import_uik122.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime112.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.AgentType.GoogleCloud",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime112.jsx)("mask", { height: "6", id: "icon-agent-type-google-cloud__a", maskUnits: "userSpaceOnUse", width: "17", x: "3", y: "8", children: /* @__PURE__ */ (0, import_jsx_runtime112.jsx)("path", { clipRule: "evenodd", d: "M3.625 8.318h16.13v5.284H3.625V8.318Z", fill: "#fff", fillRule: "evenodd" }) }),
      /* @__PURE__ */ (0, import_jsx_runtime112.jsx)("g", { mask: "url(#icon-agent-type-google-cloud__a)", children: /* @__PURE__ */ (0, import_jsx_runtime112.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M16.79 13.501c.292.068.597.101.9.101.299 0 .574-.039.837-.118a1.92 1.92 0 0 0 .65-.315c.18-.134.32-.303.426-.494a1.4 1.4 0 0 0 .152-.652 1.24 1.24 0 0 0-.269-.787c-.181-.23-.485-.41-.907-.54l-.83-.253c-.31-.095-.526-.202-.643-.309a.521.521 0 0 1-.176-.4c0-.23.094-.393.275-.5.182-.106.445-.157.778-.157.415 0 .79.073 1.123.22.1.044.175.067.222.067.088 0 .135-.062.135-.18V8.92a.294.294 0 0 0-.053-.186.5.5 0 0 0-.175-.14 1.3 1.3 0 0 0-.246-.101 4.655 4.655 0 0 0-.333-.09l-.006-.001a6.6 6.6 0 0 0-.375-.061 3.062 3.062 0 0 0-.391-.023c-.258 0-.503.028-.737.096a1.888 1.888 0 0 0-.608.292 1.465 1.465 0 0 0-.422.461c-.105.18-.158.388-.158.624 0 .292.1.568.293.815.193.253.509.444.936.574l.848.252c.286.09.485.186.59.293a.535.535 0 0 1 .158.393.6.6 0 0 1-.304.534c-.199.124-.485.186-.854.186-.234 0-.462-.023-.696-.068a3.278 3.278 0 0 1-.702-.22 1.525 1.525 0 0 0-.087-.033.345.345 0 0 0-.105-.016c-.088 0-.135.056-.135.174v.286c0 .051.012.107.035.158a.42.42 0 0 0 .181.157c.152.085.38.158.673.225Zm-6.837-.107c.047.04.117.057.222.057h.503c.106 0 .188-.017.234-.057.047-.039.082-.112.111-.225l.901-3.62.907 3.626c.023.112.064.186.11.225.048.04.123.056.235.056h.503c.1 0 .175-.022.222-.056.047-.034.088-.107.123-.22l1.41-4.345a.771.771 0 0 0 .04-.14l.003-.016a.429.429 0 0 0 .009-.074c0-.096-.053-.14-.146-.14h-.544a.392.392 0 0 0-.228.056c-.041.033-.082.106-.117.219l-1.012 3.766-.924-3.766c-.024-.107-.065-.186-.111-.22-.047-.039-.123-.056-.234-.056h-.468a.414.414 0 0 0-.234.057c-.047.033-.082.106-.111.219l-.912 3.721-.983-3.721c-.035-.107-.07-.186-.117-.22-.04-.039-.117-.056-.228-.056h-.573c-.094 0-.14.051-.14.141 0 .04.017.112.052.225l1.374 4.345c.035.107.076.186.123.22Zm-4.474-.55c.193 0 .392-.034.603-.102.21-.067.397-.19.555-.36a.881.881 0 0 0 .199-.36c.035-.134.058-.297.058-.488v-.236a4.58 4.58 0 0 0-1.088-.13c-.391 0-.678.073-.87.225-.194.152-.287.365-.287.647 0 .264.07.46.216.595.14.141.345.208.614.208Zm2.439-.355a1.638 1.638 0 0 1-.064-.5h-.012v-1.821c0-.619-.164-1.08-.485-1.383-.328-.304-.837-.455-1.533-.455-.321 0-.626.033-.912.107a3.45 3.45 0 0 0-.737.252.435.435 0 0 0-.164.118c-.029.04-.04.107-.04.197v.276c0 .118.04.174.122.174a.37.37 0 0 0 .094-.017c.04-.011.11-.034.204-.073.205-.079.416-.14.632-.191.216-.05.427-.073.632-.073.45 0 .766.084.953.258.181.175.275.473.275.9v.41a8.221 8.221 0 0 0-.673-.123 4.815 4.815 0 0 0-.62-.046c-.602 0-1.076.147-1.433.439-.356.292-.532.68-.532 1.158 0 .45.146.81.433 1.08.287.269.678.404 1.17.404a2.2 2.2 0 0 0 1.72-.776c.063.13.122.236.18.332.059.09.13.18.211.264.058.05.117.079.175.079.047 0 .1-.017.153-.05l.368-.237c.076-.056.111-.112.111-.169a.237.237 0 0 0-.04-.129 2.946 2.946 0 0 1-.188-.405Z",
          fill: "#fff",
          fillRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ (0, import_jsx_runtime112.jsx)("mask", { height: "5", id: "icon-agent-type-google-cloud__b", maskUnits: "userSpaceOnUse", width: "16", x: "3", y: "14", children: /* @__PURE__ */ (0, import_jsx_runtime112.jsx)("path", { clipRule: "evenodd", d: "M3 14.848h15.556v3.546H3v-3.546Z", fill: "#fff", fillRule: "evenodd" }) }),
      /* @__PURE__ */ (0, import_jsx_runtime112.jsx)("g", { mask: "url(#icon-agent-type-google-cloud__b)", children: /* @__PURE__ */ (0, import_jsx_runtime112.jsx)(
        "path",
        {
          d: "M18.42 16.258c-1.866 1.396-4.578 2.136-6.91 2.136a12.415 12.415 0 0 1-8.434-3.256c-.176-.16-.017-.379.192-.252 2.406 1.412 5.373 2.268 8.441 2.268 2.071 0 4.346-.436 6.439-1.332.312-.144.579.206.272.436Z",
          fill: "#F90"
        }
      ) }),
      /* @__PURE__ */ (0, import_jsx_runtime112.jsx)(
        "path",
        {
          d: "M19.586 15.64c-.221-.287-1.463-.138-2.026-.07-.169.022-.195-.127-.043-.238.99-.7 2.616-.498 2.806-.265.19.239-.053 1.876-.98 2.66-.141.122-.278.058-.215-.101.21-.524.679-1.706.458-1.987Z",
          fill: "#F90"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime112.jsx)("ellipse", { cx: "12", cy: "11.867", fill: "#EDEDED", rx: "12", ry: "11.867" }),
      /* @__PURE__ */ (0, import_jsx_runtime112.jsx)("mask", { height: "6", id: "icon-agent-type-google-cloud__c", maskUnits: "userSpaceOnUse", width: "11", x: "6", y: "4", children: /* @__PURE__ */ (0, import_jsx_runtime112.jsx)("path", { clipRule: "evenodd", d: "M6.109 4.988h9.942v4.456H6.109V4.988Z", fill: "#fff", fillRule: "evenodd" }) }),
      /* @__PURE__ */ (0, import_jsx_runtime112.jsx)("g", { mask: "url(#icon-agent-type-google-cloud__c)", children: /* @__PURE__ */ (0, import_jsx_runtime112.jsx)(
        "path",
        {
          d: "M8.608 8.678c.298 0 .588.031.869.087.007-.002.014-.005.02-.004A3.401 3.401 0 0 1 12 7.667a3.414 3.414 0 0 1 2.128.748l1.922-1.9a6.115 6.115 0 0 0-4.052-1.527c-2.813 0-5.187 1.893-5.89 4.456l.03-.013a4.427 4.427 0 0 1 2.47-.753Z",
          fill: "#EA4335"
        }
      ) }),
      /* @__PURE__ */ (0, import_jsx_runtime112.jsx)("path", { d: "M14.128 8.418h.002l-.002-.002v.002Z", fill: "#EA4335" }),
      /* @__PURE__ */ (0, import_jsx_runtime112.jsx)(
        "path",
        {
          d: "M16.05 6.517 14.13 8.42a3.332 3.332 0 0 1 1.262 2.606v.336c.935 0 1.695.753 1.695 1.676 0 .925-.762 1.676-1.695 1.676h-3.396v2.683h3.396c2.433-.003 4.404-1.953 4.408-4.359a4.349 4.349 0 0 0-1.909-3.586 6.034 6.034 0 0 0-1.84-2.935Z",
          fill: "#4285F4"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime112.jsx)(
        "path",
        {
          d: "M11.996 14.72v-.008H8.608c-.24 0-.478-.051-.697-.15l-.004.001c.002 0 .004.002.005.003l-1.964 1.942a4.42 4.42 0 0 0 2.66.888v.001h3.388V14.72Z",
          fill: "#34A853"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime112.jsx)(
        "path",
        {
          d: "M7.907 14.563a1.677 1.677 0 0 1-.994-1.525c0-.925.762-1.677 1.695-1.677.688 0 1.278.41 1.546.989l1.965-1.944a4.419 4.419 0 0 0-3.51-1.728 4.429 4.429 0 0 0-2.472.753A4.348 4.348 0 0 0 4.2 13.038c0 1.415.686 2.674 1.747 3.471l1.965-1.943-.005-.003Z",
          fill: "#FBBC05"
        }
      )
    ]
  }
));
GoogleCloud.displayName = "Icon.AgentType.GoogleCloud";

// Icon/AgentType/Snowflake.tsx
var import_uik123 = require("@appd/uik");
var import_jsx_runtime113 = require("react/jsx-runtime");
var Snowflake = import_uik123.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime113.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.AgentType.Snowflake",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime113.jsx)(
      "path",
      {
        d: "M5.47283 7.07507L9.3084 9.37499C9.5208 9.50264 9.77016 9.55461 10.0159 9.52243C10.2616 9.49025 10.4892 9.37582 10.6615 9.19778C10.7767 9.08676 10.8681 8.95353 10.9303 8.80614C10.9925 8.65876 11.0242 8.50029 11.0233 8.34032V3.73074C11.031 3.52884 10.9841 3.32861 10.8875 3.15114C10.7909 2.97367 10.6483 2.82553 10.4746 2.72231C10.3009 2.61911 10.1026 2.56464 9.90063 2.56464C9.69862 2.56464 9.50034 2.61911 9.32668 2.72231C9.15299 2.82553 9.01034 2.97367 8.91377 3.15114C8.8172 3.32861 8.77027 3.52884 8.77794 3.73074V6.35384L6.5998 5.0476C6.47135 4.97136 6.32893 4.92164 6.18095 4.90138C6.03296 4.88112 5.88242 4.89073 5.73821 4.92965C5.44748 5.00779 5.20215 5.20682 5.06003 5.47338C4.74836 6.03361 4.93029 6.73539 5.47283 7.07212M14.6932 9.37204L18.5287 7.07212C19.0713 6.73509 19.2535 6.03037 18.9415 5.47279C18.871 5.34122 18.7745 5.22531 18.658 5.13203C18.5414 5.03874 18.4072 4.97003 18.2634 4.93002C18.1196 4.89002 17.9691 4.87955 17.8211 4.89925C17.6732 4.91895 17.5307 4.96841 17.4024 5.04465L15.2499 6.33319V3.72661C15.2553 3.57576 15.2303 3.42535 15.1764 3.28436C15.1224 3.14338 15.0406 3.01472 14.9358 2.90606C14.831 2.7974 14.7054 2.71098 14.5665 2.65195C14.4275 2.59292 14.2781 2.5625 14.1272 2.5625C13.9762 2.5625 13.8268 2.59292 13.6879 2.65195C13.5489 2.71098 13.4233 2.7974 13.3185 2.90606C13.2138 3.01472 13.1319 3.14338 13.078 3.28436C13.024 3.42535 12.999 3.57576 13.0045 3.72661V8.24478C12.9814 8.4868 13.0322 8.73014 13.1502 8.94272C13.2923 9.20898 13.5376 9.40566 13.8283 9.48645C13.9724 9.52674 14.1232 9.53706 14.2714 9.51677C14.4195 9.49648 14.562 9.44602 14.6899 9.3685M9.92171 11.7993V12.2015C9.9267 12.3026 9.9653 12.3991 10.0314 12.4758L11.5529 14.0553C11.6247 14.1232 11.7181 14.1635 11.8168 14.1692H12.2036C12.3023 14.1635 12.3958 14.1232 12.4676 14.0553L13.989 12.4758C14.0551 12.3991 14.0937 12.3026 14.0987 12.2015V11.7993C14.0937 11.6983 14.0551 11.6018 13.989 11.5251L12.4676 9.94555C12.3958 9.87766 12.3023 9.83735 12.2036 9.83173H11.8168C11.7181 9.83735 11.6247 9.87766 11.5529 9.94555L10.0314 11.5281C9.9655 11.6048 9.92692 11.7013 9.92171 11.8023M3.48841 10.7084L5.66007 12.0108L3.48841 13.312C3.22741 13.4746 3.03897 13.7314 2.96217 14.0291C2.88537 14.3269 2.92609 14.6428 3.0759 14.9113C3.14635 15.0431 3.24276 15.1592 3.35932 15.2526C3.47588 15.3461 3.61017 15.4149 3.75408 15.455C4.04482 15.5358 4.35619 15.4943 4.61567 15.3395L8.45124 13.0395C8.80507 12.8149 9.01147 12.4268 9.01147 12.0099C9.01145 11.8051 8.96017 11.6036 8.86231 11.4238C8.76445 11.2439 8.62313 11.0915 8.45124 10.9802L4.61567 8.6803C4.48723 8.60406 4.34481 8.55434 4.19682 8.53408C4.04883 8.51382 3.89829 8.52343 3.75408 8.56235C3.46335 8.64049 3.21802 8.83952 3.0759 9.10608C2.76423 9.66631 2.94616 10.3675 3.48871 10.7048M14.9869 12.0146C14.9835 12.2197 15.0336 12.4222 15.1324 12.602C15.2312 12.7817 15.3751 12.9327 15.55 13.0398L19.3832 15.3398C19.6427 15.4943 19.9535 15.5361 20.2442 15.4553C20.535 15.3745 20.78 15.1782 20.9224 14.9119C21.0729 14.6435 21.114 14.3273 21.0371 14.0294C20.9602 13.7314 20.7712 13.4746 20.5096 13.3126L18.3406 12.0111L20.5123 10.7087C21.0548 10.3716 21.2367 9.66779 20.9251 9.10991C20.8548 8.97806 20.7584 8.86188 20.6418 8.76841C20.5252 8.67494 20.3909 8.60614 20.2469 8.56618C19.9559 8.48539 19.6448 8.52667 19.3859 8.68413L15.5527 10.9841C15.3765 11.092 15.2317 11.2443 15.1328 11.4258C15.034 11.6073 14.9846 11.8115 14.9895 12.0181M10.0786 14.5085C9.81386 14.4574 9.5396 14.5062 9.30869 14.6454L5.47313 16.9453C4.93058 17.2823 4.74895 17.9861 5.06032 18.544C5.20274 18.8103 5.44777 19.007 5.7385 19.0874C5.88248 19.1274 6.03305 19.1377 6.18113 19.1179C6.32922 19.098 6.47174 19.0483 6.60009 18.9719L8.77824 17.6656V20.2693C8.77223 20.4204 8.79683 20.5712 8.85053 20.7127C8.90424 20.8541 8.98596 20.9832 9.09079 21.0923C9.19562 21.2014 9.3214 21.2881 9.46058 21.3474C9.59977 21.4067 9.74949 21.4373 9.90078 21.4373C10.0521 21.4373 10.2018 21.4067 10.341 21.3474C10.4802 21.2881 10.6059 21.2014 10.7108 21.0923C10.8156 20.9832 10.8973 20.8541 10.951 20.7127C11.0047 20.5712 11.0293 20.4204 11.0233 20.2693V15.6561C11.0273 15.3835 10.9345 15.1184 10.7615 14.9077C10.5885 14.697 10.3464 14.5544 10.0783 14.5053M18.529 16.9456L14.6935 14.6456C14.5651 14.5692 14.4226 14.5195 14.2745 14.4996C14.1264 14.4798 13.9758 14.4901 13.8319 14.5301C13.6879 14.57 13.5536 14.6387 13.437 14.7322C13.3204 14.8256 13.224 14.9417 13.1537 15.0735C13.0357 15.2864 12.985 15.53 13.008 15.7723V20.269C13.002 20.4201 13.0266 20.5709 13.0803 20.7124C13.134 20.8538 13.2158 20.9829 13.3206 21.092C13.4254 21.2011 13.5512 21.2878 13.6904 21.3471C13.8296 21.4064 13.9793 21.437 14.1306 21.437C14.2819 21.437 14.4316 21.4064 14.5708 21.3471C14.71 21.2878 14.8357 21.2011 14.9406 21.092C15.0454 20.9829 15.1271 20.8538 15.1808 20.7124C15.2345 20.5709 15.2591 20.4201 15.2531 20.269V17.6848L17.4018 18.9733C17.5302 19.0496 17.6726 19.0993 17.8206 19.1196C17.9686 19.1398 18.1192 19.1302 18.2634 19.0913C18.5541 19.0131 18.7994 18.8141 18.9415 18.5476C19.2532 17.9873 19.0713 17.2855 18.5287 16.9488",
        fill: "#29B5E8"
      }
    )
  }
));
Snowflake.displayName = "Icon.AgentType.Snowflake";

// Icon/AgentType/ThousandEyes.tsx
var import_uik124 = require("@appd/uik");
var import_jsx_runtime114 = require("react/jsx-runtime");
var ThousandEyes = import_uik124.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime114.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.AgentType.ThousandEyes",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime114.jsx)(
        "path",
        {
          d: "M12.75 14.362a11.677 11.677 0 0 0 3.674-2.914 12.086 12.086 0 0 0-3.825-2.812c2.775-.607 5.192 2.113 5.192 2.113l.65.709-.64.717c-2.534 2.708-5.051 2.187-5.051 2.187Z",
          fill: "#FF9E59"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime114.jsx)(
        "path",
        {
          d: "M12.963 11.496a1.291 1.291 0 0 1-1.3 1.28 1.291 1.291 0 0 1-1.296-1.284 1.29 1.29 0 0 1 1.298-1.283c.345 0 .675.136.919.377.244.242.38.57.38.91Z",
          fill: "#fff",
          fillOpacity: ".64"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime114.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M5.292 11.913c.134.212 3.35 5.17 8.16 5.17 2.838 0 5.555-1.722 8.072-5.118l.393-.53-.399-.526c-2.518-3.318-5.231-5-8.066-5-4.803 0-8.019 4.846-8.153 5.052l-.311.474.304.478Zm8.16 3.402c-3.049 0-5.449-2.737-6.312-3.867.867-1.11 3.266-3.772 6.312-3.772 2.102 0 4.197 1.268 6.23 3.772-2.035 2.566-4.129 3.867-6.23 3.867Z",
          fill: "#FF9E59",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime114.jsx)(
        "path",
        {
          d: "M9.79 17.079c-4.69-.145-7.716-4.996-7.848-5.204l-.249-.481.29-.47c.133-.203 3.104-4.845 7.767-5.01-3.62 1.648-6.14 5.57-6.14 5.57a16.75 16.75 0 0 0 6.18 5.595Z",
          fill: "#FF9E59"
        }
      )
    ]
  }
));
ThousandEyes.displayName = "Icon.AgentType.ThousandEyes";

// Icon/AgentType/ThousandEyesThemable.tsx
var import_uik125 = require("@appd/uik");
var import_jsx_runtime115 = require("react/jsx-runtime");
var ThousandEyesThemable = import_uik125.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime115.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.AgentType.ThousandEyesThemable",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime115.jsx)(
        "path",
        {
          d: "M12.75 14.362a11.677 11.677 0 0 0 3.674-2.914 12.086 12.086 0 0 0-3.825-2.812c2.775-.607 5.192 2.113 5.192 2.113l.65.709-.64.717c-2.534 2.708-5.051 2.187-5.051 2.187Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime115.jsx)(
        "path",
        {
          d: "M12.963 11.496a1.291 1.291 0 0 1-1.3 1.28 1.291 1.291 0 0 1-1.296-1.284 1.29 1.29 0 0 1 1.298-1.283c.345 0 .675.136.919.377.244.242.38.57.38.91Z",
          fill: "#fff",
          fillOpacity: ".64"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime115.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M5.292 11.913c.134.212 3.35 5.17 8.16 5.17 2.838 0 5.555-1.722 8.072-5.118l.393-.53-.399-.526c-2.518-3.318-5.231-5-8.066-5-4.803 0-8.019 4.846-8.153 5.052l-.311.474.304.478Zm8.16 3.402c-3.049 0-5.449-2.737-6.312-3.867.867-1.11 3.266-3.772 6.312-3.772 2.102 0 4.197 1.268 6.23 3.772-2.035 2.566-4.129 3.867-6.23 3.867Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime115.jsx)(
        "path",
        {
          d: "M9.79 17.079c-4.69-.145-7.716-4.996-7.848-5.204l-.249-.481.29-.47c.133-.203 3.104-4.845 7.767-5.01-3.62 1.648-6.14 5.57-6.14 5.57a16.75 16.75 0 0 0 6.18 5.595Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
ThousandEyesThemable.displayName = "Icon.AgentType.ThousandEyesThemable";

// Icon/Apps/Apps.ts
var Apps_exports = {};
__export(Apps_exports, {
  AIOperations: () => AIOperations,
  ApplicationResourceOptimizer: () => ApplicationResourceOptimizer,
  BrowserRealUserMonitoring: () => BrowserRealUserMonitoring,
  CiscoCloudObservability: () => CiscoCloudObservability,
  DigitalExperienceMonitoring: () => DigitalExperienceMonitoring,
  MobileRealUserMonitoring: () => MobileRealUserMonitoring,
  SecureApplication: () => SecureApplication,
  Smartlook: () => Smartlook
});

// Icon/Apps/AIOperations.tsx
var import_uik126 = require("@appd/uik");
var import_jsx_runtime116 = require("react/jsx-runtime");
var AIOperations = import_uik126.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime116.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Apps.AIOperations",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime116.jsx)("rect", { fill: "#5EB035", height: "24", rx: "4", width: "24" }),
      /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(
        "path",
        {
          d: "M12.0215 9.10059H12.0137C11.2412 9.10059 10.5156 9.3999 9.96876 9.94434C9.41895 10.4907 9.11524 11.2183 9.11329 11.9932C9.11134 12.7681 9.41212 13.4971 9.95802 14.0459C10.5039 14.5947 11.2315 14.8984 12.0068 14.9004H12.0137C12.7852 14.9004 13.5117 14.6006 14.0586 14.0562C14.6084 13.5098 14.9121 12.7822 14.9141 12.0078C14.916 11.2329 14.6152 10.5039 14.0693 9.95508C13.5234 9.40625 12.7959 9.10254 12.0215 9.10059ZM13.1426 13.1343C12.8399 13.4351 12.4395 13.6001 12.0137 13.6001H12.0098C11.582 13.5991 11.1807 13.4321 10.8799 13.1289C10.5781 12.8262 10.4121 12.4238 10.4141 11.9966C10.415 11.5688 10.582 11.1675 10.8848 10.8662C11.1875 10.5654 11.5879 10.4004 12.0137 10.4004H12.0176C12.4453 10.4014 12.8467 10.5688 13.1475 10.8721C13.4492 11.1753 13.6152 11.5771 13.6133 12.0044C13.6123 12.4316 13.4453 12.833 13.1426 13.1343Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(
        "path",
        {
          d: "M20.207 13.2251H18.9004V10.7749H20.207C20.5211 10.7749 20.7754 10.4839 20.7754 10.125C20.7754 9.76611 20.5211 9.4751 20.207 9.4751H18.9004V6.375C18.9004 5.67188 18.3281 5.1001 17.625 5.1001H14.5254V3.79315C14.5254 3.47943 14.2344 3.2251 13.875 3.2251C13.5156 3.2251 13.2246 3.47943 13.2246 3.79315V5.1001H10.7754V3.79315C10.7754 3.47943 10.4844 3.2251 10.125 3.2251C9.76562 3.2251 9.47461 3.47943 9.47461 3.79315V5.1001H6.375C5.67188 5.1001 5.09961 5.67188 5.09961 6.375V9.4751H3.79303C3.47894 9.4751 3.22461 9.76611 3.22461 10.125C3.22461 10.4839 3.47894 10.7749 3.79303 10.7749H5.09961V13.2251H3.79303C3.47894 13.2251 3.22461 13.5161 3.22461 13.875C3.22461 14.2339 3.47894 14.5249 3.79303 14.5249H5.09961V17.625C5.09961 18.3281 5.67188 18.8999 6.375 18.8999H9.47461V20.2068C9.47461 20.5205 9.76562 20.7749 10.125 20.7749C10.4844 20.7749 10.7754 20.5205 10.7754 20.2068V18.8999H13.2246V20.2068C13.2246 20.5205 13.5156 20.7749 13.875 20.7749C14.2344 20.7749 14.5254 20.5205 14.5254 20.2068V18.8999H17.625C18.3281 18.8999 18.9004 18.3281 18.9004 17.625V14.5249H20.207C20.5211 14.5249 20.7754 14.2339 20.7754 13.875C20.7754 13.5161 20.5211 13.2251 20.207 13.2251ZM6.40039 17.625V6.3999L17.5996 6.375L17.625 17.6001L6.40039 17.625Z",
          fill: "white"
        }
      )
    ]
  }
));
AIOperations.displayName = "Icon.Apps.AIOperations";

// Icon/Apps/ApplicationResourceOptimizer.tsx
var import_uik127 = require("@appd/uik");
var import_jsx_runtime117 = require("react/jsx-runtime");
var ApplicationResourceOptimizer = import_uik127.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime117.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Apps.ApplicationResourceOptimizer",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime117.jsx)("rect", { fill: "#9B5FF5", height: "24", rx: "4", width: "24" }),
      /* @__PURE__ */ (0, import_jsx_runtime117.jsx)(
        "path",
        {
          d: "M21.743 14.9624L21.6854 14.6704L20.2899 13.8755L20.285 12.2954L20.0546 12.1016C19.5546 11.6797 18.9862 11.3604 18.3671 11.1519L18.0946 11.0601L16.6893 11.8457L15.2841 11.0601L15.0106 11.1523C14.3905 11.3623 13.8221 11.6831 13.3231 12.1064L13.0956 12.2998L13.0878 13.8794L11.6927 14.6714L11.6351 14.9634C11.5096 15.5991 11.5096 16.2437 11.6351 16.8794L11.6927 17.1714L13.0887 17.9663L13.0936 19.5464L13.3241 19.7407C13.8241 20.1616 14.3915 20.481 15.0116 20.6899L15.2841 20.7817L16.6913 19.9966L18.0946 20.7817L18.368 20.6899C18.9872 20.48 19.5546 20.1587 20.0546 19.7358L20.2831 19.5425L20.2899 17.9624L21.6854 17.1704L21.743 16.8784C21.868 16.2417 21.868 15.5972 21.743 14.9624ZM20.5126 16.3413L19.246 17.0601L18.9921 17.4976L18.9862 18.9233C18.746 19.0981 18.4872 19.2437 18.2137 19.3589L16.9481 18.6499H16.4364L15.1649 19.3599C14.8915 19.2446 14.6327 19.1001 14.3925 18.9263L14.3876 17.4946L14.1327 17.0649L12.8661 16.3433C12.8329 16.063 12.8329 15.7808 12.8656 15.5005L14.1268 14.7837L14.3856 14.3403L14.3925 12.9185C14.6327 12.7437 14.8915 12.5981 15.1649 12.4829L16.4335 13.1919H16.9452L18.2137 12.4824C18.4872 12.5972 18.746 12.7417 18.9862 12.916L18.9911 14.3472L19.246 14.7769L20.5126 15.4985C20.5448 15.7788 20.5448 16.061 20.5126 16.3413Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime117.jsx)(
        "path",
        {
          d: "M16.6895 14.0854C15.6771 14.0854 14.8535 14.9091 14.8535 15.9214C14.8535 16.9338 15.6771 17.7574 16.6895 17.7574C17.7019 17.7574 18.5255 16.9338 18.5255 15.9214C18.5255 14.9091 17.7019 14.0854 16.6895 14.0854ZM16.6895 16.6403C16.2928 16.6403 15.9707 16.3182 15.9707 15.9214C15.9707 15.5247 16.2928 15.2026 16.6895 15.2026C17.0862 15.2026 17.4083 15.5247 17.4083 15.9214C17.4083 16.3182 17.0862 16.6403 16.6895 16.6403Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime117.jsx)(
        "path",
        {
          d: "M10.4248 18.4233L4.56738 18.3481L4.5874 5.20557L19.3501 5.28125V9.22021C19.3501 9.5791 19.6411 9.87012 20.0005 9.87012C20.3599 9.87012 20.6509 9.5791 20.6509 9.22021V5.28125C20.6509 4.52295 20.0581 3.90576 19.3306 3.90576H4.5874C3.85938 3.90576 3.26758 4.52295 3.26758 5.28125V18.3481C3.26758 19.1069 3.85938 19.7241 4.5874 19.7241H10.4248C10.7837 19.7241 11.0747 19.4331 11.0747 19.0737C11.0747 18.7144 10.7837 18.4233 10.4248 18.4233Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime117.jsx)(
        "path",
        {
          d: "M6.29297 8.28802C6.29297 9.03772 6.9007 9.64545 7.65039 9.64545C8.40002 9.64545 9.00775 9.03772 9.00775 8.28802C9.00775 7.53839 8.40002 6.93066 7.65039 6.93066C6.9007 6.93066 6.29297 7.53839 6.29297 8.28802Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime117.jsx)(
        "path",
        {
          d: "M10.3652 8.28802C10.3652 9.03772 10.973 9.64545 11.7226 9.64545C12.4723 9.64545 13.08 9.03772 13.08 8.28802C13.08 7.53839 12.4723 6.93066 11.7226 6.93066C10.973 6.93066 10.3652 7.53839 10.3652 8.28802Z",
          fill: "white"
        }
      )
    ]
  }
));
ApplicationResourceOptimizer.displayName = "Icon.Apps.ApplicationResourceOptimizer";

// Icon/Apps/BrowserRealUserMonitoring.tsx
var import_uik128 = require("@appd/uik");
var import_jsx_runtime118 = require("react/jsx-runtime");
var BrowserRealUserMonitoring = import_uik128.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime118.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Apps.BrowserRealUserMonitoring",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime118.jsx)("rect", { fill: "#04A4B0", height: "24", rx: "4", width: "24" }),
      /* @__PURE__ */ (0, import_jsx_runtime118.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M5.85469 8.93774V6.78364H18.3717V8.93774H5.85469ZM4.55469 9.58774V6.70935C4.55469 6.03241 5.10346 5.48364 5.7804 5.48364H18.446C19.1229 5.48364 19.6717 6.03241 19.6717 6.70935V9.58774V12.026C19.6717 12.385 19.3807 12.676 19.0217 12.676C18.6627 12.676 18.3717 12.385 18.3717 12.026V10.2377H5.85469V16.9978H12.0424C12.4014 16.9978 12.6924 17.2888 12.6924 17.6478C12.6924 18.0068 12.4014 18.2978 12.0424 18.2978H5.7804C5.10346 18.2978 4.55469 17.7491 4.55469 17.0721V9.58774ZM16.3288 14.4248C15.5492 14.4248 14.9172 15.0567 14.9172 15.8363C14.9172 16.616 15.5492 17.2479 16.3288 17.2479C17.1084 17.2479 17.7404 16.616 17.7404 15.8363C17.7404 15.0567 17.1084 14.4248 16.3288 14.4248ZM13.6172 15.8363C13.6172 14.3388 14.8312 13.1248 16.3288 13.1248C17.8264 13.1248 19.0404 14.3388 19.0404 15.8363C19.0404 16.3495 18.8978 16.8294 18.6502 17.2385L19.8808 18.4691C20.1346 18.723 20.1346 19.1345 19.8808 19.3884C19.627 19.6422 19.2154 19.6422 18.9616 19.3884L17.7309 18.1577C17.3218 18.4054 16.8419 18.5479 16.3288 18.5479C14.8312 18.5479 13.6172 17.3339 13.6172 15.8363Z",
          fill: "white",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
BrowserRealUserMonitoring.displayName = "Icon.Apps.BrowserRealUserMonitoring";

// Icon/Apps/CiscoCloudObservability.tsx
var import_uik129 = require("@appd/uik");
var import_jsx_runtime119 = require("react/jsx-runtime");
var CiscoCloudObservability = import_uik129.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime119.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Apps.CiscoCloudObservability",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime119.jsx)("rect", { fill: "#6977F0", height: "24", rx: "4", width: "24" }),
      /* @__PURE__ */ (0, import_jsx_runtime119.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M9.27656 11.0001C9.27656 8.25248 11.5039 6.0251 14.2516 6.0251C16.9992 6.0251 19.2266 8.25248 19.2266 11.0001C19.2266 12.0765 18.8774 13.1239 18.2316 13.9851C18.0162 14.2723 18.0744 14.6797 18.3616 14.8951C18.6488 15.1105 19.0562 15.0523 19.2716 14.7651C20.0862 13.6789 20.5266 12.3578 20.5266 11.0001C20.5266 7.53451 17.7171 4.7251 14.2516 4.7251C11.8165 4.7251 9.70543 6.11209 8.66522 8.13915C8.46926 8.11341 8.27166 8.10035 8.07363 8.1001C5.54003 8.09698 3.4836 10.1483 3.48047 12.6819C3.47735 15.2155 5.52951 17.272 8.06311 17.2751H9.75061C10.1096 17.2751 10.4006 16.9841 10.4006 16.6251C10.4006 16.2661 10.1096 15.9751 9.75061 15.9751H8.06354C6.24808 15.9727 4.77823 14.4991 4.78047 12.6835C4.78271 10.8679 6.25639 9.39786 8.07203 9.4001C8.10866 9.40015 8.14528 9.4008 8.18186 9.40207C8.0479 9.91228 7.97656 10.4479 7.97656 11.0001C7.97656 11.3591 8.26758 11.6501 8.62656 11.6501C8.98555 11.6501 9.27656 11.3591 9.27656 11.0001ZM14.3073 14.3989C13.5277 14.3989 12.8957 15.0309 12.8957 15.8105C12.8957 16.5901 13.5277 17.2221 14.3073 17.2221C15.0869 17.2221 15.7189 16.5901 15.7189 15.8105C15.7189 15.0309 15.0869 14.3989 14.3073 14.3989ZM11.5957 15.8105C11.5957 14.3129 12.8097 13.0989 14.3073 13.0989C15.8049 13.0989 17.0189 14.3129 17.0189 15.8105C17.0189 16.3236 16.8763 16.8035 16.6287 17.2126L17.8593 18.4432C18.1132 18.6971 18.1132 19.1086 17.8593 19.3625C17.6055 19.6163 17.1939 19.6163 16.9401 19.3625L15.7095 18.1319C15.3003 18.3795 14.8205 18.5221 14.3073 18.5221C12.8097 18.5221 11.5957 17.308 11.5957 15.8105Z",
          fill: "white",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
CiscoCloudObservability.displayName = "Icon.Apps.CiscoCloudObservability";

// Icon/Apps/DigitalExperienceMonitoring.tsx
var import_uik130 = require("@appd/uik");
var import_jsx_runtime120 = require("react/jsx-runtime");
var DigitalExperienceMonitoring = import_uik130.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime120.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Apps.DigitalExperienceMonitoring",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime120.jsx)("rect", { fill: "#04A4B0", height: "24", rx: "4", width: "24" }),
      /* @__PURE__ */ (0, import_jsx_runtime120.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M4.64961 6.30902C4.64961 5.93162 4.95555 5.62568 5.33294 5.62568H18.6663C19.0437 5.62568 19.3496 5.93162 19.3496 6.30902V15.6424C19.3496 16.0197 19.0437 16.3257 18.6663 16.3257H5.33294C4.95555 16.3257 4.64961 16.0197 4.64961 15.6424V6.30902ZM5.33294 4.32568C4.23758 4.32568 3.34961 5.21365 3.34961 6.30902V15.6424C3.34961 16.7377 4.23758 17.6257 5.33294 17.6257H18.6663C19.7616 17.6257 20.6496 16.7377 20.6496 15.6424V6.30902C20.6496 5.21365 19.7616 4.32568 18.6663 4.32568H5.33294ZM9.19688 19.248C8.83789 19.248 8.54688 19.5391 8.54688 19.898C8.54688 20.257 8.83789 20.548 9.19688 20.548H14.5302C14.8892 20.548 15.1802 20.257 15.1802 19.898C15.1802 19.5391 14.8892 19.248 14.5302 19.248H9.19688ZM12.0016 8.58223C11.1913 8.58223 10.5344 9.23915 10.5344 10.0495C10.5344 10.8533 11.1808 11.5062 11.9821 11.5166C11.9887 11.5166 11.9952 11.5166 12.0018 11.5166C12.0083 11.5166 12.0148 11.5166 12.0212 11.5166C12.8226 11.5062 13.4689 10.8533 13.4689 10.0495C13.4689 9.23915 12.812 8.58223 12.0016 8.58223ZM13.9711 11.9935C14.4644 11.4938 14.7689 10.8072 14.7689 10.0495C14.7689 8.52118 13.53 7.28223 12.0016 7.28223C10.4733 7.28223 9.23438 8.52118 9.23438 10.0495C9.23438 10.8073 9.53894 11.4939 10.0323 11.9936C9.29229 12.3778 8.68103 12.9718 8.26331 13.6936C8.0835 14.0043 8.1896 14.402 8.50031 14.5818C8.81101 14.7616 9.20866 14.6555 9.38847 14.3448C9.91781 13.4301 10.8658 12.8248 11.9792 12.8167C11.9867 12.8167 11.9942 12.8168 12.0016 12.8168C12.0092 12.8168 12.0167 12.8167 12.0242 12.8167C13.1377 12.8247 14.0858 13.4301 14.6151 14.3448C14.7949 14.6555 15.1926 14.7616 15.5033 14.5818C15.814 14.402 15.9201 14.0043 15.7403 13.6936C15.3225 12.9718 14.7112 12.3777 13.9711 11.9935Z",
          fill: "white",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
DigitalExperienceMonitoring.displayName = "Icon.Apps.DigitalExperienceMonitoring";

// Icon/Apps/MobileRealUserMonitoring.tsx
var import_uik131 = require("@appd/uik");
var import_jsx_runtime121 = require("react/jsx-runtime");
var MobileRealUserMonitoring = import_uik131.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime121.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Apps.MobileRealUserMonitoring",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime121.jsx)("rect", { fill: "#04A4B0", height: "24", rx: "4", width: "24" }),
      /* @__PURE__ */ (0, import_jsx_runtime121.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M8.54543 4.1501C8.30113 4.1501 8.00312 4.38674 8.00312 4.80779V19.1924C8.00312 19.6135 8.30113 19.8501 8.54543 19.8501H15.6993C16.0583 19.8501 16.3493 20.1411 16.3493 20.5001C16.3493 20.8591 16.0583 21.1501 15.6993 21.1501H8.54543C7.47275 21.1501 6.70312 20.2158 6.70312 19.1924V4.80779C6.70312 3.7844 7.47275 2.8501 8.54543 2.8501H15.6993C16.772 2.8501 17.5416 3.7844 17.5416 4.80779V11.5192C17.5416 11.8782 17.2506 12.1692 16.8916 12.1692C16.5326 12.1692 16.2416 11.8782 16.2416 11.5192V4.80779C16.2416 4.38674 15.9436 4.1501 15.6993 4.1501H8.54543ZM14.0188 15.8107C14.0188 15.0311 14.6507 14.3991 15.4303 14.3991C16.2099 14.3991 16.8419 15.0311 16.8419 15.8107C16.8419 16.5903 16.2099 17.2223 15.4303 17.2223C14.6507 17.2223 14.0188 16.5903 14.0188 15.8107ZM15.4303 13.0991C13.9328 13.0991 12.7188 14.3131 12.7188 15.8107C12.7188 17.3083 13.9328 18.5223 15.4303 18.5223C15.9435 18.5223 16.4234 18.3798 16.8325 18.1321L18.0631 19.3627C18.317 19.6166 18.7285 19.6166 18.9824 19.3627C19.2362 19.1089 19.2362 18.6973 18.9824 18.4435L17.7517 17.2129C17.9994 16.8037 18.1419 16.3239 18.1419 15.8107C18.1419 14.3131 16.9279 13.0991 15.4303 13.0991ZM10.4293 5.61938C10.0703 5.61938 9.7793 5.9104 9.7793 6.26938C9.7793 6.62837 10.0703 6.91938 10.4293 6.91938H13.8139C14.1729 6.91938 14.4639 6.62837 14.4639 6.26938C14.4639 5.9104 14.1729 5.61938 13.8139 5.61938H10.4293Z",
          fill: "white",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
MobileRealUserMonitoring.displayName = "Icon.Apps.MobileRealUserMonitoring";

// Icon/Apps/SecureApplication.tsx
var import_uik132 = require("@appd/uik");
var import_jsx_runtime122 = require("react/jsx-runtime");
var SecureApplication = import_uik132.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime122.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Apps.SecureApplication",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime122.jsx)("rect", { fill: "#C2306F", height: "24", rx: "4", width: "24" }),
      /* @__PURE__ */ (0, import_jsx_runtime122.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M5.78242 10.2521V5.68965H18.2178V10.2505C18.2178 11.7977 17.8909 13.07 17.3939 14.1153C15.903 17.2504 12.8105 18.4732 12.0001 18.7446C10.8992 18.3777 5.78242 16.3376 5.78242 10.2521ZM5.75676 4.38965C5.05296 4.38965 4.48242 4.96019 4.48242 5.66398V10.2521C4.48242 17.2805 10.4456 19.5988 11.6005 19.9818C11.8597 20.0701 12.1409 20.0701 12.4001 19.9816C13.2811 19.6884 16.8343 18.3193 18.5679 14.6735C19.149 13.4514 19.5178 11.9881 19.5178 10.2505V5.66398C19.5178 4.96019 18.9473 4.38965 18.2435 4.38965H5.75676ZM15.5815 9.86963C15.8353 9.61579 15.8353 9.20423 15.5815 8.95039C15.3276 8.69655 14.9161 8.69655 14.6622 8.95039L10.7515 12.8611L9.33813 11.4477C9.08429 11.1939 8.67274 11.1939 8.4189 11.4477C8.16506 11.7016 8.16506 12.1131 8.4189 12.367L10.2919 14.24C10.5457 14.4938 10.9573 14.4938 11.2111 14.24L15.5815 9.86963Z",
          fill: "white",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
SecureApplication.displayName = "Icon.Apps.SecureApplication";

// Icon/Apps/Smartlook.tsx
var import_uik133 = require("@appd/uik");
var import_jsx_runtime123 = require("react/jsx-runtime");
var Smartlook = import_uik133.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime123.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Apps.Smartlook",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime123.jsx)("rect", { fill: "#3E84E5", height: "24", rx: "4", width: "24" }),
      /* @__PURE__ */ (0, import_jsx_runtime123.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M6.91309 6.60787C9.86133 3.66305 14.5352 3.59566 17.5615 6.45064C19.0459 7.85104 19.8955 9.74557 19.9541 11.7851C20.0137 13.8252 19.2744 15.7656 17.874 17.25C16.4736 18.7338 14.5801 19.5839 12.54 19.643C12.4639 19.6455 12.3887 19.6464 12.3125 19.6464C10.3564 19.6464 8.50391 18.9116 7.0752 17.5629C6.81445 17.3169 6.80273 16.9052 7.04883 16.644C7.2959 16.3833 7.70605 16.3711 7.96777 16.6176C9.19922 17.7793 10.8193 18.3906 12.502 18.3437C14.1953 18.2944 15.7666 17.5893 16.9287 16.3579C18.0908 15.1259 18.7041 13.5156 18.6553 11.8232C18.6064 10.1303 17.9004 8.55807 16.6689 7.39596C14.1582 5.02633 10.2783 5.08199 7.83594 7.52389C7.19946 8.16872 6.64062 8.79281 6.08075 9.45113H7.87109C8.23047 9.45113 8.52148 9.74215 8.52148 10.101C8.52148 10.4599 8.23047 10.7509 7.87109 10.7509H4.69336C4.67586 10.7509 4.65986 10.7464 4.64381 10.7419C4.63247 10.7388 4.62111 10.7356 4.60919 10.734L4.60403 10.7333C4.56076 10.7276 4.51891 10.7221 4.47705 10.7073C4.43567 10.6925 4.4002 10.6706 4.36346 10.648L4.35956 10.6456C4.34918 10.6393 4.33825 10.6345 4.32735 10.6298C4.31171 10.623 4.29611 10.6162 4.28223 10.6049C4.27754 10.6011 4.27433 10.5964 4.27111 10.5916C4.2682 10.5873 4.26529 10.583 4.26129 10.5794C4.23084 10.5519 4.2077 10.5196 4.18392 10.4864C4.18092 10.4823 4.17791 10.478 4.17487 10.4738C4.16897 10.4656 4.1629 10.4575 4.15687 10.4495C4.13978 10.4268 4.12294 10.4044 4.1109 10.3789C4.09704 10.3501 4.08956 10.3192 4.08195 10.2878C4.07978 10.2789 4.0776 10.2699 4.07526 10.2609C4.07361 10.2545 4.07194 10.2481 4.07027 10.2418C4.06091 10.2063 4.05177 10.1717 4.0498 10.1348C4.04951 10.1292 4.04796 10.124 4.0464 10.1188C4.04468 10.113 4.04297 10.1073 4.04297 10.101V6.92379C4.04297 6.5649 4.33398 6.27389 4.69336 6.27389C5.05273 6.27389 5.34375 6.5649 5.34375 6.92379V8.31344C5.84015 7.73971 6.34528 7.18343 6.91309 6.60787ZM12.04 15.0541C11.8965 15.1425 11.7324 15.1869 11.5693 15.1869C11.418 15.1869 11.2666 15.1488 11.1299 15.0727C10.8379 14.9096 10.6562 14.5976 10.6562 14.2587V9.99161C10.6562 9.65323 10.8379 9.34171 11.1289 9.17814C11.4121 9.02091 11.7617 9.02677 12.0391 9.19571L15.5156 11.33C15.792 11.4994 15.957 11.7963 15.957 12.1244C15.957 12.453 15.792 12.7504 15.5156 12.9203L12.04 15.0541ZM14.3262 12.1254L11.957 10.6708V13.58L14.3262 12.1254Z",
          fill: "white",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
Smartlook.displayName = "Icon.Apps.Smartlook";

// Icon/Browser/Browser.ts
var Browser_exports = {};
__export(Browser_exports, {
  Chrome: () => Chrome,
  Firefox: () => Firefox,
  Ie: () => Ie,
  Netscape: () => Netscape,
  Other: () => Other,
  Safari: () => Safari
});

// Icon/Browser/Chrome.tsx
var import_uik134 = require("@appd/uik");
var import_jsx_runtime124 = require("react/jsx-runtime");
var Chrome = import_uik134.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime124.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Browser.Chrome",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(
        "path",
        {
          d: "M12 17.118a4.957 4.957 0 0 1-2.774-.82 5.2 5.2 0 0 1-1.875-2.11L3.251 7C2.39 8.537 2 10.256 2 12c0 2.5.812 4.681 2.44 6.544 1.627 1.862 3.653 2.974 6.075 3.34l2.9-5.02c-.292.086-.779.254-1.416.254Z",
          fill: "#20A264"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(
        "path",
        {
          d: "M8.856 7.957C9.78 7.241 10.829 7 12 7h8.593c-.885-1.51-2.09-2.786-3.613-3.672A9.744 9.744 0 0 0 12 2c-1.563 0-3.022.332-4.375.997C6.27 3.66 5.018 4.627 4.1 5.868L7 10.75a5.107 5.107 0 0 1 1.856-2.793Z",
          fill: "#DC5148"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(
        "path",
        {
          d: "M21.248 8.25h-5.81c1.015 1.016 1.68 2.318 1.68 3.75a5.118 5.118 0 0 1-.899 2.93L12.117 22c2.735-.026 5.065-1.016 6.993-2.969C21.036 17.078 22 14.734 22 12c0-1.275-.215-2.617-.752-3.75Z",
          fill: "#FFCE55"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime124.jsx)("path", { d: "M12 15.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z", fill: "#4D86F7" }),
      /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(
        "path",
        {
          d: "M12 17.118a4.957 4.957 0 0 1-2.774-.82 5.2 5.2 0 0 1-1.875-2.11L3.251 7C2.39 8.537 2 10.256 2 12c0 2.5.812 4.681 2.44 6.544 1.627 1.862 3.653 2.974 6.075 3.34l2.9-5.02c-.292.086-.779.254-1.416.254Z",
          fill: "#20A264"
        }
      )
    ]
  }
));
Chrome.displayName = "Icon.Browser.Chrome";

// Icon/Browser/Firefox.tsx
var import_uik135 = require("@appd/uik");
var import_jsx_runtime125 = require("react/jsx-runtime");
var Firefox = import_uik135.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime125.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Browser.Firefox",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime125.jsx)(
        "path",
        {
          d: "M18.322 2.355c-.523.61-.767 1.98-.237 3.37.53 1.388 1.343 1.087 1.85 2.503.669 1.87.357 4.38.357 4.38s.804 2.329 1.365-.144c1.24-4.645-3.335-8.965-3.335-10.109Z",
          fill: "url(#icon-browser-firefox__a)"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime125.jsx)(
        "path",
        {
          d: "M11.94 21.639c5.356 0 9.694-4.362 9.694-9.74 0-5.379-4.338-9.74-9.689-9.74-5.35 0-9.688 4.361-9.688 9.74-.01 5.383 4.333 9.74 9.683 9.74Z",
          fill: "url(#icon-browser-firefox__b)"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime125.jsx)(
        "path",
        {
          d: "M19.203 17.906a5.41 5.41 0 0 1-.657.397c.302-.444.582-.902.836-1.375a5.41 5.41 0 0 0 .55-.691c.075-.118.16-.264.25-.433.544-.98 1.144-2.567 1.16-4.197v-.004l.001-.12a5.629 5.629 0 0 0-.125-1.218c.005.031.009.062.012.094-.004-.024-.008-.049-.014-.073l.022.13c.111.945.032 1.865-.364 2.544l-.02.029c.206-1.032.275-2.17.046-3.31 0 0-.091-.555-.772-2.238-.393-.969-1.089-1.763-1.704-2.341-.539-.667-1.029-1.115-1.299-1.4-.564-.593-.8-1.038-.897-1.328-.084-.043-1.16-1.088-1.246-1.128-.47.728-1.947 3.007-1.244 5.135.318.965 1.124 1.966 1.967 2.528.037.042.501.547.722 1.685.228 1.175.108 2.093-.361 3.45-.552 1.19-1.967 2.367-3.292 2.487-2.831.257-3.868-1.422-3.868-1.422 1.012.405 2.13.32 2.81-.1.687-.423 1.101-.738 1.438-.614.332.123.596-.235.36-.606a1.714 1.714 0 0 0-1.735-.755c-.686.111-1.315.655-2.214.128a1.865 1.865 0 0 1-.17-.11c-.059-.04.194.06.135.015a4.399 4.399 0 0 1-.565-.376c-.014-.012.135.047.122.035-.841-.692-.736-1.16-.71-1.454.022-.234.174-.535.432-.657.124.068.202.12.202.12l-.082-.166c.01-.004.02-.003.03-.007.101.049.327.176.445.254.155.11.204.206.204.206s.04-.022.01-.117a.61.61 0 0 0-.21-.288l.01.001c.09.053.178.113.258.18.043-.156.121-.32.104-.613-.01-.206-.006-.26-.042-.339-.032-.068.018-.095.075-.024a.717.717 0 0 0-.048-.162v-.005c.07-.245 1.49-.883 1.594-.958.17-.12.312-.275.418-.454.079-.126.138-.303.152-.57.008-.194-.082-.322-1.518-.473-.392-.038-.623-.323-.753-.585a3.83 3.83 0 0 0-.073-.16 1.266 1.266 0 0 1-.056-.183 3.446 3.446 0 0 1 1.21-1.675c.03-.03-.127.007-.096-.022.037-.033.278-.13.323-.152.056-.026-.237-.15-.496-.12-.264.03-.32.06-.46.12.058-.058.244-.134.2-.134-.284.044-.637.21-.939.396 0-.032.006-.065.018-.095-.14.06-.486.301-.586.506a.97.97 0 0 0 .006-.118 1.87 1.87 0 0 0-.289.301l-.005.005c-.816-.328-1.534-.35-2.141-.202-.133-.134-.198-.036-.5-.7-.02-.04.015.039 0 0-.05-.13.03.171 0 0-.509.4-1.178.855-1.499 1.176-.004.013.375-.107 0 0-.131.038-.122.116-.142.82-.005.052 0 .112-.005.16-.257.327-.431.604-.497.747-.332.572-.698 1.463-1.052 2.873a7.3 7.3 0 0 1 .563-1.1c-.294.748-.58 1.923-.636 3.733.071-.374.163-.743.274-1.107-.07 1.502.19 3 .758 4.391a10.71 10.71 0 0 0 1.115 2.083 9.849 9.849 0 0 0 7.16 3.077 9.858 9.858 0 0 0 7.39-3.327Z",
          fill: "url(#icon-browser-firefox__c)"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime125.jsx)(
        "path",
        {
          d: "M17.029 19.283c3.557-.412 5.131-4.078 3.11-4.15-1.827-.058-4.795 4.344-3.11 4.15Z",
          fill: "url(#icon-browser-firefox__d)"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime125.jsx)(
        "path",
        {
          d: "M20.394 14.385c2.448-1.424 1.81-4.5 1.81-4.5s-.945 1.097-1.587 2.846c-.633 1.731-1.694 2.514-.223 1.654Z",
          fill: "url(#icon-browser-firefox__e)"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime125.jsx)(
        "path",
        {
          d: "M12.626 21.104c3.412 1.088 6.344-1.6 4.536-2.497-1.643-.81-6.155 1.982-4.536 2.497Z",
          fill: "url(#icon-browser-firefox__f)"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime125.jsx)(
        "path",
        {
          d: "M20.649 15.692c.083-.117.195-.492.294-.66.602-.972.607-1.748.607-1.765.363-1.818.33-2.56.107-3.932-.18-1.105-.968-2.688-1.65-3.45-.704-.786-.208-.53-.89-1.104-.596-.661-1.175-1.316-1.49-1.58C15.35 1.297 15.402.893 15.445.824l-.032.036a5.51 5.51 0 0 1-.046-.198s-1.245 1.245-1.507 3.32c-.17 1.354.336 2.766 1.07 3.668a8.33 8.33 0 0 0 1.289 1.267c.554.796.86 1.779.86 2.836a4.795 4.795 0 0 1-5.87 4.674c-1.25-.238-1.972-.869-2.332-1.297-.206-.245-.294-.424-.294-.424 1.12.401 2.358.317 3.112-.099.758-.42 1.218-.732 1.59-.61.367.123.66-.232.398-.6-.257-.369-.926-.895-1.92-.75-.76.111-1.455.65-2.45.128a2.106 2.106 0 0 1-.187-.11c-.066-.038.213.06.148.016a4.937 4.937 0 0 1-.626-.373c-.014-.012.15.047.136.035-.931-.687-.815-1.151-.786-1.442a.835.835 0 0 1 .478-.652c.137.067.223.118.223.118l-.09-.164c.01-.004.021-.003.032-.007.113.049.362.175.494.253.17.108.225.204.225.204s.045-.022.012-.116a.61.61 0 0 0-.233-.286l.01.001c.1.052.197.111.287.179.048-.156.134-.318.115-.609-.012-.204-.007-.257-.047-.336-.036-.067.02-.094.083-.023a.656.656 0 0 0-.053-.16v-.006c.078-.243 1.65-.876 1.764-.95.184-.116.342-.27.462-.45.088-.126.154-.3.17-.566.005-.12-.032-.215-.448-.305-.25-.055-.636-.107-1.232-.163-.435-.039-.69-.32-.835-.581a3.587 3.587 0 0 0-.08-.158 1.159 1.159 0 0 1-.062-.183 3.46 3.46 0 0 1 1.338-1.66c.035-.03-.14.007-.105-.022.041-.033.307-.13.358-.151.061-.026-.263-.15-.55-.12-.291.03-.353.061-.51.12.066-.057.271-.133.223-.132-.315.043-.706.207-1.04.392 0-.032.007-.064.02-.094-.155.06-.537.299-.649.501a.862.862 0 0 0 .007-.117 1.937 1.937 0 0 0-.32.3l-.005.004c-.903-.326-1.698-.347-2.37-.2-.147-.133-.384-.333-.718-.992-.023-.04-.035.082-.053.043-.13-.302-.208-.796-.195-1.137 0 0-.27.123-.492.635-.041.092-.068.143-.094.193-.013.015.027-.168.02-.158-.038.066-.138.157-.182.276-.03.088-.073.137-.1.246l-.006.01c-.002-.032.008-.132 0-.112a5.284 5.284 0 0 0-.268.652c-.12.394-.26.93-.282 1.628-.005.053 0 .112-.005.16-.284.324-.477.599-.55.74-.368.568-.772 1.452-1.164 2.85a6.97 6.97 0 0 1 .623-1.092c-.326.743-.641 1.908-.704 3.703.08-.372.18-.738.303-1.098a9.294 9.294 0 0 0 .84 4.355c.449.984 1.483 2.984 4.01 4.544 0 0 .859.64 2.336 1.12.11.04.22.079.333.116a2.15 2.15 0 0 1-.103-.044c.984.294 2.005.444 3.031.445 3.826.003 4.954-1.533 4.954-1.533l-.011.008a2.88 2.88 0 0 0 .156-.158c-.604.57-1.981.608-2.496.566.878-.258 1.456-.476 2.58-.906a6.94 6.94 0 0 0 .404-.167l.045-.02.082-.039a7.627 7.627 0 0 0 1.534-.96c1.13-.902 1.375-1.781 1.503-2.36a3.255 3.255 0 0 1-.113.268c-.29.622-.935 1.004-1.636 1.331.334-.437.643-.892.926-1.363.229-.227.3-.582.47-.82Z",
          fill: "url(#icon-browser-firefox__g)"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime125.jsx)(
        "path",
        {
          d: "M19.274 17.847a7.23 7.23 0 0 0 1.187-1.746c.806-1.694 2.052-4.511 1.07-7.453-.775-2.326-1.84-3.597-3.191-4.84C16.143 1.792 15.53.892 15.53.356c0 0-2.535 2.827-1.435 5.774 1.1 2.948 3.351 2.84 4.84 5.915 1.754 3.62-1.418 7.57-4.04 8.675.16-.035 5.83-1.318 6.128-4.561-.007.06-.134.956-1.749 1.69Z",
          fill: "url(#icon-browser-firefox__h)"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime125.jsx)(
        "path",
        {
          d: "M11.93 7.33c.008-.192-.091-.32-1.675-.469-.652-.06-.901-.662-.977-.916-.232.602-.327 1.234-.276 1.998.035.5.371 1.038.532 1.353 0 0 .036-.046.052-.063.303-.316 1.571-.796 1.69-.864.132-.083.632-.448.654-1.04Z",
          fill: "url(#icon-browser-firefox__i)"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime125.jsx)(
        "path",
        {
          d: "M4.957 3.773c-.022-.04-.035.082-.052.043-.13-.302-.21-.79-.19-1.136 0 0-.27.122-.492.634a3.334 3.334 0 0 1-.095.194c-.012.015.028-.168.022-.158-.039.065-.139.157-.183.27-.036.093-.073.142-.1.257-.009.031.008-.138 0-.117-.517 1-.616 2.513-.561 2.45C4.408 5.031 5.67 4.752 5.67 4.752c-.134-.099-.426-.385-.714-.98Z",
          fill: "url(#icon-browser-firefox__j)"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime125.jsx)(
        "path",
        {
          d: "M9.14 16.08c-1.523-.65-3.254-1.567-3.188-3.65.089-2.743 2.558-2.2 2.558-2.2-.093.022-.343.2-.43.388-.094.237-.264.77.251 1.33.81.878-1.664 2.082 2.155 4.358.096.053-.895-.03-1.346-.226Z",
          fill: "url(#icon-browser-firefox__k)"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime125.jsx)(
        "path",
        {
          d: "M8.599 14.713c1.08.376 2.338.31 3.09-.106.505-.28 1.151-.73 1.55-.619a2.707 2.707 0 0 0-.92-.215c-.054 0-.118-.001-.176-.007-.115 0-.23.006-.344.019-.194.017-.41.14-.606.12-.01 0 .19-.082.174-.078-.104.021-.216.026-.336.04-.075.01-.14.019-.216.022-2.248.19-4.15-1.22-4.15-1.22-.16.546.725 1.623 1.934 2.044Z",
          fill: "url(#icon-browser-firefox__l)"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime125.jsx)(
        "path",
        {
          d: "M19.27 17.863c2.275-2.234 3.426-4.948 2.94-7.993 0 0 .194 1.561-.543 3.158.354-1.559.395-3.497-.546-5.503-1.255-2.678-3.32-4.087-4.108-4.675-1.195-.89-1.69-1.798-1.699-1.985-.357.731-1.436 3.237-.116 5.394 1.237 2.022 3.186 2.622 4.55 4.476 2.513 3.416-.478 7.128-.478 7.128Z",
          fill: "url(#icon-browser-firefox__m)"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime125.jsx)(
        "path",
        {
          d: "M18.945 12.05c-.795-1.641-1.788-2.358-2.726-3.134.11.153.136.207.196.306.826.88 2.045 3.028 1.16 5.724-1.664 5.074-8.323 2.685-9.021 2.013.282 2.937 5.198 4.343 8.399 2.438 1.82-1.724 3.294-4.655 1.992-7.346Z",
          fill: "url(#icon-browser-firefox__n)"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime125.jsxs)("defs", { children: [
        /* @__PURE__ */ (0, import_jsx_runtime125.jsxs)(
          "radialGradient",
          {
            cx: "0",
            cy: "0",
            gradientTransform: "matrix(9.84622 0 0 27.1334 21.333 5.732)",
            gradientUnits: "userSpaceOnUse",
            id: "icon-browser-firefox__a",
            r: "1",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".045", stopColor: "#FFEA00" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".12", stopColor: "#FFDE00" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".254", stopColor: "#FFBF00" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".429", stopColor: "#FF8E00" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".769", stopColor: "#FF272D" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".872", stopColor: "#E0255A" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".953", stopColor: "#CC2477" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: "1", stopColor: "#C42482" })
            ]
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime125.jsxs)(
          "radialGradient",
          {
            cx: "0",
            cy: "0",
            gradientTransform: "matrix(25.9171 0 0 26.0553 15.981 4.572)",
            gradientUnits: "userSpaceOnUse",
            id: "icon-browser-firefox__b",
            r: "1",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { stopColor: "#00CCDA" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".22", stopColor: "#0083FF" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".261", stopColor: "#007AF9" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".33", stopColor: "#0060E8" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".333", stopColor: "#005FE7" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".438", stopColor: "#2639AD" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".522", stopColor: "#401E84" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: "1", stopColor: "#4A1475" })
            ]
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime125.jsxs)(
          "radialGradient",
          {
            cx: "0",
            cy: "0",
            gradientTransform: "matrix(5.38137 0 0 4.96875 23.179 14.232)",
            gradientUnits: "userSpaceOnUse",
            id: "icon-browser-firefox__d",
            r: "1",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".003", stopColor: "#FFEA00" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".497", stopColor: "#FF272D" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: "1", stopColor: "#C42482" })
            ]
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime125.jsxs)(
          "radialGradient",
          {
            cx: "0",
            cy: "0",
            gradientTransform: "matrix(9.73273 0 0 17.9742 23.224 7.356)",
            gradientUnits: "userSpaceOnUse",
            id: "icon-browser-firefox__e",
            r: "1",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".003", stopColor: "#FFE900" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".157", stopColor: "#FFAF0E" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".316", stopColor: "#FF7A1B" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".472", stopColor: "#FF4E26" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".621", stopColor: "#FF2C2E" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".762", stopColor: "#FF1434" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".892", stopColor: "#FF0538" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: "1", stopColor: "#FF0039" })
            ]
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime125.jsxs)(
          "radialGradient",
          {
            cx: "0",
            cy: "0",
            gradientTransform: "matrix(4.76433 0 0 2.54163 23.792 18.523)",
            gradientUnits: "userSpaceOnUse",
            id: "icon-browser-firefox__f",
            r: "1",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".003", stopColor: "#FF272D" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".497", stopColor: "#C42482" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".986", stopColor: "#620700" })
            ]
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime125.jsxs)(
          "radialGradient",
          {
            cx: "0",
            cy: "0",
            gradientTransform: "matrix(19.53778 -.28086 .29272 20.3627 19.063 8.936)",
            gradientUnits: "userSpaceOnUse",
            id: "icon-browser-firefox__g",
            r: "1",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { stopColor: "#FFEA00" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".231", stopColor: "#FFDE00" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".365", stopColor: "#FFBF00" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".541", stopColor: "#FF8E00" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".763", stopColor: "#FF272D" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".796", stopColor: "#F92433" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".841", stopColor: "#E91C45" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".893", stopColor: "#CF0E62" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: "1", stopColor: "#B5007F" })
            ]
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime125.jsxs)(
          "radialGradient",
          {
            cx: "0",
            cy: "0",
            gradientTransform: "rotate(50.789 10.048 21.111) scale(12.9865 16.1813)",
            gradientUnits: "userSpaceOnUse",
            id: "icon-browser-firefox__h",
            r: "1",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { stopColor: "#FFEC00" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { stopColor: "#FFEA00" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".397", stopColor: "#FD0" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".63", stopColor: "#FFBA00" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".845", stopColor: "#FF9100" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".933", stopColor: "#FF6711" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: "1", stopColor: "#FF4A1D" })
            ]
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime125.jsxs)(
          "linearGradient",
          {
            gradientUnits: "userSpaceOnUse",
            id: "icon-browser-firefox__c",
            x1: "19.751",
            x2: "15.099",
            y1: "14.062",
            y2: ".548",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { stopColor: "#000F43", stopOpacity: ".4" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".485", stopColor: "#001962", stopOpacity: ".173" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: "1", stopColor: "#002079", stopOpacity: ".01" })
            ]
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime125.jsxs)(
          "linearGradient",
          {
            gradientUnits: "userSpaceOnUse",
            id: "icon-browser-firefox__i",
            x1: "5.923",
            x2: "13.718",
            y1: "12.527",
            y2: "11.625",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { stopColor: "#C42482", stopOpacity: ".5" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".474", stopColor: "#FF272D", stopOpacity: ".5" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".486", stopColor: "#FF2C2C", stopOpacity: ".513" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".675", stopColor: "#FF7A1A", stopOpacity: ".72" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".829", stopColor: "#FFB20D", stopOpacity: ".871" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".942", stopColor: "#FFD605", stopOpacity: ".964" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: "1", stopColor: "#FFE302" })
            ]
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime125.jsxs)(
          "linearGradient",
          {
            gradientUnits: "userSpaceOnUse",
            id: "icon-browser-firefox__j",
            x1: "5.7",
            x2: "4.05",
            y1: "5.378",
            y2: "2.692",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { stopColor: "#891551", stopOpacity: ".6" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: "1", stopColor: "#C42482", stopOpacity: ".01" })
            ]
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime125.jsxs)(
          "linearGradient",
          {
            gradientUnits: "userSpaceOnUse",
            id: "icon-browser-firefox__k",
            x1: "5.379",
            x2: "7.742",
            y1: "11.819",
            y2: "13.627",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".005", stopColor: "#891551", stopOpacity: ".5" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".484", stopColor: "#FF272D", stopOpacity: ".5" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: "1", stopColor: "#FF272D", stopOpacity: ".01" })
            ]
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime125.jsxs)(
          "linearGradient",
          {
            gradientUnits: "userSpaceOnUse",
            id: "icon-browser-firefox__l",
            x1: "12.116",
            x2: "12.136",
            y1: "15.051",
            y2: "13.424",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { stopColor: "#C42482" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".083", stopColor: "#C42482", stopOpacity: ".81" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".206", stopColor: "#C42482", stopOpacity: ".565" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".328", stopColor: "#C42482", stopOpacity: ".362" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".447", stopColor: "#C42482", stopOpacity: ".204" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".562", stopColor: "#C42482", stopOpacity: ".091" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".673", stopColor: "#C42482", stopOpacity: ".023" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".773", stopColor: "#C42482", stopOpacity: ".01" })
            ]
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime125.jsxs)(
          "linearGradient",
          {
            gradientUnits: "userSpaceOnUse",
            id: "icon-browser-firefox__m",
            x1: "11.644",
            x2: "22.843",
            y1: "8.456",
            y2: "13.675",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { stopColor: "#FFF14F" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".268", stopColor: "#FFEE4C" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".452", stopColor: "#FFE643" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".612", stopColor: "#FFD834" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".757", stopColor: "#FFC41E" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".892", stopColor: "#FFAB02" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".902", stopColor: "#FFA900" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".949", stopColor: "#FFA000" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: "1", stopColor: "#FF9100" })
            ]
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime125.jsxs)(
          "linearGradient",
          {
            gradientUnits: "userSpaceOnUse",
            id: "icon-browser-firefox__n",
            x1: "12.298",
            x2: "8.9",
            y1: "8.08",
            y2: "16.474",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { stopColor: "#FF8E00" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".04", stopColor: "#FF8E00", stopOpacity: ".858" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".084", stopColor: "#FF8E00", stopOpacity: ".729" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".13", stopColor: "#FF8E00", stopOpacity: ".628" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".178", stopColor: "#FF8E00", stopOpacity: ".557" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".227", stopColor: "#FF8E00", stopOpacity: ".514" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".282", stopColor: "#FF8E00", stopOpacity: ".5" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".389", stopColor: "#FF8E00", stopOpacity: ".478" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".524", stopColor: "#FF8E00", stopOpacity: ".416" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".676", stopColor: "#FF8E00", stopOpacity: ".314" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: ".838", stopColor: "#FF8E00", stopOpacity: ".172" }),
              /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("stop", { offset: "1", stopColor: "#FF8E00", stopOpacity: ".01" })
            ]
          }
        )
      ] })
    ]
  }
));
Firefox.displayName = "Icon.Browser.Firefox";

// Icon/Browser/Ie.tsx
var import_uik136 = require("@appd/uik");
var import_jsx_runtime126 = require("react/jsx-runtime");
var Ie = import_uik136.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime126.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Browser.Ie",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime126.jsx)(
      "path",
      {
        d: "M3.844 6.851c.654-1.213 1.52-2.249 2.626-3.07a8.708 8.708 0 0 1 4.336-1.71c.5-.054 1-.092 1.501-.059.407.027.816.051 1.217.12a9.14 9.14 0 0 1 3.011 1.046c1.473.835 2.617 1.994 3.41 3.491.75 1.421 1.093 2.945 1.11 4.546.007.788.001 1.575 0 2.363 0 .171.023.166-.165.166H8.573l-.129.002c-.053.001-.08.024-.077.08.006.08.013.161.017.241.026.616.224 1.175.56 1.688.402.615.962 1.045 1.608 1.371.853.432 1.766.64 2.714.7a8.226 8.226 0 0 0 1.584-.058 9.78 9.78 0 0 0 1.76-.416c.86-.285 1.672-.68 2.476-1.098.026-.013.091-.058.091-.058 0 .056.004.11.004.15 0 1.296-.002 2.592.003 3.888 0 .107-.035.158-.129.202-.95.448-1.936.794-2.958 1.035-.72.17-1.452.273-2.192.305-.22.01-.44.015-.66.025-.036.001-.335-.002-.382-.002a8.004 8.004 0 0 1-1.458-.14c-1.424-.269-2.708-.842-3.83-1.766a7.38 7.38 0 0 1-1.728-2.027 7.386 7.386 0 0 1-.98-4.225c.024-.38.065-.765.133-1.14a7.242 7.242 0 0 1 1.025-2.603A7.475 7.475 0 0 1 8.818 7.31c.256-.14.524-.26.787-.39.004.006.01.013.012.02a.46.46 0 0 1-.028.034 4.51 4.51 0 0 0-.914 1.508 7.311 7.311 0 0 0-.41 1.557l7.122-.018c-.015-.259-.026-.588-.046-.848a4.859 4.859 0 0 0-.283-1.348c-.276-.746-.766-1.302-1.489-1.643-.594-.279-1.227-.382-1.874-.406a7.726 7.726 0 0 0-.938.02c-.396.034-.795.076-1.184.157-1.332.275-2.562.8-3.696 1.55C4.76 8.24 3.785 9.13 3 10.22",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
Ie.displayName = "Icon.Browser.Ie";

// Icon/Browser/Netscape.tsx
var import_uik137 = require("@appd/uik");
var import_jsx_runtime127 = require("react/jsx-runtime");
var Netscape = import_uik137.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime127.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Browser.Netscape",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime127.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M2.986 15.539a9.858 9.858 0 0 1-.723-3.717c0-5.468 4.432-9.9 9.899-9.9 5.467 0 9.899 4.432 9.899 9.9a9.868 9.868 0 0 1-.79 3.88c-1.653-.794-3.21-1.38-5.164-1.705l.019-6.095s.022-.288.177-.443c.177-.177.399-.221.399-.221h.93V6.75h-3.721v.488h.93s.222.044.399.22c.156.156.177.444.177.444l.019 5.996c-.108-.015-.218-.027-.33-.04l-.077-.01L9.128 6.75H6.381v.488h.931l1.171 1.349-.015 5.469c-2.395.412-4.593 1.089-5.482 1.483Zm9.154-1.835c-.954 0-1.972.093-2.972.24l-.013-4.582 3.775 4.35a33.713 33.713 0 0 0-.79-.008Z",
          fill: "#17C2C2",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime127.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M12.095 14.634c-1.063.008-2.033.09-2.926.229l.003 1.056s.022.288.177.443a.87.87 0 0 0 .399.22h.931v.488H6.958v-.487h.931s.22-.045.397-.221c.155-.156.178-.443.178-.443l.003-.933a16.137 16.137 0 0 0-4.869 1.803 9.894 9.894 0 0 0 8.564 4.932 9.901 9.901 0 0 0 8.904-5.568c-.679-.316-3.597-1.52-8.729-1.52h-.242Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
Netscape.displayName = "Icon.Browser.Netscape";

// Icon/Browser/Other.tsx
var import_uik138 = require("@appd/uik");
var import_jsx_runtime128 = require("react/jsx-runtime");
var Other = import_uik138.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime128.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Browser.Other",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime128.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M10.305 21.86c-4.145-.68-7.486-4.023-8.166-8.167A10.011 10.011 0 0 1 13.693 2.14c4.144.68 7.487 4.022 8.167 8.167A10.012 10.012 0 0 1 10.305 21.86Zm3.373-13.808A27.711 27.711 0 0 0 12 8c-.557 0-1.12.02-1.678.053C10.786 5.385 11.635 4 12 4s1.213 1.386 1.68 4.053Zm-5.417.21c-1.403.201-2.709.523-3.76.974a8.026 8.026 0 0 1 4.735-4.734c-.452 1.05-.773 2.356-.975 3.76Zm.975 11.235c-.452-1.05-.773-2.356-.975-3.759-1.403-.202-2.709-.524-3.76-.975a8.028 8.028 0 0 0 4.735 4.734Zm10.261-4.734c-1.05.451-2.356.773-3.759.975-.203 1.403-.524 2.708-.975 3.76a8.027 8.027 0 0 0 4.734-4.735Zm-4.734-10.26c.451 1.05.772 2.355.975 3.758 1.403.202 2.71.524 3.76.975a8.024 8.024 0 0 0-4.735-4.734ZM8 11.998c0-.557.02-1.12.053-1.678C5.384 10.787 4 11.636 4 12c0 .364 1.385 1.213 4.053 1.68A27.685 27.685 0 0 1 8 11.998Zm2.073 1.93a25.218 25.218 0 0 1 0-3.858 25.687 25.687 0 0 1 3.855 0c.046.601.072 1.242.072 1.928 0 .687-.026 1.328-.072 1.93-.6.044-1.24.07-1.928.07a25.71 25.71 0 0 1-1.927-.07ZM12 15.998c-.557 0-1.12-.018-1.678-.052C10.786 18.614 11.635 20 12 20s1.213-1.385 1.68-4.052c-.56.034-1.122.052-1.68.052Zm4-4c0-.557-.018-1.12-.052-1.678C18.615 10.787 20 11.636 20 12c0 .364-1.384 1.213-4.052 1.68.034-.559.052-1.122.052-1.68Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Other.displayName = "Icon.Browser.Other";

// Icon/Browser/Safari.tsx
var import_uik139 = require("@appd/uik");
var import_jsx_runtime129 = require("react/jsx-runtime");
var Safari = import_uik139.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime129.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Browser.Safari",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime129.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M2 12.291C2 6.608 6.607 2 12.29 2c5.684 0 10.29 4.608 10.29 10.291 0 5.683-4.606 10.29-10.29 10.29C6.608 22.581 2 17.974 2 12.291Zm1.049 0a9.241 9.241 0 0 0 9.242 9.241 9.24 9.24 0 0 0 9.24-9.241 9.24 9.24 0 0 0-9.24-9.241 9.241 9.241 0 0 0-9.242 9.241Z",
          fill: "#DFDBDA",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime129.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M3.048 12.29a9.241 9.241 0 0 1 9.242-9.241 9.241 9.241 0 1 1 0 18.482 9.241 9.241 0 0 1-9.242-9.241Zm10.421 1.085v-.008l5.277-6.947-.82.525.68-.97-7.362 5.222-5.182 7.407 1.287-.915-.726 1.196 6.838-5.502.008-.008Z",
          fill: "#BFBFBF",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime129.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M3.048 12.29a9.241 9.241 0 0 1 9.242-9.241 9.241 9.241 0 1 1 0 18.482 9.241 9.241 0 0 1-9.242-9.241Zm10.421 1.085v-.008l5.136-7.392-7.36 5.222-5.183 7.407 7.4-5.221.008-.008Z",
          fill: "url(#icon-browser-safari__a)",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime129.jsx)(
        "path",
        {
          d: "m11.25 11.205 1.096 1.079 1.085 1.085 4.496-6.422.678-.97-4.743 4.778-1.516 1.529-1.095-1.08Z",
          fill: "#D30D08"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime129.jsx)("path", { d: "m12.345 12.284 6.26-6.307-7.36 5.222.006.006 1.095 1.079Z", fill: "#FF4E47" }),
      /* @__PURE__ */ (0, import_jsx_runtime129.jsx)(
        "path",
        {
          d: "m11.245 11.197.004.004-.004-.004Zm2.185 2.171-1.089-1.08-6.279 6.317 1.287-.915 6.067-4.312.014-.01Z",
          fill: "#ACACAC"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime129.jsx)("path", { d: "m12.345 12.282-1.093-1.077-.002-.002-.002-.002-.003-.004-5.182 7.407 6.279-6.318.003-.004Z", fill: "#EEE" }),
      /* @__PURE__ */ (0, import_jsx_runtime129.jsx)("defs", { children: /* @__PURE__ */ (0, import_jsx_runtime129.jsxs)(
        "radialGradient",
        {
          cx: "0",
          cy: "0",
          gradientTransform: "matrix(0 12.0726 -12.0739 0 12.575 12.29)",
          gradientUnits: "userSpaceOnUse",
          id: "icon-browser-safari__a",
          r: "1",
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime129.jsx)("stop", { stopColor: "#00CAEF" }),
            /* @__PURE__ */ (0, import_jsx_runtime129.jsx)("stop", { stopColor: "#02C1EC" }),
            /* @__PURE__ */ (0, import_jsx_runtime129.jsx)("stop", { offset: "1", stopColor: "#1678D1" })
          ]
        }
      ) })
    ]
  }
));
Safari.displayName = "Icon.Browser.Safari";

// Icon/ChartType/ChartType.ts
var ChartType_exports = {};
__export(ChartType_exports, {
  Area: () => Area,
  CirclePack: () => CirclePack,
  Column: () => Column,
  Donut: () => Donut,
  Funnel: () => Funnel,
  Histogram: () => Histogram,
  Line: () => Line,
  List: () => List,
  Numeric: () => Numeric,
  Pie: () => Pie,
  Scatter: () => Scatter,
  Table: () => Table,
  TreeMap: () => TreeMap,
  WorldMap: () => WorldMap
});

// Icon/ChartType/Area.tsx
var import_uik140 = require("@appd/uik");
var import_jsx_runtime130 = require("react/jsx-runtime");
var Area = import_uik140.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime130.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.ChartType.Area",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime130.jsx)("path", { d: "M3.265 18.716v-5.603L9.127 7.9l5.96 2.598 5.648-5.214v13.432H3.265Z", fill: "#fff", fillOpacity: ".94" })
  }
));
Area.displayName = "Icon.ChartType.Area";

// Icon/ChartType/CirclePack.tsx
var import_uik141 = require("@appd/uik");
var import_jsx_runtime131 = require("react/jsx-runtime");
var CirclePack = import_uik141.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime131.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.ChartType.CirclePack",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime131.jsx)(
      "path",
      {
        d: "M6 5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm13.2 4a3.2 3.2 0 1 1-6.4 0 3.2 3.2 0 0 1 6.4 0ZM16 17.8a4.8 4.8 0 1 1-9.6 0 4.8 4.8 0 0 1 9.6 0Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
CirclePack.displayName = "Icon.ChartType.CirclePack";

// Icon/ChartType/Column.tsx
var import_uik142 = require("@appd/uik");
var import_jsx_runtime132 = require("react/jsx-runtime");
var Column = import_uik142.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime132.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.ChartType.Column",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime132.jsx)("path", { d: "M10 5h4v15h-4V5ZM4 9h4v11H4V9Zm16 3h-4v8h4v-8Z", fill: "#fff", fillOpacity: ".94" })
  }
));
Column.displayName = "Icon.ChartType.Column";

// Icon/ChartType/Donut.tsx
var import_uik143 = require("@appd/uik");
var import_jsx_runtime133 = require("react/jsx-runtime");
var Donut = import_uik143.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime133.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.ChartType.Donut",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(
        "path",
        {
          d: "M6.108 11.992a5.89 5.89 0 0 0 5.884 5.884c2.9 0 5.311-2.111 5.791-4.876h4.042c-.507 4.979-4.723 8.876-9.833 8.876-5.45 0-9.884-4.434-9.884-9.884 0-5.115 3.906-9.334 8.892-9.834v4.04c-2.773.474-4.892 2.888-4.892 5.794Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(
        "path",
        {
          d: "M21.826 11h-4.04A5.89 5.89 0 0 0 13 6.2V2.16c4.652.473 8.36 4.187 8.826 8.841Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
Donut.displayName = "Icon.ChartType.Donut";

// Icon/ChartType/Funnel.tsx
var import_uik144 = require("@appd/uik");
var import_jsx_runtime134 = require("react/jsx-runtime");
var Funnel = import_uik144.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime134.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.ChartType.Funnel",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime134.jsx)(
      "path",
      {
        d: "M3 5.971h18v2.01H3v-2.01Zm7 10.048h4v2.01h-4v-2.01Zm8-5.024H6v2.01h12v-2.01Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
Funnel.displayName = "Icon.ChartType.Funnel";

// Icon/ChartType/Histogram.tsx
var import_uik145 = require("@appd/uik");
var import_jsx_runtime135 = require("react/jsx-runtime");
var Histogram = import_uik145.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime135.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.ChartType.Histogram",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime135.jsx)(
      "path",
      {
        d: "M20.953 19.82v-6.014h-2.031v6.014h2.03ZM17.03 9.89v9.93H15V9.89h2.031Zm-3.896-5.735V19.82h-2.031V4.155h2.031Zm-4.063 3.12V19.82H7.04V7.275h2.031Zm-3.993 12.57v-9.262h-2.03v9.262h2.03Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
Histogram.displayName = "Icon.ChartType.Histogram";

// Icon/ChartType/Line.tsx
var import_uik146 = require("@appd/uik");
var import_jsx_runtime136 = require("react/jsx-runtime");
var Line = import_uik146.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime136.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.ChartType.Line",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime136.jsx)(
      "path",
      {
        d: "m9.443 12.308 3.113 3.446A.957.957 0 0 0 14 15.742l7.763-8.87a1.073 1.073 0 0 0-.06-1.465.956.956 0 0 0-1.396.062l-7.047 8.052-3.093-3.424a.956.956 0 0 0-1.427-.009l-6.486 7.02c-.38.41-.37 1.067.021 1.466a.956.956 0 0 0 1.397-.023l5.77-6.243Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
Line.displayName = "Icon.ChartType.Line";

// Icon/ChartType/List.tsx
var import_uik147 = require("@appd/uik");
var import_jsx_runtime137 = require("react/jsx-runtime");
var List = import_uik147.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.ChartType.List",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(
      "path",
      {
        d: "M4 6a2 2 0 1 0 4.001-.001A2 2 0 0 0 4 6Zm16.063-1.25h-9.625v2.5h9.624v-2.5Zm0 6h-9.625v2.5h9.624v-2.5Zm-9.625 6h9.624v2.5h-9.625v-2.5ZM6 14a2 2 0 1 1 .001-4.001A2 2 0 0 1 6 14Zm-2 4a2 2 0 1 0 4.001-.001A2 2 0 0 0 4 18Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
List.displayName = "Icon.ChartType.List";

// Icon/ChartType/Numeric.tsx
var import_uik148 = require("@appd/uik");
var import_jsx_runtime138 = require("react/jsx-runtime");
var Numeric = import_uik148.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime138.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.ChartType.Numeric",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime138.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M9.4 15.8h3.3l-1.1 6h2.1l1.1-6h4.5l.4-1.9h-4.6l.6-3.3h4.6l.4-1.9H16L17.1 3H15l-1 5.7h-3.4l1-5.7h-2L8.5 8.7H4.3l-.4 1.9h4.3l-.7 3.3H3.3L3 15.8h4.4l-1.1 6h2l1.1-6Zm.9-5.2h3.4l-.7 3.3H9.6l.7-3.3Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Numeric.displayName = "Icon.ChartType.Numeric";

// Icon/ChartType/Pie.tsx
var import_uik149 = require("@appd/uik");
var import_jsx_runtime139 = require("react/jsx-runtime");
var Pie = import_uik149.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime139.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.ChartType.Pie",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime139.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M11.992 2C6.482 2 2 6.482 2 11.992c0 5.51 4.482 9.992 9.992 9.992 5.51 0 9.992-4.482 9.992-9.992 0-5.51-4.482-9.992-9.992-9.992Zm7.924 9H13.01l.067-6.918A7.998 7.998 0 0 1 19.917 11ZM4 11.992c0 4.407 3.585 7.992 7.992 7.992 4.065 0 7.424-3.052 7.922-6.984H10.99l.087-8.944C7.1 4.513 4 7.896 4 11.992Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Pie.displayName = "Icon.ChartType.Pie";

// Icon/ChartType/Scatter.tsx
var import_uik150 = require("@appd/uik");
var import_jsx_runtime140 = require("react/jsx-runtime");
var Scatter = import_uik150.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime140.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.ChartType.Scatter",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime140.jsx)(
      "path",
      {
        d: "m12.522 5 2.197 2.084-2.197 2.083-2.198-2.083L12.522 5ZM7.395 8.462 5.198 6.38 3 8.462l2.198 2.084 2.197-2.084Zm5.767 4.168-2.197-2.084-2.198 2.084 2.198 2.083 2.197-2.083Zm-5.767 2.051-2.197-2.083L3 14.68l2.198 2.084 2.197-2.084Zm8.322.423 2.198 2.083-2.198 2.084-2.197-2.084 2.197-2.083Zm4.79-3.512L18.309 9.51l-2.197 2.083 2.197 2.084 2.198-2.084Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
Scatter.displayName = "Icon.ChartType.Scatter";

// Icon/ChartType/Table.tsx
var import_uik151 = require("@appd/uik");
var import_jsx_runtime141 = require("react/jsx-runtime");
var Table = import_uik151.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime141.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.ChartType.Table",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime141.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M3 9h2V7H3v2Zm2 4H3v-2h2v2Zm0 4H3v-2h2v2Zm16-4H7v-2h14v2ZM7 17h14v-2H7v2Zm0-8V7h14v2H7Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Table.displayName = "Icon.ChartType.Table";

// Icon/ChartType/TreeMap.tsx
var import_uik152 = require("@appd/uik");
var import_jsx_runtime142 = require("react/jsx-runtime");
var TreeMap = import_uik152.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime142.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.ChartType.TreeMap",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime142.jsx)(
      "path",
      {
        d: "M10.511 5.109H2.37V18.98h8.142V5.11Zm1.464 7.4h3.82v6.472h-3.82V12.51Zm10.096 3.764H17.21v2.708h4.862v-2.708Zm-4.861-3.746h4.861v2.707H17.21v-2.707Zm4.861-7.418H11.974v6.125h10.097V5.11Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
TreeMap.displayName = "Icon.ChartType.TreeMap";

// Icon/ChartType/WorldMap.tsx
var import_uik153 = require("@appd/uik");
var import_jsx_runtime143 = require("react/jsx-runtime");
var WorldMap = import_uik153.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime143.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.ChartType.WorldMap",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime143.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M2 11.992C2 6.482 6.482 2 11.992 2c5.51 0 9.992 4.482 9.992 9.992 0 5.51-4.482 9.992-9.992 9.992-5.51 0-9.992-4.482-9.992-9.992Zm2.999 1.652c0 .131.073.25.19.308l2.19 1.096v3.46c.368.26.759.488 1.168.685l4.2-4.724a.35.35 0 0 0 .086-.23v-1.786a.346.346 0 0 0-.346-.346c-2.167 0-4.42-2.184-4.515-2.276a.347.347 0 0 0-.246-.104H5.344a.346.346 0 0 0-.345.345v3.572ZM9.261 4.49v.82a.344.344 0 0 1-.1.243L6.777 7.936a.345.345 0 0 1-.243.1H5.057a8.026 8.026 0 0 1 4.204-3.545Zm9 6.109c.235.878.66 3.181 0 6.335a7.947 7.947 0 0 0 1.723-4.943c0-3.165-1.854-5.9-4.53-7.192a3.295 3.295 0 0 0-.93 2.296 3.322 3.322 0 0 0 3.483 3.319l.203-.01.052.195Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
WorldMap.displayName = "Icon.ChartType.WorldMap";

// Icon/DataType/DataType.ts
var DataType_exports = {};
__export(DataType_exports, {
  Boolean: () => Boolean2,
  Currency: () => Currency,
  Number: () => Number2,
  Object: () => $Object,
  Text: () => Text
});

// Icon/DataType/$Object.tsx
var import_uik154 = require("@appd/uik");
var import_jsx_runtime144 = require("react/jsx-runtime");
var $Object = import_uik154.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime144.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.DataType.Object",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime144.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M9.522 4.248v1.904h-.918c-.204 0-.365.04-.484.119a.878.878 0 0 0-.28.297c-.069.12-.111.253-.128.4a3.71 3.71 0 0 0-.026.425v2.584c0 .42-.065.756-.195 1.011-.13.255-.284.454-.46.596a1.61 1.61 0 0 1-.552.297 2.59 2.59 0 0 1-.476.102v.051c.125.011.284.048.476.11.193.063.377.165.553.306.175.142.328.33.459.562.13.232.195.53.195.892v2.72c0 .125.009.26.026.408.017.147.06.28.127.4a.878.878 0 0 0 .28.297c.12.08.281.119.485.119h.918v1.904H7.363c-.192 0-.41-.048-.654-.144a2.275 2.275 0 0 1-.68-.425 2.408 2.408 0 0 1-.536-.715 2.199 2.199 0 0 1-.22-1.011v-3.298c0-.26-.057-.482-.17-.663a1.43 1.43 0 0 0-.409-.434 1.743 1.743 0 0 0-.51-.237 1.75 1.75 0 0 0-.459-.077v-1.479c.125 0 .278-.026.46-.076a1.54 1.54 0 0 0 .51-.255c.158-.12.294-.278.407-.477.114-.198.17-.439.17-.722V6.543c0-.385.074-.723.221-1.012.148-.289.326-.527.536-.714.21-.187.436-.328.68-.425a1.81 1.81 0 0 1 .654-.144h2.16Zm4.939 15.504v-1.904h.918c.204 0 .365-.04.484-.119a.878.878 0 0 0 .28-.297c.069-.12.111-.253.128-.4.017-.147.026-.283.026-.408v-2.72c0-.363.065-.66.195-.893a1.89 1.89 0 0 1 .46-.56c.175-.142.36-.244.552-.306.192-.063.351-.1.476-.111v-.051a2.592 2.592 0 0 1-.476-.102 1.598 1.598 0 0 1-.553-.297 1.806 1.806 0 0 1-.459-.595c-.13-.256-.195-.593-.195-1.012V7.393a3.71 3.71 0 0 0-.026-.425 1.035 1.035 0 0 0-.127-.4.878.878 0 0 0-.28-.297c-.12-.08-.281-.119-.485-.119h-.918V4.248h2.159c.192 0 .41.048.654.144.244.097.47.238.68.425.21.187.388.425.536.714.147.29.22.627.22 1.012v3.196a1.436 1.436 0 0 0 .579 1.198c.158.12.328.205.51.256.181.05.34.076.476.076v1.479c-.136 0-.295.026-.476.077-.182.05-.352.13-.51.238a1.432 1.432 0 0 0-.408.433 1.22 1.22 0 0 0-.17.663v3.298c0 .385-.074.723-.221 1.011a2.407 2.407 0 0 1-.536.715 2.31 2.31 0 0 1-.68.425 1.807 1.807 0 0 1-.654.144h-2.16Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
$Object.displayName = "Icon.DataType.Object";

// Icon/DataType/Boolean.tsx
var import_uik155 = require("@appd/uik");
var import_jsx_runtime145 = require("react/jsx-runtime");
var Boolean2 = import_uik155.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime145.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.DataType.Boolean",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime145.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M12 20.6c-4.8 0-8.6-3.8-8.6-8.6S7.3 3.4 12 3.4c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6Zm7-8.6c0-3.9-3.1-7-7-7v13.9c3.9 0 7-3.1 7-6.9Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Boolean2.displayName = "Icon.DataType.Boolean";

// Icon/DataType/Currency.tsx
var import_uik156 = require("@appd/uik");
var import_jsx_runtime146 = require("react/jsx-runtime");
var Currency = import_uik156.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime146.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.DataType.Currency",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime146.jsx)(
      "path",
      {
        d: "M9.48 8.75c0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1H7c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4-2.27-.59-3-1.2-3-2.15Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
Currency.displayName = "Icon.DataType.Currency";

// Icon/DataType/Number.tsx
var import_uik157 = require("@appd/uik");
var import_jsx_runtime147 = require("react/jsx-runtime");
var Number2 = import_uik157.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime147.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.DataType.Number",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime147.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M5.924 8.458v2.264H8.65l-.554 2.726H5v2.265h2.634l-.9 4.457h2.308l.902-4.457h2.632l-.923 4.457h2.31l.926-4.457h3.186v-2.265h-2.726l.554-2.726H19V8.458h-2.634l.9-4.458h-2.31l-.9 4.458h-2.634L12.345 4h-2.308L9.11 8.458H5.924Zm4.482 4.99.554-2.726h2.634l-.554 2.726h-2.634Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Number2.displayName = "Icon.DataType.Number";

// Icon/DataType/Text.tsx
var import_uik158 = require("@appd/uik");
var import_jsx_runtime148 = require("react/jsx-runtime");
var Text = import_uik158.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime148.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.DataType.Text",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime148.jsx)(
      "path",
      {
        d: "M5.77 3.7v4.71h2.202V5.901h2.812v12.196h-2.53V20.3h7.469v-2.202h-2.53V5.902h2.835v2.507h2.203V3.7H5.77Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
Text.displayName = "Icon.DataType.Text";

// Icon/Health/Health.ts
var Health_exports = {};
__export(Health_exports, {
  Active: () => Active,
  Critical: () => Critical,
  CriticalOutline: () => CriticalOutline,
  Inactive: () => Inactive,
  InfoMessage: () => InfoMessage,
  InfoMessageOutline: () => InfoMessageOutline,
  Normal: () => Normal,
  NormalOutline: () => NormalOutline,
  SecurityCritical: () => SecurityCritical,
  SecurityLow: () => SecurityLow,
  SecurityMedium: () => SecurityMedium,
  Terminated: () => Terminated,
  Unknown: () => Unknown,
  Warning: () => Warning,
  WarningOutline: () => WarningOutline
});

// Icon/Health/Active.tsx
var import_uik159 = require("@appd/uik");
var import_jsx_runtime149 = require("react/jsx-runtime");
var Active = import_uik159.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime149.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Health.Active",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime149.jsx)(
        "path",
        {
          d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2Zm0 15.696a5.744 5.744 0 0 1-5.737-5.738A5.744 5.744 0 0 1 12 6.222a5.744 5.744 0 0 1 5.737 5.738A5.744 5.744 0 0 1 12 17.696Z",
          fill: "#3FB6F2"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime149.jsx)(
        "path",
        {
          d: "M12 8.22a3.742 3.742 0 0 0-3.737 3.739A3.742 3.742 0 0 0 12 15.696a3.742 3.742 0 0 0 3.737-3.737A3.742 3.742 0 0 0 12 8.22Z",
          fill: "#3FB6F2"
        }
      )
    ]
  }
));
Active.displayName = "Icon.Health.Active";

// Icon/Health/Critical.tsx
var import_uik160 = require("@appd/uik");
var import_jsx_runtime150 = require("react/jsx-runtime");
var {
  COLORS: { NEGATIVE_ICON }
} = import_uik160.MAGNETIC_TOKENS;
var Critical = import_uik160.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime150.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Health.Critical",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime150.jsx)(
        "path",
        {
          d: "M10.7403 2.4846C11.5187 2.03053 12.4813 2.03053 13.2597 2.4846L19.7597 6.27626C20.5277 6.72429 21 7.54654 21 8.43571V15.5639C21 16.453 20.5277 17.2753 19.7597 17.7233L13.2597 21.515C12.4813 21.969 11.5187 21.969 10.7403 21.515L4.24032 17.7233C3.47228 17.2753 3 16.453 3 15.5639V8.43571C3 7.54654 3.47228 6.72429 4.24032 6.27626L10.7403 2.4846Z",
          fill: NEGATIVE_ICON
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime150.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M11 12.5L11 8.25C11 7.69772 11.4477 7.25 12 7.25C12.5523 7.25 13 7.69772 13 8.25L13 12.5C13 13.0523 12.5523 13.5 12 13.5C11.4477 13.5 11 13.0523 11 12.5Z",
          fill: "white",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime150.jsx)(
        "path",
        {
          d: "M13.25 16C13.25 16.6904 12.6904 17.25 12 17.25C11.3096 17.25 10.75 16.6904 10.75 16C10.75 15.3096 11.3096 14.75 12 14.75C12.6904 14.75 13.25 15.3096 13.25 16Z",
          fill: "white"
        }
      )
    ]
  }
));
Critical.displayName = "Icon.Health.Critical";

// Icon/Health/CriticalOutline.tsx
var import_uik161 = require("@appd/uik");
var import_jsx_runtime151 = require("react/jsx-runtime");
var CriticalOutline = import_uik161.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime151.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Health.CriticalOutline",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M19 3H5a2.006 2.006 0 0 0-2 2v14a2.006 2.006 0 0 0 2 2h14a2.006 2.006 0 0 0 2-2V5a2.006 2.006 0 0 0-2-2Zm-6 14h-2v-2h2v2Zm-2-4h2V7h-2v6Z",
          fill: "#FA5762",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M5 1h14a4.005 4.005 0 0 1 4 4v14a4.005 4.005 0 0 1-4 4H5a4.005 4.005 0 0 1-4-4V5a4.005 4.005 0 0 1 4-4Zm14 20a2.006 2.006 0 0 0 2-2V5a2.006 2.006 0 0 0-2-2H5a2.006 2.006 0 0 0-2 2v14a2.006 2.006 0 0 0 2 2h14Z",
          fill: "#fff",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
CriticalOutline.displayName = "Icon.Health.CriticalOutline";

// Icon/Health/Inactive.tsx
var import_uik162 = require("@appd/uik");
var import_jsx_runtime152 = require("react/jsx-runtime");
var Inactive = import_uik162.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime152.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Health.Inactive",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime152.jsx)(
      "path",
      {
        d: "M13.697 2.14C6.863 1.01 1.01 6.865 2.141 13.699c.685 4.14 4.024 7.478 8.164 8.162 6.832 1.129 12.684-4.723 11.555-11.556-.684-4.14-4.023-7.479-8.163-8.163Zm-2.958 15.82c-2.27-.476-4.105-2.312-4.581-4.58-.564-2.681.667-5.24 2.885-6.51.003-.002.007.001.005.005a6.087 6.087 0 0 0-.54 4.012c.476 2.348 2.378 4.25 4.727 4.724a6.087 6.087 0 0 0 4.01-.54c.002-.002.006.001.004.004-1.27 2.219-3.83 3.45-6.51 2.886Z",
        fill: "#6F7680"
      }
    )
  }
));
Inactive.displayName = "Icon.Health.Inactive";

// Icon/Health/InfoMessage.tsx
var import_uik163 = require("@appd/uik");
var import_jsx_runtime153 = require("react/jsx-runtime");
var InfoMessage = import_uik163.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime153.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Health.InfoMessage",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime153.jsx)(
        "path",
        {
          d: "M2.5 8.5C2.5 5.18629 5.18629 2.5 8.5 2.5H15.5C18.8137 2.5 21.5 5.18629 21.5 8.5V15.5C21.5 18.8137 18.8137 21.5 15.5 21.5H8.5C5.18629 21.5 2.5 18.8137 2.5 15.5V8.5Z",
          fill: "#2774D9"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime153.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M11 16.25L11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12L13 16.25C13 16.8023 12.5523 17.25 12 17.25C11.4477 17.25 11 16.8023 11 16.25Z",
          fill: "white",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime153.jsx)(
        "path",
        {
          d: "M13.25 8.25C13.25 8.94036 12.6904 9.5 12 9.5C11.3096 9.5 10.75 8.94036 10.75 8.25C10.75 7.55964 11.3096 7 12 7C12.6904 7 13.25 7.55964 13.25 8.25Z",
          fill: "white"
        }
      )
    ]
  }
));
InfoMessage.displayName = "Icon.Health.InfoMessage";

// Icon/Health/InfoMessageOutline.tsx
var import_uik164 = require("@appd/uik");
var import_jsx_runtime154 = require("react/jsx-runtime");
var InfoMessageOutline = import_uik164.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime154.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Health.InfoMessageOutline",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime154.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10c-.002-5.522-4.478-9.998-10-10Zm-1 15v-6h2v6h-2Zm0-10v2h2V7h-2Z",
          fill: "#79D1FD",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime154.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M0 12C0 5.373 5.373 0 12 0c6.624.007 11.992 5.376 12 12 0 6.627-5.373 12-12 12S0 18.627 0 12Zm2 0c0 5.523 4.477 10 10 10 5.522-.002 9.998-4.478 10-10 0-5.523-4.477-10-10-10S2 6.477 2 12Z",
          fill: "#fff",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
InfoMessageOutline.displayName = "Icon.Health.InfoMessageOutline";

// Icon/Health/Normal.tsx
var import_uik165 = require("@appd/uik");
var import_jsx_runtime155 = require("react/jsx-runtime");
var {
  COLORS: { POSITIVE_ICON }
} = import_uik165.MAGNETIC_TOKENS;
var Normal = import_uik165.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime155.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Health.Normal",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime155.jsx)(
        "path",
        {
          d: "M21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12Z",
          fill: POSITIVE_ICON
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime155.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M16.457 8.79279C16.8476 9.18326 16.8477 9.81643 16.4572 10.207L11.2088 15.4569C10.8184 15.8474 10.1854 15.8476 9.79475 15.4573L7.54316 13.2074C7.15249 12.817 7.15225 12.1838 7.54262 11.7932C7.933 11.4025 8.56617 11.4022 8.95684 11.7926L10.5012 13.3358L15.0428 8.79299C15.4333 8.40241 16.0664 8.40232 16.457 8.79279Z",
          fill: "white",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
Normal.displayName = "Icon.Health.Normal";

// Icon/Health/NormalOutline.tsx
var import_uik166 = require("@appd/uik");
var import_jsx_runtime156 = require("react/jsx-runtime");
var NormalOutline = import_uik166.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime156.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Health.NormalOutline",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime156.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M2 12C2 6.477 6.477 2 12 2c5.522.002 9.998 4.478 10 10 0 5.523-4.477 10-10 10S2 17.523 2 12Zm3 .21 5 5 9-9-1.41-1.42L10 14.38 6.41 10.8 5 12.21Z",
          fill: "#36B26E",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime156.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M0 12C0 5.373 5.373 0 12 0c6.624.007 11.992 5.376 12 12 0 6.627-5.373 12-12 12S0 18.627 0 12Zm2 0c0 5.523 4.477 10 10 10 5.522-.002 9.998-4.478 10-10 0-5.523-4.477-10-10-10S2 6.477 2 12Z",
          fill: "#fff",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
NormalOutline.displayName = "Icon.Health.NormalOutline";

// Icon/Health/SecurityCritical.tsx
var import_uik167 = require("@appd/uik");
var import_jsx_runtime157 = require("react/jsx-runtime");
var SecurityCritical = import_uik167.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime157.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Health.SecurityCritical",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime157.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "m12 1 9 4v6c0 5.55-3.84 10.74-9 12-5.16-1.26-9-6.45-9-12V5l9-4Zm-1 16v-2h2v2h-2Zm0-10v6h2V7h-2Z",
        fill: "#FA5762",
        fillRule: "evenodd"
      }
    )
  }
));
SecurityCritical.displayName = "Icon.Health.SecurityCritical";

// Icon/Health/SecurityLow.tsx
var import_uik168 = require("@appd/uik");
var import_jsx_runtime158 = require("react/jsx-runtime");
var SecurityLow = import_uik168.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime158.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Health.SecurityLow",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime158.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "m21 5-9-4-9 4v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5ZM5.5 12.41l4.41 4.3L18 8.74l-1.41-1.42-6.68 6.56-3-2.88-1.41 1.41Z",
        fill: "#36B26E",
        fillRule: "evenodd"
      }
    )
  }
));
SecurityLow.displayName = "Icon.Health.SecurityLow";

// Icon/Health/SecurityMedium.tsx
var import_uik169 = require("@appd/uik");
var import_jsx_runtime159 = require("react/jsx-runtime");
var SecurityMedium = import_uik169.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime159.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Health.SecurityMedium",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime159.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "m12 1 9 4v6c0 5.55-3.84 10.74-9 12-5.16-1.26-9-6.45-9-12V5l9-4Zm-1 16v-2h2v2h-2Zm0-10v6h2V7h-2Z",
        fill: "#FCB3C8",
        fillRule: "evenodd"
      }
    )
  }
));
SecurityMedium.displayName = "Icon.Health.SecurityMedium";

// Icon/Health/Terminated.tsx
var import_uik170 = require("@appd/uik");
var import_jsx_runtime160 = require("react/jsx-runtime");
var Terminated = import_uik170.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime160.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Health.Terminated",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime160.jsx)(
      "path",
      {
        d: "M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3ZM17 15.74 15.74 17 12 13.26 8.26 17 7 15.74 10.74 12 7 8.26 8.26 7 12 10.74 15.74 7 17 8.26 13.26 12 17 15.74Z",
        fill: "#F891B3"
      }
    )
  }
));
Terminated.displayName = "Icon.Health.Terminated";

// Icon/Health/Unknown.tsx
var import_uik171 = require("@appd/uik");
var import_jsx_runtime161 = require("react/jsx-runtime");
var Unknown = import_uik171.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime161.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Health.Unknown",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime161.jsx)("circle", { cx: "8", cy: "8", fill: "#6F7680", r: "6.5" }),
      /* @__PURE__ */ (0, import_jsx_runtime161.jsxs)("g", { clipPath: "url(#clip0_12489_35755)", children: [
        /* @__PURE__ */ (0, import_jsx_runtime161.jsx)(
          "path",
          {
            d: "M8 11.75C8.41421 11.75 8.75 11.4142 8.75 11C8.75 10.5858 8.41421 10.25 8 10.25C7.58579 10.25 7.25 10.5858 7.25 11C7.25 11.4142 7.58579 11.75 8 11.75Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime161.jsx)(
          "path",
          {
            d: "M8.5 8.705V8.75C8.5 9.02614 8.27614 9.25 8 9.25C7.72386 9.25 7.5 9.02614 7.5 8.75V8.25C7.5 7.97386 7.72386 7.75 8 7.75C8.82687 7.75 9.5 7.1875 9.5 6.5C9.5 5.8125 8.82687 5.25 8 5.25C7.17313 5.25 6.5 5.8125 6.5 6.5V6.75C6.5 7.02614 6.27614 7.25 6 7.25C5.72386 7.25 5.5 7.02614 5.5 6.75V6.5C5.5 5.25938 6.62125 4.25 8 4.25C9.37875 4.25 10.5 5.25938 10.5 6.5C10.5 7.58625 9.64 8.49562 8.5 8.705Z",
            fill: "white"
          }
        )
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime161.jsx)("defs", { children: /* @__PURE__ */ (0, import_jsx_runtime161.jsx)("clipPath", { id: "clip0_12489_35755", children: /* @__PURE__ */ (0, import_jsx_runtime161.jsx)("rect", { fill: "white", height: "7.5", transform: "translate(5.5 4.25)", width: "5" }) }) })
    ]
  }
));
Unknown.displayName = "Icon.Health.Unknown";

// Icon/Health/Warning.tsx
var import_uik172 = require("@appd/uik");
var import_jsx_runtime162 = require("react/jsx-runtime");
var {
  COLORS: { WARNING_ICON }
} = import_uik172.MAGNETIC_TOKENS;
var Warning = import_uik172.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime162.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Health.Warning",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime162.jsx)(
        "path",
        {
          d: "M9.82473 4.34186C10.7822 2.65102 13.2181 2.65102 14.1756 4.34186L21.6369 17.5183C22.5807 19.1849 21.3767 21.2501 19.4615 21.2501H4.53882C2.62359 21.2501 1.41966 19.1849 2.36339 17.5183L9.82473 4.34186Z",
          fill: WARNING_ICON
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime162.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M11 13.75L11 9.5C11 8.94772 11.4477 8.5 12 8.5C12.5523 8.5 13 8.94772 13 9.5L13 13.75C13 14.3023 12.5523 14.75 12 14.75C11.4477 14.75 11 14.3023 11 13.75Z",
          fill: "white",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime162.jsx)(
        "path",
        {
          d: "M13.25 17.25C13.25 17.9404 12.6904 18.5 12 18.5C11.3096 18.5 10.75 17.9404 10.75 17.25C10.75 16.5596 11.3096 16 12 16C12.6904 16 13.25 16.5596 13.25 17.25Z",
          fill: "white"
        }
      )
    ]
  }
));
Warning.displayName = "Icon.Health.Warning";

// Icon/Health/WarningOutline.tsx
var import_uik173 = require("@appd/uik");
var import_jsx_runtime163 = require("react/jsx-runtime");
var WarningOutline = import_uik173.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime163.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Health.WarningOutline",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime163.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M12.605 3.355a.96.96 0 0 0-1.661 0L2.049 18.719a.96.96 0 0 0 .83 1.441h17.79a.96.96 0 0 0 .831-1.44L12.605 3.354ZM10.815 9.6h1.92v3.84h-1.92V9.6Zm1.92 5.76h-1.92v1.92h1.92v-1.92Z",
          fill: "#F0C243",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime163.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "m14.267 2.393 8.895 15.364a2.88 2.88 0 0 1-2.493 4.323H2.88a2.88 2.88 0 0 1-2.492-4.323L9.282 2.393a2.88 2.88 0 0 1 4.985 0ZM2.879 20.16h17.79a.96.96 0 0 0 .831-1.44L12.605 3.354a.96.96 0 0 0-1.661 0L2.049 18.719a.96.96 0 0 0 .83 1.441Z",
          fill: "#fff",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
WarningOutline.displayName = "Icon.Health.WarningOutline";

// Icon/Language/Language.ts
var Language_exports = {};
__export(Language_exports, {
  Cpp: () => Cpp,
  Elixir: () => Elixir,
  Erlang: () => Erlang,
  GoLang: () => GoLang,
  Java: () => Java,
  Net: () => Net,
  NodeJs: () => NodeJs,
  Php: () => Php,
  Python: () => Python,
  Ruby: () => Ruby,
  Rust: () => Rust
});

// Icon/Language/Cpp.tsx
var import_uik174 = require("@appd/uik");
var import_jsx_runtime164 = require("react/jsx-runtime");
var Cpp = import_uik174.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime164.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Language.Cpp",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime164.jsx)("rect", { fill: "#1760CF", height: "16", rx: "1.61", width: "22", x: "1", y: "4" }),
      /* @__PURE__ */ (0, import_jsx_runtime164.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M8.19 13.8v.52a1.71 1.71 0 0 1-.15.75 1.91 1.91 0 0 1-.41.63 1.84 1.84 0 0 1-.62.44 1.76 1.76 0 0 1-.76.16 2.941 2.941 0 0 1-.71-.09 1.72 1.72 0 0 1-.64-.34 1.67 1.67 0 0 1-.48-.62 2.21 2.21 0 0 1-.19-1V9.58a2 2 0 0 1 .15-.78 1.86 1.86 0 0 1 .41-.62 1.72 1.72 0 0 1 .63-.41 2.09 2.09 0 0 1 .81-.15 1.84 1.84 0 0 1 1.4.56c.165.19.291.41.37.65a2 2 0 0 1 .15.83v.48H7v-.41a1.05 1.05 0 0 0-.2-.63.68.68 0 0 0-.56-.26.61.61 0 0 0-.6.28 1.52 1.52 0 0 0-.15.71v4.37c-.009.221.047.44.16.63a.63.63 0 0 0 .58.25.822.822 0 0 0 .26 0 .94.94 0 0 0 .26-.14.75.75 0 0 0 .18-.26 1.09 1.09 0 0 0 .07-.46v-.42h1.19Zm4.62-4.01v1.58h1.58v1.19h-1.58v1.58h-1.2v-1.58h-1.58v-1.19h1.58V9.79h1.2Zm7.37 2.77v-1.19H18.6V9.79h-1.2v1.58h-1.58v1.19h1.58v1.58h1.2v-1.58h1.58Z",
          fill: "#fff",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
Cpp.displayName = "Icon.Language.Cpp";

// Icon/Language/Elixir.tsx
var import_uik175 = require("@appd/uik");
var import_jsx_runtime165 = require("react/jsx-runtime");
var Elixir = import_uik175.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime165.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Language.Elixir",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime165.jsx)("rect", { fill: "#154EB0", height: "16", rx: "1.61", width: "22", x: "1", y: "4" }),
      /* @__PURE__ */ (0, import_jsx_runtime165.jsx)(
        "path",
        {
          d: "M7.216 16.23V7.686h3.648v1.152H8.44v2.508h2.112v1.152H8.44v2.508h2.424v1.224H7.216Zm5.29 0 1.728-4.476-1.596-4.068h1.296l.924 2.532.936-2.532h1.296l-1.632 4.068 1.764 4.476h-1.296l-1.068-2.88-1.056 2.88h-1.296Z",
          fill: "#fff"
        }
      )
    ]
  }
));
Elixir.displayName = "Icon.Language.Elixir";

// Icon/Language/Erlang.tsx
var import_uik176 = require("@appd/uik");
var import_jsx_runtime166 = require("react/jsx-runtime");
var Erlang = import_uik176.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime166.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Language.Erlang",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime166.jsx)("rect", { fill: "#930F38", height: "16", rx: "1.61", width: "22", x: "1", y: "4" }),
      /* @__PURE__ */ (0, import_jsx_runtime166.jsx)(
        "path",
        {
          d: "M4.766 16.23V7.686h3.648v1.152H5.99v2.508h2.112v1.152H5.99v2.508h2.424v1.224H4.766ZM11.4 8.838v2.664h.696c.216 0 .388-.028.516-.084a.742.742 0 0 0 .3-.264c.064-.112.108-.248.132-.408a4.11 4.11 0 0 0 .036-.576c0-.216-.012-.404-.036-.564a1.147 1.147 0 0 0-.144-.432c-.152-.224-.44-.336-.864-.336H11.4Zm-1.224 7.392V7.686h1.968c1.44 0 2.16.836 2.16 2.508 0 .504-.08.932-.24 1.284-.152.352-.424.636-.816.852l1.32 3.9h-1.296l-1.14-3.648H11.4v3.648h-1.224Zm5.61 0V7.686h1.224v7.32h2.424v1.224h-3.648Z",
          fill: "#fff"
        }
      )
    ]
  }
));
Erlang.displayName = "Icon.Language.Erlang";

// Icon/Language/GoLang.tsx
var import_uik177 = require("@appd/uik");
var import_jsx_runtime167 = require("react/jsx-runtime");
var GoLang = import_uik177.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime167.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Language.GoLang",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime167.jsx)("rect", { fill: "#21A65F", height: "16", rx: "1.61", width: "22", x: "1", y: "4" }),
      /* @__PURE__ */ (0, import_jsx_runtime167.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M7.02 10.04a2.21 2.21 0 0 1 .18-.91 1.91 1.91 0 0 1 1.13-1 2.18 2.18 0 0 1 2.14.38c.198.188.358.412.47.66.124.287.186.597.18.91v.44H9.9v-.48a.83.83 0 0 0-.25-.65.86.86 0 0 0-.58-.21.84.84 0 0 0-.58.21.8.8 0 0 0-.25.65v4.52a.8.8 0 0 0 .25.65.84.84 0 0 0 .58.21.86.86 0 0 0 .58-.21.83.83 0 0 0 .25-.65v-1.61h-1v-1.08h2.2v2.69c.008.316-.053.63-.18.92a1.93 1.93 0 0 1-.47.64 2.137 2.137 0 0 1-1.4.52 2.1 2.1 0 0 1-.74-.13c-.24-.087-.46-.22-.65-.39a1.83 1.83 0 0 1-.48-.64 2.16 2.16 0 0 1-.18-.92l.02-4.52Zm5.36 0a2.21 2.21 0 0 1 .18-.91 1.91 1.91 0 0 1 1.13-1 2.14 2.14 0 0 1 .74-.13 2.23 2.23 0 0 1 1.41.51c.423.41.655.98.64 1.57v4.52c.008.316-.053.63-.18.92a1.91 1.91 0 0 1-.46.64c-.198.168-.425.3-.67.39a2.1 2.1 0 0 1-.74.13c-.252 0-.503-.043-.74-.13-.24-.087-.46-.22-.65-.39a1.828 1.828 0 0 1-.48-.64 2.158 2.158 0 0 1-.18-.92v-4.56Zm1.47 5.17a.83.83 0 0 1-.25-.65v-4.52a.83.83 0 0 1 .25-.65.86.86 0 0 1 .58-.21.84.84 0 0 1 .58.21.8.8 0 0 1 .25.65v4.52a.8.8 0 0 1-.25.65.84.84 0 0 1-.58.21.86.86 0 0 1-.58-.21Z",
          fill: "#fff",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
GoLang.displayName = "Icon.Language.GoLang";

// Icon/Language/Java.tsx
var import_uik178 = require("@appd/uik");
var import_jsx_runtime168 = require("react/jsx-runtime");
var Java = import_uik178.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime168.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Language.Java",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime168.jsx)("rect", { fill: "#1465C0", height: "16", rx: "1.61", width: "22", x: "1", y: "4" }),
      /* @__PURE__ */ (0, import_jsx_runtime168.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M6.08 14.22V7.69h-1.2V14a1.28 1.28 0 0 1-.09.52.77.77 0 0 1-.49.47.8.8 0 0 1-.62 0 1.295 1.295 0 0 1-.3-.22l-1 .77c.189.19.396.362.62.51.3.183.649.27 1 .25.301.006.6-.048.88-.16.243-.112.463-.268.65-.46a2 2 0 0 0 .55-1.46Zm2.76-6.53-1.91 8.54h1.23l.36-1.83h1.67l.36 1.83h1.2L9.84 7.69h-1Zm1.09 5.54-.6-3.09-.6 3.09h1.2Zm4.65 3 1.75-8.54h-1.28l-1 6-1-6h-1.29l1.74 8.54h1.08Zm1.74 0 1.91-8.54h1l1.9 8.54h-1.2l-.36-1.83H17.9l-.36 1.83h-1.22Zm2.4-6.09.6 3.09h-1.2l.6-3.09Z",
          fill: "#fff",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
Java.displayName = "Icon.Language.Java";

// Icon/Language/Net.tsx
var import_uik179 = require("@appd/uik");
var import_jsx_runtime169 = require("react/jsx-runtime");
var Net = import_uik179.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime169.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Language.Net",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime169.jsx)("rect", { fill: "#652DDF", height: "16", rx: "1.61", width: "22", x: "1", y: "4" }),
      /* @__PURE__ */ (0, import_jsx_runtime169.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M6.6 7.69v8.54h1.25V11.1l1.87 5.13h1.14V7.69H9.63v5.14L7.78 7.69H6.6ZM3.05 15v1.23l1.23-.01V15H3.05Zm9.18 1.23V7.69h3.65v1.15h-2.42v2.51h2.11v1.15h-2.11V15h2.42v1.22l-3.65.01Zm6.46-7.39v7.39h1.27V8.84h1.37V7.69h-4.06v1.15h1.42Z",
          fill: "#fff",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
Net.displayName = "Icon.Language.Net";

// Icon/Language/NodeJs.tsx
var import_uik180 = require("@appd/uik");
var import_jsx_runtime170 = require("react/jsx-runtime");
var NodeJs = import_uik180.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime170.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Language.NodeJs",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime170.jsx)("rect", { fill: "#0F874C", height: "16", rx: "1.61", width: "22", x: "1", y: "4" }),
      /* @__PURE__ */ (0, import_jsx_runtime170.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M19.19 10.15h1.23v-.64c0-.498-.203-.974-.56-1.32a2.152 2.152 0 0 0-.65-.45 2 2 0 0 0-.83-.16 2.2 2.2 0 0 0-.93.18c-.25.118-.472.288-.65.5a2.27 2.27 0 0 0-.39.74 3.102 3.102 0 0 0-.13 1c.001.436.1.867.29 1.26a1.89 1.89 0 0 0 1.06.86l.87.36.37.18a.66.66 0 0 1 .22.22c.055.11.088.228.1.35v.55c.01.173.01.347 0 .52a.94.94 0 0 1-.11.4.62.62 0 0 1-.27.26 1.102 1.102 0 0 1-.49.09.76.76 0 0 1-.66-.27 1 1 0 0 1-.2-.61v-.38h-1.22v.46a2 2 0 0 0 1.26 1.87c.261.101.54.152.82.15.343.012.685-.052 1-.19.26-.119.488-.301.66-.53.171-.232.29-.498.35-.78.074-.328.11-.664.11-1 0-.28-.016-.561-.05-.84a2.132 2.132 0 0 0-.18-.65 1.58 1.58 0 0 0-.4-.49 2.255 2.255 0 0 0-.66-.36l-.93-.38a1.502 1.502 0 0 1-.38-.19.7.7 0 0 1-.3-.53v-.42a1.837 1.837 0 0 1 0-.41.819.819 0 0 1 .13-.35.81.81 0 0 1 1.32 0c.14.213.21.465.2.72v.28ZM3.62 7.69v8.54h1.24V11.1l1.88 5.13h1.15V7.69H6.64v5.14L4.79 7.69H3.62ZM9.17 15v1.23l1.23-.01V15H9.17Zm5.88-7.31v6.53a2 2 0 0 1-.55 1.46 2.182 2.182 0 0 1-.65.46 2.242 2.242 0 0 1-.89.16 1.73 1.73 0 0 1-1-.25 3.928 3.928 0 0 1-.62-.51l1-.77c.089.087.19.162.3.22a.8.8 0 0 0 .62 0 .77.77 0 0 0 .49-.47 1.28 1.28 0 0 0 .09-.52V7.69h1.21Z",
          fill: "#fff",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
NodeJs.displayName = "Icon.Language.NodeJs";

// Icon/Language/Php.tsx
var import_uik181 = require("@appd/uik");
var import_jsx_runtime171 = require("react/jsx-runtime");
var Php = import_uik181.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime171.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Language.Php",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime171.jsx)("rect", { fill: "#6929C4", height: "16", rx: "1.61", width: "22", x: "1", y: "4" }),
      /* @__PURE__ */ (0, import_jsx_runtime171.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M4.8 16.23V7.69h1.84a2.63 2.63 0 0 1 .88.13c.268.098.508.26.7.47a1.8 1.8 0 0 1 .43.79c.09.397.13.803.12 1.21a6.75 6.75 0 0 1-.06 1 2 2 0 0 1-.29.74 1.68 1.68 0 0 1-.67.65 2.21 2.21 0 0 1-1.1.24h-.63v3.33l-1.22-.02Zm1.22-7.39v2.91h.59c.2.008.398-.03.58-.11a.72.72 0 0 0 .3-.3 1.14 1.14 0 0 0 .11-.4V9.79a1.41 1.41 0 0 0-.11-.48.67.67 0 0 0-.28-.37 1.16 1.16 0 0 0-.55-.11l-.64.01Zm3.9-1.15v8.54h1.24v-3.8h1.51v3.8h1.25V7.69h-1.27v3.66h-1.51V7.69H9.92Zm5.38 8.54V7.69h1.84a2.63 2.63 0 0 1 .88.13c.268.098.508.26.7.47a1.8 1.8 0 0 1 .43.79c.09.397.13.803.12 1.21.005.334-.015.669-.06 1a2 2 0 0 1-.29.74 1.68 1.68 0 0 1-.67.65 2.21 2.21 0 0 1-1.1.24h-.63v3.33l-1.22-.02Zm1.22-4.48V8.84l.64-.01c.19-.009.378.029.55.11a.67.67 0 0 1 .28.32c.065.152.102.315.11.48v1.15a1.14 1.14 0 0 1-.11.45.72.72 0 0 1-.3.3 1.31 1.31 0 0 1-.58.11h-.59Z",
          fill: "#fff",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
Php.displayName = "Icon.Language.Php";

// Icon/Language/Python.tsx
var import_uik182 = require("@appd/uik");
var import_jsx_runtime172 = require("react/jsx-runtime");
var Python = import_uik182.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime172.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Language.Python",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime172.jsx)("rect", { fill: "#306998", height: "16", rx: "1.61", width: "22", x: "1", y: "4" }),
      /* @__PURE__ */ (0, import_jsx_runtime172.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M7.6 16.23V7.69h1.84a2.63 2.63 0 0 1 .88.13c.268.098.508.26.7.47a1.8 1.8 0 0 1 .43.79c.09.397.13.803.12 1.21.005.334-.015.669-.06 1a2 2 0 0 1-.29.74 1.68 1.68 0 0 1-.67.65 2.21 2.21 0 0 1-1.1.24h-.63v3.33l-1.22-.02Zm1.22-7.39v2.91h.59a1.3 1.3 0 0 0 .55-.11.72.72 0 0 0 .3-.3 1.14 1.14 0 0 0 .11-.45V9.74a1.413 1.413 0 0 0-.11-.48.67.67 0 0 0-.25-.32 1.16 1.16 0 0 0-.55-.1h-.64Zm5.06 3.78v3.61h1.23v-3.61l1.68-4.93h-1.3l-1 3.4-1-3.4H12.2l1.68 4.93Z",
          fill: "#fff",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
Python.displayName = "Icon.Language.Python";

// Icon/Language/Ruby.tsx
var import_uik183 = require("@appd/uik");
var import_jsx_runtime173 = require("react/jsx-runtime");
var Ruby = import_uik183.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime173.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Language.Ruby",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime173.jsx)("rect", { fill: "#BF4040", height: "16", rx: "1.61", width: "22", x: "1", y: "4" }),
      /* @__PURE__ */ (0, import_jsx_runtime173.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M12.62 7.69v8.54l1.67.03a2.27 2.27 0 0 0 1.75-.6c.39-.485.582-1.1.54-1.72v-.51c.016-.37-.052-.74-.2-1.08a1.293 1.293 0 0 0-.64-.6c.254-.14.47-.338.63-.58.073-.132.127-.273.16-.42.035-.195.051-.392.05-.59v-.31c0-.274-.038-.546-.11-.81a1.8 1.8 0 0 0-1.06-1.17 2.48 2.48 0 0 0-1-.18h-1.79Zm-5.36 8.54V7.69h2c1.44 0 2.16.84 2.16 2.51a3.08 3.08 0 0 1-.24 1.28 1.77 1.77 0 0 1-.82.85l1.32 3.9h-1.3l-1.17-3.64h-.73v3.64H7.26Zm1.22-7.39v2.67h.7c.175.007.349-.023.51-.09a.7.7 0 0 0 .3-.26c.073-.13.121-.272.14-.42.012-.19.012-.38 0-.57.011-.19.011-.38 0-.57a1.3 1.3 0 0 0-.17-.42 1 1 0 0 0-.86-.34h-.62Zm5.37 0v2.35h.55a.94.94 0 0 0 .82-.3 1.6 1.6 0 0 0 .21-.9 1.38 1.38 0 0 0-.23-.86 1.06 1.06 0 0 0-.85-.29h-.5Zm0 6.17v-2.74l.56.04c.183-.004.366.023.54.08a.72.72 0 0 1 .32.25.998.998 0 0 1 .14.41 3.08 3.08 0 0 1 0 .56v.58c-.013.158-.06.312-.14.45a.69.69 0 0 1-.31.3c-.189.067-.39.09-.59.07h-.52Z",
          fill: "#fff",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
Ruby.displayName = "Icon.Language.Ruby";

// Icon/Language/Rust.tsx
var import_uik184 = require("@appd/uik");
var import_jsx_runtime174 = require("react/jsx-runtime");
var Rust = import_uik184.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime174.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Language.Rust",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime174.jsx)("rect", { fill: "#596069", height: "16", rx: "1.61", width: "22", x: "1", y: "4" }),
      /* @__PURE__ */ (0, import_jsx_runtime174.jsx)(
        "path",
        {
          d: "M8.48 8.838v2.664h.696c.216 0 .388-.028.516-.084a.742.742 0 0 0 .3-.264c.064-.112.108-.248.132-.408a4.11 4.11 0 0 0 .036-.576c0-.216-.012-.404-.036-.564a1.147 1.147 0 0 0-.144-.432c-.152-.224-.44-.336-.864-.336H8.48ZM7.256 16.23V7.686h1.968c1.44 0 2.16.836 2.16 2.508 0 .504-.08.932-.24 1.284-.152.352-.424.636-.816.852l1.32 3.9h-1.296l-1.14-3.648H8.48v3.648H7.256Zm9.56-6.084h-1.224V9.87c0-.28-.068-.52-.204-.72-.128-.208-.348-.312-.66-.312a.77.77 0 0 0-.408.096.805.805 0 0 0-.252.24 1.017 1.017 0 0 0-.132.36 2.212 2.212 0 0 0-.036.408c0 .168.004.308.012.42a.881.881 0 0 0 .096.3.69.69 0 0 0 .204.228c.096.064.224.128.384.192l.936.372c.272.104.492.228.66.372.168.136.3.296.396.48.088.192.148.412.18.66.032.24.048.516.048.828 0 .36-.036.696-.108 1.008a2.111 2.111 0 0 1-.348.78c-.168.224-.388.4-.66.528s-.604.192-.996.192c-.296 0-.572-.052-.828-.156a1.97 1.97 0 0 1-.66-.432 2.219 2.219 0 0 1-.444-.636 2.058 2.058 0 0 1-.156-.804v-.456h1.224v.384c0 .224.064.428.192.612.136.176.36.264.672.264.208 0 .368-.028.48-.084a.676.676 0 0 0 .276-.264.88.88 0 0 0 .108-.396c.016-.16.024-.336.024-.528 0-.224-.008-.408-.024-.552a.95.95 0 0 0-.096-.348.657.657 0 0 0-.228-.216 2.487 2.487 0 0 0-.36-.18l-.876-.36c-.528-.216-.884-.5-1.068-.852-.176-.36-.264-.808-.264-1.344 0-.32.044-.624.132-.912.088-.288.22-.536.396-.744.168-.208.38-.372.636-.492.264-.128.576-.192.936-.192.304 0 .58.056.828.168.256.112.476.26.66.444.368.384.552.824.552 1.32v.6Z",
          fill: "#fff"
        }
      )
    ]
  }
));
Rust.displayName = "Icon.Language.Rust";

// Icon/Location/Location.ts
var Location_exports = {};
__export(Location_exports, {
  ActionSuspended: () => ActionSuspended,
  Actions: () => Actions,
  AlertAndRespond: () => AlertAndRespond,
  Analytics: () => Analytics,
  AnomalyDetection: () => AnomalyDetection,
  Apm: () => Apm,
  ApplicationServers: () => ApplicationServers,
  Bts: () => Bts,
  BusinessJourneys: () => BusinessJourneys,
  CloudAutoScaling: () => CloudAutoScaling,
  CloudBackend: () => CloudBackend,
  Cluster: () => Cluster,
  CodeIssues: () => CodeIssues,
  Community: () => Community,
  Comparison: () => Comparison,
  Container: () => Container,
  Dashboards: () => Dashboards,
  DataPipeline: () => DataPipeline,
  DbMon: () => DbMon,
  DiagnosticSessions: () => DiagnosticSessions,
  Docs: () => Docs,
  EmailAction: () => EmailAction,
  EmailDigest: () => EmailDigest,
  Eum: () => Eum,
  EumCloud: () => EumCloud,
  EumSessions: () => EumSessions,
  EumWebApp: () => EumWebApp,
  Events: () => Events,
  EventsService: () => EventsService,
  ExperienceLevelManagement: () => ExperienceLevelManagement,
  GetApplication: () => GetApplication,
  HealthRuleViolation: () => HealthRuleViolation,
  HealthRules: () => HealthRules,
  Home: () => Home,
  Host: () => Host,
  HttpAction: () => HttpAction,
  JavascriptErrors: () => JavascriptErrors,
  JobsManager: () => JobsManager,
  JourneyMap: () => JourneyMap,
  LogAnalytics: () => LogAnalytics,
  MetricBrowser: () => MetricBrowser,
  MobileApp: () => MobileApp,
  MobileCrash: () => MobileCrash,
  NetworkRequests: () => NetworkRequests,
  OnDemandPageSnap: () => OnDemandPageSnap,
  Overview: () => Overview,
  Pages: () => Pages,
  PagesAndAjax: () => PagesAndAjax,
  Policies: () => Policies,
  RemoteServices: () => RemoteServices,
  Reports: () => Reports,
  ResourcePerformance: () => ResourcePerformance,
  Searches: () => Searches,
  Servers: () => Servers,
  ServiceAvailability: () => ServiceAvailability,
  ServiceEndPoint: () => ServiceEndPoint,
  Support: () => Support,
  Synthetic: () => Synthetic,
  SyntheticSessions: () => SyntheticSessions,
  TransactionAnalytics: () => TransactionAnalytics,
  Troubleshoot: () => Troubleshoot,
  UserAnalytics: () => UserAnalytics,
  Videos: () => Videos,
  VirtualPages: () => VirtualPages
});

// Icon/Location/Actions.tsx
var import_uik185 = require("@appd/uik");
var import_jsx_runtime175 = require("react/jsx-runtime");
var Actions = import_uik185.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime175.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.Actions",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime175.jsx)("path", { d: "M9.4 2 6 13h4.5v9l7-12h-4l4-8H9.4Z", fill: "#fff", fillOpacity: ".94" })
  }
));
Actions.displayName = "Icon.Location.Actions";

// Icon/Location/ActionSuspended.tsx
var import_uik186 = require("@appd/uik");
var import_jsx_runtime176 = require("react/jsx-runtime");
var ActionSuspended = import_uik186.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime176.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.ActionSuspended",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime176.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M16.093 12.748 17.696 10h-4l4-8H9.655l-1.01 3.293 7.448 7.455Zm2.965 5.821L5.25 4.672 4 5.914l3.392 3.411L6.238 13h4.458v9l3.438-5.894 3.68 3.7 1.244-1.237Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
ActionSuspended.displayName = "Icon.Location.ActionSuspended";

// Icon/Location/AlertAndRespond.tsx
var import_uik187 = require("@appd/uik");
var import_jsx_runtime177 = require("react/jsx-runtime");
var AlertAndRespond = import_uik187.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime177.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.AlertAndRespond",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime177.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M20.317 13.748a2.15 2.15 0 0 0-1.049-1.38l-.97-.54-.661-2.78c-.681-2.866-3.283-4.878-6.387-5.025a1.57 1.57 0 0 0 .002-.7l-.1-.423a1.636 1.636 0 0 0-1.956-1.209l-1.19.272a1.617 1.617 0 0 0-1.223 1.934l.099.424c.059.248.178.466.333.652-2.699 1.501-4.11 4.42-3.427 7.29l.662 2.78-.626.911a2.128 2.128 0 0 0-.316 1.697l.16.674a2.171 2.171 0 0 0 2.578 1.608c.436 1.423 1.86 2.4 3.538 2.4.338 0 .678-.04 1.012-.117 2.059-.477 3.36-2.23 3.043-4.046l5.02-1.165a2.147 2.147 0 0 0 1.619-2.583l-.161-.674Zm-9.928 6.733a2.644 2.644 0 0 1-.63.079c-.766 0-1.402-.375-1.58-1.101l3.702-.863c.226.917-.465 1.632-1.492 1.885ZM5.626 17.16l.16.674 12.574-2.921-.16-.673-1.801-1.003-.881-3.699c-.484-2.038-2.423-3.392-4.621-3.392h-.085l-2.221.515c-2.016.951-3.176 3.045-2.685 5.11l.88 3.698-1.16 1.69Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
AlertAndRespond.displayName = "Icon.Location.AlertAndRespond";

// Icon/Location/Analytics.tsx
var import_uik188 = require("@appd/uik");
var import_jsx_runtime178 = require("react/jsx-runtime");
var Analytics = import_uik188.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime178.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.Analytics",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime178.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M9.975 17H3v-4.822l3.304-2.766c.48.34 1.064.543 1.696.543a2.91 2.91 0 0 0 1.431-.386l2.071 2.293a6.243 6.243 0 0 1 1.129-.989l-2.116-2.342c.274-.448.44-.969.44-1.531A2.958 2.958 0 0 0 8 4.045 2.958 2.958 0 0 0 5.045 7c0 .454.111.879.295 1.263L3 10.222V3h14v6.884a6.166 6.166 0 0 1 2 .647V2.725C19 1.772 18.227 1 17.275 1H2.725C1.772 1 1 1.772 1 2.725v14.55C1 18.228 1.772 19 2.725 19h7.924a6.168 6.168 0 0 1-.674-2ZM7.045 7a.956.956 0 1 1 1.912.002A.956.956 0 0 1 7.045 7Zm15.583 14.232a.932.932 0 0 1-1.318 1.317l-1.677-1.678-1.056-1.053-.065-.068-.197-.197a4.117 4.117 0 0 1-3.46.46c-1.432-.438-2.548-1.664-2.842-3.12a4.207 4.207 0 0 1 .856-3.513 4.166 4.166 0 0 1 3.235-1.534c.287 0 .58.03.867.088 1.457.294 2.683 1.41 3.121 2.843a4.098 4.098 0 0 1-.46 3.459l.197.197.068.065 1.161 1.164 1.57 1.57Zm-4.139-5.207a2.388 2.388 0 0 1-2.385 2.385 2.388 2.388 0 0 1-2.385-2.385 2.388 2.388 0 0 1 2.385-2.385 2.388 2.388 0 0 1 2.385 2.385Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Analytics.displayName = "Icon.Location.Analytics";

// Icon/Location/AnomalyDetection.tsx
var import_uik189 = require("@appd/uik");
var import_jsx_runtime179 = require("react/jsx-runtime");
var AnomalyDetection = import_uik189.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime179.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.AnomalyDetection",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime179.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "m18.656 12.5-2.452-7.8a1 1 0 0 0-1.907-.003l-2.48 7.803h2.099l1.33-4.182 1.313 4.182h2.097Zm-8.387 4.873.913-2.873h2.098l-1.327 4.176a1 1 0 0 1-.953.697H7.56a1 1 0 0 1-.713-.299l-1.59-1.619-1.446 1.59a1 1 0 0 1-.74.328H1v-2h1.628l1.861-2.046a1.004 1.004 0 0 1 1.453-.028l2.037 2.074h2.29Zm9.918 0h2.563v2h-3.297a1 1 0 0 1-.954-.7L17.188 14.5h2.096l.904 2.873Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
AnomalyDetection.displayName = "Icon.Location.AnomalyDetection";

// Icon/Location/Apm.tsx
var import_uik190 = require("@appd/uik");
var import_jsx_runtime180 = require("react/jsx-runtime");
var Apm = import_uik190.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime180.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.Apm",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime180.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M19.33 12.791a3.296 3.296 0 0 1 1.547.832c.589.59.903 1.37.885 2.195a3.007 3.007 0 0 1-.993 2.166 3.05 3.05 0 0 1-2.17.891 3.06 3.06 0 0 1-2.15-.872 1.028 1.028 0 0 1-.375-.404l-3.908 1.181c.036.766-.263 1.47-.89 2.097-.6.6-1.388.9-2.176.9A3.07 3.07 0 0 1 6.025 18.7c0-.825.32-1.598.898-2.177l.007-.006c.08-.08.217-.218.378-.33l-2.2-7.743c-.776-.052-1.53-.42-2-.984-1.185-1.184-1.185-3.136.015-4.337 1.2-1.2 3.154-1.2 4.354 0 .368.369.68.919.824 1.443l6.551.57c.184-.362.383-.724.671-1.013a3.084 3.084 0 0 1 4.354 0c1.2 1.2 1.2 3.153 0 4.354-.113.081-.19.138-.267.197-.187.141-.394.298-.641.4l.361 3.717Zm-2.907.832a2.86 2.86 0 0 1 .909-.59l-.363-3.731a3.422 3.422 0 0 1-1.446-.825 3.009 3.009 0 0 1-.83-1.441L8.148 6.56c-.184.364-.382.728-.671 1.016-.08.079-.221.221-.387.338l2.102 7.74c.85.034 1.509.304 2.058.842.177.1.288.25.376.404l3.928-1.187c.034-.865.312-1.533.869-2.091Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Apm.displayName = "Icon.Location.Apm";

// Icon/Location/ApplicationServers.tsx
var import_uik191 = require("@appd/uik");
var import_jsx_runtime181 = require("react/jsx-runtime");
var ApplicationServers = import_uik191.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime181.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.ApplicationServers",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime181.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M5 19a1 1 0 1 1-2 0V5a1 1 0 1 1 2 0v14Zm12 1.5c0 .825-.675 1.5-1.5 1.5h-7c-.825 0-1.5-.675-1.5-1.5v-17C7 2.675 7.675 2 8.5 2h7c.825 0 1.5.675 1.5 1.5v17Zm4-1.5a1 1 0 1 1-2 0V5a1 1 0 1 1 2 0v14Zm-6 1V4H9v16h6ZM10.5 7.75a.75.75 0 0 1 0-1.5h3a.75.75 0 0 1 0 1.5h-3Zm0 3a.75.75 0 0 1 0-1.5h3a.75.75 0 0 1 0 1.5h-3ZM12 18a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
ApplicationServers.displayName = "Icon.Location.ApplicationServers";

// Icon/Location/Bts.tsx
var import_uik192 = require("@appd/uik");
var import_jsx_runtime182 = require("react/jsx-runtime");
var Bts = import_uik192.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime182.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.Bts",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime182.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M2 12c0 5.514 4.486 10 10 10s10-4.486 10-10S17.514 2 12 2 2 6.486 2 12Zm2 0c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8-8-3.589-8-8Zm9 1.25a.75.75 0 0 1 0 1.5H8.81l.72.72a.75.75 0 1 1-1.06 1.06l-1.999-1.999a.75.75 0 0 1-.163-.245.744.744 0 0 1-.051-.252.066.066 0 0 0-.004-.016L6.25 14a.06.06 0 0 1 .003-.018.066.066 0 0 0 .004-.016.744.744 0 0 1 .05-.252.75.75 0 0 1 .164-.245L8.47 11.47a.75.75 0 1 1 1.06 1.06l-.72.72H13Zm4.529-2.719a.75.75 0 0 0 .163-.245.746.746 0 0 0 .051-.252c0-.006.002-.011.004-.016A.061.061 0 0 0 17.75 10l-.003-.018a.062.062 0 0 1-.004-.016.746.746 0 0 0-.05-.252.75.75 0 0 0-.164-.245L15.53 7.47a.75.75 0 1 0-1.06 1.06l.72.72H11a.75.75 0 0 0 0 1.5h4.19l-.72.72a.749.749 0 1 0 1.06 1.06l1.999-1.999Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Bts.displayName = "Icon.Location.Bts";

// Icon/Location/BusinessJourneys.tsx
var import_uik193 = require("@appd/uik");
var import_jsx_runtime183 = require("react/jsx-runtime");
var BusinessJourneys = import_uik193.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime183.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.BusinessJourneys",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime183.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M18 15.224a2.763 2.763 0 0 0-2.632 1.868H6.78a.877.877 0 0 1-.974-.973V14.25a.877.877 0 0 1 .974-.973h2.991a2.772 2.772 0 0 0 5.263 0h2.781a2.693 2.693 0 0 0 2.746-2.764V8.636a2.693 2.693 0 0 0-2.772-2.763H9.394a2.772 2.772 0 1 0 0 1.798h8.386a.877.877 0 0 1 .982.965v1.869a.877.877 0 0 1-.973.956h-2.755a2.772 2.772 0 0 0-5.263 0H6.78a2.693 2.693 0 0 0-2.772 2.772V16.1a2.693 2.693 0 0 0 2.772 2.772h8.605a2.763 2.763 0 1 0 2.632-3.667l-.018.018ZM6.78 7.74a.974.974 0 1 1 0-1.947.974.974 0 0 1 0 1.947Zm6.529 4.262a.974.974 0 1 0-1.794.758.974.974 0 0 0 1.794-.758Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
BusinessJourneys.displayName = "Icon.Location.BusinessJourneys";

// Icon/Location/CloudAutoScaling.tsx
var import_uik194 = require("@appd/uik");
var import_jsx_runtime184 = require("react/jsx-runtime");
var CloudAutoScaling = import_uik194.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime184.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.CloudAutoScaling",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime184.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M4 5h3V3H2v5h2V5Zm3 14v2H2v-5h2v3h3Zm13-3h2v5h-5v-2h3v-3Zm0-8V5h-3V3h5v5h-2Zm-5.164 3.44v.255h1.035c.845 0 1.528.683 1.528 1.528 0 .846-.683 1.237-1.528 1.237H8.978c-1.125 0-2.037-.62-2.037-1.746s.912-2.038 2.037-2.038h.362a2.802 2.802 0 0 1 5.496.764ZM4.725 12.715a4.261 4.261 0 0 1 3.18-4.116 5.04 5.04 0 0 1 4.13-2.175A5.026 5.026 0 0 1 16.69 9.57a3.75 3.75 0 0 1 2.925 3.653c0 2-1.575 3.452-3.744 3.452H8.978c-2.464 0-4.253-1.666-4.253-3.961Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
CloudAutoScaling.displayName = "Icon.Location.CloudAutoScaling";

// Icon/Location/CloudBackend.tsx
var import_uik195 = require("@appd/uik");
var import_jsx_runtime185 = require("react/jsx-runtime");
var CloudBackend = import_uik195.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime185.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.CloudBackend",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime185.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M12 5c3 0 5.5 2.1 6.1 5 2.2.1 3.9 1.9 3.9 4.1 0 2.3-1.9 4.2-4.2 4.2H7c-2.8 0-5-2.2-5-5 0-2.6 2-4.7 4.5-4.9C7.5 6.4 9.6 5 12 5ZM7 16.6h10.8c1.4 0 2.5-1.1 2.5-2.5 0-1.3-1-2.4-2.3-2.5l-1.3-.1-.2-1.2c-.4-2.2-2.3-3.7-4.5-3.7-1.7 0-3.3.9-4 2.5l-.4.8-.9.1c-1.7.2-3 1.6-3 3.3 0 1.8 1.5 3.3 3.3 3.3Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
CloudBackend.displayName = "Icon.Location.CloudBackend";

// Icon/Location/Cluster.tsx
var import_uik196 = require("@appd/uik");
var import_jsx_runtime186 = require("react/jsx-runtime");
var Cluster = import_uik196.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime186.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.Cluster",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime186.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M21.007 13.304a.212.212 0 0 1-.09.178l-2.15 1.307a.256.256 0 0 1-.16 0l-2.15-1.328s-.06-.063-.06-.105v-2.688a.21.21 0 0 1 .08-.146l2.14-1.308h.099l2.212 1.276c.056.04.09.107.089.178l-.01 2.636Zm-3.312 6.056a.221.221 0 0 1-.089.178l-2.151 1.307a.169.169 0 0 1-.198 0l-2.162-1.307a.199.199 0 0 1-.099-.178v-2.635a.22.22 0 0 1 .12-.19l2.14-1.295h.09l.09.072 2.14 1.307h.06a.192.192 0 0 1 .06.136v2.605Zm-6.682 0a.2.2 0 0 1-.089.178l-2.151 1.307a.169.169 0 0 1-.199 0l-2.141-1.307a.199.199 0 0 1-.1-.178v-2.646a.3.3 0 0 1 0-.095h.08l2.142-1.307.099-.072a.095.095 0 0 1 .08 0l2.16 1.327a.204.204 0 0 1 .09.178v2.615h.03Zm-7.931-5.889a.22.22 0 0 1-.1-.178v-2.625a.223.223 0 0 1 .1-.178l2.161-1.307h.159l2.171 1.338a.157.157 0 0 1 .07.126v2.626a.204.204 0 0 1 0 .104h-.06l-2.171 1.36h-.12l-2.21-1.266Zm3.262-8.87a.19.19 0 0 1 .089-.167l2.132-1.307a.16.16 0 0 1 .099 0 .178.178 0 0 1 .099 0l2.161 1.297a.2.2 0 0 1 .09.177v2.615a.201.201 0 0 1-.11.189L8.763 8.712a.24.24 0 0 1-.149 0L6.433 7.373a.202.202 0 0 1-.07-.136l-.02-2.636Zm6.791-.167 2.142-1.307h.089a.16.16 0 0 1 .099 0l2.141 1.297a.213.213 0 0 1 .1.167v2.625a.241.241 0 0 1-.08.147l-2.19 1.318a.208.208 0 0 1-.16 0l-2.18-1.287a.199.199 0 0 1-.1-.178V4.664a.2.2 0 0 1 .12-.23h.019Zm-.991 10.283-.13.103-.088-.061-2.172-1.34h-.099v-2.814h.1l2.13-1.297.12-.178.109.074 2.151 1.307h.1a.443.443 0 0 0 0 .115v2.71h-.09l-2.131 1.38Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Cluster.displayName = "Icon.Location.Cluster";

// Icon/Location/CodeIssues.tsx
var import_uik197 = require("@appd/uik");
var import_jsx_runtime187 = require("react/jsx-runtime");
var CodeIssues = import_uik197.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime187.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.CodeIssues",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime187.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M22.345 10.167a.998.998 0 0 0 0-1.286l-4.638-5.523a1 1 0 1 0-1.532 1.286l4.099 4.88-2.19 2.606 1.067 1.84 3.194-3.803Zm-6.183 1.635-5.263 9.09h10.526l-5.263-9.09Zm.478 6.699v.957h-.957V18.5h.957Zm0-2.871h-.957v1.914h.957V15.63ZM7.706 3.235a1 1 0 0 1 .123 1.409L3.73 9.524l4.098 4.88a1 1 0 0 1-1.532 1.286L1.66 10.167a.998.998 0 0 1 0-1.286l4.637-5.523a1 1 0 0 1 1.409-.123Zm3.492 12.103 3.35-10.99a1.001 1.001 0 0 0-1.914-.583l-3.35 10.99a1.001 1.001 0 0 0 1.914.583Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
CodeIssues.displayName = "Icon.Location.CodeIssues";

// Icon/Location/Community.tsx
var import_uik198 = require("@appd/uik");
var import_jsx_runtime188 = require("react/jsx-runtime");
var Community = import_uik198.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime188.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.Community",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime188.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M6.284 10.144a3.325 3.325 0 0 1-3.322-3.322A3.325 3.325 0 0 1 6.284 3.5a3.326 3.326 0 0 1 3.321 3.322 3.326 3.326 0 0 1-3.321 3.322Zm0-4.971c-.91 0-1.65.74-1.65 1.649s.74 1.649 1.65 1.649c.91 0 1.65-.74 1.65-1.65 0-.908-.74-1.648-1.65-1.648Zm.311 7.468v-1.673H4.213A3.717 3.717 0 0 0 .5 14.68v.5h1.672v-.5c0-1.125.916-2.04 2.041-2.04h2.382Zm11.08-2.497a3.326 3.326 0 0 1-3.322-3.323c0-1.83 1.49-3.32 3.322-3.32a3.325 3.325 0 0 1 3.322 3.32 3.326 3.326 0 0 1-3.322 3.323Zm-1.65-3.323a1.65 1.65 0 1 1 1.65 1.65c-.91 0-1.65-.74-1.65-1.65Zm3.721 4.147a3.718 3.718 0 0 1 3.713 3.713v.5h-1.672v-.5c0-1.125-.916-2.04-2.04-2.04H17.22v-1.673h2.525Zm-4.69.119a3.318 3.318 0 0 0-6.123-.416c-.23.465-.347.96-.347 1.47a3.326 3.326 0 0 0 3.322 3.322 3.326 3.326 0 0 0 3.322-3.322c0-.356-.058-.71-.174-1.054Zm-3.148 2.703a1.65 1.65 0 0 0 0-3.299c-.909 0-1.649.74-1.649 1.65 0 .909.74 1.649 1.65 1.649ZM17.48 20c0-2.047-1.907-3.713-4.25-3.713h-2.5c-2.344 0-4.25 1.666-4.25 3.713v.5h1.784V20c0-1.125 1.106-2.041 2.466-2.041h2.5c1.359 0 2.464.916 2.464 2.041v.5h1.786V20Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Community.displayName = "Icon.Location.Community";

// Icon/Location/Comparison.tsx
var import_uik199 = require("@appd/uik");
var import_jsx_runtime189 = require("react/jsx-runtime");
var Comparison = import_uik199.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime189.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.Comparison",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime189.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M9.972 4.023V2h2v19.985h-2v-1.99H4a2.006 2.006 0 0 1-2-2V6.023a2.006 2.006 0 0 1 2-2h5.972Zm9.996 0h-5.996v2h5.996v2.684l-4.102 4.14-1.894-.668v2.12l2.424.855 3.572-3.607v6.447h-5.996v2h5.996a2.006 2.006 0 0 0 2-2V6.024a2.006 2.006 0 0 0-2-2Z",
        fill: "#DADADA",
        fillRule: "evenodd"
      }
    )
  }
));
Comparison.displayName = "Icon.Location.Comparison";

// Icon/Location/Container.tsx
var import_uik200 = require("@appd/uik");
var import_jsx_runtime190 = require("react/jsx-runtime");
var Container = import_uik200.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime190.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.Container",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime190.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M22.9 12.5c.1-.7-.4-1.3-1.1-1.3h-2l-4.4-3.1c.1-.2.1-.3.1-.5.2-1.5-.6-2.9-1.9-3.7-.3-.2-.6-.3-.9-.4V3h2l.9-2h-7l.9 2h1.6v.7l-.001.057c-.008.317-.036 1.443.801 1.443 1.1 0 2 .9 2 2s-.9 2-2 2c-.5 0-.9-.2-1.3-.5l1.5-1c.3-.2.4-.7.2-1-.2-.3-.7-.4-1-.2l-1.4 1v-.2c0-.2.1-.8.1-.8.1-.6-.2-1-.7-1h-.1c-.4 0-.8.3-.9.7 0 0 0 .2-.1.5v.7c0 .3.1.7.2 1l-4.2 3h-2c-.6-.1-1.2.4-1.2 1.1v9.3c0 .7.6 1.2 1.2 1.2h19.5c.7 0 1.2-.6 1.2-1.2v-9.3Zm-16-1.2 2.5-1.8c.2.2.4.4.6.5.6.5 1.4.8 2.2.7 1-.1 1.8-.5 2.5-1.2l2.5 1.8H6.9ZM21 21v-7.8H3V21h18ZM6 19.2c0 .5.4 1 1 1s1-.4 1-1v-4.1c0-.6-.4-1-1-1s-1 .4-1 1v4.1Zm6 1c-.6 0-1-.5-1-1v-4.1c0-.6.4-1 1-1s1 .4 1 1v4.1c0 .6-.4 1-1 1Zm4-1c0 .5.4 1 1 1s1-.4 1-1v-4.1c0-.6-.4-1-1-1s-1 .4-1 1v4.1Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Container.displayName = "Icon.Location.Container";

// Icon/Location/Dashboards.tsx
var import_uik201 = require("@appd/uik");
var import_jsx_runtime191 = require("react/jsx-runtime");
var Dashboards = import_uik201.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime191.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.Dashboards",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime191.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M3.016 4h17.968v15.967H3.016V4Zm15.968 2H5.016v4.96h13.968V6ZM11 17.967H5.016v-4.96H11v4.96Zm2 0h5.984v-4.96H13v4.96Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Dashboards.displayName = "Icon.Location.Dashboards";

// Icon/Location/DataPipeline.tsx
var import_uik202 = require("@appd/uik");
var import_jsx_runtime192 = require("react/jsx-runtime");
var DataPipeline = import_uik202.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime192.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.DataPipeline",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime192.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M19.975 17.677h.295c.4 0 .724.325.724.725v2.803c0 .4-.324.725-.724.725h-5.66a.725.725 0 0 1-.724-.724v-2.804a.725.725 0 0 1 .724-.725h.294v-1.956a1.613 1.613 0 0 0-.24-1.055.895.895 0 0 0-.503-.163l-.029.001-3.807.002a6.176 6.176 0 0 1-4.558-1.777 6.685 6.685 0 0 1-1.749-4.54V6.254h-.294A.725.725 0 0 1 3 5.528V2.725A.725.725 0 0 1 3.725 2h5.658a.725.725 0 0 1 .724.725v2.803c0 .4-.324.725-.724.725h-.294v1.986c.002.345.112.68.316.957.271.182.596.266.921.24h3.675a3.19 3.19 0 0 1 .168-.004 5.982 5.982 0 0 1 3.962 1.534 6.233 6.233 0 0 1 1.844 4.755v1.956Zm-3.37 0h1.67v-1.956a4.602 4.602 0 0 0-1.306-3.514 4.254 4.254 0 0 0-2.8-1.075 1.18 1.18 0 0 0-.11.004h-3.733a2.872 2.872 0 0 1-2.134-.748A3.33 3.33 0 0 1 7.39 8.23V6.253H5.72v1.955a4.998 4.998 0 0 0 1.268 3.335 4.462 4.462 0 0 0 3.34 1.263l3.778-.002h.045a2.56 2.56 0 0 1 1.688.631c.56.624.838 1.45.768 2.286v1.956Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
DataPipeline.displayName = "Icon.Location.DataPipeline";

// Icon/Location/DbMon.tsx
var import_uik203 = require("@appd/uik");
var import_jsx_runtime193 = require("react/jsx-runtime");
var DbMon = import_uik203.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime193.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.DbMon",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime193.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M2.698 5.754c.93-2.138 5.136-3.25 9.302-3.25 4.72 0 9.497 1.426 9.497 4.154v10.684c0 .32-.07.62-.195.905-.93 2.136-5.136 3.25-9.302 3.25-4.166 0-8.372-1.114-9.302-3.25a2.231 2.231 0 0 1-.195-.905V6.658s-.007-.37.195-.904ZM16.69 8.35c1.859-.496 2.909-1.214 2.909-1.692 0-.796-2.884-2.255-7.598-2.255S4.402 5.862 4.402 6.658c0 .478 1.05 1.196 2.909 1.692 1.23.33 2.81.564 4.689.564 1.877 0 3.46-.235 4.69-.564ZM4.402 17.342c0 .794 2.884 2.256 7.598 2.256s7.598-1.462 7.598-2.256v-2.754l-.123.066-.033.017c-.77.412-1.709.738-2.753.978-1.44.333-3.065.506-4.689.506s-3.25-.173-4.69-.506c-1.043-.24-1.983-.566-2.751-.978l-.157-.083v2.754ZM19.598 12c0 .478-1.05 1.196-2.909 1.693-1.23.329-2.812.563-4.689.563-1.878 0-3.459-.234-4.69-.563-1.858-.497-2.908-1.215-2.908-1.693V9.245c.034.02.07.038.105.057l.052.027c.768.41 1.708.737 2.752.979 1.439.332 3.065.505 4.689.505s3.25-.173 4.69-.505c1.044-.242 1.983-.568 2.752-.979l.06-.032c.032-.017.065-.034.096-.052V12Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
DbMon.displayName = "Icon.Location.DbMon";

// Icon/Location/DiagnosticSessions.tsx
var import_uik204 = require("@appd/uik");
var import_jsx_runtime194 = require("react/jsx-runtime");
var DiagnosticSessions = import_uik204.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime194.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.DiagnosticSessions",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime194.jsx)(
      "path",
      {
        d: "M7.053 20.29c0 .834.677 1.51 1.511 1.51h9.68a1.51 1.51 0 0 0 1.51-1.51V7.9c1.393-.507 2.464-2.136 1.795-3.87a2.859 2.859 0 0 0-1.888-1.72 2.908 2.908 0 0 0-3.708 2.79c0 1.3.8 2.3 2 2.8v11.9h-8.8v-3c2.6-.5 4.8-2.9 4.8-5.8V5.6c0-1.32-1.08-2.4-2.4-2.4h-.6v-1h-2v3.9h2v-1h.5c.3 0 .5.2.5.5V11c0 2.54-2.398 4.413-4.888 3.774-1.752-.449-2.912-2.127-2.912-3.936V5.6c0-.3.2-.5.5-.5h.5v1h2V2.2h-2v1h-.5c-1.32 0-2.4 1.08-2.4 2.4V11c-.1 2.9 2 5.3 4.8 5.8v3.49Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
DiagnosticSessions.displayName = "Icon.Location.DiagnosticSessions";

// Icon/Location/Docs.tsx
var import_uik205 = require("@appd/uik");
var import_jsx_runtime195 = require("react/jsx-runtime");
var Docs = import_uik205.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime195.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.Docs",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime195.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M5.082 2.27v19.917h14.766V7.623L14.36 2.27H5.082ZM14.9 7.286l.053-2.007 2.062 2.007H14.9ZM6.931 4.27l-.015 16.016h11.047l.015-11-5.031-.031.016-4.985H6.93Zm9.542 6.938H8.426v1.5h8.047v-1.5Zm-8.047 2.675h8.047v1.5H8.426v-1.5Zm4.793 2.617H8.426V18h4.793v-1.5Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Docs.displayName = "Icon.Location.Docs";

// Icon/Location/EmailAction.tsx
var import_uik206 = require("@appd/uik");
var import_jsx_runtime196 = require("react/jsx-runtime");
var EmailAction = import_uik206.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime196.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.EmailAction",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime196.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "m4.147 20.904 3.012-.008v-1.95H4.796a.637.637 0 0 1-.629-.628V7.484c0-.34.288-.628.629-.628h2.363v-1.96H4.147A1.957 1.957 0 0 0 2.183 6.86v12.08c0 1.027.915 1.964 1.964 1.964Zm15.969 0-3.05-.008v-1.95h2.37c.34 0 .628-.288.628-.628V7.484a.637.637 0 0 0-.629-.628h-2.37v-1.96h3.05c1.2 0 1.95.916 1.95 1.964v12.08c0 1.069-.9 1.964-1.95 1.964Zm-8.294-8.147 5.511-3.194c-.135-.386-.467-.662-.858-.662H7.62c-.382 0-.71.263-.849.635l5.052 3.221Zm5.58-2.063-5.583 3.244-5.122-3.27-.004 5.195c0 .57.417 1.038.926 1.038h8.856c.51 0 .926-.467.926-1.038v-5.169Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
EmailAction.displayName = "Icon.Location.EmailAction";

// Icon/Location/EmailDigest.tsx
var import_uik207 = require("@appd/uik");
var import_jsx_runtime197 = require("react/jsx-runtime");
var EmailDigest = import_uik207.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime197.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.EmailDigest",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime197.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M21.4 10.428v11.267c0 .018-18.9.034-18.9.034v-11.3c0-.7.4-1.3.9-1.6l.8-.5v-5.3h15.4v5.3l.9.5c.6.3.9.9.9 1.6ZM6 4.728v6l6 4.4 6-4.4v-6H6Zm10 2H8v1h8v-1Zm-8 2h8v1H8v-1Zm6 3v-1h-4v1h4Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
EmailDigest.displayName = "Icon.Location.EmailDigest";

// Icon/Location/Eum.tsx
var import_uik208 = require("@appd/uik");
var import_jsx_runtime198 = require("react/jsx-runtime");
var Eum = import_uik208.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime198.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.Eum",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime198.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M17 9.396a5 5 0 1 1-10 0 5 5 0 0 1 10 0Zm-2 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0Zm5 11c0-2.21-1.856-4-4.111-4H8.111c-2.255 0-4.111 1.79-4.111 4h2c0-1.089.944-2 2.111-2h7.778c1.167 0 2.111.911 2.111 2h2Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Eum.displayName = "Icon.Location.Eum";

// Icon/Location/EumCloud.tsx
var import_uik209 = require("@appd/uik");
var import_jsx_runtime199 = require("react/jsx-runtime");
var EumCloud = import_uik209.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime199.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.EumCloud",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime199.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M.324 7.146A1.42 1.42 0 0 0 1.74 8.563h14.167c.78 0 1.417-.638 1.417-1.417V4.313c0-.779-.638-1.417-1.417-1.417H1.74A1.42 1.42 0 0 0 .324 4.313v2.833Zm1.888-.471v-1.89h13.223v1.89H2.212Zm10.722 11.331.034.038.027.03a4.728 4.728 0 0 0-2.868 1.822H1.269a.946.946 0 0 1 0-1.89h6.61V16.12H1.74a1.42 1.42 0 0 1-1.416-1.417V11.87c0-.78.637-1.417 1.416-1.417h11.11a5.43 5.43 0 0 0-1.025 1.888H2.212v1.89h9.325c0 .672.114 1.3.317 1.89H9.768v1.886h3.166Zm10.841 4.902c0-1.82-1.52-3.3-3.388-3.3h-6.125c-1.868 0-3.388 1.48-3.388 3.3h1.875c0-.786.679-1.425 1.513-1.425h6.125c.834 0 1.512.64 1.512 1.425h1.876Zm-10.539-8.663a4.093 4.093 0 0 1 4.088-4.088 4.093 4.093 0 0 1 4.088 4.088c0 1.613-.947 2.998-2.307 3.662-.54.265-1.14.426-1.78.426-.642 0-1.24-.161-1.781-.426-1.36-.664-2.308-2.049-2.308-3.662Zm4.088 2.212a2.215 2.215 0 0 1-2.213-2.212c0-1.22.992-2.213 2.213-2.213 1.22 0 2.213.993 2.213 2.213 0 1.22-.992 2.212-2.213 2.212Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
EumCloud.displayName = "Icon.Location.EumCloud";

// Icon/Location/EumSessions.tsx
var import_uik210 = require("@appd/uik");
var import_jsx_runtime200 = require("react/jsx-runtime");
var EumSessions = import_uik210.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime200.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.EumSessions",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime200.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M8.727 11.806a5.455 5.455 0 1 1 0-10.91 5.455 5.455 0 0 1 0 10.91Zm0-8.728a3.273 3.273 0 1 0 0 6.546 3.273 3.273 0 0 0 0-6.546ZM0 18.351c0-2.41 2.025-4.364 4.485-4.364h6.02A8.094 8.094 0 0 0 9.49 16.17H4.485c-1.273 0-2.303.993-2.303 2.182H0Zm17.087-5.967a5.978 5.978 0 0 1 5.974 5.967 5.978 5.978 0 0 1-5.974 5.967 5.972 5.972 0 0 1-5.963-5.967 5.972 5.972 0 0 1 5.963-5.967Zm4.29 5.967a4.288 4.288 0 0 0-4.285-4.284 4.288 4.288 0 0 0-4.284 4.284 4.288 4.288 0 0 0 4.284 4.284 4.288 4.288 0 0 0 4.284-4.284Zm-3.641-2.86V18.3l2.41 1.43-.669 1.098-3.055-1.833v-3.502h1.314Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
EumSessions.displayName = "Icon.Location.EumSessions";

// Icon/Location/EumWebApp.tsx
var import_uik211 = require("@appd/uik");
var import_jsx_runtime201 = require("react/jsx-runtime");
var EumWebApp = import_uik211.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime201.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.EumWebApp",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime201.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M12 2.896c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10Zm1.651 12.017a2.063 2.063 0 0 1 1.377 1.942c0 .03-.005.058-.008.086a.954.954 0 0 0-.007.06h.29c.99.212 2.063.377 3.25.47a7.948 7.948 0 0 0 1.343-3.346 30.36 30.36 0 0 0-5.28-4.014c-.125.17-.275.32-.446.444a2.055 2.055 0 0 1-.584.291l-.003-.186-1 .015.004.241c-.069-.012-.134-.032-.2-.052l-.026-.009a2.05 2.05 0 0 1-.696-.367 30.323 30.323 0 0 0-2.053 2.234c.241.33.388.734.388 1.175 0 .339-.093.653-.242.934.46.293.962.574 1.51.837a2.065 2.065 0 0 1 1.106-.788c.09-.027.18-.049.275-.063l.018 1.087 1-.015-.016-.976Zm3.15-8.4a7.983 7.983 0 0 1 3.196 6.327 30.57 30.57 0 0 0-4.996-3.689l.007-.053c.01-.07.02-.14.02-.213 0-.377-.109-.725-.284-1.029A21.84 21.84 0 0 1 16.8 6.512ZM12 4.895c-1.661 0-3.206.51-4.486 1.38 1.403.25 2.735.652 3.98 1.146a2.051 2.051 0 0 1 2.531-.302c.708-.52 1.335-.93 1.834-1.227A7.947 7.947 0 0 0 12 4.896Zm-7.091 4.31c.404-.772.93-1.47 1.552-2.068 1.593.203 3.109.623 4.518 1.176-.053.182-.09.371-.09.57 0 .278.057.542.156.784a30.848 30.848 0 0 0-2.22 2.411A1.984 1.984 0 0 0 8 11.896c-.438 0-.84.145-1.17.384-1.014-1.213-1.568-2.343-1.888-3.006l-.017-.035-.016-.032ZM4 12.897a7.95 7.95 0 0 0 1.306 4.368 35.9 35.9 0 0 1 1.21-2.038A1.984 1.984 0 0 1 6 13.896c0-.294.067-.57.181-.822a13.847 13.847 0 0 1-1.784-2.655A7.959 7.959 0 0 0 4 12.896Zm13.778 5.518A7.971 7.971 0 0 1 12 20.896a7.977 7.977 0 0 1-6.028-2.756 34.53 34.53 0 0 1 1.383-2.36c.203.07.418.117.645.117.39 0 .752-.117 1.06-.311.558.365 1.171.714 1.853 1.037a2.857 2.857 0 0 1-.009.066 1.203 1.203 0 0 0-.015.166 2.07 2.07 0 0 0 2.07 2.069 2.06 2.06 0 0 0 1.77-1.014c.936.217 1.943.392 3.05.504Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
EumWebApp.displayName = "Icon.Location.EumWebApp";

// Icon/Location/Events.tsx
var import_uik212 = require("@appd/uik");
var import_jsx_runtime202 = require("react/jsx-runtime");
var Events = import_uik212.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime202.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.Events",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime202.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M19 4.896h-1v-1a1 1 0 1 0-2 0v1H8v-1a1 1 0 1 0-2 0v1H5c-1.11 0-1.99.9-1.99 2l-.01 14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2Zm-10 7v2H7v-2h2Zm0 4v2H7v-2h2Zm-4 5h14v-11H5v11Zm6.063-5v2h5.845v-2h-5.846Zm0-4v2h5.845v-2h-5.846Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Events.displayName = "Icon.Location.Events";

// Icon/Location/EventsService.tsx
var import_uik213 = require("@appd/uik");
var import_jsx_runtime203 = require("react/jsx-runtime");
var EventsService = import_uik213.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime203.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.EventsService",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime203.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M1.5 8.723c-.825 0-1.5-.675-1.5-1.5v-3c0-.825.675-1.5 1.5-1.5h15c.825 0 1.5.675 1.5 1.5v3c0 .825-.675 1.5-1.5 1.5h-15Zm.5-4v2h14v-2H2Zm9.283 13.999H10v-2h.928l-.001-.016-.001-.018c0-.689.12-1.348.332-1.965H2v-2h10.409a6.046 6.046 0 0 1 3.529-2H1.5c-.825 0-1.5.675-1.5 1.5v3c0 .825.675 1.5 1.5 1.5H8v1.999H1a1 1 0 1 0 0 2h11.472a6.048 6.048 0 0 1-1.189-2Zm12.228 3.172a.932.932 0 0 1-1.317 1.317l-1.677-1.677-1.056-1.053-.065-.067-.198-.198a4.117 4.117 0 0 1-3.459.46c-1.433-.439-2.549-1.664-2.843-3.121a4.207 4.207 0 0 1 .856-3.513 4.165 4.165 0 0 1 3.235-1.533c.288 0 .58.03.868.088 1.457.294 2.682 1.41 3.12 2.842a4.098 4.098 0 0 1-.46 3.46l.199.198.066.064 2.731 2.733Zm-4.138-5.206a2.388 2.388 0 0 1-2.386 2.385 2.388 2.388 0 0 1-2.385-2.385 2.388 2.388 0 0 1 2.385-2.386 2.388 2.388 0 0 1 2.386 2.386Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
EventsService.displayName = "Icon.Location.EventsService";

// Icon/Location/ExperienceLevelManagement.tsx
var import_uik214 = require("@appd/uik");
var import_jsx_runtime204 = require("react/jsx-runtime");
var ExperienceLevelManagement = import_uik214.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime204.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.ExperienceLevelManagement",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime204.jsx)(
        "path",
        {
          d: "M7.54 17.037A6.34 6.34 0 0 1 5 14.287a5.94 5.94 0 0 1-.36-.91h.55a1 1 0 1 0 0-2h-.87a6.39 6.39 0 0 1 1.27-3.74l.89.93a1 1 0 0 0 .72.33 1 1 0 0 0 .7-.28 1 1 0 0 0 0-1.41l-.9-.97c.292-.207.6-.391.92-.55a6.4 6.4 0 0 1 2.75-.64l-.06 1.29a1 1 0 1 0 2 0l.05-1.08a6.45 6.45 0 0 1 3.86 3.31 6.6 6.6 0 0 1 .6 2.05h2.18a8.81 8.81 0 0 0-.83-3A8.59 8.59 0 1 0 6 18.596l1.54-1.56Zm14.23-4.241a1.07 1.07 0 0 0-.19-.28.998.998 0 0 0-.28-.19 1 1 0 0 0-.38-.08h-3.78a1 1 0 1 0 0 2h1.33l-4.32 4.26-2.15-2.32a1 1 0 0 0-.71-.31 1 1 0 0 0-.71.3l-5.11 5a1 1 0 0 0 0 1.41 1 1 0 0 0 1.41 0l4.39-4.31 2.18 2.26a1 1 0 0 0 .72.31 1 1 0 0 0 .72-.31l5-5v1.36a1 1 0 0 0 1 1 1 1 0 0 0 .69-.29 1 1 0 0 0 .29-.7v-3.73a1 1 0 0 0-.1-.38Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime204.jsx)(
        "path",
        {
          d: "M15.26 8.316a.78.78 0 0 1 0 1.08l-.9 1.11-1.1 1.28c.015.133.015.268 0 .4a2 2 0 1 1-2-2c.183.002.364.03.54.08l1.29-1.02 1.09-.93a.79.79 0 0 1 1.08 0Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
ExperienceLevelManagement.displayName = "Icon.Location.ExperienceLevelManagement";

// Icon/Location/GetApplication.tsx
var import_uik215 = require("@appd/uik");
var import_jsx_runtime205 = require("react/jsx-runtime");
var GetApplication = import_uik215.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime205.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.GetApplication",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime205.jsx)(
      "path",
      {
        d: "M4 5a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5Zm0 9a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-5Zm9 0a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-5Zm7-7h-3V4h-1v3h-3v1h3v3h1V8h3V7Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
GetApplication.displayName = "Icon.Location.GetApplication";

// Icon/Location/HealthRules.tsx
var import_uik216 = require("@appd/uik");
var import_jsx_runtime206 = require("react/jsx-runtime");
var HealthRules = import_uik216.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime206.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.HealthRules",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime206.jsx)(
        "path",
        {
          d: "M8.5 12.889a2.05 2.05 0 0 1 1.5-3.5 2 2 0 0 1 1.4.61l.6.59.6-.6a2.05 2.05 0 1 1 2.9 2.9l-3.5 3.5-3.5-3.5Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime206.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "m12 1.229-9 4v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12v-6l-9-4Zm0 2.19 7 3.11v4.7a10.47 10.47 0 0 1-7 9.93 10.47 10.47 0 0 1-7-9.93v-4.7l7-3.11Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
HealthRules.displayName = "Icon.Location.HealthRules";

// Icon/Location/HealthRuleViolation.tsx
var import_uik217 = require("@appd/uik");
var import_jsx_runtime207 = require("react/jsx-runtime");
var HealthRuleViolation = import_uik217.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime207.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.HealthRuleViolation",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime207.jsx)("path", { d: "M13 7.579v6h-2v-6h2Zm-1 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z", fill: "#fff", fillOpacity: ".94" }),
      /* @__PURE__ */ (0, import_jsx_runtime207.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "m3 5.229 9-4 9 4v6c0 5.55-3.84 10.74-9 12-5.16-1.26-9-6.45-9-12v-6Zm16 1.3-7-3.11-7 3.11v4.7a10.47 10.47 0 0 0 7 9.93 10.47 10.47 0 0 0 7-9.93v-4.7Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
HealthRuleViolation.displayName = "Icon.Location.HealthRuleViolation";

// Icon/Location/Home.tsx
var import_uik218 = require("@appd/uik");
var import_jsx_runtime208 = require("react/jsx-runtime");
var Home = import_uik218.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime208.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.Home",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime208.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "m21.165 11.886-9.289-8.948-9.203 8.948 1.363 1.363 7.84-7.584 7.84 7.584 1.449-1.363Zm-9.289-3.41-5.795 5.71v6.818h3.835v-5.028h3.92v5.028h3.92v-6.818l-5.88-5.71Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Home.displayName = "Icon.Location.Home";

// Icon/Location/Host.tsx
var import_uik219 = require("@appd/uik");
var import_jsx_runtime209 = require("react/jsx-runtime");
var Host = import_uik219.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime209.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.Host",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime209.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M3 6.893c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5v-3c0-.825-.675-1.5-1.5-1.5h-15c-.825 0-1.5.675-1.5 1.5v3Zm16.5 3.5c.825 0 1.5.675 1.5 1.5v3c0 .825-.675 1.5-1.5 1.5h-15c-.825 0-1.5-.675-1.5-1.5v-3c0-.825.675-1.5 1.5-1.5h15Zm-.5 4v-2H5v2h14Zm-14-10v2h14v-2H5Zm3.116 15H4a1 1 0 1 0 0 2h4.116a3.977 3.977 0 0 1-.141-1c0-.347.058-.678.14-1Zm11.884 0a1 1 0 1 1 0 2h-4.116c.083-.322.141-.653.141-1s-.057-.678-.14-1H20Zm-5.514 0A2.682 2.682 0 0 0 12 17.71a2.68 2.68 0 0 0-2.486 1.684c-.125.31-.198.646-.198 1s.073.69.198 1A2.682 2.682 0 0 0 12 23.077a2.68 2.68 0 0 0 2.486-1.684c.125-.31.198-.646.198-1s-.073-.69-.198-1Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Host.displayName = "Icon.Location.Host";

// Icon/Location/HttpAction.tsx
var import_uik220 = require("@appd/uik");
var import_jsx_runtime210 = require("react/jsx-runtime");
var HttpAction = import_uik220.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime210.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.HttpAction",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime210.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "m7.16 20.229-3.013.008c-1.049 0-1.964-.938-1.964-1.966V6.193c0-1.07.853-1.964 1.964-1.964h3.012v1.96H4.796a.637.637 0 0 0-.629.628V17.65c0 .34.288.628.629.628h2.363v1.95Zm9.905 0 3.05.008c1.05 0 1.95-.896 1.95-1.966V6.193c0-1.049-.75-1.964-1.95-1.964h-3.05v1.96h2.37c.34 0 .629.287.629.628V17.65c0 .34-.288.628-.629.628h-2.37v1.95Zm-7.62-9.161a2.53 2.53 0 0 1 4.962.69v.23h.934c.763 0 1.379.616 1.379 1.379s-.616 1.116-1.38 1.116H9.12c-1.017 0-1.84-.56-1.84-1.576s.823-1.84 1.84-1.84h.326Zm6.636-1a4.537 4.537 0 0 0-4.203-2.84 4.55 4.55 0 0 0-3.727 1.963 3.846 3.846 0 0 0-2.871 3.716c0 2.072 1.615 3.576 3.84 3.576h6.22c1.959 0 3.38-1.31 3.38-3.116 0-1.61-1.13-2.96-2.64-3.298Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
HttpAction.displayName = "Icon.Location.HttpAction";

// Icon/Location/JavascriptErrors.tsx
var import_uik221 = require("@appd/uik");
var import_jsx_runtime211 = require("react/jsx-runtime");
var JavascriptErrors = import_uik221.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime211.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.JavascriptErrors",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime211.jsx)(
        "path",
        {
          d: "m17.615 3.627 4.45 5.294a.96.96 0 0 1 0 1.228l-3.06 3.654-1.025-1.765 2.1-2.503-3.932-4.68a.96.96 0 1 1 1.467-1.228ZM7.324 3.284a.96.96 0 0 1 .7.218h.001a.96.96 0 0 1 .115 1.352l-3.923 4.68 3.923 4.68a.96.96 0 0 1-1.468 1.238l-4.45-5.304a.96.96 0 0 1 0-1.227l4.45-5.294.002-.002a.96.96 0 0 1 .65-.341Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime211.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M18.343 14.63a3.392 3.392 0 1 0 0 4.797v-.001a3.392 3.392 0 0 0 0-4.797Zm-1.439 3.836-.96-.96-.96.96-.478-.478.96-.96-.96-.96.478-.479.96.96.96-.96.479.478-.96.96.96.96-.479.479Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime211.jsx)(
        "path",
        {
          d: "M14.585 4.576a.959.959 0 0 0-1.832-.527L9.54 14.599a.96.96 0 0 0 .633 1.198.957.957 0 0 0 .287 0 .959.959 0 0 0 .912-.671l3.213-10.55Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
JavascriptErrors.displayName = "Icon.Location.JavascriptErrors";

// Icon/Location/JobsManager.tsx
var import_uik222 = require("@appd/uik");
var import_jsx_runtime212 = require("react/jsx-runtime");
var JobsManager = import_uik222.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime212.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.JobsManager",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime212.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M1.5 3.229c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5Zm0 6c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5Zm1.5 7.5c0-.82-.67-1.5-1.5-1.5s-1.5.68-1.5 1.5.68 1.5 1.5 1.5 1.5-.68 1.5-1.5Zm1.5-1h5.046v2H4.5v-2Zm0-6v2h14v-2h-14Zm0-6h14v2h-14v-2Zm19 12-1.5-1.5-5.49 5.5-3.01-3-1.5 1.5 4.51 4.5 6.99-7Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
JobsManager.displayName = "Icon.Location.JobsManager";

// Icon/Location/JourneyMap.tsx
var import_uik223 = require("@appd/uik");
var import_jsx_runtime213 = require("react/jsx-runtime");
var JourneyMap = import_uik223.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime213.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.JourneyMap",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime213.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M16.29 11.229h4.42A1.29 1.29 0 0 0 22 9.939v-5.42a1.29 1.29 0 0 0-1.29-1.29h-4.42A1.29 1.29 0 0 0 15 4.519v1.71h-2a2 2 0 0 0-2 2v3H9v-1.65a1.34 1.34 0 0 0-1.35-1.35h-4.3A1.34 1.34 0 0 0 2 9.579v5.3a1.34 1.34 0 0 0 1.35 1.35h4.3A1.34 1.34 0 0 0 9 14.879v-1.65h2v3a2 2 0 0 0 2 2h2v1.71c0 .712.578 1.29 1.29 1.29h4.42a1.29 1.29 0 0 0 1.29-1.29v-5.42a1.29 1.29 0 0 0-1.29-1.29h-4.42a1.29 1.29 0 0 0-1.29 1.29v1.71h-2v-8h2v1.71c0 .712.578 1.29 1.29 1.29Zm-9.29 3H4v-4h3v4Zm13 1h-3v4h3v-4Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
JourneyMap.displayName = "Icon.Location.JourneyMap";

// Icon/Location/LogAnalytics.tsx
var import_uik224 = require("@appd/uik");
var import_jsx_runtime214 = require("react/jsx-runtime");
var LogAnalytics = import_uik224.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime214.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.LogAnalytics",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime214.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M11.987 10.056H5v-1.5h6.987v1.5ZM3 17.23h7.257c.142.725.421 1.4.808 2h-8.34A1.725 1.725 0 0 1 1 17.503V2.953C1 2 1.772 1.23 2.725 1.23h14.55A1.723 1.723 0 0 1 19 2.953v8.325a5.704 5.704 0 0 0-2-.807V3.229H3v14Zm2-4.173v-1.5h7.4a5.773 5.773 0 0 0-1.365 1.5H5Zm0-7.5h9v1.5H5v-1.5Zm17.586 15.941a.932.932 0 0 1-1.318 1.317l-1.677-1.678-1.056-1.053-.065-.068-.197-.197a4.118 4.118 0 0 1-3.46.46c-1.432-.438-2.548-1.663-2.842-3.12a4.207 4.207 0 0 1 .856-3.513 4.166 4.166 0 0 1 3.235-1.533c.288 0 .58.03.867.087 1.458.294 2.683 1.41 3.122 2.843a4.098 4.098 0 0 1-.461 3.459l.197.197.068.066 1.162 1.164 1.569 1.569Zm-6.524-2.822a2.388 2.388 0 0 0 2.385-2.385 2.388 2.388 0 0 0-2.385-2.385 2.388 2.388 0 0 0-2.385 2.385 2.388 2.388 0 0 0 2.385 2.386Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
LogAnalytics.displayName = "Icon.Location.LogAnalytics";

// Icon/Location/MetricBrowser.tsx
var import_uik225 = require("@appd/uik");
var import_jsx_runtime215 = require("react/jsx-runtime");
var MetricBrowser = import_uik225.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime215.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.MetricBrowser",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime215.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M10.25 3.229v14H14v-14h-3.75Zm-6 8v6H8v-6H4.25Zm12 6v-8H20v8h-3.75Zm-13.25 2v2h18v-2H3Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
MetricBrowser.displayName = "Icon.Location.MetricBrowser";

// Icon/Location/MobileApp.tsx
var import_uik226 = require("@appd/uik");
var import_jsx_runtime216 = require("react/jsx-runtime");
var MobileApp = import_uik226.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime216.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.MobileApp",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime216.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M16.5 2.229c.8 0 1.4.7 1.4 1.6v15.8c0 .9-.6 1.6-1.4 1.6H8.4c-.8 0-1.4-.7-1.4-1.6v-15.8c0-.9.6-1.6 1.4-1.6h8.1Zm-.4 17.1v-15.2H8.8v15.2h7.3Zm-2.2-14h-3v1h3v-1Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
MobileApp.displayName = "Icon.Location.MobileApp";

// Icon/Location/MobileCrash.tsx
var import_uik227 = require("@appd/uik");
var import_jsx_runtime217 = require("react/jsx-runtime");
var MobileCrash = import_uik227.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime217.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.MobileCrash",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime217.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M6.8 4.129v15.2H9v1.9H6.4c-.8 0-1.4-.7-1.4-1.6v-15.8c0-.9.6-1.6 1.4-1.6h8.1c.8 0 1.4.7 1.4 1.6v9.4h-1.8v-9.1H6.8Zm2.1 1.2h3v1h-3v-1Zm7.26 13.389 2.321-2.322-1.288-1.287-2.32 2.322-2.322-2.322-1.287 1.287 2.321 2.322-2.321 2.321 1.287 1.288 2.321-2.321 2.321 2.321 1.288-1.288-2.32-2.321Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
MobileCrash.displayName = "Icon.Location.MobileCrash";

// Icon/Location/NetworkRequests.tsx
var import_uik228 = require("@appd/uik");
var import_jsx_runtime218 = require("react/jsx-runtime");
var NetworkRequests = import_uik228.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime218.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.NetworkRequests",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime218.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M11.063 2.729c.8 0 1.4.7 1.4 1.6v15.8c0 .9-.6 1.6-1.4 1.6h-8.1c-.8 0-1.4-.7-1.4-1.6v-15.8c0-.9.6-1.6 1.4-1.6h8.1Zm-7.7 1.9v15.2h7.3v-15.2h-7.3Zm5.1 2.2h-3v-1h3v1Zm11.136 2.335h-4.09a.886.886 0 0 1-.891-.88c0-.486.4-.88.892-.88h4.09l-1.154-1.138a.872.872 0 0 1 0-1.245.9.9 0 0 1 1.261 0l2.676 2.64a.873.873 0 0 1 0 1.245l-2.675 2.64a.9.9 0 0 1-1.262 0 .872.872 0 0 1 0-1.245L19.6 9.164Zm-1.936 6.425h4.09c.492 0 .891.393.891.88 0 .485-.4.88-.892.88h-4.09l1.154 1.137a.873.873 0 0 1 0 1.245.9.9 0 0 1-1.261 0l-2.676-2.64a.872.872 0 0 1 0-1.245l2.676-2.64a.9.9 0 0 1 1.26 0 .871.871 0 0 1 0 1.245l-1.152 1.138Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
NetworkRequests.displayName = "Icon.Location.NetworkRequests";

// Icon/Location/OnDemandPageSnap.tsx
var import_uik229 = require("@appd/uik");
var import_jsx_runtime219 = require("react/jsx-runtime");
var OnDemandPageSnap = import_uik229.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime219.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.OnDemandPageSnap",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime219.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M4 18.229v-14h14v8.11h2V3.954C20 3 19.227 2.23 18.275 2.23H3.725A1.722 1.722 0 0 0 2 3.953v14.55c0 .953.772 1.726 1.725 1.726H9.78v-2H4Zm8-4.173v-1.5H6v1.5h6Zm11.14 9.18H11.712v-7.514h3.204l.949-1.421 3.176-.002.857 1.317a.23.23 0 0 0 .102.082.23.23 0 0 0 .094.024h3.046v7.514ZM18 16.866a2.47 2.47 0 0 0-.574-.074c-.996 0-1.85.59-2.25 1.436a2.467 2.467 0 0 0-.243 1.057 2.494 2.494 0 0 0 2.493 2.493 2.496 2.496 0 0 0 2.493-2.493.99.99 0 0 0-.012-.135 1.583 1.583 0 0 1-.01-.08A2.486 2.486 0 0 0 18 16.865Zm.65 3.32c-.278.376-.72.623-1.224.623-.484 0-.91-.23-1.188-.58a1.51 1.51 0 0 1-.336-.944c0-.411.164-.782.429-1.056a1.517 1.517 0 0 1 1.67-.354 1.513 1.513 0 0 1 .649 2.31ZM6 6.555h7.04v1.5H6v-1.5Zm9 3H6v1.5h9v-1.5Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
OnDemandPageSnap.displayName = "Icon.Location.OnDemandPageSnap";

// Icon/Location/Overview.tsx
var import_uik230 = require("@appd/uik");
var import_jsx_runtime220 = require("react/jsx-runtime");
var Overview = import_uik230.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime220.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.Overview",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime220.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M3.25 4C3.25 2.48122 4.48122 1.25 6 1.25H18C19.5188 1.25 20.75 2.48122 20.75 4V20C20.75 21.5188 19.5188 22.75 18 22.75H6C4.48122 22.75 3.25 21.5188 3.25 20V4ZM6 2.75C5.30964 2.75 4.75 3.30964 4.75 4V20C4.75 20.6904 5.30964 21.25 6 21.25H18C18.6904 21.25 19.25 20.6904 19.25 20V4C19.25 3.30964 18.6904 2.75 18 2.75H6Z",
          fill: "#7E868F",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime220.jsx)(
        "path",
        {
          d: "M9.5 6.5C9.5 5.94772 9.94772 5.5 10.5 5.5C11.0523 5.5 11.5 5.94772 11.5 6.5V11.5C11.5 12.0523 11.0523 12.5 10.5 12.5C9.94772 12.5 9.5 12.0523 9.5 11.5V6.5Z",
          fill: "#7E868F"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime220.jsx)(
        "path",
        {
          d: "M15.5 6.5C15.5 5.94772 15.9477 5.5 16.5 5.5C17.0523 5.5 17.5 5.94772 17.5 6.5V11.5C17.5 12.0523 17.0523 12.5 16.5 12.5C15.9477 12.5 15.5 12.0523 15.5 11.5V6.5Z",
          fill: "#7E868F"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime220.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M6.25 15.5C6.25 15.0858 6.58579 14.75 7 14.75H16C16.4142 14.75 16.75 15.0858 16.75 15.5C16.75 15.9142 16.4142 16.25 16 16.25H7C6.58579 16.25 6.25 15.9142 6.25 15.5Z",
          fill: "#A7ADB5",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime220.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M6.25 18.5C6.25 18.0858 6.58579 17.75 7 17.75H13C13.4142 17.75 13.75 18.0858 13.75 18.5C13.75 18.9142 13.4142 19.25 13 19.25H7C6.58579 19.25 6.25 18.9142 6.25 18.5Z",
          fill: "#A7ADB5",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime220.jsx)(
        "path",
        {
          d: "M6.5 9.5C6.5 8.94772 6.94772 8.5 7.5 8.5C8.05228 8.5 8.5 8.94772 8.5 9.5V11.5C8.5 12.0523 8.05228 12.5 7.5 12.5C6.94772 12.5 6.5 12.0523 6.5 11.5V9.5Z",
          fill: "#A7ADB5"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime220.jsx)(
        "path",
        {
          d: "M12.5 8.5C12.5 7.94772 12.9477 7.5 13.5 7.5C14.0523 7.5 14.5 7.94772 14.5 8.5V11.5C14.5 12.0523 14.0523 12.5 13.5 12.5C12.9477 12.5 12.5 12.0523 12.5 11.5V8.5Z",
          fill: "#A7ADB5"
        }
      )
    ]
  }
));
Overview.displayName = "Icon.Location.Overview";

// Icon/Location/Pages.tsx
var import_uik231 = require("@appd/uik");
var import_jsx_runtime221 = require("react/jsx-runtime");
var Pages = import_uik231.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime221.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.Pages",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime221.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M20 18.229h3v2H1v-2h3c-1.1 0-2-.9-2-2v-10c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2l-.01 10c0 1.1-.89 2-1.99 2Zm0-12H4v10h16v-10Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Pages.displayName = "Icon.Location.Pages";

// Icon/Location/PagesAndAjax.tsx
var import_uik232 = require("@appd/uik");
var import_jsx_runtime222 = require("react/jsx-runtime");
var PagesAndAjax = import_uik232.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime222.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.PagesAndAjax",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime222.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M20 18.229h3v2H1v-2h3c-1.1 0-2-.9-2-2v-10c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2l-.01 10c0 1.1-.89 2-1.99 2Zm0-12H4v10h16v-10Zm-8.25 6.5H7.56l.72.72a.749.749 0 1 1-1.06 1.06l-2-1.999a.75.75 0 0 1-.001-1.062l2-2a.749.749 0 1 1 1.06 1.06l-.72.72h4.19a.75.75 0 0 1 0 1.5Zm6.692-2.465a.737.737 0 0 0 .043-.211.186.186 0 0 1 .007-.033.142.142 0 0 0 .008-.041c0-.012-.003-.023-.006-.034-.003-.01-.006-.018-.006-.028a.756.756 0 0 0-.046-.224.75.75 0 0 0-.163-.246l-2-1.999a.75.75 0 1 0-1.06 1.06l.72.72H11.75a.75.75 0 0 0 0 1.5h4.189l-.72.72a.75.75 0 1 0 1.06 1.06l2-2a.744.744 0 0 0 .163-.244Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
PagesAndAjax.displayName = "Icon.Location.PagesAndAjax";

// Icon/Location/Policies.tsx
var import_uik233 = require("@appd/uik");
var import_jsx_runtime223 = require("react/jsx-runtime");
var Policies = import_uik233.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime223.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.Policies",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime223.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M18.5 12.299v6.93h-14v-14h12.055s1.963-2 1.945-2h-14c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-8.93l-2 2Zm3.7-6.57-1.6-1.7-8.9 9-4.2-4.2-1.6 1.6 5.8 5.9 10.5-10.6Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Policies.displayName = "Icon.Location.Policies";

// Icon/Location/RemoteServices.tsx
var import_uik234 = require("@appd/uik");
var import_jsx_runtime224 = require("react/jsx-runtime");
var RemoteServices = import_uik234.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime224.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.RemoteServices",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime224.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M24 13.729c0-2.64-2.051-4.78-4.65-4.96A7.49 7.49 0 0 0 12 2.728c-2.891 0-5.4 1.64-6.65 4.04A5.994 5.994 0 0 0 0 12.729c0 3.31 2.689 6 6 6h3.113v-2H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h.71a5.5 5.5 0 0 1 10.79 1.5v.5H19c1.66 0 3 1.34 3 3s-1.34 3-3 3h-4.209v2H19c2.76 0 5-2.24 5-5Zm-9.751-.547c.33.17.74.127 1.017-.153a.9.9 0 0 0 0-1.261l-2.64-2.676a.872.872 0 0 0-1.244 0l-2.64 2.676a.9.9 0 0 0 0 1.26.863.863 0 0 0 1.007.16.863.863 0 0 0 .237-.16l1.138-1.152v8.09c0 .492.394.891.88.891s.88-.399.88-.891v-8.09l1.137 1.153a.857.857 0 0 0 .228.153Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
RemoteServices.displayName = "Icon.Location.RemoteServices";

// Icon/Location/Reports.tsx
var import_uik235 = require("@appd/uik");
var import_jsx_runtime225 = require("react/jsx-runtime");
var Reports = import_uik235.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime225.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.Reports",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime225.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M7.07 20.244V.327h9.279l5.488 5.353v14.564H7.071Zm9.872-16.907-.053 2.006h2.115l-2.062-2.006ZM8.905 18.343 8.92 2.327h6.031l-.015 4.985 5.031.031-.015 11H8.904Zm1.549-4.902h1.5v2.928h-1.5v-2.928Zm3.646 1.116h-1.5v1.812h1.5v-1.812Zm.792-2.3h1.5v4.112h-1.5v-4.112Zm3.525 1.342h-1.5v2.77h1.5V13.6Zm-8.002-4.334h8.047v1.5h-8.047v-1.5Zm5.528 14.963v-2h-11v-13h-2v15h13Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Reports.displayName = "Icon.Location.Reports";

// Icon/Location/ResourcePerformance.tsx
var import_uik236 = require("@appd/uik");
var import_jsx_runtime226 = require("react/jsx-runtime");
var ResourcePerformance = import_uik236.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime226.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.ResourcePerformance",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime226.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M5.846 4.326 5.83 20.342h3.241c-.062.482-.105.97-.105 1.47 0 .087.006.173.012.259l.01.172H5.966a1.97 1.97 0 0 1-1.97-1.97V4.153c0-1.009.818-1.827 1.828-1.827h7.45l5.489 5.352v2.842c-.643.092-1.27.229-1.873.423l.003-1.601-5.032-.032.016-4.984H5.846Zm10.083 3.016-2.061-2.007-.053 2.007h2.114Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime226.jsx)(
        "path",
        {
          d: "M19.073 18.975a1.463 1.463 0 0 0-.31-.03h-.008l-.936-.973-.816-.8a.416.416 0 0 0-.096-.078.616.616 0 0 0-.765-.004.632.632 0 0 0-.081.86l.658.938.715 1.105a1.6 1.6 0 0 0-.105.424 1.593 1.593 0 0 0 .69 1.463c.217.15.47.254.752.281a1.6 1.6 0 1 0 .302-3.186Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime226.jsx)(
        "path",
        {
          d: "M16.887 13.06a9.954 9.954 0 0 1 3.849-.775v1.8c-.681 0-1.34.093-1.974.251a8.106 8.106 0 0 0-1.877.719 8.18 8.18 0 0 0-4.072 5.287 8.12 8.12 0 0 0-.232 1.898h-1.8a9.987 9.987 0 0 1 6.107-9.18Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
ResourcePerformance.displayName = "Icon.Location.ResourcePerformance";

// Icon/Location/Searches.tsx
var import_uik237 = require("@appd/uik");
var import_jsx_runtime227 = require("react/jsx-runtime");
var Searches = import_uik237.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime227.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.Searches",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime227.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M18 4.229v7.24c.725.14 1.4.418 2 .804v-8.32c0-.952-.773-1.724-1.725-1.724H3.725C2.772 2.229 2 3 2 3.954v14.55c0 .952.772 1.724 1.725 1.724h8.334a5.726 5.726 0 0 1-.805-2H4v-14h14Zm5.702 18.265-3.044-3.047a.99.99 0 0 0-.299-.208 4.061 4.061 0 0 0-3.462-6.185 4.061 4.061 0 0 0-4.06 4.064 4.061 4.061 0 0 0 6.179 3.466c.049.108.118.21.207.3l3.045 3.047a1.011 1.011 0 0 0 1.434 0 1.015 1.015 0 0 0 0-1.437Zm-11.674-8.438H6v-1.5h7.39c-.537.415-1 .923-1.362 1.5ZM15 6.556H6v1.5h9v-1.5Zm-9 3h6.987v1.5H6v-1.5Zm8.36 7.562c0-1.4 1.137-2.54 2.537-2.54a2.542 2.542 0 0 1 2.537 2.54c0 1.4-1.138 2.54-2.537 2.54-1.4 0-2.537-1.14-2.537-2.54Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Searches.displayName = "Icon.Location.Searches";

// Icon/Location/Servers.tsx
var import_uik238 = require("@appd/uik");
var import_jsx_runtime228 = require("react/jsx-runtime");
var Servers = import_uik238.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime228.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.Servers",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime228.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M19.5 3.229c.825 0 1.5.675 1.5 1.5v3c0 .825-.675 1.5-1.5 1.5h-15c-.825 0-1.5-.675-1.5-1.5v-3c0-.825.675-1.5 1.5-1.5h15Zm1.5 9.5c0-.825-.675-1.5-1.5-1.5h-15c-.825 0-1.5.675-1.5 1.5v3c0 .825.675 1.5 1.5 1.5H11v1.998H4a1 1 0 1 0 0 2h16a1 1 0 1 0 0-2h-7V17.23h6.5c.825 0 1.5-.675 1.5-1.5v-3Zm-2 .5v2H5v-2h14Zm0-8v2H5v-2h14Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Servers.displayName = "Icon.Location.Servers";

// Icon/Location/ServiceAvailability.tsx
var import_uik239 = require("@appd/uik");
var import_jsx_runtime229 = require("react/jsx-runtime");
var ServiceAvailability = import_uik239.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime229.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.ServiceAvailability",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime229.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "m7.043 20.229-3.012.008c-1.049 0-1.964-.938-1.964-1.966V6.193c0-1.07.853-1.964 1.964-1.964h3.012v1.96H4.68a.637.637 0 0 0-.629.628V17.65c0 .34.288.628.629.628h2.363v1.95Zm13.01.008-3.05-.008v-1.95h2.37c.34 0 .628-.288.628-.629V6.817a.637.637 0 0 0-.629-.629h-2.37v-1.96h3.05c1.2 0 1.95.916 1.95 1.965V18.27c0 1.07-.9 1.966-1.95 1.966Zm-3.77-12.464-6.165 6.19L7.455 11.3l-1.326 1.325 3.977 3.977L17.609 9.1l-1.325-1.326Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
ServiceAvailability.displayName = "Icon.Location.ServiceAvailability";

// Icon/Location/ServiceEndPoint.tsx
var import_uik240 = require("@appd/uik");
var import_jsx_runtime230 = require("react/jsx-runtime");
var ServiceEndPoint = import_uik240.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime230.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.ServiceEndPoint",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime230.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "m4.031 20.237 3.012-.008v-1.95H4.68a.637.637 0 0 1-.629-.629V6.817c0-.341.288-.629.629-.629h2.363v-1.96H4.031a1.957 1.957 0 0 0-1.964 1.965V18.27c0 1.028.915 1.966 1.964 1.966Zm16.022 0-3.05-.008v-1.95h2.37c.34 0 .628-.288.628-.629V6.817a.637.637 0 0 0-.629-.629h-2.37v-1.96h3.05c1.2 0 1.95.916 1.95 1.965V18.27c0 1.07-.9 1.966-1.95 1.966ZM12 15.19a2.962 2.962 0 1 1 0-5.923 2.962 2.962 0 0 1 0 5.923Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
ServiceEndPoint.displayName = "Icon.Location.ServiceEndPoint";

// Icon/Location/Support.tsx
var import_uik241 = require("@appd/uik");
var import_jsx_runtime231 = require("react/jsx-runtime");
var Support = import_uik241.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime231.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.Support",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime231.jsx)(
      "path",
      {
        d: "M19.58 9.59c0-4.065-3.408-7.341-7.603-7.341-4.196 0-7.604 3.302-7.604 7.34-1.39.508-2.36 1.804-2.36 3.327v1.27c0 1.956 1.652 3.556 3.67 3.556h.263c.865 0 1.573-.686 1.573-1.524v-5.334c0-.66-.445-1.219-1.048-1.422.078-2.87 2.517-5.181 5.506-5.181 2.989 0 5.427 2.31 5.506 5.181-.603.203-1.049.762-1.049 1.422v5.334c0 .711.525 1.321 1.206 1.473-.288.33-.734.56-1.206.56h-1.101c-.42-1.118-1.52-1.906-2.832-1.906-1.652 0-3.015 1.321-3.015 2.921 0 1.6 1.364 2.92 3.015 2.92a3.043 3.043 0 0 0 2.832-1.904h1.1c1.836 0 3.33-1.295 3.619-2.997 1.127-.61 1.888-1.778 1.888-3.099v-1.27c0-1.524-.97-2.819-2.36-3.327ZM5.422 15.684c-.734-.127-1.311-.736-1.311-1.498v-1.27c0-.762.577-1.372 1.31-1.499v4.267Zm14.42-1.498c0 .762-.576 1.371-1.31 1.498v-4.293c.734.128 1.31.737 1.31 1.5v1.295Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
Support.displayName = "Icon.Location.Support";

// Icon/Location/Synthetic.tsx
var import_uik242 = require("@appd/uik");
var import_jsx_runtime232 = require("react/jsx-runtime");
var Synthetic = import_uik242.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime232.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.Synthetic",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime232.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M17.123 8.246H7.3l.021-4.211c0-.926.884-1.684 1.964-1.684h5.763c1.081 0 2.076.758 2.076 1.684v4.211Zm-6.877-1.965c.54 0 .983-.442.983-.982a.987.987 0 0 0-.983-.983.986.986 0 0 0-.982.983c0 .54.442.982.982.982Zm4.912-.982c0 .54-.442.982-.982.982a.985.985 0 0 1-.982-.982c0-.54.442-.983.982-.983s.982.443.982.983ZM19.96 9.72c.603 0 1.095.491 1.095 1.093v2.444c0 .602-.492 1.094-1.095 1.094l-.012 5.143c0 .503-.495.91-1.104.91-.61 0-1.105-.407-1.105-.91V14.35h-1.58v4.5h-8v-4.5H6.686v5.143c0 .503-.495.91-1.105.91-.446 0-.826-.22-1-.534a.77.77 0 0 1-.105-.376V14.35a1.1 1.1 0 0 1-1.105-1.094v-2.444c0-.602.492-1.093 1.093-1.093H19.96Zm-3.8 10.131h-8v.407c0 .602.492 1.094 1.094 1.094h5.812c.602 0 1.094-.492 1.094-1.095v-.406Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Synthetic.displayName = "Icon.Location.Synthetic";

// Icon/Location/SyntheticSessions.tsx
var import_uik243 = require("@appd/uik");
var import_jsx_runtime233 = require("react/jsx-runtime");
var SyntheticSessions = import_uik243.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime233.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.SyntheticSessions",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime233.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M15.123 7.623v-4.21c0-.927-.995-1.685-2.076-1.685H7.284c-1.08 0-1.964.758-1.964 1.684L5.3 7.623h9.823Zm7.755 9.913a5.48 5.48 0 0 0-5.476-5.471 5.474 5.474 0 0 0-5.466 5.47 5.474 5.474 0 0 0 5.466 5.472 5.48 5.48 0 0 0 5.476-5.471ZM20.206 18.8l-2.21-1.312v-2.573h-1.204v3.21l2.8 1.68.614-1.005Zm-2.799 2.662a3.931 3.931 0 0 0 3.927-3.926 3.931 3.931 0 0 0-3.927-3.927 3.931 3.931 0 0 0-3.927 3.927 3.931 3.931 0 0 0 3.927 3.926ZM8.247 5.658c.54 0 .982-.442.982-.982a.987.987 0 0 0-.983-.983.986.986 0 0 0-.982.983c0 .54.442.982.982.982Zm4.911-.982c0 .54-.442.982-.982.982a.985.985 0 0 1-.982-.982c0-.54.442-.983.982-.983s.982.443.982.983Zm4.244 5.689c-3.951 0-7.166 3.217-7.166 7.17 0 .235.013.465.035.694H6.16v-4.5H4.685v5.142c0 .503-.495.91-1.105.91-.446 0-.826-.22-1-.533a.77.77 0 0 1-.105-.377V13.73a1.1 1.1 0 0 1-1.106-1.094V10.19c0-.602.493-1.093 1.094-1.093h15.496c.602 0 1.095.49 1.095 1.092v.374a7.152 7.152 0 0 0-1.652-.2Zm-6.956 8.864H6.16v.406c0 .602.492 1.094 1.094 1.094h3.742a7.12 7.12 0 0 1-.549-1.5Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
SyntheticSessions.displayName = "Icon.Location.SyntheticSessions";

// Icon/Location/TransactionAnalytics.tsx
var import_uik244 = require("@appd/uik");
var import_jsx_runtime234 = require("react/jsx-runtime");
var TransactionAnalytics = import_uik244.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime234.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.TransactionAnalytics",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime234.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M11.37 13.089H7.8l.613.613a.638.638 0 1 1-.903.903l-1.703-1.703a.638.638 0 0 1-.139-.208.639.639 0 0 1-.043-.217c0-.01-.006-.017-.006-.027 0-.008.005-.015.005-.024a.639.639 0 0 1 .044-.22.636.636 0 0 1 .139-.207l1.703-1.704a.638.638 0 1 1 .903.903l-.613.613h3.569a.64.64 0 0 1 0 1.278Zm4.04-4.072c.001.01.006.017.006.026 0 .009-.005.016-.005.025a.636.636 0 0 1-.044.218.636.636 0 0 1-.139.208l-1.703 1.704a.634.634 0 0 1-.903 0 .638.638 0 0 1 0-.903l.613-.613H9.666a.64.64 0 0 1 0-1.278h3.569l-.613-.613a.638.638 0 1 1 .903-.903l1.703 1.703a.634.634 0 0 1 .139.208.633.633 0 0 1 .044.218Zm-4.892 8.544c.313 0 .619-.029.92-.07.146.58.38 1.123.689 1.616-.522.1-1.059.157-1.61.157-4.696 0-8.517-3.82-8.517-8.518C2 6.05 5.821 2.23 10.518 2.23c4.697 0 8.518 3.82 8.518 8.517 0 .052-.007.102-.008.153a5.59 5.59 0 0 0-1.708-.4c-.131-3.642-3.128-6.567-6.802-6.567a6.822 6.822 0 0 0-6.814 6.814 6.822 6.822 0 0 0 6.814 6.815Zm12.852 4.047a.932.932 0 0 1-1.318 1.317l-1.677-1.678-1.056-1.053-.065-.068-.197-.197a4.117 4.117 0 0 1-3.46.46c-1.432-.438-2.548-1.663-2.842-3.12a4.207 4.207 0 0 1 .856-3.513 4.166 4.166 0 0 1 3.235-1.534c.287 0 .58.03.867.088 1.457.294 2.683 1.41 3.121 2.843a4.098 4.098 0 0 1-.46 3.459l.197.197.068.065 1.161 1.164 1.57 1.57Zm-6.524-2.822a2.388 2.388 0 0 0 2.385-2.385 2.388 2.388 0 0 0-2.385-2.385 2.388 2.388 0 0 0-2.385 2.385 2.388 2.388 0 0 0 2.385 2.385Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
TransactionAnalytics.displayName = "Icon.Location.TransactionAnalytics";

// Icon/Location/Troubleshoot.tsx
var import_uik245 = require("@appd/uik");
var import_jsx_runtime235 = require("react/jsx-runtime");
var Troubleshoot = import_uik245.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime235.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.Troubleshoot",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime235.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M19.253 2.729c.965 0 1.747.781 1.747 1.746v11.513c0 .964-.782 1.746-1.747 1.746H4.747A1.746 1.746 0 0 1 3 15.987V4.476c0-.965.782-1.746 1.747-1.746h14.506ZM5 15.734h14V4.729H5v11.005Zm6.026-8.987a.026.026 0 0 0-.026.025v3.89c0 .014.011.026.026.026h1.948a.026.026 0 0 0 .026-.026v-3.89a.026.026 0 0 0-.026-.025h-1.948Zm1.948 6.963h-1.948a.026.026 0 0 1-.026-.025v-1.85c0-.013.011-.025.026-.025h1.948c.014 0 .026.012.026.026v1.849a.026.026 0 0 1-.026.025ZM21 19.728H3v2h18v-2Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Troubleshoot.displayName = "Icon.Location.Troubleshoot";

// Icon/Location/UserAnalytics.tsx
var import_uik246 = require("@appd/uik");
var import_jsx_runtime236 = require("react/jsx-runtime");
var UserAnalytics = import_uik246.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime236.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.UserAnalytics",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime236.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M9 11.229a5 5 0 1 1 0-10 5 5 0 0 1 0 10Zm0-8a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-3.889 10h5.162a6.015 6.015 0 0 0-.607 2H5.11c-1.167 0-2.111.91-2.111 2H1c0-2.211 1.856-4 4.111-4Zm17.092 7.938c.176.176.273.41.273.658a.925.925 0 0 1-.273.659.927.927 0 0 1-.659.272.927.927 0 0 1-.659-.272l-1.677-1.678-1.055-1.053-.066-.068-.197-.197a4.117 4.117 0 0 1-3.46.46c-1.432-.438-2.548-1.663-2.842-3.12a4.207 4.207 0 0 1 .856-3.513 4.165 4.165 0 0 1 3.235-1.534c.288 0 .58.03.868.088 1.457.294 2.682 1.41 3.12 2.843a4.098 4.098 0 0 1-.46 3.459l.197.197.068.065 2.731 2.734Zm-6.524-2.822a2.388 2.388 0 0 0 2.386-2.385 2.388 2.388 0 0 0-2.386-2.385 2.388 2.388 0 0 0-2.385 2.385 2.388 2.388 0 0 0 2.385 2.385Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
UserAnalytics.displayName = "Icon.Location.UserAnalytics";

// Icon/Location/Videos.tsx
var import_uik247 = require("@appd/uik");
var import_jsx_runtime237 = require("react/jsx-runtime");
var Videos = import_uik247.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime237.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.Videos",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime237.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M18.548 3.455c1.216 0 2.202.985 2.202 2.201v13.177a2.202 2.202 0 0 1-2.202 2.202H5.452a2.202 2.202 0 0 1-2.202-2.202V5.656c0-1.216.986-2.201 2.202-2.201h13.096Zm.202 15.378V5.656a.202.202 0 0 0-.202-.201H5.452a.202.202 0 0 0-.202.201v13.177c0 .112.09.202.202.202h13.096c.112 0 .202-.09.202-.202ZM9.643 8.103v8.29l6.033-4.144-6.033-4.145Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Videos.displayName = "Icon.Location.Videos";

// Icon/Location/VirtualPages.tsx
var import_uik248 = require("@appd/uik");
var import_jsx_runtime238 = require("react/jsx-runtime");
var VirtualPages = import_uik248.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime238.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Location.VirtualPages",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime238.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M23 18.229a1 1 0 1 1 0 2H1a1 1 0 1 1 0-2h3c-1.1 0-2-.9-2-2v-10c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2l-.01 10c0 1.1-.89 2-1.99 2h3Zm-19-12v10h16v-10H4Zm9.189 2.014-1.197 4.376-1.193-4.376H9.193l2.006 6.01h1.585l2.023-6.01H13.19Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
VirtualPages.displayName = "Icon.Location.VirtualPages";

// Icon/Navigation/Navigation.ts
var Navigation_exports = {};
__export(Navigation_exports, {
  ArrowDown: () => ArrowDown,
  ArrowDropDown: () => ArrowDropDown,
  ArrowDropUp: () => ArrowDropUp,
  ArrowLeft: () => ArrowLeft,
  ArrowRight: () => ArrowRight,
  ArrowUp: () => ArrowUp,
  ChevronDown: () => ChevronDown,
  ChevronLeft: () => ChevronLeft,
  ChevronRight: () => ChevronRight,
  ChevronUp: () => ChevronUp,
  Close: () => Close,
  DisclosureRight: () => DisclosureRight,
  DoubleChevronLeft: () => DoubleChevronLeft,
  DoubleChevronRight: () => DoubleChevronRight,
  DragHandle: () => DragHandle,
  DragIndicator: () => DragIndicator,
  ExitFullscreen: () => ExitFullscreen,
  FirstPage: () => FirstPage,
  Fullscreen: () => Fullscreen,
  LastPage: () => LastPage,
  Maximize: () => Maximize,
  Menu: () => Menu,
  Minimize: () => Minimize,
  MoreHorizontal: () => MoreHorizontal,
  MoreVertical: () => MoreVertical,
  Slash: () => Slash
});

// Icon/Navigation/ArrowDown.tsx
var import_uik249 = require("@appd/uik");
var import_jsx_runtime239 = require("react/jsx-runtime");
var ArrowDown = import_uik249.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime239.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Navigation.ArrowDown",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime239.jsx)(
      "path",
      {
        d: "M11 5a1 1 0 1 1 2 0v11.17l4.884-4.876a.998.998 0 0 1 1.411 1.411l-6.588 6.588a1 1 0 0 1-1.414 0l-6.588-6.588a1 1 0 0 1 1.412-1.418L11 16.17V5Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
ArrowDown.displayName = "Icon.Navigation.ArrowDown";

// Icon/Navigation/ArrowDropDown.tsx
var import_uik250 = require("@appd/uik");
var import_jsx_runtime240 = require("react/jsx-runtime");
var ArrowDropDown = import_uik250.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime240.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Navigation.ArrowDropDown",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime240.jsx)("path", { d: "m7 10 5 5 5-5H7Z", fill: "#fff", fillOpacity: ".94" })
  }
));
ArrowDropDown.displayName = "Icon.Navigation.ArrowDropDown";

// Icon/Navigation/ArrowDropUp.tsx
var import_uik251 = require("@appd/uik");
var import_jsx_runtime241 = require("react/jsx-runtime");
var ArrowDropUp = import_uik251.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime241.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Navigation.ArrowDropUp",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime241.jsx)("path", { d: "M17 15H7l5-5 5 5Z", fill: "#fff", fillOpacity: ".94" })
  }
));
ArrowDropUp.displayName = "Icon.Navigation.ArrowDropUp";

// Icon/Navigation/ArrowLeft.tsx
var import_uik252 = require("@appd/uik");
var import_jsx_runtime242 = require("react/jsx-runtime");
var ArrowLeft = import_uik252.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime242.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Navigation.ArrowLeft",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime242.jsx)(
      "path",
      {
        d: "M19 11H7.83l4.883-4.882a1.002 1.002 0 0 0-1.417-1.413l-6.589 6.588a1 1 0 0 0 0 1.414l6.588 6.588a.997.997 0 1 0 1.41-1.41L7.83 13H19a1 1 0 1 0 0-2Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
ArrowLeft.displayName = "Icon.Navigation.ArrowLeft";

// Icon/Navigation/ArrowRight.tsx
var import_uik253 = require("@appd/uik");
var import_jsx_runtime243 = require("react/jsx-runtime");
var ArrowRight = import_uik253.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime243.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Navigation.ArrowRight",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime243.jsx)(
      "path",
      {
        d: "M5 13a1 1 0 1 1 0-2h11.17l-4.876-4.884a.998.998 0 0 1 1.411-1.411l6.588 6.588a1 1 0 0 1 0 1.414l-6.588 6.588a1 1 0 0 1-1.418-1.413L16.17 13H5Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
ArrowRight.displayName = "Icon.Navigation.ArrowRight";

// Icon/Navigation/ArrowUp.tsx
var import_uik254 = require("@appd/uik");
var import_jsx_runtime244 = require("react/jsx-runtime");
var ArrowUp = import_uik254.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime244.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Navigation.ArrowUp",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime244.jsx)(
      "path",
      {
        d: "M13 19a1 1 0 1 1-2 0V7.83l-4.884 4.876a.998.998 0 0 1-1.411-1.411l6.588-6.588a1 1 0 0 1 1.414 0l6.588 6.588a1 1 0 0 1-1.413 1.418L13 7.83V19Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
ArrowUp.displayName = "Icon.Navigation.ArrowUp";

// Icon/Navigation/ChevronDown.tsx
var import_uik255 = require("@appd/uik");
var import_jsx_runtime245 = require("react/jsx-runtime");
var ChevronDown = import_uik255.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime245.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Navigation.ChevronDown",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime245.jsx)(
      "path",
      {
        d: "M6.775 9.828a.896.896 0 0 0 0 1.302l4.405 4.235c.375.36.982.36 1.357 0l4.405-4.235a.895.895 0 0 0 0-1.302.985.985 0 0 0-1.355 0l-3.729 3.577L8.13 9.828a.986.986 0 0 0-1.355 0Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
ChevronDown.displayName = "Icon.Navigation.ChevronDown";

// Icon/Navigation/ChevronLeft.tsx
var import_uik256 = require("@appd/uik");
var import_jsx_runtime246 = require("react/jsx-runtime");
var ChevronLeft = import_uik256.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime246.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Navigation.ChevronLeft",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime246.jsx)(
      "path",
      {
        d: "M14.117 6.705a.93.93 0 0 0-1.354 0L8.36 11.293a1.03 1.03 0 0 0 0 1.414l4.404 4.588a.93.93 0 0 0 1.354 0c.374-.39.374-1.02 0-1.41L10.397 12l3.72-3.884a1.028 1.028 0 0 0 0-1.411Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
ChevronLeft.displayName = "Icon.Navigation.ChevronLeft";

// Icon/Navigation/ChevronRight.tsx
var import_uik257 = require("@appd/uik");
var import_jsx_runtime247 = require("react/jsx-runtime");
var ChevronRight = import_uik257.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime247.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Navigation.ChevronRight",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime247.jsx)(
      "path",
      {
        d: "M9.317 17.295a1.028 1.028 0 0 1-.001-1.41L13.036 12l-3.72-3.884a1.028 1.028 0 0 1 0-1.411.93.93 0 0 1 1.354 0l4.405 4.588a1.03 1.03 0 0 1 0 1.414l-4.405 4.588a.93.93 0 0 1-1.353 0Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
ChevronRight.displayName = "Icon.Navigation.ChevronRight";

// Icon/Navigation/ChevronUp.tsx
var import_uik258 = require("@appd/uik");
var import_jsx_runtime248 = require("react/jsx-runtime");
var ChevronUp = import_uik258.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime248.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Navigation.ChevronUp",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime248.jsx)(
      "path",
      {
        d: "M16.942 15.366a.986.986 0 0 1-1.355 0l-3.729-3.577-3.728 3.577a.986.986 0 0 1-1.355 0 .896.896 0 0 1 0-1.302l4.405-4.235a.987.987 0 0 1 1.357 0l4.405 4.235a.896.896 0 0 1 0 1.302Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
ChevronUp.displayName = "Icon.Navigation.ChevronUp";

// Icon/Navigation/Close.tsx
var import_uik259 = require("@appd/uik");
var import_jsx_runtime249 = require("react/jsx-runtime");
var Close = import_uik259.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime249.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Navigation.Close",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime249.jsx)(
      "path",
      {
        d: "M18.295 5.705a.997.997 0 0 0-1.41 0L12 10.59 7.115 5.705a.997.997 0 0 0-1.41 1.41L10.59 12l-4.885 4.885a.997.997 0 1 0 1.41 1.41L12 13.41l4.885 4.885a.997.997 0 0 0 1.41-1.41L13.41 12l4.885-4.885a.997.997 0 0 0 0-1.41Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
Close.displayName = "Icon.Navigation.Close";

// Icon/Navigation/DisclosureRight.tsx
var import_uik260 = require("@appd/uik");
var import_jsx_runtime250 = require("react/jsx-runtime");
var DisclosureRight = import_uik260.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime250.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Navigation.DisclosureRight",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime250.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M12 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10Zm0-18c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8Zm-1.126 2.705a.93.93 0 0 0-1.353 0 1.028 1.028 0 0 0-.001 1.41L13.24 12l-3.72 3.884a1.028 1.028 0 0 0 0 1.411.93.93 0 0 0 1.354 0l4.405-4.588a1.03 1.03 0 0 0 0-1.414l-4.405-4.588Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
DisclosureRight.displayName = "Icon.Navigation.DisclosureRight";

// Icon/Navigation/DoubleChevronLeft.tsx
var import_uik261 = require("@appd/uik");
var import_jsx_runtime251 = require("react/jsx-runtime");
var DoubleChevronLeft = import_uik261.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime251.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Navigation.DoubleChevronLeft",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime251.jsx)(
        "path",
        {
          d: "M10.9 6.3c.4-.4 1-.4 1.4 0 .4.4.4 1.1 0 1.4l-3.9 3.9 3.9 3.9c.3.3.3.9 0 1.3-.4.4-1 .5-1.4.1l-4.6-4.6c-.4-.4-.4-1 0-1.4l4.6-4.6Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime251.jsx)(
        "path",
        {
          d: "M16.9 6.3c.4-.4 1-.4 1.4 0 .4.4.4 1.1 0 1.4l-3.9 3.9 3.9 3.9c.3.3.3.9 0 1.3-.4.4-1 .5-1.4.1l-4.6-4.6c-.4-.4-.4-1 0-1.4l4.6-4.6Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
DoubleChevronLeft.displayName = "Icon.Navigation.DoubleChevronLeft";

// Icon/Navigation/DoubleChevronRight.tsx
var import_uik262 = require("@appd/uik");
var import_jsx_runtime252 = require("react/jsx-runtime");
var DoubleChevronRight = import_uik262.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime252.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Navigation.DoubleChevronRight",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime252.jsx)(
        "path",
        {
          d: "M13.7 16.855c-.4.4-1 .4-1.4 0-.4-.4-.4-1.1 0-1.4l3.9-3.9-3.9-3.9c-.3-.3-.3-.9 0-1.3.4-.4 1-.5 1.4-.1l4.6 4.6c.4.4.4 1 0 1.4l-4.6 4.6Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime252.jsx)(
        "path",
        {
          d: "M7.7 16.855c-.4.4-1 .4-1.4 0-.4-.4-.4-1.1 0-1.4l3.9-3.9-3.9-3.9c-.3-.3-.3-.9 0-1.3.4-.4 1-.5 1.4-.1l4.6 4.6c.4.4.4 1 0 1.4l-4.6 4.6Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
DoubleChevronRight.displayName = "Icon.Navigation.DoubleChevronRight";

// Icon/Navigation/DragHandle.tsx
var import_uik263 = require("@appd/uik");
var import_jsx_runtime253 = require("react/jsx-runtime");
var DragHandle = import_uik263.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime253.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Navigation.DragHandle",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime253.jsx)("path", { clipRule: "evenodd", d: "M4 9h16v2H4V9Zm16 6H4v-2h16v2Z", fill: "#fff", fillOpacity: ".94", fillRule: "evenodd" })
  }
));
DragHandle.displayName = "Icon.Navigation.DragHandle";

// Icon/Navigation/DragIndicator.tsx
var import_uik264 = require("@appd/uik");
var import_jsx_runtime254 = require("react/jsx-runtime");
var DragIndicator = import_uik264.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime254.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Navigation.DragIndicator",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime254.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M9 4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Zm-2 8c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2Zm2 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2Zm8-14c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2Zm-2 4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Zm-2 8c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
DragIndicator.displayName = "Icon.Navigation.DragIndicator";

// Icon/Navigation/ExitFullscreen.tsx
var import_uik265 = require("@appd/uik");
var import_jsx_runtime255 = require("react/jsx-runtime");
var ExitFullscreen = import_uik265.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime255.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Navigation.ExitFullscreen",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime255.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M5 8h3V5h2v5H5V8Zm3 8H5v-2h5v5H8v-3Zm6 3h2v-3h3v-2h-5v5Zm2-14v3h3v2h-5V5h2Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
ExitFullscreen.displayName = "Icon.Navigation.ExitFullscreen";

// Icon/Navigation/FirstPage.tsx
var import_uik266 = require("@appd/uik");
var import_jsx_runtime256 = require("react/jsx-runtime");
var FirstPage = import_uik266.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime256.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Navigation.FirstPage",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime256.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M8.003 7.412a1 1 0 1 0-2 0v9.175a1 1 0 1 0 2 0V7.412ZM13.611 12l3.885 3.885a.997.997 0 1 1-1.41 1.41l-4.588-4.588a1 1 0 0 1 0-1.414l4.588-4.588a.997.997 0 0 1 1.41 1.41L13.61 12Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
FirstPage.displayName = "Icon.Navigation.FirstPage";

// Icon/Navigation/Fullscreen.tsx
var import_uik267 = require("@appd/uik");
var import_jsx_runtime257 = require("react/jsx-runtime");
var Fullscreen = import_uik267.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime257.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Navigation.Fullscreen",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime257.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M7 10H5V5h5v2H7v3Zm-2 4h2v3h3v2H5v-5Zm12 3h-3v2h5v-5h-2v3ZM14 7V5h5v5h-2V7h-3Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Fullscreen.displayName = "Icon.Navigation.Fullscreen";

// Icon/Navigation/LastPage.tsx
var import_uik268 = require("@appd/uik");
var import_jsx_runtime258 = require("react/jsx-runtime");
var LastPage = import_uik268.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime258.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Navigation.LastPage",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime258.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M15.788 16.587a1 1 0 1 0 2 0V7.412a1 1 0 1 0-2 0v9.175ZM6.295 6.705a.997.997 0 0 0 0 1.41L10.18 12l-3.885 3.885a.997.997 0 0 0 1.41 1.41l4.588-4.588a1 1 0 0 0 0-1.414L7.705 6.705a.997.997 0 0 0-1.41 0Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
LastPage.displayName = "Icon.Navigation.LastPage";

// Icon/Navigation/Maximize.tsx
var import_uik269 = require("@appd/uik");
var import_jsx_runtime259 = require("react/jsx-runtime");
var Maximize = import_uik269.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime259.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Navigation.Maximize",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime259.jsx)("path", { d: "M4 3h16c.55 0 1 .45 1 1s-.45 1-1 1H4c-.55 0-1-.45-1-1s.45-1 1-1Z", fill: "#fff", fillOpacity: ".94" })
  }
));
Maximize.displayName = "Icon.Navigation.Maximize";

// Icon/Navigation/Menu.tsx
var import_uik270 = require("@appd/uik");
var import_jsx_runtime260 = require("react/jsx-runtime");
var Menu = import_uik270.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime260.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Navigation.Menu",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime260.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M4 8a1 1 0 0 1 0-2h16a1 1 0 1 1 0 2H4Zm0 5h16a1 1 0 1 0 0-2H4a1 1 0 1 0 0 2Zm0 5h16a1 1 0 1 0 0-2H4a1 1 0 1 0 0 2Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Menu.displayName = "Icon.Navigation.Menu";

// Icon/Navigation/Minimize.tsx
var import_uik271 = require("@appd/uik");
var import_jsx_runtime261 = require("react/jsx-runtime");
var Minimize = import_uik271.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime261.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Navigation.Minimize",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime261.jsx)("path", { d: "M7 16.593h10c.5 0 1 .5 1 1s-.5 1-1 1H7c-.6 0-1-.5-1-1s.4-1 1-1Z", fill: "#fff", fillOpacity: ".94" })
  }
));
Minimize.displayName = "Icon.Navigation.Minimize";

// Icon/Navigation/MoreHorizontal.tsx
var import_uik272 = require("@appd/uik");
var import_jsx_runtime262 = require("react/jsx-runtime");
var MoreHorizontal = import_uik272.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime262.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Navigation.MoreHorizontal",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime262.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Zm-8 2c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
MoreHorizontal.displayName = "Icon.Navigation.MoreHorizontal";

// Icon/Navigation/MoreVertical.tsx
var import_uik273 = require("@appd/uik");
var import_jsx_runtime263 = require("react/jsx-runtime");
var MoreVertical = import_uik273.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime263.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Navigation.MoreVertical",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime263.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M14 6c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2Zm0 12c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2Zm-2-4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
MoreVertical.displayName = "Icon.Navigation.MoreVertical";

// Icon/Navigation/Slash.tsx
var import_uik274 = require("@appd/uik");
var import_jsx_runtime264 = require("react/jsx-runtime");
var Slash = import_uik274.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime264.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Navigation.Slash",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime264.jsx)(
      "path",
      {
        d: "M9.358 19.497a.8.8 0 0 1-.746-1.09L13.81 5.042a.8.8 0 1 1 1.492.58l-5.198 13.365a.8.8 0 0 1-.746.51Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
Slash.displayName = "Icon.Navigation.Slash";

// Icon/Object/Object.ts
var Object_exports = {};
__export(Object_exports, {
  Activity: () => Activity,
  AmazonS3: () => AmazonS3,
  AmazonSns: () => AmazonSns,
  BiDirectedTraffic: () => BiDirectedTraffic,
  Blitz: () => Blitz,
  Breadcrumb: () => Breadcrumb,
  CallGraphFull: () => CallGraphFull,
  CallGraphPartial: () => CallGraphPartial,
  CallGraphPossible: () => CallGraphPossible,
  CallIncoming: () => CallIncoming,
  CallOutgoing: () => CallOutgoing,
  Cassandra: () => Cassandra,
  Class: () => Class,
  Clock: () => Clock,
  CloudHttp: () => CloudHttp,
  CloudMod: () => CloudMod,
  CloudWs: () => CloudWs,
  ConsumerGroup: () => ConsumerGroup,
  CustomExitpoint: () => CustomExitpoint,
  CustomMetric: () => CustomMetric,
  CustomTimer: () => CustomTimer2,
  DatabaseCluster: () => DatabaseCluster,
  DatabaseServer: () => DatabaseServer,
  DatabaseService: () => DatabaseService,
  DatabaseShard: () => DatabaseShard,
  Db: () => Db,
  Docker: () => Docker,
  EndpointTcp: () => EndpointTcp,
  ExitpointCache: () => ExitpointCache,
  FileAttachment: () => FileAttachment,
  FileServer: () => FileServer,
  Fragment: () => Fragment2,
  HealthRuleTemplate: () => HealthRuleTemplate,
  IframeEum: () => IframeEum,
  Image: () => Image,
  IncomingTraffic: () => IncomingTraffic,
  Infopoint: () => Infopoint,
  Interactions: () => Interactions,
  Key: () => Key,
  Kubernetes: () => Kubernetes,
  LoadBalancer: () => LoadBalancer,
  Location: () => Location,
  MainFrame: () => MainFrame,
  MessageProcessor: () => MessageProcessor,
  MessagingServer: () => MessagingServer,
  Method: () => Method,
  MetricTreeFolder: () => MetricTreeFolder,
  MobileCustomMetric: () => MobileCustomMetric,
  MobileInfoPoint: () => MobileInfoPoint,
  MongoDb: () => MongoDb,
  MonitoringStatus: () => MonitoringStatus,
  NetworkRequest: () => NetworkRequest,
  Node: () => Node,
  Notebook: () => Notebook,
  OpenTelemetry: () => OpenTelemetry,
  OutgoingCall: () => OutgoingCall,
  OutgoingTraffic: () => OutgoingTraffic,
  Page: () => Page,
  Participants: () => Participants2,
  Placeholder: () => Placeholder,
  Platform: () => Platform,
  Presenter: () => Presenter,
  RealUser: () => RealUser,
  Resources: () => Resources,
  Server: () => Server,
  SessionFrame: () => SessionFrame,
  SnapshotStartingPoint: () => SnapshotStartingPoint,
  Socket: () => Socket,
  Sqs: () => Sqs,
  Storage: () => Storage,
  Stream: () => Stream,
  StreamProcessor: () => StreamProcessor,
  SyntheticUser: () => SyntheticUser,
  SystemEvent: () => SystemEvent,
  Topic: () => Topic,
  TxDiscoveryAuto: () => TxDiscoveryAuto,
  TxDiscoveryCustom: () => TxDiscoveryCustom,
  TxDiscoveryCustomExclude: () => TxDiscoveryCustomExclude,
  UnresolvedDatabase: () => UnresolvedDatabase,
  Web: () => Web,
  WebServer: () => WebServer,
  WebsphereMq: () => WebsphereMq
});

// Icon/Object/Activity.tsx
var import_uik275 = require("@appd/uik");
var import_jsx_runtime265 = require("react/jsx-runtime");
var Activity = import_uik275.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime265.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.Activity",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime265.jsx)(
        "path",
        {
          d: "M6.26 5.929a1 1 0 0 0-1.4.2l-4.6 5.5c-.3.38-.3.918 0 1.3l4.6 5.5c.207.229.493.371.8.4a1.07 1.07 0 0 0 .6-.2 1 1 0 0 0 .1-1.4l-4.1-5 4.1-4.9a1 1 0 0 0-.1-1.4Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime265.jsx)(
        "path",
        {
          d: "M6 12.229a1.2 1.2 0 1 1 2.4 0 1.2 1.2 0 0 1-2.4 0Zm13.03 6.199a1 1 0 0 1-1.4.2 1 1 0 0 1-.1-1.4l4.07-4.9-4.1-5a1 1 0 0 1 .1-1.4 1.07 1.07 0 0 1 .6-.2c.307.029.593.172.8.4l4.63 5.5c.3.382.3.92 0 1.3l-4.6 5.5Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime265.jsx)(
        "path",
        {
          d: "M15.6 12.229a1.2 1.2 0 1 1 2.4 0 1.2 1.2 0 0 1-2.4 0ZM12 11.028a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
Activity.displayName = "Icon.Object.Activity";

// Icon/Object/AmazonS3.tsx
var import_uik276 = require("@appd/uik");
var import_jsx_runtime266 = require("react/jsx-runtime");
var AmazonS3 = import_uik276.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime266.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.AmazonS3",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime266.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M7.194 20.305h11.34c2.935 0 5.323-2.556 5.323-5.697 0-2.7-1.805-5.003-4.224-5.548-.913-3.417-3.845-5.831-7.205-5.831-2.656 0-5.078 1.487-6.431 3.916C3.114 7.744 1 10.452 1 13.662c0 3.662 2.779 6.643 6.194 6.643ZM7.492 8.43c.972-2.025 2.863-3.282 4.936-3.282 2.649 0 4.949 2.074 5.467 4.933l.133.73.74.055c1.776.134 3.169 1.777 3.169 3.741 0 2.082-1.527 3.777-3.402 3.777H7.195c-2.358 0-4.275-2.12-4.275-4.724 0-2.423 1.641-4.44 3.817-4.692l.526-.06.23-.478Zm4.38 4.59c0-.515-.123-.89-.367-1.125-.244-.236-.64-.353-1.186-.353-.529 0-.923.128-1.183.383s-.39.627-.39 1.115c0 .283.049.511.145.686.096.175.217.316.363.423.146.108.304.195.474.262.17.068.328.134.473.199.146.065.267.143.363.235a.491.491 0 0 1 .145.373.52.52 0 0 1-.104.329.356.356 0 0 1-.3.134.383.383 0 0 1-.295-.124c-.076-.083-.114-.227-.114-.433v-.115h-1.21v.168c0 .251.036.462.108.632a1 1 0 0 0 .312.413c.137.106.305.18.504.222.2.043.43.064.689.064.551 0 .972-.115 1.263-.346.292-.23.437-.601.437-1.112 0-.291-.05-.528-.151-.71a1.35 1.35 0 0 0-.38-.44 2.189 2.189 0 0 0-.49-.271c-.175-.07-.339-.138-.49-.206a1.395 1.395 0 0 1-.38-.238.48.48 0 0 1-.152-.373.49.49 0 0 1 .094-.292c.063-.088.162-.131.296-.131.121 0 .21.05.269.15a.73.73 0 0 1 .087.367v.114h1.17Zm1.97.094h-1.13c.014-.497.144-.86.39-1.088.247-.233.614-.35 1.102-.35.291 0 .533.03.726.088.193.058.346.143.46.255a.92.92 0 0 1 .242.413c.047.164.07.35.07.561 0 .095-.01.192-.033.293a.964.964 0 0 1-.11.282.835.835 0 0 1-.521.386c.277.054.472.176.584.367.112.19.168.415.168.675 0 .538-.13.924-.39 1.16-.26.234-.647.352-1.162.352-.269 0-.503-.022-.702-.067a1.078 1.078 0 0 1-.494-.242 1.039 1.039 0 0 1-.29-.467 2.385 2.385 0 0 1-.093-.723h1.169c0 .135.008.247.023.336.016.09.037.166.064.229.054.116.148.175.283.175.071 0 .13-.01.174-.03a.21.21 0 0 0 .104-.115.758.758 0 0 0 .05-.228c.01-.097.014-.219.014-.367 0-.232-.037-.39-.11-.47-.075-.08-.19-.12-.347-.12h-.316v-.78h.182a.95.95 0 0 0 .242-.027.34.34 0 0 0 .168-.101.475.475 0 0 0 .1-.205c.023-.087.034-.2.034-.34 0-.201-.026-.337-.077-.406-.052-.07-.131-.104-.239-.104-.12 0-.207.047-.258.141-.052.094-.078.266-.078.517Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
AmazonS3.displayName = "Icon.Object.AmazonS3";

// Icon/Object/AmazonSns.tsx
var import_uik277 = require("@appd/uik");
var import_jsx_runtime267 = require("react/jsx-runtime");
var AmazonSns = import_uik277.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime267.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.AmazonSns",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime267.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M18.535 20.305H7.195C3.778 20.305 1 17.325 1 13.662c0-3.21 2.114-5.918 4.997-6.517C7.35 4.716 9.772 3.23 12.428 3.23c3.36 0 6.293 2.414 7.205 5.831 2.419.545 4.223 2.848 4.223 5.548 0 3.141-2.387 5.697-5.321 5.697ZM12.428 5.149c-2.073 0-3.964 1.257-4.936 3.282l-.229.477-.526.06c-2.176.253-3.817 2.27-3.817 4.694 0 2.604 1.917 4.723 4.274 4.723h11.341c1.875 0 3.401-1.695 3.401-3.777 0-1.964-1.392-3.607-3.169-3.74l-.74-.056-.132-.73c-.518-2.859-2.817-4.933-5.467-4.933Zm-3.115 6.747c.245.235.367.61.367 1.125H8.51v-.114a.72.72 0 0 0-.087-.366.29.29 0 0 0-.269-.151c-.134 0-.233.043-.296.13a.49.49 0 0 0-.094.293c0 .157.05.281.152.373.1.092.227.171.38.239.152.067.315.135.49.204.175.07.338.16.49.273.153.112.28.258.38.44.1.181.151.418.151.709 0 .51-.145.881-.437 1.112-.29.23-.712.346-1.263.346-.26 0-.49-.021-.689-.064a1.236 1.236 0 0 1-.504-.222 1 1 0 0 1-.312-.413 1.631 1.631 0 0 1-.108-.632v-.168h1.21v.115c0 .206.038.35.114.433a.383.383 0 0 0 .296.124c.13 0 .23-.044.299-.134a.52.52 0 0 0 .104-.33.491.491 0 0 0-.144-.372 1.271 1.271 0 0 0-.363-.235 11.74 11.74 0 0 0-.474-.199 2.08 2.08 0 0 1-.474-.262 1.292 1.292 0 0 1-.363-.423c-.096-.175-.144-.403-.144-.686 0-.488.13-.86.39-1.115s.654-.383 1.182-.383c.547 0 .942.118 1.186.353Zm1.322-.259v4.798h1.17v-2.963h.013l.833 2.963h1.37v-4.798h-1.169v2.957h-.013l-.806-2.957h-1.398Zm7.033.259c.244.235.367.61.367 1.125h-1.17v-.114a.72.72 0 0 0-.087-.366.29.29 0 0 0-.269-.151c-.134 0-.233.043-.296.13a.489.489 0 0 0-.094.293c0 .157.05.281.151.373.101.092.228.171.38.239.152.067.316.135.49.204.175.07.339.16.491.273.153.112.28.258.38.44.1.181.151.418.151.709 0 .51-.145.881-.437 1.112-.29.23-.712.346-1.263.346-.26 0-.49-.021-.689-.064a1.236 1.236 0 0 1-.504-.222 1 1 0 0 1-.312-.413 1.63 1.63 0 0 1-.108-.632v-.168h1.21v.115c0 .206.038.35.114.433a.383.383 0 0 0 .296.124c.13 0 .23-.044.299-.134a.52.52 0 0 0 .104-.33.49.49 0 0 0-.145-.372 1.27 1.27 0 0 0-.362-.235 11.767 11.767 0 0 0-.474-.199 2.08 2.08 0 0 1-.474-.262 1.291 1.291 0 0 1-.363-.423c-.096-.175-.144-.403-.144-.686 0-.488.13-.86.39-1.115s.653-.383 1.182-.383c.547 0 .942.118 1.186.353Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
AmazonSns.displayName = "Icon.Object.AmazonSns";

// Icon/Object/BiDirectedTraffic.tsx
var import_uik278 = require("@appd/uik");
var import_jsx_runtime268 = require("react/jsx-runtime");
var BiDirectedTraffic = import_uik278.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime268.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.BiDirectedTraffic",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime268.jsx)(
      "path",
      {
        d: "M3 11.229h18a.999.999 0 0 0 .595-1.804l-5.4-4a1 1 0 0 0-1.19 1.607L17.97 9.23H3a1 1 0 0 0 0 2Zm4.805 7.803a1 1 0 1 0 1.19-1.607L6.03 15.228H21a1 1 0 1 0 0-2H3a1 1 0 0 0-.595 1.804l5.4 4Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
BiDirectedTraffic.displayName = "Icon.Object.BiDirectedTraffic";

// Icon/Object/Blitz.tsx
var import_uik279 = require("@appd/uik");
var import_jsx_runtime269 = require("react/jsx-runtime");
var Blitz = import_uik279.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime269.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.Blitz",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime269.jsx)(
        "path",
        {
          d: "M3.996 15.924c0 .703 2.551 1.996 6.72 1.996.819 0 1.558-.06 2.243-.145l-.663 1.749c-.523.041-1.05.076-1.58.076-3.684 0-7.405-.986-8.227-2.876a1.974 1.974 0 0 1-.173-.8c-.047-5.057-.047-8.323 0-9.796.07-2.21 4.716-3.328 8.4-3.328 3.384 0 6.8.83 7.973 2.428h-2.863l-.053-.007c-1.162-.44-2.867-.741-5.057-.741-4.169 0-6.72 1.29-6.72 1.994 0 .423.929 1.059 2.573 1.497 1.088.292 2.486.499 4.147.499 1.397 0 2.588-.153 3.584-.374l-.773 1.844a19.61 19.61 0 0 1-2.81.21c-1.437 0-2.875-.153-4.148-.447-.923-.214-1.755-.502-2.434-.865l-.048-.026a4.61 4.61 0 0 1-.09-.05V11.2c0 .423.928 1.057 2.572 1.497 1.088.291 2.486.498 4.147.498a17.9 17.9 0 0 0 1.475-.068l-.725 1.727-.086.004c-.221.008-.442.016-.664.016-1.436 0-2.873-.153-4.147-.447-.923-.213-1.755-.501-2.434-.865l-.003-.001c-.046-.024-.092-.048-.136-.073v2.436Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime269.jsx)(
        "path",
        {
          d: "M16.823 7.25h4.142l-2.588 5.694H22l-8.8 9.835 2.847-7.506H13.46l3.364-8.023Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
Blitz.displayName = "Icon.Object.Blitz";

// Icon/Object/Breadcrumb.tsx
var import_uik280 = require("@appd/uik");
var import_jsx_runtime270 = require("react/jsx-runtime");
var Breadcrumb = import_uik280.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime270.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.Breadcrumb",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime270.jsx)(
        "path",
        {
          d: "M8.8 10.868a.75.75 0 0 0 0 1.06.79.79 0 0 0 .53.22.75.75 0 0 0 .53-.22l2.67-2.67a.75.75 0 0 0-1.06-1.06l-2.67 2.67Zm4.67-3.609a.75.75 0 0 1 1.06-1.06.75.75 0 0 1-1.06 1.06Zm-5 7.939a.75.75 0 0 0 1.06 1.06l6-6a.75.75 0 0 0-1.06-1.06l-6 6Zm4 1.061a.75.75 0 0 1 0-1.06l2.17-2.17a.75.75 0 0 1 1.06 1.06l-2.17 2.17a.74.74 0 0 1-.53.22.74.74 0 0 1-.53-.22Zm-1.982.958a.75.75 0 0 0-.018 1.042.74.74 0 0 0 .53.22.75.75 0 0 0 .53-1.28.75.75 0 0 0-1.042.018Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime270.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M6 22.729a2 2 0 0 1-2-2v-10.4a3.85 3.85 0 0 1-2-3.1c0-2.88 4.3-5 10-5s10 2.12 10 5a3.85 3.85 0 0 1-2 3.1v10.4a2 2 0 0 1-2 2H6Zm6-18.55c-5 0-8 1.78-8 3.05 0 .5.54 1.14 1.49 1.67l.51.29v11.54h12V9.189l.51-.29c.95-.53 1.49-1.17 1.49-1.67 0-1.27-3-3.05-8-3.05Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
Breadcrumb.displayName = "Icon.Object.Breadcrumb";

// Icon/Object/CallGraphFull.tsx
var import_uik281 = require("@appd/uik");
var import_jsx_runtime271 = require("react/jsx-runtime");
var CallGraphFull = import_uik281.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime271.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.CallGraphFull",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime271.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M4 4.229c0-1.1.9-2 2-2h8l6 6v12c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2v-16Zm9-.5v5.5h5.5l-5.5-5.5Zm4 8.5v1H9v-1h8Zm-2 2H7v1h8v-1Zm2 2v1H9v-1h8Zm-2 2H7v1h8v-1Z",
        fill: "#4983E5",
        fillRule: "evenodd"
      }
    )
  }
));
CallGraphFull.displayName = "Icon.Object.CallGraphFull";

// Icon/Object/CallGraphPartial.tsx
var import_uik282 = require("@appd/uik");
var import_jsx_runtime272 = require("react/jsx-runtime");
var CallGraphPartial = import_uik282.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime272.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.CallGraphPartial",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime272.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M4 4.229c0-1.1.9-2 2-2h8l6 6v12c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2v-16Zm11 10H7v1h8v-1Zm0 5H7v-1h8v1Zm-6-2h8v-1H9v1Zm8-4H9v-1h8v1Zm-4-9.5v5.5h5.5l-5.5-5.5Z",
          fill: "#A0A0A0",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime272.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M4 4.229c0-1.1.9-2 2-2h8l6 6v12c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2v-16Zm11 10H7v1h8v-1Zm0 5H7v-1h8v1Zm-6-2h8v-1H9v1Zm8-4H9v-1h8v1Zm-4-9.5v5.5h5.5l-5.5-5.5Z",
          fill: "#A0A0A0",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
CallGraphPartial.displayName = "Icon.Object.CallGraphPartial";

// Icon/Object/CallGraphPossible.tsx
var import_uik283 = require("@appd/uik");
var import_jsx_runtime273 = require("react/jsx-runtime");
var CallGraphPossible = import_uik283.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime273.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.CallGraphPossible",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime273.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M5.708 19.232v-1h4.16a6.817 6.817 0 0 1-.083-1H7.708v-1h2.16c.05-.341.12-.676.22-1h-4.38v-1h4.78c.172-.35.369-.685.595-1H7.708v-1h4.246a7.299 7.299 0 0 1 6.754-1.793V8.232l-6-6h-8c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h7.246a6.958 6.958 0 0 1-1.866-3h-4.38Zm6-15.5 5.5 5.5h-5.5v-5.5Z",
          fill: "#A0A0A0",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime273.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M22.708 16.638c-.244-2.235-1.85-4.078-4-4.729a5.912 5.912 0 0 0-1.717-.253c-.909 0-1.765.21-2.528.576a5.626 5.626 0 0 0-2.823 3c-.128.32-.226.654-.29 1a5.407 5.407 0 0 0-.098 1c0 .342.037.675.098 1 .064.346.162.68.29 1a5.65 5.65 0 0 0 2.822 3 5.85 5.85 0 0 0 2.53.576c2.97 0 5.41-2.183 5.716-4.982a5.468 5.468 0 0 0 0-1.188Zm-5.101 4.439h-1.22v-1.099h1.22v1.099Zm1.262-4.257c.347-.313.567-.752.566-1.236 0-.612-.278-1.165-.727-1.563a2.571 2.571 0 0 0-1.711-.634c-1.347 0-2.438.983-2.438 2.197h1.219c0-.604.548-1.098 1.219-1.098.67 0 1.22.494 1.22 1.098 0 .302-.135.577-.36.775l-.756.692c-.44.4-.713.95-.713 1.554v.275h1.219c0-.824.274-1.154.713-1.555l.549-.505Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
CallGraphPossible.displayName = "Icon.Object.CallGraphPossible";

// Icon/Object/CallIncoming.tsx
var import_uik284 = require("@appd/uik");
var import_jsx_runtime274 = require("react/jsx-runtime");
var CallIncoming = import_uik284.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime274.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.CallIncoming",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime274.jsx)(
        "path",
        {
          d: "M7.517 6.619a7.94 7.94 0 0 1 5.65-2.39 8 8 0 1 1-5.65 13.61l1.41-1.42a6 6 0 1 0 0-8.38l-1.41-1.42Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime274.jsx)(
        "path",
        {
          d: "M13.097 13.229h-.32l-.02-.06h-9a1 1 0 0 1 0-1.94h9.39l-.92-.92a1 1 0 0 1 0-1.34 1 1 0 0 1 1.35 0l2.5 2.58a1 1 0 0 1 0 1.36l-2.55 2.58a.94.94 0 0 1-1.35 0 1 1 0 0 1 0-1.34l.54-.55.38-.37Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
CallIncoming.displayName = "Icon.Object.CallIncoming";

// Icon/Object/CallOutgoing.tsx
var import_uik285 = require("@appd/uik");
var import_jsx_runtime275 = require("react/jsx-runtime");
var CallOutgoing = import_uik285.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime275.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.CallOutgoing",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime275.jsx)(
        "path",
        {
          d: "M4 12.19a5.962 5.962 0 0 0 10.204 4.186l1.409 1.42a7.962 7.962 0 1 1-.002-11.215l-1.409 1.421A5.962 5.962 0 0 0 4 12.19Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime275.jsx)(
        "path",
        {
          d: "M17.86 11.224a7.937 7.937 0 0 0-.059-.38l-.541-.549a.972.972 0 0 1-.023-1.331.082.082 0 0 0 .01-.017.076.076 0 0 1 .013-.019.943.943 0 0 1 1.348 0l2.549 2.579a.977.977 0 0 1 0 1.367l-2.549 2.576a.942.942 0 0 1-1.348 0 .044.044 0 0 1-.012-.018.085.085 0 0 0-.01-.016.973.973 0 0 1 .022-1.333l.541-.548a7.87 7.87 0 0 0 .058-.38H9.84a.963.963 0 0 1-.957-.966c0-.532.43-.965.957-.965h8.02Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
CallOutgoing.displayName = "Icon.Object.CallOutgoing";

// Icon/Object/Cassandra.tsx
var import_uik286 = require("@appd/uik");
var import_jsx_runtime276 = require("react/jsx-runtime");
var Cassandra = import_uik286.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime276.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.Cassandra",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime276.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M3.715 15.353c0 .252.333.58.945.896-.354.468-.643.95-.87 1.435-.758-.417-1.32-.927-1.582-1.531a1.974 1.974 0 0 1-.173-.8c-.047-5.058-.047-8.323 0-9.796.07-2.21 4.715-3.328 8.4-3.328 4.175 0 8.4 1.261 8.4 3.674v7.03c-.747-.646-1.753-1.076-2.912-1.276.793-.356 1.232-.741 1.232-1.029V8.191a2.36 2.36 0 0 1-.084.046l-.053.03c-.68.362-1.511.65-2.435.864-1.274.294-2.712.447-4.148.447-1.436 0-2.875-.153-4.148-.447-.923-.213-1.754-.502-2.434-.865l-.047-.025a4.61 4.61 0 0 1-.09-.05v2.437c0 .423.928 1.058 2.571 1.497.875.235 1.96.408 3.21.47l-.063.025-.07.029c-.861.383-1.65.84-2.358 1.348l-.033-.006a15.419 15.419 0 0 1-.686-.135c-.923-.213-1.754-.501-2.434-.865l-.002-.002c-.046-.024-.092-.047-.136-.072v2.436Zm6.72-7.455c-1.661 0-3.06-.207-4.148-.498-1.643-.439-2.572-1.074-2.572-1.497 0-.704 2.551-1.994 6.72-1.994 4.17 0 6.72 1.29 6.72 1.994 0 .423-.929 1.058-2.572 1.497-1.088.291-2.488.498-4.148.498Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime276.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M22.324 15.045a.305.305 0 0 1 .413.056.3.3 0 0 1-.039.397 4.238 4.238 0 0 1-1.537.91 5.218 5.218 0 0 1-.995.155 5.463 5.463 0 0 1-.793.002c-.056.14-.123.28-.201.408.287.12.545.293.787.489l.062.05c.1.08.201.16.291.255.196.206-.117.558-.34.38a1.603 1.603 0 0 0-.169-.121c-.013-.01-.027-.018-.04-.027a1.841 1.841 0 0 0-.474-.238 2.098 2.098 0 0 0-.62-.04l-.162.213c.184.207.385.397.592.576.224.156.04.559-.223.441a1.772 1.772 0 0 0-.44-.125 2.133 2.133 0 0 1-.365-.093l-.168-.072a7.544 7.544 0 0 1-.486.464c.207.245.425.48.654.698.251.246-.129.576-.391.43a3.024 3.024 0 0 1-.822-.681 5.23 5.23 0 0 1-.22.156l-.138.095-.1.067c.156.213.29.442.397.688a.265.265 0 0 1-.1.33.275.275 0 0 1-.347-.056 3.417 3.417 0 0 1-.498-.526l-.039-.078a8.832 8.832 0 0 1-.883.458l.062.056.251.313c.09.1.078.263-.028.358a.253.253 0 0 1-.363-.034l-.257-.302a.253.253 0 0 1-.056-.218 8.314 8.314 0 0 1-2.566.638 8.88 8.88 0 0 1-1.335-.023 5.926 5.926 0 0 1-1.364-.179c-.262-.083-.251-.547.05-.57.17-.013.342-.014.515-.014.19 0 .38-.002.57-.02.128-.005.251-.021.38-.044a3.941 3.941 0 0 1-.598-.34 3.508 3.508 0 0 1-1.638-2.572c-.033-.413.593-.542.643-.123a2.638 2.638 0 0 0 1.028 1.8c.682.436 1.498.61 2.297.497a2.633 2.633 0 0 0 1.05-.29c.32-.201.582-.48.761-.81a3.34 3.34 0 0 0 .57-2.175c-.05-.374-.19-.72-.408-1.022a2.103 2.103 0 0 0-.413-.42 6.9 6.9 0 0 0-2.644.073 9.62 9.62 0 0 0-3.23 1.56l-.109.073c-.282.193-.562.384-.825.597-.268.23-.508.48-.715.766a12.642 12.642 0 0 0-1.302 1.894c-.157.285-.654.034-.514-.257.29-.614.626-1.207 1.006-1.771.184-.269.38-.526.587-.777a8.59 8.59 0 0 0 .274-.364c.117-.16.233-.32.363-.469a7.177 7.177 0 0 1 1.458-1.33 9.075 9.075 0 0 1 1.794-.922c.14-.05.28-.1.42-.146l-.045-.122a.385.385 0 0 1-.011-.263.37.37 0 0 1 .184-.207c.173-.078.38 0 .47.173l.072.235a7.12 7.12 0 0 1 .56-.109l.116-.02-.01-.1c0-.14.038-.274.105-.391.028-.05.056-.1.09-.146l.007-.008c.02-.026.045-.057.065-.092a.303.303 0 0 1 .392-.168.298.298 0 0 1 .19.29c.005.051.01.096.028.146.01.067.01.129.01.196a.749.749 0 0 1-.022.195c.302-.005.61.006.917.034a1.45 1.45 0 0 1 .128-.324c.044-.094.085-.188.125-.283l.099-.226c.173-.397.805-.19.648.23l-.063.173c-.042.115-.084.23-.121.346l-.067.207c.257.056.514.123.766.195.056-.037.118-.07.18-.103.067-.035.136-.071.2-.115a1.28 1.28 0 0 0 .413-.48c.168-.319.676-.045.553.28a2.244 2.244 0 0 1-.419.726l.129.045c.117-.03.236-.046.352-.061.315-.042.613-.08.821-.403.168-.269.643-.045.503.257-.106.212-.24.408-.407.58.39.023.776-.044 1.134-.2.364-.147.685-.377.948-.661.129-.139.248-.286.343-.451.15-.269.615-.034.48.245a3.23 3.23 0 0 1-.548.794 3.333 3.333 0 0 1-1.016.76c.406.107.824.153 1.245.168l.125.008c.065.005.13.01.195.009a3.445 3.445 0 0 0 1.816-.453Zm-5.041 2.632c.302-.24.581-.508.838-.793.105-.125.206-.255.31-.388l.037-.048a22.619 22.619 0 0 1-2.8-.833c.05.084.09.162.128.246a3.669 3.669 0 0 1-.229 3.096l-.022.045.017-.011a15.695 15.695 0 0 0 1.72-1.314Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime276.jsx)(
        "path",
        {
          d: "M12.332 18.881a1.46 1.46 0 0 1-1.196-.212 1.608 1.608 0 0 1-.648-1.783l.022-.061a.511.511 0 0 0 .123.179.678.678 0 0 0 .632.167.633.633 0 0 0 .508-.743.544.544 0 0 0-.067-.195.676.676 0 0 0-.33-.33c.124-.056.252-.084.386-.095.168-.04.347-.05.52-.028.665.09 1.196.603 1.308 1.263a1.574 1.574 0 0 1-.553 1.48 1.13 1.13 0 0 1-.705.358Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
Cassandra.displayName = "Icon.Object.Cassandra";

// Icon/Object/Class.tsx
var import_uik287 = require("@appd/uik");
var import_jsx_runtime277 = require("react/jsx-runtime");
var Class = import_uik287.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime277.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.Class",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime277.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M2 12.229c0-5.52 4.48-10 10-10s10 4.48 10 10-4.48 10-10 10-10-4.48-10-10Zm8.31 2.481a3.208 3.208 0 0 1-.37-1.08 8.269 8.269 0 0 1-.098-1.228v-.332c0-.43.037-.835.099-1.24a3.14 3.14 0 0 1 .368-1.069c.172-.307.418-.565.725-.761.294-.184.663-.27 1.117-.283.283.013.54.062.774.16.245.11.466.258.638.442s.307.405.418.651c.11.246.16.516.172.786h2.198a4.394 4.394 0 0 0-.344-1.584 3.687 3.687 0 0 0-.86-1.24 4.009 4.009 0 0 0-1.326-.811c-.515-.196-1.08-.282-1.707-.282-.798 0-1.498.135-2.087.417-.59.283-1.08.65-1.474 1.13a4.617 4.617 0 0 0-.872 1.67 7.194 7.194 0 0 0-.295 2.014v.332c0 .712.099 1.375.283 2.014.184.638.479 1.19.872 1.657a4.19 4.19 0 0 0 1.473 1.118c.59.27 1.29.418 2.088.418.577 0 1.118-.099 1.621-.283a4.192 4.192 0 0 0 1.326-.774 3.75 3.75 0 0 0 .91-1.154 3.33 3.33 0 0 0 .368-1.412h-2.199a1.752 1.752 0 0 1-.184.712c-.11.221-.258.405-.442.565-.184.16-.393.282-.639.368-.233.086-.479.11-.736.123-.442-.012-.81-.098-1.093-.282a2.149 2.149 0 0 1-.725-.762Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Class.displayName = "Icon.Object.Class";

// Icon/Object/Clock.tsx
var import_uik288 = require("@appd/uik");
var import_jsx_runtime278 = require("react/jsx-runtime");
var Clock = import_uik288.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime278.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.Clock",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime278.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M11.99 2.229c5.524.004 10 4.477 10.01 10-.01 5.522-4.486 9.995-10.01 10C6.475 22.22 2.005 17.748 2 12.23c.002-5.518 4.472-9.993 9.99-10.001Zm.033 17.752a7.736 7.736 0 0 0 7.727-7.728 7.736 7.736 0 0 0-7.727-7.727 7.736 7.736 0 0 0-7.727 7.727 7.736 7.736 0 0 0 7.727 7.728Zm3.97-3.605 1.123-1.837-4.04-2.396V7.438h-2.2v5.867l5.118 3.07Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Clock.displayName = "Icon.Object.Clock";

// Icon/Object/CloudHttp.tsx
var import_uik289 = require("@appd/uik");
var import_jsx_runtime279 = require("react/jsx-runtime");
var CloudHttp = import_uik289.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime279.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.CloudHttp",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime279.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M6.752 20.729h11.34a5.53 5.53 0 0 0 5.32-5.62 5.63 5.63 0 0 0-4.22-5.55 7.63 7.63 0 0 0-7.21-5.83 7.37 7.37 0 0 0-6.43 3.88 6.53 6.53 0 0 0-5 6.52 6.44 6.44 0 0 0 6.2 6.6Zm.29-11.83a5.55 5.55 0 0 1 4.94-3.29 5.76 5.76 0 0 1 5.47 4.99l.13.73h.74a3.63 3.63 0 0 1 3.17 3.74 3.62 3.62 0 0 1-3.4 3.78H6.752a4.52 4.52 0 0 1-4.28-4.72 4.56 4.56 0 0 1 3.82-4.7l.53-.06.22-.47Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime279.jsx)(
        "path",
        {
          d: "M5.145 13.123v3.57h.785v-1.54h1.445v1.54h.785v-3.57h-.785v1.37H5.93v-1.37h-.785Zm4.945.66v2.91h.786v-2.91h1.07v-.66H9.02v.66h1.07Zm3.908 0v2.91h.785v-2.91h1.07v-.66h-2.925v.66h1.07Zm3.474 1.02v-1.07h.61c.09 0 .176.007.26.02a.58.58 0 0 1 .22.08c.063.037.113.09.15.16.04.07.06.162.06.275 0 .113-.02.205-.06.275a.423.423 0 0 1-.15.165.634.634 0 0 1-.22.075c-.084.013-.17.02-.26.02h-.61Zm-.785-1.68v3.57h.785v-1.28h.825c.223 0 .413-.032.57-.095.156-.067.283-.153.38-.26a.945.945 0 0 0 .215-.365 1.335 1.335 0 0 0 0-.85.946.946 0 0 0-.215-.365 1.019 1.019 0 0 0-.38-.255 1.455 1.455 0 0 0-.57-.1h-1.61Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
CloudHttp.displayName = "Icon.Object.CloudHttp";

// Icon/Object/CloudMod.tsx
var import_uik290 = require("@appd/uik");
var import_jsx_runtime280 = require("react/jsx-runtime");
var CloudMod = import_uik290.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime280.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.CloudMod",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime280.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M18.58 20.466H7.24c-3.416 0-6.195-2.98-6.195-6.643 0-3.21 2.114-5.918 4.997-6.516 1.353-2.43 3.775-3.917 6.431-3.917 3.36 0 6.293 2.414 7.205 5.832 2.419.544 4.223 2.847 4.223 5.548 0 3.14-2.387 5.696-5.321 5.696ZM12.473 5.31c-2.073 0-3.964 1.258-4.936 3.282l-.229.478-.526.06c-2.176.252-3.817 2.269-3.817 4.693 0 2.604 1.917 4.723 4.274 4.723H18.58c1.875 0 3.401-1.694 3.401-3.776 0-1.964-1.392-3.608-3.169-3.741l-.74-.056-.132-.73c-.518-2.858-2.818-4.933-5.467-4.933ZM6.086 16.597v-4.799h1.788l.517 2.843.504-2.843h1.788v4.798h-1.17L9.5 13.021l-.665 3.575h-.9l-.68-3.575v3.575H6.086Zm6.674-2.4c0 .323.005.59.014.804.009.212.028.381.057.507.029.125.071.213.127.262.056.05.131.074.226.074a.33.33 0 0 0 .225-.074c.056-.05.098-.137.127-.262a2.88 2.88 0 0 0 .057-.507c.01-.213.014-.481.014-.804 0-.322-.005-.59-.014-.803a2.883 2.883 0 0 0-.057-.507c-.029-.125-.071-.213-.127-.262a.329.329 0 0 0-.226-.074.329.329 0 0 0-.225.074c-.056.05-.098.137-.127.262a2.8 2.8 0 0 0-.057.507c-.01.213-.014.48-.014.803Zm-1.203-1.145a6.433 6.433 0 0 0-.087 1.145c0 .448.029.83.087 1.146.059.316.155.574.29.773.134.2.31.342.53.427.22.085.488.127.806.127.319 0 .587-.042.807-.127.22-.085.396-.228.53-.427.135-.2.232-.457.29-.773a6.46 6.46 0 0 0 .087-1.146c0-.448-.029-.83-.087-1.145a2.032 2.032 0 0 0-.29-.773 1.174 1.174 0 0 0-.53-.437 2.09 2.09 0 0 0-.806-.138 2.09 2.09 0 0 0-.807.138c-.22.092-.396.237-.53.437-.135.2-.231.457-.29.773Zm5.989-1.254c.363 0 .645.066.846.199.202.132.353.309.454.53.1.222.162.478.185.767.022.288.033.59.033.903 0 .314-.01.615-.033.904a2.263 2.263 0 0 1-.185.766 1.23 1.23 0 0 1-.454.531c-.201.132-.483.198-.846.198H15.73v-4.798h1.815Zm-.316 3.898h-.249v-2.997h.249a.69.69 0 0 1 .289.05c.072.034.126.104.165.212.038.107.062.26.073.457.012.197.017.457.017.78 0 .322-.005.582-.017.779-.01.197-.035.35-.074.457-.038.107-.093.178-.164.212a.69.69 0 0 1-.29.05Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
CloudMod.displayName = "Icon.Object.CloudMod";

// Icon/Object/CloudWs.tsx
var import_uik291 = require("@appd/uik");
var import_jsx_runtime281 = require("react/jsx-runtime");
var CloudWs = import_uik291.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime281.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.CloudWs",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime281.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M7.194 20.305h11.341c2.934 0 5.321-2.556 5.321-5.697 0-2.7-1.804-5.003-4.223-5.548-.912-3.417-3.845-5.831-7.205-5.831-2.656 0-5.078 1.487-6.431 3.916C3.114 7.744 1 10.452 1 13.662c0 3.662 2.779 6.643 6.194 6.643ZM7.492 8.43c.972-2.025 2.863-3.282 4.936-3.282 2.65 0 4.95 2.074 5.467 4.932l.133.731.74.055c1.776.134 3.168 1.777 3.168 3.741 0 2.082-1.526 3.777-3.401 3.777H7.195c-2.358 0-4.275-2.12-4.275-4.724 0-2.423 1.641-4.44 3.817-4.692l.526-.06.23-.478Zm2.588 3.206-.45 3.32-.39-3.32H8.03l.82 4.798h1.371l.417-3.225.43 3.225h1.37l.82-4.798h-1.21l-.335 3.32-.504-3.32h-1.13Zm6.53.259c.244.235.366.61.366 1.125h-1.17v-.114a.721.721 0 0 0-.087-.366.29.29 0 0 0-.269-.151c-.134 0-.233.043-.296.13a.49.49 0 0 0-.094.293c0 .157.05.281.151.373.101.092.228.171.38.239.152.067.316.135.49.204.175.07.339.16.491.273.153.112.28.258.38.44.1.181.151.418.151.709 0 .51-.145.881-.437 1.112-.29.23-.712.346-1.263.346-.26 0-.49-.021-.689-.064a1.236 1.236 0 0 1-.504-.222 1 1 0 0 1-.312-.413 1.63 1.63 0 0 1-.108-.632v-.168H15v.115c0 .206.038.35.114.433a.383.383 0 0 0 .296.124c.13 0 .23-.044.299-.134a.52.52 0 0 0 .104-.33.491.491 0 0 0-.145-.372 1.271 1.271 0 0 0-.362-.235 11.76 11.76 0 0 0-.474-.199 2.078 2.078 0 0 1-.474-.262 1.292 1.292 0 0 1-.363-.423c-.096-.175-.144-.403-.144-.686 0-.488.13-.86.39-1.115s.654-.383 1.182-.383c.547 0 .942.118 1.186.353Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
CloudWs.displayName = "Icon.Object.CloudWs";

// Icon/Object/ConsumerGroup.tsx
var import_uik292 = require("@appd/uik");
var import_jsx_runtime282 = require("react/jsx-runtime");
var ConsumerGroup = import_uik292.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime282.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.ConsumerGroup",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime282.jsx)(
      "path",
      {
        d: "M19.993 2.57H4.053v3h15.94v-3ZM7.97 21.887H3.591v-4h4.377v4Zm6.13 0H9.724v-4h4.378v4Zm6.308 0h-4.377v-4h4.377v4Zm-9.155-13.91v2.23H5.64c-.41 0-.75.34-.75.75v2.68H3.85l.95 1 .95 1 .95-1 .95-1H6.38v-1.93h4.863v1.93h-1.12l.95 1 .95 1 .95-1 .95-1h-1.18v-1.93h4.898v1.93h-1.26l.95 1 .95 1 .95-1 .95-1h-1.05v-2.68c0-.41-.34-.75-.75-.75h-5.648v-3.23h-1.5l.02 1Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
ConsumerGroup.displayName = "Icon.Object.ConsumerGroup";

// Icon/Object/CustomExitpoint.tsx
var import_uik293 = require("@appd/uik");
var import_jsx_runtime283 = require("react/jsx-runtime");
var CustomExitpoint = import_uik293.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime283.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.CustomExitpoint",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime283.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M11.5 17.939H13v-2.43h2v3.4a1 1 0 0 1-1 1h-2.46v2.94a1 1 0 0 1-1.54.82l-7.44-4.93a1 1 0 0 1-.43-.82V4.229a1 1 0 0 1 1-1H14a1 1 0 0 1 1 1v3.4h-2v-2.4H6.36l4.7 3.11a1 1 0 0 1 .44.82v8.78Zm-7.4-.55 5.42 3.62v-.007L4.1 17.389Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime283.jsx)(
        "path",
        {
          d: "m19.32 7.379 3.44 3.44a1 1 0 0 1 0 1.41l-3.44 3.41a1 1 0 1 1-1.42-1.41l1.74-1.7H13v-2h6.64l-1.74-1.74a1 1 0 1 1 1.42-1.41Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
CustomExitpoint.displayName = "Icon.Object.CustomExitpoint";

// Icon/Object/CustomMetric.tsx
var import_uik294 = require("@appd/uik");
var import_jsx_runtime284 = require("react/jsx-runtime");
var CustomMetric = import_uik294.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime284.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.CustomMetric",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime284.jsx)(
      "path",
      {
        d: "M14 3.229h-4v15h4v-15Zm6 7h-4v8h4v-8Zm-17 9.5h18v2H3v-2Zm5-12.5H4v11h4v-11Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
CustomMetric.displayName = "Icon.Object.CustomMetric";

// Icon/Object/CustomTimer.tsx
var import_uik295 = require("@appd/uik");
var import_jsx_runtime285 = require("react/jsx-runtime");
var CustomTimer2 = import_uik295.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime285.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.CustomTimer",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime285.jsx)("path", { d: "M10 3.729h4a1 1 0 1 0 0-2h-4a1 1 0 0 0 0 2Zm1 5h2v6h-2v-6Z", fill: "#fff", fillOpacity: ".94" }),
      /* @__PURE__ */ (0, import_jsx_runtime285.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "m19.03 8.119.75-.75a.991.991 0 0 0 .005-1.398.995.995 0 0 0-1.415-.013l-.75.75a8.959 8.959 0 0 0-5.619-1.98c-4.804 0-8.875 3.96-8.998 8.764A8.994 8.994 0 0 0 12 22.729a8.994 8.994 0 0 0 7.03-14.61Zm-8.399-1.261c-2.758.52-4.982 2.744-5.502 5.502a7.01 7.01 0 0 0 8.24 8.239c2.758-.52 4.981-2.744 5.501-5.502a7.01 7.01 0 0 0-8.239-8.24Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
CustomTimer2.displayName = "Icon.Object.CustomTimer";

// Icon/Object/DatabaseCluster.tsx
var import_uik296 = require("@appd/uik");
var import_jsx_runtime286 = require("react/jsx-runtime");
var DatabaseCluster = import_uik296.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime286.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.DatabaseCluster",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime286.jsx)(
        "path",
        {
          d: "M3.98 8.766V7.37a8.478 8.478 0 0 0 1.62.535c.86.2 1.825.3 2.804.327 1.585-1.012 3.958-1.409 6.06-1.409.375 0 .733.01 1.077.03V5.16c0-2.126-3.476-3.093-6.706-3.093-2.748 0-5.84.732-6.551 2.369-.157.413-.156.698-.156.729v7.221c0 .245.053.49.156.725.52 1.197 2.316 1.908 4.317 2.205v-1.874c-1.681-.293-2.573-.853-2.622-1.064v-1.394a8.452 8.452 0 0 0 1.62.533c.317.073.663.116 1.002.166v-.492c-.003-.165.014-.614.238-1.204l.01-.03.014-.029c.008-.02.02-.036.029-.056a10.31 10.31 0 0 1-1.155-.228c-1.262-.338-1.73-.763-1.758-.88Zm4.855-4.847c3.144 0 4.788.959 4.855 1.25-.027.1-.495.526-1.757.862-.908.243-1.98.372-3.098.372-1.119 0-2.19-.129-3.098-.372-1.262-.336-1.73-.762-1.758-.879.067-.274 1.711-1.233 4.856-1.233Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime286.jsx)(
        "path",
        {
          d: "M16.348 8.606a15.997 15.997 0 0 0-1.95-.018c-2.301.117-4.651.73-5.612 1.932-.121.15-.226.309-.3.478-.16.425-.16.717-.16.749v7.416c0 .252.054.503.16.745.732 1.68 3.906 2.432 6.728 2.432 2.822 0 5.996-.752 6.728-2.432.105-.243.16-.494.16-.745v-7.421c0-1.935-2.806-2.934-5.754-3.136ZM20.2 19.163c-.069.29-1.758 1.275-4.986 1.275-3.228 0-4.917-.984-4.987-1.284l.001-1.431a8.68 8.68 0 0 0 1.664.548c1.016.234 2.165.358 3.322.358s2.306-.124 3.323-.358a8.71 8.71 0 0 0 1.663-.548v1.44Zm0-3.71c-.028.11-.508.547-1.804.894-.933.25-2.033.381-3.182.381s-2.25-.132-3.182-.381a7.38 7.38 0 0 1-.624-.198c-.824-.298-1.157-.607-1.18-.705v-1.433c.192.088.401.164.612.239.329.116.673.223 1.051.31a14.99 14.99 0 0 0 3.295.358l.028.001c1.157 0 2.306-.124 3.323-.358a8.748 8.748 0 0 0 1.663-.548v1.44Zm-.111-3.57a2.16 2.16 0 0 1-.315.22c-.286.165-.73.36-1.378.533a11.53 11.53 0 0 1-2.048.332c-.37.03-.748.05-1.134.05-.276 0-.548-.009-.816-.024a11.798 11.798 0 0 1-2.366-.358 7.215 7.215 0 0 1-.825-.27l-.005-.002a4.176 4.176 0 0 1-.547-.264c-.215-.125-.34-.235-.395-.308a.173.173 0 0 1-.033-.059.337.337 0 0 1 .102-.135c.118-.108.337-.247.655-.39.795-.357 2.212-.741 4.23-.741.405 0 .778.018 1.134.046 2.13.165 3.397.763 3.751 1.096.06.055.093.104.102.14-.008.027-.043.073-.112.134Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
DatabaseCluster.displayName = "Icon.Object.DatabaseCluster";

// Icon/Object/DatabaseServer.tsx
var import_uik297 = require("@appd/uik");
var import_jsx_runtime287 = require("react/jsx-runtime");
var DatabaseServer = import_uik297.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime287.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.DatabaseServer",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime287.jsx)(
      "path",
      {
        d: "M8.723 18.42H3.366a.945.945 0 1 0 0 1.89h5.458a3.01 3.01 0 0 1-.101-.734V18.42ZM3.837 8.978h14.167c.78 0 1.417-.638 1.417-1.417V4.728c0-.78-.638-1.417-1.417-1.417H3.837a1.42 1.42 0 0 0-1.416 1.417V7.56a1.42 1.42 0 0 0 1.416 1.417ZM4.31 5.2h13.223v1.889H4.31v-1.89Zm4.413 10.263v-.82H4.309v-1.89h4.474c.034-.18.084-.385.172-.618l.013-.034.015-.033c.11-.253.26-.496.457-.744.136-.169.299-.314.462-.458H3.837a1.42 1.42 0 0 0-1.416 1.417v2.833a1.42 1.42 0 0 0 1.416 1.417h4.886v-1.07Zm8.789-4.822c-.32-.022-.641-.034-.96-.034a13.6 13.6 0 0 0-.69.02c-1.948.098-3.937.618-4.75 1.634a1.81 1.81 0 0 0-.254.405c-.136.36-.135.607-.135.634v6.276c0 .213.046.425.135.63.62 1.422 3.306 2.059 5.694 2.059s5.075-.637 5.693-2.059a1.56 1.56 0 0 0 .136-.63v-6.281c0-1.637-2.375-2.482-4.87-2.654Zm3.26 8.935c-.058.246-1.488 1.08-4.22 1.08-2.732 0-4.162-.834-4.22-1.087v-1.212a7.38 7.38 0 0 0 1.408.464c.86.198 1.832.303 2.812.303.98 0 1.951-.105 2.812-.303a7.374 7.374 0 0 0 1.407-.464v1.219Zm0-3.14c-.024.094-.43.463-1.527.757-.79.21-1.72.323-2.693.323-.972 0-1.904-.112-2.693-.323a6.217 6.217 0 0 1-.528-.167c-.697-.253-.98-.515-1-.597l.001-.966v-.247c.163.074.34.138.518.202.279.099.57.189.89.263.852.197 1.816.3 2.788.302l.024.002c.98 0 1.951-.105 2.812-.304a7.417 7.417 0 0 0 1.407-.463v1.218Zm-.095-3.02a1.692 1.692 0 0 1-.266.184c-.242.14-.618.306-1.166.452a9.76 9.76 0 0 1-1.733.281c-.314.025-.633.042-.96.042-.233 0-.464-.007-.69-.02a9.985 9.985 0 0 1-2.003-.303 6.094 6.094 0 0 1-.698-.228l-.005-.002a3.539 3.539 0 0 1-.463-.223 1.202 1.202 0 0 1-.334-.26.147.147 0 0 1-.027-.05c.007-.03.036-.07.086-.115.1-.092.285-.209.554-.33.673-.302 1.872-.628 3.58-.628.342 0 .658.016.96.04 1.803.14 2.874.645 3.174.927.05.047.079.088.086.12-.006.021-.036.06-.095.112Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
DatabaseServer.displayName = "Icon.Object.DatabaseServer";

// Icon/Object/DatabaseService.tsx
var import_uik298 = require("@appd/uik");
var import_jsx_runtime288 = require("react/jsx-runtime");
var DatabaseService = import_uik298.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime288.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.DatabaseService",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime288.jsx)(
        "path",
        {
          d: "M7.31 13.921c-1.858-.497-2.908-1.214-2.908-1.692V9.474l.157.084c.768.41 1.708.737 2.752.978 1.439.333 3.065.506 4.689.506s3.249-.173 4.69-.506c1.044-.241 1.983-.567 2.752-.978.052-.029.105-.055.156-.084v2.755h1.9V6.886c0-2.728-4.778-4.154-9.498-4.154-4.166 0-8.372 1.113-9.302 3.25-.202.535-.195.904-.195.904V17.57c0 .32.07.62.195.905.93 2.136 5.136 3.25 9.302 3.25.108 0 .216-.003.325-.005v-1.9c-.11.002-.214.006-.325.006-4.714 0-7.598-1.461-7.598-2.256v-2.754c.051.029.104.056.157.084.768.411 1.708.737 2.752.978 1.44.332 3.065.505 4.689.505.108 0 .216-.007.325-.008v-1.9c-.111.002-.212.01-.325.01-1.878 0-3.459-.234-4.69-.564ZM12 4.631c4.714 0 7.598 1.46 7.598 2.255 0 .478-1.05 1.197-2.909 1.693-1.23.329-2.812.563-4.689.563-1.878 0-3.459-.234-4.69-.563-1.858-.496-2.908-1.215-2.908-1.693 0-.795 2.884-2.255 7.598-2.255Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime288.jsx)(
        "path",
        {
          d: "M19.6 19.829H17v-3.3h2.6v1l3-1.8-1-.6-2-1.1v.9h-2.7c-.7 0-1.3.5-1.4 1.1v1.3H13v1.5h2.5v1.1c0 .6.5 1.2 1.2 1.3h2.9v1l3-1.7-3-1.6v.9Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
DatabaseService.displayName = "Icon.Object.DatabaseService";

// Icon/Object/DatabaseShard.tsx
var import_uik299 = require("@appd/uik");
var import_jsx_runtime289 = require("react/jsx-runtime");
var DatabaseShard = import_uik299.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime289.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.DatabaseShard",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime289.jsx)(
        "path",
        {
          d: "M18.478 11.586c-.304.553-.757 1.034-1.326 1.443 2.05.376 3.147 1.096 3.147 1.45 0 .299-.766.854-2.218 1.248-.95.258-2.191.448-3.714.448-1.524 0-2.765-.19-3.715-.448-.962-.26-1.615-.591-1.95-.872a18.79 18.79 0 0 1-1.962-.189v4.05c0 2.225 3.836 3.39 7.627 3.39 3.789 0 7.625-1.165 7.625-3.39V14.48c0-1.382-1.483-2.355-3.514-2.893Zm1.82 5.097v2.033c0 .492-2.079 1.696-5.931 1.696-3.853 0-5.932-1.204-5.932-1.696v-2.033c.623.33 1.38.593 2.217.785 1.144.265 2.43.401 3.715.401 1.284 0 2.57-.136 3.714-.4.838-.193 1.596-.455 2.218-.787Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime289.jsx)(
        "path",
        {
          d: "M17.308 9.904V5.667c0-2.225-3.836-3.389-7.626-3.389-3.79 0-7.626 1.164-7.626 3.39v4.236c0 2.225 3.836 3.39 7.626 3.39 3.79 0 7.626-1.165 7.626-3.39ZM9.682 3.973c3.853 0 5.933 1.202 5.933 1.694 0 .298-.766.853-2.217 1.248-.951.258-2.192.447-3.716.447-1.523 0-2.764-.189-3.713-.447-1.454-.395-2.218-.95-2.218-1.248 0-.492 2.079-1.694 5.931-1.694Zm-5.93 5.931V7.87c.622.331 1.379.593 2.217.786 1.143.264 2.43.4 3.713.4 1.285 0 2.571-.136 3.716-.4.837-.193 1.594-.455 2.217-.786v2.034c0 .492-2.08 1.695-5.933 1.695-3.852 0-5.93-1.203-5.93-1.695Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
DatabaseShard.displayName = "Icon.Object.DatabaseShard";

// Icon/Object/Db.tsx
var import_uik300 = require("@appd/uik");
var import_jsx_runtime290 = require("react/jsx-runtime");
var Db = import_uik300.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime290.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.Db",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime290.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M2.698 5.983C3.628 3.845 7.834 2.732 12 2.732c4.72 0 9.497 1.426 9.497 4.154V17.57c0 .321-.07.62-.195.906-.93 2.136-5.136 3.25-9.302 3.25-4.166 0-8.372-1.114-9.302-3.251a2.231 2.231 0 0 1-.195-.905V6.886s-.007-.37.195-.903ZM16.69 8.579c1.859-.496 2.909-1.215 2.909-1.693 0-.796-2.884-2.255-7.598-2.255s-7.598 1.46-7.598 2.255c0 .478 1.05 1.197 2.909 1.693 1.23.329 2.81.563 4.689.563 1.877 0 3.459-.234 4.69-.563ZM4.402 17.57c0 .795 2.884 2.256 7.598 2.256s7.598-1.461 7.598-2.256v-2.754c-.04.023-.082.045-.123.066l-.033.018c-.77.411-1.709.737-2.753.978-1.44.332-3.065.505-4.689.505s-3.25-.173-4.69-.505c-1.043-.24-1.983-.567-2.751-.978-.053-.028-.106-.055-.157-.084v2.754Zm15.196-5.341c0 .478-1.05 1.195-2.909 1.692-1.23.33-2.812.564-4.689.564-1.878 0-3.459-.234-4.69-.564-1.858-.497-2.908-1.214-2.908-1.692V9.474l.105.056.052.028c.768.41 1.708.736 2.752.978 1.439.333 3.065.506 4.689.506s3.249-.173 4.69-.506c1.044-.242 1.983-.568 2.752-.978l.06-.032c.032-.017.065-.034.096-.052v2.755Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Db.displayName = "Icon.Object.Db";

// Icon/Object/Docker.tsx
var import_uik301 = require("@appd/uik");
var import_jsx_runtime291 = require("react/jsx-runtime");
var Docker = import_uik301.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime291.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.Docker",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime291.jsx)("path", { d: "M9.197 5.515h2.386V3.23H9.197v2.286Zm0 3.429h2.385V6.658H9.197v2.286Z", fill: "#fff", fillOpacity: ".94" }),
      /* @__PURE__ */ (0, import_jsx_runtime291.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M20.83 11.957c.93-.238 2.05-.181 2.856.296l.314.174-.183.292c-.682 1.308-2.102 1.652-3.53 1.594-2.172 4.997-6.753 7.472-12.337 7.293-5.317-.17-7.325-3.921-7.325-3.921-.497-1.072-.715-2.303-.59-3.434l.062-.44h16.257c.499.003.997.005 1.495-.154.125-.06.264-.098.404-.136.14-.038.28-.077.404-.136-.31-.418-.496-.952-.558-1.488-.064-.713.123-1.665.62-2.201l.248-.298.31.238c.808.596 1.429 1.37 1.553 2.32ZM4.717 16.404c-.726 0-1.27.547-1.27 1.218 0 .67.605 1.217 1.27 1.217.666 0 1.271-.547 1.271-1.217s-.544-1.218-1.27-1.218Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime291.jsx)(
        "path",
        {
          d: "M15.16 8.944h-2.386V6.658h2.385v2.286Zm-3.578 3.429H9.197v-2.286h2.385v2.286ZM5.62 8.944h2.384V6.658H5.62v2.286Zm2.384 3.429H5.62v-2.286h2.385v2.286Zm4.77 0h2.385v-2.286h-2.385v2.286Zm-8.347 0H2.042v-2.286h2.385v2.286Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
Docker.displayName = "Icon.Object.Docker";

// Icon/Object/EndpointTcp.tsx
var import_uik302 = require("@appd/uik");
var import_jsx_runtime292 = require("react/jsx-runtime");
var EndpointTcp = import_uik302.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime292.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.EndpointTcp",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime292.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M16.4 8.729H20a1.58 1.58 0 0 1 1.58 1.54v1.53a1.58 1.58 0 0 1-1.58 1.54h-2.06v2.39H16.4v-7Zm1.54 3.07H20v-1.53h-2.06v1.53Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime292.jsx)(
        "path",
        {
          d: "M9.3 10.198v4.17a1.44 1.44 0 0 0 1.44 1.43h3.76v-1.6h-3.66v-4h3.66v-1.47h-3.76a1.45 1.45 0 0 0-1.44 1.47Zm-5 .07H2.5v-1.54h5.14v1.54h-1.8v5.5H4.3v-5.5Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
EndpointTcp.displayName = "Icon.Object.EndpointTcp";

// Icon/Object/ExitpointCache.tsx
var import_uik303 = require("@appd/uik");
var import_jsx_runtime293 = require("react/jsx-runtime");
var ExitpointCache = import_uik303.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime293.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.ExitpointCache",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime293.jsx)(
        "path",
        {
          d: "M14 10.229h6c.55 0 1 .45 1 1v2c0 .55-.45 1-1 1h-6c-.55 0-1-.45-1-1v-.25h-2.25v5.5H13v-.25c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v2c0 .55-.45 1-1 1h-6c-.55 0-1-.45-1-1v-.25H7v.25c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v.25h2.25v-5.5H7v.25c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v.25h2.25v-5.5H7v.25c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v.25h3.75v7H13v-.25c0-.55.45-1 1-1Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime293.jsx)(
        "path",
        {
          d: "M14 3.229h6c.55 0 1 .45 1 1v2c0 .55-.45 1-1 1h-6c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
ExitpointCache.displayName = "Icon.Object.ExitpointCache";

// Icon/Object/FileAttachment.tsx
var import_uik304 = require("@appd/uik");
var import_jsx_runtime294 = require("react/jsx-runtime");
var FileAttachment = import_uik304.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime294.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.FileAttachment",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime294.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M4.01 4.229c0-1.1.89-2 1.99-2h8l6 6v12c0 1.1-.9 2-2 2H5.99c-1.1 0-1.99-.9-1.99-2l.01-16Zm8.99-.5v5.5h5.5l-5.5-5.5Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
FileAttachment.displayName = "Icon.Object.FileAttachment";

// Icon/Object/FileServer.tsx
var import_uik305 = require("@appd/uik");
var import_jsx_runtime295 = require("react/jsx-runtime");
var FileServer = import_uik305.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime295.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.FileServer",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime295.jsx)(
        "path",
        {
          d: "M2.387 19.343c0 .52.423.945.945.945h6.314l.002-1.89H3.332a.945.945 0 0 0-.945.945ZM3.803 8.955H17.97c.78 0 1.417-.638 1.417-1.417V4.705c0-.78-.638-1.417-1.417-1.417H3.803a1.42 1.42 0 0 0-1.416 1.417v2.833a1.42 1.42 0 0 0 1.416 1.417Zm.472-3.778h13.223v1.889H4.275v-1.89Zm0 9.443v-1.889h13.223v1.287l.028.027h1.861V12.26c0-.78-.638-1.417-1.417-1.417H3.803a1.42 1.42 0 0 0-1.416 1.417v2.833a1.42 1.42 0 0 0 1.416 1.417h5.845v-1.89H4.275Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime295.jsx)(
        "path",
        {
          d: "M22.091 16.152h-5.287l-1.244-1.244h-3.422a.491.491 0 0 0-.487.494l-.007 7.465a.5.5 0 0 0 .494.493h9.954a.501.501 0 0 0 .494-.494v-6.22a.5.5 0 0 0-.494-.494Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
FileServer.displayName = "Icon.Object.FileServer";

// Icon/Object/Fragment.tsx
var import_uik306 = require("@appd/uik");
var import_jsx_runtime296 = require("react/jsx-runtime");
var Fragment2 = import_uik306.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime296.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.Fragment",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime296.jsx)(
        "path",
        {
          d: "M6.29 2.729H20a1.53 1.53 0 0 1 1.48 1.5v13.71c0 .85-.69 1.54-1.54 1.54h-5.12v-2h4.66V4.709H6.73v4.7h-2v-5.12c0-.862.698-1.56 1.56-1.56Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime296.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M2.48 20.058a1.66 1.66 0 0 0 1.66 1.67h8.33v-10h-10l.01 8.33Zm8-.32h-6v-6h6v6Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
Fragment2.displayName = "Icon.Object.Fragment";

// Icon/Object/HealthRuleTemplate.tsx
var import_uik307 = require("@appd/uik");
var import_jsx_runtime297 = require("react/jsx-runtime");
var HealthRuleTemplate = import_uik307.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime297.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.HealthRuleTemplate",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime297.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M4.6 2.729h14.79a2.12 2.12 0 0 1 2.11 2.11v14.78a2.12 2.12 0 0 1-2.11 2.11H4.6a2.1 2.1 0 0 1-2.1-2.11V4.839a2.1 2.1 0 0 1 2.1-2.11Zm9.52 14.61h5.27v-12.5H4.61v12.5H9.9a2.11 2.11 0 0 0 4.22 0Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime297.jsx)("path", { d: "M6.5 7.729h11v2h-11v-2Zm0 4h11v2h-11v-2Z", fill: "#fff", fillOpacity: ".94" })
    ]
  }
));
HealthRuleTemplate.displayName = "Icon.Object.HealthRuleTemplate";

// Icon/Object/IframeEum.tsx
var import_uik308 = require("@appd/uik");
var import_jsx_runtime298 = require("react/jsx-runtime");
var IframeEum = import_uik308.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime298.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.IframeEum",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime298.jsx)(
        "path",
        {
          d: "M9.966 16.459a.75.75 0 0 1-1.111 1.008L6.711 15.1a.75.75 0 0 1 0-1.008l2.144-2.367a.75.75 0 1 1 1.111 1.007l-1.688 1.864 1.688 1.863Zm5.18 1.008 2.143-2.367a.751.751 0 0 0 0-1.008l-2.144-2.367a.75.75 0 0 0-1.11 1.006l1.687 1.865-1.688 1.864a.748.748 0 0 0 .556 1.253.748.748 0 0 0 .556-.246ZM9.41 6.229H6.38v1h3.03v-1Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime298.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M6 3.229h12c1.654 0 3 1.345 3 3v12c0 1.654-1.346 3-3 3H6c-1.654 0-3-1.346-3-3v-12c0-1.655 1.346-3 3-3Zm-1 15V9.738h14v8.49a1 1 0 0 1-1 1H6c-.551 0-1-.448-1-1Zm14-9.991v-2.01c0-.55-.448-1-1-1H6c-.551 0-1 .45-1 1v2.01h14Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
IframeEum.displayName = "Icon.Object.IframeEum";

// Icon/Object/Image.tsx
var import_uik309 = require("@appd/uik");
var import_jsx_runtime299 = require("react/jsx-runtime");
var Image = import_uik309.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime299.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.Image",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime299.jsx)("g", { clipPath: "url(#clip0_5958_44634)", children: /* @__PURE__ */ (0, import_jsx_runtime299.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M5.32954 21.4001H19.4996C20.549 21.4001 21.3996 20.5494 21.3996 19.5001V4.5001C21.3996 3.45076 20.549 2.6001 19.4996 2.6001H4.49961C3.45027 2.6001 2.59961 3.45076 2.59961 4.5001V19.5001C2.59961 20.5494 3.45027 21.4001 4.49961 21.4001H5.29858C5.3089 21.4002 5.31922 21.4002 5.32954 21.4001ZM8.09033 19.1001L16.1244 11.0653L19.0996 14.0414V19.1001H8.09033ZM19.0996 10.7883V4.9001H4.89961V19.0383L14.7801 9.15685L14.7805 9.15644C15.5222 8.41445 16.7249 8.41391 17.4671 9.15536L17.4683 9.15651L19.0996 10.7883ZM9 10.875C10.0355 10.875 10.875 10.0355 10.875 9C10.875 7.96447 10.0355 7.125 9 7.125C7.96447 7.125 7.125 7.96447 7.125 9C7.125 10.0355 7.96447 10.875 9 10.875Z",
          fill: "#7E868F",
          fillRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ (0, import_jsx_runtime299.jsx)("defs", { children: /* @__PURE__ */ (0, import_jsx_runtime299.jsx)("clipPath", { id: "clip0_5958_44634", children: /* @__PURE__ */ (0, import_jsx_runtime299.jsx)("rect", { fill: "white", height: "24", width: "24" }) }) })
    ]
  }
));
Image.displayName = "Icon.Object.Image";

// Icon/Object/IncomingTraffic.tsx
var import_uik310 = require("@appd/uik");
var import_jsx_runtime300 = require("react/jsx-runtime");
var IncomingTraffic = import_uik310.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime300.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.IncomingTraffic",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime300.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M18 19.192h2V5.229h-2v13.963Zm-7.707-3.661 2.293-2.293H5a1 1 0 1 1 0-2h7.586l-2.293-2.293a1 1 0 0 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 1 1-1.414-1.414Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
IncomingTraffic.displayName = "Icon.Object.IncomingTraffic";

// Icon/Object/Infopoint.tsx
var import_uik311 = require("@appd/uik");
var import_jsx_runtime301 = require("react/jsx-runtime");
var Infopoint = import_uik311.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime301.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.Infopoint",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime301.jsx)(
        "path",
        {
          d: "M10 1.729a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2h-4Zm2 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime301.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M19.785 5.97a.991.991 0 0 1-.005 1.399l-.75.75A8.994 8.994 0 0 1 12 22.729a8.994 8.994 0 0 1-8.997-9.236c.123-4.804 4.194-8.765 8.998-8.764 2.12 0 4.069.74 5.619 1.98l.75-.751a.995.995 0 0 1 1.415.013Zm-9.154.888c-2.758.52-4.982 2.744-5.502 5.502a7.01 7.01 0 0 0 8.24 8.239c2.758-.52 4.981-2.744 5.501-5.502a7.01 7.01 0 0 0-8.239-8.24Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
Infopoint.displayName = "Icon.Object.Infopoint";

// Icon/Object/Interactions.tsx
var import_uik312 = require("@appd/uik");
var import_jsx_runtime302 = require("react/jsx-runtime");
var Interactions = import_uik312.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime302.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.Interactions",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime302.jsx)(
        "path",
        {
          d: "M7.303 12.227a.998.998 0 0 1-1.699.137A6.938 6.938 0 0 1 4.25 8.23c0-3.86 3.14-7 7-7a7.008 7.008 0 0 1 6.355 9.94 1 1 0 0 1-1.815-.84 5.006 5.006 0 0 0-4.54-7.1c-2.756 0-5 2.243-5 5a4.965 4.965 0 0 0 .965 2.955.998.998 0 0 1 .088 1.043Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime302.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "m17.922 14.065-3.065-1.957a.974.974 0 0 0-.157-.08 2.236 2.236 0 0 0-.529-.15V7.555c0-1.44-1.611-2.325-2.767-2.325-1.155 0-2.766.885-2.766 2.325v8.255l-1.825-.383a.948.948 0 0 0-.084-.014l-.02-.004c-.549-.1-1.258.095-1.723.559l-.697.705a1 1 0 0 0 .004 1.41l4.364 4.366a2.337 2.337 0 0 0 1.643.68h5.998c1.137 0 2.087-.832 2.263-1.99l.662-4.654c.015-.11.027-.224.027-.319a2.342 2.342 0 0 0-1.328-2.1Zm-1.34 6.784c-.008.046-.055.28-.284.28H10.3a.334.334 0 0 1-.229-.096l-3.645-3.645 3.006.631a1.002 1.002 0 0 0 1.206-.978l-.011-9.423c.065-.14.481-.388.777-.388.297 0 .713.248.767.325v5.3a1 1 0 0 0 1 1l.736.02 3.001 1.915c.049.032.1.06.154.082.091.037.188.145.18.331l-.66 4.646Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
Interactions.displayName = "Icon.Object.Interactions";

// Icon/Object/Key.tsx
var import_uik313 = require("@appd/uik");
var import_jsx_runtime303 = require("react/jsx-runtime");
var Key = import_uik313.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime303.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.Key",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime303.jsx)(
        "path",
        {
          d: "M9.57 12.15c0 .372-.18.713-.494.937a1.125 1.125 0 0 1-1.27.005c-.606-.388-.649-1.42-.006-1.878.383-.264.89-.264 1.268-.005.307.197.502.56.502.942Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime303.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M13.25 9.654a5.486 5.486 0 0 0-4.82-2.897 5.43 5.43 0 0 0-3.98 1.715C3.421 9.554 2.89 11 2.955 12.547a5.453 5.453 0 0 0 5.1 5.101 5.437 5.437 0 0 0 5.16-2.895h1.867a.998.998 0 0 0 .72-.294l.657-.657.587.587a1 1 0 0 0 1.43.012l.586-.587.587.587a1.019 1.019 0 0 0 1.439 0l1.484-1.484c.38-.38.39-1.001.011-1.428l-1.542-1.542a1.012 1.012 0 0 0-.719-.294H13.25Zm4.552 3.058-.587-.587a1.02 1.02 0 0 0-1.44 0l-.943.944h-2.7l-.217.526a3.762 3.762 0 0 1-3.728 2.358 3.738 3.738 0 0 1-3.513-3.492 3.736 3.736 0 0 1 1.013-2.816 3.683 3.683 0 0 1 2.743-1.19c1.548 0 2.916.93 3.489 2.373l.214.522 7.891.012.847.847-.49.492-.564-.564a.999.999 0 0 0-1.428-.012l-.587.587Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
Key.displayName = "Icon.Object.Key";

// Icon/Object/Kubernetes.tsx
var import_uik314 = require("@appd/uik");
var import_jsx_runtime304 = require("react/jsx-runtime");
var Kubernetes = import_uik314.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime304.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.Kubernetes",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime304.jsx)(
        "path",
        {
          d: "M11.105 7.443c-.87.2-1.67.635-2.306 1.259l2 1.423c.083.059.177.07.26.059.058 0 .093-.035.14-.047.047-.024.094-.035.13-.082a.485.485 0 0 0 .117-.247l.142-2.447a7.09 7.09 0 0 0-.495.082h.012Zm.706 3.93-.47.588.164.718.682.33.671-.318.07-.295.095-.435-.47-.588h-.742Zm-1.282 2.374a.37.37 0 0 0-.07-.188c-.013-.024-.024-.06-.048-.083a.383.383 0 0 0-.27-.117h-.083l-2.4.4c.318.894.906 1.647 1.659 2.211.094.07.176.141.27.212l.93-2.247a.392.392 0 0 0 .012-.2v.012Zm5.752-4.127-1.811 1.623a.394.394 0 0 0-.13.27v.036c0 .094.024.176.083.259 0 0 .023.023.023.035a.341.341 0 0 0 .177.106l2.352.694c.024-.259.024-.53 0-.788a4.423 4.423 0 0 0-.117-.777c-.118-.505-.318-1-.6-1.458h.023ZM9.74 11.96a.362.362 0 0 0 .177-.118s.024-.024.024-.036a.423.423 0 0 0 .082-.258v-.036a.454.454 0 0 0-.13-.258L8.07 9.607a4.82 4.82 0 0 0-.682 3.035l2.34-.67.013-.012Zm6.988 1.823-2.423-.411h-.094a.326.326 0 0 0-.153.035.41.41 0 0 0-.2.53l.941 2.27a4.894 4.894 0 0 0 1.941-2.435l-.012.011Zm-3.823-3.988c0 .07.035.14.07.2 0 .012.012.023.024.035.059.07.141.13.235.141h.036a.4.4 0 0 0 .282-.059l1.988-1.4a4.567 4.567 0 0 0-.859-.647 4.705 4.705 0 0 0-1.929-.694l.141 2.436.012-.012Zm.282 5.917-.623-1.13a.442.442 0 0 0-.212-.176c-.047-.023-.106-.012-.153-.012s-.094 0-.141.012a.387.387 0 0 0-.212.177l-1.176 2.14c.847.283 1.753.33 2.623.13.165-.035.318-.082.47-.13l-.552-1-.024-.01Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime304.jsx)(
        "path",
        {
          d: "m23.328 14.112-1.918-8.34a1.52 1.52 0 0 0-.8-1l-7.775-3.718a1.47 1.47 0 0 0-1.295 0L5.753 3.82l-1.988.953c-.2.094-.377.235-.518.411 0 .012-.012.024-.024.036-.058.07-.105.153-.153.235-.047.094-.082.2-.117.318l-1.918 8.34a1.447 1.447 0 0 0 0 .635c.012.06.036.13.06.189.034.105.081.211.152.306.024.035.059.082.082.117l5.376 6.694s.048.059.06.082c.035.047.093.07.14.118.048.035.095.082.142.117.023 0 .035.012.058.024.118.07.236.13.365.165.118.035.247.047.377.047h8.775a.78.78 0 0 0 .224-.047.66.66 0 0 0 .141-.047H17s.082-.036.117-.047c.06-.024.106-.06.165-.095.141-.082.259-.188.353-.317l.13-.165.035-.035 3.694-4.6 1.517-1.894.035-.07c.071-.106.153-.224.189-.342.023-.058.035-.117.047-.176v-.106c.012-.082.023-.153.023-.235 0-.059-.011-.106-.023-.165 0-.059 0-.106-.024-.165l.07.012Zm-2.965-.095v.036c0 .012-.011.024-.023.036a.19.19 0 0 1-.047.082.141.141 0 0 1-.06.059c-.023.023-.046.035-.07.059a.56.56 0 0 1-.082.035c-.023 0-.059.024-.082.024h-.141c-.024 0-.06 0-.083-.024h-.023l-.118-.035a2.507 2.507 0 0 1-.412-.165 3.782 3.782 0 0 0-.812-.235.411.411 0 0 0-.258.094 5.607 5.607 0 0 0-.189-.036 6.064 6.064 0 0 1-2.682 3.377c.024.058.047.13.083.188a.36.36 0 0 0-.036.27c.118.26.247.506.412.742.094.117.177.247.247.376a.634.634 0 0 1 .059.13c.012.023.024.058.035.082v.047c0 .035.012.059.012.094v.082c0 .036 0 .06-.023.083 0 .023-.024.059-.036.082-.011.024-.035.047-.047.07a.31.31 0 0 1-.07.06c-.012 0-.024.023-.036.035-.011 0-.023 0-.047.012-.011 0-.023.023-.035.023h-.047c-.035 0-.059.012-.094.012h-.083c-.035 0-.058 0-.082-.024-.023 0-.059-.023-.082-.035-.024-.012-.047-.035-.07-.047a.31.31 0 0 1-.06-.07c0-.012-.023-.024-.035-.036-.012-.023-.024-.059-.035-.082a.55.55 0 0 1-.06-.118c-.058-.141-.093-.282-.128-.423a4.48 4.48 0 0 0-.318-.777.333.333 0 0 0-.235-.141c0-.024-.047-.07-.07-.13l-.024-.047a6.066 6.066 0 0 1-4.294 0l-.07.13-.036.059c-.07 0-.141.047-.2.094a3.53 3.53 0 0 0-.365.835 5.404 5.404 0 0 1-.13.424.55.55 0 0 1-.058.117l-.035.083c0 .011-.024.023-.036.035-.023.023-.035.047-.07.07a.232.232 0 0 1-.07.047c-.024.012-.06.036-.083.036-.024 0-.047.012-.082.023h-.095c-.023 0-.058 0-.082-.011h-.047c-.012 0-.024-.024-.047-.024-.012 0-.024 0-.035-.012-.012 0-.024-.023-.036-.023l-.07-.07c-.024-.024-.036-.048-.047-.06-.012-.023-.036-.058-.036-.082 0-.023-.011-.047-.023-.082v-.095c0-.035 0-.058.012-.094v-.047c0-.023.023-.059.035-.082 0 0 .047-.094.059-.13.07-.129.164-.246.247-.376.165-.235.306-.494.423-.753a.396.396 0 0 0-.047-.259l.083-.2a6.177 6.177 0 0 1-1.647-1.423 5.826 5.826 0 0 1-1.036-1.918h-.011l-.189.036a.471.471 0 0 0-.27-.094c-.282.059-.553.13-.812.235h-.035c-.13.07-.247.118-.377.165-.035 0-.082.023-.117.023h-.012s-.059.024-.082.024h-.141a.17.17 0 0 1-.083-.024c-.023 0-.047-.023-.082-.035a.285.285 0 0 1-.07-.059c-.024-.023-.036-.047-.06-.07a.19.19 0 0 1-.047-.083c0-.012-.023-.023-.023-.047v-.047c0-.012-.012-.024-.012-.035v-.141c0-.024.012-.06.024-.083 0-.035.023-.059.047-.082.011-.024.035-.047.047-.07a.311.311 0 0 1 .07-.06c.024-.011.047-.035.083-.046.011 0 .023-.024.047-.024a.217.217 0 0 0 .082-.024s.094-.023.13-.035c.152-.023.294-.035.446-.035.106 0 .2-.035.306-.047.177-.024.353-.047.53-.083a.543.543 0 0 0 .2-.2l.2-.058a6.022 6.022 0 0 1 .953-4.2l-.153-.13a.471.471 0 0 0-.094-.27 3.492 3.492 0 0 0-.695-.482C6.13 7.842 6 7.77 5.87 7.689c-.023-.023-.07-.047-.094-.082a.54.54 0 0 1-.2-.33.45.45 0 0 1 .082-.364.453.453 0 0 1 .377-.165c.118 0 .235.047.33.118.035.023.07.058.105.082.07.059.13.13.188.2.036.047.083.082.118.13.188.211.4.4.624.564a.315.315 0 0 0 .27.024l.059.035s.07.059.118.082a5.994 5.994 0 0 1 3.882-1.87v-.2c.059-.047.082-.106.106-.165.011-.023.047-.047.047-.082 0-.283 0-.565-.047-.847a2.675 2.675 0 0 1-.06-.447v-.224c0-.012 0-.023.012-.047 0-.035.012-.059.024-.094 0-.024.024-.047.035-.082a.291.291 0 0 1 .06-.07c.023-.024.046-.036.07-.06.023-.011.047-.035.082-.047a.222.222 0 0 1 .094-.023c.012 0 .024-.012.047-.012h.094a.09.09 0 0 1 .047.012c.036 0 .06.011.095.023.023 0 .046.024.07.036.024.011.047.035.07.058.024.024.036.047.06.07.011.024.035.048.046.083a.221.221 0 0 1 .024.094c0 .012.012.024.012.047v.224c0 .07-.024.13-.024.2 0 .082-.023.165-.035.247a4.083 4.083 0 0 0-.047.847c.012.07.07.13.118.176.011.012.011.036.035.047v.212c1.47.13 2.847.8 3.858 1.87l.177-.129c.094.012.188 0 .282-.035.224-.165.436-.353.624-.565.094-.117.2-.223.306-.33a.826.826 0 0 1 .105-.081s.047-.047.083-.06a.548.548 0 0 1 .235-.07h.047c.106 0 .2.047.282.118h.024v.023c.012.024.035.036.047.06.047.07.059.152.07.234v.048a.41.41 0 0 1-.117.282v.023a.312.312 0 0 1-.07.06s-.071.058-.107.082c-.129.082-.258.152-.388.223a4.862 4.862 0 0 0-.694.482.344.344 0 0 0-.082.26c-.024.023-.118.105-.165.152a6.06 6.06 0 0 1 .965 4.188l.188.059a.543.543 0 0 0 .2.2c.177.047.353.059.53.082.105.012.2.047.305.047.083 0 .165.012.247.024.07 0 .13 0 .2.011.036 0 .094.024.142.036 0 0 .058 0 .082.023.012 0 .023.012.047.024a.189.189 0 0 1 .082.047.14.14 0 0 1 .059.059c.024.023.035.047.059.07l.035.07c.012.036.024.06.024.095v.142c0 .011 0 .023-.012.046l-.07.059Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
Kubernetes.displayName = "Icon.Object.Kubernetes";

// Icon/Object/LoadBalancer.tsx
var import_uik315 = require("@appd/uik");
var import_jsx_runtime305 = require("react/jsx-runtime");
var LoadBalancer = import_uik315.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime305.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.LoadBalancer",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime305.jsx)(
      "path",
      {
        d: "M9.2 7.023v4H6.15c-.37-.71-1.1-1.2-1.95-1.2a2.2 2.2 0 0 0 0 4.4c.85 0 1.58-.49 1.95-1.2H9.2v4c0 1.11.89 2 2 2h5v-2h-5v-4h5v-2h-5v-4h5v-2h-5c-1.11 0-2 .89-2 2Zm10.719 2.781a2.219 2.219 0 1 0 0 4.438 2.219 2.219 0 0 0 0-4.438Zm0 6.009a2.219 2.219 0 1 0 0 4.438 2.219 2.219 0 0 0 0-4.438Zm0-7.471a2.219 2.219 0 1 0 0-4.438 2.219 2.219 0 0 0 0 4.438Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
LoadBalancer.displayName = "Icon.Object.LoadBalancer";

// Icon/Object/Location.tsx
var import_uik316 = require("@appd/uik");
var import_jsx_runtime306 = require("react/jsx-runtime");
var Location = import_uik316.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime306.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.Location",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime306.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M11.664 20.74C10.128 19.014 6 13.638 6 9.894 6 6.726 8.496 4.23 11.664 4.23c3.168 0 5.76 2.592 5.76 5.664 0 3.551-3.84 8.64-5.76 10.848Zm0-13.151a2.377 2.377 0 0 0-2.4 2.4c0 1.343 1.056 2.4 2.4 2.4 1.344 0 2.4-1.152 2.4-2.4 0-1.344-1.152-2.4-2.4-2.4Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Location.displayName = "Icon.Object.Location";

// Icon/Object/MainFrame.tsx
var import_uik317 = require("@appd/uik");
var import_jsx_runtime307 = require("react/jsx-runtime");
var MainFrame = import_uik317.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime307.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.MainFrame",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime307.jsx)(
        "path",
        {
          d: "M14.25 6.085h1.5v8.143h-1.5V6.085Zm-1.5 0h-1.5v8.143h1.5V6.085Zm-4.5 0h1.5v8.143h-1.5V6.085Zm0 10.144v2h5v-2h-5Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime307.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M7 2.229h10c1.1 0 2 .9 2 2v16c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2v-16c0-1.1.9-2 2-2Zm10 18H7v-16h10v16Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
MainFrame.displayName = "Icon.Object.MainFrame";

// Icon/Object/MessageProcessor.tsx
var import_uik318 = require("@appd/uik");
var import_jsx_runtime308 = require("react/jsx-runtime");
var MessageProcessor = import_uik318.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime308.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.MessageProcessor",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime308.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M16.84 11.72c.747 0 1.353-.606 1.353-1.351V4.155c0-.745-.607-1.352-1.352-1.352H7.223c-.746 0-1.352.607-1.352 1.352v6.214c0 .745.606 1.352 1.352 1.352h9.618Zm-.522-7.415-4.286 2.679-4.286-2.679h8.572ZM7.373 5.628v4.59h9.318v-4.59L12.032 8.54 7.373 5.628Z",
          fill: "#DADADA",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime308.jsx)(
        "path",
        {
          d: "M19.969 19.578v-2.925c0-.593-.48-1.073-1.074-1.073h-6.18v-2.245h-1.5v2.244H5.17c-.593 0-1.074.481-1.074 1.074v2.925H2.807l1.02 1.105 1.018 1.105 1.02-1.105 1.018-1.105H5.595V17.08h5.62v2.498H9.907l1.019 1.105 1.02 1.105 1.018-1.105 1.02-1.105h-1.267V17.08h5.753v2.498h-1.29l1.019 1.105 1.019 1.105 1.019-1.105 1.019-1.105h-1.288Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
MessageProcessor.displayName = "Icon.Object.MessageProcessor";

// Icon/Object/MessagingServer.tsx
var import_uik319 = require("@appd/uik");
var import_jsx_runtime309 = require("react/jsx-runtime");
var MessagingServer = import_uik319.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime309.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.MessagingServer",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime309.jsx)(
        "path",
        {
          d: "M3.332 17.898a.945.945 0 1 0 0 1.89h5.24v-1.89h-5.24Zm.471-9.443H17.97c.78 0 1.417-.638 1.417-1.417V4.205c0-.78-.638-1.417-1.417-1.417H3.803a1.42 1.42 0 0 0-1.416 1.417v2.833a1.42 1.42 0 0 0 1.416 1.417Zm.472-3.778h13.223v1.889H4.275v-1.89Zm15.112 7.561v-.478c0-.78-.638-1.417-1.417-1.417H3.803a1.42 1.42 0 0 0-1.416 1.417v2.833a1.42 1.42 0 0 0 1.416 1.417h4.768v-1.89H4.275v-1.889",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime309.jsx)(
        "path",
        {
          d: "M10.571 22.188H22.38v-7.95H10.57v7.95Zm1.181-6.456 4.723 2.964 4.724-2.964v1.185l-4.724 2.964-4.723-2.964v-1.185Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
MessagingServer.displayName = "Icon.Object.MessagingServer";

// Icon/Object/Method.tsx
var import_uik320 = require("@appd/uik");
var import_jsx_runtime310 = require("react/jsx-runtime");
var Method = import_uik320.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime310.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.Method",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime310.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M2.4 12.229c0-5.28 4.32-9.6 9.6-9.6 5.28 0 9.6 4.32 9.6 9.6 0 5.28-4.32 9.6-9.6 9.6-5.28 0-9.6-4.32-9.6-9.6Zm13.056 3.456h1.92v-4.8c0-.48-.096-.864-.192-1.152a2.09 2.09 0 0 0-.48-.768c-.192-.192-.48-.288-.768-.384-.384-.096-.672-.096-1.056-.096-.48 0-.864.192-1.248.384s-.672.48-.864.768a1.884 1.884 0 0 0-.864-.864 2.657 2.657 0 0 0-1.248-.288c-.48 0-.864.096-1.248.288-.288.192-.576.48-.864.864v-.96H6.72v7.008h1.92v-4.033c0-.383.096-.671.192-.863.096-.192.288-.384.384-.48a.505.505 0 0 1 .2-.114c.051-.02.11-.042.184-.079.192-.095.288-.095.384-.095.288 0 .48.095.672.191.096.097.192.193.288.385.096.192.096.383.096.575v4.512h1.92v-4.511c0-.193.096-.384.192-.576a.75.75 0 0 1 .384-.384c.192-.096.384-.192.672-.192.288 0 .48 0 .672.095a.75.75 0 0 1 .384.385c.096.192.192.383.192.575v4.608Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Method.displayName = "Icon.Object.Method";

// Icon/Object/MetricTreeFolder.tsx
var import_uik321 = require("@appd/uik");
var import_jsx_runtime311 = require("react/jsx-runtime");
var MetricTreeFolder = import_uik321.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime311.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.MetricTreeFolder",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime311.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M22 18.229c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2l.01-12c0-1.1.89-2 1.99-2h6l2 2h8c1.1 0 2 .9 2 2v10ZM9.656 17.227H7.524v-3.41h2.132v3.41Zm3.41 0h-2.132V9.27h2.132v7.957Zm3.41 0h-2.132V12.68h2.132v4.547Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
MetricTreeFolder.displayName = "Icon.Object.MetricTreeFolder";

// Icon/Object/MobileCustomMetric.tsx
var import_uik322 = require("@appd/uik");
var import_jsx_runtime312 = require("react/jsx-runtime");
var MobileCustomMetric = import_uik322.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime312.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.MobileCustomMetric",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime312.jsx)("path", { d: "M21 5.229h-3v16h3v-16Zm-15 3H3v13h3v-13Zm2 4h3v9H8v-9Zm8-3h-3v12h3v-12Z", fill: "#fff", fillOpacity: ".94" })
  }
));
MobileCustomMetric.displayName = "Icon.Object.MobileCustomMetric";

// Icon/Object/MobileInfoPoint.tsx
var import_uik323 = require("@appd/uik");
var import_jsx_runtime313 = require("react/jsx-runtime");
var MobileInfoPoint = import_uik323.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime313.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.MobileInfoPoint",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime313.jsx)(
        "path",
        {
          d: "M10.004 3.229h4a1 1 0 1 0 0-2h-4a1 1 0 0 0 0 2Zm2 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime313.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M19.754 5.469a1 1 0 0 1 0 1.4l-.75.75a9 9 0 1 1-16 5.37 9.11 9.11 0 0 1 9-8.76 9 9 0 0 1 5.62 2l.73-.76a1 1 0 0 1 1.4 0ZM4.996 13.703a7 7 0 0 0 6.524 6.524c3.502.231 6.634-2.167 7.354-5.629a7 7 0 0 0-8.27-8.22 7 7 0 0 0-5.608 7.325Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
MobileInfoPoint.displayName = "Icon.Object.MobileInfoPoint";

// Icon/Object/MongoDb.tsx
var import_uik324 = require("@appd/uik");
var import_jsx_runtime314 = require("react/jsx-runtime");
var MongoDb = import_uik324.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime314.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.MongoDb",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime314.jsx)(
        "path",
        {
          d: "M4.002 15.936c0 .703 2.553 1.997 6.726 1.997 1.383 0 2.584-.144 3.577-.36.216.563.457 1.084.713 1.561-1.308.317-2.8.48-4.29.48-3.688 0-7.412-.986-8.235-2.877a1.976 1.976 0 0 1-.172-.801c-.047-5.062-.047-8.33 0-9.805C2.39 3.92 7.04 2.8 10.728 2.8c1.918 0 3.84.27 5.366.79-.286.425-.58.922-.866 1.486-1.13-.342-2.657-.595-4.5-.595-4.173 0-6.726 1.292-6.726 1.997 0 .423.93 1.059 2.575 1.498 1.089.292 2.488.499 4.151.499 1.27 0 2.386-.123 3.329-.31a17.7 17.7 0 0 0-.383 1.768c-.947.145-1.945.223-2.946.223-1.438 0-2.877-.153-4.151-.447-.924-.214-1.757-.503-2.437-.866l-.044-.024-.094-.05v2.438c0 .423.93 1.059 2.575 1.499 1.089.291 2.488.498 4.151.498a17.58 17.58 0 0 0 2.712-.207c.007.583.044 1.145.118 1.68a19.71 19.71 0 0 1-2.83.208c-1.438 0-2.876-.153-4.151-.447-.924-.213-1.757-.502-2.437-.866l-.138-.074v2.438Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime314.jsx)(
        "path",
        {
          d: "M18.26 4.164s.227.661.454 1.034c.047.12.182.283.372.514.647.785 1.934 2.347 2.561 5.593.633 4.339-1.236 6.989-2.225 8.06a5.354 5.354 0 0 1-.505.484 1.272 1.272 0 0 0-.214.49c-.117.622-.033 1.906-.033 1.906l-.414-.16s.028-1.324-.254-2.098a8.705 8.705 0 0 1-1.27-1.408 9.977 9.977 0 0 1-.885-1.454 9.373 9.373 0 0 1-.981-4.416v-.073c-.001-.029-.002-.057 0-.087.045-1.122.215-2.105.449-2.965.21-.769.47-1.437.75-2.007a9.793 9.793 0 0 1 1.007-1.641c.378-.494.695-.801.835-.93a1.7 1.7 0 0 0 .229-.358c.074-.162.092-.307.107-.533a.535.535 0 0 1 .016.05Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
MongoDb.displayName = "Icon.Object.MongoDb";

// Icon/Object/MonitoringStatus.tsx
var import_uik325 = require("@appd/uik");
var import_jsx_runtime315 = require("react/jsx-runtime");
var MonitoringStatus = import_uik325.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime315.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.MonitoringStatus",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime315.jsx)(
      "path",
      {
        d: "M7.672 3.904C6.752 3.904 6 4.657 6 5.576v5.85h3.227l1.416-4.737a.75.75 0 0 1 .695-.534.735.735 0 0 1 .727.489l3.023 8.165.53-1.382.908-2.088a.749.749 0 0 1 .688-.45H20a.75.75 0 0 1 0 1.5h-2.295l-.7 1.606-1.229 3.21a.75.75 0 0 1-1.403-.009L11.438 9.27l-.934 3.121a.75.75 0 0 1-.718.535H2v1.978h4v3.273c0 .92.753 1.672 1.672 1.672h12.656c.92 0 1.672-.752 1.672-1.672v-12.6c0-.92-.753-1.673-1.672-1.673H7.672Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
MonitoringStatus.displayName = "Icon.Object.MonitoringStatus";

// Icon/Object/NetworkRequest.tsx
var import_uik326 = require("@appd/uik");
var import_jsx_runtime316 = require("react/jsx-runtime");
var NetworkRequest = import_uik326.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime316.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.NetworkRequest",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime316.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "m17 5.229 4 4-4 4v-3h-7v-2h7v-3Zm-14 10 4-4v3h7v2H7v3l-4-4Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
NetworkRequest.displayName = "Icon.Object.NetworkRequest";

// Icon/Object/Node.tsx
var import_uik327 = require("@appd/uik");
var import_jsx_runtime317 = require("react/jsx-runtime");
var Node = import_uik327.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime317.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.Node",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime317.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M15.5 2.729c.825 0 1.5.675 1.5 1.5v16c0 .825-.675 1.5-1.5 1.5h-7c-.825 0-1.5-.675-1.5-1.5v-16c0-.825.675-1.5 1.5-1.5h7Zm-.5 17v-15H9v15h6ZM9.75 7.479c0 .414.336.75.75.75h3a.75.75 0 0 0 0-1.5h-3a.75.75 0 0 0-.75.75Zm.75 3.6a.75.75 0 0 1 0-1.5h3a.75.75 0 0 1 0 1.5h-3Zm.5 5.9c0 .524.448.95 1 .95s1-.426 1-.95c0-.525-.448-.95-1-.95s-1 .425-1 .95Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Node.displayName = "Icon.Object.Node";

// Icon/Object/Notebook.tsx
var import_uik328 = require("@appd/uik");
var import_jsx_runtime318 = require("react/jsx-runtime");
var Notebook = import_uik328.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime318.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.Notebook",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime318.jsx)(
      "path",
      {
        d: "M108,108a12,12,0,0,1,12-12h56a12,12,0,0,1,0,24H120A12,12,0,0,1,108,108Zm68,28H120a12,12,0,0,0,0,24h56a12,12,0,0,0,0-24Zm52-88V208a20,20,0,0,1-20,20H48a20,20,0,0,1-20-20V48A20,20,0,0,1,48,28H208A20,20,0,0,1,228,48ZM52,204H68V52H52ZM204,52H92V204H204Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
Notebook.displayName = "Icon.Object.Notebook";

// Icon/Object/OpenTelemetry.tsx
var import_uik329 = require("@appd/uik");
var import_jsx_runtime319 = require("react/jsx-runtime");
var OpenTelemetry = import_uik329.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime319.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.OpenTelemetry",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime319.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M15.17 3.538 14 4.728a.6.6 0 0 0 0 .84l4.6 4.66a.61.61 0 0 0 .85 0l1.18-1.18a.6.6 0 0 0 0-.84L16 3.538a.6.6 0 0 0-.84 0h.01Zm-2.69 9.49a1.93 1.93 0 1 0 2.73 0 1.94 1.94 0 0 0-2.73 0Zm-5.58 4.85a.54.54 0 0 1 0 .76l-1.24 1.25.34.34a.49.49 0 0 1 .05.68.48.48 0 0 1-.68 0l-2.05-2a.48.48 0 1 1 .68-.68l.3.29 1.24-1.29a.56.56 0 0 1 .76 0l.6.65Zm6.25-10.94-2.63 2.62a.61.61 0 0 0 0 .85l1.62 1.62a2.92 2.92 0 0 1 3.78.31l1.32-1.31a.61.61 0 0 0 0-.85L14 6.938a.59.59 0 0 0-.85 0ZM11.452 12.7l.008.009v-.02l-.008.011Zm-.992-.991.992.991a3 3 0 0 0-.242 2.989l-2.17 2.17a.58.58 0 0 1-.81 0l-1.92-1.91a.59.59 0 0 1 0-.82l3.34-3.42a.58.58 0 0 1 .81 0Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
OpenTelemetry.displayName = "Icon.Object.OpenTelemetry";

// Icon/Object/OutgoingCall.tsx
var import_uik330 = require("@appd/uik");
var import_jsx_runtime320 = require("react/jsx-runtime");
var OutgoingCall = import_uik330.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime320.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.OutgoingCall",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime320.jsx)(
        "path",
        {
          d: "M2.778 13.668a7.154 7.154 0 0 0 12.007 3.184l1.692 1.705a9.554 9.554 0 1 1-.002-13.458l-1.691 1.704a7.154 7.154 0 0 0-12.006 6.865Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime320.jsx)(
        "path",
        {
          d: "m20.071 7.914 3.059 3.094a1.172 1.172 0 0 1 0 1.641l-3.058 3.093a1.132 1.132 0 0 1-1.62 0 .073.073 0 0 1-.013-.021.073.073 0 0 0-.013-.021 1.168 1.168 0 0 1 .026-1.599l.65-.657.45-.456H9.548c-.631 0-1.147-.52-1.147-1.16a1.156 1.156 0 0 1 1.147-1.159h10.007l-.451-.457-.65-.658a1.166 1.166 0 0 1-.028-1.597.096.096 0 0 0 .013-.021c.004-.008.008-.016.014-.022a1.133 1.133 0 0 1 1.62 0Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
OutgoingCall.displayName = "Icon.Object.OutgoingCall";

// Icon/Object/OutgoingTraffic.tsx
var import_uik331 = require("@appd/uik");
var import_jsx_runtime321 = require("react/jsx-runtime");
var OutgoingTraffic = import_uik331.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime321.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.OutgoingTraffic",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime321.jsx)(
      "path",
      {
        d: "M6 5.229H4v13.963h2V5.229Zm9.728 2.301 4 4a1 1 0 0 1 0 1.415l-4 4a1 1 0 0 1-1.414-1.414l2.293-2.293H9.021a1 1 0 1 1 0-2h7.586l-2.293-2.293a1 1 0 1 1 1.414-1.414Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
OutgoingTraffic.displayName = "Icon.Object.OutgoingTraffic";

// Icon/Object/Page.tsx
var import_uik332 = require("@appd/uik");
var import_jsx_runtime322 = require("react/jsx-runtime");
var Page = import_uik332.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime322.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.Page",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime322.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M21.5 19.619v-14.8a1.94 1.94 0 0 0-1.73-2.09H4.23a1.94 1.94 0 0 0-1.73 2.09v14.8a2 2 0 0 0 1.73 2.11h15.54a2 2 0 0 0 1.73-2.11Zm-2.01-10.89v-3.91a.277.277 0 0 0 0-.09h-15a.28.28 0 0 0 0 .09v3.91h15Zm0 2h-15v8.89a.37.37 0 0 0 0 .11h15a.369.369 0 0 0 0-.11v-8.89ZM9 6.229h8v1H9v-1Zm-1.5 0H6v1h1.5v-1Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Page.displayName = "Icon.Object.Page";

// Icon/Object/Participants.tsx
var import_uik333 = require("@appd/uik");
var import_jsx_runtime323 = require("react/jsx-runtime");
var Participants2 = import_uik333.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime323.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.Participants",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime323.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M7.604 12.788a3.885 3.885 0 1 0 0-7.77 3.885 3.885 0 0 0 0 7.77Zm0-5.937a2.053 2.053 0 1 1 0 4.105 2.053 2.053 0 0 1 0-4.105Zm10.652 2.052a2.053 2.053 0 1 0-4.105 0 2.053 2.053 0 0 0 4.105 0Zm-2.052 3.885a3.885 3.885 0 1 0 0-7.77 3.885 3.885 0 0 0 0 7.77ZM2.106 18.525H.273c0-2.48 1.636-4.582 3.767-4.582h7.128c2.13 0 3.767 2.103 3.767 4.582h-1.833c0-1.553-.93-2.75-1.934-2.75H4.04c-1.004 0-1.934 1.196-1.934 2.75Zm19.596 0h1.832c0-2.48-1.635-4.582-3.767-4.582h-3.563v1.833h3.563c1.005 0 1.935 1.195 1.935 2.749Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Participants2.displayName = "Icon.Object.Participants";

// Icon/Object/Placeholder.tsx
var import_uik334 = require("@appd/uik");
var import_jsx_runtime324 = require("react/jsx-runtime");
var Placeholder = import_uik334.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime324.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.Placeholder",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime324.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M0 .229h24v24H0v-24Zm11.957 11.25 4.95-4.95.707.707-4.95 4.95 4.95 4.95-.707.706-4.95-4.95-4.95 4.95-.707-.707 4.95-4.95-4.95-4.95.707-.706 4.95 4.95ZM1 23.228v-22h22v22H1Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Placeholder.displayName = "Icon.Object.Placeholder";

// Icon/Object/Platform.tsx
var import_uik335 = require("@appd/uik");
var import_jsx_runtime325 = require("react/jsx-runtime");
var Platform = import_uik335.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime325.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.Platform",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime325.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M2.615 7.964a1 1 0 0 0-.032 1.832l8.775 4.024a1.003 1.003 0 0 0 .817.008l9.22-4.033a.99.99 0 0 0 .535-.54 1.001 1.001 0 0 0-.56-1.298l-9.227-3.659a1.003 1.003 0 0 0-.753.007l-8.775 3.66Zm2.879.967 6.29-2.623 6.614 2.623-6.613 2.885L5.494 8.93ZM20.6 11.629a1 1 0 1 1 .799 1.833l-9.225 4.024a1 1 0 0 1-.817-.008l-8.775-4.023a1 1 0 0 1 .834-1.818l8.368 3.837 8.816-3.845Zm1.316 4.176a1 1 0 0 0-1.316-.518l-8.816 3.846-8.368-3.838a1 1 0 1 0-.834 1.818l8.775 4.025a1.002 1.002 0 0 0 .817.007l9.224-4.024a1 1 0 0 0 .518-1.316Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Platform.displayName = "Icon.Object.Platform";

// Icon/Object/Presenter.tsx
var import_uik336 = require("@appd/uik");
var import_jsx_runtime326 = require("react/jsx-runtime");
var Presenter = import_uik336.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime326.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.Presenter",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime326.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M7.224 1.229h14.27A2.51 2.51 0 0 1 24 3.734v11.544a2.508 2.508 0 0 1-2.506 2.504h-10.42a23.566 23.566 0 0 0 3.818-2.147h6.602a.363.363 0 0 0 .36-.357V3.734a.364.364 0 0 0-.36-.358H7.224a.363.363 0 0 0-.359.358v3.14a4.405 4.405 0 0 0-2.146-1.17v-1.97a2.508 2.508 0 0 1 2.505-2.505ZM4.436 14.41c4.25.864 9.014-3.293 9.061-3.336l1.905 2.136c-.195.177-4.126 3.657-8.734 4.124.002 0 .001.06 0 .12v6.273H0v-6.186a3.336 3.336 0 0 1 3.333-3.333c.377.004.75.073 1.103.203Zm-.668-7.099a2.684 2.684 0 1 0 0 5.369 2.684 2.684 0 0 0 0-5.369Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Presenter.displayName = "Icon.Object.Presenter";

// Icon/Object/RealUser.tsx
var import_uik337 = require("@appd/uik");
var import_jsx_runtime327 = require("react/jsx-runtime");
var RealUser = import_uik337.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime327.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.RealUser",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime327.jsx)(
      "path",
      {
        d: "M11.738 5.995a1.867 1.867 0 1 0-.002-3.733 1.867 1.867 0 0 0 .002 3.733Zm2.244 8.919c.027-.355.212-.68.505-.883l.48-.333c.318-.222.508-.584.508-.972V8.2c0-.587-.43-1.086-1.013-1.171l-.44-.064a1.183 1.183 0 0 0-1.229.636 1.184 1.184 0 0 1-2.112 0 1.183 1.183 0 0 0-1.227-.636l-.442.064A1.184 1.184 0 0 0 8 8.198v4.528c0 .388.19.75.508.972l.48.333c.292.204.478.527.505.883l.472 6.185a1.184 1.184 0 0 0 1.181 1.095h1.182c.62 0 1.134-.476 1.181-1.095l.473-6.185Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
RealUser.displayName = "Icon.Object.RealUser";

// Icon/Object/Resources.tsx
var import_uik338 = require("@appd/uik");
var import_jsx_runtime328 = require("react/jsx-runtime");
var Resources = import_uik338.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime328.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.Resources",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime328.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M12 6.229h8c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2l.01-12c0-1.1.89-2 1.99-2h6l2 2Zm3.3 10.4.9-1.6-2.6-1.7 2.6-1.7-.9-1.6-2.4 1.6v-3.2h-1.8v3.3l-2.4-1.6-.9 1.6 2.5 1.6-2.5 1.7.9 1.6 2.4-1.6v3.2h1.8v-3.2l2.4 1.6Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Resources.displayName = "Icon.Object.Resources";

// Icon/Object/Server.tsx
var import_uik339 = require("@appd/uik");
var import_jsx_runtime329 = require("react/jsx-runtime");
var Server = import_uik339.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime329.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.Server",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime329.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M19.5 3.229h-15c-.825 0-1.5.675-1.5 1.5v3c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5v-3c0-.825-.675-1.5-1.5-1.5Zm-.5 2H5v2h14v-2Zm-14.5 6h15c.825 0 1.5.675 1.5 1.5v3c0 .825-.675 1.5-1.5 1.5H13v1.998h7a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2h7V17.23H4.5c-.825 0-1.5-.675-1.5-1.5v-3c0-.825.675-1.5 1.5-1.5Zm.5 4h14v-2H5v2Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Server.displayName = "Icon.Object.Server";

// Icon/Object/SessionFrame.tsx
var import_uik340 = require("@appd/uik");
var import_jsx_runtime330 = require("react/jsx-runtime");
var SessionFrame = import_uik340.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime330.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.SessionFrame",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime330.jsx)(
        "path",
        {
          d: "M4 4.229h7v-2H4a2 2 0 0 0-2 2v7h2v-7Zm16-2h-7v2h7v7h2v-7a2 2 0 0 0-2-2Zm-7 18h7v-7h2v7a2 2 0 0 1-2 2h-7v-2Zm-9-7H2v7a2 2 0 0 0 2 2h7v-2H4v-7Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime330.jsx)("path", { d: "M17.5 7.339h-11v9.78h11v-9.78Z", fill: "#fff", fillOpacity: ".94" })
    ]
  }
));
SessionFrame.displayName = "Icon.Object.SessionFrame";

// Icon/Object/SnapshotStartingPoint.tsx
var import_uik341 = require("@appd/uik");
var import_jsx_runtime331 = require("react/jsx-runtime");
var SnapshotStartingPoint = import_uik341.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime331.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.SnapshotStartingPoint",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime331.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M6.75 18.8S2 13.54 2 9.978a4.747 4.747 0 0 1 4.75-4.75 4.747 4.747 0 0 1 4.75 4.75c0 3.562-4.75 8.82-4.75 8.82Zm0-10.518a1.696 1.696 0 1 0 0 3.392 1.696 1.696 0 0 0 0-3.392Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime331.jsx)("path", { d: "M11.5 19.007H21a1 1 0 1 0 0-2h-9.5a1 1 0 1 0 0 2Z", fill: "#fff", fillOpacity: ".94" })
    ]
  }
));
SnapshotStartingPoint.displayName = "Icon.Object.SnapshotStartingPoint";

// Icon/Object/Socket.tsx
var import_uik342 = require("@appd/uik");
var import_jsx_runtime332 = require("react/jsx-runtime");
var Socket = import_uik342.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime332.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.Socket",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime332.jsx)(
        "path",
        {
          d: "M13.502 12.229 13.5 7.865h1.996l.004 4.363h-1.998ZM8.5 7.866l.002 4.363H10.5l-.004-4.363H8.5Zm1.639 9.331v-1.425a1.86 1.86 0 1 1 3.722-.002v1.425l-3.722.002Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime332.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M17.915 21.144H6.085c-1.654 0-3-1.346-3-3V6.314c0-1.655 1.346-3 3-3h11.83c1.654 0 3 1.345 3 3v11.83c0 1.654-1.346 3-3 3ZM6.085 5.314c-.551 0-1 .448-1 1v11.83c0 .551.449 1 1 1h11.83a1 1 0 0 0 1-1V6.314a1 1 0 0 0-1-1H6.085Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
Socket.displayName = "Icon.Object.Socket";

// Icon/Object/Sqs.tsx
var import_uik343 = require("@appd/uik");
var import_jsx_runtime333 = require("react/jsx-runtime");
var Sqs = import_uik343.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime333.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.Sqs",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime333.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M0 12.229c0-3.313.934-6 2.087-6h19.826c1.152 0 2.087 2.687 2.087 6s-.935 6-2.087 6H2.087c-1.153 0-2.087-2.688-2.087-6Zm21.337 4c.29-.606.663-2.034.663-4 0-1.966-.373-3.394-.663-4H2.663c-.29.606-.663 2.034-.663 4 0 1.966.373 3.394.663 4h18.674ZM8.562 11.146h1.044c0-.46-.11-.795-.327-1.005-.218-.21-.571-.315-1.06-.315-.471 0-.823.114-1.055.342-.232.228-.348.56-.348.996 0 .252.043.456.129.612.086.156.194.282.324.378.13.096.27.174.423.234.152.06.293.119.423.177.13.058.238.128.324.21a.438.438 0 0 1 .129.333.465.465 0 0 1-.093.294.318.318 0 0 1-.267.12.342.342 0 0 1-.264-.111c-.068-.074-.102-.203-.102-.387v-.102h-1.08v.15c0 .224.032.412.096.564a.893.893 0 0 0 .279.369c.122.094.272.16.45.198.178.038.383.057.615.057.492 0 .868-.103 1.128-.31.26-.205.39-.536.39-.992 0-.26-.045-.471-.135-.633a1.205 1.205 0 0 0-.34-.393 1.956 1.956 0 0 0-.437-.243 12.796 12.796 0 0 1-.438-.183 1.245 1.245 0 0 1-.34-.213.428.428 0 0 1-.134-.333c0-.096.028-.183.084-.261.056-.078.144-.117.264-.117.108 0 .188.045.24.135.052.09.078.199.078.327v.102Zm3.44 3.084.612.66.672-.582-.516-.516c.128-.18.22-.412.276-.696.056-.284.084-.632.084-1.044 0-.4-.026-.741-.078-1.023a1.816 1.816 0 0 0-.258-.69 1.049 1.049 0 0 0-.474-.39 1.867 1.867 0 0 0-.72-.123c-.284 0-.524.04-.72.123a1.049 1.049 0 0 0-.474.39c-.12.178-.206.408-.258.69a5.74 5.74 0 0 0-.078 1.023c0 .4.026.74.078 1.023.052.282.138.512.258.69.12.178.278.305.474.38a2 2 0 0 0 .72.115h.108a2.357 2.357 0 0 0 .293-.03Zm-.78-2.178c0 .288.004.527.012.717.008.19.025.34.05.453.027.112.065.19.115.234.05.044.117.066.2.066a.293.293 0 0 0 .202-.066c.05-.044.088-.122.114-.234a2.49 2.49 0 0 0 .05-.453c.009-.19.013-.43.013-.717 0-.288-.004-.527-.012-.717a2.568 2.568 0 0 0-.051-.453c-.026-.112-.064-.19-.114-.234a.293.293 0 0 0-.201-.066.293.293 0 0 0-.201.066c-.05.044-.088.122-.114.234a2.568 2.568 0 0 0-.051.453c-.008.19-.012.429-.012.717Zm5.102-.906H15.28v-.102a.643.643 0 0 0-.078-.327.258.258 0 0 0-.24-.135c-.12 0-.208.039-.264.117a.437.437 0 0 0-.084.26c0 .14.045.252.135.334.09.082.203.153.339.213s.282.12.438.183c.156.062.302.143.438.243s.249.23.339.393c.09.162.135.373.135.633 0 .456-.13.787-.39.993-.26.206-.636.309-1.128.309-.232 0-.437-.02-.615-.057a1.103 1.103 0 0 1-.45-.198.893.893 0 0 1-.28-.37 1.457 1.457 0 0 1-.095-.563v-.15h1.08v.102c0 .184.034.313.102.387a.342.342 0 0 0 .264.11c.116 0 .205-.04.267-.12a.465.465 0 0 0 .093-.293.438.438 0 0 0-.13-.333 1.133 1.133 0 0 0-.323-.21c-.13-.058-.271-.117-.423-.177a1.856 1.856 0 0 1-.423-.234 1.153 1.153 0 0 1-.324-.378c-.086-.156-.13-.36-.13-.612 0-.436.117-.768.349-.996.232-.228.584-.342 1.056-.342.488 0 .84.105 1.059.315.218.21.327.545.327 1.005Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Sqs.displayName = "Icon.Object.Sqs";

// Icon/Object/Storage.tsx
var import_uik344 = require("@appd/uik");
var import_jsx_runtime334 = require("react/jsx-runtime");
var Storage = import_uik344.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime334.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.Storage",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime334.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M5.92 2.23h11.52v.009a1.92 1.92 0 0 1 1.92 1.91v15.36c0 1.06-.86 1.92-1.92 1.92H5.92A1.92 1.92 0 0 1 4 19.51V4.15c0-1.06.86-1.92 1.92-1.92ZM8.8 5.11c.53 0 .96.43.96.96v.96a.96.96 0 0 1-1.92 0v-.96c0-.53.43-.96.96-.96Zm0 6.72c.53 0 .96.43.96.96v2.88a.96.96 0 1 1-1.92 0v-2.88c0-.53.43-.96.96-.96Zm8.64 7.68H5.92v-8.698h11.52v8.697ZM5.92 8.95h11.52v-4.8H5.92v4.8Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Storage.displayName = "Icon.Object.Storage";

// Icon/Object/Stream.tsx
var import_uik345 = require("@appd/uik");
var import_jsx_runtime335 = require("react/jsx-runtime");
var Stream = import_uik345.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime335.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.Stream",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime335.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M3 5.229v1.5h18v-1.5H3Zm10.876 8.2c.668-.327 1.428-.7 2.624-.7 1.215 0 1.98.376 2.655.716.585.313 1.035.537 1.845.537v1.747c-1.233 0-1.98-.377-2.655-.717-.585-.313-1.035-.537-1.845-.537s-1.26.224-1.845.537l-.07.035c-.657.323-1.386.681-2.585.681-1.234 0-1.97-.37-2.642-.71l-.013-.006c-.585-.313-1.035-.537-1.845-.537s-1.26.224-1.845.537l-.031.015c-.668.328-1.428.702-2.624.702v-1.747c.752 0 1.212-.226 1.758-.494l.157-.078c.657-.323 1.386-.681 2.585-.681 1.234 0 1.97.37 2.642.71l.013.006c.585.313 1.035.537 1.845.537.75 0 1.22-.23 1.773-.502l.103-.05ZM21 17.98v1.5H3v-1.5h18Zm-7.124-8.3c.668-.327 1.428-.7 2.624-.7 1.215 0 1.98.376 2.655.716.585.313 1.035.537 1.845.537v1.747c-1.233 0-1.98-.377-2.655-.717-.585-.313-1.035-.537-1.845-.537-.75 0-1.22.23-1.773.502l-.072.035-.07.035c-.657.323-1.386.681-2.585.681-1.234 0-1.97-.37-2.642-.71l-.013-.006c-.585-.313-1.062-.537-1.845-.537-.75 0-1.22.23-1.773.502l-.072.035-.031.015c-.668.328-1.428.702-2.624.702v-1.747c.81 0 1.26-.224 1.845-.537l.07-.035c.657-.323 1.386-.681 2.585-.681 1.234 0 1.97.37 2.642.71l.013.006c.585.313 1.035.537 1.845.537s1.26-.224 1.845-.537l.031-.015Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Stream.displayName = "Icon.Object.Stream";

// Icon/Object/StreamProcessor.tsx
var import_uik346 = require("@appd/uik");
var import_jsx_runtime336 = require("react/jsx-runtime");
var StreamProcessor = import_uik346.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime336.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.StreamProcessor",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime336.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M8.283 5.2c.7 0 1.127.253 1.65.607l.014.008c.6.382 1.26.8 2.363.8 1.074 0 1.728-.406 2.316-.77l.06-.038.065-.04c.495-.307.915-.567 1.588-.567.725 0 1.127.253 1.65.607.605.384 1.273.808 2.377.808V4.644c-.725 0-1.128-.253-1.651-.607-.604-.384-1.29-.808-2.376-.808-1.07 0-1.75.42-2.348.79l-.03.018c-.523.354-.925.607-1.65.607-.725 0-1.129-.253-1.652-.607l-.011-.007c-.601-.382-1.26-.801-2.365-.801-1.074 0-1.727.405-2.314.77l-.062.038c-.525.354-.927.607-1.652.607v1.971c1.071 0 1.752-.422 2.35-.792l.09-.056C7.19 5.46 7.61 5.2 8.283 5.2ZM20.35 16.386v2.957h1.302l-2.06 2.235-2.061-2.235h1.304v-2.525h-5.817v2.525H14.3l-2.06 2.235-2.062-2.235h1.323v-2.525H5.819v2.525H7.12l-2.06 2.235L3 19.343h1.303v-2.957c0-.6.487-1.085 1.086-1.085h6.112v-2.27h1.516v2.27h6.248c.601 0 1.086.487 1.086 1.085Zm-10.417-6.08c-.524-.354-.926-.607-1.651-.607s-1.129.253-1.652.607l-.026.016c-.598.37-1.279.793-2.35.793V9.143c.672 0 1.083-.254 1.571-.557l.08-.05.063-.038c.587-.365 1.24-.77 2.314-.77 1.105 0 1.764.42 2.365.801l.01.007c.524.354.928.607 1.653.607.671 0 1.09-.26 1.586-.566l.065-.04.029-.019c.597-.37 1.277-.79 2.348-.79 1.086 0 1.772.424 2.376.808.523.354.926.607 1.65.607v1.972c-1.102 0-1.77-.425-2.375-.81-.524-.353-.926-.606-1.651-.606-.726 0-1.129.253-1.652.607l-.061.038c-.588.365-1.242.77-2.316.77-1.104 0-1.762-.418-2.363-.8l-.013-.008Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
StreamProcessor.displayName = "Icon.Object.StreamProcessor";

// Icon/Object/SyntheticUser.tsx
var import_uik347 = require("@appd/uik");
var import_jsx_runtime337 = require("react/jsx-runtime");
var SyntheticUser = import_uik347.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime337.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.SyntheticUser",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime337.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M14.678 2.774H8.915c-1.08 0-1.964.758-1.964 1.684l-.02 4.211h9.823V4.46c0-.927-.995-1.685-2.076-1.685Zm-.87 1.965a.986.986 0 0 0-.983.983c0 .54.442.982.982.982s.982-.442.982-.982a.986.986 0 0 0-.982-.983Zm-4.913.983c0-.54.442-.983.982-.983s.983.443.983.983-.443.982-.983.982a.985.985 0 0 1-.982-.982Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime337.jsx)(
        "path",
        {
          d: "M19.59 10.143H4.093c-.6 0-1.093.491-1.093 1.093v2.444c0 .602.492 1.094 1.093 1.094l.012 5.095c0 .5.495.905 1.105.905s1.105-.405 1.105-.905v-5.095H7.79v4.5h8v-4.5h1.58v5.095c0 .5.495.905 1.105.905.609 0 1.104-.405 1.104-.905v-5.095a1.1 1.1 0 0 0 1.106-1.094v-2.444c0-.602-.492-1.093-1.094-1.093Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime337.jsx)(
        "path",
        {
          d: "M7.79 20.68v-.406h8v.406c0 .602-.492 1.095-1.095 1.095H8.883A1.097 1.097 0 0 1 7.79 20.68Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
SyntheticUser.displayName = "Icon.Object.SyntheticUser";

// Icon/Object/SystemEvent.tsx
var import_uik348 = require("@appd/uik");
var import_jsx_runtime338 = require("react/jsx-runtime");
var SystemEvent = import_uik348.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime338.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.SystemEvent",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime338.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M20.5 2.729a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1h-6.61l-.68 1-.75 1.14a.66.66 0 0 1-1.09 0l-.75-1.14-.68-1H3.5a1 1 0 0 1-1-1v-15a1 1 0 0 1 1-1h17Zm-16 15h15v-13h-15v13Zm12-7.27H7v1.5h9.5v-1.5ZM7 6.959h5.7v1.5H7v-1.5Zm7.71 7.04H7v1.5h7.71v-1.5Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
SystemEvent.displayName = "Icon.Object.SystemEvent";

// Icon/Object/Topic.tsx
var import_uik349 = require("@appd/uik");
var import_jsx_runtime339 = require("react/jsx-runtime");
var Topic = import_uik349.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime339.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.Topic",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime339.jsx)(
        "path",
        {
          d: "M8.87 4.229H7.02v12.12h1.85V4.229Zm4.04 0h-1.85v12.12h1.85V4.229ZM2.09 8.198v4.11l3.39-2.06-3.39-2.05Zm16.43 0v4.11l3.39-2.06-3.39-2.05Zm-1.65-3.969h-1.85v12.12h1.85V4.229Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime339.jsx)("path", { d: "M18.97 18.218H4.95l.01-3.87-2-.01-.01 5.88h18.02v-5.89h-2v3.89Z", fill: "#fff", fillOpacity: ".94" })
    ]
  }
));
Topic.displayName = "Icon.Object.Topic";

// Icon/Object/TxDiscoveryAuto.tsx
var import_uik350 = require("@appd/uik");
var import_jsx_runtime340 = require("react/jsx-runtime");
var TxDiscoveryAuto = import_uik350.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime340.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.TxDiscoveryAuto",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime340.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M8 5.229a7 7 0 1 1 0 14 7 7 0 0 1 0-14Zm0 2c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5Zm-.646 5.115H8.48l-.564-1.761-.563 1.76Zm1.558 1.36H6.917l-.477 1.434H4.911l2.433-6.91h1.141l2.434 6.91H9.393l-.48-1.433Zm7.838-3.976a.752.752 0 0 1-.751-.75c0-.413.338-.749.751-.749h4.192l-.721-.72a.752.752 0 0 1 0-1.062.746.746 0 0 1 1.059 0l2.001 2.001a.752.752 0 0 1 0 1.061l-2.001 2a.746.746 0 0 1-1.059 0 .752.752 0 0 1 0-1.06l.72-.72H16.75Zm6 5.5a.75.75 0 0 1 0 1.501h-4.19l.719.72a.75.75 0 1 1-1.059 1.06l-1.998-1.998a.752.752 0 0 1-.005-1.058l2.003-2.005a.744.744 0 0 1 1.059 0 .75.75 0 0 1 0 1.06l-.719.72h4.19Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
TxDiscoveryAuto.displayName = "Icon.Object.TxDiscoveryAuto";

// Icon/Object/TxDiscoveryCustom.tsx
var import_uik351 = require("@appd/uik");
var import_jsx_runtime341 = require("react/jsx-runtime");
var TxDiscoveryCustom = import_uik351.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime341.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.TxDiscoveryCustom",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime341.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M8 5.229a7 7 0 1 1 0 14 7 7 0 0 1 0-14Zm0 12c2.757 0 5-2.243 5-5s-2.243-5-5-5-5 2.243-5 5 2.243 5 5 5Zm1.048-4.35a.958.958 0 0 1-.946.947.958.958 0 0 1-.945-.946v-1.303c0-.512.432-.946.945-.946a.96.96 0 0 1 .946.946h1.659a2.612 2.612 0 0 0-2.605-2.605 2.612 2.612 0 0 0-2.604 2.605v1.303a2.612 2.612 0 0 0 2.604 2.605 2.613 2.613 0 0 0 2.605-2.605h-1.66Zm7.702-3.15a.752.752 0 0 1-.751-.75c0-.414.338-.75.751-.75h4.192l-.721-.72a.752.752 0 0 1 0-1.062.746.746 0 0 1 1.059 0l2.001 2.001a.752.752 0 0 1 0 1.061l-2.001 2a.746.746 0 0 1-1.059 0 .752.752 0 0 1 0-1.06l.72-.72H16.75Zm6.749 6.25a.75.75 0 0 0-.749-.75h-4.19l.719-.72a.75.75 0 1 0-1.059-1.06l-2.003 2.004a.75.75 0 0 0 .003 1.055l2 2a.748.748 0 1 0 1.059-1.06l-.718-.719h4.189a.75.75 0 0 0 .749-.75Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
TxDiscoveryCustom.displayName = "Icon.Object.TxDiscoveryCustom";

// Icon/Object/TxDiscoveryCustomExclude.tsx
var import_uik352 = require("@appd/uik");
var import_jsx_runtime342 = require("react/jsx-runtime");
var TxDiscoveryCustomExclude = import_uik352.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime342.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.TxDiscoveryCustomExclude",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime342.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M7.768 7.229c-.619 0-1.205.127-1.752.333l-1.52-1.52a7 7 0 0 1 9.458 9.458l-1.52-1.52a4.949 4.949 0 0 0 .334-1.751c0-2.757-2.243-5-5-5ZM1.177 5.552 0 6.728 1.82 8.55a6.957 6.957 0 0 0-1.052 3.68 7 7 0 0 0 7 7c1.351 0 2.609-.39 3.679-1.053l1.82 1.82 1.177-1.177L1.177 5.552Zm4.01 6.364v.964a2.613 2.613 0 0 0 2.465 2.601c.24-.014.47-.067.692-.141l.061.062c.07-.019.139-.04.206-.062l1.357 1.356a4.939 4.939 0 0 1-2.337.53 5.006 5.006 0 0 1-5.13-4.998 4.929 4.929 0 0 1 .532-2.2l.181.182c.028-.06.056-.122.086-.181l1.888 1.887Zm11.985-2.188a.752.752 0 0 1-.75-.75.75.75 0 0 1 .75-.749h4.192l-.72-.72a.752.752 0 0 1 0-1.062.746.746 0 0 1 1.059 0l2 2.001a.752.752 0 0 1 0 1.061l-2 2a.746.746 0 0 1-1.06 0 .752.752 0 0 1 0-1.06l.72-.72h-4.19Zm6.75 6.251a.75.75 0 0 0-.75-.75h-4.19l.72-.72a.75.75 0 1 0-1.06-1.06l-2.003 2.004a.745.745 0 0 0 .005 1.058l1.998 1.998a.748.748 0 1 0 1.06-1.06l-.72-.72h4.19a.75.75 0 0 0 .75-.75Zm-13.526-4.402a2.612 2.612 0 0 0-2.604-2.605c-.09 0-.177.013-.264.025l-.069.01 2.571 2.57h.367Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
TxDiscoveryCustomExclude.displayName = "Icon.Object.TxDiscoveryCustomExclude";

// Icon/Object/UnresolvedDatabase.tsx
var import_uik353 = require("@appd/uik");
var import_jsx_runtime343 = require("react/jsx-runtime");
var UnresolvedDatabase = import_uik353.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime343.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.UnresolvedDatabase",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime343.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M17.8 13.229a4.4 4.4 0 1 0 0 8.8 4.4 4.4 0 0 0 0-8.8Zm.42 7.37h-.85v-.85h.85v.85Zm.5-2.9.38-.39c.255-.255.4-.6.4-.96a1.7 1.7 0 1 0-3.4 0h.85a.85.85 0 1 1 1.45.6l-.53.54a1.68 1.68 0 0 0-.5 1.2v.21h.85a1.43 1.43 0 0 1 .5-1.2Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime343.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M4.06 14.399c.868.454 1.793.79 2.75 1 1.54.339 3.113.507 4.69.5h.67a5.84 5.84 0 0 1 1.05-2c-.262 0-.53.016-.808.033-.294.018-.598.037-.912.037a18.278 18.278 0 0 1-4.69-.56c-1.81-.49-2.91-1.18-2.91-1.68v-2.76l.16.09c.868.453 1.793.79 2.75 1a20.84 20.84 0 0 0 4.69.51 20.813 20.813 0 0 0 4.69-.51 11.35 11.35 0 0 0 2.75-1l.16-.09v2.76a.433.433 0 0 1 0 .14 5.701 5.701 0 0 1 1.93.81v-6.29c-.03-2.73-4.81-4.16-9.53-4.16-4.17 0-8.37 1.11-9.3 3.25a2.58 2.58 0 0 0-.2.91v10.68c0 .31.068.618.2.9.93 2.14 5.13 3.26 9.3 3.26h1.59a5.73 5.73 0 0 1-.94-1.86h-.65c-4.72 0-7.6-1.47-7.6-2.26v-2.79l.16.08Zm7.44-10.27c4.71 0 7.6 1.46 7.6 2.26 0 .47-1.05 1.19-2.91 1.69a18.34 18.34 0 0 1-4.69.56 18.28 18.28 0 0 1-4.69-.56C5 7.579 3.9 6.859 3.9 6.389c0-.8 2.88-2.26 7.6-2.26Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
UnresolvedDatabase.displayName = "Icon.Object.UnresolvedDatabase";

// Icon/Object/Web.tsx
var import_uik354 = require("@appd/uik");
var import_jsx_runtime344 = require("react/jsx-runtime");
var Web = import_uik354.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime344.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.Web",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime344.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M23.017 12.137c0 5.904-4.935 10.693-11.028 10.693C5.91 22.83.983 18.04.983 12.137c0-5.904 4.925-10.694 11.005-10.694 6.094 0 11.03 4.79 11.03 10.694ZM14.105 7.86A14.897 14.897 0 0 0 12 3.63a14.87 14.87 0 0 0-2.103 4.23h4.208Zm-6.48 0a16.413 16.413 0 0 1 1.522-3.807A8.752 8.752 0 0 0 4.375 7.86h3.25ZM3.473 10a8.44 8.44 0 0 0-.288 2.139 8.49 8.49 0 0 0 .288 2.138h3.724a17.091 17.091 0 0 1-.154-2.138c.007-.716.058-1.43.154-2.139H3.473Zm5.95 0h5.156c.098.694.177 1.412.177 2.139 0 .727-.078 1.432-.177 2.138H9.422a15.29 15.29 0 0 1-.177-2.138c0-.727.078-1.445.177-2.139Zm6.952 6.415h3.25a8.79 8.79 0 0 1-4.77 3.807c.664-1.2 1.174-2.48 1.52-3.807Zm0-8.555h3.25a8.79 8.79 0 0 0-4.77-3.807c.664 1.2 1.175 2.48 1.52 3.807ZM20.53 10c.175.683.286 1.4.286 2.138s-.11 1.455-.286 2.138h-3.726c.088-.706.155-1.41.155-2.138 0-.727-.066-1.433-.155-2.139h3.726ZM9.897 16.414A14.867 14.867 0 0 0 12 20.65a14.888 14.888 0 0 0 2.105-4.235H9.897Zm-5.521-.001h3.25a16.4 16.4 0 0 0 1.521 3.807 8.74 8.74 0 0 1-4.771-3.807Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Web.displayName = "Icon.Object.Web";

// Icon/Object/WebServer.tsx
var import_uik355 = require("@appd/uik");
var import_jsx_runtime345 = require("react/jsx-runtime");
var WebServer = import_uik355.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime345.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.WebServer",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime345.jsx)(
      "path",
      {
        d: "m9.676 18.428-.028-.03H3.332a.945.945 0 1 0 0 1.89h7.079a7.514 7.514 0 0 1-.482-1.021 7.62 7.62 0 0 1-.253-.839ZM3.803 8.955H17.97c.78 0 1.417-.638 1.417-1.417V4.705c0-.78-.638-1.417-1.417-1.417H3.803a1.42 1.42 0 0 0-1.416 1.417v2.833a1.42 1.42 0 0 0 1.416 1.417Zm.472-3.778h13.223v1.889H4.275v-1.89Zm5.373 9.832c.03-.131.069-.26.105-.389H4.275v-1.889H10.6c.38-.608.84-1.172 1.38-1.654.093-.083.191-.156.287-.234H3.803a1.42 1.42 0 0 0-1.416 1.417v2.833a1.42 1.42 0 0 0 1.416 1.417H9.46l.001-.02c.012-.502.078-.997.188-1.481Zm8.654-3.812a5.948 5.948 0 0 0-1.11-.106 5.803 5.803 0 0 0-3.88 1.477 5.578 5.578 0 0 0-1.434 2 5.418 5.418 0 0 0-.42 2c0 .033-.004.066-.004.1a5.553 5.553 0 0 0 1.64 3.9 5.8 5.8 0 0 0 4.099 1.676c2.97 0 5.41-2.183 5.716-4.983a5.466 5.466 0 0 0 0-1.187c-.266-2.441-2.157-4.412-4.607-4.877Zm2.872 3.24h-1.695a8.529 8.529 0 0 0-.793-1.985 4.583 4.583 0 0 1 2.488 1.985Zm-4.588-1.19c.18-.354.383-.695.613-1.017.476.668.85 1.41 1.097 2.207h-2.195a7.77 7.77 0 0 1 .485-1.19Zm-3.834 4.536a4.427 4.427 0 0 1-.15-1.116c0-.033.006-.066.007-.1.01-.349.059-.69.143-1.014h1.942a9.485 9.485 0 0 0-.074 1.015c0 .033-.007.066-.007.1 0 .38.035.747.08 1.115h-1.94Zm2.227 2.784a4.526 4.526 0 0 1-1.757-1.67h1.696c.153.584.377 1.14.643 1.67.052.104.093.215.15.316a4.646 4.646 0 0 1-.732-.316Zm.677-8a8.566 8.566 0 0 0-.738 1.87h-1.696c.507-.85 1.293-1.495 2.222-1.87.09-.036.174-.084.266-.115-.02.038-.034.078-.054.116Zm1.867 8c-.108.18-.203.368-.325.54-.121-.172-.216-.36-.324-.54a7.651 7.651 0 0 1-.773-1.67h2.195a7.656 7.656 0 0 1-.773 1.67Zm1.02-2.784h-2.689a7.985 7.985 0 0 1-.092-1.115c0-.034.004-.067.005-.1.006-.345.04-.685.087-1.015h2.689c.052.362.092.736.092 1.115 0 .38-.04.747-.092 1.115Zm.143 3.1c.345-.618.61-1.288.793-1.985h1.695a4.583 4.583 0 0 1-2.488 1.985Zm2.96-3.1h-1.943c.046-.368.08-.736.08-1.115a8.97 8.97 0 0 0-.08-1.115h1.942c.092.356.15.73.15 1.115s-.058.758-.15 1.115Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
WebServer.displayName = "Icon.Object.WebServer";

// Icon/Object/WebsphereMq.tsx
var import_uik356 = require("@appd/uik");
var import_jsx_runtime346 = require("react/jsx-runtime");
var WebsphereMq = import_uik356.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime346.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Object.WebsphereMq",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime346.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "m4.965 14.445.14-.021.613.66.672-.582-.516-.516c.128-.18.22-.412.276-.697.056-.283.084-.631.084-1.043 0-.4-.026-.741-.078-1.023a1.816 1.816 0 0 0-.258-.69 1.049 1.049 0 0 0-.474-.39 1.867 1.867 0 0 0-.72-.123c-.284 0-.524.04-.72.123a1.049 1.049 0 0 0-.474.39c-.12.178-.206.408-.258.69a5.74 5.74 0 0 0-.078 1.023c0 .4.026.74.078 1.023.052.282.138.512.258.69.12.178.278.305.474.38a2 2 0 0 0 .72.114h.108a1.2 1.2 0 0 0 .153-.008Zm-.576-1.03c.026.112.064.19.114.235.05.043.117.066.2.066a.298.298 0 0 0 .202-.066c.05-.044.088-.123.114-.234a2.49 2.49 0 0 0 .05-.453c.009-.19.013-.43.013-.717 0-.288-.004-.527-.012-.717a2.568 2.568 0 0 0-.051-.453c-.026-.112-.064-.19-.114-.234a.293.293 0 0 0-.201-.066.293.293 0 0 0-.201.066c-.05.044-.088.122-.114.234a2.568 2.568 0 0 0-.051.453c-.008.19-.012.429-.012.717s.004.527.012.717c.008.19.025.34.05.453Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime346.jsx)(
        "path",
        {
          d: "M8.184 13.194c0 .208.03.347.09.417s.142.105.246.105a.307.307 0 0 0 .246-.105c.06-.07.09-.21.09-.417v-3.09h1.116v2.808c0 .3-.032.55-.096.75-.064.199-.157.36-.279.48a.955.955 0 0 1-.453.246c-.18.044-.388.065-.624.065-.232 0-.439-.021-.621-.065a.956.956 0 0 1-.456-.246 1.157 1.157 0 0 1-.279-.48c-.064-.2-.096-.45-.096-.75v-2.808h1.116v3.09Zm5.286-2.179v-.912h-2.538v4.284h2.592v-.912h-1.476v-.851h1.332v-.877h-1.332v-.732h1.422Zm2.01 2.179c0 .208.03.347.09.417s.141.105.246.105a.31.31 0 0 0 .246-.105c.06-.07.09-.21.09-.417v-3.09h1.115v2.808c0 .3-.03.55-.096.75-.064.199-.156.36-.279.48a.946.946 0 0 1-.453.246c-.18.044-.388.065-.623.065a2.65 2.65 0 0 1-.62-.065.959.959 0 0 1-.458-.246 1.168 1.168 0 0 1-.279-.48c-.063-.2-.096-.45-.096-.75v-2.808h1.117v3.09Zm5.285-2.179v-.912h-2.537v4.284h2.592v-.912h-1.477v-.851h1.332v-.877h-1.332v-.732h1.422Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime346.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M0 12.229c0-3.313.934-6 2.087-6h19.826c1.152 0 2.087 2.687 2.087 6s-.935 6-2.087 6H2.087c-1.153 0-2.087-2.688-2.087-6Zm21.337 4c.29-.606.663-2.034.663-4 0-1.966-.373-3.394-.663-4H2.663c-.29.606-.663 2.034-.663 4 0 1.966.373 3.394.663 4h18.674Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
WebsphereMq.displayName = "Icon.Object.WebsphereMq";

// Icon/Os/Os.ts
var Os_exports = {};
__export(Os_exports, {
  Aix: () => Aix,
  Android: () => Android,
  Ios: () => Ios,
  Linux: () => Linux,
  Solaris: () => Solaris,
  Windows: () => Windows
});

// Icon/Os/Aix.tsx
var import_uik357 = require("@appd/uik");
var import_jsx_runtime347 = require("react/jsx-runtime");
var Aix = import_uik357.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime347.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Os.Aix",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime347.jsx)(
        "path",
        {
          d: "M6.81 14.33H4.45L4 15.68H2.2l2.62-7.25h1.62l2.63 7.25H7.22l-.41-1.35ZM4.86 13H6.4l-.77-2.52L4.86 13Zm8.19 2.68h-1.72V8.43h1.72v7.25Zm5.56-4.84 1.17-2.41h2l-2 3.6 2.05 3.65h-2l-1.2-2.45-1.2 2.45h-2L17.48 12l-2-3.6h2l1.13 2.44Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime347.jsx)(
        "path",
        {
          d: "M6.81 14.33H4.45L4 15.68H2.2l2.62-7.25h1.62l2.63 7.25H7.22l-.41-1.35ZM4.86 13H6.4l-.77-2.52L4.86 13Zm8.19 2.68h-1.72V8.43h1.72v7.25Zm5.56-4.84 1.17-2.41h2l-2 3.6 2.05 3.65h-2l-1.2-2.45-1.2 2.45h-2L17.48 12l-2-3.6h2l1.13 2.44Z",
          stroke: "#000",
          strokeMiterlimit: "10",
          strokeWidth: ".2"
        }
      )
    ]
  }
));
Aix.displayName = "Icon.Os.Aix";

// Icon/Os/Android.tsx
var import_uik358 = require("@appd/uik");
var import_jsx_runtime348 = require("react/jsx-runtime");
var Android = import_uik358.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime348.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Os.Android",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime348.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M16.5 8.823a4.047 4.047 0 0 0-1.7-3.328l.898-.898a.34.34 0 0 0 .102-.243.348.348 0 0 0-.595-.243l-1.02 1.02a3.999 3.999 0 0 0-1.814-.437 4.04 4.04 0 0 0-1.83.438l-1.028-1.02a.344.344 0 1 0-.486.485l.915.898a4.12 4.12 0 0 0-1.7 3.328H16.5Zm2.475.97a1.028 1.028 0 0 0-.76-.283 1.028 1.028 0 0 0-.986 1.029v4.857a1.036 1.036 0 1 0 2.064 0v-4.857c0-.282-.114-.551-.318-.745ZM7.25 9.81a1.028 1.028 0 0 0-.732-.298c-.568 0-1.029.46-1.029 1.028v4.857a1.036 1.036 0 1 0 2.065 0V10.54c0-.274-.11-.537-.304-.73Zm.993 6.582V9.51H16.5v6.922c0 .38-.308.688-.688.688h-.688v2.43a1.036 1.036 0 0 1-2.064 0v-2.43h-1.377v2.389a1.036 1.036 0 0 1-2.064 0V17.08H8.93a.688.688 0 0 1-.687-.688Zm2.752-8.945v-.688h-.688v.688h.688Zm3.44-.688v.688h-.688v-.688h.688Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Android.displayName = "Icon.Os.Android";

// Icon/Os/Ios.tsx
var import_uik359 = require("@appd/uik");
var import_jsx_runtime349 = require("react/jsx-runtime");
var Ios = import_uik359.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime349.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Os.Ios",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime349.jsx)(
      "path",
      {
        d: "M12.853 6.36a3.62 3.62 0 0 1-.91.14 4 4 0 0 1 .67-2.23A3.33 3.33 0 0 1 14.773 3c.002.03.002.06 0 .09a.557.557 0 0 0 0 .1v.19a3.222 3.222 0 0 1-.24 1.18 3.381 3.381 0 0 1-.79 1.2 2.721 2.721 0 0 1-.89.6Zm3.88 6.06a3.29 3.29 0 0 1-.6-1.92 3.23 3.23 0 0 1 .56-1.79 5.858 5.858 0 0 1 1-1 5.143 5.143 0 0 0-.91-.86 3.13 3.13 0 0 0-1.85-.55 5 5 0 0 0-1.49.29 4.55 4.55 0 0 1-1.28.25 6 6 0 0 1-1.2-.27 5.94 5.94 0 0 0-1.54-.26 3 3 0 0 0-2.42 1.24 5.15 5.15 0 0 0-1 3.24 8.85 8.85 0 0 0 1.28 4.37c.88 1.46 1.73 2.2 2.62 2.2a3.301 3.301 0 0 0 1.15-.28 3.14 3.14 0 0 1 1.22-.29c.449.01.89.108 1.3.29.383.157.788.252 1.2.28.74 0 1.48-.57 2.23-1.7a8.003 8.003 0 0 0 1.05-2.16 2.8 2.8 0 0 1-1.32-1.08Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
Ios.displayName = "Icon.Os.Ios";

// Icon/Os/Linux.tsx
var import_uik360 = require("@appd/uik");
var import_jsx_runtime350 = require("react/jsx-runtime");
var Linux = import_uik360.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime350.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Os.Linux",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime350.jsx)(
      "path",
      {
        d: "M18.92 16.13c-1.87-2.61-.28-5.62-2-9.48-.714-1.725-2.328-2.964-4.189-3.124-.211-.01-.29-.026-.5-.026h-.501a6.63 6.63 0 0 0-3.31 1.12c-2.38 1.64-2 5.8-1.75 7.71a7.86 7.86 0 0 1-.43 4.52c-.13.33-.36.43-1.1 1.42.278.331.582.639.91.92a6.05 6.05 0 0 1 .64-1A5.24 5.24 0 0 0 7.83 15s1.25 1.52 2.37 1.52c.103.015.207.015.31 0 1.763-.215 3.384-1.794 4.12-2a.26.26 0 0 1 .14 0 39.843 39.843 0 0 1 2.46 5.24 9.211 9.211 0 0 0 2.42-2.63l-.73-1ZM8.27 12.58a2.1 2.1 0 0 1-1-1.95c0-1.13.64-2 1.4-2 .76 0 1.39.91 1.39 2 0 .198-.054.565-.095.76l-.564.364c.023-.273-.049-.582-.101-.884-.1-.58-.47-1-.85-1h-.07c-.41.07-.591.622-.55 1.25.058.88.52 1.13.832 1.161-.187.13-.215.163-.392.299Zm4.91 1.11c-.083.16-.72.56-.72.56-.638.378-1.25.687-1.92.95-.067.072-.57-.24-.9-.45-.33-.21-1.06-.75-.88-1l1.754-1.248.144-.091c.338.1 1.792.709 1.792.709.36.15.853.335.73.57Zm.82-1.36-.47-.2A1.23 1.23 0 0 0 14.1 11c.072-.586-.487-1.32-.954-1.273-.59.023-.962.685-.896 1.273a1.48 1.48 0 0 0 .157.671l-.777-.301a2.58 2.58 0 0 1-.19-1c-.088-1.077.683-2.12 1.77-2.15.961-.05 1.895 1.085 1.79 2.18a2.25 2.25 0 0 1-1 1.93Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
Linux.displayName = "Icon.Os.Linux";

// Icon/Os/Solaris.tsx
var import_uik361 = require("@appd/uik");
var import_jsx_runtime351 = require("react/jsx-runtime");
var Solaris = import_uik361.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime351.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Os.Solaris",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime351.jsx)(
      "path",
      {
        d: "M11.94 3.28a8.7 8.7 0 1 0 0 17.4 8.7 8.7 0 0 0 0-17.4Zm-4.69 10.6a1.05 1.05 0 0 1-1-.36 5.088 5.088 0 0 1-.37-.52 1 1 0 0 0-1.19-.54c-.12.033-.236.073-.35.12.288-.242.632-.41 1-.49.31-.07.636-.02.91.14l.54.23c.378.14.792.14 1.17 0a5.25 5.25 0 0 0-.71 1.42Zm.91-1.76a1 1 0 0 1-.75-.68 5.467 5.467 0 0 1-.19-.65 1 1 0 0 0-.91-.94h-.37A2.44 2.44 0 0 1 7 9.74c.315.047.601.211.8.46 0 0 .35.37.41.42.305.264.696.41 1.1.41-.433.308-.82.675-1.15 1.09Zm1.49-1.3a1.06 1.06 0 0 1-.44-.92 3.77 3.77 0 0 1 .07-.66A1.06 1.06 0 0 0 8.76 8a2.67 2.67 0 0 0-.34-.14c.351.02.693.119 1 .29.273.166.475.425.57.73 0 0 .19.47.23.54a1.7 1.7 0 0 0 .87.79 5.372 5.372 0 0 0-1.44.61Zm2.64-.736s-.44-.011-.816.04c-.185-.303-.18-.631-.034-.954a5.1 5.1 0 0 1 .31-.59 1 1 0 0 0 0-1.31 3.188 3.188 0 0 0-.27-.27c.329.15.62.372.85.65.195.254.288.571.26.89a4.007 4.007 0 0 0 0 .59c.048.383.22.764.501 1.027-.633-.08-.802-.072-.802-.072Zm2.82-.964s-.19.47-.21.55a1.71 1.71 0 0 0 .1 1.2 5.222 5.222 0 0 0-1.48-.62 1.08 1.08 0 0 1 .31-1c.162-.153.332-.296.51-.43a1.06 1.06 0 0 0 .48-1.23 3.097 3.097 0 0 0-.15-.33c.252.258.437.574.54.92.099.32.063.647-.1.94Zm.19 1.94a1.06 1.06 0 0 1 .64-.77c.21-.082.423-.152.64-.21a1.05 1.05 0 0 0 .9-1v-.37c.131.337.186.7.16 1.06a1.26 1.26 0 0 1-.42.82s-.36.37-.4.44a1.68 1.68 0 0 0-.36 1.12 5.364 5.364 0 0 0-1.16-1.07v-.02Zm3.3 1.73-.53.24a1.7 1.7 0 0 0-.76.94c-.13-.501-.336-1-.61-1.44l-.025-.051c.197-.299.557-.488.915-.489a5.35 5.35 0 0 1 .67 0 1.05 1.05 0 0 0 1.19-.56s.13-.32.13-.34a2.35 2.35 0 0 1-.25 1 1.23 1.23 0 0 1-.73.7Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
Solaris.displayName = "Icon.Os.Solaris";

// Icon/Os/Windows.tsx
var import_uik362 = require("@appd/uik");
var import_jsx_runtime352 = require("react/jsx-runtime");
var Windows = import_uik362.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime352.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Os.Windows",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime352.jsx)(
      "path",
      {
        d: "m3.98 17.68 5.99.9v-5.7H3.98v4.8Zm7.72 1.13 8.32 1.2v-7.13H11.7v5.93Zm0-13.5v5.92h8.32V4.11l-8.32 1.2Zm-7.72 5.92h5.99v-5.7l-5.99.9v4.8Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
Windows.displayName = "Icon.Os.Windows";

// Icon/Status/Status.ts
var Status_exports = {};
__export(Status_exports, {
  AppNotResponding: () => AppNotResponding,
  ArrowDownDropoff: () => ArrowDownDropoff,
  Broken: () => Broken,
  Charging: () => Charging,
  CloudCritical: () => CloudCritical,
  CloudVerySlow: () => CloudVerySlow,
  CloudWarning: () => CloudWarning,
  CodeCritical: () => CodeCritical,
  CodeVerySlow: () => CodeVerySlow,
  CodeWarning: () => CodeWarning,
  Crash: () => Crash,
  DatabaseCritical: () => DatabaseCritical,
  DatabaseDisconnected: () => DatabaseDisconnected,
  DatabaseNormal: () => DatabaseNormal,
  DatabaseVerySlow: () => DatabaseVerySlow,
  DatabaseWarning: () => DatabaseWarning,
  DiagnosticSessionCritical: () => DiagnosticSessionCritical,
  DiagnosticSessionVerySlow: () => DiagnosticSessionVerySlow,
  DiagnosticSessionWarning: () => DiagnosticSessionWarning,
  Down: () => Down,
  Error: () => Error2,
  Error_2: () => Error_2,
  Info: () => Info2,
  LowCharge: () => LowCharge,
  MetricBrowserConfigure: () => MetricBrowserConfigure,
  MobileEumCrash: () => MobileEumCrash,
  MobileEumError: () => MobileEumError,
  MobileEumInfo: () => MobileEumInfo,
  MobileEumNormal: () => MobileEumNormal,
  MobileEumUnknown: () => MobileEumUnknown,
  NoData: () => NoData,
  NoDataFound: () => NoDataFound,
  On: () => On,
  Paused: () => Paused,
  PendingConfiguration: () => PendingConfiguration,
  Ready: () => Ready,
  Running: () => Running,
  SearchNotFound: () => SearchNotFound,
  Sleeping: () => Sleeping,
  Success: () => Success,
  Terminated: () => Terminated2,
  Unauthorized: () => Unauthorized,
  Unknown: () => Unknown2,
  Up: () => Up,
  Warning: () => Warning2,
  Warning_2: () => Warning_2,
  Warning_3: () => Warning_3,
  Zombie: () => Zombie
});

// Icon/Status/AppNotResponding.tsx
var import_uik363 = require("@appd/uik");
var import_jsx_runtime353 = require("react/jsx-runtime");
var AppNotResponding = import_uik363.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime353.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.AppNotResponding",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime353.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "m13.23 3.878-.73 2.7a1 1 0 0 0 .66 1.14.94.94 0 0 0 1.15-.66l.72-2.7a.932.932 0 0 0-1.8-.48Zm-2.495 12.953a.94.94 0 0 0-1.125.588l-.72 2.7a.931.931 0 0 0 1.8.48l.73-2.7a.94.94 0 0 0-.685-1.068ZM2.93 9.818a.92.92 0 0 1 1.14-.66l2.7.72a.94.94 0 0 1-.48 1.81l-2.7-.73a.93.93 0 0 1-.66-1.14Zm14.68 2.95a.94.94 0 0 0-1.14.66.94.94 0 0 0 .66 1.15l2.7.72a.932.932 0 0 0 .48-1.8l-2.7-.73Zm-11.32 0a.94.94 0 0 1 .48 1.81l-2.7.72a.932.932 0 0 1-.48-1.8l2.7-.73Zm14.44-3.367a.931.931 0 0 0-.9-.243l-2.7.72a.94.94 0 0 0 .48 1.81l2.7-.73a.932.932 0 0 0 .42-1.557ZM9.55 3.228a.92.92 0 0 1 1.14.66l.73 2.7a.94.94 0 0 1-1.81.48l-.72-2.7a.92.92 0 0 1 .66-1.14Zm4.76 14.2a.94.94 0 0 0-1.15-.66v-.03a1 1 0 0 0-.66 1.17l.73 2.7a.932.932 0 0 0 1.8-.48l-.72-2.7Zm-6.95-1.88a.94.94 0 1 1 1.33 1.33l-2 2a.94.94 0 1 1-1.33-1.33l2-2Zm9.9-9.92-2 2v-.03a1 1 0 0 0 0 1.36.94.94 0 0 0 1.33 0l2-2a.94.94 0 1 0-1.33-1.33ZM6.025 5.344a.92.92 0 0 1 .665.284l2 2a.94.94 0 1 1-1.36 1.3l-2-2a.92.92 0 0 1 .03-1.3.92.92 0 0 1 .665-.284ZM16.59 15.528a.94.94 0 0 0-1.33 0 1 1 0 0 0 0 1.33l2 2a.94.94 0 1 0 1.33-1.33l-2-2Z",
        fill: "#FA5762",
        fillRule: "evenodd"
      }
    )
  }
));
AppNotResponding.displayName = "Icon.Status.AppNotResponding";

// Icon/Status/ArrowDownDropoff.tsx
var import_uik364 = require("@appd/uik");
var import_jsx_runtime354 = require("react/jsx-runtime");
var ArrowDownDropoff = import_uik364.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime354.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.ArrowDownDropoff",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime354.jsx)(
      "path",
      {
        d: "M11 5.229v11.17l-4.883-4.883a.997.997 0 0 0-1.41 0l-.002.002-.003.003a1 1 0 0 0 .003 1.412l6.588 6.588a1 1 0 0 0 1.414 0l6.588-6.588a.997.997 0 0 0-1.41-1.41L13 16.398V5.228a1 1 0 1 0-2 0Z",
        fill: "#FA5762"
      }
    )
  }
));
ArrowDownDropoff.displayName = "Icon.Status.ArrowDownDropoff";

// Icon/Status/Broken.tsx
var import_uik365 = require("@appd/uik");
var import_jsx_runtime355 = require("react/jsx-runtime");
var Broken = import_uik365.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime355.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.Broken",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime355.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M21 5.229c0-1.1-.9-2-2-2h-5.095l-1.947 1.914 3.5 3.44-3.5 3.438 3.5 3.44-3.5 3.44 2.367 2.328H19c1.1 0 2-.9 2-2v-14ZM9.104 18.9l3.5-3.44-3.5-3.44 3.5-3.438-3.5-3.44 1.948-1.914H5c-1.102 0-2 .9-2 2v14c0 1.099.899 2 2 2h6.47L9.105 18.9Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Broken.displayName = "Icon.Status.Broken";

// Icon/Status/Charging.tsx
var import_uik366 = require("@appd/uik");
var import_jsx_runtime356 = require("react/jsx-runtime");
var Charging = import_uik366.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime356.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.Charging",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime356.jsx)("path", { d: "M15.38 10.872h-2.53v-6.96l-5.06 9.49h2.53v6.96l5.06-9.49Z", fill: "#fff", fillOpacity: ".94" }),
      /* @__PURE__ */ (0, import_jsx_runtime356.jsx)(
        "path",
        {
          d: "M21.18 9.229v-.67a2.31 2.31 0 0 0-2.27-2.33h-4.56v2h4.56a.31.31 0 0 1 .27.33v7.33a.31.31 0 0 1-.27.33h-4.68l-1.072 2.01h5.752a2.3 2.3 0 0 0 2.27-2.33v-.67h.9v-6h-.9ZM4 8.559v7.33a.32.32 0 0 0 .29.33h4.53v2.01H4.26A2.3 2.3 0 0 1 2 15.888v-7.34a2.31 2.31 0 0 1 2.3-2.32h5.616l-1.067 2H4.29a.31.31 0 0 0-.29.33Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
Charging.displayName = "Icon.Status.Charging";

// Icon/Status/CloudCritical.tsx
var import_uik367 = require("@appd/uik");
var import_jsx_runtime357 = require("react/jsx-runtime");
var CloudCritical = import_uik367.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime357.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.CloudCritical",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime357.jsx)(
        "path",
        {
          d: "M2.5 13.329c0-2.2 1.7-4 3.8-4.3h.5l.2-.5c1-1.9 2.9-3 5-3 2.7 0 5 1.9 5.5 4.5l.1.6h.7c.9.1 1.8.5 2.3 1.2h2.3c-.7-1.5-2.1-2.5-3.7-2.9-.9-3.2-3.9-5.5-7.2-5.5-2.7.1-5.1 1.5-6.4 3.8-2.9.5-5.1 3.1-5.1 6.1 0 3.4 2.8 6.2 6.2 6.2h5.6v-2H6.8c-2.4 0-4.3-1.9-4.3-4.2Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime357.jsx)(
        "path",
        {
          d: "M21.6 13.928h-6.3c-.6 0-1 .4-1 1v6.301c0 .6.4 1 1 1h6.3c.6 0 1-.4 1-1v-6.4c0-.5-.5-.9-1-.9Z",
          fill: "#FA5762"
        }
      )
    ]
  }
));
CloudCritical.displayName = "Icon.Status.CloudCritical";

// Icon/Status/CloudVerySlow.tsx
var import_uik368 = require("@appd/uik");
var import_jsx_runtime358 = require("react/jsx-runtime");
var CloudVerySlow = import_uik368.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime358.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.CloudVerySlow",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime358.jsx)(
        "path",
        {
          d: "M6.8 17.529c-2.4 0-4.3-1.9-4.3-4.3 0-2.2 1.7-4 3.8-4.3h.5l.2-.4c1-1.9 2.9-3 5-3 2.7 0 5 1.9 5.5 4.5l.1.6h.7c1 .1 1.9.6 2.4 1.3h1.5c.3 0 .6.1.9.1-.7-1.6-2.1-2.8-3.8-3.1-.9-3.2-3.9-5.5-7.2-5.5-2.8.1-5.2 1.5-6.5 3.8-2.9.5-5.1 3.1-5.1 6.1 0 3.4 2.8 6.2 6.2 6.2h7.5l-1.2-2H6.8Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime358.jsx)(
        "path",
        {
          d: "M22.7 14.129c-.2-.1-.3-.1-.5-.1H15c-.6 0-1 .4-1 1 0 .2 0 .3.1.5l1.2 2 1.2 2 1.2 2.2c.3.5.9.6 1.4.4.2-.1.3-.2.4-.4l1.8-3.2 1.7-3c.3-.5.2-1.1-.3-1.4Z",
          fill: "#FF9E59"
        }
      )
    ]
  }
));
CloudVerySlow.displayName = "Icon.Status.CloudVerySlow";

// Icon/Status/CloudWarning.tsx
var import_uik369 = require("@appd/uik");
var import_jsx_runtime359 = require("react/jsx-runtime");
var CloudWarning = import_uik369.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime359.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.CloudWarning",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime359.jsx)(
        "path",
        {
          d: "M19.2 9.029c-.9-3.2-3.9-5.5-7.2-5.5-2.7 0-5.1 1.4-6.4 3.7-2.9.5-5.1 3.1-5.1 6.1 0 3.4 2.8 6.2 6.2 6.2h4.9l1.2-2h-6c-2.4 0-4.3-1.9-4.3-4.3 0-2.2 1.7-4 3.8-4.3h.5l.2-.4c1-1.9 2.9-3 5-3 2.7 0 5 1.9 5.5 4.5l.1.6h.7c1.8.1 3.2 1.6 3.2 3.4 0 .6-.2 1.1-.4 1.6l1.1 1.9c.8-.9 1.3-2.1 1.3-3.5 0-2.3-1.8-4.5-4.3-5Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime359.jsx)(
        "path",
        {
          d: "m20.6 18.928-1-1.8-1.3-2.3c-.3-.5-.9-.6-1.4-.4-.2.1-.3.2-.4.4l-1.5 2.7-1.2 2-.8 1.6c-.3.5-.1 1.1.4 1.4.2.1.3.1.5.1H21c.6 0 1-.4 1-1 0-.2 0-.3-.1-.5l-1.3-2.2Z",
          fill: "#F0C243"
        }
      )
    ]
  }
));
CloudWarning.displayName = "Icon.Status.CloudWarning";

// Icon/Status/CodeCritical.tsx
var import_uik370 = require("@appd/uik");
var import_jsx_runtime360 = require("react/jsx-runtime");
var CodeCritical = import_uik370.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime360.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.CodeCritical",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime360.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M7.5 5.928c.4.4.5 1 .1 1.4l-4.1 4.9 4.1 5c.4.4.3 1-.1 1.4-.1.1-.4.2-.6.2-.3 0-.6-.2-.8-.4l-4.6-5.5c-.3-.4-.3-.9 0-1.3l4.6-5.5c.4-.5 1-.5 1.4-.2Zm12.3 6-3.8-4.5c-.4-.4-.3-1 .1-1.4.4-.4 1-.3 1.4.1l4.6 5.5c.1.1.2.2.2.3h-2.5Zm-5.3-4.9c0-.5-.3-1-.8-1.2-.5-.2-1.1.1-1.2.7l-3.4 11c-.2.5.1 1.1.7 1.2h.3c.4 0 .8-.3 1-.7l3.4-11Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime360.jsx)("path", { d: "M21.6 13.928h-6.3c-.6 0-1 .4-1 1v6.3c0 .6.4 1 1 1h6.3c.6 0 1-.4 1-1v-6.3c0-.6-.5-1-1-1Z", fill: "#FA5762" })
    ]
  }
));
CodeCritical.displayName = "Icon.Status.CodeCritical";

// Icon/Status/CodeVerySlow.tsx
var import_uik371 = require("@appd/uik");
var import_jsx_runtime361 = require("react/jsx-runtime");
var CodeVerySlow = import_uik371.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime361.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.CodeVerySlow",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime361.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M7.2 6.029c.5.3.5 1 .1 1.4l-4.1 4.9 4.1 4.9c.4.4.3 1-.1 1.4-.1.1-.4.2-.6.2-.3 0-.6-.2-.8-.4l-4.6-5.5c-.3-.4-.3-.9 0-1.3l4.6-5.5c.4-.4 1-.5 1.4-.1Zm12.4 6-3.8-4.6c-.4-.4-.3-1 .1-1.4.4-.4 1-.3 1.4.1l4.6 5.5c.1.1.2.2.2.4h-2.5Zm-5.4-4.9c0-.5-.3-1.1-.8-1.2-.5-.2-1.1.1-1.2.7l-3.4 11c-.2.5.1 1.1.7 1.2h.3c.4 0 .8-.3 1-.7l3.4-11Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime361.jsx)(
        "path",
        {
          d: "M22.4 14.229c-.2-.1-.3-.1-.5-.1h-7.2c-.6 0-1 .4-1 1 0 .2 0 .3.1.5l3.6 6.2c.3.5.9.6 1.4.4.2-.1.3-.2.4-.4l3.6-6.2c.2-.5.1-1.1-.4-1.4Z",
          fill: "#FF9E59"
        }
      )
    ]
  }
));
CodeVerySlow.displayName = "Icon.Status.CodeVerySlow";

// Icon/Status/CodeWarning.tsx
var import_uik372 = require("@appd/uik");
var import_jsx_runtime362 = require("react/jsx-runtime");
var CodeWarning = import_uik372.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime362.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.CodeWarning",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime362.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M7.3 5.629c.4.4.5 1 .1 1.5l-4.1 4.9 4.1 4.9c.4.4.3 1-.1 1.4-.1.1-.4.2-.6.2-.3 0-.6-.2-.8-.4l-4.6-5.5c-.3-.4-.3-.9 0-1.3l4.6-5.5c.3-.5 1-.5 1.4-.2Zm12.5 6.3-4-4.8c-.4-.4-.3-1 .1-1.4.4-.4 1-.3 1.4.1l4.6 5.5c.3.4.3.9 0 1.3l-1.6 1.9-.3-.6c-.3-.4-.6-.8-1-1l.8-1Zm-5.6-5.2c.1-.5-.2-1-.7-1.2-.5-.2-1.1.1-1.2.7l-3.4 11c-.2.5.1 1 .6 1.2h.3c.4 0 .8-.3 1-.7l3.4-11Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime362.jsx)(
        "path",
        {
          d: "m19 16.129-.7-1.2c-.1-.2-.3-.4-.6-.4-.3-.1-.6-.1-.8.1-.2.1-.3.2-.4.4l-3.5 6.1c-.3.5-.1 1.1.4 1.4.2.1.3.1.5.1H21c.6 0 1-.4 1-1 0-.2 0-.3-.1-.5l-2.9-5Z",
          fill: "#F0C243"
        }
      )
    ]
  }
));
CodeWarning.displayName = "Icon.Status.CodeWarning";

// Icon/Status/Crash.tsx
var import_uik373 = require("@appd/uik");
var import_jsx_runtime363 = require("react/jsx-runtime");
var Crash = import_uik373.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime363.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.Crash",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime363.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M8.174 2.99a10 10 0 0 1 10.898 2.169c3.904 3.905 3.904 10.235 0 14.14A10 10 0 1 1 8.174 2.989Zm3.828 10.649 2.83 2.83 1.41-1.41-2.83-2.83 2.83-2.83-1.41-1.41-2.83 2.83-2.83-2.83-1.41 1.41 2.83 2.83-2.83 2.83 1.41 1.41 2.83-2.83Z",
        fill: "#FA5762",
        fillRule: "evenodd"
      }
    )
  }
));
Crash.displayName = "Icon.Status.Crash";

// Icon/Status/DatabaseCritical.tsx
var import_uik374 = require("@appd/uik");
var import_jsx_runtime364 = require("react/jsx-runtime");
var DatabaseCritical = import_uik374.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime364.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.DatabaseCritical",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime364.jsx)(
        "path",
        {
          d: "M4.346 14.815c.051.029.104.056.157.084.768.411 1.708.737 2.752.978 1.44.332 3.065.505 4.69.505.342 0 .685-.012 1.027-.027v-1.18c0-.254.036-.494.09-.726-.362.02-.73.035-1.118.035-1.878 0-3.459-.234-4.69-.563-1.858-.497-2.908-1.215-2.908-1.693V9.473l.157.084c.768.41 1.708.737 2.752.978 1.439.333 3.065.506 4.69.506 1.623 0 3.248-.173 4.689-.506 1.044-.241 1.983-.567 2.753-.978.051-.028.104-.055.155-.084v2.726h1.9V6.885c0-2.727-4.778-4.154-9.498-4.154-4.166 0-8.372 1.113-9.302 3.251-.202.534-.195.903-.195.903V17.57c0 .32.07.62.195.905.93 2.137 5.136 3.251 9.302 3.251.358 0 .716-.011 1.072-.028a3.2 3.2 0 0 1-.044-.473V19.8c-.333.016-.674.027-1.028.027-4.714 0-7.598-1.462-7.598-2.256v-2.755ZM11.944 4.63c4.714 0 7.598 1.46 7.598 2.255 0 .478-1.05 1.197-2.909 1.693-1.23.33-2.812.563-4.689.563-1.878 0-3.459-.234-4.69-.563-1.858-.496-2.908-1.215-2.908-1.693 0-.795 2.884-2.255 7.598-2.255Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime364.jsx)(
        "path",
        {
          d: "M22.008 14.2h-6.072c-.579 0-.964.39-.964.975v6.049c0 .107.026.2.05.294.111.413.442.681.913.681h6.073c.578 0 .964-.39.964-.975v-6.147c0-.487-.482-.878-.964-.878Z",
          fill: "#FA5762"
        }
      )
    ]
  }
));
DatabaseCritical.displayName = "Icon.Status.DatabaseCritical";

// Icon/Status/DatabaseDisconnected.tsx
var import_uik375 = require("@appd/uik");
var import_jsx_runtime365 = require("react/jsx-runtime");
var DatabaseDisconnected = import_uik375.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime365.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.DatabaseDisconnected",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime365.jsx)(
        "path",
        {
          d: "m4.346 14.816.157.083c.768.412 1.708.738 2.752.979 1.44.332 3.065.505 4.69.505.269 0 .537-.012.806-.021a6.474 6.474 0 0 1 .987-1.96c-.567.048-1.156.083-1.794.083-1.878 0-3.459-.234-4.69-.564-1.858-.497-2.908-1.214-2.908-1.692V9.473c.051.029.104.056.157.085.768.41 1.708.736 2.752.978 1.439.332 3.065.505 4.69.505 1.623 0 3.248-.173 4.689-.505 1.044-.242 1.983-.568 2.753-.978.051-.029.104-.055.155-.085v2.296a6.448 6.448 0 0 1 1.9.461V6.886c0-2.728-4.778-4.154-9.498-4.154-4.166 0-8.372 1.113-9.302 3.25-.202.535-.195.904-.195.904V17.57c0 .32.07.62.195.904.93 2.137 5.136 3.252 9.302 3.252.508 0 1.017-.017 1.52-.05a6.455 6.455 0 0 1-.792-1.864c-.239.008-.48.014-.728.014-4.714 0-7.598-1.461-7.598-2.256v-2.754Zm7.598-10.185c4.714 0 7.598 1.46 7.598 2.255 0 .478-1.05 1.197-2.909 1.693-1.23.329-2.812.563-4.689.563-1.878 0-3.459-.234-4.69-.563-1.858-.496-2.908-1.215-2.908-1.693 0-.796 2.884-2.255 7.598-2.255Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime365.jsx)(
        "path",
        {
          d: "M22.814 15.812 21.4 14.396l-2.428 2.43-2.429-2.43-1.414 1.415 2.429 2.428-2.43 2.429 1.415 1.414 2.429-2.429 2.428 2.429 1.414-1.414-2.428-2.429 2.428-2.428Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
DatabaseDisconnected.displayName = "Icon.Status.DatabaseDisconnected";

// Icon/Status/DatabaseNormal.tsx
var import_uik376 = require("@appd/uik");
var import_jsx_runtime366 = require("react/jsx-runtime");
var DatabaseNormal = import_uik376.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime366.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.DatabaseNormal",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime366.jsx)(
        "path",
        {
          d: "m4.346 14.816.157.083c.768.412 1.708.738 2.752.979 1.44.332 3.065.505 4.69.505.269 0 .537-.012.806-.021a6.474 6.474 0 0 1 .987-1.96c-.567.048-1.156.083-1.794.083-1.878 0-3.459-.234-4.69-.564-1.858-.497-2.908-1.214-2.908-1.692V9.473c.051.029.104.056.157.085.768.41 1.708.736 2.752.978 1.439.332 3.065.505 4.69.505 1.623 0 3.248-.173 4.689-.505 1.044-.242 1.983-.568 2.753-.978.051-.029.104-.055.155-.085v2.296a6.448 6.448 0 0 1 1.9.461V6.886c0-2.728-4.778-4.154-9.498-4.154-4.166 0-8.372 1.113-9.302 3.25-.202.535-.195.904-.195.904V17.57c0 .32.07.62.195.904.93 2.137 5.136 3.252 9.302 3.252.508 0 1.017-.017 1.52-.05a6.455 6.455 0 0 1-.792-1.864c-.239.008-.48.014-.728.014-4.714 0-7.598-1.461-7.598-2.256v-2.754Zm7.598-10.185c4.714 0 7.598 1.46 7.598 2.255 0 .478-1.05 1.197-2.909 1.693-1.23.329-2.812.563-4.689.563-1.878 0-3.459-.234-4.69-.563-1.858-.496-2.908-1.215-2.908-1.693 0-.796 2.884-2.255 7.598-2.255Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime366.jsx)("path", { d: "M18.972 22.74a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z", fill: "#75D9A0" })
    ]
  }
));
DatabaseNormal.displayName = "Icon.Status.DatabaseNormal";

// Icon/Status/DatabaseVerySlow.tsx
var import_uik377 = require("@appd/uik");
var import_jsx_runtime367 = require("react/jsx-runtime");
var DatabaseVerySlow = import_uik377.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime367.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.DatabaseVerySlow",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime367.jsx)(
        "path",
        {
          d: "M14.377 19.688c-.743.088-1.556.139-2.433.139-4.714 0-7.598-1.462-7.598-2.256v-2.754l.157.083c.768.412 1.708.738 2.752.978 1.44.333 3.065.506 4.69.506.191 0 .382-.01.573-.015a3.138 3.138 0 0 1-.19-1.896c-.13.002-.25.012-.384.012-1.878 0-3.459-.234-4.69-.563-1.858-.497-2.908-1.215-2.908-1.693V9.474c.051.029.104.056.157.084.768.41 1.708.737 2.752.979 1.44.332 3.065.505 4.69.505 1.623 0 3.25-.173 4.69-.505 1.043-.242 1.982-.568 2.752-.98.051-.027.104-.053.155-.083v2.514h1.9V6.887c0-2.728-4.778-4.155-9.498-4.155-4.166 0-8.372 1.113-9.302 3.25-.202.535-.195.905-.195.905V17.57c0 .32.07.62.195.904.93 2.137 5.136 3.25 9.302 3.25 1.174 0 2.35-.09 3.456-.266l-1.023-1.77ZM11.944 4.632c4.714 0 7.598 1.459 7.598 2.255 0 .478-1.05 1.196-2.909 1.692-1.23.33-2.812.564-4.689.564-1.878 0-3.459-.235-4.69-.564-1.858-.496-2.908-1.214-2.908-1.692 0-.796 2.884-2.255 7.598-2.255Z",
          fill: "#F7F7F7"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime367.jsx)(
        "path",
        {
          d: "M22.552 13.988h-7.159c-.888 0-1.442.96-.998 1.73l3.579 6.2c.221.383.61.575.997.575.388 0 .776-.192.997-.576l3.581-6.202a1.152 1.152 0 0 0-.997-1.727Z",
          fill: "#FF9E59"
        }
      )
    ]
  }
));
DatabaseVerySlow.displayName = "Icon.Status.DatabaseVerySlow";

// Icon/Status/DatabaseWarning.tsx
var import_uik378 = require("@appd/uik");
var import_jsx_runtime368 = require("react/jsx-runtime");
var DatabaseWarning = import_uik378.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime368.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.DatabaseWarning",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime368.jsx)(
        "path",
        {
          d: "M11.944 19.826c-4.714 0-7.598-1.461-7.598-2.256v-2.754c.051.029.104.056.157.083.768.412 1.708.738 2.752.979 1.44.332 3.065.505 4.69.505.937 0 1.87-.064 2.772-.177l1.228-2.127c-1.116.242-2.45.406-4 .406-1.88 0-3.46-.234-4.69-.564-1.859-.497-2.909-1.214-2.909-1.692V9.474l.157.084c.768.41 1.708.737 2.752.978 1.439.333 3.065.506 4.69.506 1.623 0 3.248-.173 4.689-.506 1.044-.241 1.983-.568 2.753-.978.051-.029.104-.055.155-.084v2.59a3.126 3.126 0 0 1 1.9 1.161V6.886c0-2.728-4.778-4.154-9.498-4.154-4.166 0-8.372 1.113-9.302 3.25-.202.535-.195.904-.195.904V17.57c0 .32.07.62.195.905.93 2.136 5.136 3.25 9.302 3.25.116 0 .231-.003.346-.005a3.13 3.13 0 0 1 .353-1.907c-.23.007-.46.013-.699.013Zm0-15.195c4.714 0 7.598 1.46 7.598 2.255 0 .478-1.05 1.197-2.909 1.693-1.23.329-2.812.563-4.689.563-1.878 0-3.459-.234-4.69-.563-1.858-.496-2.908-1.215-2.908-1.693 0-.795 2.884-2.255 7.598-2.255Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime368.jsx)(
        "path",
        {
          d: "m23.549 20.763-3.58-6.2a1.14 1.14 0 0 0-.997-.575 1.14 1.14 0 0 0-.997.575l-3.58 6.203a1.15 1.15 0 0 0 .996 1.727h7.159c.888 0 1.443-.961.999-1.73Z",
          fill: "#F0C243"
        }
      )
    ]
  }
));
DatabaseWarning.displayName = "Icon.Status.DatabaseWarning";

// Icon/Status/DiagnosticSessionCritical.tsx
var import_uik379 = require("@appd/uik");
var import_jsx_runtime369 = require("react/jsx-runtime");
var DiagnosticSessionCritical = import_uik379.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime369.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.DiagnosticSessionCritical",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime369.jsx)(
        "path",
        {
          d: "M17.7 11.929v-4c-1.2-.5-2-1.5-2-2.8 0-1.9 1.8-3.3 3.7-2.8.9.2 1.6.9 1.9 1.7.7 1.8-.4 3.4-1.8 3.9v4h-1.8Zm-7-8.7h.6c1.3 0 2.4 1.1 2.4 2.4v5.4c0 2.9-2.2 5.3-4.8 5.8v3h3.4v1.3c0 .165.03.3.058.42.022.1.042.19.042.28H8.3c-.8 0-1.5-.7-1.5-1.5v-3.5c-2.8-.5-4.9-2.9-4.8-5.8v-5.4c0-1.3 1.1-2.4 2.4-2.4h.5v-1h2v3.9h-2v-1h-.5c-.3 0-.5.2-.5.5v5.3c0 1.8 1.1 3.5 2.9 3.9 2.5.6 4.9-1.3 4.9-3.8v-5.4c0-.3-.2-.5-.5-.5h-.5v1h-2v-3.9h2v1Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime369.jsx)(
        "path",
        {
          d: "M21.6 13.928h-6.3c-.6 0-1 .4-1 1v6.2c0 .3.1.5.3.7.2.2.4.3.7.3h6.3c.6 0 1-.4 1-1v-6.3c0-.5-.5-.9-1-.9Z",
          fill: "#FA5762"
        }
      )
    ]
  }
));
DiagnosticSessionCritical.displayName = "Icon.Status.DiagnosticSessionCritical";

// Icon/Status/DiagnosticSessionVerySlow.tsx
var import_uik380 = require("@appd/uik");
var import_jsx_runtime370 = require("react/jsx-runtime");
var DiagnosticSessionVerySlow = import_uik380.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime370.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.DiagnosticSessionVerySlow",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime370.jsx)(
        "path",
        {
          d: "M17.7 12.029v-4.1c-1.2-.5-2-1.5-2-2.8 0-1.9 1.8-3.3 3.7-2.8.9.2 1.6.9 1.9 1.7.7 1.8-.4 3.4-1.8 3.9v4.1h-1.8Zm-8.8 4.8v3h5.4l1.2 2H8.3c-.8 0-1.5-.7-1.5-1.5v-3.5c-2.8-.5-4.9-2.9-4.8-5.8v-5.4c0-1.3 1.1-2.4 2.4-2.4h.5v-1h2v3.9h-2v-1h-.5c-.3 0-.5.2-.5.5v5.3c0 1.8 1.1 3.5 2.9 3.9 2.5.6 4.9-1.3 4.9-3.8v-5.4c0-.3-.2-.5-.5-.5h-.5v1h-2v-3.9h2v1h.6c1.3 0 2.4 1.1 2.4 2.4v5.4c0 2.9-2.2 5.3-4.8 5.8Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime370.jsx)(
        "path",
        {
          d: "M22.7 14.129c-.2-.1-.3-.1-.5-.1H15c-.6 0-1 .4-1 1 0 .2 0 .3.1.5l2.5 4.3 1.1 1.9.1.1c.3.4.8.5 1.3.3.2-.1.3-.2.4-.4l3.6-6.2c.2-.5.1-1.1-.4-1.4Z",
          fill: "#FF9E59"
        }
      )
    ]
  }
));
DiagnosticSessionVerySlow.displayName = "Icon.Status.DiagnosticSessionVerySlow";

// Icon/Status/DiagnosticSessionWarning.tsx
var import_uik381 = require("@appd/uik");
var import_jsx_runtime371 = require("react/jsx-runtime");
var DiagnosticSessionWarning = import_uik381.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime371.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.DiagnosticSessionWarning",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime371.jsx)(
        "path",
        {
          d: "M16.992 12.94V8.62c-1.152-.48-1.92-1.44-1.92-2.687 0-1.824 1.728-3.168 3.552-2.688.864.192 1.536.864 1.824 1.632.672 1.728-.384 3.264-1.728 3.744v5.088a3.556 3.556 0 0 0-1.728-.768Zm-3.84-6.527v5.184c0 2.784-2.112 5.088-4.608 5.568v2.88h2.4l-.192.287c-.288.48-.384 1.056-.384 1.633h-2.4c-.768 0-1.44-.672-1.44-1.44v-3.36c-2.688-.48-4.704-2.784-4.608-5.568V6.413c0-1.248 1.056-2.304 2.304-2.304h.48v-.96h1.92v3.744h-1.92v-.96h-.48c-.288 0-.48.192-.48.48V11.5c0 1.728 1.056 3.36 2.784 3.744 2.4.575 4.704-1.248 4.704-3.648V6.413c0-.288-.192-.48-.48-.48h-.48v.96h-1.92V3.149h1.92v.96h.576c1.248 0 2.304 1.056 2.304 2.304Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime371.jsx)(
        "path",
        {
          d: "m18.72 17.357-1.152-2.016a.983.983 0 0 0-.576-.48c-.288-.097-.48-.097-.768.095a.75.75 0 0 0-.384.385l-2.688 4.704-.672 1.247c-.096.192-.192.48-.096.672.096.289.192.48.48.673.192.096.288.096.48.096h6.816c.576 0 .96-.384.96-.96 0-.192 0-.288-.096-.48l-2.304-3.936Z",
          fill: "#F0C243"
        }
      )
    ]
  }
));
DiagnosticSessionWarning.displayName = "Icon.Status.DiagnosticSessionWarning";

// Icon/Status/Down.tsx
var import_uik382 = require("@appd/uik");
var import_jsx_runtime372 = require("react/jsx-runtime");
var Down = import_uik382.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime372.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.Down",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime372.jsx)(
        "path",
        {
          d: "M14.4 12.729c.3-.3.8-.3 1.1 0 .3.3.3.7-.1 1.1l-3 3c0 .1-.1.2-.2.2-.2.1-.4.1-.6 0 0-.062-.038-.086-.091-.119a.534.534 0 0 1-.109-.082l-3-3c-.3-.3-.3-.8 0-1.1.3-.3.8-.3 1.1 0l1.7 1.7v-6.2c0-.4.2-.8.7-.8.5 0 .8.4.8.8v6.2l1.7-1.7Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime372.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M12 2.229c5.5 0 10 4.5 10 10s-4.5 10-10 10-10-4.5-10-10 4.5-10 10-10Zm0 2c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
Down.displayName = "Icon.Status.Down";

// Icon/Status/Error.tsx
var import_uik383 = require("@appd/uik");
var import_jsx_runtime373 = require("react/jsx-runtime");
var Error2 = import_uik383.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime373.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.Error",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime373.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M12 2.229c-5.523 0-10 4.477-10 10 0 5.522 4.477 10 10 10s10-4.478 10-10a10 10 0 0 0-10-10Zm-1 5v6h2v-6h-2Zm0 8v2h2v-2h-2Zm-7-3a8 8 0 1 0 16 0 8 8 0 0 0-16 0Z",
        fill: "#FF6E72",
        fillRule: "evenodd"
      }
    )
  }
));
Error2.displayName = "Icon.Status.Error";

// Icon/Status/Error_2.tsx
var import_uik384 = require("@appd/uik");
var import_jsx_runtime374 = require("react/jsx-runtime");
var Error_2 = import_uik384.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime374.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.Error_2",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime374.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M15.73 3.229H8.27L3 8.499v7.46l5.27 5.27h7.46l5.27-5.27v-7.46l-5.27-5.27Zm-4.73 4h2v6h-2v-6Zm-.3 9a1.3 1.3 0 1 0 2.6 0 1.3 1.3 0 0 0-2.6 0Z",
        fill: "#FA5762",
        fillRule: "evenodd"
      }
    )
  }
));
Error_2.displayName = "Icon.Status.Error_2";

// Icon/Status/Info.tsx
var import_uik385 = require("@appd/uik");
var import_jsx_runtime375 = require("react/jsx-runtime");
var Info2 = import_uik385.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime375.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.Info",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime375.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M2.026 12.229c0-5.52 4.48-10 10-10s10 4.48 10 10-4.48 10-10 10-10-4.48-10-10Zm11-1v6h-2v-6h2Zm-1 9c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Zm1-13v2h-2v-2h2Z",
        fill: "#79D1FD",
        fillRule: "evenodd"
      }
    )
  }
));
Info2.displayName = "Icon.Status.Info";

// Icon/Status/LowCharge.tsx
var import_uik386 = require("@appd/uik");
var import_jsx_runtime376 = require("react/jsx-runtime");
var LowCharge = import_uik386.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime376.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.LowCharge",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime376.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M22.08 9.229h-.9v-.67a2.31 2.31 0 0 0-2.27-2.33H4.3A2.31 2.31 0 0 0 2 8.549v7.34a2.3 2.3 0 0 0 2.26 2.34h14.65a2.3 2.3 0 0 0 2.27-2.33v-.67h.9v-6Zm-16.63.38h3.827v5.06H5.45v-5.06ZM4.3 8.229h14.61a.31.31 0 0 1 .27.33v7.34a.31.31 0 0 1-.27.33H4.26a.32.32 0 0 1-.26-.34V8.547a.31.31 0 0 1 .3-.32Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
LowCharge.displayName = "Icon.Status.LowCharge";

// Icon/Status/MetricBrowserConfigure.tsx
var import_uik387 = require("@appd/uik");
var import_jsx_runtime377 = require("react/jsx-runtime");
var MetricBrowserConfigure = import_uik387.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime377.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.MetricBrowserConfigure",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime377.jsx)(
      "path",
      {
        d: "M14.367 3.234h-3.75v14h.618a7.459 7.459 0 0 1 3.132-4.311v-9.69Zm-6 8h-3.75v6h3.75v-6Zm11.999.751V9.234h-3.75v2.712a7.407 7.407 0 0 1 1.799-.23c.676 0 1.328.1 1.951.27ZM3.367 19.234v2h7.908a7.404 7.404 0 0 1-.297-2H3.367Zm18.811-.047a4 4 0 0 0-.05-.65l1.15-1-1-1.7-1.45.45a4.427 4.427 0 0 0-.537-.338 7.29 7.29 0 0 0-.563-.262l-.3-1.5h-2l-.3 1.5c-.2.083-.388.17-.562.262a4.374 4.374 0 0 0-.538.338l-1.45-.45-1 1.7 1.15 1c-.034.2-.05.417-.05.65 0 .233.016.45.05.65l-1.15 1 1 1.7 1.45-.45c.183.133.362.246.538.338.174.091.362.179.562.262l.3 1.5h2l.3-1.5c.2-.083.387-.17.563-.262.174-.092.353-.205.537-.338l1.45.45 1-1.7-1.15-1a4 4 0 0 0 .05-.65ZM19.84 20.6a1.928 1.928 0 0 1-1.413.587c-.55 0-1.02-.196-1.412-.587a1.927 1.927 0 0 1-.588-1.413c0-.55.196-1.021.588-1.413a1.925 1.925 0 0 1 1.412-.587c.55 0 1.02.196 1.413.587.391.392.587.863.587 1.413s-.196 1.021-.587 1.413Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
MetricBrowserConfigure.displayName = "Icon.Status.MetricBrowserConfigure";

// Icon/Status/MobileEumCrash.tsx
var import_uik388 = require("@appd/uik");
var import_jsx_runtime378 = require("react/jsx-runtime");
var MobileEumCrash = import_uik388.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime378.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.MobileEumCrash",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime378.jsx)(
        "path",
        {
          d: "M14.1 4.129H6.8v15.2H9v1.9H6.4c-.8 0-1.4-.7-1.4-1.6v-15.8c0-.9.6-1.6 1.4-1.6h8.1c.8 0 1.4.7 1.4 1.6v9.4h-1.8v-9.1Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime378.jsx)(
        "path",
        {
          d: "m17.193 15.11 1.288 1.287-2.32 2.32 2.32 2.323-1.288 1.288-2.321-2.322-2.321 2.322-1.287-1.288 2.321-2.322-2.321-2.322 1.287-1.287 2.229 2.228h.092l-.045.048.046.045 2.32-2.32ZM8.9 5.329h3v1h-3v-1Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
MobileEumCrash.displayName = "Icon.Status.MobileEumCrash";

// Icon/Status/MobileEumError.tsx
var import_uik389 = require("@appd/uik");
var import_jsx_runtime379 = require("react/jsx-runtime");
var MobileEumError = import_uik389.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime379.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.MobileEumError",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime379.jsx)(
        "path",
        {
          d: "M6.8 19.328h2.5v1.9H6.4c-.8 0-1.4-.7-1.4-1.6v-15.8c0-.9.6-1.6 1.4-1.6h8.1c.8 0 1.4.7 1.4 1.6v8.5h-1.8v-8.2H6.8v15.2Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime379.jsx)("path", { d: "M11.9 5.329h-3v1h3v-1Z", fill: "#fff", fillOpacity: ".94" }),
      /* @__PURE__ */ (0, import_jsx_runtime379.jsx)("path", { d: "M19 14.229h-6c-.5 0-1 .4-1 1v6c0 .5.4 1 1 1h6c.5 0 1-.4 1-1v-6c-.1-.5-.5-1-1-1Z", fill: "#FA5762" })
    ]
  }
));
MobileEumError.displayName = "Icon.Status.MobileEumError";

// Icon/Status/MobileEumInfo.tsx
var import_uik390 = require("@appd/uik");
var import_jsx_runtime380 = require("react/jsx-runtime");
var MobileEumInfo = import_uik390.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime380.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.MobileEumInfo",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime380.jsx)(
        "path",
        {
          d: "M8.8 4.129v15.2h2c.2.7.4 1.3.8 1.9H8.4c-.8 0-1.4-.7-1.4-1.6v-15.8c0-.9.6-1.6 1.4-1.6h8.1c.8 0 1.4.7 1.4 1.6v7.6c-.3-.1-.6-.1-.9-.1-.5 0-.9.1-.9.1v-7.3H8.8Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime380.jsx)("path", { d: "M13.9 5.329h-3v1h3v-1Z", fill: "#fff", fillOpacity: ".94" }),
      /* @__PURE__ */ (0, import_jsx_runtime380.jsx)(
        "path",
        {
          d: "M17.9 13.428c-.3-.1-.6-.1-.9-.1-.3 0-.6 0-.9.1-2 .4-3.5 2.2-3.5 4.3 0 .5.1 1 .3 1.5.3.8.8 1.4 1.4 1.9.8.6 1.7 1 2.8 1 2.4 0 4.4-2 4.4-4.4-.1-2.1-1.6-3.8-3.6-4.3Z",
          fill: "#3FB6F2"
        }
      )
    ]
  }
));
MobileEumInfo.displayName = "Icon.Status.MobileEumInfo";

// Icon/Status/MobileEumNormal.tsx
var import_uik391 = require("@appd/uik");
var import_jsx_runtime381 = require("react/jsx-runtime");
var MobileEumNormal = import_uik391.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime381.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.MobileEumNormal",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime381.jsx)(
        "path",
        {
          d: "M8.8 4.129v15.2h2c.2.7.4 1.3.8 1.9H8.4c-.8 0-1.4-.7-1.4-1.6v-15.8c0-.9.6-1.6 1.4-1.6h8.1c.8 0 1.4.7 1.4 1.6v7.6c-.3-.1-.6-.1-.9-.1-.5 0-.9.1-.9.1v-7.3H8.8Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime381.jsx)("path", { d: "M13.9 5.329h-3v1h3v-1Z", fill: "#fff", fillOpacity: ".94" }),
      /* @__PURE__ */ (0, import_jsx_runtime381.jsx)(
        "path",
        {
          d: "M17.9 13.428c-.3-.1-.6-.1-.9-.1-.3 0-.6 0-.9.1-2 .4-3.5 2.2-3.5 4.3 0 .5.1 1 .3 1.5.3.8.8 1.4 1.4 1.9.8.6 1.7 1 2.8 1 2.4 0 4.4-2 4.4-4.4-.1-2.1-1.6-3.8-3.6-4.3Z",
          fill: "#21A65F"
        }
      )
    ]
  }
));
MobileEumNormal.displayName = "Icon.Status.MobileEumNormal";

// Icon/Status/MobileEumUnknown.tsx
var import_uik392 = require("@appd/uik");
var import_jsx_runtime382 = require("react/jsx-runtime");
var MobileEumUnknown = import_uik392.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime382.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.MobileEumUnknown",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime382.jsx)(
        "path",
        {
          d: "M8.8 4.129v15.2h2c.2.7.4 1.3.8 1.9H8.4c-.8 0-1.4-.7-1.4-1.6v-15.8c0-.9.6-1.6 1.4-1.6h8.1c.8 0 1.4.7 1.4 1.6v7.6c-.3-.1-.6-.1-.9-.1-.5 0-.9.1-.9.1v-7.3H8.8Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime382.jsx)("path", { d: "M13.9 5.329h-3v1h3v-1Z", fill: "#fff", fillOpacity: ".94" }),
      /* @__PURE__ */ (0, import_jsx_runtime382.jsx)(
        "path",
        {
          d: "M17.9 13.428c-.3-.1-.6-.1-.9-.1-.3 0-.6 0-.9.1-2 .4-3.5 2.2-3.5 4.3 0 .5.1 1 .3 1.5.3.8.8 1.4 1.4 1.9.8.6 1.7 1 2.8 1 2.4 0 4.4-2 4.4-4.4-.1-2.1-1.6-3.8-3.6-4.3Z",
          fill: "#8C8C8C"
        }
      )
    ]
  }
));
MobileEumUnknown.displayName = "Icon.Status.MobileEumUnknown";

// Icon/Status/NoData.tsx
var import_uik393 = require("@appd/uik");
var import_jsx_runtime383 = require("react/jsx-runtime");
var NoData = import_uik393.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime383.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.NoData",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime383.jsx)("path", { d: "M11 9.992h2v3.677h-2V9.992Zm0 5.677h2v2h-2v-2Z", fill: "#fff", fillOpacity: ".94" }),
      /* @__PURE__ */ (0, import_jsx_runtime383.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M12 2.2a1.05 1.05 0 0 0-.916.529L1.28 19.664c-.409.705.1 1.588.916 1.588h19.608c.816 0 1.325-.883.916-1.588L12.916 2.729A1.048 1.048 0 0 0 12 2.2Zm0 2.939 8.17 14.113H3.83L12 5.14Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
NoData.displayName = "Icon.Status.NoData";

// Icon/Status/NoDataFound.tsx
var import_uik394 = require("@appd/uik");
var import_jsx_runtime384 = require("react/jsx-runtime");
var NoDataFound = import_uik394.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime384.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.NoDataFound",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime384.jsx)(
      "path",
      {
        d: "M21.51 8.72H6.34s-.07 0-.09.01c-.59.099-1.08.515-1.21 1.03l-1.42 3.843V5.451h5.12l1.49 2.07h10.73v-.198c0-.872-.72-1.585-1.6-1.585h-7.9L9.79 3.43H3.17c-.88 0-1.6.713-1.6 1.585v15.116c0 .05 0 .188.24.475.32.367.81.377 1.3.377h14.92c.67 0 1.31-.456 1.46-1.05l3.42-9.312.03-.237c0-.921-.62-1.615-1.44-1.654l.01-.01ZM3.84 18.952l3.02-8.212h13.85l-3.02 8.212H3.84Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
NoDataFound.displayName = "Icon.Status.NoDataFound";

// Icon/Status/On.tsx
var import_uik395 = require("@appd/uik");
var import_jsx_runtime385 = require("react/jsx-runtime");
var On = import_uik395.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime385.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.On",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime385.jsx)(
        "path",
        {
          d: "m12.5 7.729 3 3c.3.3.5.7.2 1-.3.3-.8.3-1.1 0l-1.7-1.7v6.2c0 .5-.3.8-.8.8s-.8-.4-.8-.8v-6.1l-1.7 1.7c-.3.3-.8.3-1.1 0-.3-.3-.3-.8 0-1.1l3-3c0-.1.1-.2.2-.2.2-.1.4-.1.6 0 0 .061.038.085.091.118.033.02.07.043.109.082Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime385.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M12 22.229c-5.5 0-10-4.5-10-10s4.5-10 10-10 10 4.5 10 10-4.5 10-10 10Zm0-2c4.4 0 8-3.6 8-8s-3.6-8-8-8-8 3.6-8 8 3.6 8 8 8Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
On.displayName = "Icon.Status.On";

// Icon/Status/Paused.tsx
var import_uik396 = require("@appd/uik");
var import_jsx_runtime386 = require("react/jsx-runtime");
var Paused = import_uik396.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime386.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.Paused",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime386.jsx)(
      "path",
      {
        d: "M9 16.229h2v-8H9v8Zm4 0h2v-8h-2v8Zm-1 6c-1.38 0-2.68-.26-3.9-.79-1.22-.52-2.28-1.24-3.18-2.14-.9-.9-1.61-1.96-2.14-3.18a9.678 9.678 0 0 1-.79-3.9c0-1.38.26-2.68.79-3.9.52-1.22 1.24-2.28 2.14-3.18.9-.9 1.96-1.61 3.18-2.14a9.85 9.85 0 0 1 3.9-.79c1.38 0 2.68.26 3.9.79 1.22.53 2.28 1.24 3.18 2.14.9.9 1.61 1.96 2.14 3.18.53 1.22.79 2.52.79 3.9s-.26 2.68-.79 3.9c-.52 1.22-1.24 2.28-2.14 3.18-.9.9-1.96 1.61-3.18 2.14-1.22.53-2.52.79-3.9.79Zm0-2c2.22 0 4.1-.78 5.66-2.34 1.56-1.56 2.34-3.45 2.34-5.66s-.78-4.1-2.34-5.66c-1.56-1.56-3.45-2.34-5.66-2.34s-4.1.78-5.66 2.34C4.78 8.129 4 10.018 4 12.229s.78 4.1 2.34 5.66c1.56 1.56 3.45 2.34 5.66 2.34Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
Paused.displayName = "Icon.Status.Paused";

// Icon/Status/PendingConfiguration.tsx
var import_uik397 = require("@appd/uik");
var import_jsx_runtime387 = require("react/jsx-runtime");
var PendingConfiguration = import_uik397.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime387.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.PendingConfiguration",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime387.jsx)(
        "path",
        {
          d: "M12.09 19.849h-1.18l-.62-1.91a.906.906 0 0 0-.58-.58 5.5 5.5 0 0 1-.95-.4.88.88 0 0 0-.82 0l-1.79.91-.83-.83.91-1.79a.89.89 0 0 0 0-.81c-.18-.35-.31-.66-.41-.97a.906.906 0 0 0-.58-.58l-1.91-.62v-1.17l1.91-.62c.28-.09.5-.31.58-.6.1-.32.23-.64.38-.93.14-.26.14-.57 0-.83l-.91-1.78.83-.84 1.79.92c.27.13.58.13.84-.02.26-.14.54-.26.94-.39.27-.09.49-.3.57-.58l.62-1.91h1.17l.61 1.91c.09.28.31.5.59.58.34.11.66.24.94.39.26.14.57.15.84.01l1.79-.92.83.83-.92 1.79c-.13.26-.13.57 0 .83.14.27.27.58.4.97.09.27.31.48.58.57l1.9.61v1.33c.62.17 1.2.45 1.73.82.04-.1.07-.21.07-.32v-2.48c0-.39-.25-.73-.62-.85l-2.11-.68c-.05-.13-.1-.25-.15-.36l1.01-1.98c.18-.35.11-.77-.16-1.04l-1.75-1.76a.898.898 0 0 0-1.04-.17l-1.97 1.01c-.12-.06-.25-.11-.38-.16l-.67-2.11a.895.895 0 0 0-.86-.62h-2.48c-.39 0-.73.25-.85.62l-.68 2.11c-.12.05-.25.1-.38.15l-1.96-1.01a.88.88 0 0 0-1.04.17l-1.76 1.76c-.27.28-.34.69-.16 1.04l1 1.96c-.06.12-.11.25-.15.38l-2.1.68c-.37.12-.62.46-.62.85v2.48c0 .39.24.73.61.86l2.11.69.15.36-1.01 1.97c-.18.35-.11.76.16 1.04l1.75 1.76c.28.28.7.35 1.04.17l1.97-1c.12.06.25.11.37.15l.69 2.11c.12.37.46.62.85.62h2.48c.11 0 .21-.02.3-.06-.37-.54-.64-1.12-.82-1.74h-.14l.05.01Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime387.jsx)(
        "path",
        {
          d: "M20.82 15.379c-.51-.51-1.11-.84-1.76-1.02-.34-.09-.69-.15-1.07-.15-.43 0-.83.08-1.21.19-.6.19-1.14.5-1.62.97-.48.47-.79 1.02-.97 1.61-.12.38-.2.78-.2 1.21 0 .38.06.74.16 1.09.18.65.5 1.23 1.01 1.74.78.78 1.72 1.17 2.83 1.17s2.05-.39 2.83-1.17c.78-.78 1.17-1.72 1.17-2.83s-.39-2.05-1.17-2.83v.02Zm-1.49 4.73-1.74-1.74v-2.56h.8v2.24l1.5 1.5-.56.56Zm-4.94-6.7c.23-.38.39-.81.46-1.28.25-1.84-1.06-3.54-2.9-3.79-.22-.03-.44-.04-.66-.02-.66.04-1.29.28-1.83.69a3.35 3.35 0 0 0-1.3 2.23c-.12.89.12 1.78.66 2.5a3.35 3.35 0 0 0 2.69 1.33c.62 0 1.2-.17 1.71-.47.49-.29.89-.7 1.19-1.19h-.02Zm-1.27-1.51c-.06.43-.28.82-.63 1.09-.26.2-.57.31-.89.33-.11 0-.22 0-.33-.01-.43-.06-.82-.28-1.08-.63-.27-.35-.38-.78-.32-1.21.11-.81.8-1.42 1.62-1.42.07 0 .14 0 .22.01.9.12 1.53.94 1.41 1.84Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
PendingConfiguration.displayName = "Icon.Status.PendingConfiguration";

// Icon/Status/Ready.tsx
var import_uik398 = require("@appd/uik");
var import_jsx_runtime388 = require("react/jsx-runtime");
var Ready = import_uik398.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime388.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.Ready",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime388.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M16.59 7.809 10 14.399l-2.59-2.58L6 13.229l4 4 8-8-1.41-1.42ZM12 20.229c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Zm0-18c-5.52 0-10 4.48-10 10 0 5.518 4.48 10 10 10s10-4.482 10-10c0-5.52-4.48-10-10-10Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Ready.displayName = "Icon.Status.Ready";

// Icon/Status/Running.tsx
var import_uik399 = require("@appd/uik");
var import_jsx_runtime389 = require("react/jsx-runtime");
var Running = import_uik399.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime389.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.Running",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime389.jsx)(
      "path",
      {
        d: "m9.5 16.729 7-4.5-7-4.5v9Zm2.5 5.5c-1.38 0-2.68-.26-3.9-.79-1.22-.52-2.28-1.24-3.18-2.14-.9-.9-1.61-1.96-2.14-3.18a9.678 9.678 0 0 1-.79-3.9c0-1.38.26-2.68.79-3.9.52-1.22 1.24-2.28 2.14-3.18.9-.9 1.96-1.61 3.18-2.14a9.85 9.85 0 0 1 3.9-.79c1.38 0 2.68.26 3.9.79 1.22.53 2.28 1.24 3.18 2.14.9.9 1.61 1.96 2.14 3.18.53 1.22.79 2.52.79 3.9s-.26 2.68-.79 3.9c-.52 1.22-1.24 2.28-2.14 3.18-.9.9-1.96 1.61-3.18 2.14-1.22.53-2.52.79-3.9.79Zm0-2c2.22 0 4.1-.78 5.66-2.34 1.56-1.56 2.34-3.45 2.34-5.66s-.78-4.1-2.34-5.66c-1.56-1.56-3.45-2.34-5.66-2.34s-4.1.78-5.66 2.34C4.78 8.129 4 10.018 4 12.229s.78 4.1 2.34 5.66c1.56 1.56 3.45 2.34 5.66 2.34Z",
        fill: "#fff",
        fillOpacity: ".94"
      }
    )
  }
));
Running.displayName = "Icon.Status.Running";

// Icon/Status/SearchNotFound.tsx
var import_uik400 = require("@appd/uik");
var import_jsx_runtime390 = require("react/jsx-runtime");
var SearchNotFound = import_uik400.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime390.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.SearchNotFound",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime390.jsx)(
        "path",
        {
          d: "M7.14 19.487H3.02V7.729h4.3v-4.2h8.97V6.6c.72.218 1.39.535 2.02.951V3.529c0-.534-.2-1-.6-1.406-.4-.396-.87-.594-1.42-.594H6.32L1 6.799v12.678c0 .535.2 1 .6 1.407.4.396.87.594 1.42.594h6.34a7.936 7.936 0 0 1-1.49-1.179c-.27-.267-.5-.545-.73-.822v.01Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime390.jsx)(
        "path",
        {
          d: "M18.82 17.981c.39-.475.66-1.02.83-1.634.17-.604.25-1.238.25-1.882 0-1.605-.54-2.972-1.6-4.11-.06-.07-.12-.14-.19-.209a6.093 6.093 0 0 0-1.83-1.258 6.238 6.238 0 0 0-2.53-.515c-1.71 0-3.17.595-4.36 1.773-1.19 1.18-1.79 2.625-1.79 4.319s.6 3.14 1.79 4.319c.27.267.55.495.84.693 1.02.713 2.19 1.08 3.52 1.08.65 0 1.28-.08 1.9-.248a4.685 4.685 0 0 0 1.65-.822l.82.812 3.52 3.487 1.52-1.506-4.34-4.299Zm-2.22-.703c-.1.1-.21.169-.31.258-.7.574-1.54.871-2.53.871-1.13 0-2.08-.376-2.84-1.129-.76-.753-1.14-1.694-1.14-2.813 0-1.12.38-2.06 1.14-2.813.76-.753 1.71-1.13 2.84-1.13.99 0 1.83.308 2.53.872.1.08.21.159.31.258.76.753 1.14 1.694 1.14 2.813 0 1.12-.38 2.06-1.14 2.813Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      )
    ]
  }
));
SearchNotFound.displayName = "Icon.Status.SearchNotFound";

// Icon/Status/Sleeping.tsx
var import_uik401 = require("@appd/uik");
var import_jsx_runtime391 = require("react/jsx-runtime");
var Sleeping = import_uik401.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime391.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.Sleeping",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime391.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M17.752 2.462a.999.999 0 0 0-1.405.121.999.999 0 0 0 .118 1.412l3.071 2.577a1 1 0 0 0 1.286-1.533l-3.07-2.577Zm-6.163 19.5c-4.98 0-9-4.03-9-9a9 9 0 1 1 9 9Zm-7-9c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7-7-3.13-7-7Zm4-2h3.63l-3.63 4.2v1.8h6v-2h-3.63l3.63-4.2v-1.8h-6v2ZM2.357 5.029l3.066-2.567a.997.997 0 1 1 1.282 1.53l-3.063 2.57a1 1 0 0 1-1.407-.124.998.998 0 0 1 .122-1.409Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Sleeping.displayName = "Icon.Status.Sleeping";

// Icon/Status/Success.tsx
var import_uik402 = require("@appd/uik");
var import_jsx_runtime392 = require("react/jsx-runtime");
var Success = import_uik402.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime392.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.Success",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime392.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M16.59 7.809 10 14.399l-2.59-2.58L6 13.229l4 4 8-8-1.41-1.42ZM12 20.229c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Zm0-18c-5.52 0-10 4.48-10 10 0 5.518 4.48 10 10 10s10-4.482 10-10c0-5.52-4.48-10-10-10Z",
        fill: "#75D9A0",
        fillRule: "evenodd"
      }
    )
  }
));
Success.displayName = "Icon.Status.Success";

// Icon/Status/Terminated.tsx
var import_uik403 = require("@appd/uik");
var import_jsx_runtime393 = require("react/jsx-runtime");
var Terminated2 = import_uik403.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime393.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.Terminated",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime393.jsx)(
      "path",
      {
        d: "m12.175 14.056-4.129 4.129a1.168 1.168 0 1 1-1.651-1.652l4.129-4.13-4.13-4.128a1.168 1.168 0 1 1 1.652-1.652l4.13 4.13 4.129-4.13a1.168 1.168 0 1 1 1.651 1.652l-4.129 4.129 4.13 4.129a1.168 1.168 0 1 1-1.652 1.652l-4.13-4.13Z",
        fill: "#FA5762"
      }
    )
  }
));
Terminated2.displayName = "Icon.Status.Terminated";

// Icon/Status/Unauthorized.tsx
var import_uik404 = require("@appd/uik");
var import_jsx_runtime394 = require("react/jsx-runtime");
var Unauthorized = import_uik404.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime394.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.Unauthorized",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime394.jsx)(
        "path",
        {
          d: "M6.166 19.354v-8.323h9.955v.57c.41 0 .786.016 1.146.058.351.041.694.117 1.02.225v-.853c0-.602-.209-1.112-.636-1.53a2.104 2.104 0 0 0-1.53-.636h-.327V7.234c0-1.288-.451-2.401-1.355-3.313-.903-.92-1.999-1.38-3.295-1.38-1.297 0-2.393.46-3.296 1.38-.904.92-1.355 2.025-1.355 3.313v1.63h-.327c-.602 0-1.112.21-1.53.637A2.09 2.09 0 0 0 4 11.03v8.323c0 .603.21 1.113.636 1.531a2.09 2.09 0 0 0 1.53.636h5.103a9.435 9.435 0 0 1-.61-1.054 5.727 5.727 0 0 1-.385-1.113H6.166Zm2.485-12.12c0-.695.242-1.288.728-1.782a2.382 2.382 0 0 1 1.765-.744c.694 0 1.28.25 1.765.744.485.494.727 1.096.727 1.782v1.63H8.66v-1.63h-.008Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime394.jsx)(
        "path",
        {
          d: "M19.65 14.602c-.911-.912-2.007-1.363-3.287-1.363-1.28 0-2.375.451-3.287 1.363-.912.912-1.364 2.008-1.364 3.287 0 1.28.452 2.376 1.364 3.288.912.912 2.007 1.363 3.287 1.363 1.28 0 2.376-.451 3.288-1.363.911-.912 1.363-2.008 1.363-3.288 0-1.28-.452-2.375-1.363-3.287Zm-2.684 5.512a.615.615 0 0 1-.611.611h-.042a.614.614 0 0 1-.61-.61v-.042c0-.335.276-.611.61-.611h.042c.334 0 .61.277.61.611v.041Zm0-1.606H15.71v-3.145h1.254v3.145Z",
          fill: "#FA5762"
        }
      )
    ]
  }
));
Unauthorized.displayName = "Icon.Status.Unauthorized";

// Icon/Status/Unknown.tsx
var import_uik405 = require("@appd/uik");
var import_jsx_runtime395 = require("react/jsx-runtime");
var {
  PARTICLE: { UNKNOWN_ICON }
} = import_uik405.MAGNETIC_TOKENS;
var Unknown2 = import_uik405.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime395.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.Unknown",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime395.jsx)(
        "path",
        {
          d: "M21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12Z",
          fill: UNKNOWN_ICON
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime395.jsx)(
        "path",
        {
          d: "M6.75 11.9998C6.75 11.3371 7.28726 10.7998 7.95 10.7998H16.05C16.7127 10.7998 17.25 11.3371 17.25 11.9998C17.25 12.6625 16.7127 13.1998 16.05 13.1998H7.95C7.28726 13.1998 6.75 12.6625 6.75 11.9998Z",
          fill: "white"
        }
      )
    ]
  }
));
Unknown2.displayName = "Icon.Status.Unknown";

// Icon/Status/Up.tsx
var import_uik406 = require("@appd/uik");
var import_jsx_runtime396 = require("react/jsx-runtime");
var Up = import_uik406.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime396.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.Up",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime396.jsx)(
        "path",
        {
          d: "m12.5 7.729 3 3c.3.3.5.7.2 1-.3.3-.8.3-1.1 0l-1.7-1.7v6.2c0 .5-.3.8-.8.8s-.8-.4-.8-.8v-6.1l-1.7 1.7c-.3.3-.8.3-1.1 0-.3-.3-.3-.8 0-1.1l3-3c0-.1.1-.2.2-.2.2-.1.4-.1.6 0 0 .061.038.085.091.118.033.02.07.043.109.082Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime396.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M12 22.229c-5.5 0-10-4.5-10-10s4.5-10 10-10 10 4.5 10 10-4.5 10-10 10Zm0-2c4.4 0 8-3.6 8-8s-3.6-8-8-8-8 3.6-8 8 3.6 8 8 8Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
Up.displayName = "Icon.Status.Up";

// Icon/Status/Warning.tsx
var import_uik407 = require("@appd/uik");
var import_jsx_runtime397 = require("react/jsx-runtime");
var Warning2 = import_uik407.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime397.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.Warning",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime397.jsx)("path", { d: "M11 9.992h2v3.677h-2V9.992Zm0 5.677h2v2h-2v-2Z", fill: "#F0C243" }),
      /* @__PURE__ */ (0, import_jsx_runtime397.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M12 2.2a1.05 1.05 0 0 0-.916.529L1.28 19.664c-.409.705.1 1.588.916 1.588h19.608c.816 0 1.325-.883.916-1.588L12.916 2.729A1.048 1.048 0 0 0 12 2.2Zm0 2.939 8.17 14.113H3.83L12 5.14Z",
          fill: "#F0C243",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
Warning2.displayName = "Icon.Status.Warning";

// Icon/Status/Warning_2.tsx
var import_uik408 = require("@appd/uik");
var import_jsx_runtime398 = require("react/jsx-runtime");
var Warning_2 = import_uik408.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime398.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.Warning_2",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime398.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "m21.43 11.039-8.34-8.34a1.61 1.61 0 0 0-2.28 0l-8.34 8.34a1.61 1.61 0 0 0 0 2.28l8.34 8.34a1.61 1.61 0 0 0 2.28 0l8.34-8.34a1.61 1.61 0 0 0 0-2.28Zm-8.48-3.88v6h-2v-6h2Zm-2.3 9a1.3 1.3 0 1 0 2.6 0 1.3 1.3 0 0 0-2.6 0Z",
        fill: "#FF6E72",
        fillRule: "evenodd"
      }
    )
  }
));
Warning_2.displayName = "Icon.Status.Warning_2";

// Icon/Status/Warning_3.tsx
var import_uik409 = require("@appd/uik");
var import_jsx_runtime399 = require("react/jsx-runtime");
var Warning_3 = import_uik409.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime399.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.Warning_3",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime399.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M21.026 21.229a.97.97 0 0 0 .844-.501c.174-.31.173-.691-.001-1L12.843 3.727A.97.97 0 0 0 12 3.229a.97.97 0 0 0-.843.498l-9.026 16a1.02 1.02 0 0 0 0 1 .97.97 0 0 0 .843.502h18.052Zm-10-3v-2h1.948v2h-1.948Zm0-7.998v3.999h1.948v-4h-1.948Z",
        fill: "#F0C243",
        fillRule: "evenodd"
      }
    )
  }
));
Warning_3.displayName = "Icon.Status.Warning_3";

// Icon/Status/Zombie.tsx
var import_uik410 = require("@appd/uik");
var import_jsx_runtime400 = require("react/jsx-runtime");
var Zombie = import_uik410.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime400.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Status.Zombie",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime400.jsx)(
        "path",
        {
          d: "m14.53 16.141-1.206 2.244-1.096-2.244H8a.75.75 0 0 1 0-1.5h8a.75.75 0 0 1 0 1.5h-1.47Zm-7.718-4.154a.663.663 0 0 0 .667.667c.178 0 .345-.07.47-.195l.763-.763.764.763c.252.252.69.25.941 0a.666.666 0 0 0 0-.942l-.763-.763.763-.764a.665.665 0 1 0-.941-.941l-.764.763-.763-.763c-.127-.126-.291-.163-.472-.195a.657.657 0 0 0-.469.195.661.661 0 0 0-.001.941l.763.764-.762.763a.658.658 0 0 0-.196.47Zm9.418-1.234.764-.763a.669.669 0 0 0 0-.94.685.685 0 0 0-.944-.002l-.761.764-.764-.763a.683.683 0 0 0-.943 0 .668.668 0 0 0 0 .941l.763.763-.763.764a.667.667 0 0 0 .002.942.68.68 0 0 0 .94 0l.765-.764.761.763a.661.661 0 0 0 .471.195.662.662 0 0 0 .473-.195.669.669 0 0 0 0-.94l-.764-.765Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime400.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M12 22.229c-5.523 0-10-4.479-10-10 0-5.523 4.477-10 10-10 5.522 0 10 4.477 10 10 0 5.521-4.478 10-10 10Zm0-2c4.411 0 8-3.59 8-8 0-4.411-3.589-8-8-8s-8 3.589-8 8c0 4.41 3.589 8 8 8Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
Zombie.displayName = "Icon.Status.Zombie";

// Icon/Widget/Widget.ts
var Widget_exports = {};
__export(Widget_exports, {
  Analytics: () => Analytics2,
  Custom: () => Custom,
  FlowMap: () => FlowMap,
  Funnel: () => Funnel2,
  Gauge: () => Gauge,
  Graph: () => Graph,
  HealthList: () => HealthList,
  Iframe: () => Iframe,
  Image: () => Image2,
  List: () => List2,
  Metric: () => Metric,
  Pie: () => Pie2,
  StatusLight: () => StatusLight,
  StreamingGraph: () => StreamingGraph,
  Text: () => Text2
});

// Icon/Widget/Analytics.tsx
var import_uik411 = require("@appd/uik");
var import_jsx_runtime401 = require("react/jsx-runtime");
var Analytics2 = import_uik411.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime401.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Widget.Analytics",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime401.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M19.275 3H4.725C3.772 3 3 3.772 3 4.725v14.55C3 20.228 3.772 21 4.725 21h14.55c.952 0 1.725-.772 1.725-1.725V4.725C21 3.772 20.227 3 19.275 3Zm-.737 16H5v-3.175l4.45-3.841a2.478 2.478 0 0 0 2.289.17L18.538 19ZM5 13.85l3.48-2.99a2.48 2.48 0 1 1 4.421.262L19 17.323V5H5v8.85Zm5.757-3.011a.963.963 0 1 0 0-1.925.963.963 0 0 0 0 1.925Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Analytics2.displayName = "Icon.Widget.Analytics";

// Icon/Widget/Custom.tsx
var import_uik412 = require("@appd/uik");
var import_jsx_runtime402 = require("react/jsx-runtime");
var Custom = import_uik412.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime402.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Widget.Custom",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime402.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M17.935 18.398v-7l1.826-1.853V18.4a1.831 1.831 0 0 1-1.826 1.826H5.153A1.831 1.831 0 0 1 3.327 18.4V5.617a1.83 1.83 0 0 1 1.826-1.826l10.685-.016-1.826 1.826-8.86.016v12.782l12.783-.001Zm1.34-10.736 1.206-1.206a.658.658 0 0 0 0-.93l-1.543-1.543a.657.657 0 0 0-.93 0L16.803 5.19l2.472 2.472Zm-3.465-1.48-7.005 7.005v2.473h2.472l7.005-7.007-2.472-2.471Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Custom.displayName = "Icon.Widget.Custom";

// Icon/Widget/FlowMap.tsx
var import_uik413 = require("@appd/uik");
var import_jsx_runtime403 = require("react/jsx-runtime");
var FlowMap = import_uik413.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime403.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Widget.FlowMap",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime403.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M8.666 7c.771 0 1.414.527 1.604 1.239l3.571.255A1.661 1.661 0 0 1 17 9.223c0 .729-.472 1.343-1.125 1.569v1.862a1.661 1.661 0 0 1-.543 3.235c-.6 0-1.121-.32-1.415-.796l-1.937.43a1.661 1.661 0 0 1-3.313-.19c0-.585.303-1.097.759-1.394l-.905-3.62A1.662 1.662 0 0 1 8.666 7Zm5.02 7.034-1.937.43a1.657 1.657 0 0 0-1.27-.782l-.906-3.62c.276-.18.496-.436.627-.742l3.504.25a1.664 1.664 0 0 0 1.088 1.222v1.862a1.657 1.657 0 0 0-1.107 1.38Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime403.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M4.725 3h14.55C20.227 3 21 3.772 21 4.725v14.55c0 .953-.773 1.725-1.725 1.725H4.725A1.725 1.725 0 0 1 3 19.275V4.725C3 3.772 3.772 3 4.725 3ZM19 19H5V5h14v14Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
FlowMap.displayName = "Icon.Widget.FlowMap";

// Icon/Widget/Funnel.tsx
var import_uik414 = require("@appd/uik");
var import_jsx_runtime404 = require("react/jsx-runtime");
var Funnel2 = import_uik414.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime404.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Widget.Funnel",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime404.jsx)(
        "path",
        {
          d: "M17.5 8.234h-11v1.672h11V8.234Zm-9.244 2.93h7.494v1.671H8.256v-1.671Zm5.154 2.916h-2.829v1.672h2.83v-1.671Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime404.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M19.275 3H4.725C3.772 3 3 3.772 3 4.725v14.55C3 20.228 3.772 21 4.725 21h14.55c.952 0 1.725-.772 1.725-1.725V4.725C21 3.772 20.227 3 19.275 3ZM19 19H5V5h14v14Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
Funnel2.displayName = "Icon.Widget.Funnel";

// Icon/Widget/Gauge.tsx
var import_uik415 = require("@appd/uik");
var import_jsx_runtime405 = require("react/jsx-runtime");
var Gauge = import_uik415.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime405.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Widget.Gauge",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime405.jsx)(
        "path",
        {
          d: "m13.977 9.86-2.97 2.372a.499.499 0 0 0-.042.744l.6.6a.499.499 0 0 0 .353.146l.028-.001a.5.5 0 0 0 .363-.188l2.371-2.971a.5.5 0 0 0-.703-.702Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime405.jsx)(
        "path",
        {
          d: "M8.537 7.937c.005-.002.01-.003.014-.006a5.809 5.809 0 0 1 3.51-1.186 5.63 5.63 0 0 1 3.48 1.2 5.707 5.707 0 0 1 2.165 3.831 5.704 5.704 0 0 1-1.178 4.24.746.746 0 0 1-1.052.13.748.748 0 0 1-.129-1.053 4.231 4.231 0 0 0 .871-3.136 4.228 4.228 0 0 0-4.189-3.722c-.908 0-1.811.291-2.56.848a4.3 4.3 0 0 0-.63.58 1.032 1.032 0 0 1-.052.054c-.02.02-.04.04-.059.062a4.257 4.257 0 0 0-.247 5.318.748.748 0 0 1-.604 1.192.747.747 0 0 1-.607-.308c-1.573-2.153-1.421-5.04.187-7.019.003-.004.004-.008.006-.013.002-.005.004-.01.008-.015a.319.319 0 0 1 .031-.032c.01-.01.022-.02.031-.033a5.55 5.55 0 0 1 .985-.923c.006-.005.013-.007.02-.01Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime405.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M5 3h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2Zm0 16h14V5H5v14Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
Gauge.displayName = "Icon.Widget.Gauge";

// Icon/Widget/Graph.tsx
var import_uik416 = require("@appd/uik");
var import_jsx_runtime406 = require("react/jsx-runtime");
var Graph = import_uik416.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime406.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Widget.Graph",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime406.jsx)("path", { d: "M10 13H8v4h2v-4Zm1-6h2v10h-2V7Zm5 4h-2v6h2v-6Z", fill: "#fff", fillOpacity: ".94" }),
      /* @__PURE__ */ (0, import_jsx_runtime406.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M19.275 3H4.725C3.772 3 3 3.772 3 4.725v14.55C3 20.228 3.772 21 4.725 21h14.55c.952 0 1.725-.772 1.725-1.725V4.725C21 3.772 20.227 3 19.275 3ZM19 19H5V5h14v14Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
Graph.displayName = "Icon.Widget.Graph";

// Icon/Widget/HealthList.tsx
var import_uik417 = require("@appd/uik");
var import_jsx_runtime407 = require("react/jsx-runtime");
var HealthList = import_uik417.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime407.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Widget.HealthList",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime407.jsx)(
        "path",
        {
          d: "m8.464 10.296-1.535 2.66H10l-1.536-2.66ZM7.05 7.928a1.433 1.433 0 1 1 2.828-.459 1.433 1.433 0 0 1-2.829.46Zm-.02 9.806h2.868v-2.867H7.03v2.867ZM17.003 6.95h-5.699v1.5h5.7v-1.5Zm-5.699 4.3h5.7v1.5h-5.7v-1.5Zm5.699 4.3h-5.699v1.5h5.7v-1.5Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime407.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M4.725 3h14.55C20.227 3 21 3.772 21 4.725v14.55c0 .953-.773 1.725-1.725 1.725H4.725A1.725 1.725 0 0 1 3 19.275V4.725C3 3.772 3.772 3 4.725 3ZM5 19h14V5H5v14Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
HealthList.displayName = "Icon.Widget.HealthList";

// Icon/Widget/Iframe.tsx
var import_uik418 = require("@appd/uik");
var import_jsx_runtime408 = require("react/jsx-runtime");
var Iframe = import_uik418.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime408.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Widget.Iframe",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime408.jsx)(
        "path",
        {
          d: "M8.932 14.871a.748.748 0 0 0 1.059.052.75.75 0 0 0 .052-1.06L8.355 12l1.688-1.864A.75.75 0 1 0 8.932 9.13l-2.144 2.368a.75.75 0 0 0 0 1.007l2.144 2.367Zm5.734.246a.75.75 0 0 1-.556-1.254L15.8 12l-1.689-1.864a.75.75 0 1 1 1.112-1.007l2.144 2.368a.75.75 0 0 1 0 1.007l-2.144 2.367a.748.748 0 0 1-.556.246Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime408.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M4.725 3h14.55C20.227 3 21 3.772 21 4.725v14.55c0 .953-.773 1.725-1.725 1.725H4.725A1.725 1.725 0 0 1 3 19.275V4.725C3 3.772 3.772 3 4.725 3ZM5 19h14V5H5v14Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
Iframe.displayName = "Icon.Widget.Iframe";

// Icon/Widget/Image.tsx
var import_uik419 = require("@appd/uik");
var import_jsx_runtime409 = require("react/jsx-runtime");
var Image2 = import_uik419.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime409.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Widget.Image",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime409.jsx)(
        "path",
        {
          d: "m10.215 11.975-3.215 5h10l-2.5-3.75-1.785 2.508-2.5-3.758Zm5.785-3a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime409.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M4.5 3h15c.825 0 1.5.675 1.5 1.5v15c0 .825-.675 1.5-1.5 1.5h-15c-.825 0-1.5-.675-1.5-1.5v-15C3 3.675 3.675 3 4.5 3ZM5 19h14V5H5v14Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
Image2.displayName = "Icon.Widget.Image";

// Icon/Widget/List.tsx
var import_uik420 = require("@appd/uik");
var import_jsx_runtime410 = require("react/jsx-runtime");
var List2 = import_uik420.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime410.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Widget.List",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime410.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M4.725 3h14.55C20.227 3 21 3.772 21 4.725v14.55c0 .953-.773 1.725-1.725 1.725H4.725A1.725 1.725 0 0 1 3 19.275V4.725C3 3.772 3.772 3 4.725 3ZM5 19h14V5H5v14Zm2-6h2v-2H7v2Zm2 4H7v-2h2v2ZM7 9h2V7H7v2Zm9.977 4H11v-2h5.977v2ZM11 17h5.977v-2H11v2Zm0-8V7h5.977v2H11Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
List2.displayName = "Icon.Widget.List";

// Icon/Widget/Metric.tsx
var import_uik421 = require("@appd/uik");
var import_jsx_runtime411 = require("react/jsx-runtime");
var Metric = import_uik421.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime411.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Widget.Metric",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime411.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M4.725 3h14.55C20.227 3 21 3.772 21 4.725v14.55c0 .953-.773 1.725-1.725 1.725H4.725A1.725 1.725 0 0 1 3 19.275V4.725C3 3.772 3.772 3 4.725 3ZM5 19h14V5H5v14Zm6.462-8.004-.336 1.653h1.597l.336-1.653h-1.597ZM8.408 9.623v1.373h1.653l-.336 1.653H7.848v1.373h1.597l-.546 2.703h1.4l.547-2.703h1.596l-.56 2.703h1.4l.562-2.703h1.932v-1.373h-1.653l.336-1.653h1.878V9.623H14.74l.546-2.703h-1.401l-.546 2.703h-1.597l.56-2.703h-1.4l-.561 2.703H8.408Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
Metric.displayName = "Icon.Widget.Metric";

// Icon/Widget/Pie.tsx
var import_uik422 = require("@appd/uik");
var import_jsx_runtime412 = require("react/jsx-runtime");
var Pie2 = import_uik422.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime412.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Widget.Pie",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime412.jsx)(
        "path",
        {
          d: "M11.59 7.892a4.506 4.506 0 0 0-4.52 4.519 4.506 4.506 0 0 0 4.52 4.519 4.506 4.506 0 0 0 4.518-4.52H11.59V7.893Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime412.jsx)("path", { d: "M12.411 11.59V7.07a4.506 4.506 0 0 1 4.52 4.52h-4.52Z", fill: "#fff", fillOpacity: ".94" }),
      /* @__PURE__ */ (0, import_jsx_runtime412.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M4.725 3h14.55C20.227 3 21 3.772 21 4.725v14.55c0 .953-.773 1.725-1.725 1.725H4.725A1.725 1.725 0 0 1 3 19.275V4.725C3 3.772 3.772 3 4.725 3ZM5 19h14V5H5v14Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
Pie2.displayName = "Icon.Widget.Pie";

// Icon/Widget/StatusLight.tsx
var import_uik423 = require("@appd/uik");
var import_jsx_runtime413 = require("react/jsx-runtime");
var StatusLight = import_uik423.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime413.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Widget.StatusLight",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime413.jsx)("path", { d: "M8.991 12a3.01 3.01 0 0 1 6.018 0 3.01 3.01 0 0 1-6.018 0Z", fill: "#fff", fillOpacity: ".94" }),
      /* @__PURE__ */ (0, import_jsx_runtime413.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M19.275 3H4.725C3.772 3 3 3.772 3 4.725v14.55C3 20.228 3.772 21 4.725 21h14.55c.952 0 1.725-.772 1.725-1.725V4.725C21 3.772 20.227 3 19.275 3ZM19 19H5V5h14v14Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
StatusLight.displayName = "Icon.Widget.StatusLight";

// Icon/Widget/StreamingGraph.tsx
var import_uik424 = require("@appd/uik");
var import_jsx_runtime414 = require("react/jsx-runtime");
var StreamingGraph = import_uik424.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime414.jsx)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Widget.StreamingGraph",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime414.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M4.725 3h14.55C20.227 3 21 3.772 21 4.725v14.55c0 .953-.773 1.725-1.725 1.725H4.725A1.725 1.725 0 0 1 3 19.275V4.725C3 3.772 3.772 3 4.725 3ZM5 16.59V19h14V5H5v9.469l3.22-3.22a.75.75 0 0 1 1.06 0l1.47 1.47 3.19-3.19h-1.19a.75.75 0 0 1 0-1.5h3a.737.737 0 0 1 .723.552.754.754 0 0 1 .027.251v2.948a.75.75 0 0 1-1.5 0v-1.19l-3.72 3.72a.75.75 0 0 1-1.06 0l-1.47-1.47L5 16.59Z",
        fill: "#fff",
        fillOpacity: ".94",
        fillRule: "evenodd"
      }
    )
  }
));
StreamingGraph.displayName = "Icon.Widget.StreamingGraph";

// Icon/Widget/Text.tsx
var import_uik425 = require("@appd/uik");
var import_jsx_runtime415 = require("react/jsx-runtime");
var Text2 = import_uik425.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime415.jsxs)(
  "svg",
  {
    ...withSize(props2),
    fill: "none",
    ref,
    uik: "Icon.Widget.Text",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime415.jsx)(
        "path",
        {
          d: "M11.016 15.095H9.534v1.43h4.732v-1.43h-1.469v-6.24h1.235v1.573h1.43V7.425H8.338v3.003h1.43V8.855h1.248v6.24Z",
          fill: "#fff",
          fillOpacity: ".94"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime415.jsx)(
        "path",
        {
          clipRule: "evenodd",
          d: "M19.5 3h-15C3.675 3 3 3.675 3 4.5v15c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5v-15c0-.825-.675-1.5-1.5-1.5ZM19 19H5V5h14v14Z",
          fill: "#fff",
          fillOpacity: ".94",
          fillRule: "evenodd"
        }
      )
    ]
  }
));
Text2.displayName = "Icon.Widget.Text";

// Icon/Icon.tsx
var import_jsx_runtime416 = require("react/jsx-runtime");
var Icon = Object.assign(
  import_uik426.utils.forwardRef(({ fallback = "Status.Unknown", type, ...props2 }, ref) => {
    const [category, name] = String(type).split(".");
    const [fallbackCategory, fallbackName] = String(fallback).split(".");
    const Component = import_uik426.utils.maybeGet(import_uik426.utils.maybeGet(Icon, category), name) ?? import_uik426.utils.maybeGet(import_uik426.utils.maybeGet(Icon, fallbackCategory), fallbackName) ?? Icon.Status.Unknown;
    if (import_uik426.utils.IS_DEV_MODE && !Component.displayName?.includes(String(type))) {
      console.warn(
        Component.displayName?.includes(String(fallback)) ? `(UIK) <Icon type={${JSON.stringify(type)}}> not found. Using <Icon fallback={${JSON.stringify(
          fallback
        )}}> instead.` : `(UIK) <Icon type={${JSON.stringify(type)}}> and <Icon fallback={${JSON.stringify(
          fallback
        )}}> not found. Using <Icon.Status.Unknown> instead.`
      );
    }
    return /* @__PURE__ */ (0, import_jsx_runtime416.jsx)(Component, { ...props2, ref });
  }),
  {
    Action: Action_exports,
    AgentType: AgentType_exports,
    Apps: Apps_exports,
    Browser: Browser_exports,
    ChartType: ChartType_exports,
    DataType: DataType_exports,
    Health: Health_exports,
    Language: Language_exports,
    Location: Location_exports,
    Navigation: Navigation_exports,
    Object: Object_exports,
    Os: Os_exports,
    Status: Status_exports,
    Widget: Widget_exports
  }
);
Icon.displayName = "Icon";
Icon.__DEV_METADATA__ = { status: "IN_PROGRESS" };

// format/$number/by/by.tsx
var import_uik428 = require("@appd/uik");

// format/intl.ts
var import_uik427 = require("@appd/uik");
var import_intl = require("@formatjs/intl");
var cache2 = (0, import_intl.createIntlCache)();
var intl = import_uik427.utils.mutable(
  (0, import_intl.createIntl)({ locale: "en-US" }, cache2),
  (locale) => (0, import_intl.createIntl)({ locale }, cache2)
);

// format/toNumberOrNull.tsx
var toNumberOrNull = /* @__PURE__ */ __name((value) => (typeof value === "number" || typeof value === "string") && isFinite(value) ? Number(value) : null, "toNumberOrNull");

// format/$number/by/by.tsx
var by = /* @__PURE__ */ __name((type) => (rawValue, rawOptions) => {
  const value = toNumberOrNull(rawValue);
  if (value === null) {
    return "--";
  }
  const CASES2 = {
    // TODO - internationalize this
    BIT_RATE_OR_BYTES_BINARY: (index = Math.floor(Math.log(import_uik428.utils.clamp(value, [1])) / Math.log(BYTES_PER_KB_BINARY))) => ({
      finalValue: value / BYTES_PER_KB_BINARY ** index,
      // If `value` is greater than the the greatest `BYTES` bucket, use scientific notation ("1E19").
      ...!(index in BYTES_BINARY_UNITS) && { notation: "scientific" }
    }),
    BIT_RATE_OR_BYTES_DECIMAL: (index = Math.floor(Math.log(import_uik428.utils.clamp(value, [1])) / Math.log(BYTES_PER_KB_DECIMAL)), unit2 = `${BYTES_DECIMAL[index] ?? BYTES_DECIMAL[BYTES_DECIMAL.length - 1]}${type === "BIT_RATE_DECIMAL" ? (
      // https://tc39.es/proposal-unified-intl-numberformat/section6/locales-currencies-tz_proposed_out.html#sec-iswellformedunitidentifier
      "-per-second"
    ) : ""}`) => ({
      finalValue: value / BYTES_PER_KB_DECIMAL ** index,
      // If `value` is greater than the the greatest `BYTES` bucket, use scientific notation ("1E19").
      ...!(index in BYTES_DECIMAL) && { notation: "scientific" },
      style: "unit",
      unit: unit2
    }),
    LONG: () => value === 0 || Math.abs(value) >= 1e-4 ? { style: "decimal" } : { notation: "scientific" },
    PERCENT: () => ({
      finalValue: value,
      maximumFractionDigits: import_uik428.utils.clamp(rawOptions?.maximumFractionDigits ?? 1, [0, 4]),
      style: "percent"
    }),
    SHORT: () => ({ notation: "compact" })
  };
  const { finalValue, ...options } = {
    finalValue: value,
    maximumFractionDigits: import_uik428.utils.clamp(rawOptions?.maximumFractionDigits ?? 2, [0, 4]),
    minimumFractionDigits: import_uik428.utils.clamp(rawOptions?.minimumFractionDigits ?? 0, [0, 4]),
    minimumIntegerDigits: 1,
    notation: "standard",
    ...CASES2[type === "BIT_RATE_BINARY" || type === "BYTES_BINARY" ? "BIT_RATE_OR_BYTES_BINARY" : type === "BIT_RATE_DECIMAL" || type === "BYTES_DECIMAL" ? "BIT_RATE_OR_BYTES_DECIMAL" : type]()
  };
  const binaryUnits = BYTES_BINARY_UNITS[Math.floor(Math.log(import_uik428.utils.clamp(value, [1])) / Math.log(BYTES_PER_KB_BINARY))] ?? BYTES_BINARY_UNITS[BYTES_BINARY_UNITS.length - 1];
  return `${intl().formatNumber(finalValue, options)}${type === "BYTES_BINARY" || type === "BIT_RATE_BINARY" ? ` ${binaryUnits}` : ""}${type === "BIT_RATE_BINARY" ? "/s" : ""}`;
}, "by");
var BYTES_DECIMAL = [
  "byte",
  "kilobyte",
  "megabyte",
  "gigabyte",
  "terabyte",
  "petabyte"
  // "exabyte" not supported, but was in ui-kit-levitate.
];
var BYTES_BINARY_UNITS = ["byte", "kiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
var BYTES_PER_KB_BINARY = 1024;
var BYTES_PER_KB_DECIMAL = 1e3;

// format/$number/$number.ts
var $number = Object.assign(by("LONG"), {
  bitRateBinary: by("BIT_RATE_BINARY"),
  bitRateDecimal: by("BIT_RATE_DECIMAL"),
  bytesBinary: by("BYTES_BINARY"),
  bytesDecimal: by("BYTES_DECIMAL"),
  long: by("LONG"),
  percent: by("PERCENT"),
  short: by("SHORT")
});

// format/currency.ts
var currency = /* @__PURE__ */ __name((rawValue, { currency: currency2 = "USD", maximumFractionDigits = 2 } = {}) => {
  const value = toNumberOrNull(rawValue);
  if (value === null) {
    return "--";
  }
  return intl().formatNumber(value, {
    currency: currency2,
    maximumFractionDigits,
    style: "currency"
  });
}, "currency");

// format/byOptions/byOptions.ts
var import_uik442 = require("@appd/uik");
var import_luxon = require("luxon");

// format/getTimeOptions.ts
var getTimeOptions = /* @__PURE__ */ __name((twentyFourHour, seconds) => ({
  hour: "numeric",
  minute: "2-digit",
  second: seconds ? "2-digit" : void 0,
  ...twentyFourHour ? { hourCycle: "h23" } : { hour12: true }
}), "getTimeOptions");

// format/byOptions/getDateTimeOptions.ts
var getDateTimeOptions = /* @__PURE__ */ __name((type, rawOptions) => {
  const { day, fractionalSecondDigits, month, seconds, timeZoneName, twentyFourHour, weekday, year } = rawOptions ?? {};
  const cases = {
    DATE: () => ({
      day,
      month,
      timeZoneName,
      weekday,
      year
    }),
    DATE_TIME: () => ({
      ...cases.DATE(),
      ...cases.TIME()
    }),
    TIME: () => ({
      fractionalSecondDigits,
      timeZoneName,
      ...getTimeOptions(twentyFourHour, seconds)
    })
  };
  return rawOptions == null ? DEFAULT[type] : cases[type]();
}, "getDateTimeOptions");
var DEFAULT;
((DEFAULT3) => {
  DEFAULT3.DATE = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric"
  };
  DEFAULT3.TIME = {
    hour: "numeric",
    hour12: true,
    hourCycle: "h23",
    minute: "2-digit",
    second: void 0
  };
  DEFAULT3.DATE_TIME = {
    ...DEFAULT3.DATE,
    ...DEFAULT3.TIME
  };
})(DEFAULT || (DEFAULT = {}));

// format/LOCALE.ts
var import_uik440 = require("@appd/uik");

// format/message/message.ts
var import_uik439 = require("@appd/uik");

// format/message/fromJson/fromJson.ts
var import_uik429 = require("@appd/uik");

// format/message/fromJson/escape.ts
var escape = /* @__PURE__ */ __name((message2) => message2.replaceAll(
  /((^|[^{])(?:[{][{])+|(?:[}][}])+($|[^}]))/g,
  (_, brace, left = "", right = "") => (
    // Surely no one will use these weird symbols ⎨ and ⎬.
    `${left}${{
      "{": "\u23A8",
      "}": "\u23AC"
    }[brace[1]].repeat(brace.length / 2)}${right}`
  )
), "escape");

// format/message/fromJson/unescape.ts
var unescape = /* @__PURE__ */ __name((message2) => message2.replaceAll(
  /[⎨⎬]/g,
  (x) => ({
    "\u23A8": "{{",
    "\u23AC": "}}"
  })[x]
), "unescape");

// format/message/fromJson/fromJson.ts
var fromJson = /* @__PURE__ */ __name((m, { message: message2, placeholders = {} } = m, escaped = escape(message2)) => ({
  parts: escaped.split(/\{\d+\}/g).map(
    (part) => part.replaceAll(
      /[⎨⎬]/g,
      (x) => ({
        "\u23A8": "{",
        "\u23AC": "}"
      })[x]
    )
  ),
  placeholders: [...escaped.matchAll(/\{\d+\}/g)].map(
    (placeholder) => import_uik429.utils.ASSERT.get(placeholders, placeholder[0]).else(
      Error(
        // This error can only happen if there was a placeholder that was not a key in the translated message's
        // `placeholders` field.
        //
        // Example:
        // ```json
        // {
        //   "message": "Hello, {10}!",
        //   "placeholders": {}
        // }
        // ```
        //
        // but there is no `{10}` key in `placeholders`.
        `

[#2] Invalid placeholder (${placeholder}) encountered for JSON message: ${JSON.stringify(m)}

`
      )
    )
  )
}), "fromJson");
fromJson.escape = escape;
fromJson.unescape = unescape;

// format/message/getRenderer/getRenderer.ts
var import_uik431 = require("@appd/uik");

// format/message/getRenderer/warnOutOfBounds.ts
var import_uik430 = require("@appd/uik");
var warnOutOfBounds = /* @__PURE__ */ __name((warning) => (import_uik430.utils.IS_DEV_MODE && console.warn(warning), ""), "warnOutOfBounds");

// format/message/getRenderer/getRenderer.ts
var getRenderer = /* @__PURE__ */ __name(({ debug: debug2, parts, placeholders }) => (...args) => placeholders.reduce(
  (result, placeholder, i) => result + (typeof placeholder === "object" ? (
    // Array or Object placeholder.
    import_uik431.utils.maybeGet(placeholder, args[i]) ?? // Out of bounds. Default to...
    (placeholder instanceof Array ? (
      // Last element if Array placeholder.
      placeholder[placeholder.length - 1] ?? warnOutOfBounds(`Placeholder array is empty, defaulting to an empty string.`)
    ) : (
      // "*" option if Object placeholder.
      placeholder["*"] ?? // Warn that an invalid key was used for an Object placeholder with no "*".
      warnOutOfBounds(
        `${args[i]} is not a key of ${JSON.stringify(
          placeholder
        )}, and no default option ("*") was defined.`
      )
    ))
  ) : (
    // String placeholder. (Replaced by `.replaceAll` for $-index pattern below...)
    placeholder
  )) + parts[i + 1],
  parts[0]
).replaceAll(
  /((?:[$][$])*)[$](\d+)\b/g,
  debug2 ? (_, left) => `${left}\u2B50\uFE0F` : (_, left, index) => `${left}${String(args[+index]) ?? warnOutOfBounds(`$${+index} is greater than the index of the last argument (${args.length - 1}).`)}`
).replaceAll(/[$][$]/g, "$"), "getRenderer");

// format/message/hydrate/hydrate.ts
var import_uik432 = require("@appd/uik");

// format/message/hydrate/Element.tsx
var import_jsx_runtime417 = require("react/jsx-runtime");
var Element2 = /* @__PURE__ */ __name(({ messages }) => /* @__PURE__ */ (0, import_jsx_runtime417.jsx)(
  "script",
  {
    dangerouslySetInnerHTML: { __html: JSON.stringify(messages) },
    type: "application/json",
    uik: "format.message.hydrate.Element"
  }
), "Element");
Element2.SELECTOR = "[uik='format.message.hydrate.Element']";

// format/message/store.ts
var import_md5 = __toESM(require("md5"));
var store = {
  add: (locale, hash, message2) => (store.data.get(locale) ?? store.data.set(locale, /* @__PURE__ */ new Map()).get(locale)).set(hash, message2),
  data: /* @__PURE__ */ new Map(),
  getHash: ({ description, message: message2, placeholders }) => (0, import_md5.default)(
    JSON.stringify({
      description,
      message: message2,
      placeholders
    })
  ).slice(0, 8),
  lookup: (hash, locale = format.LOCALE()) => store.data.get(locale)?.get(hash) ?? null,
  lookupAll: (locale = format.LOCALE()) => store.data.get(locale) ?? /* @__PURE__ */ new Map()
};

// format/message/hydrate/hydrate.ts
var hydrate2 = /* @__PURE__ */ __name((locale) => {
  if (import_uik432.utils.CAN_USE_DOM) {
    const messages = JSON.parse(document.querySelector(Element2.SELECTOR)?.textContent || "{}");
    Object.entries(messages).forEach(([hash, message2]) => store.add(locale, hash, message2));
  }
}, "hydrate");
hydrate2.Element = Element2;

// format/message/toJson.ts
var toJson3 = /* @__PURE__ */ __name((parts, placeholders, description = "") => ({
  message: parts.map((part) => part.replaceAll(/([{}])/g, (_, brace) => brace + brace)).reduce(
    (message2, part, i) => `${message2}{${i - 1}}${part}`
    /* No initial value needed because `parts` is definitely non-empty. */
  ),
  ...placeholders?.length && {
    // (object-curly-newline)
    placeholders: Object.fromEntries(placeholders.map((placeholder, i) => [`{${i}}`, placeholder]))
  },
  description
}), "toJson");

// format/message/withSsr/withSsr.tsx
var import_uik438 = require("@appd/uik");

// format/message/withSsr/extractJson/extractJson.ts
var import_server_only7 = require("@appd/uik/@server-only");

// format/message/withSsr/extractJson/getDebug/getDebug.ts
var import_uik433 = require("@appd/uik");

// format/message/withSsr/extractJson/getDebug/toEmoji.ts
var toEmoji = /* @__PURE__ */ __name((x) => fromJson.unescape(
  fromJson.escape(x).replaceAll(/(\$\d+|\{\d+\}|\w)/g, (_, x2) => x2.match(/\$\d+|\{\d+\}/) ? x2 : "\u{1F30E}")
), "toEmoji");

// format/message/withSsr/extractJson/getDebug/getDebug.ts
var getDebug = /* @__PURE__ */ __name((combined) => import_uik433.utils.transform(combined).by(
  (entries) => entries.map(
    ([hash, { description, message: message2, ...maybe }]) => [
      hash,
      {
        message: toEmoji(message2),
        ...maybe.placeholders && {
          placeholders: import_uik433.utils.transform(maybe.placeholders).by(
            (entries2) => entries2.map(
              ([key, value]) => [
                key,
                typeof value === "string" ? value : value instanceof Array ? value.map(toEmoji) : import_uik433.utils.transform(value).by((entries3) => entries3.map(([k, v]) => [k, toEmoji(v)]))
              ]
            )
          )
        },
        description
      }
    ]
  )
), "getDebug");

// format/message/withSsr/extractJson/readExisting.ts
var import_server_only = require("@appd/uik/@server-only");
var readExisting = /* @__PURE__ */ __name(async (outputPath) => JSON.parse(await (0, import_server_only.readFile)(outputPath, "utf-8").catch(() => {
}) || "{}"), "readExisting");

// format/message/withSsr/extractJson/report.ts
var report = /* @__PURE__ */ __name(({ debugPath, newEntries, outputPath, page }) => console.log(
  [
    "",
    "",
    `${BRIGHT + BLACK}\u{1F30E} ${newEntries.length} new messages extracted from ${RESET + CYAN}${page}${RESET}`,
    ...newEntries.reduce(
      (rows, hash) => (rows.at(-1)?.length === 8 ? rows.push([hash]) : rows.at(-1)?.push(hash), rows),
      [[]]
    ).map(
      (row, i, { length }) => `   ${YELLOW + DIM + row.join(`${WHITE}, ${YELLOW}`)}${i < length - 1 ? `${WHITE},` : ""}${RESET}`
    ),
    [outputPath, debugPath].map((x) => `${BLUE}   \u{1F449} ${x}${RESET}`).join("\n"),
    ""
  ].join("\n")
), "report");
var { BLACK, BLUE, BRIGHT, CYAN, DIM, RESET, WHITE, YELLOW } = {
  BLACK: "\x1B[30m",
  BLUE: "\x1B[34m",
  BRIGHT: "\x1B[1m",
  CYAN: "\x1B[36m",
  DIM: "\x1B[2m",
  RESET: "\x1B[0m",
  WHITE: "\x1B[37m",
  YELLOW: "\x1B[33m"
};

// format/message/withSsr/extractJson/write.ts
var import_uik434 = require("@appd/uik");
var import_server_only2 = require("@appd/uik/@server-only");
var write = /* @__PURE__ */ __name((path, output) => (0, import_server_only2.writeFile)(
  path,
  (0, import_server_only2.format)(
    // Manually stringify to ensure alphabetically ordered hashes.
    `{
  ${Object.entries(output).sort(([a], [b]) => import_uik434.utils.byLessThan(a, b)).map(([hash, message2]) => `  "${hash}": ${JSON.stringify(message2, null, 2)}`).join(",")}
}`,
    {
      ...PRETTIERRC,
      parser: "json",
      plugins: [import_server_only2.parser]
    }
  )
), "write");
var PRETTIERRC = {
  arrowParens: "always",
  bracketSameLine: false,
  bracketSpacing: true,
  endOfLine: "lf",
  htmlWhitespaceSensitivity: "strict",
  jsxSingleQuote: false,
  printWidth: 120,
  proseWrap: "preserve",
  quoteProps: "as-needed",
  semi: true,
  singleQuote: false,
  tabWidth: 2,
  trailingComma: "es5",
  useTabs: false
};

// format/message/withSsr/lock/lock.ts
var import_server_only6 = require("@appd/uik/@server-only");

// format/message/withSsr/lock/acquired/acquired.ts
var import_uik435 = require("@appd/uik");
var import_server_only4 = require("@appd/uik/@server-only");

// format/message/withSsr/lock/acquired/refresh.ts
var import_server_only3 = require("@appd/uik/@server-only");
var refresh = /* @__PURE__ */ __name((path) => {
  const nowSeconds = Date.now() / 1e3;
  return (0, import_server_only3.utimes)(path, nowSeconds, nowSeconds);
}, "refresh");

// format/message/withSsr/lock/acquired/acquired.ts
var acquired = /* @__PURE__ */ __name((path, period) => {
  const interval = setInterval(() => refresh(path), period);
  return async () => {
    clearInterval(interval);
    await (0, import_server_only4.rm)(path, { recursive: true });
    await import_uik435.utils.sleep(Math.random() * period);
  };
}, "acquired");

// format/message/withSsr/lock/exists/exists.ts
var import_server_only5 = require("@appd/uik/@server-only");

// format/message/withSsr/lock/exists/retry.ts
var import_uik436 = require("@appd/uik");
var retry = /* @__PURE__ */ __name(async (path, period) => {
  await import_uik436.utils.sleep(import_uik436.utils.mix(period, 2 * period, Math.random()));
  return lock(path, period);
}, "retry");

// format/message/withSsr/lock/exists/exists.ts
var exists = /* @__PURE__ */ __name(async (lockPath, path, period) => {
  let lastUpdated;
  try {
    ({ mtimeMs: lastUpdated } = await (0, import_server_only5.stat)(lockPath));
  } catch {
    return retry(path, period);
  }
  const fresh = Date.now() < lastUpdated + 10 * period;
  const valid = Date.now() > /* Ensure */
  lastUpdated - 2 * period;
  if (fresh && valid) {
    return retry(path, period);
  } else {
    const nestedPath = (0, import_server_only5.resolve)(lockPath, ".lock");
    const hasNested = await (0, import_server_only5.access)(nestedPath).then(
      () => true,
      () => false
    );
    if (hasNested) {
      return exists(nestedPath, path, period);
    } else {
      try {
        await (0, import_server_only5.mkdir)(nestedPath);
      } catch {
        return retry(path, period);
      }
      return acquired(lockPath, period);
    }
  }
}, "exists");

// format/message/withSsr/lock/lock.ts
var lock = /* @__PURE__ */ __name(async (path, period = 100) => {
  const [file, dir] = [(0, import_server_only6.basename)(path), (0, import_server_only6.dirname)(path)];
  const lockPath = (0, import_server_only6.resolve)(dir, `.${file}.lock`);
  try {
    await (0, import_server_only6.mkdir)(lockPath);
  } catch {
    return exists(lockPath, path, period);
  }
  return acquired(lockPath, period);
}, "lock");

// format/message/withSsr/extractJson/extractJson.ts
var extractJson = /* @__PURE__ */ __name(async (outDir, page) => {
  await (0, import_server_only7.mkdir)(outDir, { recursive: true });
  const outputPath = (0, import_server_only7.resolve)(outDir, "en-US.json");
  const debugPath = (0, import_server_only7.resolve)(outDir, "en-DEBUG.json");
  const release = await lock(outDir);
  try {
    const existing = await readExisting(outputPath);
    const latest = Object.fromEntries([...store.lookupAll("en-US")]);
    const newEntries = Object.keys(latest).filter((hash) => !(hash in existing)).sort();
    if (newEntries.length) {
      report({
        debugPath,
        newEntries,
        outputPath,
        page
      });
      const combined = {
        ...existing,
        ...latest
      };
      await Promise.all([write(debugPath, getDebug(combined)), write(outputPath, combined)]);
    }
  } finally {
    await release();
  }
}, "extractJson");

// format/message/withSsr/readToStore.ts
var import_server_only8 = require("@appd/uik/@server-only");
var readToStore = /* @__PURE__ */ __name(async (locale, outDir) => {
  const inputPath = (0, import_server_only8.resolve)(outDir, `${locale}.json`);
  const release = await lock(outDir);
  const messages = JSON.parse(
    await (0, import_server_only8.readFile)(inputPath, "utf-8").catch(() => {
    }).finally(release) || "{}"
  );
  Object.entries(messages).forEach(
    ([hash, { description, message: message2, pages: _, ...placeholders }]) => store.add(locale, hash, {
      message: message2,
      ...placeholders,
      description
    })
  );
}, "readToStore");

// format/message/withSsr/renderStatic.tsx
var import_uik437 = require("@appd/uik");
var import_jsx_runtime418 = require("react/jsx-runtime");
var renderStatic = /* @__PURE__ */ __name((locale) => {
  const usedHashes = [...store.lookupAll("en-US").keys()];
  const usedMessages = Object.fromEntries(
    usedHashes.map(
      (hash) => [
        hash,
        import_uik437.utils.ASSERT(store.lookup(hash, locale)).else(
          // This error happens alongside [#3]. Try rerunning `yarn build`.
          Error(`[#4] A translation was missing for message '${hash}' in ${locale}.json during prerendering.`)
        )
      ]
    )
  );
  return /* @__PURE__ */ (0, import_jsx_runtime418.jsx)(hydrate2.Element, { messages: usedMessages });
}, "renderStatic");

// format/message/withSsr/withSsr.tsx
var withSsr2 = /* @__PURE__ */ __name(async (renderPage, { dynamicImports = [], locale = "en-US", outDir, page }) => {
  import_uik438.utils.ASSERT(!import_uik438.utils.CAN_USE_DOM).else(Error("[#1] `format.message.withSsr` should only be called from node, never from the browser."));
  if (locale !== "en-US") {
    await readToStore(locale, outDir);
  }
  const result = await renderPage();
  await Promise.all(dynamicImports);
  if (locale === "en-US" && !page.startsWith("/_next/") && !page.endsWith(".webpack.hot-update.json")) {
    await extractJson(outDir, page);
  }
  return {
    ...result,
    // Render the actually used messages to the static HTML for hydration at runtime.
    ...locale !== "en-US" && { head: [...result.head ?? [], renderStatic(locale)] }
  };
}, "withSsr");

// format/message/message.ts
var message = /* @__PURE__ */ __name((parts, ...placeholders) => ({
  description(description) {
    let renderer;
    const englishMessage = toJson3(parts, placeholders, description);
    const hash = store.getHash(englishMessage);
    const setRenderer = /* @__PURE__ */ __name((locale = format.LOCALE()) => renderer = locale === "en-US" ? getRenderer({
      parts,
      placeholders
    }) : getRenderer({
      debug: locale === "en-DEBUG",
      ...fromJson(
        import_uik439.utils.ASSERT(store.lookup(hash, locale)).else(
          Error(
            // This error happens if the locale file (e.g. `jp.JSON`) is missing a translation for this hash.
            //
            // Alternatively, the locale file was not loaded correctly.
            // Since locale files are loaded by "hydration" via a DOM node set at build time, this second case
            // case can only happen if "hydration" failed, or if the build was misconfigured.
            //
            // Perhaps `format.message.withSsr()` was not called correctly?
            `[#3] A ${locale} translation for message '${hash}' was not found. (${JSON.stringify(
              englishMessage
            )})`
          )
        )
      )
    }), "setRenderer");
    store.add("en-US", hash, englishMessage);
    format.LOCALE.subscribe(setRenderer);
    setRenderer();
    return (...args) => renderer(...args);
  }
}), "message");
message.fromJson = fromJson;
message.getRenderer = getRenderer;
message.hydrate = hydrate2;
message.store = store;
message.withSsr = withSsr2;

// format/LOCALE.ts
var LOCALE = import_uik440.utils.mutable("en-US", (locale) => {
  intl.set(locale);
  message.hydrate(locale);
  return locale;
});

// format/TIME_ZONE.ts
var import_uik441 = require("@appd/uik");
var TIME_ZONE = import_uik441.utils.mutable(Intl.DateTimeFormat().resolvedOptions().timeZone);

// format/byOptions/byOptions.ts
var byOptions = /* @__PURE__ */ __name((type) => (isoOrTimestamp, rawOptions) => {
  const maybe = (typeof isoOrTimestamp === "number" ? import_luxon.DateTime.fromMillis(isoOrTimestamp, {
    locale: LOCALE(),
    zone: TIME_ZONE()
  }) : import_luxon.DateTime.fromISO(isoOrTimestamp, {
    locale: LOCALE(),
    zone: TIME_ZONE()
  })).toLocaleString(getDateTimeOptions(type, rawOptions), { locale: LOCALE() });
  if (maybe === "Invalid DateTime") {
    import_uik442.utils.IS_DEV_MODE && console.warn(`[uik] [dev warning] Invalid DateTime received: ${isoOrTimestamp}`);
    return "?";
  } else {
    return maybe;
  }
}, "byOptions");

// format/byPreset.ts
var import_luxon2 = require("luxon");
var byPreset = /* @__PURE__ */ __name((kind) => (isoOrTimestamp) => (
  // TODO This could be unified with the `DateTime` call in `byOptions`. Duplication is hazardous.
  (typeof isoOrTimestamp === "number" ? import_luxon2.DateTime.fromMillis(isoOrTimestamp, {
    locale: LOCALE(),
    zone: TIME_ZONE()
  }) : import_luxon2.DateTime.fromISO(isoOrTimestamp, {
    locale: LOCALE(),
    zone: TIME_ZONE()
  })).toLocaleString(PRESET[kind], { locale: LOCALE() })
), "byPreset");
var PRESET;
((PRESET2) => {
  PRESET2.DATE_LONG = {
    day: "2-digit",
    month: "long",
    year: "numeric"
  };
  PRESET2.DATE_LONG_WITH_WEEKDAY = {
    ...PRESET2.DATE_LONG,
    weekday: "long"
  };
  PRESET2.DATE_SHORT = {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit"
  };
  PRESET2.DATE_SHORT_WITH_FULL_YEAR = {
    ...PRESET2.DATE_SHORT,
    year: "numeric"
  };
  PRESET2.TIME_LONG_12 = getTimeOptions(false, true);
  PRESET2.TIME_LONG_24 = getTimeOptions(true, true);
  PRESET2.TIME_SHORT_12 = getTimeOptions(false, false);
  PRESET2.TIME_SHORT_24 = getTimeOptions(true, false);
  PRESET2.DATE_TIME_LONG = {
    ...PRESET2.DATE_LONG,
    ...PRESET2.TIME_SHORT_12
  };
  PRESET2.DATE_TIME_LONG_WITH_WEEKDAY = {
    ...PRESET2.DATE_LONG_WITH_WEEKDAY,
    ...PRESET2.TIME_SHORT_12
  };
  PRESET2.DATE_TIME_SHORT = {
    ...PRESET2.DATE_SHORT,
    ...PRESET2.TIME_SHORT_12
  };
  PRESET2.DATE_TIME_SHORT_WITH_FULL_YEAR = {
    ...PRESET2.DATE_SHORT,
    ...PRESET2.TIME_SHORT_12
  };
})(PRESET || (PRESET = {}));

// format/date.ts
var date = Object.assign(byOptions("DATE"), {
  long: byPreset("DATE_LONG"),
  longWithWeekday: byPreset("DATE_LONG_WITH_WEEKDAY"),
  short: byPreset("DATE_SHORT"),
  shortWithFullYear: byPreset("DATE_SHORT_WITH_FULL_YEAR")
});

// format/dateTime.ts
var dateTime = Object.assign(byOptions("DATE_TIME"), {
  long: byPreset("DATE_TIME_LONG"),
  longWithWeekday: byPreset("DATE_TIME_LONG_WITH_WEEKDAY"),
  short: byPreset("DATE_TIME_SHORT"),
  shortWithFullYear: byPreset("DATE_TIME_SHORT_WITH_FULL_YEAR")
});

// format/duration.ts
var import_uik443 = require("@appd/uik");
var import_luxon3 = require("luxon");
var duration = /* @__PURE__ */ __name((isoOrMillis, { days, hours, maximumFractionDigits = 0, milliseconds, minutes, seconds, unitDisplay = "narrow", weeks } = {}) => {
  if (typeof isoOrMillis === "number" && isNaN(isoOrMillis)) {
    import_uik443.utils.IS_DEV_MODE && console.warn(`[uik] [dev warning] Invalid duration received: ${isoOrMillis}`);
    return "?";
  }
  const duration2 = (typeof isoOrMillis === "number" ? import_luxon3.Duration.fromMillis(isoOrMillis) : import_luxon3.Duration.fromISO(isoOrMillis)).shiftTo("weeks", "days", "hours", "minutes", "seconds", "milliseconds");
  const maybeUnits = [
    (weeks ?? duration2.weeks) && "weeks",
    (days ?? duration2.days) && "days",
    (hours ?? duration2.hours) && "hours",
    (minutes ?? duration2.minutes) && "minutes",
    (seconds ?? duration2.seconds) && "seconds",
    // only show ms if specified
    milliseconds && "milliseconds"
  ].filter(import_uik443.utils.Boolean);
  const units = maybeUnits.length ? maybeUnits : (
    // If no `maybeUnits` is empty, default to seconds.
    ["seconds"]
  );
  return duration2.shiftTo(...units).toHuman({
    maximumFractionDigits,
    unitDisplay
  });
}, "duration");
duration.withSeconds = (isoOrMillis, options) => duration(isoOrMillis, {
  seconds: true,
  ...options
});

// format/time.ts
var time = Object.assign(byOptions("TIME"), {
  long12: byPreset("TIME_LONG_12"),
  long24: byPreset("TIME_LONG_24"),
  short12: byPreset("TIME_SHORT_12"),
  short24: byPreset("TIME_SHORT_24")
});

// format/format.ts
var format = {
  LOCALE,
  TIME_ZONE,
  currency,
  date,
  dateTime,
  duration,
  message,
  number: $number,
  time
};

// Banner/Banner.tsx
var import_uik445 = require("@appd/uik");
var import_react6 = require("react");

// Banner/getStyles.ts
var import_uik444 = require("@appd/uik");
var {
  COLORS: {
    DEFAULT_TEXT,
    DEFAULT_TEXT_STRONG,
    INFO_BG_STRONG,
    INFO_BG_WEAK,
    INFO_BORDER,
    NEGATIVE_BG_STRONG,
    NEGATIVE_BORDER,
    POSITIVE_BG_STRONG,
    POSITIVE_BORDER,
    WARNING_BG_STRONG,
    WARNING_BORDER
  },
  EFFECTS: { SHAODW_LIFTED },
  RADIUS,
  SPACING,
  TYPOGRAPHY: { ELLIPSES, P3_BOLD, P3_DEFAULT }
} = import_uik444.MAGNETIC_TOKENS;
var BACKGROUND_COLOR = {
  ERROR: NEGATIVE_BG_STRONG,
  INFO: INFO_BG_STRONG,
  SUCCESS: POSITIVE_BG_STRONG,
  WARNING: WARNING_BG_STRONG
};
var getStyles2 = /* @__PURE__ */ __name((props2) => ({
  CLOSE: (0, import_uik444.css)({
    ":hover": { backgroundColor: "transparent" },
    ...props2.inline ? {
      marginBottom: "auto",
      marginTop: "auto"
    } : { marginTop: SPACING[3] },
    backgroundColor: "transparent",
    marginRight: 6,
    minWidth: 24
  }),
  DESCRIPTION: (0, import_uik444.css)({
    color: DEFAULT_TEXT,
    display: "flex",
    flexDirection: "column",
    font: P3_DEFAULT,
    marginBottom: SPACING[4],
    marginLeft: 9,
    marginTop: SPACING[4],
    textAlign: "left",
    width: "100%"
  }),
  HOST: (0, import_uik444.css)({
    ...props2.inline ? {
      background: props2.type && BACKGROUND_COLOR[props2.type],
      minHeight: 48,
      overflow: "hidden"
    } : {
      backgroundColor: INFO_BG_WEAK,
      borderLeft: `6px solid ${props2.type ? {
        ERROR: NEGATIVE_BORDER,
        INFO: INFO_BORDER,
        SUCCESS: POSITIVE_BORDER,
        WARNING: WARNING_BORDER
      }[props2.type] ?? INFO_BORDER : INFO_BORDER}`,
      boxShadow: SHAODW_LIFTED,
      paddingBlock: SPACING[1],
      paddingLeft: SPACING[5],
      paddingRight: SPACING[2]
    },
    border: "none",
    borderRadius: RADIUS.DEFAULT,
    boxSizing: "border-box",
    display: "flex",
    overflow: "hidden"
  }),
  ICON: (0, import_uik444.css)({
    ...props2.inline ? { marginLeft: SPACING[3] } : { marginRight: SPACING[3] },
    marginTop: 14
  }),
  NONE: (0, import_uik444.css)({ display: "none" }),
  TITLE: (0, import_uik444.css)({
    ...ELLIPSES.END,
    color: DEFAULT_TEXT_STRONG,
    font: P3_BOLD,
    marginBottom: 4,
    textAlign: "left",
    width: "100%"
  })
}), "getStyles");

// Banner/Banner.tsx
var import_jsx_runtime419 = require("react/jsx-runtime");
var ICONS = {
  ERROR: "Health.Critical",
  INFO: "Health.InfoMessage",
  SUCCESS: "Health.Normal",
  WARNING: "Health.Warning"
};
var Banner = import_uik445.utils.forwardRef(
  ({ children = null, className: className2, type, icon = type ? ICONS[type] : null, inline = true, onClose, title, ...props2 }, ref) => {
    const { CLOSE: CLOSE3, DESCRIPTION: DESCRIPTION3, HOST: HOST14, ICON: ICON4, NONE, TITLE: TITLE4 } = getStyles2({
      inline,
      type
    });
    const [close, setClose] = (0, import_react6.useReducer)(() => true, false);
    return /* @__PURE__ */ (0, import_jsx_runtime419.jsxs)("div", { className: (0, import_uik445.css)(HOST14, close && NONE, ...import_uik445.utils.many(className2)), ref, uik: "Banner", ...props2, children: [
      icon && /* @__PURE__ */ (0, import_jsx_runtime419.jsx)(import_uik445.Icon, { className: ICON4, size: "MEDIUM", type: icon }),
      /* @__PURE__ */ (0, import_jsx_runtime419.jsxs)("div", { className: DESCRIPTION3, children: [
        title && /* @__PURE__ */ (0, import_jsx_runtime419.jsx)("div", { className: TITLE4, children: title }),
        children
      ] }),
      onClose !== "DISABLE" && /* @__PURE__ */ (0, import_jsx_runtime419.jsx)(
        import_uik445.Button,
        {
          className: CLOSE3,
          icon: "Navigation.Close",
          onClick: () => {
            setClose();
            onClose?.();
          },
          type: "TERTIARY"
        }
      )
    ] });
  }
);
Banner.displayName = "Banner";
Banner.__DEV_METADATA__ = { status: "READY" };

// Button/Button.tsx
var import_uik448 = require("@appd/uik");
var import_react7 = require("react");

// Button/getStyles.ts
var import_uik446 = require("@appd/uik");
var {
  COLORS: {
    CONTROL_BORDER_WEAK,
    CONTROL_BORDER_WEAK_FOCUS,
    CONTROL_BORDER_WEAK_HOVER,
    DEFAULT_BG_HOVER,
    DEFAULT_BG_WEAK,
    DEFAULT_ICON_IN,
    DEFAULT_ICON_IN_DISABLED,
    DEFAULT_TEXT: DEFAULT_TEXT2,
    DEFAULT_TEXT_DISABLED,
    DEFAULT_TEXT_MEDIUM,
    DEFAULT_TEXT_STRONG: DEFAULT_TEXT_STRONG2,
    INTERACT_BG,
    INTERACT_BG_ACTIVE,
    INTERACT_BG_DISABLED,
    INTERACT_BG_FOCUS,
    INTERACT_BG_HOVER,
    INTERACT_BG_WEAK,
    INTERACT_BG_WEAK_ACTIVE,
    INTERACT_BG_WEAK_FOCUS,
    INTERACT_BG_WEAK_HOVER,
    INTERACT_BORDER,
    INTERACT_BORDER_DISABLED,
    INTERACT_ICON_WEAK,
    INTERACT_ICON_WEAK_DISABLED,
    INTERACT_TEXT,
    INTERACT_TEXT_DISABLED,
    INTERACT_TEXT_IN
  },
  PARTICLE: {
    EFFECTS: { SHADOW }
  },
  RADIUS: RADIUS2,
  SPACING: SPACING2,
  TYPOGRAPHY: { ELLIPSES: ELLIPSES2, LINE_HEIGHT_P3, P3_BOLD: P3_BOLD2, P3_DEFAULT: P3_DEFAULT2 }
} = import_uik446.MAGNETIC_TOKENS;
var getStyles3 = /* @__PURE__ */ __name(({
  disabled,
  iconOnlyOrNotification,
  selected,
  type
}) => ({
  FILL: (0, import_uik446.css)(
    type === "PRIMARY" ? disabled ? DEFAULT_ICON_IN_DISABLED : DEFAULT_ICON_IN : type === "TERTIARY" && iconOnlyOrNotification ? disabled ? INTERACT_ICON_WEAK_DISABLED : INTERACT_ICON_WEAK : disabled ? INTERACT_TEXT_DISABLED : INTERACT_TEXT
  ),
  HOST: (0, import_uik446.css)({
    border: "none",
    boxSizing: "border-box",
    display: "flex",
    font: P3_BOLD2,
    overflow: "hidden",
    ...type === "MACRO" ? {
      alignItems: "flex-start",
      height: "unset",
      minWidth: 180
    } : {
      alignItems: "center",
      height: 30,
      minWidth: 30
    },
    ...type === "MACRO" ? {
      borderRadius: RADIUS2.HEAVY,
      justifyContent: "flex-start",
      textAlign: "left",
      width: "fit-content"
    } : type === "MENU_ITEM" ? {
      borderRadius: 0,
      justifyContent: "left",
      textAlign: "left",
      width: "100%"
    } : {
      borderRadius: RADIUS2.DEFAULT,
      justifyContent: "center",
      textAlign: "center",
      width: "fit-content"
    },
    ...type === "MACRO" ? {
      maxWidth: 448,
      paddingBlock: SPACING2[3],
      paddingInline: SPACING2[4]
    } : type === "TERTIARY" ? { padding: 0 } : iconOnlyOrNotification ? { padding: 3 } : {
      maxWidth: 400,
      paddingInline: SPACING2[4]
    },
    ...type === "MACRO" && {
      "> .macro-content": {
        ...MACRO.CONTENT,
        color: disabled ? DEFAULT_TEXT_DISABLED : selected ? DEFAULT_TEXT2 : DEFAULT_TEXT_MEDIUM,
        minHeight: 0,
        overflowY: "auto"
      },
      "> .macro-title": {
        ...MACRO.TITLE,
        color: disabled ? DEFAULT_TEXT_DISABLED : selected ? DEFAULT_TEXT_STRONG2 : DEFAULT_TEXT2
      },
      flexDirection: "column",
      minHeight: 56
    },
    ...{
      ...["PRIMARY", "SUBMIT"].includes(type) ? {
        backgroundColor: INTERACT_BG,
        borderRadius: RADIUS2.HEAVY,
        color: INTERACT_TEXT_IN,
        ...!disabled ? {
          ":focus-visible": { backgroundColor: INTERACT_BG_FOCUS },
          ":hover": { backgroundColor: INTERACT_BG_HOVER }
        } : { backgroundColor: INTERACT_BG_DISABLED },
        ...selected ? { backgroundColor: INTERACT_BG_ACTIVE } : {}
      } : ["MENU", "MENU_ITEM"].includes(type) ? {
        backgroundColor: "transparent",
        color: INTERACT_TEXT,
        ...!disabled ? {
          ":focus-visible": { backgroundColor: INTERACT_BG_WEAK_FOCUS },
          ":hover": { backgroundColor: INTERACT_BG_WEAK_HOVER }
        } : {},
        ...selected ? { backgroundColor: INTERACT_BG_WEAK_ACTIVE } : {}
      } : type === "MACRO" ? {
        backgroundColor: DEFAULT_BG_WEAK,
        border: `2px solid`,
        borderColor: CONTROL_BORDER_WEAK,
        boxShadow: SHADOW,
        ...!disabled ? {
          ":focus-visible": { outline: `1px solid ${CONTROL_BORDER_WEAK_FOCUS}` },
          ":hover": {
            backgroundColor: DEFAULT_BG_HOVER,
            borderColor: CONTROL_BORDER_WEAK_HOVER
          }
        } : {},
        ...selected ? { backgroundColor: INTERACT_BG_ACTIVE } : {}
      } : type === "SECONDARY" ? {
        backgroundColor: INTERACT_BG_WEAK,
        border: `2px solid ${INTERACT_BORDER}`,
        borderRadius: RADIUS2.HEAVY,
        color: INTERACT_TEXT,
        ...!disabled ? {
          ":focus-visible": { backgroundColor: INTERACT_BG_WEAK_FOCUS },
          ":hover": { backgroundColor: INTERACT_BG_WEAK_HOVER }
        } : { borderColor: INTERACT_BORDER_DISABLED },
        ...selected ? { backgroundColor: INTERACT_BG_WEAK_ACTIVE } : {}
      } : type === "TERTIARY" && {
        backgroundColor: "transparent",
        color: INTERACT_TEXT,
        ...!disabled ? {
          ":focus-visible": { backgroundColor: INTERACT_BG_WEAK_FOCUS },
          ":hover": { backgroundColor: INTERACT_BG_WEAK_HOVER }
        } : {},
        ...selected ? { backgroundColor: INTERACT_BG_WEAK_ACTIVE } : {}
      },
      cursor: disabled ? "not-allowed" : "pointer"
    }
  }),
  ICON: (0, import_uik446.css)({
    marginRight: type === "MENU" ? (
      // Manually collapse whitespace to right of ▾ icon.
      -(18 - 7.5) / 2
    ) : iconOnlyOrNotification ? 0 : 4
  }),
  LABEL: (0, import_uik446.css)(ELLIPSES2.END)
}), "getStyles");
var MACRO = {
  CONTENT: import_uik446.css.Styles({
    font: P3_DEFAULT2,
    textAlign: "left",
    width: "100%"
  }),
  TITLE: import_uik446.css.Styles({
    font: P3_BOLD2,
    minHeight: LINE_HEIGHT_P3,
    paddingBlock: SPACING2[1],
    textAlign: "left",
    width: "100%",
    ...ELLIPSES2.END
  })
};

// Button/useIsIconOnly.ts
var import_uik447 = require("@appd/uik");
var useIsIconOnly = /* @__PURE__ */ __name(({
  children,
  icon,
  iconRight,
  ref,
  setIsIconOnly
}) => {
  import_uik447.utils.useLayoutEffect(() => {
    if (!children && (icon != void 0 || iconRight != void 0)) {
      setIsIconOnly(true);
    } else {
      const buttonElement = ref.current;
      setIsIconOnly(
        buttonElement != void 0 && (buttonElement?.children?.length ?? 0) > 0 && !(Array.from(buttonElement?.children ?? []).findIndex(
          (child) => !child.getAttribute("uik")?.includes("Icon")
        ) >= 0)
      );
    }
  }, [icon, iconRight, children]);
}, "useIsIconOnly");

// Button/Button.tsx
var import_jsx_runtime420 = require("react/jsx-runtime");
var Button2 = import_uik448.utils.forwardRef(
  ({
    children = null,
    className: className2,
    disabled = false,
    icon = "",
    iconColor,
    iconRight,
    selected = false,
    type = "PRIMARY",
    ...props2
  }, forwardedRef) => {
    const [isIconOnly, setIsIconOnly] = (0, import_react7.useState)(false);
    const ref = import_uik448.utils.useBroadcastRef(forwardedRef);
    useIsIconOnly({
      children,
      icon,
      iconRight,
      ref,
      setIsIconOnly
    });
    const isNotification = isFinite(children);
    const { FILL, HOST: HOST14, ICON: ICON4, LABEL: LABEL7 } = getStyles3({
      disabled,
      iconOnlyOrNotification: (isIconOnly || isNotification) && ["PRIMARY", "SECONDARY", "TERTIARY"].includes(type),
      selected,
      type
    });
    return /* @__PURE__ */ (0, import_jsx_runtime420.jsxs)(
      "button",
      {
        className: (0, import_uik448.css)(HOST14, ...import_uik448.utils.many(className2)),
        disabled,
        ref,
        type: type === "SUBMIT" ? "submit" : "button",
        uik: "Button",
        ...props2,
        children: [
          icon && /* @__PURE__ */ (0, import_jsx_runtime420.jsx)(import_uik448.Icon, { className: ICON4, fill: iconColor ?? FILL, type: icon }),
          type !== "MACRO" && typeof children === "string" ? /* @__PURE__ */ (0, import_jsx_runtime420.jsx)("span", { className: LABEL7, children }) : children,
          type === "MENU" && /* @__PURE__ */ (0, import_jsx_runtime420.jsx)(import_uik448.Icon.Navigation.ArrowDropDown, { className: ICON4, size: "SMALL" }),
          iconRight && /* @__PURE__ */ (0, import_jsx_runtime420.jsx)(import_uik448.Icon, { className: ICON4, fill: iconColor ?? FILL, type: iconRight })
        ]
      }
    );
  }
);
Button2.displayName = "Button";
Button2.__DEV_METADATA__ = { status: "READY" };

// ButtonScroll/ButtonScroll.tsx
var import_uik450 = require("@appd/uik");
var import_react8 = require("react");
var import_server = require("react-dom/server");

// ButtonScroll/STYLES.ts
var import_uik449 = require("@appd/uik");
var {
  COLORS: { INTERACT_ICON_WEAK: INTERACT_ICON_WEAK2 }
} = import_uik449.MAGNETIC_TOKENS;
var STYLES = {
  ARROW: (0, import_uik449.css)({
    "&, > svg": {
      height: 32,
      width: 32
    },
    ":hover": { backgroundColor: "transparent" },
    backgroundColor: "transparent",
    left: "calc(-1 * var(--paddingLeft))",
    padding: 0,
    position: "sticky",
    top: "calc(var(--clientHeight) / 2 - var(--paddingTop) - 16px)"
  }),
  ARROW_FILL: INTERACT_ICON_WEAK2,
  HOST: (0, import_uik449.css)({
    display: "flex",
    // Overrides `height: "100%"` from ScrollBox; otherwise, if no parent is provided height will = page height.
    height: "fit-content",
    position: "relative",
    // Scroll snapping.
    ...{
      "> *, & [uik='ButtonScroll.Content'] > *": { scrollSnapAlign: "start" },
      scrollSnapType: "x proximity"
    }
  }),
  ISOLATE: (0, import_uik449.css)({
    "> *": { pointerEvents: "auto" },
    contain: "size layout style",
    containIntrinsicSize: 0,
    height: "100%",
    left: 0,
    pointerEvents: "none",
    position: "absolute",
    top: 0,
    width: "100%"
  })
};

// ButtonScroll/ButtonScroll.tsx
var import_jsx_runtime421 = require("react/jsx-runtime");
var ButtonScroll = import_uik450.utils.forwardRef(
  ({ children, className: className2, onLeftClick: rawOnLeftClick, onRightClick: rawOnRightClick, ...props2 }, maybeRef) => {
    const [hasArrow, setHasArrow] = (0, import_react8.useState)({
      left: false,
      right: false
    });
    const ref = import_uik450.utils.useBroadcastRef(maybeRef);
    const onResizeOrScroll = (0, import_react8.useCallback)(() => {
      const { clientWidth, scrollLeft, scrollWidth } = ref.current ?? {};
      setHasArrow({
        left: scrollLeft > 0,
        // Decimal calcs don't favor the hiding, so need to round.
        right: Math.ceil(scrollLeft) + clientWidth < Math.floor(scrollWidth)
      });
    }, []);
    import_uik450.utils.useLayoutEffect(() => {
      if (!ref.current) {
        return;
      }
      const observer = new MutationObserver(onResizeOrScroll);
      observer.observe(ref.current, {
        attributes: false,
        childList: true,
        subtree: true
      });
      return () => observer.disconnect();
    }, [ref.current]);
    const onLeftClick = /* @__PURE__ */ __name(() => {
      ref.current?.scrollTo({
        behavior: "smooth",
        left: ref.current.scrollLeft - ref.current.getBoundingClientRect().width
      });
      rawOnLeftClick?.();
    }, "onLeftClick");
    const onRightClick = /* @__PURE__ */ __name(() => {
      ref.current?.scrollTo({
        behavior: "smooth",
        left: ref.current.scrollLeft + ref.current.getBoundingClientRect().width
      });
      rawOnRightClick?.();
    }, "onRightClick");
    const maskImage = (0, import_react8.useMemo)(
      () => (
        // Requires "0px" instead of "0", otherwise the masks don't update properly on `next.right` -> false.
        [
          ...import_uik450.utils.when(hasArrow.left).then(`url("data:image/svg+xml;base64,${ARROW_SVG.LEFT}") no-repeat left`),
          `linear-gradient(to right, transparent, white ${hasArrow.left ? 80 : 0}px calc(100% - ${hasArrow.right ? 80 : 0}px), transparent)`,
          ...import_uik450.utils.when(hasArrow.right).then(`url("data:image/svg+xml;base64,${ARROW_SVG.RIGHT}") no-repeat right`)
        ].join(", ")
      ),
      [hasArrow.left, hasArrow.right]
    );
    return /* @__PURE__ */ (0, import_jsx_runtime421.jsx)(import_uik450.Measurer, { onResize: onResizeOrScroll, children: /* @__PURE__ */ (0, import_jsx_runtime421.jsxs)(
      import_uik450.ScrollBox,
      {
        className: (0, import_uik450.css)(HOST, ...import_uik450.utils.many(className2)),
        hideHorizontal: true,
        hideVertical: true,
        onScroll: onResizeOrScroll,
        ref,
        style: {
          WebkitMask: maskImage,
          maskImage
        },
        uik: "ButtonScroll",
        ...props2,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime421.jsxs)(import_uik450.Overlay, { children: [
            /* @__PURE__ */ (0, import_jsx_runtime421.jsx)("div", { className: ISOLATE, children: hasArrow.left && /* @__PURE__ */ (0, import_jsx_runtime421.jsx)(
              import_uik450.Button,
              {
                "aria-label": "Previous",
                className: ARROW,
                icon: "Navigation.ChevronLeft",
                iconColor: ARROW_FILL,
                onClick: onLeftClick
              }
            ) }),
            /* @__PURE__ */ (0, import_jsx_runtime421.jsx)("div", { className: ISOLATE, children: hasArrow.right && /* @__PURE__ */ (0, import_jsx_runtime421.jsx)(
              import_uik450.Button,
              {
                "aria-label": "Next",
                className: (0, import_uik450.css)(ARROW, { left: "calc(var(--clientWidth) - var(--paddingLeft) - 32px)" }),
                icon: "Navigation.ChevronRight",
                iconColor: ARROW_FILL,
                onClick: onRightClick
              }
            ) })
          ] }),
          children
        ]
      }
    ) });
  }
);
ButtonScroll.displayName = "ButtonScroll";
ButtonScroll.__DEV_METADATA__ = { status: "IN_PROGRESS" };
var ARROW_SVG = {
  LEFT: btoa((0, import_server.renderToString)(/* @__PURE__ */ (0, import_jsx_runtime421.jsx)(import_uik450.Icon.Navigation.ChevronLeft, { height: 32, width: 32 }))),
  RIGHT: btoa((0, import_server.renderToString)(/* @__PURE__ */ (0, import_jsx_runtime421.jsx)(import_uik450.Icon.Navigation.ChevronRight, { height: 32, width: 32 })))
};
var { ARROW, ARROW_FILL, HOST, ISOLATE } = STYLES;

// Card/Card.tsx
var import_uik458 = require("@appd/uik");
var import_react12 = require("react");

// Card/Container/Container.tsx
var import_uik452 = require("@appd/uik");

// Card/Container/STYLES.ts
var import_uik451 = require("@appd/uik");
var {
  COLORS: { DEFAULT_BG_WEAK: DEFAULT_BG_WEAK2 },
  EFFECTS: { SHAODW_LIFTED: SHAODW_LIFTED2 },
  SPACING: SPACING3
} = import_uik451.MAGNETIC_TOKENS;
var STYLES2 = (0, import_uik451.css)({
  backgroundColor: DEFAULT_BG_WEAK2,
  borderRadius: SPACING3[3],
  boxShadow: SHAODW_LIFTED2,
  display: "flex",
  flexDirection: "column",
  gap: SPACING3[4],
  padding: SPACING3[6]
});

// Card/CONTEXT.ts
var import_react9 = require("react");
var CONTEXT2 = (0, import_react9.createContext)("CARD");

// Card/Container/Container.tsx
var import_jsx_runtime422 = require("react/jsx-runtime");
var Container2 = import_uik452.utils.forwardRef(
  ({ children, className: className2, title, ...props2 }, ref) => /* @__PURE__ */ (0, import_jsx_runtime422.jsx)(CONTEXT2.Provider, { value: "CONTAINER", children: /* @__PURE__ */ (0, import_jsx_runtime422.jsxs)("div", { className: (0, import_uik452.css)(STYLES2, ...import_uik452.utils.many(className2)), ref, uik: "Card.Container", ...props2, children: [
    title && /* @__PURE__ */ (0, import_jsx_runtime422.jsx)(import_uik452.Heading, { children: title }),
    children
  ] }) })
);
Container2.displayName = "Card.Container";
Container2.__DEV_METADATA__ = { status: "READY" };

// Card/getStyles.ts
var import_uik453 = require("@appd/uik");
var {
  COLORS: {
    CONTROL_BG_WEAK,
    CONTROL_BORDER_WEAK: CONTROL_BORDER_WEAK2,
    CONTROL_BORDER_WEAK_ACTIVE,
    CONTROL_BORDER_WEAK_HOVER: CONTROL_BORDER_WEAK_HOVER2,
    DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM2,
    DEFAULT_TEXT_STRONG: DEFAULT_TEXT_STRONG3,
    DORMANT_BORDER,
    INFO_BORDER: INFO_BORDER2,
    NEGATIVE_BORDER: NEGATIVE_BORDER2,
    POSITIVE_BORDER: POSITIVE_BORDER2,
    WARNING_BORDER: WARNING_BORDER2
  },
  PARTICLE: {
    EFFECTS: { SHADOW: SHADOW2 }
  },
  RADIUS: RADIUS3,
  SPACING: SPACING4,
  TYPOGRAPHY: { ELLIPSES: ELLIPSES3, HEADING_SUB_SECTION, P3_DEFAULT: P3_DEFAULT3, P4_DEFAULT, P4_EMPHASIS }
} = import_uik453.MAGNETIC_TOKENS;
var getStyles4 = /* @__PURE__ */ __name(({
  accentColor,
  computedStyles,
  interactable,
  selected,
  titleTagType
}, { backgroundColor } = { ...computedStyles }) => ({
  ACCENT: (0, import_uik453.css)({
    backgroundColor: accentColor ?? ACCENT_COLOR[titleTagType],
    height: 5,
    left: 0,
    position: "absolute",
    top: 0,
    width: "100%"
  }),
  ACTIONS_OR_EDIT: (0, import_uik453.css)({
    height: 24,
    minWidth: 24,
    width: 24
  }),
  EXPAND: (0, import_uik453.css)({
    height: 24,
    marginRight: -SPACING4[1],
    minWidth: 24,
    padding: 0,
    width: 24
  }),
  HEADER: (0, import_uik453.css)({
    alignItems: "start",
    background: (
      // Not part of spec.
      // This avoids a sharp cutoff when the content scrolls beneath the header.
      // Remove if/when spec defines a behavior.
      {
        get gradient() {
          const hex3 = import_uik453.utils.color.as.hex(backgroundColor || CONTROL_BG_WEAK);
          return hex3 ? `linear-gradient(${hex3}, ${applyAlphaToHex(hex3.slice(0, -2), 240)} 55%, ${applyAlphaToHex(
            hex3.slice(0, -2),
            221
          )} 62%, transparent)` : void 0;
        }
      }.gradient
    ),
    borderRadius: `${RADIUS3.HEAVY}px ${RADIUS3.HEAVY}px 0 0`,
    boxSizing: "border-box",
    display: "flex",
    zIndex: 1,
    // Fill available width.
    ...{
      maxWidth: `100%`,
      width: `100%`
    }
  }),
  HOST: (0, import_uik453.css)({
    // Don't use the `backgroundColor` from `computedStyles` above. Doing so will prevent theming (DASHUI-4936).
    backgroundColor: CONTROL_BG_WEAK,
    border: "2px solid",
    borderColor: selected ? CONTROL_BORDER_WEAK_ACTIVE : CONTROL_BORDER_WEAK2,
    borderRadius: RADIUS3.HEAVY,
    boxShadow: interactable && SHADOW2,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    gap: 12,
    height: "unset",
    // Don't trigger overflow in a flex container. (https://stackoverflow.com/a/66689926/3624264)
    ...{
      minHeight: 0,
      minWidth: 0
    },
    "&:hover": interactable ? { borderColor: CONTROL_BORDER_WEAK_HOVER2 } : {},
    padding: SPACING4[4]
  }),
  ICON: (0, import_uik453.css)({
    flexShrink: 0,
    marginRight: SPACING4[2],
    marginTop: 2
  }),
  LEFT: (0, import_uik453.css)({
    marginRight: SPACING4[2],
    // Don't trigger overflow in a flex container. (https://stackoverflow.com/a/66689926/3624264)
    minWidth: 0
  }),
  LEFT_RIGHT_SPACER: (0, import_uik453.css)({ marginLeft: "auto" }),
  RIGHT: (0, import_uik453.css)({
    display: "flex",
    flexShrink: 0,
    marginLeft: SPACING4[1],
    // Don't trigger overflow in a flex container. (https://stackoverflow.com/a/66689926/3624264)
    minWidth: 0
  }),
  // Spec says this should be "anchored" to bottom (i.e. `position: sticky`), but would take a lot more effort to
  // replicate the behavior of `HEADER` here as well.
  // TODO: Implement later if desired.
  SHOW_MORE: (0, import_uik453.css)({
    flexShrink: 0,
    marginTop: SPACING4[4],
    paddingLeft: 2,
    paddingRight: 10
  }),
  SHOW_MORE_SPACER: (0, import_uik453.css)({ marginTop: "auto" }),
  /** Cancel out `marginBottom` of `HEADER`. Forward `paddingTop` of `<Card>`. */
  SPACER: (0, import_uik453.css)({}),
  SUBTITLE: (0, import_uik453.css)({
    ...ELLIPSES3.END,
    color: DEFAULT_TEXT_MEDIUM2,
    font: P3_DEFAULT3,
    marginTop: SPACING4[1]
  }),
  TAG: (0, import_uik453.css)({
    marginLeft: SPACING4[2],
    padding: 0,
    paddingInline: SPACING4[2]
  }),
  TAG_TEXT_EMPHASIS_ONLY: (0, import_uik453.css)({
    font: P4_EMPHASIS,
    marginLeft: SPACING4[1]
  }),
  TAG_TEXT_ONLY: (0, import_uik453.css)({
    color: DEFAULT_TEXT_MEDIUM2,
    font: P4_DEFAULT,
    marginLeft: SPACING4[1]
  }),
  TITLE: (0, import_uik453.css)({
    ...ELLIPSES3.END,
    color: DEFAULT_TEXT_STRONG3,
    font: HEADING_SUB_SECTION
  }),
  TITLE_ROW: (0, import_uik453.css)({
    alignItems: "end",
    display: "flex"
  })
}), "getStyles");
var ACCENT_COLOR = {
  DEFAULT: INFO_BORDER2,
  INACTIVE: DORMANT_BORDER,
  NEGATIVE: NEGATIVE_BORDER2,
  NONE: "transparent",
  POSITIVE: POSITIVE_BORDER2,
  TEXT_EMPHASIS_ONLY: "transparent",
  TEXT_ONLY: "transparent",
  WARNING: WARNING_BORDER2
};

// Card/MESSAGES.ts
var import_uik454 = require("@appd/uik");
var MESSAGES = {
  CHEVRON: import_uik454.format.message`${{
    // Not from spec. I made this up, since spec has no guidance.
    COLLAPSE: "Collapse",
    EXPAND: "Expand"
  }}`.description("Tooltip hint for chevron icon in top left of Card."),
  EDITING: import_uik454.format.message`${{
    // Not from spec. I made this up, since spec has no guidance.
    OFF: "Done",
    ON: "Edit"
  }}`.description("Tooltip hint for pencil icon in top right of Card."),
  SHOW: import_uik454.format.message`${{
    LESS: "Show less",
    MORE: "Show more"
  }}`.description("Button text for showing/hiding the Card's secondary content.")
};

// Card/useComputedStyles.ts
var import_uik455 = require("@appd/uik");
var import_react10 = require("react");
var useComputedStyles = /* @__PURE__ */ __name((ref) => {
  (0, import_react10.useContext)(import_uik455.css.CONTEXT);
  const [computedStyles, setComputedStyles] = (0, import_react10.useState)();
  import_uik455.utils.useLayoutEffect(() => {
    if (!ref.current) {
      return;
    }
    const { backgroundColor } = getComputedStyle(ref.current);
    setComputedStyles((old) => backgroundColor !== old?.backgroundColor ? { backgroundColor } : old);
  });
  return computedStyles;
}, "useComputedStyles");

// Card/Well/Well.tsx
var import_uik457 = require("@appd/uik");
var import_react11 = require("react");

// Card/Well/STYLES.ts
var import_uik456 = require("@appd/uik");
var {
  COLORS: { DEFAULT_BG_MEDIUM },
  SPACING: SPACING5
} = import_uik456.MAGNETIC_TOKENS;
var STYLES3 = {
  CARD: (0, import_uik456.css)({ padding: `${SPACING5[1]}px ${SPACING5[4]}px ` }),
  CONTAINER: (0, import_uik456.css)({
    borderRadius: SPACING5[1],
    padding: `${4 * SPACING5[4]}px ${SPACING5[4]}px `
  }),
  HOST: (0, import_uik456.css)({ backgroundColor: DEFAULT_BG_MEDIUM })
};

// Card/Well/Well.tsx
var import_jsx_runtime423 = require("react/jsx-runtime");
var Well = import_uik457.utils.forwardRef(({ children, className: className2, ...props2 }, rawRef) => {
  const parent = (0, import_react11.useContext)(CONTEXT2);
  return /* @__PURE__ */ (0, import_jsx_runtime423.jsx)(
    "div",
    {
      className: (0, import_uik457.css)(
        HOST2,
        {
          CARD,
          CONTAINER
        }[parent],
        ...import_uik457.utils.many(className2)
      ),
      ref: rawRef,
      uik: "Card.Well",
      ...props2,
      children
    }
  );
});
Well.displayName = "Card.Well";
var { CARD, CONTAINER, HOST: HOST2 } = STYLES3;

// Card/Card.tsx
var import_jsx_runtime424 = require("react/jsx-runtime");
var Card = Object.assign(
  import_uik458.utils.forwardRef(
    ({
      accentColor,
      actions: rawActions = null,
      children,
      className: className2,
      edit: rawEdit = null,
      expandable = false,
      expanded: rawExpanded,
      icon: rawIcon = null,
      initialExpanded,
      left: rawLeft = null,
      more,
      onClick,
      onExpandedChange = /* @__PURE__ */ __name(() => {
      }, "onExpandedChange"),
      onShowingMoreChange,
      right: rawRight = null,
      selected,
      showingMore,
      subtitle: rawSubtitle = null,
      title: rawTitle = null,
      titleTag: rawTitleTag = {},
      ...props2
    }, rawRef) => {
      const ref = import_uik458.utils.useBroadcastRef(rawRef);
      const computedStyles = useComputedStyles(ref);
      const [rawShowingMore, setRawShowingMore] = (0, import_react12.useState)(false);
      const [expanded, setExpanded] = (0, import_react12.useState)(expandable ? rawExpanded || initialExpanded : true);
      const [editing, toggleEditing] = (0, import_react12.useReducer)((editing2) => !editing2, false);
      showingMore ??= rawShowingMore;
      if (rawExpanded !== void 0 && rawExpanded !== expanded) {
        setExpanded(rawExpanded);
      }
      const hasHeader = [
        expandable || null,
        rawActions,
        rawEdit,
        rawIcon,
        rawLeft,
        rawRight,
        rawSubtitle,
        rawTitle
      ].some((x) => x != null);
      const {
        ACCENT,
        ACTIONS_OR_EDIT,
        EXPAND,
        HEADER: HEADER4,
        HOST: HOST14,
        ICON: ICON4,
        LEFT: LEFT2,
        LEFT_RIGHT_SPACER,
        RIGHT,
        SHOW_MORE,
        SHOW_MORE_SPACER,
        SUBTITLE: SUBTITLE2,
        TAG,
        TAG_TEXT_EMPHASIS_ONLY,
        TAG_TEXT_ONLY,
        TITLE: TITLE4,
        TITLE_ROW
      } = getStyles4({
        accentColor,
        computedStyles,
        interactable: onClick != void 0,
        selected,
        titleTagType: rawTitleTag.type ?? "NONE"
      });
      const {
        accent = /* @__PURE__ */ (0, import_jsx_runtime424.jsx)("div", { className: (0, import_uik458.css)(ACCENT) }),
        actions = typeof rawActions === "function" ? /* @__PURE__ */ (0, import_jsx_runtime424.jsx)(
          import_uik458.Button,
          {
            className: ACTIONS_OR_EDIT,
            icon: "Navigation.MoreVertical",
            onClick: rawActions,
            type: "TERTIARY",
            uik: "Card.ACTIONS"
          }
        ) : rawActions,
        edit = typeof rawEdit === "function" ? /* @__PURE__ */ (0, import_jsx_runtime424.jsx)(import_uik458.Tooltip, { value: EDITING(editing ? "OFF" : "ON"), children: /* @__PURE__ */ (0, import_jsx_runtime424.jsx)(
          import_uik458.Button,
          {
            className: (0, import_uik458.css)(ACTIONS_OR_EDIT),
            icon: "Action.Edit",
            onClick: (e) => {
              toggleEditing();
              rawEdit(e);
            },
            selected: editing,
            type: "TERTIARY",
            uik: "Card.EDIT"
          }
        ) }) : rawEdit,
        expand = expandable && /* @__PURE__ */ (0, import_jsx_runtime424.jsx)(import_uik458.Tooltip, { className: (0, import_uik458.css)({ pointerEvents: "none" }), value: CHEVRON(expanded ? "COLLAPSE" : "EXPAND"), children: /* @__PURE__ */ (0, import_jsx_runtime424.jsx)(
          import_uik458.Button,
          {
            className: EXPAND,
            icon: expanded ? "Navigation.ChevronDown" : "Navigation.ChevronRight",
            onClick: () => {
              setRawShowingMore(false);
              setExpanded(!expanded);
              onExpandedChange(!expanded);
            },
            type: "TERTIARY",
            uik: "Card.EXPAND"
          }
        ) }),
        icon = typeof rawIcon === "string" ? /* @__PURE__ */ (0, import_jsx_runtime424.jsx)(import_uik458.Icon, { className: ICON4, size: "SMALL", type: rawIcon }) : rawIcon,
        showMore = more && /* @__PURE__ */ (0, import_jsx_runtime424.jsxs)(import_jsx_runtime424.Fragment, { children: [
          /* @__PURE__ */ (0, import_jsx_runtime424.jsx)("div", { className: SHOW_MORE_SPACER, uik: "Card.SHOW_MORE_SPACER" }),
          showingMore && more,
          /* @__PURE__ */ (0, import_jsx_runtime424.jsx)(
            import_uik458.Button,
            {
              className: SHOW_MORE,
              icon: showingMore ? "Navigation.ChevronUp" : "Navigation.ChevronRight",
              onClick: () => setRawShowingMore((x) => (onShowingMoreChange?.(!x), !x)),
              type: "TERTIARY",
              uik: "Card.SHOW_MORE",
              children: SHOW(showingMore ? "LESS" : "MORE")
            }
          )
        ] }),
        subtitle = typeof rawSubtitle === "string" ? /* @__PURE__ */ (0, import_jsx_runtime424.jsx)(import_uik458.Tooltip, { showOnOverflowOnly: true, value: rawSubtitle, children: /* @__PURE__ */ (0, import_jsx_runtime424.jsx)("div", { className: SUBTITLE2, uik: "Card.SUBTITLE", children: rawSubtitle }) }) : rawSubtitle,
        title = typeof rawTitle === "string" ? /* @__PURE__ */ (0, import_jsx_runtime424.jsx)(import_uik458.Tooltip, { showOnOverflowOnly: true, value: rawTitle, children: /* @__PURE__ */ (0, import_jsx_runtime424.jsx)("div", { className: TITLE4, uik: "Card.TITLE", children: rawTitle }) }) : rawTitle,
        titleTag = rawTitleTag.text ? {
          DEFAULT: /* @__PURE__ */ (0, import_jsx_runtime424.jsx)(import_uik458.Tag, { className: (0, import_uik458.css)(TAG), children: rawTitleTag.text }),
          INACTIVE: /* @__PURE__ */ (0, import_jsx_runtime424.jsx)(import_uik458.Tag.Status, { className: (0, import_uik458.css)(TAG), status: "INACTIVE", children: rawTitleTag.text }),
          NEGATIVE: /* @__PURE__ */ (0, import_jsx_runtime424.jsx)(import_uik458.Tag.Status, { className: (0, import_uik458.css)(TAG), status: "NEGATIVE", children: rawTitleTag.text }),
          POSITIVE: /* @__PURE__ */ (0, import_jsx_runtime424.jsx)(import_uik458.Tag.Status, { className: (0, import_uik458.css)(TAG), status: "POSITIVE", children: rawTitleTag.text }),
          TEXT_EMPHASIS_ONLY: /* @__PURE__ */ (0, import_jsx_runtime424.jsx)("div", { className: (0, import_uik458.css)(TAG_TEXT_EMPHASIS_ONLY), children: rawTitleTag.text }),
          TEXT_ONLY: /* @__PURE__ */ (0, import_jsx_runtime424.jsx)("div", { className: (0, import_uik458.css)(TAG_TEXT_ONLY), children: rawTitleTag.text }),
          WARNING: /* @__PURE__ */ (0, import_jsx_runtime424.jsx)(import_uik458.Tag.Status, { className: (0, import_uik458.css)(TAG), status: "WARNING", children: rawTitleTag.text })
        }[rawTitleTag.type ?? "DEFAULT"] : /* @__PURE__ */ (0, import_jsx_runtime424.jsx)(import_jsx_runtime424.Fragment, {})
      } = {};
      const {
        left = rawLeft ?? /* @__PURE__ */ (0, import_jsx_runtime424.jsxs)(import_jsx_runtime424.Fragment, { children: [
          icon,
          /* @__PURE__ */ (0, import_jsx_runtime424.jsxs)("div", { className: LEFT2, children: [
            /* @__PURE__ */ (0, import_jsx_runtime424.jsxs)("div", { className: TITLE_ROW, children: [
              title,
              titleTag
            ] }),
            subtitle
          ] })
        ] }),
        right = rawRight ?? /* @__PURE__ */ (0, import_jsx_runtime424.jsxs)("div", { className: RIGHT, children: [
          edit,
          actions
        ] }),
        header = hasHeader && /* @__PURE__ */ (0, import_jsx_runtime424.jsx)(import_jsx_runtime424.Fragment, { children: /* @__PURE__ */ (0, import_jsx_runtime424.jsxs)("div", { className: HEADER4, uik: "Card.HEADER", children: [
          left,
          /* @__PURE__ */ (0, import_jsx_runtime424.jsx)("div", { className: LEFT_RIGHT_SPACER, uik: "Card.LEFT_RIGHT_SPACER" }),
          right,
          expand
        ] }) })
      } = {};
      return /* @__PURE__ */ (0, import_jsx_runtime424.jsx)(CONTEXT2.Provider, { value: "CARD", children: /* @__PURE__ */ (0, import_jsx_runtime424.jsxs)(import_uik458.ScrollBox, { className: (0, import_uik458.css)(HOST14, ...import_uik458.utils.many(className2)), onClick, ref, uik: "Card", ...props2, children: [
        accent,
        header,
        expanded && /* @__PURE__ */ (0, import_jsx_runtime424.jsxs)(import_jsx_runtime424.Fragment, { children: [
          children,
          showMore
        ] })
      ] }) });
    }
  ),
  {
    Container: Container2,
    Well
  }
);
Card.displayName = "Card";
Card.__DEV_METADATA__ = { status: "READY" };
var { CHEVRON, EDITING, SHOW } = MESSAGES;

// Cartesian/Cartesian.tsx
var import_uik493 = require("@appd/uik");
var import_luxon4 = require("luxon");
var import_react39 = require("react");

// Cartesian/Area.tsx
var import_uik460 = require("@appd/uik");
var import_react14 = require("react");

// Cartesian/CONTEXT.ts
var import_uik459 = require("@appd/uik");
var import_react13 = require("react");
var CONTEXT3 = (0, import_react13.createContext)(import_uik459.utils.noop);

// Cartesian/Area.tsx
var Area2 = /* @__PURE__ */ __name(({ data, fillColor, lineWidth, marker = { enabled: false }, name, visible, yAxis }) => {
  const setSeries = (0, import_react14.useContext)(CONTEXT3);
  import_uik460.utils.useLayoutEffect(
    () => setSeries([
      {
        crisp: true,
        data: [...data],
        fillColor,
        lineWidth,
        marker,
        name,
        type: "area",
        visible,
        yAxis
      }
    ])
  );
  return null;
}, "Area");
Area2.displayName = "Cartesian.Area";

// Cartesian/AreaRange.tsx
var import_uik461 = require("@appd/uik");
var import_react15 = require("react");
var AreaRange = /* @__PURE__ */ __name(({ data, name, visible, yAxis }) => {
  const setSeries = (0, import_react15.useContext)(CONTEXT3);
  import_uik461.utils.useLayoutEffect(
    () => setSeries([
      {
        crisp: true,
        data: [...data],
        marker: { enabled: false },
        name,
        type: "arearange",
        visible,
        yAxis
      }
    ])
  );
  return null;
}, "AreaRange");
AreaRange.displayName = "Cartesian.AreaRange";

// Cartesian/Bar.tsx
var import_uik462 = require("@appd/uik");
var import_react16 = require("react");
var Bar = /* @__PURE__ */ __name(({ data, name, visible, yAxis }) => {
  const setSeries = (0, import_react16.useContext)(CONTEXT3);
  import_uik462.utils.useLayoutEffect(() => {
    setSeries([
      {
        crisp: false,
        data: [...data],
        name,
        type: "bar",
        visible,
        yAxis
      }
    ]);
  });
  return null;
}, "Bar");
Bar.displayName = "Cartesian.Bar";

// Cartesian/Column.tsx
var import_uik463 = require("@appd/uik");
var import_react17 = require("react");

// Cartesian/Flag/withEmptyTitle.tsx
var withEmptyTitle = /* @__PURE__ */ __name((data) => data.map(({ title, x }) => ({
  title: !title || title === "" ? " " : title,
  x
})), "withEmptyTitle");

// Cartesian/Flag/toFlagSeries.ts
var toFlagSeries = /* @__PURE__ */ __name(({ data, shape = "diamond", y = -5 }) => ({
  data: withEmptyTitle(data),
  shape,
  type: "flags",
  /**
   * [API](https://api.highcharts.com/highstock/plotOptions.flags)
   * Highcharts Default: -30
   * Set to `-5` to make marker on the top of column
   */
  y
}), "toFlagSeries");

// Cartesian/Flag/withSeries.ts
var withSeries = /* @__PURE__ */ __name(({ maybeFlag, series }) => maybeFlag ? [series, toFlagSeries(maybeFlag)] : [series], "withSeries");

// Cartesian/Flag/Flag.tsx
var Flag;
((Flag2) => {
  Flag2.withSeries = withSeries;
})(Flag || (Flag = {}));

// Cartesian/Column.tsx
var Column2 = /* @__PURE__ */ __name(({ data, flags, name, select: select4, stack, stackGroup, visible, yAxis }) => {
  const setSeries = (0, import_react17.useContext)(CONTEXT3);
  import_uik463.utils.useLayoutEffect(() => {
    setSeries(
      Flag.withSeries({
        maybeFlag: flags,
        series: {
          crisp: false,
          data: [...data],
          name,
          select: select4,
          stack: stackGroup ?? stack,
          type: "column",
          visible,
          yAxis
        }
      })
    );
  });
  return null;
}, "Column");
Column2.displayName = "Cartesian.Column";

// Cartesian/CONTEXT/CONTEXT.ts
var import_react18 = require("react");
var CONTEXT4 = (0, import_react18.createContext)({ setMarginLeft: () => {
} });

// Cartesian/DEFAULT_COLORS.ts
var import_uik464 = require("@appd/uik");
var {
  COLORS: { ACCENT_A, ACCENT_B, ACCENT_C, ACCENT_D, ACCENT_F, ACCENT_G, ACCENT_H, ACCENT_I, ACCENT_J }
} = import_uik464.MAGNETIC_TOKENS;
var DEFAULT_COLORS = import_uik464.utils.infer().from([ACCENT_A, ACCENT_B, ACCENT_C, ACCENT_D, ACCENT_F, ACCENT_G, ACCENT_H, ACCENT_I, ACCENT_J]);

// Cartesian/getGradient.tsx
var import_jsx_runtime425 = require("react/jsx-runtime");
var getGradient = /* @__PURE__ */ __name((series, colors) => /* @__PURE__ */ (0, import_jsx_runtime425.jsx)("svg", { height: 0, width: 0, children: /* @__PURE__ */ (0, import_jsx_runtime425.jsx)("defs", { children: series.map(
  (series2, index, _, { x1, x2, y1, y2 } = series2.type === "area" && isGradientColorObject(series2.fillColor) && series2.fillColor.linearGradient || {
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 1
  }) => series2.type === "area" ? /* @__PURE__ */ (0, import_jsx_runtime425.jsx)(
    "linearGradient",
    {
      id: `series-gradient-${index}`,
      x1: `${x1 * 100}%`,
      x2: `${x2 * 100}%`,
      y1: `${y1 * 100}%`,
      y2: `${y2 * 100}%`,
      children: (isGradientColorObject(series2.fillColor) ? series2.fillColor.stops : typeof series2.fillColor === "string" ? [
        [0, `color-mix(in srgb, transparent, ${series2.fillColor} 20%)`],
        [1, `color-mix(in srgb, transparent, ${series2.fillColor} 2%)`]
      ] : [
        [0, `color-mix(in srgb, transparent, ${colors[series2.colorIndex ?? index]} 20%)`],
        [1, `color-mix(in srgb, transparent, ${colors[series2.colorIndex ?? index]} 2%)`]
      ]).map(({ 0: i, 1: stopColor }) => /* @__PURE__ */ (0, import_jsx_runtime425.jsx)("stop", { offset: `${i * 100}%`, style: { stopColor } }, i))
    },
    index
  ) : null
) }) }), "getGradient");
function isGradientColorObject(grad) {
  return grad?.stops !== void 0;
}
__name(isGradientColorObject, "isGradientColorObject");

// Cartesian/getStyles/getStyles.ts
var import_uik470 = require("@appd/uik");

// Cartesian/getStyles/AXES.ts
var import_uik465 = require("@appd/uik");
var AXES = import_uik465.css.Styles({
  // Partially Overridden
  "& .highcharts-axis-labels": {
    cursor: "default",
    fill: "#666666",
    fontSize: "0.9em"
  },
  "& .highcharts-axis-line": {
    fill: "none",
    stroke: "#ccd6eb"
  },
  // Overridden
  "& .highcharts-axis-title": { fill: "#666666" },
  "& .highcharts-crosshair-category": {
    stroke: "#ccd6eb",
    strokeOpacity: "0.25"
  },
  "& .highcharts-crosshair-thin": {
    stroke: "#cccccc",
    strokeWidth: "1px"
  },
  // Partially Overridden
  "& .highcharts-grid-line": {
    fill: "none",
    stroke: "#e6e6e6"
  },
  "& .highcharts-minor-grid-line": { stroke: "#f2f2f2" },
  // Overridden
  "& .highcharts-tick": { stroke: "#ccd6eb" },
  // Inherited
  "& .highcharts-xaxis-grid .highcharts-grid-line": { strokeWidth: "0px" },
  // Inherited
  "& .highcharts-yaxis .highcharts-axis-line": { strokeWidth: "0" },
  "& .highcharts-yaxis .highcharts-tick": { strokeWidth: "0" }
});

// Cartesian/getStyles/LEGEND_HOVER_AFFECTS_POINTS_AND_SERIES.ts
var import_uik466 = require("@appd/uik");
var LEGEND_HOVER_AFFECTS_POINTS_AND_SERIES = import_uik466.css.Styles({
  "& .highcharts-legend-series-active g.highcharts-series:not(.highcharts-series-hover), & .highcharts-legend-point-active .highcharts-point:not(.highcharts-point-hover), & .highcharts-legend-series-active .highcharts-markers:not(.highcharts-series-hover), & .highcharts-legend-series-active .highcharts-data-labels:not(.highcharts-series-hover)": { opacity: "0.2" },
  // Inherited
  "& g.highcharts-series, & .highcharts-point, & .highcharts-markers, & .highcharts-data-labels": (
    // (object-curly-newline)
    { transition: "opacity 250ms" }
  )
});

// Cartesian/getStyles/ROOT.ts
var import_uik467 = require("@appd/uik");
var ROOT = import_uik467.css.Styles({
  "& .highcharts-anchor": { cursor: "pointer" },
  // Overridden
  "& .highcharts-background": { fill: "#ffffff" },
  "& .highcharts-button-box": { fill: "inherit" },
  "& .highcharts-container": {
    fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',
    fontSize: "12px",
    height: "100%",
    lineHeight: "normal",
    outline: "none",
    overflow: "hidden",
    position: "relative",
    textAlign: "left",
    touchAction: "manipulation",
    userSelect: "none",
    /* #1072 */
    webkitTapHighlightColor: "rgba(0, 0, 0, 0)",
    width: "100%",
    zIndex: "0"
  },
  "& .highcharts-emphasized": { fontStyle: "italic" },
  "& .highcharts-label-box": { fill: "none" },
  // Overridden
  "& .highcharts-plot-border, & .highcharts-plot-background": { fill: "none" },
  // Inherited
  "& .highcharts-root": { display: "block" },
  "& .highcharts-root text": { strokeWidth: "0" },
  "& .highcharts-strong": { fontWeight: "bold" },
  // Overridden when series is `arearange` type
  "& .highcharts-tracker-area": {
    fill: "rgba(192, 192, 192, 0.0001)",
    strokeWidth: "0"
  },
  // Inherited
  "& .highcharts-tracker-line": {
    fill: "none",
    stroke: "rgba(192, 192, 192, 0.0001)",
    strokeLinejoin: "round",
    strokeWidth: "22"
  }
});

// Cartesian/getStyles/SERIES_OPTIONS_AND_DEFAULT_COLORS.ts
var import_uik468 = require("@appd/uik");
var {
  COLORS: { CONTROL_BORDER_WEAK: CONTROL_BORDER_WEAK3, CONTROL_ICON }
} = import_uik468.MAGNETIC_TOKENS;
var SERIES_OPTIONS_AND_DEFAULT_COLORS = import_uik468.css.Styles({
  "& .highcharts-a11y-markers-hidden .highcharts-point:not(.highcharts-point-hover):not(.highcharts-a11y-marker-visible), & .highcharts-a11y-marker-hidden": { opacity: "0" },
  "& .highcharts-area": {
    fillOpacity: "0.75",
    strokeWidth: "0"
  },
  // "& .highcharts-color-0": {
  //   fill: "#7cb5ec",
  //   stroke: "#7cb5ec",
  // },
  // "& .highcharts-color-1": {
  //   fill: "#434348",
  //   stroke: "#434348",
  // },
  // "& .highcharts-color-2": {
  //   fill: "#90ed7d",
  //   stroke: "#90ed7d",
  // },
  // "& .highcharts-color-3": {
  //   fill: "#f7a35c",
  //   stroke: "#f7a35c",
  // },
  // "& .highcharts-color-4": {
  //   fill: "#8085e9",
  //   stroke: "#8085e9",
  // },
  // "& .highcharts-color-5": {
  //   fill: "#f15c80",
  //   stroke: "#f15c80",
  // },
  // "& .highcharts-color-6": {
  //   fill: "#e4d354",
  //   stroke: "#e4d354",
  // },
  // "& .highcharts-color-7": {
  //   fill: "#2b908f",
  //   stroke: "#2b908f",
  // },
  // "& .highcharts-color-8": {
  //   fill: "#f45b5b",
  //   stroke: "#f45b5b",
  // },
  // "& .highcharts-color-9": {
  //   fill: "#91e8e1",
  //   stroke: "#91e8e1",
  // },
  // Inherited
  "& .highcharts-column-series .highcharts-point": { transition: "fill-opacity 250ms" },
  // Overridden
  "& .highcharts-column-series .highcharts-point-hover": {
    fillOpacity: "0.75",
    transition: "fill-opacity 50ms"
  },
  "& .highcharts-column-series rect.highcharts-point": { stroke: CONTROL_ICON },
  // "& .highcharts-data-label": {
  //   fontSize: "0.9em",
  //   fontWeight: "bold",
  // },
  // "& .highcharts-data-label text, & text.highcharts-data-label": {
  //   fill: "#333333",
  // },
  // "& .highcharts-data-label-box": {
  //   fill: "none",
  //   strokeWidth: "0",
  // },
  // "& .highcharts-data-label-connector": {
  //   fill: "none",
  // },
  // "& .highcharts-data-label-hidden": {
  //   pointerEvents: "none",
  // },
  // "& .highcharts-dense-data .highcharts-point": {
  //   strokeWidth: "0",
  // },
  "& .highcharts-focus-border": {
    fill: "none",
    strokeWidth: "2px"
  },
  // "& .highcharts-funnel-series .highcharts-point": {
  //   stroke: "#ffffff",
  //   strokeLinejoin: "round",
  // },
  // "& .highcharts-funnel-series .highcharts-point-hover": {
  //   fillOpacity: "0.75",
  //   transition: "fill-opacity 50ms",
  // },
  // "& .highcharts-funnel-series .highcharts-point-select": {
  //   fill: "inherit",
  //   stroke: "inherit",
  // },
  "& .highcharts-halo": {
    fillOpacity: "0",
    strokeWidth: "0"
  },
  // "& .highcharts-legend-item-hidden .highcharts-focus-border": {
  //   fill: "none !important",
  // },
  // "& .highcharts-lollipop-stem": {
  //   stroke: "#000000",
  // },
  "& .highcharts-markers": {
    stroke: CONTROL_BORDER_WEAK3,
    strokeWidth: "1px"
  },
  // "& .highcharts-pie-series .highcharts-point": {
  //   stroke: "#ffffff",
  //   strokeLinejoin: "round",
  // },
  // "& .highcharts-pie-series .highcharts-point-hover": {
  //   fillOpacity: "0.75",
  //   transition: "fill-opacity 50ms",
  // },
  "& .highcharts-point": { strokeWidth: "1px" },
  // "& .highcharts-pyramid-series .highcharts-point": {
  //   stroke: "#ffffff",
  //   strokeLinejoin: "round",
  // },
  // "& .highcharts-pyramid-series .highcharts-point-hover": {
  //   fillOpacity: "0.75",
  //   transition: "fill-opacity 50ms",
  // },
  // "& .highcharts-pyramid-series .highcharts-point-select": {
  //   fill: "inherit",
  //   stroke: "inherit",
  // },
  "& .highcharts-series:not(.highcharts-pie-series) .highcharts-point-select, & .highcharts-markers .highcharts-point-select": {
    fill: "#cccccc",
    stroke: CONTROL_BORDER_WEAK3
  }
  // "& .highcharts-solidgauge-series .highcharts-point": {
  //   strokeWidth: "0",
  // },
  // "& .highcharts-treemap-series .highcharts-above-level": {
  //   display: "none",
  // },
  // "& .highcharts-treemap-series .highcharts-internal-node": {
  //   fill: "none",
  // },
  // "& .highcharts-treemap-series .highcharts-internal-node-interactive": {
  //   cursor: "pointer",
  //   fillOpacity: "0.15",
  // },
  // "& .highcharts-treemap-series .highcharts-internal-node-interactive:hover": {
  //   fillOpacity: "0.75",
  // },
  // "& .highcharts-treemap-series .highcharts-point": {
  //   stroke: "#e6e6e6",
  //   strokeWidth: "1px",
  //   transition: "stroke 250ms, fill 250ms, fill-opacity 250ms",
  // },
  // "& .highcharts-treemap-series .highcharts-point-hover": {
  //   stroke: "#999999",
  //   transition: "stroke 25ms, fill 25ms, fill-opacity 25ms",
  // },
  // "& .highcharts-vector-series .highcharts-point": {
  //   fill: "none",
  //   strokeWidth: "2px",
  // },
  // "& .highcharts-windbarb-series .highcharts-point": {
  //   fill: "none",
  //   strokeWidth: "2px",
  // },
});

// Cartesian/getStyles/TOOLTIP.ts
var import_uik469 = require("@appd/uik");
var TOOLTIP = import_uik469.css.Styles({
  // Inherited
  "& .highcharts-empty-series": {
    fill: "none",
    stroke: "#cccccc",
    strokeWidth: "1px"
  },
  // Inherited
  "& .highcharts-graph": {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px"
  },
  // Inherited
  "& .highcharts-point-inactive": {
    opacity: "0.2",
    transition: "opacity 50ms"
    /* quick in */
  },
  // Inherited
  "& .highcharts-selection-marker": {
    fill: "#335cad",
    fillOpacity: "0.25"
  },
  // Inherited
  "& .highcharts-series-inactive": {
    opacity: "0.2",
    transition: "opacity 50ms"
    /* quick in */
  },
  // Inherited
  "& .highcharts-state-hover .highcharts-graph": { strokeWidth: "3" },
  // Inherited
  "& .highcharts-state-hover path": {
    transition: "stroke-width 50ms"
    /* quick in */
  },
  // Inherited
  "& .highcharts-state-normal path": {
    transition: "stroke-width 250ms"
    /* slow out */
  },
  "& .highcharts-tooltip": {
    cursor: "default",
    pointerEvents: "none",
    transition: "stroke 150ms",
    whiteSpace: "nowrap"
  },
  "& .highcharts-tooltip .highcharts-header": { fontSize: "0.85em" },
  "& .highcharts-tooltip text": { fill: "#333333" },
  "& .highcharts-tooltip-box": {
    fill: "#f7f7f7",
    fillOpacity: "0.85",
    strokeWidth: "1px"
  },
  "& .highcharts-tooltip-box .highcharts-label-box": {
    fill: "#f7f7f7",
    fillOpacity: "0.85"
  },
  "& div.highcharts-tooltip": { filter: "none" }
});

// Cartesian/getStyles/getStyles.ts
var {
  COLORS: {
    CONTROL_BG_WEAK: CONTROL_BG_WEAK2,
    CONTROL_BORDER,
    CONTROL_BORDER_STRONG,
    CONTROL_BORDER_WEAK: CONTROL_BORDER_WEAK4,
    DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM3,
    INTERACT_BORDER_FOCUS
  },
  TYPOGRAPHY: { P3_DEFAULT: P3_DEFAULT4, P4_DEFAULT: P4_DEFAULT2, P4_EMPHASIS: P4_EMPHASIS2 }
} = import_uik470.MAGNETIC_TOKENS;
var getStyles5 = /* @__PURE__ */ __name(({
  colors,
  empty,
  series,
  yAxis
}) => ({
  CHART: import_uik470.css.Styles({
    ...{
      // ...AXES,
      "& .highcharts-axis-labels": {
        ...AXES["& .highcharts-axis-labels"],
        fill: DEFAULT_TEXT_MEDIUM3,
        font: P4_DEFAULT2
      },
      "& .highcharts-axis-title": {
        fill: DEFAULT_TEXT_MEDIUM3,
        // ...AXES["& .highcharts-axis-title"],
        font: P4_EMPHASIS2
      },
      "& .highcharts-crosshair": {
        stroke: CONTROL_BORDER_STRONG,
        strokeWidth: 2
      },
      "& .highcharts-grid-line, & .highcharts-xaxis .highcharts-axis-line": {
        ...AXES["& .highcharts-grid-line"],
        stroke: CONTROL_BORDER_WEAK4
      },
      "& .highcharts-tick": {
        // ...AXES["& .highcharts-tick"],
        stroke: "transparent"
      },
      "& .highcharts-xaxis-grid .highcharts-grid-line": {
        ...AXES["& .highcharts-xaxis-grid .highcharts-grid-line"],
        strokeWidth: 1
      },
      "& .highcharts-yaxis .highcharts-axis-line": AXES["& .highcharts-yaxis .highcharts-axis-line"],
      "& .highcharts-yaxis-grid .highcharts-grid-line": {
        stroke: yAxis.gridLineColor,
        strokeDasharray: DASH_STYLES["ShortDash"],
        strokeWidth: 1
      }
    },
    ...{
      // ...LEGEND_HOVER_AFFECTS_POINTS_AND_SERIES,
      "& g.highcharts-series, & .highcharts-point, & .highcharts-markers, & .highcharts-data-labels": LEGEND_HOVER_AFFECTS_POINTS_AND_SERIES["& g.highcharts-series, & .highcharts-point, & .highcharts-markers, & .highcharts-data-labels"]
    },
    ...{
      // ...ROOT,
      "& .highcharts-background": {
        // ...ROOT["& .highcharts-background"],
        fill: "transparent"
      },
      "& .highcharts-plot-border, & .highcharts-plot-background": {
        // ...ROOT["& .highcharts-plot-border, & .highcharts-plot-background"],
        fill: "transparent"
      },
      "& .highcharts-root": {
        ...empty ? { height: 0 } : {},
        ...ROOT["& .highcharts-root"],
        // Browser sets `svg:not(:root) { overflow: hidden }` by default.
        // Revert this so that text won't be clipped from bad Highcharts text measurements.
        overflow: "initial"
      },
      "& .highcharts-tracker-line": ROOT["& .highcharts-tracker-line"]
    },
    ...{
      // ...SERIES_OPTIONS_AND_DEFAULT_COLORS,
      // Customizations for TMNT-4632.
      "& .highcharts-column-series .highcharts-point": {
        ...SERIES_OPTIONS_AND_DEFAULT_COLORS["& .highcharts-column-series .highcharts-point"],
        "&.hover": {
          fillOpacity: 0.5,
          transition: "fill-opacity 50ms"
        },
        "&.inactive": { fillOpacity: 0.25 },
        "&.normal, &.select": { fillOpacity: 1 }
      },
      "& .highcharts-data-labels.uik-threshold": { outline: "transparent" },
      "& .highcharts-halo": SERIES_OPTIONS_AND_DEFAULT_COLORS["& .highcharts-halo"],
      // Duplicate class name to raise specificity above `.highcarts-color-${i}`.
      "& .highcharts-markers.highcharts-markers": SERIES_OPTIONS_AND_DEFAULT_COLORS["& .highcharts-markers"],
      "& .highcharts-series.uik-threshold": { strokeDasharray: DASH_STYLES["DashDot"] },
      "& .uik-threshold-data-labels": {
        "& text": { fill: DEFAULT_TEXT_MEDIUM3 },
        fill: "transparent",
        outline: "transparent",
        stroke: "transparent"
      },
      ...Object.fromEntries([
        ...colors.map((color2, i) => {
          const { custom, type } = series[i] ?? {};
          const hasThreshold = custom?.threshold != void 0;
          const hasVerticalThreshold = custom?.thresholdOptions?.xAxis;
          const thresholdColor = custom?.thresholdOptions?.color ? custom?.thresholdOptions?.color : CONTROL_BORDER;
          return [
            [
              `& .highcharts-color-${i}`,
              `& .highcharts-color-${i}.highcharts-point`,
              type === "arearange" && "& .highcharts-tracker-area"
            ].filter(Boolean).join(","),
            {
              fill: color2,
              stroke: color2,
              ...type === "arearange" && {
                fillOpacity: 0.24,
                stroke: void 0
              },
              ...hasThreshold && {
                fill: thresholdColor,
                stroke: thresholdColor
              },
              ...hasVerticalThreshold && { outline: `1px solid ${CONTROL_BG_WEAK2}` }
            }
          ];
        }),
        ...series.map((ser, i) => [
          [`& .highcharts-color-${i}.highcharts-point`],
          {
            ...ser.type === "scatter" && {
              "&.highcharts-point-select": {
                stroke: INTERACT_BORDER_FOCUS,
                strokeWidth: 3
              }
            },
            cursor: ser.allowPointSelect ? "pointer" : "default"
          }
        ]),
        ...series.map((ser, i) => [
          [`& .highcharts-series-${i}`],
          { strokeDasharray: DASH_STYLES[ser.dashStyle ?? "Solid"] }
        ]),
        ...series.map((_ser, i) => [
          `& .highcharts-series-${i} > .highcharts-area`,
          {
            fill: `url(#series-gradient-${i})`,
            stroke: "none"
          }
        ]),
        [`& .highcharts-area-series > .highcharts-graph`, { strokeWidth: 3 }]
      ])
    },
    ...{
      // ...TITLES,
      "& .highcharts-title": {
        fill: DEFAULT_TEXT_MEDIUM3,
        // ...TITLES["& .highcharts-title"],
        font: P3_DEFAULT4
      }
    },
    ...{
      // ...TOOLTIP,
      "& .highcharts-empty-series": TOOLTIP["& .highcharts-empty-series"],
      "& .highcharts-graph": TOOLTIP["& .highcharts-graph"],
      "& .highcharts-point-inactive": TOOLTIP["& .highcharts-point-inactive"],
      "& .highcharts-selection-marker": TOOLTIP["& .highcharts-selection-marker"],
      // Disable for column and flags series.
      // https://bitbucket.corp.appdynamics.com/projects/TMNT/repos/next-ui-levitate/pull-requests/968/overview?commentId=659079
      "& .highcharts-series-inactive:not(.highcharts-column-series):not(.highcharts-flags-series)": TOOLTIP["& .highcharts-series-inactive"],
      "& .highcharts-state-hover .highcharts-graph": TOOLTIP["& .highcharts-state-hover .highcharts-graph"],
      "& .highcharts-state-hover path": TOOLTIP["& .highcharts-state-hover path"],
      "& .highcharts-state-normal path": TOOLTIP["& .highcharts-state-normal path"]
    },
    ...{
      // No upstream styles. (TMNT-5081)
      "& .highcharts-reset-zoom": { display: "none" }
    },
    all: void 0,
    height: "100%",
    // Don't trigger overflow in a flex container. (https://stackoverflow.com/a/66689926/3624264)
    ...{
      minHeight: 0,
      minWidth: 0
    },
    // Highcharts sets this as an inline style despite "styled mode" guarantee.
    overflow: "initial !important"
  }),
  HOST: import_uik470.css.Styles({
    "--no-data-max-height": 34,
    display: "flex",
    flexDirection: "column",
    // Take up available space in a flex container.
    flexGrow: 1,
    // Default height.
    height: "100%",
    // height of default `noDataIllustration`
    maxHeight: empty ? "var(--no-data-max-height)" : void 0,
    position: "relative",
    // Don't trigger overflow in a flex container. (https://stackoverflow.com/a/66689926/3624264)
    ...{
      minHeight: 0,
      minWidth: 0
    }
  })
}), "getStyles");
var DASH_STYLES = {
  Dash: [8, 6],
  DashDot: [4, 4, 1, 4],
  Dot: [2, 6],
  LongDash: [16, 6],
  LongDashDot: [16, 6, 2, 6],
  LongDashDotDot: [16, 6, 2, 6, 2, 6],
  ShortDash: [6, 2],
  ShortDashDot: [6, 2, 2, 2],
  ShortDashDotDot: [6, 2, 2, 2, 2],
  ShortDot: [1, 4],
  Solid: "none"
};

// Cartesian/getYAxis/DEFAULT_FORMATTER.ts
var import_uik471 = require("@appd/uik");
var DEFAULT_FORMATTER = /* @__PURE__ */ __name((value) => import_uik471.format.number[Math.abs(Number(value)) < 1e-4 ? "long" : "short"](value, { maximumFractionDigits: 4 }), "DEFAULT_FORMATTER");

// Cartesian/getYAxis/getYAxis.ts
var getYAxis = /* @__PURE__ */ __name(({ format: maybeFormatter, labels, plotBands, title, unit: unit2, ...yAxis } = {}) => {
  const formatter = maybeFormatter ? (value) => maybeFormatter(value, DEFAULT_FORMATTER) : DEFAULT_FORMATTER;
  return {
    formatter,
    options: [
      {
        ...yAxis,
        labels: {
          enabled: labels?.enabled ?? true,
          formatter: ({ value }) => `${yAxis.prefix ?? ""}${formatter(+value)}${yAxis.suffix ?? ""}`
        },
        plotBands: plotBands?.map(({ color: color2 = "NORMAL", from: from2, to }) => ({
          className: css({
            all: void 0,
            fill: {
              [color2]: color2,
              // eslint-disable-next-line sort-keys-fix/sort-keys-fix
              CRITICAL,
              NORMAL,
              WARNING
            }[color2],
            opacity: 0.24
          }),
          from: from2,
          to
        })),
        /**
         * UIK-4783:
         * [reversedStacks](https://api.highcharts.com/highcharts/yAxis.reversedStacks)
         * Do not reversed the order of stacked columns
         */
        reversedStacks: false,
        title: { text: title ? `${title}${unit2 ? ` (${unit2})` : ""}` : "" }
      },
      ...yAxis.secondary?.map((axis) => {
        const secondaryFormatter = axis.format != void 0 ? (value) => axis.format?.(value, DEFAULT_FORMATTER) ?? "" : DEFAULT_FORMATTER;
        return {
          ...axis,
          labels: {
            enabled: axis.labels?.enabled ?? true,
            formatter: ({ value }) => `${axis.prefix ?? ""}${secondaryFormatter(+value)}${axis.suffix ?? ""}`
          },
          title: { text: axis.title ? `${axis.title}${axis.unit ? ` (${axis.unit})` : ""}` : "" }
        };
      }) ?? []
    ]
  };
}, "getYAxis");
var {
  STATIC: { CRITICAL, NORMAL, WARNING }
} = MAGNETIC_TOKENS;

// Cartesian/Histogram.tsx
var import_uik472 = require("@appd/uik");
var import_react19 = require("react");
var Histogram2 = /* @__PURE__ */ __name(({ data, flags, name, stackGroup, visible }) => {
  const setSeries = (0, import_react19.useContext)(CONTEXT3);
  import_uik472.utils.useLayoutEffect(
    () => setSeries(
      Flag.withSeries({
        maybeFlag: flags,
        series: {
          borderWidth: 0,
          crisp: false,
          data: [...data],
          groupPadding: 0,
          name,
          pointPadding: 0.05,
          stack: stackGroup,
          type: "column",
          visible
        }
      })
    )
  );
  return null;
}, "Histogram");
Histogram2.displayName = "Cartesian.Histogram";

// Cartesian/Line/Line.tsx
var import_uik473 = require("@appd/uik");
var import_react20 = require("react");

// Cartesian/Line/withOrphanMarkers.tsx
var withOrphanMarkers = /* @__PURE__ */ __name((data) => data?.map(
  (point, i, { [i - 1]: previous, [i + 1]: next }) => !Number.isFinite(previous?.y) && Number.isFinite(point.y) && !Number.isFinite(next?.y) ? {
    ...point,
    marker: { enabled: true }
  } : point
), "withOrphanMarkers");

// Cartesian/Line/Line.tsx
var Line2 = /* @__PURE__ */ __name(({
  dashStyle = "Solid",
  data,
  marker = { enabled: false },
  name,
  spline = false,
  step,
  threshold,
  thresholdOptions,
  visible,
  yAxis
}) => {
  const setSeries = (0, import_react20.useContext)(CONTEXT3);
  import_uik473.utils.useLayoutEffect(
    () => setSeries([
      {
        crisp: true,
        custom: threshold !== void 0 ? {
          threshold,
          thresholdOptions
        } : void 0,
        dashStyle,
        // https://www.figma.com/file/z5Q0CdBAuyBsf0jP2JIeNX/%F0%9F%85%BF%EF%B8%8F-Particle---03---%F0%9F%93%8A-Charts-%26-Graphs?node-id=2682%3A35870
        data: withOrphanMarkers(data),
        marker,
        name,
        step: step ? "left" : void 0,
        type: spline ? "spline" : "line",
        visible,
        yAxis
      }
    ])
  );
  return null;
}, "Line");
Line2.displayName = "Cartesian.Line";

// Cartesian/MESSAGES.ts
var import_uik474 = require("@appd/uik");
var MESSAGES2 = {
  // (object-curly-newline)
  NO_DATA: import_uik474.format.message`No data for this timeframe`.description("An indicator of there being no data in the chart.")
};

// Cartesian/OPTIONS.ts
var import_uik475 = require("@appd/uik");
var { SPACING: SPACING6 } = import_uik475.MAGNETIC_TOKENS;
var OPTIONS = import_uik475.utils.infer().from({
  accessibility: { enabled: (
    /* TODO Maybe later, requires sifting through the `getStyles/@unused` folder. */
    false
  ) },
  chart: {
    spacingBottom: 0,
    spacingLeft: 0,
    spacingRight: 0,
    spacingTop: SPACING6[4],
    styledMode: true
  },
  credits: { enabled: false },
  legend: { enabled: false },
  // https://api.highcharts.com/highcharts/plotOptions.series.animation
  ...import_uik475.utils.PREFERS_REDUCED_MOTION && { plotOptions: { series: { animation: false } } },
  title: { align: "left" }
});

// Cartesian/Provider.tsx
var import_react21 = require("react");
var import_jsx_runtime426 = require("react/jsx-runtime");
var Provider2 = /* @__PURE__ */ __name(({ children }) => {
  const [marginLeft, setMarginLeft] = (0, import_react21.useState)();
  return /* @__PURE__ */ (0, import_jsx_runtime426.jsx)(
    CONTEXT4.Provider,
    {
      value: {
        marginLeft,
        setMarginLeft
      },
      children
    }
  );
}, "Provider");
Provider2.displayName = "Cartesian.Provider";

// Cartesian/Scatter.tsx
var import_uik476 = require("@appd/uik");
var import_react22 = require("react");
var Scatter2 = /* @__PURE__ */ __name(({ allowPointSelect, data, marker, name, visible, yAxis }) => {
  const setSeries = (0, import_react22.useContext)(CONTEXT3);
  import_uik476.utils.useLayoutEffect(
    () => setSeries([
      {
        allowPointSelect,
        crisp: true,
        data: [...data],
        marker: { ...marker },
        name,
        states: {
          select: {
            enabled: allowPointSelect,
            lineWidthPlus: 4
          }
        },
        type: "scatter",
        visible,
        yAxis
      }
    ])
  );
  return null;
}, "Scatter");
Scatter2.displayName = "Cartesian.Scatter";

// Cartesian/useChart.ts
var import_uik478 = require("@appd/uik");
var import_react24 = require("react");

// HIGHCHARTS/HIGHCHARTS.ts
var import_uik477 = require("@appd/uik");
var import_react23 = require("react");

// HIGHCHARTS/SHAPES.tsx
var import_jsx_runtime427 = require("react/jsx-runtime");
var SHAPES = {
  BASELINE: /* @__PURE__ */ (0, import_jsx_runtime427.jsxs)("svg", { viewBox: "0 0 1 1", children: [
    /* @__PURE__ */ (0, import_jsx_runtime427.jsx)("rect", { height: 0.2, width: 0.2, x: 0.1, y: 0.4 }),
    /* @__PURE__ */ (0, import_jsx_runtime427.jsx)("rect", { height: 0.2, width: 0.2, x: 0.4, y: 0.4 }),
    /* @__PURE__ */ (0, import_jsx_runtime427.jsx)("rect", { height: 0.2, width: 0.2, x: 0.7, y: 0.4 })
  ] }),
  CIRCLE: /* @__PURE__ */ (0, import_jsx_runtime427.jsx)("svg", { viewBox: "0 0 1 1", children: /* @__PURE__ */ (0, import_jsx_runtime427.jsx)("circle", { cx: 0.5, cy: 0.5, r: 0.5 }) }),
  DIAMOND: /* @__PURE__ */ (0, import_jsx_runtime427.jsx)("svg", { viewBox: "0 0 1 1", children: /* @__PURE__ */ (0, import_jsx_runtime427.jsx)(
    "polygon",
    {
      points: [
        [0.5, 0],
        [1, 0.5],
        [0.5, 1],
        [0, 0.5]
      ].join(" ")
    }
  ) }),
  PENTAGON: /* @__PURE__ */ (0, import_jsx_runtime427.jsx)("svg", { viewBox: "0 0 1 1", children: /* @__PURE__ */ (0, import_jsx_runtime427.jsx)(
    "polygon",
    {
      points: [...Array(5).keys()].map(
        (i) => [
          0.5 + 0.5 * Math.cos((i * -72 + 90) * Math.PI / 180),
          0.5 - 0.5 * Math.sin((i * -72 + 90) * Math.PI / 180)
        ].map((t) => +t.toFixed(6))
      ).join(" ")
    }
  ) }),
  PERCENTILE: /* @__PURE__ */ (0, import_jsx_runtime427.jsxs)("svg", { viewBox: "0 0 1 1", children: [
    /* @__PURE__ */ (0, import_jsx_runtime427.jsx)("rect", { height: 0.2, width: 0.2, y: 0.4 }),
    /* @__PURE__ */ (0, import_jsx_runtime427.jsx)("rect", { height: 0.2, width: 0.4, x: 0.3, y: 0.4 }),
    /* @__PURE__ */ (0, import_jsx_runtime427.jsx)("rect", { height: 0.2, width: 0.2, x: 0.8, y: 0.4 })
  ] }),
  SQUARE: /* @__PURE__ */ (0, import_jsx_runtime427.jsx)("svg", { viewBox: "0 0 1 1", children: /* @__PURE__ */ (0, import_jsx_runtime427.jsx)("rect", { height: 1, width: 1, x: 0, y: 0 }) }),
  TREND: /* @__PURE__ */ (0, import_jsx_runtime427.jsxs)("svg", { viewBox: "0 0 1 1", children: [
    /* @__PURE__ */ (0, import_jsx_runtime427.jsx)("rect", { height: 0.1, width: 0.7, y: 0.45 }),
    /* @__PURE__ */ (0, import_jsx_runtime427.jsx)(
      "polygon",
      {
        points: [
          [0.7, 0.35],
          [1, 0.5],
          [0.7, 0.65]
        ].join(" ")
      }
    )
  ] }),
  TRIANGLE: /* @__PURE__ */ (0, import_jsx_runtime427.jsx)("svg", { viewBox: "0 0 1 1", children: /* @__PURE__ */ (0, import_jsx_runtime427.jsx)(
    "polygon",
    {
      points: [
        [0.5, 0],
        [1, 1],
        [0, 1]
      ].join(" ")
    }
  ) }),
  TRIANGLE_DOWN: /* @__PURE__ */ (0, import_jsx_runtime427.jsx)("svg", { viewBox: "0 0 1 1", children: /* @__PURE__ */ (0, import_jsx_runtime427.jsx)(
    "polygon",
    {
      points: [
        [0, 0],
        [1, 0],
        [0.5, 1]
      ].join(" ")
    }
  ) }),
  // Keep in sync with `PENTAGON` above.
  registerPentagon: (SVGRenderer) => {
    SVGRenderer.prototype.symbols.pentagon ??= (x, y, w, h) => [
      ...[...Array(5).keys()].map(
        (i) => [
          x + w * (0.5 + 0.5 * Math.cos((i * -72 + 90) * Math.PI / 180)),
          y + h * (0.5 - 0.5 * Math.sin((i * -72 + 90) * Math.PI / 180))
        ].map((t) => +t.toFixed(6))
      ).flatMap(([x2, y2], i) => [i === 0 ? "M" : "L", x2, y2]),
      "z"
    ];
  }
};

// HIGHCHARTS/HIGHCHARTS.ts
var HIGHCHARTS = /* @__PURE__ */ __name(() => RESOLVED() ?? void LOAD.then(RESOLVED.set), "HIGHCHARTS");
HIGHCHARTS.SHAPES = SHAPES;
HIGHCHARTS.use = () => {
  const [, rerender] = (0, import_react23.useReducer)(() => true, false);
  (0, import_react23.useEffect)(() => RESOLVED.subscribe(rerender), []);
  return HIGHCHARTS();
};
var LOAD = import_uik477.utils.CAN_USE_DOM ? import_uik477.utils.lazyPromise(async () => {
  const [_, highstock, more, solidGauge] = await Promise.all([
    import("highcharts"),
    import("highcharts/highstock"),
    import("highcharts/highcharts-more"),
    import("highcharts/modules/solid-gauge")
  ]);
  more.default(highstock);
  solidGauge.default(highstock);
  SHAPES.registerPentagon(highstock.SVGRenderer);
  if (import_uik477.utils.IS_JEST) {
    SVGElement.prototype.getBBox ??= () => ({
      height: 0,
      width: 0,
      x: 0,
      y: 0
    });
  }
  return highstock;
}) : (
  // Don't fetch on server due to errors like
  // TypeError: Cannot read properties of undefined (reading 'Core/Chart/Chart.js')
  new Promise(() => {
  })
);
var RESOLVED = import_uik477.utils.mutable(void 0);

// Cartesian/useChart.ts
var useChart = /* @__PURE__ */ __name(({ column, isEmpty, isReady, options }) => {
  const chartRef = (0, import_react24.useRef)(null);
  const ref = (0, import_react24.useRef)(null);
  const fontsReady = import_uik478.utils.useFontsReady();
  const Highcharts = HIGHCHARTS.use();
  const { isInViewport } = INTERSECTION_OBSERVER().use(ref);
  const dependencies = [
    column?.selectable,
    fontsReady,
    Highcharts,
    isEmpty,
    isInViewport,
    isReady,
    ref.current,
    options
  ];
  const changes = (0, import_react24.useRef)().current ??= import_uik478.utils.cell.initWithInput(void 0, options);
  (0, import_react24.useEffect)(() => {
    const { current: container } = ref;
    if (!container || !fontsReady || !Highcharts || !isReady || !isInViewport) {
      return;
    }
    if (!chartRef.current) {
      chartRef.current = Highcharts.chart(container, options);
    } else {
      import_uik478.utils.cell(changes, { options }, () => {
        chartRef.current?.update(
          options,
          /* redraw */
          true,
          /* oneToOne */
          true,
          /* animation */
          true
        );
      });
    }
    return import_uik478.utils.resizeObserver(container, () => chartRef.current?.reflow());
  }, dependencies);
  return {
    chartRef: (
      // Invalidate referential identity whenever `useEffect` retriggers, by using the same `dependencies`.
      (0, import_react24.useMemo)(
        () => ({
          get current() {
            return chartRef.current;
          }
        }),
        dependencies
      )
    ),
    ref
  };
}, "useChart");
var INTERSECTION_OBSERVER = import_uik478.utils.lazyConstant(() => {
  const SUPPORTS_INTERSECTION_OBSERVER = Boolean(globalThis.IntersectionObserver);
  const observer = SUPPORTS_INTERSECTION_OBSERVER ? new IntersectionObserver(
    (entries) => entries.forEach((entry) => {
      const callback = CALLBACKS.get(entry.target);
      callback?.(entry.isIntersecting);
    }),
    { threshold: [0] }
  ) : {
    observe: import_uik478.utils.noop,
    unobserve: import_uik478.utils.noop
  };
  const CALLBACKS = /* @__PURE__ */ new WeakMap();
  const subscribe2 = /* @__PURE__ */ __name((element, callback) => {
    if (!element) {
      return;
    }
    CALLBACKS.set(element, callback);
    observer.observe(element);
    return () => {
      observer.unobserve(element);
      CALLBACKS.delete(element);
    };
  }, "subscribe");
  const use = /* @__PURE__ */ __name((ref) => {
    const [isInViewport, setIsInViewport] = (0, import_react24.useState)(false);
    import_uik478.utils.useEffect(() => subscribe2(ref.current, setIsInViewport), [ref.current]);
    return { isInViewport: isInViewport || !SUPPORTS_INTERSECTION_OBSERVER };
  }, "use");
  return Object.assign(observer, {
    CALLBACKS,
    subscribe: subscribe2,
    use
  });
});

// Cartesian/useChildren.tsx
var import_uik479 = require("@appd/uik");
var import_react25 = require("react");
var import_jsx_runtime428 = require("react/jsx-runtime");
var useChildren = /* @__PURE__ */ __name((rawChildren) => {
  const [maybeSeries, setSeries] = (0, import_react25.useReducer)(
    ({ value }, [i, data, length]) => {
      value[i] = data;
      value.length = length;
      return { value };
    },
    { value: [] }
  );
  const elements = (0, import_react25.useMemo)(
    () => import_react25.Children.toArray(rawChildren).filter((child) => (0, import_react25.isValidElement)(child)).map((child, i, { length }) => /* @__PURE__ */ (0, import_jsx_runtime428.jsx)(CONTEXT3.Provider, { value: (data) => setSeries([i, data, length]), children: child }, i)),
    [rawChildren]
  );
  const rawSeriesGroups = (0, import_react25.useMemo)(
    () => maybeSeries.value.slice(0, elements.length).filter(import_uik479.utils.Boolean),
    [maybeSeries, elements.length]
  );
  const rawSeries = (0, import_react25.useMemo)(() => rawSeriesGroups.flat(), [rawSeriesGroups]);
  const isEmpty = (0, import_react25.useMemo)(() => rawSeries.every(({ data: { length } = {} }) => !length), [rawSeries]);
  const isReady = elements.length === rawSeriesGroups.length;
  return {
    elements,
    isEmpty,
    isReady,
    rawSeries
  };
}, "useChildren");

// Cartesian/useColors.tsx
var import_react26 = require("react");

// Cartesian/DEFAULT_COLORS_WITH_AREA_AND_BASELINE.ts
var import_uik480 = require("@appd/uik");
var {
  COLORS: {
    ACCENT_A: ACCENT_A2,
    ACCENT_B: ACCENT_B2,
    ACCENT_C: ACCENT_C2,
    ACCENT_D: ACCENT_D2,
    ACCENT_F: ACCENT_F2,
    ACCENT_G: ACCENT_G2,
    ACCENT_H: ACCENT_H2,
    ACCENT_I: ACCENT_I2,
    ACCENT_J: ACCENT_J2,
    CONTROL_BORDER: CONTROL_BORDER2,
    DEFAULT_BORDER_STRONG
  }
} = import_uik480.MAGNETIC_TOKENS;
var DEFAULT_COLORS_WITH_AREA_AND_BASELINE = import_uik480.utils.infer().from([
  CONTROL_BORDER2,
  DEFAULT_BORDER_STRONG,
  ACCENT_A2,
  ACCENT_B2,
  ACCENT_C2,
  ACCENT_D2,
  ACCENT_F2,
  ACCENT_G2,
  ACCENT_H2,
  ACCENT_I2,
  ACCENT_J2
]);

// Cartesian/useColors.tsx
var useColors = /* @__PURE__ */ __name(({ autoFillColors, children: { isEmpty, isReady, rawSeries }, rawColors }) => {
  const isAreaAndBaseline = isReady && !isEmpty && rawSeries[0].type === "arearange" && rawSeries[1]?.type === "line" && rawSeries[1].dashStyle === "ShortDot";
  return (0, import_react26.useMemo)(
    () => autoFillColors ? rawColors.concat(DEFAULT_COLORS) : rawColors == DEFAULT_COLORS && isAreaAndBaseline ? DEFAULT_COLORS_WITH_AREA_AND_BASELINE : rawColors,
    [autoFillColors, isAreaAndBaseline, rawColors]
  );
}, "useColors");

// Cartesian/useLegend.tsx
var import_uik481 = require("@appd/uik");
var import_react27 = require("react");
var import_jsx_runtime429 = require("react/jsx-runtime");
var useLegend = /* @__PURE__ */ __name(({ onSeriesSelect, options = false, series, setVisible }, {
  Layout: {
    Defaults: { HEIGHT: HEIGHT4, MARGIN: MARGIN2 }
  }
} = import_uik481.Legend) => {
  const items = (0, import_react27.useMemo)(
    () => options ? series.map(({ color: color2, name: label, shape }) => ({
      color: color2,
      kind: "DATA",
      label,
      shape
    })) : [],
    [Boolean(options), series]
  );
  const { maxRows = 2 } = typeof options === "boolean" ? {} : options;
  const maxHeight = (HEIGHT4 + MARGIN2) * maxRows - MARGIN2;
  const onSelectedChange = (0, import_react27.useCallback)(
    (seriesIndices) => {
      setVisible(seriesIndices);
      onSeriesSelect?.(seriesIndices);
    },
    [setVisible, onSeriesSelect]
  );
  return options && /* @__PURE__ */ (0, import_jsx_runtime429.jsx)(
    import_uik481.Legend,
    {
      className: (0, import_uik481.css)({
        marginTop: SPACING7[4],
        maxHeight
      }),
      items,
      onSelectedChange
    }
  );
}, "useLegend");
var { SPACING: SPACING7 } = import_uik481.MAGNETIC_TOKENS;

// Cartesian/useSeries.ts
var import_uik482 = require("@appd/uik");
var import_react28 = require("react");
var useSeries = /* @__PURE__ */ __name(({ colors, isReady, rawSeries }) => {
  const [visible, setVisible] = (0, import_react28.useReducer)(
    (_, next) => new Set(next),
    void 0,
    () => /* @__PURE__ */ new Set()
  );
  const options = (0, import_react28.useMemo)(
    () => isReady ? rawSeries.map((series, i) => ({
      ...series,
      colorIndex: i % colors.length,
      id: series.id ?? uniqueKey(),
      marker: "marker" in series ? {
        ...series.marker,
        symbol: series.marker?.symbol ?? SYMBOLS[i % SYMBOLS.length]
      } : { symbol: SYMBOLS[i % SYMBOLS.length] },
      visible: !visible.size || visible.has(i)
    })) : [],
    [isReady, rawSeries, visible]
  );
  const [resolved, setResolved] = (0, import_react28.useState)([]);
  return {
    options,
    resolved,
    setVisible,
    useResolved: (chartRef) => (0, import_react28.useEffect)(() => {
      chartRef.current && setResolved(
        chartRef.current.series.map(
          ({
            // @ts-expect-error
            // Not part of public API, but present at runtime.
            colorIndex,
            name,
            // @ts-expect-error
            // Not part of public API, but present at runtime.
            symbol,
            userOptions
          }, i) => ({
            ...options[i],
            color: userOptions?.custom?.color ? userOptions?.custom?.color : colors[colorIndex],
            name: (
              /* Highcharts assigns a default. */
              name
            ),
            shape: userOptions?.custom?.shape ? userOptions?.custom?.shape : import_uik482.utils.maybeGet(
              {
                circle: "CIRCLE",
                diamond: "DIAMOND",
                pentagon: "PENTAGON",
                square: "SQUARE",
                triangle: "TRIANGLE",
                "triangle-down": "TRIANGLE_DOWN"
              },
              symbol
            ) ?? "SQUARE",
            userOptions
          })
        )
      );
    }, [chartRef])
  };
}, "useSeries");
var SYMBOLS = ["circle", "square", "triangle", "diamond", "triangle-down", "pentagon"];
var uniqueKey = ((HASH = Math.random().toString(36).substring(2, 9), id = 0) => () => `highcharts-${HASH}-${id++}`)();

// Cartesian/useTooltip/useTooltip.tsx
var import_uik487 = require("@appd/uik");
var import_react31 = require("react");

// Cartesian/useTooltip/getPositioner.ts
var import_uik483 = require("@appd/uik");
var getPositioner = /* @__PURE__ */ __name(({ margin = 10, x, y }) => ({ defaultPositioner: defaultPositioner2, measurements: { container, content, trigger } }) => {
  const get = /* @__PURE__ */ __name((position) => defaultPositioner2({
    align: "CENTER",
    measurements: {
      container,
      content,
      trigger: {
        ...trigger,
        height: 0,
        width: 0,
        x: trigger.x + x + {
          LEFT: -margin,
          RIGHT: margin
        }[position],
        y: trigger.y + import_uik483.utils.clamp(y, [content.height / 2, trigger.height - content.height / 2])
      }
    },
    position
  }), "get");
  const candidates = {
    LEFT: get("LEFT"),
    RIGHT: get("RIGHT")
  };
  const toPlotRelative = /* @__PURE__ */ __name((left) => left + container.x - trigger.x, "toPlotRelative");
  const overflow = {
    LEFT: candidates.LEFT.actual !== "LEFT" ? (
      // Disqualify if flipped.
      Infinity
    ) : import_uik483.utils.clamp(-toPlotRelative(candidates.LEFT.left), [0]),
    RIGHT: candidates.RIGHT.actual !== "RIGHT" ? (
      // Disqualify if flipped.
      Infinity
    ) : import_uik483.utils.clamp(toPlotRelative(candidates.RIGHT.left) - (trigger.width - content.width - margin), [0])
  };
  return candidates[overflow.LEFT < overflow.RIGHT ? "LEFT" : "RIGHT"];
}, "getPositioner");

// Cartesian/useTooltip/State.ts
var State;
((State2) => {
  State2.INIITAL = {
    anchored: false,
    hoverPoints: [],
    maxHeight: 0,
    maxWidth: 0,
    points: [],
    position: {
      x: 0,
      y: 0
    },
    visible: false,
    xAxis: void 0
  };
})(State || (State = {}));

// Cartesian/useTooltip/STYLES.ts
var import_uik484 = require("@appd/uik");
var {
  COLORS: { CONTROL_BORDER: CONTROL_BORDER3, DEFAULT_BG_WEAK: DEFAULT_BG_WEAK3, DEFAULT_TEXT: DEFAULT_TEXT3 },
  EFFECTS: { SHAODW_LIFTED: SHAODW_LIFTED3 },
  RADIUS: RADIUS4,
  SPACING: SPACING8,
  TYPOGRAPHY: { BODY, ELLIPSES: ELLIPSES4, TEXT }
} = import_uik484.MAGNETIC_TOKENS;
var STYLES4 = {
  CONTENT: ({ hasSeriesName, maxHeight, maxWidth }) => (0, import_uik484.css)({
    ...{
      maxHeight,
      maxWidth,
      /**
       * Show at least a title and one row. (See `Simple (Empty)` example in Figma.)
       * ```
       * ╭─────────╮
       * │ 3:30 PM │
       * │ •   120 │
       * ╰─────────╯
       * ```
       * Has priority over `maxHeight` and `maxWidth` (https://stackoverflow.com/a/65937579/3624264).
       */
      minHeight: 60,
      minWidth: hasSeriesName ? (
        // Larger min-width if at least one series has a name (i.e. not `Simple (Empty)` case).
        150
      ) : 73
    },
    backgroundColor: DEFAULT_BG_WEAK3,
    boxSizing: "border-box",
    overflowY: "auto",
    padding: SPACING8[3]
  }),
  HEADER: (0, import_uik484.css)({
    ...TEXT.DEFAULT,
    ...ELLIPSES4.END,
    color: DEFAULT_TEXT3,
    // Allow multi-line. Not to spec (see `Scalability` > `Scrolling` case), but needed because spec doesn't know we always use full date-time.
    whiteSpace: void 0
  }),
  ROW: {
    ICON: (fill) => (0, import_uik484.css)({
      fill,
      flexShrink: 0,
      height: 10,
      width: 10
    }),
    NAME: (0, import_uik484.css)({
      ...BODY.SMALL,
      ...ELLIPSES4.END,
      color: DEFAULT_TEXT3,
      marginLeft: SPACING8[2],
      marginRight: SPACING8[3],
      // Enough space for "X…" for any letter "X".
      minWidth: 17,
      // Allow multi-line. See `Simple (Line Wrap)` example.
      whiteSpace: void 0
    }),
    // New coding pattern: Redeclare the parent property here to avoid spread at destructuring site.
    // (Similar to defining the parent file of a folder in 1-file-1-function.)
    // Allows `css()` over `css.Styles()`. Statically rendered styles save work and increase predictability.
    ROW: (0, import_uik484.css)({
      display: "flex",
      marginTop: SPACING8[2]
    }),
    VALUE: (hasSeriesName) => (0, import_uik484.css)({
      ...BODY.SMALL_LABEL,
      ...ELLIPSES4.END,
      color: DEFAULT_TEXT3,
      marginLeft: "auto",
      textAlign: "right",
      ...{
        alignSelf: "flex-start",
        flexShrink: 0,
        maxWidth: `calc(100% - ${10 + SPACING8[2] + +hasSeriesName * (17 + SPACING8[3])}px)`
      }
    })
  },
  TOOLTIP: (anchored) => (0, import_uik484.css)(
    { all: "initial" },
    {
      border: `2px solid ${CONTROL_BORDER3}`,
      borderRadius: RADIUS4.HEAVY,
      boxShadow: SHAODW_LIFTED3,
      display: "block",
      height: "max-content",
      overflow: "hidden",
      width: "max-content"
    },
    !anchored && { pointerEvents: "none" }
  )
};

// Cartesian/useTooltip/useEvents.ts
var import_uik485 = require("@appd/uik");
var useEvents = /* @__PURE__ */ __name(({ anchorable: maybeAnchorable, anchored, containerRef, setState, tooltipRef }) => import_uik485.utils.useEffect(() => {
  const anchorable = /* @__PURE__ */ __name(() => maybeAnchorable === true || maybeAnchorable === "OVERFLOW_ONLY" && (tooltip?.scrollHeight ?? 0) > (tooltip?.offsetHeight ?? 0), "anchorable");
  const { current: container } = containerRef;
  const { current: tooltip } = tooltipRef;
  return container && [
    ...maybeAnchorable ? [
      import_uik485.utils.addEventListener(document, "click", ({ clientX, clientY }) => {
        const { height: height2, width, x, y } = import_uik485.utils.getBoundingClientRect(container);
        anchorable() && setState({
          anchored: false,
          visible: clientX === import_uik485.utils.clamp(clientX, [x, x + width]) && clientY === import_uik485.utils.clamp(clientY, [y, y + height2])
        });
      }),
      import_uik485.utils.addEventListener(container, "click", (e) => {
        e.stopPropagation();
        anchorable() && setState({ anchored: !anchored });
      })
    ] : [],
    // I'd like this to be more precise (hide when leaving plot area, not just leaving the chart), but not easy.
    import_uik485.utils.addEventListener(container, "mouseleave", () => setState({ visible: false }))
  ];
}, [anchored, containerRef.current, maybeAnchorable, tooltipRef.current]), "useEvents");

// Cartesian/useTooltip/useHaloAndCrosshair.ts
var import_react29 = require("react");
var useHaloAndCrosshair = /* @__PURE__ */ __name(({ anchored, hoverPoints, xAxis }) => (0, import_react29.useEffect)(
  (frame = NaN) => {
    if (anchored && hoverPoints.length && xAxis) {
      const drawHaloAndCrossHair = /* @__PURE__ */ __name(() => {
        const hoveredSeries = new Set(hoverPoints.map((point) => point.series));
        hoverPoints[0].series?.chart.series.forEach(
          (series) => !hoveredSeries.has(series) && series.setState("inactive")
        );
        hoverPoints.forEach((point) => {
          if (point.series?.visible) {
            point.setState("hover");
            point.series.setState("hover");
          }
        });
        xAxis.drawCrosshair(void 0, hoverPoints[0]);
        frame = requestAnimationFrame(drawHaloAndCrossHair);
      }, "drawHaloAndCrossHair");
      drawHaloAndCrossHair();
      return () => {
        cancelAnimationFrame(frame);
        hoverPoints[0].series?.chart.series.forEach((series) => series.setState());
        hoverPoints.forEach((point) => point?.setState?.());
        xAxis.hideCrosshair();
      };
    }
    return void 0;
  },
  [anchored, hoverPoints, xAxis]
), "useHaloAndCrosshair");

// Cartesian/useTooltip/useOptions.ts
var import_react30 = require("react");

// Cartesian/useTooltip/getFormattedPoints.ts
var import_uik486 = require("@appd/uik");

// Cartesian/useTooltip/getPointsWithSameXValue.ts
var getPointsWithSameXValue = /* @__PURE__ */ __name((point) => point.series?.chart.series.reduce(
  (allHoveredPoints, series) => [
    ...allHoveredPoints,
    // exclude x-axis thresholds
    ...series.options.custom?.thresholdOptions?.xAxis ? [] : series.data.filter((data) => point.x === data.x || point.x === data.category)
  ],
  []
), "getPointsWithSameXValue");

// Cartesian/useTooltip/getFormattedPoints.ts
var getFormattedPoints = /* @__PURE__ */ __name((formatter, rawPoints, shared) => shared ? getPointsWithSameXValue(rawPoints[0]).map((rawPoint) => {
  const {
    series: { index, type },
    x,
    y = null
  } = rawPoint;
  return getFormattedPoint({
    formatter,
    index,
    point: rawPoint,
    type,
    x,
    y
  });
}) : rawPoints.map(
  ({ point, series: { index, type }, x, y = null }) => getFormattedPoint({
    formatter,
    index,
    point,
    type,
    x,
    y
  })
), "getFormattedPoints");
var getFormattedPoint = /* @__PURE__ */ __name(({ formatter, index, point, type, x, y }) => ({
  rawX: x ?? "",
  rawY: y,
  seriesIndex: index,
  x: formatter.x({ value: x }),
  y: type === "arearange" ? `${formatter.y(Number(import_uik486.utils.maybeGet(point, "low")))} - ${formatter.y(Number(import_uik486.utils.maybeGet(point, "high")))}` : formatter.y(y),
  ...type === "flags" && { isFlag: true }
}), "getFormattedPoint");

// Cartesian/useTooltip/useOptions.ts
var useOptions = /* @__PURE__ */ __name(({ colors, containerRef, formatter, inverted, setState, shared, triggerRef }) => (0, import_react30.useMemo)(
  () => ({
    formatter({
      chart: {
        chartHeight,
        chartWidth,
        container,
        hoverPoints,
        plotHeight,
        plotLeft,
        plotTop,
        plotWidth,
        xAxis: [xAxis]
      }
    }) {
      triggerRef.current = containerRef.current = container;
      const rawPoints = shared ? this.points ?? // Flags series or Scatter cannot get shared points with `this.points`
      (this.series.type === "flags" || this.series.userOptions.type === "scatter" ? [this] : []) : [this];
      setState({
        hoverPoints: hoverPoints ?? [],
        maxHeight: chartHeight,
        maxWidth: 0.5 * chartWidth,
        points: getFormattedPoints(formatter, rawPoints, shared),
        position: inverted ? {
          x: plotLeft + // Average of all `plotY`s.
          rawPoints.reduce(
            (sum, { point: { plotY = 0 }, series: { type } }) => sum + // Use halfway up the bar, if column.
            plotWidth - (type === "column" ? plotY / 2 : plotY),
            0
          ) / rawPoints.length,
          y: plotTop + (plotHeight - (rawPoints[0].point.plotX ?? 0))
        } : {
          x: plotLeft + (rawPoints[0]?.point.plotX ?? 0),
          y: plotTop + // Average of all `plotY`s.
          rawPoints.reduce(
            (sum, { point: { plotY = 0 }, series: { type } }) => sum + // Use halfway up the bar, if column.
            (type === "column" ? plotHeight - (plotHeight - plotY) / 2 : plotY),
            0
          ) / rawPoints.length
        },
        visible: true,
        xAxis
      });
      return false;
    },
    shared
  }),
  [colors, formatter.x, formatter.y, inverted, shared]
), "useOptions");

// Cartesian/useTooltip/useTooltip.tsx
var import_jsx_runtime430 = require("react/jsx-runtime");
var useTooltip = /* @__PURE__ */ __name(({
  colors,
  formatter,
  inverted,
  options: { anchorable = "OVERFLOW_ONLY", shared = true } = {},
  series,
  tooltipComponent
}) => {
  const [{ anchored, hoverPoints, maxHeight, maxWidth, points, position, visible, xAxis }, setState] = (0, import_react31.useReducer)(
    (old, next) => ({
      ...old,
      ...next
    }),
    State.INIITAL
  );
  const containerRef = (0, import_react31.useRef)(null);
  const triggerRef = (0, import_react31.useRef)(null);
  const tooltipRef = (0, import_react31.useRef)(null);
  const options = useOptions({
    colors,
    containerRef,
    formatter,
    inverted,
    setState,
    shared,
    triggerRef
  });
  const hasSeriesName = (0, import_react31.useMemo)(() => series.some(({ name }) => name), [series]);
  const value = (0, import_react31.useMemo)(
    () => tooltipComponent ? (0, import_react31.cloneElement)((0, import_react31.createElement)(tooltipComponent), {
      points,
      series: series.map(({ color: color2, name, shape }) => ({
        color: color2,
        name,
        shape
      }))
    }) : /* @__PURE__ */ (0, import_jsx_runtime430.jsxs)(
      import_uik487.ScrollBox,
      {
        className: CONTENT({
          hasSeriesName,
          maxHeight,
          maxWidth
        }),
        containOverlays: false,
        ref: tooltipRef,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime430.jsx)(import_uik487.Tooltip, { showOnOverflowOnly: true, value: points[0]?.x, children: /* @__PURE__ */ (0, import_jsx_runtime430.jsx)("div", { className: HEADER, children: points[0]?.x }) }),
          points.map(({ seriesIndex, y }, i) => {
            if (series == void 0 || series.length <= seriesIndex) {
              return;
            }
            const { color: color2, name, shape } = series[seriesIndex];
            return /* @__PURE__ */ (0, import_jsx_runtime430.jsxs)("div", { className: ROW, children: [
              (0, import_react31.cloneElement)(HIGHCHARTS.SHAPES[shape], { className: ICON(color2) }),
              hasSeriesName && /* @__PURE__ */ (0, import_jsx_runtime430.jsx)(import_uik487.Tooltip, { showOnOverflowOnly: true, value: name, children: /* @__PURE__ */ (0, import_jsx_runtime430.jsx)("div", { className: NAME, children: name }) }),
              /* @__PURE__ */ (0, import_jsx_runtime430.jsx)(import_uik487.Tooltip, { showOnOverflowOnly: true, value: y, children: /* @__PURE__ */ (0, import_jsx_runtime430.jsx)("div", { className: VALUE(hasSeriesName), children: y }) })
            ] }, i);
          })
        ]
      }
    ),
    [anchored, maxHeight, series, points]
  );
  useEvents({
    anchorable,
    anchored,
    containerRef,
    setState,
    tooltipRef
  });
  useHaloAndCrosshair({
    anchored,
    hoverPoints,
    xAxis
  });
  return {
    element: /* @__PURE__ */ (0, import_jsx_runtime430.jsx)(
      import_uik487.Tooltip,
      {
        children: triggerRef,
        className: TOOLTIP2(anchored),
        onClick: (e) => e.stopPropagation(),
        position: getPositioner({
          ...position,
          ...anchored && { margin: 25 }
        }),
        value,
        visible: anchored || visible
      }
    ),
    hostClassName: anchored && (0, import_uik487.css)({
      "& .highcharts-crosshair": {
        strokeWidth: 1.5,
        visibility: "visible"
      },
      pointerEvents: "none"
    }),
    options
  };
}, "useTooltip");
var {
  CONTENT,
  HEADER,
  ROW: { ICON, NAME, ROW, VALUE },
  TOOLTIP: TOOLTIP2
} = STYLES4;

// Cartesian/useWithColumns/useWithColumns.ts
var import_uik488 = require("@appd/uik");
var import_react35 = require("react");

// Cartesian/useWithColumns/useHover.ts
var import_react32 = require("react");
var useHover = /* @__PURE__ */ __name(({ hover, selectable, selected, series }) => (0, import_react32.useMemo)(
  () => series.map(
    (series2, seriesIndex) => series2.type === "column" ? {
      ...series2,
      data: series2.data.map(({ className: className2, ...point }) => ({
        ...point,
        className: className2 ?? (!hover.point && !hover.column && !selected.columns.size && !selected.points.length ? (
          // No hover or selection
          "normal"
        ) : [
          // Hovering the column
          (!selectable || selectable === "COLUMN" || selectable === "MULTIPLE_COLUMNS") && point.x === hover.column,
          // Hovering the point
          (selectable === "MULTIPLE_POINTS" || selectable === "POINT") && point.x === hover.point?.x && point.y === hover.point?.y && seriesIndex === hover.point?.seriesIndex
        ].some(Boolean) ? "hover" : "inactive")
      }))
    } : series2
  ),
  [hover.column, hover.point, selectable, selected.columns, selected.points, series]
), "useHover");

// Cartesian/useWithColumns/useInteraction.ts
var import_react33 = require("react");
var useInteraction = /* @__PURE__ */ __name(() => {
  const hover = {
    column: (0, import_react33.useState)(void 0),
    point: (0, import_react33.useState)(void 0)
  };
  const selected = {
    columns: (0, import_react33.useState)(/* @__PURE__ */ new Set()),
    points: (0, import_react33.useState)([])
  };
  return {
    hover: {
      column: hover.column[0],
      point: hover.point[0]
    },
    selected: {
      columns: selected.columns[0],
      points: selected.points[0]
    },
    setHover: {
      column: hover.column[1],
      point: hover.point[1]
    },
    setSelected: {
      columns: selected.columns[1],
      points: selected.points[1]
    }
  };
}, "useInteraction");

// Cartesian/useWithColumns/useSelect.ts
var import_react34 = require("react");
var useSelect = /* @__PURE__ */ __name(({ selectable, selected: { columns, points }, series }) => (0, import_react34.useMemo)(
  () => selectable ? series.map(
    (series2, i) => series2.type === "column" ? {
      ...series2,
      // Update className on each point in current series
      data: series2.data.map(
        (point) => [
          selectable === "COLUMN" && (columns.has(point.x) || points[0]?.x === point.x),
          selectable === "MULTIPLE_COLUMNS" && (columns.has(point.x) || points.some(({ x }) => x === point.x)),
          selectable === "MULTIPLE_POINTS" && points.some(({ seriesIndex, x, y }) => x === point.x && y === point.y && seriesIndex === i),
          selectable === "POINT" && points[0]?.x === point.x && points[0]?.y === point.y && points[0]?.seriesIndex === i
        ].some(Boolean) ? {
          ...point,
          className: "select"
        } : point
      )
    } : series2
  ) : series,
  [columns, points, selectable, series]
), "useSelect");

// Cartesian/useWithColumns/useWithColumns.ts
var useWithColumns = /* @__PURE__ */ __name(({
  column: { groupPadding, onSelect, pointPadding, selectable } = {},
  series,
  stacking
}) => {
  const { hover, selected, setHover, setSelected } = useInteraction();
  const programmaticSelections = (0, import_react35.useMemo)(
    () => series.flatMap(
      (series2, i) => series2.type === "column" ? import_uik488.utils.many(series2.select).map(
        (selection) => typeof selection === "number" || selection === void 0 ? selection : {
          seriesIndex: series2.index ?? i,
          x: selection.x,
          y: selection.y ?? void 0
        }
      ).filter((selection) => selection !== void 0) : []
    ),
    [series]
  );
  const [current, setCurrent] = (0, import_react35.useState)({
    /**
     * A queue of `onSelect` events to be emitted during useEffect.
     *
     * Gets pushed into by a user event, and flushed by useEffect.
     *
     * We need this deferral to avoid "Cannot update a component while rendering a different component" error.
     */
    pendingOnSelect: [],
    /**
     * The developer can force some points/columns to be selected via `<Column select={...}>`.
     *
     * Compare the current `<Column select>` to the last seen one to see if we should update.
     */
    programmaticSelections,
    /** `<Cartesian column={{selectable: ...}}>` can change, in which case we need to clear the existing selection. */
    selectable
  });
  {
    const changed = {
      programmaticSelections: JSON.stringify(programmaticSelections) !== JSON.stringify(current.programmaticSelections),
      selectable: selectable !== current.selectable
    };
    if (changed.programmaticSelections) {
      setSelected.columns(
        () => new Set(programmaticSelections.map((selection) => typeof selection === "number" ? selection : selection.x))
      );
      setSelected.points(
        () => programmaticSelections.map((selection) => typeof selection !== "number" && selection).filter(import_uik488.utils.Boolean)
      );
      setCurrent((current2) => ({
        ...current2,
        programmaticSelections
      }));
    }
    if (changed.selectable) {
      setHover.column(void 0);
      setHover.point(void 0);
      if (!programmaticSelections.length) {
        setSelected.columns(/* @__PURE__ */ new Set());
        setSelected.points([]);
      }
      setCurrent((current2) => ({
        ...current2,
        selectable
      }));
    }
  }
  const isColumn = selectable && ["COLUMN", "MULTIPLE_COLUMNS"].includes(selectable);
  const numberOf = (0, import_react35.useMemo)(() => {
    const points = series.filter((series2) => series2.type === "column").flatMap(({ data }) => data);
    const columns = [...new Set(points.map(({ x }) => x))].length;
    return {
      columns,
      points: points.length
    };
  }, [series]);
  const plotOptions = (0, import_react35.useMemo)(
    (mouseOut = () => isColumn ? setHover.column(void 0) : setHover.point(void 0)) => ({
      // Stack only if at least one `<Column stack={...}>` is specified.
      ...{
        column: {
          ...groupPadding && { groupPadding },
          ...pointPadding && { pointPadding },
          ...stacking == void 0 && series.some(({ stack, type }) => type === "column" && stack != null) && { stacking: "normal" }
        }
      },
      ...selectable && {
        series: {
          events: { mouseOut },
          point: {
            events: {
              click: ({ point }) => isColumn ? setSelected.columns((columns) => {
                const next = columns.has(point.x) ? (
                  // Deselect
                  {
                    actual: [...columns].filter(
                      (selection) => selection !== point.x || // Preserve programatically selected points
                      programmaticSelections.includes(selection)
                    ),
                    uncontrolled: [...columns].filter((selection) => selection !== point.x)
                  }
                ) : selectable === "MULTIPLE_COLUMNS" ? (
                  // Muti-select
                  {
                    actual: columns.size + 1 === numberOf.columns ? (
                      // Clear all selections (except `programmaticSelections`)
                      [...columns].filter((selection) => programmaticSelections.includes(selection))
                    ) : [...columns, point.x],
                    uncontrolled: columns.size + 1 === numberOf.columns ? (
                      // Clear all selections
                      []
                    ) : [...columns, point.x]
                  }
                ) : selectable === "COLUMN" ? (
                  // Single select
                  {
                    actual: programmaticSelections.some((selection) => typeof selection === "number") ? (
                      // Preserve programatically selected points
                      [...columns]
                    ) : [point.x],
                    uncontrolled: [point.x]
                  }
                ) : void 0;
                setCurrent((current2) => ({
                  ...current2,
                  pendingOnSelect: [...current2.pendingOnSelect, next.uncontrolled]
                }));
                return new Set(next.actual);
              }) : setSelected.points((points) => {
                const next = points.some(
                  ({ seriesIndex, x, y }) => x === point.x && y === point.y && seriesIndex === point.series.index
                ) ? (
                  // Deselect
                  {
                    actual: [...points].filter(
                      ({ seriesIndex, x, y }) => x !== point.x || y !== point.y || seriesIndex !== point.series.index || // Preserve programatically selected points
                      programmaticSelections.some(
                        (selection) => typeof selection !== "number" && x === selection.x && y === selection.y && seriesIndex === selection.seriesIndex
                      )
                    ),
                    uncontrolled: [...points].filter(
                      ({ seriesIndex, x, y }) => x !== point.x || y !== point.y || seriesIndex !== point.series.index
                    )
                  }
                ) : selectable === "MULTIPLE_POINTS" ? (
                  // Muti-select
                  {
                    actual: points.length + 1 === numberOf.points ? (
                      // Clear all selections (except `programmaticSelections`)
                      [...points].filter(
                        ({ seriesIndex, x, y }) => programmaticSelections.some(
                          (selection) => typeof selection !== "number" && x === selection.x && y === selection.y && seriesIndex === selection.seriesIndex
                        )
                      )
                    ) : [
                      ...points,
                      {
                        seriesIndex: point.series.index,
                        x: point.x,
                        y: point.y
                      }
                    ],
                    uncontrolled: points.length + 1 === numberOf.points ? (
                      // Clear all selections
                      []
                    ) : [
                      ...points,
                      {
                        seriesIndex: point.series.index,
                        x: point.x,
                        y: point.y
                      }
                    ]
                  }
                ) : selectable === "POINT" ? (
                  // Single select
                  {
                    actual: programmaticSelections.some((selection) => typeof selection !== "number") ? (
                      // Preserve programatically selected points
                      points
                    ) : [
                      {
                        seriesIndex: point.series.index,
                        x: point.x,
                        y: point.y
                      }
                    ],
                    uncontrolled: [
                      {
                        seriesIndex: point.series.index,
                        x: point.x,
                        y: point.y
                      }
                    ]
                  }
                ) : [];
                setCurrent((current2) => ({
                  ...current2,
                  pendingOnSelect: [...current2.pendingOnSelect, next.uncontrolled]
                }));
                return next.actual;
              }),
              mouseOut,
              mouseOver() {
                isColumn ? setHover.column(this.x) : setHover.point({
                  seriesIndex: this.series.index,
                  x: this.x,
                  y: this.y
                });
              }
              // # To be fixed:
              // - Using `events.select` causing stale state
              //   - Unselect requires click twice
              //   - Don't know the reason why after clicking on point/column once, `allowPointSelect` is set to `false`
              /*
                  select(this: Highcharts.Point): void {
                  },
                  */
            }
          }
        }
      }
    }),
    [isColumn, numberOf, programmaticSelections, selectable, series]
  );
  import_uik488.utils.useLayoutEffect(() => {
    if (current.pendingOnSelect.length && onSelect) {
      current.pendingOnSelect.forEach((payload) => onSelect(payload));
      setCurrent((current2) => ({
        ...current2,
        pendingOnSelect: []
      }));
    }
  }, [current.pendingOnSelect, onSelect]);
  return {
    plotOptions,
    series: useHover({
      hover,
      selectable,
      selected,
      series: useSelect({
        selectable,
        selected,
        series
      })
    })
  };
}, "useWithColumns");

// Cartesian/useWithFlags.ts
var useWithFlags = /* @__PURE__ */ __name(({ series }) => ({
  series: series.map((_series, index) => {
    const lastColumnIndex = series.findIndex(({ type }, subindex) => type === "column" && subindex === index - 1);
    return _series.type === "flags" ? {
      ..._series,
      ...{
        colorIndex: lastColumnIndex,
        onSeries: series[lastColumnIndex].id
      }
      // Intentional type casting for `Flag.shape`
    } : { ..._series };
  })
}), "useWithFlags");

// Cartesian/useWithThreshold.ts
var import_react36 = require("react");
var useWithThreshold = /* @__PURE__ */ __name(({ rawSeries, series }) => {
  const firstNonThresholdSeries = rawSeries.find((_rawSeries) => _rawSeries.custom?.threshold == void 0);
  const firstNonThresholdSeriesData = (firstNonThresholdSeries?.type !== "arearange" ? firstNonThresholdSeries?.data : (firstNonThresholdSeries?.data ?? []).map(
    (datum) => datum != void 0 && datum.length > 0 ? {
      x: datum[0],
      y: null
    } : {
      x: null,
      y: null
    }
  )) ?? [];
  return (0, import_react36.useMemo)(
    () => ({
      series: series.map((_series) => {
        const threshold = _series.custom?.threshold;
        const thresholdOptions = _series.custom?.thresholdOptions;
        const getThresholdSeries = /* @__PURE__ */ __name(() => {
          if (threshold != void 0 && !thresholdOptions?.xAxis) {
            return firstNonThresholdSeriesData.map(({ x }) => ({
              x,
              y: threshold
            }));
          } else if (threshold != void 0 && thresholdOptions.xAxis) {
            const rawXAxisThreshold = firstNonThresholdSeriesData.map(({ y }) => ({
              x: threshold,
              y
            }));
            const max2 = rawXAxisThreshold != void 0 && rawXAxisThreshold.length > 0 ? rawXAxisThreshold.reduce((prev, current) => (prev?.y ?? 0) > (current?.y ?? 0) ? prev : current) : void 0;
            return [
              {
                x: threshold,
                y: 0
              },
              max2
            ];
          }
          return [];
        }, "getThresholdSeries");
        return threshold != void 0 && _series.type === "line" ? {
          ..._series,
          ...{
            className: "uik-threshold",
            color: thresholdOptions?.color ?? CONTROL_BORDER4,
            custom: {
              ..._series.custom,
              ...{
                color: thresholdOptions?.color ?? CONTROL_BORDER4,
                id: "uikThreshold",
                shape: "BASELINE"
              }
            },
            dashStyle: _series.dashStyle ?? "DashDot",
            data: _series.data != void 0 ? _series.data : getThresholdSeries(),
            dataLabels: {
              className: "uik-threshold-data-labels",
              enabled: thresholdOptions?.xAxis,
              filter: {
                operator: ">",
                property: "y",
                value: 0
              },
              format: `${thresholdOptions?.name}`,
              y: -SPACING9[1]
            },
            enableMouseTracking: !thresholdOptions?.xAxis,
            marker: {
              enabled: false,
              states: { hover: { enabled: false } }
            },
            name: thresholdOptions?.name ?? (_series.name !== void 0 && _series.name !== "" ? _series.name : "Threshold")
          }
        } : { ..._series };
      })
    }),
    [series]
  );
}, "useWithThreshold");
var {
  COLORS: { CONTROL_BORDER: CONTROL_BORDER4 },
  SPACING: SPACING9
} = MAGNETIC_TOKENS;

// Cartesian/useXAxis/useXAxis.ts
var import_uik492 = require("@appd/uik");
var import_react38 = require("react");

// Cartesian/useXAxis/getFormatter.ts
var import_uik489 = require("@appd/uik");
var getFormatter = /* @__PURE__ */ __name(({ categories, format: rawFormat, type }) => categories ? ({ value }) => typeof value === "string" ? value : categories[value] ?? import_uik489.format.number(value) : typeof rawFormat === "function" ? ({ value }) => rawFormat(value) : type === "linear" ? ({ value }) => import_uik489.format.number(value) : ({ value }) => {
  const cases = {
    day: () => import_uik489.format.date(value, {
      day: "numeric",
      month: "numeric"
    }),
    millisecond: () => import_uik489.format.time(value, {
      ...rawFormat,
      fractionalSecondDigits: 3
    }),
    second: () => import_uik489.format.time(value, { ...rawFormat }),
    year: () => import_uik489.format.date(value, {
      month: "numeric",
      year: "numeric"
    })
  };
  return `${cases.second()} - ${import_uik489.format.date(value, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric"
  })}`;
}, "getFormatter");

// Cartesian/useXAxis/getTimeFormat.ts
function getTimeFormat(format35) {
  const { seconds: showSeconds, twentyFourHour } = format35;
  const hours = twentyFourHour ? "%k" : "%l";
  const seconds = showSeconds ? ":%S" : "";
  const amPm = twentyFourHour ? "" : " %p";
  const millisecond = `${hours}:%M:%S.%L${amPm}`;
  const second = `${hours}:%M:%S${amPm}`;
  const minute = `${hours}:%M${seconds}${amPm}`;
  return {
    day: "%m/%d",
    hour: minute,
    millisecond,
    minute,
    month: "%m/%d",
    second,
    week: "%m/%d",
    year: "%m/%d"
  };
}
__name(getTimeFormat, "getTimeFormat");

// Cartesian/useXAxis/useResetZoom.tsx
var import_uik491 = require("@appd/uik");

// Cartesian/useXAxis/STYLES.tsx
var import_uik490 = require("@appd/uik");
var RESET_ZOOM = import_uik490.css.Styles({
  position: "absolute",
  right: 8,
  top: 8
});
var STYLES5 = { RESET_ZOOM };

// Cartesian/useXAxis/useIsZoomed.ts
var useIsZoomed = /* @__PURE__ */ __name(({ chartRef }) => {
  const extremes = chartRef.current?.axes?.[0]?.getExtremes();
  return (extremes?.min ?? 0) > (extremes?.dataMin ?? 0) || (extremes?.max ?? 0) < (extremes?.dataMax ?? 0);
}, "useIsZoomed");

// Cartesian/useXAxis/useResetZoom.tsx
var import_jsx_runtime431 = require("react/jsx-runtime");
var { RESET_ZOOM: RESET_ZOOM2 } = STYLES5;
var useResetZoom = /* @__PURE__ */ __name(({ chartRef, resetZoom: resetZoom2 }) => {
  const resetZoomElement = /* @__PURE__ */ (0, import_jsx_runtime431.jsx)(import_uik491.Button, { className: (0, import_uik491.css)(RESET_ZOOM2), onClick: () => chartRef.current?.xAxis?.[0]?.setExtremes(void 0, void 0), children: resetZoom2 });
  return !!resetZoom2 && useIsZoomed({ chartRef }) && resetZoomElement || "";
}, "useResetZoom");

// Cartesian/useXAxis/useZoom.ts
var import_react37 = require("react");
var useZoom = /* @__PURE__ */ __name(({ chartRef, max: max2, min: min2 }) => (0, import_react37.useEffect)(() => {
  chartRef.current?.axes?.[0]?.setExtremes(min2, max2);
}, [min2, max2]), "useZoom");

// Cartesian/useXAxis/useXAxis.ts
var useXAxis = /* @__PURE__ */ __name(({
  options: {
    categories,
    format: format35 = {},
    max: max2,
    min: min2,
    onMinMaxChange,
    plotBands,
    resetZoom: resetZoom2,
    title,
    type: rawType,
    zoomType = onMinMaxChange && "x",
    ...xAxis
  } = {},
  series
}) => {
  const crosshair = (0, import_react38.useMemo)(() => series.every(({ type: type2 }) => ["line", "spline"].includes(type2)), [series]);
  const xMin = (0, import_react38.useMemo)(() => {
    const firstSeriesData = series?.[0]?.data;
    return Math.min(...(firstSeriesData ?? []).map(({ x = Infinity }) => x));
  }, [series]);
  const type = rawType ?? (Math.min(min2 ?? xMin, xMin) >= 3600 * 24 * 365 * 1e3 ? "datetime" : "linear");
  const formatter = (0, import_react38.useMemo)(
    () => getFormatter({
      categories,
      format: format35,
      type
    }),
    [...typeof format35 === "function" ? [] : Object.values(format35), type]
  );
  const dateTimeLabelFormats = (0, import_react38.useMemo)(
    () => typeof format35 === "function" ? void 0 : getTimeFormat({ ...format35 }),
    [...typeof format35 === "function" ? [] : Object.values(format35)]
  );
  const options = (0, import_react38.useMemo)(
    () => ({
      ...xAxis,
      categories,
      crosshair,
      ...dateTimeLabelFormats && { dateTimeLabelFormats },
      ...typeof onMinMaxChange === "function" && { events: { setExtremes: onMinMaxChange } },
      labels: {
        ...!dateTimeLabelFormats && { formatter },
        padding: 20
      },
      max: max2,
      min: min2,
      plotBands: plotBands?.map(({ color: color2 = "NORMAL", from: from2, to }) => ({
        className: (0, import_uik492.css)({
          all: void 0,
          fill: {
            [color2]: color2,
            // eslint-disable-next-line sort-keys-fix/sort-keys-fix
            CRITICAL: CRITICAL2,
            NORMAL: NORMAL2,
            WARNING: WARNING2
          }[color2],
          opacity: 0.24
        }),
        from: from2,
        to
      })),
      title,
      type
    }),
    [crosshair, formatter, max2, min2, plotBands, type, ...Object.values(xAxis)]
  );
  return {
    formatter,
    options,
    useResetZoom: (chartRef) => useResetZoom({
      chartRef,
      resetZoom: resetZoom2
    }),
    useZoom: (chartRef) => useZoom({
      chartRef,
      max: max2,
      min: min2
    }),
    zoomType
  };
}, "useXAxis");
var {
  STATIC: { CRITICAL: CRITICAL2, NORMAL: NORMAL2, WARNING: WARNING2 }
} = import_uik492.MAGNETIC_TOKENS;

// Cartesian/Cartesian.tsx
var import_jsx_runtime432 = require("react/jsx-runtime");
var Cartesian = Object.assign(
  import_uik493.utils.forwardRef(
    ({
      animation = !import_uik493.utils.PREFERS_REDUCED_MOTION,
      autoFillColors = false,
      children: rawChildren,
      className: className2,
      colors: rawColors = DEFAULT_COLORS,
      column,
      inverted = false,
      legend: rawLegend,
      maxPointWidth,
      noDataIllustration = /* @__PURE__ */ (0, import_jsx_runtime432.jsx)(
        "div",
        {
          className: (0, import_uik493.css)({
            backgroundColor: DEFAULT_BG,
            borderRadius: RADIUS5.DEFAULT,
            color: DEFAULT_TEXT_MEDIUM4,
            display: "flex",
            font: P3_DEFAULT5,
            justifyContent: "center",
            padding: SPACING10[3],
            textAlign: "center"
          }),
          children: MESSAGES2.NO_DATA()
        }
      ),
      onSeriesSelect,
      pointClick,
      pointWidth,
      stacking,
      syncId,
      title,
      tooltip: rawTooltip,
      tooltipComponent,
      xAxis: rawXAxis,
      yAxis: rawYAxis,
      ...inherited
    }, forwardedRef) => {
      const children = useChildren(rawChildren);
      const colors = useColors({
        autoFillColors,
        children,
        rawColors
      });
      const series = useSeries({
        colors,
        isReady: children.isReady,
        rawSeries: children.rawSeries
      });
      const xAxis = useXAxis({
        options: rawXAxis,
        series: series.options
      });
      const yAxis = (0, import_react39.useMemo)(() => getYAxis(rawYAxis), Object.values(rawYAxis ?? {}));
      const tooltip = useTooltip({
        colors,
        formatter: {
          x: xAxis.formatter,
          y: yAxis.formatter
        },
        inverted,
        options: rawTooltip,
        series: series.resolved,
        tooltipComponent
      });
      const withColumns = useWithColumns({
        column,
        series: series.options,
        stacking
      });
      const withFlags = useWithFlags({ series: withColumns.series });
      const withThreshold = useWithThreshold({
        rawSeries: children.rawSeries,
        series: withFlags.series
      });
      const context = (0, import_react39.useContext)(CONTEXT4);
      (0, import_react39.useEffect)(() => {
        syncId && import_uik493.Measurer.subscribe(ref.current?.parentElement, () => {
          const currentChartX = Number(
            ref.current?.querySelector(`.highcharts-plot-background`)?.getAttribute("x")
          );
          if (currentChartX != null) {
            context.setMarginLeft(
              (marginLeft2) => (marginLeft2?.get(syncId) ?? -Infinity) < currentChartX ? new Map(marginLeft2?.set(syncId, currentChartX)) ?? /* @__PURE__ */ new Map([[syncId, currentChartX]]) : marginLeft2
            );
          }
        });
      });
      const marginLeft = syncId ? context.marginLeft?.get(syncId) : void 0;
      const options = (0, import_react39.useMemo)(
        () => ({
          ...OPTIONS,
          chart: {
            ...OPTIONS.chart,
            colorCount: colors.length,
            //
            events: {
              click: /* @__PURE__ */ __name(function myFunction() {
                this.getSelectedPoints()[0]?.select();
              }, "myFunction")
            },
            inverted,
            marginLeft,
            zoomType: xAxis.zoomType
          },
          plotOptions: {
            // Spread avoids `column: undefined`, which throws:
            //
            //   Uncaught TypeError: Cannot read properties of undefined (reading 'tooltip')
            //
            // 🤦‍♂️ Highcharts is so perverse.
            column: { ...withColumns.plotOptions.column },
            series: {
              animation,
              maxPointWidth,
              point: { events: { click: pointClick } },
              pointWidth,
              stacking: stacking === "NORMAL" ? "normal" : stacking === "PERCENT" ? "percent" : void 0,
              ...OPTIONS.plotOptions?.series,
              ...withColumns.plotOptions.series
            }
          },
          series: withThreshold.series,
          time: { timezoneOffset: import_luxon4.DateTime.now().setZone(import_uik493.format.TIME_ZONE()).offset * -1 },
          title: {
            ...OPTIONS.title,
            text: title
          },
          tooltip: tooltip.options,
          xAxis: xAxis.options,
          yAxis: yAxis.options
        }),
        [
          colors.length,
          inverted,
          withColumns.plotOptions.column,
          withColumns.plotOptions.series,
          withColumns.series,
          marginLeft,
          title,
          tooltip.options,
          xAxis.options,
          yAxis.options
        ]
      );
      const legend = useLegend({
        onSeriesSelect,
        options: rawLegend,
        series: series.resolved,
        setVisible: series.setVisible
      });
      const { chartRef, ref } = useChart({
        column,
        isEmpty: children.isEmpty,
        isReady: children.isReady,
        options
      });
      series.useResolved(chartRef);
      xAxis.useZoom(chartRef);
      const resetZoom2 = xAxis.useResetZoom(chartRef);
      const { CHART, HOST: HOST14 } = getStyles5({
        colors,
        empty: children.isReady && children.isEmpty,
        series: series.options,
        yAxis: rawYAxis ?? {}
      });
      return /* @__PURE__ */ (0, import_jsx_runtime432.jsxs)("div", { className: (0, import_uik493.css)(HOST14, ...import_uik493.utils.many(className2)), ref: forwardedRef, uik: "Cartesian", ...inherited, children: [
        children.isReady && children.isEmpty && noDataIllustration,
        getGradient(series.options, colors),
        /* @__PURE__ */ (0, import_jsx_runtime432.jsx)("div", { className: (0, import_uik493.css)(CHART, tooltip.hostClassName, children.isEmpty && { visibility: "hidden" }), ref }),
        children.isReady && !children.isEmpty && legend,
        children.elements,
        tooltip.element,
        resetZoom2
      ] });
    }
  ),
  {
    Area: Area2,
    AreaRange,
    Bar,
    Column: Column2,
    DEFAULT_COLORS,
    Histogram: Histogram2,
    Line: Line2,
    Provider: Provider2,
    SHAPES: HIGHCHARTS.SHAPES,
    Scatter: Scatter2
  }
);
Cartesian.displayName = "Cartesian";
Cartesian.__DEV_METADATA__ = { status: "READY" };
var {
  COLORS: { DEFAULT_BG, DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM4 },
  RADIUS: RADIUS5,
  SPACING: SPACING10,
  TYPOGRAPHY: { P3_DEFAULT: P3_DEFAULT5 }
} = import_uik493.MAGNETIC_TOKENS;

// Checkbox/Checkbox.tsx
var import_uik495 = require("@appd/uik");
var import_react40 = require("react");

// Checkbox/getStyles.ts
var import_uik494 = require("@appd/uik");
var {
  COLORS: {
    CONTROL_BG_STRONG,
    CONTROL_BG_STRONG_HOVER,
    CONTROL_BG_WEAK: CONTROL_BG_WEAK3,
    CONTROL_BG_WEAK_DISABLED,
    CONTROL_BORDER: CONTROL_BORDER5,
    CONTROL_BORDER_DISABLED,
    CONTROL_BORDER_HOVER,
    DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM5
  },
  RADIUS: RADIUS6,
  SPACING: SPACING11,
  TYPOGRAPHY: { ELLIPSES: ELLIPSES5, P4_DEFAULT: P4_DEFAULT3 }
} = import_uik494.MAGNETIC_TOKENS;
var CHECKBOX_SIZE = 20;
var getStyles6 = /* @__PURE__ */ __name(({ active, disabled }) => import_uik494.css.Styles({
  CONTAINER: import_uik494.css.Styles({
    FRAME: import_uik494.css.Styles({
      "&:hover": !disabled && !active ? { borderColor: CONTROL_BORDER_HOVER } : {},
      ICON: import_uik494.css.Styles({
        borderRadius: RADIUS6.DEFAULT,
        bottom: 0,
        height: CHECKBOX_SIZE - 4,
        left: 0,
        minWidth: CHECKBOX_SIZE,
        position: "absolute",
        right: 0,
        top: 2,
        width: CHECKBOX_SIZE
      }),
      borderColor: disabled ? CONTROL_BORDER_DISABLED : active ? "transparent" : CONTROL_BORDER5,
      borderRadius: RADIUS6.DEFAULT,
      borderStyle: "solid",
      borderWidth: "2px",
      bottom: 0,
      left: 0,
      position: "absolute",
      right: 0,
      top: 0
    }),
    ...disabled === true ? { cursor: "default" } : { cursor: "pointer" },
    "&:hover": active && !disabled ? { backgroundColor: CONTROL_BG_STRONG_HOVER } : {},
    backgroundColor: disabled ? CONTROL_BG_WEAK_DISABLED : active ? CONTROL_BG_STRONG : CONTROL_BG_WEAK3,
    borderRadius: RADIUS6.DEFAULT,
    height: CHECKBOX_SIZE,
    marginRight: SPACING11[1],
    minWidth: CHECKBOX_SIZE,
    position: "relative",
    width: CHECKBOX_SIZE
  }),
  DESCRIPTION: import_uik494.css.Styles({
    ...ELLIPSES5.END,
    ...disabled === true ? { cursor: "not-allowed" } : { cursor: "pointer" },
    color: DEFAULT_TEXT_MEDIUM5,
    font: P4_DEFAULT3
  }),
  INPUT: import_uik494.css.Styles({
    appearance: "none",
    border: 0,
    clip: "rect(0 0 0 0)",
    cursor: disabled ? "not-allowed" : "pointer",
    height: "1px",
    left: 0,
    margin: "-1px",
    outline: 0,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    width: "1px"
  }),
  LABEL: import_uik494.css.Styles({
    ...ELLIPSES5.END,
    ...disabled === true ? { cursor: "not-allowed" } : { cursor: "pointer" }
  }),
  LABEL_CONTAINER: import_uik494.css.Styles({
    ...ELLIPSES5.END,
    ...disabled === true ? { cursor: "not-allowed" } : { cursor: "pointer" },
    marginLeft: "4px"
  }),
  alignItems: "center",
  display: "flex",
  position: "relative"
}), "getStyles");

// Checkbox/Checkbox.tsx
var import_jsx_runtime433 = require("react/jsx-runtime");
var {
  COLORS: { CONTROL_ICON_IN_ACTIVE, CONTROL_ICON_IN_DISABLED }
} = import_uik495.MAGNETIC_TOKENS;
var Checkbox = import_uik495.utils.forwardRef(
  ({
    checked,
    className: className2,
    description,
    disabled,
    indeterminate,
    initialChecked,
    label,
    name = label,
    onChange,
    tabIndex = disabled ? -1 : 0,
    value = label,
    ...inherited
  }, rawRef) => {
    const firstRender = (0, import_react40.useRef)(true);
    const [rawChecked, setRawChecked] = (0, import_react40.useState)(checked ?? initialChecked ?? false);
    const ref = import_uik495.utils.useBroadcastRef(rawRef);
    checked ??= rawChecked;
    (0, import_react40.useEffect)(() => {
      !firstRender.current && ref.current?.dispatchEvent(new Event("change", { bubbles: true }));
    }, [checked]);
    const toggleChecked = disabled ? import_uik495.utils.noop : () => {
      firstRender.current = false;
      setRawChecked(!checked);
      onChange?.(!checked);
    };
    const onKeyUp = /* @__PURE__ */ __name(({ key }) => {
      !disabled && import_uik495.utils.maybeGet(
        {
          " ": toggleChecked,
          Enter: toggleChecked
        },
        key
      )?.();
    }, "onKeyUp");
    const {
      CONTAINER: {
        FRAME: { ICON: ICON4, ...FRAME2 },
        ...CONTAINER7
      },
      DESCRIPTION: DESCRIPTION3,
      INPUT,
      LABEL: LABEL7,
      LABEL_CONTAINER,
      ...STYLES47
    } = getStyles6({
      active: checked || indeterminate,
      disabled
    });
    const fill = disabled ? CONTROL_ICON_IN_DISABLED : CONTROL_ICON_IN_ACTIVE;
    return /* @__PURE__ */ (0, import_jsx_runtime433.jsxs)("div", { className: (0, import_uik495.css)(STYLES47, ...import_uik495.utils.many(className2)), uik: "Checkbox", ...inherited, children: [
      /* @__PURE__ */ (0, import_jsx_runtime433.jsx)(
        "input",
        {
          "aria-checked": `${checked}`,
          checked,
          className: (0, import_uik495.css)(INPUT),
          name,
          onChange: import_uik495.utils.noop,
          ref,
          type: "checkbox",
          value
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime433.jsxs)(
        "div",
        {
          "aria-checked": `${checked}`,
          "aria-labelledby": "label",
          className: (0, import_uik495.css)(CONTAINER7),
          id: "container",
          onClick: toggleChecked,
          onKeyUp,
          role: "checkbox",
          tabIndex,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime433.jsx)("span", { className: (0, import_uik495.css)(FRAME2) }),
            indeterminate && /* @__PURE__ */ (0, import_jsx_runtime433.jsx)(import_uik495.Icon.Action.Minus, { className: (0, import_uik495.css)(ICON4), fill }) || checked && /* @__PURE__ */ (0, import_jsx_runtime433.jsx)(import_uik495.Icon.Action.Enable, { className: (0, import_uik495.css)(ICON4), fill })
          ]
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime433.jsxs)("span", { className: (0, import_uik495.css)(LABEL_CONTAINER), children: [
        /* @__PURE__ */ (0, import_jsx_runtime433.jsx)(import_uik495.Tooltip, { showOnOverflowOnly: true, value: label, children: /* @__PURE__ */ (0, import_jsx_runtime433.jsx)(
          "label",
          {
            className: (0, import_uik495.css)(LABEL7),
            htmlFor: "container",
            id: "label",
            onClick: toggleChecked,
            children: label
          }
        ) }),
        description && /* @__PURE__ */ (0, import_jsx_runtime433.jsx)(import_uik495.Tooltip, { showOnOverflowOnly: true, value: description, children: /* @__PURE__ */ (0, import_jsx_runtime433.jsx)("div", { className: (0, import_uik495.css)(DESCRIPTION3), onClick: toggleChecked, children: description }) })
      ] })
    ] });
  }
);
Checkbox.displayName = "Checkbox";
Checkbox.__DEV_METADATA__ = { status: "READY" };

// CodeEditor/CodeEditor.tsx
var import_uik498 = require("@appd/uik");
var import_react43 = require("react");

// CodeEditor/Snippet/Snippet.tsx
var import_uik497 = require("@appd/uik");
var import_react42 = require("react");

// CodeEditor/Snippet/STYLES.ts
var STYLES6 = {
  HOST: {
    "& .cursor": { display: "none !important" },
    "& .decorationsOverviewRuler": { display: "none !important" },
    "& .monaco-editor-overlaymessage": { display: "none !important" },
    "& .monaco-hover-content": { display: "none !important" },
    "& .wordHighlightText, & .wordHighlightStrong": { display: "none !important" },
    height: "100%",
    width: "100%"
  }
};

// MONACO/MONACO.ts
var import_uik496 = require("@appd/uik");
var import_react41 = require("react");
var MONACO = /* @__PURE__ */ __name(() => RESOLVED2() ?? void LOAD2.then(RESOLVED2.set), "MONACO");
MONACO.use = () => {
  const [, rerender] = (0, import_react41.useReducer)(() => true, false);
  (0, import_react41.useEffect)(() => RESOLVED2.subscribe(rerender), []);
  return MONACO();
};
var LOAD2 = import_uik496.utils.CAN_USE_DOM ? import_uik496.utils.lazyPromise(async () => {
  const MonacoEditor = await import("@monaco-editor/react");
  return MonacoEditor;
}) : new Promise(() => {
});
var RESOLVED2 = import_uik496.utils.mutable(void 0);

// CodeEditor/Snippet/Snippet.tsx
var import_jsx_runtime434 = require("react/jsx-runtime");
var Snippet = import_uik497.utils.forwardRef(
  ({
    beforeMount: userBeforeMount,
    className: className2,
    language = "javascript",
    loading = null,
    onMount,
    options,
    value,
    ...props2
  }, ref) => {
    const { currentTheme } = (0, import_react42.useContext)(import_uik497.css.CONTEXT);
    const Monaco = MONACO.use()?.default;
    const { HOST: HOST14 } = STYLES6;
    const beforeMount = /* @__PURE__ */ __name((monaco) => {
      monaco.editor.defineTheme("vs-snippet", {
        base: "vs",
        colors: { "editor.background": "#F1F2F3" },
        inherit: true,
        rules: []
      });
      userBeforeMount?.(monaco);
    }, "beforeMount");
    return /* @__PURE__ */ (0, import_jsx_runtime434.jsx)("div", { className: (0, import_uik497.css)(className2, HOST14), ref, uik: import_uik497.CodeSnippet.displayName, ...props2, children: Monaco ? /* @__PURE__ */ (0, import_jsx_runtime434.jsx)(
      Monaco,
      {
        beforeMount,
        language,
        loading,
        onMount,
        options: {
          ...{
            bracketPairGuides: false,
            colorDecorators: false,
            contextmenu: false,
            domReadOnly: true,
            folding: false,
            glyphMargin: false,
            guides: {
              bracketPairs: false,
              bracketPairsHorizontal: false,
              highlightActiveBracketPair: false,
              highlightActiveIndentation: false,
              indentation: false
            },
            lineNumbers: "off",
            matchBrackets: "never",
            minimap: { enabled: false },
            occurrencesHighlight: "off",
            readOnly: true,
            renderLineHighlight: "none",
            scrollBeyondLastLine: false,
            selectionHighlight: false,
            unicodeHighlight: {
              ambiguousCharacters: false,
              includeComments: false,
              includeStrings: false,
              invisibleCharacters: false,
              nonBasicASCII: false
            }
          },
          ...options
        },
        theme: currentTheme === "light" ? "vs-snippet" : "vs-dark",
        value
      }
    ) : /* @__PURE__ */ (0, import_jsx_runtime434.jsx)(import_jsx_runtime434.Fragment, {}) });
  }
);
Snippet.displayName = "CodeEditor.Snippet";
Snippet.__DEV_METADATA__ = { status: "IN_PROGRESS" };

// CodeEditor/STYLES.ts
var STYLES7 = {
  HOST: {
    height: "100%",
    width: "100%"
  }
};

// CodeEditor/CodeEditor.tsx
var import_jsx_runtime435 = require("react/jsx-runtime");
var CodeEditor = Object.assign(
  import_uik498.utils.forwardRef(
    ({
      beforeMount,
      className: className2,
      language = "javascript",
      loading = null,
      onChange,
      onMount,
      options,
      theme,
      value,
      ...props2
    }, ref) => {
      const { currentTheme } = (0, import_react43.useContext)(import_uik498.css.CONTEXT);
      const Monaco = MONACO.use()?.Editor;
      const { HOST: HOST14 } = STYLES7;
      return /* @__PURE__ */ (0, import_jsx_runtime435.jsx)("div", { className: (0, import_uik498.css)(className2, HOST14), ref, uik: CodeEditor.displayName, ...props2, children: Monaco ? /* @__PURE__ */ (0, import_jsx_runtime435.jsx)(
        Monaco,
        {
          beforeMount,
          language,
          loading,
          onChange,
          onMount,
          options: {
            ...{
              contextmenu: false,
              glyphMargin: false,
              lineDecorationsWidth: 0,
              lineNumbersMinChars: 0,
              minimap: { enabled: false },
              scrollBeyondLastLine: false
            },
            ...options,
            fixedOverflowWidgets: true
          },
          theme: theme ?? (currentTheme === "light" ? "vs" : "vs-dark"),
          value
        }
      ) : /* @__PURE__ */ (0, import_jsx_runtime435.jsx)(import_jsx_runtime435.Fragment, {}) });
    }
  ),
  { Snippet }
);
CodeEditor.displayName = "CodeEditor";
CodeEditor.__DEV_METADATA__ = { status: "IN_PROGRESS" };

// CodeSnippet/CodeSnippet.tsx
var import_uik500 = require("@appd/uik");
var import_react44 = require("react");

// CodeSnippet/getBottomPadding.ts
var getBottomPadding = /* @__PURE__ */ __name((showRows) => showRows ? (
  // Avoid "half a line number" showing due to overflow cutoff
  2
) : (
  // Avoid scrollbar when content lines equals maxRows
  // For example, on the `localhost:3000/configure/prometheus` page added by
  // https://bitbucket.corp.appdynamics.com/projects/DASHUI/repos/next-ui-levitate/pull-requests/3731
  SPACING12[2]
), "getBottomPadding");
var { SPACING: SPACING12 } = MAGNETIC_TOKENS;

// CodeSnippet/getStyles.tsx
var import_uik499 = require("@appd/uik");
var {
  COLORS: { DEFAULT_BORDER_WEAK, DEFAULT_TEXT: DEFAULT_TEXT4, DORMANT_BG_MEDIUM, INTERACT_ICON_WEAK: INTERACT_ICON_WEAK3 },
  SPACING: SPACING13,
  TYPOGRAPHY: { MONOSPACE_DEFAULT }
} = import_uik499.MAGNETIC_TOKENS;
var getStyles7 = /* @__PURE__ */ __name(({
  fontFamily,
  maxRows,
  showActionsOnHoverOnly,
  showRows,
  wrapped
}) => import_uik499.css.Styles({
  ...showActionsOnHoverOnly && { ":hover div > svg": { visibility: "visible" } },
  "> b": { fontWeight: "bold" },
  ACTIONS: import_uik499.css.Styles({
    alignItems: "center",
    display: "flex",
    gap: "15",
    paddingBottom: "4",
    paddingRight: "9",
    visibility: showActionsOnHoverOnly ? "hidden" : "visible"
  }),
  CODE: import_uik499.css.Styles({
    border: "none",
    boxSizing: "border-box",
    color: DEFAULT_TEXT4,
    font: MONOSPACE_DEFAULT,
    fontFamily,
    height: "fit-content",
    outline: "none",
    overflow: "auto",
    padding: `${SPACING13[2]}px ${SPACING13[2]}px ${getBottomPadding(showRows)}px ${SPACING13[2]}px`,
    resize: "none",
    whiteSpace: wrapped ? "pre-wrap" : "pre",
    width: "100%",
    wordBreak: wrapped ? "break-word" : "normal"
  }),
  CONTENT: import_uik499.css.Styles({
    backgroundColor: DORMANT_BG_MEDIUM,
    display: "flex",
    maxHeight: maxRows != Infinity ? maxRows * 15 + SPACING13[2] + getBottomPadding(showRows) : void 0,
    overflow: "auto"
  }),
  HEADER: import_uik499.css.Styles({
    display: "flex",
    justifyContent: "space-between"
  }),
  ICON: import_uik499.css.Styles({
    "& > path": { fill: INTERACT_ICON_WEAK3 },
    cursor: "pointer"
  }),
  LINE_NUMBERS: import_uik499.css.Styles({
    alignItems: "flex-end",
    borderRight: `1px solid ${DEFAULT_BORDER_WEAK}`,
    boxSizing: "border-box",
    color: DEFAULT_TEXT4,
    display: "flex",
    flexDirection: "column",
    font: MONOSPACE_DEFAULT,
    fontFamily,
    justifyContent: "flex-start",
    outline: "none",
    padding: `${SPACING13[2]}px ${SPACING13[3]}px`,
    userSelect: "none"
  }),
  display: "flex",
  flexDirection: "column",
  fontFamily
}), "getStyles");

// CodeSnippet/MESSAGES.ts
var MESSAGES3 = {
  COPY: format.message`Copy`.description("A tooltip to copy a code block"),
  UNWRAP: format.message`Unwrap`.description("A tooltip to unwrap text in a code block"),
  WRAP: format.message`Wrap`.description("A tooltip to wrap text in a code block")
};

// CodeSnippet/CodeSnippet.tsx
var import_jsx_runtime436 = require("react/jsx-runtime");
var CodeSnippet2 = import_uik500.utils.forwardRef(
  ({
    className: className2,
    fontFamily = "Roboto Mono",
    initialWrapped = false,
    label,
    maxRows = Infinity,
    onWrappedChange,
    showActions = false,
    showActionsOnHoverOnly = false,
    showRows = false,
    value = "",
    wrapped: rawWrapped,
    ...props2
  }, forwardedRef) => {
    const codeRef = (0, import_react44.useRef)(null);
    const [currentRows, setCurrentRows] = (0, import_react44.useState)(1);
    const [wrapped, setWrapped] = (0, import_react44.useState)(initialWrapped);
    if (rawWrapped != null && rawWrapped !== wrapped) {
      setWrapped(rawWrapped);
    }
    const { ACTIONS, CODE, CONTENT: CONTENT4, HEADER: HEADER4, ICON: ICON4, LINE_NUMBERS, ...HOST14 } = getStyles7({
      fontFamily,
      maxRows,
      showActionsOnHoverOnly,
      showRows,
      wrapped
    });
    const LINE_HEIGHT2 = 15;
    const getNumberOfRows = /* @__PURE__ */ __name(() => codeRef.current?.scrollHeight != null ? (
      // Clamp needed because `.scrollHeight` is `0` in jest.
      import_uik500.utils.clamp(
        Math.floor((codeRef.current?.scrollHeight - (SPACING14[2] + getBottomPadding(showRows))) / LINE_HEIGHT2),
        [0]
      )
    ) : currentRows, "getNumberOfRows");
    import_uik500.utils.useLayoutEffect(() => {
      codeRef.current != null && setCurrentRows(getNumberOfRows());
    }, [wrapped, value]);
    return /* @__PURE__ */ (0, import_jsx_runtime436.jsxs)("div", { className: (0, import_uik500.css)(HOST14, ...import_uik500.utils.many(className2)), ref: forwardedRef, uik: "CodeSnippet", ...props2, children: [
      /* @__PURE__ */ (0, import_jsx_runtime436.jsxs)("div", { className: (0, import_uik500.css)(HEADER4), children: [
        /* @__PURE__ */ (0, import_jsx_runtime436.jsx)(import_uik500.Form.Label, { label, showOptional: false }),
        showActions ? /* @__PURE__ */ (0, import_jsx_runtime436.jsxs)("div", { className: (0, import_uik500.css)(ACTIONS), children: [
          /* @__PURE__ */ (0, import_jsx_runtime436.jsx)(import_uik500.Tooltip, { value: MESSAGES3.COPY(), children: /* @__PURE__ */ (0, import_jsx_runtime436.jsx)(
            import_uik500.Icon,
            {
              className: (0, import_uik500.css)(ICON4),
              onClick: () => navigator.clipboard.writeText(value?.toString() ?? ""),
              size: "SMALL",
              type: "Action.Copy"
            }
          ) }),
          /* @__PURE__ */ (0, import_jsx_runtime436.jsx)(import_uik500.Tooltip, { value: wrapped ? MESSAGES3.UNWRAP() : MESSAGES3.WRAP(), children: /* @__PURE__ */ (0, import_jsx_runtime436.jsx)(
            import_uik500.Icon,
            {
              className: (0, import_uik500.css)(ICON4),
              onClick: () => {
                setWrapped(!wrapped);
                onWrappedChange?.(!wrapped);
              },
              size: "SMALL",
              type: "Action.WrapText"
            }
          ) })
        ] }) : null
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime436.jsxs)(import_uik500.ScrollBox, { className: (0, import_uik500.css)(CONTENT4), children: [
        showRows ? /* @__PURE__ */ (0, import_jsx_runtime436.jsx)("div", { className: (0, import_uik500.css)(LINE_NUMBERS), children: [...Array(currentRows).keys()].map((_, i) => /* @__PURE__ */ (0, import_jsx_runtime436.jsx)("div", { children: i + 1 }, i)) }) : null,
        /* @__PURE__ */ (0, import_jsx_runtime436.jsx)(import_uik500.ScrollBox, { className: (0, import_uik500.css)(CODE), ref: codeRef, children: value })
      ] })
    ] });
  }
);
CodeSnippet2.displayName = "CodeSnippet";
CodeSnippet2.__DEV_METADATA__ = { status: "DEPRECATED" };
var { SPACING: SPACING14 } = import_uik500.MAGNETIC_TOKENS;

// Collapse/Collapse.tsx
var import_uik507 = require("@appd/uik");
var import_react49 = require("react");

// Collapse/getStyles.ts
var import_uik501 = require("@appd/uik");
var {
  COLORS: { CONTROL_BG_WEAK: CONTROL_BG_WEAK4, CONTROL_BORDER: CONTROL_BORDER6 }
} = import_uik501.MAGNETIC_TOKENS;
var getStyles8 = /* @__PURE__ */ __name(({ kind }) => ({
  HOST: {
    borderRadius: 8,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    width: "100%",
    ...KIND_MAPPING[kind]
  }
}), "getStyles");
var BORDERLESS = {
  backgroundColor: CONTROL_BG_WEAK4,
  border: `2px solid ${CONTROL_BORDER6}`,
  borderInline: 0,
  borderRadius: 0
};
var CONTAINED = {
  backgroundColor: CONTROL_BG_WEAK4,
  border: `2px solid ${CONTROL_BORDER6}`,
  borderRadius: 0
};
var STACKED = {
  backgroundColor: CONTROL_BG_WEAK4,
  border: `2px solid ${CONTROL_BORDER6}`,
  borderRadius: 8
};
var UNSTYLED = {};
var KIND_MAPPING = {
  BORDERLESS,
  CONTAINED,
  STACKED,
  UNSTYLED
};

// Collapse/Group/Group.tsx
var import_uik502 = require("@appd/uik");
var import_react46 = require("react");

// Collapse/Group/CONTEXT.tsx
var import_react45 = require("react");
var CONTEXT5 = (0, import_react45.createContext)({
  density: void 0,
  kind: void 0,
  open: false,
  setOpen: () => {
  }
});

// Collapse/Group/getStyles.ts
var getStyles9 = /* @__PURE__ */ __name(({ kind }) => ({
  HOST: {
    display: "flex",
    flexDirection: "column",
    ...KIND_MAPPING2[kind]
  }
}), "getStyles");
var BORDERLESS2 = { "> [uik='Collapse'] ~ [uik='Collapse'] ": { borderTop: 0 } };
var CONTAINED2 = {
  ">:first-of-type": {
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8
  },
  ">:last-of-type": {
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8
  },
  ">:not(:first-of-type)": { borderTop: 0 }
};
var STACKED2 = { gap: 10 };
var UNSTYLED2 = {};
var KIND_MAPPING2 = {
  BORDERLESS: BORDERLESS2,
  CONTAINED: CONTAINED2,
  STACKED: STACKED2,
  UNSTYLED: UNSTYLED2
};

// Collapse/Group/Group.tsx
var import_jsx_runtime437 = require("react/jsx-runtime");
var Group3 = Object.assign(
  import_uik502.utils.forwardRef(
    ({
      accordion,
      children,
      className: className2,
      density = "MEDIUM",
      initiallyOpen,
      kind = "STACKED",
      onOpenChange,
      open: rawOpen,
      ...props2
    }, ref) => {
      const [open, setOpen] = (0, import_react46.useState)(
        rawOpen != void 0 ? rawOpen : import_react46.Children.toArray(children).map(
          (_, index) => initiallyOpen != void 0 ? initiallyOpen.includes(index) : false
        )
      );
      const _setOpen = /* @__PURE__ */ __name((childIndex) => (_open) => {
        if (accordion) {
          const newOpen = open.map(() => false);
          newOpen[childIndex] = _open;
          setOpen(newOpen);
          onOpenChange?.(newOpen);
        } else {
          const newOpen = [...open];
          newOpen[childIndex] = _open;
          setOpen(newOpen);
          onOpenChange?.(newOpen);
        }
      }, "_setOpen");
      const { HOST: HOST14 } = getStyles9({ kind });
      const childrenNodes = import_react46.Children.toArray(children).filter(import_react46.isValidElement);
      return /* @__PURE__ */ (0, import_jsx_runtime437.jsx)("div", { className: (0, import_uik502.css)(HOST14, ...import_uik502.utils.many(className2)), ref, uik: Group3.displayName, ...props2, children: childrenNodes.map((child, index) => /* @__PURE__ */ (0, import_jsx_runtime437.jsx)(
        CONTEXT5.Provider,
        {
          value: {
            density,
            kind,
            open: open[index],
            setOpen: _setOpen(index)
          },
          children: child
        },
        index
      )) });
    }
  ),
  { CONTEXT: CONTEXT5 }
);
Group3.displayName = "Collapse.Group";

// Collapse/Header/Header.tsx
var import_uik504 = require("@appd/uik");
var import_react47 = require("react");

// Collapse/Header/getStyles.ts
var import_uik503 = require("@appd/uik");
var {
  COLORS: { DEFAULT_TEXT: DEFAULT_TEXT5, INTERACT_ICON_WEAK: INTERACT_ICON_WEAK4 },
  TYPOGRAPHY: { ELLIPSES: ELLIPSES6, FONT_BODY, WEIGHT_EMPHASIS }
} = import_uik503.MAGNETIC_TOKENS;
var getStyles10 = /* @__PURE__ */ __name(({
  density,
  kind
}) => ({
  CHEVRON: {
    alignItems: "center",
    color: INTERACT_ICON_WEAK4,
    cursor: "pointer",
    display: "flex",
    flexShrink: 0,
    fontSize: "unset",
    justifyContent: "center",
    padding: 0
  },
  CONTENT: {
    ...ELLIPSES6.END,
    flexGrow: 1
  },
  HEADING: {
    alignItems: "center",
    backgroundColor: "transparent",
    border: 0,
    color: DEFAULT_TEXT5,
    cursor: "pointer",
    display: "flex",
    fontFamily: FONT_BODY,
    fontWeight: WEIGHT_EMPHASIS,
    gap: 16,
    justifyContent: "space-between",
    textAlign: "unset",
    ...DENSITY_MAPPING[density],
    ...KIND_MAPPING3[kind]
  }
}), "getStyles");
var BORDERLESS3 = {};
var CONTAINED3 = {};
var STACKED3 = {};
var UNSTYLED3 = { padding: "unset" };
var KIND_MAPPING3 = {
  BORDERLESS: BORDERLESS3,
  CONTAINED: CONTAINED3,
  STACKED: STACKED3,
  UNSTYLED: UNSTYLED3
};
var SMALL = {
  fontSize: 12,
  lineHeight: "18px",
  paddingBlock: 8,
  paddingInline: 12
};
var MEDIUM = {
  fontSize: 14,
  lineHeight: "20px",
  paddingBlock: 12,
  paddingInline: 16
};
var LARGE = {
  fontSize: 16,
  lineHeight: "22px",
  paddingBlock: 16,
  paddingInline: 20
};
var DENSITY_MAPPING = {
  LARGE,
  MEDIUM,
  SMALL
};

// Collapse/Header/Header.tsx
var import_jsx_runtime438 = require("react/jsx-runtime");
var Header = import_uik504.utils.forwardRef(
  ({ children, className: className2, onClick: rawOnClick, showChevron = true, ...props2 }, maybeRef) => {
    const { density, kind, open, setOpen } = (0, import_react47.useContext)(Group3.CONTEXT);
    const { CHEVRON: CHEVRON2, CONTENT: CONTENT4, HEADING } = getStyles10({
      density: density != void 0 ? density : "MEDIUM",
      kind: kind != void 0 ? kind : "UNSTYLED"
    });
    const ref = import_uik504.utils.useBroadcastRef(maybeRef);
    const updateOpen = /* @__PURE__ */ __name((open2, event) => {
      setOpen(!open2);
      rawOnClick?.(event);
    }, "updateOpen");
    const onClick = /* @__PURE__ */ __name((event) => {
      if (event.defaultPrevented) {
        return;
      }
      event.preventDefault();
      updateOpen(open, event);
    }, "onClick");
    const onKeyDown = /* @__PURE__ */ __name((event) => {
      if (event.defaultPrevented) {
        return;
      }
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        onClick(event);
        updateOpen(open, event);
      }
    }, "onKeyDown");
    const icon = open ? "Navigation.ChevronUp" : "Navigation.ChevronDown";
    const chevron = showChevron && /* @__PURE__ */ (0, import_jsx_runtime438.jsx)(import_uik504.Icon, { className: (0, import_uik504.css)(CHEVRON2), height: 20, type: icon, width: 20 });
    const content = typeof children === "string" ? /* @__PURE__ */ (0, import_jsx_runtime438.jsx)(import_uik504.Tooltip, { value: children, children: /* @__PURE__ */ (0, import_jsx_runtime438.jsx)("span", { children }) }) : /* @__PURE__ */ (0, import_jsx_runtime438.jsx)(import_jsx_runtime438.Fragment, { children });
    return /* @__PURE__ */ (0, import_jsx_runtime438.jsxs)(
      "div",
      {
        className: (0, import_uik504.css)(HEADING, ...import_uik504.utils.many(className2)),
        onClick,
        onKeyDown,
        ref,
        tabIndex: 0,
        uik: Header.displayName,
        ...props2,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime438.jsx)("div", { className: (0, import_uik504.css)(CONTENT4), children: content }),
          chevron
        ]
      }
    );
  }
);
Header.displayName = "Collapse.Header";

// Collapse/Panel/Panel.tsx
var import_uik506 = require("@appd/uik");
var import_react48 = require("react");

// Collapse/Panel/getStyles.ts
var import_uik505 = require("@appd/uik");
var {
  COLORS: { CONTROL_BORDER_WEAK: CONTROL_BORDER_WEAK5 }
} = import_uik505.MAGNETIC_TOKENS;
var getStyles11 = /* @__PURE__ */ __name(({
  density,
  kind
}) => ({
  PANEL: {
    display: "flex",
    flexDirection: "column",
    height: "auto",
    overflow: "hidden",
    wordWrap: "break-word",
    ...DENSITY_MAPPING2[density],
    ...KIND_MAPPING4[kind]
  }
}), "getStyles");
var BORDERLESS4 = {};
var CONTAINED4 = {};
var STACKED4 = { borderTop: `1px solid ${CONTROL_BORDER_WEAK5}` };
var UNSTYLED4 = { padding: "24px 0 0" };
var KIND_MAPPING4 = {
  BORDERLESS: BORDERLESS4,
  CONTAINED: CONTAINED4,
  STACKED: STACKED4,
  UNSTYLED: UNSTYLED4
};
var SMALL2 = { padding: 12 };
var MEDIUM2 = { padding: 16 };
var LARGE2 = { padding: 20 };
var DENSITY_MAPPING2 = {
  LARGE: LARGE2,
  MEDIUM: MEDIUM2,
  SMALL: SMALL2
};

// Collapse/Panel/Panel.tsx
var import_jsx_runtime439 = require("react/jsx-runtime");
var Panel = import_uik506.utils.forwardRef(({ children, className: className2, ...props2 }, ref) => {
  const { density, kind, open } = (0, import_react48.useContext)(Group3.CONTEXT);
  const { PANEL } = getStyles11({
    density: density != void 0 ? density : "MEDIUM",
    kind: kind != void 0 ? kind : "UNSTYLED"
  });
  return open ? /* @__PURE__ */ (0, import_jsx_runtime439.jsx)("div", { className: (0, import_uik506.css)(PANEL, ...import_uik506.utils.many(className2)), ref, uik: Panel.displayName, ...props2, children }) : /* @__PURE__ */ (0, import_jsx_runtime439.jsx)(import_jsx_runtime439.Fragment, {});
});
Panel.displayName = "Collapse.Panel";

// Collapse/Collapse.tsx
var import_jsx_runtime440 = require("react/jsx-runtime");
var Collapse = Object.assign(
  import_uik507.utils.forwardRef(({ children, className: className2, title, ...props2 }, ref) => {
    const { kind } = (0, import_react49.useContext)(Group3.CONTEXT);
    const { HOST: HOST14 } = getStyles8({ kind: kind != void 0 ? kind : "UNSTYLED" });
    return /* @__PURE__ */ (0, import_jsx_runtime440.jsxs)("div", { className: (0, import_uik507.css)(HOST14, ...import_uik507.utils.many(className2)), ref, uik: Collapse.displayName, ...props2, children: [
      title && /* @__PURE__ */ (0, import_jsx_runtime440.jsx)(Header, { children: title }),
      children
    ] });
  }),
  {
    Group: Group3,
    Header,
    Panel
  }
);
Collapse.displayName = "Collapse";
Collapse.__DEV_METADATA__ = { status: "READY" };

// DatePicker/DatePicker.tsx
var import_uik508 = require("@appd/uik");
var import_jsx_runtime441 = require("react/jsx-runtime");
var DatePicker = import_uik508.utils.forwardRef(({ ...props2 }, forwardedRef) => /* @__PURE__ */ (0, import_jsx_runtime441.jsx)(import_uik508.DateTimePicker.CONTEXT.Provider, { value: { dateOnly: true }, children: /* @__PURE__ */ (0, import_jsx_runtime441.jsx)(import_uik508.DateTimePicker, { ref: forwardedRef, ...props2 }) }));
DatePicker.displayName = "DatePicker";
DatePicker.__DEV_METADATA__ = { status: "READY" };

// DateTimePicker/DateTimePicker.tsx
var import_uik518 = require("@appd/uik");
var import_react53 = require("react");

// DateTimePicker/CONTEXT.ts
var import_react50 = require("react");
var CONTEXT6 = (0, import_react50.createContext)({
  dateOnly: false,
  timeOnly: false
});

// DateTimePicker/DatePicker/DatePicker.tsx
var import_uik511 = require("@appd/uik");
var import_luxon6 = require("luxon");
var import_react51 = require("react");

// DateTimePicker/DatePicker/MESSAGES.ts
var MESSAGES4 = {
  DAYS: format.message`${["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]}`.description("Abbreviations for days of week"),
  MONTHS: format.message`${[
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]}`.description("Names of months")
};

// DateTimePicker/DatePicker/STYLES.ts
var import_uik509 = require("@appd/uik");
var {
  COLORS: {
    CONTROL_BG_STRONG: CONTROL_BG_STRONG2,
    CONTROL_BG_WEAK: CONTROL_BG_WEAK5,
    CONTROL_ICON_WEAK: CONTROL_ICON_WEAK2,
    DEFAULT_TEXT: DEFAULT_TEXT6,
    DEFAULT_TEXT_STRONG: DEFAULT_TEXT_STRONG4,
    INTERACT_TEXT: INTERACT_TEXT2,
    INTERACT_TEXT_IN: INTERACT_TEXT_IN2
  },
  RADIUS: RADIUS7,
  SPACING: SPACING15,
  TYPOGRAPHY: { P3_DEFAULT: P3_DEFAULT6, P3_EMPHASIS }
} = import_uik509.MAGNETIC_TOKENS;
var STYLES8 = {
  DAYS: import_uik509.css.Styles({
    DAY: import_uik509.css.Styles({
      "&.uik-date-picker-selected": {
        backgroundColor: CONTROL_BG_STRONG2,
        color: INTERACT_TEXT_IN2
      },
      "&:hover:not(.uik-date-picker-selected)": {
        color: INTERACT_TEXT2,
        font: P3_EMPHASIS
      },
      borderRadius: RADIUS7.DEFAULT,
      color: DEFAULT_TEXT6,
      font: P3_DEFAULT6,
      justifyContent: "center",
      maxHeight: 34,
      maxWidth: 32,
      minHeight: 34,
      minWidth: 32,
      padding: 0
    }),
    DAYS_CONTAINER: import_uik509.css.Styles({
      display: "grid",
      gridTemplateColumns: "repeat(7, 1fr)",
      padding: 0
    }),
    DAY_HEADER: import_uik509.css.Styles({
      color: DEFAULT_TEXT6,
      display: "flex",
      justifyContent: "center",
      minWidth: 18,
      padding: `${SPACING15[3]}px ${SPACING15[1]}px`,
      width: "100%"
    }),
    DAY_HEADER_CONTAINER: import_uik509.css.Styles({ display: "flex" }),
    OTHER_MONTH_DAY: import_uik509.css.Styles({ opacity: 0.5 })
  }),
  MONTH_SWITCHER: import_uik509.css.Styles({
    ARROW_BUTTON: import_uik509.css.Styles({
      "& > svg > path": { fill: CONTROL_ICON_WEAK2 },
      borderRadius: RADIUS7.DEFAULT,
      justifyContent: "center",
      padding: 0,
      width: 30
    }),
    MONTH_PLUS_YEAR: import_uik509.css.Styles({
      alignItems: "center",
      color: DEFAULT_TEXT_STRONG4,
      display: "flex",
      flex: 1,
      font: P3_EMPHASIS,
      justifyContent: "center"
    }),
    display: "flex",
    marginBottom: SPACING15[1]
  }),
  backgroundColor: CONTROL_BG_WEAK5,
  padding: SPACING15[3]
};

// DateTimePicker/DatePicker/useDays.ts
var import_uik510 = require("@appd/uik");
var import_luxon5 = require("luxon");
var getOtherMonthDays = /* @__PURE__ */ __name((dateTime2, backwards, prevMonthDayLength = 0) => {
  if (backwards) {
    const numberOfBackwardDays = dateTime2.weekday % 7;
    return Array.from(
      { length: numberOfBackwardDays },
      (_e, i) => dateTime2.minus(import_luxon5.Duration.fromObject({ day: numberOfBackwardDays - i }))
    );
  } else {
    const numberOfForwardDays = 42 - dateTime2.daysInMonth - prevMonthDayLength;
    return Array.from({ length: numberOfForwardDays }, (_e, i) => dateTime2.plus(import_luxon5.Duration.fromObject({ day: i + 1 })));
  }
}, "getOtherMonthDays");
var useDays = /* @__PURE__ */ __name((currentDateTime) => {
  const timeZonePlusLocale = {
    locale: import_uik510.format.LOCALE(),
    zone: import_uik510.format.TIME_ZONE()
  };
  const previousMonthDays = getOtherMonthDays(
    currentDateTime.startOf("month").set({
      hour: currentDateTime.hour,
      millisecond: currentDateTime.millisecond,
      minute: currentDateTime.minute,
      second: currentDateTime.second
    }),
    true
  );
  const currentMonthDays = [...Array(currentDateTime.daysInMonth).keys()].map((index) => index + 1).map(
    (index) => import_luxon5.DateTime.fromObject(
      {
        day: index,
        hour: currentDateTime.hour,
        millisecond: currentDateTime.millisecond,
        minute: currentDateTime.minute,
        month: currentDateTime.month,
        second: currentDateTime.second,
        year: currentDateTime.year
      },
      timeZonePlusLocale
    )
  );
  const nextMonthDays = getOtherMonthDays(
    currentDateTime.endOf("month").set({
      hour: currentDateTime.hour,
      millisecond: currentDateTime.millisecond,
      minute: currentDateTime.minute,
      second: currentDateTime.second
    }),
    false,
    previousMonthDays.length
  );
  return {
    currentMonthDays,
    nextMonthDays,
    previousMonthDays
  };
}, "useDays");

// DateTimePicker/DatePicker/DatePicker.tsx
var import_jsx_runtime442 = require("react/jsx-runtime");
var isSelected = /* @__PURE__ */ __name((prospectiveDateTime, selectedDateTime) => prospectiveDateTime.equals(selectedDateTime), "isSelected");
var onMonthChange = /* @__PURE__ */ __name((dateTime2, backwards = true) => {
  const dayDuration = import_luxon6.Duration.fromObject({ day: 1 });
  const time2 = {
    hour: dateTime2.hour,
    millisecond: dateTime2.millisecond,
    minute: dateTime2.minute,
    second: dateTime2.second
  };
  return backwards ? dateTime2.startOf("month").set(time2).minus(dayDuration) : dateTime2.endOf("month").set(time2).plus(dayDuration);
}, "onMonthChange");
var getDateTimeFromTimestamp = /* @__PURE__ */ __name((timestamp) => {
  const dateTime2 = import_luxon6.DateTime.fromMillis(
    timestamp != void 0 && !isNaN(timestamp) ? timestamp : import_luxon6.DateTime.now().toMillis(),
    {
      locale: import_uik511.format.LOCALE(),
      zone: import_uik511.format.TIME_ZONE()
    }
  );
  return import_luxon6.DateTime.fromObject(
    {
      day: dateTime2.day,
      hour: dateTime2.hour,
      millisecond: dateTime2.millisecond,
      minute: dateTime2.minute,
      month: dateTime2.month,
      second: dateTime2.second,
      year: dateTime2.year
    },
    {
      locale: import_uik511.format.LOCALE(),
      zone: import_uik511.format.TIME_ZONE()
    }
  );
}, "getDateTimeFromTimestamp");
var getNextMonthButton = /* @__PURE__ */ __name((element, direction) => {
  let nextElementSibling = direction === "left" ? element.previousElementSibling : element.nextElementSibling;
  while (nextElementSibling) {
    if (nextElementSibling.classList.contains("month-change")) {
      return nextElementSibling;
    }
    nextElementSibling = direction === "left" ? nextElementSibling.previousElementSibling : nextElementSibling.nextElementSibling;
  }
  return null;
}, "getNextMonthButton");
var DatePicker2 = import_uik511.utils.forwardRef(
  ({ className: className2, onTimestampChange, timestamp, ...props2 }, forwardedRef) => {
    const {
      DAYS: { DAY, DAY_HEADER, DAY_HEADER_CONTAINER, DAYS_CONTAINER, OTHER_MONTH_DAY },
      MONTH_SWITCHER: { ARROW_BUTTON, MONTH_PLUS_YEAR, ...MONTH_SWITCHER },
      ...HOST14
    } = STYLES8;
    const ref = import_uik511.utils.useBroadcastRef(forwardedRef);
    const monthsRef = (0, import_react51.useRef)(null);
    const daysRef = (0, import_react51.useRef)(null);
    const onDaySelection = /* @__PURE__ */ __name((day, isOtherMonth) => {
      onTimestampChange(day.toMillis());
      if (isOtherMonth) {
        setTimeout(() => {
          ref.current?.querySelector(".uik-date-picker-selected")?.focus();
        });
      }
    }, "onDaySelection");
    const [currentDateTime, setCurrentDateTime] = (0, import_react51.useState)(getDateTimeFromTimestamp(timestamp));
    import_uik511.utils.useLayoutEffect(() => {
      setCurrentDateTime(getDateTimeFromTimestamp(timestamp));
    }, [timestamp]);
    const currentMonthIndex = currentDateTime.month;
    const currentMonth = MESSAGES4.MONTHS(currentMonthIndex - 1);
    const currentYear = currentDateTime.year;
    const { currentMonthDays, nextMonthDays, previousMonthDays } = useDays(currentDateTime);
    const onMonthsKeyDown = /* @__PURE__ */ __name((event) => {
      const days = daysRef.current;
      const key = event.key;
      const currentFocus = document.activeElement;
      if (key === "ArrowDown") {
        event.preventDefault();
        days.firstElementChild?.focus();
      } else if (key === "ArrowLeft") {
        event.preventDefault();
        (getNextMonthButton(currentFocus, "left") ?? currentFocus.nextElementSibling?.nextElementSibling)?.focus();
      } else if (key === "ArrowRight") {
        event.preventDefault();
        (getNextMonthButton(currentFocus, "right") ?? currentFocus.previousElementSibling?.previousElementSibling)?.focus();
      }
    }, "onMonthsKeyDown");
    const onDaysKeyDown = /* @__PURE__ */ __name((event) => {
      const datePicker = ref.current;
      const days = daysRef.current;
      const key = event.key;
      const currentFocus = document.activeElement;
      if (key === "ArrowDown") {
        event.preventDefault();
        let newElement = currentFocus;
        for (let i = 0; i < 7; i++) {
          newElement = newElement?.nextElementSibling ?? days.firstElementChild;
        }
        newElement.focus();
      } else if (key === "ArrowUp") {
        event.preventDefault();
        let newElement = currentFocus;
        for (let i = 0; i < 7; i++) {
          newElement = newElement?.previousElementSibling ? newElement?.previousElementSibling : null;
        }
        newElement != null ? newElement.focus() : datePicker.querySelector(".left-month-change")?.focus();
      } else if (key === "ArrowLeft") {
        event.preventDefault();
        (currentFocus?.previousElementSibling ?? days.lastElementChild).focus();
      } else if (key === "ArrowRight") {
        event.preventDefault();
        (currentFocus?.nextElementSibling ?? days.firstElementChild).focus();
      }
    }, "onDaysKeyDown");
    return /* @__PURE__ */ (0, import_jsx_runtime442.jsxs)("div", { className: (0, import_uik511.css)(HOST14, ...import_uik511.utils.many(className2)), ref, uik: "DateTimePicker.DatePicker", ...props2, children: [
      /* @__PURE__ */ (0, import_jsx_runtime442.jsxs)("div", { className: (0, import_uik511.css)(MONTH_SWITCHER), onKeyDown: onMonthsKeyDown, ref: monthsRef, children: [
        /* @__PURE__ */ (0, import_jsx_runtime442.jsx)(
          import_uik511.Button,
          {
            className: `${(0, import_uik511.css)(ARROW_BUTTON)} left-month-change month-change`,
            onClick: () => setCurrentDateTime(onMonthChange(currentDateTime, true)),
            type: "MENU_ITEM",
            children: /* @__PURE__ */ (0, import_jsx_runtime442.jsx)(import_uik511.Icon.Navigation.ChevronLeft, {})
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime442.jsxs)("span", { className: (0, import_uik511.css)(MONTH_PLUS_YEAR), children: [
          currentMonth,
          " ",
          currentYear
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime442.jsx)(
          import_uik511.Button,
          {
            className: `${(0, import_uik511.css)(ARROW_BUTTON)} month-change`,
            onClick: () => setCurrentDateTime(onMonthChange(currentDateTime, false)),
            tabIndex: -1,
            type: "MENU_ITEM",
            children: /* @__PURE__ */ (0, import_jsx_runtime442.jsx)(import_uik511.Icon.Navigation.ChevronRight, {})
          }
        )
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime442.jsxs)("div", { children: [
        /* @__PURE__ */ (0, import_jsx_runtime442.jsx)("div", { className: (0, import_uik511.css)(DAY_HEADER_CONTAINER), children: [...Array(7)].map((_, index) => /* @__PURE__ */ (0, import_jsx_runtime442.jsx)("div", { className: (0, import_uik511.css)(DAY_HEADER), children: MESSAGES4.DAYS(index) }, MESSAGES4.DAYS(index))) }),
        /* @__PURE__ */ (0, import_jsx_runtime442.jsx)("div", { className: (0, import_uik511.css)(DAYS_CONTAINER), onKeyDown: onDaysKeyDown, ref: daysRef, children: [previousMonthDays, currentMonthDays, nextMonthDays].map(
          (monthDays, monthsIndex) => monthDays.map((monthDay) => /* @__PURE__ */ (0, import_jsx_runtime442.jsx)(
            import_uik511.Button,
            {
              className: `${(0, import_uik511.css)(DAY, monthsIndex !== 1 ? OTHER_MONTH_DAY : {})} ${isSelected(monthDay, getDateTimeFromTimestamp(timestamp)) ? "uik-date-picker-selected" : ""}`,
              onClick: () => onDaySelection(monthDay, monthsIndex === 0 || monthsIndex === 2),
              selected: isSelected(monthDay, getDateTimeFromTimestamp(timestamp)),
              tabIndex: -1,
              type: "MENU_ITEM",
              children: monthDay.day
            },
            monthDay.day
          ))
        ) })
      ] })
    ] });
  }
);
DatePicker2.displayName = "DateTimePicker.DatePicker";

// DateTimePicker/getDateTime.ts
var import_uik512 = require("@appd/uik");
var import_luxon7 = require("luxon");
var getInputFormat = /* @__PURE__ */ __name((locale = "en-US", fractionalSecondDigits, dateOnly, timeOnly) => {
  const milliseconds = fractionalSecondDigits ? `:ss${locale == "fr-FR" ? "," : "."}${"S".repeat(fractionalSecondDigits)}` : ``;
  const DATETIME_INPUT_FORMATS = {
    ["en-US"]: `M/d/yyyy, h:mm${milliseconds} a`,
    ["fr-FR"]: `d/M/yyyy. h:mm${milliseconds} a`,
    ["ja-JP"]: `yyyy/M/d, ah:mm${milliseconds}`,
    ["te-ST"]: `d-M-yyyy, h:mm${milliseconds} a`
  };
  const DATE_INPUT_FORMATS = {
    ["en-US"]: `M/d/yyyy`,
    ["fr-FR"]: `d/M/yyyy`,
    ["ja-JP"]: `yyyy/M/d`,
    ["te-ST"]: `d-M-yyyy`
  };
  const TIME_INPUT_FORMATS = {
    ["en-US"]: `h:mm${milliseconds} a`,
    ["fr-FR"]: `h:mm${milliseconds} a`,
    ["ja-JP"]: `ah:mm${milliseconds}`,
    ["te-ST"]: `h:mm${milliseconds} a`
  };
  return dateOnly ? DATE_INPUT_FORMATS[locale] : timeOnly ? TIME_INPUT_FORMATS[locale] : DATETIME_INPUT_FORMATS[locale];
}, "getInputFormat");
var getDateTime = /* @__PURE__ */ __name((formattedTimestamp, displayFormat, dateOnly, timeOnly) => import_luxon7.DateTime.fromFormat(
  formattedTimestamp,
  getInputFormat(import_uik512.format.LOCALE(), displayFormat?.fractionalSecondDigits, dateOnly, timeOnly),
  {
    locale: import_uik512.format.LOCALE(),
    zone: import_uik512.format.TIME_ZONE()
  }
), "getDateTime");

// DateTimePicker/getFormattedTimestamp.ts
var import_uik513 = require("@appd/uik");
var getFormattedTimestamp = /* @__PURE__ */ __name(({ dateOnly, displayFormat, timeOnly, timestamp }) => dateOnly ? import_uik513.format.date(timestamp, {
  ...{
    day: "numeric",
    month: "numeric",
    year: "numeric"
  }
}) : timeOnly ? import_uik513.format.time(timestamp, {
  ...{
    fractionalSecondDigits: void 0,
    hour: "numeric",
    hour12: true,
    minute: "numeric",
    second: "numeric"
  },
  ...displayFormat
}) : import_uik513.format.dateTime(timestamp, {
  ...{
    day: "numeric",
    month: "numeric",
    year: "numeric"
  },
  ...{
    fractionalSecondDigits: void 0,
    hour: "numeric",
    hour12: true,
    minute: "numeric",
    second: "numeric"
  },
  ...displayFormat
}), "getFormattedTimestamp");

// DateTimePicker/getState.ts
var getState = /* @__PURE__ */ __name(({ dateOnly, displayFormat, timeOnly, timestamp }) => ({
  formattedTimestamp: timestamp || timestamp === 0 ? getFormattedTimestamp({
    dateOnly,
    displayFormat,
    timeOnly,
    timestamp
  }) : ""
}), "getState");

// DateTimePicker/getStyles.ts
var import_uik514 = require("@appd/uik");
var {
  COLORS: {
    CONTROL_BG_WEAK: CONTROL_BG_WEAK6,
    CONTROL_BORDER: CONTROL_BORDER7,
    CONTROL_BORDER_WEAK: CONTROL_BORDER_WEAK6,
    CONTROL_ICON_ACTIVE,
    CONTROL_ICON_WEAK: CONTROL_ICON_WEAK3,
    DEFAULT_TEXT: DEFAULT_TEXT7,
    NEGATIVE_TEXT
  },
  RADIUS: RADIUS8,
  SPACING: SPACING16
} = import_uik514.MAGNETIC_TOKENS;
var getStyles12 = /* @__PURE__ */ __name((width, dateOnly, timeOnly, selected) => ({
  ACTIONS: (0, import_uik514.css)({ display: "flex" }),
  CLEAR: (0, import_uik514.css)({
    "& > svg": {
      "& > path": { fill: CONTROL_ICON_WEAK3 },
      width: 18
    },
    "&:hover": {
      "& > svg > path": { fill: CONTROL_ICON_ACTIVE },
      backgroundColor: "transparent"
    },
    backgroundColor: "transparent",
    justifyContent: "center",
    marginTop: 2,
    minWidth: 18,
    padding: 0,
    width: 18
  }),
  CLOSE: (0, import_uik514.css)({ paddingInline: SPACING16[2] }),
  DATE_PICKER: (0, import_uik514.css)({
    "& > div > div > button.uik-date-picker-selected": {
      ...selected ? {} : {
        backgroundColor: "transparent",
        color: `${DEFAULT_TEXT7}`
      }
    }
  }),
  DATE_TIME_PICKER: (0, import_uik514.css)({
    "& > div:first-child": !dateOnly && !timeOnly ? { borderRight: `1px solid ${CONTROL_BORDER_WEAK6}` } : {},
    borderBottom: `1px solid ${CONTROL_BORDER_WEAK6}`,
    display: "flex",
    overflow: "hidden"
  }),
  ERROR: (0, import_uik514.css)({
    "&:first-letter": { textTransform: "capitalize" },
    color: NEGATIVE_TEXT,
    marginTop: SPACING16[1]
  }),
  FOOTER: (0, import_uik514.css)({
    display: "flex",
    justifyContent: "flex-end",
    padding: SPACING16[2]
  }),
  HOST: (0, import_uik514.css)({ width: "100%" }),
  INPUT_CONTAINER: (0, import_uik514.css)({ display: "flex" }),
  OVERLAY: (0, import_uik514.css)({
    display: "flex",
    marginLeft: -(width - (dateOnly ? 143 : timeOnly ? 64 : 187)),
    maxHeight: 370,
    overflow: "hidden"
  }),
  OVERLAY_CONTENT: (0, import_uik514.css)({
    backgroundColor: CONTROL_BG_WEAK6,
    border: `2px solid ${CONTROL_BORDER7}`,
    borderRadius: RADIUS8.HEAVY,
    boxShadow: "none",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    marginBlock: SPACING16[1],
    minWidth: dateOnly ? 252 : timeOnly ? 94 : 340,
    overflow: "hidden",
    padding: 0,
    width: dateOnly ? 252 : timeOnly ? 94 : 340
  }),
  OVERLAY_TRIGGER: (0, import_uik514.css)({
    "& > svg": {
      "& > path": { fill: CONTROL_ICON_WEAK3 },
      width: 18
    },
    "&:hover": {
      "& > svg > path": { fill: CONTROL_ICON_ACTIVE },
      backgroundColor: "transparent"
    },
    backgroundColor: "transparent",
    justifyContent: "center",
    margin: 2,
    padding: 0
  }),
  TIME_PICKER: (0, import_uik514.css)({
    "& > div > button": {
      ...selected ? {} : {
        backgroundColor: "transparent",
        color: `${DEFAULT_TEXT7}`
      }
    }
  })
}), "getStyles");

// DateTimePicker/MESSAGES.ts
var import_uik515 = require("@appd/uik");
var MESSAGES5 = {
  // (object-curly-newline)
  OK: import_uik515.format.message`OK`.description("A confirmation button to close a date picker dropdown.")
};

// DateTimePicker/TimePicker/TimePicker.tsx
var import_uik517 = require("@appd/uik");
var import_luxon9 = require("luxon");
var import_react52 = require("react");

// DateTimePicker/TimePicker/getTimes.ts
var import_luxon8 = require("luxon");
var getTimes = /* @__PURE__ */ __name((startTime) => Array(24 * 2).fill(0).map((_, index) => startTime.plus(import_luxon8.Duration.fromObject({ minutes: 30 * index }))), "getTimes");

// DateTimePicker/TimePicker/STYLES.ts
var import_uik516 = require("@appd/uik");
var {
  COLORS: { CONTROL_BG_WEAK: CONTROL_BG_WEAK7 }
} = import_uik516.MAGNETIC_TOKENS;
var STYLES9 = {
  backgroundColor: CONTROL_BG_WEAK7,
  boxSizing: "border-box",
  minWidth: 90,
  overflowY: "auto",
  width: "100%"
};

// DateTimePicker/TimePicker/TimePicker.tsx
var import_jsx_runtime443 = require("react/jsx-runtime");
var TimePicker = import_uik517.utils.forwardRef(
  ({ className: className2, onTimestampChange, timestamp, ...props2 }, forwardedRef) => {
    const [selected, setSelected] = (0, import_react52.useState)(void 0);
    const [times, setTimes] = (0, import_react52.useState)(
      () => getTimes(
        import_luxon9.DateTime.fromMillis(import_luxon9.DateTime.now().startOf("day").toMillis(), {
          locale: import_uik517.format.LOCALE(),
          zone: import_uik517.format.TIME_ZONE()
        }).startOf("day")
      )
    );
    (0, import_react52.useEffect)(() => {
      if (timestamp != void 0 && !isNaN(timestamp)) {
        const userDateTime = import_luxon9.DateTime.fromMillis(timestamp, {
          locale: import_uik517.format.LOCALE(),
          zone: import_uik517.format.TIME_ZONE()
        });
        setSelected(userDateTime.hour * 2 + userDateTime.minute / 30);
        setTimes(
          getTimes(
            import_luxon9.DateTime.fromMillis(timestamp, {
              locale: import_uik517.format.LOCALE(),
              zone: import_uik517.format.TIME_ZONE()
            }).startOf("day")
          )
        );
      }
    }, [timestamp]);
    const { ...HOST14 } = STYLES9;
    return /* @__PURE__ */ (0, import_jsx_runtime443.jsx)(
      import_uik517.ScrollBox,
      {
        className: (0, import_uik517.css)(HOST14, ...import_uik517.utils.many(className2)),
        ref: forwardedRef,
        uik: "DateTimePicker.TimePicker",
        ...props2,
        children: /* @__PURE__ */ (0, import_jsx_runtime443.jsx)(
          import_uik517.Menu.List,
          {
            onSelect: (indices) => {
              onTimestampChange(times[indices[0]].toMillis());
            },
            selected,
            children: times.map((time2, index) => /* @__PURE__ */ (0, import_jsx_runtime443.jsx)(import_uik517.Menu.Option, { tabIndex: index === 0 ? 0 : -1, children: time2.setLocale(import_uik517.format.LOCALE()).setZone(import_uik517.format.TIME_ZONE()).toLocaleString({ timeStyle: "short" }) }, time2.toMillis()))
          }
        )
      }
    );
  }
);
TimePicker.displayName = "DateTimePicker.TimePicker";

// DateTimePicker/DateTimePicker.tsx
var import_jsx_runtime444 = require("react/jsx-runtime");
var DateTimePicker2 = Object.assign(
  import_uik518.utils.forwardRef(
    ({
      className: className2,
      displayFormat,
      errors,
      onOverlayVisibleChange,
      onTimestampChange,
      overlay,
      overlayVisible = false,
      required,
      timestamp,
      ...props2
    }, forwardedRef) => {
      const { dateOnly, timeOnly } = (0, import_react53.useContext)(CONTEXT6);
      const state = getState({
        dateOnly,
        displayFormat,
        timeOnly,
        timestamp
      });
      const [width, setWidth] = (0, import_react53.useState)(0);
      const [value, setValue] = (0, import_react53.useState)(state.formattedTimestamp);
      const [invalidExplanation, setInvalidExplanation] = (0, import_react53.useState)("");
      const [prevTimestamp, setPrevTimestamp] = (0, import_react53.useState)(timestamp);
      const [visible, setVisible] = (0, import_react53.useState)(overlayVisible);
      const inputRef = (0, import_react53.useRef)(null);
      const overlayRef = (0, import_react53.useRef)(null);
      (0, import_react53.useEffect)(() => {
        setVisible(overlayVisible ?? false);
      }, [overlayVisible]);
      const ref = import_uik518.utils.useBroadcastRef(forwardedRef);
      import_uik518.utils.useLayoutEffect(() => {
        setWidth(inputRef.current?.offsetWidth ?? 0);
      }, []);
      import_uik518.utils.useLayoutEffect(() => {
        !isNaN(timestamp ?? NaN) && setPrevTimestamp(timestamp);
        setValue(state.formattedTimestamp);
      }, [timestamp]);
      const onBlur = /* @__PURE__ */ __name((event) => {
        const newDateTime = getDateTime(event.currentTarget.value, displayFormat, dateOnly, timeOnly);
        !newDateTime.invalidReason && onTimestampChange(newDateTime.toMillis());
        !isNaN(timestamp ?? NaN) && setInvalidExplanation(newDateTime.invalidExplanation);
      }, "onBlur");
      const onPopoverKeyUp = /* @__PURE__ */ __name((event) => {
        event.stopPropagation();
        if (event.key === "Escape") {
          setVisible(false);
          onOverlayVisibleChange?.(false);
          setTimeout(() => {
            inputRef.current?.focus();
          });
        }
      }, "onPopoverKeyUp");
      const {
        ACTIONS,
        CLEAR,
        CLOSE: CLOSE3,
        DATE_PICKER,
        DATE_TIME_PICKER,
        ERROR,
        FOOTER: FOOTER3,
        HOST: HOST14,
        INPUT_CONTAINER,
        OVERLAY: OVERLAY2,
        OVERLAY_CONTENT: OVERLAY_CONTENT2,
        OVERLAY_TRIGGER,
        TIME_PICKER
      } = getStyles12(width, dateOnly, timeOnly, !isNaN(timestamp ?? NaN));
      return /* @__PURE__ */ (0, import_jsx_runtime444.jsxs)("div", { className: (0, import_uik518.css)(HOST14, ...import_uik518.utils.many(className2)), ref, uik: "DateTimePicker", children: [
        /* @__PURE__ */ (0, import_jsx_runtime444.jsx)("div", { className: INPUT_CONTAINER, children: /* @__PURE__ */ (0, import_jsx_runtime444.jsx)(
          import_uik518.Input,
          {
            actions: /* @__PURE__ */ (0, import_jsx_runtime444.jsxs)("div", { className: (0, import_uik518.css)(ACTIONS), children: [
              !required && !isNaN(timestamp ?? NaN) && /* @__PURE__ */ (0, import_jsx_runtime444.jsx)(
                import_uik518.Button,
                {
                  className: (0, import_uik518.css)(CLEAR),
                  icon: "Action.Cancel",
                  onClick: () => {
                    onTimestampChange(NaN);
                  },
                  type: "TERTIARY"
                }
              ),
              overlay ? /* @__PURE__ */ (0, import_jsx_runtime444.jsx)(
                import_uik518.Popover,
                {
                  arrow: false,
                  className: (0, import_uik518.css)(OVERLAY2),
                  content: /* @__PURE__ */ (0, import_jsx_runtime444.jsxs)(import_jsx_runtime444.Fragment, { children: [
                    /* @__PURE__ */ (0, import_jsx_runtime444.jsxs)("div", { className: DATE_TIME_PICKER, onKeyUp: onPopoverKeyUp, ref: overlayRef, children: [
                      !timeOnly && /* @__PURE__ */ (0, import_jsx_runtime444.jsx)(
                        DateTimePicker2.DatePicker,
                        {
                          className: (0, import_uik518.css)(DATE_PICKER),
                          onTimestampChange,
                          timestamp: !isNaN(timestamp ?? NaN) ? timestamp : prevTimestamp
                        }
                      ),
                      !dateOnly && /* @__PURE__ */ (0, import_jsx_runtime444.jsx)("div", { children: /* @__PURE__ */ (0, import_jsx_runtime444.jsx)(
                        DateTimePicker2.TimePicker,
                        {
                          className: (0, import_uik518.css)(TIME_PICKER),
                          onTimestampChange,
                          timestamp: !isNaN(timestamp ?? NaN) ? timestamp : prevTimestamp
                        }
                      ) })
                    ] }),
                    /* @__PURE__ */ (0, import_jsx_runtime444.jsx)("div", { className: FOOTER3, children: /* @__PURE__ */ (0, import_jsx_runtime444.jsx)(
                      import_uik518.Button,
                      {
                        className: CLOSE3,
                        onClick: () => {
                          setVisible(false);
                          onOverlayVisibleChange?.(false);
                          setTimeout(() => {
                            if (!visible) {
                              overlayRef?.current?.querySelector(".uik-date-picker-selected")?.focus();
                            }
                          });
                        },
                        children: MESSAGES5.OK()
                      }
                    ) })
                  ] }),
                  contentClassName: OVERLAY_CONTENT2,
                  ignore: ref,
                  onVisibleChange: setVisible,
                  position: "BOTTOM",
                  stopPropagation: true,
                  trigger: "CLICK",
                  visible,
                  children: /* @__PURE__ */ (0, import_jsx_runtime444.jsx)(
                    import_uik518.Button,
                    {
                      className: OVERLAY_TRIGGER,
                      icon: "Action.Calendar",
                      onClick: () => {
                        setVisible(!visible);
                        onOverlayVisibleChange?.(!visible);
                        setTimeout(() => {
                          if (!visible) {
                            overlayRef?.current?.querySelector(".uik-date-picker-selected")?.focus();
                          }
                        });
                      },
                      selected: visible,
                      type: "TERTIARY"
                    }
                  )
                }
              ) : /* @__PURE__ */ (0, import_jsx_runtime444.jsx)(import_jsx_runtime444.Fragment, {})
            ] }),
            errors,
            onBlur,
            onChange: (e) => setValue(e.target.value),
            ref: inputRef,
            required,
            value,
            ...props2
          }
        ) }),
        /* @__PURE__ */ (0, import_jsx_runtime444.jsx)("div", { className: ERROR, children: invalidExplanation })
      ] });
    }
  ),
  {
    CONTEXT: CONTEXT6,
    DatePicker: DatePicker2,
    TimePicker
  }
);
DateTimePicker2.displayName = "DateTimePicker";
DateTimePicker2.__DEV_METADATA__ = { status: "READY" };

// Dialog/Dialog.tsx
var import_uik522 = require("@appd/uik");
var import_react54 = require("react");

// Dialog/MESSAGES.ts
var MESSAGES6 = {
  CLOSE: format.message`Close`.description("A button to close a dialog."),
  CONFIRM_ACTION: format.message`Discard`.description("A confirmation of discarding a dialog's input."),
  CONFIRM_CANCEL: format.message`Keep Editing`.description("A confirmation to continue editing a dialog's input."),
  CONFIRM_MESSAGE: format.message`Are you sure you want to cancel? This will discard your input.`.description(
    "A short message to describe that the user will lose unsaved changes in the dialog if they close it."
  ),
  CONFIRM_TITLE: format.message`Unsaved Changes`.description(
    "A title for a confirmation dialog, to indicate there are unsaved changes."
  )
};

// Dialog/NoOverscrolling.tsx
var import_uik519 = require("@appd/uik");
var import_jsx_runtime445 = require("react/jsx-runtime");
var NoOverscrolling = /* @__PURE__ */ __name(({ children, className: className2, ...props2 }) => /* @__PURE__ */ (0, import_jsx_runtime445.jsxs)("div", { className: (0, import_uik519.css)(NO_OVERSCROLLING, className2), uik: "NoOverscrolling", ...props2, children: [
  /* @__PURE__ */ (0, import_jsx_runtime445.jsx)("div", { className: SPACER, uik: `${props2.uik ?? "NoOverscrolling"}.SPACER` }),
  children
] }), "NoOverscrolling");
var NO_OVERSCROLLING = (0, import_uik519.css)({
  "::-webkit-scrollbar": { display: "none" },
  height: "100%",
  overflow: "scroll",
  overscrollBehavior: "none",
  position: "relative",
  scrollbarWidth: "none",
  width: "100%"
});
var SPACER = (0, import_uik519.css)({
  height: "calc(100% + 1px)",
  left: 0,
  position: "absolute",
  top: 0,
  width: 1
});

// Dialog/Sticky.tsx
var import_uik520 = require("@appd/uik");
var import_jsx_runtime446 = require("react/jsx-runtime");
var Sticky = /* @__PURE__ */ __name(({ className: className2, ...props2 }) => /* @__PURE__ */ (0, import_jsx_runtime446.jsx)("div", { className: (0, import_uik520.css)(STICKY, className2), uik: "Sticky", ...props2 }), "Sticky");
var STICKY = (0, import_uik520.css)({
  contain: "size layout style",
  containIntrinsicSize: 0,
  height: 0,
  left: 0,
  position: "sticky",
  top: 0,
  width: 0
});

// Dialog/STYLES.ts
var import_uik521 = require("@appd/uik");
var {
  COLORS: { CONTROL_BG_WEAK: CONTROL_BG_WEAK8, CONTROL_ICON_WEAK: CONTROL_ICON_WEAK4, DEFAULT_TEXT: DEFAULT_TEXT8 },
  RADIUS: RADIUS9,
  SPACING: SPACING17,
  STATIC: { MODAL_BACKDROP },
  TYPOGRAPHY: { HEADING_PRIMARY }
} = import_uik521.MAGNETIC_TOKENS;
var STYLES10 = {
  BACKDROP: (0, import_uik521.css)({
    backgroundColor: MODAL_BACKDROP,
    left: 0,
    position: "absolute",
    top: 0
  }),
  CANCEL: (0, import_uik521.css)({ marginRight: SPACING17[3] }),
  CLOSE: (0, import_uik521.css)({
    "& > svg > path": { fill: CONTROL_ICON_WEAK4 },
    backgroundColor: "transparent",
    marginLeft: 0,
    marginRight: "auto",
    paddingLeft: 0,
    paddingRight: 0
  }),
  CONFIRM: (0, import_uik521.css)({ padding: SPACING17[4] }),
  CONTENT: (0, import_uik521.css)({
    backgroundColor: CONTROL_BG_WEAK8,
    height: "fit-content",
    maxHeight: "calc(100% - 34px - 62px)",
    minHeight: 0,
    pointerEvents: "initial"
  }),
  FOOTER: (0, import_uik521.css)({
    backgroundColor: CONTROL_BG_WEAK8,
    borderBottomLeftRadius: RADIUS9.HEAVY,
    borderBottomRightRadius: RADIUS9.HEAVY,
    boxSizing: "border-box",
    display: "flex",
    height: 82,
    justifyContent: "flex-end",
    padding: SPACING17[6],
    pointerEvents: "initial"
  }),
  /** Set the available dimensions for the MODAL. */
  FRAME: (0, import_uik521.css)({
    "--availableHeight": "calc(min(var(--clientHeight), 100vh) - 2 * 80px)",
    "--availableWidth": "calc(min(var(--clientWidth), 100vw) - 2 * 80px)",
    height: "var(--availableHeight)",
    margin: 80,
    pointerEvents: "none",
    width: "var(--availableWidth)"
  }),
  HEADER: (0, import_uik521.css)({
    alignItems: "center",
    backgroundColor: CONTROL_BG_WEAK8,
    borderTopLeftRadius: RADIUS9.HEAVY,
    borderTopRightRadius: RADIUS9.HEAVY,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "row",
    paddingBottom: SPACING17[4],
    paddingLeft: SPACING17[6],
    paddingRight: SPACING17[6],
    paddingTop: SPACING17[6],
    pointerEvents: "initial"
  }),
  HOST: (0, import_uik521.css)({
    height: "var(--scrollHeight)",
    left: 0,
    position: "absolute",
    top: 0,
    width: "var(--scrollWidth)"
  }),
  /**
   * Container for the HEADER, CONTENT, FOOTER that keeps it vertically centered.
   *
   * Can't set `pointerEvents` or `backgroundColor` here because this element is larger than the visible area.
   */
  MODAL: (0, import_uik521.css)({
    alignItems: "stretch",
    color: DEFAULT_TEXT8,
    display: "flex",
    flexDirection: "column",
    height: "var(--availableHeight)",
    justifyContent: "center",
    marginLeft: "calc((var(--availableWidth) - var(--width)) / 2)",
    width: "var(--width)"
  }),
  TITLE: (0, import_uik521.css)({
    ":not(:first-child)": { marginLeft: SPACING17[2] },
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    // temporary until redesigned
    font: HEADING_PRIMARY,
    marginRight: SPACING17[3]
  })
};

// Dialog/Dialog.tsx
var import_jsx_runtime447 = require("react/jsx-runtime");
var Dialog = import_uik522.utils.forwardRef(
  ({
    action,
    cancel,
    children,
    className: className2,
    closeBehavior = {},
    hideClose = false,
    icon,
    onClose,
    open: rawOpen,
    size = "MEDIUM",
    stopPropagation,
    title,
    ...props2
  }, ref) => {
    const { zIndex } = (0, import_react54.useContext)(import_uik522.Overlay.CONTEXT);
    const [confirmOpen, setConfirmOpen] = (0, import_react54.useState)(false);
    const [open, setOpen] = (0, import_react54.useState)(true);
    const [didOpen, setDidOpen] = (0, import_react54.useState)(false);
    if (rawOpen !== void 0 && rawOpen !== open) {
      setOpen(rawOpen);
    } else if (!didOpen && open) {
      setDidOpen(true);
    }
    const contentCloseHandler = (0, import_react54.useCallback)(
      (kind) => closeBehavior[kind] === "CONFIRM" ? setConfirmOpen(true) : closeBehavior[kind] !== "IGNORE" && (onClose(kind), setOpen(false)),
      [closeBehavior, onClose]
    );
    const confirmCloseHandler = (0, import_react54.useCallback)(
      (kind) => {
        if (kind === "ACTION") {
          onClose("CONFIRM");
          setOpen(false);
        }
        setConfirmOpen(false);
      },
      [onClose]
    );
    (0, import_react54.useEffect)(
      () => import_uik522.utils.addEventListener(
        document.body,
        "keydown",
        ({ key }) => key === "Escape" && [contentCloseHandler("ESCAPE_KEY"), confirmCloseHandler("ESCAPE_KEY")]
      ),
      [contentCloseHandler, confirmCloseHandler]
    );
    return didOpen ? /* @__PURE__ */ (0, import_jsx_runtime447.jsx)(import_uik522.Overlay.Provider, { promote: Infinity, zIndex, children: /* @__PURE__ */ (0, import_jsx_runtime447.jsxs)(import_uik522.Overlay, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime447.jsxs)(
        "div",
        {
          className: (0, import_uik522.css)(
            HOST3,
            { zIndex },
            // Better than `display: none`. In firefox, `display: none` loses stickiness on second open.
            !open && { visibility: "hidden" }
          ),
          uik: "Dialog",
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime447.jsx)(
              NoOverscrolling,
              {
                className: BACKDROP,
                onClick: (e) => {
                  contentCloseHandler("BACKDROP");
                  stopPropagation && e.stopPropagation();
                },
                uik: "Dialog.BACKDROP"
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime447.jsx)(Sticky, { children: /* @__PURE__ */ (0, import_jsx_runtime447.jsx)(NoOverscrolling, { className: FRAME, children: /* @__PURE__ */ (0, import_jsx_runtime447.jsx)(Sticky, { children: /* @__PURE__ */ (0, import_jsx_runtime447.jsxs)(
              "div",
              {
                className: (0, import_uik522.css)(MODAL, {
                  "--width": `min(var(--availableWidth), ${{
                    FULLSCREEN: 840,
                    LARGE: 840,
                    MEDIUM: 600,
                    SMALL: 400
                  }[size]}px)`
                }),
                uik: "Dialog.MODAL",
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime447.jsxs)("div", { className: HEADER2, uik: "Dialog.HEADER", children: [
                    typeof icon === "string" ? /* @__PURE__ */ (0, import_jsx_runtime447.jsx)(
                      import_uik522.Icon,
                      {
                        className: (0, import_uik522.css)({
                          "& path": {
                            fill: {
                              ERROR: NEGATIVE_ICON2,
                              INFO: INFO_ICON,
                              SUCCESS: POSITIVE_ICON2,
                              WARNING: WARNING_ICON2
                            }[icon] ?? CONTROL_ICON_WEAK5
                          }
                        }),
                        size: "MEDIUM",
                        type: {
                          ERROR: "Status.Error",
                          INFO: "Status.Info",
                          SUCCESS: "Status.Success",
                          WARNING: "Status.Warning"
                        }[icon] ?? "Status.Info"
                      }
                    ) : icon,
                    /* @__PURE__ */ (0, import_jsx_runtime447.jsx)("div", { className: TITLE, children: title })
                  ] }),
                  /* @__PURE__ */ (0, import_jsx_runtime447.jsx)(
                    import_uik522.ScrollBox,
                    {
                      className: (0, import_uik522.css)(CONTENT2, size === "FULLSCREEN" && { flexGrow: 1 }, ...import_uik522.utils.many(className2)),
                      ref,
                      uik: "Dialog.CONTENT",
                      ...props2,
                      children: /* @__PURE__ */ (0, import_jsx_runtime447.jsx)(import_uik522.Overlay.Provider, { promote: 1, zIndex: zIndex + 1, children })
                    }
                  ),
                  /* @__PURE__ */ (0, import_jsx_runtime447.jsxs)("div", { className: (0, import_uik522.css)(FOOTER, size === "FULLSCREEN" && { marginTop: "auto" }), uik: "Dialog.FOOTER", children: [
                    !hideClose && /* @__PURE__ */ (0, import_jsx_runtime447.jsx)(import_uik522.Button, { className: CLOSE, onClick: () => contentCloseHandler("CLOSE_ICON"), type: "TERTIARY", children: MESSAGES6.CLOSE() }),
                    cancel && /* @__PURE__ */ (0, import_jsx_runtime447.jsx)(import_uik522.Button, { className: CANCEL, onClick: () => contentCloseHandler("CANCEL"), type: "SECONDARY", children: cancel }),
                    /* @__PURE__ */ (0, import_jsx_runtime447.jsx)(import_uik522.Button, { onClick: () => contentCloseHandler("ACTION"), type: "PRIMARY", children: action })
                  ] })
                ]
              }
            ) }) }) })
          ]
        }
      ),
      confirmOpen && /* @__PURE__ */ (0, import_jsx_runtime447.jsx)(import_uik522.Overlay.Provider, { promote: 1, zIndex: zIndex + 1, children: /* @__PURE__ */ (0, import_jsx_runtime447.jsx)(
        Dialog,
        {
          action: CONFIRM_ACTION(),
          cancel: CONFIRM_CANCEL(),
          closeBehavior: { BACKDROP: "IGNORE" },
          icon: "WARNING",
          onClose: confirmCloseHandler,
          open: confirmOpen,
          size: "SMALL",
          title: CONFIRM_TITLE(),
          children: /* @__PURE__ */ (0, import_jsx_runtime447.jsx)("div", { className: CONFIRM, children: CONFIRM_MESSAGE() })
        }
      ) })
    ] }) }) : /* @__PURE__ */ (0, import_jsx_runtime447.jsx)(import_jsx_runtime447.Fragment, {});
  }
);
Dialog.displayName = "Dialog";
Dialog.__DEV_METADATA__ = { status: "READY" };
var {
  COLORS: { CONTROL_ICON_WEAK: CONTROL_ICON_WEAK5, INFO_ICON, NEGATIVE_ICON: NEGATIVE_ICON2, POSITIVE_ICON: POSITIVE_ICON2, WARNING_ICON: WARNING_ICON2 }
} = import_uik522.MAGNETIC_TOKENS;
var { BACKDROP, CANCEL, CLOSE, CONFIRM, CONTENT: CONTENT2, FOOTER, FRAME, HEADER: HEADER2, HOST: HOST3, MODAL, TITLE } = STYLES10;
var { CONFIRM_ACTION, CONFIRM_CANCEL, CONFIRM_MESSAGE, CONFIRM_TITLE } = MESSAGES6;

// Drawer/Drawer.tsx
var import_uik528 = require("@appd/uik");
var import_react57 = require("@appd/utils/@react");
var import_react58 = require("react");

// Drawer/DESTINATION.ts
var import_uik523 = require("@appd/uik");
var DESTINATION = import_uik523.utils.mutable(void 0);

// Drawer/Divider/Divider.tsx
var import_uik525 = require("@appd/uik");

// Drawer/Divider/STYLES.ts
var import_uik524 = require("@appd/uik");

// Drawer/CONSTANTS/CONSTANTS.ts
var { SPACING: SPACING18 } = MAGNETIC_TOKENS;
var CONSTANTS = { CONTENT: { MARGIN: SPACING18[6] } };

// Drawer/Divider/STYLES.ts
var {
  COLORS: { CONTROL_BORDER_WEAK: CONTROL_BORDER_WEAK7 }
} = import_uik524.MAGNETIC_TOKENS;
var {
  CONTENT: { MARGIN: CONTENT_MARGIN }
} = CONSTANTS;
var STYLES11 = {
  HOST: (0, import_uik524.css)({
    border: "none",
    borderBottom: `1px solid ${CONTROL_BORDER_WEAK7}`,
    marginBlock: CONTENT_MARGIN,
    marginInline: -CONTENT_MARGIN
  })
};

// Drawer/Divider/Divider.tsx
var import_jsx_runtime448 = require("react/jsx-runtime");
var Divider = /* @__PURE__ */ __name(() => /* @__PURE__ */ (0, import_jsx_runtime448.jsx)("div", { className: (0, import_uik525.css)(HOST4), uik: Divider.displayName }), "Divider");
Divider.displayName = "Drawer.Divider";
Divider.__DEV_METADATA__ = { status: "READY" };
var { HOST: HOST4 } = STYLES11;

// Drawer/IS_NESTED.ts
var import_react55 = require("react");
var IS_NESTED = (0, import_react55.createContext)(false);

// Drawer/Portal.tsx
var import_uik526 = require("@appd/uik");
var import_react56 = require("react");
var Portal = /* @__PURE__ */ __name(() => {
  const overlay = (0, import_react56.useContext)(import_uik526.Overlay.CONTEXT);
  (0, import_react56.useEffect)(() => {
    if (DESTINATION() && DESTINATION().ref !== overlay.ref) {
      throw Error("Can't have more than one <Drawer.Portal /> on the page!");
    }
    DESTINATION.set(overlay);
    return DESTINATION.set;
  }, [overlay]);
  return null;
}, "Portal");
Portal.displayName = "Drawer.Portal";

// Drawer/STYLES.ts
var import_uik527 = require("@appd/uik");
var {
  COLORS: { CONTROL_BG_WEAK: CONTROL_BG_WEAK9, CONTROL_BORDER_WEAK: CONTROL_BORDER_WEAK8, DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM6, INTERACT_ICON_WEAK: INTERACT_ICON_WEAK5 },
  PARTICLE: {
    EFFECTS: { SHADOW: SHADOW3 }
  },
  SPACING: SPACING19,
  TYPOGRAPHY: { ELLIPSES: ELLIPSES7, P3_DEFAULT: P3_DEFAULT7 }
} = import_uik527.MAGNETIC_TOKENS;
var {
  CONTENT: { MARGIN: CONTENT_MARGIN2 }
} = CONSTANTS;
var STYLES12 = {
  CLOSE: (0, import_uik527.css)({
    "> svg": {
      "> path": { fill: INTERACT_ICON_WEAK5 },
      height: 16,
      width: 16
    },
    height: 20,
    minHeight: 20,
    minWidth: 20,
    padding: 2,
    width: 20
  }),
  CONTENT: (0, import_uik527.css)({
    minHeight: 0,
    overflowX: "hidden",
    paddingBottom: CONTENT_MARGIN2,
    paddingInline: CONTENT_MARGIN2
  }),
  FOOTER: (0, import_uik527.css)({
    alignItems: "center",
    borderTop: `1px solid ${CONTROL_BORDER_WEAK8}`,
    boxSizing: "border-box",
    display: "flex",
    gap: SPACING19[2],
    justifyContent: "flex-end",
    marginTop: "auto",
    padding: SPACING19[4]
  }),
  HEADER: (0, import_uik527.css)({
    display: "flex",
    gap: SPACING19[3],
    paddingBlock: SPACING19[4],
    paddingInline: SPACING19[6]
  }),
  HOST: (0, import_uik527.css)({
    "--availableHeight": "min(var(--clientHeight), 100vh)",
    "--availableWidth": "min(var(--clientWidth), 100vw)",
    backgroundColor: CONTROL_BG_WEAK9,
    boxShadow: SHADOW3,
    display: "flex",
    flexDirection: "column",
    height: "var(--availableHeight)",
    left: "calc(-1 * var(--paddingLeft))",
    pointerEvents: "auto",
    position: "sticky",
    top: "calc(-1 * var(--paddingTop))",
    translate: "calc(var(--availableWidth) - var(--width))",
    width: "var(--width)"
  }),
  ISOLATE: (0, import_uik527.css)({
    height: "var(--scrollHeight)",
    left: 0,
    pointerEvents: "none",
    position: "absolute",
    top: 0,
    width: "var(--scrollWidth)"
  }),
  SUBTITLE: (0, import_uik527.css)({
    color: DEFAULT_TEXT_MEDIUM6,
    font: P3_DEFAULT7
  }),
  TEXT: (0, import_uik527.css)({
    color: DEFAULT_TEXT_MEDIUM6,
    marginRight: "auto"
  }),
  TITLE_CONTAINER: (0, import_uik527.css)({
    display: "flex",
    flexDirection: "column",
    gap: SPACING19[1],
    marginRight: "auto",
    minWidth: 0
  }),
  TITLE_HEADER: (0, import_uik527.css)({
    ...ELLIPSES7.END,
    width: "100%"
  })
};

// Drawer/Drawer.tsx
var import_jsx_runtime449 = require("react/jsx-runtime");
var Drawer = Object.assign(
  import_uik528.utils.forwardRef(
    ({
      children,
      className: className2,
      closeBehavior,
      footer,
      hostClassName,
      onClose: rawOnClose,
      onOpen,
      open: rawOpen,
      size = "MEDIUM",
      subtitle,
      title,
      ...props2
    }, ref) => {
      if ((0, import_react58.useContext)(IS_NESTED)) {
        throw Error("Nested Drawers are unsupported for now. Please file a ticket if you really need this use case.");
      }
      const overlay = (0, import_react58.useContext)(import_uik528.Overlay.CONTEXT);
      const root = (0, import_react58.useMemo)(() => [...import_uik528.Overlay.Provider.parentsOf(overlay)].at(-1) ?? overlay, [overlay]);
      const [destination = root, setDestination] = (0, import_react58.useState)(DESTINATION);
      (0, import_react57.useEffect)(() => DESTINATION.subscribe(setDestination), []);
      const [open, setOpen] = (0, import_react57.useControlledState)(
        true,
        rawOpen,
        (open2, kind) => open2 ? onOpen?.() : rawOnClose?.(kind),
        (_, open2) => open2 && onOpen?.()
      );
      const onClose = (0, import_react58.useCallback)(
        (kind) => open && (import_uik528.utils.maybeGet(closeBehavior, kind) ?? true) && setOpen(false, kind),
        [closeBehavior, open, rawOnClose]
      );
      (0, import_react57.useEffect)(
        () => import_uik528.utils.addEventListener(document.body, "keydown", ({ key }) => key === "Escape" && onClose("ESCAPE_KEY")),
        [onClose]
      );
      import_react57.useEffect.unstrict(() => open && onOpen?.(), []);
      return !open ? /* @__PURE__ */ (0, import_jsx_runtime449.jsx)(import_jsx_runtime449.Fragment, {}) : /* @__PURE__ */ (0, import_jsx_runtime449.jsx)(import_uik528.Overlay.CONTEXT.Provider, { value: destination, children: /* @__PURE__ */ (0, import_jsx_runtime449.jsx)(import_uik528.Overlay, { children: /* @__PURE__ */ (0, import_jsx_runtime449.jsx)("div", { className: ISOLATE2, uik: "Drawer.ISOLATE", children: /* @__PURE__ */ (0, import_jsx_runtime449.jsxs)(
        "div",
        {
          className: (0, import_uik528.css)(
            HOST5,
            {
              "--width": `min(var(--availableWidth), ${{
                LARGE: 768,
                MEDIUM: 576,
                SMALL: 400
              }[size]}px)`,
              zIndex: destination.zIndex
            },
            ...import_uik528.utils.many(hostClassName)
          ),
          uik: "Drawer",
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime449.jsxs)("div", { className: HEADER3, uik: "Drawer.HEADER", children: [
              /* @__PURE__ */ (0, import_jsx_runtime449.jsxs)("div", { className: TITLE_CONTAINER, children: [
                /* @__PURE__ */ (0, import_jsx_runtime449.jsx)(import_uik528.Tooltip, { value: title, children: /* @__PURE__ */ (0, import_jsx_runtime449.jsx)(import_uik528.Heading, { className: TITLE_HEADER, size: "PRIMARY", children: title }) }),
                subtitle && /* @__PURE__ */ (0, import_jsx_runtime449.jsx)("div", { className: SUBTITLE, children: subtitle })
              ] }),
              /* @__PURE__ */ (0, import_jsx_runtime449.jsx)(
                import_uik528.Button,
                {
                  className: CLOSE2,
                  icon: "Navigation.Close",
                  onClick: () => onClose("CLOSE_ICON"),
                  type: "TERTIARY"
                }
              )
            ] }),
            /* @__PURE__ */ (0, import_jsx_runtime449.jsx)(
              import_uik528.ScrollBox,
              {
                className: (0, import_uik528.css)(CONTENT3, ...import_uik528.utils.many(className2)),
                hideHorizontal: true,
                ref,
                uik: "Drawer.CONTENT",
                ...props2,
                children: /* @__PURE__ */ (0, import_jsx_runtime449.jsx)(IS_NESTED.Provider, { value: true, children })
              }
            ),
            footer && /* @__PURE__ */ (0, import_jsx_runtime449.jsxs)("div", { className: FOOTER2, uik: "Drawer.FOOTER", children: [
              /* @__PURE__ */ (0, import_jsx_runtime449.jsx)("div", { className: TEXT2, children: footer.text }),
              footer.secondary && /* @__PURE__ */ (0, import_jsx_runtime449.jsx)(import_uik528.Button, { onClick: () => onClose("FOOTER_SECONDARY"), type: "SECONDARY", children: footer.secondary }),
              footer.primary && /* @__PURE__ */ (0, import_jsx_runtime449.jsx)(import_uik528.Button, { onClick: () => onClose("FOOTER_PRIMARY"), children: footer.primary })
            ] })
          ]
        }
      ) }) }) });
    }
  ),
  {
    Divider,
    Portal
  }
);
Drawer.displayName = "Drawer";
Drawer.__DEV_METADATA__ = { status: "READY" };
var { CLOSE: CLOSE2, CONTENT: CONTENT3, FOOTER: FOOTER2, HEADER: HEADER3, HOST: HOST5, ISOLATE: ISOLATE2, SUBTITLE, TEXT: TEXT2, TITLE_CONTAINER, TITLE_HEADER } = STYLES12;

// Dropdown/Dropdown.tsx
var import_uik534 = require("@appd/uik");
var import_react61 = require("react");

// Dropdown/DropdownList.tsx
var import_uik529 = require("@appd/uik");
var import_react59 = require("react");
var import_jsx_runtime450 = require("react/jsx-runtime");
var DropdownList = import_uik529.utils.forwardRef(
  ({ children: rawChildren, ...props2 }, forwardedRef) => {
    const children = import_react59.Children.toArray(rawChildren).filter(import_react59.isValidElement).map((child, index) => (0, import_react59.cloneElement)(child, { tabIndex: index === 0 ? 0 : -1 }));
    const listRef = import_uik529.utils.useBroadcastRef(forwardedRef);
    const onKeyDown = /* @__PURE__ */ __name((event) => {
      const list = listRef.current;
      const key = event.key;
      const currentFocus = document.activeElement;
      if (!list.contains(currentFocus)) {
        return;
      }
      if (key === "ArrowDown") {
        event.preventDefault();
        moveFocus(list, currentFocus, "next");
      } else if (key === "ArrowUp") {
        event.preventDefault();
        moveFocus(list, currentFocus, "previous");
      }
    }, "onKeyDown");
    return /* @__PURE__ */ (0, import_jsx_runtime450.jsx)(import_uik529.List, { onKeyDown, ref: listRef, role: "menu", uik: DropdownList.displayName, ...props2, children });
  }
);
DropdownList.displayName = "Dropdown.List";
var TRAVERSAL = {
  next: (list, item) => item.nextElementSibling ?? list.firstChild,
  previous: (list, item) => item.previousElementSibling ?? list.lastChild
};
var moveFocus = /* @__PURE__ */ __name((list, currentFocus, type) => {
  const traversal = TRAVERSAL[type];
  let nextFocus = traversal(list, currentFocus);
  let wrappedOnce = false;
  while (nextFocus) {
    if (nextFocus === list.firstChild) {
      if (wrappedOnce) {
        return false;
      }
      wrappedOnce = true;
    }
    if (!nextFocus.hasAttribute("tabindex") || nextFocus.disabled) {
      nextFocus = traversal(list, nextFocus);
    } else {
      nextFocus.focus();
      return;
    }
  }
  return;
}, "moveFocus");

// Dropdown/Option.tsx
var import_uik530 = require("@appd/uik");
var import_jsx_runtime451 = require("react/jsx-runtime");
var Option = import_uik530.utils.forwardRef((props2, forwardedRef) => /* @__PURE__ */ (0, import_jsx_runtime451.jsx)(import_uik530.List.Option, { ref: forwardedRef, tabIndex: -1, uik: Option.displayName, ...props2 }));
Option.displayName = "Dropdown.Option";

// Dropdown/STYLES.ts
var import_uik531 = require("@appd/uik");
var {
  COLORS: { CONTROL_BG_ACTIVE, CONTROL_BORDER: CONTROL_BORDER8 }
} = import_uik531.MAGNETIC_TOKENS;
var STYLES13 = {
  BUTTON: (0, import_uik531.css)({ "& svg": { pointerEvents: "none" } }),
  CONTAINER: (0, import_uik531.css)({
    alignItems: "center",
    display: "flex"
  }),
  LABEL: (0, import_uik531.css)({ flex: 1 }),
  MENU_LIST: (0, import_uik531.css)({
    ":focus": { backgroundColor: CONTROL_BG_ACTIVE },
    borderRadius: 6,
    outline: "none",
    paddingBlock: 2
  }),
  OVERLAY: (0, import_uik531.css)({
    marginTop: 4,
    maxHeight: 500,
    maxWidth: 600,
    outline: "none"
  }),
  OVERLAY_CONTENT: (0, import_uik531.css)({
    border: `2px solid ${CONTROL_BORDER8}`,
    maxHeight: 500,
    maxWidth: 600
  })
};

// Dropdown/SubMenu/SubMenu.tsx
var import_uik533 = require("@appd/uik");
var import_react60 = require("react");

// Dropdown/SubMenu/STYLES.ts
var import_uik532 = require("@appd/uik");
var {
  TYPOGRAPHY: { ELLIPSES: ELLIPSES8 }
} = import_uik532.MAGNETIC_TOKENS;
var STYLES14 = {
  ITEM: (0, import_uik532.css)({
    alignItems: "center",
    display: "flex"
  }),
  LABEL: (0, import_uik532.css)({
    ...ELLIPSES8.END,
    flex: 1
  })
};

// Dropdown/SubMenu/SubMenu.tsx
var import_jsx_runtime452 = require("react/jsx-runtime");
var SubMenu = import_uik533.utils.forwardRef(
  ({ children, contentClassName, label, onSelect, selected, triggerClassName, ...props2 }, forwardedRef) => {
    const subMenuRef = (0, import_react60.useRef)(null);
    const menu = /* @__PURE__ */ (0, import_jsx_runtime452.jsx)(import_uik533.FocusManager, { autoFocus: true, children: /* @__PURE__ */ (0, import_jsx_runtime452.jsx)(DropdownList, { onSelect, ref: subMenuRef, selected, children }) });
    const onKeyDown = /* @__PURE__ */ __name((event) => {
      event.stopPropagation();
      const { key, shiftKey } = event;
      if (shiftKey && key === "Tab" || key === "Escape") {
        event.preventDefault();
      } else if (key === "Tab") {
        event.preventDefault();
      }
    }, "onKeyDown");
    const trigger = /* @__PURE__ */ (0, import_jsx_runtime452.jsx)(Option, { className: (0, import_uik533.css)(triggerClassName), children: /* @__PURE__ */ (0, import_jsx_runtime452.jsxs)("div", { className: ITEM, children: [
      /* @__PURE__ */ (0, import_jsx_runtime452.jsx)("span", { className: LABEL, children: label }),
      /* @__PURE__ */ (0, import_jsx_runtime452.jsx)(import_uik533.Icon.Navigation.ChevronRight, { size: "SMALL" })
    ] }) });
    return /* @__PURE__ */ (0, import_jsx_runtime452.jsx)(
      import_uik533.Popover,
      {
        align: "START",
        arrow: false,
        contentClassName: (0, import_uik533.css)(contentClassName, { padding: 0 }),
        ignore: forwardedRef,
        position: "RIGHT",
        trigger: "HOVER",
        uik: SubMenu.displayName,
        ...props2,
        content: menu,
        onKeyDown,
        children: trigger
      }
    );
  }
);
SubMenu.displayName = "Dropdown.SubMenu";
var { ITEM, LABEL } = STYLES14;

// Dropdown/Dropdown.tsx
var import_jsx_runtime453 = require("react/jsx-runtime");
var Dropdown = Object.assign(
  import_uik534.utils.forwardRef(
    ({
      align,
      children,
      contentClassName,
      icon: rawIcon,
      kind,
      label,
      onClick: rawOnClick,
      onSelect,
      onVisibleChange,
      overlayClassName,
      position,
      selected,
      triggerClassName,
      visible: rawVisible,
      ...props2
    }, forwardedRef) => {
      const [originalFocus, setOriginalFocus] = (0, import_react61.useState)(null);
      const menuRef = (0, import_react61.useRef)(null);
      const [visible, setVisible] = (0, import_react61.useState)(void 0);
      if (rawVisible != null && rawVisible !== visible) {
        setVisible(rawVisible);
      }
      const controlled = rawVisible != void 0;
      const onWrappedSelect = /* @__PURE__ */ __name((indices, values) => {
        controlled && onVisibleChange?.(false);
        setVisible(false);
        if (Array.isArray(children)) {
          const childrenArray = children;
          if (childrenArray[indices[0]]?.props?.items) {
            return;
          } else {
            onSelect?.(indices, values);
          }
        }
      }, "onWrappedSelect");
      const menu = visible && /* @__PURE__ */ (0, import_jsx_runtime453.jsx)(import_uik534.FocusManager, { children: /* @__PURE__ */ (0, import_jsx_runtime453.jsx)(DropdownList, { className: MENU_LIST, onSelect: onWrappedSelect, ref: menuRef, selected, uik: "Menu", children }) });
      const onClick = /* @__PURE__ */ __name((event) => {
        const newVisible = !visible;
        rawOnClick?.(event);
        setVisible(newVisible);
      }, "onClick");
      const trigger = /* @__PURE__ */ (0, import_jsx_runtime453.jsxs)(
        import_uik534.Button,
        {
          className: (0, import_uik534.css)(BUTTON, triggerClassName),
          icon: typeof rawIcon === "string" ? rawIcon : void 0,
          iconRight: label != void 0 ? visible ? "Navigation.ChevronUp" : "Navigation.ChevronDown" : void 0,
          onClick,
          type: kind,
          children: [
            typeof rawIcon !== "string" ? /* @__PURE__ */ (0, import_jsx_runtime453.jsx)(import_jsx_runtime453.Fragment, { children: rawIcon }) : void 0,
            label && /* @__PURE__ */ (0, import_jsx_runtime453.jsx)("div", { className: CONTAINER2, children: /* @__PURE__ */ (0, import_jsx_runtime453.jsx)("span", { className: LABEL2, children: label }) })
          ]
        }
      );
      (0, import_react61.useEffect)(() => {
        visible ? !originalFocus && setOriginalFocus(document.activeElement) : originalFocus?.focus();
        setTimeout(() => menuRef.current?.querySelector(FOCUSABLE_SELECTOR)?.focus());
      }, [visible]);
      const onKeyDown = /* @__PURE__ */ __name((event) => {
        const { key, shiftKey } = event;
        if (shiftKey && key === "Tab" || key === "Escape") {
          event.preventDefault();
          onVisibleChange?.(false);
        } else if (key === "Tab") {
          event.preventDefault();
        }
      }, "onKeyDown");
      const popoverVisible = controlled ? rawVisible : visible;
      return /* @__PURE__ */ (0, import_jsx_runtime453.jsx)(
        import_uik534.Popover,
        {
          align: align ?? "START",
          arrow: false,
          className: (0, import_uik534.css)(OVERLAY, overlayClassName),
          contentClassName: (0, import_uik534.css)(
            OVERLAY_CONTENT,
            {
              border: !(controlled ? rawVisible : visible) && "unset",
              padding: 0
            },
            contentClassName
          ),
          ignore: forwardedRef,
          position: position ?? "BOTTOM",
          ref: forwardedRef,
          tabIndex: -1,
          ...props2,
          content: menu,
          onKeyDown,
          onVisibleChange: (newVisible) => {
            setVisible(newVisible);
            onVisibleChange?.(newVisible);
          },
          visible: popoverVisible,
          children: trigger
        }
      );
    }
  ),
  {
    Option,
    SubMenu
  }
);
Dropdown.displayName = "Dropdown";
Dropdown.__DEV_METADATA__ = { status: "READY" };
var { BUTTON, CONTAINER: CONTAINER2, LABEL: LABEL2, MENU_LIST, OVERLAY, OVERLAY_CONTENT } = STYLES13;

// Expander/Expander.tsx
var import_uik543 = require("@appd/uik");
var import_react64 = require("react");

// Expander/getStyles.ts
var import_uik535 = require("@appd/uik");
var {
  COLORS: { DEFAULT_TEXT: DEFAULT_TEXT9, DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM7, INTERACT_ICON_WEAK: INTERACT_ICON_WEAK6 },
  MOTION,
  TYPOGRAPHY: { ELLIPSES: ELLIPSES9, P3_DEFAULT: P3_DEFAULT8, P3_EMPHASIS: P3_EMPHASIS2 }
} = import_uik535.MAGNETIC_TOKENS;
var getStyles13 = /* @__PURE__ */ __name(({
  icon,
  leftAlignContent,
  open,
  titleType
}) => ({
  ADDITIONAL_ICON: (0, import_uik535.css)({ marginRight: ICON_MARGIN_RIGHT }),
  CHEVRON: (0, import_uik535.css)({
    "& > path": { fill: INTERACT_ICON_WEAK6 },
    marginRight: CHEVRON_MARGIN_RIGHT,
    transition: `linear ${MOTION.DURATION.MEDIUM}`,
    ...open && { transform: "rotate(90deg)" }
  }),
  CONTENT: (0, import_uik535.css)({
    marginLeft: leftAlignContent ? ICON_SMALL_SIZE + CHEVRON_MARGIN_RIGHT + (icon ? ICON_SMALL_SIZE + ICON_MARGIN_RIGHT : 0) : 0,
    marginTop: 7
  }),
  DESCRIPTION: (0, import_uik535.css)({
    color: DEFAULT_TEXT_MEDIUM7,
    fontStyle: "normal",
    paddingLeft: ICON_SMALL_SIZE + CHEVRON_MARGIN_RIGHT + (icon ? ICON_SMALL_SIZE + ICON_MARGIN_RIGHT : 0),
    userSelect: "none"
  }),
  HEADER_CONTAINER: (0, import_uik535.css)({ ":hover": { cursor: "pointer" } }),
  TITLE: (0, import_uik535.css)({
    ...ELLIPSES9.END,
    color: DEFAULT_TEXT9,
    font: titleType === "normal" ? P3_DEFAULT8 : P3_EMPHASIS2,
    maxWidth: 800,
    textTransform: titleType === "section" ? "uppercase" : "none",
    userSelect: "none"
  }),
  TITLE_CONTAINER: (0, import_uik535.css)({
    alignItems: "center",
    display: "flex",
    flexDirection: "row"
  })
}), "getStyles");
var ICON_MARGIN_RIGHT = 6;
var CHEVRON_MARGIN_RIGHT = 6;
var ICON_SMALL_SIZE = 18;

// Tooltip/Tooltip.tsx
var import_uik542 = require("@appd/uik");
var import_react63 = require("react");

// Tooltip/defaultPositioner.ts
var import_uik536 = require("@appd/uik");
var defaultPositioner = /* @__PURE__ */ __name(({
  align,
  measurements: { container, content, trigger },
  position
}) => {
  const clamp4 = {
    left: (left2) => import_uik536.utils.clamp(left2, [0, container.width - content.width]),
    top: (top2) => import_uik536.utils.clamp(top2, [0, container.height - content.height])
  };
  const get = /* @__PURE__ */ __name((leftOrTop, p = position, xy = X_OR_Y[leftOrTop], d = DIMENSION[xy], origin = container[xy]) => ({
    // Flipping doesn't happen along the "align" axis, so clamp unconditionally.
    ALIGN: clamp4[leftOrTop](trigger[xy] + ALIGN[align] * (trigger[d] - content[d]) - origin),
    "DOWN / RIGHT": trigger[xy] + trigger[d] - origin,
    "UP / LEFT": trigger[xy] - content[d] - origin
  })[CASES[leftOrTop][p]], "get");
  const [left, top] = [get("left"), get("top")];
  const needsFlip = left !== clamp4.left(left) || top !== clamp4.top(top);
  return needsFlip ? {
    actual: FLIP[position],
    left: clamp4.left(get("left", FLIP[position])),
    top: clamp4.top(get("top", FLIP[position]))
  } : {
    actual: position,
    left,
    top
  };
}, "defaultPositioner");
var ALIGN = {
  CENTER: 0.5,
  END: 1,
  START: 0
};
var CASES = {
  left: {
    BOTTOM: "ALIGN",
    LEFT: "UP / LEFT",
    RIGHT: "DOWN / RIGHT",
    TOP: "ALIGN"
  },
  top: {
    BOTTOM: "DOWN / RIGHT",
    LEFT: "ALIGN",
    RIGHT: "ALIGN",
    TOP: "UP / LEFT"
  }
};
var DIMENSION = {
  x: "width",
  y: "height"
};
var FLIP = {
  BOTTOM: "TOP",
  LEFT: "RIGHT",
  RIGHT: "LEFT",
  TOP: "BOTTOM"
};
var X_OR_Y = {
  left: "x",
  top: "y"
};

// Tooltip/getStyles.ts
var import_uik537 = require("@appd/uik");
var getStyles14 = /* @__PURE__ */ __name(({
  measurements: {
    content: { height: height2, width }
  },
  position,
  props: { align, arrow },
  visible
}) => ({
  ARROW: (arrowColor) => (0, import_uik537.css)({
    border: `8px solid ${arrowColor ?? INVERSE_BG_WEAK}`,
    boxSizing: "border-box",
    position: "absolute",
    zIndex: 1,
    ...position.actual === "BOTTOM" || position.actual === "TOP" ? {
      borderBottomWidth: 0,
      borderLeftColor: "transparent",
      borderRightColor: "transparent",
      borderTopWidth: 9,
      height: 9,
      left: `calc(${[
        `${{
          CENTER: 0,
          END: -SPACING20[2],
          START: SPACING20[2]
        }[align]}px`,
        `${{
          CENTER: 0.5,
          END: 1,
          START: 0
        }[align]} * (-12px + var(--trigger-width))`,
        "var(--trigger-left) - var(--content-left)"
      ].join(" + ")})`,
      top: position.actual == "TOP" ? `calc(${CONTENT_HEIGHT} - ${SPACING20[2]}px)` : 0,
      transform: `scaleY(${{
        BOTTOM: -1,
        TOP: 1
      }[position.actual]})`,
      width: 12
    } : {
      borderBottomColor: "transparent",
      borderLeftWidth: 9,
      borderRightWidth: 0,
      borderTopColor: "transparent",
      height: 12,
      left: position.actual == "LEFT" ? `calc(${CONTENT_WIDTH} - ${SPACING20[2]}px)` : 0,
      top: `calc(${[
        `${{
          CENTER: 0,
          END: -SPACING20[2],
          START: SPACING20[2]
        }[align]}px`,
        `${{
          CENTER: 0.5,
          END: 1,
          START: 0
        }[align]} * (-12px + var(--trigger-height))`,
        "var(--trigger-top) - var(--content-top)"
      ].join(" + ")})`,
      transform: `scaleX(${{
        LEFT: 1,
        RIGHT: -1
      }[position.actual]})`,
      width: 9
    },
    ...(position.actual === "TOP" || position.actual === "LEFT") && { order: 1 }
  }),
  CONTENT: import_uik537.css.Styles({
    backgroundColor: INVERSE_BG_WEAK,
    borderRadius: RADIUS10.DEFAULT,
    boxShadow: SHADOW_FLOATING,
    boxSizing: "border-box",
    color: DEFAULT_TEXT_IN_WEAK,
    font: P4_DEFAULT4,
    inset: arrow ? {
      BOTTOM: `${SPACING20[2]}px 0px 0px 0px`,
      LEFT: `0px 0px 0px ${-SPACING20[2]}px`,
      RIGHT: `0px 0px 0px ${SPACING20[2]}px`,
      TOP: `${-SPACING20[2]}px 0px 0px 0px`
    }[position.actual] : "",
    maxWidth: 400,
    overflowWrap: "break-word",
    padding: `${SPACING20[1]}px ${SPACING20[3]}px`,
    position: "relative",
    width: "max-content"
  }),
  POSITION: import_uik537.css.Styles({
    height: 0,
    left: CONTENT_LEFT,
    position: "absolute",
    top: CONTENT_TOP,
    width: 0,
    zIndex: Z_INDEX
  }),
  VISIBLE: (($visible = Boolean(width && height2 && visible.actual)) => import_uik537.css.Styles({
    transformOrigin: {
      BOTTOM: `calc(0.5 * ${CONTENT_WIDTH}) 0`,
      LEFT: `${CONTENT_WIDTH} calc(0.5 * ${CONTENT_HEIGHT})`,
      RIGHT: `0 calc(0.5 * ${CONTENT_HEIGHT})`,
      TOP: `calc(0.5 * ${CONTENT_WIDTH}) ${CONTENT_HEIGHT}`
    }[position.actual],
    ...$visible ? { transition: "opacity .1s ease-in" } : (
      // This fade out transition is not from Figma. Replace it once Figma specifies something.
      {
        "& *": { pointerEvents: "none !important" },
        opacity: 0,
        pointerEvents: "none",
        transform: `scale(max((${CONTENT_HEIGHT} - 20px) / ${CONTENT_HEIGHT}, 0.9))`,
        transition: "all .1s ease-out"
      }
    )
  }))()
}), "getStyles");
var {
  COLORS: { DEFAULT_TEXT_IN_WEAK, INVERSE_BG_WEAK },
  EFFECTS: { SHADOW_FLOATING },
  RADIUS: RADIUS10,
  SPACING: SPACING20,
  TYPOGRAPHY: { P4_DEFAULT: P4_DEFAULT4 }
} = import_uik537.MAGNETIC_TOKENS;
var {
  CONTENT_HEIGHT = "var(--content-height)",
  CONTENT_LEFT = "var(--content-left)",
  CONTENT_TOP = "var(--content-top)",
  CONTENT_WIDTH = "var(--content-width)",
  Z_INDEX = "var(--z-index)"
} = {};

// Tooltip/getVolatileStyles.ts
var getVolatileStyles = /* @__PURE__ */ __name(({
  measurements: {
    container,
    content: { height: height2, width },
    trigger
  },
  position: { left, top },
  zIndex
}) => ({
  "--content-height": `${height2}px`,
  "--content-left": `${left}px`,
  "--content-top": `${top}px`,
  "--content-width": `${width}px`,
  "--trigger-height": `${trigger.height}px`,
  "--trigger-left": `${trigger.x - container.x}px`,
  "--trigger-top": `${trigger.y - container.y}px`,
  "--trigger-width": `${trigger.width}px`,
  "--z-index": `${zIndex}`
}), "getVolatileStyles");

// Tooltip/REDUCERS/REDUCERS.ts
var import_uik539 = require("@appd/uik");

// Tooltip/REDUCERS/$INITIAL_STATE.ts
var $INITIAL_STATE = {
  content: {
    focused: false,
    hovered: false
  },
  elements: {
    container: null,
    content: null,
    trigger: null
  },
  measurements: {
    container: {
      height: Infinity,
      width: Infinity,
      x: 0,
      y: 0
    },
    content: {
      height: 0,
      width: 0,
      x: 0,
      y: 0
    },
    trigger: {
      height: 0,
      offsetHeight: 0,
      offsetWidth: 0,
      scrollHeight: 0,
      scrollWidth: 0,
      width: 0,
      x: 0,
      y: 0
    }
  },
  overflowed: false,
  pending: {
    onPositionChange: [],
    onVisibleChange: []
  },
  position: {
    actual: "BOTTOM",
    left: 0,
    top: 0
  },
  props: {
    align: "CENTER",
    arrow: false,
    position: "BOTTOM",
    visible: void 0
  },
  trigger: { hovered: false },
  visible: {
    actual: false,
    remainMounted: false,
    uncontrolled: false
  }
};

// Tooltip/REDUCERS/updateMeasurements.ts
var import_uik538 = require("@appd/uik");
var updateMeasurements = /* @__PURE__ */ __name(({
  elements: { container, content, trigger },
  elements,
  ...state
}) => {
  const triggerRect = import_uik538.utils.getBoundingClientRect(trigger);
  return {
    ...state,
    elements,
    measurements: {
      container: import_uik538.utils.getBoundingClientRect(container) ?? $INITIAL_STATE.measurements.container,
      content: import_uik538.utils.getBoundingClientRect(content) ?? $INITIAL_STATE.measurements.content,
      trigger: trigger ? {
        height: triggerRect.height,
        offsetHeight: trigger.offsetHeight ?? 0,
        offsetWidth: trigger.offsetWidth ?? 0,
        scrollHeight: trigger.scrollHeight,
        scrollWidth: trigger.scrollWidth,
        width: triggerRect.width,
        x: triggerRect.x,
        y: triggerRect.y
      } : $INITIAL_STATE.measurements.trigger
    }
  };
}, "updateMeasurements");

// Tooltip/REDUCERS/updateOverflowed.ts
var updateOverflowed = /* @__PURE__ */ __name(({
  measurements: {
    trigger: { offsetHeight, offsetWidth, scrollHeight, scrollWidth }
  },
  measurements,
  ...state
}) => ({
  ...state,
  measurements,
  overflowed: scrollWidth > offsetWidth || scrollHeight > offsetHeight
}), "updateOverflowed");

// Tooltip/REDUCERS/updatePosition.ts
var updatePosition = /* @__PURE__ */ __name(({ measurements, props: { align, position: rawPosition }, props: props2, ...state }, old) => {
  const position = typeof rawPosition === "function" ? rawPosition({
    align,
    defaultPositioner,
    measurements
  }) : defaultPositioner({
    align,
    measurements,
    position: rawPosition
  });
  const didChange = old.position.actual !== position.actual;
  return {
    ...state,
    ...didChange && {
      pending: {
        ...state.pending,
        onPositionChange: [...state.pending.onPositionChange, position.actual]
      }
    },
    measurements,
    position,
    props: props2
  };
}, "updatePosition");

// Tooltip/REDUCERS/updateVisible.ts
var updateVisible = /* @__PURE__ */ __name(({ content: { focused, hovered }, content, props: { visible }, props: props2, trigger, visible: { remainMounted }, ...state }, old, [event]) => {
  const nextUncontrolled = focused || hovered || trigger.hovered;
  const newActual = visible ?? nextUncontrolled;
  const didChange = (event === "FOCUS" || event === "HOVER") && old.visible.actual !== nextUncontrolled;
  return {
    ...state,
    ...didChange && {
      pending: {
        ...state.pending,
        onVisibleChange: [...state.pending.onVisibleChange, nextUncontrolled]
      }
    },
    content,
    props: props2,
    trigger,
    visible: {
      actual: newActual,
      remainMounted: remainMounted || newActual,
      uncontrolled: nextUncontrolled
    }
  };
}, "updateVisible");

// Tooltip/REDUCERS/REDUCERS.ts
var REDUCERS = {
  $AFTER_EACH: [updateMeasurements, updateOverflowed, updatePosition, updateVisible],
  $INITIAL_STATE,
  CLEAR_PENDING: (state, event) => ({
    ...state,
    pending: {
      ...state.pending,
      [event]: []
    }
  }),
  ELEMENTS: (state, elements) => ({
    ...state,
    elements
  }),
  FOCUS: ({ content, ...state }, focused) => ({
    content: {
      ...content,
      focused
    },
    ...state
  }),
  HOVER: (state, [element, hovered]) => ({
    ...state,
    [element]: {
      ...state[element],
      hovered
    },
    [OPPOSITE[element]]: {
      ...state[OPPOSITE[element]],
      hovered: false
    }
  }),
  PROPS: (state, {
    align = INITIAL.props.align,
    arrow = INITIAL.props.arrow,
    position = INITIAL.props.position,
    visible = INITIAL.props.visible
  }) => ({
    ...state,
    props: {
      align,
      arrow,
      position,
      visible
    }
  }),
  REFRESH: import_uik539.utils.identity
};
var INITIAL = $INITIAL_STATE;
var OPPOSITE = {
  content: "trigger",
  trigger: "content"
};

// Tooltip/useEvents.ts
var import_uik540 = require("@appd/uik");
var import_react62 = require("react");
var import_rxjs = require("rxjs");
var useEvents2 = /* @__PURE__ */ __name(({ contentRef, dispatch, remainMounted, triggerRef, value, visible }) => {
  const {
    ref: { current: container }
  } = (0, import_react62.useContext)(import_uik540.Overlay.CONTEXT);
  const unmountedRef = import_uik540.utils.useUnmountedRef();
  import_uik540.utils.useLayoutEffect(() => {
    if (!value)
      return;
    const { current: trigger } = triggerRef;
    const { current: content } = contentRef;
    dispatch("ELEMENTS", {
      container,
      content,
      trigger
    });
    const subscription = (0, import_rxjs.from)(
      [
        content && (0, import_rxjs.fromEvent)(content, "focusin").pipe((0, import_rxjs.map)(() => ["FOCUS", true])),
        content && (0, import_rxjs.fromEvent)(content, "focusout").pipe((0, import_rxjs.map)(() => ["FOCUS", false])),
        content && new import_rxjs.Observable((subscriber) => import_uik540.Measurer.subscribe(content, () => subscriber.next())).pipe(
          (0, import_rxjs.map)(() => ["REFRESH"])
        ),
        remainMounted && trigger && new import_rxjs.Observable((subscriber) => import_uik540.Measurer.subscribe(trigger, () => subscriber.next())).pipe(
          (0, import_rxjs.map)(() => ["REFRESH"])
        ),
        (0, import_rxjs.from)(
          [
            content && (0, import_rxjs.fromEvent)(content, "mouseenter").pipe(
              (0, import_rxjs.map)(() => (0, import_rxjs.of)(["HOVER", ["content", true]]).pipe((0, import_rxjs.delay)(50)))
            ),
            content && (0, import_rxjs.fromEvent)(content, "mouseleave").pipe((0, import_rxjs.map)(() => (0, import_rxjs.of)(["HOVER", ["content", false]]))),
            trigger && (0, import_rxjs.fromEvent)(trigger, "mouseenter").pipe(
              (0, import_rxjs.map)(() => (0, import_rxjs.of)(["HOVER", ["trigger", true]]).pipe((0, import_rxjs.delay)(50)))
            ),
            trigger && (0, import_rxjs.fromEvent)(trigger, "mouseleave").pipe(
              (0, import_rxjs.map)(() => (0, import_rxjs.of)(["HOVER", ["trigger", false]]).pipe((0, import_rxjs.delay)(50)))
            )
          ].filter(import_uik540.utils.Boolean)
        ).pipe((0, import_rxjs.mergeAll)(), (0, import_rxjs.switchAll)())
      ].filter(import_uik540.utils.Boolean)
    ).pipe((0, import_rxjs.mergeAll)()).subscribe((action) => dispatch(...action));
    return () => {
      unmountedRef.current ? (
        // Immediately unsubscribe to avoid warning for updating an unmounted component.
        subscription.unsubscribe()
      ) : (
        // Wait for mouseleave to fire.
        setTimeout(() => subscription.unsubscribe(), 50)
      );
    };
  }, [container, contentRef.current, remainMounted, triggerRef.current, Boolean(value), visible]);
}, "useEvents");

// Tooltip/useTrigger.tsx
var import_uik541 = require("@appd/uik");
var import_jsx_runtime454 = require("react/jsx-runtime");
var useTrigger = /* @__PURE__ */ __name((children, forwardedRef) => {
  const isRef = children && "current" in children;
  const child = import_uik541.utils.useOnlyChildWithRef(isRef ? /* @__PURE__ */ (0, import_jsx_runtime454.jsx)("div", {}) : children, forwardedRef);
  const ref = import_uik541.utils.useBroadcastRef({
    sinks: [forwardedRef],
    source: isRef && children
  });
  return isRef ? {
    ref,
    withRef: /* @__PURE__ */ (0, import_jsx_runtime454.jsx)(import_jsx_runtime454.Fragment, {})
  } : child;
}, "useTrigger");

// Tooltip/Tooltip.tsx
var import_jsx_runtime455 = require("react/jsx-runtime");
var Tooltip7 = Object.assign(
  import_uik542.utils.forwardRef(
    ({
      align,
      arrow,
      arrowColor,
      children,
      className: className2,
      onPositionChange,
      onVisibleChange,
      position,
      showOnOverflowOnly,
      tabIndex: _,
      value,
      visible,
      ...inherited
    }, forwardedRef) => {
      const overlay = (0, import_react63.useContext)(import_uik542.Overlay.CONTEXT);
      const contentRef = (0, import_react63.useRef)(null);
      const [state, dispatch] = import_uik542.utils.useReducer(REDUCERS);
      const trigger = useTrigger(children, forwardedRef);
      if (arrow != null && arrow !== state.props.arrow || align != null && align !== state.props.align || position != null && position !== state.props.position || visible != null && visible !== state.props.visible) {
        dispatch("PROPS", {
          align,
          arrow,
          position,
          visible
        });
      }
      useEvents2({
        contentRef,
        dispatch,
        remainMounted: state.visible.remainMounted,
        triggerRef: trigger.ref,
        value,
        visible: state.visible.actual
      });
      import_uik542.utils.useLayoutEffect(() => dispatch("REFRESH"), [overlay]);
      import_uik542.utils.useLayoutEffect(() => {
        if (state.pending.onPositionChange.length && // Don't flush until visible.
        state.visible.actual) {
          if (onPositionChange) {
            state.pending.onPositionChange.forEach((position2) => onPositionChange(position2));
          }
          dispatch("CLEAR_PENDING", "onPositionChange");
        }
      }, [onPositionChange, state.pending.onPositionChange, state.visible.actual]);
      import_uik542.utils.useLayoutEffect(() => {
        if (state.pending.onVisibleChange.length) {
          if (onVisibleChange) {
            state.pending.onVisibleChange.forEach((visible2) => onVisibleChange(visible2));
          }
          dispatch("CLEAR_PENDING", "onVisibleChange");
        }
      }, [onVisibleChange, state.pending.onVisibleChange]);
      const {
        styles: { ARROW: ARROW2, CONTENT: CONTENT4, POSITION, VISIBLE },
        volatileStyles
      } = (0, import_react63.useMemo)(
        () => ({
          styles: getStyles14(state),
          volatileStyles: getVolatileStyles({
            ...state,
            zIndex: overlay.zIndex
          })
        }),
        [state, overlay.zIndex]
      );
      return /* @__PURE__ */ (0, import_jsx_runtime455.jsxs)(import_jsx_runtime455.Fragment, { children: [
        trigger.withRef,
        /* @__PURE__ */ (0, import_jsx_runtime455.jsx)(import_uik542.Overlay, {
          // Don't mount without a `value`.
          children: value && (!showOnOverflowOnly || state.overflowed) && // Wait until `state.visible.actual` is first set before mounting. (Then, remain mounted.)
          state.visible.remainMounted && /* @__PURE__ */ (0, import_jsx_runtime455.jsx)(import_jsx_runtime455.Fragment, { children: /* @__PURE__ */ (0, import_jsx_runtime455.jsxs)("div", { className: (0, import_uik542.css)(POSITION, VISIBLE), style: volatileStyles, uik: "Tooltip.POSITIONER", children: [
            state.props.arrow && /* @__PURE__ */ (0, import_jsx_runtime455.jsx)("div", { className: ARROW2(arrowColor) }),
            /* @__PURE__ */ (0, import_jsx_runtime455.jsx)(
              "div",
              {
                className: (0, import_uik542.css)(CONTENT4, ...import_uik542.utils.many(className2)),
                ref: contentRef,
                tabIndex: state.visible.actual ? 0 : void 0,
                uik: "Tooltip",
                ...inherited,
                children: /* @__PURE__ */ (0, import_jsx_runtime455.jsx)(import_uik542.Overlay.Provider, { promote: 1, zIndex: overlay.zIndex + 1, children: value })
              }
            )
          ] }) })
        })
      ] });
    }
  ),
  { defaultPositioner }
);
Tooltip7.displayName = "Tooltip";
Tooltip7.__DEV_METADATA__ = { status: "IN_PROGRESS" };

// Expander/Expander.tsx
var import_jsx_runtime456 = require("react/jsx-runtime");
var Expander = import_uik543.utils.forwardRef(
  ({
    children,
    className: className2,
    description,
    icon,
    leftAlignContent = false,
    onClick = /* @__PURE__ */ __name(() => {
    }, "onClick"),
    open,
    title,
    titleType = "normal",
    ...inherited
  }, ref) => {
    const [rawOpen, setRawOpen] = (0, import_react64.useState)(false);
    open ??= rawOpen;
    const { ADDITIONAL_ICON, CHEVRON: CHEVRON2, CONTENT: CONTENT4, DESCRIPTION: DESCRIPTION3, HEADER_CONTAINER, TITLE: TITLE4, TITLE_CONTAINER: TITLE_CONTAINER2 } = getStyles13({
      icon,
      leftAlignContent,
      open,
      titleType
    });
    return /* @__PURE__ */ (0, import_jsx_runtime456.jsxs)("div", { className: (0, import_uik543.css)(...import_uik543.utils.many(className2)), ref, uik: "Expander", ...inherited, children: [
      /* @__PURE__ */ (0, import_jsx_runtime456.jsxs)(
        "div",
        {
          className: HEADER_CONTAINER,
          onClick: () => {
            onClick(!open);
            setRawOpen((prev) => !prev);
          },
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime456.jsxs)("div", { className: TITLE_CONTAINER2, children: [
              /* @__PURE__ */ (0, import_jsx_runtime456.jsx)(import_uik543.Icon.Navigation.ChevronRight, { className: CHEVRON2, size: "SMALL" }),
              icon && /* @__PURE__ */ (0, import_jsx_runtime456.jsx)(import_uik543.Icon, { className: ADDITIONAL_ICON, size: "SMALL", type: icon }),
              /* @__PURE__ */ (0, import_jsx_runtime456.jsx)(Tooltip7, { showOnOverflowOnly: true, value: title, children: /* @__PURE__ */ (0, import_jsx_runtime456.jsx)("span", { className: TITLE4, children: title }) })
            ] }),
            /* @__PURE__ */ (0, import_jsx_runtime456.jsx)("div", { className: DESCRIPTION3, children: description })
          ]
        }
      ),
      open && /* @__PURE__ */ (0, import_jsx_runtime456.jsx)("div", { className: CONTENT4, children })
    ] });
  }
);
Expander.displayName = "Expander";
Expander.__DEV_METADATA__ = { status: "DEPRECATED" };

// FlowMap/Constellation.tsx
var import_uik548 = require("@appd/uik");
var d33 = __toESM(require("d3"));
var import_react66 = require("react");

// FlowMap/CONSTANTS/CONSTANTS.ts
var CONSTANTS2;
((CONSTANTS3) => {
  CONSTANTS3.defaultHighlightedEntities = {
    edges: [],
    nodes: []
  };
  CONSTANTS3.defaultGraphLabels = [];
  CONSTANTS3.DEFAULT_GRAPH_NAME = "forceGraph";
  CONSTANTS3.ALPHA = 1;
  CONSTANTS3.ALPHA_MIN = 1e-3;
  CONSTANTS3.ALPHA_DECAY = 0.08;
  CONSTANTS3.ALPHA_TARGET = 0;
  CONSTANTS3.CANVAS_SVG_WIDTH = "100%";
  CONSTANTS3.CANVAS_SVG_HEIGHT = "100%";
  CONSTANTS3.DEFAULT_ANIMATION_DURATION = 10;
  CONSTANTS3.DEFAULT_LINK_THICKNESS_FACTOR = 2;
  CONSTANTS3.DEFAULT_OPACITY = 1;
  CONSTANTS3.DEFAULT_SHADOWLINK_THICKNESS = 15;
  CONSTANTS3.DEFAULT_SHOW_ICON = 0;
  CONSTANTS3.DEFAULT_SHOW_LABEL = 0;
  CONSTANTS3.DEFAULT_WEIGHT = 3;
  CONSTANTS3.DEFAULT_FLOWING_PARTICLES = false;
  CONSTANTS3.EDGE_NODE_BUFFER = 8;
  CONSTANTS3.ICON_WIDTH = 30;
  CONSTANTS3.ICON_HEIGHT = 30;
  CONSTANTS3.LABEL_BUFFER = 3;
  CONSTANTS3.LABEL_FONT_SIZE = 18;
  CONSTANTS3.LINK_FORCE = 250;
  CONSTANTS3.LOW_OPACITY = 0.35;
  CONSTANTS3.MAX_NODES = 6;
  CONSTANTS3.MAX_ZOOM = 8;
  CONSTANTS3.MIN_ZOOM = 0.2;
  CONSTANTS3.MULTI_EDGE_LINK_THICKNESS_FACTOR = 1;
  CONSTANTS3.NODE_RADIUS = 20;
  CONSTANTS3.NODE_COLLIDE_FORCE = 125;
  CONSTANTS3.PAN_VALUE = 100;
  CONSTANTS3.RING_THICKNESS = 3;
  CONSTANTS3.RING_SPACING = 2;
  CONSTANTS3.SKIP = "$skip";
  CONSTANTS3.TRANSPARENT = 0;
  CONSTANTS3.UNKNOWN_HEALTH = 1;
  CONSTANTS3.X_FORCE = 0.1;
  CONSTANTS3.Y_FORCE = 0.1;
  CONSTANTS3.ZOOM_IN = 1.25;
  CONSTANTS3.ZOOM_OUT = 0.8;
  CONSTANTS3.PADDING = 4 * CONSTANTS3.NODE_RADIUS;
  CONSTANTS3.XY_EXTENSION_PADDING_FACTOR = 2;
  CONSTANTS3.FOUR_NODES = 4;
  CONSTANTS3.FOUR_NODE_SCALE_FACTOR = 1.5;
  CONSTANTS3.START_LABEL = "START";
  CONSTANTS3.DEFAULT_LABEL_TRUNCATE_LENGTH = 30;
  CONSTANTS3.DEFAULT_RESET_ZOOM_ON_SCOPED_ENTITY = true;
  CONSTANTS3.DEFAULT_ROOT_NODE_EDGES_ONLY = false;
  CONSTANTS3.DEFAULT_IS_N_LEVELS = false;
  CONSTANTS3.DEFAULT_MULTI_EDGE_THICKNESS = false;
  CONSTANTS3.DEFAULT_OPAQUE_FILTERS = ["", "isActive=true"];
  CONSTANTS3.DEFAULT_SHOW_HOVER_METRICS = true;
  CONSTANTS3.DEFAULT_SHOW_ONE_HOP_VISUALS = false;
  CONSTANTS3.DEFAULT_ALLOW_REBALANCE_NODES = true;
  CONSTANTS3.DEFAULT_ALLOW_SMOOTH_EDGES = true;
  CONSTANTS3.DEFAULT_ALLOW_TRUNCATE_LABELS = true;
  CONSTANTS3.DEFAULT_SHOW_START_LABEL = true;
  CONSTANTS3.TOP_LABEL_BG_WIDTH = 220;
  CONSTANTS3.TOP_LABEL_BG_HEIGHT = 25;
  CONSTANTS3.TOP_LABEL_BG_BORDER_RADIUS = 15;
  CONSTANTS3.TOP_LABEL_BG_X_OFFSET = 110;
  CONSTANTS3.TOP_LABEL_BG_Y_OFFSET = 3.3;
  CONSTANTS3.TOP_LABEL_BG_Y_OFFSET_FOR_ROOT = 5;
  CONSTANTS3.TOP_LABEL_Y_OFFSET = 2.35;
  CONSTANTS3.TOP_LABEL_Y_OFFSET_FOR_ROOT = 4;
  CONSTANTS3.TOP_LABEL_TRUNCATE_LENGTH = 17;
  CONSTANTS3.LINK_DASH_ARRAY = "20 5";
  CONSTANTS3.LINK_DASH_OFFSET = "100";
  CONSTANTS3.DEFAULT_LINK_ANIMATION_DURATION = 3e3;
  CONSTANTS3.GRAPH_TOP_LABEL_KEY = "topLabel";
  CONSTANTS3.NODE_WIDTH_TO_SHOW_ICONS = 25;
  CONSTANTS3.NODE_WIDTH_TO_SHOW_LABELS = 35;
  CONSTANTS3.DEFAULT_GRAPH_CONTROLS = true;
  CONSTANTS3.DEFAULT_MOUSE_SCROLL_ZOOM = true;
  CONSTANTS3.DEFAULT_FIXED_Y_POS = true;
  CONSTANTS3.HOVER_CARD_WIDTH = 370;
  CONSTANTS3.HOVER_CARD_HEIGHT = 67;
  CONSTANTS3.HOVER_CARD_X_OFFSET = 150;
  CONSTANTS3.HOVER_CARD_Y_OFFSET = 115;
  CONSTANTS3.HOVER_CARD_X_OFFSET_N_LEVELS = 150;
  CONSTANTS3.HOVER_CARD_Y_OFFSET_N_LEVELS = 105;
  CONSTANTS3.HOVER_CARD_X_OFFSET_FIREFOX = CONSTANTS3.HOVER_CARD_WIDTH + 40;
  CONSTANTS3.HOVER_CARD_Y_OFFSET_FIREFOX = 210;
  CONSTANTS3.HOVER_CARD_X_OFFSET_N_LEVELS_FIREFOX = CONSTANTS3.HOVER_CARD_WIDTH + 40;
  CONSTANTS3.HOVER_CARD_Y_OFFSET_N_LEVELS_FIREFOX = 210;
  CONSTANTS3.HOVER_CARD_X_LEFT_BORDER_ADJUSTMENT = 5;
  CONSTANTS3.HOVER_CARD_X_RIGHT_BORDER_ADJUSTMENT = CONSTANTS3.HOVER_CARD_WIDTH + 20;
  CONSTANTS3.HOVER_CARD_Y_TOP_BORDER_ADJUSTMENT = CONSTANTS3.HOVER_CARD_Y_OFFSET + 5 * CONSTANTS3.NODE_RADIUS;
  CONSTANTS3.EDGE_THICKNESS_BANDS = [3, 3];
  CONSTANTS3.MULTI_EDGE_THICKNESS_BANDS = [2, 8];
  CONSTANTS3.EDGE_SCALE_BANDS = ["2", "3", "4", "5", "6", "7", "8"];
  CONSTANTS3.EDGE_MARKER_END_REFX = [3];
  CONSTANTS3.MULTI_EDGE_MARKER_END_REFX = [2, 2.3, 2.5, 2.9, 2.9, 3.1, 3.3];
  CONSTANTS3.ARROW_MARKER_END_PREFIX = "arrow-";
  CONSTANTS3.ARROW_HOVER_MARKER_END_PREFIX = "arrow-hover-";
  CONSTANTS3.ARROW_ERROR_MARKER_END_PREFIX = "arrow-error-";
  CONSTANTS3.PARTICLE_RADIUS = 2.5;
  CONSTANTS3.PARTICLE_CREATION_SPEED = 200;
  CONSTANTS3.PARTICLE_FLOW_MIN_SPEED = 5e3;
  CONSTANTS3.PARTICLE_FLOW_MAX_SPEED = 2e4;
  CONSTANTS3.EDGE_STROKE_WIDTH_WITH_PARTICLES = 8;
})(CONSTANTS2 || (CONSTANTS2 = {}));

// FlowMap/ForceGraph.tsx
var import_uik547 = require("@appd/uik");
var d32 = __toESM(require("d3"));
var import_react65 = require("react");
var import_client = require("react-dom/client");
var import_server2 = require("react-dom/server");

// FlowMap/COMMON/COMMON.ts
var COMMON;
((COMMON2) => {
  let EntityType;
  ((EntityType2) => {
    EntityType2[EntityType2["Node"] = 0] = "Node";
    EntityType2[EntityType2["Link"] = 1] = "Link";
  })(EntityType = COMMON2.EntityType || (COMMON2.EntityType = {}));
})(COMMON || (COMMON = {}));

// FlowMap/graphUtils.tsx
var import_uik544 = require("@appd/uik");
var d3 = __toESM(require("d3"));
var import_jsx_runtime457 = require("react/jsx-runtime");
var {
  ARROW_HOVER_MARKER_END_PREFIX,
  DEFAULT_ANIMATION_DURATION,
  DEFAULT_LINK_ANIMATION_DURATION,
  DEFAULT_OPACITY,
  DEFAULT_WEIGHT,
  FOUR_NODE_SCALE_FACTOR,
  FOUR_NODES,
  LINK_DASH_ARRAY,
  LINK_DASH_OFFSET,
  LOW_OPACITY,
  NODE_RADIUS,
  PADDING,
  PAN_VALUE,
  RING_SPACING,
  RING_THICKNESS,
  XY_EXTENSION_PADDING_FACTOR,
  ZOOM_IN,
  ZOOM_OUT
} = CONSTANTS2;
var {
  COLORS: {
    CONTROL_BG_STRONG: CONTROL_BG_STRONG3,
    CONTROL_BORDER: CONTROL_BORDER9,
    CONTROL_BORDER_HOVER: CONTROL_BORDER_HOVER2,
    INTERACT_BORDER_MEDIUM,
    NEGATIVE_ICON: NEGATIVE_ICON3,
    POSITIVE_ICON: POSITIVE_ICON3,
    WARNING_ICON: WARNING_ICON3
  },
  PARTICLE: { UNKNOWN_ICON: UNKNOWN_ICON2 }
} = import_uik544.MAGNETIC_TOKENS;
var getHealthStatusColor = /* @__PURE__ */ __name((status) => {
  switch (status) {
    case 0:
      return POSITIVE_ICON3;
    case 1:
      return UNKNOWN_ICON2;
    case 2:
      return WARNING_ICON3;
    case 3:
      return NEGATIVE_ICON3;
    default:
      return CONTROL_BG_STRONG3;
  }
}, "getHealthStatusColor");
var getGraphNodeIcon = /* @__PURE__ */ __name((iconProps, nodeType) => {
  const { contentMapping, fallbackIconName, fill } = iconProps;
  const iconName = contentMapping[nodeType ?? ""] ?? fallbackIconName;
  return /* @__PURE__ */ (0, import_jsx_runtime457.jsx)(import_uik544.Icon, { fill, type: iconName });
}, "getGraphNodeIcon");
var truncateStr = /* @__PURE__ */ __name((label, n) => label !== void 0 && label !== null && label.length > n + 3 ? `${label.slice(0, n / 2 + 1)}...${label.slice(label.length - n / 2 + 1)}` : label, "truncateStr");
var getNormalizedMetrics = /* @__PURE__ */ __name((metrics) => {
  if (metrics) {
    const options = {
      maximumFractionDigits: 2,
      minimumFractionDigits: 1
    };
    const normalizedMetrics = [];
    metrics.forEach(
      (metric) => normalizedMetrics.push({
        name: metric.name,
        units: metric.units,
        value: import_uik544.format.number.short(metric.value, options)
      })
    );
    return normalizedMetrics;
  }
  return metrics;
}, "getNormalizedMetrics");
var updateScaleFactorAndGraphCenterCoordinates = /* @__PURE__ */ __name((nodes, height2, width) => {
  let maxY = Number.NEGATIVE_INFINITY;
  let minY = Number.POSITIVE_INFINITY;
  let maxX = Number.NEGATIVE_INFINITY;
  let minX = Number.POSITIVE_INFINITY;
  nodes.forEach((elem) => {
    maxY = Math.max(maxY, elem.y);
    minY = Math.min(minY, elem.y);
    maxX = Math.max(maxX, elem.x);
    minX = Math.min(minX, elem.x);
  });
  const yExtension = (maxY > height2 - PADDING || minY < PADDING) && Math.abs(maxY - minY) > 1 ? maxY - minY : height2 - XY_EXTENSION_PADDING_FACTOR * PADDING;
  const xExtension = (maxX > width - PADDING || minX < PADDING) && Math.abs(maxX - minX) > 1 ? maxX - minX : width - XY_EXTENSION_PADDING_FACTOR * PADDING;
  let scaleFactor = Math.min(
    (width - XY_EXTENSION_PADDING_FACTOR * PADDING) / xExtension,
    (height2 - XY_EXTENSION_PADDING_FACTOR * PADDING) / yExtension
  );
  scaleFactor = nodes.length <= FOUR_NODES ? FOUR_NODE_SCALE_FACTOR : scaleFactor;
  const renderedGraphCenterX = (minX + maxX) / 2;
  const renderedGraphCenterY = (minY + maxY) / 2;
  return {
    centerX: renderedGraphCenterX,
    centerY: renderedGraphCenterY,
    scaleFactor
  };
}, "updateScaleFactorAndGraphCenterCoordinates");
var addAnimationToLinks = /* @__PURE__ */ __name((linksToUpdate) => {
  linksToUpdate.attr("marker-end", (d) => `url(#${ARROW_HOVER_MARKER_END_PREFIX}${d.id})`).attr("stroke-dasharray", LINK_DASH_ARRAY).attr("stroke-dashoffset", LINK_DASH_OFFSET).attr("stroke", CONTROL_BORDER_HOVER2).attr("cursor", "pointer").transition().ease(d3.easeLinear).attr("stroke-dashoffset", "0").duration(DEFAULT_LINK_ANIMATION_DURATION).on("end", () => setTimeout(addAnimationToLinks, 0, linksToUpdate));
}, "addAnimationToLinks");
var clearEntitySelection = /* @__PURE__ */ __name((nodeLinkRef, edgeThicknessScale, oneHopFilteredEntitiesRef, showOneHopNodeVisuals) => {
  nodeLinkRef.current.nodeElem.current?.selectAll("circle").style("outline", "").style("outline-offset", "").attr("opacity", DEFAULT_OPACITY);
  nodeLinkRef.current.nodeElem.current?.selectAll(".topLabelBG").attr("visibility", "hidden");
  nodeLinkRef.current.nodeElem.current?.selectAll(".topLabel").attr("visibility", "hidden");
  nodeLinkRef.current.link.current?.attr("stroke", CONTROL_BORDER9).interrupt().lower().attr("stroke-width", (d) => Math.round(edgeThicknessScale(d.weight ?? DEFAULT_WEIGHT))).attr("marker-end", (d) => `url(#arrow-${d.id})`).attr("stroke-dasharray", "").attr("stroke", CONTROL_BORDER9).attr("cursor", "pointer").attr("opacity", DEFAULT_OPACITY);
  highlightScopeEntities(oneHopFilteredEntitiesRef, showOneHopNodeVisuals, nodeLinkRef);
}, "clearEntitySelection");
var highlightScopeEntities = /* @__PURE__ */ __name((oneHopFilteredEntitiesRef, showOneHopNodeVisuals, nodeLinkRef) => {
  if (showOneHopNodeVisuals) {
    nodeLinkRef.current.nodeElem.current.attr("opacity", LOW_OPACITY).filter((elem) => oneHopFilteredEntitiesRef.current.nodes.includes(elem.id)).attr("opacity", DEFAULT_OPACITY);
    nodeLinkRef.current.link.current.attr("opacity", LOW_OPACITY).filter((elem) => oneHopFilteredEntitiesRef.current.edges.includes(elem.id)).attr("opacity", DEFAULT_OPACITY);
  }
}, "highlightScopeEntities");
var zoomIn = /* @__PURE__ */ __name((forceGraphCanvas, d3zoom) => {
  forceGraphCanvas?.transition().duration(DEFAULT_ANIMATION_DURATION).call(d3zoom.scaleBy, ZOOM_IN);
}, "zoomIn");
var zoomOut = /* @__PURE__ */ __name((forceGraphCanvas, d3zoom) => {
  forceGraphCanvas?.transition().duration(DEFAULT_ANIMATION_DURATION).call(d3zoom.scaleBy, ZOOM_OUT);
}, "zoomOut");
var moveLeft = /* @__PURE__ */ __name((forceGraphCanvas, d3zoom) => {
  forceGraphCanvas?.transition().duration(DEFAULT_ANIMATION_DURATION).call(d3zoom.translateBy, -PAN_VALUE, 0);
}, "moveLeft");
var moveRight = /* @__PURE__ */ __name((forceGraphCanvas, d3zoom) => {
  forceGraphCanvas?.transition().duration(DEFAULT_ANIMATION_DURATION).call(d3zoom.translateBy, PAN_VALUE, 0);
}, "moveRight");
var moveUp = /* @__PURE__ */ __name((forceGraphCanvas, d3zoom) => {
  forceGraphCanvas?.transition().duration(DEFAULT_ANIMATION_DURATION).call(d3zoom.translateBy, 0, -PAN_VALUE);
}, "moveUp");
var moveDown = /* @__PURE__ */ __name((forceGraphCanvas, d3zoom) => {
  forceGraphCanvas?.transition().duration(DEFAULT_ANIMATION_DURATION).call(d3zoom.translateBy, 0, PAN_VALUE);
}, "moveDown");
var getSecondaryLabel = /* @__PURE__ */ __name((label) => {
  if (label && label.length > 0) {
    return label;
  }
  return void 0;
}, "getSecondaryLabel");
var onNodeClick = /* @__PURE__ */ __name((e, d, nodeLinkRef, edgeThicknessScale, oneHopFilteredEntitiesRef, showOneHopNodeVisuals) => {
  clearEntitySelection(nodeLinkRef, edgeThicknessScale, oneHopFilteredEntitiesRef, showOneHopNodeVisuals);
  nodeLinkRef.current.nodeElem.current.filter((elem) => elem.id === d.id).select("circle").style("outline", `${RING_THICKNESS}px solid ${INTERACT_BORDER_MEDIUM}`).style("outline-offset", `${RING_SPACING}px`).style("border-radius", `${NODE_RADIUS}px`);
  e.stopPropagation();
}, "onNodeClick");
var onNodeDblClick = /* @__PURE__ */ __name((e, d, nodeLinkRef, edgeThicknessScale, oneHopFilteredEntitiesRef, showOneHopNodeVisuals) => {
  clearEntitySelection(nodeLinkRef, edgeThicknessScale, oneHopFilteredEntitiesRef, showOneHopNodeVisuals);
  nodeLinkRef.current.nodeElem.current.filter((elem) => elem.id === d.id).select("circle").style("outline", `${RING_THICKNESS}px solid ${INTERACT_BORDER_MEDIUM}`).style("outline-offset", `${RING_SPACING}px`).style("border-radius", `${NODE_RADIUS}px`);
  e.stopPropagation();
}, "onNodeDblClick");
var onLinkClick = /* @__PURE__ */ __name((e, d, nodeLinkRef, edgeThicknessScale, linkThicknessFactor, oneHopFilteredEntitiesRef, showOneHopNodeVisuals) => {
  clearEntitySelection(nodeLinkRef, edgeThicknessScale, oneHopFilteredEntitiesRef, showOneHopNodeVisuals);
  nodeLinkRef.current.link.current.filter((elem) => elem.id === d.id).attr("marker-end", (d2) => `url(#${ARROW_HOVER_MARKER_END_PREFIX}${d2.id})`).attr("stroke", CONTROL_BORDER_HOVER2).attr("stroke-width", (d2) => linkThicknessFactor * Math.round(edgeThicknessScale(d2.weight ?? DEFAULT_WEIGHT))).attr("cursor", "pointer").raise();
  e.stopPropagation();
}, "onLinkClick");

// FlowMap/MESSAGES.ts
var import_uik545 = require("@appd/uik");
var MESSAGES7 = {
  // (object-curly-newline)
  NO_DATA: import_uik545.format.message`No data`.description("An indicator of there being no data in the flowmap.")
};

// FlowMap/MetricsHoverCard.tsx
var import_uik546 = require("@appd/uik");
var import_jsx_runtime458 = require("react/jsx-runtime");
var {
  COLORS: { CONTROL_BG_STRONG: CONTROL_BG_STRONG4, CONTROL_BG_WEAK: CONTROL_BG_WEAK10, CONTROL_BORDER_WEAK: CONTROL_BORDER_WEAK9, DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM8, DEFAULT_TEXT_STRONG: DEFAULT_TEXT_STRONG5 },
  TYPOGRAPHY: { ELLIPSES: ELLIPSES10 }
} = import_uik546.MAGNETIC_TOKENS;
var getHealthIcons = /* @__PURE__ */ __name((status) => {
  const HEALTHICONS = {
    0: /* @__PURE__ */ (0, import_jsx_runtime458.jsx)(import_uik546.Icon.Health.Normal, { width: 14 }),
    1: /* @__PURE__ */ (0, import_jsx_runtime458.jsx)(import_uik546.Icon.Health.Unknown, { width: 14 }),
    2: /* @__PURE__ */ (0, import_jsx_runtime458.jsx)(import_uik546.Icon.Health.Warning, { width: 14 }),
    3: /* @__PURE__ */ (0, import_jsx_runtime458.jsx)(import_uik546.Icon.Health.Critical, { width: 14 })
  };
  const noAlertRuleStyle = { "& path:first-child": { fill: CONTROL_BG_STRONG4 } };
  return HEALTHICONS[status] ?? /* @__PURE__ */ (0, import_jsx_runtime458.jsx)(import_uik546.Icon.Status.Unknown, { className: (0, import_uik546.css)(noAlertRuleStyle), width: 14 });
}, "getHealthIcons");
var metricDisplay = /* @__PURE__ */ __name((metric, key) => {
  const { name, units, value } = metric;
  return /* @__PURE__ */ (0, import_jsx_runtime458.jsxs)(
    "div",
    {
      style: {
        flex: 1,
        lineHeight: 1.5,
        padding: "1px 7px 1px 0px"
      },
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime458.jsx)(
          "div",
          {
            className: (0, import_uik546.css)(
              {
                color: DEFAULT_TEXT_MEDIUM8,
                fontSize: 10
              },
              "metricTitle"
            ),
            children: name
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime458.jsxs)(
          "div",
          {
            className: (0, import_uik546.css)(
              {
                alignItems: "end",
                display: "flex",
                height: 23
              },
              "metricValues"
            ),
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime458.jsx)(
                "div",
                {
                  style: {
                    fontSize: 12,
                    fontWeight: 500
                  },
                  children: value
                }
              ),
              /* @__PURE__ */ (0, import_jsx_runtime458.jsx)(
                "div",
                {
                  style: {
                    color: DEFAULT_TEXT_MEDIUM8,
                    fontSize: 11,
                    paddingLeft: 2
                  },
                  children: units
                }
              )
            ]
          }
        )
      ]
    },
    key
  );
}, "metricDisplay");
var headerCss = {
  display: "flex",
  fontSize: 12,
  fontWeight: 500,
  lineHeight: 1.5
};
var nodeHeader = /* @__PURE__ */ __name((name, healthStatus, width) => {
  const healthIcon = getHealthIcons(healthStatus);
  return /* @__PURE__ */ (0, import_jsx_runtime458.jsxs)("div", { className: (0, import_uik546.css)(headerCss, "nodeHeader"), children: [
    /* @__PURE__ */ (0, import_jsx_runtime458.jsx)(
      "div",
      {
        className: (0, import_uik546.css)(
          {
            ...ELLIPSES10.END,
            maxWidth: width - 5
          },
          "titleName"
        ),
        children: name
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime458.jsx)("div", { style: { padding: "1px 0px 0px 6px" }, children: healthIcon })
  ] });
}, "nodeHeader");
var edgeHeader = /* @__PURE__ */ __name((headerAttributes) => {
  const { fromNode, toNode } = headerAttributes;
  const fromNodeHealth = getHealthIcons(fromNode.health);
  const toNodeHealth = getHealthIcons(toNode.health);
  return /* @__PURE__ */ (0, import_jsx_runtime458.jsxs)("div", { className: (0, import_uik546.css)(headerCss, "edgeHeader"), children: [
    /* @__PURE__ */ (0, import_jsx_runtime458.jsxs)("div", { style: { display: "flex" }, children: [
      /* @__PURE__ */ (0, import_jsx_runtime458.jsx)(
        "div",
        {
          className: (0, import_uik546.css)(
            {
              ...ELLIPSES10.END,
              maxWidth: 136
            },
            "titleName"
          ),
          children: fromNode.name
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime458.jsxs)("div", { style: { padding: "1px 0px 0px 5px" }, children: [
        " ",
        fromNodeHealth,
        " "
      ] })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime458.jsx)("div", { style: { padding: "0px 10px" }, children: `-->` }),
    /* @__PURE__ */ (0, import_jsx_runtime458.jsxs)("div", { style: { display: "flex" }, children: [
      /* @__PURE__ */ (0, import_jsx_runtime458.jsx)(
        "div",
        {
          className: (0, import_uik546.css)(
            {
              ...ELLIPSES10.END,
              maxWidth: 136
            },
            "titleName"
          ),
          children: toNode.name
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime458.jsxs)("div", { style: { padding: "1px 0px 0px 6px" }, children: [
        " ",
        toNodeHealth,
        " "
      ] })
    ] })
  ] });
}, "edgeHeader");
var MetricsHoverCard = /* @__PURE__ */ __name(({ entityAttributes, height: height2, pos, type, width }) => {
  const { metrics, ...otherAttributes } = entityAttributes;
  let header;
  if (type === "node") {
    const { health, name } = otherAttributes;
    header = nodeHeader(name, health, width);
  } else {
    header = edgeHeader(otherAttributes);
  }
  return /* @__PURE__ */ (0, import_jsx_runtime458.jsxs)(
    "div",
    {
      className: (0, import_uik546.css)(
        {
          backgroundColor: CONTROL_BG_WEAK10,
          border: `1px solid ${CONTROL_BORDER_WEAK9}`,
          borderRadius: 4,
          color: DEFAULT_TEXT_STRONG5,
          height: height2,
          left: pos.x,
          padding: "5px 0px 2px 10px",
          pointerEvents: "none",
          position: "absolute",
          top: pos.y,
          width,
          zIndex: 10
        },
        "hoverContainer"
      ),
      children: [
        header,
        /* @__PURE__ */ (0, import_jsx_runtime458.jsx)(
          "div",
          {
            style: {
              display: "flex",
              justifyContent: "space-between"
            },
            children: metrics && metrics.map((metric, index) => metricDisplay(metric, index))
          }
        )
      ]
    }
  );
}, "MetricsHoverCard");
var MetricsHoverCard_default = MetricsHoverCard;

// FlowMap/ForceGraph.tsx
var import_jsx_runtime459 = require("react/jsx-runtime");
var {
  ALPHA,
  ALPHA_DECAY,
  ALPHA_MIN,
  ALPHA_TARGET,
  ARROW_ERROR_MARKER_END_PREFIX,
  ARROW_HOVER_MARKER_END_PREFIX: ARROW_HOVER_MARKER_END_PREFIX2,
  ARROW_MARKER_END_PREFIX,
  CANVAS_SVG_HEIGHT,
  CANVAS_SVG_WIDTH,
  DEFAULT_ALLOW_REBALANCE_NODES,
  DEFAULT_ALLOW_SMOOTH_EDGES,
  DEFAULT_ALLOW_TRUNCATE_LABELS,
  DEFAULT_ANIMATION_DURATION: DEFAULT_ANIMATION_DURATION2,
  DEFAULT_FIXED_Y_POS,
  DEFAULT_FLOWING_PARTICLES,
  DEFAULT_GRAPH_CONTROLS,
  DEFAULT_GRAPH_NAME,
  DEFAULT_IS_N_LEVELS,
  DEFAULT_LABEL_TRUNCATE_LENGTH,
  DEFAULT_LINK_THICKNESS_FACTOR,
  DEFAULT_MOUSE_SCROLL_ZOOM,
  DEFAULT_MULTI_EDGE_THICKNESS,
  DEFAULT_OPACITY: DEFAULT_OPACITY2,
  DEFAULT_ROOT_NODE_EDGES_ONLY,
  DEFAULT_SHADOWLINK_THICKNESS,
  DEFAULT_SHOW_HOVER_METRICS,
  DEFAULT_SHOW_ICON,
  DEFAULT_SHOW_LABEL,
  DEFAULT_SHOW_ONE_HOP_VISUALS,
  DEFAULT_SHOW_START_LABEL,
  DEFAULT_WEIGHT: DEFAULT_WEIGHT2,
  EDGE_MARKER_END_REFX,
  EDGE_SCALE_BANDS,
  EDGE_STROKE_WIDTH_WITH_PARTICLES,
  EDGE_THICKNESS_BANDS,
  HOVER_CARD_HEIGHT,
  HOVER_CARD_WIDTH,
  HOVER_CARD_X_LEFT_BORDER_ADJUSTMENT,
  HOVER_CARD_X_OFFSET,
  HOVER_CARD_X_OFFSET_FIREFOX,
  HOVER_CARD_X_OFFSET_N_LEVELS,
  HOVER_CARD_X_OFFSET_N_LEVELS_FIREFOX,
  HOVER_CARD_X_RIGHT_BORDER_ADJUSTMENT,
  HOVER_CARD_Y_OFFSET,
  HOVER_CARD_Y_OFFSET_FIREFOX,
  HOVER_CARD_Y_OFFSET_N_LEVELS,
  HOVER_CARD_Y_OFFSET_N_LEVELS_FIREFOX,
  HOVER_CARD_Y_TOP_BORDER_ADJUSTMENT,
  ICON_HEIGHT,
  ICON_WIDTH,
  LABEL_BUFFER,
  LABEL_FONT_SIZE,
  LINK_FORCE,
  LOW_OPACITY: LOW_OPACITY2,
  MAX_ZOOM,
  MIN_ZOOM,
  MULTI_EDGE_LINK_THICKNESS_FACTOR,
  MULTI_EDGE_MARKER_END_REFX,
  MULTI_EDGE_THICKNESS_BANDS,
  NODE_COLLIDE_FORCE,
  NODE_RADIUS: NODE_RADIUS2,
  PARTICLE_CREATION_SPEED,
  PARTICLE_FLOW_MAX_SPEED,
  PARTICLE_FLOW_MIN_SPEED,
  PARTICLE_RADIUS,
  RING_SPACING: RING_SPACING2,
  RING_THICKNESS: RING_THICKNESS2,
  START_LABEL,
  TOP_LABEL_BG_BORDER_RADIUS,
  TOP_LABEL_BG_HEIGHT,
  TOP_LABEL_BG_WIDTH,
  TOP_LABEL_BG_X_OFFSET,
  TOP_LABEL_BG_Y_OFFSET,
  TOP_LABEL_BG_Y_OFFSET_FOR_ROOT,
  TOP_LABEL_TRUNCATE_LENGTH,
  TOP_LABEL_Y_OFFSET,
  TOP_LABEL_Y_OFFSET_FOR_ROOT,
  TRANSPARENT,
  UNKNOWN_HEALTH
} = CONSTANTS2;
var {
  COLORS: {
    CONTROL_BORDER: CONTROL_BORDER10,
    CONTROL_BORDER_HOVER: CONTROL_BORDER_HOVER3,
    CONTROL_ICON_IN,
    DEFAULT_TEXT: DEFAULT_TEXT10,
    INFO_ICON_WEAK,
    INTERACT_BORDER_MEDIUM: INTERACT_BORDER_MEDIUM2,
    INTERACT_TEXT: INTERACT_TEXT3,
    INTERACT_TEXT_IN: INTERACT_TEXT_IN3,
    INVERSE_ICON,
    NEGATIVE_BG,
    NEGATIVE_BORDER: NEGATIVE_BORDER3
  }
} = import_uik547.MAGNETIC_TOKENS;
var arePropsEqual = /* @__PURE__ */ __name((oldProps, newProps) => JSON.stringify(oldProps) === JSON.stringify(newProps), "arePropsEqual");
var ForceGraph = (0, import_react65.memo)(
  (0, import_react65.forwardRef)(/* @__PURE__ */ __name(function ForceGraph2({
    className: className2,
    configProps,
    eventActions,
    filteredNodes,
    linkPosition,
    linksData,
    nodePosition,
    nodesData,
    rootNode
  }, ref) {
    const {
      allowRebalance = DEFAULT_ALLOW_REBALANCE_NODES,
      allowSmooth = DEFAULT_ALLOW_SMOOTH_EDGES,
      allowTruncate = DEFAULT_ALLOW_TRUNCATE_LABELS,
      alpha = ALPHA,
      alphaDecay = ALPHA_DECAY,
      alphaMin = ALPHA_MIN,
      alphaTarget = ALPHA_TARGET,
      enableZoomOnMouseScroll = DEFAULT_MOUSE_SCROLL_ZOOM,
      fixedYPos = DEFAULT_FIXED_Y_POS,
      graphName = DEFAULT_GRAPH_NAME,
      iconProps,
      isNLevels = DEFAULT_IS_N_LEVELS,
      labelTruncateLength = DEFAULT_LABEL_TRUNCATE_LENGTH,
      linkForce = LINK_FORCE,
      multiEdgeThickness = DEFAULT_MULTI_EDGE_THICKNESS,
      nodeCollideForce = NODE_COLLIDE_FORCE,
      rootNodeEdgesOnly = DEFAULT_ROOT_NODE_EDGES_ONLY,
      showFlowingParticles = DEFAULT_FLOWING_PARTICLES,
      showGraphControls = DEFAULT_GRAPH_CONTROLS,
      showHoverMetrics: showHoverMetricsCard = DEFAULT_SHOW_HOVER_METRICS,
      showIcon = DEFAULT_SHOW_ICON,
      showLabel = DEFAULT_SHOW_LABEL,
      showOneHopNodeVisuals = DEFAULT_SHOW_ONE_HOP_VISUALS,
      showStartLabel = DEFAULT_SHOW_START_LABEL
    } = configProps;
    const nodeLinkRef = ref;
    const {
      onCanvasClick = /* @__PURE__ */ __name(() => {
      }, "onCanvasClick"),
      onLinkSingleClick = /* @__PURE__ */ __name(() => {
      }, "onLinkSingleClick"),
      onNodeDoubleClick = /* @__PURE__ */ __name(() => {
      }, "onNodeDoubleClick"),
      onNodeSingleClick = /* @__PURE__ */ __name(() => {
      }, "onNodeSingleClick")
    } = eventActions;
    let edgeThicknessScale;
    let markerViewBoxScale;
    let simulation;
    let nodeToLinkDict = {};
    let oneHopDownstreamNodesDict = {};
    let oneHopUpstreamNodesDict = {};
    let shadowLink;
    let minLinkART = 0;
    let maxLinkART = 0;
    let initialPageLoad = true;
    const links = [];
    const nodes = [];
    const nodeIds = [];
    const edgePaths = [];
    let linkThicknessFactor = DEFAULT_LINK_THICKNESS_FACTOR;
    const [rebalanceNodes, setRebalanceNodes] = (0, import_react65.useState)(allowRebalance);
    const [smoothEdges, setSmoothEdges] = (0, import_react65.useState)(allowSmooth);
    const [truncateLabels, setTruncateLabels] = (0, import_react65.useState)(allowTruncate);
    const [zoomLevel, setZoomLevel] = (0, import_react65.useState)({
      k: 1,
      x: 0,
      y: 0
    });
    const { currentTheme } = (0, import_react65.useContext)(import_uik547.css.CONTEXT);
    const containerRef = (0, import_react65.useRef)(null);
    const hoverRef = (0, import_react65.useRef)(null);
    const scaleFactor = (0, import_react65.useRef)(1);
    const renderedGraphCenterX = (0, import_react65.useRef)(0);
    const renderedGraphCenterY = (0, import_react65.useRef)(0);
    const width = (0, import_react65.useRef)(0);
    const height2 = (0, import_react65.useRef)(0);
    const selectedNodeId = (0, import_react65.useRef)("");
    const selectedLinkId = (0, import_react65.useRef)("");
    const currentParticlesFlowId = (0, import_react65.useRef)(0);
    const forceGraphCanvas = (0, import_react65.useRef)(d32.select(containerRef.current).select(`#${graphName}Canvas`));
    const canvas = (0, import_react65.useRef)(d32.select(containerRef.current).select(`#canvas`).append("svg").append("g"));
    const filteredNodesRef = (0, import_react65.useRef)(filteredNodes ?? []);
    const hoverCardRoot = (0, import_react65.useRef)(null);
    const d3zoom = d32.zoom().scaleExtent([MIN_ZOOM, MAX_ZOOM]).translateExtent([
      [Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY],
      [Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY]
    ]).on("zoom", (e) => zoomed(e));
    if (!enableZoomOnMouseScroll) {
      d3zoom.filter(
        (event) => (
          // zoom on mouse scroll only if control button is pressed
          (event.ctrlKey || event.type !== "wheel") && !event.button
        )
      );
    }
    const oneHopFilteredEntitiesRef = (0, import_react65.useRef)(
      getOneHopFilteredEntities(linksData, filteredNodesRef)
    );
    const updateRebalanceNodes = /* @__PURE__ */ __name((checked) => {
      setRebalanceNodes(checked);
    }, "updateRebalanceNodes");
    const updateSmoothEdges = /* @__PURE__ */ __name((checked) => {
      setSmoothEdges(checked);
    }, "updateSmoothEdges");
    const updateTruncateLabels = /* @__PURE__ */ __name((checked) => {
      setTruncateLabels(checked);
    }, "updateTruncateLabels");
    nodesData.forEach((elem) => {
      nodes.push(Object.assign({}, elem));
      nodeIds.push(elem.id);
    });
    linksData.forEach((link) => {
      const linkFrom = link.source;
      const linkTo = link.target;
      if (nodeIds.includes(linkFrom) && nodeIds.includes(linkTo) && (!rootNodeEdgesOnly || rootNodeEdgesOnly && (rootNode?.id === linkFrom || rootNode?.id === linkTo))) {
        links.push(Object.assign({}, link));
        if (!edgePaths.includes(`${link.target}-${link.source}`)) {
          edgePaths.push(`${link.source}-${link.target}`);
        }
        nodeToLinkDict[link.source] ? nodeToLinkDict[link.source].push(link.id) : nodeToLinkDict[link.source] = [link.id];
        nodeToLinkDict[link.target] ? nodeToLinkDict[link.target].push(link.id) : nodeToLinkDict[link.target] = [link.id];
        oneHopDownstreamNodesDict[link.source] ? oneHopDownstreamNodesDict[link.source].push(link.target) : oneHopDownstreamNodesDict[link.source] = [link.target];
        oneHopUpstreamNodesDict[link.target] ? oneHopUpstreamNodesDict[link.target].push(link.source) : oneHopUpstreamNodesDict[link.target] = [link.source];
      }
      const currentArt = Number(link.metrics ? link.metrics[0]?.value ?? 0 : 0);
      minLinkART = Math.min(currentArt, minLinkART);
      maxLinkART = Math.max(currentArt, maxLinkART);
    });
    const nodeMap = new Map(nodes.map((elem) => [elem.id, elem]));
    const min2 = d32.min(links, (d) => d.weight) ?? links[0]?.weight ?? DEFAULT_WEIGHT2;
    const max2 = d32.max(links, (d) => d.weight) ?? links[0]?.weight ?? DEFAULT_WEIGHT2;
    edgeThicknessScale = multiEdgeThickness ? d32.scaleLog().domain([min2, max2]).range(MULTI_EDGE_THICKNESS_BANDS) : d32.scaleLog().domain([min2, max2]).range(EDGE_THICKNESS_BANDS);
    markerViewBoxScale = multiEdgeThickness ? d32.scaleOrdinal().domain(EDGE_SCALE_BANDS).range(MULTI_EDGE_MARKER_END_REFX) : d32.scaleOrdinal().domain(EDGE_SCALE_BANDS).range(EDGE_MARKER_END_REFX);
    linkThicknessFactor = multiEdgeThickness ? MULTI_EDGE_LINK_THICKNESS_FACTOR : DEFAULT_LINK_THICKNESS_FACTOR;
    const zoomed = /* @__PURE__ */ __name((event) => {
      canvas.current.attr("transform", event.transform);
      setZoomLevel(event.transform);
    }, "zoomed");
    (0, import_react65.useEffect)(() => {
      if (containerRef.current !== null) {
        d32.selectAll(`#${graphName}`).remove();
        width.current = containerRef.current.getBoundingClientRect().width;
        height2.current = containerRef.current.getBoundingClientRect().height;
        simulation = d32.forceSimulation(nodes).force(
          "link",
          d32.forceLink(links).id((d) => d.id)
          //.distance(LINK_FORCE),
        ).force("charge", d32.forceManyBody()).force("collide", d32.forceCollide(nodeCollideForce)).alpha(alpha).alphaMin(alphaMin).alphaDecay(alphaDecay).alphaTarget(alphaTarget);
        const forceGraphSvg = d32.select(`#${graphName}Canvas`).append("svg").attr("id", `${graphName}`).style("width", CANVAS_SVG_WIDTH).style("height", CANVAS_SVG_HEIGHT);
        forceGraphCanvas.current = d32.select(`#${graphName}Canvas`).call(d3zoom);
        canvas.current = forceGraphSvg.append("g");
        forceGraphCanvas.current.on("dblclick", (e) => e.stopPropagation());
        forceGraphCanvas.current.transition().duration(DEFAULT_ANIMATION_DURATION2).call(d3zoom.scaleTo, MIN_ZOOM);
        canvas.current.append("defs").selectAll("marker").data(links).join("marker").attr("id", (d) => `${ARROW_MARKER_END_PREFIX}${d.id}`).attr("viewBox", "0 0 4 4").attr(
          "refX",
          (d) => Number(markerViewBoxScale(Math.round(edgeThicknessScale(d.weight ?? DEFAULT_WEIGHT2)).toString()))
        ).attr("refY", 2).attr("markerWidth", 4).attr("markerHeight", 4).attr("orient", "auto-start-reverse").append("path").attr("fill", CONTROL_BORDER10).attr("d", "M0,0 L4,2 0,4 0,0");
        canvas.current.append("defs").selectAll("marker").data(links).join("marker").attr("id", (d) => `${ARROW_HOVER_MARKER_END_PREFIX2}${d.id}`).attr("viewBox", "0 0 4 4").attr(
          "refX",
          (d) => Number(markerViewBoxScale(Math.round(edgeThicknessScale(d.weight ?? DEFAULT_WEIGHT2)).toString()))
        ).attr("refY", 2).attr("markerWidth", 4).attr("markerHeight", 4).attr("orient", "auto-start-reverse").append("path").attr("fill", CONTROL_BORDER_HOVER3).attr("d", "M0,0 L4,2 0,4 0,0").style("mix-blend-mode", "normal");
        canvas.current.append("defs").selectAll("marker").data(links).join("marker").attr("id", (d) => `${ARROW_ERROR_MARKER_END_PREFIX}${d.id}`).attr("viewBox", "0 0 4 4").attr(
          "refX",
          (d) => Number(markerViewBoxScale(Math.round(edgeThicknessScale(d.weight ?? DEFAULT_WEIGHT2)).toString()))
        ).attr("refY", 2).attr("markerWidth", 4).attr("markerHeight", 4).attr("orient", "auto-start-reverse").append("path").attr("fill", NEGATIVE_BORDER3).attr("d", "M0,0 L4,2 0,4 0,0");
        const graphLinks = canvas.current.append("svg").attr("id", "links").style("overflow", "visible").selectAll("path").data(links);
        nodeLinkRef.current.link.current = graphLinks.join(
          (enter) => enter.append("path").attr("id", (d) => `${d.id}`).attr("opacity", TRANSPARENT).attr("stroke", CONTROL_BORDER10).attr("fill", "none").attr("stroke-width", (d) => Math.round(edgeThicknessScale(d.weight ?? DEFAULT_WEIGHT2))).attr("marker-end", (d) => `url(#${ARROW_MARKER_END_PREFIX}${d.id})`),
          (update) => update,
          (exit) => exit.remove()
        );
        const graphShadowLinks = canvas.current.append("svg").attr("id", "shadowLinks").style("overflow", "visible").selectAll("path").data(links);
        shadowLink = graphShadowLinks.join(
          (enter) => enter.append("path").attr("id", (d) => `${d.id}`).attr("opacity", TRANSPARENT).attr("stroke", CONTROL_BORDER10).attr("fill", "none").attr("stroke-width", DEFAULT_SHADOWLINK_THICKNESS).attr("marker-end", (d) => `url(#${ARROW_MARKER_END_PREFIX}${d.id})`).attr("cursor", "pointer"),
          (update) => update,
          (exit) => exit.remove()
        );
        const graphNodes = canvas.current.append("svg").attr("id", "nodes").style("overflow", "visible").selectAll("g").data(nodes);
        nodeLinkRef.current.nodeElem.current = graphNodes.join(
          (enter) => enter.append("g").attr("id", (elem) => elem.id).attr("opacity", TRANSPARENT).call(drag2(simulation)),
          (update) => update,
          (exit) => exit.remove()
        );
        nodeLinkRef.current.nodeElem.current.append("circle").attr("class", "node").attr("r", NODE_RADIUS2).attr("cx", 0).attr("cy", 0).attr("fill", (elem) => getHealthStatusColor(elem.status ?? null)).attr("cursor", "pointer");
        nodeLinkRef.current.nodeElem.current.append("text").attr("class", "label").attr("text-anchor", "middle").attr("font-size", LABEL_FONT_SIZE).attr("fill", DEFAULT_TEXT10).text((node) => truncateLabels ? truncateStr(node.name, labelTruncateLength) : node.name).attr("cursor", "pointer");
        if (iconProps) {
          nodeLinkRef.current.nodeElem.current.append("g").html((elem) => (0, import_server2.renderToString)(getGraphNodeIcon(iconProps, elem.type))).attr("class", "icon").select("svg").attr("width", ICON_WIDTH).attr("height", ICON_HEIGHT).attr("overflow", "visible").attr("visibility", "hidden").attr("cursor", "pointer").selectAll("path").attr("fill", CONTROL_ICON_IN);
        }
        nodeLinkRef.current.nodeElem.current.filter((elem) => elem.id === rootNode?.id).on("mousedown.drag", null);
        if (isNLevels && showStartLabel) {
          nodeLinkRef.current.nodeElem.current.filter((elem) => elem.id === rootNode?.id).insert("text").attr("class", "startLabel").attr("text-anchor", "middle").attr("font-size", LABEL_FONT_SIZE).attr("fill", DEFAULT_TEXT10).text(START_LABEL).attr("opacity", DEFAULT_OPACITY2).attr("cursor", "pointer");
        }
        nodeLinkRef.current.nodeElem.current.append("text").attr("class", "secondaryLabel").attr("text-anchor", "middle").attr("font-size", LABEL_FONT_SIZE).attr("fill", DEFAULT_TEXT10).text(
          (node) => truncateLabels ? truncateStr(node.secondaryLabel ?? "", labelTruncateLength) : node.secondaryLabel ?? ""
        ).attr("cursor", "pointer");
        nodeLinkRef.current.nodeElem.current.append("rect").attr("class", "topLabelBG").attr("width", TOP_LABEL_BG_WIDTH).attr("height", TOP_LABEL_BG_HEIGHT).attr("rx", TOP_LABEL_BG_BORDER_RADIUS).attr("fill", NEGATIVE_BG).attr("visibility", "hidden");
        nodeLinkRef.current.nodeElem.current.append("text").attr("class", "topLabel").attr("text-anchor", "middle").attr("font-size", LABEL_FONT_SIZE).attr("fill", INTERACT_TEXT_IN3).attr("visibility", "hidden").attr("cursor", "pointer");
        updateFilteredNodes(showOneHopNodeVisuals, nodeLinkRef, oneHopFilteredEntitiesRef);
        forceGraphCanvas.current.on("click", () => {
          updateEntitySelection(selectedNodeId, selectedLinkId, nodeLinkRef, "", "");
          onCanvasClick();
          clearEntitySelection(nodeLinkRef, edgeThicknessScale, oneHopFilteredEntitiesRef, showOneHopNodeVisuals);
        });
        nodeLinkRef.current.nodeElem.current.on("click", (e, d) => {
          onNodeSingleClick(d);
          updateEntitySelection(selectedNodeId, selectedLinkId, nodeLinkRef, d.id, "");
          removeParticles(showFlowingParticles, canvas, currentParticlesFlowId);
          onNodeClick(e, d, nodeLinkRef, edgeThicknessScale, oneHopFilteredEntitiesRef, showOneHopNodeVisuals);
        });
        shadowLink.on("click", (e, d) => {
          onLinkSingleClick(d);
          updateEntitySelection(selectedNodeId, selectedLinkId, nodeLinkRef, "", d.id);
          removeParticles(showFlowingParticles, canvas, currentParticlesFlowId);
          onLinkClick(
            e,
            d,
            nodeLinkRef,
            edgeThicknessScale,
            linkThicknessFactor,
            oneHopFilteredEntitiesRef,
            showOneHopNodeVisuals
          );
        });
        nodeLinkRef.current.nodeElem.current.on("dblclick", (e, d) => {
          onNodeDoubleClick(d);
          updateEntitySelection(selectedNodeId, selectedLinkId, nodeLinkRef, d.id, "");
          removeParticles(showFlowingParticles, canvas, currentParticlesFlowId);
          onNodeDblClick(e, d, nodeLinkRef, edgeThicknessScale, oneHopFilteredEntitiesRef, showOneHopNodeVisuals);
        });
        shadowLink.on("dblclick", (_, d) => {
          selectedNodeId.current = "";
          selectedLinkId.current = d.id;
          onLinkSingleClick(d);
        });
        nodeLinkRef.current.nodeElem.current.on("mouseover", (e, d) => {
          onNodeHover(
            e,
            d,
            nodeLinkRef.current.nodeElem.current,
            nodeLinkRef.current.link.current,
            hoverRef,
            showLabel,
            showFlowingParticles,
            showHoverMetricsCard,
            width.current,
            nodeToLinkDict,
            hoverCardRoot
          );
          if (showFlowingParticles) {
            currentParticlesFlowId.current = currentParticlesFlowId.current + 1;
            addBubblesOnLinks(
              d,
              currentParticlesFlowId.current,
              COMMON.EntityType.Node,
              currentTheme,
              nodeLinkRef.current.link.current,
              nodeToLinkDict,
              currentParticlesFlowId,
              width.current,
              minLinkART,
              maxLinkART,
              canvas
            );
          }
        });
        shadowLink.on("mouseover", (e, d) => {
          onLinkMouseout(
            nodeLinkRef,
            selectedNodeId.current,
            selectedLinkId.current,
            showFlowingParticles,
            showHoverMetricsCard,
            linkThicknessFactor,
            edgeThicknessScale,
            hoverCardRoot
          );
          onLinkHover(
            e,
            d,
            nodeLinkRef.current.nodeElem.current,
            nodeLinkRef.current.link.current,
            hoverRef,
            showLabel,
            showFlowingParticles,
            showHoverMetricsCard,
            width.current,
            hoverCardRoot
          );
          if (showFlowingParticles) {
            currentParticlesFlowId.current = currentParticlesFlowId.current + 1;
            addBubblesOnLinks(
              d,
              currentParticlesFlowId.current,
              COMMON.EntityType.Link,
              currentTheme,
              nodeLinkRef.current.link.current,
              nodeToLinkDict,
              currentParticlesFlowId,
              width.current,
              minLinkART,
              maxLinkART,
              canvas
            );
          }
        });
        nodeLinkRef.current.nodeElem.current.on("mouseout", (_, d) => {
          onNodeMouseout(
            d,
            nodeLinkRef,
            showFlowingParticles,
            showHoverMetricsCard,
            nodeToLinkDict,
            selectedNodeId.current,
            selectedLinkId.current,
            linkThicknessFactor,
            edgeThicknessScale,
            hoverCardRoot
          );
          if (showFlowingParticles) {
            canvas.current.selectAll(".flowing-circle").interrupt().remove();
            currentParticlesFlowId.current = currentParticlesFlowId.current + 1;
            onLinkMouseout(
              nodeLinkRef,
              selectedNodeId.current,
              selectedLinkId.current,
              showFlowingParticles,
              showHoverMetricsCard,
              linkThicknessFactor,
              edgeThicknessScale,
              hoverCardRoot
            );
            const connectedLinks = nodeToLinkDict[d.id];
            if (connectedLinks) {
              nodeLinkRef.current.link.current.filter((elem) => connectedLinks.includes(elem.id)).attr("marker-end", (d2) => `url(#${ARROW_MARKER_END_PREFIX}${d2.id})`);
            }
            updateSelectedLinkStyle(nodeLinkRef, selectedLinkId, linkThicknessFactor, edgeThicknessScale);
            updateHighlightedEntitiesAndTopLabelsProp(nodeLinkRef);
          }
        });
        shadowLink.on("mouseout", (_, d) => {
          onLinkMouseout(
            nodeLinkRef,
            selectedNodeId.current,
            selectedLinkId.current,
            showFlowingParticles,
            showHoverMetricsCard,
            linkThicknessFactor,
            edgeThicknessScale,
            hoverCardRoot
          );
          if (showFlowingParticles) {
            canvas.current.selectAll(".flowing-circle").interrupt().remove();
            currentParticlesFlowId.current = currentParticlesFlowId.current + 1;
            if (d.id !== selectedLinkId.current) {
              nodeLinkRef.current.link.current.filter((elem) => elem.source === d.source && elem.target === d.target).attr("marker-end", (d2) => `url(#${ARROW_MARKER_END_PREFIX}${d2.id})`);
            }
          }
          updateSelectedLinkStyle(nodeLinkRef, selectedLinkId, linkThicknessFactor, edgeThicknessScale);
          updateHighlightedEntitiesAndTopLabelsProp(nodeLinkRef);
        });
        forceGraphCanvas.current.on("highlight", () => {
          renderFinalGraphStyle(
            nodeLinkRef,
            edgeThicknessScale,
            oneHopFilteredEntitiesRef,
            showOneHopNodeVisuals,
            selectedNodeId,
            selectedLinkId,
            linkThicknessFactor,
            nodeIds,
            oneHopUpstreamNodesDict,
            oneHopDownstreamNodesDict,
            nodeToLinkDict,
            linksData
          );
        });
        if (nodePosition !== void 0 && rootNode !== void 0) {
          nodePosition(
            rootNode,
            nodeMap,
            rebalanceNodes,
            linkForce,
            nodeCollideForce,
            simulation,
            oneHopUpstreamNodesDict,
            oneHopDownstreamNodesDict,
            width.current,
            height2.current,
            fixedYPos
          );
          if (!isNLevels) {
            nodeLinkRef.current.nodeElem.current.filter((elem) => elem.id === rootNode.id).select("circle").style("outline", `${RING_THICKNESS2}px solid ${INTERACT_BORDER_MEDIUM2}`).style("outline-offset", `${RING_SPACING2}px`).style("border-radius", `${NODE_RADIUS2}px`);
            selectedNodeId.current = rootNode.id;
            selectedLinkId.current = "";
          }
        }
        simulation.on("tick", () => {
          nodeLinkRef.current.nodeElem.current.selectAll("circle").attr("cx", (d) => d.x).attr("cy", (d) => d.y);
          nodeLinkRef.current.nodeElem.current.selectAll(".label").attr("x", (d) => d.x).attr("y", (d) => d.y + 2 * NODE_RADIUS2 + LABEL_BUFFER);
          nodeLinkRef.current.nodeElem.current.selectAll(".secondaryLabel").attr("x", (d) => d.x).attr("y", (d) => d.y + 3 * NODE_RADIUS2 + LABEL_BUFFER);
          nodeLinkRef.current.nodeElem.current.selectAll(".topLabelBG").attr("x", (d) => d.x - TOP_LABEL_BG_X_OFFSET).attr(
            "y",
            (d) => isNLevels && rootNode?.id === d.id ? d.y - TOP_LABEL_BG_Y_OFFSET_FOR_ROOT * NODE_RADIUS2 + LABEL_BUFFER : d.y - TOP_LABEL_BG_Y_OFFSET * NODE_RADIUS2 + LABEL_BUFFER
          );
          nodeLinkRef.current.nodeElem.current.selectAll(".topLabel").attr("x", (d) => d.x).attr(
            "y",
            (d) => isNLevels && rootNode?.id === d.id ? d.y - TOP_LABEL_Y_OFFSET_FOR_ROOT * NODE_RADIUS2 + LABEL_BUFFER : d.y - TOP_LABEL_Y_OFFSET * NODE_RADIUS2 + LABEL_BUFFER
          );
          nodeLinkRef.current.nodeElem.current.selectAll(".startLabel").attr("x", (d) => d.x).attr("y", (d) => d.y - 2 * NODE_RADIUS2 + LABEL_BUFFER);
          nodeLinkRef.current.nodeElem.current.selectAll("g").select("svg").attr("x", (d) => d.x - ICON_WIDTH / 2).attr("y", (d) => d.y - ICON_HEIGHT / 2).attr("fill", CONTROL_ICON_IN);
          nodeLinkRef.current.link.current.attr("d", (d) => linkPosition(d, edgePaths, smoothEdges));
          shadowLink.attr("d", (d) => linkPosition(d, edgePaths, smoothEdges));
        });
        simulation.on("end", () => {
          if (initialPageLoad) {
            const graphPosProps = updateScaleFactorAndGraphCenterCoordinates(
              nodes,
              height2.current,
              width.current
            );
            scaleFactor.current = graphPosProps.scaleFactor;
            renderedGraphCenterX.current = graphPosProps.centerX;
            renderedGraphCenterY.current = graphPosProps.centerY;
            resetZoom(
              forceGraphCanvas.current,
              scaleFactor.current,
              renderedGraphCenterX.current,
              renderedGraphCenterY.current,
              d3zoom
            );
            renderFinalGraphStyle(
              nodeLinkRef,
              edgeThicknessScale,
              oneHopFilteredEntitiesRef,
              showOneHopNodeVisuals,
              selectedNodeId,
              selectedLinkId,
              linkThicknessFactor,
              nodeIds,
              oneHopUpstreamNodesDict,
              oneHopDownstreamNodesDict,
              nodeToLinkDict,
              linksData
            );
            initialPageLoad = false;
          }
        });
        window.addEventListener("resize", () => {
          width.current = containerRef.current.getBoundingClientRect().width;
          height2.current = containerRef.current.getBoundingClientRect().height;
          const graphPosProps = updateScaleFactorAndGraphCenterCoordinates(
            nodes,
            height2.current,
            width.current
          );
          scaleFactor.current = graphPosProps.scaleFactor;
          renderedGraphCenterX.current = graphPosProps.centerX;
          renderedGraphCenterY.current = graphPosProps.centerY;
          resetZoom(
            forceGraphCanvas.current,
            scaleFactor.current,
            renderedGraphCenterX.current,
            renderedGraphCenterY.current,
            d3zoom
          );
        });
      }
    }, [linksData, nodesData, configProps, smoothEdges, rebalanceNodes, truncateLabels]);
    (0, import_react65.useEffect)(() => {
      const circle = nodeLinkRef.current.nodeElem.current.select(".node").nodes()[0]?.getBoundingClientRect();
      nodeLinkRef.current.nodeElem.current?.select(".icon").attr("visibility", circle?.width > showIcon ? "visible" : "hidden");
      nodeLinkRef.current.nodeElem.current?.select(".label").attr("visibility", circle?.width > showLabel ? "visible" : "hidden");
    }, [zoomLevel]);
    return /* @__PURE__ */ (0, import_jsx_runtime459.jsxs)("div", { children: [
      /* @__PURE__ */ (0, import_jsx_runtime459.jsx)("div", { ref: containerRef, children: nodesData.length === 0 ? /* @__PURE__ */ (0, import_jsx_runtime459.jsxs)("div", { children: [
        /* @__PURE__ */ (0, import_jsx_runtime459.jsx)(import_uik547.Icon, { size: "SMALL", type: "Status.NoData" }),
        /* @__PURE__ */ (0, import_jsx_runtime459.jsx)("div", { children: MESSAGES7.NO_DATA() })
      ] }) : /* @__PURE__ */ (0, import_jsx_runtime459.jsxs)("div", { className: className2, children: [
        /* @__PURE__ */ (0, import_jsx_runtime459.jsx)("div", { className: (0, import_uik547.css)({ height: showGraphControls ? "95%" : "100%" }), id: `${graphName}Canvas` }),
        showGraphControls ? /* @__PURE__ */ (0, import_jsx_runtime459.jsxs)("div", { className: (0, import_uik547.css)({ height: "5%" }), children: [
          /* @__PURE__ */ (0, import_jsx_runtime459.jsxs)(
            "div",
            {
              className: (0, import_uik547.css)({
                alignItems: "center",
                display: "flex",
                flexDirection: "row",
                left: 10,
                position: "absolute"
              }),
              children: [
                allowRebalance && /* @__PURE__ */ (0, import_jsx_runtime459.jsxs)(import_jsx_runtime459.Fragment, { children: [
                  /* @__PURE__ */ (0, import_jsx_runtime459.jsx)(import_uik547.Checkbox, { checked: rebalanceNodes, onChange: updateRebalanceNodes }),
                  /* @__PURE__ */ (0, import_jsx_runtime459.jsx)(
                    "div",
                    {
                      className: (0, import_uik547.css)({
                        cursor: "pointer",
                        paddingRight: "10px"
                      }),
                      children: "Rebalance Nodes"
                    }
                  )
                ] }),
                allowSmooth && /* @__PURE__ */ (0, import_jsx_runtime459.jsxs)(import_jsx_runtime459.Fragment, { children: [
                  /* @__PURE__ */ (0, import_jsx_runtime459.jsx)(import_uik547.Checkbox, { checked: smoothEdges, onChange: updateSmoothEdges }),
                  /* @__PURE__ */ (0, import_jsx_runtime459.jsx)(
                    "div",
                    {
                      className: (0, import_uik547.css)({
                        cursor: "pointer",
                        paddingRight: "10px"
                      }),
                      children: "Smooth Edges"
                    }
                  )
                ] }),
                allowTruncate && /* @__PURE__ */ (0, import_jsx_runtime459.jsxs)(import_jsx_runtime459.Fragment, { children: [
                  /* @__PURE__ */ (0, import_jsx_runtime459.jsx)(import_uik547.Checkbox, { checked: truncateLabels, onChange: updateTruncateLabels }),
                  /* @__PURE__ */ (0, import_jsx_runtime459.jsx)(
                    "div",
                    {
                      className: (0, import_uik547.css)({
                        cursor: "pointer",
                        paddingRight: "10px"
                      }),
                      children: "Truncate Labels"
                    }
                  )
                ] })
              ]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime459.jsxs)(
            "div",
            {
              className: (0, import_uik547.css)({
                alignItems: "center",
                display: "flex",
                flexDirection: "row",
                position: "absolute",
                right: 0
              }),
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime459.jsx)(import_uik547.Tooltip, { value: "Zoom In", children: /* @__PURE__ */ (0, import_jsx_runtime459.jsx)(
                  import_uik547.Icon,
                  {
                    className: (0, import_uik547.css)({
                      cursor: "pointer",
                      paddingRight: "10px"
                    }),
                    fill: DEFAULT_TEXT10,
                    onClick: () => zoomIn(forceGraphCanvas.current, d3zoom),
                    type: "Action.Add"
                  }
                ) }),
                /* @__PURE__ */ (0, import_jsx_runtime459.jsx)(import_uik547.Tooltip, { value: "Zoom Out", children: /* @__PURE__ */ (0, import_jsx_runtime459.jsx)(
                  import_uik547.Icon,
                  {
                    className: (0, import_uik547.css)({
                      cursor: "pointer",
                      paddingRight: "10px"
                    }),
                    fill: DEFAULT_TEXT10,
                    onClick: () => zoomOut(forceGraphCanvas.current, d3zoom),
                    type: "Action.Minus"
                  }
                ) }),
                /* @__PURE__ */ (0, import_jsx_runtime459.jsx)(import_uik547.Tooltip, { value: "Move Left", children: /* @__PURE__ */ (0, import_jsx_runtime459.jsx)(
                  import_uik547.Icon,
                  {
                    className: (0, import_uik547.css)({
                      cursor: "pointer",
                      paddingRight: "10px"
                    }),
                    fill: DEFAULT_TEXT10,
                    onClick: () => moveLeft(forceGraphCanvas.current, d3zoom),
                    type: "Navigation.ArrowLeft"
                  }
                ) }),
                /* @__PURE__ */ (0, import_jsx_runtime459.jsx)(import_uik547.Tooltip, { value: "Move Right", children: /* @__PURE__ */ (0, import_jsx_runtime459.jsx)(
                  import_uik547.Icon,
                  {
                    className: (0, import_uik547.css)({
                      cursor: "pointer",
                      paddingRight: "10px"
                    }),
                    fill: DEFAULT_TEXT10,
                    onClick: () => moveRight(forceGraphCanvas.current, d3zoom),
                    type: "Navigation.ArrowRight"
                  }
                ) }),
                /* @__PURE__ */ (0, import_jsx_runtime459.jsx)(import_uik547.Tooltip, { value: "Move Up", children: /* @__PURE__ */ (0, import_jsx_runtime459.jsx)(
                  import_uik547.Icon,
                  {
                    className: (0, import_uik547.css)({
                      cursor: "pointer",
                      paddingRight: "10px"
                    }),
                    fill: DEFAULT_TEXT10,
                    onClick: () => moveUp(forceGraphCanvas.current, d3zoom),
                    type: "Navigation.ArrowUp"
                  }
                ) }),
                /* @__PURE__ */ (0, import_jsx_runtime459.jsx)(import_uik547.Tooltip, { value: "Move Down", children: /* @__PURE__ */ (0, import_jsx_runtime459.jsx)(
                  import_uik547.Icon,
                  {
                    className: (0, import_uik547.css)({
                      cursor: "pointer",
                      paddingRight: "10px"
                    }),
                    fill: DEFAULT_TEXT10,
                    onClick: () => moveDown(forceGraphCanvas.current, d3zoom),
                    type: "Navigation.ArrowDown"
                  }
                ) }),
                /* @__PURE__ */ (0, import_jsx_runtime459.jsx)(import_uik547.Tooltip, { value: "Reset", children: /* @__PURE__ */ (0, import_jsx_runtime459.jsx)(
                  import_uik547.Icon,
                  {
                    className: (0, import_uik547.css)({
                      cursor: "pointer",
                      paddingRight: "10px"
                    }),
                    fill: DEFAULT_TEXT10,
                    onClick: () => resetZoom(
                      forceGraphCanvas.current,
                      scaleFactor.current,
                      renderedGraphCenterX.current,
                      renderedGraphCenterY.current,
                      d3zoom
                    ),
                    type: "Action.Refresh"
                  }
                ) })
              ]
            }
          )
        ] }) : /* @__PURE__ */ (0, import_jsx_runtime459.jsx)("div", {})
      ] }) }),
      /* @__PURE__ */ (0, import_jsx_runtime459.jsx)("div", { id: "hoverRef", ref: hoverRef })
    ] });
  }, "ForceGraph")),
  arePropsEqual
);
var drag2 = /* @__PURE__ */ __name((simulation) => {
  function dragstarted(event, d) {
    if (!event.active) {
      simulation.alphaTarget(0.01).restart();
    }
    d.fx = d.x;
    d.fy = d.y;
  }
  __name(dragstarted, "dragstarted");
  function dragged(event, d) {
    d.fx = event.x;
    d.fy = event.y;
  }
  __name(dragged, "dragged");
  function dragended(event, d) {
    if (!event.active) {
      simulation.alphaTarget(0);
    }
    d.fx = event.x;
    d.fy = event.y;
  }
  __name(dragended, "dragended");
  return d32.drag().on("start", dragstarted).on("drag", dragged).on("end", dragended);
}, "drag");
var resetZoom = /* @__PURE__ */ __name((forceGraphCanvas, scaleFactor, renderedGraphCenterX, renderedGraphCenterY, d3zoom) => {
  if (renderedGraphCenterX && renderedGraphCenterY && scaleFactor) {
    forceGraphCanvas?.transition().duration(DEFAULT_ANIMATION_DURATION2).ease(d32.easeLinear).call(d3zoom.translateTo, renderedGraphCenterX, renderedGraphCenterY).transition().call(d3zoom.scaleTo, scaleFactor);
  }
}, "resetZoom");
var onNodeHover = /* @__PURE__ */ __name((e, d, nodeElem, link, hoverRef, showLabel, showFlowingParticles, showHoverMetricsCard, width, nodeToLinkDict, hoverCardRoot) => {
  nodeElem.selectAll("circle").style("filter", "");
  if (!showFlowingParticles) {
    nodeElem.filter((elem) => elem.id === d.id).select("circle").style("filter", `drop-shadow(0px 1px 1px ${DEFAULT_TEXT10})`);
    animateLinks(d, link, nodeToLinkDict);
  } else {
    nodeElem.filter((elem) => elem.id === d.id).select("circle").style("outline", `${RING_THICKNESS2}px solid ${INTERACT_BORDER_MEDIUM2}`).style("outline-offset", `${RING_SPACING2}px`).style("border-radius", `${NODE_RADIUS2}px`);
  }
  const circle = nodeElem.select(".node").nodes()[0].getBoundingClientRect();
  if (showHoverMetricsCard && circle.width > showLabel) {
    const secondaryLabel = getSecondaryLabel(d.secondaryLabel);
    const hoverPosition = {
      x: e.layerX - (secondaryLabel ? HOVER_CARD_X_OFFSET_N_LEVELS : HOVER_CARD_X_OFFSET),
      y: e.layerY - circle.width / 2 - (secondaryLabel ? HOVER_CARD_Y_OFFSET_N_LEVELS : HOVER_CARD_Y_OFFSET)
    };
    const entityAttributes = {
      health: d.status ?? UNKNOWN_HEALTH,
      metrics: getNormalizedMetrics(d.metrics),
      name: secondaryLabel ?? d.name ?? ""
    };
    if (window.navigator.userAgent.indexOf("Firefox") > -1) {
      hoverPosition.x = e.clientX - (secondaryLabel ? HOVER_CARD_X_OFFSET_N_LEVELS_FIREFOX : HOVER_CARD_X_OFFSET_FIREFOX);
      hoverPosition.y = e.clientY - (secondaryLabel ? HOVER_CARD_Y_OFFSET_N_LEVELS_FIREFOX : HOVER_CARD_Y_OFFSET_FIREFOX);
    }
    hoverPosition.x = hoverPosition.x < 0 ? HOVER_CARD_X_LEFT_BORDER_ADJUSTMENT : hoverPosition.x + HOVER_CARD_WIDTH > width ? width - HOVER_CARD_X_RIGHT_BORDER_ADJUSTMENT : hoverPosition.x;
    hoverPosition.y = hoverPosition.y < 0 ? hoverPosition.y + HOVER_CARD_Y_TOP_BORDER_ADJUSTMENT : hoverPosition.y;
    if (hoverRef?.current) {
      hoverCardRoot.current = (0, import_client.createRoot)(hoverRef?.current);
      hoverCardRoot.current.render(
        /* @__PURE__ */ (0, import_jsx_runtime459.jsx)(
          MetricsHoverCard_default,
          {
            entityAttributes,
            height: HOVER_CARD_HEIGHT,
            pos: hoverPosition,
            type: "node",
            width: HOVER_CARD_WIDTH
          }
        )
      );
    }
  }
}, "onNodeHover");
var animateLinks = /* @__PURE__ */ __name((d, link, nodeToLinkDict) => {
  const connectedLinks = nodeToLinkDict[d.id];
  if (connectedLinks) {
    link.filter((elem) => connectedLinks.includes(elem.id)).interrupt();
    const linksToUpdate = link.filter((elem) => connectedLinks.includes(elem.id)).raise();
    addAnimationToLinks(linksToUpdate);
  }
}, "animateLinks");
var onNodeMouseout = /* @__PURE__ */ __name((d, nodeLinkRef, showFlowingParticles, showHoverMetricsCard, nodeToLinkDict, selectedNodeId, selectedLinkId, linkThicknessFactor, edgeThicknessScale, hoverCardRoot) => {
  if (showHoverMetricsCard && hoverCardRoot.current) {
    hoverCardRoot.current.unmount();
  }
  if (!showFlowingParticles) {
    nodeLinkRef.current.nodeElem.current.selectAll("circle").style("filter", "");
    const connectedLinks = nodeToLinkDict[d.id];
    if (connectedLinks) {
      const linksToUpdate = nodeLinkRef.current.link.current.filter((elem) => connectedLinks.includes(elem.id));
      removeAnimationToLinks(
        nodeLinkRef.current.link.current,
        linksToUpdate,
        selectedLinkId,
        linkThicknessFactor,
        edgeThicknessScale
      );
    }
  } else {
    nodeLinkRef.current.nodeElem.current.filter((node) => node.id !== selectedNodeId).select("circle").style("filter", "").style("outline", "").style("outline-offset", "");
    nodeLinkRef.current.nodeElem.current.filter((node) => node.id === selectedNodeId).select("circle").style("outline", `${RING_THICKNESS2}px solid ${INTERACT_BORDER_MEDIUM2}`).style("outline-offset", `${RING_SPACING2}px`).style("border-radius", `${NODE_RADIUS2}px`);
  }
  updateHighlightedEntitiesAndTopLabelsProp(nodeLinkRef);
}, "onNodeMouseout");
var removeAnimationToLinks = /* @__PURE__ */ __name((link, linksToUpdate, selectedLinkId, linkThicknessFactor, edgeThicknessScale) => {
  linksToUpdate.interrupt().lower().attr("marker-end", (d) => `url(#${ARROW_MARKER_END_PREFIX}${d.id})`).attr("stroke-dasharray", "").attr("stroke", CONTROL_BORDER10).attr("cursor", "pointer");
  if (selectedLinkId) {
    link.filter((elem) => elem.id === selectedLinkId).raise().attr("stroke", CONTROL_BORDER_HOVER3).attr("stroke-width", (d) => linkThicknessFactor * Math.round(edgeThicknessScale(d.weight ?? DEFAULT_WEIGHT2))).attr("cursor", "pointer").attr("marker-end", (d) => `url(#${ARROW_HOVER_MARKER_END_PREFIX2}${d.id})`);
  }
}, "removeAnimationToLinks");
var onLinkHover = /* @__PURE__ */ __name((e, d, nodeElem, link, hoverRef, showLabel, showFlowingParticles, showHoverMetricsCard, width, hoverCardRoot) => {
  const hoverLink = d;
  if (!showFlowingParticles) {
    const linksToUpdate = link.filter((elem) => elem.source === d.source && elem.target === d.target).raise();
    addAnimationToLinks(linksToUpdate);
  } else {
    const highlightNode = /* @__PURE__ */ __name((nodeId) => {
      nodeElem.filter((elem) => elem.id === nodeId).select("circle").style("outline", `${RING_THICKNESS2}px solid ${INTERACT_BORDER_MEDIUM2}`).style("outline-offset", `${RING_SPACING2}px`).style("border-radius", `${NODE_RADIUS2}px`);
    }, "highlightNode");
    highlightNode(hoverLink.source.id);
    highlightNode(hoverLink.target.id);
  }
  const circle = nodeElem.select(".node").nodes()[0].getBoundingClientRect();
  if (showHoverMetricsCard && circle.width > showLabel) {
    const fromSecondaryLabel = getSecondaryLabel(hoverLink.source?.secondaryLabel);
    const toSecondaryLabel = getSecondaryLabel(hoverLink.target?.secondaryLabel);
    const secondaryLabel = fromSecondaryLabel || toSecondaryLabel;
    const hoverPosition = {
      x: e.layerX - (secondaryLabel ? HOVER_CARD_X_OFFSET_N_LEVELS : HOVER_CARD_X_OFFSET),
      y: e.layerY - (secondaryLabel ? HOVER_CARD_Y_OFFSET_N_LEVELS : HOVER_CARD_Y_OFFSET)
    };
    const entityAttributes = {
      fromNode: {
        health: hoverLink.source?.status ?? UNKNOWN_HEALTH,
        name: fromSecondaryLabel ?? hoverLink.source?.name ?? ""
      },
      metrics: getNormalizedMetrics(d.metrics),
      toNode: {
        health: hoverLink.target?.status ?? UNKNOWN_HEALTH,
        name: toSecondaryLabel ?? hoverLink.target?.name ?? ""
      }
    };
    hoverPosition.x = hoverPosition.x < 0 ? HOVER_CARD_X_LEFT_BORDER_ADJUSTMENT : hoverPosition.x + HOVER_CARD_WIDTH > width ? width - HOVER_CARD_X_RIGHT_BORDER_ADJUSTMENT : hoverPosition.x;
    hoverPosition.y = hoverPosition.y < 0 ? hoverPosition.y + HOVER_CARD_Y_TOP_BORDER_ADJUSTMENT : hoverPosition.y;
    if (hoverRef?.current) {
      hoverCardRoot.current = (0, import_client.createRoot)(hoverRef?.current);
      hoverCardRoot.current.render(
        /* @__PURE__ */ (0, import_jsx_runtime459.jsx)(
          MetricsHoverCard_default,
          {
            entityAttributes,
            height: HOVER_CARD_HEIGHT,
            pos: hoverPosition,
            type: "edge",
            width: HOVER_CARD_WIDTH
          }
        )
      );
    }
  }
}, "onLinkHover");
var onLinkMouseout = /* @__PURE__ */ __name((nodeLinkRef, selectedNodeId, selectedLinkId, showFlowingParticles, showHoverMetricsCard, linkThicknessFactor, edgeThicknessScale, hoverCardRoot) => {
  if (!showFlowingParticles) {
    removeAnimationToLinks(
      nodeLinkRef.current.link.current,
      nodeLinkRef.current.link.current,
      selectedLinkId,
      linkThicknessFactor,
      edgeThicknessScale
    );
  } else {
    nodeLinkRef.current.link.current.filter((entity) => entity.id !== selectedLinkId).attr("stroke", CONTROL_BORDER10).style("mix-blend-mode", "normal").attr("stroke-width", (d) => Math.round(edgeThicknessScale(d.weight ?? DEFAULT_WEIGHT2)));
    nodeLinkRef.current.nodeElem.current.filter((node) => node.id !== selectedNodeId).selectAll("circle").style("filter", "").style("outline", "").style("outline-offset", "");
    nodeLinkRef.current.nodeElem.current.filter((node) => node.id === selectedNodeId).select("circle").style("outline", `${RING_THICKNESS2}px solid ${INTERACT_BORDER_MEDIUM2}`).style("outline-offset", `${RING_SPACING2}px`).style("border-radius", `${NODE_RADIUS2}px`);
  }
  updateHighlightedEntitiesAndTopLabelsProp(nodeLinkRef);
  if (showHoverMetricsCard && hoverCardRoot.current) {
    hoverCardRoot.current.unmount();
  }
}, "onLinkMouseout");
var addBubblesOnLinks = /* @__PURE__ */ __name((d, id, entityType, currentTheme, link, nodeToLinkDict, currentParticlesFlowId, width, minLinkART, maxLinkART, canvas) => {
  const connectedLinks = nodeToLinkDict[d.id];
  let linksToUpdate;
  if (connectedLinks && entityType === COMMON.EntityType.Node) {
    linksToUpdate = link.filter((elem) => connectedLinks.includes(elem.id)).raise();
  } else {
    linksToUpdate = link.filter((elem) => elem.source === d.source && elem.target === d.target).raise();
  }
  linksToUpdate.style("mix-blend-mode", currentTheme === "light" ? "multiply" : "screen").attr("stroke", INFO_ICON_WEAK).attr("stroke-width", EDGE_STROKE_WIDTH_WITH_PARTICLES).attr("marker-end", (d2) => `url(#${ARROW_HOVER_MARKER_END_PREFIX2}${d2.id})`);
  const svgLinks = linksToUpdate.nodes();
  for (const svgLink of svgLinks) {
    const totalLength = svgLink.getTotalLength();
    const edgeData = d32.select(svgLink).datum();
    const linkARTValue = Number(edgeData.metrics ? edgeData.metrics[0]?.value ?? 0 : 0);
    const createCircle = /* @__PURE__ */ __name(() => {
      if (id !== currentParticlesFlowId.current) {
        return;
      }
      const flowingCircle = canvas.current.append("circle").attr("r", PARTICLE_RADIUS).attr("fill", currentTheme === "light" ? INTERACT_TEXT3 : INVERSE_ICON).attr("class", "flowing-circle").lower();
      const responseTimeScale = d32.scaleLinear().domain([minLinkART, maxLinkART]).range([PARTICLE_FLOW_MIN_SPEED, PARTICLE_FLOW_MAX_SPEED]);
      const transitionDuration = totalLength / width * responseTimeScale(linkARTValue);
      flowingCircle.transition().duration(transitionDuration).ease(d32.easeLinear).attrTween(
        "transform",
        () => function(t) {
          const point = svgLink.getPointAtLength(t * (totalLength || 1)) ?? {
            x: 1,
            y: 1
          };
          return `translate(${point.x},${point.y})`;
        }
      ).remove();
      setTimeout(createCircle, PARTICLE_CREATION_SPEED);
    }, "createCircle");
    if (linkARTValue > 0) {
      createCircle();
    }
  }
}, "addBubblesOnLinks");
var getOneHopFilteredEntities = /* @__PURE__ */ __name((linksData, filteredNodesRef) => {
  if (filteredNodesRef.current) {
    const edgesConnectingFilteredNodes = [];
    linksData.forEach((link) => {
      if (filteredNodesRef.current.includes(link.source) && filteredNodesRef.current.includes(link.target)) {
        edgesConnectingFilteredNodes.push(link.id);
      }
    });
    return {
      edges: edgesConnectingFilteredNodes,
      nodes: filteredNodesRef.current
    };
  }
  return {
    edges: [],
    nodes: []
  };
}, "getOneHopFilteredEntities");
var updateHighlightedEntitiesAndTopLabelsProp = /* @__PURE__ */ __name((nodeLinkRef) => {
  nodeLinkRef.current.nodeElem.current.filter((elem) => nodeLinkRef.current.highlightedEntities.current.nodes.includes(elem.id)).raise().select("circle").style("outline", `${RING_THICKNESS2}px solid ${NEGATIVE_BORDER3}`).style("outline-offset", `${RING_SPACING2}px`).style("border-radius", `${NODE_RADIUS2}px`);
  nodeLinkRef.current.link.current.filter((elem) => nodeLinkRef.current.highlightedEntities.current.edges.includes(elem.id)).raise().attr("marker-end", (d) => `url(#${ARROW_ERROR_MARKER_END_PREFIX}${d.id})`).attr("stroke", NEGATIVE_BORDER3).attr("cursor", "pointer");
  nodeLinkRef.current.topLabels.current.forEach((topLabel) => {
    const elemToUpdate = nodeLinkRef.current.nodeElem.current.filter((elem) => elem.id === topLabel.nodeId);
    elemToUpdate.selectAll(".topLabelBG").attr("visibility", "visible");
    elemToUpdate.selectAll(".topLabel").attr("visibility", "visible").text(truncateStr(topLabel.nodeLabel, TOP_LABEL_TRUNCATE_LENGTH));
  });
}, "updateHighlightedEntitiesAndTopLabelsProp");
var updateSelectedLinkStyle = /* @__PURE__ */ __name((nodeLinkRef, selectedLinkId, linkThicknessFactor, edgeThicknessScale) => {
  nodeLinkRef.current.link.current.filter((elem) => elem.id === selectedLinkId.current).raise().attr("stroke", CONTROL_BORDER_HOVER3).attr("stroke-width", (d) => linkThicknessFactor * Math.round(edgeThicknessScale(d.weight ?? DEFAULT_WEIGHT2))).attr("cursor", "pointer").attr("marker-end", (d) => `url(#${ARROW_HOVER_MARKER_END_PREFIX2}${d.id})`);
}, "updateSelectedLinkStyle");
var updateSelectedNodeStyle = /* @__PURE__ */ __name((nodeLinkRef, selectedNodeId) => {
  nodeLinkRef.current.nodeElem.current.filter((node) => node.id !== selectedNodeId.current).select("circle").style("filter", "").style("outline", "").style("outline-offset", "");
  nodeLinkRef.current.nodeElem.current.filter((node) => node.id === selectedNodeId.current).select("circle").style("outline", `${RING_THICKNESS2}px solid ${INTERACT_BORDER_MEDIUM2}`).style("outline-offset", `${RING_SPACING2}px`).style("border-radius", `${NODE_RADIUS2}px`);
}, "updateSelectedNodeStyle");
var updateFilteredNodes = /* @__PURE__ */ __name((showOneHopNodeVisuals, nodeLinkRef, oneHopFilteredEntitiesRef) => {
  if (showOneHopNodeVisuals) {
    nodeLinkRef.current.nodeElem.current.attr("opacity", LOW_OPACITY2).filter((elem) => oneHopFilteredEntitiesRef.current.nodes.includes(elem.id)).attr("opacity", DEFAULT_OPACITY2).attr("cursor", "pointer");
    nodeLinkRef.current.link.current.attr("opacity", LOW_OPACITY2).filter((elem) => oneHopFilteredEntitiesRef.current.edges.includes(elem.id)).attr("opacity", DEFAULT_OPACITY2).attr("cursor", "pointer");
  } else {
    nodeLinkRef.current.link.current.attr("opacity", DEFAULT_OPACITY2).attr("cursor", "pointer");
    nodeLinkRef.current.nodeElem.current.attr("opacity", DEFAULT_OPACITY2).attr("cursor", "pointer");
  }
}, "updateFilteredNodes");
var updateFocusedEntityVisuals = /* @__PURE__ */ __name((showOneHopNodeVisuals, nodeLinkRef, nodeIds, oneHopUpstreamNodesDict, oneHopDownstreamNodesDict, nodeToLinkDict, linksData, edgeThicknessScale, linkThicknessFactor, oneHopFilteredEntitiesRef) => {
  updateFilteredNodes(showOneHopNodeVisuals, nodeLinkRef, oneHopFilteredEntitiesRef);
  let oneHopEdges = [];
  let oneHopNodes = [];
  let updateGraph = false;
  const node = nodeLinkRef.current.entityId.current;
  const edge = nodeLinkRef.current.interactionId.current;
  const focusedNodes = nodeLinkRef.current.focusedNodes.current;
  const highlightNodes = focusedNodes?.length > 0 ? focusedNodes : [node];
  if (highlightNodes?.length > 0) {
    highlightNodes.forEach((node2) => {
      if (nodeIds.includes(node2)) {
        oneHopNodes.push(node2);
        if (showOneHopNodeVisuals) {
          oneHopNodes.push(...oneHopUpstreamNodesDict[node2] || []);
          oneHopNodes.push(...oneHopDownstreamNodesDict[node2] || []);
          const connectedEdges = nodeToLinkDict[node2];
          if (connectedEdges) {
            oneHopEdges.push(...connectedEdges);
          }
        }
        updateGraph = true;
      }
    });
    if (oneHopNodes?.length > 0) {
      linksData.forEach((link) => {
        if (oneHopNodes.includes(link.source) && oneHopNodes.includes(link.target)) {
          oneHopEdges.push(link.id);
        }
      });
    }
  }
  if (edge) {
    oneHopEdges.push(edge);
    if (showOneHopNodeVisuals) {
      linksData.forEach((link) => {
        if (link.id === edge) {
          oneHopNodes.push(link.source);
          oneHopNodes.push(link.target);
        }
      });
    }
    updateGraph = true;
  }
  if (updateGraph) {
    if (showOneHopNodeVisuals || focusedNodes?.length > 0) {
      nodeLinkRef.current.nodeElem.current.attr("opacity", LOW_OPACITY2).filter((elem) => oneHopNodes.includes(elem.id)).attr("opacity", DEFAULT_OPACITY2);
      nodeLinkRef.current.link.current.attr("opacity", LOW_OPACITY2).filter((elem) => oneHopEdges?.includes(elem.id)).attr("opacity", DEFAULT_OPACITY2);
    }
    nodeLinkRef.current.nodeElem.current.filter((elem) => elem.id === node).select("circle").style("outline", `${RING_THICKNESS2}px solid ${INTERACT_BORDER_MEDIUM2}`).style("outline-offset", `${RING_SPACING2}px`).style("border-radius", `${NODE_RADIUS2}px`);
    nodeLinkRef.current.link.current.filter((elem) => elem.id === edge).attr("marker-end", (d) => `url(#${ARROW_HOVER_MARKER_END_PREFIX2}${d.id})`).attr("stroke", CONTROL_BORDER_HOVER3).attr("stroke-width", (d) => linkThicknessFactor * Math.round(edgeThicknessScale(d.weight ?? DEFAULT_WEIGHT2))).attr("cursor", "pointer").raise();
  }
}, "updateFocusedEntityVisuals");
var renderFinalGraphStyle = /* @__PURE__ */ __name((nodeLinkRef, edgeThicknessScale, oneHopFilteredEntitiesRef, showOneHopNodeVisuals, selectedNodeId, selectedLinkId, linkThicknessFactor, nodeIds, oneHopUpstreamNodesDict, oneHopDownstreamNodesDict, nodeToLinkDict, linksData) => {
  clearEntitySelection(nodeLinkRef, edgeThicknessScale, oneHopFilteredEntitiesRef, showOneHopNodeVisuals);
  updateSelectedNodeStyle(nodeLinkRef, selectedNodeId);
  updateSelectedLinkStyle(nodeLinkRef, selectedLinkId, linkThicknessFactor, edgeThicknessScale);
  updateHighlightedEntitiesAndTopLabelsProp(nodeLinkRef);
  updateFocusedEntityVisuals(
    showOneHopNodeVisuals,
    nodeLinkRef,
    nodeIds,
    oneHopUpstreamNodesDict,
    oneHopDownstreamNodesDict,
    nodeToLinkDict,
    linksData,
    edgeThicknessScale,
    linkThicknessFactor,
    oneHopFilteredEntitiesRef
  );
}, "renderFinalGraphStyle");
function removeParticles(showFlowingParticles, canvas, currentParticlesFlowId) {
  if (showFlowingParticles) {
    canvas.current.selectAll(".flowing-circle").interrupt().remove();
    currentParticlesFlowId.current = currentParticlesFlowId.current + 1;
  }
}
__name(removeParticles, "removeParticles");
function updateEntitySelection(selectedNodeId, selectedLinkId, nodeLinkRef, nodeId, linkId) {
  selectedNodeId.current = nodeId;
  selectedLinkId.current = linkId;
  nodeLinkRef.current.highlightedEntities.current = {
    edges: [],
    nodes: []
  };
}
__name(updateEntitySelection, "updateEntitySelection");

// FlowMap/Constellation.tsx
var import_jsx_runtime460 = require("react/jsx-runtime");
var {
  ARROW_MARKER_END_PREFIX: ARROW_MARKER_END_PREFIX2,
  DEFAULT_LINK_THICKNESS_FACTOR: DEFAULT_LINK_THICKNESS_FACTOR2,
  EDGE_NODE_BUFFER,
  NODE_RADIUS: NODE_RADIUS3,
  TRANSPARENT: TRANSPARENT2,
  defaultGraphLabels,
  defaultHighlightedEntities
} = CONSTANTS2;
var {
  COLORS: { CONTROL_BORDER: CONTROL_BORDER11 }
} = import_uik548.MAGNETIC_TOKENS;
var Constellation = import_uik548.utils.forwardRef(
  ({
    className: className2,
    configProps,
    entityId,
    eventActions,
    filteredNodes,
    focusedNodes,
    interactionId,
    linksData,
    nodesData
  }, _forwardedRef) => {
    configProps = {
      ...configProps,
      ...{
        allowRebalance: false,
        allowSmooth: false,
        allowTruncate: true,
        rootNodeEdgesOnly: false,
        showIcon: 10,
        showLabel: 15
      }
    };
    const highlightedEntitiesRef = (0, import_react66.useRef)(defaultHighlightedEntities);
    const graphLabelsRef = (0, import_react66.useRef)(defaultGraphLabels);
    const focusedNodesRef = (0, import_react66.useRef)([]);
    const entityIdRef = (0, import_react66.useRef)("");
    const interactionIdRef = (0, import_react66.useRef)("");
    const hostRef = (0, import_react66.useRef)(null);
    entityIdRef.current = entityId ?? "";
    interactionIdRef.current = interactionId ?? "";
    focusedNodesRef.current = focusedNodes ?? [];
    const links = [];
    const nodes = [];
    const graphNodes = d33.select(hostRef.current).select(`#canvas`).append("svg").attr("id", "nodes").style("overflow", "visible").selectAll("g").data(nodes);
    const nodeElem = (0, import_react66.useRef)(
      graphNodes?.join(
        (enter) => enter.append("g").attr("id", (elem) => elem.id).attr("opacity", TRANSPARENT2),
        (update) => update,
        (exit) => exit.remove()
      )
    );
    const graphLinks = d33.select(hostRef.current).select(`#canvas`).append("svg").attr("id", "links").style("overflow", "visible").selectAll("path").data(links);
    const link = (0, import_react66.useRef)(
      graphLinks?.join(
        (enter) => enter.append("path").attr("id", (d) => `${d.id}`).attr("opacity", TRANSPARENT2).attr("stroke", CONTROL_BORDER11).attr("fill", "none").attr("stroke-width", DEFAULT_LINK_THICKNESS_FACTOR2).attr("marker-end", (d) => `url(#${ARROW_MARKER_END_PREFIX2}${d.id})`),
        (update) => update,
        (exit) => exit.remove()
      )
    );
    const nodeLinkRef = (0, import_react66.useRef)({
      entityId: entityIdRef,
      focusedNodes: focusedNodesRef,
      highlightedEntities: highlightedEntitiesRef,
      interactionId: interactionIdRef,
      link,
      nodeElem,
      topLabels: graphLabelsRef
    });
    (0, import_react66.useEffect)(() => {
      const graphCanvas = d33.select(`#${configProps.graphName}Canvas`);
      graphCanvas.dispatch("highlight");
    }, [filteredNodes, focusedNodes, entityId, interactionId]);
    if (nodesData && linksData) {
      return /* @__PURE__ */ (0, import_jsx_runtime460.jsx)("div", { ref: hostRef, children: /* @__PURE__ */ (0, import_jsx_runtime460.jsx)(
        ForceGraph,
        {
          className: className2,
          configProps,
          eventActions,
          filteredNodes,
          linkPosition: linkPos,
          linksData,
          nodesData,
          ref: nodeLinkRef
        }
      ) });
    }
    return /* @__PURE__ */ (0, import_jsx_runtime460.jsx)("div", { children: MESSAGES7.NO_DATA() });
  }
);
var linkPos = /* @__PURE__ */ __name((d, edgePaths) => {
  if (d.source.x === d.target.x && d.source.y === d.target.y) {
    const r = Math.hypot(NODE_RADIUS3, NODE_RADIUS3);
    return `
        M${d.source.x + NODE_RADIUS3 + EDGE_NODE_BUFFER},${d.source.y}
        A${r},${r} 0 1,0 ${d.target.x},${d.target.y - NODE_RADIUS3 - EDGE_NODE_BUFFER}
      `;
  }
  const isBidirectionalEdge = edgePaths.includes(`${d.target.id}-${d.source.id}`);
  const adjBuffer = NODE_RADIUS3 + EDGE_NODE_BUFFER;
  const xDiff = Math.abs(d.source.x - d.target.x);
  const yDiff = Math.abs(d.source.y - d.target.y);
  let xAdjustment = adjBuffer;
  let yAdjustment = adjBuffer;
  if (xDiff >= yDiff) {
    yAdjustment = adjBuffer * yDiff / xDiff;
  } else {
    xAdjustment = adjBuffer * xDiff / yDiff;
  }
  const fromX = d.source.x > 0 ? d.source.x < d.target.x ? d.source.x + xAdjustment : d.source.x - xAdjustment : d.source.x < d.target.x ? d.source.x + xAdjustment : d.source.x - xAdjustment;
  const fromY = d.source.y > 0 ? d.source.y < d.target.y ? d.source.y + yAdjustment : d.source.y - yAdjustment : d.source.y < d.target.y ? d.source.y + yAdjustment : d.source.y - yAdjustment;
  const toX = d.target.x > 0 ? d.target.x < d.source.x ? d.target.x + xAdjustment : d.target.x - xAdjustment : d.target.x < d.source.x ? d.target.x + xAdjustment : d.target.x - xAdjustment;
  const toY = d.target.y > 0 ? d.target.y < d.source.y ? d.target.y + yAdjustment : d.target.y - yAdjustment : d.target.y < d.source.y ? d.target.y + yAdjustment : d.target.y - yAdjustment;
  if (isBidirectionalEdge) {
    const r = Math.hypot(toX - fromX, toY - fromY);
    return `
        M${fromX},${fromY}
        A${r},${r} 0 0,1 ${toX},${toY}
      `;
  }
  return `
              M 
                ${fromX} ${fromY} 
              L
                ${toX} ${toY}
            `;
}, "linkPos");
Constellation.displayName = "FlowMap.Constellation";
Constellation.__DEV_METADATA__ = { status: "READY" };

// FlowMap/Dependency.tsx
var import_uik549 = require("@appd/uik");
var d34 = __toESM(require("d3"));
var import_react67 = require("react");
var import_jsx_runtime461 = require("react/jsx-runtime");
var {
  ARROW_MARKER_END_PREFIX: ARROW_MARKER_END_PREFIX3,
  DEFAULT_LINK_THICKNESS_FACTOR: DEFAULT_LINK_THICKNESS_FACTOR3,
  EDGE_NODE_BUFFER: EDGE_NODE_BUFFER2,
  MAX_NODES,
  NODE_RADIUS: NODE_RADIUS4,
  TRANSPARENT: TRANSPARENT3,
  defaultGraphLabels: defaultGraphLabels2,
  defaultHighlightedEntities: defaultHighlightedEntities2
} = CONSTANTS2;
var {
  COLORS: { CONTROL_BORDER: CONTROL_BORDER12 }
} = import_uik549.MAGNETIC_TOKENS;
var Dependency = import_uik549.utils.forwardRef(
  ({
    className: className2,
    configProps,
    entityId,
    eventActions,
    focusedNodes,
    highlightedEdges,
    highlightedNodes,
    interactionId,
    linksData,
    nodesData,
    rootNode,
    topLabels
  }, _forwardedRef) => {
    const highlightedEntitiesRef = (0, import_react67.useRef)(defaultHighlightedEntities2);
    const graphLabelsRef = (0, import_react67.useRef)(defaultGraphLabels2);
    const focusedNodesRef = (0, import_react67.useRef)([]);
    const entityIdRef = (0, import_react67.useRef)("");
    const interactionIdRef = (0, import_react67.useRef)("");
    const hostRef = (0, import_react67.useRef)(null);
    entityIdRef.current = entityId ?? "";
    interactionIdRef.current = interactionId ?? "";
    focusedNodesRef.current = focusedNodes ?? [];
    const highlightedEntities = {
      edges: highlightedEdges ?? [],
      nodes: highlightedNodes ?? []
    };
    highlightedEntitiesRef.current = highlightedEntities;
    if (topLabels) {
      try {
        graphLabelsRef.current = JSON.parse(decodeURI(topLabels));
      } catch (error) {
        console.error("Error with topLabels ", topLabels, error);
        graphLabelsRef.current = defaultGraphLabels2;
      }
    } else {
      graphLabelsRef.current = defaultGraphLabels2;
    }
    const links = [];
    const nodes = [];
    const graphNodes = d34.select(hostRef.current).select(`#canvas`).append("svg").attr("id", "nodes").style("overflow", "visible").selectAll("g").data(nodes);
    const nodeElem = (0, import_react67.useRef)(
      graphNodes?.join(
        (enter) => enter.append("g").attr("id", (elem) => elem.id).attr("opacity", TRANSPARENT3),
        (update) => update,
        (exit) => exit.remove()
      )
    );
    const graphLinks = d34.select(hostRef.current).select(`#canvas`).append("svg").attr("id", "links").style("overflow", "visible").selectAll("path").data(links);
    const link = (0, import_react67.useRef)(
      graphLinks?.join(
        (enter) => enter.append("path").attr("id", (d) => `${d.id}`).attr("opacity", TRANSPARENT3).attr("stroke", CONTROL_BORDER12).attr("fill", "none").attr("stroke-width", DEFAULT_LINK_THICKNESS_FACTOR3).attr("marker-end", (d) => `url(#${ARROW_MARKER_END_PREFIX3}${d.id})`),
        (update) => update,
        (exit) => exit.remove()
      )
    );
    const nodeLinkRef = (0, import_react67.useRef)({
      entityId: entityIdRef,
      focusedNodes: focusedNodesRef,
      highlightedEntities: highlightedEntitiesRef,
      interactionId: interactionIdRef,
      link,
      nodeElem,
      topLabels: graphLabelsRef
    });
    (0, import_react67.useEffect)(() => {
      const graphCanvas = d34.select(`#${configProps.graphName}Canvas`);
      graphCanvas.dispatch("highlight");
    }, [focusedNodes, entityId, interactionId, highlightedNodes, highlightedEdges, topLabels]);
    if (nodesData && linksData && rootNode) {
      return /* @__PURE__ */ (0, import_jsx_runtime461.jsx)("div", { ref: hostRef, children: /* @__PURE__ */ (0, import_jsx_runtime461.jsx)(
        ForceGraph,
        {
          className: className2,
          configProps,
          eventActions,
          linkPosition: linkPos2,
          linksData,
          nodePosition: positionNodes,
          nodesData,
          ref: nodeLinkRef,
          rootNode
        }
      ) });
    }
    return /* @__PURE__ */ (0, import_jsx_runtime461.jsx)("div", { children: MESSAGES7.NO_DATA() });
  }
);
var linkPos2 = /* @__PURE__ */ __name((d, edgePaths, smoothEdges) => {
  if (d.source.x === d.target.x && d.source.y === d.target.y) {
    const r = Math.hypot(NODE_RADIUS4, NODE_RADIUS4);
    return `
          M${d.source.x + NODE_RADIUS4 + EDGE_NODE_BUFFER2},${d.source.y}
          A${r},${r} 0 1,0 ${d.target.x},${d.target.y - NODE_RADIUS4 - EDGE_NODE_BUFFER2}
        `;
  }
  const isBidirectionalEdge = edgePaths.includes(`${d.target.id}-${d.source.id}`);
  const factor = isBidirectionalEdge ? 2.2 : 2;
  const isHorizontalOverlap = isBidirectionalEdge && Math.abs(d.source.y - d.target.y) < 4 * NODE_RADIUS4;
  const isVerticalEdge = Math.abs(d.source.x - d.target.x) < 6 * NODE_RADIUS4;
  const adjBuffer = NODE_RADIUS4 + EDGE_NODE_BUFFER2;
  const fromX = isVerticalEdge ? d.source.x : d.source.x < d.target.x ? d.source.x + adjBuffer : d.source.x - adjBuffer;
  const fromY = isVerticalEdge ? d.source.y < d.target.y ? d.source.y + adjBuffer : d.source.y - adjBuffer : d.source.y;
  const toX = isVerticalEdge ? d.target.x : d.target.x > d.source.x ? d.target.x - adjBuffer : d.target.x + adjBuffer;
  const toY = isVerticalEdge ? d.target.y > d.source.y ? d.target.y - adjBuffer : d.target.y + adjBuffer : d.target.y;
  if (isHorizontalOverlap || isVerticalEdge) {
    const r = Math.hypot(toX - fromX, toY - fromY);
    return `
          M${fromX},${fromY}
          A${r},${r} 0 0,1 ${toX},${toY}
        `;
  }
  const edgeStyle = smoothEdges ? "C" : "L";
  return `
                M 
                  ${fromX} ${fromY} 
                ${edgeStyle} 
                  ${(fromX + toX) / factor} ${fromY} 
                  ${(fromX + toX) / factor} ${toY} 
                  ${toX} ${toY}
              `;
}, "linkPos");
var positionNodes = /* @__PURE__ */ __name((rootNode, nodeMap, rebalanceNodes, linkForce, nodeCollideForce, simulation, oneHopUpstreamNodesDict, oneHopDownstreamNodesDict, width, height2, fixedYPos) => {
  let nodesToVisit = [];
  let visitedNodes = [];
  let nodesInSection = /* @__PURE__ */ new Map();
  let nodeToSectionMap = /* @__PURE__ */ new Map();
  let sectionNumber = 0;
  nodesToVisit.push(rootNode.id);
  nodesInSection.set(sectionNumber, /* @__PURE__ */ new Set());
  nodesInSection.get(sectionNumber)?.add(rootNode.id);
  nodeToSectionMap.set(rootNode.id, sectionNumber);
  while (nodesToVisit.length > 0) {
    const curRootNodeId = nodesToVisit.splice(0, 1)[0];
    if (curRootNodeId && !visitedNodes.includes(curRootNodeId)) {
      visitedNodes.push(curRootNodeId);
      const curRootNode = nodeMap.get(curRootNodeId);
      if (curRootNode) {
        const downstreamNodes = oneHopDownstreamNodesDict[curRootNodeId];
        if (downstreamNodes?.length > 0) {
          downstreamNodes.filter((elem) => visitedNodes.includes(elem)).forEach((elem) => {
            const section = nodeToSectionMap.get(elem);
            nodesInSection.get(section)?.delete(elem);
            const mismatchedNodeIndex = visitedNodes.findIndex((node) => node === elem);
            if (mismatchedNodeIndex > -1) {
              const mismatchedNodes = visitedNodes.splice(mismatchedNodeIndex, 1);
              removeMismatchedNodes(
                mismatchedNodes,
                oneHopDownstreamNodesDict,
                visitedNodes,
                nodeToSectionMap,
                nodesInSection
              );
            }
          });
          nodesInSection.get(nodeToSectionMap.get(curRootNodeId) + 1) ? downstreamNodes.forEach(
            (dsNode) => nodesInSection.get(nodeToSectionMap.get(curRootNodeId) + 1)?.add(dsNode)
          ) : nodesInSection.set(nodeToSectionMap.get(curRootNodeId) + 1, new Set(downstreamNodes));
          downstreamNodes.forEach((elem) => nodeToSectionMap.set(elem, nodeToSectionMap.get(curRootNodeId) + 1));
        }
      }
    }
    if (nodesToVisit && oneHopDownstreamNodesDict[curRootNodeId]) {
      nodesToVisit.push(...oneHopDownstreamNodesDict[curRootNodeId].filter((elem) => !visitedNodes.includes(elem)));
    }
  }
  nodesToVisit.push(rootNode.id);
  visitedNodes = [];
  while (nodesToVisit.length > 0) {
    const curRootNodeId = nodesToVisit.splice(0, 1)[0];
    if (curRootNodeId && !visitedNodes.includes(curRootNodeId)) {
      visitedNodes.push(curRootNodeId);
      const curRootNode = nodeMap.get(curRootNodeId);
      if (curRootNode) {
        const upstreamNodes = oneHopUpstreamNodesDict[curRootNodeId];
        if (upstreamNodes?.length > 0) {
          nodesInSection.get(nodeToSectionMap.get(curRootNodeId) - 1) ? upstreamNodes.filter((elem) => !visitedNodes.includes(elem)).forEach((usNode) => nodesInSection.get(nodeToSectionMap.get(curRootNodeId) - 1)?.add(usNode)) : nodesInSection.set(nodeToSectionMap.get(curRootNodeId) - 1, new Set(upstreamNodes));
          upstreamNodes.filter((elem) => !visitedNodes.includes(elem)).forEach((elem) => nodeToSectionMap.set(elem, nodeToSectionMap.get(curRootNodeId) - 1));
        }
      }
    }
    if (nodesToVisit && oneHopDownstreamNodesDict[curRootNodeId]) {
      nodesToVisit.push(...oneHopDownstreamNodesDict[curRootNodeId].filter((elem) => !visitedNodes.includes(elem)));
    }
  }
  const maxSection = Math.max(...nodesInSection.keys());
  const minSection = Math.min(...nodesInSection.keys());
  let curSection = minSection;
  let xForceFactor = 0;
  let placedNodes = [];
  let placedNodesYPos = [];
  while (curSection <= maxSection) {
    xForceFactor = curSection;
    const sectionNodes = nodesInSection.get(curSection);
    let yForceFactor = 0;
    let yDir = 1;
    let cnt = 1;
    simulation.nodes().filter((elem) => sectionNodes?.has(elem.id)).forEach((elem) => {
      elem.fx = width / 2 + xForceFactor * linkForce;
      const nodeYPos = height2 / 2 + yDir * yForceFactor * nodeCollideForce;
      if (fixedYPos || !fixedYPos && !placedNodesYPos.includes(`${elem.fx}-${nodeYPos}`)) {
        elem.fy = nodeYPos;
        placedNodesYPos.push(`${elem.fx}-${nodeYPos}`);
      } else {
        elem.y = nodeYPos;
      }
      if (rebalanceNodes && cnt % MAX_NODES === 0) {
        xForceFactor++;
        yForceFactor = 0;
      }
      cnt++;
      if (cnt % 2 === 0) {
        yForceFactor++;
      }
      yDir = yDir * -1;
      placedNodes.push(elem);
    });
    curSection++;
  }
}, "positionNodes");
var removeMismatchedNodes = /* @__PURE__ */ __name((mismatchedNodes, oneHopDownstreamNodesDict, visitedNodes, nodeToSectionMap, nodesInSection) => {
  mismatchedNodes.forEach((msNodes) => {
    const mismatchedDownstreamNodes = oneHopDownstreamNodesDict[msNodes];
    console.log();
    mismatchedDownstreamNodes?.forEach((elem) => {
      const section = nodeToSectionMap.get(elem);
      nodesInSection.get(section)?.delete(elem);
      const mismatchedNodeIndex = visitedNodes.findIndex((node) => node === elem);
      if (mismatchedNodeIndex > -1) {
        const mismatchedNodesRec = visitedNodes.splice(mismatchedNodeIndex, 1);
        removeMismatchedNodes(
          mismatchedNodesRec,
          oneHopDownstreamNodesDict,
          visitedNodes,
          nodeToSectionMap,
          nodesInSection
        );
      }
    });
  });
}, "removeMismatchedNodes");
Dependency.displayName = "FlowMap.Dependency";
Dependency.__DEV_METADATA__ = { status: "READY" };

// FlowMap/FlowMap.tsx
var FlowMap2 = Object.assign(() => null, {
  Constellation,
  Dependency
});
FlowMap2.displayName = "FlowMap";
FlowMap2.__DEV_METADATA__ = { status: "READY" };

// FocusManager/FocusManager.tsx
var import_uik550 = require("@appd/uik");
var import_react68 = require("react");
var import_jsx_runtime462 = require("react/jsx-runtime");
var FocusManager3 = import_uik550.utils.forwardRef(
  ({ autoFocus, children, className: className2, conditional, restoreFocus, ...props2 }, forwardedRef) => {
    const ref = (0, utils_exports.useBroadcastRef)(forwardedRef);
    const [firstMount, setFirstMount] = (0, import_react68.useState)(true);
    (0, import_react68.useEffect)(() => {
      const active = document.activeElement;
      if (autoFocus) {
        if (firstMount && conditional) {
          setTimeout(() => {
            import_uik550.utils.focusFirst(ref);
            setFirstMount(false);
          });
        }
      }
      return () => {
        if (restoreFocus) {
          active.focus();
        }
      };
    });
    return /* @__PURE__ */ (0, import_jsx_runtime462.jsx)("div", { className: (0, import_uik550.css)(...import_uik550.utils.many(className2)), ref, uik: "FocusManager", ...props2, children });
  }
);
FocusManager3.displayName = "FocusManager";

// Form/Form.tsx
var import_uik556 = require("@appd/uik");
var import_react70 = require("react");

// Form/CONTEXT.ts
var import_react69 = require("react");
var CONTEXT7 = (0, import_react69.createContext)({
  isRoot: true,
  submitted: false
});

// Form/getSnapshot.ts
var import_uik551 = require("@appd/uik");
var getSnapshot = /* @__PURE__ */ __name((form) => {
  const {
    allErrors: errors,
    stack: [{ values }]
  } = Array.from(form.elements).map((element) => {
    const name = element.getAttribute("name") ?? void 0;
    return is.fieldSet(element) ? {
      element,
      name
    } : is.checkbox(element) ? {
      element,
      errors: getElementsErrors(element).filter(import_uik551.utils.Boolean),
      name,
      value: element.ariaChecked == "true"
    } : is.input(element) || is.textArea(element) ? (
      // TODO Should <Input disabled> really be included here? (Currently it is.)
      {
        element,
        errors: getElementsErrors(element).filter(import_uik551.utils.Boolean),
        name,
        value: element.value
      }
    ) : is.select(element) ? {
      element,
      errors: getElementsErrors(element).filter(import_uik551.utils.Boolean),
      name,
      value: Array.from(
        element.selectedOptions ?? [],
        ({ id, value }) => id != void 0 && id !== "" ? id : value
      )
    } : void 0;
  }).filter(import_uik551.utils.Boolean).reduce(
    ({ allErrors, stack }, { element, errors: errors2, name: maybeName, value }) => {
      stack.length = import_uik551.utils.findLastIndex(stack, ({ element: e }) => e.contains(element)) + 1;
      const parent = stack[stack.length - 1];
      const name = maybeName ?? String(parent.numChildren);
      const values2 = value ?? {};
      Object.assign(parent, {
        numChildren: parent.numChildren + 1,
        values: Object.assign(parent.values, { [name]: values2 })
      });
      errors2?.length && allErrors.push({
        element,
        errors: errors2,
        name
      });
      is.fieldSet(element) && stack.push({
        element,
        numChildren: 0,
        values: values2
      });
      return {
        allErrors,
        stack
      };
    },
    {
      allErrors: [],
      stack: Array.of({
        element: form,
        numChildren: 0,
        values: {}
      })
    }
  );
  return {
    errors,
    values
  };
}, "getSnapshot");
var is = {
  checkbox: (e) => e.tagName === "INPUT" && e.type === "checkbox",
  fieldSet: (e) => e.tagName === "FIELDSET",
  input: (e) => e.tagName === "INPUT",
  select: (e) => e.tagName === "SELECT",
  textArea: (e) => e.tagName === "TEXTAREA"
};
var getElementsErrors = /* @__PURE__ */ __name((element) => (
  // `element.errors` is undefined or `[]`
  !element.errors?.length ? (
    // `element.validity.valid` is `true`
    element.validity.valid ? [] : (
      // `element.validationMessage` is `""`
      !element.validationMessage.length ? element.validity.valueMissing ? (
        // If element does not have a validationMessage but it's required
        [import_uik551.Form.MESSAGES.REQUIRED()]
      ) : ["This field has error"] : ["This field has error"]
    )
  ) : (
    // `element.errors` is not `[]`
    element.errors
  )
), "getElementsErrors");

// Form/Label/Label.tsx
var import_uik553 = require("@appd/uik");

// Form/Label/STYLES.ts
var import_uik552 = require("@appd/uik");
var {
  COLORS: { DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM9, INTERACT_ICON_WEAK: INTERACT_ICON_WEAK7 },
  SPACING: SPACING21,
  TYPOGRAPHY: { P3_DEFAULT: P3_DEFAULT9, P3_EMPHASIS: P3_EMPHASIS3, P4_DEFAULT: P4_DEFAULT5 }
} = import_uik552.MAGNETIC_TOKENS;
var STYLES15 = {
  HINT: (0, import_uik552.css)({
    color: DEFAULT_TEXT_MEDIUM9,
    font: P4_DEFAULT5
  }),
  HINT_CONTAINER: (0, import_uik552.css)({
    alignItems: "flex-start",
    display: "flex",
    justifyContent: "space-between",
    marginBottom: SPACING21[1],
    marginTop: SPACING21[1]
  }),
  HOST: (0, import_uik552.css)({
    alignItems: "center",
    display: "flex",
    marginBottom: SPACING21[1]
  }),
  LABEL: (0, import_uik552.css)({ font: P3_EMPHASIS3 }),
  MAIN: (0, import_uik552.css)({
    display: "flex",
    flex: 1
  }),
  OPTIONAL: (0, import_uik552.css)({
    color: DEFAULT_TEXT_MEDIUM9,
    font: P3_DEFAULT9,
    marginLeft: SPACING21[1]
  }),
  TOOLTIP: (0, import_uik552.css)({
    "& path": { fill: INTERACT_ICON_WEAK7 },
    marginLeft: SPACING21[1]
  })
};

// Form/Label/Label.tsx
var import_jsx_runtime463 = require("react/jsx-runtime");
var Label = import_uik553.utils.forwardRef(
  ({
    children,
    className: className2,
    hint,
    label,
    name,
    required,
    secondaryHint,
    secondaryLabel,
    showOptional = true,
    tooltip,
    ...props2
  }, ref) => /* @__PURE__ */ (0, import_jsx_runtime463.jsxs)(import_jsx_runtime463.Fragment, { children: [
    label && /* @__PURE__ */ (0, import_jsx_runtime463.jsxs)("div", { className: (0, import_uik553.css)(HOST6, ...import_uik553.utils.many(className2)), ref, uik: "Form.Label", ...props2, children: [
      /* @__PURE__ */ (0, import_jsx_runtime463.jsxs)("div", { className: (0, import_uik553.css)(MAIN), children: [
        /* @__PURE__ */ (0, import_jsx_runtime463.jsx)("label", { className: LABEL3, htmlFor: name, children: label }),
        tooltip && /* @__PURE__ */ (0, import_jsx_runtime463.jsx)(import_uik553.Tooltip, { onClick: (e) => e.preventDefault(), value: tooltip, children: /* @__PURE__ */ (0, import_jsx_runtime463.jsx)(import_uik553.Icon, { className: TOOLTIP3, size: "SMALL", type: "Status.Info" }) }),
        !required && showOptional && /* @__PURE__ */ (0, import_jsx_runtime463.jsx)("div", { className: OPTIONAL, children: import_uik553.Form.MESSAGES.OPTIONAL() })
      ] }),
      secondaryLabel
    ] }),
    children,
    (hint ?? secondaryHint) && /* @__PURE__ */ (0, import_jsx_runtime463.jsxs)("div", { className: HINT_CONTAINER, uik: "Form.Label.HINT_CONTAINER", children: [
      /* @__PURE__ */ (0, import_jsx_runtime463.jsx)("div", { className: HINT, children: hint }),
      /* @__PURE__ */ (0, import_jsx_runtime463.jsx)("div", { className: HINT, children: secondaryHint })
    ] })
  ] })
);
Label.displayName = "Form.Label";
var { HINT, HINT_CONTAINER, HOST: HOST6, LABEL: LABEL3, MAIN, OPTIONAL, TOOLTIP: TOOLTIP3 } = STYLES15;

// Form/MESSAGES.ts
var MESSAGES8 = {
  LOOKUP_PLACEHOLDER: format.message`Type or select...`.description(
    "A placeholder for the text input of a combobox component."
  ),
  NO_RESULTS: format.message`No matches found`.description(
    "A message to show that no results were returned for the query."
  ),
  OPTIONAL: format.message`(optional)`.description("A hint that a form field is not required."),
  REQUIRED: format.message`This field is required.`.description("An error message to fill out a required form field."),
  SEARCH: format.message`Search...`.description("A placeholder on a searchbox"),
  SELECTED: format.message`${"$0"} Selected`.description(
    "A placeholder to show how many options are selected in a dropdown."
  ),
  SELECT_PLACEHOLDER: format.message`Select a value`.description(
    "A placeholder for the text input of a select component."
  ),
  SHOW_MORE: format.message`Show ${"$0"} More...`.description(
    "A button to show more options on a form field dropdown."
  ),
  SLIDER_POPOVER_PLACEHOLDER: format.message`Select a range`.description("A placeholder for the slider input.")
};

// Form/Validation/Validation.tsx
var import_uik555 = require("@appd/uik");

// Form/Validation/getStyles.ts
var import_uik554 = require("@appd/uik");
var {
  COLORS: { DEFAULT_TEXT: DEFAULT_TEXT11, DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM10, NEGATIVE_BG_STRONG: NEGATIVE_BG_STRONG2, POSITIVE_BG_STRONG: POSITIVE_BG_STRONG2, WARNING_BG_STRONG: WARNING_BG_STRONG2 },
  RADIUS: RADIUS11,
  SPACING: SPACING22,
  TYPOGRAPHY: { P3_DEFAULT: P3_DEFAULT10 }
} = import_uik554.MAGNETIC_TOKENS;
var getStyles15 = /* @__PURE__ */ __name((kind) => ({
  DESCRIPTIONS: (0, import_uik554.css)({ color: DEFAULT_TEXT_MEDIUM10 }),
  HOST: (0, import_uik554.css)({
    alignItems: "center",
    backgroundColor: KIND_COLORS[kind],
    borderRadius: RADIUS11.DEFAULT,
    color: DEFAULT_TEXT11,
    display: "flex",
    font: P3_DEFAULT10,
    padding: `${SPACING22[2]}px ${SPACING22[3]}px`
  }),
  ICON: (0, import_uik554.css)({ marginRight: SPACING22[2] })
}), "getStyles");
var KIND_COLORS = {
  ERROR: NEGATIVE_BG_STRONG2,
  SUCCESS: POSITIVE_BG_STRONG2,
  WARNING: WARNING_BG_STRONG2
};

// Form/Validation/Validation.tsx
var import_jsx_runtime464 = require("react/jsx-runtime");
var Validation = Object.assign(
  import_uik555.utils.forwardRef(({ children, className: className2, kind = "ERROR", ...props2 }, ref) => {
    const { DESCRIPTIONS, HOST: HOST14, ICON: ICON4 } = getStyles15(kind);
    const iconType = kind === "SUCCESS" ? "Health.Normal" : kind === "WARNING" ? "Health.Warning" : "Health.Critical";
    return /* @__PURE__ */ (0, import_jsx_runtime464.jsxs)("div", { className: (0, import_uik555.css)(HOST14, ...import_uik555.utils.many(className2)), ref, uik: "Form.Validation", ...props2, children: [
      /* @__PURE__ */ (0, import_jsx_runtime464.jsx)(import_uik555.Icon, { className: ICON4, size: "MEDIUM", type: iconType }),
      /* @__PURE__ */ (0, import_jsx_runtime464.jsx)("div", { className: DESCRIPTIONS, children })
    ] });
  }),
  {
    Error: Object.assign(
      import_uik555.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime464.jsx)(Validation, { ref, uik: "Form.Validation.Error", ...props2, kind: "ERROR" })),
      { displayName: "Form.Validation.Error" }
    ),
    Success: Object.assign(
      import_uik555.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime464.jsx)(Validation, { ref, uik: "Form.Validation.Success", ...props2, kind: "SUCCESS" })),
      { displayName: "Form.Validation.Success" }
    ),
    Warning: Object.assign(
      import_uik555.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime464.jsx)(Validation, { ref, uik: "Form.Validation.Warning", ...props2, kind: "WARNING" })),
      { displayName: "Form.Validation.Warning" }
    )
  }
);
Validation.displayName = "Form.Validation";

// Form/Form.tsx
var import_jsx_runtime465 = require("react/jsx-runtime");
var Form4 = Object.assign(
  import_uik556.utils.forwardRef(
    ({ children, className: className2, onChange, onSubmit, submitted: rawSubmitted, ...inherited }, ref) => {
      const { isRoot, submitted: ancestorSubmitted } = (0, import_react70.useContext)(CONTEXT7);
      const [submitted, setSubmitted] = (0, import_react70.useState)(false);
      if (rawSubmitted !== void 0 && rawSubmitted !== submitted) {
        setSubmitted(rawSubmitted);
      }
      const FormOrFieldSet = isRoot ? "form" : "fieldset";
      return /* @__PURE__ */ (0, import_jsx_runtime465.jsx)(
        CONTEXT7.Provider,
        {
          value: {
            isRoot: false,
            submitted: submitted || ancestorSubmitted
          },
          children: /* @__PURE__ */ (0, import_jsx_runtime465.jsx)(
            FormOrFieldSet,
            {
              className: (0, import_uik556.css)(
                {
                  border: "initial",
                  margin: "initial",
                  minInlineSize: "initial",
                  padding: "initial"
                },
                ...import_uik556.utils.many(className2)
              ),
              noValidate: true,
              onChange: onChange && ((event) => {
                if (event.target.tabIndex === -1) {
                  return;
                }
                const { errors, values } = getSnapshot(event.currentTarget);
                onChange(values, errors);
              }),
              onSubmit: (e) => {
                e.preventDefault();
                setSubmitted(true);
                if (onSubmit) {
                  const { errors, values } = getSnapshot(e.currentTarget);
                  onSubmit(values, errors);
                }
              },
              ref,
              uik: "Form",
              ...inherited,
              children
            }
          )
        }
      );
    }
  ),
  {
    CONTEXT: CONTEXT7,
    Label,
    MESSAGES: MESSAGES8,
    Validation,
    getSnapshot
  }
);
Form4.displayName = "Form";
Form4.__DEV_METADATA__ = { status: "READY" };

// Grid/Grid.tsx
var import_uik569 = require("@appd/uik");
var import_react78 = require("react");
var import_server4 = require("react-dom/server");

// Grid/EXTERNAL_STYLES.ts
var import_uik557 = require("@appd/uik");
var {
  COLORS: { DEFAULT_TEXT: DEFAULT_TEXT12 },
  TYPOGRAPHY: { ELLIPSES: ELLIPSES11, P3_EMPHASIS: P3_EMPHASIS4 }
} = import_uik557.MAGNETIC_TOKENS;
var EXTERNAL_STYLES = {
  HEADER_CELL_LABEL: {
    HEADER_CELL_LABEL_TEXT: (0, import_uik557.css)({
      ...ELLIPSES11.END,
      color: DEFAULT_TEXT12,
      font: P3_EMPHASIS4
    }),
    alignItems: "center",
    boxSizing: "border-box",
    display: "flex",
    height: "100%",
    justifyContent: "inherit",
    padding: `0 12px`,
    width: "100%"
  }
};

// Grid/getGridVisible.ts
var getGridVisible = /* @__PURE__ */ __name((ref) => {
  const gridBody = ref?.current?.querySelector(".ag-body-viewport");
  return gridBody != null && gridBody.clientWidth > 0;
}, "getGridVisible");

// Grid/Loading.tsx
var import_uik558 = require("@appd/uik");
var import_jsx_runtime466 = require("react/jsx-runtime");
var Loading = /* @__PURE__ */ __name(() => /* @__PURE__ */ (0, import_jsx_runtime466.jsx)("div", { className: STYLES16, children: /* @__PURE__ */ (0, import_jsx_runtime466.jsx)("div", {}) }), "Loading");
var {
  COLORS: { CONTROL_BORDER_WEAK: CONTROL_BORDER_WEAK10 }
} = import_uik558.MAGNETIC_TOKENS;
var STYLES16 = (0, import_uik558.css)({
  "> div": {
    animation: "2s ease-in-out infinite",
    animationName: { "50%": { opacity: 0.5 } },
    backgroundColor: CONTROL_BORDER_WEAK10,
    borderRadius: 50,
    height: 15,
    marginLeft: 8,
    marginRight: 8,
    width: "100%"
  },
  alignItems: "center",
  display: "flex",
  height: "100%",
  width: "100%"
});

// Grid/getState.ts
var noop = /* @__PURE__ */ __name(() => {
}, "noop");
var getState2 = /* @__PURE__ */ __name(({
  defaultColDef,
  detailCellRenderer,
  detailRowHeight,
  filter,
  getRowClass,
  getRowHeight,
  getRowStyle,
  masterDetail,
  maxConcurrentDatasourceRequests,
  multiSort,
  onCellClicked = noop,
  onColumnVisible = noop,
  onGridReady = noop,
  onRowClicked = noop,
  onRowDoubleClicked = noop,
  onRowGroupOpened = noop,
  onSelectionChanged = noop,
  onSortChanged = noop,
  postSortRows,
  rowSelection,
  rows,
  suppressRowClickSelection,
  suppressRowHoverHighlight,
  ...props2
}) => ({
  autoGroupColumnDef: { hide: true },
  defaultColDef: {
    resizable: true,
    sortable: false,
    suppressMenu: true,
    ...defaultColDef
  },
  detailCellRenderer,
  detailRowHeight,
  filter: void 0,
  getRowClass,
  getRowHeight,
  getRowStyle,
  groupDisplayType: "custom",
  isServerSideGroup: "isServerSideGroup" in props2 && props2.isServerSideGroup || (({ group }) => group),
  loadingCellRenderer: Loading,
  masterDetail,
  maxConcurrentDatasourceRequests,
  noData: void 0,
  onCellClicked,
  onColumnVisible,
  onGridReady,
  onRowClicked,
  onRowDoubleClicked,
  onRowGroupOpened,
  onSelectionChanged,
  onSortChanged,
  postSortRows,
  quickFilterText: filter,
  rowMultiSelectWithClick: rowSelection === "multiple",
  rowSelection,
  suppressMultiSort: !multiSort,
  suppressRowClickSelection,
  suppressRowHoverHighlight,
  unsortable: void 0,
  ...isViewport(rows) ? {
    rowData: void 0,
    rowModelType: "viewport",
    serverSideDatasource: void 0,
    viewportDatasource: rows
  } : isServerSide(rows) ? {
    cacheBlockSize: rows.cacheBlockSize,
    rowData: void 0,
    rowModelType: "serverSide",
    serverSideDatasource: rows,
    serverSideInfiniteScroll: true,
    viewportDatasource: void 0
  } : {
    rowData: rows,
    rowModelType: "clientSide",
    serverSideDatasource: void 0,
    viewportDatasource: void 0
  },
  ...props2
}), "getState");
function isViewport(rows) {
  return typeof rows?.init === "function";
}
__name(isViewport, "isViewport");
function isServerSide(rows) {
  return typeof rows?.getRows === "function";
}
__name(isServerSide, "isServerSide");

// Grid/getStyles.ts
var import_uik559 = require("@appd/uik");

// Grid/Icons.tsx
var import_server3 = require("react-dom/server");
var import_jsx_runtime467 = require("react/jsx-runtime");
var Enable2 = /* @__PURE__ */ __name(({ color: color2 }) => /* @__PURE__ */ (0, import_jsx_runtime467.jsx)("svg", { fill: color2, uik: "Icon.Action.Enable", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ (0, import_jsx_runtime467.jsx)(
  "path",
  {
    d: "m19.292 4.996-9.901 9.505-4.683-4.483-1.84 1.766 6.523 6.262L21.13 6.774l-1.839-1.778Z",
    fill: color2,
    fillOpacity: ".94"
  }
) }), "Enable");
var Minus2 = /* @__PURE__ */ __name(({ color: color2 }) => /* @__PURE__ */ (0, import_jsx_runtime467.jsx)("svg", { fill: color2, uik: "Icon.Action.Minus", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ (0, import_jsx_runtime467.jsx)("path", { d: "M5 10.878h14v1.978H5z", fill: color2, fillOpacity: ".94" }) }), "Minus");
var SortOff2 = /* @__PURE__ */ __name(({ color: color2 }) => /* @__PURE__ */ (0, import_jsx_runtime467.jsx)("svg", { fill: color2, uik: "Icon.Action.SortOff", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ (0, import_jsx_runtime467.jsx)(
  "path",
  {
    d: "m20.5 21.9-9.8-9.8v4.35l1.55-1.55 1.45 1.4-4 4-4-4 1.45-1.4 1.55 1.55V10.1L2.1 3.5l1.4-1.4 18.4 18.4-1.4 1.4Zm-3.8-9.45-2-2V6.1l-1.6 1.6-1.4-1.4 4-4 4 4-1.4 1.4-1.6-1.6v6.35Z",
    fill: color2,
    fillOpacity: ".94"
  }
) }), "SortOff");
var ICONS2 = {
  CHECKBOX: {
    CHECKED: (color2) => (0, import_server3.renderToString)(/* @__PURE__ */ (0, import_jsx_runtime467.jsx)(Enable2, { color: color2 })),
    INDETERMINATE: (color2) => (0, import_server3.renderToString)(/* @__PURE__ */ (0, import_jsx_runtime467.jsx)(Minus2, { color: color2 }))
  },
  // Keep case as is for ag-grid's use.
  CUSTOM: {
    groupContracted: (0, import_server3.renderToString)(/* @__PURE__ */ (0, import_jsx_runtime467.jsx)(Icon.Navigation.ChevronRight, {})),
    groupExpanded: (0, import_server3.renderToString)(/* @__PURE__ */ (0, import_jsx_runtime467.jsx)(Icon.Navigation.ChevronDown, {})),
    sortAscending: (0, import_server3.renderToString)(/* @__PURE__ */ (0, import_jsx_runtime467.jsx)(Icon.Action.SortUp, {})),
    sortDescending: (0, import_server3.renderToString)(/* @__PURE__ */ (0, import_jsx_runtime467.jsx)(Icon.Action.SortDown, {})),
    sortUnSort: (0, import_server3.renderToString)(/* @__PURE__ */ (0, import_jsx_runtime467.jsx)(Icon.Action.Sort, {}))
  },
  SORT: { UNSORTABLE: (color2) => (0, import_server3.renderToString)(/* @__PURE__ */ (0, import_jsx_runtime467.jsx)(SortOff2, { color: color2 })) }
};

// Grid/getStyles.ts
var {
  COLORS: {
    CONTROL_BG_STRONG: CONTROL_BG_STRONG5,
    CONTROL_BG_WEAK_ACTIVE,
    CONTROL_BG_WEAK_HOVER,
    CONTROL_BORDER: CONTROL_BORDER13,
    CONTROL_BORDER_STRONG: CONTROL_BORDER_STRONG2,
    CONTROL_BORDER_WEAK: CONTROL_BORDER_WEAK11,
    CONTROL_ICON_WEAK: CONTROL_ICON_WEAK6,
    DEFAULT_TEXT: DEFAULT_TEXT13
  },
  MOTION: {
    DURATION: { SLOW }
  },
  RADIUS: RADIUS12,
  SPACING: SPACING23,
  TYPOGRAPHY: { ELLIPSES: ELLIPSES12, P3_DEFAULT: P3_DEFAULT11, P3_EMPHASIS: P3_EMPHASIS5 }
} = import_uik559.MAGNETIC_TOKENS;
var getStyles16 = /* @__PURE__ */ __name((checkboxIconColor, unsortableIconColor, headerHeight, rowSelection, unsortable) => import_uik559.css.Styles({
  "& .ag-root": {
    "& .ag-center-cols-container": { minWidth: "100%" },
    "& .ag-checkbox-input-wrapper": {
      "& .ag-checkbox-input": {
        boxSizing: "border-box",
        cursor: "pointer",
        height: CHECKBOX_SIZE2,
        opacity: 0,
        width: CHECKBOX_SIZE2
      },
      "&.ag-checked": {
        background: `url("data:image/svg+xml;base64,${Buffer.from(ICONS2.CHECKBOX.CHECKED(checkboxIconColor)).toString(
          "base64"
        )}") no-repeat`,
        backgroundColor: `${CONTROL_BG_STRONG5}`,
        backgroundSize: CHECKBOX_SIZE2,
        height: CHECKBOX_SIZE2,
        width: CHECKBOX_SIZE2
      },
      "&.ag-indeterminate": {
        background: `url("data:image/svg+xml;base64,${Buffer.from(
          ICONS2.CHECKBOX.INDETERMINATE(checkboxIconColor)
        ).toString("base64")}") no-repeat`,
        backgroundColor: `${CONTROL_BG_STRONG5}`,
        backgroundSize: CHECKBOX_SIZE2,
        height: CHECKBOX_SIZE2,
        width: CHECKBOX_SIZE2
      },
      "&:not(.ag-checked):not(.ag-indeterminate)": {
        borderColor: CONTROL_BORDER13,
        borderStyle: "solid",
        borderWidth: "2px",
        height: CHECKBOX_SIZE2,
        width: CHECKBOX_SIZE2
      },
      "::after": { display: "none" },
      borderRadius: RADIUS12.DEFAULT,
      boxSizing: "border-box",
      display: "block",
      height: CHECKBOX_SIZE2,
      marginTop: 1,
      width: CHECKBOX_SIZE2
    },
    "& .ag-group-contracted, & .ag-group-expanded": {
      "> svg > path": { fill: CONTROL_ICON_WEAK6 },
      boxSizing: "border-box",
      cursor: "pointer",
      display: "flex",
      marginTop: -2
    },
    "& .ag-header": {
      "& .ag-header-cell": {
        "& .ag-header-cell-comp-wrapper": {
          "& .ag-cell-label-container": {
            "& .ag-header-cell-label": {
              "& .ag-sort-ascending-icon,  & .ag-sort-descending-icon, & .ag-sort-none-icon": {
                "> svg": {
                  height: 25,
                  marginTop: 4,
                  width: 24
                },
                display: "block",
                paddingTop: 2
              },
              "> .ag-header-cell-text": {
                ...ELLIPSES12.END,
                color: DEFAULT_TEXT13,
                font: P3_EMPHASIS5
              },
              alignItems: "center",
              boxSizing: "border-box",
              display: "flex",
              height: "100%",
              justifyContent: "space-between",
              padding: `0 8px`,
              width: "100%"
            },
            justifyContent: "inherit"
          },
          all: "inherit",
          display: "contents",
          height: "100%",
          width: "100%"
        },
        "& .ag-header-select-all": { marginLeft: SPACING23[2] },
        "& .ag-sort-order": { display: "none" },
        "&:focus-visible": { backgroundColor: `${CONTROL_BG_WEAK_ACTIVE}` },
        "&:hover": {
          backgroundColor: HOVER_COLOR,
          transition: `background-color ${SLOW} linear`
        },
        outline: "none"
      },
      borderBottom: `2px solid ${CONTROL_BORDER_STRONG2}`,
      boxSizing: "content-box",
      // Ag-Grid adds one to the header-height internally,
      // so need to pre-set equivalent to that to avoid flickering.
      height: headerHeight + 1,
      minHeight: headerHeight + 1,
      ...unsortable && {
        "& .uik-unsortable:hover:not(.uik-checkbox-selection)::after": {
          background: `url("data:image/svg+xml;base64,${Buffer.from(
            ICONS2.SORT.UNSORTABLE(unsortableIconColor)
          ).toString("base64")}") no-repeat`,
          backgroundSize: 18,
          content: '""',
          height: 18,
          marginRight: 8,
          opacity: 0.2,
          width: 18
        }
      }
    },
    "& .ag-icon": {
      fontSize: LINE_HEIGHT,
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      lineHeight: LINE_HEIGHT,
      textTransform: "none"
    },
    "& .ag-row": {
      "& .ag-cell": {
        "&:focus-visible": { backgroundColor: `${CONTROL_BG_WEAK_ACTIVE}` },
        userSelect: "text",
        ...ELLIPSES12.END,
        alignItems: "center",
        border: "none",
        boxSizing: "border-box",
        height: "100%",
        lineHeight: LINE_HEIGHT,
        outline: "none",
        padding: SPACING23[2]
      },
      "&.ag-row-hover:not(.ag-full-width-row)": {
        backgroundColor: HOVER_COLOR,
        transition: `background-color ${SLOW} linear`
      },
      "&.ag-row-selected": {
        "&.ag-row-hover": { backgroundColor: HOVER_COLOR },
        backgroundColor: SELECTED_COLOR
      },
      "&[row-index='0']": { borderWidth: 0 },
      borderColor: CONTROL_BORDER_WEAK11,
      borderStyle: "solid",
      borderWidth: "1px 0 0 0",
      cursor: rowSelection ? "pointer" : void 0,
      outline: "none"
    },
    backgroundColor: "transparent"
  },
  backgroundColor: "transparent",
  color: DEFAULT_TEXT13,
  font: P3_DEFAULT11,
  height: 400
}), "getStyles");
var CHECKBOX_SIZE2 = 18;
var HOVER_COLOR = CONTROL_BG_WEAK_HOVER;
var SELECTED_COLOR = CONTROL_BG_WEAK_ACTIVE;
var LINE_HEIGHT = "21.5px";

// Grid/getTreeData.ts
var import_uik560 = require("@appd/uik");
var getTreeData = /* @__PURE__ */ __name((id, [key, ...rest], rows) => key && rows ? import_uik560.utils.let("match", rows.find((row) => String(row[id]) === key)?.children).get((match) => getTreeData(id, rest, match)) : rows?.map(({ children, ...row }) => ({
  group: Boolean(children?.length),
  ...row
})) ?? [], "getTreeData");

// Grid/useAgGridReact.ts
var import_uik561 = require("@appd/uik");
var import_react71 = require("react");
var useAgGridReact = /* @__PURE__ */ __name(() => {
  if (!import_uik561.utils.CAN_USE_DOM) {
    return;
  }
  const [, rerender] = (0, import_react71.useReducer)((i) => i + 1, 0);
  return AG_GRID_REACT().else(rerender);
}, "useAgGridReact");
var AG_GRID_REACT = import_uik561.utils.lazyConstant(() => {
  const loaded = import_uik561.utils.mutable(null);
  const promise = Promise.all([
    import("ag-grid-enterprise"),
    import("ag-grid-react"),
    fetch(`${ASSETS_PATH()}ag-grid.css`).then((response) => response.text())
  ]).then(([{ LicenseManager }, { AgGridReact }, agGridCss]) => {
    LicenseManager.setLicenseKey(
      "CompanyName=AppDynamics LLC (USA, San Francisco, CA, 94158),LicensedApplication=AppDynamics,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=5,LicensedProductionInstancesCount=5000,AssetReference=AG-034230,SupportServicesEnd=17_December_2023_[v2]_MTcwMjc3MTIwMDAwMA==7dce4b3494d57d868a05d6837d95aca1"
    );
    import_uik561.css.RENDERER.renderStatic(agGridCss);
    loaded.set(AgGridReact);
  });
  return { else: (rerender) => loaded() ?? void promise.then(rerender) };
});

// Grid/useCellFocus.ts
var import_uik562 = require("@appd/uik");
var import_react72 = require("react");
var useCellFocus = /* @__PURE__ */ __name((ref) => {
  (0, import_react72.useEffect)(() => {
    const gridElement = ref.current;
    gridElement?.addEventListener("keyup", (event) => {
      if (event.key === " " && gridElement.contains(document.activeElement)) {
        document.activeElement?.querySelector(import_uik562.utils.FOCUSABLE_SELECTOR)?.click();
      }
    });
  });
}, "useCellFocus");

// Grid/useColumnDefs.ts
var import_uik567 = require("@appd/uik");
var import_react76 = require("react");

// Grid/Configure/ConfigureCell.tsx
var import_uik563 = require("@appd/uik");
var import_jsx_runtime468 = require("react/jsx-runtime");
var ConfigureCell = /* @__PURE__ */ __name(({ value }) => {
  const { HOST: HOST14 } = STYLES17;
  return value != void 0 && value.dropdown != void 0 ? /* @__PURE__ */ (0, import_jsx_runtime468.jsx)("div", { className: (0, import_uik563.css)(HOST14), children: /* @__PURE__ */ (0, import_jsx_runtime468.jsx)(import_uik563.Dropdown, { icon: "Navigation.MoreHorizontal", kind: "TERTIARY", triggerClassName: (0, import_uik563.css)({ height: "auto" }), children: value.dropdown.options?.map((option, index) => /* @__PURE__ */ (0, import_jsx_runtime468.jsx)(import_uik563.Dropdown.Option, { onClick: option.onClick, children: option.label }, `option-${index}`)) }) }) : /* @__PURE__ */ (0, import_jsx_runtime468.jsx)(import_jsx_runtime468.Fragment, {});
}, "ConfigureCell");
var STYLES17 = {
  HOST: (0, import_uik563.css)({
    display: "flex",
    justifyContent: "center"
  })
};

// Grid/Configure/ConfigureHeader.tsx
var import_uik566 = require("@appd/uik");
var import_react75 = require("react");

// Grid/Configure/ColumnChooser.tsx
var import_uik565 = require("@appd/uik");
var import_react73 = require("@appd/utils/@react");
var import_react74 = require("react");

// Grid/Configure/MESSAGES.ts
var import_uik564 = require("@appd/uik");
var MESSAGES9 = {
  DRAWER_PRIMARY: import_uik564.format.message`Apply`.description("A primary button in the drawer."),
  DRAWER_SECONDARY: import_uik564.format.message`Cancel`.description("A secondary button in the drawer."),
  DRAWER_SUBTITLE: import_uik564.format.message`Select columns to display in the table`.description("A subtitle in the drawer"),
  DRAWER_TITLE: import_uik564.format.message`Select columns`.description("A title in the drawer.")
};

// Grid/Configure/ColumnChooser.tsx
var import_jsx_runtime469 = require("react/jsx-runtime");
var ColumnChooser = import_uik565.utils.forwardRef(
  ({ className: className2, columnApi, onApply, onOpenChange, open, ...props2 }, ref) => {
    const [columns, setColumns] = (0, import_react74.useState)([]);
    const [search, setSearch] = (0, import_react74.useState)("");
    const { CONTAINER: CONTAINER7, HOST: HOST14, LABEL: LABEL7 } = STYLES18;
    const { DRAWER_PRIMARY, DRAWER_SECONDARY, DRAWER_SUBTITLE, DRAWER_TITLE } = MESSAGES9;
    (0, import_react73.useLayoutEffect)(() => {
      if (open) {
        setColumns(getState3(columnApi));
      }
    }, [open, columnApi]);
    const content = /* @__PURE__ */ (0, import_jsx_runtime469.jsxs)("div", { className: (0, import_uik565.css)(HOST14, className2), ref, ...props2, children: [
      /* @__PURE__ */ (0, import_jsx_runtime469.jsx)(import_uik565.SearchBox, { onChange: setSearch, value: search }),
      columns.filter(
        ({ name }) => name && name !== "configure" && (!search || name.toLowerCase().includes(search.toLowerCase()))
      ).map(({ alwaysVisible, id, name, visible }) => /* @__PURE__ */ (0, import_jsx_runtime469.jsxs)("div", { className: CONTAINER7, children: [
        /* @__PURE__ */ (0, import_jsx_runtime469.jsx)(
          import_uik565.Checkbox,
          {
            checked: visible,
            disabled: alwaysVisible,
            onChange: (newValue) => {
              const newColumns = columns.map(
                (column) => column.id === id ? {
                  ...column,
                  visible: newValue
                } : column
              );
              setColumns(newColumns);
            }
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime469.jsx)("div", { className: LABEL7, children: name })
      ] }, id))
    ] });
    return /* @__PURE__ */ (0, import_jsx_runtime469.jsx)(
      import_uik565.Drawer,
      {
        closeBehavior: {
          CLOSE_ICON: true,
          ESCAPE_KEY: true,
          FOOTER_PRIMARY: true,
          FOOTER_SECONDARY: true
        },
        footer: {
          primary: DRAWER_PRIMARY(),
          secondary: DRAWER_SECONDARY()
        },
        onClose: (kind) => {
          onOpenChange?.(false);
          if (kind === "FOOTER_PRIMARY") {
            onApply(columns);
          } else {
            setColumns(getState3(columnApi));
          }
        },
        open,
        subtitle: DRAWER_SUBTITLE(),
        title: DRAWER_TITLE(),
        children: content
      }
    );
  }
);
var getState3 = /* @__PURE__ */ __name((columnApi) => columnApi.getAllGridColumns().map((column) => ({
  alwaysVisible: column.getColDef().alwaysVisible ?? false,
  id: column.getColId(),
  name: getColumnName(column),
  visible: column.isVisible()
})), "getState");
var {
  COLORS: { DEFAULT_TEXT: DEFAULT_TEXT14 },
  TYPOGRAPHY: { ELLIPSES: ELLIPSES13, P3_DEFAULT: P3_DEFAULT12 }
} = import_uik565.MAGNETIC_TOKENS;
var STYLES18 = {
  CONTAINER: (0, import_uik565.css)({
    display: "flex",
    gap: 4,
    width: "100%"
  }),
  HOST: (0, import_uik565.css)({
    display: "flex",
    flexDirection: "column",
    gap: 12,
    marginTop: 8,
    width: "100%"
  }),
  LABEL: (0, import_uik565.css)({
    ...ELLIPSES13.END,
    color: DEFAULT_TEXT14,
    flex: 1,
    font: P3_DEFAULT12,
    minWidth: 0,
    textTransform: "capitalize"
  })
};
var getColumnName = /* @__PURE__ */ __name((column) => column.getColDef().headerName ?? column.getColDef().field, "getColumnName");

// Grid/Configure/ConfigureHeader.tsx
var import_jsx_runtime470 = require("react/jsx-runtime");
var ConfigureHeader = /* @__PURE__ */ __name(({ api, columnApi }) => {
  const [drawerOpen, setDrawerOpen] = (0, import_react75.useState)(false);
  const onApply = /* @__PURE__ */ __name((columns) => {
    for (const { id, visible } of columns) {
      columnApi.setColumnVisible(id, visible);
    }
    api.sizeColumnsToFit();
  }, "onApply");
  const { HOST: HOST14, ICON_CONTAINER } = STYLES19;
  return /* @__PURE__ */ (0, import_jsx_runtime470.jsxs)("div", { className: HOST14, children: [
    /* @__PURE__ */ (0, import_jsx_runtime470.jsx)("div", { className: ICON_CONTAINER, onClick: () => setDrawerOpen(!drawerOpen), children: /* @__PURE__ */ (0, import_jsx_runtime470.jsx)(import_uik566.Tooltip, { value: "Configure", children: /* @__PURE__ */ (0, import_jsx_runtime470.jsx)(import_uik566.Icon.Action.Configure, { height: "20", width: "20" }) }) }),
    /* @__PURE__ */ (0, import_jsx_runtime470.jsx)(ColumnChooser, { columnApi, onApply, onOpenChange: setDrawerOpen, open: drawerOpen })
  ] });
}, "ConfigureHeader");
var STYLES19 = {
  HOST: (0, import_uik566.css)({
    all: void 0,
    cursor: "pointer",
    height: "100%",
    width: "100%"
  }),
  ICON_CONTAINER: (0, import_uik566.css)({
    alignItems: "center",
    display: "flex",
    height: "100%",
    justifyContent: "center",
    width: "100%"
  })
};

// Grid/useColumnDefs.ts
var useColumnDefs = /* @__PURE__ */ __name((columns, showConfigure) => (0, import_react76.useMemo)(() => {
  const columnDefs = columns?.map(
    ({
      cellRenderer,
      cellStyle,
      checkboxSelection,
      field,
      headerComponent,
      headerStyle,
      hide,
      maxWidth,
      minWidth,
      pinnedCellRenderer: _,
      sortable,
      width,
      ...rest
    }) => ({
      cellClass: (0, import_uik567.css)({
        ...cellStyle,
        ...{ all: void 0 }
      }),
      cellRenderer,
      checkboxSelection,
      field,
      headerClass: `${(0, import_uik567.css)({
        ...headerStyle,
        ...{ all: void 0 }
      })} ${sortable ? "uik-sortable" : "uik-unsortable"} ${checkboxSelection ? "uik-checkbox-selection" : ""}`,
      headerComponent,
      headerTooltip: field,
      hide,
      maxWidth,
      minWidth: minWidth ?? 50,
      sortable,
      suppressKeyboardEvent: (params) => params.event.metaKey,
      suppressSizeToFit: !!width,
      tooltipField: cellRenderer == void 0 ? field : void 0,
      width: hide ? void 0 : width != void 0 ? width : void 0,
      ...rest
    })
  ) ?? [];
  if (showConfigure) {
    columnDefs.push({
      cellRenderer: ConfigureCell,
      field: "configure",
      headerClass: (0, import_uik567.css)({ all: void 0 }),
      headerComponent: ConfigureHeader,
      headerName: "",
      hide: false,
      lockPinned: true,
      lockPosition: true,
      lockVisible: true,
      maxWidth: 50,
      minWidth: 50,
      pinned: "right",
      resizable: false,
      sortable: false,
      suppressKeyboardEvent: (params) => params.event.metaKey,
      width: 50
    });
  }
  return columnDefs;
}, [columns, showConfigure]), "useColumnDefs");

// Grid/useIconColors.ts
var import_uik568 = require("@appd/uik");
var import_react77 = require("react");
var {
  COLORS: { CONTROL_ICON: CONTROL_ICON2, CONTROL_ICON_IN: CONTROL_ICON_IN2 }
} = import_uik568.MAGNETIC_TOKENS;
var useIconColors = /* @__PURE__ */ __name(({ currentTheme, setIconColors }) => {
  (0, import_react77.useEffect)(() => {
    if (import_uik568.utils.CAN_USE_DOM) {
      const controlIconIn = getIconColor(CONTROL_ICON_IN2);
      const controlIcon = getIconColor(CONTROL_ICON2);
      setIconColors({
        checkboxIconColor: controlIconIn,
        unsortableIconColor: controlIcon
      });
    }
  }, [currentTheme]);
}, "useIconColors");
var getIconColor = /* @__PURE__ */ __name((token) => {
  const controlIconIn = /\(([^)]+)\)/.exec(token)?.[1];
  if (controlIconIn == void 0) {
    return "";
  }
  return window.getComputedStyle(document.body)?.getPropertyValue(controlIconIn);
}, "getIconColor");

// Grid/Grid.tsx
var import_jsx_runtime471 = require("react/jsx-runtime");
var Grid = Object.assign(
  import_uik569.utils.forwardRef(
    ({
      className: className2,
      columns,
      headerHeight = HEADER_HEIGHT,
      noData,
      onModelUpdated,
      rowHeight = ROW_HEIGHT,
      showConfigure = true,
      style,
      unsortable = true,
      ...props2
    }, maybeRef) => {
      const [initialRows, setInitialRows] = (0, import_react78.useState)(void 0);
      const [postFirstDataRendered, setPostFirstDataRendered] = (0, import_react78.useState)(false);
      const [iconColors, setIconColors] = (0, import_react78.useState)({
        checkboxIconColor: "#fff",
        unsortableIconColor: "gray"
      });
      const { currentTheme } = (0, import_react78.useContext)(import_uik569.css.CONTEXT);
      const ref = import_uik569.utils.useBroadcastRef(maybeRef);
      const state = getState2(props2);
      const columnDefs = useColumnDefs(columns, showConfigure);
      const onResize2 = (0, import_react78.useCallback)(({ height: height2 }) => {
        setInitialRows(
          (initialRows2) => initialRows2 ?? Math.max((height2 ?? GRID_DEFAULT_HEIGHT) / rowHeight - ROW_BUFFER, 1)
        );
      }, []);
      useCellFocus(ref);
      useIconColors({
        currentTheme,
        setIconColors
      });
      const AgGridReact = useAgGridReact();
      return /* @__PURE__ */ (0, import_jsx_runtime471.jsx)(import_uik569.Measurer, { onResize: onResize2, children: /* @__PURE__ */ (0, import_jsx_runtime471.jsx)(
        "div",
        {
          className: (0, import_uik569.css)(
            getStyles16(
              iconColors.checkboxIconColor,
              iconColors.unsortableIconColor,
              headerHeight,
              props2.rowSelection,
              unsortable
            ),
            ...import_uik569.utils.many(className2)
          ),
          ref,
          style,
          uik: "Grid",
          children: AgGridReact && /* @__PURE__ */ (0, import_jsx_runtime471.jsx)(
            AgGridReact,
            {
              cacheOverflowSize: CACHE_OVERFLOW_SIZE,
              columnDefs,
              containerStyle: {
                height: "100%",
                width: "100%"
              },
              enableBrowserTooltips: true,
              ensureDomOrder: true,
              headerHeight,
              icons: ICONS2.CUSTOM,
              onFirstDataRendered: ({ api }) => {
                const gridVisible = getGridVisible(ref);
                gridVisible && api.sizeColumnsToFit();
                setPostFirstDataRendered(true);
              },
              onGridSizeChanged: ({ api }) => {
                const gridVisible = getGridVisible(ref);
                gridVisible && api.sizeColumnsToFit();
              },
              onModelUpdated: (event) => {
                const { api } = event;
                api.getDisplayedRowCount() > 0 ? api.hideOverlay() : api.showNoRowsOverlay();
                !postFirstDataRendered && getGridVisible(ref) && api.sizeColumnsToFit();
                onModelUpdated?.(event);
              },
              overlayNoRowsTemplate: (0, import_server4.renderToString)(
                /* @__PURE__ */ (0, import_jsx_runtime471.jsx)(
                  "div",
                  {
                    className: (0, import_uik569.css)({
                      alignItems: "center",
                      backgroundColor: DEFAULT_BG2,
                      color: DEFAULT_TEXT_MEDIUM11,
                      display: "flex",
                      font: P3_DEFAULT13,
                      height: "100%",
                      justifyContent: "center",
                      padding: SPACING24[3],
                      textAlign: "center",
                      width: "100%"
                    }),
                    children: noData?.message ?? import_uik569.Illustration.MESSAGES.NO_DATA()
                  }
                )
              ),
              rowHeight,
              serverSideInitialRowCount: initialRows ?? SERVER_SIDE_INITIAL_ROW_COUNT,
              suppressContextMenu: true,
              suppressDragLeaveHidesColumns: true,
              ...state
            }
          )
        }
      ) });
    }
  ),
  {
    EXTERNAL_STYLES,
    GroupCellRenderer: "agGroupCellRenderer",
    getTreeData
  }
);
Grid.displayName = "Grid";
Grid.__DEV_METADATA__ = { status: "READY" };
var BASE_HEIGHT = 37.5;
var HEADER_HEIGHT = BASE_HEIGHT;
var ROW_HEIGHT = BASE_HEIGHT;
var CACHE_OVERFLOW_SIZE = 5;
var SERVER_SIDE_INITIAL_ROW_COUNT = 5;
var GRID_DEFAULT_HEIGHT = 200;
var ROW_BUFFER = 2;
var {
  COLORS: { DEFAULT_BG: DEFAULT_BG2, DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM11 },
  SPACING: SPACING24,
  TYPOGRAPHY: { P3_DEFAULT: P3_DEFAULT13 }
} = import_uik569.MAGNETIC_TOKENS;

// Heading/Heading.tsx
var import_uik571 = require("@appd/uik");

// Heading/STYLES.ts
var import_uik570 = require("@appd/uik");
var {
  COLORS: { DEFAULT_TEXT_STRONG: DEFAULT_TEXT_STRONG6 },
  TYPOGRAPHY: { HEADING_PRIMARY: HEADING_PRIMARY2, HEADING_SECTION, HEADING_SMALLEST, HEADING_SUB_SECTION: HEADING_SUB_SECTION2 }
} = import_uik570.MAGNETIC_TOKENS;
var STYLES20 = {
  FONT: {
    PRIMARY: (0, import_uik570.css)({ font: HEADING_PRIMARY2 }),
    SECTION: (0, import_uik570.css)({ font: HEADING_SECTION }),
    SMALLEST: (0, import_uik570.css)({
      font: HEADING_SMALLEST,
      letterSpacing: 1,
      textTransform: "uppercase"
    }),
    SUB_SECTION: (0, import_uik570.css)({ font: HEADING_SUB_SECTION2 })
  },
  HOST: (0, import_uik570.css)({
    color: DEFAULT_TEXT_STRONG6,
    margin: 0
  })
};

// Heading/Heading.tsx
var import_jsx_runtime472 = require("react/jsx-runtime");
var Heading3 = import_uik571.utils.forwardRef(
  ({ children, className: className2, size = "SECTION", ...props2 }, rawRef) => {
    const Component = SIZES[size];
    return /* @__PURE__ */ (0, import_jsx_runtime472.jsx)(Component, { className: (0, import_uik571.css)(HOST7, FONT[size], ...import_uik571.utils.many(className2)), ref: rawRef, uik: "Heading", ...props2, children });
  }
);
Heading3.displayName = "Heading";
Heading3.__DEV_METADATA__ = { status: "READY" };
var SIZES = {
  PRIMARY: "h1",
  SECTION: "h2",
  SMALLEST: "h4",
  SUB_SECTION: "h3"
};
var { FONT, HOST: HOST7 } = STYLES20;

// HealthBar/HealthBar.tsx
var import_uik580 = require("@appd/uik");
var import_react81 = require("react");

// HealthBar/CONSTANTS.ts
var MIN_BAR_WIDTH = 4;
var LABEL_OVERFLOW_WIDTH = 60;
var TOOLTIP_WIDTH = 200;

// HealthBar/getBarColor.ts
var import_uik572 = require("@appd/uik");

// HealthBar/isCustomStatus.ts
var isCustomStatus = /* @__PURE__ */ __name((barStatus) => {
  const statusObj = barStatus;
  return statusObj.name != void 0 && statusObj.color != void 0;
}, "isCustomStatus");

// HealthBar/getBarColor.ts
var getBarColor = /* @__PURE__ */ __name(({ status }) => isCustomStatus(status) ? status.color : import_uik572.MAGNETIC_TOKENS.STATIC[status], "getBarColor");

// HealthBar/getBarDisplayValue.ts
var import_uik573 = require("@appd/uik");
var getDisplayValue = /* @__PURE__ */ __name((scoreValue, decimalPlaces, showPercentSign) => {
  if (scoreValue == void 0) {
    return "\u2013";
  }
  const formattedValue = import_uik573.format.number(scoreValue, {
    maximumFractionDigits: decimalPlaces,
    minimumFractionDigits: 0
  });
  return showPercentSign ? `${formattedValue}%` : formattedValue;
}, "getDisplayValue");

// HealthBar/getBarStatus.ts
var getBarStatus = /* @__PURE__ */ __name((status) => isCustomStatus(status) ? status.name : status.charAt(0) + status.slice(1).toLocaleLowerCase(), "getBarStatus");

// HealthBar/getLabel.tsx
var import_jsx_runtime473 = require("react/jsx-runtime");
var getLabel = /* @__PURE__ */ __name((value, status) => /* @__PURE__ */ (0, import_jsx_runtime473.jsxs)(import_jsx_runtime473.Fragment, { children: [
  /* @__PURE__ */ (0, import_jsx_runtime473.jsx)("span", { children: value }),
  "\xA0",
  /* @__PURE__ */ (0, import_jsx_runtime473.jsx)("span", { children: status })
] }), "getLabel");

// HealthBar/getSegmentWidth.ts
var getSegmentWidth = /* @__PURE__ */ __name((segmentValue, totalWidth, totalValue) => Math.max(MIN_BAR_WIDTH, Math.ceil(segmentValue * totalWidth / totalValue)), "getSegmentWidth");

// HealthBar/getStyles.ts
var import_uik574 = require("@appd/uik");
var HEIGHT = 8;
var BORDER_RADIUS = 12;
var {
  COLORS: { CONTROL_BG_WEAK: CONTROL_BG_WEAK11, CONTROL_BORDER_WEAK: CONTROL_BORDER_WEAK12 }
} = import_uik574.MAGNETIC_TOKENS;
var getStyles17 = /* @__PURE__ */ __name((zeroValue) => import_uik574.css.Styles({
  BAR_CONTAINER: import_uik574.css.Styles({
    "> div:last-child > .bar-segment": {
      borderBottomRightRadius: BORDER_RADIUS,
      borderTopRightRadius: BORDER_RADIUS
    },
    "> div:nth-child(1) .bar-segment": {
      borderBottomLeftRadius: BORDER_RADIUS,
      borderTopLeftRadius: BORDER_RADIUS
    },
    display: "flex",
    flexDirection: "row",
    ...zeroValue && {
      backgroundColor: `${CONTROL_BG_WEAK11}`,
      border: `1px solid ${CONTROL_BORDER_WEAK12}`,
      borderRadius: 3,
      height: 4
    }
  }),
  BAR_SEGMENT: import_uik574.css.Styles({ height: HEIGHT }),
  LABEL: import_uik574.css.Styles({
    marginTop: 4,
    overflow: "hidden",
    padding: 4,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    ...zeroValue && { marginRight: 8 }
  }),
  LABEL_ALIGN_LEFT: import_uik574.css.Styles({
    maxWidth: 200,
    minWidth: 60
  }),
  LABEL_CONTAINER: (0, import_uik574.css)({
    display: "flex",
    flexDirection: "row",
    overflow: "auto"
  })
}), "getStyles");

// HealthBar/useMarkers/useMarkers.tsx
var import_uik576 = require("@appd/uik");
var import_react79 = require("react");

// HealthBar/useMarkers/STYLES.ts
var import_uik575 = require("@appd/uik");
var {
  COLORS: { CONTROL_ICON_WEAK: CONTROL_ICON_WEAK7 }
} = import_uik575.MAGNETIC_TOKENS;
var MARKER_HEIGHT = 16;
var MARKER_WIDTH = 2;
var STYLES21 = import_uik575.css.Styles({
  CONTAINER: import_uik575.css.Styles({
    display: "flex",
    flexDirection: "column",
    height: "max-content",
    justifyContent: "space-between",
    // Give it a negative top margin equal to the top offset to remove the gap created by relative positioning
    marginTop: Math.ceil(-MARKER_HEIGHT * 2 / 3),
    position: "relative",
    top: Math.ceil(MARKER_HEIGHT * 2 / 3)
  }),
  LABEL: {
    "> div": { width: "max-content" },
    marginBottom: 2
  },
  MARKER: {
    "> rect": {
      fill: `${CONTROL_ICON_WEAK7}`,
      height: MARKER_HEIGHT,
      width: MARKER_WIDTH
    },
    height: MARKER_HEIGHT,
    width: "100%"
  }
});

// HealthBar/useMarkers/useMarkers.tsx
var import_jsx_runtime474 = require("react/jsx-runtime");
var useMarkers = /* @__PURE__ */ __name(({ marker, totalWidth }) => {
  const { CONTAINER: CONTAINER7, LABEL: LABEL7, MARKER } = STYLES21;
  const [labelWidth, setLabelWidth] = (0, import_react79.useState)(0);
  const [markerLeftOffset, setMarkerLeftOffset] = (0, import_react79.useState)(0);
  const [labelPosition, setLabelPosition] = (0, import_react79.useState)(0);
  const labelRef = (0, import_react79.useCallback)((node) => {
    if (node !== null) {
      setLabelWidth(node.getBoundingClientRect().width);
    }
  }, []);
  (0, import_react79.useEffect)(() => {
    if (!marker) {
      return;
    }
    const isValidPosition = marker.position >= 0 && marker.position <= 100;
    const validPosition = isValidPosition ? marker.position : 0;
    const left = Math.floor(validPosition * totalWidth / 100);
    let adjustment = 0;
    if (left > MARKER_WIDTH && left + MARKER_WIDTH >= totalWidth) {
      adjustment = -MARKER_WIDTH;
    }
    setMarkerLeftOffset(left + adjustment);
  }, [marker, totalWidth]);
  (0, import_react79.useEffect)(() => {
    if (markerLeftOffset + labelWidth <= totalWidth) {
      setLabelPosition(markerLeftOffset);
    } else if (markerLeftOffset - labelWidth >= 0) {
      setLabelPosition(markerLeftOffset - labelWidth);
    }
  }, [labelWidth, markerLeftOffset, totalWidth]);
  if (!marker) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime474.jsxs)("div", { className: (0, import_uik576.css)(CONTAINER7), children: [
    /* @__PURE__ */ (0, import_jsx_runtime474.jsx)("div", { className: (0, import_uik576.css)(LABEL7), children: /* @__PURE__ */ (0, import_jsx_runtime474.jsx)("div", { ref: labelRef, style: { marginLeft: labelPosition }, children: marker.label }) }),
    /* @__PURE__ */ (0, import_jsx_runtime474.jsx)("svg", { className: (0, import_uik576.css)(MARKER), children: /* @__PURE__ */ (0, import_jsx_runtime474.jsx)("rect", { x: markerLeftOffset, y: "0" }) })
  ] });
}, "useMarkers");

// HealthBar/useTooltip/useTooltip.tsx
var import_uik579 = require("@appd/uik");
var import_react80 = require("react");

// HealthBar/useTooltip/getPosition.ts
var import_uik577 = require("@appd/uik");
var getPosition = /* @__PURE__ */ __name((cursorPosition, boundingRect, tooltipWidth) => {
  let left = cursorPosition.x - boundingRect.x - boundingRect.width / 2;
  if (cursorPosition.x - boundingRect.x < tooltipWidth / 2) {
    left += tooltipWidth / 2;
  }
  if (boundingRect.width + boundingRect.x - cursorPosition.x < tooltipWidth / 2) {
    left -= tooltipWidth / 2;
  }
  return import_uik577.css.Styles({
    left,
    position: "absolute"
  });
}, "getPosition");

// HealthBar/useTooltip/STYLES.ts
var import_uik578 = require("@appd/uik");
var { TYPOGRAPHY } = import_uik578.MAGNETIC_TOKENS;
var STYLES22 = import_uik578.css.Styles({
  CIRCLE: (0, import_uik578.css)({
    borderRadius: "50%",
    height: 10,
    marginTop: 4,
    width: 10
  }),
  CONTAINER: import_uik578.css.Styles({
    display: "grid",
    font: TYPOGRAPHY.P4_DEFAULT,
    gridGap: 6,
    gridTemplateColumns: "auto auto auto",
    maxWidth: 600,
    padding: "8px 0px"
  }),
  NAME: (0, import_uik578.css)({
    marginLeft: 12,
    maxWidth: 280,
    textAlign: "left",
    ...TYPOGRAPHY.ELLIPSES.END
  }),
  VALUE: (0, import_uik578.css)({
    marginLeft: 12,
    minWidth: 80,
    textAlign: "right"
  })
});

// HealthBar/useTooltip/useTooltip.tsx
var import_jsx_runtime475 = require("react/jsx-runtime");
var useTooltip2 = /* @__PURE__ */ __name(({ boundingRect, cursorPosition, decimalPlaces, segments, showPercentSign }) => {
  const { CIRCLE, CONTAINER: CONTAINER7, NAME: NAME3, VALUE: VALUE3 } = STYLES22;
  const value = (0, import_react80.useMemo)(
    () => /* @__PURE__ */ (0, import_jsx_runtime475.jsx)("div", { className: (0, import_uik579.css)(CONTAINER7), children: segments.map((barSegment, index) => /* @__PURE__ */ (0, import_jsx_runtime475.jsxs)(import_react80.Fragment, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime475.jsx)("div", { className: (0, import_uik579.css)(CIRCLE, import_uik579.css.Styles({ backgroundColor: getBarColor(barSegment) })) }),
      /* @__PURE__ */ (0, import_jsx_runtime475.jsx)("div", { className: NAME3, children: getBarStatus(barSegment.status) }),
      /* @__PURE__ */ (0, import_jsx_runtime475.jsx)("div", { className: VALUE3, children: getDisplayValue(barSegment.value, decimalPlaces, showPercentSign) })
    ] }, index)) }),
    [segments, decimalPlaces, showPercentSign]
  );
  const className2 = (0, import_react80.useMemo)(
    () => (0, import_uik579.css)(getPosition(cursorPosition, boundingRect, TOOLTIP_WIDTH)),
    [cursorPosition, boundingRect]
  );
  return {
    className: className2,
    value
  };
}, "useTooltip");

// HealthBar/HealthBar.tsx
var import_jsx_runtime476 = require("react/jsx-runtime");
var HealthBar = import_uik580.utils.forwardRef(
  ({
    className: className2,
    decimalPlaces,
    labelAlign = "UNDERNEATH",
    markers: marker,
    noDataMessage,
    segments,
    showPercentSign,
    ...props2
  }, ref) => {
    const [boundingRect, setBoundingRect] = (0, import_react81.useState)({
      width: 0,
      x: 0
    });
    const onResize2 = (0, import_react81.useCallback)(({ width, x }) => {
      setBoundingRect({
        width,
        x
      });
    }, []);
    const [cursorPosition, setCursorPosition] = (0, import_react81.useState)({ x: 0 });
    const handleMouseOver = /* @__PURE__ */ __name((event) => {
      setCursorPosition({ x: event.clientX });
    }, "handleMouseOver");
    const getWidth = /* @__PURE__ */ __name((scoreValue) => getSegmentWidth(scoreValue ?? 0, boundingRect.width, totalValue), "getWidth");
    const totalValue = segments.map((barSegment) => barSegment.value ?? 0).reduce((previousValue, currentValue) => previousValue + currentValue, 0);
    const noData = segments.every((value) => value.value == void 0);
    const { BAR_CONTAINER, BAR_SEGMENT, LABEL: LABEL7, LABEL_ALIGN_LEFT, LABEL_CONTAINER } = getStyles17(totalValue === 0);
    const markerElement = useMarkers({
      marker,
      totalWidth: boundingRect.width
    });
    const healthBarElement = /* @__PURE__ */ (0, import_jsx_runtime476.jsxs)("div", { className: (0, import_uik580.css)(...import_uik580.utils.many(className2)), onMouseOver: handleMouseOver, ref, uik: "HealthBar", ...props2, children: [
      markerElement,
      /* @__PURE__ */ (0, import_jsx_runtime476.jsxs)("div", {
        className: (0, import_uik580.css)(BAR_CONTAINER),
        /* We need a non-breaking space to render the empty bar properly */
        children: [
          totalValue === 0 && /* @__PURE__ */ (0, import_jsx_runtime476.jsx)(import_jsx_runtime476.Fragment, { children: "\xA0" }),
          totalValue > 0 && segments.map(
            (barSegment, index) => (barSegment.value ?? 0) > 0 && /* @__PURE__ */ (0, import_jsx_runtime476.jsxs)("div", { className: (0, import_uik580.css)({ width: getWidth(barSegment.value) }), children: [
              /* @__PURE__ */ (0, import_jsx_runtime476.jsx)(
                "div",
                {
                  className: (0, import_uik580.css)(
                    BAR_SEGMENT,
                    import_uik580.css.Styles({ backgroundColor: getBarColor(barSegment) }),
                    "bar-segment"
                  )
                }
              ),
              /* Hide the label if there is not enough space to render it. It will be shown in the tooltip */
              labelAlign === "UNDERNEATH" && /* @__PURE__ */ (0, import_jsx_runtime476.jsx)("div", { className: (0, import_uik580.css)(LABEL7), children: getWidth(barSegment.value) > LABEL_OVERFLOW_WIDTH && getLabel(
                getDisplayValue(barSegment.value, decimalPlaces, showPercentSign),
                getBarStatus(barSegment.status)
              ) })
            ] }, index)
          )
        ]
      }),
      totalValue > 0 && labelAlign === "LEFT" && /* @__PURE__ */ (0, import_jsx_runtime476.jsx)("div", { className: LABEL_CONTAINER, children: segments.map(
        (barSegment, index) => boundingRect.width > 0 && /* @__PURE__ */ (0, import_jsx_runtime476.jsx)("div", { className: (0, import_uik580.css)(LABEL7, LABEL_ALIGN_LEFT), children: getLabel(
          getDisplayValue(barSegment.value, decimalPlaces, showPercentSign),
          getBarStatus(barSegment.status)
        ) }, index)
      ) }),
      totalValue === 0 && // When the bar has no renderable segments, we display some labels below to show 0 or — next to the status
      /* @__PURE__ */ (0, import_jsx_runtime476.jsx)("div", { className: LABEL_CONTAINER, children: noData && noDataMessage != void 0 ? /* @__PURE__ */ (0, import_jsx_runtime476.jsx)("div", { className: (0, import_uik580.css)(LABEL7), children: noDataMessage }) : segments.map((barSegment, index) => /* @__PURE__ */ (0, import_jsx_runtime476.jsx)("div", { className: (0, import_uik580.css)(LABEL7), children: getLabel(getDisplayValue(barSegment.value), getBarStatus(barSegment.status)) }, index)) })
    ] });
    const tooltipProps = useTooltip2({
      boundingRect,
      cursorPosition,
      decimalPlaces,
      segments,
      showPercentSign
    });
    return /* @__PURE__ */ (0, import_jsx_runtime476.jsx)(import_uik580.Tooltip, { className: tooltipProps.className, value: tooltipProps.value, children: /* @__PURE__ */ (0, import_jsx_runtime476.jsx)(import_uik580.Measurer, { onResize: onResize2, children: healthBarElement }) });
  }
);
HealthBar.displayName = "HealthBar";
HealthBar.__DEV_METADATA__ = { status: "READY" };

// Illustration/Illustration.tsx
var import_uik583 = require("@appd/uik");

// Illustration/getStyles.ts
var import_uik581 = require("@appd/uik");
var {
  COLORS: { DEFAULT_TEXT_WEAK },
  SPACING: SPACING25,
  TYPOGRAPHY: { HEADING_PRIMARY: HEADING_PRIMARY3 }
} = import_uik581.MAGNETIC_TOKENS;
var getStyles18 = /* @__PURE__ */ __name((row, size) => ({
  ACTION: (0, import_uik581.css)({
    marginTop: SPACING25[6],
    paddingBlock: SPACING25[4],
    paddingInline: SPACING25[6]
  }),
  HOST: (0, import_uik581.css)({
    alignItems: "center",
    display: "flex",
    flexDirection: row ? "row" : "column",
    height: "100%",
    justifyContent: row ? "flex-start" : "center",
    overflow: "hidden",
    width: "100%"
  }),
  ICON: (0, import_uik581.css)({
    ...row && size == "XLARGE" ? {
      marginRight: 100,
      maxWidth: 400,
      width: "35%"
    } : {}
  }),
  PRIMARY: (0, import_uik581.css)({
    font: HEADING_PRIMARY3,
    marginTop: size == "XLARGE" ? SPACING25[4] : SPACING25[2],
    textAlign: row ? "start" : "center"
  }),
  SECONDARY: (0, import_uik581.css)({
    color: DEFAULT_TEXT_WEAK,
    marginTop: size == "XLARGE" ? SPACING25[4] : SPACING25[2],
    textAlign: row ? "start" : "center"
  }),
  TEXT: (0, import_uik581.css)({
    ...row ? {
      alignItems: "flex-start",
      marginTop: 0
    } : {
      alignItems: "center",
      marginTop: size == "XLARGE" ? SPACING25[6] : SPACING25[2],
      width: 300
    },
    display: "flex",
    flexDirection: "column"
  })
}), "getStyles");

// Illustration/MESSAGES.ts
var import_uik582 = require("@appd/uik");
var MESSAGES10 = {
  // (object-curly-newline)
  NO_DATA: import_uik582.format.message`No Data`.description("An indicator of there being no data in the component.")
};

// Illustration/Illustration.tsx
var import_jsx_runtime477 = require("react/jsx-runtime");
var Illustration2 = Object.assign(
  import_uik583.utils.forwardRef(
    ({
      action,
      className: className2,
      icon = "",
      onAction,
      primary = "",
      row = false,
      secondary = "",
      size = "LARGE",
      ...inherited
    }, ref) => {
      const { ACTION, HOST: HOST14, ICON: ICON4, PRIMARY, SECONDARY, TEXT: TEXT4 } = getStyles18(row, size);
      return /* @__PURE__ */ (0, import_jsx_runtime477.jsxs)("div", { className: (0, import_uik583.css)(HOST14, ...import_uik583.utils.many(className2)), ref, uik: "Illustration", ...inherited, children: [
        icon && /* @__PURE__ */ (0, import_jsx_runtime477.jsx)(import_uik583.Icon, { className: (0, import_uik583.css)(ICON4), size, type: icon }),
        /* @__PURE__ */ (0, import_jsx_runtime477.jsxs)("div", { className: (0, import_uik583.css)(TEXT4), children: [
          primary && /* @__PURE__ */ (0, import_jsx_runtime477.jsx)("div", { className: PRIMARY, children: primary }),
          secondary && /* @__PURE__ */ (0, import_jsx_runtime477.jsx)("div", { className: SECONDARY, children: secondary }),
          action && /* @__PURE__ */ (0, import_jsx_runtime477.jsx)(import_uik583.Button, { className: ACTION, onClick: onAction, children: action })
        ] })
      ] });
    }
  ),
  { MESSAGES: MESSAGES10 }
);
Illustration2.displayName = "Illustration";
Illustration2.__DEV_METADATA__ = { status: "READY" };

// Input/Input.tsx
var import_uik585 = require("@appd/uik");
var import_react83 = require("react");

// Input/CONTEXT.ts
var import_react82 = require("react");
var CONTEXT8 = (0, import_react82.createContext)(false);

// Input/getStyles.ts
var import_uik584 = require("@appd/uik");
var getStyles19 = /* @__PURE__ */ __name((actionsWidth, isReadOnlyButton, prefixWidth, showErrorStyles) => ({
  ACTIONS: (0, import_uik584.css)({
    height: height - 1,
    // border-width
    position: "absolute",
    right: 0
  }),
  ERROR: (0, import_uik584.css)({ marginTop: SPACING26[2] }),
  HOST: (0, import_uik584.css)({
    maxWidth: 800,
    width: "100%"
  }),
  INPUT: (0, import_uik584.css)({
    "&::placeholder": { color: DEFAULT_TEXT_WEAK2 },
    "&:disabled": {
      backgroundColor: CONTROL_BG_WEAK_DISABLED2,
      border: `2px solid ${CONTROL_BORDER_DISABLED2}`,
      color: DEFAULT_TEXT_DISABLED2,
      cursor: "not-allowed"
    },
    "&:not(:disabled):not(:read-only)": {
      "&:focus": {
        border: `2px solid ${CONTROL_BORDER_FOCUS}`,
        boxShadow: SHADOW_FOCUS
      },
      "&:hover:not(:focus)": { border: `2px solid ${CONTROL_BORDER_HOVER4}` },
      ...showErrorStyles && {
        "&:invalid": {
          "&:focus": {
            border: `2px solid ${NEGATIVE_BORDER_MEDIUM_FOCUS}`,
            boxShadow: SHADOW_FOCUS_NEGATIVE
          },
          "&:hover:not(:focus)": { border: `2px solid ${NEGATIVE_BORDER_MEDIUM_HOVER}` },
          border: `2px solid ${NEGATIVE_BORDER_MEDIUM_ACTIVE}`
        }
      }
    },
    "&:read-only": { backgroundColor: "transparent" },
    backgroundColor: CONTROL_BG_WEAK12,
    border: `2px solid ${CONTROL_BORDER14}`,
    borderRadius: RADIUS13.HEAVY,
    boxSizing: "border-box",
    caretColor: isReadOnlyButton ? "transparent" : void 0,
    color: DEFAULT_TEXT15,
    font: P3_DEFAULT14,
    height,
    outline: "none",
    overflow: "hidden",
    paddingLeft: prefixWidth > 0 ? SPACING26[1] + prefixWidth : 10,
    paddingRight: SPACING26[1] + actionsWidth,
    textOverflow: "ellipsis",
    width: "100%"
  }),
  INPUT_CONTAINER: (0, import_uik584.css)({
    display: "flex",
    position: "relative"
  }),
  PREFIX: (0, import_uik584.css)({
    left: 0,
    position: "absolute"
  })
}), "getStyles");
var height = 34;
var {
  COLORS: {
    CONTROL_BG_WEAK: CONTROL_BG_WEAK12,
    CONTROL_BG_WEAK_DISABLED: CONTROL_BG_WEAK_DISABLED2,
    CONTROL_BORDER: CONTROL_BORDER14,
    CONTROL_BORDER_DISABLED: CONTROL_BORDER_DISABLED2,
    CONTROL_BORDER_FOCUS,
    CONTROL_BORDER_HOVER: CONTROL_BORDER_HOVER4,
    DEFAULT_TEXT: DEFAULT_TEXT15,
    DEFAULT_TEXT_DISABLED: DEFAULT_TEXT_DISABLED2,
    DEFAULT_TEXT_WEAK: DEFAULT_TEXT_WEAK2,
    NEGATIVE_BORDER_MEDIUM_ACTIVE,
    NEGATIVE_BORDER_MEDIUM_FOCUS,
    NEGATIVE_BORDER_MEDIUM_HOVER
  },
  EFFECTS: { SHADOW_FOCUS, SHADOW_FOCUS_NEGATIVE },
  RADIUS: RADIUS13,
  SPACING: SPACING26,
  TYPOGRAPHY: { P3_DEFAULT: P3_DEFAULT14 }
} = import_uik584.MAGNETIC_TOKENS;

// Input/Input.tsx
var import_jsx_runtime478 = require("react/jsx-runtime");
var Input2 = Object.assign(
  import_uik585.utils.forwardRef(
    ({
      actions,
      className: className2,
      disabled = false,
      errors = [],
      hint,
      label,
      name = label,
      onChange,
      overflowTooltip = false,
      prefix,
      readOnly,
      required = false,
      secondaryHint,
      secondaryLabel,
      showOptional,
      tooltip,
      value,
      ...props2
    }, forwardedRef) => {
      const actionsRef = (0, import_react83.useRef)(null);
      const isReadOnlyButton = (0, import_react83.useContext)(CONTEXT8);
      const prefixRef = (0, import_react83.useRef)(null);
      const ref = import_uik585.utils.useBroadcastRef(forwardedRef);
      const { submitted } = (0, import_react83.useContext)(import_uik585.Form.CONTEXT);
      const [actionsWidth, setActionsWidth] = (0, import_react83.useState)(0);
      const [customValidity, setCustomValidity] = (0, import_react83.useState)(true);
      const [requiredValidity, setRequiredValidity] = (0, import_react83.useState)(true);
      const [prefixWidth, setPrefixWidth] = (0, import_react83.useState)(0);
      const [touched, setTouched] = (0, import_react83.useState)(false);
      const [tooltipVisible, setTooltipVisible] = (0, import_react83.useState)(false);
      (0, import_react83.useEffect)(() => {
        setErrors(ref);
      }, [errors, required, value]);
      import_uik585.utils.useLayoutEffect(() => {
        setActionsWidth(actionsRef.current?.offsetWidth ?? 0);
        setPrefixWidth(prefixRef.current?.offsetWidth ?? 0);
      }, [actions]);
      const setErrors = /* @__PURE__ */ __name((ref2) => {
        const requiredError = required && !disabled && !readOnly && ref2?.current?.validity.valueMissing;
        if (ref2.current) {
          ref2.current.setCustomValidity(errors.join(" "));
          ref2.current.errors = [...requiredError ? [import_uik585.Form.MESSAGES.REQUIRED()] : [], ...errors];
        }
        setCustomValidity(!errors.length);
        setRequiredValidity(!requiredError);
      }, "setErrors");
      const { ACTIONS, ERROR, HOST: HOST14, INPUT, INPUT_CONTAINER, PREFIX } = getStyles19(
        actionsWidth,
        isReadOnlyButton,
        prefixWidth,
        touched || submitted || errors.length > 0
      );
      return /* @__PURE__ */ (0, import_jsx_runtime478.jsxs)("div", { className: (0, import_uik585.css)(HOST14, ...import_uik585.utils.many(className2)), uik: "Input", children: [
        /* @__PURE__ */ (0, import_jsx_runtime478.jsx)(
          import_uik585.Form.Label,
          {
            hint,
            label,
            name,
            required,
            secondaryHint,
            secondaryLabel,
            showOptional,
            tooltip,
            children: /* @__PURE__ */ (0, import_jsx_runtime478.jsx)(
              import_uik585.Tooltip,
              {
                onVisibleChange: (visible) => overflowTooltip && setTooltipVisible(visible),
                value,
                visible: disabled && (ref.current?.scrollWidth ?? 1) > (ref.current?.offsetWidth ?? 0) && ref.current?.matches(":hover") && tooltipVisible,
                children: /* @__PURE__ */ (0, import_jsx_runtime478.jsxs)("div", { className: INPUT_CONTAINER, children: [
                  prefix && /* @__PURE__ */ (0, import_jsx_runtime478.jsx)("div", { className: PREFIX, ref: prefixRef, children: prefix }),
                  /* @__PURE__ */ (0, import_jsx_runtime478.jsx)(
                    "input",
                    {
                      autoComplete: "off",
                      className: INPUT,
                      disabled,
                      id: name,
                      name,
                      onBlur: () => setTouched(true),
                      onChange: (e) => {
                        setTouched(true);
                        setErrors(ref);
                        onChange && onChange(e);
                      },
                      onKeyDown: (e) => isReadOnlyButton && e.key !== "Tab" && e.preventDefault(),
                      readOnly,
                      ref,
                      required,
                      value,
                      ...props2
                    }
                  ),
                  actions && /* @__PURE__ */ (0, import_jsx_runtime478.jsx)("div", { className: ACTIONS, ref: actionsRef, children: actions })
                ] })
              }
            )
          }
        ),
        (touched || submitted) && !requiredValidity && !disabled && !readOnly && /* @__PURE__ */ (0, import_jsx_runtime478.jsx)(import_uik585.Form.Validation.Error, { className: ERROR, children: import_uik585.Form.MESSAGES.REQUIRED() }),
        !customValidity && /* @__PURE__ */ (0, import_jsx_runtime478.jsx)(import_jsx_runtime478.Fragment, { children: errors.map((error) => /* @__PURE__ */ (0, import_jsx_runtime478.jsx)(import_uik585.Form.Validation.Error, { className: ERROR, children: error }, error)) })
      ] });
    }
  ),
  { CONTEXT: CONTEXT8 }
);
Input2.displayName = "Input";
Input2.__DEV_METADATA__ = { status: "READY" };

// Layout/Layout.tsx
var import_uik628 = require("@appd/uik");
var import_react91 = require("react");

// Layout/$.ts
var $ = {
  /**
   * Set anywhere that could be clicked, to disable draggging and perform default behavior.
   *
   * Used currently by `onFrameChange` in `clickInside` / `clickOutside`.
   *
   * Likely only effective when used along with `$.INTERACTIVE`.
   */
  ACTIONABLE: "ACTIONABLE",
  /** Toggled on `<Frame>` when mouse is down (but haven't started moving yet). */
  ACTIVE: "ACTIVE",
  /** Toggled on the `<Layout>` when `editing` prop is set. */
  EDITING: "EDITING",
  /**
   * Toggled on `<Frame>` and the item when an item has been selected.
   *
   * (Also used by `<Section>` and `<Group>` to infer their editing state.)
   *
   * Caveat: On `<Frame>` this is toggled as a CSS class, but on the item it is toggled as an element attribute. This
   * is because the item may reset its own class name if it rerender. We must avoid that.
   */
  FOCUSED: "FOCUSED",
  /** More efficient version of `[uik="Layout.Frame"]`. */
  FRAME: "FRAME",
  /** More efficient version of `[uik="Layout.Header"]`. */
  HEADER: "HEADER",
  /**
   * Set on `<Frame>` and an item to allow pointer and keyboard events on the item even while editing.
   *
   * This is used by `<Section>`, `<Group>`, and `<Widget>` since they should have enough padding to give the user
   * some space to drag from.
   */
  INTERACTIVE: "INTERACTIVE",
  /** More efficient version of `[uik="Layout"]`. */
  LAYOUT: "LAYOUT",
  /**
   * Toggled on `<Layout>`, `GRID_PAPER`, `<Preview>`, and the item when mouse has started to move.
   *
   * Caveat: On `<Layout>`, `GRID_PAPER`, and `<Preview>` this is toggled as a CSS class, but on the item it is toggled
   * as an element attribute. This is because the item may reset its own class name if it rerender. We must avoid that.
   */
  MOVING: "MOVING",
  /**
   * Exclude a subtree from being considered actionable. (Drag will work again in this subtree.)
   *
   * If an element is marked both `ACTIONABLE` and `NOT_ACTIONABLE`, only its descendants are actionable, while the
   * element itself is not.
   *
   * Only has effect on a subtree which has already been marked `ACTIONABLE` above somewhere.
   *
   * #### Example
   *
   * ```tsx
   * <Layout>
   *   <div className={$.ACTIONABLE} onClick={() => console.log("👍 Fires!")}>
   *     <div className={$.NOT_ACTIONABLE} onClick={() => console.log("👎 Never fires!")} />
   *
   *     <div onClick={() => console.log("👍 Fires!")} />
   *
   *     <div className={`${$.ACTIONABLE} ${$.NOT_ACTIONABLE}`} onClick={() => console.log("👎 Never fires!")}>
   *       <div onClick={() => console.log("👍 Fires!")} />
   *     </div>
   *   </div>
   * </Layout>
   * ```
   *
   * In the example above, the `👍` logs run, but their elements will not be draggable. The `👎` logs never run (except
   * outside of editing mode), and their elements will be draggable.
   */
  NOT_ACTIONABLE: "NOT_ACTIONABLE",
  /** More efficient version of `[uik="Layout.PERIPHERALS"]`. */
  PERIPHERALS: "PERIPHERALS"
};

// Layout/FEATURE.ts
var FEATURE = {
  /**
   * Circular corner resize handles shown on focus.
   *
   * (Not part of Figma, but user has hard time seeing focus state without this.)
   */
  CORNERS: false,
  /** Grid background shown while moving items.  */
  GRID_PAPER: false
};

// Layout/Group.tsx
var import_uik592 = require("@appd/uik");
var import_react86 = require("react");

// Layout/Header.tsx
var import_uik590 = require("@appd/uik");

// Layout/STYLES.ts
var import_uik586 = require("@appd/uik");
var FOCUS_COLOR = "#3F8AE2";
var OUTLINE_WIDTH = 2.5;
var ITEM2 = import_uik586.css.Styles({
  all: void 0,
  boxSizing: "border-box",
  height: "calc(var(--h) * var(--STEP) - var(--GAP))",
  left: 0,
  position: "absolute",
  top: 0,
  transition: "height, translate, width",
  transitionDuration: "var(--transitionDuration)",
  translate: "calc(var(--x) * var(--STEP)) calc(var(--y) * var(--STEP))",
  width: "calc(var(--w) * var(--STEP) - var(--GAP))",
  zIndex: "var(--i)"
});
var TRANSITION_DURATION = "0.3s";
var STYLES23 = {
  FOCUS_COLOR,
  HOST: (0, import_uik586.css)(
    {
      [`> :not(.${$.PERIPHERALS})`]: ITEM2,
      // Peripherals are hidden, unless...
      [`> .${$.PERIPHERALS}`]: { display: "none" },
      [`&.${$.EDITING}`]: {
        // ...we're editing.
        [`> .${$.PERIPHERALS}`]: { display: "block" },
        // All items (children except peripherals)...
        [`> :not(.${$.PERIPHERALS})`]: {
          // block pointer events of their children,
          [`:not(.${$.INTERACTIVE}) > *`]: { pointerEvents: "none" },
          // but have pointer events themselves.
          pointerEvents: "initial",
          userSelect: "none",
          [`:hover:not(:active):not(:has(.${$.LAYOUT} > :hover)):not([${$.FOCUSED}])`]: (
            // A hovered item, that's not clicked, that doesn't contain another hovered item, should be outlined.
            { outline: `${OUTLINE_WIDTH}px solid ${FOCUS_COLOR}` }
          )
        },
        // Transitions only enabled while editing and moving.
        [`[${$.MOVING}]`]: { "--transitionDuration": TRANSITION_DURATION }
      },
      "--focusColor": FOCUS_COLOR,
      "--outlineWidth": `${OUTLINE_WIDTH}px`,
      "--transitionDuration": 0,
      ":not([id]) > *": { display: "none" },
      contain: "layout size style",
      containIntrinsicSize: "calc(var(--C) * var(--STEP) - var(--GAP)) calc(var(--R) * var(--STEP) - var(--GAP))",
      position: "relative",
      zIndex: 0
    },
    $.LAYOUT
  ),
  ITEM: ITEM2,
  OUTLINE_WIDTH,
  TRANSITION_DURATION
};

// ToggleSwitch/ToggleSwitch.tsx
var import_uik589 = require("@appd/uik");
var import_react84 = require("react");

// ToggleSwitch/getStyles.ts
var import_uik587 = require("@appd/uik");
var getStyles20 = /* @__PURE__ */ __name(({ disabled, label, on }) => ({
  CONTAINER: (0, import_uik587.css)({
    display: "flex",
    flexDirection: "column",
    minHeight: 20 + (label ? 15 + 4 : 0),
    position: "relative"
  }),
  DESCRIPTION: (0, import_uik587.css)({
    color: disabled ? DEFAULT_TEXT_DISABLED3 : DEFAULT_TEXT16,
    font: P3_DEFAULT15,
    marginLeft: 48
  }),
  INPUT: (0, import_uik587.css)({ display: "contents" }),
  LABEL: (0, import_uik587.css)({
    color: DEFAULT_TEXT16,
    font: P3_EMPHASIS6,
    whiteSpace: "nowrap"
  }),
  /* Rounded sliders */
  SLIDER: (0, import_uik587.css)({
    "::before": {
      ":hover": { background: !disabled && CONTROL_ICON_IN_HOVER },
      backgroundColor: CONTROL_ICON_IN3,
      borderRadius: "50%",
      content: '""',
      height: 14,
      marginLeft: 3,
      marginTop: 3,
      position: "absolute",
      transform: on ? "translateX(20px)" : "",
      transition: ".4s",
      width: 14
    },
    ":hover": { background: !disabled && (on ? CONTROL_BG_STRONG_HOVER2 : DEFAULT_BG_STRONG_HOVER) },
    background: disabled ? on ? CONTROL_BG_STRONG_DISABLED : DEFAULT_BG_STRONG_DISABLED : on ? CONTROL_BG_STRONG6 : DEFAULT_BG_STRONG,
    borderRadius: "34px",
    bottom: 0,
    cursor: disabled ? "not-allowed" : "pointer",
    height: 20,
    left: 0,
    position: "absolute",
    right: 0,
    tabindex: 0,
    width: 40
  })
}), "getStyles");
var {
  COLORS: {
    CONTROL_BG_STRONG: CONTROL_BG_STRONG6,
    CONTROL_BG_STRONG_DISABLED,
    CONTROL_BG_STRONG_HOVER: CONTROL_BG_STRONG_HOVER2,
    CONTROL_ICON_IN: CONTROL_ICON_IN3,
    CONTROL_ICON_IN_HOVER,
    DEFAULT_BG_STRONG,
    DEFAULT_BG_STRONG_DISABLED,
    DEFAULT_BG_STRONG_HOVER,
    DEFAULT_TEXT: DEFAULT_TEXT16,
    DEFAULT_TEXT_DISABLED: DEFAULT_TEXT_DISABLED3
  },
  TYPOGRAPHY: { P3_DEFAULT: P3_DEFAULT15, P3_EMPHASIS: P3_EMPHASIS6 }
} = import_uik587.MAGNETIC_TOKENS;

// ToggleSwitch/MESSAGES.ts
var import_uik588 = require("@appd/uik");
var MESSAGES11 = {
  STATUS: import_uik588.format.message`${{
    DISABLED: "disabled",
    OFF: "Off",
    ON: "On"
  }}`.description("ToggleSwitch description of status")
};

// ToggleSwitch/ToggleSwitch.tsx
var import_jsx_runtime479 = require("react/jsx-runtime");
var ToggleSwitch = import_uik589.utils.forwardRef(
  ({ className: className2, disabled = false, label, on, onSwitch, showDescription = false, showOn = false, ...props2 }, ref) => {
    const [rawOn, setRawOn] = (0, import_react84.useState)(on ?? false);
    on ??= rawOn;
    const toggleChecked = disabled ? import_uik589.utils.noop : () => {
      setRawOn(!on);
      onSwitch?.(!on);
    };
    const { CONTAINER: CONTAINER7, DESCRIPTION: DESCRIPTION3, INPUT, LABEL: LABEL7, SLIDER } = getStyles20({
      disabled,
      label: label != null,
      on
    });
    return /* @__PURE__ */ (0, import_jsx_runtime479.jsxs)("div", { className: (0, import_uik589.css)(CONTAINER7, ...import_uik589.utils.many(className2)), ref, uik: "ToggleSwitch", ...props2, children: [
      label && /* @__PURE__ */ (0, import_jsx_runtime479.jsx)("div", { className: LABEL7, children: label }),
      /* @__PURE__ */ (0, import_jsx_runtime479.jsx)("input", { className: INPUT, hidden: true, type: "checkbox" }),
      /* @__PURE__ */ (0, import_jsx_runtime479.jsx)("div", { className: SLIDER, onClick: toggleChecked }),
      (showDescription || showOn) && /* @__PURE__ */ (0, import_jsx_runtime479.jsx)("div", { className: DESCRIPTION3, children: `${on ? STATUS("ON") : STATUS("OFF")}${showDescription && disabled ? ` ${STATUS("DISABLED")}` : ""}` })
    ] });
  }
);
ToggleSwitch.displayName = "ToggleSwitch";
ToggleSwitch.__DEV_METADATA__ = { status: "READY" };
var { STATUS } = MESSAGES11;

// Layout/Header.tsx
var import_jsx_runtime480 = require("react/jsx-runtime");
var Header2 = Object.assign(
  import_uik590.utils.forwardRef(
    ({
      children,
      className: className2,
      compact = false,
      editing: rawEditing,
      filters: __UNIMPLEMENTED__,
      heading,
      input,
      icon,
      onEditingChange,
      onTitleChange,
      size = "SECTION",
      alignToFrame = size === "SECTION",
      title: rawTitle,
      ...inherited
    }, rawRef) => {
      const ref = import_uik590.utils.useBroadcastRef(rawRef);
      const inputRef = import_uik590.utils.useBroadcastRef(input?.ref);
      const [editing, setEditing] = import_uik590.utils.useControlledState(
        false,
        rawEditing,
        import_uik590.utils.useLiveCallback((editing2) => {
          onEditingChange?.(editing2);
          setTextWidth(title);
        })
      );
      const title = rawTitle || (editing ? "" : TITLE2());
      const { setTextWidth: rawSetTextWidth, textWidth } = import_uik590.utils.measureText.use({
        font: {
          PRIMARY: HEADING_PRIMARY4,
          SECTION: HEADING_SECTION2,
          SUB_SECTION: HEADING_SUB_SECTION3
        }[size],
        initialText: title
      });
      const setTextWidth = /* @__PURE__ */ __name((text) => rawSetTextWidth(text || input?.placeholder || ""), "setTextWidth");
      import_uik590.utils.useEffect(
        () => import_uik590.utils.mutationObserver(
          ref.current?.parentElement,
          () => setEditing(ref.current?.parentElement?.matches(`[${$.FOCUSED}]:not([${$.MOVING}])`) ?? false),
          { attributeFilter: [$.FOCUSED.toLowerCase(), $.MOVING.toLowerCase()] }
        ),
        [ref.current?.parentElement]
      );
      const { HEADING, HOST: HOST14, INPUT } = STYLES24({
        alignToFrame,
        compact,
        size,
        textWidth
      });
      return /* @__PURE__ */ (0, import_jsx_runtime480.jsxs)(
        "div",
        {
          className: (0, import_uik590.css)(
            {
              // The 3rd child and onward.
              "> :nth-child(n + 3)": {
                flexShrink: 0,
                order: 1
              },
              alignItems: "center",
              color: DEFAULT_TEXT17,
              display: "flex",
              flexShrink: 0,
              gap: SPACING27[2],
              ...HOST14,
              ...!editing && { "& .EDITING_ONLY": { display: "none" } }
            },
            ...import_uik590.utils.many(className2),
            $.HEADER
          ),
          ref,
          uik: "Layout.Header",
          ...inherited,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime480.jsxs)(
              import_uik590.Heading,
              {
                ...heading,
                className: [
                  {
                    marginRight: "auto",
                    minWidth: 0,
                    ...ELLIPSES14.END,
                    ...HEADING,
                    ...icon && {
                      "> svg": { alignSelf: "center" },
                      display: "flex",
                      gap: SPACING27[1]
                    }
                  },
                  !Number.isNaN(textWidth) && editing && { display: "none" },
                  onTitleChange && $.ACTIONABLE,
                  ...import_uik590.utils.many(heading?.className)
                ],
                onPointerDownCapture: callOriginal(heading?.onPointerDownCapture).then(
                  () => globalThis.requestAnimationFrame(() => inputRef.current?.focus())
                ),
                size,
                children: [
                  icon && /* @__PURE__ */ (0, import_jsx_runtime480.jsx)(import_uik590.Icon, { size: "SMALL", type: icon }),
                  title
                ]
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime480.jsx)(
              import_uik590.Input,
              {
                ...input,
                className: [
                  {
                    alignSelf: "flex-end",
                    marginRight: "auto",
                    maxWidth: "unset",
                    minWidth: 0,
                    zIndex: 1,
                    ...INPUT,
                    "& input": {
                      color: DEFAULT_TEXT_STRONG7,
                      ...INPUT["& input"]
                    }
                  },
                  (Number.isNaN(textWidth) || !editing) && { display: "none" },
                  onTitleChange && $.ACTIONABLE,
                  ...import_uik590.utils.many(input?.className)
                ],
                disabled: input?.disabled ?? !onTitleChange,
                onBlur: callOriginal(input?.onBlur).then(() => setTextWidth(title)),
                onChange: callOriginal(input?.onChange).then(({ currentTarget: { value } }) => {
                  onTitleChange?.(value);
                  setTextWidth(value);
                }),
                onFocus: callOriginal(input?.onFocus).then(() => setTextWidth(title)),
                onKeyDown: callOriginal(input?.onKeyDown).then(
                  ({ currentTarget, key }) => key === "Enter" && currentTarget.blur()
                ),
                ref: inputRef,
                value: input?.value ?? title
              }
            ),
            children
          ]
        }
      );
    }
  ),
  {
    Button: import_uik590.utils.forwardRef(({ className: className2, disabled, onClick, type = "TERTIARY", ...props2 }, ref) => /* @__PURE__ */ (0, import_jsx_runtime480.jsx)(
      import_uik590.Button,
      {
        uik: "Layout.Header.Button",
        ...props2,
        className: [
          {
            font: import_uik590.MAGNETIC_TOKENS.TYPOGRAPHY.P4_EMPHASIS,
            paddingInline: import_uik590.MAGNETIC_TOKENS.SPACING[2]
          },
          onClick && $.ACTIONABLE,
          ...import_uik590.utils.many(className2)
        ],
        disabled: disabled ?? !onClick,
        onClick: (event) => globalThis.requestAnimationFrame(() => onClick?.(event)),
        ref,
        type
      }
    )),
    ToggleSwitch: import_uik590.utils.forwardRef(({ className: className2, disabled, label, onSwitch, ...props2 }, ref) => /* @__PURE__ */ (0, import_jsx_runtime480.jsxs)(
      "div",
      {
        className: (0, import_uik590.css)(
          {
            color: import_uik590.MAGNETIC_TOKENS.COLORS.DEFAULT_TEXT,
            display: "flex",
            font: import_uik590.MAGNETIC_TOKENS.TYPOGRAPHY.FONT_BODY,
            gap: import_uik590.MAGNETIC_TOKENS.SPACING[2]
          },
          ...import_uik590.utils.many(className2)
        ),
        uik: "Layout.Header.ToggleSwitch",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime480.jsx)(
            ToggleSwitch,
            {
              ...props2,
              className: [{ width: 40 }, onSwitch && $.ACTIONABLE],
              disabled: disabled ?? !onSwitch,
              onSwitch,
              ref
            }
          ),
          label
        ]
      }
    ))
  }
);
Header2.displayName = "Layout.Header";
Header2.__DEV_METADATA__ = { status: "IN_PROGRESS" };
var STYLES24 = /* @__PURE__ */ __name(({
  alignToFrame,
  compact,
  size,
  textWidth
}) => {
  const buttonContentSize = {
    PRIMARY: 24,
    SECTION: 24,
    SUB_SECTION: 18,
    __: 18
  }[size];
  const buttonPadding = {
    PRIMARY: 3,
    SECTION: 2,
    SUB_SECTION: 6,
    __: 0
  }[size];
  const BUTTON3 = import_uik590.css.Styles({
    height: buttonContentSize + 2 * buttonPadding,
    minWidth: buttonContentSize + 2 * buttonPadding,
    padding: buttonPadding
  });
  const headingHeight = {
    PRIMARY: 34,
    SECTION: 24,
    SUB_SECTION: 22
  }[size];
  const hostExtraBlockSpace = {
    PRIMARY: 0,
    SECTION: SPACING27[2],
    SUB_SECTION: 2
  }[size];
  const HOST14 = import_uik590.css.Styles({
    "> [uik='Layout.Header.Button']": {
      "> svg": {
        height: buttonContentSize,
        width: buttonContentSize
      },
      ...BUTTON3
    },
    height: headingHeight + hostExtraBlockSpace,
    marginBottom: (compact ? {
      PRIMARY: 0,
      SECTION: 5,
      SUB_SECTION: 5
    } : {
      PRIMARY: SPACING27[6],
      SECTION: SPACING27[4],
      SUB_SECTION: SPACING27[3]
    })[size]
  });
  const {
    inputBorderWidth = 2,
    inputPaddingBlock = compact ? 1.75 : {
      PRIMARY: 5,
      SECTION: 5,
      SUB_SECTION: 4
    }[size]
  } = {};
  const {
    /** Between the `<Input>`'s focus outline and a layout item's focus frame outline.  */
    inputHeight = headingHeight + 2 * (inputPaddingBlock + inputBorderWidth),
    outlineExcess = Math.max(0, SPACING27[1] - STYLES23.OUTLINE_WIDTH)
  } = {};
  const {
    marginBottom = alignToFrame ? HOST14.height - inputHeight - outlineExcess : (HOST14.height - inputHeight) / 2,
    paddingInline = 10
  } = {};
  const INPUT = import_uik590.css.Styles({
    "& input": {
      borderWidth: inputBorderWidth,
      font: {
        PRIMARY: HEADING_PRIMARY4,
        SECTION: HEADING_SECTION2,
        SUB_SECTION: HEADING_SUB_SECTION3
      }[size],
      height: inputHeight,
      paddingBlock: inputPaddingBlock,
      paddingInline
    },
    marginBottom,
    ...alignToFrame && { marginLeft: outlineExcess },
    width: Math.max(30, textWidth + 2 * (paddingInline + inputBorderWidth))
  });
  const HEADING = import_uik590.css.Styles({ alignSelf: size === "SECTION" ? "flex-end" : "center" });
  return {
    HEADING,
    HOST: HOST14,
    INPUT
  };
}, "STYLES");
var callOriginal = /* @__PURE__ */ __name((original) => ({
  then: (callback) => (event) => {
    original?.(event);
    if (!event.defaultPrevented) {
      callback(event);
    }
  }
}), "callOriginal");
var {
  COLORS: { DEFAULT_TEXT: DEFAULT_TEXT17, DEFAULT_TEXT_STRONG: DEFAULT_TEXT_STRONG7 },
  SPACING: SPACING27,
  TYPOGRAPHY: { ELLIPSES: ELLIPSES14, HEADING_PRIMARY: HEADING_PRIMARY4, HEADING_SECTION: HEADING_SECTION2, HEADING_SUB_SECTION: HEADING_SUB_SECTION3 }
} = import_uik590.MAGNETIC_TOKENS;
var TITLE2 = import_uik590.format.message`Title`.description(
  "Default title of editable 'Header' component. This is used in 'Section', 'Group', and 'Widget' components in a dashboard layout."
);

// Layout/Provider.tsx
var import_uik591 = require("@appd/uik");
var import_react85 = require("react");
var import_jsx_runtime481 = require("react/jsx-runtime");
var Provider3 = /* @__PURE__ */ __name(({
  children,
  defaults,
  group,
  onChange,
  onResize: onResize2,
  saved,
  section,
  widget,
  ...rest
}) => {
  const parent = (0, import_react85.useContext)(Provider3.CONTEXT);
  const ref = (0, import_react85.useRef)();
  const initial = {
    onChange: import_uik591.utils.useLiveCallback((...args) => {
      parent.context.onChange(...args);
      onChange?.(...args);
    }),
    onResize: import_uik591.utils.useLiveCallback((...args) => {
      parent.context.onResize(...args);
      onResize2?.(...args);
    })
  };
  const { context } = ref.current ??= {
    context: {
      defaults: import_uik591.utils.cell.initWithInput({}),
      group: import_uik591.utils.cell.initWithInput({}),
      onChange: initial.onChange,
      onResize: initial.onResize,
      parent: parent && import_uik591.utils.cell.initWithInput(parent),
      rest: import_uik591.utils.cell.initWithInput({}),
      saved: { __proto__: parent.context.saved },
      section: import_uik591.utils.cell.initWithInput({}),
      widget: import_uik591.utils.cell.initWithInput({})
    }
  };
  const changed = {
    defaults: ((changed2 = false) => {
      import_uik591.utils.cell(
        context.defaults,
        (0, import_react85.useMemo)(
          () => ({
            ...parent.context.defaults.output,
            ...defaults
          }),
          [defaults, parent.context.defaults.output]
        ),
        (input) => {
          changed2 = true;
          return {
            ...context.defaults.output,
            ...input
          };
        }
      );
      return changed2;
    })(),
    group: ((changed2 = false) => {
      import_uik591.utils.cell(
        context.group,
        (0, import_react85.useMemo)(
          () => ({
            ...parent.context.group.output,
            ...group
          }),
          [group, parent.context.group.output]
        ),
        (input) => {
          changed2 = true;
          return {
            ...context.group.output,
            ...input
          };
        }
      );
      return changed2;
    })(),
    parent: ((changed2 = false) => {
      context.parent && import_uik591.utils.cell(context.parent, { parent }, () => {
        changed2 = true;
        return parent;
      });
      return changed2;
    })(),
    rest: ((changed2 = false) => {
      import_uik591.utils.cell(
        context.rest,
        (0, import_react85.useMemo)(
          () => ({
            ...parent.context.rest.output,
            ...rest
          }),
          [rest, parent.context.rest.output]
        ),
        (input) => {
          changed2 = true;
          return {
            ...context.rest.output,
            ...input
          };
        }
      );
      return changed2;
    })(),
    saved: ((changed2 = false) => {
      saved && Object.entries(saved).forEach(
        ([id, value]) => value && import_uik591.utils.cell(context.saved[id] ??= import_uik591.utils.cell.init({}), [JSON.stringify(value)], () => {
          changed2 = true;
          return Array.isArray(saved[id]) ? (
            // Migrate old snapshot format.
            { items: value }
          ) : value;
        })
      );
      return changed2;
    })(),
    section: ((changed2 = false) => {
      import_uik591.utils.cell(
        context.section,
        (0, import_react85.useMemo)(
          () => ({
            ...parent.context.section.output,
            ...section
          }),
          [section, parent.context.section.output]
        ),
        (input) => {
          changed2 = true;
          return {
            ...context.section.output,
            ...input
          };
        }
      );
      return changed2;
    })(),
    widget: ((changed2 = false) => {
      import_uik591.utils.cell(
        context.widget,
        (0, import_react85.useMemo)(
          () => ({
            ...parent.context.widget.output,
            ...widget
          }),
          [widget, parent.context.widget.output]
        ),
        (input) => {
          changed2 = true;
          return {
            ...context.widget.output,
            ...input
          };
        }
      );
      return changed2;
    })()
  };
  ref.current = // Invalidate on `parent` change because prototype of `context.saved` could have changed.
  // No efficient way to detect the exact change or lack of.
  changed.defaults || changed.group || changed.parent || changed.rest || changed.saved || changed.section || changed.widget ? { context } : ref.current;
  return (0, import_react85.useMemo)(
    () => /* @__PURE__ */ (0, import_jsx_runtime481.jsx)(Provider3.CONTEXT.Provider, { value: ref.current, children }),
    [children, ref.current]
  );
}, "Provider");
Provider3.CONTEXT = (0, import_react85.createContext)({
  context: {
    defaults: import_uik591.utils.cell.initWithInput({}),
    group: import_uik591.utils.cell.initWithInput({}),
    onChange: import_uik591.utils.noop,
    onResize: import_uik591.utils.noop,
    parent: null,
    rest: import_uik591.utils.cell.initWithInput({}),
    saved: {},
    section: import_uik591.utils.cell.initWithInput({}),
    widget: import_uik591.utils.cell.initWithInput({})
  }
});
Provider3.displayName = "Layout.Provider";
Provider3.__DEV_METADATA__ = { status: "IN_PROGRESS" };

// Layout/Group.tsx
var import_jsx_runtime482 = require("react/jsx-runtime");
var Group4 = Object.assign(
  import_uik592.utils.forwardRef(
    ({
      children,
      className: className2,
      compact: rawCompact,
      controls,
      editing: rawEditing,
      icon,
      layout,
      onDelete: rawOnDelete,
      onDuplicate: rawOnDuplicate,
      onTitleChange: rawOnTitleChange,
      title: rawTitle,
      ...inherited
    }, forwardedRef) => {
      const headerRef = (0, import_react86.useRef)(null);
      const layoutRef = import_uik592.utils.useBroadcastRef(layout?.ref);
      const [id, setId2] = (0, import_react86.useState)("");
      import_uik592.utils.useLayoutEffect(() => setId2(layoutRef.current?.api.state.id ?? ""), []);
      const {
        context: {
          group: { output: group },
          rest: { output: rest },
          section: { output: section }
        }
      } = (0, import_react86.useContext)(Provider3.CONTEXT);
      const saved = id && layoutRef.current?.api ? (layoutRef.current.api.state.context.saved[id] ??= import_uik592.utils.cell.init(
        {}
      )).output.group ??= {} : void 0;
      if (saved && rawTitle != null) {
        saved.title = rawTitle;
      }
      const [editing, setEditing] = (0, import_react86.useState)(rawEditing);
      const {
        compact = rawCompact ?? section.compact ?? false,
        onDelete = rawOnDelete ?? group.onDelete,
        onDuplicate = rawOnDuplicate ?? group.onDuplicate,
        onTitleChange = rawOnTitleChange ?? group.onTitleChange,
        title = rawTitle || saved?.title || (editing ? "" : MESSAGES12.NEW_GROUP())
      } = {};
      const [, rerender] = (0, import_react86.useReducer)((i) => i + 1, 0);
      const initial = { groupContext: (0, import_react86.useContext)(Group4.CONTEXT) };
      const groupContext = (0, import_react86.useRef)().current ??= { parent: initial.groupContext };
      const HAS_NESTED_HOVER = "--HAS_NESTED_HOVER";
      return /* @__PURE__ */ (0, import_jsx_runtime482.jsxs)(
        "div",
        {
          className: (0, import_uik592.css)(
            {
              backgroundColor: import_uik592.MAGNETIC_TOKENS.COLORS.CONTROL_BG_WEAK,
              ...rest.editing && rawEditing !== false ? !editing && {
                [`:hover > .${$.HEADER} > .SHOW_ON_HOVER`]: (
                  // Not using `display` to avoid flickering the dropdown on option click, because dropdown
                  // overlay needs to measure its anchor position.
                  { visibility: `var(${HAS_NESTED_HOVER}, visible)` }
                ),
                [`> .${$.HEADER} > .SHOW_ON_HOVER`]: { visibility: "hidden" },
                [`> .${$.LAYOUT}`]: { pointerEvents: "none" }
              } : { [`> .${$.HEADER} > .SHOW_ON_HOVER`]: { display: "none" } },
              ...groupContext.parent ? {
                border: `2px solid ${import_uik592.MAGNETIC_TOKENS.COLORS.CONTROL_BORDER_WEAK}`,
                borderRadius: import_uik592.MAGNETIC_TOKENS.RADIUS.HEAVY,
                padding: import_uik592.MAGNETIC_TOKENS.SPACING[4]
              } : {
                borderRadius: import_uik592.MAGNETIC_TOKENS.SPACING[3],
                boxShadow: import_uik592.MAGNETIC_TOKENS.EFFECTS.SHAODW_LIFTED,
                padding: import_uik592.MAGNETIC_TOKENS.SPACING[compact ? 4 : 6]
              }
            },
            $.INTERACTIVE,
            ...import_uik592.utils.many(className2)
          ),
          ref: forwardedRef,
          uik: "Layout.Group",
          ...inherited,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime482.jsxs)(
              Header2,
              {
                className: {
                  ...!id && { opacity: 0 },
                  zIndex: 1
                },
                compact,
                editing: rawEditing,
                icon,
                input: { placeholder: MESSAGES12.ENTER_GROUP_TITLE() },
                onEditingChange: setEditing,
                onTitleChange: (rawTitle == null || onTitleChange) && ((title2) => {
                  if (saved && rawTitle == null) {
                    saved.title = title2;
                    rerender();
                  }
                  onTitleChange?.(title2, id);
                }),
                ref: headerRef,
                size: "SUB_SECTION",
                title,
                children: [
                  controls ? /* @__PURE__ */ (0, import_jsx_runtime482.jsxs)(
                    import_uik592.Dropdown,
                    {
                      contentClassName: (0, import_uik592.css)({ width: "fit-content" }),
                      icon: /* @__PURE__ */ (0, import_jsx_runtime482.jsx)(import_uik592.Icon.Navigation.MoreHorizontal, {}),
                      kind: "TERTIARY",
                      triggerClassName: (0, import_uik592.css)(
                        {
                          ...!title && {
                            alignSelf: "flex-start",
                            backgroundColor: import_uik592.MAGNETIC_TOKENS.COLORS.INTERACT_BG_WEAK_HOVER,
                            marginLeft: "auto",
                            marginRight: 2,
                            marginTop: 2,
                            zIndex: 10
                          }
                        },
                        "SHOW_ON_HOVER",
                        $.ACTIONABLE
                      ),
                      children: [
                        /* @__PURE__ */ (0, import_jsx_runtime482.jsxs)(
                          import_uik592.Dropdown.Option,
                          {
                            className: [
                              {
                                "> span": {
                                  alignItems: "center",
                                  display: "flex",
                                  gap: import_uik592.MAGNETIC_TOKENS.SPACING[2]
                                }
                              },
                              $.ACTIONABLE
                            ],
                            disabled: !onDuplicate,
                            onPointerDown: onDuplicate && (() => onDuplicate?.({ TODO: [{ _: "UNIMPLEMENTED" }] }, id)),
                            children: [
                              /* @__PURE__ */ (0, import_jsx_runtime482.jsx)(
                                import_uik592.Icon.Action.Duplicate,
                                {
                                  ...!onDuplicate && { fill: import_uik592.MAGNETIC_TOKENS.COLORS.INTERACT_ICON_WEAK_DISABLED }
                                }
                              ),
                              "Duplicate"
                            ]
                          }
                        ),
                        /* @__PURE__ */ (0, import_jsx_runtime482.jsxs)(
                          import_uik592.Dropdown.Option,
                          {
                            className: [
                              {
                                "> span": {
                                  alignItems: "center",
                                  display: "flex",
                                  gap: import_uik592.MAGNETIC_TOKENS.SPACING[2]
                                }
                              },
                              $.ACTIONABLE
                            ],
                            disabled: !onDelete,
                            onPointerDown: onDelete && (() => onDelete?.(Layout.snapshot.delete(id), id)),
                            children: [
                              /* @__PURE__ */ (0, import_jsx_runtime482.jsx)(
                                import_uik592.Icon.Action.Delete,
                                {
                                  ...!onDelete && { fill: import_uik592.MAGNETIC_TOKENS.COLORS.INTERACT_ICON_WEAK_DISABLED }
                                }
                              ),
                              "Delete"
                            ]
                          }
                        )
                      ]
                    }
                  ) : /* @__PURE__ */ (0, import_jsx_runtime482.jsxs)(import_jsx_runtime482.Fragment, { children: [
                    /* @__PURE__ */ (0, import_jsx_runtime482.jsx)(
                      Header2.Button,
                      {
                        className: "SHOW_ON_HOVER",
                        icon: "Action.Duplicate",
                        onClick: onDuplicate && (() => onDuplicate?.({ TODO: [{ _: "UNIMPLEMENTED" }] }, id))
                      }
                    ),
                    /* @__PURE__ */ (0, import_jsx_runtime482.jsx)(
                      Header2.Button,
                      {
                        className: "SHOW_ON_HOVER",
                        icon: "Action.Delete",
                        onClick: onDelete && (() => onDelete?.(Layout.snapshot.delete(id), id))
                      }
                    )
                  ] }),
                  controls
                ]
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime482.jsx)(Group4.CONTEXT.Provider, { value: groupContext, children: /* @__PURE__ */ (0, import_jsx_runtime482.jsx)(
              Layout,
              {
                ...layout,
                gap: layout?.gap ?? import_uik592.MAGNETIC_TOKENS.SPACING[compact ? 4 : 6],
                onMouseEnter: (event) => {
                  layout?.onMouseEnter?.(event);
                  if (!event.defaultPrevented) {
                    headerRef.current?.style.setProperty(HAS_NESTED_HOVER, "hidden");
                  }
                },
                onMouseLeave: (event) => {
                  layout?.onMouseLeave?.(event);
                  if (!event.defaultPrevented) {
                    headerRef.current?.style.removeProperty(HAS_NESTED_HOVER);
                  }
                },
                ref: layoutRef,
                children
              }
            ) })
          ]
        }
      );
    }
  ),
  { CONTEXT: (0, import_react86.createContext)(null) }
);
Group4.displayName = "Layout.Group";
Group4.__DEV_METADATA__ = { status: "IN_PROGRESS" };
var MESSAGES12 = {
  ENTER_GROUP_TITLE: import_uik592.format.message`Enter group title`.description(
    "Placeholder text for a 'Group' title input field in a dashboard"
  ),
  NEW_GROUP: import_uik592.format.message`New Group`.description("Default title for a new 'Group' in a dashboard")
};

// Layout/PARENT.ts
var import_react87 = require("react");
var PARENT = (0, import_react87.createContext)({
  children: /* @__PURE__ */ new Map(),
  parent: null,
  propsRef: null,
  rerender: null,
  state: null
});

// Layout/query.ts
var import_uik593 = require("@appd/uik");
var query = {
  SELECTOR: "[uik='Layout']",
  /** Given a starting `element`, find all `<div uik="Layout">` DOM elements. */
  all: (element = document.body, initialized = true) => element ? Array.from(element.querySelectorAll(query.SELECTOR)).filter(
    (element2) => query.is(element2, initialized)
  ) : [],
  /** Given a starting `element`, find the first child `<Layout>`. */
  child: (element, initialized = true) => {
    const candidate = element?.querySelector(query.SELECTOR);
    return query.is(candidate, initialized) ? candidate : null;
  },
  /**
   * Given a starting `element`, find all the logical children.
   *
   * This is different from `.all()` because only direct logical children are included instead of the entire subtree.
   *
   * A "logic child" is one that matches `.child(element)`. (This is not necessarily a DOM child.)
   *
   * Example:
   *
   * ```tsx
   * <div id="theElementArgument"> // 👈 Pretend this is the `element` argument.
   *   <div id="/0" uik="Layout" />
   *   <div id="/1" uik="Layout">
   *     <div id="/1/0" uik="Layout" />
   *   </div>
   *   <div>
   *     <div id="/2" uik="Layout" />
   *   </div>
   * </div>
   *
   * Layout.query.children(document.getElementById("theElementArgument"))
   * // =>
   * // [
   * //   <div id="/0" uik="Layout" />,
   * //   <div id="/1" uik="Layout" />,
   * //   <div id="/2" uik="Layout" />,
   * // ]
   * ```
   *
   * Notice how `<div id="/1/0" uik="Layout" />` was excluded, because it is a "grandchild" not a direct "child".
   * Meanwhile, `<div id="/2" uik="Layout" />` was included, because it is a direct (logical) "child", even though it
   * is not a direct DOM child.
   */
  children: (element, initialized = true) => {
    if (!element) {
      return [];
    }
    const children = [];
    for (let child = query.child(element, initialized); child; ) {
      children.push(child);
      const next = import_uik593.utils.getNextElement(child, query.SELECTOR, { recurseUp: (parent) => element.contains(parent) });
      child = query.is(next, initialized) ? next : null;
    }
    return children;
  },
  /** Shorthand for `is(document.getElementById(id), initialized) ? document.getElementById(id) : null`. */
  id: (id, initialized = true) => {
    const candidate = document.getElementById(id);
    return query.is(candidate, initialized) ? candidate : null;
  },
  /** Whether `element` is an `<Layout>` element. */
  is: (element, initialized = true) => element instanceof Element && element.getAttribute("uik") === "Layout" && (!initialized || "api" in element),
  /** Given a starting `child` element, find its closest parent `<Layout>` element. */
  parent: (child, initialized = true) => {
    if (!(child instanceof Element) || child?.parentElement == null) {
      return null;
    }
    const candidate = child.parentElement.closest(query.SELECTOR);
    return query.is(candidate, initialized) ? candidate : null;
  }
};

// Layout/readItemOrder.ts
var import_uik594 = require("@appd/uik");
var readItemOrder = /* @__PURE__ */ __name((eventTarget) => {
  if (!import_uik594.utils.CAN_USE_DOM || !(eventTarget instanceof Element)) {
    return;
  }
  const i = parseFloat(getComputedStyle(eventTarget).getPropertyValue("--i"));
  const isLayoutFrame = eventTarget.getAttribute("uik") === "Layout.Frame";
  return Number.isInteger(i) && !isLayoutFrame ? i : void 0;
}, "readItemOrder");

// Layout/render/className.ts
var import_uik595 = require("@appd/uik");
var className = /* @__PURE__ */ __name(({
  api: { parent },
  className: className2,
  exactLengths: {
    output: { gap }
  },
  props: { className: rawClassName, editing, step }
}) => import_uik595.utils.cell(
  className2,
  {
    editing,
    gap,
    parent,
    rawClassName,
    step
  },
  () => [
    STYLES23.HOST,
    // 👆 Excluded from below to avoid selector complexity explosion. (10s slowdown observed in `aws:elbOverview`.)
    // Since `STYLES.HOST` is rendered statically, it will still defer to `rawClassName` as desired.
    (0, import_uik595.css)(
      parent.parent ? (
        // Declared one level below to not interfere with vars from parent layout.
        {
          "> *": {
            "--GAP": gap,
            "--STEP": step
          }
        }
      ) : {
        "--GAP": gap,
        "--STEP": step
      },
      ...import_uik595.utils.many(rawClassName)
    ),
    editing && $.EDITING
  ].filter(Boolean).join(" ")
), "className");

// Layout/render/cleanItems.ts
var import_uik597 = require("@appd/uik");

// Layout/normalizeOrder.ts
var import_uik596 = require("@appd/uik");
var normalizeOrder = /* @__PURE__ */ __name((items, dropOrderIfPossible = true) => {
  const { canOmit, normalized } = items.map((item, index) => ({
    index,
    item: item ?? {}
  })).sort(({ item: { order: a = 0 } }, { item: { order: b = 0 } }) => import_uik596.utils.byLessThan(a, b)).map(({ index, item }, order) => ({
    index,
    item: Object.assign({}, item, { order })
  })).reduce(
    ({ canOmit: canOmit2, normalized: normalized2 }, { index, item }) => {
      canOmit2 &&= item.order === index;
      normalized2[index] = item;
      return {
        canOmit: canOmit2,
        normalized: normalized2
      };
    },
    {
      canOmit: dropOrderIfPossible,
      normalized: []
    }
  );
  return canOmit ? normalized.map(({ order: _, ...item }) => item) : normalized;
}, "normalizeOrder");

// Layout/render/cleanItems.ts
var cleanItems = /* @__PURE__ */ __name(({ current: { items } }, {
  cleanItems: cleanItems2,
  context,
  id,
  onChildrenChange: { epoch },
  refs: {
    host: { current: host }
  }
}) => {
  if (!id) {
    return cleanItems2.output;
  }
  const saved = (context.saved[id] ??= import_uik597.utils.cell.init({})).output;
  return import_uik597.utils.cell(
    cleanItems2,
    {
      epoch,
      host,
      id,
      items,
      saved
    },
    (input, changed) => {
      const { id: id2, saved: saved2, items: items2 = saved2.items ?? [] } = input;
      if (!host || host.children.length <= 1) {
        return import_uik597.utils.LOG.IF(Layout.VERBOSE)("\u{1F9F9}", id2, Math.round(performance.now()), changed, []);
      }
      const ordered = normalizeOrder(items2, false);
      const byId = import_uik597.utils.group(ordered).by((item) => item.id ?? "");
      const mounted = Array.from(host.children).reduce((mounted2, { id: id3 }, i, { [i + 1]: hasNext }) => {
        if (!hasNext) {
          return mounted2;
        }
        const item = import_uik597.utils.omit("unmounted").from((byId.get(id3) ?? byId.get(""))?.shift() ?? {});
        mounted2.push(item);
        return mounted2;
      }, []);
      const unmounted = [...byId.values()].flatMap(
        (items3) => items3.map((item) => ({
          ...item,
          unmounted: true
        }))
      );
      saved2.items = [...mounted, ...unmounted];
      if (items2 === saved2.items) {
        input.items = saved2.items;
      }
      return import_uik597.utils.LOG.IF(Layout.VERBOSE)(
        "\u{1F9F9}",
        /* exclude from dependencies */
        id2,
        Math.round(performance.now()),
        changed,
        saved2.items
      );
    }
  );
}, "cleanItems");

// Layout/render/effect.ts
var import_uik598 = require("@appd/uik");

// Layout/render/renderItemCss.ts
var renderItemCss = /* @__PURE__ */ __name((element, item, forceTransition) => {
  if (!element || !(element instanceof HTMLElement) || !item) {
    return;
  }
  const { h, i, w, x, y } = item;
  const previous = {
    i: +element.style.getPropertyValue("--i") || NaN,
    transition: element.style.getPropertyValue("transition")
  };
  const disableTransition = forceTransition == null ? +previous.i !== i && previous.transition !== "none" : !forceTransition;
  if (disableTransition) {
    element.style.transition = "none";
  }
  element.style.setProperty("--h", String(h));
  element.style.setProperty("--i", String(i));
  element.style.setProperty("--w", String(w));
  element.style.setProperty("--x", String(x));
  element.style.setProperty("--y", String(y));
  if (disableTransition) {
    element.offsetHeight;
    element.style.transition = previous.transition;
  }
}, "renderItemCss");
renderItemCss.all = (element, items, positions2, forceTransition) => {
  if (element) {
    for (const [i, { h, index, unmounted, w }] of items.entries()) {
      if (unmounted) {
        continue;
      }
      renderItemCss(
        element.children[index],
        {
          h,
          i,
          w,
          x: positions2[i].x,
          y: positions2[i].y
        },
        forceTransition
      );
    }
  }
};

// Layout/render/effect.ts
var effect = /* @__PURE__ */ __name(({
  container,
  effect: effect2,
  exactLengths: {
    output: { gap, items }
  },
  frame: { dragging, focused },
  id,
  onChildrenChange: { epoch },
  onResize: {
    handler: { output: onResize2 }
  },
  positions: {
    output: { positions: positions2 }
  },
  props: { step },
  refs,
  vars: { output: vars2 }
}) => !id ? effect2.output : import_uik598.utils.cell(
  effect2,
  {
    container,
    dragging,
    epoch,
    focused,
    gapOrStep: [gap, step].join(),
    id,
    items,
    onResize: onResize2,
    positions: positions2,
    vars: vars2
  },
  (input, { \u0394container, \u0394dragging, \u0394focused, \u0394gapOrStep, \u0394items, \u0394vars, ...changed }) => {
    const pending = effect2.output;
    Layout.VERBOSE && console.log("\u{1F4C6}", id, Math.round(performance.now()), {
      \u0394container,
      \u0394dragging,
      \u0394focused,
      \u0394gapOrStep,
      \u0394items,
      \u0394vars,
      ...changed
    });
    return () => {
      pending?.();
      Layout.VERBOSE && console.log("\u{1F3A8}", id, Math.round(performance.now()), vars2);
      const {
        frame: { current: frame },
        host: { current: host },
        preview: { current: preview }
      } = refs;
      if (\u0394gapOrStep) {
        onResize2();
      }
      if (\u0394vars) {
        if (host) {
          Object.entries(vars2).forEach(([key, value]) => host.style.setProperty(key, value));
        } else {
          input.vars = \u0394vars.old;
        }
        if (preview) {
          Object.entries(vars2).forEach(([key, value]) => preview.style.setProperty(key, value));
        } else {
          input.vars = \u0394vars.old;
        }
      }
      if (\u0394gapOrStep) {
        if (preview) {
          preview.style.setProperty("--GAP", `${gap}px`);
          preview.style.setProperty("--STEP", `${step}px`);
        } else {
          input.gapOrStep = \u0394gapOrStep.old;
        }
      }
      const isRevealing = \u0394container?.old?.height === 0 && \u0394container?.old.width === 0;
      renderItemCss.all(host, items, positions2, isRevealing ? false : void 0);
      if (\u0394dragging || \u0394focused || \u0394items) {
        if (\u0394focused && host) {
          Array.prototype.forEach.call(host?.children, (child) => child.toggleAttribute($.FOCUSED, false));
          host?.children[items[focused]?.index]?.toggleAttribute($.FOCUSED, true);
        }
        if (frame) {
          if (items[focused]) {
            const item = host.children[items[focused].index];
            frame.classList.toggle($.FOCUSED, true);
            frame.classList.toggle($.INTERACTIVE, item.classList.contains($.INTERACTIVE));
            if (Layout.FEATURE.CORNERS) {
              frame.style.removeProperty("borderRadius");
              frame.classList.toggle("DISABLE_CORNERS", false);
            } else {
              frame.style.borderRadius = getComputedStyle(item).borderRadius;
              frame.classList.toggle("DISABLE_CORNERS", true);
            }
            frame.setAttribute("stats", `${items[focused].w} \xD7 ${items[focused].h}`);
            renderItemCss(frame, {
              h: items[focused].h,
              i: focused,
              w: items[focused].w,
              x: positions2[focused].x,
              y: positions2[focused].y
            });
          } else {
            frame.classList.toggle($.FOCUSED, false);
            frame.classList.toggle($.INTERACTIVE, false);
          }
        } else {
          input.dragging = \u0394dragging?.old;
          input.focused = \u0394focused?.old;
          input.items = \u0394items?.old;
        }
      }
      effect2.output = void 0;
    };
  }
), "effect");

// Layout/render/exactLengths.ts
var import_uik601 = require("@appd/uik");

// Layout/getExactLengths/getExactLengths.ts
var import_uik600 = require("@appd/uik");

// Layout/getExactLengths/convert.ts
var import_uik599 = require("@appd/uik");
var convert = /* @__PURE__ */ __name((options) => {
  const { columns, round: round2 = Math.floor } = options;
  return {
    toExact: (length) => Math.max(
      typeof length === "string" ? round2(
        length.endsWith("%") ? percent2(length, columns) : length.includes("/") ? fraction(length, columns) : (
          // Don't know what this is. Coerce to number.
          parseFloat(length)
        )
      ) : typeof length === "object" ? import_uik599.utils.clamp(convert(options).toExact(length.value), [
        length.min && convert(options).toExact(length.min),
        length.max && convert(options).toExact(length.max)
      ]) : round2(length),
      0
    ) || 0
  };
}, "convert");
var fraction = /* @__PURE__ */ __name((value, columns) => {
  const [numerator, denominator] = value.split("/", 2);
  return parseFloat(numerator) * // Multiple before divide to avoid precision loss.
  columns / parseFloat(denominator);
}, "fraction");
var percent2 = /* @__PURE__ */ __name((value, columns) => parseFloat(value) * columns / 100, "percent");

// Layout/getExactLengths/getExactLengths.ts
var getExactLengths = /* @__PURE__ */ __name(({
  defaults = {},
  gap: rawGap,
  items: rawItems = [],
  step,
  width
}) => {
  rawGap ||= 0;
  const columns = Math.max(Math.floor((width + rawGap) / step), 1);
  const { toExact } = convert({ columns });
  const { items, minSize } = rawItems.reduce(
    ({ items: items2, minSize: minSize2 }, item, index) => {
      const maxH = item.maxH == null && defaults.maxH == null ? void 0 : toExact(item.maxH ?? defaults.maxH);
      const maxW = item.maxW == null && defaults.maxW == null ? void 0 : toExact({
        max: columns,
        value: item.maxW ?? defaults.maxW
      });
      const minH = toExact({
        min: 1,
        value: item.minH ?? defaults.minH ?? 1
      });
      const minW = toExact({
        min: 1,
        value: item.minW ?? defaults.minW ?? 1
      });
      const order = item.order ?? 0;
      const h = toExact({
        max: maxH,
        min: minH,
        value: item.h ?? defaults.h ?? minH
      });
      const x = item.x == null ? void 0 : toExact({
        max: columns - minW,
        value: [...import_uik600.utils.many(item.x)].reduce((total, x2) => total + toExact(x2), 0)
      });
      const w = toExact({
        max: x == null ? maxW : {
          max: maxW,
          value: columns - x
        },
        min: minW,
        value: item.w ?? defaults.w ?? "100%"
      });
      const y = item.y == null ? void 0 : [...import_uik600.utils.many(item.y)].reduce((total, y2) => total + toExact(y2), 0);
      items2.push({
        h,
        ...item.id && { id: item.id },
        index,
        ...(item.maxH ?? defaults.maxH) && { maxH },
        ...(item.maxW ?? defaults.maxW) && { maxW },
        ...(item.minH ?? defaults.minH) && { minH },
        ...(item.minW ?? defaults.minW) && { minW },
        order,
        ...item.unmounted && { unmounted: true },
        w,
        x,
        y
      });
      return {
        items: items2,
        minSize: item.unmounted ? minSize2 : Math.min(minSize2, h, w)
      };
    },
    {
      items: [],
      minSize: columns
    }
  );
  const gap = Math.min(rawGap, 0.5 * minSize * step);
  return gap < rawGap ? getExactLengths({
    defaults,
    gap,
    items: rawItems,
    step,
    width
  }) : {
    columns,
    gap,
    items: items.sort(({ order: a }, { order: b }) => a - b),
    toExact
  };
}, "getExactLengths");
getExactLengths.convert = convert;

// Layout/render/exactLengths.ts
var exactLengths = /* @__PURE__ */ __name(({
  cleanItems: { output: cleanItems2 },
  container: { width },
  exactLengths: exactLengths2,
  id,
  props: {
    defaults: { output: defaults },
    gap,
    step
  }
}) => !id ? exactLengths2.output : import_uik601.utils.cell(
  exactLengths2,
  {
    cleanItems: cleanItems2,
    defaults,
    gap,
    step,
    width
  },
  (_, changed) => import_uik601.utils.LOG.IF(Layout.VERBOSE)(
    "\u{1FA9A}",
    /* exclude from dependencies */
    id,
    Math.round(performance.now()),
    changed,
    getExactLengths({
      defaults,
      gap,
      items: cleanItems2,
      step,
      width
    })
  )
), "exactLengths");

// Layout/render/frameHandler/frameHandler.ts
var import_uik609 = require("@appd/uik");

// Layout/render/frameHandler/clickThrough.ts
var clickThrough = /* @__PURE__ */ __name((event, lastClicked, {
  id,
  onFrameChange: {
    output: { clickOutside }
  },
  refs: {
    frame: { current: frame },
    host: { current: ownHost },
    preview: { current: preview }
  }
}) => {
  if (!frame || !preview || Date.now() >= lastClicked + clickThrough.DELAY_MS) {
    return false;
  }
  Layout.VERBOSE && console.log("\u{1F50D}", id, Math.round(performance.now()));
  const original = [preview.style.pointerEvents, frame.style.pointerEvents];
  [preview.style.pointerEvents, frame.style.pointerEvents] = ["auto", "none"];
  try {
    const clickThroughTarget = document.elementFromPoint(event.clientX, event.clientY);
    const host = Layout.query.parent(clickThroughTarget);
    if (host && host !== ownHost) {
      const forwardedEvent = Object.defineProperties(event, {
        target: {
          configurable: true,
          value: clickThroughTarget
        }
      });
      host.api.state.onFrameChange.output.clickInside(forwardedEvent);
      if (host.api.state.frame.focused !== -1) {
        clickOutside(forwardedEvent);
        return true;
      }
    }
  } finally {
    [preview.style.pointerEvents, frame.style.pointerEvents] = original;
  }
  return false;
}, "clickThrough");
clickThrough.DELAY_MS = 500;

// Layout/render/frameHandler/commitChange/commitChange.ts
var import_uik604 = require("@appd/uik");

// Layout/render/frameHandler/commitChange/omitDefaults.ts
var omitDefaults = /* @__PURE__ */ __name(({
  props: {
    defaults: { output: defaults }
  }
}, { h, id, maxH, maxW, minH, minW, order, w, x, y, ...rest }) => ({
  ...h != null && h !== (defaults?.h ?? defaults?.minH ?? 1) && { h },
  ...id != null && { id },
  ...maxH != null && { maxH },
  ...maxW != null && { maxW },
  ...minH != null && { minH },
  ...minW != null && { minW },
  ...order != null && { order },
  ...w != null && w !== (defaults?.w ?? "100%") && { w },
  ...x != null && { x },
  ...y != null && { y },
  ...rest
}), "omitDefaults");

// Layout/getPositions/getPositions.ts
var import_uik602 = require("@appd/uik");

// Layout/getPositions/DEBUG.ts
var DEBUG = false;

// Layout/getPositions/getIntersectedPosition.ts
var getIntersectedPosition = /* @__PURE__ */ __name((intervals, item, previous) => {
  const start = intervals.findIndex(({ w, x }) => x + w > item.x);
  if (start === -1) {
    console.error("Implementation Error details:", {
      intervals,
      item,
      previous
    });
    throw Error(
      `Implementation Error: Invalid item.x (${item.x}) was greater than the bounds of the container (${intervals.at(-1) ? intervals.at(-1).x + intervals.at(-1).w : "???"}).`
    );
  }
  let end = start + 1;
  let y = Math.max(intervals[start].y, previous.y + (item.x >= previous.x ? 0 : previous.h));
  for (; end < intervals.length && intervals[end].x < item.x + item.w; ++end) {
    y = Math.max(y, intervals[end].y);
  }
  return {
    slice: [start, end],
    x: item.x,
    y
  };
}, "getIntersectedPosition");

// Layout/getPositions/PERF.ts
var PERF = false;

// Layout/getPositions/getPositions.ts
var getPositions = /* @__PURE__ */ __name(({
  columns,
  dense,
  gap,
  items,
  step
}) => {
  if (PERF) {
    console.time("{ positions }");
  }
  const iterations = [];
  const { intervals, positions: positions2 } = items.reduce(
    ({ intervals: intervals2, positions: positions3 }, item, i) => {
      if (item.unmounted) {
        positions3.push({
          unmounted: true,
          x: -Infinity,
          y: -Infinity
        });
        return {
          intervals: intervals2,
          positions: positions3
        };
      }
      const previous = !dense && i ? {
        h: items[i - 1].h,
        x: positions3[positions3.length - 1].x,
        y: positions3[positions3.length - 1].y
      } : {
        h: 0,
        x: 0,
        y: 0
      };
      if (DEBUG) {
        iterations.push({
          i,
          item,
          ...{ intervals: [...intervals2] },
          positions: [...positions3],
          previous,
          ...{ earliestPosition: void 0 },
          "earliestPosition.iterations": []
        });
      }
      const earliestPosition = item.x != null ? {
        best: getIntersectedPosition(
          intervals2,
          item,
          previous
        )
      } : intervals2.reduce(
        ({ best, candidates }, interval, j) => {
          if (DEBUG) {
            iterations.at(-1)["earliestPosition.iterations"].push({
              j,
              ...{ interval },
              best,
              candidates: [...candidates]
            });
          }
          const candidate = {
            j,
            x: interval.x + interval.w,
            y: Math.max(interval.y, previous.y + (interval.x >= previous.x ? 0 : previous.h))
          };
          const lastTaller = import_uik602.utils.findLastIndex(candidates, ({ y }) => y > candidate.y);
          const tooShortDropped = (
            // Implementation detail: I would have liked to use `.slice()`, but mutating is likely faster.
            (candidates.splice(lastTaller + 1, candidates.length - (lastTaller + 1), candidate), candidates)
          );
          const firstTooClose = tooShortDropped.findIndex(({ x }) => x + item.w > candidate.x);
          if (DEBUG) {
            Object.assign(iterations.at(-1)["earliestPosition.iterations"].at(-1), {
              candidate,
              lastTaller,
              tooShortDropped: [...tooShortDropped],
              ...{ firstTooClose }
            });
          }
          if (firstTooClose === 0) {
            return {
              best,
              candidates: tooShortDropped
            };
          }
          const nextBest = candidates[firstTooClose].y < best.y ? {
            slice: [candidates[firstTooClose - 1].j + 1, candidates[candidates.length - 1].j + 1],
            x: candidates[firstTooClose - 1].x,
            y: candidates[firstTooClose].y
          } : best;
          const farEnoughDropped = (
            // Same implementation detail as above (`.splice` instead of `.slice` for performance).
            (tooShortDropped.splice(0, firstTooClose), tooShortDropped)
          );
          if (DEBUG) {
            Object.assign(iterations.at(-1)["earliestPosition.iterations"].at(-1), {
              nextBest,
              ...{ farEnoughDropped: [...farEnoughDropped] }
            });
          }
          return {
            best: nextBest,
            candidates: farEnoughDropped
          };
        },
        {
          best: getIntersectedPosition(
            intervals2,
            {
              w: item.w,
              x: 0
            },
            previous
          ),
          candidates: []
        }
      );
      const nextPosition = {
        x: item.x ?? earliestPosition.best.x,
        y: earliestPosition.best.y
      };
      const [start, end] = earliestPosition.best.slice;
      const splitEnds = {
        left: intervals2[start].x < nextPosition.x ? [
          {
            w: nextPosition.x - intervals2[start].x,
            x: intervals2[start].x,
            y: intervals2[start].y
          }
        ] : [],
        right: nextPosition.x + item.w < intervals2[end - 1].x + intervals2[end - 1].w ? [
          {
            w: intervals2[end - 1].x + intervals2[end - 1].w - (nextPosition.x + item.w),
            x: nextPosition.x + item.w,
            y: intervals2[end - 1].y
          }
        ] : []
      };
      const mergeEnds = {
        left: !splitEnds.left.length && nextPosition.y + item.h === intervals2[start - 1]?.y,
        right: !splitEnds.right.length && nextPosition.y + item.h === intervals2[end]?.y
      };
      const center = {
        w: item.w + (mergeEnds.left ? intervals2[start - 1].w : 0) + (mergeEnds.right ? intervals2[end].w : 0),
        x: mergeEnds.left ? intervals2[start - 1].x : nextPosition.x,
        y: nextPosition.y + item.h
      };
      const nextIntervals = (intervals2.splice(
        mergeEnds.left ? start - 1 : start,
        end - start + +mergeEnds.left + +mergeEnds.right,
        ...splitEnds.left,
        center,
        ...splitEnds.right
      ), // Same implementation detail as above (`.splice` instead of `.slice` for performance).
      intervals2);
      positions3.push(nextPosition);
      if (DEBUG) {
        Object.assign(iterations.at(-1), {
          earliestPosition,
          nextPosition,
          ...{ "[start, end]": [start, end] },
          splitEnds,
          ...{ mergeEnds },
          center,
          ...{ nextIntervals: [...nextIntervals] }
        });
      }
      return {
        intervals: nextIntervals,
        positions: positions3
      };
    },
    {
      intervals: [
        {
          w: columns,
          x: 0,
          y: 0
        }
      ],
      positions: []
    }
  );
  const used = intervals.reduce(
    ({ columns: columns2, rows }, { w, x, y }) => ({
      columns: Math.max(columns2, x + w),
      rows: Math.max(rows, y)
    }),
    {
      columns: 0,
      rows: 0
    }
  );
  if (PERF) {
    console.timeEnd("{ positions }");
  }
  if (DEBUG) {
    console.log(
      "<Layout>",
      globalThis.LAYOUT_DUMP = {
        columns,
        dense,
        gap,
        items,
        step,
        ...{ getIntersectedPosition },
        positions: positions2,
        ...{ iterations }
      }
    );
  }
  return {
    positions: positions2,
    used
  };
}, "getPositions");

// Layout/render/frameHandler/commitChange/omitX.ts
var omitX = /* @__PURE__ */ __name(({
  container: { width },
  exactLengths: {
    output: { toExact }
  },
  props: props2
}, { index, nextFocused, nextItem, nextItems }) => {
  if (nextItem.x != null) {
    const candidate = {
      ...nextItem,
      x: void 0
    };
    const withoutX = nextItems.map((item, j) => j === index ? candidate : item);
    const { columns, gap, items } = getExactLengths({
      defaults: props2.defaults.output,
      gap: props2.gap,
      items: withoutX,
      step: props2.step,
      width
    });
    const { positions: positions2 } = getPositions({
      columns,
      dense: props2.dense,
      gap,
      items,
      step: props2.step
    });
    if (positions2[nextFocused].x === (Array.isArray(nextItem.x) ? nextItem.x.reduce((sum, x) => sum + toExact(x), 0) : toExact(nextItem.x))) {
      return candidate;
    }
  }
  return nextItem;
}, "omitX");

// Layout/render/frameHandler/commitChange/preserveUnits/toSameUnits.ts
var toSameUnits = /* @__PURE__ */ __name((length, exact, columns) => typeof length === "string" ? `${exact}/${columns}` : typeof length === "object" ? {
  ...length,
  value: toSameUnits(length.value, exact, columns)
} : exact, "toSameUnits");

// Layout/render/frameHandler/commitChange/preserveUnits/preserveUnits.ts
var preserveUnits = /* @__PURE__ */ __name(({
  cleanItems: { output: cleanItems2 },
  exactLengths: {
    output: { columns, toExact }
  }
}, { h, w, x, ...item }, index) => {
  const original = cleanItems2[index];
  return {
    ...item,
    ...h != null && { h: toSameUnits(original.h || 0, toExact(h), columns) },
    ...w != null && { w: toSameUnits(original.w || "0/1", toExact(w), columns) },
    ...x != null && {
      x: Array.isArray(x) ? x : toSameUnits(original.x == null || Array.isArray(original.x) ? "0/1" : original.x, toExact(x), columns)
    }
  };
}, "preserveUnits");

// Layout/render/frameHandler/commitChange/reduceFractions/toReducedFraction.ts
var import_uik603 = require("@appd/uik");
var toReducedFraction = /* @__PURE__ */ __name((length, toExact, columns) => typeof length === "string" ? length.includes("/") ? toReducedFraction.reduce(toExact(length), columns) : length : typeof length === "object" ? {
  ...length.max != null && { max: toReducedFraction(length.max, toExact, columns) },
  ...length.min != null && { min: toReducedFraction(length.min, toExact, columns) },
  value: toReducedFraction(length.value, toExact, columns)
} : length, "toReducedFraction");
toReducedFraction.reduce = (numerator, denominator) => {
  const f = import_uik603.utils.gcd(numerator, denominator);
  return numerator === 0 ? 0 : numerator === denominator ? "100%" : `${numerator / f}/${denominator / f}`;
};

// Layout/render/frameHandler/commitChange/reduceFractions/reduceFractions.ts
var reduceFractions = /* @__PURE__ */ __name(({
  exactLengths: {
    output: { columns, toExact }
  }
}, { h, w, x, ...item }) => ({
  ...item,
  ...h != null && { h: toReducedFraction(h, toExact, columns) },
  ...w != null && { w: toReducedFraction(w, toExact, columns) },
  ...x != null && {
    // (object-curly-newline)
    x: Array.isArray(x) ? x.map((x2) => toReducedFraction(x2, toExact, columns)) : toReducedFraction(x, toExact, columns)
  }
}), "reduceFractions");

// Layout/render/frameHandler/commitChange/commitChange.ts
var commitChange = /* @__PURE__ */ __name(({ current: { onChange } }, state, lastMoved) => {
  if (!lastMoved) {
    return;
  }
  const xOmitted = omitX(state, lastMoved);
  const unitsPreserved = preserveUnits(state, xOmitted, lastMoved.index);
  const fractionsReduced = reduceFractions(state, unitsPreserved);
  const defaultsOmitted = omitDefaults(state, fractionsReduced);
  const nextItems = lastMoved.nextItems.map((item, j) => j === lastMoved.index ? defaultsOmitted : item);
  (state.context.saved[state.id] ??= import_uik604.utils.cell.init({})).output.items = // Eagerly commit the user's change to support uncontrolled mode.
  // (Consumer must pass in a new `items` prop to overwrite the user's change, see `Layout.Props["items"]` docs.)
  state.cleanItems.output = nextItems;
  if (
    // If the `items` prop was not a dependency for `cleanItems`...
    !state.cleanItems.input?.items && state.cleanItems.input?.saved
  ) {
    state.cleanItems.input.saved.items = nextItems;
  }
  state.frame.focused = lastMoved.nextFocused;
  onChange?.(nextItems, state.api);
  state.context.onChange(nextItems, state.api);
}, "commitChange");

// Layout/render/frameHandler/getElementsAndFocused.ts
var getElementsAndFocused = /* @__PURE__ */ __name(({
  frame: { focused: i },
  exactLengths: {
    output: {
      items: { [i]: focusedExact }
    }
  },
  positions: {
    output: {
      positions: { [i]: focusedPosition }
    }
  },
  cleanItems: { output: cleanItems2 },
  refs: {
    frame: { current: frame },
    host: { current: host },
    peripherals: { current: peripherals },
    placeholder: { current: placeholder },
    preview: { current: preview }
  }
}) => {
  const focusedRaw = cleanItems2[focusedExact?.index];
  const item = host?.children[focusedExact?.index];
  const gridPaper = peripherals?.children[0];
  if (!focusedRaw || !frame || !(gridPaper instanceof HTMLElement) || !host || !(item instanceof HTMLElement) || !peripherals || !placeholder || !preview) {
    return;
  }
  return {
    elements: {
      frame,
      gridPaper,
      host,
      item,
      peripherals,
      placeholder,
      preview
    },
    focused: {
      exact: focusedExact,
      i,
      position: focusedPosition,
      raw: focusedRaw
    }
  };
}, "getElementsAndFocused");

// Layout/render/frameHandler/mountPreviewAndPlaceholder.ts
var import_uik605 = require("@appd/uik");
var mountPreviewAndPlaceholder = /* @__PURE__ */ __name(({
  elements,
  focused
}) => {
  const { frame, gridPaper, host, item, peripherals, placeholder, preview } = elements;
  let didMove = false;
  const onFirstMove = /* @__PURE__ */ __name(() => {
    if (didMove) {
      return;
    }
    didMove = true;
    placeholder.style.borderRadius = getComputedStyle(item).borderRadius;
    if (Layout.FEATURE.GRID_PAPER) {
      gridPaper.classList.toggle($.MOVING, true);
    }
    host.classList.toggle($.MOVING, true);
    preview.classList.toggle($.MOVING, true);
    item.toggleAttribute($.MOVING, true);
    renderItemCss(
      placeholder,
      {
        h: focused.exact.h,
        i: focused.i,
        w: focused.exact.w,
        x: focused.position.x,
        y: focused.position.y
      },
      false
    );
    item.replaceWith(placeholder);
    preview.append(item, frame);
  }, "onFirstMove");
  const updatePreview = /* @__PURE__ */ __name((itemCss) => {
    const { left, top } = import_uik605.utils.getBoundingClientRect(host);
    Object.assign(preview.style, {
      left: `${left + globalThis.scrollX}px`,
      top: `${top + globalThis.scrollY}px`
    });
    if (itemCss) {
      onFirstMove();
      renderItemCss(item, itemCss, true);
      renderItemCss(frame, itemCss, true);
    }
  }, "updatePreview");
  const unmount = /* @__PURE__ */ __name(() => {
    frame.classList.toggle($.ACTIVE, false);
    if (!didMove) {
      return;
    }
    placeholder.replaceWith(item);
    peripherals.appendChild(frame);
    preview.appendChild(placeholder);
    if (Layout.FEATURE.GRID_PAPER) {
      gridPaper.classList.toggle($.MOVING, false);
    }
    host.classList.toggle($.MOVING, false);
    preview.classList.toggle($.MOVING, false);
    item.toggleAttribute($.MOVING, false);
    item.style.setProperty("--transitionDuration", STYLES23.TRANSITION_DURATION);
    frame.style.setProperty("--transitionDuration", STYLES23.TRANSITION_DURATION);
    frame.animate({}, { duration: 300 }).finished.then(() => {
      item.style.removeProperty("--transitionDuration");
      frame.style.removeProperty("--transitionDuration");
    }, import_uik605.utils.noop);
  }, "unmount");
  frame.classList.toggle($.ACTIVE, true);
  frame.getAnimations().forEach((a) => a.cancel());
  return {
    unmount,
    updatePreview
  };
}, "mountPreviewAndPlaceholder");

// Layout/render/frameHandler/onReposition/onReposition.ts
var import_uik607 = require("@appd/uik");

// Layout/render/frameHandler/onReposition/cursor.ts
var import_uik606 = require("@appd/uik");
var cursor = {
  init: () => document.documentElement.style.cursor = "default",
  restore: () => document.documentElement.style.cursor = "",
  set: import_uik606.utils.lazyConstant(() => document.documentElement.style.cursor = "move")
};

// Layout/render/frameHandler/onReposition/getNextLayout.ts
var getNextLayout = /* @__PURE__ */ __name((previous, nextItem, desiredY, getPositionsParams) => {
  let layout = previous;
  let [from2, until] = [0, previous.reordered.length + 1];
  while (from2 < until) {
    const i = Math.floor((from2 + until) / 2);
    const placedAt = previous.i < i ? i - 1 : i;
    const reordered = previous.i < i ? [
      ...previous.reordered.slice(0, previous.i),
      ...previous.reordered.slice(previous.i + 1, i),
      nextItem,
      ...previous.reordered.slice(i)
    ] : [
      ...previous.reordered.slice(0, i),
      nextItem,
      ...previous.reordered.slice(i, previous.i),
      ...previous.reordered.slice(previous.i + 1)
    ];
    const { positions: positions2 } = getPositions({
      ...getPositionsParams,
      items: reordered
    });
    const isMet = {
      x: positions2[placedAt].x === nextItem.x,
      y: positions2[placedAt].y <= desiredY
    };
    if (isMet.x && isMet.y) {
      layout = {
        i: placedAt,
        positions: positions2,
        reordered
      };
      [from2, until] = [i + 1, until];
    } else {
      [from2, until] = [from2, i];
    }
  }
  return layout;
}, "getNextLayout");

// Layout/render/frameHandler/onReposition/onReposition.ts
var onReposition = /* @__PURE__ */ __name(({
  elements: { frame, host },
  focused,
  rerender,
  state,
  updatePreview
}) => {
  let lastMoved;
  let previous = {
    i: focused.i,
    positions: state.positions.output.positions,
    reordered: state.exactLengths.output.items
  };
  const {
    props: { dense, step }
  } = state;
  cursor.init();
  return {
    doneMoving: cursor.restore,
    handler: ({ delta }) => {
      cursor.set();
      rerender({
        eagerEffects: true,
        notifyReact: false
      });
      const {
        exactLengths: {
          output: { columns, gap, toExact }
        },
        props: {
          defaults: { output: defaults }
        }
      } = state;
      const mouse = {
        x: focused.position.x + delta.x / step,
        y: focused.position.y + delta.y / step
      };
      const dynamicW = toExact({
        max: focused.exact.maxW,
        min: focused.exact.minW,
        value: focused.raw.w ?? defaults.w ?? columns - Math.max(0, Math.round(mouse.x))
      });
      const nextItem = {
        ...focused.exact,
        // Use the `dynamicW` for the placeholder...
        w: dynamicW,
        x: import_uik607.utils.clamp(Math.round(mouse.x), [0, columns - dynamicW])
      };
      const layout = getNextLayout(previous, nextItem, Math.max(0, mouse.y), {
        columns,
        dense,
        gap,
        step
      });
      renderItemCss.all(host, layout.reordered, layout.positions, true);
      updatePreview({
        ...focused.exact,
        i: layout.i,
        x: mouse.x,
        y: mouse.y
      });
      frame.setAttribute("stats", `${nextItem.w} \xD7 ${nextItem.h}`);
      previous = layout;
      lastMoved = getLastMoved(focused, state, layout);
    },
    lastMoved: () => lastMoved?.()
  };
}, "onReposition");
var getLastMoved = /* @__PURE__ */ __name((focused, state, repositioned) => () => {
  const withOrder = {
    ...state.cleanItems.output[focused.exact.index],
    order: repositioned.i,
    x: `${repositioned.reordered[repositioned.i].x}/${state.exactLengths.output.columns}`
  };
  return {
    exactLengths: repositioned.reordered,
    index: focused.exact.index,
    nextFocused: repositioned.i,
    nextItem: withOrder,
    nextItems: repositioned.reordered.reduce((result, { index }, i) => {
      result[index] = i === repositioned.i ? withOrder : {
        ...state.cleanItems.output[index],
        order: i
      };
      return result;
    }, Array(repositioned.reordered.length)),
    positions: repositioned.positions
  };
}, "getLastMoved");

// Layout/render/frameHandler/onResizeSE/onResizeSE.ts
var import_uik608 = require("@appd/uik");

// Layout/render/frameHandler/onResizeSE/getNextLayout.ts
var getNextLayout2 = /* @__PURE__ */ __name(({
  index,
  nextItem,
  state: {
    cleanItems: { output: cleanItems2 },
    container: { width },
    props: {
      defaults: { output: defaults },
      dense,
      gap,
      step
    }
  }
}) => {
  const nextItems = cleanItems2.map((item, j) => j === index ? nextItem : item);
  const exactLengths2 = getExactLengths({
    defaults,
    gap,
    items: nextItems,
    step,
    width
  });
  const { positions: positions2 } = getPositions({
    columns: exactLengths2.columns,
    dense,
    gap: exactLengths2.gap,
    items: exactLengths2.items,
    step
  });
  return {
    exactLengths: exactLengths2.items,
    index,
    nextItem,
    nextItems,
    positions: positions2
  };
}, "getNextLayout");

// Layout/render/frameHandler/onResizeSE/onResizeSE.ts
var onResizeSE = /* @__PURE__ */ __name(({
  elements: { frame, host },
  focused: { exact, i, position, raw },
  rerender,
  state,
  updatePreview
}) => {
  let lastMoved;
  const {
    frame: { dragging },
    props: { step }
  } = state;
  const ignore = {
    x: dragging === "N" || dragging === "S",
    y: dragging === "E" || dragging === "W"
  };
  return {
    doneMoving: import_uik608.utils.noop,
    handler: ({ delta }) => {
      rerender({
        eagerEffects: true,
        notifyReact: false
      });
      const {
        exactLengths: {
          output: { columns, toExact }
        }
      } = state;
      const toExactUnrounded = getExactLengths.convert({
        columns,
        round: import_uik608.utils.identity
      }).toExact;
      const unrounded = {
        h: toExactUnrounded({
          max: exact.maxH,
          min: exact.minH,
          value: exact.h + (ignore.y ? 0 : delta.y / step)
        }),
        w: toExactUnrounded({
          max: {
            max: exact.maxW,
            value: columns - position.x
          },
          min: exact.minW,
          value: exact.w + (ignore.x ? 0 : delta.x / step)
        })
      };
      const rounded = getNextLayout2({
        index: exact.index,
        nextItem: {
          ...raw,
          h: toExact(unrounded.h),
          w: toExact(unrounded.w),
          ...!raw.x && { x: position.x }
        },
        state
      });
      renderItemCss.all(host, rounded.exactLengths, rounded.positions, true);
      updatePreview({
        h: unrounded.h,
        i,
        w: unrounded.w,
        x: position.x,
        y: position.y
      });
      frame.setAttribute("stats", `${rounded.nextItem.w} \xD7 ${rounded.nextItem.h}`);
      lastMoved = /* @__PURE__ */ __name(() => ({
        ...rounded,
        nextFocused: i
      }), "lastMoved");
    },
    lastMoved: () => lastMoved?.()
  };
}, "onResizeSE");

// Layout/render/frameHandler/pauseReact.ts
var pauseReact = /* @__PURE__ */ __name((rerender, state, target) => {
  state.frame.dragging = target;
  return () => {
    state.frame.dragging = void 0;
    (state.effect.input ??= {}).dragging = target;
    rerender({
      eagerEffects: true,
      eagerRender: true
    });
  };
}, "pauseReact");

// Layout/render/frameHandler/frameHandler.ts
var frameHandler = /* @__PURE__ */ __name((propsRef, rerender, state) => {
  let lastClicked = -Infinity;
  return import_uik609.utils.cell(state.frame.handler, [], () => (event) => {
    if (event.type !== "START" || state.frame.dragging || !state.props.editing) {
      return;
    }
    if (clickThrough(event.nativeEvent, lastClicked, state)) {
      return event.abort();
    }
    lastClicked = Date.now();
    const { elements, focused } = getElementsAndFocused(state) ?? {};
    if (!elements || !focused || TODO_UNIMPLEMENTED(event.target)) {
      return;
    }
    event.setOriginElement(elements.host);
    const resume = pauseReact(rerender, state, event.target);
    const { unmount, updatePreview } = mountPreviewAndPlaceholder({
      elements,
      focused
    });
    const { doneMoving, handler, lastMoved } = event.target === "CENTER" ? onReposition({
      elements,
      focused,
      rerender,
      state,
      updatePreview
    }) : onResizeSE({
      elements,
      focused,
      rerender,
      state,
      updatePreview
    });
    event.onMove(handler);
    let cancelled = false;
    event.onCancel(() => cancelled = true);
    event.finally(() => {
      doneMoving();
      if (!cancelled) {
        commitChange(propsRef, state, lastMoved());
      }
      unmount();
      resume();
    });
  });
}, "frameHandler");
var TODO_UNIMPLEMENTED = /* @__PURE__ */ __name((target) => ["NE", "NW", "SW", "N", "W"].includes(target), "TODO_UNIMPLEMENTED");

// Layout/render/jsx/jsx.tsx
var import_uik617 = require("@appd/uik");

// Layout/render/jsx/GRID_PAPER.tsx
var import_uik610 = require("@appd/uik");
var import_jsx_runtime483 = require("react/jsx-runtime");
var GRID_PAPER = /* @__PURE__ */ (0, import_jsx_runtime483.jsx)(
  "div",
  {
    className: (0, import_uik610.css)({
      [`&.${$.MOVING}`]: { display: "block" },
      background: [
        "repeating-linear-gradient(to right, #84bcff4c, #84bcff4c 1px, transparent 1px, transparent var(--STEP))",
        "repeating-linear-gradient(to bottom, #84bcff4c, #84bcff4c 1px, transparent 1px, transparent var(--STEP))"
      ].join(","),
      backgroundColor: "#4499df08",
      display: "none",
      height: "100%",
      left: 0,
      outline: `1px solid ${STYLES23.FOCUS_COLOR}`,
      position: "absolute",
      top: 0,
      width: "100%",
      zIndex: -1
    }),
    uik: "Layout.GridPaper"
  }
);

// Layout/render/jsx/Preview.tsx
var import_uik611 = require("@appd/uik");
var import_jsx_runtime484 = require("react/jsx-runtime");
var Preview = import_uik611.utils.memo(
  import_uik611.utils.forwardRef(({ placeholderRef }, ref) => /* @__PURE__ */ (0, import_jsx_runtime484.jsx)(import_uik611.Overlay.Provider, { promote: Infinity, children: /* @__PURE__ */ (0, import_jsx_runtime484.jsx)(import_uik611.Overlay, { children: /* @__PURE__ */ (0, import_jsx_runtime484.jsx)(
    "div",
    {
      className: (0, import_uik611.css)({
        // Only show when moving.
        [`&.${$.MOVING}`]: { display: "block" },
        // Unmounted item has the same styles as in the host element, but less opacity.
        [`> :not(.${$.FRAME})`]: {
          ...STYLES23.ITEM,
          opacity: 0.8
        },
        display: "none",
        pointerEvents: "none",
        position: "absolute"
      }),
      ref,
      uik: "Layout.Preview",
      children: /* @__PURE__ */ (0, import_jsx_runtime484.jsx)(
        "div",
        {
          className: (0, import_uik611.css)({
            "--transitionDuration": "0.2s",
            backgroundColor: "#00000026"
          }),
          ref: placeholderRef,
          uik: "Layout.Placeholder"
        }
      )
    }
  ) }) }))
);
Preview.displayName = "Preview";

// Layout/Frame/Frame.tsx
var import_uik616 = require("@appd/uik");

// Layout/Frame/onPointerDown/onPointerDown.ts
var import_uik614 = require("@appd/uik");

// Layout/Frame/onPointerDown/defineOrigin.ts
var import_uik612 = require("@appd/uik");
var defineOrigin = /* @__PURE__ */ __name((rawEvent, target, frameElement, originElement) => {
  const { scrollX, scrollY } = globalThis;
  const raw = {
    frame: import_uik612.utils.getBoundingClientRect(frameElement),
    origin: import_uik612.utils.getBoundingClientRect(originElement)
  };
  const origin = {
    x: raw.origin.x + scrollX,
    y: raw.origin.y + scrollY
  };
  const event = {
    x: rawEvent.pageX - origin.x,
    y: rawEvent.pageY - origin.y
  };
  const frame = {
    bottom: raw.frame.bottom + scrollY - origin.y,
    left: raw.frame.left + scrollX - origin.x,
    right: raw.frame.right + scrollX - origin.x,
    top: raw.frame.top + scrollY - origin.y
  };
  const initialOrigin = {
    CENTER: {
      localX: event.x,
      localY: event.y
    },
    E: {
      localX: frame.right,
      localY: event.y
    },
    N: {
      localX: event.x,
      localY: frame.top
    },
    NE: {
      localX: frame.right,
      localY: frame.top
    },
    NW: {
      localX: frame.left,
      localY: frame.top
    },
    S: {
      localX: event.x,
      localY: frame.bottom
    },
    SE: {
      localX: frame.right,
      localY: frame.bottom
    },
    SW: {
      localX: frame.left,
      localY: frame.bottom
    },
    W: {
      localX: frame.left,
      localY: event.y
    }
  }[target];
  return {
    measure: () => {
      const { x, y } = import_uik612.utils.getBoundingClientRect(originElement);
      const { scrollX: scrollX2, scrollY: scrollY2 } = globalThis;
      return {
        pageX: x + scrollX2 + initialOrigin.localX,
        pageY: y + scrollY2 + initialOrigin.localY
      };
    }
  };
}, "defineOrigin");

// Layout/Frame/onPointerDown/setCursor.ts
var import_uik613 = require("@appd/uik");
var setCursor = /* @__PURE__ */ __name((target) => {
  if (document.documentElement.style.cursor) {
    return import_uik613.utils.noop;
  }
  document.documentElement.style.cursor = {
    CENTER: "move",
    E: "ew-resize",
    N: TODO_UNIMPLEMENTED2 ?? "ns-resize",
    NE: TODO_UNIMPLEMENTED2 ?? "nesw-resize",
    NW: TODO_UNIMPLEMENTED2 ?? "nwse-resize",
    S: "ns-resize",
    SE: "nwse-resize",
    SW: TODO_UNIMPLEMENTED2 ?? "nesw-resize",
    W: TODO_UNIMPLEMENTED2 ?? "ew-resize"
  }[target];
  return () => document.documentElement.style.cursor = "";
}, "setCursor");
var TODO_UNIMPLEMENTED2 = "not-allowed";

// Layout/Frame/onPointerDown/setPointerCapture.ts
var setPointerCapture = /* @__PURE__ */ __name((pointerId) => {
  document.documentElement.setPointerCapture(pointerId);
  return () => document.documentElement.releasePointerCapture(pointerId);
}, "setPointerCapture");

// Layout/Frame/onPointerDown/onPointerDown.ts
var onPointerDown = /* @__PURE__ */ __name((handler, target, frameRef) => (event) => {
  if (event.defaultPrevented) {
    return;
  }
  const frameElement = frameRef.current;
  if (!(frameElement instanceof Element)) {
    return;
  }
  const { pointerId, timeStamp: startedAt } = event;
  Layout.VERBOSE && console.log("POINTERDOWN", event);
  const callbacks = {
    finally: void 0,
    onCancel: void 0,
    onMove: void 0,
    onStop: void 0
  };
  let originElement = document.documentElement;
  let subscriptions = [];
  let unsubscribed = false;
  const cleanup = /* @__PURE__ */ __name(() => {
    if (!unsubscribed) {
      Layout.VERBOSE && console.log("CLEANUP");
      subscriptions.forEach((fn) => fn());
      callbacks.finally?.({
        nativeEvent: event,
        // Reference `origin().` instead of `measure()` in case `abort()`ed and `measure` was never initialized.
        origin: origin().measure(),
        target,
        type: "FINALLY"
      });
      unsubscribed = true;
    }
  }, "cleanup");
  const origin = import_uik614.utils.lazyConstant(() => defineOrigin(event, target, frameElement, originElement));
  handler({
    abort: cleanup,
    finally: (f) => void (callbacks.finally = f),
    nativeEvent: event,
    onCancel: (f) => void (callbacks.onCancel = f),
    onMove: (f) => void (callbacks.onMove = f),
    onStop: (f) => void (callbacks.onStop = f),
    setOriginElement: (o) => originElement = o,
    target,
    type: "START"
  });
  if (unsubscribed) {
    return;
  }
  import_uik614.utils.isolate(event);
  const { measure } = origin();
  subscriptions = [
    setCursor(target),
    setPointerCapture(pointerId),
    import_uik614.utils.addEventListener(
      document.documentElement,
      "pointermove",
      (event2) => {
        Layout.VERBOSE && console.log("POINTERMOVE");
        if (unsubscribed || event2.timeStamp < startedAt + onPointerDown.MOVE_THRESHOLD_MS) {
          return;
        }
        import_uik614.utils.isolate(event2);
        const origin2 = measure();
        (callbacks.onMove ?? handler)({
          delta: {
            x: event2.pageX - origin2.pageX,
            y: event2.pageY - origin2.pageY
          },
          nativeEvent: event2,
          origin: origin2,
          target,
          type: "MOVE"
        });
      },
      {
        capture: true,
        passive: false
      }
    ),
    import_uik614.utils.addEventListener(
      document.documentElement,
      "pointerup",
      (event2) => {
        Layout.VERBOSE && console.log("POINTERUP");
        if (unsubscribed) {
          return;
        }
        import_uik614.utils.isolate(event2);
        const origin2 = measure();
        (callbacks.onStop ?? handler)({
          delta: {
            x: event2.pageX - origin2.pageX,
            y: event2.pageY - origin2.pageY
          },
          nativeEvent: event2,
          origin: origin2,
          target,
          type: "STOP"
        });
        cleanup();
      },
      {
        capture: true,
        passive: false
      }
    ),
    import_uik614.utils.addEventListener(
      document.documentElement,
      "pointercancel",
      (event2) => {
        Layout.VERBOSE && console.log("POINTERCANCEL");
        if (unsubscribed) {
          return;
        }
        import_uik614.utils.isolate(event2);
        (callbacks.onCancel ?? handler)({
          nativeEvent: event2,
          origin: measure(),
          target,
          type: "CANCEL"
        });
        cleanup();
      },
      {
        capture: true,
        passive: false
      }
    ),
    import_uik614.utils.addEventListener(
      document.documentElement,
      "keydown",
      (event2) => {
        Layout.VERBOSE && console.log("KEYDOWN");
        if (event2.key !== "Escape" || unsubscribed) {
          return;
        }
        import_uik614.utils.isolate(event2);
        (callbacks.onCancel ?? handler)({
          nativeEvent: event2,
          origin: measure(),
          target,
          type: "CANCEL"
        });
        cleanup();
      },
      {
        capture: true,
        passive: false
      }
    )
  ];
}, "onPointerDown");
onPointerDown.MOVE_THRESHOLD_MS = 100;

// Layout/Frame/STYLES.ts
var import_uik615 = require("@appd/uik");
var TODO_UNIMPLEMENTED3 = import_uik615.css.Styles({
  ":hover": { opacity: 0.3 },
  cursor: import_uik615.utils.IS_DEV_MODE ? "not-allowed" : "revert"
});
var HOVER_DISTANCE = 5;
var CORNER_SIZE = 6;
var CORNER_OUTLINE = 1.4;
var UNHOVERED_SIDE_WIDTH = FEATURE.CORNERS ? 1.4 : STYLES23.OUTLINE_WIDTH * 0.7;
var SIDE_WIDTH = `var(--sideWidth, ${UNHOVERED_SIDE_WIDTH}px)`;
var CORNER_OFFSET = `calc(${-CORNER_SIZE / 2}px - ${SIDE_WIDTH} / 2)`;
var SIDE_OFFSET = `calc(-1 * ${SIDE_WIDTH})`;
var STATS_MARGIN = 6;
var DEBUG2 = {
  BLUE: {},
  RED: {}
};
var AFTER = /* @__PURE__ */ __name((styles) => import_uik615.css.Styles({
  "::after": {
    content: "''",
    position: "absolute",
    ...styles
  }
}), "AFTER");
var CORNER = import_uik615.css.Styles({
  backgroundColor: "white",
  borderRadius: CORNER_SIZE / 2,
  height: CORNER_SIZE,
  outline: `${CORNER_OUTLINE}px solid ${STYLES23.FOCUS_COLOR}`,
  position: "absolute",
  width: CORNER_SIZE
});
var SIDE = {
  E_W: import_uik615.css.Styles({
    backgroundColor: STYLES23.FOCUS_COLOR,
    cursor: "ew-resize",
    insetBlock: SIDE_OFFSET,
    position: "absolute",
    width: SIDE_WIDTH
  }),
  N_S: import_uik615.css.Styles({
    backgroundColor: STYLES23.FOCUS_COLOR,
    cursor: "ns-resize",
    height: SIDE_WIDTH,
    insetInline: SIDE_OFFSET,
    position: "absolute"
  })
};
var STYLES25 = {
  CORNERS: {
    NE: (0, import_uik615.css)({
      ...CORNER,
      ...AFTER({
        ...DEBUG2.RED,
        bottom: -CORNER_OUTLINE,
        left: -CORNER_OUTLINE,
        right: -HOVER_DISTANCE,
        top: -HOVER_DISTANCE
      }),
      ...TODO_UNIMPLEMENTED3 ?? { cursor: "nesw-resize" },
      right: CORNER_OFFSET,
      top: CORNER_OFFSET
    }),
    NW: (0, import_uik615.css)({
      ...CORNER,
      ...AFTER({
        ...DEBUG2.RED,
        bottom: -CORNER_OUTLINE,
        left: -HOVER_DISTANCE,
        right: -CORNER_OUTLINE,
        top: -HOVER_DISTANCE
      }),
      ...TODO_UNIMPLEMENTED3 ?? { cursor: "nwse-resize" },
      left: CORNER_OFFSET,
      top: CORNER_OFFSET
    }),
    SE: (0, import_uik615.css)({
      ...CORNER,
      ...AFTER({
        ...DEBUG2.RED,
        bottom: -HOVER_DISTANCE,
        left: -CORNER_OUTLINE,
        right: -HOVER_DISTANCE,
        top: -CORNER_OUTLINE
      }),
      bottom: CORNER_OFFSET,
      cursor: "nwse-resize",
      right: CORNER_OFFSET
    }),
    SW: (0, import_uik615.css)({
      ...CORNER,
      ...AFTER({
        ...DEBUG2.RED,
        bottom: -HOVER_DISTANCE,
        left: -HOVER_DISTANCE,
        right: -CORNER_OUTLINE,
        top: -CORNER_OUTLINE
      }),
      bottom: CORNER_OFFSET,
      ...TODO_UNIMPLEMENTED3 ?? { cursor: "nesw-resize" },
      left: CORNER_OFFSET
    })
  },
  HOST: (0, import_uik615.css)(
    {
      ...STYLES23.ITEM,
      "&.DISABLE_CORNERS": {
        "> div, > div:hover": { opacity: 0 },
        outline: `${SIDE_WIDTH} solid ${STYLES23.FOCUS_COLOR}`
      },
      "::after": {
        backgroundClip: "padding-box",
        backgroundColor: STYLES23.FOCUS_COLOR,
        // Reserve some white space after the stats indicator when it appears at the bottom of a scroll region.
        border: `${STATS_MARGIN}px solid transparent`,
        borderRadius: 3 + STATS_MARGIN,
        color: "white",
        content: "attr(stats)",
        fontSize: 11,
        fontWeight: 600,
        left: "50%",
        lineHeight: "15px",
        paddingBlock: 2,
        paddingInline: 4,
        pointerEvents: "none",
        position: "absolute",
        top: `calc(100% + ${STYLES23.OUTLINE_WIDTH}px)`,
        translate: "-50%",
        whiteSpace: "nowrap"
      },
      [`:hover, &.${$.ACTIVE}, :is(.${$.FOCUSED}:hover:not(:has(.${$.LAYOUT} > :hover)) ~ .${$.PERIPHERALS} > .${$.FRAME})`]: (
        // When hovered, or when an item is clicked, or when frame is "interactive" (and there is a hovered item), show
        // the thick outline.
        { "--sideWidth": `${STYLES23.OUTLINE_WIDTH}px` }
      ),
      [`&.${$.FOCUSED}`]: { display: "block" },
      [`&.${$.INTERACTIVE}`]: {
        "> *": { pointerEvents: "initial" },
        pointerEvents: "none"
      },
      display: "none",
      pointerEvents: "initial",
      zIndex: "var(--N)"
    },
    $.FRAME
  ),
  SIDES: {
    E: (0, import_uik615.css)({
      ...SIDE.E_W,
      ...AFTER({
        ...DEBUG2.BLUE,
        insetBlock: 0,
        left: `calc(${-CORNER_SIZE / 2 - CORNER_OUTLINE}px + ${SIDE_WIDTH} / 2)`,
        right: `calc(${-HOVER_DISTANCE - CORNER_SIZE / 2}px + ${SIDE_WIDTH} / 2)`
      }),
      right: SIDE_OFFSET
    }),
    N: (0, import_uik615.css)({
      ...SIDE.N_S,
      ...TODO_UNIMPLEMENTED3,
      ...AFTER({
        ...DEBUG2.BLUE,
        bottom: `calc(${-CORNER_SIZE / 2 - CORNER_OUTLINE}px + ${SIDE_WIDTH} / 2)`,
        insetInline: 0,
        top: `calc(${-HOVER_DISTANCE - CORNER_SIZE / 2}px + ${SIDE_WIDTH} / 2)`
      }),
      top: SIDE_OFFSET
    }),
    S: (0, import_uik615.css)({
      ...SIDE.N_S,
      ...AFTER({
        ...DEBUG2.BLUE,
        bottom: `calc(${-HOVER_DISTANCE - CORNER_SIZE / 2}px + ${SIDE_WIDTH} / 2)`,
        insetInline: 0,
        top: `calc(${-CORNER_SIZE / 2 - CORNER_OUTLINE}px + ${SIDE_WIDTH} / 2)`
      }),
      bottom: SIDE_OFFSET
    }),
    W: (0, import_uik615.css)({
      ...SIDE.E_W,
      ...TODO_UNIMPLEMENTED3,
      ...AFTER({
        ...DEBUG2.BLUE,
        insetBlock: 0,
        left: `calc(${-HOVER_DISTANCE - CORNER_SIZE / 2}px + ${SIDE_WIDTH} / 2)`,
        right: `calc(${-CORNER_SIZE / 2 - CORNER_OUTLINE}px + ${SIDE_WIDTH} / 2)`
      }),
      left: SIDE_OFFSET
    })
  }
};

// Layout/Frame/Frame.tsx
var import_jsx_runtime485 = require("react/jsx-runtime");
var Frame = Object.assign(
  import_uik616.utils.memo(
    import_uik616.utils.forwardRef(({ handler }, rawRef) => {
      const ref = import_uik616.utils.useBroadcastRef(rawRef);
      import_uik616.utils.useEffect(
        (children = ref.current?.children ?? []) => [
          import_uik616.utils.addEventListener(ref.current, "pointerdown", onPointerDown(handler, "CENTER", ref), { passive: false }),
          import_uik616.utils.addEventListener(children[0], "pointerdown", onPointerDown(handler, "N", ref), { passive: false }),
          import_uik616.utils.addEventListener(children[1], "pointerdown", onPointerDown(handler, "S", ref), { passive: false }),
          import_uik616.utils.addEventListener(children[2], "pointerdown", onPointerDown(handler, "W", ref), { passive: false }),
          import_uik616.utils.addEventListener(children[3], "pointerdown", onPointerDown(handler, "E", ref), { passive: false }),
          import_uik616.utils.addEventListener(children[4], "pointerdown", onPointerDown(handler, "NW", ref), { passive: false }),
          import_uik616.utils.addEventListener(children[5], "pointerdown", onPointerDown(handler, "NE", ref), { passive: false }),
          import_uik616.utils.addEventListener(children[6], "pointerdown", onPointerDown(handler, "SW", ref), { passive: false }),
          import_uik616.utils.addEventListener(children[7], "pointerdown", onPointerDown(handler, "SE", ref), { passive: false })
        ],
        [handler]
      );
      return /* @__PURE__ */ (0, import_jsx_runtime485.jsxs)("div", { className: HOST8, ref, uik: "Layout.Frame", children: [
        TODO_UNIMPLEMENTED4().N,
        /* @__PURE__ */ (0, import_jsx_runtime485.jsx)("div", { className: S }),
        TODO_UNIMPLEMENTED4().W,
        /* @__PURE__ */ (0, import_jsx_runtime485.jsx)("div", { className: E }),
        TODO_UNIMPLEMENTED4().NW,
        TODO_UNIMPLEMENTED4().NE,
        TODO_UNIMPLEMENTED4().SW,
        /* @__PURE__ */ (0, import_jsx_runtime485.jsx)("div", { className: SE })
      ] });
    })
  ),
  { onPointerDown }
);
Frame.displayName = "Layout.Frame";
var {
  CORNERS: { NE, NW, SE, SW },
  HOST: HOST8,
  SIDES: { E, N, S, W }
} = STYLES25;
var TODO_UNIMPLEMENTED4 = import_uik616.utils.lazyConstant(() => ({
  N: /* @__PURE__ */ (0, import_jsx_runtime485.jsx)(import_uik616.Tooltip, { position: "TOP", style: { marginTop: -5 }, value: import_uik616.utils.IS_DEV_MODE && "Unimplemented", children: /* @__PURE__ */ (0, import_jsx_runtime485.jsx)("div", { className: N }) }),
  NE: /* @__PURE__ */ (0, import_jsx_runtime485.jsx)(import_uik616.Tooltip, { position: "TOP", style: { marginTop: -5 }, value: import_uik616.utils.IS_DEV_MODE && "Unimplemented", children: /* @__PURE__ */ (0, import_jsx_runtime485.jsx)("div", { className: NE }) }),
  NW: /* @__PURE__ */ (0, import_jsx_runtime485.jsx)(import_uik616.Tooltip, { position: "TOP", style: { marginTop: -5 }, value: import_uik616.utils.IS_DEV_MODE && "Unimplemented", children: /* @__PURE__ */ (0, import_jsx_runtime485.jsx)("div", { className: NW }) }),
  SW: /* @__PURE__ */ (0, import_jsx_runtime485.jsx)(import_uik616.Tooltip, { position: "BOTTOM", style: { marginTop: 5 }, value: import_uik616.utils.IS_DEV_MODE && "Unimplemented", children: /* @__PURE__ */ (0, import_jsx_runtime485.jsx)("div", { className: SW }) }),
  W: /* @__PURE__ */ (0, import_jsx_runtime485.jsx)(import_uik616.Tooltip, { position: "LEFT", style: { marginLeft: -5 }, value: import_uik616.utils.IS_DEV_MODE && "Unimplemented", children: /* @__PURE__ */ (0, import_jsx_runtime485.jsx)("div", { className: W }) })
}));

// Layout/render/jsx/jsx.tsx
var import_jsx_runtime486 = require("react/jsx-runtime");
var jsx487 = /* @__PURE__ */ __name((state, {
  api,
  className: { output: className2 },
  frame: {
    handler: { output: handler }
  },
  id,
  jsx: jsx556,
  onResize: {
    handler: { output: onResize2 }
  },
  props: {
    inherited: { output: inherited }
  },
  refs: { frame, host, peripherals, placeholder, preview }
} = state) => import_uik617.utils.cell(
  jsx556,
  {
    api,
    className: className2,
    handler,
    inherited,
    onResize: onResize2
  },
  (_, changed) => {
    Layout.VERBOSE && import_uik617.utils.LOG(
      "\u{1F4F8}",
      /* exclude from dependencies */
      id,
      Math.round(performance.now()),
      changed
    );
    return /* @__PURE__ */ (0, import_jsx_runtime486.jsx)(import_uik617.Measurer, { onResize: (dimensions) => onResize2(dimensions), children: /* @__PURE__ */ (0, import_jsx_runtime486.jsxs)("div", { className: className2, ref: host, uik: "Layout", ...inherited, children: [
      /* @__PURE__ */ (0, import_jsx_runtime486.jsx)(PARENT.Provider, { value: api, children: inherited.children }),
      /* @__PURE__ */ (0, import_jsx_runtime486.jsxs)("div", { className: $.PERIPHERALS, ref: peripherals, uik: "Layout.PERIPHERALS", children: [
        GRID_PAPER,
        /* @__PURE__ */ (0, import_jsx_runtime486.jsx)(Frame, { handler, ref: frame }),
        /* @__PURE__ */ (0, import_jsx_runtime486.jsx)(Preview, { placeholderRef: placeholder, ref: preview })
      ] })
    ] }) });
  }
), "jsx");

// Layout/render/onChildrenChange.ts
var import_uik618 = require("@appd/uik");
var onChildrenChange = /* @__PURE__ */ __name((rerender, state) => import_uik618.utils.cell(state.onChildrenChange.handler, [], () => (mutation) => {
  if (state.frame.dragging) {
    return;
  }
  const isFinishingDrag = mutation.removedNodes.length === 1 && mutation.removedNodes[0] instanceof HTMLElement && mutation.removedNodes[0].getAttribute("uik") === "Layout.Placeholder";
  if (isFinishingDrag) {
    return;
  }
  Layout.VERBOSE && console.log("\u{1F476}", state.id, Math.round(performance.now()), mutation);
  ++state.onChildrenChange.epoch;
  rerender({
    eagerEffects: true,
    eagerRender: true
  });
}), "onChildrenChange");

// Layout/render/onResize.ts
var import_uik619 = require("@appd/uik");
var onResize = /* @__PURE__ */ __name((propsRef, rerender, state) => import_uik619.utils.cell(
  state.onResize.handler,
  [],
  () => ({ height: height2, width } = state.onResize.previous.container.output, customRerender = rerender) => {
    import_uik619.utils.cell(
      state.onResize.previous.container,
      {
        height: height2,
        width
      },
      (input, changed) => {
        Layout.VERBOSE && console.log("\u{1F4D0}", state.id, Math.round(performance.now()), input, changed);
        state.container = input;
        customRerender({ eagerRender: true });
        return input;
      }
    );
    {
      const {
        api,
        exactLengths: {
          output: { gap: actualGap }
        },
        positions: {
          output: {
            used: { columns, rows }
          }
        }
      } = state;
      import_uik619.utils.cell(
        state.onResize.previous.stats,
        {
          ...state.onResize.previous.container.output,
          actualGap,
          columns,
          rows
        },
        (input, changed) => {
          Layout.VERBOSE && console.log("\u{1F4E3}", state.id, Math.round(performance.now()), input, changed);
          propsRef.current.onResize?.(input, api);
          state.context.onResize(input, api);
          return input;
        }
      );
    }
  }
), "onResize");

// Layout/render/positions.ts
var import_uik620 = require("@appd/uik");
var positions = /* @__PURE__ */ __name(({
  exactLengths: {
    output: { columns, gap, items }
  },
  id,
  positions: positions2,
  props: { dense, step }
}) => !id ? positions2.output : import_uik620.utils.cell(
  positions2,
  {
    columns,
    dense,
    gap,
    items,
    step
  },
  () => import_uik620.utils.LOG.IF(Layout.VERBOSE)(
    "\u{1F3D7}\uFE0F",
    /* exclude from dependencies */
    id,
    Math.round(performance.now()),
    getPositions({
      columns,
      dense,
      gap,
      items,
      step
    })
  )
), "positions");

// Layout/render/props.ts
var import_uik621 = require("@appd/uik");
var props = /* @__PURE__ */ __name(({ current: props2 }, state) => {
  const {
    context: {
      defaults: { output: defaults },
      rest: { output: rest }
    }
  } = state;
  const {
    className: className2,
    defaults: rawDefaults,
    dense,
    direction,
    editing,
    gap,
    // Read from `context.group` instead.
    group: _group,
    id,
    // Use `state.cleanItems` instead.
    items: _items,
    // Read from `propsRef` instead.
    onChange: _onChange,
    // Read from `propsRef` instead.
    onResize: _onResize,
    // Read from `context.saved` instead.
    saved: _saved,
    // Read from `context.section` instead.
    section: _section,
    step,
    ...inherited
  } = props2;
  import_uik621.utils.cell(
    state.props.defaults,
    {
      ...defaults,
      ...rawDefaults
    },
    import_uik621.utils.identity
  );
  import_uik621.utils.cell(state.props.inherited, inherited, import_uik621.utils.identity);
  return state.props = {
    className: className2,
    defaults: state.props.defaults,
    dense: dense ?? rest.dense ?? false,
    direction: direction ?? rest.direction ?? "ROW",
    editing: editing ?? rest.editing ?? false,
    gap: gap ?? rest.gap ?? 16,
    id,
    inherited: state.props.inherited,
    step: Math.max(step || rest.step || 16, 1)
  };
}, "props");

// Layout/render/vars.ts
var import_uik622 = require("@appd/uik");
var vars = /* @__PURE__ */ __name(({
  exactLengths: {
    output: {
      items: { length }
    }
  },
  id,
  positions: {
    output: {
      used: { columns, rows }
    }
  },
  props: {
    inherited: {
      output: {
        // Downstream error in `:packages:forms:check`:
        //   TS2339: Property '--C' does not exist on type 'CSSProperties'.
        // @ts-ignore
        style: { "--C": C = String(columns), "--N": N2 = String(length), "--R": R = String(rows) } = {}
      }
    }
  },
  vars: vars2
}) => !id ? vars2.output : import_uik622.utils.cell(
  vars2,
  {
    C,
    N: N2,
    R
  },
  () => import_uik622.utils.LOG.IF(Layout.VERBOSE)(
    "\u{1FAE7}",
    /* exclude from dependencies */
    id,
    Math.round(performance.now()),
    {
      "--C": C,
      "--N": N2,
      "--R": R
    }
  )
), "vars");

// Layout/onFrameChange/onFrameChange.ts
var import_uik623 = require("@appd/uik");

// Layout/onFrameChange/promoteFocusTo.ts
var promoteFocusTo = /* @__PURE__ */ __name((host) => {
  const parent = Layout.query.parent(host);
  if (!host || !parent) {
    return null;
  }
  Layout.VERBOSE && console.log("\u{1F451}", host.id, Math.round(performance.now()));
  parent.api.state.frame.focused = readItemOrder(host) ?? (console.warn("<Layout> internal error: No item index found in promoteFocusTo(host)", { host }), -1);
  parent.api.rerender();
  return parent;
}, "promoteFocusTo");

// Layout/onFrameChange/onFrameChange.ts
var onFrameChange = /* @__PURE__ */ __name((rerender, state) => import_uik623.utils.cell(state.onFrameChange, [], () => ({
  clickInside: (event) => {
    const { defaultPrevented, target } = event;
    const {
      frame: {
        dragging,
        handler: { output: handler }
      },
      props: { editing },
      refs: {
        frame,
        host: { current: host }
      }
    } = state;
    if (defaultPrevented || dragging || !editing || !host || !(target instanceof Element)) {
      return;
    }
    const fromChild = Layout.query.parent(target) === host;
    const clicked = fromChild ? readItemOrder(target) : null;
    if (clicked != null) {
      if (clicked !== state.frame.focused) {
        Layout.VERBOSE && console.log("\u{1F5BC}\uFE0F", clicked, state.id, Math.round(performance.now()));
        state.frame.focused = clicked;
        rerender({
          eagerEffects: true,
          eagerRender: true,
          notifyReact: false
        });
      }
      if (!isActionable(target, host)) {
        event.stopPropagation = import_uik623.utils.noop;
        event.stopImmediatePropagation = import_uik623.utils.noop;
        Frame.onPointerDown(handler, "CENTER", frame)(event);
      }
    }
  },
  clickOutside: ({ target }) => {
    const {
      frame: { dragging },
      props: { editing },
      refs: {
        host: { current: host }
      }
    } = state;
    const fromChild = Layout.query.parent(target) === host;
    if (dragging || !editing || state.frame.focused === -1 || fromChild) {
      return;
    }
    Layout.VERBOSE && console.log("\u2B06\uFE0F", state.id, Math.round(performance.now()));
    state.frame.focused = -1;
    rerender();
  },
  escapeKey: (event) => {
    const { defaultPrevented, key } = event;
    const {
      frame: { dragging },
      props: { editing },
      refs: {
        host: { current: host }
      }
    } = state;
    if (defaultPrevented || key !== "Escape" || dragging || !editing || !host || state.frame.focused === -1) {
      return;
    }
    Layout.VERBOSE && console.log("\u241B", state.id, Math.round(performance.now()));
    import_uik623.utils.isolate(event);
    state.frame.focused = -1;
    rerender();
    promoteFocusTo(host);
  },
  focusIn: (event) => {
    const { defaultPrevented, target } = event;
    const {
      exactLengths: {
        output: { items }
      },
      frame: { dragging },
      props: { editing },
      refs: {
        host: { current: host }
      }
    } = state;
    if (defaultPrevented || dragging || !editing || !host || !(target instanceof HTMLElement || target instanceof SVGElement) || state.frame.focused === -1 && Layout.query.parent(host) || isActionable(target, host)) {
      return;
    }
    Layout.VERBOSE && console.log("\u{1F4E5}", state.id, Math.round(performance.now()), target);
    import_uik623.utils.isolate(event);
    target.blur();
    if (state.frame.focused === -1) {
      state.frame.focused = items.findIndex(({ unmounted }) => !unmounted);
      if (state.frame.focused !== -1) {
        rerender();
      }
    }
  },
  spaceKey: {
    down: (event) => {
      const { defaultPrevented, key, target } = event;
      const {
        props: { editing },
        refs: {
          host: { current: host }
        }
      } = state;
      if (defaultPrevented || !editing || key !== " " || state.frame.focused === -1 || isActionable(target, host)) {
        return;
      }
      Layout.VERBOSE && console.log("\u2423 keydown", state.id, Math.round(performance.now()));
      import_uik623.utils.isolate(event);
    },
    up: (event) => {
      const { defaultPrevented, key, target } = event;
      const {
        exactLengths: {
          output: { items }
        },
        frame: { dragging },
        props: { editing },
        refs: {
          host: { current: host }
        }
      } = state;
      if (defaultPrevented || !editing || !host || key !== " " || state.frame.focused === -1 || isActionable(target, host)) {
        return;
      }
      Layout.VERBOSE && console.log("\u2423 keyup", state.id, Math.round(performance.now()));
      if (dragging) {
        return import_uik623.utils.isolate(event);
      }
      const child = host.children[items[state.frame.focused]?.index];
      const nextHost = Layout.query.is(child) ? child : Layout.query.child(child);
      if (nextHost) {
        import_uik623.utils.isolate(event);
        state.frame.focused = -1;
        rerender();
        const next = nextHost.api.state.exactLengths.output.items.findIndex(({ unmounted }) => !unmounted);
        if (next !== -1) {
          nextHost.api.state.frame.focused = next;
          nextHost.api.rerender();
        }
      }
    }
  },
  tabKey: (event) => {
    const { defaultPrevented, key, shiftKey, target } = event;
    const {
      exactLengths: {
        output: { items }
      },
      props: { editing },
      refs: {
        host: { current: host }
      }
    } = state;
    if (defaultPrevented || !editing || !host || key !== "Tab" || state.frame.focused === -1 || isActionable(target, host)) {
      return;
    }
    Layout.VERBOSE && console.log("\u27A1", state.id, Math.round(performance.now()), event.target);
    import_uik623.utils.isolate(event);
    if (state.frame.dragging) {
      return;
    }
    const rawNext = shiftKey ? import_uik623.utils.findLastIndex(items, ({ unmounted }) => !unmounted, state.frame.focused - 1) : import_uik623.utils.findIndex(items, ({ unmounted }) => !unmounted, state.frame.focused + 1);
    const next = rawNext === -1 ? shiftKey ? import_uik623.utils.findLastIndex(items, ({ unmounted }) => !unmounted, items.length - 1, state.frame.focused - 1) : import_uik623.utils.findIndex(items, ({ unmounted }) => !unmounted, 0, state.frame.focused + 1) : rawNext;
    state.frame.focused = next;
    rerender();
    host.children[items[state.frame.focused]?.index].scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest"
    });
  }
})), "onFrameChange");
var isActionable = /* @__PURE__ */ __name((target, host) => {
  if (!(target instanceof Element) || !host) {
    return;
  }
  const actionable = target.closest(`.${$.ACTIONABLE}`);
  const notActionable = target.closest(`.${$.NOT_ACTIONABLE}`);
  return host.contains(actionable) && (!actionable?.contains(notActionable) || actionable === notActionable && notActionable !== target);
}, "isActionable");

// Layout/render/render.ts
var render = /* @__PURE__ */ __name((propsRef, rerender, state) => {
  const isReactPaused = state.frame.dragging;
  const f = frameHandler(propsRef, rerender, state);
  const _onC = onChildrenChange(rerender, state);
  const _o = onFrameChange(rerender, state);
  const p = isReactPaused || props(propsRef, state);
  const on = [p, onResize(propsRef, rerender, state)];
  const c = isReactPaused || cleanItems(propsRef, state);
  const e = [c, p, exactLengths(state)];
  const cl = [p, className(state)];
  const po = [e, p, positions(state)];
  const v = [e, p, po, vars(state)];
  const _ef = [e, on, _onC, p, po, v, effect(state)];
  const _j = isReactPaused || [cl, f, on, p, jsx487(state)];
  return state.jsx.output;
}, "render");

// Layout/Section.tsx
var import_uik624 = require("@appd/uik");
var import_react88 = require("react");
var import_react89 = require("react");
var import_jsx_runtime487 = require("react/jsx-runtime");
var Section = import_uik624.utils.forwardRef(
  ({
    children,
    className: className2,
    collapse: rawCollapse,
    collapsible: rawCollapsible,
    compact: rawCompact,
    editing: rawEditing,
    layout,
    onCollapseChange: rawOnCollapseChange,
    onCollapsibleChange: rawOnCollapsibleChange,
    onDelete: rawOnDelete,
    onTitleChange: rawOnTitleChange,
    title: rawTitle,
    ...inherited
  }, forwardedRef) => {
    const headerRef = (0, import_react88.useRef)(null);
    const layoutRef = import_uik624.utils.useBroadcastRef(layout?.ref);
    const [id, setId2] = (0, import_react88.useState)("");
    import_uik624.utils.useLayoutEffect(() => setId2(layoutRef.current?.api.state.id ?? ""), []);
    const {
      context: {
        rest: { output: rest },
        section: { output: section }
      }
    } = (0, import_react89.useContext)(Provider3.CONTEXT);
    const saved = id && layoutRef.current?.api ? (layoutRef.current.api.state.context.saved[id] ??= import_uik624.utils.cell.init(
      {}
    )).output.section ??= {} : void 0;
    if (saved && rawCollapse != null) {
      saved.collapse = rawCollapse;
    }
    if (saved && rawCollapsible != null) {
      saved.collapsible = rawCollapsible;
    }
    if (saved && rawCompact != null) {
      saved.compact = rawCompact;
    }
    if (saved && rawTitle != null) {
      saved.title = rawTitle;
    }
    const [editing, setEditing] = (0, import_react88.useState)(rawEditing);
    const {
      collapse = rawCollapse ?? saved?.collapse ?? false,
      collapsible = rawCollapsible ?? saved?.collapsible ?? false,
      compact = rawCompact ?? section.compact ?? false,
      onCollapseChange = rawOnCollapseChange ?? section.onCollapseChange,
      onCollapsibleChange = rawOnCollapsibleChange ?? section.onCollapsibleChange,
      onDelete = rawOnDelete ?? section.onDelete,
      onTitleChange = rawOnTitleChange ?? section.onTitleChange,
      title = rawTitle || saved?.title || (editing ? "" : MESSAGES13.NEW_SECTION())
    } = {};
    const [, rerender] = (0, import_react88.useReducer)((i) => i + 1, 0);
    const HAS_NESTED_HOVER = "--HAS_NESTED_HOVER";
    return /* @__PURE__ */ (0, import_jsx_runtime487.jsxs)(
      "div",
      {
        className: (0, import_uik624.css)(
          {
            borderRadius: import_uik624.MAGNETIC_TOKENS.RADIUS.HEAVY,
            ...rest.editing && rawEditing !== false ? !editing && {
              [`:hover > .${$.HEADER} > .SHOW_ON_HOVER`]: (
                // (object-curly-newline)
                { display: `var(${HAS_NESTED_HOVER}, flex)` }
              ),
              [`> .${$.HEADER} > .SHOW_ON_HOVER`]: { display: "none" },
              [`> .${$.LAYOUT}`]: { pointerEvents: "none" }
            } : { [`> .${$.HEADER} > .SHOW_ON_HOVER`]: { display: "none" } }
          },
          $.INTERACTIVE,
          ...import_uik624.utils.many(className2)
        ),
        ref: forwardedRef,
        uik: "Layout.Section",
        ...inherited,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime487.jsxs)(
            Header2,
            {
              className: {
                ...!id && { opacity: 0 },
                zIndex: 1
              },
              compact,
              editing: rawEditing,
              input: { placeholder: MESSAGES13.ENTER_SECTION_TITLE() },
              onEditingChange: setEditing,
              onTitleChange: (rawTitle == null || onTitleChange) && ((title2) => {
                if (saved && rawTitle == null) {
                  saved.title = title2;
                  rerender();
                }
                onTitleChange?.(title2, id);
              }),
              ref: headerRef,
              title,
              children: [
                collapsible && /* @__PURE__ */ (0, import_jsx_runtime487.jsx)(
                  Header2.Button,
                  {
                    icon: collapse ? "Navigation.ChevronDown" : "Navigation.ChevronUp",
                    onClick: import_uik624.utils.noop,
                    onPointerDown: () => {
                      globalThis.requestAnimationFrame(() => {
                        if (saved && rawCollapse == null) {
                          saved.collapse = !collapse;
                          rerender();
                        }
                        onCollapseChange?.(!collapse, id);
                      });
                    }
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime487.jsx)(
                  Header2.ToggleSwitch,
                  {
                    className: ["SHOW_ON_HOVER", "EDITING_ONLY"],
                    label: MESSAGES13.COLLAPSIBLE(),
                    on: collapsible,
                    onSwitch: (rawCollapsible == null || onCollapsibleChange) && (() => {
                      if (saved && rawCollapsible == null) {
                        saved.collapsible = !collapsible;
                        rerender();
                      }
                      onCollapsibleChange?.(!collapsible, id);
                    })
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime487.jsx)(
                  Header2.Button,
                  {
                    className: [{ marginRight: import_uik624.MAGNETIC_TOKENS.SPACING[2] }, "SHOW_ON_HOVER", "EDITING_ONLY"],
                    icon: "Action.Delete",
                    onClick: onDelete && import_uik624.utils.noop,
                    onPointerDown: onDelete && (() => onDelete?.(Layout.snapshot.delete(id), id))
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime487.jsx)(
            Layout,
            {
              ...layout,
              className: [{ ...collapse && collapsible && { display: "none" } }, ...import_uik624.utils.many(layout?.className)],
              onMouseEnter: (event) => {
                layout?.onMouseEnter?.(event);
                if (!event.defaultPrevented) {
                  headerRef.current?.style.setProperty(HAS_NESTED_HOVER, "none");
                }
              },
              onMouseLeave: (event) => {
                layout?.onMouseLeave?.(event);
                if (!event.defaultPrevented) {
                  headerRef.current?.style.removeProperty(HAS_NESTED_HOVER);
                }
              },
              ref: layoutRef,
              children
            }
          )
        ]
      }
    );
  }
);
Section.displayName = "Layout.Section";
Section.__DEV_METADATA__ = { status: "IN_PROGRESS" };
var MESSAGES13 = {
  COLLAPSIBLE: import_uik624.format.message`Collapsible`.description(
    "Label for toggling whether the 'Section' can be collapsed or should always show its contents"
  ),
  ENTER_SECTION_TITLE: import_uik624.format.message`Enter section title`.description(
    "Placeholder text for a 'Section' title input field in a dashboard"
  ),
  NEW_SECTION: import_uik624.format.message`New Section`.description("Default title for a new 'Section' in a dashboard")
};

// Layout/setId/setId.ts
var import_uik625 = require("@appd/uik");

// Layout/setId/setChildren.ts
var setChildren = /* @__PURE__ */ __name((id, api) => {
  const children = Layout.query.children(api.parent ? api.state.refs.host.current : document.body, false);
  const { anonymous, named } = children.reduce(
    (grouped, child) => {
      if (child.id && !child.id.startsWith(`${id}/`)) {
        grouped.named.push([child, Infinity]);
      } else {
        grouped.anonymous.push([child, grouped.anonymous.length]);
      }
      return grouped;
    },
    {
      anonymous: [],
      named: []
    }
  );
  return api.children = new Map([...anonymous, ...named]);
}, "setChildren");

// Layout/setId/setId.ts
var setId = /* @__PURE__ */ __name((rerender, state, eagerHostElement) => {
  if (!state.id) {
    state.refs.host.current ??= eagerHostElement;
    const {
      api,
      api: { parent },
      context,
      onResize: {
        handler: { output: onResize2 }
      },
      props: props2,
      refs: {
        host: { current: host }
      }
    } = state;
    if (!host) {
      throw Error("Implementation Error: Somehow `host` is not set.");
    }
    if (props2.id) {
      host.id = props2.id;
    }
    const prefix = parent.rerender ? (
      // "Upwards recursion" to ensure parent ID is set first.
      (setId(parent.rerender, parent.state, Layout.query.parent(host, false)), // Read the parent's ID.
      parent.state.id)
    ) : "";
    const index = (
      // Read own item index within `parent.children`.
      parent.children.get(host) ?? // Conduct a "census" if `host` not found in parent's existing census.
      setChildren(parent.state?.id ?? "", parent)?.get(host)
    );
    state.id = props2.id ?? [prefix, index].join("/");
    Layout.VERBOSE && console.log("\u{1F194}", state.id, Math.round(performance.now()), index);
    setChildren(state.id, api);
    {
      state.onResize.handler.output = import_uik625.utils.noop;
      state.container = {
        height: 0,
        width: import_uik625.utils.getBoundingClientRect(host).width
      };
      rerender({
        eagerEffects: true,
        eagerRender: true
      });
      host.className = state.className.output;
      onResize2(
        {
          height: import_uik625.utils.getBoundingClientRect(host).height,
          width: state.container.width
        },
        import_uik625.utils.noop
      );
      state.onResize.handler.output = onResize2;
    }
    host.id = state.id;
    host.api = api;
    if (parent.state) {
      (context.saved[host.id] ??= import_uik625.utils.cell.init({})).output.parentId = parent.state.id;
    }
  }
  return state.id;
}, "setId");

// Layout/snapshot.ts
var import_uik626 = require("@appd/uik");
var snapshot = /* @__PURE__ */ __name((options = {}) => import_uik626.utils.LOG.IF(Layout.VERBOSE)(
  "\u{1F4BE}",
  Math.round(performance.now()),
  Object.assign(
    import_uik626.utils.transform(
      [
        ...new Set(
          Layout.query.all().flatMap(
            ({ api }) => getPrototypeChain(api.state.context.saved).reverse()
          )
        )
      ].flatMap(
        (saved) => Object.entries(saved).map(([id, maybe]) => maybe && [id, maybe.output]).filter(import_uik626.utils.Boolean)
      ).reduce((snapshot2, [id, { group, items, parentId, section, widget }]) => {
        snapshot2[id] = Object.assign(snapshot2[id] ?? {}, {
          ...group && {
            group: {
              ...snapshot2[id]?.group,
              ...group
            }
          },
          ...items && {
            items: normalizeOrder(
              options.mountedOnly ? items.filter((item) => !import_uik626.utils.maybeGet(item, "unmounted")) : items
            ).map(import_uik626.utils.omit("unmounted").from)
          },
          parentId,
          ...section && {
            section: {
              ...snapshot2[id]?.section,
              ...section
            }
          },
          ...widget && {
            widget: {
              ...snapshot2[id]?.widget,
              ...widget
            }
          }
        });
        return snapshot2;
      }, {})
    ).by(
      (entries) => (options.mountedOnly ? entries.filter(([id]) => Layout.query.id(id)) : entries).sort(
        ([a], [b]) => import_uik626.utils.byLessThan(a, b)
      )
    ),
    { "": { timestamp: Date.now() } }
  )
), "snapshot");
snapshot.add = (pointer, item, current = snapshot()) => {
  const { index: rawIndex = Infinity, parentId } = pointer;
  const parentItems = current[parentId]?.items;
  if (!parentItems?.length) {
    return Object.assign({}, current, {
      [parentId]: {
        ...current[parentId],
        items: [import_uik626.utils.omit("order").from(item)]
      }
    });
  }
  const index = Number.isInteger(rawIndex) ? (rawIndex % parentItems.length + parentItems.length) % parentItems.length : parentItems.length;
  const siblingsShifted = item.id ? (
    // No shift required if `item` doesn't participate in anonymous index flow.
    current
  ) : import_uik626.utils.transform(current).by.entry(([key, value]) => {
    if (!key.startsWith(`${parentId}/`)) {
      return [key, value];
    }
    const [unshiftedIndex, ...rest] = key.slice(parentId.length + "/".length).split("/");
    if (!Number.isInteger(+unshiftedIndex) || +unshiftedIndex < index) {
      return [key, value];
    }
    return [[parentId, +unshiftedIndex + 1, ...rest].join("/"), value];
  });
  const orderNormalized = normalizeOrder([...parentItems.slice(0, index), item, ...parentItems.slice(index)]);
  Layout.DEBUG && console.log({
    orderNormalized,
    parentItems,
    siblingsShifted
  });
  return Object.assign({}, siblingsShifted, {
    [parentId]: {
      ...siblingsShifted[parentId],
      items: orderNormalized
    }
  });
};
snapshot.delete = (pointer, current = snapshot()) => {
  const parentId = typeof pointer === "string" ? current[pointer]?.parentId ?? Layout.query.id(pointer)?.api.parent.state?.id ?? "" : pointer.parentId;
  const parentItems = current[parentId]?.items ?? [];
  const isAnonymous = typeof pointer === "string" ? pointer.startsWith(`${parentId}/`) : !parentItems.at(pointer.index ?? -1)?.id;
  const rawIndex = (typeof pointer === "string" ? isAnonymous ? +(pointer.split("/").at(-1) ?? "-1") : parentItems.findIndex(({ id }) => id === pointer) : pointer.index) ?? -1;
  const index = parentItems.length ? Number.isInteger(rawIndex) ? (rawIndex % parentItems.length + parentItems.length) % parentItems.length : parentItems.length - 1 : 0;
  const itemDeleted = parentItems ? Object.assign({}, current, {
    [parentId]: {
      ...current[parentId],
      items: normalizeOrder(
        isAnonymous ? parentItems.filter((_, i) => i !== index) : parentItems.filter(({ id }) => id !== pointer)
      )
    }
  }) : current;
  const byParentId = import_uik626.utils.group(Object.entries(itemDeleted).map(([id, entry]) => [entry?.parentId ?? "", id])).by(
    ([parentId2]) => parentId2,
    ([, id]) => id
  );
  const gatherReachable = /* @__PURE__ */ __name((id, gathered = []) => {
    gathered.push(id);
    const children = byParentId.get(id) ?? [];
    gathered.push(...children);
    children.forEach((child) => gatherReachable(child, gathered));
    return gathered;
  }, "gatherReachable");
  const itemId = isAnonymous ? `${parentId}/${index}` : typeof pointer === "string" ? pointer : parentItems[index].id ?? "";
  const subtree = new Set(gatherReachable(itemId));
  const subtreeDeleted = import_uik626.utils.transform(itemDeleted).by.entry((entry) => !subtree.has(entry[0]) && entry);
  const siblingsShifted = parentItems && index !== parentItems.length - 1 ? import_uik626.utils.transform(subtreeDeleted).by.entry(([key, value]) => {
    if (!key.startsWith(`${parentId}/`)) {
      return [key, value];
    }
    const [unshiftedIndex, ...rest] = key.slice(parentId.length + "/".length).split("/");
    if (!Number.isInteger(+unshiftedIndex) || +unshiftedIndex < index) {
      return [key, value];
    }
    return [[parentId, +unshiftedIndex - 1, ...rest].join("/"), value];
  }) : subtreeDeleted;
  Layout.DEBUG && console.log([
    ["pointer", pointer],
    ["current", current],
    ["parentId", parentId],
    ["parentItems", parentItems],
    ["isAnonymous", isAnonymous],
    ["rawIndex", rawIndex],
    ["index", index],
    ["itemDeleted", itemDeleted],
    ["byParentId", byParentId],
    ["itemId", itemId],
    ["subtree", subtree],
    ["subtreeDeleted", subtreeDeleted],
    ["siblingsShifted", siblingsShifted]
  ]);
  return siblingsShifted;
};
snapshot.load = (saved = snapshot.localStorage()) => saved && Layout.query.all().forEach(
  ({
    api: {
      rerender,
      state: { context, id }
    }
  }) => {
    if (saved[id]) {
      (context.saved[id] ??= import_uik626.utils.cell.init({})).output = saved[id];
      rerender();
    }
  }
);
snapshot.localStorage = Object.assign(
  (key = `Layout for ${globalThis.location?.pathname}`) => {
    const saved = globalThis.localStorage?.getItem(key);
    return saved ? JSON.parse(saved) : void 0;
  },
  {
    /** Delete the localStorage snapshot for this page if any. */
    clear: (key = `Layout for ${globalThis.location?.pathname}`) => globalThis.localStorage?.removeItem(key),
    /** Write the `serialized` snapshot to localStorage. */
    write: (key = `Layout for ${globalThis.location?.pathname}`, serialized = JSON.stringify(snapshot())) => globalThis.localStorage?.setItem(key, serialized)
  }
);
snapshot.save = async ({
  clipboard = false,
  localStorage = `Layout for ${globalThis.location?.pathname}`,
  serialized = JSON.stringify(snapshot())
} = {}) => {
  localStorage !== false && snapshot.localStorage.write(localStorage, serialized);
  clipboard && await globalThis.navigator?.clipboard.writeText(serialized);
  return serialized;
};
var getPrototypeChain = /* @__PURE__ */ __name((o, chain = []) => {
  if (!o || typeof o !== "object" || o === Object.prototype) {
    return chain;
  }
  chain.push(o);
  return getPrototypeChain(Object.getPrototypeOf(o), chain);
}, "getPrototypeChain");

// Layout/Widget.tsx
var import_uik627 = require("@appd/uik");
var import_react90 = require("react");
var import_jsx_runtime488 = require("react/jsx-runtime");
var Widget = Object.assign(
  import_uik627.utils.forwardRef(
    ({
      children,
      className: className2,
      compact: rawCompact,
      editing: rawEditing,
      layout,
      onDelete: rawOnDelete,
      onDuplicate: rawOnDuplicate,
      onEdit: rawOnEdit,
      onTitleChange: rawOnTitleChange,
      title: rawTitle,
      ...inherited
    }, forwardedRef) => {
      const layoutRef = import_uik627.utils.useBroadcastRef(layout?.ref);
      const [id, setId2] = (0, import_react90.useState)("");
      import_uik627.utils.useLayoutEffect(() => setId2(layoutRef.current?.api.state.id ?? ""), []);
      const {
        context: {
          rest: { output: rest },
          section: { output: section },
          widget: { output: widget }
        }
      } = (0, import_react90.useContext)(Provider3.CONTEXT);
      const saved = id && layoutRef.current?.api ? (layoutRef.current.api.state.context.saved[id] ??= import_uik627.utils.cell.init(
        {}
      )).output.widget ??= {} : void 0;
      if (saved && rawTitle != null) {
        saved.title = rawTitle;
      }
      const [editing, setEditing] = (0, import_react90.useState)(rawEditing ?? false);
      const {
        compact = rawCompact ?? section.compact ?? false,
        onDelete = rawOnDelete ?? widget.onDelete,
        onDuplicate = rawOnDuplicate ?? widget.onDuplicate,
        onEdit = rawOnEdit ?? widget.onEdit,
        onTitleChange = rawOnTitleChange ?? widget.onTitleChange,
        title = rawTitle || saved?.title || ""
      } = {};
      const [, rerender] = (0, import_react90.useReducer)((i) => i + 1, 0);
      const groupContext = (0, import_react90.useContext)(Group4.CONTEXT);
      return /* @__PURE__ */ (0, import_jsx_runtime488.jsxs)(
        "div",
        {
          className: (0, import_uik627.css)(
            {
              "> :nth-child(3)": {
                flexGrow: 1,
                minWidth: 0
              },
              display: "flex",
              flexDirection: "column",
              flexGrow: 1,
              ...!groupContext && {
                backgroundColor: import_uik627.MAGNETIC_TOKENS.COLORS.DEFAULT_BG_WEAK,
                borderRadius: import_uik627.MAGNETIC_TOKENS.SPACING[3],
                boxShadow: import_uik627.MAGNETIC_TOKENS.EFFECTS.SHAODW_LIFTED,
                padding: import_uik627.MAGNETIC_TOKENS.SPACING[compact ? 4 : 6]
              },
              ...rest.editing && rawEditing !== false ? !editing && {
                [`:hover, [${$.FOCUSED}]`]: {
                  [`> .${$.HEADER} > .SHOW_ON_HOVER`]: (
                    // Not using `display` to avoid flickering the dropdown on option click, because dropdown
                    // overlay needs to measure its anchor position.
                    { visibility: "visible" }
                  )
                },
                [`> .${$.HEADER} > .SHOW_ON_HOVER`]: { visibility: "hidden" }
              } : { [`> .${$.HEADER} > .SHOW_ON_HOVER`]: { display: "none" } }
            },
            $.INTERACTIVE,
            ...import_uik627.utils.many(className2)
          ),
          ref: forwardedRef,
          uik: "Layout.Widget",
          ...inherited,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime488.jsx)(
              Header2,
              {
                className: {
                  ...!id && { opacity: 0 },
                  ...!title && {
                    marginBottom: -24,
                    marginTop: 0
                  },
                  zIndex: 1
                },
                compact,
                editing: false,
                heading: { className: !title && { display: "none" } },
                input: {
                  className: !title && { display: "none" },
                  placeholder: MESSAGES14.ENTER_WIDGET_TITLE()
                },
                onEditingChange: setEditing,
                onTitleChange: (rawTitle == null || onTitleChange) && ((title2) => {
                  if (saved && rawTitle == null) {
                    saved.title = title2;
                    rerender();
                  }
                  onTitleChange?.(title2, id);
                }),
                size: "SUB_SECTION",
                title,
                children: /* @__PURE__ */ (0, import_jsx_runtime488.jsxs)(
                  import_uik627.Dropdown,
                  {
                    contentClassName: (0, import_uik627.css)({ width: "fit-content" }),
                    icon: /* @__PURE__ */ (0, import_jsx_runtime488.jsx)(import_uik627.Icon.Navigation.MoreHorizontal, {}),
                    kind: "TERTIARY",
                    triggerClassName: (0, import_uik627.css)(
                      {
                        ...(!title || groupContext) && {
                          ":hover": { backgroundColor: import_uik627.MAGNETIC_TOKENS.COLORS.INTERACT_BORDER_MEDIUM_HOVER },
                          alignSelf: "flex-start",
                          backgroundColor: import_uik627.MAGNETIC_TOKENS.COLORS.INTERACT_BG_WEAK_HOVER,
                          marginLeft: "auto",
                          marginRight: 2,
                          marginTop: 2,
                          zIndex: 10
                        },
                        marginBlock: -15
                      },
                      "SHOW_ON_HOVER",
                      $.ACTIONABLE
                    ),
                    children: [
                      /* @__PURE__ */ (0, import_jsx_runtime488.jsxs)(
                        import_uik627.Dropdown.Option,
                        {
                          className: [
                            {
                              "> span": {
                                alignItems: "center",
                                display: "flex",
                                gap: import_uik627.MAGNETIC_TOKENS.SPACING[2]
                              }
                            },
                            $.ACTIONABLE
                          ],
                          disabled: !onEdit,
                          onPointerDown: onEdit && (() => onEdit?.(id)),
                          children: [
                            /* @__PURE__ */ (0, import_jsx_runtime488.jsx)(import_uik627.Icon.Action.Edit, { ...!onEdit && { fill: import_uik627.MAGNETIC_TOKENS.COLORS.INTERACT_ICON_WEAK_DISABLED } }),
                            "Edit"
                          ]
                        }
                      ),
                      /* @__PURE__ */ (0, import_jsx_runtime488.jsxs)(
                        import_uik627.Dropdown.Option,
                        {
                          className: [
                            {
                              "> span": {
                                alignItems: "center",
                                display: "flex",
                                gap: import_uik627.MAGNETIC_TOKENS.SPACING[2]
                              }
                            },
                            $.ACTIONABLE
                          ],
                          disabled: !onDuplicate,
                          onPointerDown: onDuplicate && (() => onDuplicate?.({ TODO: [{ _: "UNIMPLEMENTED" }] }, id)),
                          children: [
                            /* @__PURE__ */ (0, import_jsx_runtime488.jsx)(
                              import_uik627.Icon.Action.Duplicate,
                              {
                                ...!onDuplicate && { fill: import_uik627.MAGNETIC_TOKENS.COLORS.INTERACT_ICON_WEAK_DISABLED }
                              }
                            ),
                            "Duplicate"
                          ]
                        }
                      ),
                      /* @__PURE__ */ (0, import_jsx_runtime488.jsxs)(
                        import_uik627.Dropdown.Option,
                        {
                          className: [
                            {
                              "> span": {
                                alignItems: "center",
                                display: "flex",
                                gap: import_uik627.MAGNETIC_TOKENS.SPACING[2]
                              }
                            },
                            $.ACTIONABLE
                          ],
                          disabled: !onDelete,
                          onPointerDown: onDelete && (() => onDelete?.(Layout.snapshot.delete(id), id)),
                          children: [
                            /* @__PURE__ */ (0, import_jsx_runtime488.jsx)(import_uik627.Icon.Action.Delete, { ...!onDelete && { fill: import_uik627.MAGNETIC_TOKENS.COLORS.INTERACT_ICON_WEAK_DISABLED } }),
                            "Delete"
                          ]
                        }
                      )
                    ]
                  }
                )
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime488.jsx)(
              Layout,
              {
                ...layout,
                className: (0, import_react90.useMemo)(() => [{ display: "none" }, ...import_uik627.utils.many(layout?.className)], [, layout?.className]),
                ref: layoutRef
              }
            ),
            children
          ]
        }
      );
    }
  ),
  { CONTEXT: (0, import_react90.createContext)(null) }
);
Widget.displayName = "Layout.Widget";
Widget.__DEV_METADATA__ = { status: "IN_PROGRESS" };
var MESSAGES14 = {
  ENTER_WIDGET_TITLE: import_uik627.format.message`Enter widget title`.description(
    "Placeholder text for a 'Widget' title input field in a dashboard"
  )
};

// Layout/Layout.tsx
var import_jsx_runtime489 = require("react/jsx-runtime");
var Layout = Object.assign(
  // Copy `props` to avoid `TypeError: Cannot assign to read only property 'children' of object '#<Object>' below.
  import_uik628.utils.forwardRef(({ ...props2 }, rawRef) => {
    const propsRef = import_uik628.utils.useLiveRef(props2);
    const initial = {
      api: { parent: (0, import_react91.useContext)(PARENT) },
      // Act like `<Layout>` was wrapped in `<Provider group={...} section={...} saved={...}>`, and
      // `useContext(Provider.CONTEXT)` was read here.
      context: (props2.children = Provider3({
        children: props2.children,
        group: props2.group,
        saved: props2.saved,
        section: props2.section
      })).props.value.context,
      refs: {
        frame: (0, import_react91.useRef)(null),
        host: import_uik628.utils.useBroadcastRef(rawRef),
        peripherals: (0, import_react91.useRef)(null),
        placeholder: (0, import_react91.useRef)(null),
        preview: (0, import_react91.useRef)(null)
      }
    };
    const [{ state }, dispatch] = (0, import_react91.useReducer)(
      ({ state: state2 }) => ({ state: state2 }),
      void 0,
      () => ({
        state: {
          api: {
            children: /* @__PURE__ */ new Map(),
            parent: initial.api.parent,
            propsRef,
            get rerender() {
              return rerender;
            },
            get state() {
              return state;
            }
          },
          className: import_uik628.utils.cell.init(""),
          cleanItems: import_uik628.utils.cell.init([]),
          container: {
            height: 0,
            width: 0
          },
          context: initial.context,
          effect: import_uik628.utils.cell.init(),
          exactLengths: import_uik628.utils.cell.init({
            columns: 1,
            // Gap is clamped to half the minimum item size (which will be 0.5 steps initially).
            gap: 8,
            items: [],
            toExact: Number
          }),
          frame: {
            dragging: void 0,
            focused: -1,
            handler: import_uik628.utils.cell.init(import_uik628.utils.noop)
          },
          id: "",
          jsx: import_uik628.utils.cell.init(/* @__PURE__ */ (0, import_jsx_runtime489.jsx)(import_jsx_runtime489.Fragment, {})),
          onChildrenChange: {
            epoch: 0,
            handler: import_uik628.utils.cell.init(import_uik628.utils.noop)
          },
          onFrameChange: import_uik628.utils.cell.init({
            clickInside: import_uik628.utils.noop,
            clickOutside: import_uik628.utils.noop,
            escapeKey: import_uik628.utils.noop,
            focusIn: import_uik628.utils.noop,
            spaceKey: {
              down: import_uik628.utils.noop,
              up: import_uik628.utils.noop
            },
            tabKey: import_uik628.utils.noop
          }),
          onResize: {
            handler: import_uik628.utils.cell.init(import_uik628.utils.noop),
            previous: {
              container: import_uik628.utils.cell.initWithInput({
                height: 0,
                width: 0
              }),
              stats: import_uik628.utils.cell.initWithInput({
                actualGap: 8,
                columns: 0,
                height: 0,
                rows: 0,
                width: 0
              })
            }
          },
          positions: import_uik628.utils.cell.init({
            positions: [],
            used: {
              columns: 0,
              rows: 0
            }
          }),
          props: {
            defaults: import_uik628.utils.cell.init({}),
            dense: false,
            direction: "ROW",
            editing: false,
            gap: 16,
            inherited: import_uik628.utils.cell.init({}),
            step: 16
          },
          refs: initial.refs,
          vars: import_uik628.utils.cell.init({
            "--C": "0",
            "--N": "0",
            "--R": "0"
          })
        }
      })
    );
    const rerender = (0, import_react91.useCallback)(
      ({ eagerEffects = false, eagerRender = false, notifyReact = true } = {}) => {
        if (eagerRender) {
          Layout.VERBOSE && console.log("\u26A1\uFE0F", state.id, Math.round(performance.now()));
          render(propsRef, rerender, state);
        }
        if (eagerEffects) {
          state.effect.output?.();
        }
        if (notifyReact) {
          dispatch();
        }
      },
      []
    );
    import_uik628.utils.useLayoutEffect(() => {
      setId(rerender, state);
    }, []);
    import_uik628.utils.useLayoutEffect(
      () => {
        if (!state.effect.output || state.frame.dragging) {
          return;
        }
        Layout.VERBOSE && console.log("\u2728", state.id, Math.round(performance.now()));
        state.effect.output?.();
      }
      // (Run every time)
    );
    import_uik628.utils.useLayoutEffect(
      () => import_uik628.utils.mutationObserver(state.refs.host.current, state.onChildrenChange.handler.output, { childList: true }),
      [state.onChildrenChange.handler.output, state.refs.host.current]
    );
    import_uik628.utils.useEffect(
      ({ clickInside, clickOutside, escapeKey, focusIn, spaceKey, tabKey } = state.onFrameChange.output) => [
        import_uik628.utils.addEventListener(state.refs.host.current, "focusin", focusIn, { passive: false }),
        import_uik628.utils.addEventListener(document.documentElement, "keydown", escapeKey, {
          capture: true,
          passive: false
        }),
        import_uik628.utils.addEventListener(document.documentElement, "keydown", tabKey, {
          capture: true,
          passive: false
        }),
        import_uik628.utils.addEventListener(document.documentElement, "keydown", spaceKey.down, {
          capture: true,
          passive: false
        }),
        import_uik628.utils.addEventListener(document.documentElement, "keyup", spaceKey.up, {
          capture: true,
          passive: false
        }),
        import_uik628.utils.addEventListener(state.refs.host.current, "pointerdown", clickInside, { passive: false }),
        import_uik628.utils.addEventListener(document.documentElement, "pointerdown", clickOutside)
      ],
      [state.onFrameChange.output]
    );
    return render(propsRef, rerender, state);
  }),
  {
    $,
    DEBUG: false,
    FEATURE,
    Group: Group4,
    Header: Header2,
    Provider: Provider3,
    Section,
    VERBOSE: false,
    Widget,
    query,
    readItemOrder,
    snapshot
  }
);
Layout.displayName = "Layout";
Layout.__DEV_METADATA__ = { status: "IN_PROGRESS" };
globalThis.Layout = Layout;

// Legend/Legend.tsx
var import_uik642 = require("@appd/uik");
var import_react92 = require("react");

// Legend/getState/getItems/getNextDataItem/getNextDataItem.ts
var import_uik629 = require("@appd/uik");

// Legend/getState/getItems/getNextDataItem/maybeGetNextDefault/incrementAndWrap.ts
var incrementAndWrap = /* @__PURE__ */ __name((index, length) => (index + 1) % length, "incrementAndWrap");

// Legend/getState/getItems/getNextDataItem/maybeGetNextDefault/getNextDistinctFromPrevious.ts
var getNextDistinctFromPrevious = /* @__PURE__ */ __name((nextIndex, defaultValues, previous, equals = (a, b) => a === b) => {
  const next = defaultValues[nextIndex];
  const secondNextIndex = incrementAndWrap(nextIndex, defaultValues.length);
  const secondNext = defaultValues[secondNextIndex];
  const sameAsNeighbor = equals(next, previous);
  return sameAsNeighbor ? (
    // Case 0: `next` matches `previous`.
    {
      nextIndex: incrementAndWrap(secondNextIndex, defaultValues.length),
      value: secondNext
    }
  ) : (
    // Case 1: `next` is distinct from `previous`.
    {
      nextIndex: secondNextIndex,
      value: next
    }
  );
}, "getNextDistinctFromPrevious");

// Legend/getState/getItems/getNextDataItem/maybeGetNextDefault/maybeGetNextDefault.ts
var maybeGetNextDefault = /* @__PURE__ */ __name((rawValue, nextIndex, defaultValues, previous, equals = (a, b) => a === b) => rawValue ? (
  // Case 0: `rawValue` is defined.
  {
    nextIndex: equals(rawValue, defaultValues[nextIndex]) ? (
      // Case a: The next default value would match `rawValue`. (Needs increment.)
      incrementAndWrap(nextIndex, defaultValues.length)
    ) : (
      // Case b: The next default value is distinct from `rawValue`.
      nextIndex
    ),
    value: rawValue
  }
) : (
  // Case 1: `rawValue` is `undefined`.
  getNextDistinctFromPrevious(nextIndex, defaultValues, previous, equals)
), "maybeGetNextDefault");

// Legend/getState/getItems/getNextDataItem/shapes.ts
var SHAPES2 = ["CIRCLE", "SQUARE", "DIAMOND", "TRIANGLE", "TRIANGLE_DOWN", "PENTAGON"];

// Legend/getState/getItems/getNextDataItem/getNextDataItem.ts
var getNextDataItem = /* @__PURE__ */ __name((context, item, index, items) => {
  const { color: rawColor, kind = "DATA", label, selected, shape: rawShape } = item;
  const { nextIndex: colorIndex, value: color2 } = maybeGetNextDefault(
    rawColor,
    context.nextIndex.color,
    import_uik629.Cartesian.DEFAULT_COLORS,
    items[index + 1]?.color,
    (a, b) => a == b
  );
  const { nextIndex: shapeIndex, value: shape } = maybeGetNextDefault(
    rawShape,
    context.nextIndex.shape,
    SHAPES2,
    items[index + 1]?.shape
  );
  context.nextIndex.color = colorIndex;
  context.nextIndex.shape = shapeIndex;
  context.data.push({
    color: color2,
    index,
    kind,
    label,
    selected,
    shape
  });
  return context;
}, "getNextDataItem");

// Legend/getState/getItems/groupItemsByKind/isDataItem.ts
var isDataItem = /* @__PURE__ */ __name((item) => (item.kind ?? "DATA") === "DATA", "isDataItem");

// Legend/getState/getItems/groupItemsByKind/groupItemsByKind.ts
var groupItemsByKind = /* @__PURE__ */ __name((items) => items.reduce(
  (context, item, index) => {
    const { data, statistical } = context;
    const withIndexAndSelected = {
      ...item,
      index,
      label: item.label ?? "",
      selected: item.selected ?? false
    };
    isDataItem(withIndexAndSelected) ? (
      // Case 0: Data item.
      data.push(withIndexAndSelected)
    ) : (
      // Case 1: Not data item.
      statistical.push(withIndexAndSelected)
    );
    return context;
  },
  {
    data: [],
    statistical: []
  }
), "groupItemsByKind");

// Legend/getState/getItems/getItems.ts
function getItems(items) {
  if (!items) {
    return {
      anySelected: false,
      data: [],
      statistical: []
    };
  } else {
    const { data: rawData, statistical } = groupItemsByKind(items);
    const anySelected = rawData.some(({ selected }) => selected) || statistical.some(({ selected }) => selected);
    const { data } = rawData.reduce(getNextDataItem, {
      data: [],
      nextIndex: {
        color: 0,
        shape: 0
      }
    });
    return {
      anySelected,
      data,
      statistical
    };
  }
}
__name(getItems, "getItems");

// Legend/utils/bisect.ts
var import_uik630 = require("@appd/uik");
function bisect(list, valueOrCondition, from2 = 0, until = list.length) {
  from2 = import_uik630.utils.clamp(from2, [0, list.length]);
  until = import_uik630.utils.clamp(until, [0, list.length]);
  if (valueOrCondition instanceof Function) {
    const condition = valueOrCondition;
    while (from2 < until) {
      const middle = Math.floor((from2 + until) / 2);
      if (condition(list[middle], middle, list)) {
        until = middle;
      } else {
        from2 = middle + 1;
      }
    }
  } else {
    const value = valueOrCondition;
    while (from2 < until) {
      const middle = Math.floor((from2 + until) / 2);
      if (list[middle] >= value) {
        until = middle;
      } else {
        from2 = middle + 1;
      }
    }
  }
  return from2;
}
__name(bisect, "bisect");
((bisect2) => {
  function continuous(domain, condition = continuous.DEFAULT_CONDITION, tolerance = domain[0] === domain[1] ? Infinity : Math.abs(domain[1] - domain[0]) * 0.01) {
    if (import_uik630.utils.IS_DEV_MODE && tolerance < 0) {
      throw Error(
        `[ui-kit development warning] [bisect.continuous]: Assumption #2 violated. \`tolerance\` (${tolerance}) was negative.`
      );
    }
    const [a, b] = domain;
    const magnitude = Math.abs(b - a);
    let low = 0;
    let high = 1;
    while ((high - low) * magnitude > tolerance) {
      const middle = (low + high) / 2;
      const x = import_uik630.utils.mix(a, b, middle);
      if (condition(x)) {
        high = middle;
      } else {
        low = middle;
      }
    }
    return import_uik630.utils.mix(a, b, high);
  }
  bisect2.continuous = continuous;
  __name(continuous, "continuous");
  ((continuous2) => {
    function DEFAULT_CONDITION(x) {
      return x >= 0;
    }
    continuous2.DEFAULT_CONDITION = DEFAULT_CONDITION;
    __name(DEFAULT_CONDITION, "DEFAULT_CONDITION");
  })(continuous = bisect2.continuous || (bisect2.continuous = {}));
})(bisect || (bisect = {}));

// Legend/utils/findLastIndex.ts
var import_uik631 = require("@appd/uik");
function findLastIndex(array, valueOrCondition, from2 = array.length - 1, until = -1) {
  from2 = import_uik631.utils.clamp(from2, [-1, array.length - 1]);
  until = import_uik631.utils.clamp(until, [-1, array.length - 1]);
  if (valueOrCondition instanceof Function) {
    const condition = valueOrCondition;
    for (; from2 > until && !condition(array[from2]); --from2)
      ;
  } else {
    const value = valueOrCondition;
    for (; from2 > until && array[from2] !== value; --from2)
      ;
  }
  return from2;
}
__name(findLastIndex, "findLastIndex");

// Legend/utils/getLayeredCake.ts
function fromEntries(pairs) {
  return Object.assign({}, ...pairs.map(([k, v]) => ({ [k]: v })));
}
__name(fromEntries, "fromEntries");
var isDefined = /* @__PURE__ */ __name((it) => it != null, "isDefined");
function getLayeredCake(...layers) {
  return fromEntries(
    [].concat(
      ...layers.filter(isDefined).map((layer) => Object.entries(layer).filter(([, value]) => value !== void 0))
    )
  );
}
__name(getLayeredCake, "getLayeredCake");

// Legend/getState/getLayoutConfig.ts
var getLayoutConfig = /* @__PURE__ */ __name((rawLayoutConfig) => getLayeredCake(Legend2.Layout.Defaults, rawLayoutConfig), "getLayoutConfig");

// Legend/getState/getState.ts
var getState4 = /* @__PURE__ */ __name(({ items, layoutConfig, orientation = "HORIZONTAL" }) => ({
  items: getItems(items),
  layoutConfig: getLayoutConfig(layoutConfig),
  orientation
}), "getState");

// Legend/getTemplate/getTemplate.ts
var import_uik640 = require("@appd/uik");

// Legend/getTemplate/getItems/MEASURER.ts
var import_uik632 = require("@appd/uik");
var MEASURER = import_uik632.utils.lazyConstant(
  (withFont = (font) => Object.assign(
    !import_uik632.utils.IS_JEST && globalThis.document?.createElement("canvas").getContext("2d") || {
      // Default value needed for jsdom environments (e.g. Jest).
      measureText: () => ({ width: 1 })
    },
    { font }
  )) => ({
    // Chosen to match `particle-body-small` mixin in `_text.scss` form `@appd/ui-assets`.
    LABEL: withFont(`11px / 13px "Inter"`)
  })
);

// Legend/getTemplate/getItems/getItemBounds.ts
var getItemBounds = /* @__PURE__ */ __name((items, hostWidth, { EXTRA_WIDTH, LEAST_MAX_WIDTH, MARGIN: MARGIN2, MAX_WIDTH_FRACTION, MIN_WIDTH }) => {
  const maxWidth = Math.max(hostWidth * MAX_WIDTH_FRACTION, LEAST_MAX_WIDTH);
  return items.map(({ label }) => {
    const { width: textWidth } = MEASURER().LABEL.measureText(`${label}`);
    const contentWidth = EXTRA_WIDTH + textWidth;
    return {
      /**
       * Note: `MARGIN` is included in these bounds to simplify calculations downstream. In particular, the margin
       * needs to be included when estimating the "total width" used by a particular "cutoff width" in the
       * `getTotalWidthCurve` and `getRawLayout` functions.
       *
       * We "absorb" the `MARGIN` into the item itself at this early stage, and separate it back out at the very
       * last step in `getWithLayoutAndTooltip`.
       */
      maxWidth: Math.min(contentWidth, maxWidth) + MARGIN2,
      minWidth: Math.min(contentWidth, MIN_WIDTH) + MARGIN2,
      rawWidth: contentWidth
    };
  });
}, "getItemBounds");

// Legend/getTemplate/getItems/getRawLayout/getRawLayout.ts
var import_uik637 = require("@appd/uik");

// Legend/getTemplate/getItems/getRawLayout/getAvailableDimensions.ts
var import_uik633 = require("@appd/uik");
var getAvailableDimensions = /* @__PURE__ */ __name(({ height: height2, width }, { HEIGHT: HEIGHT4, MARGIN: MARGIN2 }) => ({
  numRowsAvailable: import_uik633.utils.clamp(Math.floor((height2 + MARGIN2) / (HEIGHT4 + MARGIN2)), [1]),
  rowWidthAvailable: width + MARGIN2
}), "getAvailableDimensions");

// Legend/getTemplate/getItems/getRawLayout/getWrapping/getWrapping.ts
var import_uik636 = require("@appd/uik");

// Legend/getTemplate/getItems/getRawLayout/getWrapping/getWithStretchedCutoffWidth.ts
var import_uik634 = require("@appd/uik");

// Legend/getTemplate/getItems/getTotalWidthCurve/getMinWidthTails/byMinWidth.ts
var byMinWidth = /* @__PURE__ */ __name(({ minWidth: first }, { minWidth: second }) => first - second, "byMinWidth");

// Legend/getTemplate/getItems/getTotalWidthCurve/getMinWidthTails/getMinWidthTails.ts
var getMinWidthTails = /* @__PURE__ */ __name((itemBounds) => itemBounds.slice().sort(byMinWidth).reduceRight(
  (context, { minWidth }) => {
    const { length, [length - 1]: previous } = context;
    if (minWidth !== previous.minWidth) {
      context.push({
        minWidth,
        tailCount: previous.tailCount + 1,
        tailSum: previous.tailSum + minWidth
      });
    } else {
      ++previous.tailCount;
      previous.tailSum += minWidth;
    }
    return context;
  },
  [
    {
      minWidth: Infinity,
      tailCount: 0,
      tailSum: 0
    }
  ]
), "getMinWidthTails");

// Legend/getTemplate/getItems/getTotalWidthCurve/getSortedCutoffWidths/byCutoffWidth.ts
var byCutoffWidth = /* @__PURE__ */ __name(({ cutoffWidth: first }, { cutoffWidth: second }) => first - second, "byCutoffWidth");

// Legend/getTemplate/getItems/getTotalWidthCurve/getSortedCutoffWidths/getSortedCutoffWidths.ts
var getSortedCutoffWidths = /* @__PURE__ */ __name((itemBounds) => [
  ...itemBounds.map(({ minWidth }) => ({
    cutoffWidth: minWidth,
    isHead: false
  })),
  ...itemBounds.map(({ maxWidth }) => ({
    cutoffWidth: maxWidth,
    isHead: true
  }))
].sort(byCutoffWidth), "getSortedCutoffWidths");

// Legend/getTemplate/getItems/getTotalWidthCurve/getTotalWidthCurve.ts
var getTotalWidthCurve = /* @__PURE__ */ __name((itemBounds) => {
  const minWidthTails = getMinWidthTails(itemBounds);
  const sortedCutoffWidths = getSortedCutoffWidths(itemBounds);
  return sortedCutoffWidths.reduce(
    (context, { cutoffWidth, isHead }) => {
      context.tailIndex = findLastIndex(
        minWidthTails,
        ({ minWidth }) => minWidth > cutoffWidth,
        context.tailIndex
      );
      const { headSum, itemsRemaining, previousValue, tailIndex } = context;
      if (cutoffWidth !== previousValue) {
        const { tailCount, tailSum } = minWidthTails[tailIndex];
        const totalWidth = headSum + cutoffWidth * (itemsRemaining - tailCount) + tailSum;
        context.result.push({
          cutoffWidth,
          totalWidth
        });
      }
      if (isHead) {
        context.headSum += cutoffWidth;
        --context.itemsRemaining;
      }
      context.previousValue = cutoffWidth;
      return context;
    },
    {
      headSum: 0,
      itemsRemaining: itemBounds.length,
      previousValue: NaN,
      result: [],
      tailIndex: minWidthTails.length - 1
    }
  ).result;
}, "getTotalWidthCurve");

// Legend/getTemplate/getItems/getRawLayout/getWrapping/getWithStretchedCutoffWidth.ts
var getWithStretchedCutoffWidth = /* @__PURE__ */ __name((rowWidth, rows) => rows.map(({ itemBounds, startIndex }) => {
  const totalWidthCurve = getTotalWidthCurve(itemBounds);
  const firstStrictlyGreaterThan = bisect(totalWidthCurve, ({ totalWidth }) => totalWidth > rowWidth);
  if (firstStrictlyGreaterThan === 0) {
    return {
      cutoffWidth: totalWidthCurve[0].cutoffWidth,
      startIndex
    };
  } else {
    const { [firstStrictlyGreaterThan - 1]: low, [firstStrictlyGreaterThan]: high = low } = totalWidthCurve;
    const stretchedMaxWidth = import_uik634.utils.mix(
      low.cutoffWidth,
      high.cutoffWidth,
      import_uik634.utils.clamp(import_uik634.utils.unmix(low.totalWidth, high.totalWidth, rowWidth) ?? 0, [0, 1])
    );
    return {
      cutoffWidth: stretchedMaxWidth,
      startIndex
    };
  }
}), "getWithStretchedCutoffWidth");

// Legend/getTemplate/getItems/getRawLayout/getWrapping/lengthOnly.ts
var import_uik635 = require("@appd/uik");
var lengthOnly = /* @__PURE__ */ __name((itemBounds, cutoffWidth, rowWidth) => itemBounds.reduce(
  (context, item) => {
    const { currentRowWidth } = context;
    const itemWidth = import_uik635.utils.clamp(item.maxWidth, [, cutoffWidth]);
    const maybeNextSum = currentRowWidth + itemWidth;
    if (maybeNextSum > rowWidth) {
      ++context.numRows;
      context.currentRowWidth = itemWidth;
    } else {
      context.currentRowWidth = maybeNextSum;
    }
    return context;
  },
  {
    currentRowWidth: 0,
    numRows: 1
  }
).numRows, "lengthOnly");

// Legend/getTemplate/getItems/getRawLayout/getWrapping/getWrapping.ts
var getWrapping = /* @__PURE__ */ __name((itemBounds, cutoffWidth, rowWidth) => {
  const { rows } = itemBounds.reduce(
    (context, { maxWidth, minWidth }, i) => {
      const { currentRowWidth } = context;
      const clampedWidth = import_uik636.utils.clamp(maxWidth, [minWidth, cutoffWidth]);
      const maybeNextSum = currentRowWidth + clampedWidth;
      if (i === 0 || maybeNextSum > rowWidth) {
        context.currentRowWidth = clampedWidth;
        context.rows.push({
          itemBounds: [],
          startIndex: i
        });
      } else {
        context.currentRowWidth = maybeNextSum;
      }
      context.rows[context.rows.length - 1].itemBounds.push({
        maxWidth,
        minWidth: clampedWidth
      });
      return context;
    },
    {
      currentRowWidth: 0,
      rows: []
    }
  );
  return getWithStretchedCutoffWidth(rowWidth, rows);
}, "getWrapping");
getWrapping.lengthOnly = lengthOnly;

// Legend/getTemplate/getItems/getRawLayout/getGreatestFittingCutoffWidth.ts
var getGreatestFittingCutoffWidth = /* @__PURE__ */ __name((lowerBound, upperBound, itemBounds, rowWidthAvailable, numRowsAvailable, { CUTOFF_WIDTH_TOLERANCE }) => {
  const cutoffWidth = bisect.continuous(
    /**
     * Decreasing variation of `utils.bisect.continuous`. (`condition(x)` is decreasing, but
     * `condition(mix(upperBound, lowerBound, x)` is increasing.)
     */
    [upperBound, lowerBound],
    (cutoffWidth$) => cutoffWidth$ <= rowWidthAvailable && getWrapping.lengthOnly(itemBounds, cutoffWidth$, rowWidthAvailable) <= numRowsAvailable,
    CUTOFF_WIDTH_TOLERANCE
  );
  return {
    rowWidth: rowWidthAvailable,
    wrapping: getWrapping(itemBounds, cutoffWidth, rowWidthAvailable)
  };
}, "getGreatestFittingCutoffWidth");

// Legend/getTemplate/getItems/getRawLayout/getGreatestMinWidth.ts
var getGreatestMinWidth = /* @__PURE__ */ __name((itemBounds) => itemBounds.reduce((greatestSoFar, { minWidth }) => Math.max(greatestSoFar, minWidth), 0), "getGreatestMinWidth");

// Legend/getTemplate/getItems/getRawLayout/getLastFitIndex.ts
var getLastFitIndex = /* @__PURE__ */ __name((itemBounds, totalWidthCurve, numRowsAvailable, rowWidthAvailable) => {
  if (getGreatestMinWidth(itemBounds) > rowWidthAvailable) {
    return -1;
  } else {
    const totalWidthAvailable = numRowsAvailable * rowWidthAvailable;
    const firstStrictlyGreaterThan = bisect(
      totalWidthCurve,
      ({ totalWidth }) => totalWidth > totalWidthAvailable
    );
    return findLastIndex(
      totalWidthCurve,
      ({ cutoffWidth }) => cutoffWidth <= rowWidthAvailable && getWrapping.lengthOnly(itemBounds, cutoffWidth, rowWidthAvailable) <= numRowsAvailable,
      firstStrictlyGreaterThan
    );
  }
}, "getLastFitIndex");

// Legend/getTemplate/getItems/getRawLayout/getLeastFittingRowWidth.ts
var getLeastFittingRowWidth = /* @__PURE__ */ __name((lowerBound, upperBound, itemBounds, cutoffWidth, numRowsAvailable, { ROW_WIDTH_TOLERANCE }) => {
  const rowWidth = bisect.continuous(
    [lowerBound, upperBound],
    (rowWidth$) => cutoffWidth <= rowWidth$ && getWrapping.lengthOnly(itemBounds, cutoffWidth, rowWidth$) <= numRowsAvailable,
    ROW_WIDTH_TOLERANCE
  );
  return {
    rowWidth,
    wrapping: getWrapping(itemBounds, cutoffWidth, rowWidth)
  };
}, "getLeastFittingRowWidth");

// Legend/getTemplate/getItems/getRawLayout/getRawLayout.ts
var getRawLayout = /* @__PURE__ */ __name((itemBounds, totalWidthCurve, dimensions, orientation, layoutConfig) => {
  const { numRowsAvailable, rowWidthAvailable } = getAvailableDimensions(dimensions, layoutConfig);
  const lastFitIndex = getLastFitIndex(itemBounds, totalWidthCurve, numRowsAvailable, rowWidthAvailable);
  const { length, [length - 1]: { cutoffWidth: greatestCutoffWidth = 0, totalWidth: greatestTotalWidth = 0 } = {} } = totalWidthCurve;
  const noneFit = lastFitIndex === -1;
  const allFit = lastFitIndex === length - 1;
  const notFittingRowWidth = greatestTotalWidth / numRowsAvailable;
  const maxPossibleOverflow = numRowsAvailable * greatestCutoffWidth;
  return noneFit ? (
    // Fit not found...
    orientation === "VERTICAL" ? (
      // Case 0: Overflow vertically. (Minimize ellipsizing.)
      {
        rowWidth: import_uik637.utils.clamp(rowWidthAvailable, [getGreatestMinWidth(itemBounds)]),
        wrapping: getWrapping(itemBounds, rowWidthAvailable, rowWidthAvailable)
      }
    ) : (
      // Case 1: Overflow horizontally. (Minimize overflow.)
      getLeastFittingRowWidth(
        notFittingRowWidth,
        notFittingRowWidth + maxPossibleOverflow,
        itemBounds,
        greatestCutoffWidth,
        numRowsAvailable,
        layoutConfig
      )
    )
  ) : (
    // Fit found...
    allFit ? (
      // Case 2: All `cutoffWidth` values fit. (Minimize ellipsizing.)
      {
        rowWidth: rowWidthAvailable,
        wrapping: getWrapping(itemBounds, greatestCutoffWidth, rowWidthAvailable)
      }
    ) : (
      // Case 3: Some `cutoffWidth` values fit. (Minimize ellipsizing.)
      getGreatestFittingCutoffWidth(
        totalWidthCurve[lastFitIndex].cutoffWidth,
        totalWidthCurve[lastFitIndex + 1].cutoffWidth,
        itemBounds,
        rowWidthAvailable,
        numRowsAvailable,
        layoutConfig
      )
    )
  );
}, "getRawLayout");

// Legend/getTemplate/getItems/getStatistical.ts
var import_uik638 = require("@appd/uik");
var {
  COLORS: { DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM12 }
} = import_uik638.MAGNETIC_TOKENS;
var getStatistical = /* @__PURE__ */ __name((rawStatistical) => rawStatistical.map((item) => ({
  ...item,
  color: DEFAULT_TEXT_MEDIUM12,
  shape: item.kind === "STANDARD_DEVIATION" ? "SQUARE" : item.kind
})), "getStatistical");

// Legend/getTemplate/getItems/getWithLayoutAndTooltip.ts
var import_uik639 = require("@appd/uik");
var getWithLayoutAndTooltip = /* @__PURE__ */ __name((data, statistical, itemBounds, wrapping, { HEIGHT: HEIGHT4, MARGIN: MARGIN2 }) => [...statistical, ...data].reduce(
  (context, item, i) => {
    const { rowIndex, translateX } = context;
    const translateY = rowIndex * (MARGIN2 + HEIGHT4);
    const finalWidth = import_uik639.utils.clamp(itemBounds[i].maxWidth, [, wrapping[rowIndex].cutoffWidth]) - MARGIN2;
    const layout = {
      transform: `translate(${translateX}px, ${translateY}px)`,
      width: `${finalWidth}px`
    };
    const tooltip = finalWidth < itemBounds[i].rawWidth ? item.label : "";
    context.items.push({
      ...item,
      layout,
      tooltip
    });
    if (i + 1 === wrapping[rowIndex + 1]?.startIndex) {
      ++context.rowIndex;
      context.translateX = 0;
    } else {
      context.translateX += finalWidth + MARGIN2;
    }
    return context;
  },
  {
    items: [],
    rowIndex: 0,
    translateX: 0
  }
).items, "getWithLayoutAndTooltip");

// Legend/getTemplate/getItems/getItems.ts
var getItems2 = /* @__PURE__ */ __name((rawItems, layoutConfig, orientation, dimensions) => {
  const { data, statistical: rawStatistical } = rawItems;
  const itemBounds = [
    ...getItemBounds(rawStatistical, dimensions.width, layoutConfig),
    ...getItemBounds(data, dimensions.width, layoutConfig)
  ];
  const totalWidthCurve = getTotalWidthCurve(itemBounds);
  const { wrapping } = getRawLayout(itemBounds, totalWidthCurve, dimensions, orientation, layoutConfig);
  const statistical = getStatistical(rawStatistical);
  return getWithLayoutAndTooltip(data, statistical, itemBounds, wrapping, layoutConfig);
}, "getItems");

// Legend/getTemplate/getOverflow.ts
var getOverflow = /* @__PURE__ */ __name((orientation) => orientation === "HORIZONTAL" ? (
  // Case 0: Overflow horizontally.
  {
    x: "auto",
    y: "hidden"
  }
) : (
  // Case 1: Overflow vertically.
  {
    x: "hidden",
    y: "auto"
  }
), "getOverflow");

// Legend/getTemplate/getTemplate.ts
var getTemplate = /* @__PURE__ */ __name(({ items, layoutConfig, orientation }, dimensions) => ({
  anySelected: items.anySelected,
  items: import_uik640.utils.CAN_USE_DOM ? getItems2(items, layoutConfig, orientation, dimensions) : [],
  overflow: getOverflow(orientation),
  trackByPosition: import_uik640.utils.identity
}), "getTemplate");

// Legend/Layout.ts
var { SPACING: SPACING28 } = MAGNETIC_TOKENS;
var Layout2;
((Layout3) => {
  let Defaults;
  ((Defaults2) => {
    Defaults2.CUTOFF_WIDTH_TOLERANCE = 10;
    Defaults2.ICON_SIZE = 16;
    Defaults2.EXTRA_WIDTH = /* Padding (left, right, between icon/label) */
    3 * SPACING28[2] + /* Icon */
    Defaults2.ICON_SIZE;
    Defaults2.HEIGHT = /* Padding (top, bottom) */
    2 * SPACING28[2] + /* Icon */
    10;
    Defaults2.LEAST_MAX_WIDTH = 400;
    Defaults2.MARGIN = SPACING28[1];
    Defaults2.MAX_WIDTH_FRACTION = 1 / 3;
    Defaults2.MIN_WIDTH = 60;
    Defaults2.ROW_WIDTH_TOLERANCE = Defaults2.CUTOFF_WIDTH_TOLERANCE;
  })(Defaults = Layout3.Defaults || (Layout3.Defaults = {}));
})(Layout2 || (Layout2 = {}));

// Legend/STYLES.ts
var import_uik641 = require("@appd/uik");
var {
  COLORS: { CONTROL_BORDER_ACTIVE, CONTROL_BORDER_HOVER: CONTROL_BORDER_HOVER5, DEFAULT_TEXT: DEFAULT_TEXT18 },
  FONT: FONT2,
  RADIUS: RADIUS14,
  SPACING: SPACING29,
  TYPOGRAPHY: { ELLIPSES: ELLIPSES15 }
} = import_uik641.MAGNETIC_TOKENS;
var {
  Defaults: { ICON_SIZE }
} = Layout2;
var STYLES26 = {
  CHECKBOX: (color2, isSelected2) => (0, import_uik641.css)({
    "& > div": {
      "& > svg": {
        marginLeft: 1,
        marginTop: -1,
        maxHeight: ICON_SIZE - 1,
        maxWidth: ICON_SIZE - 1,
        minHeight: ICON_SIZE - 1,
        minWidth: ICON_SIZE - 1
      },
      ...isSelected2 ? { backgroundColor: color2 } : {},
      borderRadius: 3,
      maxHeight: ICON_SIZE,
      maxWidth: ICON_SIZE,
      minHeight: ICON_SIZE,
      minWidth: ICON_SIZE
    },
    "&:hover": { "& > div": { ...isSelected2 ? { backgroundColor: color2 } : {} } }
  }),
  HOST: (0, import_uik641.css)({
    "::-webkit-scrollbar": { display: "none" },
    // Take up available space in a flex container.
    flexGrow: 1,
    minHeight: 26,
    overflowX: "auto",
    position: "relative"
  }),
  ICON: (0, import_uik641.css)({
    borderRadius: 3,
    flexShrink: 0,
    height: ICON_SIZE,
    marginRight: SPACING29[2],
    width: ICON_SIZE
  }),
  ITEM: (isSelected2) => (0, import_uik641.css)({
    ":focus-visible": {
      borderRadius: RADIUS14.DEFAULT + 2,
      outline: `2px solid ${CONTROL_BORDER_ACTIVE}`,
      outlineOffset: -2
    },
    ":hover": { "& > div > div > span": isSelected2 ? {} : { borderColor: CONTROL_BORDER_HOVER5 } },
    alignItems: "center",
    background: "none",
    border: "none",
    borderRadius: RADIUS14.DEFAULT,
    cursor: "pointer",
    display: "flex",
    height: 26,
    padding: SPACING29[2],
    position: "absolute"
  }),
  LABEL: (0, import_uik641.css)({
    ...ELLIPSES15.END,
    color: DEFAULT_TEXT18,
    fontFamily: FONT2.INTER[400].fontFamily,
    fontSize: "11px"
  })
};

// Legend/Legend.tsx
var import_jsx_runtime490 = require("react/jsx-runtime");
var Legend2 = Object.assign(
  import_uik642.utils.forwardRef(
    ({ className: className2, items, onSelectedChange, orientation = "HORIZONTAL", ...inherited }, ref) => {
      const [dimensions, setDimensions] = (0, import_react92.useReducer)(
        (dimensions2, { height: height2, width }) => dimensions2.height !== height2 || dimensions2.width !== width ? {
          height: height2,
          width
        } : dimensions2,
        INITIAL_DIMENSIONS
      );
      const [selected, setSelected] = (0, import_react92.useState)([]);
      const state = getState4({
        items,
        orientation
      });
      const template = getTemplate(state, dimensions);
      const fontsReady = import_uik642.utils.useFontsReady();
      const allSquareShapes = template.items.every(({ shape }) => shape === "SQUARE");
      return /* @__PURE__ */ (0, import_jsx_runtime490.jsx)(import_uik642.Measurer, { onResize: setDimensions, children: /* @__PURE__ */ (0, import_jsx_runtime490.jsx)(
        "div",
        {
          className: (0, import_uik642.css)(HOST9, ...import_uik642.utils.many(className2)),
          ref,
          suppressHydrationWarning: true,
          uik: "Legend",
          ...inherited,
          children: fontsReady && template.items.map(({ color: color2, index, label, layout, shape, tooltip }, _, { length }) => {
            const isSelected2 = selected.includes(index);
            const showEmptyCheckbox = selected.length > 0 && !isSelected2;
            const showSeriesIcon = selected.length === 0 || isSelected2;
            return /* @__PURE__ */ (0, import_jsx_runtime490.jsx)(import_uik642.Tooltip, { value: tooltip, children: /* @__PURE__ */ (0, import_jsx_runtime490.jsxs)(
              "button",
              {
                className: (0, import_uik642.css)(ITEM3(isSelected2), layout),
                onClick: () => {
                  const nextSelected = isSelected2 ? selected.filter((x) => x !== index) : selected.length + 1 === length ? [] : [...selected, index];
                  setSelected(nextSelected);
                  onSelectedChange?.(nextSelected);
                },
                children: [
                  allSquareShapes ? /* @__PURE__ */ (0, import_jsx_runtime490.jsx)(import_jsx_runtime490.Fragment, { children: selected.length > 0 ? /* @__PURE__ */ (0, import_jsx_runtime490.jsx)(import_uik642.Checkbox, { checked: isSelected2, className: (0, import_uik642.css)(CHECKBOX(color2, isSelected2)) }) : (0, import_react92.cloneElement)(import_uik642.Cartesian.SHAPES[shape], { className: (0, import_uik642.css)(ICON2, { fill: color2 }) }) }) : /* @__PURE__ */ (0, import_jsx_runtime490.jsxs)(import_jsx_runtime490.Fragment, { children: [
                    showEmptyCheckbox && /* @__PURE__ */ (0, import_jsx_runtime490.jsx)(import_uik642.Checkbox, { checked: false, className: (0, import_uik642.css)(CHECKBOX(color2, isSelected2)) }),
                    showSeriesIcon && (0, import_react92.cloneElement)(import_uik642.Cartesian.SHAPES[shape], { className: (0, import_uik642.css)(ICON2, { fill: color2 }) })
                  ] }),
                  /* @__PURE__ */ (0, import_jsx_runtime490.jsx)("div", { className: LABEL4, children: label })
                ]
              }
            ) }, index);
          })
        }
      ) });
    }
  ),
  { Layout: Layout2 }
);
Legend2.displayName = "Legend";
Legend2.__DEV_METADATA__ = { status: "READY" };
var INITIAL_DIMENSIONS = {
  height: 40,
  width: 0
};
var { CHECKBOX, HOST: HOST9, ICON: ICON2, ITEM: ITEM3, LABEL: LABEL4 } = STYLES26;

// List/List.tsx
var import_uik648 = require("@appd/uik");
var import_react95 = require("react");

// List/CONTEXT.ts
var import_react93 = require("react");
var CONTEXT9 = (0, import_react93.createContext)({
  filtered: false,
  multiple: false,
  selected: false
});

// List/MESSAGES.ts
var MESSAGES15 = {
  SELECT_ALL: format.message`Select all`.description("A button to select all options from a list.")
};

// List/Option/Option.tsx
var import_uik644 = require("@appd/uik");
var import_react94 = require("react");

// List/Option/getStyles.ts
var import_uik643 = require("@appd/uik");
var {
  COLORS: { CONTROL_BG_WEAK_ACTIVE: CONTROL_BG_WEAK_ACTIVE2, CONTROL_BG_WEAK_HOVER: CONTROL_BG_WEAK_HOVER2, DEFAULT_TEXT: DEFAULT_TEXT19, DEFAULT_TEXT_DISABLED: DEFAULT_TEXT_DISABLED4 },
  EFFECTS: { TRANSITION },
  SPACING: SPACING30,
  TYPOGRAPHY: { ELLIPSES: ELLIPSES16, P3_DEFAULT: P3_DEFAULT16 }
} = import_uik643.MAGNETIC_TOKENS;
var getStyles21 = /* @__PURE__ */ __name((disabled, filtered = false, multiple, selected) => ({
  OPTION: (0, import_uik643.css)({
    all: void 0,
    ...!disabled && { ":hover": { backgroundColor: CONTROL_BG_WEAK_HOVER2 } },
    alignItems: "left",
    backgroundColor: selected && !multiple ? CONTROL_BG_WEAK_ACTIVE2 : "transparent",
    border: "none",
    color: disabled ? DEFAULT_TEXT_DISABLED4 : DEFAULT_TEXT19,
    cursor: disabled ? "not-allowed" : "pointer",
    display: filtered ? "none" : "flex",
    font: P3_DEFAULT16,
    height: 36,
    maxWidth: 800,
    outlineOffset: "-1px",
    padding: `${SPACING30[0]} ${SPACING30[3]}px`,
    transition: TRANSITION,
    whiteSpace: "pre-wrap"
  }),
  TEXT: (0, import_uik643.css)({
    ...ELLIPSES16.END,
    width: "100%"
  })
}), "getStyles");

// List/Option/Option.tsx
var import_jsx_runtime491 = require("react/jsx-runtime");
var Option2 = import_uik644.utils.forwardRef(
  ({ children, className: className2, disabled = false, subMenuTrigger = false, tabIndex = 0, ...props2 }, forwardedRef) => {
    const ref = (0, utils_exports.useBroadcastRef)(forwardedRef);
    const { filtered, multiple, selected } = (0, import_react94.useContext)(CONTEXT9);
    const { OPTION: OPTION2, TEXT: TEXT4 } = getStyles21(disabled, filtered, multiple, selected);
    return /* @__PURE__ */ (0, import_jsx_runtime491.jsxs)(
      Button2,
      {
        className: (0, import_uik644.css)(OPTION2, ...import_uik644.utils.many(className2)),
        disabled,
        ref,
        role: "listitem",
        tabIndex,
        uik: "List.Option",
        ...props2,
        type: "MENU_ITEM",
        children: [
          multiple && /* @__PURE__ */ (0, import_jsx_runtime491.jsx)(import_uik644.Checkbox, { checked: selected, disabled, tabIndex: -1 }),
          /* @__PURE__ */ (0, import_jsx_runtime491.jsx)(import_uik644.Tooltip, { position: "RIGHT", showOnOverflowOnly: true, value: children, children: /* @__PURE__ */ (0, import_jsx_runtime491.jsx)("span", { className: TEXT4, children }) }),
          subMenuTrigger && /* @__PURE__ */ (0, import_jsx_runtime491.jsx)("div", { children: ">" })
        ]
      }
    );
  }
);
Option2.displayName = "List.Option";

// List/Section/Section.tsx
var import_uik646 = require("@appd/uik");

// List/Section/STYLES.ts
var import_uik645 = require("@appd/uik");
var {
  COLORS: { CONTROL_BORDER_WEAK: CONTROL_BORDER_WEAK13, DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM13 },
  SPACING: SPACING31,
  TYPOGRAPHY: { ELLIPSES: ELLIPSES17, P4_DEFAULT: P4_DEFAULT6 }
} = import_uik645.MAGNETIC_TOKENS;
var STYLES27 = {
  "& > .title": {
    "& .label": { ...ELLIPSES17.END },
    "& > .icon": {
      flexShrink: 0,
      marginRight: `${SPACING31[1]}px`
    },
    alignItems: "center",
    color: DEFAULT_TEXT_MEDIUM13,
    display: "flex",
    font: P4_DEFAULT6,
    margin: `${SPACING31[2]}px ${SPACING31[3]}px`
  },
  all: void 0,
  borderBottomWidth: "1px",
  borderColor: CONTROL_BORDER_WEAK13,
  borderTopWidth: "1px"
};

// List/Section/Section.tsx
var import_jsx_runtime492 = require("react/jsx-runtime");
var Section2 = import_uik646.utils.forwardRef(
  ({ children, className: className2, icon, label, ...props2 }, ref) => /* @__PURE__ */ (0, import_jsx_runtime492.jsxs)("div", { className: (0, import_uik646.css)(STYLES27, ...import_uik646.utils.many(className2)), ref, uik: "List.Section", ...props2, children: [
    /* @__PURE__ */ (0, import_jsx_runtime492.jsxs)("div", { className: "title", children: [
      icon && /* @__PURE__ */ (0, import_jsx_runtime492.jsx)(import_uik646.Icon, { className: "icon", type: icon }),
      /* @__PURE__ */ (0, import_jsx_runtime492.jsx)(import_uik646.Tooltip, { showOnOverflowOnly: true, value: label, children: /* @__PURE__ */ (0, import_jsx_runtime492.jsx)("div", { className: "label", children: label }) })
    ] }),
    children
  ] })
);
Section2.displayName = "List.Section";

// List/STYLES.ts
var import_uik647 = require("@appd/uik");
var {
  COLORS: { CONTROL_BORDER_WEAK: CONTROL_BORDER_WEAK14 }
} = import_uik647.MAGNETIC_TOKENS;
var STYLES28 = {
  SELECT_ALL: (0, import_uik647.css)({
    borderBottom: `1px solid ${CONTROL_BORDER_WEAK14}`,
    height: 36
  })
};

// List/List.tsx
var import_jsx_runtime493 = require("react/jsx-runtime");
var List5 = Object.assign(
  import_uik648.utils.forwardRef(
    ({
      children: rawChildren = [],
      className: className2,
      filter = "",
      multiple = false,
      onFilter,
      onSelect,
      selectAll: selectAll2 = false,
      selected: untypedSelected,
      ...props2
    }, forwardedRef) => {
      const maybeSelected = untypedSelected;
      const [rawSelected, setRawSelected] = (0, import_react95.useState)(() => import_uik648.utils.many(maybeSelected ?? []));
      const selected = maybeSelected == null ? rawSelected : import_uik648.utils.many(maybeSelected ?? []);
      (0, import_react95.useEffect)(() => onFilter?.(filteredItems), [filter]);
      const {
        /** The context-wrapped version of rawChildren/rawChildElements. */
        children,
        /** The number of children matching the `filter` prop. */
        filteredItems,
        /** `rawChildren` filtered down to just JSX elements (e.g. exclude primitives like `number`, `string`, etc). */
        rawChildElements
      } = (0, import_react95.useMemo)(() => {
        const rawChildElements2 = import_react95.Children.toArray(rawChildren).filter(import_react95.isValidElement);
        const filteredItems2 = rawChildElements2.filter(matchesFilter(filter)).length;
        const notSelectable = selected.length === 0 && onSelect == void 0 && multiple === false;
        if (notSelectable) {
          return {
            children: rawChildElements2,
            filteredItems: filteredItems2,
            rawChildElements: rawChildElements2
          };
        }
        return {
          children: rawChildElements2.map((child, i) => {
            const self = child.props.id ?? i;
            const isSelected2 = selected.includes(self);
            return /* @__PURE__ */ (0, import_jsx_runtime493.jsx)(
              CONTEXT9.Provider,
              {
                value: {
                  filtered: matchesFilter(filter)(child),
                  multiple,
                  selected: isSelected2
                },
                children: (0, import_react95.cloneElement)(child, {
                  onClick: (event) => {
                    event.stopPropagation();
                    child.props.onClick?.(event);
                    const cases = {
                      MULTIPLE: () => {
                        if (self == null) {
                          return { changed: false };
                        }
                        const nextSelected = isSelected2 ? selected.filter((x) => x !== self) : [...selected, self];
                        return {
                          changed: true,
                          next: {
                            selected: nextSelected,
                            values: rawChildElements2.filter(({ props: { id } }, i2) => nextSelected.includes(id ?? i2)).map(getNodeText)
                          }
                        };
                      },
                      SINGLE: () => self == null ? { changed: false } : {
                        changed: true,
                        next: {
                          selected: [self],
                          values: [getNodeText(child)]
                        }
                      }
                    };
                    const { changed, next } = cases[multiple ? "MULTIPLE" : "SINGLE"]();
                    if (changed) {
                      setRawSelected(next.selected);
                      onSelect?.(next.selected, next.values);
                    }
                  }
                })
              },
              i
            );
          }),
          filteredItems: filteredItems2,
          rawChildElements: rawChildElements2
        };
      }, [rawChildren, filter, rawSelected]);
      const selectAllOption = multiple && selectAll2 && /* @__PURE__ */ (0, import_jsx_runtime493.jsx)(
        CONTEXT9.Provider,
        {
          value: {
            filtered: false,
            multiple,
            selected: children.length === selected.length
          },
          children: /* @__PURE__ */ (0, import_jsx_runtime493.jsx)(
            Option2,
            {
              className: SELECT_ALL,
              onClick: (event) => {
                event.stopPropagation();
                if (children.length === selected.length) {
                  setRawSelected([]);
                  onSelect?.([], []);
                } else {
                  const nextSelected = rawChildElements.map(({ props: { id } }, i) => id ?? i);
                  setRawSelected(nextSelected);
                  onSelect?.(nextSelected, rawChildElements.map(getNodeText));
                }
              },
              children: MESSAGES15.SELECT_ALL()
            }
          )
        }
      );
      return /* @__PURE__ */ (0, import_jsx_runtime493.jsxs)("div", { className: (0, import_uik648.css)(...import_uik648.utils.many(className2)), ref: forwardedRef, role: "list", uik: "List", ...props2, children: [
        selectAllOption,
        children
      ] });
    }
  ),
  {
    Option: Option2,
    Section: Section2
  }
);
List5.displayName = "List";
List5.__DEV_METADATA__ = { status: "READY" };
var getNodeText = /* @__PURE__ */ __name((node) => !node ? "" : typeof node === "object" ? Array.isArray(node) ? node.map(getNodeText).join("") : node.props?.children ? getNodeText(node.props.children) : String(node) : String(node), "getNodeText");
var matchesFilter = /* @__PURE__ */ __name((filter) => (child) => child.props.children?.toString().toLowerCase().indexOf(filter.toLowerCase()) === -1, "matchesFilter");
var { SELECT_ALL } = STYLES28;

// Loading/Loading.tsx
var import_uik651 = require("@appd/uik");

// Loading/Bar/Bar.tsx
var import_uik650 = require("@appd/uik");

// Loading/Bar/getStyles.ts
var import_uik649 = require("@appd/uik");
var {
  COLORS: { DEFAULT_TEXT: DEFAULT_TEXT20, DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM14, INTERACT_BORDER: INTERACT_BORDER2, INTERACT_BORDER_WEAK },
  RADIUS: RADIUS15,
  TYPOGRAPHY: { P3_EMPHASIS: P3_EMPHASIS7, P4_DEFAULT: P4_DEFAULT7 }
} = import_uik649.MAGNETIC_TOKENS;
var getStyles22 = /* @__PURE__ */ __name(({ progress = NaN, thin }, randomOrThin = isNaN(progress) || thin) => import_uik649.css.Styles({
  BAR: import_uik649.css.Styles({
    ...randomOrThin && {
      animationDelay: "0s",
      animationDirection: "alternate",
      animationDuration: "3s",
      animationIterationCount: "infinite",
      animationName: {
        "0%": { backgroundPosition: "25%" },
        "100%": { backgroundPosition: "-75%" }
      },
      animationTimingFunction: "ease-in-out"
    },
    background: `linear-gradient(90deg, ${(randomOrThin ? [`${INTERACT_BORDER2} 25%`, `${INTERACT_BORDER_WEAK} 0%`] : [
      `${INTERACT_BORDER2} ${import_uik649.format.number.percent(progress)}`,
      `${INTERACT_BORDER_WEAK} ${import_uik649.format.number.percent(progress)}`
    ]).join(",")})`,
    backgroundSize: randomOrThin ? "200% 100%" : "100% 100%",
    borderRadius: RADIUS15.DEFAULT,
    display: "inline-block",
    height: thin ? 6 : 8,
    marginTop: 4.5,
    width: randomOrThin ? "100%" : "calc(100% - 47px)"
  }),
  BAR_LABEL: import_uik649.css.Styles({
    color: DEFAULT_TEXT_MEDIUM14,
    display: thin ? "none" : "inline-block",
    font: P4_DEFAULT7,
    marginLeft: 15
  }),
  DESCRIPTION: import_uik649.css.Styles({
    color: DEFAULT_TEXT_MEDIUM14,
    display: thin ? "none" : "block",
    font: P4_DEFAULT7,
    marginTop: 4.5
  }),
  TITLE: import_uik649.css.Styles({
    color: DEFAULT_TEXT20,
    display: thin ? "none" : "block",
    font: P3_EMPHASIS7
  })
}), "getStyles");

// Loading/Bar/Bar.tsx
var import_jsx_runtime494 = require("react/jsx-runtime");
var Bar2 = import_uik650.utils.forwardRef(
  ({ className: className2, description, progress, thin, title, ...props2 }, ref) => {
    const { BAR, BAR_LABEL, DESCRIPTION: DESCRIPTION3, TITLE: TITLE4 } = getStyles22({
      progress,
      thin
    });
    return /* @__PURE__ */ (0, import_jsx_runtime494.jsxs)("div", { className: (0, import_uik650.css)(...import_uik650.utils.many(className2)), ref, uik: "Loading.Bar", ...props2, children: [
      /* @__PURE__ */ (0, import_jsx_runtime494.jsx)("div", { className: (0, import_uik650.css)(TITLE4), children: title }),
      /* @__PURE__ */ (0, import_jsx_runtime494.jsx)("div", { className: (0, import_uik650.css)(BAR) }),
      progress != null && /* @__PURE__ */ (0, import_jsx_runtime494.jsx)("div", { className: (0, import_uik650.css)(BAR_LABEL), children: import_uik650.format.number.percent(progress) }),
      /* @__PURE__ */ (0, import_jsx_runtime494.jsx)("div", { className: (0, import_uik650.css)(DESCRIPTION3), children: description })
    ] });
  }
);
Bar2.displayName = "Loading.Bar";

// Loading/Loading.tsx
var import_jsx_runtime495 = (
  // Implementation suggestion:
  //   Use `::before` and `::after` pseudo elements if more elements are needed, rather than introducing new <div>s.
  //   (There were 3 `getStyles.spinnerElement` and 1 `getStyles.spinnerContainer` before, which was very superfluous.)
  // Motivation:
  //   Spinners are the leafmost of leaf elements. We'd like it to take up as less space in the DevTools Elements panel
  //   to match its low conceptual importance.
  require("react/jsx-runtime")
);
var Loading2 = Object.assign(
  import_uik651.utils.forwardRef(({ className: className2, ...props2 }, ref) => /* @__PURE__ */ (0, import_jsx_runtime495.jsx)("div", { className: (0, import_uik651.css)(...import_uik651.utils.many(className2)), ref, uik: "Loading", ...props2, children: "TODO" })),
  { Bar: Bar2 }
);
Loading2.displayName = "Loading";
Loading2.__DEV_METADATA__ = { status: "READY" };

// Lookup/Lookup.tsx
var import_uik660 = require("@appd/uik");
var import_react99 = require("react");

// Lookup/Action/Action.tsx
var import_uik653 = require("@appd/uik");

// Lookup/Action/STYLES.ts
var import_uik652 = require("@appd/uik");
var { SPACING: SPACING32 } = import_uik652.MAGNETIC_TOKENS;
var STYLES29 = {
  CONTAINER: (0, import_uik652.css)({ display: "flex" }),
  ICON: (0, import_uik652.css)({
    marginLeft: -2,
    marginRight: SPACING32[1]
  }),
  TEXT: (0, import_uik652.css)({ marginTop: 2 })
};

// Lookup/Action/Action.tsx
var import_jsx_runtime496 = require("react/jsx-runtime");
var Action = import_uik653.utils.forwardRef(({ children, label, type, ...props2 }, forwardedRef) => /* @__PURE__ */ (0, import_jsx_runtime496.jsx)(import_uik653.List.Option, { ref: forwardedRef, tabIndex: -1, uik: "Lookup.Action", ...props2, children: /* @__PURE__ */ (0, import_jsx_runtime496.jsxs)("div", { className: (0, import_uik653.css)(CONTAINER3), children: [
  type && /* @__PURE__ */ (0, import_jsx_runtime496.jsx)(import_uik653.Icon, { className: (0, import_uik653.css)(ICON3), size: "SMALL", type }),
  label && /* @__PURE__ */ (0, import_jsx_runtime496.jsx)("div", { className: (0, import_uik653.css)(TEXT3), children: label }),
  children
] }) }));
Action.displayName = "Lookup.Action";
var { CONTAINER: CONTAINER3, ICON: ICON3, TEXT: TEXT3 } = STYLES29;

// Lookup/CONTEXT.ts
var import_react96 = require("react");
var CONTEXT10 = (0, import_react96.createContext)({
  open: false,
  searchValue: "",
  setOpen: () => {
  }
});

// Lookup/Dialog/Dialog.tsx
var import_uik655 = require("@appd/uik");
var import_react97 = require("react");

// Lookup/Dialog/STYLES.ts
var import_uik654 = require("@appd/uik");
var { SPACING: SPACING33 } = import_uik654.MAGNETIC_TOKENS;
var STYLES30 = {
  DIALOG: (0, import_uik654.css)({
    paddingLeft: SPACING33[6],
    paddingRight: SPACING33[6]
  }),
  SEARCHBOX: (0, import_uik654.css)({
    "& > div": { width: 200 },
    display: "flex",
    justifyContent: "flex-start",
    marginBottom: SPACING33[2],
    marginTop: SPACING33[1]
  })
};

// Lookup/MESSAGES.ts
var MESSAGES16 = {
  ADD: format.message`Add`.description("A button to confirm the action presented by a dialog"),
  CANCEL: format.message`Cancel`.description("A button to cancel the action presented by a dialog")
};

// Lookup/Dialog/Dialog.tsx
var import_jsx_runtime497 = require("react/jsx-runtime");
var Dialog2 = import_uik655.utils.forwardRef(
  ({
    action = MESSAGES16.ADD(),
    cancel = MESSAGES16.CANCEL(),
    children,
    onClose,
    onSearch,
    open: rawOpen,
    searchValue,
    size = "LARGE",
    ...props2
  }, ref) => {
    const { open, setOpen } = (0, import_react97.useContext)(CONTEXT10);
    const [rawSearchValue, setRawSearchValue] = (0, import_react97.useState)("");
    searchValue ??= rawSearchValue;
    return /* @__PURE__ */ (0, import_jsx_runtime497.jsxs)(
      import_uik655.Dialog,
      {
        action,
        cancel,
        className: DIALOG,
        onClose: (kind) => {
          setOpen(false);
          onClose(kind);
        },
        open: rawOpen ?? open,
        ref,
        size,
        uik: "Lookup.Dialog",
        ...props2,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime497.jsx)("div", { className: SEARCHBOX, children: /* @__PURE__ */ (0, import_jsx_runtime497.jsx)(
            import_uik655.SearchBox,
            {
              onChange: (value) => {
                onSearch?.(value);
                setRawSearchValue(value);
              },
              value: searchValue
            }
          ) }),
          children
        ]
      }
    );
  }
);
Dialog2.displayName = "Lookup.Dialog";
var { DIALOG, SEARCHBOX } = STYLES30;

// Lookup/getStyles.ts
var import_uik656 = require("@appd/uik");
var OPTION_HEIGHT = 36;
var MAX_POPOVER_HEIGHT = 260;
var MAX_WIDTH = 800;
var getStyles23 = /* @__PURE__ */ __name((width, showMore, dropdownVisible) => ({
  ACTIONS: (0, import_uik656.css)({ borderTop: `1px solid ${CONTROL_BORDER_WEAK15}` }),
  BORDER: (0, import_uik656.css)({
    border: `2px solid ${CONTROL_BORDER15}`,
    borderRadius: RADIUS16.HEAVY,
    boxShadow: "none",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    maxHeight: MAX_POPOVER_HEIGHT,
    maxWidth: MAX_WIDTH,
    minWidth: width,
    overflow: "hidden",
    padding: 0,
    width
  }),
  BUTTON: (0, import_uik656.css)({
    "& > svg > path, & > svg > path[fill='#fff']": { fill: CONTROL_ICON_WEAK8 },
    ":hover": { backgroundColor: "transparent" },
    backgroundColor: "transparent",
    borderRadius: 0,
    height: OPTION_HEIGHT,
    padding: 0
  }),
  CLOSE: (0, import_uik656.css)({
    "& > svg": {
      height: 16,
      width: 16
    },
    display: "flex",
    height: 36,
    marginRight: -SPACING34[1]
  }),
  INPUT: (0, import_uik656.css)({
    "& > div > input": dropdownVisible && {
      border: `2px solid ${CONTROL_BORDER_FOCUS2}`,
      boxShadow: SHADOW_FOCUS2
    }
  }),
  INPUT_ACTIONS: (0, import_uik656.css)({ display: "flex" }),
  NO_RESULTS: (0, import_uik656.css)({
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    height: 60,
    margin: SPACING34[5],
    maxHeight: 60,
    overflow: "hidden"
  }),
  OPEN: (0, import_uik656.css)({ marginRight: SPACING34[1] }),
  POPOVER: (0, import_uik656.css)({
    borderRadius: RADIUS16.HEAVY,
    boxSizing: "border-box",
    marginBottom: SPACING34[2],
    marginTop: 6
  }),
  POPOVER_CONTENT: (0, import_uik656.css)({
    borderRadius: RADIUS16.HEAVY,
    boxShadow: "none",
    maxHeight: MAX_POPOVER_HEIGHT,
    maxWidth: MAX_WIDTH,
    minWidth: width,
    padding: 0,
    width
  }),
  SCROLL_BOX: (0, import_uik656.css)({
    flexGrow: 1,
    maxHeight: showMore ? 216 : MAX_POPOVER_HEIGHT,
    overflowX: "hidden",
    overflowY: showMore ? "hidden" : "scroll",
    width: "100%"
  }),
  SHOWMORE: (0, import_uik656.css)({
    borderTop: `1px solid ${CONTROL_BORDER_WEAK15}`,
    height: OPTION_HEIGHT
  }),
  TAGS_CONTAINER: (0, import_uik656.css)({
    alignItems: "center",
    display: "flex",
    height: 34
  }),
  TAG_COUNT: (0, import_uik656.css)({
    marginLeft: SPACING34[2],
    paddingInline: SPACING34[2]
  })
}), "getStyles");
var {
  COLORS: { CONTROL_BORDER: CONTROL_BORDER15, CONTROL_BORDER_FOCUS: CONTROL_BORDER_FOCUS2, CONTROL_BORDER_WEAK: CONTROL_BORDER_WEAK15, CONTROL_ICON_WEAK: CONTROL_ICON_WEAK8 },
  EFFECTS: { SHADOW_FOCUS: SHADOW_FOCUS2 },
  RADIUS: RADIUS16,
  SPACING: SPACING34
} = import_uik656.MAGNETIC_TOKENS;

// Lookup/Option/Option.tsx
var import_uik659 = require("@appd/uik");

// Lookup/Option/Custom/Custom.tsx
var import_uik658 = require("@appd/uik");
var import_react98 = require("react");

// Lookup/Option/Custom/STYLES.ts
var import_uik657 = require("@appd/uik");
var {
  COLORS: { DEFAULT_TEXT: DEFAULT_TEXT21 },
  SPACING: SPACING35,
  TYPOGRAPHY: { P3_DEFAULT: P3_DEFAULT17 }
} = import_uik657.MAGNETIC_TOKENS;
var STYLES31 = {
  OPTION: (0, import_uik657.css)({
    alignItems: "center",
    color: DEFAULT_TEXT21,
    display: "flex",
    flexDirection: "row",
    font: P3_DEFAULT17,
    height: 36,
    justifyContent: "space-between",
    paddingLeft: SPACING35[3],
    paddingRight: SPACING35[1]
  })
};

// Lookup/Option/Custom/Custom.tsx
var import_jsx_runtime498 = require("react/jsx-runtime");
var Custom2 = import_uik658.utils.forwardRef(({ ...props2 }, forwardedRef) => {
  const { searchValue } = (0, import_react98.useContext)(CONTEXT10);
  return searchValue ? /* @__PURE__ */ (0, import_jsx_runtime498.jsxs)("div", { className: OPTION, ref: forwardedRef, tabIndex: -1, uik: "Lookup.Option.Custom", ...props2, children: [
    /* @__PURE__ */ (0, import_jsx_runtime498.jsxs)("div", { children: [
      '"',
      searchValue,
      '"'
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime498.jsx)(import_uik658.Button, { icon: "Action.Add", type: "TERTIARY", children: MESSAGES16.ADD() })
  ] }) : /* @__PURE__ */ (0, import_jsx_runtime498.jsx)(import_jsx_runtime498.Fragment, {});
});
Custom2.displayName = "Lookup.Custom";
var { OPTION } = STYLES31;

// Lookup/Option/Option.tsx
var import_jsx_runtime499 = require("react/jsx-runtime");
var Option3 = Object.assign(
  import_uik659.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime499.jsx)(import_uik659.List.Option, { ref, uik: "Lookup.Option", ...props2 })),
  { Custom: Custom2 }
);
Option3.displayName = "Lookup.Option";

// Lookup/Lookup.tsx
var import_jsx_runtime500 = require("react/jsx-runtime");
var Lookup = Object.assign(
  import_uik660.utils.forwardRef(
    ({
      children: rawChildren,
      className: className2,
      disabled,
      disableFiltering: rawDisableFiltering,
      errors: rawErrors = [],
      getSuggestions,
      initialValue: untypedInitialValue,
      label,
      multiple,
      name = label,
      onChange,
      onSearch: rawOnSearch,
      placeholder = import_uik660.Form.MESSAGES.LOOKUP_PLACEHOLDER(),
      readOnly,
      required = false,
      searchable,
      secondaryHint,
      selectAll: selectAll2 = false,
      showClear = true,
      showOptional = !required,
      value: untypedValue,
      uik = "Lookup",
      ...props2
    }, maybeRef) => {
      let value = untypedValue;
      let initialValue = untypedInitialValue;
      const MAX_ADVANCED_OPTIONS_VISIBLE = 8;
      const actionsRef = (0, import_react99.useRef)(null);
      const firstRender = (0, import_react99.useRef)(true);
      const inputRef = (0, import_react99.useRef)(null);
      const ref = import_uik660.utils.useBroadcastRef(maybeRef);
      const { submitted } = (0, import_react99.useContext)(import_uik660.Form.CONTEXT);
      const [filteredChildren, setFilteredChildren] = (0, import_react99.useState)(0);
      const [dialogOpen, setDialogOpen] = (0, import_react99.useState)(false);
      const [dropdownVisible, setDropdownVisible] = (0, import_react99.useState)(false);
      const [touched, setTouched] = (0, import_react99.useState)(false);
      const [width, setWidth] = (0, import_react99.useState)(0);
      const [suggestions, setSuggestions] = (0, import_react99.useState)([]);
      const disableFiltering = rawDisableFiltering ?? getSuggestions != void 0;
      const onSearch = /* @__PURE__ */ __name((search) => {
        rawOnSearch?.(search);
        if (!getSuggestions) {
          setSuggestions([]);
          return;
        } else {
          (async () => {
            setSuggestions(await getSuggestions(search));
          })();
        }
        setValues((prev) => ({
          ...prev,
          searchValue: search
        }));
      }, "onSearch");
      (0, import_react99.useEffect)(() => {
        onSearch("");
      }, []);
      const children = getSuggestions != void 0 ? suggestions.map((suggestion) => /* @__PURE__ */ (0, import_jsx_runtime500.jsx)(Lookup.Option, { id: suggestion.id, children: suggestion.label })) : rawChildren;
      const actions = (0, import_react99.useMemo)(
        () => import_react99.Children.toArray(children).filter(import_react99.isValidElement).filter(({ type }) => type === Lookup.Action || type === Lookup.Option.Custom),
        [children]
      );
      const dialog = (0, import_react99.useMemo)(
        () => import_react99.Children.toArray(children).filter(import_react99.isValidElement).filter(({ type }) => type === Lookup.Dialog),
        [children]
      );
      const listChildren = (0, import_react99.useMemo)(
        () => import_react99.Children.toArray(children).filter(import_react99.isValidElement).filter(({ type }) => type !== Lookup.Dialog && type !== Lookup.Action && type !== Lookup.Option.Custom),
        [children]
      );
      const [{ pseudoSelectValue, rawValue, searchValue }, setValues] = (0, import_react99.useState)({
        pseudoSelectValue: getPseudoSelectValue(listChildren, value ?? initialValue ?? []),
        rawValue: initialValue ?? [],
        searchValue: ""
      });
      value ??= rawValue;
      (0, import_react99.useEffect)(
        () => import_uik660.utils.addEventListener(document.body, "keydown", ({ key }) => key === "Tab" && setDropdownVisible(false)),
        []
      );
      (0, import_react99.useEffect)(() => {
        const nextPseudoSelectValue = getPseudoSelectValue(listChildren, value ?? initialValue ?? []);
        !dropdownVisible && setValues({
          pseudoSelectValue: nextPseudoSelectValue,
          rawValue: value ?? initialValue ?? [],
          searchValue: searchable && multiple ? searchValue : getPlaceholderSearchValue(multiple, nextPseudoSelectValue, value ?? initialValue ?? [])
        });
      }, [JSON.stringify(value), JSON.stringify(suggestions)]);
      import_uik660.utils.useLayoutEffect(() => {
        if (firstRender.current) {
          firstRender.current = false;
          return;
        }
        ref.current?.dispatchEvent(new Event("change", { bubbles: true }));
      }, [ref, JSON.stringify(pseudoSelectValue)]);
      (0, import_react99.useEffect)(
        () => import_uik660.utils.addEventListener(document.body, "click", (e) => {
          if (searchable && multiple) {
            const inside = inputRef?.current?.contains(e.target);
            if (inside) {
              setDropdownVisible(true);
            } else {
              setDropdownVisible(false);
            }
          } else {
            const nextPseudoSelectValue = getPseudoSelectValue(listChildren, value ?? initialValue ?? []);
            !inputRef?.current?.contains(e.target) && value?.length && setValues((prev) => ({
              ...prev,
              searchValue: getPlaceholderSearchValue(multiple, nextPseudoSelectValue, value ?? initialValue ?? [])
            }));
          }
        }),
        [inputRef, multiple, value]
      );
      import_uik660.utils.useLayoutEffect(() => {
        setWidth(inputRef.current?.offsetWidth ?? 0);
      }, []);
      const noResults = listChildren.length - (disableFiltering ? 0 : filteredChildren) === 0;
      const remainder = dialog.length && listChildren.length - (disableFiltering ? 0 : filteredChildren) - MAX_ADVANCED_OPTIONS_VISIBLE;
      const {
        ACTIONS,
        BORDER,
        BUTTON: BUTTON3,
        CLOSE: CLOSE3,
        INPUT,
        INPUT_ACTIONS,
        NO_RESULTS,
        OPEN,
        POPOVER: POPOVER2,
        POPOVER_CONTENT: POPOVER_CONTENT2,
        SCROLL_BOX,
        SHOWMORE,
        TAG_COUNT,
        TAGS_CONTAINER
      } = getStyles23(width, remainder > 0, dropdownVisible);
      const onResizeOrScroll = (0, import_react99.useCallback)(() => {
        if (inputRef.current != null) {
          setWidth(inputRef.current?.offsetWidth ?? 0);
        }
      }, []);
      const requiredError = (submitted || touched) && required && !disabled && !readOnly && value.every((value2) => typeof value2 === "number" && value2 < 0);
      ref.current?.setCustomValidity(rawErrors.join(" "));
      ref.current && (ref.current.errors = [...requiredError ? [import_uik660.Form.MESSAGES.REQUIRED()] : [], ...rawErrors]);
      const errors = ref.current?.errors ?? [];
      return /* @__PURE__ */ (0, import_jsx_runtime500.jsx)(
        CONTEXT10.Provider,
        {
          value: {
            open: dialogOpen,
            searchValue,
            setOpen: setDialogOpen
          },
          children: /* @__PURE__ */ (0, import_jsx_runtime500.jsx)(import_uik660.Measurer, { onResize: onResizeOrScroll, children: /* @__PURE__ */ (0, import_jsx_runtime500.jsxs)("div", { className: (0, import_uik660.css)(...import_uik660.utils.many(className2)), uik, children: [
            dialog,
            /* @__PURE__ */ (0, import_jsx_runtime500.jsx)(
              import_uik660.Popover,
              {
                align: "START",
                arrow: false,
                className: POPOVER2,
                content: !disabled && dropdownVisible && /* @__PURE__ */ (0, import_jsx_runtime500.jsxs)("div", { className: BORDER, children: [
                  /* @__PURE__ */ (0, import_jsx_runtime500.jsx)(import_uik660.ScrollBox, { className: SCROLL_BOX, containOverlays: false, hideVertical: remainder > 0, children: /* @__PURE__ */ (0, import_jsx_runtime500.jsx)(
                    import_uik660.List,
                    {
                      filter: disableFiltering ? void 0 : searchValue,
                      multiple,
                      onFilter: disableFiltering ? void 0 : setFilteredChildren,
                      onSelect: (selected, values) => {
                        setTouched(true);
                        onChange?.(selected);
                        !multiple && setDropdownVisible(false);
                        setValues((prev) => ({
                          pseudoSelectValue: values,
                          rawValue: selected,
                          searchValue: !multiple ? values[0] : prev.searchValue
                        }));
                      },
                      selectAll: selectAll2,
                      selected: value,
                      children: listChildren
                    }
                  ) }),
                  remainder > 0 && /* @__PURE__ */ (0, import_jsx_runtime500.jsx)(
                    import_uik660.List.Option,
                    {
                      className: SHOWMORE,
                      onClick: () => {
                        setDropdownVisible(false);
                        setDialogOpen(true);
                        if (!searchable || !multiple) {
                          setValues((prev) => ({
                            ...prev,
                            searchValue: getPlaceholderSearchValue(
                              multiple,
                              pseudoSelectValue,
                              value ?? prev.rawValue
                            )
                          }));
                        }
                      },
                      children: import_uik660.Form.MESSAGES.SHOW_MORE(remainder)
                    }
                  ),
                  noResults && /* @__PURE__ */ (0, import_jsx_runtime500.jsx)("div", { className: NO_RESULTS, children: /* @__PURE__ */ (0, import_jsx_runtime500.jsx)(
                    import_uik660.Illustration,
                    {
                      icon: "Health.InfoMessage",
                      secondary: import_uik660.Form.MESSAGES.NO_RESULTS(),
                      size: "MEDIUM"
                    }
                  ) }),
                  actions.length > 0 && /* @__PURE__ */ (0, import_jsx_runtime500.jsx)(
                    import_uik660.List,
                    {
                      className: ACTIONS,
                      onSelect: () => {
                        setTouched(true);
                        setDropdownVisible(false);
                      },
                      children: actions
                    }
                  )
                ] }),
                contentClassName: POPOVER_CONTENT2,
                ignore: actionsRef,
                onVisibleChange: setDropdownVisible,
                position: "BOTTOM",
                stopPropagation: true,
                visible: !disabled && dropdownVisible,
                children: /* @__PURE__ */ (0, import_jsx_runtime500.jsx)(
                  import_uik660.Input,
                  {
                    actions: /* @__PURE__ */ (0, import_jsx_runtime500.jsxs)("div", { className: INPUT_ACTIONS, ref: actionsRef, children: [
                      showClear && value.length > 0 && !disabled && /* @__PURE__ */ (0, import_jsx_runtime500.jsx)(
                        import_uik660.Button,
                        {
                          className: (0, import_uik660.css)(BUTTON3, CLOSE3),
                          icon: "Action.Cancel",
                          onClick: () => {
                            onChange?.([]);
                            setValues({
                              pseudoSelectValue: [],
                              rawValue: [],
                              searchValue: ""
                            });
                          },
                          type: "TERTIARY"
                        }
                      ),
                      /* @__PURE__ */ (0, import_jsx_runtime500.jsx)(
                        import_uik660.Button,
                        {
                          className: (0, import_uik660.css)(BUTTON3, OPEN),
                          disabled,
                          icon: dialog.length ? "Navigation.ChevronRight" : "Navigation.ArrowDropDown",
                          onClick: (e) => {
                            e.stopPropagation();
                            if (dialog.length) {
                              setDialogOpen(true);
                              setDropdownVisible(false);
                            } else {
                              if (searchable && multiple) {
                                setDropdownVisible(!dropdownVisible);
                              } else {
                                setDropdownVisible((prevState) => {
                                  prevState ? (
                                    // if closing, set searchValue
                                    setValues((prev) => ({
                                      ...prev,
                                      searchValue: getPlaceholderSearchValue(
                                        multiple,
                                        prev.pseudoSelectValue,
                                        prev.rawValue
                                      )
                                    }))
                                  ) : (
                                    // if opening, clear searchValue
                                    setValues((prev) => ({
                                      ...prev,
                                      searchValue: ""
                                    }))
                                  );
                                  return !prevState;
                                });
                              }
                            }
                          },
                          type: "TERTIARY"
                        }
                      )
                    ] }),
                    className: (0, import_uik660.css)(INPUT),
                    disabled,
                    errors,
                    form: "",
                    label,
                    onBlur: () => setTouched(true),
                    onChange: ({ currentTarget: { value: value2 } }) => {
                      onSearch(value2);
                      setDropdownVisible(true);
                      setValues((prev) => ({
                        ...prev,
                        searchValue: value2
                      }));
                    },
                    onFocus: () => {
                      if (!searchable || !multiple) {
                        setValues((prev) => ({
                          ...prev,
                          searchValue: ""
                        }));
                        setDropdownVisible(true);
                      }
                    },
                    overflowTooltip: true,
                    placeholder,
                    prefix: /* @__PURE__ */ (0, import_jsx_runtime500.jsx)("div", { className: (0, import_uik660.css)(TAGS_CONTAINER), children: multiple && value.length > 0 && /* @__PURE__ */ (0, import_jsx_runtime500.jsx)(
                      import_uik660.Tooltip,
                      {
                        value: import_react99.Children.toArray(listChildren).filter(import_react99.isValidElement).filter(({ props: { id } }, i) => value?.includes(id ?? i)).map((child) => getNodeText2(child)?.toString()).join(", "),
                        children: /* @__PURE__ */ (0, import_jsx_runtime500.jsx)(import_uik660.Tag, { className: (0, import_uik660.css)(TAG_COUNT), children: value.length })
                      }
                    ) }),
                    readOnly,
                    ref: inputRef,
                    required: false,
                    secondaryHint,
                    showOptional: required ? false : showOptional,
                    tabIndex: -1,
                    value: searchValue,
                    ...props2
                  }
                )
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime500.jsx)(
              "select",
              {
                className: (0, import_uik660.css)({ display: "none" }),
                multiple: true,
                name,
                readOnly: true,
                ref,
                required,
                value: multiple ? pseudoSelectValue : [pseudoSelectValue[0]],
                children: import_react99.Children.toArray(listChildren).filter(import_react99.isValidElement).map((child) => {
                  const label2 = getNodeText2(child)?.toString();
                  return /* @__PURE__ */ (0, import_jsx_runtime500.jsx)("option", { id: child.props.id, value: label2 }, label2);
                })
              }
            )
          ] }) })
        }
      );
    }
  ),
  {
    Action,
    Dialog: Dialog2,
    Option: Option3,
    Section: Object.assign(
      import_uik660.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime500.jsx)("div", { ref, uik: "Lookup.Section", ...props2, children: "Section" })),
      { displayName: "Lookup.Section" }
    )
  }
);
Lookup.displayName = "Lookup";
Lookup.__DEV_METADATA__ = { status: "DEPRECATED" };
var getNodeText2 = /* @__PURE__ */ __name((node) => !node ? "" : typeof node === "object" ? Array.isArray(node) ? node.map(getNodeText2).join("") : node.props?.children ? getNodeText2(node.props.children) : String(node) : String(node), "getNodeText");
var getPseudoSelectValue = /* @__PURE__ */ __name((children, value) => import_react99.Children.toArray(children).filter(import_react99.isValidElement).filter(({ props: { id } }, i) => value.includes(id ?? i)).map((child) => getNodeText2(child)?.toString() ?? ""), "getPseudoSelectValue");
var getPlaceholderSearchValue = /* @__PURE__ */ __name((multiple = false, pseudoSelectValue, value) => value.length === 0 || multiple && value?.length > 0 ? "" : pseudoSelectValue[0]?.toString() ?? "", "getPlaceholderSearchValue");

// Measurer/Measurer.tsx
var import_uik663 = require("@appd/uik");

// Measurer/OBSERVER.ts
var import_uik661 = require("@appd/uik");

// Measurer/SUBSCRIBERS.ts
var SUBSCRIBERS = /* @__PURE__ */ new WeakMap();

// Measurer/OBSERVER.ts
var OBSERVER = (
  // Doesn't exist for static renders.
  globalThis.ResizeObserver && new ResizeObserver(
    (entries) => entries.forEach((entry) => {
      const { target } = entry;
      const callbacks = SUBSCRIBERS.get(target);
      if (callbacks) {
        const boundingClientRect = import_uik661.utils.getBoundingClientRect(target);
        callbacks.forEach((onResize2) => onResize2?.(boundingClientRect, entry, target));
      }
    })
  )
);

// Measurer/subscribe.ts
var import_uik662 = require("@appd/uik");
var subscribe = /* @__PURE__ */ __name((element, onResize2, box) => {
  if (element) {
    SUBSCRIBERS.get(element)?.push(onResize2) ?? SUBSCRIBERS.set(element, [onResize2]);
    OBSERVER?.observe(element, { box });
    return () => {
      OBSERVER?.unobserve(element);
      const callbacks = SUBSCRIBERS.get(element)?.filter((callback) => callback !== onResize2) ?? [];
      SUBSCRIBERS[callbacks.length ? "set" : "delete"](element, callbacks);
    };
  }
  return import_uik662.utils.noop;
}, "subscribe");

// Measurer/Measurer.tsx
var Measurer9 = Object.assign(
  import_uik663.utils.forwardRef(({ box, children, onResize: rawOnResize }, forwardedRef) => {
    const child = import_uik663.utils.useOnlyChildWithRef(children, forwardedRef);
    const onResize2 = import_uik663.utils.useLiveCallback(rawOnResize);
    import_uik663.utils.useLayoutEffect(
      () => import_uik663.utils.resizeObserver(
        child.ref.current,
        ({ height: height2, width }, entry) => onResize2(
          {
            get bottom() {
              return entry.target.getBoundingClientRect().bottom;
            },
            height: height2,
            get left() {
              return entry.target.getBoundingClientRect().left;
            },
            get right() {
              return entry.target.getBoundingClientRect().right;
            },
            get toJSON() {
              return entry.target.getBoundingClientRect().toJSON;
            },
            get top() {
              return entry.target.getBoundingClientRect().top;
            },
            width,
            get x() {
              return entry.target.getBoundingClientRect().x;
            },
            get y() {
              return entry.target.getBoundingClientRect().y;
            }
          },
          entry,
          entry.target
        ),
        { box }
      ),
      [child.ref.current]
    );
    return child.withRef;
  }),
  {
    OBSERVER,
    SUBSCRIBERS,
    subscribe
  }
);
Measurer9.displayName = "Measurer";

// Menu/Menu.tsx
var import_uik668 = require("@appd/uik");
var import_react102 = require("react");

// Menu/List.tsx
var import_uik664 = require("@appd/uik");
var import_react100 = require("react");
var import_jsx_runtime501 = require("react/jsx-runtime");
var TRAVERSAL2 = {
  next: (list, item) => item.nextElementSibling ?? list.firstChild,
  previous: (list, item) => item.previousElementSibling ?? list.lastChild
};
var moveFocus2 = /* @__PURE__ */ __name((list, currentFocus, type) => {
  const traversal = TRAVERSAL2[type];
  let nextFocus = traversal(list, currentFocus);
  let wrappedOnce = false;
  while (nextFocus) {
    if (nextFocus === list.firstChild) {
      if (wrappedOnce) {
        return false;
      }
      wrappedOnce = true;
    }
    if (!nextFocus.hasAttribute("tabindex") || nextFocus.disabled) {
      nextFocus = traversal(list, nextFocus);
    } else {
      nextFocus.focus();
      return;
    }
  }
  return;
}, "moveFocus");
var List9 = import_uik664.utils.forwardRef(
  ({ children: rawChildren, onSelect, selected, ...props2 }, forwardedRef) => {
    const children = import_react100.Children.toArray(rawChildren).filter(import_react100.isValidElement).map((child, index) => (0, import_react100.cloneElement)(child, { tabIndex: index === 0 ? 0 : -1 }));
    const listRef = import_uik664.utils.useBroadcastRef(forwardedRef);
    const onKeyDown = /* @__PURE__ */ __name((event) => {
      const list = listRef.current;
      const key = event.key;
      const currentFocus = document.activeElement;
      if (!list.contains(currentFocus)) {
        return;
      }
      if (key === "ArrowDown") {
        event.preventDefault();
        moveFocus2(list, currentFocus, "next");
      } else if (key === "ArrowUp") {
        event.preventDefault();
        moveFocus2(list, currentFocus, "previous");
      }
    }, "onKeyDown");
    return /* @__PURE__ */ (0, import_jsx_runtime501.jsx)(
      import_uik664.List,
      {
        onKeyDown,
        onSelect,
        ref: listRef,
        role: "menu",
        selected,
        uik: "Menu.List",
        ...props2,
        children
      }
    );
  }
);
List9.displayName = "Menu.List";

// Menu/Option.tsx
var import_uik665 = require("@appd/uik");
var import_jsx_runtime502 = require("react/jsx-runtime");
var Option4 = import_uik665.utils.forwardRef((props2, forwardedRef) => {
  const ref = (0, utils_exports.useBroadcastRef)(forwardedRef);
  return /* @__PURE__ */ (0, import_jsx_runtime502.jsx)(import_uik665.List.Option, { ref, tabIndex: -1, uik: "Menu.Option", ...props2 });
});
Option4.displayName = "Menu.Option";

// Menu/STYLES.ts
var import_uik666 = require("@appd/uik");
var {
  COLORS: { CONTROL_BG_ACTIVE: CONTROL_BG_ACTIVE2, CONTROL_BORDER_WEAK: CONTROL_BORDER_WEAK16 },
  EFFECT: {
    SHADOW: { ELEVATED }
  }
} = import_uik666.MAGNETIC_TOKENS;
var STYLES32 = {
  MENU_LIST: (0, import_uik666.css)({
    ":focus": { backgroundColor: CONTROL_BG_ACTIVE2 },
    boxShadow: ELEVATED,
    outline: `1px solid ${CONTROL_BORDER_WEAK16}`
  }),
  OUTLINE: (0, import_uik666.css)({ outline: `1px solid ${CONTROL_BORDER_WEAK16}` })
};

// Menu/SubMenu.tsx
var import_uik667 = require("@appd/uik");
var import_react101 = require("react");
var import_jsx_runtime503 = require("react/jsx-runtime");
var SubMenu2 = import_uik667.utils.forwardRef(
  ({ onSelect, options, selectedSubMenu, trigger: rawTrigger, ...props2 }, forwardedRef) => {
    const triggerRef = (0, import_react101.useRef)(null);
    const trigger = (0, import_react101.cloneElement)(rawTrigger, { ref: triggerRef });
    const menuRef = (0, import_react101.useRef)(null);
    const subMenu = /* @__PURE__ */ (0, import_jsx_runtime503.jsx)(import_uik667.FocusManager, { autoFocus: true, children: /* @__PURE__ */ (0, import_jsx_runtime503.jsx)(List9, { onSelect, ref: menuRef, selected: selectedSubMenu, children: options.map((option, index) => /* @__PURE__ */ (0, import_jsx_runtime503.jsx)(Option4, { children: hasTrigger(option) ? option.trigger : option.label }, index)) }) });
    const onKeyDown = /* @__PURE__ */ __name((event) => {
      event.stopPropagation();
      const { key, shiftKey } = event;
      if (shiftKey && key === "Tab" || key === "Escape") {
        event.preventDefault();
      } else if (key === "Tab") {
        event.preventDefault();
      }
    }, "onKeyDown");
    return /* @__PURE__ */ (0, import_jsx_runtime503.jsx)(
      import_uik667.Popover,
      {
        align: "START",
        arrow: false,
        contentClassName: (0, import_uik667.css)({ padding: 0 }),
        ignore: forwardedRef,
        position: "RIGHT",
        trigger: "HOVER",
        uik: "Menu.SubMenu",
        ...props2,
        content: subMenu,
        onKeyDown,
        children: trigger
      }
    );
  }
);
SubMenu2.displayName = "Menu.SubMenu";
var hasTrigger = /* @__PURE__ */ __name((option) => "trigger" in option, "hasTrigger");

// Menu/Menu.tsx
var import_jsx_runtime504 = require("react/jsx-runtime");
var Menu3 = Object.assign(
  import_uik668.utils.forwardRef(
    ({ children, className: className2, onSelect, onVisibleChange, selected, trigger, visible: rawVisible, ...props2 }, forwardedRef) => {
      const [originalFocus, setOriginalFocus] = (0, import_react102.useState)(null);
      const menuRef = (0, import_react102.useRef)(null);
      const [visible, setVisible] = (0, import_react102.useState)(void 0);
      if (rawVisible != null && rawVisible !== visible) {
        setVisible(rawVisible);
      }
      const controlled = rawVisible != void 0;
      const onWrappedSelect = /* @__PURE__ */ __name((indices, values) => {
        controlled && onVisibleChange?.(false);
        setVisible(false);
        if (Array.isArray(children)) {
          let childrenArr = children;
          if (childrenArr[indices[0]]?.props?.options) {
            return;
          } else {
            onSelect?.(indices, values);
          }
        }
      }, "onWrappedSelect");
      const menu = visible && /* @__PURE__ */ (0, import_jsx_runtime504.jsx)(import_uik668.FocusManager, { children: /* @__PURE__ */ (0, import_jsx_runtime504.jsx)(Menu3.List, { className: MENU_LIST2, onSelect: onWrappedSelect, ref: menuRef, selected, uik: "Menu", children }) });
      const triggerRef = (0, import_react102.useRef)(null);
      const rawOnClick = trigger.props["onClick"];
      const clonedTrigger = (0, import_react102.cloneElement)(trigger, {
        "aria-expanded": `${visible}`,
        "aria-haspopup": "menu",
        onClick: (event) => {
          const newVisible = !visible;
          rawOnClick?.(event);
          setVisible(newVisible);
        },
        ref: triggerRef
      });
      (0, import_react102.useEffect)(() => {
        visible ? !originalFocus && setOriginalFocus(document.activeElement) : originalFocus?.focus();
        setTimeout(() => menuRef.current?.querySelector(FOCUSABLE_SELECTOR)?.focus());
      }, [visible]);
      const onKeyDown = /* @__PURE__ */ __name((event) => {
        const { key, shiftKey } = event;
        if (shiftKey && key === "Tab" || key === "Escape") {
          event.preventDefault();
          onVisibleChange?.(false);
        } else if (key === "Tab") {
          event.preventDefault();
        }
      }, "onKeyDown");
      return /* @__PURE__ */ (0, import_jsx_runtime504.jsx)(
        import_uik668.Popover,
        {
          align: "START",
          arrow: false,
          className: (0, import_uik668.css)(OUTLINE),
          contentClassName: (0, import_uik668.css)(className2, { padding: 0 }),
          ignore: forwardedRef,
          position: "BOTTOM",
          ref: forwardedRef,
          tabIndex: -1,
          ...props2,
          content: menu,
          onKeyDown,
          onVisibleChange: (newVisible) => {
            setVisible(newVisible);
            onVisibleChange?.(newVisible);
          },
          visible: controlled ? rawVisible : visible,
          children: clonedTrigger
        }
      );
    }
  ),
  {
    List: List9,
    Option: Option4,
    SubMenu: SubMenu2
  }
);
Menu3.displayName = "Menu";
Menu3.__DEV_METADATA__ = { status: "DEPRECATED" };
var { MENU_LIST: MENU_LIST2, OUTLINE } = STYLES32;

// Overlay/Overlay.tsx
var import_react107 = require("react");
var import_react_dom = require("react-dom");

// Overlay/CONTEXT.ts
var import_uik669 = require("@appd/uik");
var import_react103 = require("react");
var NULL = {
  parent: null,
  ref: { current: null },
  subscribe: () => import_uik669.utils.noop,
  zIndex: 0
};
var CONTEXT11 = Object.assign((0, import_react103.createContext)(NULL), {
  NULL,
  displayName: "Overlay.CONTEXT"
});

// Overlay/Provider/Provider.tsx
var import_uik673 = require("@appd/uik");
var import_react106 = require("react");

// Overlay/Provider/parentsOf.ts
function* parentsOf(context) {
  while (true) {
    if (context.parent && context.parent !== Overlay8.CONTEXT.NULL) {
      yield context.parent;
      context = context.parent;
    } else {
      break;
    }
  }
}
__name(parentsOf, "parentsOf");

// Overlay/Provider/STYLES.ts
var import_uik670 = require("@appd/uik");
var STYLES33 = {
  CONTAINER: (0, import_uik670.css)({
    "> *": { pointerEvents: "auto" },
    boxSizing: "border-box",
    contain: "size layout paint style",
    height: "var(--scrollHeight)",
    pointerEvents: "none",
    width: "var(--scrollWidth)"
  }),
  ISOLATE: (0, import_uik670.css)({
    contain: "size layout style",
    containIntrinsicSize: 0,
    height: 0,
    left: 0,
    position: "absolute",
    top: 0,
    width: 0,
    // Should be large enough to exceed normal content.
    // https://appdynamics.slack.com/archives/C043JN68ALB/p1664566314587659?thread_ts=1664561053.593799&cid=C043JN68ALB
    zIndex: 100
  })
};

// Overlay/Provider/useIntersectionObserver/useIntersectionObserver.ts
var import_uik672 = require("@appd/uik");
var import_react105 = require("react");

// Overlay/Provider/useIntersectionObserver/useUpdate.ts
var import_uik671 = require("@appd/uik");
var import_react104 = require("react");
var useUpdate = /* @__PURE__ */ __name((maybeRef, setMeasurements) => {
  const ref = import_uik671.utils.useBroadcastRef(maybeRef);
  const update = (0, import_react104.useCallback)(() => {
    const parent = ref.current?.parentElement?.parentElement;
    if (!parent) {
      return;
    }
    const { clientHeight, clientWidth, scrollHeight, scrollWidth } = parent;
    const { paddingBottom, paddingLeft, paddingRight, paddingTop } = getComputedStyle(parent);
    const next = {
      clientHeight,
      clientWidth,
      paddingBottom: parseFloat(paddingBottom),
      paddingLeft: parseFloat(paddingLeft),
      paddingRight: parseFloat(paddingRight),
      paddingTop: parseFloat(paddingTop),
      scrollHeight,
      scrollWidth
    };
    setMeasurements(
      (old) => old.clientHeight !== next.clientHeight || old.clientWidth !== next.clientWidth || old.paddingBottom !== next.paddingBottom || old.paddingLeft !== next.paddingLeft || old.paddingRight !== next.paddingRight || old.paddingTop !== next.paddingTop || old.scrollHeight !== next.scrollHeight || old.scrollWidth !== next.scrollWidth ? next : old
    );
  }, []);
  return {
    ref,
    update
  };
}, "useUpdate");

// Overlay/Provider/useIntersectionObserver/useIntersectionObserver.ts
var useIntersectionObserver = /* @__PURE__ */ __name((maybeRef) => {
  const [measurements, setMeasurements] = (0, import_react105.useState)({
    clientHeight: 0,
    clientWidth: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    scrollHeight: 0,
    scrollWidth: 0
  });
  const { ref, update } = useUpdate(maybeRef, setMeasurements);
  import_uik672.utils.useLayoutEffect(() => {
    const { current: container } = ref;
    const parent = container?.parentElement?.parentElement;
    if (!parent) {
      return;
    }
    if (!globalThis.IntersectionObserver) {
      return update();
    }
    const observer = new IntersectionObserver(update, {
      root: parent,
      threshold: [...Array(100 + 1).keys()].map((x) => x / 100)
    });
    observer.observe(container);
    const unsubscribe = [
      () => observer.disconnect(),
      import_uik672.Measurer.subscribe(parent, update, "border-box"),
      import_uik672.Measurer.subscribe(parent, update, "content-box"),
      import_uik672.utils.addEventListener(parent, "pointerdown", update, { capture: true }),
      import_uik672.utils.addEventListener(parent, "pointerenter", update, { capture: true }),
      import_uik672.utils.addEventListener(parent, "pointerleave", update, { capture: true }),
      import_uik672.utils.addEventListener(parent, "pointerup", update, { capture: true })
    ];
    return () => unsubscribe.forEach((f) => f());
  }, [ref.current]);
  return {
    measurements,
    ref
  };
}, "useIntersectionObserver");

// Overlay/Provider/Provider.tsx
var import_jsx_runtime505 = require("react/jsx-runtime");
var Provider4 = Object.assign(
  import_uik673.utils.forwardRef(
    ({ children, className: className2, onResize: onResize2, promote = 0, style: rawStyle, zIndex, ...inherited }, maybeRef) => {
      const parent = (0, import_react106.useContext)(Overlay8.CONTEXT);
      const { measurements, ref } = useIntersectionObserver(maybeRef);
      const measurementsMutable = (0, import_react106.useMemo)(() => import_uik673.utils.mutable(measurements), []);
      const context = {
        parent,
        ref,
        subscribe: measurementsMutable.subscribe,
        zIndex: parent.zIndex
      };
      const promoted = promote ? [context, ...parentsOf(context)].at(promote === Infinity ? -1 : promote) ?? context : context;
      const withZIndex = zIndex == null ? promoted : {
        ...promoted,
        zIndex: typeof zIndex === "function" ? zIndex(promoted) : zIndex
      };
      const style = {
        "--clientHeight": `${measurements.clientHeight}px`,
        "--clientWidth": `${measurements.clientWidth}px`,
        "--paddingBottom": `${measurements.paddingBottom}px`,
        "--paddingLeft": `${measurements.paddingLeft}px`,
        "--paddingRight": `${measurements.paddingRight}px`,
        "--paddingTop": `${measurements.paddingTop}px`,
        "--scrollHeight": `${measurements.scrollHeight}px`,
        "--scrollWidth": `${measurements.scrollWidth}px`,
        ...rawStyle
      };
      {
        const onResizeRef = (0, import_react106.useRef)(onResize2);
        onResizeRef.current = onResize2;
        import_uik673.utils.useLayoutEffect(() => promoted.subscribe((...args) => onResizeRef.current?.(...args)), [promoted]);
      }
      import_uik673.utils.useLayoutEffect(() => measurementsMutable.set(measurements), [measurements]);
      return /* @__PURE__ */ (0, import_jsx_runtime505.jsxs)(Overlay8.CONTEXT.Provider, { value: withZIndex, children: [
        children,
        (!promote || parent === Overlay8.CONTEXT.NULL) && /* @__PURE__ */ (0, import_jsx_runtime505.jsx)("div", { className: (0, import_uik673.css)(ISOLATE3, ...import_uik673.utils.many(className2)), style, uik: "Overlay.ISOLATE", ...inherited, children: /* @__PURE__ */ (0, import_jsx_runtime505.jsx)("div", { className: CONTAINER4, ref, uik: "Overlay.CONTAINER" }) })
      ] });
    }
  ),
  { parentsOf }
);
Provider4.displayName = "Overlay.Provider";
var { CONTAINER: CONTAINER4, ISOLATE: ISOLATE3 } = STYLES33;

// Overlay/Overlay.tsx
var Overlay8 = /* @__PURE__ */ __name(({ children }) => {
  const { ref } = (0, import_react107.useContext)(Overlay8.CONTEXT);
  return ref.current ? (0, import_react_dom.createPortal)(children, ref.current) : null;
}, "Overlay");
Overlay8.CONTEXT = CONTEXT11;
Overlay8.Provider = Provider4;
Overlay8.displayName = "Overlay";

// Pill/Pill.tsx
var import_uik675 = require("@appd/uik");
var import_react108 = require("react");

// Pill/getStyles.ts
var import_uik674 = require("@appd/uik");
var {
  COLORS: {
    CONTROL_BG_MEDIUM_ACTIVE,
    CONTROL_BG_MEDIUM_DISABLED,
    CONTROL_BORDER_STRONG_ACTIVE,
    CONTROL_BORDER_WEAK_ACTIVE: CONTROL_BORDER_WEAK_ACTIVE2,
    DEFAULT_BG_STRONG_DISABLED: DEFAULT_BG_STRONG_DISABLED2,
    DEFAULT_TEXT: DEFAULT_TEXT22,
    DEFAULT_TEXT_DISABLED: DEFAULT_TEXT_DISABLED5,
    DEFAULT_TEXT_IN_ACTIVE,
    DORMANT_ICON_IN
  },
  SPACING: SPACING36,
  TYPOGRAPHY: { ELLIPSES: ELLIPSES18, P4_DEFAULT: P4_DEFAULT8 }
} = import_uik674.MAGNETIC_TOKENS;
var getStyles24 = /* @__PURE__ */ __name(({
  disabled,
  onClose,
  onSelectedChange,
  selected
}) => import_uik674.css.Styles({
  CLOSE: import_uik674.css.Styles({
    "& > path": { fill: DORMANT_ICON_IN },
    ":focus-visible": {
      border: `1px solid ${CONTROL_BORDER_STRONG_ACTIVE}`,
      borderRadius: 2,
      boxSizing: "border-box",
      height: 20,
      marginLeft: SPACING36[2] - 1,
      marginRight: -1,
      width: 20
    },
    marginLeft: SPACING36[2],
    // TODO Unnecessary once chakra is gone.
    ...{ outline: "none" }
  }),
  ICON: import_uik674.css.Styles({ marginRight: SPACING36[1] }),
  LABEL: import_uik674.css.Styles({
    ...ELLIPSES18.END,
    font: P4_DEFAULT8,
    maxWidth: 230
  }),
  ...disabled ? import_uik674.css.Styles({
    "& path": { opacity: 0.34 },
    color: DEFAULT_TEXT_DISABLED5
  }) : import_uik674.css.Styles({
    "& path": { opacity: 0.64 },
    ":hover path": { opacity: 0.94 },
    color: DEFAULT_TEXT22,
    ...(onClose || onSelectedChange) && { cursor: "pointer" },
    ":focus-visible": { borderColor: DEFAULT_TEXT_IN_ACTIVE },
    ":hover": { backgroundColor: DEFAULT_BG_STRONG_DISABLED2 }
  }),
  ...selected ? import_uik674.css.Styles({
    backgroundColor: CONTROL_BG_MEDIUM_ACTIVE,
    border: `1px solid ${CONTROL_BORDER_WEAK_ACTIVE2}`
  }) : import_uik674.css.Styles({
    backgroundColor: CONTROL_BG_MEDIUM_DISABLED,
    border: `1px solid transparent`
  }),
  alignItems: "center",
  borderRadius: 15,
  boxSizing: "border-box",
  display: "inline-flex",
  height: 30,
  paddingLeft: SPACING36[4],
  paddingRight: onClose ? SPACING36[2] : SPACING36[4],
  // TODO Unnecessary once chakra is gone.
  ...{ outline: "none" }
}), "getStyles");

// Pill/Pill.tsx
var import_jsx_runtime506 = require("react/jsx-runtime");
var Pill = import_uik675.utils.forwardRef(
  ({ className: className2, disabled, icon: rawIcon, label, onClick, onClose, onSelectedChange, selected, ...rest }, ref) => {
    const [rawSelected, setRawSelected] = (0, import_react108.useState)(selected);
    selected ??= rawSelected;
    const { CLOSE: CLOSE3, ICON: ICON4, LABEL: LABEL7, ...HOST14 } = getStyles24({
      disabled,
      onClose,
      onSelectedChange,
      selected
    });
    const icon = rawIcon && ((element = typeof rawIcon === "string" ? /* @__PURE__ */ (0, import_jsx_runtime506.jsx)(import_uik675.Icon, { type: rawIcon }) : rawIcon) => (0, import_react108.cloneElement)(element, {
      className: (0, import_uik675.css)(ICON4, element.props.className),
      size: "SMALL"
    }))();
    const close = onClose && /* @__PURE__ */ (0, import_jsx_runtime506.jsx)(
      import_uik675.Icon.Action.Cancel,
      {
        className: (0, import_uik675.css)(CLOSE3),
        onClick: (event) => {
          event.stopPropagation();
          onClose();
        },
        size: "SMALL",
        tabIndex: 0
      }
    );
    return /* @__PURE__ */ (0, import_jsx_runtime506.jsxs)(
      "div",
      {
        className: (0, import_uik675.css)(HOST14, ...import_uik675.utils.many(className2)),
        onClick: (event) => {
          onClick?.(event);
          if (!disabled && onSelectedChange) {
            onSelectedChange(!rawSelected);
            setRawSelected(!rawSelected);
          }
        },
        ref,
        tabIndex: onSelectedChange && !disabled ? 0 : void 0,
        uik: "Pill",
        ...rest,
        children: [
          icon,
          /* @__PURE__ */ (0, import_jsx_runtime506.jsx)(import_uik675.Tooltip, { showOnOverflowOnly: true, value: label, children: /* @__PURE__ */ (0, import_jsx_runtime506.jsx)("div", { className: (0, import_uik675.css)(LABEL7), children: label }) }),
          close
        ]
      }
    );
  }
);
Pill.displayName = "Pill";
Pill.__DEV_METADATA__ = { status: "DEPRECATED" };

// Popover/Popover.tsx
var import_uik677 = require("@appd/uik");
var import_react109 = require("react");

// Popover/getStyles.ts
var import_uik676 = require("@appd/uik");
var {
  COLORS: { CONTROL_BG_WEAK: CONTROL_BG_WEAK13, DEFAULT_TEXT: DEFAULT_TEXT23, DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM15, INTERACT_TEXT: INTERACT_TEXT4 },
  EFFECTS: { SHADOW_FLOATING: SHADOW_FLOATING2 },
  RADIUS: RADIUS17,
  SPACING: SPACING37,
  TYPOGRAPHY: { P4_DEFAULT: P4_DEFAULT9, P4_EMPHASIS: P4_EMPHASIS3 }
} = import_uik676.MAGNETIC_TOKENS;
var getStyles25 = /* @__PURE__ */ __name(() => ({
  CONTENT: (0, import_uik676.css)({
    "& > a": {
      color: INTERACT_TEXT4,
      textDecorationLine: "none"
    },
    backgroundColor: CONTROL_BG_WEAK13,
    borderRadius: RADIUS17.DEFAULT,
    boxShadow: SHADOW_FLOATING2,
    color: DEFAULT_TEXT_MEDIUM15,
    font: P4_DEFAULT9,
    maxWidth: 300,
    minWidth: 100,
    overflow: "auto",
    padding: SPACING37[3],
    width: 185
  }),
  HEADER: (0, import_uik676.css)({
    alignItems: "center",
    color: DEFAULT_TEXT23,
    display: "flex",
    font: P4_EMPHASIS3,
    marginBottom: SPACING37[3]
  }),
  ICON: (0, import_uik676.css)({ marginRight: SPACING37[1] }),
  TOOLTIP: (0, import_uik676.css)({
    backgroundColor: "transparent",
    boxShadow: "unset",
    boxSizing: "border-box",
    padding: 0,
    width: "fit-content"
  })
}), "getStyles");

// Popover/Popover.tsx
var import_jsx_runtime507 = require("react/jsx-runtime");
var Popover7 = import_uik677.utils.forwardRef(
  ({
    align = "CENTER",
    arrow = true,
    children: rawChildren,
    className: className2,
    content,
    contentClassName,
    header = null,
    icon = null,
    ignore = null,
    onPositionChange,
    onVisibleChange,
    position = "BOTTOM",
    stopPropagation,
    tabIndex,
    trigger = "CLICK",
    visible: rawVisible,
    ...inherited
  }, ref) => {
    const [visible, setVisible] = (0, import_react109.useState)(false);
    const tooltipContentRef = (0, import_react109.useRef)(null);
    if (rawVisible != null && rawVisible !== visible) {
      setVisible(rawVisible);
    }
    const { ref: childRef, withRef: children } = import_uik677.utils.useOnlyChildWithRef(rawChildren, ref);
    (0, import_react109.useEffect)(
      trigger === "CLICK" ? () => import_uik677.utils.addEventListener(document.body, "click", (e) => {
        const target = e.target;
        if (ignore?.current?.contains(target)) {
          return;
        }
        if (childRef.current?.contains(target)) {
          if (rawVisible == void 0) {
            onVisibleChange?.(!visible);
            setVisible(!visible);
          }
        } else if (tooltipContentRef.current?.contains(target)) {
          onVisibleChange?.(true);
          setVisible(true);
        } else {
          onVisibleChange?.(false);
          setVisible(false);
        }
      }) : import_uik677.utils.noop,
      [ignore, trigger, visible]
    );
    const { CONTENT: CONTENT4, HEADER: HEADER4, ICON: ICON4, TOOLTIP: TOOLTIP4 } = getStyles25();
    return /* @__PURE__ */ (0, import_jsx_runtime507.jsx)(
      import_uik677.Tooltip,
      {
        align,
        arrow,
        arrowColor: CONTROL_BG_WEAK14,
        className: (0, import_uik677.css)(TOOLTIP4, ...import_uik677.utils.many(className2)),
        onPositionChange: (position2) => {
          onPositionChange?.(position2);
        },
        onVisibleChange: trigger === "HOVER" ? (visible2) => {
          onVisibleChange?.(visible2);
          setVisible(visible2);
        } : void 0,
        position,
        tabIndex,
        uik: "Popover",
        value: /* @__PURE__ */ (0, import_jsx_runtime507.jsx)(import_jsx_runtime507.Fragment, { children: /* @__PURE__ */ (0, import_jsx_runtime507.jsxs)(
          "div",
          {
            className: (0, import_uik677.css)(CONTENT4, contentClassName),
            onClick: stopPropagation ? (e) => e.stopPropagation() : void 0,
            ref: tooltipContentRef,
            children: [
              header && /* @__PURE__ */ (0, import_jsx_runtime507.jsxs)("div", { className: HEADER4, children: [
                icon && /* @__PURE__ */ (0, import_jsx_runtime507.jsx)(Icon, { className: ICON4, type: icon }),
                header
              ] }),
              content
            ]
          }
        ) }),
        visible,
        ...inherited,
        children
      }
    );
  }
);
Popover7.displayName = "Popover";
Popover7.__DEV_METADATA__ = { status: "READY" };
var {
  COLORS: { CONTROL_BG_WEAK: CONTROL_BG_WEAK14 }
} = import_uik677.MAGNETIC_TOKENS;

// Radio/Radio.tsx
var import_uik680 = require("@appd/uik");
var import_react111 = require("react");

// Radio/getStyles.ts
var import_uik678 = require("@appd/uik");
var {
  COLORS: {
    CONTROL_BG_WEAK: CONTROL_BG_WEAK15,
    CONTROL_BG_WEAK_DISABLED: CONTROL_BG_WEAK_DISABLED3,
    CONTROL_BORDER: CONTROL_BORDER16,
    CONTROL_BORDER_ACTIVE: CONTROL_BORDER_ACTIVE2,
    CONTROL_BORDER_DISABLED: CONTROL_BORDER_DISABLED3,
    CONTROL_BORDER_HOVER: CONTROL_BORDER_HOVER6,
    CONTROL_ICON_IN_STRONG_ACTIVE,
    DEFAULT_TEXT: DEFAULT_TEXT24,
    DEFAULT_TEXT_DISABLED: DEFAULT_TEXT_DISABLED6,
    DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM16,
    DEFAULT_TEXT_MEDIUM_DISABLED
  },
  RADIUS: RADIUS18
} = import_uik678.MAGNETIC_TOKENS;
var getStyles26 = /* @__PURE__ */ __name(({ checked, disabled }) => (0, import_uik678.css)({
  "> .content": {
    "> .description": {
      color: disabled ? DEFAULT_TEXT_MEDIUM_DISABLED : DEFAULT_TEXT_MEDIUM16,
      fontSize: "11px",
      height: "13px",
      lineHeight: "13px"
    },
    "> .label": {
      color: disabled ? DEFAULT_TEXT_DISABLED6 : DEFAULT_TEXT24,
      fontSize: "13px",
      height: "15px",
      lineHeight: "15px"
    },
    alignSelf: "center"
  },
  "> .radio-container": {
    "> .outer-circle": {
      ":focus-visible": { borderColor: disabled ? CONTROL_BORDER_DISABLED3 : CONTROL_BORDER_ACTIVE2 },
      ":hover": { borderColor: disabled ? CONTROL_BORDER_DISABLED3 : CONTROL_BORDER_HOVER6 },
      "> .inner-circle": {
        background: disabled ? CONTROL_BG_WEAK_DISABLED3 : checked ? CONTROL_ICON_IN_STRONG_ACTIVE : CONTROL_BG_WEAK15,
        borderRadius: RADIUS18.FULL,
        display: "block",
        height: checked ? "10px" : "0px",
        transition: "width 280ms ease, height 280ms ease",
        width: checked ? "10px" : "0px"
      },
      alignItems: "center",
      borderColor: disabled ? CONTROL_BORDER_DISABLED3 : checked ? CONTROL_BORDER_ACTIVE2 : CONTROL_BORDER16,
      borderRadius: RADIUS18.FULL,
      borderStyle: "solid",
      borderWidth: "2px",
      display: "flex",
      height: "18px",
      justifyContent: "center",
      margin: "2px",
      width: "18px"
    },
    "> input": { display: "none" },
    background: "transparent",
    borderColor: "transparent",
    borderRadius: RADIUS18.FULL,
    borderStyle: "solid",
    borderWidth: "2px",
    marginRight: "4px"
  },
  alignItems: "flex-start",
  cursor: disabled ? "not-allowed" : "pointer",
  display: "flex",
  padding: "2px"
}), "getStyles");

// Radio/Group.tsx
var import_uik679 = require("@appd/uik");
var import_react110 = require("react");
var import_jsx_runtime508 = require("react/jsx-runtime");
var Group5 = import_uik679.utils.forwardRef(
  ({ children, className: className2, disabled, name, onChange, value, ...rest }, ref) => {
    const [innerValue, setInnerValue] = (0, import_react110.useState)("");
    if (value === void 0) {
      value = innerValue;
    }
    const childrenNode = children ? Array.isArray(children) ? children.map((child, idx) => {
      if (child.type !== import_uik679.Radio) {
        return child;
      }
      const childValue = child.props.value.toString();
      const childDisabled = child.props.disabled;
      const childOnChange = child.props.onChange;
      const checked = childValue === value;
      if (child.props.checked !== void 0) {
        throw Error("Radio in Radio.Group should not have a set-value for `checked`.");
      }
      return (0, import_react110.cloneElement)(child, {
        "aria-checked": checked,
        checked,
        disabled: childDisabled === void 0 ? disabled : childDisabled,
        key: idx,
        name,
        onChange: () => {
          childOnChange?.(childValue);
          onChange?.(childValue);
          setInnerValue(childValue);
        }
      });
    }) : (0, import_react110.cloneElement)(children, { checked: children.props.value === value }) : null;
    return /* @__PURE__ */ (0, import_jsx_runtime508.jsx)("div", { className: (0, import_uik679.css)(...import_uik679.utils.many(className2)), ref, uik: "Radio.Group", ...rest, children: childrenNode });
  }
);
Group5.displayName = "Radio.Group";

// Radio/Radio.tsx
var import_jsx_runtime509 = require("react/jsx-runtime");
var Radio2 = Object.assign(
  import_uik680.utils.forwardRef(
    ({
      checked,
      children,
      className: className2,
      description,
      disabled,
      getStyles: getStyles47 = Radio2.getStyles,
      id,
      label,
      name = label,
      onChange,
      value,
      ...rest
    }, ref) => {
      const [innerChecked, setInnerChecked] = (0, import_react111.useState)(false);
      if (checked === void 0) {
        checked = innerChecked;
      }
      children = children ? (Array.isArray(children) ? children : [children]).map((child, idx) => {
        const originalOnChange = child.props.onChange;
        return (0, import_react111.cloneElement)(child, {
          key: idx,
          onChange: (newValue) => {
            originalOnChange?.(newValue);
            onChange?.(value);
          }
        });
      }) : null;
      return /* @__PURE__ */ (0, import_jsx_runtime509.jsxs)(
        "label",
        {
          className: (0, import_uik680.css)(
            getStyles47({
              checked,
              disabled: disabled || false
            }),
            ...import_uik680.utils.many(className2)
          ),
          htmlFor: id,
          tabIndex: 0,
          uik: "Radio",
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime509.jsxs)("span", { className: "radio-container", children: [
              /* @__PURE__ */ (0, import_jsx_runtime509.jsx)(
                "input",
                {
                  checked,
                  disabled,
                  name,
                  onChange: (event) => {
                    if (!disabled) {
                      onChange?.(value);
                      setInnerChecked(event.target.checked);
                    }
                  },
                  ref,
                  type: "radio",
                  value,
                  ...rest
                }
              ),
              /* @__PURE__ */ (0, import_jsx_runtime509.jsx)("span", { className: "outer-circle", children: /* @__PURE__ */ (0, import_jsx_runtime509.jsx)("span", { className: "inner-circle" }) })
            ] }),
            /* @__PURE__ */ (0, import_jsx_runtime509.jsxs)("span", { className: "content", children: [
              /* @__PURE__ */ (0, import_jsx_runtime509.jsx)("div", { className: "label", children: label || value }),
              description && /* @__PURE__ */ (0, import_jsx_runtime509.jsx)("div", { className: "description", children: description }),
              children
            ] })
          ]
        }
      );
    }
  ),
  {
    Group: Group5,
    getStyles: getStyles26
  }
);
Radio2.displayName = "Radio";
Radio2.__DEV_METADATA__ = { status: "READY" };

// Repeater/Repeater.tsx
var import_uik682 = require("@appd/uik");
var import_react112 = require("react");

// Repeater/STYLES.ts
var import_uik681 = require("@appd/uik");
var {
  COLORS: {
    CONTROL_BG_ACTIVE: CONTROL_BG_ACTIVE3,
    CONTROL_BG_HOVER,
    CONTROL_BORDER: CONTROL_BORDER17,
    CONTROL_BORDER_ACTIVE: CONTROL_BORDER_ACTIVE3,
    CONTROL_BORDER_HOVER: CONTROL_BORDER_HOVER7,
    CONTROL_BORDER_WEAK: CONTROL_BORDER_WEAK17,
    CONTROL_BORDER_WEAK_FOCUS: CONTROL_BORDER_WEAK_FOCUS2,
    CONTROL_BORDER_WEAK_HOVER: CONTROL_BORDER_WEAK_HOVER3,
    DEFAULT_TEXT: DEFAULT_TEXT25,
    DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM17,
    INTERACT_ICON_WEAK: INTERACT_ICON_WEAK8
  },
  RADIUS: RADIUS19,
  TYPOGRAPHY: { P3_EMPHASIS: P3_EMPHASIS8, P4_DEFAULT: P4_DEFAULT10 }
} = import_uik681.MAGNETIC_TOKENS;
var STYLES34 = {
  ADD: (0, import_uik681.css)({
    "& > svg > path[fill='#fff']": { fill: INTERACT_ICON_WEAK8 },
    "&:hover": { borderColor: CONTROL_BORDER_WEAK_HOVER3 },
    ":focus-visible": { borderColor: CONTROL_BORDER_WEAK_FOCUS2 },
    border: `${CONTROL_BORDER_WEAK17} 2px dashed`,
    color: DEFAULT_TEXT25,
    font: P3_EMPHASIS8,
    height: 40,
    marginLeft: 20,
    marginRight: 70,
    marginTop: 20,
    maxWidth: "unset",
    outline: "none",
    width: "calc(100% - 90px)"
  }),
  CONTAINER: (0, import_uik681.css)({
    "&:focus-within": { borderColor: CONTROL_BORDER_ACTIVE3 },
    "&:hover:not(:focus-within)": { borderColor: CONTROL_BORDER_HOVER7 },
    border: `${CONTROL_BORDER17} 1px solid`,
    borderRadius: RADIUS19.DEFAULT,
    width: "100%"
  }),
  DELETE: (0, import_uik681.css)({
    "& > svg > path[fill='#fff']": { fill: INTERACT_ICON_WEAK8 },
    margin: "auto",
    marginLeft: 20,
    marginRight: 20
  }),
  DESCRIPTION: (0, import_uik681.css)({
    color: DEFAULT_TEXT_MEDIUM17,
    font: P4_DEFAULT10,
    marginLeft: 20,
    marginTop: 4
  }),
  HOST: (0, import_uik681.css)({
    "& > svg > path[fill='#fff']": { fill: INTERACT_ICON_WEAK8 },
    "& button": { backgroundColor: "transparent" },
    "& button:focus-visible": { backgroundColor: CONTROL_BG_ACTIVE3 },
    "& button:hover": { backgroundColor: CONTROL_BG_HOVER }
  }),
  LABEL: (0, import_uik681.css)({
    color: DEFAULT_TEXT25,
    font: P3_EMPHASIS8,
    marginLeft: 20
  }),
  PARENT: (0, import_uik681.css)({
    borderRadius: 2,
    display: "flex",
    marginLeft: 20,
    marginTop: 20
  })
};

// Repeater/Repeater.tsx
var import_jsx_runtime510 = require("react/jsx-runtime");
var Repeater = import_uik682.utils.forwardRef(
  ({ children: maybeChildren, className: className2, description, element, label, onChildrenChange: onChildrenChange2, ...props2 }, ref) => {
    const [{ key, rawChildren }, setRawChildren] = (0, import_react112.useState)({
      key: 0,
      rawChildren: maybeChildren ?? []
    });
    const children = maybeChildren ?? rawChildren;
    const addOrRemove = /* @__PURE__ */ __name((index) => {
      const next = index == null ? (
        /* ADD */
        {
          key: key + 1,
          rawChildren: [...children, (0, import_react112.cloneElement)(element, { key })]
        }
      ) : (
        /* REMOVE */
        {
          key,
          rawChildren: children.filter((_, i) => i !== index)
        }
      );
      onChildrenChange2?.(next.rawChildren);
      setRawChildren(next);
    }, "addOrRemove");
    return /* @__PURE__ */ (0, import_jsx_runtime510.jsxs)(import_uik682.Form, { className: (0, import_uik682.css)(HOST10, ...import_uik682.utils.many(className2)), ref, uik: "Repeater", ...props2, children: [
      /* @__PURE__ */ (0, import_jsx_runtime510.jsx)("div", { className: LABEL5, children: label }),
      /* @__PURE__ */ (0, import_jsx_runtime510.jsx)("div", { className: DESCRIPTION, children: description }),
      children.map((element2, index) => /* @__PURE__ */ (0, import_jsx_runtime510.jsxs)("div", { className: PARENT2, children: [
        /* @__PURE__ */ (0, import_jsx_runtime510.jsx)(import_uik682.Form, { className: CONTAINER5, children: (0, import_react112.cloneElement)(element2, { index }) }),
        /* @__PURE__ */ (0, import_jsx_runtime510.jsx)(import_uik682.Button, { className: DELETE, icon: "Navigation.Close", onClick: () => addOrRemove(index) })
      ] }, element2.key)),
      /* @__PURE__ */ (0, import_jsx_runtime510.jsx)(import_uik682.Button, { className: ADD, icon: "Action.Add", onClick: () => addOrRemove(), children: "Add" })
    ] });
  }
);
Repeater.displayName = "Repeater";
Repeater.__DEV_METADATA__ = { status: "READY" };
var { ADD, CONTAINER: CONTAINER5, DELETE, DESCRIPTION, HOST: HOST10, LABEL: LABEL5, PARENT: PARENT2 } = STYLES34;

// ResizeBox/ResizeBox.tsx
var import_uik684 = require("@appd/uik");
var import_rxjs2 = require("rxjs");
var import_react113 = require("react");

// ResizeBox/getStyles.ts
var import_uik683 = require("@appd/uik");
var {
  MOTION: {
    EASING: { DECELERATE }
  }
} = import_uik683.MAGNETIC_TOKENS;
var getStyles27 = /* @__PURE__ */ __name((fullColor) => ({
  display: "flex",
  flexDirection: "column",
  position: "relative",
  boxSizing: "content-box",
  maxHeight: 400,
  maxWidth: 400,
  "> div.peripherals": {
    boxSizing: "content-box",
    height: "100%",
    left: "-10px",
    padding: "10px",
    position: "absolute",
    top: "-10px",
    width: "100%",
    zIndex: -1,
    /////////////
    // Lock icon
    /////////////
    "> div.move-icon": {
      "&:not(.visible)": {
        opacity: "0 !important",
        transition: "opacity 0.5s",
        pointerEvents: "none !important"
      },
      position: "absolute",
      top: "-20px",
      left: "50%",
      width: "12px",
      height: "12px",
      transformOrigin: "top left",
      transform: "translate(-50%, -50%)",
      zIndex: "1",
      pointerEvents: "none",
      opacity: "0.382",
      transition: "opacity 0.3s, transform 0.3s",
      "&::before": {
        content: '""',
        position: "absolute",
        left: "50%",
        top: "50%",
        transformOrigin: "top left",
        transform: "scale(1) translate(-50%, -50%)",
        width: "30px",
        height: "30px",
        borderRadius: "50%",
        backgroundColor: `${fullColor}`,
        pointerEvents: "none",
        opacity: "0",
        transition: "opacity 0.3s, transform 0.3s"
      },
      "&::after": {
        content: '""',
        position: "absolute",
        left: "50%",
        top: "50%",
        width: "100%",
        height: "100%",
        borderRadius: "50%",
        transform: "translate(-50%, -50%)",
        border: `2px solid ${applyAlphaToHex(fullColor, ~~(0.618 * 100))}`,
        pointerEvents: "all",
        cursor: "move",
        userSelect: "none"
      },
      "&:hover": {
        "&::after": {
          borderWidth: "1.236px"
        },
        transform: "scale(1.618) translate(-50%, -50%)",
        transition: `opacity 0.3s ${DECELERATE}, transform 0.3s ${DECELERATE}`
      }
    },
    "&:hover, &.dragging": {
      "> div.move-icon": {
        opacity: "1",
        transition: "opacity 0.15s"
      },
      "> div.state": {
        opacity: "1",
        pointerEvents: "all",
        transition: "opacity 0.15s"
      }
    },
    "&.moving": {
      "> div.move-icon": {
        "&::before": {
          transform: `scale(${0.25}) translate(-50%, -50%)`,
          opacity: "0.618",
          transition: `opacity 0.3s ${DECELERATE}, transform 0.3s ${DECELERATE}`
        }
      }
    },
    /////////
    // Edges
    /////////
    "> div.edge": {
      "&:not(.visible)": {
        opacity: "0 !important",
        transition: "opacity 0.5s",
        pointerEvents: "none !important"
      },
      position: "absolute",
      width: "calc(100% - 30px)",
      height: "calc(100% - 30px)",
      zIndex: "1",
      "&:hover, &.dragging": {
        backgroundColor: `${applyAlphaToHex(fullColor, ~~(0.05 * 100))}`,
        "&::before": {
          backgroundColor: `${fullColor}`
        }
      },
      "&::before": {
        content: '""',
        position: "absolute",
        width: "100%",
        height: "100%",
        left: "0",
        top: "0",
        backgroundColor: `${applyAlphaToHex(fullColor, ~~(0.618 * 100))}`
      },
      "&.left, &.right": {
        left: "0",
        top: "15px",
        width: "10px",
        "&::before": {
          width: "1px",
          left: "4.5px",
          transition: "transform 0.5s"
        },
        cursor: "ew-resize",
        "&:hover, &.dragging": {
          "&::before": {
            transform: "scaleX(3)",
            transition: "transform 0.15s"
          }
        },
        "&.right": {
          left: "unset",
          right: "0"
        }
      },
      "&.top, &.bottom": {
        left: "15px",
        top: "0",
        height: "10px",
        "&.bottom": {
          top: "unset",
          bottom: "0"
        },
        "&::before": {
          height: "1px",
          top: "4.5px",
          transition: "transform 0.5s"
        },
        cursor: "ns-resize",
        "&:hover, &.dragging": {
          "&::before": {
            transform: "scaleY(3)",
            transition: "transform 0.15s"
          }
        }
      },
      "&.moving": {
        "&::before": {
          backgroundColor: `${applyAlphaToHex(fullColor, ~~(0.236 * 100))}`
        },
        "&.top, &.right, &.bottom, &.left": {
          cursor: "not-allowed"
        }
      }
    },
    ///////////
    // Corners
    ///////////
    "> div.corner": {
      "&:not(.visible)": {
        opacity: "0 !important",
        transition: "opacity 0.5s",
        pointerEvents: "none !important"
      },
      position: "absolute",
      width: "20px",
      height: "20px",
      transition: "transform 0.5s",
      zIndex: "1",
      "&::before": {
        boxSizing: "content-box",
        content: '""',
        position: "absolute",
        left: "50%",
        top: "50%",
        width: "5px",
        height: "5px",
        transform: "translate(-50%, -50%)",
        border: `1px solid ${applyAlphaToHex(fullColor, ~~(0.618 * 100))}`,
        transition: "transform 0.5s"
      },
      "&:hover, &.dragging": {
        transition: "transform 0.15s",
        "&::before": {
          transform: "translate(-50%, -50%) scale(3)",
          backgroundColor: `${applyAlphaToHex(fullColor, ~~(0.05 * 100))}`,
          borderColor: `${fullColor}`,
          transition: "transform 0.15s"
        }
      },
      "&.dragging": {
        // "Righty tighty, lefty loosy." Rotate left to let things "loose".
        transform: "rotate(-45deg)"
      },
      "&.top": {
        top: "-5px"
      },
      "&.left": {
        left: "-5px"
      },
      "&.right": {
        right: "-5px"
      },
      "&.bottom": {
        bottom: "-5px"
      },
      "&.top.left, &.bottom.right": {
        cursor: "nwse-resize"
      },
      "&.top.right, &.bottom.left": {
        cursor: "nesw-resize"
      },
      "&.moving": {
        "&::before": {
          border: `1px solid ${applyAlphaToHex(fullColor, ~~(0.236 * 100))}`
        },
        "&.top.left, &.bottom.right, &.top.right, &.bottom.left": {
          cursor: "not-allowed"
        }
      }
    },
    ////////////////////
    // State label text
    ////////////////////
    "> div.state": {
      "&:not(.visible)": {
        opacity: "0 !important",
        transition: "opacity 0.5s",
        pointerEvents: "none !important"
      },
      position: "relative",
      top: "calc(100% + 20px)",
      width: "max-content",
      fontFamily: '"Source Code Pro", monospace',
      color: `${fullColor}`,
      opacity: "0",
      pointerEvents: "none",
      transition: "opacity 0.5s",
      zIndex: "1",
      "> div.state-entry:not(:first-child)": {
        marginTop: "5px"
      },
      "&.moving": {
        "> div:nth-child(1), > div:nth-child(2)": {
          color: `${applyAlphaToHex(fullColor, ~~(0.236 * 100))}`
        }
      }
    }
  }
}), "getStyles");

// ResizeBox/ResizeBox.tsx
var import_react114 = require("react");
var import_jsx_runtime511 = require("react/jsx-runtime");
var {
  STATIC: { RESIZE_BOX }
} = import_uik684.MAGNETIC_TOKENS;
var ResizeBox = import_uik684.utils.forwardRef(
  ({ children, className: className2, style, ...props2 }, ref) => {
    const [fullColor, setFullColor] = (0, import_react113.useState)("#000");
    const { currentTheme } = (0, import_react114.useContext)(import_uik684.css.CONTEXT);
    const hostRef = import_uik684.utils.useBroadcastRef(ref);
    const dimensions = (0, import_react113.useMemo)(() => ({ height: NaN, width: NaN }), []);
    const translate = (0, import_react113.useMemo)(() => ({ x: 0, y: 0 }), []);
    const dragState = (0, import_react113.useMemo)(
      () => ({
        reference: {
          pageX: 0,
          pageY: 0,
          dimensions: {
            height: NaN,
            width: NaN
          },
          // For some reason this clone must be here!
          translate: { ...translate }
        },
        kind: null
      }),
      []
    );
    const _moving = (0, import_react113.useRef)(false);
    const _visible = (0, import_react113.useRef)(false);
    const [rerendered, rerender] = (0, import_react113.useReducer)((i) => i + 1, 0);
    const _interaction$ = (0, import_react113.useMemo)(() => new import_rxjs2.Subject(), []);
    const refresh2 = /* @__PURE__ */ __name(() => {
      const hostElem = hostRef.current;
      if (hostElem && rerendered) {
        const { width, height: height2 } = hostElem.getBoundingClientRect();
        Object.assign(dimensions, {
          height: height2,
          width
        });
      }
    }, "refresh");
    if (ref?.current) {
      ref.current.refresh = refresh2;
    }
    const onToggleDrag = /* @__PURE__ */ __name((kind, event) => {
      _moving.current = kind === "move";
      if (kind) {
        supplyDefaults();
        dragState.reference.pageX = event.pageX;
        dragState.reference.pageY = event.pageY;
        Object.assign(dragState.reference.dimensions, dimensions);
        Object.assign(dragState.reference.translate, translate);
      }
      dragState.kind = kind;
      onInteraction();
    }, "onToggleDrag");
    const onDrag = /* @__PURE__ */ __name((event) => {
      if (!dragState.kind) {
        return;
      }
      event.preventDefault();
      const [deltaX, deltaY] = [event.pageX - dragState.reference.pageX, event.pageY - dragState.reference.pageY];
      switch (dragState.kind) {
        case "move": {
          translate.x = dragState.reference.translate.x + deltaX;
          translate.y = dragState.reference.translate.y + deltaY;
          break;
        }
        case "left edge": {
          dimensions.width = import_uik684.utils.clamp(dragState.reference.dimensions.width - deltaX, [0]);
          translate.x = dragState.reference.translate.x + dragState.reference.dimensions.width - dimensions.width;
          break;
        }
        case "right edge": {
          dimensions.width = import_uik684.utils.clamp(dragState.reference.dimensions.width + deltaX, [0]);
          break;
        }
        case "top edge": {
          dimensions.height = import_uik684.utils.clamp(dragState.reference.dimensions.height - deltaY, [0]);
          translate.y = dragState.reference.translate.y + dragState.reference.dimensions.height - dimensions.height;
          break;
        }
        case "bottom edge": {
          dimensions.height = import_uik684.utils.clamp(dragState.reference.dimensions.height + deltaY, [0]);
          break;
        }
        case "top left corner": {
          dimensions.width = import_uik684.utils.clamp(dragState.reference.dimensions.width - deltaX, [0]);
          dimensions.height = import_uik684.utils.clamp(dragState.reference.dimensions.height - deltaY, [0]);
          translate.x = dragState.reference.translate.x + dragState.reference.dimensions.width - dimensions.width;
          translate.y = dragState.reference.translate.y + dragState.reference.dimensions.height - dimensions.height;
          break;
        }
        case "top right corner": {
          dimensions.width = import_uik684.utils.clamp(dragState.reference.dimensions.width + deltaX, [0]);
          dimensions.height = import_uik684.utils.clamp(dragState.reference.dimensions.height - deltaY, [0]);
          translate.y = dragState.reference.translate.y + dragState.reference.dimensions.height - dimensions.height;
          break;
        }
        case "bottom left corner": {
          dimensions.width = import_uik684.utils.clamp(dragState.reference.dimensions.width - deltaX, [0]);
          dimensions.height = import_uik684.utils.clamp(dragState.reference.dimensions.height + deltaY, [0]);
          translate.x = dragState.reference.translate.x + dragState.reference.dimensions.width - dimensions.width;
          break;
        }
        case "bottom right corner": {
          dimensions.width = import_uik684.utils.clamp(dragState.reference.dimensions.width + deltaX, [0]);
          dimensions.height = import_uik684.utils.clamp(dragState.reference.dimensions.height + deltaY, [0]);
          break;
        }
        default:
      }
      onInteraction();
    }, "onDrag");
    const onInteraction = /* @__PURE__ */ __name(() => _interaction$.next(), "onInteraction");
    const dumpState = /* @__PURE__ */ __name(() => {
      return [
        `width: ${dimensions.width.toFixed(2)}px`,
        `height: ${dimensions.height.toFixed(2)}px`,
        `translateX: ${translate.x}px`,
        `translateY: ${translate.y}px`
      ];
    }, "dumpState");
    const supplyDefaults = /* @__PURE__ */ __name(() => {
      if (Number.isNaN(dimensions.width + dimensions.height)) {
        refresh2();
      }
    }, "supplyDefaults");
    (0, import_react113.useEffect)(() => {
      const subscription = _interaction$.pipe(
        (0, import_rxjs2.tap)(() => _visible.current = true),
        (0, import_rxjs2.tap)(rerender),
        (0, import_rxjs2.switchMap)(
          () => (0, import_rxjs2.of)(0).pipe(
            (0, import_rxjs2.delay)(1e3),
            // Don't fade out if currently dragging.
            (0, import_rxjs2.tap)(() => _visible.current = import_uik684.utils.PREFERS_REDUCED_MOTION || Boolean(dragState.kind)),
            (0, import_rxjs2.tap)(rerender)
          )
        )
      ).subscribe(() => 0);
      return () => subscription.unsubscribe();
    }, []);
    (0, import_react113.useEffect)(() => {
      const resizeObserver = new ResizeObserver(refresh2);
      hostRef.current && resizeObserver.observe(hostRef.current);
      return () => resizeObserver.disconnect();
    }, []);
    (0, import_react113.useEffect)(() => import_uik684.utils.addEventListener(document.documentElement, "mousemove", onDrag, { passive: false }), []);
    (0, import_react113.useEffect)(
      () => import_uik684.utils.addEventListener(
        document.documentElement,
        "mouseup",
        (event) => dragState.kind !== null && onToggleDrag(null, event),
        { passive: false }
      ),
      []
    );
    supplyDefaults();
    (0, import_react113.useEffect)(() => {
      if (import_uik684.utils.CAN_USE_DOM) {
        const varValue = /\(([^)]+)\)/.exec(RESIZE_BOX)?.[1];
        if (varValue == void 0) {
          return;
        }
        const full = window.getComputedStyle(document.body)?.getPropertyValue(varValue);
        full && setFullColor(full);
      }
    }, [currentTheme]);
    return /* @__PURE__ */ (0, import_jsx_runtime511.jsxs)(
      "div",
      {
        className: (0, import_uik684.css)(
          getStyles27(fullColor),
          import_uik684.utils.PREFERS_REDUCED_MOTION && {
            "& *": {
              animation: "none !important",
              transition: "none !important"
            }
          },
          ...import_uik684.utils.many(className2)
        ),
        onMouseEnter: onInteraction,
        onMouseLeave: onInteraction,
        onMouseMove: onInteraction,
        ref: hostRef,
        style: {
          ...dimensions.height && {
            height: dimensions.height,
            maxHeight: dimensions.height
          },
          ...dimensions.width && {
            width: dimensions.width,
            maxWidth: dimensions.width
          },
          transform: `translate(${translate.x}px,${translate.y}px)`,
          ...style
        },
        uik: "ResizeBox",
        ...props2,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime511.jsxs)(
            "div",
            {
              onMouseEnter: onInteraction,
              onMouseLeave: onInteraction,
              onMouseMove: onInteraction,
              className: (0, import_uik684.css)(
                "peripherals",
                dragState.kind && "dragging",
                _moving.current && "moving",
                _visible.current && "visible"
              ),
              children: [
                DRAG_KINDS.slice(1).map((kind) => /* @__PURE__ */ (0, import_jsx_runtime511.jsx)(
                  "div",
                  {
                    className: (0, import_uik684.css)(
                      dragState.kind === kind && "dragging",
                      _moving.current && "moving",
                      _visible.current && "visible",
                      ...kind.split(" ")
                    ),
                    onMouseDown: (event) => {
                      onToggleDrag(kind, event);
                      onInteraction();
                    }
                  },
                  kind
                )),
                /* @__PURE__ */ (0, import_jsx_runtime511.jsx)("div", { className: (0, import_uik684.css)(_moving.current && "moving", _visible.current && "visible", "state"), children: dumpState().map((entry, i) => /* @__PURE__ */ (0, import_jsx_runtime511.jsx)("div", { className: "state-entry", children: entry }, i)) }),
                /* @__PURE__ */ (0, import_jsx_runtime511.jsx)(
                  "div",
                  {
                    className: (0, import_uik684.css)(_moving.current && "moving", _visible.current && "visible", "move-icon"),
                    onMouseDown: (event) => {
                      onToggleDrag("move", event);
                      onInteraction();
                    }
                  }
                )
              ]
            }
          ),
          children
        ]
      }
    );
  }
);
ResizeBox.displayName = "ResizeBox";
var DRAG_KINDS = [
  "move",
  "left edge",
  "right edge",
  "top edge",
  "bottom edge",
  "top left corner",
  "top right corner",
  "bottom left corner",
  "bottom right corner"
];

// QuickFilter/QuickFilter.tsx
var import_uik691 = require("@appd/uik");

// QuickFilter/BaseQuickFilter.tsx
var import_uik690 = require("@appd/uik");
var import_react118 = require("react");

// QuickFilter/FilterBar/FilterBar.tsx
var import_uik686 = require("@appd/uik");
var import_luxon10 = require("luxon");
var import_react115 = require("react");

// QuickFilter/FilterBar/getStyles.tsx
var getStyles28 = /* @__PURE__ */ __name(({ gap }) => ({
  BAR: {
    ACTIONS: {
      display: "flex",
      gap,
      marginBottom: 5,
      marginLeft: "auto",
      order: 5,
      paddingLeft: 36
    },
    APPLY: { marginBottom: 5 },
    DRAWER_TRIGGER: { marginBottom: 5 },
    FILTERS: {
      "& [uik='Checkbox']": {
        marginBottom: 8,
        maxWidth: 160
      },
      "& [uik='Select'], & [uik='Select.Searchable']": {
        margin: 2,
        maxWidth: 240,
        minWidth: 240
      },
      "& [uik='Slider']": {
        maxWidth: 240,
        minWidth: 240
      },
      "& [uik='Slider.Popover']": {
        margin: 2,
        maxWidth: 240,
        minWidth: 240
      },
      alignItems: "flex-end",
      display: "flex",
      gap,
      height: "100%",
      margin: 2,
      minWidth: 260
    },
    OTHER: {
      alignItems: "flex-end",
      display: "flex",
      flexShrink: 1,
      gap: 8,
      height: "100%"
    },
    RECENTS: { marginBottom: 5 },
    RECENTS_CONTENT: { minWidth: 600 },
    RECENTS_OPTION: {
      ":not(:last-child)": { borderBottom: `1px solid ${CONTROL_BORDER_WEAK18}` },
      height: "fit-content",
      paddingBlock: 10
    },
    RECENTS_OPTION_CONTAINER: {
      display: "flex",
      gap: 8
    },
    RECENTS_OPTION_TAGS: { flex: 1 },
    RECENTS_OVERLAY: { minWidth: 600 },
    RESET: {
      marginBottom: 5,
      order: 3,
      width: 100
    },
    RESULTS: {
      marginBottom: 10,
      maxWidth: 110,
      minWidth: 75,
      order: 2,
      whiteSpace: "nowrap"
    },
    alignItems: "flex-end",
    display: "flex",
    gap,
    height: "100%",
    minHeight: 34,
    overflow: "hidden",
    width: "100%"
  },
  DRAWER: {
    display: "flex",
    flexDirection: "column",
    gap: 16
  },
  HOST: { height: "100%" }
}), "getStyles");
var {
  COLORS: { CONTROL_BORDER_WEAK: CONTROL_BORDER_WEAK18 }
} = MAGNETIC_TOKENS;

// QuickFilter/FilterBar/MESSAGES.ts
var MESSAGES17 = {
  APPLY: format.message`Apply`.description("A primary button in the bar that applies the current filters"),
  DRAWER_PRIMARY: format.message`Apply`.description("A primary button in the drawer."),
  DRAWER_SECONDARY: format.message`Cancel`.description("A secondary button in the drawer."),
  DRAWER_TITLE: format.message`Filters`.description("A title in the drawer."),
  DRAWER_TRIGGER: format.message`All Fields`.description("A label in a button that toggles the drawer."),
  RECENTS: format.message`Recents`.description("A label in a button that toggles the recents overlay."),
  RECENT_CREATED_AT: format.message`${"$0"} ago`.description(
    "A label in the recents overlay that describes the created at date."
  ),
  RESET_ALL: format.message`Reset All`.description("A label in a button that clears the filters."),
  RESULTS: format.message`${"$0"} Result${"$1"}`.description("A label showing how many results are filtered.")
};

// QuickFilter/utils/getBaseFilterSet.tsx
var getBaseFilterSet = /* @__PURE__ */ __name((definitions, states) => {
  const checkboxFilters = [];
  const numericFilters = [];
  const selectFilters = [];
  definitions.map((definition) => {
    const type = definition.info.type;
    const definitionKey = definition.key;
    const matchingState = states.find((state) => state.key === definitionKey);
    const newValue = {
      key: definitionKey,
      ...definition.info,
      ...matchingState?.value
    };
    if (type === "CHECKBOX") {
      checkboxFilters.push(newValue);
    } else if (type === "NUMERIC") {
      numericFilters.push(newValue);
    } else if (type === "SELECT") {
      selectFilters.push(newValue);
    }
  });
  const mergedFilterCollection = {
    checkboxFilters,
    numericFilters,
    selectFilters
  };
  return mergedFilterCollection;
}, "getBaseFilterSet");

// QuickFilter/utils/getFilterStates.tsx
var getFilterStates = /* @__PURE__ */ __name((baseFilterSet) => {
  const selectFilterStates = baseFilterSet.selectFilters.map(({ key, value }) => ({
    key,
    value: {
      type: "SELECT",
      value
    }
  }));
  const numericFilterStates = baseFilterSet.numericFilters?.map(({ key, lower, upper }) => ({
    key,
    value: {
      lower,
      type: "NUMERIC",
      upper
    }
  })) ?? [];
  const checkboxFilterStates = baseFilterSet.checkboxFilters?.map(({ checked, key }) => ({
    key,
    value: {
      checked,
      type: "CHECKBOX"
    }
  })) ?? [];
  const newFilterStates = selectFilterStates.concat(numericFilterStates).concat(checkboxFilterStates);
  return newFilterStates;
}, "getFilterStates");

// QuickFilter/utils/getTags.tsx
var import_uik685 = require("@appd/uik");
var import_jsx_runtime512 = require("react/jsx-runtime");
var getCheckboxTag = /* @__PURE__ */ __name((checkboxFilter, onClose) => checkboxFilter.checked != void 0 ? /* @__PURE__ */ (0, import_jsx_runtime512.jsx)(
  import_uik685.Tag,
  {
    onClose: onClose != void 0 ? (_) => onClose(checkboxFilter.key) : void 0,
    children: `${checkboxFilter.label}: ${checkboxFilter.checked}`
  },
  checkboxFilter.key
) : null, "getCheckboxTag");
var getSelectTag = /* @__PURE__ */ __name((selectFilter, onClose) => selectFilter.value != void 0 && selectFilter.value.length > 0 ? /* @__PURE__ */ (0, import_jsx_runtime512.jsx)(import_uik685.Tag, { onClose: onClose != void 0 ? (_) => onClose(selectFilter.key) : void 0, children: `${selectFilter.label} IN [${selectFilter.value.join(", ")}]` }, selectFilter.key) : null, "getSelectTag");
var getNumericTag = /* @__PURE__ */ __name((numericFilter, onClose) => {
  if (numericFilter.upper == void 0) {
    return null;
  }
  let content;
  if (numericFilter.upper > 0 && (numericFilter.lower ?? -1) > 0) {
    content = `${numericFilter.label} IN [${numericFilter.lower}, ${numericFilter.upper}]`;
  } else if (numericFilter.upper > 0) {
    content = `${numericFilter.label} >= ${numericFilter.upper}`;
  } else {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime512.jsx)(import_uik685.Tag, { onClose: onClose != void 0 ? (_) => onClose(numericFilter.key) : void 0, children: content }, numericFilter.key);
}, "getNumericTag");
var getTags = /* @__PURE__ */ __name((baseFilterSet, onClose) => {
  const selectTags = baseFilterSet.selectFilters.map((selectFilter) => getSelectTag(selectFilter, onClose));
  const numericTags = (baseFilterSet.numericFilters ?? []).map(
    (numericFilter) => getNumericTag(numericFilter, onClose)
  );
  const checkboxTags = (baseFilterSet.checkboxFilters ?? []).map(
    (checkboxFilter) => getCheckboxTag(checkboxFilter, onClose)
  );
  return /* @__PURE__ */ (0, import_jsx_runtime512.jsxs)(import_uik685.Tag.Group, { overflow: 8, children: [
    selectTags,
    numericTags,
    checkboxTags
  ] });
}, "getTags");

// QuickFilter/FilterBar/FilterBar.tsx
var import_jsx_runtime513 = require("react/jsx-runtime");
var FilterBar = import_uik686.utils.forwardRef(
  ({
    actions,
    children,
    className: className2,
    drawerChildren,
    filterSet,
    onClose,
    onFilterSetApply,
    onResetAll,
    recentFilterSets,
    resultCount,
    ...props2
  }, ref) => {
    const [hasMeasured, setHasMeasured] = (0, import_react115.useState)(false);
    const [drawerOpen, setDrawerOpen] = (0, import_react115.useState)(false);
    const [overflow, setOverflow] = (0, import_react115.useState)(false);
    const [hidden, setHidden] = (0, import_react115.useState)([]);
    const barRef = (0, import_react115.useRef)(null);
    const filtersRef = (0, import_react115.useRef)(null);
    const otherRef = (0, import_react115.useRef)(null);
    const actionsRef = (0, import_react115.useRef)(null);
    const drawerContentRef = (0, import_react115.useRef)(null);
    const drawerFormRef = (0, import_react115.useRef)(null);
    const {
      BAR: {
        ACTIONS,
        APPLY,
        DRAWER_TRIGGER,
        FILTERS,
        OTHER,
        RECENTS,
        RECENTS_CONTENT,
        RECENTS_OPTION,
        RECENTS_OPTION_CONTAINER,
        RECENTS_OPTION_TAGS,
        RECENTS_OVERLAY,
        RESET: RESET2,
        RESULTS,
        ...BAR
      },
      DRAWER,
      HOST: HOST14
    } = getStyles28({ gap: GAP_SIZE });
    const onResize2 = (0, import_react115.useCallback)(() => {
      measureOverflow();
    }, []);
    import_uik686.utils.useLayoutEffect(() => {
      measureOverflow();
    }, [children, onResetAll]);
    const measureOverflow = /* @__PURE__ */ __name(() => {
      const barChildren = Array.from(filtersRef.current?.children ?? []);
      if (barChildren?.length === 0) {
        return;
      }
      const newHidden = [];
      let newOverflow = false;
      let elementsSize = 0;
      barChildren.forEach((barChild, index) => {
        elementsSize += barChild.offsetWidth + (index > 0 ? GAP_SIZE : 0);
        if (elementsSize + (otherRef.current?.offsetWidth != void 0 ? otherRef.current?.offsetWidth + GAP_SIZE : 0) + (actionsRef.current?.offsetWidth != void 0 ? actionsRef.current?.offsetWidth + GAP_SIZE : 0) > (barRef.current?.offsetWidth ?? 0)) {
          newHidden.push(index);
          newOverflow = true;
        }
      });
      setOverflow(newOverflow);
      setHidden(newHidden);
      setHasMeasured(true);
    }, "measureOverflow");
    const bar = /* @__PURE__ */ (0, import_jsx_runtime513.jsxs)("div", { className: (0, import_uik686.css)(BAR), ref: barRef, children: [
      /* @__PURE__ */ (0, import_jsx_runtime513.jsx)("div", { className: (0, import_uik686.css)(FILTERS), ref: filtersRef, children: import_react115.Children.toArray(children).map((child, index) => /* @__PURE__ */ (0, import_jsx_runtime513.jsx)(
        "div",
        {
          style: hidden.includes(index) && index !== 0 ? {
            position: "absolute",
            visibility: "hidden"
          } : void 0,
          children: child
        },
        `filter-${index}`
      )) }),
      /* @__PURE__ */ (0, import_jsx_runtime513.jsxs)("div", { className: (0, import_uik686.css)(OTHER), ref: otherRef, children: [
        /* @__PURE__ */ (0, import_jsx_runtime513.jsx)(import_uik686.Button, { className: (0, import_uik686.css)(APPLY), onClick: () => onFilterSetApply({ set: filterSet }), children: MESSAGES17.APPLY() }),
        drawerChildren && /* @__PURE__ */ (0, import_jsx_runtime513.jsx)(
          "div",
          {
            style: {
              order: overflow ? 1 : 4,
              width: 110
            },
            children: overflow && /* @__PURE__ */ (0, import_jsx_runtime513.jsx)(
              import_uik686.Button,
              {
                className: (0, import_uik686.css)(DRAWER_TRIGGER),
                icon: "ChartType.Funnel",
                onClick: () => setDrawerOpen(!drawerOpen),
                type: "TERTIARY",
                children: MESSAGES17.DRAWER_TRIGGER()
              }
            )
          }
        ),
        recentFilterSets != void 0 && recentFilterSets.length > 0 && onFilterSetApply != void 0 && /* @__PURE__ */ (0, import_jsx_runtime513.jsx)(
          import_uik686.Dropdown,
          {
            align: "END",
            className: (0, import_uik686.css)(RECENTS_OVERLAY),
            contentClassName: (0, import_uik686.css)(RECENTS_CONTENT),
            kind: "TERTIARY",
            label: MESSAGES17.RECENTS(),
            triggerClassName: (0, import_uik686.css)(RECENTS),
            children: recentFilterSets.map((recentFilterSet) => /* @__PURE__ */ (0, import_jsx_runtime513.jsx)(
              import_uik686.Dropdown.Option,
              {
                className: (0, import_uik686.css)(RECENTS_OPTION),
                onClick: () => onFilterSetApply({ set: recentFilterSet }),
                children: /* @__PURE__ */ (0, import_jsx_runtime513.jsxs)("div", { className: (0, import_uik686.css)(RECENTS_OPTION_CONTAINER), children: [
                  /* @__PURE__ */ (0, import_jsx_runtime513.jsx)("div", { className: (0, import_uik686.css)(RECENTS_OPTION_TAGS), children: getTags(recentFilterSet) }),
                  /* @__PURE__ */ (0, import_jsx_runtime513.jsx)("div", { children: MESSAGES17.RECENT_CREATED_AT(
                    import_uik686.format.duration(
                      import_luxon10.DateTime.now().toMillis() - import_luxon10.DateTime.fromISO(recentFilterSet.createdAt).toMillis(),
                      {
                        milliseconds: false,
                        seconds: false,
                        unitDisplay: "narrow"
                      }
                    )
                  ) })
                ] })
              },
              `recent-${recentFilterSet.createdAt}`
            ))
          }
        ),
        resultCount != void 0 && /* @__PURE__ */ (0, import_jsx_runtime513.jsx)("span", { className: (0, import_uik686.css)(RESULTS), children: MESSAGES17.RESULTS(`${import_uik686.format.number.short(resultCount)}`, resultCount !== 1 ? "s" : "") }),
        onResetAll && /* @__PURE__ */ (0, import_jsx_runtime513.jsx)("div", { className: (0, import_uik686.css)(RESET2), children: /* @__PURE__ */ (0, import_jsx_runtime513.jsx)(import_uik686.Button, { onClick: onResetAll, type: "TERTIARY", children: MESSAGES17.RESET_ALL() }) })
      ] }),
      actions && /* @__PURE__ */ (0, import_jsx_runtime513.jsx)("div", { className: (0, import_uik686.css)(ACTIONS), ref: actionsRef, children: actions })
    ] });
    const closeBehavior = {
      CLOSE_ICON: true,
      ESCAPE_KEY: true,
      FOOTER_PRIMARY: true,
      FOOTER_SECONDARY: true
    };
    const drawer = /* @__PURE__ */ (0, import_jsx_runtime513.jsx)(
      import_uik686.Drawer,
      {
        closeBehavior,
        footer: {
          primary: MESSAGES17.DRAWER_PRIMARY(),
          secondary: MESSAGES17.DRAWER_SECONDARY()
        },
        onClose: (kind) => {
          setDrawerOpen(false);
          const formElement = drawerFormRef.current;
          if (formElement == void 0) {
            return;
          }
          const form = import_uik686.Form.getSnapshot(formElement);
          onClose?.({
            form,
            kind
          });
        },
        open: drawerOpen,
        title: MESSAGES17.DRAWER_TITLE(),
        children: /* @__PURE__ */ (0, import_jsx_runtime513.jsx)("div", { className: (0, import_uik686.css)(DRAWER), ref: drawerContentRef, children: /* @__PURE__ */ (0, import_jsx_runtime513.jsx)(import_uik686.Form, { className: DRAWER, ref: drawerFormRef, children: drawerChildren }) })
      }
    );
    return /* @__PURE__ */ (0, import_jsx_runtime513.jsx)(import_uik686.Measurer, { onResize: onResize2, children: /* @__PURE__ */ (0, import_jsx_runtime513.jsxs)(
      "div",
      {
        className: (0, import_uik686.css)(HOST14, className2),
        ref,
        style: { visibility: hasMeasured ? "initial" : "hidden" },
        uik: FilterBar.displayName,
        ...props2,
        children: [
          bar,
          drawer
        ]
      }
    ) });
  }
);
FilterBar.displayName = "QuickFilter.FilterBar";
FilterBar.__DEV_METADATA__ = { status: "IN_PROGRESS" };
var GAP_SIZE = 12;

// QuickFilter/FilterManager/FilterManager.tsx
var import_uik688 = require("@appd/uik");
var import_react116 = require("react");

// QuickFilter/FilterManager/ManageCell.tsx
var import_uik687 = require("@appd/uik");
var import_jsx_runtime514 = require("react/jsx-runtime");
var ManageCell = /* @__PURE__ */ __name(({ value }) => {
  const { HOST: HOST14 } = STYLES35;
  return value != void 0 ? /* @__PURE__ */ (0, import_jsx_runtime514.jsx)("div", { className: (0, import_uik687.css)(HOST14), children: value.actions?.map((action) => /* @__PURE__ */ (0, import_jsx_runtime514.jsx)(import_uik687.Tooltip, { value: action.label, children: /* @__PURE__ */ (0, import_jsx_runtime514.jsx)(import_uik687.Button, { icon: action.icon, onClick: action.onClick, type: "TERTIARY" }) }, `action-${action.label}`)) }) : /* @__PURE__ */ (0, import_jsx_runtime514.jsx)(import_jsx_runtime514.Fragment, {});
}, "ManageCell");
var STYLES35 = {
  HOST: (0, import_uik687.css)({
    display: "flex",
    gap: 8,
    justifyContent: "center"
  })
};

// QuickFilter/FilterManager/MESSAGES.ts
var MESSAGES18 = {
  CREATE_DRAWER_PRIMARY: format.message`Save`.description("A primary button in the create drawer."),
  CREATE_DRAWER_TITLE: format.message`Save as Quick Filter`.description("A title in the create drawer."),
  DRAWER_PRIMARY: format.message`Apply`.description("A primary button in the drawer."),
  DRAWER_SECONDARY: format.message`Cancel`.description("A secondary button in the drawer."),
  DRAWER_TITLE: format.message`Filters`.description("A title in the drawer."),
  DRAWER_TRIGGER: format.message`All Quick Filters`.description("A label in a button that toggles the drawer."),
  EDIT_DRAWER_PRIMARY: format.message`Edit`.description("A primary button in the edit drawer."),
  EDIT_DRAWER_TITLE: format.message`Edit Quick Filter`.description("A title in the edit drawer."),
  QUICK_FILTERS_LABEL: format.message`Quick Filters`.description("A label that describes the quick filters list."),
  SAVE_CURRENT: format.message`Save Current`.description("A label in a button that saves the current filters.")
};

// QuickFilter/FilterManager/STYLES.tsx
var {
  TYPOGRAPHY: { P2_BOLD }
} = MAGNETIC_TOKENS;
var STYLES36 = {
  BAR: {
    ALL_QUICK_FILTERS: { minWidth: 150 },
    FILTER_COLLECTIONS: {
      display: "flex",
      flexWrap: "wrap",
      gap: 8
    },
    QUICK_FILTERS_LABEL: {
      font: P2_BOLD,
      minWidth: 100
    },
    SAVE_CURRENT_FILTERS: { minWidth: 120 },
    alignItems: "center",
    display: "flex",
    gap: 16
  },
  DRAWER: {
    display: "flex",
    flexDirection: "column",
    gap: 16
  }
};

// QuickFilter/FilterManager/FilterManager.tsx
var import_jsx_runtime515 = require("react/jsx-runtime");
var FilterManager = import_uik688.utils.forwardRef(
  ({
    className: className2,
    currentFilterSet,
    getSuggestions,
    onFilterSetApply,
    onFilterSetDelete,
    onFilterSetSave,
    savedFilterSets,
    ...props2
  }, ref) => {
    const [drawerOpen, setDrawerOpen] = (0, import_react116.useState)(false);
    const [createDrawerOpen, setCreateDrawerOpen] = (0, import_react116.useState)(false);
    const [editDrawerOpen, setEditDrawerOpen] = (0, import_react116.useState)(false);
    const [rows, setRows] = (0, import_react116.useState)([]);
    const [createName, setCreateName] = (0, import_react116.useState)("");
    const [editFilterSet, setEditFilterSet] = (0, import_react116.useState)();
    const createDrawerFormRef = (0, import_react116.useRef)(null);
    const editDrawerFormRef = (0, import_react116.useRef)(null);
    const {
      BAR: { ALL_QUICK_FILTERS, FILTER_COLLECTIONS, QUICK_FILTERS_LABEL, SAVE_CURRENT_FILTERS, ...BAR },
      DRAWER
    } = STYLES36;
    const closeBehavior = {
      CLOSE_ICON: true,
      ESCAPE_KEY: true,
      FOOTER_PRIMARY: true,
      FOOTER_SECONDARY: true
    };
    const getElementsFromSet = /* @__PURE__ */ __name((filterSet) => {
      if (!filterSet) {
        return null;
      }
      const selectFilterElements = filterSet.selectFilters.map((item, index) => /* @__PURE__ */ (0, import_jsx_runtime515.jsx)(
        import_uik688.Select.Searchable,
        {
          disableFiltering: true,
          getSuggestions: (search) => getSuggestions(search, item.key),
          initialValue: item.value,
          label: item.label,
          multiple: true,
          name: item.key,
          showOptional: false
        },
        `drawer-select-${index}`
      ));
      const numericFilterElements = filterSet.numericFilters?.map((item, index) => /* @__PURE__ */ (0, import_jsx_runtime515.jsx)(
        import_uik688.Slider,
        {
          initialLower: item.lower,
          initialUpper: item.upper,
          invert: item.invert,
          label: item.label,
          max: item.max,
          name: item.key,
          showInput: true
        },
        `drawer-slider-${index}`
      ));
      const checkboxFilterElements = filterSet.checkboxFilters?.map((item, index) => /* @__PURE__ */ (0, import_jsx_runtime515.jsx)(import_uik688.Checkbox, { initialChecked: item.checked, label: item.label, name: item.key }, `drawer-checkbox-${index}`));
      return /* @__PURE__ */ (0, import_jsx_runtime515.jsxs)(import_jsx_runtime515.Fragment, { children: [
        selectFilterElements,
        numericFilterElements,
        checkboxFilterElements
      ] });
    }, "getElementsFromSet");
    (0, import_react116.useEffect)(() => {
      const newRows = savedFilterSets?.map((filterSet) => ({
        manage: {
          actions: [
            {
              icon: "Action.Edit",
              label: "Edit",
              onClick: () => {
                setEditFilterSet(filterSet);
                setEditDrawerOpen(true);
              }
            },
            {
              icon: "Action.Delete",
              label: "Delete",
              onClick: () => {
                onFilterSetDelete?.({ set: filterSet });
              }
            }
          ]
        },
        name: filterSet.name
      })) ?? [];
      setRows(newRows);
    }, [savedFilterSets]);
    const colDefs = [
      {
        field: "name",
        headerName: "Name"
      },
      {
        cellRenderer: ManageCell,
        field: "manage",
        headerName: "",
        minWidth: 50,
        //TODO: Not sure why ag-rid is complaining about the typing here, so have to cast.
        pinned: "right",
        resizable: false,
        sortable: false,
        width: 70
      }
    ];
    const bar = /* @__PURE__ */ (0, import_jsx_runtime515.jsxs)("div", { className: (0, import_uik688.css)(BAR), children: [
      /* @__PURE__ */ (0, import_jsx_runtime515.jsx)("span", { className: (0, import_uik688.css)(QUICK_FILTERS_LABEL), children: MESSAGES18.QUICK_FILTERS_LABEL() }),
      /* @__PURE__ */ (0, import_jsx_runtime515.jsx)("div", { className: (0, import_uik688.css)(FILTER_COLLECTIONS), children: savedFilterSets.map((filterSet) => /* @__PURE__ */ (0, import_jsx_runtime515.jsx)(import_uik688.Button, { onClick: () => onFilterSetApply?.({ set: filterSet }), type: "SECONDARY", children: filterSet.name }, filterSet.name)) }),
      /* @__PURE__ */ (0, import_jsx_runtime515.jsx)(
        import_uik688.Button,
        {
          className: (0, import_uik688.css)(ALL_QUICK_FILTERS),
          icon: "Action.Configure",
          onClick: () => {
            setDrawerOpen(!drawerOpen);
          },
          type: "TERTIARY",
          children: MESSAGES18.DRAWER_TRIGGER()
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime515.jsx)(
        import_uik688.Button,
        {
          className: (0, import_uik688.css)(SAVE_CURRENT_FILTERS),
          icon: "Action.Save",
          onClick: () => setCreateDrawerOpen(!createDrawerOpen),
          type: "TERTIARY",
          children: MESSAGES18.SAVE_CURRENT()
        }
      )
    ] });
    const drawer = /* @__PURE__ */ (0, import_jsx_runtime515.jsx)(
      import_uik688.Drawer,
      {
        closeBehavior,
        onClose: () => {
          setDrawerOpen(false);
        },
        open: drawerOpen,
        title: MESSAGES18.DRAWER_TITLE(),
        children: /* @__PURE__ */ (0, import_jsx_runtime515.jsx)(import_uik688.Grid, { columns: colDefs, rows, showConfigure: false })
      }
    );
    const createDrawerChildren = /* @__PURE__ */ (0, import_jsx_runtime515.jsxs)(
      "div",
      {
        style: {
          display: "flex",
          flexDirection: "column",
          gap: 18
        },
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime515.jsx)(
            import_uik688.Input,
            {
              label: "Name",
              onChange: ({ target: { value } }) => setCreateName(value),
              showOptional: false,
              value: createName
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime515.jsx)(import_uik688.Form, { className: DRAWER, ref: createDrawerFormRef, children: getElementsFromSet(currentFilterSet) })
        ]
      }
    );
    const clearCreate = /* @__PURE__ */ __name(() => {
      setCreateDrawerOpen(false);
      setCreateName("");
    }, "clearCreate");
    const onCreateClose = /* @__PURE__ */ __name((kind) => {
      const formElement = createDrawerFormRef.current;
      if (formElement == void 0) {
        return;
      }
      const form = import_uik688.Form.getSnapshot(formElement);
      if (kind === "FOOTER_PRIMARY" && form != null) {
        const { values } = form;
        const newSelectFilters = currentFilterSet.selectFilters.map((selectFilter) => ({
          ...selectFilter,
          value: values[selectFilter.key]
        }));
        const newNumericFilters = currentFilterSet.numericFilters?.map((numericFilter) => {
          const { max: rawMax, min: rawMin } = values[numericFilter.key];
          const max2 = rawMax === "" ? void 0 : Number(rawMax);
          const min2 = rawMin === "" ? void 0 : Number(rawMin);
          const lower = numericFilter.invert ? void 0 : min2;
          const upper = numericFilter.invert ? min2 : max2;
          return {
            ...numericFilter,
            lower,
            upper
          };
        });
        const newCheckboxFilters = currentFilterSet?.checkboxFilters?.map((checkboxFilter) => ({
          ...checkboxFilter,
          checked: values[checkboxFilter.key]
        }));
        onFilterSetSave?.({
          set: {
            checkboxFilters: newCheckboxFilters ?? [],
            name: createName,
            numericFilters: newNumericFilters ?? [],
            selectFilters: newSelectFilters ?? []
          }
        });
      }
      clearCreate();
    }, "onCreateClose");
    const createDrawer = /* @__PURE__ */ (0, import_jsx_runtime515.jsx)(
      import_uik688.Drawer,
      {
        closeBehavior,
        footer: {
          primary: MESSAGES18.CREATE_DRAWER_PRIMARY(),
          secondary: MESSAGES18.DRAWER_SECONDARY()
        },
        onClose: (kind) => {
          onCreateClose?.(kind);
        },
        open: createDrawerOpen,
        title: MESSAGES18.CREATE_DRAWER_TITLE(),
        children: createDrawerChildren
      }
    );
    const clearEdit = /* @__PURE__ */ __name(() => {
      setEditDrawerOpen(false);
    }, "clearEdit");
    const onEditClose = /* @__PURE__ */ __name((kind) => {
      const formElement = editDrawerFormRef.current;
      if (formElement == void 0) {
        return;
      }
      const form = import_uik688.Form.getSnapshot(formElement);
      if (kind === "FOOTER_PRIMARY" && form != null) {
        const { values } = form;
        const newSelectFilters = editFilterSet?.selectFilters.map((selectFilter) => ({
          ...selectFilter,
          value: values[selectFilter.key]
        }));
        const newNumericFilters = editFilterSet?.numericFilters?.map((numericFilter) => {
          const { max: rawMax, min: rawMin } = values[numericFilter.key];
          const max2 = rawMax === "" ? void 0 : Number(rawMax);
          const min2 = rawMin === "" ? void 0 : Number(rawMin);
          const lower = numericFilter.invert ? void 0 : min2;
          const upper = numericFilter.invert ? min2 : max2;
          return {
            ...numericFilter,
            lower,
            upper
          };
        });
        const newCheckboxFilters = editFilterSet?.checkboxFilters?.map((checkboxFilter) => ({
          ...checkboxFilter,
          checked: values[checkboxFilter.key]
        }));
        onFilterSetSave?.({
          set: {
            checkboxFilters: newCheckboxFilters ?? [],
            name: editFilterSet?.name ?? "",
            numericFilters: newNumericFilters ?? [],
            selectFilters: newSelectFilters ?? []
          }
        });
      }
      clearEdit();
    }, "onEditClose");
    const editDrawerChildren = /* @__PURE__ */ (0, import_jsx_runtime515.jsxs)(
      "div",
      {
        style: {
          display: "flex",
          flexDirection: "column",
          gap: 18
        },
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime515.jsx)(
            import_uik688.Input,
            {
              disabled: true,
              label: "Name",
              onChange: ({ target: { value } }) => setCreateName(value),
              showOptional: false,
              value: editFilterSet?.name
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime515.jsx)(import_uik688.Form, { className: DRAWER, ref: editDrawerFormRef, children: getElementsFromSet(editFilterSet) })
        ]
      }
    );
    const editDrawer = /* @__PURE__ */ (0, import_jsx_runtime515.jsx)(
      import_uik688.Drawer,
      {
        closeBehavior,
        footer: {
          primary: MESSAGES18.EDIT_DRAWER_PRIMARY(),
          secondary: MESSAGES18.DRAWER_SECONDARY()
        },
        onClose: (kind) => {
          onEditClose?.(kind);
        },
        open: editDrawerOpen,
        title: MESSAGES18.EDIT_DRAWER_TITLE(),
        children: editDrawerChildren
      }
    );
    return /* @__PURE__ */ (0, import_jsx_runtime515.jsxs)("div", { className: (0, import_uik688.css)(className2), ref, uik: FilterManager.displayName, ...props2, children: [
      bar,
      drawer,
      createDrawer,
      editDrawer
    ] });
  }
);
FilterManager.displayName = "FilterManager";
FilterManager.__DEV_METADATA__ = { status: "IN_PROGRESS" };

// QuickFilter/FilterTags/FilterTags.tsx
var import_uik689 = require("@appd/uik");
var import_react117 = require("react");
var import_jsx_runtime516 = require("react/jsx-runtime");
var FilterTags = import_uik689.utils.forwardRef(
  ({ className: className2, filterSet, onClose: rawOnClose, ...props2 }, ref) => {
    const onClose = (0, import_react117.useCallback)(
      (key) => {
        const newFilterSet = { ...filterSet };
        newFilterSet.selectFilters = newFilterSet.selectFilters.map(
          (selectFilter) => selectFilter.key !== key ? selectFilter : {
            ...selectFilter,
            value: []
          }
        );
        newFilterSet.checkboxFilters = newFilterSet.checkboxFilters?.map(
          (checkboxFilter) => checkboxFilter.key !== key ? checkboxFilter : {
            ...checkboxFilter,
            checked: false
          }
        );
        newFilterSet.numericFilters = newFilterSet.numericFilters?.map(
          (numericFilter) => numericFilter.key !== key ? numericFilter : {
            ...numericFilter,
            lower: 0,
            upper: 0
          }
        );
        rawOnClose(newFilterSet);
      },
      [filterSet]
    );
    return /* @__PURE__ */ (0, import_jsx_runtime516.jsx)("div", { className: (0, import_uik689.css)(className2), ref, uik: FilterTags.displayName, ...props2, children: getTags(filterSet, onClose) });
  }
);
FilterTags.displayName = "QuickFilter.FilterTags";
FilterTags.__DEV_METADATA__ = { status: "IN_PROGRESS" };

// QuickFilter/BaseQuickFilter.tsx
var import_jsx_runtime517 = require("react/jsx-runtime");
var BaseQuickFilter = /* @__PURE__ */ __name(({
  className: className2,
  filterSet: rawFilterSet,
  getSuggestions,
  onFilterSetApply: rawOnFilterSetApply,
  onFilterSetDelete: rawOnFilterSetDelete,
  onFilterSetSave: rawOnFilterSetSave,
  recentFilterSets,
  savedFilterSets
}) => {
  const [currentFilterSet, setCurrentFilterSet] = (0, import_react118.useState)(rawFilterSet);
  const { DIVIDER } = STYLES37;
  const selectFiltersElements = currentFilterSet?.selectFilters.map((item, index) => /* @__PURE__ */ (0, import_jsx_runtime517.jsx)(
    import_uik690.Select.Searchable,
    {
      disableFiltering: true,
      getSuggestions: (search) => getSuggestions(search, item.key),
      label: item.label,
      multiple: true,
      name: item.key,
      onChange: (selected) => {
        const newSelectFilters = updateArray(currentFilterSet?.selectFilters, index, {
          ...currentFilterSet.selectFilters[index],
          value: selected
        });
        const newFilterCollection = {
          ...currentFilterSet,
          selectFilters: newSelectFilters
        };
        setCurrentFilterSet(newFilterCollection);
      },
      placeholder: "Look up a value",
      showOptional: false,
      value: item.value
    },
    `select-${index}`
  ));
  const numericFiltersElements = currentFilterSet.numericFilters?.map((item, index) => /* @__PURE__ */ (0, import_jsx_runtime517.jsx)(
    import_uik690.Slider.Popover,
    {
      invert: item.invert,
      label: item.label,
      lower: item.lower,
      max: item.max,
      name: item.key,
      onChange: ({ lower, upper }) => {
        if (!currentFilterSet.numericFilters) {
          return;
        }
        const newNumericFilters = updateArray(currentFilterSet.numericFilters, index, {
          ...currentFilterSet.numericFilters[index],
          lower,
          upper
        });
        const newFilterCollection = {
          ...currentFilterSet,
          numericFilters: newNumericFilters
        };
        setCurrentFilterSet(newFilterCollection);
      },
      showInput: true,
      upper: item.upper
    },
    `slider-${index}`
  ));
  const checkboxFiltersElements = currentFilterSet.checkboxFilters?.map((item, index) => /* @__PURE__ */ (0, import_jsx_runtime517.jsx)(
    import_uik690.Checkbox,
    {
      checked: item.checked,
      label: item.label,
      name: item.key,
      onChange: (checked) => {
        if (!currentFilterSet.checkboxFilters) {
          return;
        }
        const newCheckboxFilters = updateArray(currentFilterSet.checkboxFilters, index, {
          ...currentFilterSet.checkboxFilters[index],
          checked
        });
        const newFilterCollection = {
          ...currentFilterSet,
          checkboxFilters: newCheckboxFilters
        };
        setCurrentFilterSet(newFilterCollection);
      }
    },
    `checkbox-${index}`
  ));
  const drawerSelectFiltersElements = currentFilterSet.selectFilters.map((item, index) => /* @__PURE__ */ (0, import_jsx_runtime517.jsx)(
    import_uik690.Select.Searchable,
    {
      disableFiltering: true,
      getSuggestions: (search) => getSuggestions(search, item.key),
      initialValue: item.value,
      label: item.label,
      multiple: true,
      name: item.key,
      placeholder: "Look up a value",
      showOptional: false
    },
    `drawer-select-${index}`
  ));
  const drawerNumericFiltersElements = currentFilterSet.numericFilters?.map((item, index) => /* @__PURE__ */ (0, import_jsx_runtime517.jsx)(
    import_uik690.Slider,
    {
      initialLower: item.lower,
      initialUpper: item.upper,
      invert: item.invert,
      label: item.label,
      max: item.max,
      name: item.key,
      showInput: true
    },
    `drawer-slider-${index}`
  ));
  const drawerCheckboxFiltersElements = currentFilterSet.checkboxFilters?.map((item, index) => /* @__PURE__ */ (0, import_jsx_runtime517.jsx)(import_uik690.Checkbox, { initialChecked: item.checked, label: item.label, name: item.key }, `drawer-checkbox-${index}`));
  const onFilterSetApply = /* @__PURE__ */ __name(({ set }) => {
    setCurrentFilterSet(set);
    rawOnFilterSetApply?.({ set });
  }, "onFilterSetApply");
  const onClose = /* @__PURE__ */ __name(({ form, kind }) => {
    if (kind === "FOOTER_PRIMARY" && form != null) {
      const { values } = form;
      const newSelectFilters = currentFilterSet.selectFilters.map((selectFilter) => ({
        ...selectFilter,
        value: values[selectFilter.key]
      }));
      const newNumericFilters = currentFilterSet.numericFilters?.map((numericFilter) => {
        const { max: rawMax, min: rawMin } = values[numericFilter.key];
        const max2 = rawMax === "" ? void 0 : Number(rawMax);
        const min2 = rawMin === "" ? void 0 : Number(rawMin);
        const lower = numericFilter.invert ? void 0 : min2;
        const upper = numericFilter.invert ? min2 : max2;
        return {
          ...numericFilter,
          lower,
          upper
        };
      });
      const newCheckboxFilters = currentFilterSet.checkboxFilters?.map((checkboxFilter) => ({
        ...checkboxFilter,
        checked: values[checkboxFilter.key]
      }));
      const newFilterSet = {
        ...currentFilterSet,
        checkboxFilters: newCheckboxFilters,
        numericFilters: newNumericFilters,
        selectFilters: newSelectFilters
      };
      onFilterSetApply({ set: newFilterSet });
    }
  }, "onClose");
  const filterBar = /* @__PURE__ */ (0, import_jsx_runtime517.jsxs)(
    FilterBar,
    {
      className: className2,
      drawerChildren: /* @__PURE__ */ (0, import_jsx_runtime517.jsxs)(import_jsx_runtime517.Fragment, { children: [
        drawerSelectFiltersElements,
        drawerNumericFiltersElements,
        drawerCheckboxFiltersElements
      ] }),
      filterSet: currentFilterSet,
      onClose,
      onFilterSetApply,
      recentFilterSets,
      children: [
        selectFiltersElements,
        numericFiltersElements,
        checkboxFiltersElements
      ]
    }
  );
  const onTagClose = /* @__PURE__ */ __name((filterSet) => {
    setCurrentFilterSet(filterSet);
  }, "onTagClose");
  const tags = /* @__PURE__ */ (0, import_jsx_runtime517.jsx)(FilterTags, { filterSet: currentFilterSet, onClose: onTagClose });
  const manager = rawOnFilterSetSave && rawOnFilterSetDelete ? /* @__PURE__ */ (0, import_jsx_runtime517.jsxs)(import_jsx_runtime517.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime517.jsx)("div", { className: (0, import_uik690.css)(DIVIDER) }),
    /* @__PURE__ */ (0, import_jsx_runtime517.jsx)(
      FilterManager,
      {
        currentFilterSet,
        getSuggestions,
        onFilterSetApply,
        onFilterSetDelete: rawOnFilterSetDelete,
        onFilterSetSave: rawOnFilterSetSave,
        savedFilterSets
      }
    )
  ] }) : null;
  return /* @__PURE__ */ (0, import_jsx_runtime517.jsxs)(import_jsx_runtime517.Fragment, { children: [
    filterBar,
    tags,
    manager
  ] });
}, "BaseQuickFilter");
var updateArray = /* @__PURE__ */ __name((arr, index, newValue) => {
  const newArr = [...arr];
  newArr[index] = newValue;
  return newArr;
}, "updateArray");
var {
  COLORS: { DEFAULT_BORDER }
} = import_uik690.MAGNETIC_TOKENS;
var STYLES37 = {
  DIVIDER: (0, import_uik690.css)({ border: `1px solid ${DEFAULT_BORDER}` }),
  HOST: (0, import_uik690.css)({
    display: "flex",
    flexDirection: "column",
    gap: 8
  })
};

// QuickFilter/QuickFilter.tsx
var import_jsx_runtime518 = require("react/jsx-runtime");
var QuickFilter = import_uik691.utils.forwardRef(
  ({
    className: className2,
    filterDefinitions,
    filterSet,
    getSuggestions,
    onFilterSetApply: rawOnFilterSetApply,
    onFilterSetDelete: rawOnFilterSetDelete,
    onFilterSetSave: rawOnFilterSetSave,
    recentFilterSets,
    savedFilterSets
  }, ref) => {
    const { HOST: HOST14 } = STYLES38;
    const baseFilterSet = getBaseFilterSet(filterDefinitions, filterSet.states);
    const baseRecentFilterSets = recentFilterSets?.map(({ createdAt, states }) => ({
      createdAt: createdAt ?? 0,
      ...getBaseFilterSet(filterDefinitions, states)
    })) ?? [];
    const baseSavedFilterSets = savedFilterSets?.map(({ name, states }) => ({
      name,
      ...getBaseFilterSet(filterDefinitions, states)
    })) ?? [];
    const onFilterSetApply = /* @__PURE__ */ __name(({ set: baseFilterSet2 }) => {
      rawOnFilterSetApply?.({ set: { states: getFilterStates(baseFilterSet2) } });
    }, "onFilterSetApply");
    const onFilterSetSave = rawOnFilterSetSave != void 0 ? ({ set: { checkboxFilters, name, numericFilters, selectFilters } }) => {
      const baseFilterSet2 = {
        checkboxFilters,
        numericFilters,
        selectFilters
      };
      rawOnFilterSetSave({
        set: {
          name,
          states: getFilterStates(baseFilterSet2)
        }
      });
    } : void 0;
    const onFilterSetDelete = rawOnFilterSetDelete != void 0 ? ({ set: { checkboxFilters, name, numericFilters, selectFilters } }) => {
      const baseFilterSet2 = {
        checkboxFilters,
        numericFilters,
        selectFilters
      };
      return rawOnFilterSetDelete({
        set: {
          name,
          states: getFilterStates(baseFilterSet2)
        }
      });
    } : void 0;
    return /* @__PURE__ */ (0, import_jsx_runtime518.jsx)("div", { className: (0, import_uik691.css)(className2, HOST14), ref, uik: QuickFilter.displayName, children: /* @__PURE__ */ (0, import_jsx_runtime518.jsx)(
      BaseQuickFilter,
      {
        filterSet: baseFilterSet,
        getSuggestions,
        onFilterSetApply,
        onFilterSetDelete,
        onFilterSetSave,
        recentFilterSets: baseRecentFilterSets,
        savedFilterSets: baseSavedFilterSets
      }
    ) });
  }
);
QuickFilter.displayName = "QuickFilter";
QuickFilter.__DEV_METADATA__ = { status: "IN_PROGRESS" };
var {
  COLORS: { DEFAULT_BORDER: DEFAULT_BORDER2 }
} = import_uik691.MAGNETIC_TOKENS;
var STYLES38 = {
  DIVIDER: (0, import_uik691.css)({ border: `1px solid ${DEFAULT_BORDER2}` }),
  HOST: (0, import_uik691.css)({
    display: "flex",
    flexDirection: "column",
    gap: 8
  })
};

// ScrollBox/ScrollBox.tsx
var import_uik703 = require("@appd/uik");
var import_react121 = require("react");

// ScrollBox/Dot/Dot.tsx
var import_uik699 = require("@appd/uik");

// ScrollBox/Dot/getStyles.ts
var import_uik698 = require("@appd/uik");

// ScrollBox/Scrollbar/Scrollbar.tsx
var import_uik697 = require("@appd/uik");

// ScrollBox/Scrollbar/getScrollRatio.ts
var import_uik692 = require("@appd/uik");
var getScrollRatio = /* @__PURE__ */ __name(({ hasDot, horizontal, measurements }, { PADDING: PADDING2, WIDTH: WIDTH3 } = Scrollbar) => {
  const { clientHeight, scrollHeight } = horizontal ? {
    clientHeight: measurements.clientWidth,
    scrollHeight: measurements.scrollWidth
  } : measurements;
  const tooSmall = clientHeight < (hasDot ? 2 * WIDTH3 : WIDTH3);
  return tooSmall ? {
    scrollRatio: 1,
    thumbLength: 0
  } : ((s = 1 + (clientHeight - +hasDot * WIDTH3) / scrollHeight, t = (s - 1) * clientHeight, thumbLength = import_uik692.utils.clamp(t, [WIDTH3 - +hasDot * PADDING2]), \u0394s = (t - thumbLength) / scrollHeight) => ({
    scrollRatio: s + \u0394s,
    thumbLength
  }))();
}, "getScrollRatio");

// ScrollBox/Scrollbar/getStyles.ts
var import_uik693 = require("@appd/uik");
var {
  COLORS: {
    DEFAULT_BG_STRONG: DEFAULT_BG_STRONG2,
    DEFAULT_BG_STRONG_ACTIVE,
    DEFAULT_BG_STRONG_HOVER: DEFAULT_BG_STRONG_HOVER2,
    DEFAULT_BG_WEAK: DEFAULT_BG_WEAK4,
    DEFAULT_BG_WEAK_HOVER
  },
  MOTION: { DURATION, EASING }
} = import_uik693.MAGNETIC_TOKENS;
var getStyles29 = /* @__PURE__ */ __name(({
  awake,
  hasDot,
  horizontal,
  isDragging
}, { PADDING: PADDING2, WIDTH: WIDTH3 } = Scrollbar) => ({
  THUMB: (0, import_uik693.css)({
    ...horizontal ? {
      ...hasDot && { paddingRight: 0 },
      height: WIDTH3,
      left: LEFT,
      marginRight: -import_uik693.utils.CSS_MAX_NUMBER,
      width: THUMB_LENGTH
    } : {
      ...hasDot && { paddingBottom: 0 },
      height: THUMB_LENGTH,
      marginBottom: -import_uik693.utils.CSS_MAX_NUMBER,
      top: TOP,
      width: WIDTH3
    },
    "::after": {
      backgroundColor: isDragging ? DEFAULT_BG_STRONG_ACTIVE : DEFAULT_BG_STRONG2,
      borderRadius: WIDTH3 / 2,
      content: "''",
      display: "block",
      height: "100%"
    },
    ":hover::after": { backgroundColor: DEFAULT_BG_STRONG_HOVER2 },
    boxSizing: "border-box",
    padding: PADDING2,
    position: "sticky",
    transform: `matrix3d(${[
      // Each "row" here is a "column" in conventional notation.
      [1, 0, 0, 0],
      [0, 1, 0, 0],
      [0, 0, 1, 0],
      [0, 0, Z, SCROLL_RATIO]
    ].flat()})`,
    transformOrigin: "0 0 0"
  }),
  TRACK: (0, import_uik693.css)({
    ...horizontal ? {
      height: WIDTH3,
      marginBottom: -import_uik693.utils.CSS_MAX_NUMBER,
      top: TOP,
      width: SCROLL_WIDTH
    } : {
      height: SCROLL_HEIGHT,
      left: LEFT,
      marginRight: -import_uik693.utils.CSS_MAX_NUMBER,
      width: WIDTH3
    },
    ":hover": { backgroundColor: DEFAULT_BG_WEAK_HOVER },
    ...isDragging && { backgroundColor: DEFAULT_BG_WEAK4 },
    opacity: +awake,
    perspective: 1,
    perspectiveOrigin: "0 0",
    position: "sticky",
    ...!awake && { transition: `opacity ${DURATION.LAZY} ${EASING.DECELERATE}` },
    userSelect: "none"
  })
}), "getStyles");
var {
  LEFT = "var(--left)",
  SCROLL_HEIGHT = "var(--scrollHeight)",
  SCROLL_RATIO = "var(--scrollRatio)",
  SCROLL_WIDTH = "var(--scrollWidth)",
  THUMB_LENGTH = "var(--thumbLength)",
  TOP = "var(--top)",
  Z = "var(--z)"
} = {};

// ScrollBox/Scrollbar/getVolatileStyles.ts
var getVolatileStyles2 = /* @__PURE__ */ __name(({
  horizontal,
  measurements,
  scrollRatio,
  thumbLength
}, { WIDTH: WIDTH3 } = Scrollbar) => {
  const { clientWidth, paddingLeft, paddingTop } = horizontal ? {
    clientWidth: measurements.clientHeight,
    paddingLeft: measurements.paddingTop,
    paddingTop: measurements.paddingLeft
  } : measurements;
  return {
    [horizontal ? "--top" : "--left"]: `${clientWidth - WIDTH3 - paddingLeft}px`,
    [horizontal ? "--left" : "--top"]: `${-paddingTop}px`,
    "--scrollRatio": String(scrollRatio),
    "--thumbLength": `${thumbLength}px`,
    "--z": String(scrollRatio - 1)
  };
}, "getVolatileStyles");

// ScrollBox/Scrollbar/useDrag/useDrag.ts
var import_uik695 = require("@appd/uik");
var import_react119 = require("react");

// ScrollBox/Scrollbar/useDrag/getScrollChangeFor.ts
var import_uik694 = require("@appd/uik");
var getScrollChangeFor = /* @__PURE__ */ __name(({ horizontal, parentElem, scrollRatio, thumbElem }) => (clientY, offset) => {
  const { borderBottomWidth, borderLeftWidth, borderRightWidth, borderTopWidth } = getComputedStyle(parentElem);
  const [rawParent, rawThumb] = [import_uik694.utils.getBoundingClientRect(parentElem), import_uik694.utils.getBoundingClientRect(thumbElem)];
  const [parent, thumb] = horizontal ? [
    {
      bottom: rawParent.right - parseFloat(borderRightWidth),
      top: rawParent.left + parseFloat(borderLeftWidth)
    },
    {
      bottom: rawThumb.right,
      height: rawThumb.width,
      top: rawThumb.left
    }
  ] : [
    {
      bottom: rawParent.bottom - parseFloat(borderBottomWidth),
      top: rawParent.top + parseFloat(borderTopWidth)
    },
    rawThumb
  ];
  const isInside = offset === void 0 && clientY === import_uik694.utils.clamp(clientY, [thumb.top, thumb.bottom]);
  const top = isInside ? thumb.top : import_uik694.utils.clamp(clientY + (offset ?? -thumb.height / 2), [parent.top, parent.bottom - thumb.height]);
  return {
    offset: top - clientY,
    scrollTo: (top - parent.top) / (scrollRatio - 1)
  };
}, "getScrollChangeFor");

// ScrollBox/Scrollbar/useDrag/useDrag.ts
var useDrag = /* @__PURE__ */ __name(({ horizontal, onScrollChange, parentRef, scrollRatio }) => {
  const [isDragging, setIsDragging] = (0, import_react119.useState)(false);
  const [trackRef, thumbRef] = [(0, import_react119.useRef)(null), (0, import_react119.useRef)(null)];
  (0, import_react119.useEffect)(() => {
    const [{ current: parentElem }, { current: thumbElem }, { current: trackElem }] = [parentRef, thumbRef, trackRef];
    if (!parentElem || !thumbElem || !trackElem) {
      return;
    }
    const getScrollChange = getScrollChangeFor({
      horizontal,
      parentElem,
      scrollRatio,
      thumbElem
    });
    return import_uik695.utils.addEventListener(trackElem, "pointerdown", (e) => {
      const { clientY } = horizontal ? { clientY: e.clientX } : e;
      const { offset, scrollTo: scrollStart } = getScrollChange(clientY);
      [
        setIsDragging(true),
        onScrollChange?.(scrollStart, "START"),
        document.body.classList.add("uik-scroll-bar-is-dragging")
      ];
      const unsubscribe = [
        import_uik695.utils.addEventListener(document, "pointermove", (e2) => {
          const { clientY: clientY2 } = horizontal ? { clientY: e2.clientX } : e2;
          const { scrollTo } = getScrollChange(clientY2, offset);
          onScrollChange?.(scrollTo, "MOVE");
        }),
        import_uik695.utils.addEventListener(
          document,
          "pointerup",
          (e2) => {
            const { clientY: clientY2 } = horizontal ? { clientY: e2.clientX } : e2;
            const { scrollTo } = getScrollChange(clientY2, offset);
            [
              setIsDragging(false),
              onScrollChange?.(scrollTo, "STOP"),
              document.body.classList.remove("uik-scroll-bar-is-dragging"),
              unsubscribe.forEach((f) => f())
            ];
          },
          { capture: true }
        )
      ];
    });
  }, [parentRef.current, scrollRatio, trackRef.current, thumbRef.current]);
  return {
    isDragging,
    thumbRef,
    trackRef
  };
}, "useDrag");
import_uik695.css.RENDERER.renderStatic({ pointerEvents: "none" }, "body.uik-scroll-bar-is-dragging");

// ScrollBox/ISOLATE.ts
var import_uik696 = require("@appd/uik");
var ISOLATE4 = import_uik696.css.Styles({
  "> *": { pointerEvents: "auto" },
  contain: "size layout style",
  height: "100%",
  left: 0,
  pointerEvents: "none",
  position: "absolute",
  top: 0,
  width: "100%",
  zIndex: 1e4
});

// ScrollBox/Scrollbar/Scrollbar.tsx
var import_jsx_runtime519 = require("react/jsx-runtime");
var Scrollbar = /* @__PURE__ */ __name(({
  awake,
  hasDot,
  horizontal = false,
  measurements,
  onScrollChange,
  parentRef,
  ...inherited
}) => {
  const { scrollRatio, thumbLength } = getScrollRatio({
    hasDot,
    horizontal,
    measurements
  });
  const { isDragging, thumbRef, trackRef } = useDrag({
    horizontal,
    onScrollChange,
    parentRef,
    scrollRatio
  });
  const { THUMB, TRACK } = getStyles29({
    awake,
    hasDot,
    horizontal,
    isDragging
  });
  const style = getVolatileStyles2({
    horizontal,
    measurements,
    scrollRatio,
    thumbLength
  });
  const uik = horizontal ? "Scrollbar.HORIZONTAL" : "Scrollbar.VERTICAL";
  return /* @__PURE__ */ (0, import_jsx_runtime519.jsx)("div", { className: (0, import_uik697.css)(ISOLATE4), style, uik, children: /* @__PURE__ */ (0, import_jsx_runtime519.jsx)("div", { className: (0, import_uik697.css)(TRACK), ref: trackRef, uik: `${uik}.TRACK`, ...inherited, children: /* @__PURE__ */ (0, import_jsx_runtime519.jsx)("div", { className: (0, import_uik697.css)(THUMB, { pointerEvents: "none" }), ref: thumbRef, uik: `${uik}.THUMB` }) }) });
}, "Scrollbar");
Scrollbar.PADDING = 2;
Scrollbar.WIDTH = 2 * Scrollbar.PADDING + /* thumb */
8;

// ScrollBox/Dot/getStyles.ts
var getStyles30 = /* @__PURE__ */ __name(({ awake, measurements: { clientHeight, clientWidth, paddingLeft, paddingTop } }, { WIDTH: WIDTH3 } = Scrollbar, { RADIUS: RADIUS32 } = Dot) => (0, import_uik698.css)({
  "::after": {
    backgroundColor: DEFAULT_BG_STRONG3,
    borderRadius: RADIUS32,
    content: "''",
    display: "block",
    height: "100%"
  },
  ":hover::after": { backgroundColor: DEFAULT_BG_STRONG_HOVER3 },
  boxSizing: "border-box",
  height: WIDTH3,
  left: clientWidth - WIDTH3 - paddingLeft,
  marginBottom: -import_uik698.utils.CSS_MAX_NUMBER,
  marginRight: -import_uik698.utils.CSS_MAX_NUMBER,
  opacity: +awake,
  padding: 0.5 * (WIDTH3 - RADIUS32),
  position: "sticky",
  top: clientHeight - WIDTH3 - paddingTop,
  ...!awake && { transition: `opacity ${DURATION2.LAZY} ${EASING2.DECELERATE}` },
  userSelect: "none",
  width: WIDTH3
}), "getStyles");
var {
  COLORS: { DEFAULT_BG_STRONG: DEFAULT_BG_STRONG3, DEFAULT_BG_STRONG_HOVER: DEFAULT_BG_STRONG_HOVER3 },
  MOTION: { DURATION: DURATION2, EASING: EASING2 }
} = import_uik698.MAGNETIC_TOKENS;

// ScrollBox/Dot/Dot.tsx
var import_jsx_runtime520 = require("react/jsx-runtime");
var Dot = /* @__PURE__ */ __name(({ awake, measurements, ...inherited }) => /* @__PURE__ */ (0, import_jsx_runtime520.jsx)("div", { className: (0, import_uik699.css)(ISOLATE4), uik: "Dot", children: /* @__PURE__ */ (0, import_jsx_runtime520.jsx)(
  "div",
  {
    className: getStyles30({
      awake,
      measurements
    }),
    ...inherited
  }
) }), "Dot");
Dot.RADIUS = 0.5 * /* thumb */
(Scrollbar.WIDTH - 2 * Scrollbar.PADDING);

// ScrollBox/STYLES.ts
var import_uik700 = require("@appd/uik");
var STYLES39 = import_uik700.css.Styles({
  "::-webkit-scrollbar": { display: "none" },
  boxSizing: "border-box",
  height: "100%",
  overflow: "auto",
  position: "relative",
  scrollbarWidth: "none",
  // Otherwise, any `<Overlay>` in `children` are at the z-index context as those outside.
  zIndex: 0
});

// ScrollBox/useInteractions/useInteractions.ts
var import_uik702 = require("@appd/uik");
var import_react120 = require("react");
var import_rxjs3 = require("rxjs");

// ScrollBox/useInteractions/hoverEventsFor.ts
var hoverEventsFor = /* @__PURE__ */ __name((setInteractions) => ({
  onPointerEnter: () => setInteractions({ hovering: true }),
  onPointerLeave: () => setInteractions({
    fading: true,
    hovering: false
  })
}), "hoverEventsFor");

// ScrollBox/useInteractions/onScrollChangeFor.ts
var import_uik701 = require("@appd/uik");
var onScrollChangeFor = /* @__PURE__ */ __name((setInteractions) => (kind) => import_uik701.utils.maybeGet(
  {
    START: () => setInteractions({ dragging: true }),
    STOP: () => setInteractions({ dragging: false })
  },
  kind
)?.(), "onScrollChangeFor");

// ScrollBox/useInteractions/useInteractions.ts
var useInteractions = /* @__PURE__ */ __name(({
  measurements,
  ref
}) => {
  const [{ dragging, fading, hovering }, setInteractions] = (0, import_react120.useReducer)(
    (old, action) => {
      const next = {
        ...old,
        ...action
      };
      return old.dragging !== next.dragging || old.fading !== next.fading || old.hovering !== next.hovering ? next : old;
    },
    INITIAL_STATE
  );
  const [awake, hoverEvents, onScrollChange] = [
    dragging || fading || hovering,
    hoverEventsFor(setInteractions),
    onScrollChangeFor(setInteractions)
  ];
  import_uik702.utils.useEffect(
    () => !dragging && !hovering && fading && !import_uik702.utils.PREFERS_REDUCED_MOTION && import_uik702.utils.setTimeout(() => setInteractions({ fading: false }), 1e3),
    [!dragging && !hovering && fading]
  );
  import_uik702.utils.useEffect(() => {
    const { current } = ref;
    if (!current) {
      return;
    }
    const subscription = (0, import_rxjs3.fromEvent)(current, "scroll", { passive: true }).pipe(
      (0, import_rxjs3.throttleTime)(50, void 0, {
        leading: true,
        trailing: true
      })
    ).subscribe(() => setInteractions({ fading: true }));
    return [
      () => subscription.unsubscribe(),
      import_uik702.utils.addEventListener(current, "pointerenter", () => setInteractions({ fading: true })),
      import_uik702.utils.addEventListener(current, "pointerleave", () => setInteractions({ fading: true }))
    ];
  }, [ref.current]);
  return {
    dot: import_uik702.utils.infer().from({
      awake,
      measurements,
      onClick: () => ref.current?.scrollTo({
        behavior: "smooth",
        left: Number.MAX_SAFE_INTEGER,
        top: Number.MAX_SAFE_INTEGER
      }),
      ...hoverEvents
    }),
    horizontal: import_uik702.utils.infer().from({
      awake,
      measurements,
      onScrollChange: (scrollTo, kind) => [ref.current?.scrollTo(scrollTo, 0), onScrollChange(kind)],
      parentRef: ref,
      ...hoverEvents
    }),
    vertical: import_uik702.utils.infer().from({
      awake,
      measurements,
      onScrollChange: (scrollTo, kind) => [ref.current?.scrollTo(0, scrollTo), onScrollChange(kind)],
      parentRef: ref,
      ...hoverEvents
    })
  };
}, "useInteractions");
var INITIAL_STATE = {
  dragging: false,
  fading: false,
  hovering: false
};

// ScrollBox/ScrollBox.tsx
var import_jsx_runtime521 = require("react/jsx-runtime");
var ScrollBox9 = Object.assign(
  import_uik703.utils.forwardRef(
    ({
      children,
      className: className2,
      containOverlays = "OVERFLOW_ONLY",
      hideHorizontal = false,
      hideVertical = false,
      onResize: onResize2,
      ...inherited
    }, forwardedRef) => {
      const ref = import_uik703.utils.useBroadcastRef(forwardedRef);
      const [measurements, setMeasurements] = (0, import_react121.useState)({
        clientHeight: 0,
        clientWidth: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        scrollHeight: 0,
        scrollWidth: 0
      });
      const { dot, horizontal, vertical } = useInteractions({
        measurements,
        ref
      });
      const { clientHeight, clientWidth, scrollHeight, scrollWidth } = measurements;
      const [
        hasHorizontal = clientWidth < scrollWidth,
        hasVertical = clientHeight < scrollHeight,
        hasDot = hasHorizontal && hasVertical
      ] = [];
      return /* @__PURE__ */ (0, import_jsx_runtime521.jsx)("div", { className: (0, import_uik703.css)(STYLES39, ...import_uik703.utils.many(className2)), ref, uik: "ScrollBox", ...inherited, children: /* @__PURE__ */ (0, import_jsx_runtime521.jsxs)(
        import_uik703.Overlay.Provider,
        {
          onResize: (measurements2) => {
            setMeasurements(measurements2);
            onResize2?.(measurements2);
          },
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime521.jsx)(
              import_uik703.Overlay.Provider,
              {
                promote: !containOverlays || containOverlays === "OVERFLOW_ONLY" && !hasHorizontal && !hasVertical ? 2 : 1,
                children
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime521.jsxs)(import_uik703.Overlay, { children: [
              hasHorizontal && !hideHorizontal && /* @__PURE__ */ (0, import_jsx_runtime521.jsx)(Scrollbar, { hasDot, horizontal: true, ...horizontal }),
              hasVertical && !hideVertical && /* @__PURE__ */ (0, import_jsx_runtime521.jsx)(Scrollbar, { hasDot, ...vertical }),
              hasDot && (!hideHorizontal || !hideVertical) && /* @__PURE__ */ (0, import_jsx_runtime521.jsx)(Dot, { ...dot })
            ] })
          ]
        }
      ) });
    }
  ),
  { Scrollbar }
);
ScrollBox9.displayName = "ScrollBox";
ScrollBox9.__DEV_METADATA__ = { status: "IN_PROGRESS" };

// SearchBox/SearchBox.tsx
var import_uik705 = require("@appd/uik");
var import_react122 = require("react");

// SearchBox/getStyles.ts
var import_uik704 = require("@appd/uik");
var {
  COLORS: { CONTROL_BG_WEAK: CONTROL_BG_WEAK16, CONTROL_BORDER: CONTROL_BORDER18, CONTROL_BORDER_ACTIVE: CONTROL_BORDER_ACTIVE4, DEFAULT_TEXT: DEFAULT_TEXT26, DEFAULT_TEXT_WEAK: DEFAULT_TEXT_WEAK3 },
  EFFECTS: { SHADOW_FOCUS: SHADOW_FOCUS3 },
  RADIUS: RADIUS20,
  SPACING: SPACING38
} = import_uik704.MAGNETIC_TOKENS;
var getStyles31 = /* @__PURE__ */ __name((focused = false) => ({
  CLEAR_BUTTON: (0, import_uik704.css)({
    "& > svg": {
      height: 18,
      width: 18
    },
    backgroundColor: CONTROL_BG_WEAK16,
    borderRadius: 0,
    paddingRight: SPACING38[1]
  }),
  INPUT: (0, import_uik704.css)({
    "&::placeholder": { color: DEFAULT_TEXT_WEAK3 },
    backgroundColor: CONTROL_BG_WEAK16,
    border: "none",
    borderRadius: RADIUS20.HEAVY,
    boxSizing: "border-box",
    color: DEFAULT_TEXT26,
    height: HEIGHT2,
    outline: "none",
    overflow: "hidden",
    padding: `${SPACING38[1]}px 0px ${SPACING38[1]}px 0px`,
    textOverflow: "ellipsis",
    width: "100%"
  }),
  INPUT_CONTAINER: (0, import_uik704.css)({
    backgroundColor: CONTROL_BG_WEAK16,
    border: `2px solid ${CONTROL_BORDER18}`,
    borderRadius: RADIUS20.HEAVY,
    display: "flex",
    ...focused && {
      border: `2px solid ${CONTROL_BORDER_ACTIVE4}`,
      boxShadow: SHADOW_FOCUS3
    },
    alignItems: "center"
  }),
  SEARCH_ICON: (0, import_uik704.css)({
    backgroundColor: CONTROL_BG_WEAK16,
    borderRadius: RADIUS20.HEAVY,
    minWidth: 18,
    padding: `0px ${SPACING38[1]}px 0px ${SPACING38[3]}px`
  })
}), "getStyles");
var HEIGHT2 = 30;

// SearchBox/SearchBox.tsx
var import_jsx_runtime522 = require("react/jsx-runtime");
var SearchBox3 = Object.assign(
  import_uik705.utils.forwardRef(
    ({ className: className2, form = "", onChange, placeholder, value, ...props2 }, forwardedRef) => {
      const [focused, setFocused] = (0, import_react122.useState)(false);
      const [rawValue, setRawValue] = (0, import_react122.useState)("");
      value ??= rawValue;
      const { CLEAR_BUTTON, INPUT, INPUT_CONTAINER, SEARCH_ICON } = getStyles31(focused);
      return /* @__PURE__ */ (0, import_jsx_runtime522.jsxs)("div", { className: (0, import_uik705.css)(INPUT_CONTAINER, ...import_uik705.utils.many(className2)), uik: "SearchBox", children: [
        /* @__PURE__ */ (0, import_jsx_runtime522.jsx)(import_uik705.Icon.Action.Search, { className: SEARCH_ICON, size: "SMALL" }),
        /* @__PURE__ */ (0, import_jsx_runtime522.jsx)(
          "input",
          {
            autoComplete: "off",
            className: INPUT,
            form,
            onBlur: () => setFocused(false),
            onChange: (e) => {
              onChange?.(e.target.value);
              setRawValue(e.target.value);
            },
            onFocus: () => setFocused(true),
            placeholder: placeholder ?? import_uik705.Form.MESSAGES.SEARCH(),
            ref: forwardedRef,
            value,
            ...props2
          }
        ),
        value?.toString().length > 0 && /* @__PURE__ */ (0, import_jsx_runtime522.jsx)(
          import_uik705.Button,
          {
            className: CLEAR_BUTTON,
            icon: "Navigation.Close",
            onClick: () => {
              onChange?.("");
              setRawValue("");
            },
            type: "TERTIARY"
          }
        )
      ] });
    }
  )
);
SearchBox3.displayName = "SearchBox";
SearchBox3.__DEV_METADATA__ = { status: "READY" };

// Select/Select.tsx
var import_uik707 = require("@appd/uik");

// Select/Searchable/Searchable.tsx
var import_uik706 = require("@appd/uik");
var import_jsx_runtime523 = require("react/jsx-runtime");
var Searchable = import_uik706.utils.forwardRef(
  ({ children, placeholder = import_uik706.Form.MESSAGES.SELECT_PLACEHOLDER(), required = false, showClear = !required, ...props2 }, ref) => /* @__PURE__ */ (0, import_jsx_runtime523.jsx)(import_uik706.Input.CONTEXT.Provider, { value: false, children: /* @__PURE__ */ (0, import_jsx_runtime523.jsx)(
    import_uik706.Lookup,
    {
      placeholder,
      ref,
      required,
      searchable: true,
      showClear,
      uik: Searchable.displayName,
      ...props2,
      children
    }
  ) })
);
Searchable.displayName = "Select.Searchable";
Searchable.__DEV_METADATA__ = { status: "READY" };

// Select/Select.tsx
var import_jsx_runtime524 = require("react/jsx-runtime");
var Select3 = Object.assign(
  import_uik707.utils.forwardRef(
    ({ children, placeholder = import_uik707.Form.MESSAGES.SELECT_PLACEHOLDER(), required = false, showClear = !required, ...props2 }, ref) => /* @__PURE__ */ (0, import_jsx_runtime524.jsx)(import_uik707.Input.CONTEXT.Provider, { value: true, children: /* @__PURE__ */ (0, import_jsx_runtime524.jsx)(import_uik707.Lookup, { placeholder, ref, required, showClear, uik: "Select", ...props2, children }) })
  ),
  {
    Option: Object.assign(
      import_uik707.utils.forwardRef((props2, ref) => /* @__PURE__ */ (0, import_jsx_runtime524.jsx)(import_uik707.Lookup.Option, { ref, uik: "Select.Option", ...props2 })),
      { displayName: "Select.Option" }
    ),
    Searchable
  }
);
Select3.displayName = "Select";
Select3.__DEV_METADATA__ = { status: "READY" };

// SelectionTile/SelectionTile.tsx
var import_uik711 = require("@appd/uik");

// SelectionTile/Group/Group.tsx
var import_uik709 = require("@appd/uik");
var import_react123 = require("react");

// SelectionTile/Group/STYLES.ts
var import_uik708 = require("@appd/uik");
var {
  COLORS: {
    CONTROL_BG_WEAK: CONTROL_BG_WEAK17,
    CONTROL_BG_WEAK_ACTIVE: CONTROL_BG_WEAK_ACTIVE3,
    CONTROL_BORDER_WEAK: CONTROL_BORDER_WEAK19,
    CONTROL_BORDER_WEAK_ACTIVE: CONTROL_BORDER_WEAK_ACTIVE3,
    CONTROL_BORDER_WEAK_FOCUS: CONTROL_BORDER_WEAK_FOCUS3,
    CONTROL_BORDER_WEAK_HOVER: CONTROL_BORDER_WEAK_HOVER4,
    DEFAULT_TEXT: DEFAULT_TEXT27,
    DEFAULT_TEXT_DISABLED: DEFAULT_TEXT_DISABLED7,
    DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM18,
    DEFAULT_TEXT_MEDIUM_DISABLED: DEFAULT_TEXT_MEDIUM_DISABLED2,
    DEFAULT_TEXT_STRONG: DEFAULT_TEXT_STRONG8
  },
  PARTICLE: {
    EFFECTS: { SHADOW: SHADOW4 }
  },
  RADIUS: { HEAVY: RADIUS21 },
  SPACING: SPACING39
} = import_uik708.MAGNETIC_TOKENS;
var STYLES40 = {
  CHILDREN: (0, import_uik708.css)({
    display: "flex",
    flexDirection: "row",
    gap: SPACING39[2]
  }),
  HOST: ({ isDisabled, isSelected: isSelected2, title }) => (0, import_uik708.css)({
    border: `2px solid ${CONTROL_BORDER_WEAK19}`,
    borderRadius: RADIUS21,
    cursor: "pointer",
    display: "flex",
    flexBasis: 0,
    flexGrow: 1,
    flexShrink: 1,
    maxWidth: 448,
    minHeight: 80,
    minWidth: 180,
    outline: "none",
    padding: 0,
    ...{
      CUSTOM_CONTENT: { alignItems: "center" },
      HAS_TITLE: { flexDirection: "column" }
    }[title ? "HAS_TITLE" : "CUSTOM_CONTENT"],
    ...{
      DEFAULT: {
        ":focus-visible": {
          "> .children": {
            "> *": {
              color: DEFAULT_TEXT27,
              whiteSpace: "pre-wrap"
            }
          },
          "> .title": { color: DEFAULT_TEXT_STRONG8 },
          backgroundColor: CONTROL_BG_WEAK17,
          border: `${CONTROL_BORDER_WEAK_FOCUS3} 2px solid`,
          boxShadow: SHADOW4
        },
        ":hover": {
          "> .children": {
            "> *": {
              color: DEFAULT_TEXT27,
              whiteSpace: "pre-wrap"
            }
          },
          "> .title": { color: DEFAULT_TEXT_STRONG8 },
          backgroundColor: CONTROL_BG_WEAK17,
          border: `${CONTROL_BORDER_WEAK_HOVER4} 2px solid`,
          boxShadow: SHADOW4
        },
        "> .children": {
          "> *": {
            color: DEFAULT_TEXT_MEDIUM18,
            whiteSpace: "pre-wrap"
          }
        },
        "> .title": { color: DEFAULT_TEXT27 },
        backgroundColor: CONTROL_BG_WEAK17,
        boxShadow: SHADOW4
      },
      DISABLED: {
        "> .children": {
          "> *": {
            color: DEFAULT_TEXT_MEDIUM_DISABLED2,
            whiteSpace: "pre-wrap"
          }
        },
        "> .title": { color: DEFAULT_TEXT_DISABLED7 },
        backgroundColor: CONTROL_BG_WEAK17,
        boxShadow: SHADOW4,
        cursor: "not-allowed"
      },
      SELECTED: {
        ":focus-visible": { border: `${CONTROL_BORDER_WEAK_ACTIVE3} 2px solid` },
        "> .children": {
          "> *": {
            color: DEFAULT_TEXT27,
            whiteSpace: "pre-wrap"
          }
        },
        "> .title": { color: DEFAULT_TEXT_STRONG8 },
        backgroundColor: CONTROL_BG_WEAK_ACTIVE3,
        boxShadow: SHADOW4
      }
    }[isDisabled ? "DISABLED" : isSelected2 ? "SELECTED" : "DEFAULT"]
  })
};

// SelectionTile/Group/Group.tsx
var import_jsx_runtime525 = require("react/jsx-runtime");
var Group6 = import_uik709.utils.forwardRef(
  ({ children: rawChildren, className: className2, onSelectedChange, selected, ...props2 }, ref) => {
    const [rawSelected, setRawSelected] = (0, import_react123.useState)(-1);
    selected ??= rawSelected;
    const children = import_react123.Children.toArray(rawChildren).filter(import_react123.isValidElement).filter(({ type }) => type === SelectionTile).map((child, index) => {
      const isDisabled = child.props?.disabled ?? false;
      const isSelected2 = !isDisabled && index === selected;
      const title = child.props?.title;
      return (0, import_react123.cloneElement)(child, {
        className: (0, import_uik709.css)(
          HOST11({
            isDisabled,
            isSelected: isSelected2,
            title
          })
        ),
        onClick: () => {
          const updateSelectedIndex = index === selected ? -1 : index;
          !isDisabled && onSelectedChange?.(updateSelectedIndex);
          !isDisabled && setRawSelected(updateSelectedIndex);
        }
      });
    });
    return /* @__PURE__ */ (0, import_jsx_runtime525.jsx)("div", { className: (0, import_uik709.css)(CHILDREN, ...import_uik709.utils.many(className2)), ref, uik: "SelectionTile.Group", ...props2, children });
  }
);
Group6.displayName = "SelectionTile.Group";
var { CHILDREN, HOST: HOST11 } = STYLES40;

// SelectionTile/STYLES.ts
var import_uik710 = require("@appd/uik");
var {
  SPACING: SPACING40,
  TYPOGRAPHY: { ELLIPSES: ELLIPSES19, P3_EMPHASIS: P3_EMPHASIS9 }
} = import_uik710.MAGNETIC_TOKENS;
var STYLES41 = {
  BUTTON: (0, import_uik710.css)({ alignItems: "stretch" }),
  CHILDREN: ({ hasTitle = false }) => (0, import_uik710.css)({
    marginBottom: SPACING40[3],
    marginRight: SPACING40[4],
    // Don't trigger overflow in a flex container. (https://stackoverflow.com/a/66689926/3624264)
    minHeight: 0,
    ...{
      CUSTOM_CONTENT: {
        "> svg": { paddingRight: SPACING40[3] },
        alignItems: "center",
        display: "flex",
        flexDirection: "row",
        marginLeft: SPACING40[3],
        marginTop: SPACING40[3],
        // 448 - 12 - 16
        maxWidth: "420px",
        width: "100%"
      },
      HAS_TITLE: {
        marginLeft: SPACING40[4],
        marginTop: SPACING40[1],
        // 448 - 16
        maxWidth: "432px",
        textAlign: "left"
      }
    }[hasTitle ? "HAS_TITLE" : "CUSTOM_CONTENT"]
  }),
  TITLE: (0, import_uik710.css)({
    ...ELLIPSES19.END,
    // 448 - 16(SPACING[4]) * 2
    flexShrink: 0,
    font: P3_EMPHASIS9,
    maxWidth: 416,
    paddingLeft: SPACING40[4],
    paddingRight: SPACING40[4],
    paddingTop: SPACING40[3],
    textAlign: "left",
    width: "-webkit-fill-available"
  })
};

// SelectionTile/SelectionTile.tsx
var import_jsx_runtime526 = require("react/jsx-runtime");
var SelectionTile = Object.assign(
  import_uik711.utils.forwardRef(({ children, className: className2, title: rawTitle = null, ...props2 }, ref) => {
    const title = rawTitle && /* @__PURE__ */ (0, import_jsx_runtime526.jsx)(import_uik711.Tooltip, { showOnOverflowOnly: true, value: rawTitle, children: /* @__PURE__ */ (0, import_jsx_runtime526.jsx)("div", { className: (0, import_uik711.css)("title", TITLE3), children: rawTitle }) });
    return /* @__PURE__ */ (0, import_jsx_runtime526.jsxs)("button", { className: (0, import_uik711.css)(BUTTON2, ...import_uik711.utils.many(className2)), ref, type: "button", uik: "SelectionTile", ...props2, children: [
      title,
      /* @__PURE__ */ (0, import_jsx_runtime526.jsx)(import_uik711.ScrollBox, { className: (0, import_uik711.css)("children", CHILDREN2({ hasTitle: Boolean(title) })), children })
    ] });
  }),
  { Group: Group6 }
);
SelectionTile.displayName = "SelectionTile";
SelectionTile.__DEV_METADATA__ = { status: "READY" };
var { BUTTON: BUTTON2, CHILDREN: CHILDREN2, TITLE: TITLE3 } = STYLES41;

// Slider/Slider.tsx
var import_uik715 = require("@appd/uik");
var import_react125 = require("react");

// Slider/getStyles.ts
var import_uik712 = require("@appd/uik");
var {
  COLORS: { CONTROL_BG_STRONG: CONTROL_BG_STRONG7, CONTROL_BORDER_STRONG: CONTROL_BORDER_STRONG3, CONTROL_BORDER_WEAK: CONTROL_BORDER_WEAK20, DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM19, INVERSE_ICON_STRONG }
} = import_uik712.MAGNETIC_TOKENS;
var getStyles32 = /* @__PURE__ */ __name(({
  inPopover,
  showMaxInput = false,
  showMinInput = false,
  width
}) => ({
  BOTTOM_INPUT: { display: "flex", justifyContent: "space-between", marginTop: 12 },
  CONTROL: {
    backgroundColor: INVERSE_ICON_STRONG,
    border: `2px solid`,
    borderColor: CONTROL_BORDER_STRONG3,
    borderRadius: 16,
    boxSizing: "border-box",
    cursor: "pointer",
    height: width,
    maxHeight: width,
    maxWidth: width,
    position: "absolute",
    top: 2,
    transform: "translateX(-12px) translateY(-10px)",
    width
  },
  FILLED_TRACK: {
    backgroundColor: CONTROL_BG_STRONG7,
    borderRadius: 4,
    height: 8,
    position: "absolute",
    top: 0
  },
  HOST: { position: "relative" },
  LABEL: {},
  MAX_INPUT: {
    ...showMaxInput ? { maxWidth: 96 } : { display: "none" },
    ...inPopover && { marginLeft: "auto" }
  },
  MAX_LABEL: {
    alignContent: "center",
    color: DEFAULT_TEXT_MEDIUM19,
    fontSize: 14,
    marginLeft: "auto"
  },
  MIN_INPUT: {
    ...showMinInput ? { maxWidth: 96 } : { display: "none" },
    ...inPopover && { marginRight: "auto" }
  },
  MIN_LABEL: {
    alignContent: "center",
    color: DEFAULT_TEXT_MEDIUM19,
    fontSize: 14,
    marginRight: "auto"
  },
  SUB_LABELS: {
    display: "flex",
    marginTop: 8,
    position: "relative"
  },
  TRACK: {
    backgroundColor: CONTROL_BORDER_WEAK20,
    borderRadius: 4,
    height: 8,
    marginTop: 8,
    minWidth: 140,
    position: "relative",
    width: "100%"
  },
  TRACK_AND_INPUTS: {
    alignItems: "baseline",
    display: "flex",
    flexDirection: "row",
    gap: 16
  },
  TRACK_AND_LABELS: {
    display: "flex",
    flexDirection: "column",
    width: "-webkit-fill-available"
  }
}), "getStyles");

// Slider/Popover/Popover.tsx
var import_uik714 = require("@appd/uik");
var import_react124 = require("react");

// Slider/Popover/getStyles.ts
var import_uik713 = require("@appd/uik");
var OPTION_HEIGHT2 = 36;
var MAX_POPOVER_HEIGHT2 = 260;
var MAX_WIDTH2 = 800;
var getStyles33 = /* @__PURE__ */ __name((width, dropdownVisible) => ({
  BORDER: (0, import_uik713.css)({
    border: `2px solid ${CONTROL_BORDER19}`,
    borderRadius: RADIUS22.HEAVY,
    boxShadow: "none",
    boxSizing: "border-box",
    maxHeight: MAX_POPOVER_HEIGHT2,
    maxWidth: MAX_WIDTH2,
    minWidth: width,
    width
  }),
  BUTTON: (0, import_uik713.css)({
    "& > svg > path, & > svg > path[fill='#fff']": { fill: CONTROL_ICON_WEAK9 },
    ":hover": { backgroundColor: "transparent" },
    backgroundColor: "transparent",
    borderRadius: 0,
    height: OPTION_HEIGHT2,
    padding: 0
  }),
  CLOSE: (0, import_uik713.css)({
    "& > svg": {
      height: 16,
      width: 16
    },
    display: "flex",
    height: 36,
    marginRight: -SPACING41[1]
  }),
  INPUT: (0, import_uik713.css)({
    "& > div > input": dropdownVisible && {
      border: `2px solid ${CONTROL_BORDER_FOCUS3}`,
      boxShadow: SHADOW_FOCUS4
    }
  }),
  INPUT_ACTIONS: (0, import_uik713.css)({ display: "flex" }),
  MIN_MAX_INPUT: (0, import_uik713.css)({ display: "none" }),
  OPEN: (0, import_uik713.css)({ marginRight: SPACING41[1] }),
  POPOVER: (0, import_uik713.css)({
    borderRadius: RADIUS22.HEAVY,
    boxSizing: "border-box",
    marginBottom: SPACING41[2],
    marginTop: 6
  }),
  POPOVER_CONTENT: (0, import_uik713.css)({
    borderRadius: RADIUS22.HEAVY,
    boxShadow: "none",
    maxHeight: MAX_POPOVER_HEIGHT2,
    maxWidth: MAX_WIDTH2,
    minWidth: width,
    padding: 0,
    width
  }),
  SLIDER: (0, import_uik713.css)({ margin: 20 })
}), "getStyles");
var {
  COLORS: { CONTROL_BORDER: CONTROL_BORDER19, CONTROL_BORDER_FOCUS: CONTROL_BORDER_FOCUS3, CONTROL_ICON_WEAK: CONTROL_ICON_WEAK9 },
  EFFECTS: { SHADOW_FOCUS: SHADOW_FOCUS4 },
  RADIUS: RADIUS22,
  SPACING: SPACING41
} = import_uik713.MAGNETIC_TOKENS;

// Slider/Popover/Popover.tsx
var import_jsx_runtime527 = require("react/jsx-runtime");
var Popover8 = import_uik714.utils.forwardRef(
  ({
    className: className2,
    initialLower,
    initialUpper,
    invert = false,
    label,
    lower: rawlower,
    onChange,
    uik = "Slider.Popover",
    upper: rawupper,
    useInclusiveLabel = true,
    ...props2
  }, forwardedRef) => {
    const ref = import_uik714.utils.useBroadcastRef(forwardedRef);
    const actionsRef = (0, import_react124.useRef)(null);
    const inputRef = (0, import_react124.useRef)(null);
    const minInputRef = (0, import_react124.useRef)(null);
    const maxInputRef = (0, import_react124.useRef)(null);
    const [internallower, setInternallower] = (0, import_react124.useState)(initialLower);
    const [internalupper, setInternalupper] = (0, import_react124.useState)(initialUpper);
    const [dropdownVisible, setDropdownVisible] = (0, import_react124.useState)(false);
    const [width, setWidth] = (0, import_react124.useState)(0);
    const [inputText, setInputText] = (0, import_react124.useState)("");
    const lower = rawlower ?? internallower;
    const upper = rawupper ?? internalupper ?? 0;
    import_uik714.utils.useLayoutEffect(() => {
      setWidth(inputRef.current?.offsetWidth ?? 0);
    }, []);
    import_uik714.utils.useLayoutEffect(() => {
      setInputText(updateInputText(invert, useInclusiveLabel, lower, upper));
    }, [invert, useInclusiveLabel, lower, upper]);
    const onResize2 = (0, import_react124.useCallback)(() => {
      if (inputRef.current != null) {
        setWidth(inputRef.current?.offsetWidth ?? 0);
      }
    }, []);
    const { BORDER, BUTTON: BUTTON3, CLOSE: CLOSE3, INPUT, INPUT_ACTIONS, MIN_MAX_INPUT, OPEN, POPOVER: POPOVER2, POPOVER_CONTENT: POPOVER_CONTENT2, SLIDER } = getStyles33(width, dropdownVisible);
    return /* @__PURE__ */ (0, import_jsx_runtime527.jsx)(import_uik714.Measurer, { onResize: onResize2, children: /* @__PURE__ */ (0, import_jsx_runtime527.jsxs)("div", { className: (0, import_uik714.css)(...import_uik714.utils.many(className2)), uik, children: [
      /* @__PURE__ */ (0, import_jsx_runtime527.jsx)(
        import_uik714.Popover,
        {
          align: "START",
          arrow: false,
          className: POPOVER2,
          content: dropdownVisible && /* @__PURE__ */ (0, import_jsx_runtime527.jsx)("div", { className: (0, import_uik714.css)(BORDER), children: /* @__PURE__ */ (0, import_jsx_runtime527.jsx)(
            import_uik714.Slider,
            {
              className: SLIDER,
              inPopover: true,
              invert,
              lower,
              onChange: ({ lower: lower2, upper: upper2 }) => {
                onChange?.({
                  lower: lower2,
                  upper: upper2
                });
                rawlower && setInternallower(lower2);
                setInternalupper(upper2);
                if (minInputRef.current) {
                  minInputRef.current.value = String(invert ? upper2 : lower2);
                }
                if (maxInputRef.current) {
                  maxInputRef.current.value = String(invert ? void 0 : upper2);
                }
              },
              ref,
              upper,
              ...props2
            }
          ) }),
          contentClassName: POPOVER_CONTENT2,
          ignore: actionsRef,
          onVisibleChange: setDropdownVisible,
          position: "BOTTOM",
          stopPropagation: true,
          visible: dropdownVisible,
          children: /* @__PURE__ */ (0, import_jsx_runtime527.jsx)(
            import_uik714.Input,
            {
              actions: /* @__PURE__ */ (0, import_jsx_runtime527.jsxs)("div", { className: (0, import_uik714.css)(INPUT_ACTIONS), ref: actionsRef, children: [
                inputText && /* @__PURE__ */ (0, import_jsx_runtime527.jsx)(
                  import_uik714.Button,
                  {
                    className: (0, import_uik714.css)(BUTTON3, CLOSE3),
                    icon: "Action.Cancel",
                    onClick: () => {
                      onChange?.({
                        lower: initialLower,
                        upper: initialUpper ?? 0
                      });
                      rawlower && setInternallower(initialLower ?? 0);
                      setInternalupper(initialUpper ?? 0);
                      if (minInputRef.current) {
                        minInputRef.current.value = String(initialLower ?? void 0);
                      }
                      if (maxInputRef.current) {
                        maxInputRef.current.value = String(initialUpper ?? 0);
                      }
                      maxInputRef.current?._valueTracker?.setValue("");
                      maxInputRef.current?.dispatchEvent(new Event("change", { bubbles: true }));
                    },
                    type: "TERTIARY"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime527.jsx)(
                  import_uik714.Button,
                  {
                    className: (0, import_uik714.css)(BUTTON3, OPEN),
                    icon: "Navigation.ArrowDropDown",
                    onClick: (e) => {
                      e.stopPropagation();
                      setDropdownVisible((prevState) => !prevState);
                    },
                    type: "TERTIARY"
                  }
                )
              ] }),
              className: INPUT,
              form: "",
              label,
              onChange: import_uik714.utils.noop,
              onFocus: () => {
                setDropdownVisible(true);
              },
              placeholder: import_uik714.Form.MESSAGES.SLIDER_POPOVER_PLACEHOLDER(),
              readOnly: true,
              ref: inputRef,
              required: false,
              showOptional: false,
              tabIndex: -1,
              value: inputText
            }
          )
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime527.jsxs)(import_uik714.Form, { name: label, children: [
        /* @__PURE__ */ (0, import_jsx_runtime527.jsx)(
          import_uik714.Input,
          {
            className: MIN_MAX_INPUT,
            name: "min",
            ref: minInputRef,
            type: "number",
            value: invert ? upper : lower
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime527.jsx)(
          import_uik714.Input,
          {
            className: MIN_MAX_INPUT,
            name: "max",
            ref: maxInputRef,
            type: "number",
            value: invert ? void 0 : upper
          }
        )
      ] })
    ] }) });
  }
);
var updateInputText = /* @__PURE__ */ __name((invert, useInclusiveLabel, lower, upper) => {
  if (lower && upper) {
    return `${import_uik714.format.number.short(lower)} - ${import_uik714.format.number.short(upper)}`;
  }
  if (lower) {
    return useInclusiveLabel ? `>= ${import_uik714.format.number.short(lower)}` : `> ${import_uik714.format.number.short(lower)}`;
  }
  if (upper && invert) {
    return useInclusiveLabel ? `>= ${import_uik714.format.number.short(upper)}` : `> ${import_uik714.format.number.short(upper)}`;
  }
  if (upper) {
    return useInclusiveLabel ? `<= ${import_uik714.format.number.short(upper)}` : `< ${import_uik714.format.number.short(upper)}`;
  }
  return "";
}, "updateInputText");
Popover8.displayName = "Slider.Popover";
Popover8.__DEV_METADATA__ = { status: "IN_PROGRESS" };

// Slider/Slider.tsx
var import_jsx_runtime528 = require("react/jsx-runtime");
var Slider4 = Object.assign(
  import_uik715.utils.forwardRef(
    ({
      className: className2,
      inPopover = false,
      initialLower,
      initialUpper,
      invert = false,
      label,
      lower: rawlower,
      max: max2 = 100,
      min: min2 = 0,
      name = label,
      onChange: rawOnChange,
      showInput,
      upper: rawupper,
      ...props2
    }, forwardedRef) => {
      const [internallower, setInternallower] = (0, import_react125.useState)(initialLower);
      const [internalupper, setInternalupper] = (0, import_react125.useState)(initialUpper);
      const [lowerDragging, setLowerDragging] = (0, import_react125.useState)(false);
      const [upperDragging, setUpperDragging] = (0, import_react125.useState)(false);
      const minInputRef = (0, import_react125.useRef)(null);
      const maxInputRef = (0, import_react125.useRef)(null);
      const trackerRef = (0, import_react125.useRef)(null);
      const lower = rawlower ?? internallower;
      const upper = rawupper ?? internalupper ?? 0;
      const showMaxInput = showInput && !invert;
      const showMinInput = showInput && (rawlower != void 0 || initialLower != void 0 || invert);
      import_uik715.utils.ASSERT(max2 >= min2).else(Error("`max` must be greater than or equal to `min`."));
      import_uik715.utils.ASSERT(lower != void 0 ? upper >= lower : true).else(Error("`upper` must be greater than or equal to `lower`."));
      import_uik715.utils.ASSERT(upper >= min2 && upper <= max2).else(Error("`upper` must be within the `min`/`max` bounds."));
      import_uik715.utils.ASSERT(lower != void 0 ? lower >= min2 && lower <= max2 : true).else(Error("`lower` must be within the `min`/`max` bounds."));
      const {
        BOTTOM_INPUT,
        CONTROL,
        FILLED_TRACK,
        HOST: HOST14,
        LABEL: LABEL7,
        MAX_INPUT,
        MAX_LABEL,
        MIN_INPUT,
        MIN_LABEL,
        SUB_LABELS,
        TRACK,
        TRACK_AND_INPUTS,
        TRACK_AND_LABELS
      } = getStyles32({
        inPopover,
        showMaxInput,
        showMinInput,
        width: WIDTH
      });
      const ref = import_uik715.utils.useBroadcastRef(forwardedRef);
      const onMouseMove = (0, import_react125.useCallback)(
        (event) => {
          const width = trackerRef.current?.clientWidth;
          if (!width) {
            return;
          }
          const currentOffset = trackerRef.current?.getBoundingClientRect().left ?? 0;
          const newPosition = Math.min(Math.max(Math.floor((event.clientX - currentOffset) / width * max2), min2), max2);
          if (lowerDragging) {
            const newlower = Math.min(upper ?? 0, newPosition);
            onChange({
              newlower,
              newupper: upper
            });
          } else if (upperDragging) {
            const newupper = lower != void 0 ? Math.max(lower, newPosition) : newPosition;
            onChange({
              newlower: lower,
              newupper
            });
          }
        },
        [ref, lowerDragging, upperDragging]
      );
      const onMouseDown = (0, import_react125.useCallback)(
        (event) => {
          const width = trackerRef.current?.clientWidth;
          if (!width) {
            return;
          }
          const currentOffset = trackerRef.current?.getBoundingClientRect().left ?? 0;
          const newPosition = Math.min(Math.max(Math.floor((event.clientX - currentOffset) / width * max2), min2), max2);
          if (rawlower != void 0 || initialLower != void 0) {
            const distanceToLowerControl = Math.abs(newPosition - (lower ?? 0));
            const distanceToUpperControl = Math.abs(newPosition - upper);
            if (distanceToLowerControl < distanceToUpperControl) {
              onChange({
                newlower: newPosition,
                newupper: upper
              });
              return;
            }
          }
          onChange({
            newlower: lower,
            newupper: newPosition
          });
        },
        [ref, lower, upper]
      );
      const onChange = /* @__PURE__ */ __name(({ newlower, newupper }) => {
        rawOnChange?.({
          lower: newlower,
          upper: newupper
        });
        setInternallower(newlower);
        setInternalupper(newupper);
      }, "onChange");
      (0, import_react125.useEffect)(() => {
        import_uik715.utils.addEventListener(document.body, "mouseup", () => {
          setLowerDragging((lowerDragging2) => {
            if (lowerDragging2) {
              minInputRef.current?._valueTracker?.setValue("");
              minInputRef.current?.dispatchEvent(new Event("change", { bubbles: true }));
            }
            return false;
          });
          setUpperDragging((upperDragging2) => {
            if (upperDragging2) {
              if (invert) {
                minInputRef.current?._valueTracker?.setValue("");
                minInputRef.current?.dispatchEvent(new Event("change", { bubbles: true }));
              } else {
                maxInputRef.current?._valueTracker?.setValue("");
                maxInputRef.current?.dispatchEvent(new Event("change", { bubbles: true }));
              }
            }
            return false;
          });
        });
      }, []);
      const minInput = /* @__PURE__ */ (0, import_jsx_runtime528.jsx)(
        import_uik715.Input,
        {
          className: MIN_INPUT,
          max: invert ? max2 : upper,
          min: min2,
          name: "min",
          onChange: ({ target: { value } }) => {
            if (invert) {
              const newupper = Number(value);
              if (newupper < min2 || newupper > max2) {
                return;
              }
              onChange({
                newlower: lower,
                newupper
              });
            } else {
              const newlower = Number(value);
              if (newlower > upper || newlower > max2 || newlower < min2) {
                return;
              }
              onChange({
                newlower,
                newupper: upper
              });
            }
          },
          ref: minInputRef,
          step: "any",
          type: "number",
          value: invert ? (
            // `.toString()` is for removing leading 0
            upper.toString()
          ) : rawlower != void 0 || initialLower != void 0 ? lower?.toString() ?? 0 : void 0
        }
      );
      const maxInput = /* @__PURE__ */ (0, import_jsx_runtime528.jsx)(
        import_uik715.Input,
        {
          className: MAX_INPUT,
          max: max2,
          min: lower ?? min2,
          name: "max",
          onChange: ({ target: { value } }) => {
            const newupper = Number(value);
            if (lower && newupper < lower || newupper > max2 || newupper < min2) {
              return;
            }
            onChange({
              newlower: lower,
              newupper
            });
          },
          ref: maxInputRef,
          step: "any",
          type: "number",
          value: invert ? void 0 : upper.toString()
        }
      );
      const minMaxLabels = /* @__PURE__ */ (0, import_jsx_runtime528.jsxs)("div", { className: (0, import_uik715.css)(SUB_LABELS), children: [
        /* @__PURE__ */ (0, import_jsx_runtime528.jsx)("div", { className: (0, import_uik715.css)(MIN_LABEL), children: import_uik715.format.number.short(min2) }),
        /* @__PURE__ */ (0, import_jsx_runtime528.jsx)("div", { className: (0, import_uik715.css)(MAX_LABEL), children: import_uik715.format.number.short(max2) })
      ] });
      return /* @__PURE__ */ (0, import_jsx_runtime528.jsx)("div", { className: (0, import_uik715.css)(HOST14, ...import_uik715.utils.many(className2)), ref, uik: Slider4.displayName, ...props2, children: upper != void 0 && /* @__PURE__ */ (0, import_jsx_runtime528.jsxs)(import_uik715.Form, { name, children: [
        /* @__PURE__ */ (0, import_jsx_runtime528.jsx)(import_uik715.Form.Label, { className: (0, import_uik715.css)(LABEL7), label, showOptional: false }),
        /* @__PURE__ */ (0, import_jsx_runtime528.jsxs)("div", { className: (0, import_uik715.css)(TRACK_AND_INPUTS), children: [
          !inPopover && minInput,
          /* @__PURE__ */ (0, import_jsx_runtime528.jsxs)("div", { className: (0, import_uik715.css)(TRACK_AND_LABELS), children: [
            /* @__PURE__ */ (0, import_jsx_runtime528.jsxs)("div", { className: (0, import_uik715.css)(TRACK), onMouseDown, onMouseMove, ref: trackerRef, children: [
              /* @__PURE__ */ (0, import_jsx_runtime528.jsx)(
                "div",
                {
                  className: (0, import_uik715.css)(FILLED_TRACK),
                  style: {
                    left: invert ? `calc(${upper / max2 * 100}%)` : lower ? `calc(${lower / max2 * 100}%)` : 0,
                    width: invert ? `calc(${(max2 - (upper ?? 0)) / max2 * 100}%)` : `calc(${((upper ?? 0) - (lower ? lower : 0)) / max2 * 100}%)`
                  }
                }
              ),
              (rawlower != void 0 || initialLower != void 0) && /* @__PURE__ */ (0, import_jsx_runtime528.jsx)(import_uik715.Tooltip, { position: "TOP", value: import_uik715.format.number.short(lower ?? 0), children: /* @__PURE__ */ (0, import_jsx_runtime528.jsx)(
                "div",
                {
                  className: (0, import_uik715.css)(CONTROL),
                  onMouseDown: (e) => {
                    e.preventDefault();
                    setLowerDragging(true);
                  },
                  style: { left: `calc(${(lower ?? 0) / (max2 > 0 ? max2 : 1) * 100}%)` }
                }
              ) }),
              /* @__PURE__ */ (0, import_jsx_runtime528.jsx)(import_uik715.Tooltip, { position: "TOP", value: import_uik715.format.number.short(upper), children: /* @__PURE__ */ (0, import_jsx_runtime528.jsx)(
                "div",
                {
                  className: (0, import_uik715.css)(CONTROL),
                  onMouseDown: (e) => {
                    e.preventDefault();
                    setUpperDragging(true);
                  },
                  style: { left: `calc(${(upper ?? 0) / (max2 > 0 ? max2 : 1) * 100}%)` }
                }
              ) })
            ] }),
            minMaxLabels
          ] }),
          !inPopover && maxInput
        ] }),
        showInput && inPopover && /* @__PURE__ */ (0, import_jsx_runtime528.jsxs)("div", { className: (0, import_uik715.css)(BOTTOM_INPUT), children: [
          !showMinInput && /* @__PURE__ */ (0, import_jsx_runtime528.jsx)("div", { className: (0, import_uik715.css)(MIN_LABEL), children: "Min" }),
          minInput,
          /* @__PURE__ */ (0, import_jsx_runtime528.jsx)("div", { className: (0, import_uik715.css)({ alignSelf: "center" }), children: "-" }),
          maxInput,
          !showMaxInput && /* @__PURE__ */ (0, import_jsx_runtime528.jsx)("div", { className: (0, import_uik715.css)(MAX_LABEL), children: "Max" })
        ] })
      ] }) });
    }
  ),
  { Popover: Popover8 }
);
Slider4.displayName = "Slider";
Slider4.__DEV_METADATA__ = { status: "READY" };
var WIDTH = 24;

// SparkGraph/SparkGraph.tsx
var import_uik717 = require("@appd/uik");

// SparkGraph/useTooltip.tsx
var import_uik716 = require("@appd/uik");
var import_react126 = require("react");
var import_jsx_runtime529 = require("react/jsx-runtime");
var useTooltip3 = /* @__PURE__ */ __name(({
  component,
  format: format35 = import_uik716.utils.identity,
  showSeriesName = false
} = {}) => (0, import_react126.useCallback)(
  ({
    points,
    series
  }) => component ? (0, import_react126.createElement)(component, {
    points,
    series: series.map(({ color: color2, name, shape }) => ({
      color: color2,
      name,
      shape
    }))
  }) : /* @__PURE__ */ (0, import_jsx_runtime529.jsx)("div", { className: HOST12, children: points.map(({ seriesIndex, y }, index) => {
    const { name } = series[seriesIndex];
    return /* @__PURE__ */ (0, import_jsx_runtime529.jsxs)("div", { className: (0, import_uik716.css)(ROW2, index === 0 && { marginTop: 0 }), children: [
      showSeriesName && /* @__PURE__ */ (0, import_jsx_runtime529.jsx)("div", { className: NAME2, children: name }),
      /* @__PURE__ */ (0, import_jsx_runtime529.jsx)("div", { className: (0, import_uik716.css)(VALUE2, !showSeriesName && { marginLeft: 0 }), children: format35(y) })
    ] }, seriesIndex);
  }) }),
  [format35, showSeriesName]
), "useTooltip");
var {
  COLORS: { CONTROL_BG_WEAK: CONTROL_BG_WEAK18, DEFAULT_TEXT: DEFAULT_TEXT28 },
  FONT: FONT3,
  SPACING: SPACING42
} = import_uik716.MAGNETIC_TOKENS;
var { HOST: HOST12, NAME: NAME2, ROW: ROW2, VALUE: VALUE2 } = {
  HOST: (0, import_uik716.css)({
    backgroundColor: CONTROL_BG_WEAK18,
    padding: SPACING42[3]
  }),
  NAME: (0, import_uik716.css)({
    color: DEFAULT_TEXT28,
    flexGrow: 1,
    flexShrink: 1,
    fontFamily: FONT3.INTER[400].fontFamily,
    fontSize: "11px",
    overflowWrap: "anywhere"
  }),
  ROW: (0, import_uik716.css)({
    display: "flex",
    marginTop: SPACING42[2]
  }),
  VALUE: (0, import_uik716.css)({
    color: DEFAULT_TEXT28,
    flexShrink: 0,
    fontFamily: FONT3.INTER[400].fontFamily,
    fontSize: "11px",
    marginLeft: SPACING42[3]
  })
};

// SparkGraph/SparkGraph.tsx
var import_jsx_runtime530 = require("react/jsx-runtime");
var { Area: Area3, Column: Column3, Line: Line3 } = import_uik717.Cartesian;
var SparkGraph = import_uik717.utils.forwardRef(
  ({
    baseline,
    colors = [ACCENT_A3, ACCENT_B3, ACCENT_C3],
    column,
    series = [],
    stacking,
    threshold,
    tooltip,
    type = "AREA",
    xAxis,
    yAxis,
    ...props2
  }, ref) => /* @__PURE__ */ (0, import_jsx_runtime530.jsxs)(
    import_uik717.Cartesian,
    {
      animation: false,
      colors,
      column,
      noDataIllustration: /* @__PURE__ */ (0, import_jsx_runtime530.jsx)(import_uik717.Illustration, { primary: `\u2014` }),
      ref,
      stacking,
      tooltipComponent: useTooltip3(tooltip),
      uik: "SparkGraph",
      xAxis: {
        ...xAxis,
        ...{
          formatter: (val) => val,
          visible: false
        }
      },
      yAxis: {
        ...yAxis,
        gridLineColor: "transparent",
        labels: { enabled: false },
        visible: true
      },
      ...props2,
      children: [
        type == "AREA" && series.map((series2, index) => /* @__PURE__ */ (0, import_jsx_runtime530.jsx)(
          Area3,
          {
            data: series2.data,
            fillColor: {
              linearGradient: {
                x1: 0,
                x2: 0,
                y1: 0,
                y2: 1
              },
              stops: [
                [0, "rgba(48,106,207, 0.2)"],
                [1, "rgba(108, 158, 245, 0.01)"]
              ]
            },
            marker: {
              enabled: series2.data.length === 1,
              fillColor: ACCENT_A3,
              lineColor: CONTROL_BORDER_WEAK21,
              lineWidth: 1,
              radius: 3
            },
            name: series2.name,
            states: {
              hover: {
                halo: {
                  opacity: 0.35,
                  size: 11
                },
                lineWidth: 3
              },
              inactive: { opacity: 1 }
            }
          },
          `Area${index}`
        )),
        type == "COLUMN" && series.map((series2, index) => /* @__PURE__ */ (0, import_jsx_runtime530.jsx)(Column3, { data: series2.data, name: series2.name, stack: series2.stack }, `Area${index}`)),
        baseline && /* @__PURE__ */ (0, import_jsx_runtime530.jsx)(
          Line3,
          {
            dashStyle: "Dash",
            data: baseline,
            marker: {
              enabled: false,
              states: { hover: { enabled: false } }
            },
            name: "Baseline"
          }
        ),
        threshold && /* @__PURE__ */ (0, import_jsx_runtime530.jsx)(Line3, { threshold })
      ]
    }
  )
);
SparkGraph.displayName = "SparkGraph";
SparkGraph.__DEV_METADATA__ = { status: "READY" };
var {
  COLORS: { ACCENT_A: ACCENT_A3, ACCENT_B: ACCENT_B3, ACCENT_C: ACCENT_C3, CONTROL_BORDER_WEAK: CONTROL_BORDER_WEAK21 }
} = import_uik717.MAGNETIC_TOKENS;

// Spinner/Spinner.tsx
var import_uik719 = require("@appd/uik");

// Spinner/getStyles.ts
var import_uik718 = require("@appd/uik");
var {
  COLORS: { DEFAULT_TEXT: DEFAULT_TEXT29, INTERACT_ICON_WEAK: INTERACT_ICON_WEAK9 }
} = import_uik718.MAGNETIC_TOKENS;
var STYLES42 = {
  CONTAINER: (size) => (0, import_uik718.css)({
    alignContent: "center",
    alignItems: "center",
    display: "flex",
    flexDirection: size === "SMALL" ? "row" : "column"
  }),
  DESCRIPTION: (0, import_uik718.css)({
    color: DEFAULT_TEXT29,
    fontFamily: "Inter",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "15px"
  }),
  SPINNER_CONTAINER: (size) => {
    const diameter = size === "XLARGE" ? 72 : size === "LARGE" ? 48 : size === "MEDIUM" ? 36 : 20;
    return (0, import_uik718.css)({
      height: diameter,
      marginBottom: size === "SMALL" ? 0 : 8,
      marginRight: size === "SMALL" ? 4 : 0,
      maxHeight: diameter,
      maxWidth: diameter,
      minHeight: diameter,
      minWidth: diameter,
      overflow: "hidden",
      position: "relative",
      widht: diameter
    });
  },
  SPINNER_ELEMENT: () => (0, import_uik718.css)({
    animationDuration: "1s",
    animationIterationCount: "infinite",
    animationName: {
      from: { transform: "rotate(0)" },
      to: { transform: "rotate(360deg)" }
    },
    animationTimingFunction: "linear",
    fill: INTERACT_ICON_WEAK9,
    minHeight: "100%",
    minWidth: "100%"
  })
};

// Spinner/Spinner.tsx
var import_jsx_runtime531 = require("react/jsx-runtime");
var Spinner = import_uik719.utils.forwardRef(
  ({ className: className2, description, size = "SMALL", ...inherited }, ref) => /* @__PURE__ */ (0, import_jsx_runtime531.jsxs)("div", { className: (0, import_uik719.css)(CONTAINER6(size), ...import_uik719.utils.many(className2)), ref, uik: "Spinner", ...inherited, children: [
    /* @__PURE__ */ (0, import_jsx_runtime531.jsx)("div", { className: SPINNER_CONTAINER(size), children: /* @__PURE__ */ (0, import_jsx_runtime531.jsx)("svg", { className: SPINNER_ELEMENT(), fill: "none", viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ (0, import_jsx_runtime531.jsx)(
      "path",
      {
        clipRule: "evenodd",
        d: "M25.761 5.837a3 3 0 0 1 3.674-2.121c11.203 3.001 17.851 14.516 14.85 25.72a3 3 0 1 1-5.796-1.554c2.144-8.002-2.604-16.227-10.606-18.37a3 3 0 0 1-2.122-3.675Z",
        fill: "var(--mds-spinner-fill)",
        fillRule: "evenodd"
      }
    ) }) }),
    /* @__PURE__ */ (0, import_jsx_runtime531.jsx)("div", { className: DESCRIPTION2, children: description })
  ] })
);
Spinner.displayName = "Spinner";
Spinner.__DEV_METADATA__ = { status: "READY" };
var { CONTAINER: CONTAINER6, DESCRIPTION: DESCRIPTION2, SPINNER_CONTAINER, SPINNER_ELEMENT } = STYLES42;

// TabList/TabList.tsx
var import_uik723 = require("@appd/uik");
var import_react128 = require("react");

// TabList/getStyles.ts
var import_uik720 = require("@appd/uik");
var getStyles34 = /* @__PURE__ */ __name(({
  kind,
  more,
  position,
  selected,
  size,
  vertical
}) => ({
  ADD: (0, import_uik720.css)({
    "& > svg": {
      "& > path, & > path[fill='#fff']": { fill: INTERACT_TEXT_WEAK },
      marginBottom: 2
    },
    ":hover": {
      "& > svg > path, & > svg > path[fill='#fff']": { fill: INTERACT_TEXT_WEAK_HOVER },
      backgroundColor: "transparent",
      color: INTERACT_TEXT_WEAK_HOVER
    },
    ...vertical ? {
      height: 36,
      marginLeft: -SPACING43[1],
      minHeight: 36
    } : { marginLeft: 0 },
    color: INTERACT_TEXT_WEAK,
    marginRight: vertical && SPACING43[1],
    outline: "none",
    padding: SPACING43[1],
    paddingLeft: 0,
    width: "fit-content"
  }),
  HOST: (0, import_uik720.css)({
    ...vertical ? {
      alignItems: "flex-start",
      flexDirection: "column",
      overflowY: "auto",
      width: 203
    } : {
      alignItems: "center",
      flexDirection: "row",
      height: "fit-content",
      minHeight: kind === "PRIMARY" ? 38 : 36,
      overflowX: "auto",
      vertical: 32
    },
    display: "flex",
    position: "relative"
  }),
  INDICATOR: (0, import_uik720.css)({
    ...vertical ? {
      height: size,
      right: 0,
      top: position,
      width: 3
    } : {
      bottom: 0,
      height: 3,
      left: position,
      width: size
    },
    backgroundColor: kind === "PRIMARY" ? ACCENT_D3 : INTERACT_BORDER_MEDIUM_ACTIVE,
    display: more > 0 && selected >= more ? "none" : "block",
    position: "absolute",
    zIndex: 1,
    ...!import_uik720.utils.PREFERS_REDUCED_MOTION && { transition: ".1s all ease-in" }
  }),
  INDICATOR_BAR: (0, import_uik720.css)({
    ...vertical ? {
      height: "100%",
      right: 0,
      top: 0,
      width: 3
    } : {
      bottom: 0,
      height: 3,
      left: 0,
      width: "100%"
    },
    backgroundColor: kind === "PRIMARY" ? void 0 : INTERACT_BORDER_WEAK2,
    position: "absolute"
  }),
  MORE: (0, import_uik720.css)({
    "& > svg > path[fill='#fff']": { fill: INTERACT_TEXT_WEAK },
    ":hover": { backgroundColor: "transparent" },
    color: INTERACT_TEXT_WEAK,
    font: kind === "PRIMARY" ? P2_EMPHASIS : P3_EMPHASIS10,
    paddingLeft: 0
  })
}), "getStyles");
var {
  COLORS: {
    ACCENT_D: ACCENT_D3,
    INTERACT_BORDER_MEDIUM_ACTIVE,
    INTERACT_BORDER_WEAK: INTERACT_BORDER_WEAK2,
    INTERACT_TEXT_WEAK,
    INTERACT_TEXT_WEAK_HOVER
  },
  SPACING: SPACING43,
  TYPOGRAPHY: { P2_EMPHASIS, P3_EMPHASIS: P3_EMPHASIS10 }
} = import_uik720.MAGNETIC_TOKENS;

// TabList/MESSAGES.ts
var MESSAGES19 = {
  ADD_TAB: format.message`Add Tab`.description("A button to add an addtional Tab to a list of Tabs."),
  MORE: format.message`More`.description("A button to open a dropdown of additional Tabs"),
  NEW: format.message`New`.description("A flag on a new Tab")
};

// TabList/Tab/Tab.tsx
var import_uik722 = require("@appd/uik");
var import_react127 = require("react");

// TabList/Tab/getStyles.ts
var import_uik721 = require("@appd/uik");
var getStyles35 = /* @__PURE__ */ __name(({
  disabled,
  kind,
  selected,
  vertical
}) => ({
  CLOSE: (0, import_uik721.css)({
    ":hover": { backgroundColor: INTERACT_BG_WEAK_HOVER2 },
    ...vertical ? {
      marginLeft: "auto",
      marginRight: SPACING44[4]
    } : {},
    width: 18
  }),
  HOST: (0, import_uik721.css)({
    "& .label": { ...ELLIPSES20.END },
    backgroundColor: "transparent",
    borderRadius: 4,
    color: selected ? kind === "PRIMARY" ? DEFAULT_TEXT30 : INTERACT_TEXT_WEAK_ACTIVE : kind === "PRIMARY" ? DEFAULT_TEXT_MEDIUM20 : INTERACT_TEXT_WEAK2,
    cursor: "pointer",
    display: "flex",
    flex: "0 0 auto",
    font: selected ? kind === "PRIMARY" ? P2_BOLD2 : P3_BOLD3 : kind === "PRIMARY" ? P2_EMPHASIS2 : P3_EMPHASIS11,
    gap: 8,
    maxWidth: 250,
    position: "relative",
    ...vertical ? {
      alignItems: "center",
      height: 36,
      justifyContent: "flex-start",
      marginBottom: SPACING44[2],
      width: "inherit"
    } : {
      marginRight: kind === "PRIMARY" ? 32 : SPACING44[6],
      paddingBlock: 10,
      paddingInline: 0,
      width: "fit-content"
    },
    ...!disabled ? {
      ":focus-visible": {
        backgroundColor: INTERACT_BG_WEAK_ACTIVE2,
        outline: "none"
      },
      ":hover": {
        backgroundColor: "transparent",
        color: kind === "PRIMARY" ? DEFAULT_TEXT30 : INTERACT_TEXT_WEAK_ACTIVE
      }
    } : {
      color: INTERACT_TEXT_WEAK_DISABLED,
      cursor: "not-allowed"
    }
  }),
  ICON: (0, import_uik721.css)({
    "& > path[fill='#fff']:first-child, & > path:first-child": {
      ...disabled ? { fill: INTERACT_TEXT_WEAK_DISABLED } : {}
    },
    borderRadius: RADIUS23.DEFAULT,
    marginLeft: -2,
    marginTop: kind === "PRIMARY" ? 2 : 1,
    width: 18
  }),
  ICON_RIGHT: (0, import_uik721.css)({
    ...vertical ? {
      marginLeft: "auto",
      marginRight: SPACING44[4]
    } : { marginRight: -2 }
  }),
  NEW: (0, import_uik721.css)({
    backgroundColor: ACCENT_A_WEAK,
    marginTop: kind === "PRIMARY" ? 2 : 1
  })
}), "getStyles");
var {
  COLORS: {
    ACCENT_A_WEAK,
    DEFAULT_TEXT: DEFAULT_TEXT30,
    DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM20,
    INTERACT_BG_WEAK_ACTIVE: INTERACT_BG_WEAK_ACTIVE2,
    INTERACT_BG_WEAK_HOVER: INTERACT_BG_WEAK_HOVER2,
    INTERACT_TEXT_WEAK: INTERACT_TEXT_WEAK2,
    INTERACT_TEXT_WEAK_ACTIVE,
    INTERACT_TEXT_WEAK_DISABLED
  },
  RADIUS: RADIUS23,
  SPACING: SPACING44,
  TYPOGRAPHY: { ELLIPSES: ELLIPSES20, P2_BOLD: P2_BOLD2, P2_EMPHASIS: P2_EMPHASIS2, P3_BOLD: P3_BOLD3, P3_EMPHASIS: P3_EMPHASIS11 }
} = import_uik721.MAGNETIC_TOKENS;

// TabList/Tab/Tab.tsx
var import_jsx_runtime532 = require("react/jsx-runtime");
var Tab = import_uik722.utils.forwardRef(
  ({
    actionable,
    className: className2,
    count,
    disabled,
    iconLeft,
    iconRight,
    isNew,
    kind,
    name,
    onRemove,
    selected,
    vertical,
    ...props2
  }, forwardedRef) => {
    const ref = import_uik722.utils.useBroadcastRef(forwardedRef);
    const { CLOSE: CLOSE3, HOST: HOST14, ICON: ICON4, ICON_RIGHT, NEW } = getStyles35({
      disabled,
      kind,
      selected,
      vertical
    });
    const childArray = import_react127.Children.toArray(name);
    const newChildren = childArray != void 0 && childArray.length === 1 && typeof childArray[0] === "string" ? /* @__PURE__ */ (0, import_jsx_runtime532.jsx)(import_uik722.Tooltip, { showOnOverflowOnly: true, value: childArray[0], children: /* @__PURE__ */ (0, import_jsx_runtime532.jsx)("span", { className: "label", children: childArray[0] }) }) : name;
    return /* @__PURE__ */ (0, import_jsx_runtime532.jsx)(import_jsx_runtime532.Fragment, { children: /* @__PURE__ */ (0, import_jsx_runtime532.jsxs)(
      "li",
      {
        "aria-disabled": disabled,
        "aria-selected": selected,
        className: (0, import_uik722.css)(HOST14, ...import_uik722.utils.many(className2)),
        ref,
        role: "tab",
        tabIndex: disabled ? -1 : 0,
        type: "MENU_ITEM",
        uik: "TabList.Tab",
        ...props2,
        children: [
          iconLeft && /* @__PURE__ */ (0, import_jsx_runtime532.jsx)(import_uik722.Icon, { className: (0, import_uik722.css)(ICON4), size: "SMALL", type: iconLeft }),
          newChildren,
          isNew && /* @__PURE__ */ (0, import_jsx_runtime532.jsx)(import_uik722.Tag, { className: (0, import_uik722.css)(NEW), size: "SMALL", children: MESSAGES19.NEW() }),
          iconRight && /* @__PURE__ */ (0, import_jsx_runtime532.jsx)(import_uik722.Icon, { className: (0, import_uik722.css)(ICON4, ICON_RIGHT), size: "SMALL", type: iconRight }),
          !iconRight && count && /* @__PURE__ */ (0, import_jsx_runtime532.jsx)(import_uik722.Tag, { className: (0, import_uik722.css)(ICON_RIGHT), size: "SMALL", children: count }),
          actionable && /* @__PURE__ */ (0, import_jsx_runtime532.jsx)(
            import_uik722.Icon,
            {
              className: (0, import_uik722.css)(CLOSE3),
              onClick: (e) => {
                e.stopPropagation();
                onRemove?.();
              },
              type: "Action.Disable"
            }
          )
        ]
      }
    ) });
  }
);
Tab.displayName = "TabList.Tab";

// TabList/TabList.tsx
var import_jsx_runtime533 = require("react/jsx-runtime");
var TabList = import_uik723.utils.forwardRef(
  ({
    actionable = false,
    addTitle = MESSAGES19.ADD_TAB(),
    children,
    className: className2,
    disabled,
    kind: rawKind,
    more = -1,
    onAdd,
    onRemove,
    onSelectedChange,
    selected = 0,
    tabs: rawTabs = [],
    vertical = false,
    ...props2
  }, forwardedRef) => {
    const [indicatorPosition, setIndicatorPosition] = (0, import_react128.useState)(0);
    const [indicatorSize, setIndicatorSize] = (0, import_react128.useState)(0);
    const ref = import_uik723.utils.useBroadcastRef(forwardedRef);
    const kind = vertical ? "SECONDARY" : rawKind != void 0 ? rawKind : "PRIMARY";
    const { ADD: ADD2, HOST: HOST14, INDICATOR, INDICATOR_BAR, MORE } = getStyles34({
      kind,
      more,
      position: indicatorPosition,
      selected,
      size: indicatorSize,
      vertical
    });
    const onKeyDown = /* @__PURE__ */ __name((event) => {
      const key = event.key;
      const currentFocus = document.activeElement;
      if (key === "Tab" && event.shiftKey) {
        const previousElement = currentFocus.previousElementSibling;
        if (!isTabbable(ref, previousElement)) {
          return;
        }
        event.preventDefault();
        previousElement?.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "start"
        });
        previousElement?.click();
        setTimeout(() => {
          previousElement?.focus();
        });
      } else if (key === "Tab") {
        const nextElement = currentFocus.nextElementSibling;
        if (!isTabbable(ref, nextElement) || nextElement?.getAttribute("uik") === "TabList.INDICATOR") {
          return;
        }
        event.preventDefault();
        nextElement?.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "start"
        });
        if (nextElement?.getAttribute("uik") === "Button") {
          setTimeout(() => {
            nextElement?.focus();
          });
          return;
        }
        nextElement?.click();
        setTimeout(() => {
          nextElement?.focus();
        });
      }
    }, "onKeyDown");
    const getTab = /* @__PURE__ */ __name(({
      count,
      iconLeft,
      iconRight,
      index,
      isNew,
      length,
      name
    }) => /* @__PURE__ */ (0, import_jsx_runtime533.jsx)(
      Tab,
      {
        actionable,
        count,
        disabled: disabled?.includes(index),
        iconLeft,
        iconRight,
        isNew,
        kind,
        name,
        onClick: (event) => {
          disabled?.includes(index) ? event.preventDefault() : onSelectedChange(index);
        },
        onKeyDown,
        onRemove: () => {
          const maxIndex = length - 2;
          onRemove?.(index);
          selected > maxIndex && onSelectedChange(import_uik723.utils.clamp(maxIndex, [-1, Infinity]));
        },
        selected: index === selected,
        vertical
      },
      index
    ), "getTab");
    const tabs = rawTabs.length > 0 ? rawTabs.map(
      (tab, index, tabs2) => getTab({
        index,
        length: tabs2.length,
        name: tab.name,
        ...tab
      })
    ) : (
      /** @deprecated*/
      import_react128.Children.toArray(children).map(
        (child, index, tabs2) => getTab({
          index,
          length: tabs2.length,
          name: child
        })
      )
    );
    import_uik723.utils.useFontsReady(() => {
      if (!ref.current) {
        return;
      }
      const selectedHeader = ref.current.children[selected];
      if (selectedHeader) {
        setIndicatorPosition(vertical ? selectedHeader.offsetTop ?? 0 : selectedHeader.offsetLeft ?? 0);
        setIndicatorSize(vertical ? selectedHeader.offsetHeight ?? 0 : selectedHeader.offsetWidth ?? 0);
      }
    }, [ref.current, kind, more, selected, vertical]);
    if (!actionable && (tabs == null || tabs.length === 0 || selected == null || selected > tabs.length)) {
      return /* @__PURE__ */ (0, import_jsx_runtime533.jsx)(import_uik723.ScrollBox, { className: (0, import_uik723.css)(HOST14, ...import_uik723.utils.many(className2)), ref, uik: "TabList", ...props2 });
    }
    return /* @__PURE__ */ (0, import_jsx_runtime533.jsxs)(
      import_uik723.ScrollBox,
      {
        className: (0, import_uik723.css)(HOST14, ...import_uik723.utils.many(className2)),
        containOverlays: false,
        hideHorizontal: true,
        hideVertical: true,
        ref,
        uik: "TabList",
        ...props2,
        children: [
          more > 0 && more < tabs.length ? /* @__PURE__ */ (0, import_jsx_runtime533.jsxs)(import_jsx_runtime533.Fragment, { children: [
            tabs.slice(0, more),
            /* @__PURE__ */ (0, import_jsx_runtime533.jsx)(import_uik723.Dropdown, { kind: "TERTIARY", label: MESSAGES19.MORE(), triggerClassName: (0, import_uik723.css)(MORE), children: tabs.slice(more).map((tab) => /* @__PURE__ */ (0, import_jsx_runtime533.jsx)(import_uik723.Dropdown.Option, { children: tab }, tab.toString())) })
          ] }) : tabs,
          actionable && /* @__PURE__ */ (0, import_jsx_runtime533.jsx)(import_uik723.Button, { className: ADD2, icon: "Action.Add", onClick: () => onAdd?.(), type: "TERTIARY", children: addTitle }),
          /* @__PURE__ */ (0, import_jsx_runtime533.jsx)(import_uik723.Overlay.Provider, { children: /* @__PURE__ */ (0, import_jsx_runtime533.jsxs)(import_uik723.Overlay, { children: [
            selected > -1 && /* @__PURE__ */ (0, import_jsx_runtime533.jsx)("div", { className: INDICATOR, uik: "TabList.INDICATOR" }),
            /* @__PURE__ */ (0, import_jsx_runtime533.jsx)("div", { className: INDICATOR_BAR })
          ] }) })
        ]
      }
    );
  }
);
TabList.displayName = "TabList";
TabList.__DEV_METADATA__ = { status: "READY" };
var isTabbable = /* @__PURE__ */ __name((ref, element) => ref?.current?.contains(element) && element?.ariaDisabled !== "true", "isTabbable");

// Tag/Tag.tsx
var import_uik733 = require("@appd/uik");

// Tag/Colored/Colored.tsx
var import_uik725 = require("@appd/uik");

// Tag/Colored/getStyles.ts
var import_uik724 = require("@appd/uik");
var getStyles36 = /* @__PURE__ */ __name(({ color: color2 }) => ({
  HOST: { backgroundColor: import_uik724.utils.maybeGet(COLOR_MAPPING, color2) ?? ACCENT_A_WEAK2 }
}), "getStyles");
var {
  COLORS: {
    ACCENT_A_WEAK: ACCENT_A_WEAK2,
    ACCENT_B_WEAK,
    ACCENT_C_WEAK,
    ACCENT_D_WEAK,
    ACCENT_E_WEAK,
    ACCENT_F_WEAK,
    ACCENT_G_WEAK,
    ACCENT_H_WEAK,
    ACCENT_I_WEAK,
    ACCENT_K_WEAK
  }
} = import_uik724.MAGNETIC_TOKENS;
var COLOR_MAPPING = {
  1: ACCENT_A_WEAK2,
  10: ACCENT_K_WEAK,
  2: ACCENT_B_WEAK,
  3: ACCENT_C_WEAK,
  4: ACCENT_D_WEAK,
  5: ACCENT_E_WEAK,
  6: ACCENT_F_WEAK,
  7: ACCENT_G_WEAK,
  8: ACCENT_H_WEAK,
  9: ACCENT_I_WEAK
};

// Tag/Colored/Colored.tsx
var import_jsx_runtime534 = require("react/jsx-runtime");
var Colored = import_uik725.utils.forwardRef(({ className: className2, color: color2 = 1, ...props2 }, ref) => {
  const { HOST: HOST14 } = getStyles36({ color: color2 });
  return /* @__PURE__ */ (0, import_jsx_runtime534.jsx)(import_uik725.Tag, { className: (0, import_uik725.css)(HOST14, ...import_uik725.utils.many(className2)), uik: "Tag.Colored", ...props2, ref });
});
Colored.displayName = "Tag.Colored";

// Tag/getStyles.ts
var import_uik726 = require("@appd/uik");
var getStyles37 = /* @__PURE__ */ __name(({ size }) => ({
  ":has(> svg[uik='Icon.Action.Disable']:hover)": { backgroundColor: DEFAULT_BG_STRONG_DISABLED3 },
  CLOSE: {
    "> path": { fill: INTERACT_ICON_WEAK10 },
    CLOSE_ICON: { ...SIZE_MAPPING[size].icon },
    backgroundColor: "transparent",
    border: 0,
    cursor: "pointer",
    flexGrow: 0,
    flexShrink: 0,
    padding: 0,
    textAlign: "unset",
    ...SIZE_MAPPING[size].icon
  },
  ICON: {
    flexGrow: 0,
    flexShrink: 0,
    ...SIZE_MAPPING[size].icon
  },
  LABEL: {
    ...ELLIPSES21.END,
    font: FONT_BODY2,
    fontWeight: WEIGHT_EMPHASIS2,
    maxWidth: 230
  },
  alignItems: "center",
  backgroundColor: CONTROL_BG_MEDIUM_DISABLED2,
  border: "2px solid transparent",
  borderRadius: SIZE_MAPPING[size].borderRadius,
  color: DEFAULT_TEXT31,
  display: "inline-flex",
  fontSize: SIZE_MAPPING[size].fontSize,
  gap: 4,
  lineHeight: SIZE_MAPPING[size].lineHeight,
  paddingBlock: SIZE_MAPPING[size].paddingBlock,
  paddingInline: SIZE_MAPPING[size].paddingInline
}), "getStyles");
var {
  COLORS: { CONTROL_BG_MEDIUM_DISABLED: CONTROL_BG_MEDIUM_DISABLED2, DEFAULT_BG_STRONG_DISABLED: DEFAULT_BG_STRONG_DISABLED3, DEFAULT_TEXT: DEFAULT_TEXT31, INTERACT_ICON_WEAK: INTERACT_ICON_WEAK10 },
  TYPOGRAPHY: { ELLIPSES: ELLIPSES21, FONT_BODY: FONT_BODY2, WEIGHT_EMPHASIS: WEIGHT_EMPHASIS2 }
} = import_uik726.MAGNETIC_TOKENS;
var SMALL3 = {
  borderRadius: 14,
  fontSize: 12,
  icon: {
    height: 12,
    width: 12
  },
  lineHeight: "16px",
  paddingBlock: 0,
  paddingInline: 6
};
var MEDIUM3 = {
  borderRadius: 14,
  fontSize: 12,
  icon: {
    height: 14,
    width: 14
  },
  lineHeight: "18px",
  paddingBlock: 2,
  paddingInline: 10
};
var LARGE3 = {
  borderRadius: 18,
  fontSize: 14,
  icon: {
    height: 16,
    width: 16
  },
  lineHeight: "20px",
  paddingBlock: 2,
  paddingInline: 10
};
var SIZE_MAPPING = {
  LARGE: LARGE3,
  MEDIUM: MEDIUM3,
  SMALL: SMALL3
};

// Tag/Group/Group.tsx
var import_uik728 = require("@appd/uik");
var import_react129 = require("react");

// Tag/Group/STYLES.ts
var import_uik727 = require("@appd/uik");
var {
  COLORS: { CONTROL_BORDER_WEAK: CONTROL_BORDER_WEAK22, DEFAULT_BG: DEFAULT_BG3, DEFAULT_BG_STRONG_DISABLED: DEFAULT_BG_STRONG_DISABLED4 }
} = MAGNETIC_TOKENS;
var STYLES43 = {
  HOST: (0, import_uik727.css)({
    "> li": { position: "relative" },
    display: "flex",
    flexWrap: "wrap",
    gap: 4,
    listStyleType: "none",
    margin: 0,
    padding: 0
  }),
  OVERFLOW: (0, import_uik727.css)({
    ":focus-visible": { boxShadow: "none" },
    ":hover": { borderColor: DEFAULT_BG_STRONG_DISABLED4 },
    backgroundColor: DEFAULT_BG3,
    border: "2px solid",
    borderColor: CONTROL_BORDER_WEAK22
  }),
  OVERLAY: (0, import_uik727.css)({
    minWidth: 200,
    width: "fit-content"
  }),
  OVERLAY_CONTENT: (0, import_uik727.css)({
    display: "flex",
    flexWrap: "wrap",
    gap: 8
  })
};

// Tag/Group/Group.tsx
var import_jsx_runtime535 = require("react/jsx-runtime");
var Group7 = import_uik728.utils.forwardRef(
  ({ children: rawChildren, className: className2, overflow: rawOverflow, ...props2 }, ref) => {
    const children = import_react129.Children.toArray(rawChildren);
    const overflow = rawOverflow ?? children.length;
    const visibleChildren = children.slice(0, overflow).map((child, index) => /* @__PURE__ */ (0, import_jsx_runtime535.jsx)("li", { children: child }, index));
    const overflowChildren = children.slice(overflow);
    const { HOST: HOST14, OVERFLOW, OVERLAY: OVERLAY2, OVERLAY_CONTENT: OVERLAY_CONTENT2 } = STYLES43;
    return /* @__PURE__ */ (0, import_jsx_runtime535.jsxs)("ul", { className: (0, import_uik728.css)(HOST14, ...import_uik728.utils.many(className2)), uik: "Tag.Group", ...props2, ref, children: [
      visibleChildren,
      overflowChildren != void 0 && overflowChildren.length > 0 && /* @__PURE__ */ (0, import_jsx_runtime535.jsx)("li", { children: /* @__PURE__ */ (0, import_jsx_runtime535.jsx)(
        import_uik728.Popover,
        {
          content: /* @__PURE__ */ (0, import_jsx_runtime535.jsx)("div", { className: (0, import_uik728.css)(OVERLAY_CONTENT2), children: overflowChildren }),
          contentClassName: (0, import_uik728.css)(OVERLAY2),
          position: "RIGHT",
          trigger: "HOVER",
          children: /* @__PURE__ */ (0, import_jsx_runtime535.jsx)(import_uik728.Tag.Selectable, { className: (0, import_uik728.css)(OVERFLOW), tabIndex: -1, children: `+${overflowChildren.length}` })
        }
      ) }, "overflow-tag")
    ] });
  }
);
Group7.displayName = "Tag.Group";

// Tag/Selectable/Selectable.tsx
var import_uik730 = require("@appd/uik");

// Tag/Selectable/getStyles.ts
var import_uik729 = require("@appd/uik");
var getStyles38 = /* @__PURE__ */ __name(({ selected }) => ({
  HOST: {
    ":focus-visible": {
      boxShadow: SHADOW_FOCUS5,
      outline: "none"
    },
    ":hover": { backgroundColor: DEFAULT_BG_STRONG_DISABLED5 },
    border: 0,
    cursor: "pointer",
    textAlign: "unset",
    ...selected && {
      ":hover": { backgroundColor: DEFAULT_BG_STRONG_HOVER4 },
      backgroundColor: DEFAULT_BG_STRONG4,
      color: DEFAULT_TEXT_IN
    }
  }
}), "getStyles");
var {
  COLORS: { DEFAULT_BG_STRONG: DEFAULT_BG_STRONG4, DEFAULT_BG_STRONG_DISABLED: DEFAULT_BG_STRONG_DISABLED5, DEFAULT_BG_STRONG_HOVER: DEFAULT_BG_STRONG_HOVER4, DEFAULT_TEXT_IN },
  EFFECTS: { SHADOW_FOCUS: SHADOW_FOCUS5 }
} = import_uik729.MAGNETIC_TOKENS;

// Tag/Selectable/Selectable.tsx
var import_jsx_runtime536 = require("react/jsx-runtime");
var Selectable = import_uik730.utils.forwardRef(
  ({ className: className2, onClick: rawOnClick, selected = false, ...props2 }, ref) => {
    const { HOST: HOST14 } = getStyles38({ selected });
    const onClick = /* @__PURE__ */ __name((event) => {
      event.preventDefault();
      event.stopPropagation();
      rawOnClick?.(event);
    }, "onClick");
    const onKeyDown = /* @__PURE__ */ __name((event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        rawOnClick?.(event);
      }
    }, "onKeyDown");
    return /* @__PURE__ */ (0, import_jsx_runtime536.jsx)(
      import_uik730.Tag,
      {
        className: (0, import_uik730.css)(HOST14, ...import_uik730.utils.many(className2)),
        onClick,
        onKeyDown,
        role: "button",
        tabIndex: 0,
        uik: "Tag.Selectable",
        ...props2,
        ref
      }
    );
  }
);
Selectable.displayName = "Tag.Selectable";

// Tag/Status/Status.tsx
var import_uik732 = require("@appd/uik");

// Tag/Status/getStyles.ts
var import_uik731 = require("@appd/uik");
var getStyles39 = /* @__PURE__ */ __name(({ status }) => ({
  HOST: { backgroundColor: BACKGROUND_COLOR_MAPPING[status] }
}), "getStyles");
var {
  COLORS: { CONTROL_BG_MEDIUM_DISABLED: CONTROL_BG_MEDIUM_DISABLED3, INFO_BG_MEDIUM, NEGATIVE_BG_MEDIUM, POSITIVE_BG_MEDIUM, WARNING_BG_MEDIUM }
} = import_uik731.MAGNETIC_TOKENS;
var BACKGROUND_COLOR_MAPPING = {
  ACTIVE: INFO_BG_MEDIUM,
  DISABLED: CONTROL_BG_MEDIUM_DISABLED3,
  INACTIVE: CONTROL_BG_MEDIUM_DISABLED3,
  INFO: INFO_BG_MEDIUM,
  NEGATIVE: NEGATIVE_BG_MEDIUM,
  POSITIVE: POSITIVE_BG_MEDIUM,
  WARNING: WARNING_BG_MEDIUM
};

// Tag/Status/Status.tsx
var import_jsx_runtime537 = require("react/jsx-runtime");
var Status = import_uik732.utils.forwardRef(({ className: className2, status, ...props2 }, ref) => {
  const { HOST: HOST14 } = getStyles39({ status });
  return /* @__PURE__ */ (0, import_jsx_runtime537.jsx)(
    import_uik732.Tag,
    {
      className: (0, import_uik732.css)(HOST14, ...import_uik732.utils.many(className2)),
      prefix: ICON_MAPPING[status],
      uik: "Tag.Status",
      ...props2,
      ref
    }
  );
});
Status.displayName = "Tag.Status";
var ICON_MAPPING = {
  ACTIVE: "Health.Active",
  DISABLED: "Health.Terminated",
  INACTIVE: "Status.Unknown",
  INFO: "Health.InfoMessage",
  NEGATIVE: "Health.Critical",
  POSITIVE: "Health.Normal",
  WARNING: "Health.Warning"
};

// Tag/Tag.tsx
var import_jsx_runtime538 = require("react/jsx-runtime");
var Tag9 = Object.assign(
  import_uik733.utils.forwardRef(({ children, className: className2, onClose, prefix, size = "MEDIUM", ...props2 }, ref) => {
    const {
      CLOSE: { CLOSE_ICON, ...CLOSE3 },
      ICON: ICON4,
      LABEL: LABEL7,
      ...HOST14
    } = getStyles37({ size });
    const {
      COLORS: { CONTROL_BG_STRONG: CONTROL_BG_STRONG8 }
    } = import_uik733.MAGNETIC_TOKENS;
    const noAlertRuleStyle = { "& path:first-child": { fill: CONTROL_BG_STRONG8 } };
    const onKeyDown = /* @__PURE__ */ __name((event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        onClose?.(event);
      }
    }, "onKeyDown");
    const close = onClose && /* @__PURE__ */ (0, import_jsx_runtime538.jsx)(
      "button",
      {
        className: (0, import_uik733.css)(CLOSE3),
        onClick: (event) => {
          event.preventDefault();
          event.stopPropagation();
          onClose(event);
        },
        onKeyDown,
        tabIndex: 0,
        children: /* @__PURE__ */ (0, import_jsx_runtime538.jsx)(import_uik733.Icon.Action.Disable, { className: (0, import_uik733.css)(CLOSE_ICON) })
      }
    );
    let prefixIcon = prefix && /* @__PURE__ */ (0, import_jsx_runtime538.jsx)(import_uik733.Icon, { className: (0, import_uik733.css)(ICON4), type: prefix });
    if (prefix === "Health.NoAlertRulesEnabled") {
      prefixIcon = /* @__PURE__ */ (0, import_jsx_runtime538.jsx)(import_uik733.Icon.Status.Unknown, { className: (0, import_uik733.css)(ICON4, noAlertRuleStyle), size: "SMALL" });
    }
    return /* @__PURE__ */ (0, import_jsx_runtime538.jsxs)("div", { className: (0, import_uik733.css)(HOST14, ...import_uik733.utils.many(className2)), ref, tabIndex: -1, uik: "Tag", ...props2, children: [
      prefixIcon,
      /* @__PURE__ */ (0, import_jsx_runtime538.jsx)(import_uik733.Tooltip, { showOnOverflowOnly: true, value: children, children: /* @__PURE__ */ (0, import_jsx_runtime538.jsx)("div", { className: (0, import_uik733.css)(LABEL7), children }) }),
      close
    ] });
  }),
  {
    Colored,
    Group: Group7,
    Selectable,
    Status
  }
);
Tag9.displayName = "Tag";
Tag9.__DEV_METADATA__ = { status: "READY" };

// Textarea/Textarea.tsx
var import_uik735 = require("@appd/uik");
var import_react130 = require("react");

// Textarea/getStyles.tsx
var import_uik734 = require("@appd/uik");
var getStyles40 = /* @__PURE__ */ __name((showErrorStyles) => import_uik734.css.Styles({
  ERROR: import_uik734.css.Styles({ marginTop: SPACING45[1] }),
  TEXTAREA: import_uik734.css.Styles({
    "&::placeholder": { color: DEFAULT_TEXT_WEAK4 },
    "&:disabled": {
      backgroundColor: CONTROL_BG_WEAK_DISABLED4,
      border: `2px solid ${CONTROL_BORDER_DISABLED4}`,
      color: DEFAULT_TEXT_DISABLED8,
      cursor: "not-allowed"
    },
    "&:not(:disabled):not(:read-only)": {
      "&:focus": {
        border: `2px solid ${CONTROL_BORDER_FOCUS4}`,
        boxShadow: SHADOW_FOCUS6,
        paddingTop: SPACING45[1] + 1
      },
      "&:hover:not(:focus)": { border: `2px solid ${CONTROL_BORDER_HOVER8}` },
      ...showErrorStyles && {
        "&:invalid": {
          "&:focus": { border: `2px solid ${NEGATIVE_BORDER_MEDIUM_FOCUS2}` },
          "&:hover:not(:focus)": { border: `2px solid ${NEGATIVE_BORDER_MEDIUM_HOVER2}` },
          border: `2px solid ${NEGATIVE_BORDER_MEDIUM_ACTIVE2}`,
          boxShadow: SHADOW_FOCUS_NEGATIVE2
        }
      }
    },
    "&:read-only": { backgroundColor: "transparent" },
    backgroundColor: CONTROL_BG_WEAK19,
    border: `2px solid ${CONTROL_BORDER20}`,
    borderRadius: RADIUS24.HEAVY,
    boxSizing: "border-box",
    color: DEFAULT_TEXT32,
    font: P3_DEFAULT18,
    outline: "none",
    padding: "6px 10px",
    resize: "none",
    width: "100%"
  })
}), "getStyles");
var {
  COLORS: {
    CONTROL_BG_WEAK: CONTROL_BG_WEAK19,
    CONTROL_BG_WEAK_DISABLED: CONTROL_BG_WEAK_DISABLED4,
    CONTROL_BORDER: CONTROL_BORDER20,
    CONTROL_BORDER_DISABLED: CONTROL_BORDER_DISABLED4,
    CONTROL_BORDER_FOCUS: CONTROL_BORDER_FOCUS4,
    CONTROL_BORDER_HOVER: CONTROL_BORDER_HOVER8,
    DEFAULT_TEXT: DEFAULT_TEXT32,
    DEFAULT_TEXT_DISABLED: DEFAULT_TEXT_DISABLED8,
    DEFAULT_TEXT_WEAK: DEFAULT_TEXT_WEAK4,
    NEGATIVE_BORDER_MEDIUM_ACTIVE: NEGATIVE_BORDER_MEDIUM_ACTIVE2,
    NEGATIVE_BORDER_MEDIUM_FOCUS: NEGATIVE_BORDER_MEDIUM_FOCUS2,
    NEGATIVE_BORDER_MEDIUM_HOVER: NEGATIVE_BORDER_MEDIUM_HOVER2
  },
  EFFECTS: { SHADOW_FOCUS: SHADOW_FOCUS6, SHADOW_FOCUS_NEGATIVE: SHADOW_FOCUS_NEGATIVE2 },
  RADIUS: RADIUS24,
  SPACING: SPACING45,
  TYPOGRAPHY: { P3_DEFAULT: P3_DEFAULT18 }
} = import_uik734.MAGNETIC_TOKENS;

// Textarea/Textarea.tsx
var import_jsx_runtime539 = require("react/jsx-runtime");
var Textarea = import_uik735.utils.forwardRef(
  ({
    className: className2,
    disabled,
    errors = [],
    hint,
    label,
    name = label,
    onChange,
    readOnly,
    required = false,
    rows = 1,
    maxRows = rows + 30,
    secondaryHint,
    showOptional = !required,
    tooltip,
    onBlur,
    value,
    // getCurrentNumberOfRows,
    // wrapChanged = false,
    ...props2
  }, forwardedRef) => {
    const ref = import_uik735.utils.useBroadcastRef(forwardedRef);
    const [requiredValidity, setRequiredValidity] = (0, import_react130.useState)(true);
    const [customValidity, setCustomValidity] = (0, import_react130.useState)(true);
    const { submitted } = (0, import_react130.useContext)(import_uik735.Form.CONTEXT);
    const [touched, setTouched] = (0, import_react130.useState)(false);
    const { ERROR, TEXTAREA } = getStyles40(touched || submitted || errors.length > 0);
    (0, import_react130.useEffect)(() => {
      setErrors(ref);
    }, [errors, value]);
    const rowToHeight = /* @__PURE__ */ __name((row) => row * 15 + 15, "rowToHeight");
    const onInput = /* @__PURE__ */ __name((event) => {
      event.currentTarget.style.height = "1px";
      event.currentTarget.style.height = `${import_uik735.utils.clamp(event.currentTarget.scrollHeight, [
        rowToHeight(rows),
        rowToHeight(maxRows)
      ])}px`;
    }, "onInput");
    const setErrors = /* @__PURE__ */ __name((ref2) => {
      const requiredError = ref2?.current?.validity.valueMissing;
      if (ref2.current) {
        ref2.current.setCustomValidity(errors.join(" "));
        ref2.current.errors = [...requiredError ? [import_uik735.Form.MESSAGES.REQUIRED()] : [], ...errors];
      }
      setCustomValidity(!errors.length);
      setRequiredValidity(!requiredError);
    }, "setErrors");
    return /* @__PURE__ */ (0, import_jsx_runtime539.jsxs)("div", { className: (0, import_uik735.css)(...import_uik735.utils.many(className2)), uik: "Textarea", children: [
      /* @__PURE__ */ (0, import_jsx_runtime539.jsx)(
        import_uik735.Form.Label,
        {
          hint,
          label,
          name,
          required,
          secondaryHint,
          showOptional,
          tooltip,
          children: /* @__PURE__ */ (0, import_jsx_runtime539.jsx)(
            "textarea",
            {
              disabled,
              name,
              readOnly,
              ref,
              required,
              rows,
              value,
              ...props2,
              className: (0, import_uik735.css)(TEXTAREA, { height: rowToHeight(rows) }),
              onBlur: (e) => {
                onBlur?.(e);
                if (e.defaultPrevented) {
                  return;
                }
                setTouched(true);
              },
              onChange: (e) => {
                setTouched(true);
                setErrors(ref);
                onChange && onChange(e);
              },
              onInput
            }
          )
        }
      ),
      (touched || submitted) && !requiredValidity && !disabled && !readOnly && /* @__PURE__ */ (0, import_jsx_runtime539.jsx)(import_uik735.Form.Validation.Error, { className: (0, import_uik735.css)(ERROR), children: import_uik735.Form.MESSAGES.REQUIRED() }),
      !customValidity && /* @__PURE__ */ (0, import_jsx_runtime539.jsx)(import_jsx_runtime539.Fragment, { children: errors.map((error) => /* @__PURE__ */ (0, import_jsx_runtime539.jsx)(import_uik735.Form.Validation.Error, { className: (0, import_uik735.css)(ERROR), children: error }, error)) })
    ] });
  }
);
Textarea.displayName = "Textarea";
Textarea.__DEV_METADATA__ = { status: "READY" };

// ThemeSwitch/ThemeSwitch.tsx
var import_uik737 = require("@appd/uik");
var import_react131 = require("react");

// ThemeSwitch/MESSAGES.ts
var MESSAGES20 = {
  DARK: format.message`Dark`.description("Dark theme label"),
  LIGHT: format.message`Light`.description("Light theme label")
};

// ThemeSwitch/STYLES.ts
var import_uik736 = require("@appd/uik");
var {
  COLORS: { DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM21 },
  SPACING: SPACING46
} = import_uik736.MAGNETIC_TOKENS;
var STYLES44 = {
  ENABLE: (0, import_uik736.css)({
    paddingRight: SPACING46[1],
    width: SPACING46[5]
  }),
  LABEL: (0, import_uik736.css)({ color: DEFAULT_TEXT_MEDIUM21 })
};

// ThemeSwitch/ThemeSwitch.tsx
var import_jsx_runtime540 = require("react/jsx-runtime");
var { ENABLE, LABEL: LABEL6 } = STYLES44;
var ThemeSwitch = import_uik737.utils.forwardRef(
  ({ mode = "LIST", onThemeChange, theme: intitalTheme = "light", ...props2 }, ref) => {
    const [theme, setTheme] = (0, import_react131.useState)(intitalTheme);
    const config = (0, import_react131.useContext)(import_uik737.css.CONTEXT);
    (0, import_react131.useEffect)(() => {
      if (config.currentTheme != theme) {
        setTheme(config.currentTheme);
      }
    }, [config]);
    const onSelectionChange = /* @__PURE__ */ __name((newTheme) => {
      setTheme(newTheme);
      config.setCurrentTheme(newTheme);
      const root = document.querySelector(":root");
      root?.setAttribute("uik", newTheme);
      onThemeChange?.(newTheme);
    }, "onSelectionChange");
    if (import_uik737.utils.IS_DEV_MODE && mode !== mode.toUpperCase()) {
      console.warn(`[UIK] Use <ThemeSwitch mode="${mode.toUpperCase()}"> instead of <ThemeSwitch mode="${mode}">.`);
    }
    return mode === "LIST" || mode === "list" ? /* @__PURE__ */ (0, import_jsx_runtime540.jsxs)(import_uik737.List, { ref, uik: "ThemeSwitch", ...props2, className: (0, import_uik737.css)({ width: "100%" }), children: [
      /* @__PURE__ */ (0, import_jsx_runtime540.jsx)(import_uik737.List.Option, { onClick: () => onSelectionChange("light"), children: /* @__PURE__ */ (0, import_jsx_runtime540.jsxs)("div", { className: (0, import_uik737.css)({ display: "flex" }), children: [
        /* @__PURE__ */ (0, import_jsx_runtime540.jsx)("div", { className: ENABLE, children: theme === "light" && /* @__PURE__ */ (0, import_jsx_runtime540.jsx)(import_uik737.Icon, { size: "SMALL", type: "Action.Enable" }) }),
        /* @__PURE__ */ (0, import_jsx_runtime540.jsx)("div", { className: LABEL6, children: MESSAGES20.LIGHT() })
      ] }) }),
      /* @__PURE__ */ (0, import_jsx_runtime540.jsx)(import_uik737.List.Option, { onClick: () => onSelectionChange("dark"), children: /* @__PURE__ */ (0, import_jsx_runtime540.jsxs)("div", { className: (0, import_uik737.css)({ display: "flex" }), children: [
        /* @__PURE__ */ (0, import_jsx_runtime540.jsx)("div", { className: ENABLE, children: theme === "dark" && /* @__PURE__ */ (0, import_jsx_runtime540.jsx)(import_uik737.Icon, { size: "SMALL", type: "Action.Enable" }) }),
        /* @__PURE__ */ (0, import_jsx_runtime540.jsx)("div", { className: LABEL6, children: MESSAGES20.DARK() })
      ] }) })
    ] }) : /* @__PURE__ */ (0, import_jsx_runtime540.jsxs)(import_uik737.Toggle, { ref, uik: "ThemeSwitch", ...props2, selected: theme === "light" ? 0 : 1, children: [
      /* @__PURE__ */ (0, import_jsx_runtime540.jsx)(import_uik737.Button, { icon: "Location.Actions", onClick: () => onSelectionChange("light"), type: "TERTIARY" }),
      /* @__PURE__ */ (0, import_jsx_runtime540.jsx)(import_uik737.Button, { icon: "Location.ActionSuspended", onClick: () => onSelectionChange("dark"), type: "TERTIARY" })
    ] });
  }
);
ThemeSwitch.displayName = "ThemeSwitch";

// TimelineBar/TimelineBar.tsx
var import_uik758 = require("@appd/uik");
var import_react137 = require("react");

// TimelineBar/getState/getDefaults/getEnable.ts
var getEnable = /* @__PURE__ */ __name(({
  bar = true,
  gridLines = true,
  labels = true,
  title = true,
  tooltip = true
} = {}, rawData, rawTitle) => ({
  bar: bar && Boolean(rawData),
  gridLines: typeof gridLines === "object" ? (
    /* Case 1: Unset options default to `true`. */
    {
      bottomHalf: true,
      topHalf: true,
      ...gridLines
    }
  ) : (
    /* Case 2: All options set to the same value. */
    {
      bottomHalf: gridLines,
      topHalf: gridLines
    }
  ),
  labels,
  // Only show title if `rawTitle` input was provided (and not an empty string).
  title: title && Boolean(rawTitle),
  tooltip: {
    date: typeof tooltip !== "boolean" && tooltip.date !== void 0 && tooltip.date,
    enable: tooltip !== false
  }
}), "getEnable");

// TimelineBar/getState/getDefaults/getIntervalsAndPoints/BUILTIN_STATUS.ts
var import_uik738 = require("@appd/uik");
var {
  COLORS: { NEGATIVE_ICON: NEGATIVE_ICON4, POSITIVE_ICON: POSITIVE_ICON4, WARNING_ICON: WARNING_ICON4 },
  PARTICLE: { ACTIVE_ICON, INACTIVE_ICON, TERMINATED_ICON, UNKNOWN_ICON: UNKNOWN_ICON3 }
} = import_uik738.MAGNETIC_TOKENS;
var BUILTIN_STATUS = {
  ACTIVE: {
    color: ACTIVE_ICON,
    icon: "Health.Active",
    get name() {
      return DISPLAY_NAME("ACTIVE");
    },
    priority: 0
  },
  CRITICAL: {
    color: NEGATIVE_ICON4,
    icon: "Health.Critical",
    get name() {
      return DISPLAY_NAME("CRITICAL");
    },
    priority: 30
  },
  INACTIVE: {
    color: INACTIVE_ICON,
    icon: "Health.Inactive",
    get name() {
      return DISPLAY_NAME("INACTIVE");
    },
    priority: 0
  },
  NORMAL: {
    color: POSITIVE_ICON4,
    icon: "Health.Normal",
    get name() {
      return DISPLAY_NAME("NORMAL");
    },
    priority: 0
  },
  TERMINATED: {
    color: TERMINATED_ICON,
    icon: "Health.Terminated",
    get name() {
      return DISPLAY_NAME("TERMINATED");
    },
    priority: 0
  },
  UNKNOWN: {
    color: UNKNOWN_ICON3,
    icon: "Health.Unknown",
    get name() {
      return DISPLAY_NAME("UNKNOWN");
    },
    priority: 10
  },
  WARNING: {
    color: WARNING_ICON4,
    icon: "Health.Warning",
    get name() {
      return DISPLAY_NAME("WARNING");
    },
    priority: 20
  }
};
var DISPLAY_NAME = import_uik738.format.message`${{
  ACTIVE: "Active",
  CRITICAL: "Critical",
  INACTIVE: "Inactive",
  NORMAL: "Normal",
  TERMINATED: "Terminated",
  UNKNOWN: "Unknown",
  WARNING: "Warning"
}}`.description("Health status");

// TimelineBar/getState/getDefaults/getIntervalsAndPoints/getIntervalsAndPoints.ts
var getIntervalsAndPoints = /* @__PURE__ */ __name((rawData) => {
  const withIndex = rawData.map(
    (intervalOrPoint, index) => "status" in intervalOrPoint ? {
      from: intervalOrPoint.from,
      index,
      status: typeof intervalOrPoint.status === "string" ? BUILTIN_STATUS[intervalOrPoint.status] : intervalOrPoint.status,
      until: intervalOrPoint.until
    } : {
      ...intervalOrPoint,
      index
    }
  );
  return {
    intervals: withIndex.filter((intervalOrPoint) => "status" in intervalOrPoint).sort(({ status: { priority: a } }, { status: { priority: b } }) => a - b),
    points: withIndex.filter(
      (intervalOrPoint) => !("status" in intervalOrPoint)
    )
  };
}, "getIntervalsAndPoints");

// TimelineBar/getState/getDefaults/getSelected.ts
var getSelected = /* @__PURE__ */ __name((rawSelected) => typeof rawSelected === "number" ? [rawSelected] : rawSelected, "getSelected");

// TimelineBar/getState/getDefaults/getTimeFormat.ts
var getTimeFormat2 = /* @__PURE__ */ __name(({
  alwaysShowSecond = false,
  twelveHour = true
} = {}) => ({
  alwaysShowSecond,
  twelveHour
}), "getTimeFormat");

// TimelineBar/getState/getDefaults/getTimeRange/getIntervalBounds.ts
var getIntervalBounds = /* @__PURE__ */ __name((intervals, points) => [
  ...points.map(({ timestamp }) => ({
    from: timestamp,
    until: timestamp
  })),
  ...intervals
].reduce(
  (context, { from: from2, until }) => {
    const {
      max: { from: maxStartTime, until: maxEndTime },
      min: { from: minStartTime, until: minEndTime }
    } = context;
    context.min.until = Math.min(minEndTime, until);
    context.min.from = Math.min(minStartTime, from2);
    context.max.until = Math.max(maxEndTime, until);
    context.max.from = Math.max(maxStartTime, from2);
    return context;
  },
  {
    max: {
      from: -Infinity,
      until: -Infinity
    },
    min: {
      from: Infinity,
      until: Infinity
    }
  }
), "getIntervalBounds");

// TimelineBar/getState/getDefaults/getTimeRange/getTimeRange.ts
function getTimeRange(intervals, points, rawTimeRange) {
  const {
    max: { until: maxUntil },
    min: { from: minFrom, until: minUntil }
  } = getIntervalBounds(intervals, points);
  const { from: from2 = isFinite(minFrom) ? minFrom : minUntil - /* 1 hour */
  36e5, until = maxUntil } = rawTimeRange ?? {};
  return {
    from: from2,
    until
  };
}
__name(getTimeRange, "getTimeRange");

// TimelineBar/getState/getDefaults/getDefaults.ts
var getDefaults = /* @__PURE__ */ __name(({
  animate = true,
  buffer = 100,
  data: rawData,
  enable: rawEnable,
  legend = false,
  selected: rawSelected,
  selectedClearedOnOutsideClick = false,
  timeFormat: rawTimeFormat,
  timeRange: rawTimeRange,
  title = ""
}) => {
  const enable = getEnable(rawEnable, rawData, title);
  const { intervals, points } = getIntervalsAndPoints(rawData);
  const selected = getSelected(rawSelected);
  const timeFormat = getTimeFormat2(rawTimeFormat);
  const timeRange = getTimeRange(intervals, points, rawTimeRange);
  return {
    animate,
    buffer,
    enable,
    intervals,
    legend,
    points,
    selected,
    selectedClearedOnOutsideClick,
    timeFormat,
    timeRange,
    title
  };
}, "getDefaults");

// TimelineBar/getState/getTicksAndTimeRange/getFinalTimeRange.ts
function getFinalTimeRange(axis, timeRange) {
  const { from: from2, until } = timeRange;
  const { max: max2, min: min2 } = axis ?? {};
  return {
    from: min2 ?? from2,
    until: max2 ?? until
  };
}
__name(getFinalTimeRange, "getFinalTimeRange");

// TimelineBar/getState/getTicksAndTimeRange/getTicks/getTicks.ts
var import_uik739 = require("@appd/uik");

// TimelineBar/getState/getTicksAndTimeRange/getTicks/asWithTicks.ts
var asWithTicks = /* @__PURE__ */ __name((x) => x, "asWithTicks");

// TimelineBar/getState/getTicksAndTimeRange/getTicks/undoDuplication.ts
var undoDuplication = /* @__PURE__ */ __name((text) => text.length % 2 === 0 && text.slice(0, text.length / 2) === text.slice(text.length / 2) ? text.slice(text.length / 2) : text, "undoDuplication");

// TimelineBar/getState/getTicksAndTimeRange/getTicks/undoEllipsizing.ts
var undoEllipsizing = /* @__PURE__ */ __name((text) => {
  const ellipsisAt = text.indexOf("\u2026");
  return ellipsisAt > -1 ? text.slice(ellipsisAt + 1) : text;
}, "undoEllipsizing");

// TimelineBar/getState/getTicksAndTimeRange/getTicks/getTicks.ts
function getTicks(axis) {
  const { ticks } = axis ? asWithTicks(axis) : { ticks: [] };
  return Object.entries(ticks).map(([timestamp, tick]) => {
    const tickLabel = import_uik739.utils.ASSERT(tick.label).else(Error("A tick label was `undefined`.")).element.textContent ?? "";
    return {
      label: undoDuplication(undoEllipsizing(tickLabel)),
      timestamp: +timestamp
    };
  });
}
__name(getTicks, "getTicks");

// TimelineBar/getState/getTicksAndTimeRange/getXAxis.ts
var import_uik740 = require("@appd/uik");
function getXAxis(options, width) {
  const { chart } = HIGHCHARTS() ?? {};
  if (chart && import_uik740.utils.CAN_USE_DOM) {
    const div = document.createElement("div");
    div.style.width = `${width}px`;
    div.style.height = "400px";
    return chart(div, options).xAxis[0];
  }
}
__name(getXAxis, "getXAxis");

// TimelineBar/getState/getOptions/getOptions.ts
var import_uik741 = require("@appd/uik");

// TimelineBar/getState/getOptions/getTimeFormat.ts
function getTimeFormat3(timeFormat) {
  const { alwaysShowSecond, twelveHour } = timeFormat;
  const hours = twelveHour ? "%l" : "%k";
  const seconds = alwaysShowSecond ? ":%S" : "";
  const amPm = twelveHour ? " %p" : "";
  const millisecond = `${hours}:%M:%S.%L${amPm}`;
  const second = `${hours}:%M:%S${amPm}`;
  const minute = `${hours}:%M${seconds}${amPm}`;
  return {
    day: "%m/%d",
    hour: minute,
    millisecond,
    minute,
    month: "%m/%d",
    second,
    week: "%m/%d",
    year: "%m/%d"
  };
}
__name(getTimeFormat3, "getTimeFormat");

// TimelineBar/getState/getOptions/getOptions.ts
function getOptions(inputs, timeFormat, timeRange) {
  const { timeRange: { from: min2, until: max2 } = {} } = inputs;
  const { from: from2, until } = timeRange;
  const numPoints = 20;
  const data = [...Array(numPoints)].map((_, i) => ({
    x: import_uik741.utils.mix(from2, until, i / (numPoints - 1)),
    y: 0
  }));
  const dateTimeLabelFormats = getTimeFormat3(timeFormat);
  const time2 = {
    // (UIK-4434)
    // TODO: Set timezone here once there is a way to get user's _configured_ timezone (UIK-4433).
    // The _configured_ timezone is the one they set via the AppD settings page.
    // A user in India would have a system time of IST, but possibly a different configured time (e.g. PST).
    //
    // Details:
    // https://bitbucket.corp.appdynamics.com/projects/DASHUI/repos/next-ui-levitate/pull-requests/171/overview?commentId=631928
    useUTC: false
  };
  return {
    accessibility: { enabled: false },
    boost: { enabled: false },
    chart: {
      animation: false,
      spacing: [0, 0, 0, 0],
      style: (
        /* Chosen to match `particle-body-small` mixin in `_text.scss` form `@appd/ui-assets`. */
        {
          fontFamily: `"Inter", "Helvetica Neue", Helvetica, Arial, sans-serif`,
          fontSize: "11px",
          fontWeight: "normal",
          lineHeight: "13px"
        }
      )
    },
    credits: { enabled: false },
    legend: { enabled: false },
    navigator: { enabled: false },
    plotOptions: { series: { animation: false } },
    // Minimal dataset used here.
    series: [
      {
        data,
        type: "line"
      }
    ],
    time: time2,
    tooltip: { enabled: false },
    xAxis: [
      {
        // Tick label formats used here.
        dateTimeLabelFormats,
        // Hard time range bounds used here.
        max: max2,
        // Hard time range bounds used here.
        min: min2,
        type: "datetime"
      }
    ],
    yAxis: [{ visible: false }]
  };
}
__name(getOptions, "getOptions");

// TimelineBar/getState/getTicksAndTimeRange/getOptionsAndTicks.ts
function getOptionsAndTicks(inputs, timeFormat, timeRange, width) {
  const options = getOptions(inputs, timeFormat, timeRange);
  const axis = getXAxis(options, width);
  const ticks = getTicks(axis);
  return {
    options,
    ticks
  };
}
__name(getOptionsAndTicks, "getOptionsAndTicks");

// TimelineBar/MEASURER.ts
var import_uik742 = require("@appd/uik");
var MEASURER2 = import_uik742.utils.lazyConstant(
  (withFont = (font) => Object.assign(
    !import_uik742.utils.IS_JEST && globalThis.document?.createElement("canvas").getContext("2d") || {
      // Default value needed for jsdom environments (e.g. Jest).
      measureText: () => ({ width: 1 })
    },
    { font }
  )) => ({
    // Chosen to match `particle-body-small` mixin in `_text.scss` form `@appd/ui-assets`.
    LABEL: withFont(`11px / 13px "Inter", "Helvetica Neue", Helvetica, Arial, sans-serif`),
    // Chosen to match `particle-grid-header` mixin in `_text.scss` form `@appd/ui-assets`.
    TITLE: withFont(`500 13px / 15px "Inter", "Helvetica Neue", Helvetica, Arial, sans-serif`)
  })
);

// TimelineBar/getState/getTicksAndTimeRange/getRevisedOptions.ts
function getRevisedOptions(options, ticks) {
  const maxLabelWidth = ticks.reduce(
    (maxWidth, { label }) => Math.max(maxWidth, MEASURER2().LABEL.measureText(label).width),
    0
  );
  return {
    ...options,
    xAxis: [
      {
        ...options.xAxis[0],
        minTickInterval: (
          /* Chosen experimentally. (Ideally should be `2`.) */
          2.2 * maxLabelWidth
        ),
        tickPixelInterval: (
          /* Chosen experimentally. (Ideally should be `2`.) */
          2.2 * maxLabelWidth
        )
      }
    ]
  };
}
__name(getRevisedOptions, "getRevisedOptions");

// TimelineBar/getState/getTicksAndTimeRange/getTicksAndTimeRange.ts
function getTicksAndTimeRange(inputs, width, withDefaults) {
  const { buffer, timeFormat, timeRange: $timeRange } = withDefaults;
  const { options, ticks: initialTicks } = getOptionsAndTicks(inputs, timeFormat, $timeRange, width - buffer);
  const withMaxLabelWidth = getRevisedOptions(options, initialTicks);
  const axis = getXAxis(withMaxLabelWidth, width - buffer);
  const ticks = getTicks(axis);
  const timeRange = getFinalTimeRange(axis, $timeRange);
  return {
    ticks,
    timeRange
  };
}
__name(getTicksAndTimeRange, "getTicksAndTimeRange");

// TimelineBar/getState/getState.ts
var getState5 = /* @__PURE__ */ __name((rawInputs, width) => {
  const withDefaults = getDefaults(rawInputs);
  const ticksAndTimeRange = getTicksAndTimeRange(rawInputs, width, withDefaults);
  return {
    ...withDefaults,
    ...ticksAndTimeRange,
    width
  };
}, "getState");

// TimelineBar/getStyles.ts
var import_uik744 = require("@appd/uik");

// TimelineBar/ANIMATION.ts
var import_uik743 = require("@appd/uik");
var {
  MOTION: {
    EASING: { DECELERATE: DECELERATE2 }
  }
} = import_uik743.MAGNETIC_TOKENS;
var ANIMATION = {
  animationDuration: ".15s",
  animationFillMode: "both",
  animationName: {
    from: { opacity: 0 },
    to: { opacity: 1 }
  },
  animationTimingFunction: DECELERATE2
};

// TimelineBar/getStyles.ts
var getStyles41 = /* @__PURE__ */ __name((animate) => ({
  "& .__hidden": {
    animation: "none !important",
    opacity: "0 !important",
    pointerEvents: "none"
  },
  /** HTML rendered chart elements (bar, intervals, outline). */
  "> .__bar": {
    "> .__background": {
      backgroundColor: CONTROL_BORDER_WEAK23,
      borderRadius: 2,
      height: 4,
      left: 0,
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: "100%"
    },
    ...animate && ANIMATION,
    borderRadius: 5,
    height: 10,
    position: "absolute"
  },
  /** SVG rendered chart elements (grid-lines, tick labels, title). */
  "> svg": {
    "> .__axis": {
      "> .__grid-line": {
        ...animate && ANIMATION,
        stroke: CONTROL_BORDER_WEAK23,
        strokeWidth: 1
      },
      "> .__label": {
        ...animate && ANIMATION,
        dominantBaseline: "hanging",
        fill: DEFAULT_TEXT_MEDIUM22,
        font: P4_DEFAULT11
      }
    },
    display: "block",
    overflow: "visible"
  },
  position: "relative"
}), "getStyles");
var {
  COLORS: { CONTROL_BORDER_WEAK: CONTROL_BORDER_WEAK23, DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM22 },
  TYPOGRAPHY: { P4_DEFAULT: P4_DEFAULT11 }
} = import_uik744.MAGNETIC_TOKENS;

// TimelineBar/getTemplate/round.ts
var round = /* @__PURE__ */ __name((value, numDigits) => Math.round(value * 10 ** numDigits) / 10 ** numDigits, "round");

// TimelineBar/getTemplate/toPixels.ts
var toPixels = /* @__PURE__ */ __name((value, numDigits = 3) => `${round(value, numDigits)}px`, "toPixels");

// TimelineBar/getTemplate/toSeconds.ts
var toSeconds = /* @__PURE__ */ __name((value, numDigits = 3) => `${round(value, numDigits)}s`, "toSeconds");

// TimelineBar/getTemplate/getBar.ts
var getBar = /* @__PURE__ */ __name((enable, width) => ({
  animationDelay: toSeconds(0),
  hidden: !enable.bar,
  top: +enable.title * 15 + +(enable.title || enable.gridLines.topHalf) * 8,
  width: toPixels(width)
}), "getBar");

// TimelineBar/getTemplate/getGridLines.ts
var import_uik745 = require("@appd/uik");

// TimelineBar/getTemplate/getHeight.ts
var getHeight = /* @__PURE__ */ __name(({ bar, gridLines: { bottomHalf, topHalf }, labels, title }) => bar ? +(title || topHalf) * (15 + 8) + 10 + +(labels || bottomHalf) * 16 + +labels * 13 : +(title || topHalf) * 15 + +(labels || bottomHalf) * 10 + +labels * 13, "getHeight");

// TimelineBar/getTemplate/getGridLines.ts
var getGridLines = /* @__PURE__ */ __name((enable, rescale, ticks) => ({
  animationDelay: ticks.map((_, i, { length }) => toSeconds(import_uik745.utils.mix(0, 0.2, import_uik745.utils.unmix(0, length - 1, i) ?? 0))),
  hidden: !enable.gridLines.bottomHalf && !enable.gridLines.topHalf,
  x: ticks.map(({ timestamp }) => toPixels(rescale(timestamp))),
  y1: toPixels(
    enable.gridLines.topHalf ? 0 : +enable.title * 15 + +(enable.title && enable.bar) * 8 + +enable.bar * (10 + 4) / 2
  ),
  y2: toPixels(
    enable.gridLines.bottomHalf ? getHeight(enable) - +enable.labels * 15 : +enable.title * 15 + +(enable.title && enable.bar) * 8 + +enable.bar * (10 + 4) / 2
  )
}), "getGridLines");

// TimelineBar/getTemplate/getIntervals.ts
var import_uik746 = require("@appd/uik");
var getIntervals = /* @__PURE__ */ __name(({
  animate,
  intervals,
  rescale,
  selected: rawSelected,
  width: containerWidth
}) => {
  const allSelected = new Set(rawSelected);
  return intervals.map(({ from: from2, index, status, until }, _, { length }) => {
    const x = rescale(from2);
    const width = import_uik746.utils.clamp(rescale(until) - x, [5]);
    const leftRadius = BORDER_RADIUS2 - import_uik746.utils.clamp(x, [0, BORDER_RADIUS2]);
    const rightRadius = BORDER_RADIUS2 - import_uik746.utils.clamp(containerWidth - (x + width), [0, BORDER_RADIUS2]);
    const selected = allSelected.has(index);
    return {
      className: (0, import_uik746.css)({
        ":focus-visible, :hover": {
          outline: `3px solid ${CONTROL_BORDER_WEAK_HOVER5}`,
          transition: "none"
        },
        animationDelay: toSeconds(import_uik746.utils.mix(0, 0.4, (import_uik746.utils.unmix(0, length - 1, index) ?? 0) ** 0.5)),
        backgroundColor: status.color,
        borderBottomLeftRadius: leftRadius,
        borderBottomRightRadius: rightRadius,
        borderTopLeftRadius: leftRadius,
        borderTopRightRadius: rightRadius,
        cursor: "pointer",
        height: 10,
        left: 0,
        outline: `3px solid ${selected ? INTERACT_BORDER_MEDIUM_ACTIVE2 : "transparent"}`,
        overflow: "hidden",
        position: "absolute",
        top: 0,
        transform: `translateX(${toPixels(x)})`,
        transition: selected ? "none" : `filter ${LAZY} ${DECELERATE3},outline ${LAZY} ${DECELERATE3}`,
        width,
        zIndex: status.priority,
        ...animate && ANIMATION
      }),
      index,
      selected
    };
  });
}, "getIntervals");
var BORDER_RADIUS2 = 5;
var {
  COLORS: { CONTROL_BORDER_WEAK_HOVER: CONTROL_BORDER_WEAK_HOVER5, INTERACT_BORDER_MEDIUM_ACTIVE: INTERACT_BORDER_MEDIUM_ACTIVE2 },
  MOTION: {
    DURATION: { LAZY },
    EASING: { DECELERATE: DECELERATE3 }
  }
} = import_uik746.MAGNETIC_TOKENS;

// TimelineBar/getTemplate/getLabels.ts
var import_uik747 = require("@appd/uik");
var getLabels = /* @__PURE__ */ __name((enable, rescale, ticks, width) => ({
  animationDelay: ticks.map(
    (_, i, { length }) => toSeconds(import_uik747.utils.mix(0, 0.2, import_uik747.utils.unmix(0, length - 1, i)))
  ),
  hidden: !enable.labels,
  textContent: ticks.map(({ label }) => label),
  x: ticks.map(({ label, timestamp }) => {
    const rawX = rescale(timestamp);
    const { width: labelWidth } = MEASURER2().LABEL.measureText(label);
    const x = import_uik747.utils.clamp(rawX - labelWidth / 2, [0, width - labelWidth]);
    return toPixels(x);
  }),
  y: getHeight(enable) - +(enable.labels || enable.gridLines.bottomHalf) * 13
}), "getLabels");

// TimelineBar/getTemplate/getPoints.ts
var import_uik748 = require("@appd/uik");
var getPoints = /* @__PURE__ */ __name(({ animate, points, rescale, selected: rawSelected }) => {
  const allSelected = new Set(rawSelected);
  return points.map(({ index, timestamp }, _, { length }) => {
    const x = rescale(timestamp);
    const selected = allSelected.has(index);
    return {
      className: (0, import_uik748.css)({
        "::after": {
          border: "1px solid white",
          boxSizing: "border-box",
          ...selected ? {
            height: RADIUS25.SELECTED.INNER,
            width: RADIUS25.SELECTED.INNER
          } : {
            height: RADIUS25.DEFAULT.INNER,
            width: RADIUS25.DEFAULT.INNER
          }
        },
        "::after, ::before": {
          backgroundColor: ACCENT_A4,
          borderRadius: "50%",
          content: "''",
          left: "50%",
          position: "absolute",
          top: "50%",
          transform: "translate(-50%, -50%)",
          transition: selected ? "none" : `height ${SLOW2} ${DECELERATE4}, width ${SLOW2} ${DECELERATE4}`
        },
        "::before": {
          opacity: 0.6,
          ...selected ? {
            height: RADIUS25.SELECTED.HALO,
            width: RADIUS25.SELECTED.HALO
          } : {
            height: RADIUS25.DEFAULT.HALO,
            width: RADIUS25.DEFAULT.HALO
          }
        },
        ":focus-visible, :hover": {
          ...!selected && {
            "::after": {
              height: import_uik748.utils.mix(RADIUS25.DEFAULT.INNER, RADIUS25.SELECTED.INNER, 0.5),
              width: import_uik748.utils.mix(RADIUS25.DEFAULT.INNER, RADIUS25.SELECTED.INNER, 0.5)
            },
            "::before": {
              height: import_uik748.utils.mix(RADIUS25.DEFAULT.HALO, RADIUS25.SELECTED.HALO, 0.5),
              width: import_uik748.utils.mix(RADIUS25.DEFAULT.HALO, RADIUS25.SELECTED.HALO, 0.5)
            }
          },
          "::after, ::before": {
            backgroundColor: ACCENT_A4,
            transition: "none"
          }
        },
        ...animate && ANIMATION,
        animationDelay: toSeconds(import_uik748.utils.mix(0, 0.4, (import_uik748.utils.unmix(0, length - 1, index) ?? 0) ** 0.5)),
        borderRadius: "50%",
        cursor: "pointer",
        height: RADIUS25.SELECTED.HALO,
        left: x,
        outline: "none",
        position: "absolute",
        top: "50%",
        transform: "translate(-50%, -50%)",
        width: RADIUS25.SELECTED.HALO,
        zIndex: (
          /* Just needs to exceed topmost interval. */
          30
        )
      }),
      index,
      selected
    };
  });
}, "getPoints");
var {
  COLORS: { ACCENT_A: ACCENT_A4 },
  MOTION: {
    DURATION: { SLOW: SLOW2 },
    EASING: { DECELERATE: DECELERATE4 }
  }
} = import_uik748.MAGNETIC_TOKENS;
var RADIUS25;
((RADIUS32) => {
  let DEFAULT3;
  ((DEFAULT4) => {
    DEFAULT4.INNER = 6;
    DEFAULT4.HALO = DEFAULT4.INNER + 2 * 2.5;
  })(DEFAULT3 = RADIUS32.DEFAULT || (RADIUS32.DEFAULT = {}));
  let SELECTED2;
  ((SELECTED3) => {
    SELECTED3.INNER = 10;
    SELECTED3.HALO = SELECTED3.INNER + 2 * 5.5;
  })(SELECTED2 = RADIUS32.SELECTED || (RADIUS32.SELECTED = {}));
})(RADIUS25 || (RADIUS25 = {}));

// TimelineBar/getTemplate/getScale.ts
var import_uik749 = require("@appd/uik");
var getScale = /* @__PURE__ */ __name((from2, to, width) => import_uik749.utils.scale([from2, to], [0, width], true), "getScale");

// TimelineBar/getTemplate/getTitle/getTitle.ts
var import_uik750 = require("@appd/uik");

// TimelineBar/getTemplate/getTitle/getEllipsized.ts
function getEllipsized({
  ellipsis = "\u2026",
  hyphenPattern = /(?=\W+)/,
  lineBreak = "\n",
  rows = 3,
  space = " ",
  text,
  textMeasurer,
  width = 200
}) {
  const words = text.split(/\s+/);
  const wordWidths = words.map((w) => textMeasurer.measureText(w).width);
  const lines = [];
  const ellipsesWidth = textMeasurer.measureText(ellipsis).width;
  const spaceWidth = textMeasurer.measureText(space).width;
  if (width <= ellipsesWidth) {
    return {
      didEllipsize: true,
      text: ellipsis
    };
  }
  let wordsUsed = 0;
  for (let i = 0, numWords = words.length; i < numWords && lines.length < rows; ) {
    const row = [];
    const rowWidthLimit = width - /* about to read in last row */
    (lines.length === rows - 1 && /* and it won't fit */
    wordWidths.slice(i, numWords).reduce((sum, wordWidth) => sum + spaceWidth + wordWidth, -spaceWidth) > width ? ellipsesWidth : 0);
    for (let rowWidth = 0; i < numWords && rowWidth < rowWidthLimit; ++i) {
      const needsSpaceWidth = +(rowWidth > 0);
      const [word, wordWidth] = [words[i], wordWidths[i]];
      const increment = needsSpaceWidth * spaceWidth + wordWidth;
      if (rowWidth + increment <= rowWidthLimit) {
        row.push(word);
        rowWidth += increment;
        ++wordsUsed;
      } else {
        const tokens = word.split(hyphenPattern);
        const remainingWidth = rowWidthLimit - rowWidth - needsSpaceWidth * spaceWidth;
        let j = -1;
        for (let widthSoFar = 0, { length } = tokens; j + 1 < length; ++j) {
          widthSoFar += textMeasurer.measureText(tokens[j + 1]).width;
          if (widthSoFar >= remainingWidth) {
            break;
          }
        }
        if (j === -1 && row.length === 0) {
          const split = (() => {
            let [low, high] = [1, word.length];
            while (low < high) {
              const mid = Math.ceil((low + high) / 2);
              const w = textMeasurer.measureText(word.slice(0, mid)).width;
              if (w <= remainingWidth) {
                low = mid;
              } else {
                high = mid - 1;
              }
            }
            return low;
          })();
          row.push(word.slice(0, split));
          wordWidths[i] = textMeasurer.measureText(words[i] = word.slice(split)).width;
        } else if (j !== -1) {
          row.push(tokens.slice(0, j + 1).join(""));
          wordWidths[i] = textMeasurer.measureText(words[i] = tokens.slice(j + 1).join("")).width;
        }
        break;
      }
    }
    row.length && lines.push(row);
  }
  const didEllipsize = wordsUsed < words.length;
  return {
    didEllipsize,
    text: lines.map((row) => row.join(space)).join(lineBreak) + (didEllipsize ? ellipsis : "")
  };
}
__name(getEllipsized, "getEllipsized");

// TimelineBar/getTemplate/getTitle/getTitle.ts
var getTitle = /* @__PURE__ */ __name(({ animate, enabled, title, width }) => {
  const { didEllipsize, text: textContent } = getEllipsized({
    rows: 1,
    text: title,
    textMeasurer: MEASURER2().TITLE,
    width: width - /* `x` attribute in the template. */
    2
  });
  return {
    className: (0, import_uik750.css)({
      animationDelay: 0,
      // dominantBaseline: "hanging",
      // fill: WHITE[64],
      color: DEFAULT_TEXT33,
      font: P3_EMPHASIS12,
      left: 0,
      position: "absolute",
      top: 0,
      ...enabled ? animate && ANIMATION : {
        animation: "none !important",
        opacity: 0,
        pointerEvents: "none"
      }
    }),
    textContent,
    tooltip: didEllipsize ? title : ""
  };
}, "getTitle");
var {
  COLORS: { DEFAULT_TEXT: DEFAULT_TEXT33 },
  TYPOGRAPHY: { P3_EMPHASIS: P3_EMPHASIS12 }
} = import_uik750.MAGNETIC_TOKENS;

// TimelineBar/getTemplate/getTemplate.ts
var getTemplate2 = /* @__PURE__ */ __name(({
  animate,
  enable,
  intervals,
  points,
  selected,
  ticks,
  timeRange: { from: from2, until },
  title,
  width
}) => {
  const rescale = getScale(from2, until, width);
  return {
    bar: getBar(enable, width),
    data: [
      ...getIntervals({
        animate,
        intervals,
        rescale,
        selected,
        width
      }),
      ...getPoints({
        animate,
        points,
        rescale,
        selected
      })
    ],
    gridLines: getGridLines(enable, rescale, ticks),
    height: getHeight(enable),
    labels: getLabels(enable, rescale, ticks, width),
    title: getTitle({
      animate,
      enabled: enable.title,
      title,
      width
    })
  };
}, "getTemplate");

// TimelineBar/useLegend.tsx
var import_uik751 = require("@appd/uik");
var import_react132 = require("react");

// TimelineBar/byDescendingPriority.ts
var byDescendingPriority = /* @__PURE__ */ __name(([
  ,
  [
    {
      status: { priority: a }
    }
  ]
], [
  ,
  [
    {
      status: { priority: b }
    }
  ]
]) => b - a, "byDescendingPriority");

// TimelineBar/useLegend.tsx
var import_jsx_runtime541 = require("react/jsx-runtime");
var useLegend2 = /* @__PURE__ */ __name(({ enabled = false, intervals }) => {
  const items = (0, import_react132.useMemo)(
    () => enabled ? [...import_uik751.utils.group(intervals).by(({ status: { name } }) => name)].sort(byDescendingPriority).map(
      ([
        ,
        [
          {
            status: { color: color2, name }
          }
        ]
      ]) => ({
        color: color2,
        kind: "DATA",
        label: name,
        shape: "CIRCLE"
      })
    ) : [],
    [enabled, intervals]
  );
  return enabled && /* @__PURE__ */ (0, import_jsx_runtime541.jsx)(
    import_uik751.Legend,
    {
      className: (0, import_uik751.css)({
        marginTop: SPACING47[1],
        maxHeight: useLegend2.MAX_HEIGHT
      }),
      items
    }
  );
}, "useLegend");
var {
  Layout: {
    Defaults: { HEIGHT: HEIGHT3, MARGIN }
  }
} = import_uik751.Legend;
var MAX_ROWS = 2;
useLegend2.MAX_HEIGHT = (HEIGHT3 + MARGIN) * MAX_ROWS - MARGIN;
var { SPACING: SPACING47 } = import_uik751.MAGNETIC_TOKENS;

// TimelineBar/useSelected.ts
var import_uik752 = require("@appd/uik");
var import_react133 = require("react");
var useSelected = /* @__PURE__ */ __name(({
  dataLength,
  onSelectedChange,
  selected: maybeSelected,
  selectedClearedOnOutsideClick
}) => {
  const [rawSelected, setRawSelected] = (0, import_react133.useState)([]);
  const selected = maybeSelected ?? rawSelected;
  const onSelect = (0, import_react133.useCallback)(
    /** This index is with respect to the input `Props["data"]` array. */
    (index) => {
      const { diff, next } = selected.includes(index) ? {
        diff: {
          index,
          selected: false
        },
        next: selected.filter((i) => i !== index)
      } : index === import_uik752.utils.clamp(index, [0, dataLength - 1]) ? {
        diff: {
          index,
          selected: true
        },
        next: [...selected, index]
      } : {
        diff: {
          index: -1,
          selected: false
        },
        next: []
      };
      onSelectedChange?.(next, diff);
      setRawSelected(next);
    },
    [selected, onSelectedChange]
  );
  (0, import_react133.useEffect)(
    () => import_uik752.utils.addEventListener(
      selectedClearedOnOutsideClick && document.body,
      "click",
      (event) => !event.defaultPrevented && onSelect(-1)
    ),
    [onSelect, selectedClearedOnOutsideClick]
  );
  return {
    onSelect,
    selected
  };
}, "useSelected");

// TimelineBar/useTooltip/useTooltip.ts
var import_uik757 = require("@appd/uik");
var import_react136 = require("react");

// TimelineBar/useTooltip/getStyles.ts
var import_uik753 = require("@appd/uik");
var {
  COLORS: { CONTROL_BORDER: CONTROL_BORDER21, DEFAULT_BG_WEAK: DEFAULT_BG_WEAK5, DEFAULT_TEXT: DEFAULT_TEXT34 },
  EFFECTS: { SHAODW_LIFTED: SHAODW_LIFTED4 },
  RADIUS: RADIUS26,
  SPACING: SPACING48
} = import_uik753.MAGNETIC_TOKENS;
var getStyles42 = /* @__PURE__ */ __name((display) => (0, import_uik753.css)({
  ...display ? {} : { display: "none" },
  backgroundColor: DEFAULT_BG_WEAK5,
  border: `2px solid ${CONTROL_BORDER21}`,
  borderRadius: RADIUS26.HEAVY,
  boxShadow: SHAODW_LIFTED4,
  color: DEFAULT_TEXT34,
  margin: SPACING48[1],
  padding: SPACING48[3],
  pointerEvents: "none",
  width: 207
}), "getStyles");

// TimelineBar/useTooltip/getValue/getIntervalValue.tsx
var import_uik754 = require("@appd/uik");
var import_react134 = require("react");

// TimelineBar/useTooltip/getValue/isInRange.ts
var isInRange = /* @__PURE__ */ __name((activeIndex, intervals, active = intervals.find(({ index }) => index === activeIndex) ?? {
  from: Infinity,
  index: Infinity,
  status: {
    color: "",
    name: "",
    priority: 0
  },
  until: -Infinity
}) => ({ from: from2, index, status: { priority }, until }) => {
  const empty = from2 === until;
  const intersects = {
    from: from2 >= active.from && (from2 < active.until || empty),
    until: until > active.from && until <= active.until
  };
  const covered = priority < active.status.priority || priority === active.status.priority && index < active.index;
  const same = index === active.index;
  return covered && (intersects.from || intersects.until) || same;
}, "isInRange");

// TimelineBar/useTooltip/getValue/getIntervalValue.tsx
var import_jsx_runtime542 = require("react/jsx-runtime");
var getIntervalValue = /* @__PURE__ */ __name((intervals, activeIndex, showDate, twelveHour) => {
  const activeIntervals = intervals.filter(isInRange(activeIndex, intervals));
  if (activeIntervals.length === 1) {
    const [
      {
        from: from2,
        status: { color: color2, icon, name },
        until
      }
    ] = activeIntervals;
    return [
      /* @__PURE__ */ (0, import_jsx_runtime542.jsxs)(import_react134.Fragment, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime542.jsx)("div", { className: (0, import_uik754.css)({ font: P4_EMPHASIS4 }), children: `${import_uik754.format.dateTime(from2, {
          ...showDate && {
            day: "numeric",
            month: "numeric"
          },
          hour: "numeric",
          minute: "numeric",
          twentyFourHour: !twelveHour
        })} - ${import_uik754.format.dateTime(until, {
          ...showDate && {
            day: "numeric",
            month: "numeric"
          },
          hour: "numeric",
          minute: "numeric",
          twentyFourHour: !twelveHour
        })}` }),
        /* @__PURE__ */ (0, import_jsx_runtime542.jsxs)(
          "div",
          {
            className: (0, import_uik754.css)({
              alignItems: "center",
              display: "flex",
              marginTop: SPACING49[2]
            }),
            children: [
              icon ? /* @__PURE__ */ (0, import_jsx_runtime542.jsx)(
                import_uik754.Icon,
                {
                  className: (0, import_uik754.css)({
                    flexShrink: 0,
                    marginRight: SPACING49[2]
                  }),
                  size: "SMALL",
                  type: icon
                }
              ) : (0, import_react134.cloneElement)(HIGHCHARTS.SHAPES.CIRCLE, {
                className: (0, import_uik754.css)({
                  fill: color2,
                  flexShrink: 0,
                  height: 10,
                  margin: 4,
                  marginRight: 4 + SPACING49[2],
                  width: 10
                })
              }),
              /* @__PURE__ */ (0, import_jsx_runtime542.jsx)(
                "span",
                {
                  className: (0, import_uik754.css)({
                    flexShrink: 0,
                    font: P4_DEFAULT12
                  }),
                  children: name
                }
              )
            ]
          }
        )
      ] }, 0)
    ];
  }
  return [...import_uik754.utils.group(activeIntervals).by(({ status: { name } }) => name)].sort(byDescendingPriority).map(([name, intervals2], i) => /* @__PURE__ */ (0, import_jsx_runtime542.jsxs)(import_react134.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime542.jsx)(
      "div",
      {
        className: (0, import_uik754.css)(
          i && {
            font: P4_DEFAULT12,
            marginTop: SPACING49[3]
          }
        ),
        children: name
      }
    ),
    intervals2.sort(({ from: a }, { from: b }) => a - b).map(({ from: from2, status: { color: color2, icon }, until }, j) => /* @__PURE__ */ (0, import_jsx_runtime542.jsxs)(
      "div",
      {
        className: (0, import_uik754.css)({
          alignItems: "center",
          display: "flex",
          marginTop: SPACING49[2]
        }),
        children: [
          icon ? /* @__PURE__ */ (0, import_jsx_runtime542.jsx)(
            import_uik754.Icon,
            {
              className: (0, import_uik754.css)({
                flexShrink: 0,
                marginRight: SPACING49[2]
              }),
              size: "SMALL",
              type: icon
            }
          ) : (0, import_react134.cloneElement)(HIGHCHARTS.SHAPES.CIRCLE, {
            className: (0, import_uik754.css)({
              fill: color2,
              flexShrink: 0,
              height: 10,
              margin: 4,
              marginRight: 4 + SPACING49[2],
              width: 10
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime542.jsxs)(
            "span",
            {
              className: (0, import_uik754.css)({
                flexShrink: 0,
                font: P4_DEFAULT12
              }),
              children: [
                import_uik754.format.time(from2),
                " - ",
                import_uik754.format.time(until)
              ]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime542.jsx)(import_uik754.Tooltip, { showOnOverflowOnly: true, value: import_uik754.format.duration(until - from2, { unitDisplay: "short" }), children: /* @__PURE__ */ (0, import_jsx_runtime542.jsx)(
            "span",
            {
              className: (0, import_uik754.css)({ font: P4_DEFAULT12 }, ELLIPSES22.END, {
                marginLeft: "auto",
                paddingLeft: SPACING49[4]
              }),
              children: import_uik754.format.duration(until - from2, { unitDisplay: "short" })
            }
          ) })
        ]
      },
      j
    ))
  ] }, i));
}, "getIntervalValue");
var {
  SPACING: SPACING49,
  TYPOGRAPHY: { ELLIPSES: ELLIPSES22, P4_DEFAULT: P4_DEFAULT12, P4_EMPHASIS: P4_EMPHASIS4 }
} = import_uik754.MAGNETIC_TOKENS;

// TimelineBar/useTooltip/getValue/getPointValue.tsx
var import_uik755 = require("@appd/uik");
var import_react135 = require("react");
var import_jsx_runtime543 = require("react/jsx-runtime");
var getPointValue = /* @__PURE__ */ __name((points, activeIndex, showDate) => {
  const maybePoint = points.find(({ index }) => index === activeIndex);
  if (!maybePoint) {
    return;
  }
  const { label, timestamp, value } = maybePoint;
  return [
    /* @__PURE__ */ (0, import_jsx_runtime543.jsxs)(import_react135.Fragment, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime543.jsx)("div", { className: (0, import_uik755.css)({ font: P4_EMPHASIS5 }), children: import_uik755.format.dateTime(timestamp, {
        ...showDate && {
          day: "numeric",
          month: "numeric"
        },
        hour: "numeric",
        minute: "numeric"
      }) }),
      /* @__PURE__ */ (0, import_jsx_runtime543.jsxs)(
        "div",
        {
          className: (0, import_uik755.css)({
            alignItems: "center",
            display: "flex",
            marginTop: SPACING50[2]
          }),
          children: [
            label && typeof label === "object" ? label : /* @__PURE__ */ (0, import_jsx_runtime543.jsx)(
              "span",
              {
                className: (0, import_uik755.css)({
                  flexShrink: 0,
                  font: P4_DEFAULT13
                }),
                children: label
              }
            ),
            value && typeof value === "object" ? value : /* @__PURE__ */ (0, import_jsx_runtime543.jsx)(
              "span",
              {
                className: (0, import_uik755.css)(ELLIPSES23.END, {
                  font: P4_DEFAULT13,
                  marginLeft: "auto",
                  paddingLeft: SPACING50[4]
                }),
                children: value
              }
            )
          ]
        }
      )
    ] }, 0)
  ];
}, "getPointValue");
var {
  SPACING: SPACING50,
  TYPOGRAPHY: { ELLIPSES: ELLIPSES23, P4_DEFAULT: P4_DEFAULT13, P4_EMPHASIS: P4_EMPHASIS5 }
} = import_uik755.MAGNETIC_TOKENS;

// TimelineBar/useTooltip/getValue/getValue.tsx
var getValue = /* @__PURE__ */ __name(({ activeIndex, enable: { tooltip }, intervals, points, twelveHour = true }) => getPointValue(points, activeIndex, tooltip.date) ?? getIntervalValue(intervals, activeIndex, tooltip.date, twelveHour), "getValue");

// TimelineBar/useTooltip/REDUCERS/$INITIAL_STATE.ts
var import_uik756 = require("@appd/uik");

// TimelineBar/useTooltip/REDUCERS/getPositioner.ts
var getPositioner2 = /* @__PURE__ */ __name((rect) => ({ defaultPositioner: defaultPositioner2, measurements, ...rest }) => defaultPositioner2({
  ...rest,
  measurements: {
    ...measurements,
    trigger: {
      ...measurements.trigger,
      ...rect,
      height: rect.height + 2 * /* interval outline width */
      3,
      y: rect.y - /* interval outline width */
      3
    }
  },
  position: "BOTTOM"
}), "getPositioner");

// TimelineBar/useTooltip/REDUCERS/$INITIAL_STATE.ts
var $INITIAL_STATE2 = {
  index: -1,
  position: getPositioner2(import_uik756.utils.getBoundingClientRect.ZEROS.toJSON()),
  rect: import_uik756.utils.getBoundingClientRect.ZEROS.toJSON(),
  visible: false
};

// TimelineBar/useTooltip/REDUCERS/REDUCERS.ts
var REDUCERS2 = {
  $INITIAL_STATE: $INITIAL_STATE2,
  HIDE: (old) => ({
    ...old,
    visible: false
  }),
  SHOW: (_, next) => ({
    ...next,
    position: getPositioner2(next.rect),
    visible: true
  })
};

// TimelineBar/useTooltip/useTooltip.ts
var useTooltip4 = /* @__PURE__ */ __name(({ enable, intervals, points, twelveHour = true }) => {
  const [state, dispatch] = import_uik757.utils.useReducer(REDUCERS2);
  const value = (0, import_react136.useMemo)(
    () => getValue({
      activeIndex: state.index,
      enable,
      intervals,
      points,
      twelveHour
    }),
    [enable, intervals, points, state.index]
  );
  return {
    dispatch,
    props: {
      className: getStyles42(enable.tooltip.enable),
      position: state.position,
      value,
      visible: state.visible
    },
    state
  };
}, "useTooltip");

// TimelineBar/TimelineBar.tsx
var import_jsx_runtime544 = require("react/jsx-runtime");
var TimelineBar = import_uik758.utils.forwardRef(
  ({
    animate,
    buffer,
    className: className2,
    data,
    enable,
    legend: rawLegend = false,
    onSelectedChange,
    onTimeRange,
    selected: rawSelected,
    selectedClearedOnOutsideClick,
    timeFormat,
    timeRange,
    title,
    ...inherited
  }, ref) => {
    const [width, setWidth] = (0, import_react137.useState)(0);
    const state = getState5(
      {
        animate,
        buffer,
        data,
        enable,
        selected: rawSelected,
        selectedClearedOnOutsideClick,
        timeFormat,
        timeRange,
        title
      },
      width
    );
    const { onSelect, selected } = useSelected({
      dataLength: data.length,
      onSelectedChange,
      selected: state.selected,
      selectedClearedOnOutsideClick: state.selectedClearedOnOutsideClick
    });
    (0, import_react137.useEffect)(() => onTimeRange?.(state.timeRange), [state.timeRange.from, state.timeRange.until]);
    {
      const { bar, data: data2, gridLines, height: height2, labels, title: title2 } = getTemplate2({
        ...state,
        selected
      });
      const legend = useLegend2({
        enabled: rawLegend,
        intervals: state.intervals
      });
      const onResize2 = (0, import_react137.useCallback)(({ width: width2 }) => setWidth(width2), []);
      const ready = (() => {
        const didMount = import_uik758.utils.useDidMount();
        const fontsReady = import_uik758.utils.useFontsReady();
        const highchartsReady = HIGHCHARTS.use();
        return didMount && fontsReady && highchartsReady;
      })();
      const styles = getStyles41(state.animate);
      const tooltip = useTooltip4({
        enable: state.enable,
        intervals: state.intervals,
        points: state.points,
        twelveHour: timeFormat?.twelveHour ?? true
      });
      return /* @__PURE__ */ (0, import_jsx_runtime544.jsx)(import_uik758.Tooltip, { ...tooltip.props, children: /* @__PURE__ */ (0, import_jsx_runtime544.jsx)(import_uik758.Measurer, { onResize: onResize2, children: /* @__PURE__ */ (0, import_jsx_runtime544.jsxs)(
        "div",
        {
          className: (0, import_uik758.css)(styles, ...import_uik758.utils.many(className2)),
          onPointerLeave: () => tooltip.dispatch("HIDE"),
          ref,
          uik: "TimelineBar",
          ...inherited,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime544.jsx)("svg", { height: height2, width: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime544.jsx)("g", { className: "__axis", children: ready && gridLines.x.map((_, i) => /* @__PURE__ */ (0, import_jsx_runtime544.jsxs)(import_react137.Fragment, { children: [
              /* @__PURE__ */ (0, import_jsx_runtime544.jsx)(
                "line",
                {
                  className: (0, import_uik758.css)(gridLines.hidden && "__hidden", "__grid-line"),
                  style: { animationDelay: gridLines.animationDelay[i] },
                  x1: gridLines.x[i],
                  x2: gridLines.x[i],
                  y1: gridLines.y1,
                  y2: gridLines.y2
                }
              ),
              /* @__PURE__ */ (0, import_jsx_runtime544.jsx)(
                "text",
                {
                  className: (0, import_uik758.css)(labels.hidden && "__hidden", "__label"),
                  style: { animationDelay: labels.animationDelay[i] },
                  x: labels.x[i],
                  y: labels.y,
                  children: labels.textContent[i]
                }
              )
            ] }, i)) }) }),
            /* @__PURE__ */ (0, import_jsx_runtime544.jsxs)(
              "div",
              {
                className: (0, import_uik758.css)(bar.hidden && "__hidden", "__bar"),
                style: {
                  animationDelay: bar.animationDelay,
                  top: bar.top,
                  width: bar.width
                },
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime544.jsx)("div", { className: "__background" }),
                  ready && data2.map(({ className: className3, index, selected: selected2 }) => /* @__PURE__ */ (0, import_jsx_runtime544.jsx)(
                    "div",
                    {
                      className: className3,
                      onClick: (event) => {
                        state.selectedClearedOnOutsideClick && // Don't count as an "outside click".
                        event.stopPropagation();
                        onSelect(index);
                      },
                      onKeyDown: (event) => event.key === " " && event.preventDefault(),
                      onKeyUp: ({ currentTarget, key }) => import_uik758.utils.maybeGet(
                        {
                          " ": () => onSelect(index),
                          Enter: () => onSelect(index),
                          Escape: () => {
                            selected2 && onSelect(-1);
                            currentTarget.blur();
                          }
                        },
                        key
                      )?.(),
                      onPointerEnter: ({ currentTarget }) => tooltip.dispatch("SHOW", {
                        index,
                        rect: import_uik758.utils.getBoundingClientRect(currentTarget)
                      }),
                      tabIndex: 0
                    },
                    index
                  ))
                ]
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime544.jsx)(import_uik758.Tooltip, { style: { pointerEvents: "none" }, value: title2.tooltip, children: /* @__PURE__ */ (0, import_jsx_runtime544.jsx)("div", { className: title2.className, children: ready && title2.textContent }) }),
            legend && (0, import_react137.cloneElement)(legend, { onPointerEnter: () => tooltip.dispatch("HIDE") })
          ]
        }
      ) }) });
    }
  }
);
TimelineBar.displayName = "TimelineBar";
TimelineBar.__DEV_METADATA__ = { status: "READY" };

// TimePicker/TimePicker.tsx
var import_uik759 = require("@appd/uik");
var import_jsx_runtime545 = require("react/jsx-runtime");
var TimePicker2 = import_uik759.utils.forwardRef(({ ...props2 }, forwardedRef) => /* @__PURE__ */ (0, import_jsx_runtime545.jsx)(import_uik759.DateTimePicker.CONTEXT.Provider, { value: { timeOnly: true }, children: /* @__PURE__ */ (0, import_jsx_runtime545.jsx)(import_uik759.DateTimePicker, { ref: forwardedRef, ...props2 }) }));
TimePicker2.displayName = "TimePicker";
TimePicker2.__DEV_METADATA__ = { status: "READY" };

// TimeRangeSelector/TimeRangeSelector.tsx
var import_uik762 = require("@appd/uik");
var import_luxon13 = require("luxon");
var import_react138 = require("react");

// TimeRangeSelector/MESSAGES.ts
var MESSAGES21 = {
  APPLY: format.message`Apply`.description("A button that applies the custom time range to the selected time range."),
  CUSTOM: format.message`Custom`.description("Tab for custom time ranges"),
  SINCE: format.message`Since`.description("Indicates the start point of the custom time range"),
  SINCE_BEFORE_UNTIL_ERROR: format.message`Since must be before Until`.description(
    "An error is shown in the time range selector if the since value is not before the until value"
  ),
  STANDARD: format.message`Standard`.description("Tab for predefined time ranges"),
  UNTIL: format.message`Until`.description("Indicates the end point of the custom time range.")
};

// TimeRangeSelector/parse.ts
var import_luxon12 = require("luxon");

// TimeRangeSelector/getDurationFromRelativeTimeRange/getDurationFromRelativeTimeRange.ts
var import_luxon11 = require("luxon");

// TimeRangeSelector/getDurationFromRelativeTimeRange/splitTimeDuration.ts
var splitTimeDuration = /* @__PURE__ */ __name((duration2) => {
  const valueArr = duration2.match(/\d+/g);
  const unitArr = duration2.match(/[a-zA-Z]+/g);
  if (valueArr && unitArr) {
    return {
      unit: unitArr[0],
      value: +valueArr[0]
    };
  }
  throw Error(`The TimeRange was in the wrong format. Want 'xUNIT'. Example: 2w`);
}, "splitTimeDuration");

// TimeRangeSelector/getDurationFromRelativeTimeRange/splitTimeSelectorOption.ts
var splitTimeSelectorOption = /* @__PURE__ */ __name((option) => {
  const untilReg = option.match(
    /(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}|\d{2}\.\d{3})([Z]|[+-](\d{2}):(\d{2}))|now/g
  );
  const until = untilReg != null ? untilReg[0].replace(/\s/g, "") : void 0;
  const sinceReg = option.match(/[+-]([0-9]+w)?[ ]*([0-9]+d)?[ ]*([0-9]+h)?[ ]*([0-9]+m)?\b/g);
  const since = sinceReg != null ? sinceReg[0].replace(/\s/g, "") : void 0;
  if (since == null) {
    throw Error(`The TimeRangeOption was in the wrong format. Must match format - example: now -1w.`);
  }
  return {
    since,
    until
  };
}, "splitTimeSelectorOption");

// TimeRangeSelector/getDurationFromRelativeTimeRange/getDurationFromRelativeTimeRange.ts
var getDurationFromRelativeTimeRange = /* @__PURE__ */ __name((relativeTimeRange) => {
  const { since } = splitTimeSelectorOption(relativeTimeRange);
  const { unit: unit2, value } = splitTimeDuration(since);
  switch (true) {
    case unit2 === "m":
      return import_luxon11.Duration.fromObject({ minutes: value });
    case unit2 === "h":
      return import_luxon11.Duration.fromObject({ hours: value });
    case unit2 === "d":
      return import_luxon11.Duration.fromObject({ days: value });
    case unit2 === "w":
      return import_luxon11.Duration.fromObject({ weeks: value });
    default:
      throw Error("The unit of the time object was not 'm' | 'h' | 'd' | 'w'.");
  }
}, "getDurationFromRelativeTimeRange");

// TimeRangeSelector/parse.ts
var parse2 = /* @__PURE__ */ __name((timeRange) => {
  if (timeRange.until == void 0) {
    const duration2 = getDurationFromRelativeTimeRange(timeRange.since);
    const now = import_luxon12.DateTime.now();
    return {
      since: now.minus(duration2).toUTC().toMillis(),
      until: now.toUTC().toMillis()
    };
  }
  return {
    since: import_luxon12.DateTime.fromISO(timeRange.since).toUTC().toMillis(),
    until: import_luxon12.DateTime.fromISO(timeRange.until).toUTC().toMillis()
  };
}, "parse");

// TimeRangeSelector/STANDARD_OPTIONS.ts
var STANDARD_OPTIONS = [
  {
    label: "5 Minutes",
    value: { since: "now -5m" }
  },
  {
    label: "15 Minutes",
    value: { since: "now -15m" }
  },
  {
    label: "30 Minutes",
    value: { since: "now -30m" }
  },
  {
    label: "1 Hour",
    value: { since: "now -1h" }
  },
  {
    label: "6 Hours",
    value: { since: "now -6h" }
  },
  {
    label: "1 Day",
    value: { since: "now -1d" }
  },
  {
    label: "1 Week",
    value: { since: "now -1w" }
  },
  {
    label: "1 Month",
    value: { since: "now -30d" }
  },
  {
    label: "3 Months",
    value: { since: "now -90d" }
  },
  {
    label: "6 Months",
    value: { since: "now -180d" }
  },
  {
    label: "12 Months",
    value: { since: "now -360d" }
  }
];

// TimeRangeSelector/STYLES.ts
var import_uik760 = require("@appd/uik");
var {
  COLORS: { CONTROL_BORDER: CONTROL_BORDER22, DEFAULT_TEXT: DEFAULT_TEXT35, NEGATIVE_TEXT: NEGATIVE_TEXT2 },
  RADIUS: RADIUS27,
  SPACING: SPACING51,
  TYPOGRAPHY: { P4_EMPHASIS: P4_EMPHASIS6 }
} = import_uik760.MAGNETIC_TOKENS;
var TAB_STYLES = import_uik760.css.Styles({
  CONTENT: import_uik760.css.Styles({
    flex: "1",
    overflow: "auto"
  }),
  display: "flex",
  flexDirection: "column",
  height: "100%",
  width: "100%"
});
var CUSTOM_STYLES = import_uik760.css.Styles({
  APPLY: import_uik760.css.Styles({
    float: "right",
    margin: `${SPACING51[2]}px ${SPACING51[4]}px ${SPACING51[4]}px 0`
  }),
  CONTAINER: import_uik760.css.Styles({
    LABEL: import_uik760.css.Styles({
      color: DEFAULT_TEXT35,
      font: P4_EMPHASIS6,
      marginBottom: SPACING51[1]
    }),
    PICKER: import_uik760.css.Styles({ width: 200 }),
    alignItems: "center",
    marginTop: SPACING51[4]
  }),
  ERROR: import_uik760.css.Styles({
    color: NEGATIVE_TEXT2,
    marginTop: SPACING51[2]
  }),
  margin: `${SPACING51[3]}px ${SPACING51[3]}px 0 ${SPACING51[6]}px`
});
var POPOVER = (0, import_uik760.css)({
  border: `2px solid ${CONTROL_BORDER22}`,
  borderRadius: RADIUS27.HEAVY,
  boxSizing: "border-box",
  marginBlock: SPACING51[1]
});
var POPOVER_CONTENT = (0, import_uik760.css)({
  boxShadow: "none",
  padding: 0,
  width: "280px"
});
var STYLES45 = {
  CUSTOM_STYLES,
  POPOVER,
  POPOVER_CONTENT,
  TAB_STYLES
};

// TimeRangeSelector/Trigger.tsx
var import_uik761 = require("@appd/uik");
var import_jsx_runtime546 = require("react/jsx-runtime");
var Trigger = import_uik761.utils.forwardRef(({ iconColor, onClick, selected, ...props2 }, ref) => /* @__PURE__ */ (0, import_jsx_runtime546.jsxs)(
  "button",
  {
    className: (0, import_uik761.css)({
      "&:hover": { border: `2px solid ${CONTROL_BORDER_HOVER9}` },
      all: void 0,
      ...ELLIPSES24.END,
      alignItems: "center",
      background: "none",
      border: `2px solid ${CONTROL_BORDER23}`,
      borderRadius: RADIUS28.HEAVY,
      color: iconColor ? iconColor : DEFAULT_TEXT36,
      cursor: "pointer",
      display: "flex",
      font: P4_DEFAULT14,
      gap: SPACING52[2],
      justifyContent: "center",
      paddingBlock: SPACING52[1],
      paddingInline: SPACING52[2],
      userSelect: "none"
      // I removed the padding here because it results in non-uniform visual spacing among the top-nav buttons.
      // The problem was pre-existing in levitate-ui.
      // We can confirm with designers what the intended look is, but I'm fairly certain the non-uniform white space is a
      // a bug that shouldn't be copied over to next-ui.
      // -Spencer Yue
      // (Feel free to remove this message if "whether to have padding here" is resolved.)
    }),
    ref,
    ...props2,
    onClick,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime546.jsx)(
        import_uik761.Icon.Object.Clock,
        {
          className: (0, import_uik761.css)({
            height: 15,
            width: 15
          }),
          fill: iconColor ? iconColor : CONTROL_ICON_WEAK10
        }
      ),
      selected
    ]
  }
));
Trigger.displayName = "TimeRangeSelector.Trigger";
var {
  COLORS: { CONTROL_BORDER: CONTROL_BORDER23, CONTROL_BORDER_HOVER: CONTROL_BORDER_HOVER9, CONTROL_ICON_WEAK: CONTROL_ICON_WEAK10, DEFAULT_TEXT: DEFAULT_TEXT36 },
  RADIUS: RADIUS28,
  SPACING: SPACING52,
  TYPOGRAPHY: { ELLIPSES: ELLIPSES24, P4_DEFAULT: P4_DEFAULT14 }
} = import_uik761.MAGNETIC_TOKENS;

// TimeRangeSelector/TimeRangeSelector.tsx
var import_jsx_runtime547 = require("react/jsx-runtime");
var TimeRangeSelector = Object.assign(
  import_uik762.utils.forwardRef(
    ({
      className: className2,
      displayFormat,
      onSelectedTimeRangeChanged,
      position: __UNIMPLEMENTED__,
      selectedTimeRange,
      triggerIconColor,
      ...props2
    }, ref) => {
      if (__UNIMPLEMENTED__ && __UNIMPLEMENTED__ !== "bottom" && import_uik762.utils.IS_DEV_MODE) {
        console.warn("[uik] TimeRangeSelector: Only 'bottom' position is implemented");
      }
      const [tabSelected, setTabSelected] = (0, import_react138.useState)(0);
      const onTabSelectedChange = /* @__PURE__ */ __name((_selected) => {
        setTabSelected(_selected);
      }, "onTabSelectedChange");
      const [sinceVisible, setSinceVisible] = (0, import_react138.useState)(false);
      const [untilVisible, setUntilVisible] = (0, import_react138.useState)(false);
      const [error, setError] = (0, import_react138.useState)("");
      const triggerRef = (0, import_react138.useRef)(null);
      const overlayRef = (0, import_react138.useRef)(null);
      const options = STANDARD_OPTIONS;
      const findOptionIndex = /* @__PURE__ */ __name(() => options.findIndex(
        (option) => JSON.stringify(option.value).replace(/\s/g, "") === JSON.stringify(selectedTimeRange).replace(/\s/g, "")
      ), "findOptionIndex");
      const getISO = /* @__PURE__ */ __name((timestamp) => import_luxon13.DateTime.fromMillis(timestamp).setZone("UTC").toISO(), "getISO");
      const getNewCustomTimeRange = /* @__PURE__ */ __name(({
        since,
        until
      }) => ({
        since: getISO(since),
        until: getISO(until)
      }), "getNewCustomTimeRange");
      const parsedTimeRange = parse2(selectedTimeRange);
      const [sinceTimestamp, setSinceTimestamp] = (0, import_react138.useState)(parsedTimeRange.since);
      const [untilTimestamp, setUntilTimestamp] = (0, import_react138.useState)(parsedTimeRange.until);
      const [visible, setVisible] = (0, import_react138.useState)(false);
      (0, import_react138.useEffect)(() => {
        if (visible) {
          setTimeout(() => {
            import_uik762.utils.focusFirst(overlayRef);
          });
        }
      }, [visible]);
      const onCustomApply = /* @__PURE__ */ __name(() => {
        if (sinceTimestamp >= untilTimestamp) {
          setError(MESSAGES21.SINCE_BEFORE_UNTIL_ERROR);
        } else {
          setError("");
          onSelectedTimeRangeChanged?.(
            getNewCustomTimeRange({
              since: sinceTimestamp,
              until: untilTimestamp
            })
          );
        }
      }, "onCustomApply");
      const onKeyUp = /* @__PURE__ */ __name((event) => {
        if (event.key === "Escape" && !sinceVisible && !untilVisible) {
          setVisible(false);
          setTimeout(() => {
            triggerRef.current?.focus();
          });
        }
      }, "onKeyUp");
      const {
        CUSTOM_STYLES: {
          APPLY,
          CONTAINER: { LABEL: LABEL7, PICKER, ...CONTAINER7 },
          ERROR,
          ...CUSTOM
        },
        POPOVER: POPOVER2,
        POPOVER_CONTENT: POPOVER_CONTENT2,
        TAB_STYLES: { CONTENT: CONTENT4, ...TAB }
      } = STYLES45;
      const trigger = /* @__PURE__ */ (0, import_jsx_runtime547.jsx)(
        Trigger,
        {
          iconColor: triggerIconColor,
          onClick: () => {
            setVisible(!visible);
          },
          ref: triggerRef,
          selected: findOptionIndex() !== -1 ? `Last ${options[findOptionIndex()].label}` : `${import_uik762.format.dateTime(selectedTimeRange.since)} - ${import_uik762.format.dateTime(selectedTimeRange.until ?? "")}`
        }
      );
      const tabs = [
        {
          content: /* @__PURE__ */ (0, import_jsx_runtime547.jsx)(
            import_uik762.Menu.List,
            {
              onSelect: (next) => {
                setVisible(false);
                const newTimeRange = options[next[0]]?.value;
                const { since, until } = parse2(newTimeRange);
                setSinceTimestamp(since);
                setUntilTimestamp(until);
                onSelectedTimeRangeChanged?.(newTimeRange);
                setTimeout(() => {
                  triggerRef.current?.focus();
                });
              },
              selected: findOptionIndex(),
              children: options.map((option) => /* @__PURE__ */ (0, import_jsx_runtime547.jsx)(import_uik762.Menu.Option, { children: option.label }, `option-${option.label}`))
            }
          ),
          value: MESSAGES21.STANDARD()
        },
        {
          content: /* @__PURE__ */ (0, import_jsx_runtime547.jsxs)("div", { className: (0, import_uik762.css)(CUSTOM), children: [
            /* @__PURE__ */ (0, import_jsx_runtime547.jsxs)("div", { className: (0, import_uik762.css)(CONTAINER7), children: [
              /* @__PURE__ */ (0, import_jsx_runtime547.jsx)("div", { className: (0, import_uik762.css)(LABEL7), children: MESSAGES21.SINCE() }),
              /* @__PURE__ */ (0, import_jsx_runtime547.jsx)(
                import_uik762.DateTimePicker,
                {
                  className: (0, import_uik762.css)(PICKER),
                  displayFormat,
                  onTimestampChange: setSinceTimestamp,
                  overlay: true,
                  required: true,
                  timestamp: sinceTimestamp
                }
              )
            ] }),
            /* @__PURE__ */ (0, import_jsx_runtime547.jsxs)("div", { className: (0, import_uik762.css)(CONTAINER7), children: [
              /* @__PURE__ */ (0, import_jsx_runtime547.jsx)("div", { className: (0, import_uik762.css)(LABEL7), children: MESSAGES21.UNTIL() }),
              /* @__PURE__ */ (0, import_jsx_runtime547.jsx)(
                import_uik762.DateTimePicker,
                {
                  className: (0, import_uik762.css)(PICKER),
                  displayFormat,
                  onTimestampChange: setUntilTimestamp,
                  overlay: true,
                  required: true,
                  timestamp: untilTimestamp
                }
              )
            ] }),
            error && /* @__PURE__ */ (0, import_jsx_runtime547.jsx)("div", { className: (0, import_uik762.css)(ERROR), children: error }),
            /* @__PURE__ */ (0, import_jsx_runtime547.jsx)(import_uik762.Button, { className: (0, import_uik762.css)(APPLY), onClick: onCustomApply, children: MESSAGES21.APPLY() })
          ] }),
          value: MESSAGES21.CUSTOM()
        }
      ];
      const content = /* @__PURE__ */ (0, import_jsx_runtime547.jsxs)("div", { className: (0, import_uik762.css)(TAB), onKeyUp, ref: overlayRef, children: [
        /* @__PURE__ */ (0, import_jsx_runtime547.jsx)(import_uik762.TabList, { kind: "SECONDARY", onSelectedChange: onTabSelectedChange, selected: tabSelected, children: tabs.map(({ value }) => /* @__PURE__ */ (0, import_jsx_runtime547.jsx)("div", { children: value }, value)) }),
        /* @__PURE__ */ (0, import_jsx_runtime547.jsx)(
          "div",
          {
            className: (0, import_uik762.css)(CONTENT4),
            onClick: () => {
              setSinceVisible(false);
              setUntilVisible(false);
            },
            children: tabs[tabSelected].content
          }
        )
      ] });
      return /* @__PURE__ */ (0, import_jsx_runtime547.jsx)("div", { className: (0, import_uik762.css)(...import_uik762.utils.many(className2)), ref, uik: "TimeRangeSelector", ...props2, children: /* @__PURE__ */ (0, import_jsx_runtime547.jsx)(
        import_uik762.Popover,
        {
          arrow: false,
          className: POPOVER2,
          content,
          contentClassName: POPOVER_CONTENT2,
          onVisibleChange: setVisible,
          position: "BOTTOM",
          trigger: "CLICK",
          visible,
          children: trigger
        }
      ) });
    }
  ),
  { parse: parse2 }
);
TimeRangeSelector.displayName = "TimeRangeSelector";
TimeRangeSelector.__DEV_METADATA__ = { status: "READY" };

// toast/Provider.tsx
var import_uik767 = require("@appd/uik");
var import_react141 = require("react");

// toast/QUEUE.tsx
var import_uik763 = require("@appd/uik");
var QUEUE = import_uik763.utils.mutable(
  [],
  (next, QUEUE2, key = +(import_uik763.utils.maybeGet(QUEUE2()[0], "key") ?? 0) + 1) => "DELETE" in next ? QUEUE2().filter(({ key: key2 }) => key2 !== next.DELETE) : [
    {
      ...next,
      key,
      onClose: () => QUEUE2.set({ DELETE: key })
    },
    ...QUEUE2()
  ]
);

// toast/Toast/Toast.tsx
var import_uik766 = require("@appd/uik");
var import_react140 = require("react");

// toast/Toast/getStyles.tsx
var import_uik764 = require("@appd/uik");
var {
  COLORS: {
    DEFAULT_TEXT: DEFAULT_TEXT37,
    INFO_BG_WEAK: INFO_BG_WEAK2,
    INFO_BORDER: INFO_BORDER3,
    INTERACT_ICON_WEAK: INTERACT_ICON_WEAK11,
    NEGATIVE_BORDER: NEGATIVE_BORDER4,
    POSITIVE_BORDER: POSITIVE_BORDER3,
    WARNING_BORDER: WARNING_BORDER3
  },
  EFFECT: {
    SHADOW: { DEFAULT: DEFAULT2 }
  },
  RADIUS: RADIUS29,
  SPACING: SPACING53,
  TYPOGRAPHY: { ELLIPSES: ELLIPSES25, LINE_HEIGHT_P3: LINE_HEIGHT_P32, P3_DEFAULT: P3_DEFAULT19, P3_EMPHASIS: P3_EMPHASIS13 }
} = import_uik764.MAGNETIC_TOKENS;
var getStyles43 = /* @__PURE__ */ __name((icon = "INFO") => import_uik764.css.Styles({
  BUTTONS: (0, import_uik764.css)({
    display: "flex",
    flexDirection: "column",
    gap: SPACING53[1],
    justifyContent: "space-between",
    marginLeft: "auto"
  }),
  BUTTON_ICON: (0, import_uik764.css)({
    ":first-child:not(:last-child)": { marginBottom: 0 },
    ":last-child:not(:first-child)": { marginTop: 0 },
    '> [uik^="Icon"]': {
      "> path": { fill: INTERACT_ICON_WEAK11 },
      height: 18,
      width: 18
    },
    backgroundColor: INFO_BG_WEAK2,
    height: 24,
    marginBlock: -3,
    minHeight: 24,
    minWidth: 24,
    width: 24
  }),
  DESCRIPTION: (0, import_uik764.css)({
    boxSizing: "content-box",
    font: P3_DEFAULT19,
    lineHeight: LINE_HEIGHT_P32,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    wordWrap: "break-word"
  }),
  HOST: (0, import_uik764.css)({
    backgroundColor: INFO_BG_WEAK2,
    borderLeft: `6px solid ${typeof icon == "string" ? {
      ERROR: NEGATIVE_BORDER4,
      INFO: INFO_BORDER3,
      SUCCESS: POSITIVE_BORDER3,
      WARNING: WARNING_BORDER3
    }[icon] ?? INFO_BORDER3 : INFO_BORDER3}`,
    borderRadius: RADIUS29.HEAVY,
    boxShadow: DEFAULT2,
    boxSizing: "border-box",
    color: DEFAULT_TEXT37,
    display: "flex",
    font: P3_DEFAULT19,
    gap: SPACING53[1],
    maxHeight: 160,
    maxWidth: 467,
    minHeight: 20,
    overflow: "hidden",
    padding: SPACING53[4]
  }),
  ICON: (0, import_uik764.css)({
    minHeight: 24,
    minWidth: 24
  }),
  TEXT: (0, import_uik764.css)({
    display: "flex",
    flexDirection: "column",
    gap: SPACING53[1],
    overflow: "hidden"
  }),
  TITLE: (0, import_uik764.css)({
    ...ELLIPSES25.END,
    alignItems: "center",
    font: P3_EMPHASIS13,
    minHeight: LINE_HEIGHT_P32
  })
}), "getStyles");

// toast/Toast/useCloseOnInactive.ts
var import_uik765 = require("@appd/uik");
var import_react139 = require("react");
var useCloseOnInactive = /* @__PURE__ */ __name((onClose, timeout) => {
  const [hovered, setHovered] = (0, import_react139.useState)(false);
  const id = (0, import_react139.useId)();
  import_uik765.utils.useEffect(() => {
    anyHovered.set([id, hovered]);
    return () => anyHovered.set([id, false]);
  }, [hovered]);
  (0, import_react139.useEffect)(anyHovered() ? import_uik765.utils.noop : () => import_uik765.utils.setTimeout(onClose, timeout), [anyHovered(), onClose, timeout]);
  {
    const [, rerender] = (0, import_react139.useReducer)((x) => x + 1, 0);
    (0, import_react139.useEffect)(() => anyHovered.subscribe(rerender), []);
  }
  return setHovered;
}, "useCloseOnInactive");
var anyHovered = import_uik765.utils.mutable(false, ([key, hovered]) => {
  HOVERED[hovered ? "add" : "delete"](key);
  return Boolean(HOVERED.size);
});
var HOVERED = /* @__PURE__ */ new Set();

// toast/Toast/Toast.tsx
var import_jsx_runtime548 = require("react/jsx-runtime");
var Toast = /* @__PURE__ */ __name(({ copy = false, description, icon, onClose, timeout = 3500, title, ...props2 }) => {
  const setHovered = useCloseOnInactive(onClose, timeout);
  const ref = (0, import_react140.useRef)(null);
  const copyToast = /* @__PURE__ */ __name(() => navigator.clipboard.writeText(
    ref.current?.innerText ?? `${title}: ${typeof description === "string" ? description : ""}`
  ), "copyToast");
  const isSingleRow = !copy && !description;
  const { BUTTON_ICON, BUTTONS, DESCRIPTION: DESCRIPTION3, HOST: HOST14, ICON: ICON4, TEXT: TEXT4, TITLE: TITLE4 } = getStyles43(icon);
  return /* @__PURE__ */ (0, import_jsx_runtime548.jsxs)(
    "div",
    {
      className: (0, import_uik766.css)(
        HOST14,
        isSingleRow && { alignItems: "center" },
        icon && { "> :first-child": { marginRight: SPACING54[2] } }
      ),
      onMouseEnter: () => setHovered(true),
      onMouseLeave: () => setHovered(false),
      ref,
      uik: "Toast",
      ...props2,
      children: [
        typeof icon === "string" ? /* @__PURE__ */ (0, import_jsx_runtime548.jsx)(
          import_uik766.Icon,
          {
            className: (0, import_uik766.css)(ICON4),
            size: "MEDIUM",
            type: {
              ERROR: "Health.Critical",
              INFO: "Health.InfoMessage",
              SUCCESS: "Health.Normal",
              WARNING: "Health.Warning"
            }[icon] ?? "Health.InfoMessage"
          }
        ) : icon,
        /* @__PURE__ */ (0, import_jsx_runtime548.jsxs)("div", { className: TEXT4, children: [
          /* @__PURE__ */ (0, import_jsx_runtime548.jsx)("div", { className: TITLE4, children: title }),
          description && typeof description === "string" ? /* @__PURE__ */ (0, import_jsx_runtime548.jsx)(import_uik766.ScrollBox, { className: DESCRIPTION3, containOverlays: false, children: description }) : description
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime548.jsxs)("div", { className: BUTTONS, children: [
          /* @__PURE__ */ (0, import_jsx_runtime548.jsx)(import_uik766.Button, { className: BUTTON_ICON, icon: "Navigation.Close", onClick: onClose, type: "TERTIARY" }),
          copy && /* @__PURE__ */ (0, import_jsx_runtime548.jsx)(import_uik766.Button, { className: BUTTON_ICON, icon: "Action.Copy", onClick: copyToast, type: "TERTIARY" })
        ] })
      ]
    }
  );
}, "Toast");
Toast.displayName = "Toast";
Toast.__DEV_METADATA__ = { status: "READY" };
var { SPACING: SPACING54 } = import_uik766.MAGNETIC_TOKENS;

// toast/Provider.tsx
var import_jsx_runtime549 = require("react/jsx-runtime");
var Provider5 = /* @__PURE__ */ __name(() => {
  const [toasts, setToasts] = (0, import_react141.useState)(QUEUE);
  (0, import_react141.useEffect)(() => QUEUE.subscribe(setToasts), []);
  return /* @__PURE__ */ (0, import_jsx_runtime549.jsx)(import_uik767.Overlay, { children: /* @__PURE__ */ (0, import_jsx_runtime549.jsx)(import_uik767.Overlay.Provider, { promote: 1, zIndex: Z_INDEX2, children: /* @__PURE__ */ (0, import_jsx_runtime549.jsx)("div", { className: ISOLATE5, uik: "toast.Provider", children: /* @__PURE__ */ (0, import_jsx_runtime549.jsx)("div", { className: GROUP, children: toasts.map((props2) => /* @__PURE__ */ (0, import_jsx_runtime549.jsx)(Toast, { ...props2 })) }) }) }) });
}, "Provider");
Provider5.displayName = "toast.Provider";
var { SPACING: SPACING55 } = import_uik767.MAGNETIC_TOKENS;
var WIDTH2 = 467 + 2 * SPACING55[4];
var Z_INDEX2 = 1e4;
var { GROUP, ISOLATE: ISOLATE5 } = {
  GROUP: (0, import_uik767.css)({
    '> [uik="Toast"]': { pointerEvents: "auto" },
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    gap: SPACING55[4],
    height: "fit-content",
    left: `calc(100vw - ${WIDTH2}px)`,
    padding: SPACING55[6],
    position: "sticky",
    top: 0,
    width: WIDTH2,
    zIndex: Z_INDEX2
  }),
  ISOLATE: (0, import_uik767.css)({
    height: "var(--scrollHeight)",
    left: 0,
    pointerEvents: "none",
    position: "absolute",
    top: 0,
    width: "var(--scrollWidth)"
  })
};

// toast/toast.tsx
var toast = /* @__PURE__ */ __name((props2) => {
  QUEUE.set(props2);
}, "toast");
toast.Provider = Provider5;
toast.__DEV_METADATA__ = { status: "READY" };

// Toggle/Toggle.tsx
var import_uik769 = require("@appd/uik");
var import_react142 = require("react");

// Toggle/STYLES.ts
var import_uik768 = require("@appd/uik");
var {
  COLORS: {
    CONTROL_BG_MEDIUM_ACTIVE: CONTROL_BG_MEDIUM_ACTIVE2,
    CONTROL_BG_MEDIUM_HOVER,
    CONTROL_BORDER_ACTIVE: CONTROL_BORDER_ACTIVE5,
    CONTROL_BORDER_WEAK: CONTROL_BORDER_WEAK24,
    DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM23,
    INTERACT_TEXT_WEAK_ACTIVE: INTERACT_TEXT_WEAK_ACTIVE2
  },
  RADIUS: RADIUS30
} = import_uik768.MAGNETIC_TOKENS;
var STYLES46 = {
  CHILD: (0, import_uik768.css)({
    ":hover": { backgroundColor: CONTROL_BG_MEDIUM_HOVER },
    // overwriting button border in favor of an outline, in order to prevent a breaking change on exisiting Toggle positioning
    border: "none",
    borderRadius: 0,
    color: DEFAULT_TEXT_MEDIUM23,
    outline: `2px solid ${CONTROL_BORDER_WEAK24}`
  }),
  FIRST: (0, import_uik768.css)({
    borderBottomLeftRadius: `var(--border-radius, ${RADIUS30.DEFAULT}px)`,
    borderTopLeftRadius: `var(--border-radius, ${RADIUS30.DEFAULT}px)`
  }),
  HOST: (0, import_uik768.css)({ display: "flex" }),
  LAST: (0, import_uik768.css)({
    borderBottomRightRadius: `var(--border-radius, ${RADIUS30.DEFAULT}px)`,
    borderTopRightRadius: `var(--border-radius, ${RADIUS30.DEFAULT}px)`
  }),
  NOT_FIRST: (0, import_uik768.css)({ marginLeft: 1 }),
  NOT_LAST: (0, import_uik768.css)({ marginRight: 1 }),
  SELECTED: (0, import_uik768.css)({
    backgroundColor: CONTROL_BG_MEDIUM_ACTIVE2,
    color: INTERACT_TEXT_WEAK_ACTIVE2,
    outline: `2px solid ${CONTROL_BORDER_ACTIVE5}`,
    // selected outlines need priority
    zIndex: 1
  })
};

// Toggle/Toggle.tsx
var import_jsx_runtime550 = require("react/jsx-runtime");
var Toggle2 = import_uik769.utils.forwardRef(
  ({
    children: rawChildren = [],
    className: className2,
    multiselect = false,
    onSelectedChange,
    selected: maybeSelected,
    ...inherited
  }, ref) => {
    const [rawSelected, setRawSelected] = (0, import_react142.useState)(() => maybeSelected ? [maybeSelected].flat() : []);
    const selected = maybeSelected === void 0 ? rawSelected : [maybeSelected].flat();
    const children = import_react142.Children.toArray(rawChildren).filter(import_react142.isValidElement).filter((child) => child.type === import_uik769.Button).map(
      (child, i, { length, [i - 1]: previous, [i + 1]: next }) => (
        // TODO This won't work in v1+
        (0, import_react142.cloneElement)(child, {
          className: (0, import_uik769.css)(
            CHILD,
            i === 0 && FIRST,
            i === length - 1 && LAST,
            previous && NOT_FIRST,
            next && NOT_LAST,
            selected.includes(i) && SELECTED,
            child.props.className
          ),
          onClick: (e) => {
            const cases = {
              MULTIPLE: () => ({
                changed: true,
                nextSelected: selected.includes(i) ? selected.filter((x) => x !== i) : [...selected, i]
              }),
              SINGLE: () => ({
                changed: i !== selected[0],
                nextSelected: [i]
              })
            };
            const { changed, nextSelected } = cases[multiselect || length === 1 ? "MULTIPLE" : "SINGLE"]();
            if (changed) {
              setRawSelected(nextSelected);
              onSelectedChange?.(nextSelected);
            }
            child.props.onClick?.(e);
          },
          type: "SECONDARY"
        })
      )
    );
    return /* @__PURE__ */ (0, import_jsx_runtime550.jsx)("div", { className: (0, import_uik769.css)(HOST13, ...import_uik769.utils.many(className2)), ref, uik: "Toggle", ...inherited, children });
  }
);
Toggle2.displayName = "Toggle";
Toggle2.__DEV_METADATA__ = { status: "READY" };
var { CHILD, FIRST, HOST: HOST13, LAST, NOT_FIRST, NOT_LAST, SELECTED } = STYLES46;

// Uik/Uik.tsx
var import_uik771 = require("@appd/uik");
var import_future = require("@appd/uik/@future");

// Uik/withSsr.ts
var import_uik770 = require("@appd/uik");
var withSsr3 = /* @__PURE__ */ __name((renderPage, options) => import_uik770.css.withSsr(() => import_uik770.format.message.withSsr(renderPage, options)), "withSsr");

// Uik/Uik.tsx
var import_jsx_runtime551 = require("react/jsx-runtime");
var Uik = /* @__PURE__ */ __name(({ children, ...flags }) => {
  Object.entries(flags).forEach(([flag, value]) => value != null && Uik[flag].set(value));
  return /* @__PURE__ */ (0, import_jsx_runtime551.jsx)(import_uik771.css.Provider, { children: /* @__PURE__ */ (0, import_jsx_runtime551.jsxs)(import_uik771.Overlay.Provider, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime551.jsx)(import_uik771.toast.Provider, {}),
    /* @__PURE__ */ (0, import_jsx_runtime551.jsx)(import_uik771.Cartesian.Provider, { children: /* @__PURE__ */ (0, import_jsx_runtime551.jsx)(import_future.TimeRangeSelector.Provider, { children }) })
  ] }) });
}, "Uik");
Uik.assetsPath = ASSETS_PATH;
Uik.displayName = "Uik";
Uik.locale = format.LOCALE;
Uik.timeZone = format.TIME_ZONE;
Uik.withSsr = withSsr3;

// Wizard/Wizard.tsx
var import_uik780 = require("@appd/uik");
var import_react147 = require("react");

// Wizard/CONTEXT.ts
var import_uik772 = require("@appd/uik");
var import_react143 = require("react");
var CONTEXT12;
((CONTEXT13) => {
  CONTEXT13.NavigationButton = (0, import_react143.createContext)({
    isLast: false,
    onClick: import_uik772.utils.noop,
    size: "COMPACT",
    state: "ACTIVE",
    stepIndex: 0,
    title: ""
  });
  CONTEXT13.Step = (0, import_react143.createContext)({
    isActive: false,
    isVisited: false,
    stepChange: {
      incoming: 0,
      outgoing: 0
    },
    stepIndex: 0
  });
})(CONTEXT12 || (CONTEXT12 = {}));

// Wizard/getStepProps.ts
var getStepProps = /* @__PURE__ */ __name((children) => ({
  rawRequired: children.map(({ child: { props: { required = false } = {} } }) => required),
  rawValidate: children.map(({ child: { props: { validate = /* @__PURE__ */ __name(() => {
  }, "validate") } = {} } }) => validate),
  rawVisited: children.map(({ child: { props: { visited = false } = {} } }) => visited)
}), "getStepProps");

// Wizard/getStyles.ts
var import_uik773 = require("@appd/uik");
var {
  COLORS: { INTERACT_BORDER_WEAK: INTERACT_BORDER_WEAK3 },
  SPACING: SPACING56
} = import_uik773.MAGNETIC_TOKENS;
var getStyles44 = /* @__PURE__ */ __name((vertical) => ({
  CONTROL: (0, import_uik773.css)({
    "> button": { marginLeft: SPACING56[5] },
    display: "flex",
    justifyContent: "flex-end",
    padding: SPACING56[6]
  }),
  HOST: (0, import_uik773.css)({ display: "block" }),
  NAVIGATION_BAR: (0, import_uik773.css)({
    ...vertical ? {
      borderRight: `1px solid ${INTERACT_BORDER_WEAK3}`,
      flexDirection: "column",
      margin: 0,
      minWidth: 320,
      paddingBlock: SPACING56[6],
      paddingLeft: SPACING56[6]
    } : {
      flexDirection: "column",
      margin: `${SPACING56[5]}px ${SPACING56[5]}px 0px ${SPACING56[5]}px`
    },
    display: "flex"
  }),
  NAVIGATION_BAR_BUTTON_SCROLL: (0, import_uik773.css)({ flexDirection: vertical ? "column" : "row" }),
  VERTICAL_CONTAINER: (0, import_uik773.css)({
    display: "flex",
    flexDirection: "row",
    margin: 0
  }),
  VERTICAL_RIGHT_PANE: (0, import_uik773.css)({ flexGrow: 1 })
}), "getStyles");

// Wizard/MESSAGES.ts
var import_uik774 = require("@appd/uik");
var MESSAGES22 = {
  CANCEL: import_uik774.format.message`Cancel`.description("A button to cancel the Wizard Step."),
  NEXT: import_uik774.format.message`Next`.description("A button to go to the next Wizard Step."),
  PREVIOUS: import_uik774.format.message`Previous`.description("A button to return to the previous Wizard Step."),
  SUBMIT: import_uik774.format.message`Submit`.description("A button to submit the Wizard Step."),
  VALIDATING: import_uik774.format.message`VALIDATING`.description(
    "A button that indicates the current Wizard Step is being validated."
  )
};

// Wizard/NavigationButton/NavigationButton.tsx
var import_uik776 = require("@appd/uik");
var import_react144 = require("react");

// Wizard/NavigationButton/getStyles.ts
var import_uik775 = require("@appd/uik");
var {
  COLORS: {
    DEFAULT_TEXT: DEFAULT_TEXT38,
    DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM24,
    DEFAULT_TEXT_WEAK: DEFAULT_TEXT_WEAK5,
    INTERACT_BG_MEDIUM,
    INTERACT_BORDER_MEDIUM: INTERACT_BORDER_MEDIUM3,
    INTERACT_BORDER_MEDIUM_ACTIVE: INTERACT_BORDER_MEDIUM_ACTIVE3,
    INTERACT_BORDER_MEDIUM_HOVER,
    INTERACT_BORDER_WEAK: INTERACT_BORDER_WEAK4,
    INTERACT_TEXT: INTERACT_TEXT5,
    INTERACT_TEXT_HOVER,
    INTERACT_TEXT_IN: INTERACT_TEXT_IN4,
    NEGATIVE_TEXT: NEGATIVE_TEXT3
  },
  EFFECTS: { TRANSITION: TRANSITION2 },
  RADIUS: RADIUS31,
  SPACING: SPACING57,
  TYPOGRAPHY: { P3_EMPHASIS: P3_EMPHASIS14, P4_DEFAULT: P4_DEFAULT15 }
} = import_uik775.MAGNETIC_TOKENS;
var getStyles45 = /* @__PURE__ */ __name(({
  size,
  state,
  vertical
}) => ({
  DESCRIPTION: (0, import_uik775.css)({
    display: "flex",
    maxWidth: 250,
    minWidth: 125,
    paddingLeft: SPACING57[3],
    width: "max-content"
  }),
  DESCRIPTION_TEXT: (0, import_uik775.css)(
    { all: "initial" },
    {
      color: DESCRIPTION_STATE_COLOR[state],
      font: P4_DEFAULT15
    }
  ),
  DIVIDER: (0, import_uik775.css)({
    backgroundColor: state === "COMPLETED" ? INTERACT_BORDER_MEDIUM3 : INTERACT_BORDER_WEAK4,
    display: vertical ? "none" : "block",
    flexGrow: 1,
    height: 1,
    marginTop: 11,
    minWidth: 60
  }),
  HOST: (0, import_uik775.css)({
    "&:hover": {
      ...(state === "COMPLETED" || state === "NOT_VISITED_OPTIONAL") && {
        '> [uik="Wizard.NavigationButton.Content"] > :first-child > div': {
          color: INTERACT_TEXT_HOVER,
          transition: TRANSITION2
        }
      },
      ...state !== "ACTIVE" && {
        '> [uik="Wizard.NavigationButton.Content"] > * > div': { cursor: "pointer" },
        borderRight: vertical && `3px solid ${INTERACT_BORDER_MEDIUM_HOVER}`,
        cursor: "pointer",
        transition: TRANSITION2
      }
    },
    borderRight: vertical && `3px solid ${state === "ACTIVE" ? INTERACT_BORDER_MEDIUM_ACTIVE3 : "transparent"}`,
    display: "flex",
    flexBasis: 0,
    flexDirection: "row",
    flexGrow: 1,
    flexShrink: 1,
    marginBottom: SPACING57[2],
    paddingBlock: SPACING57[1],
    paddingRight: SPACING57[3],
    transition: TRANSITION2
  }),
  STEP_CONTENT: (0, import_uik775.css)({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1
  }),
  STEP_NUM_OR_ICON: (0, import_uik775.css)({
    ...size === "NORMAL" && {
      height: 28,
      minWidth: 28,
      width: 28
    },
    ...size === "COMPACT" && {
      height: 24,
      minWidth: 24,
      width: 24
    },
    ...state === "ACTIVE" && {
      "& > span": {
        color: INTERACT_TEXT_IN4,
        font: P3_EMPHASIS14
      },
      backgroundColor: INTERACT_BG_MEDIUM
    },
    ...state === "COMPLETED" && {
      "& > svg": {
        "& path, & > path[fill='#fff']": { fill: INTERACT_BG_MEDIUM },
        width: 16
      },
      border: `2px solid ${INTERACT_BG_MEDIUM}`
    },
    ...state === "ERROR" && {
      "& > svg": {
        "& path, & path[fill='#fff']": { fill: NEGATIVE_TEXT3 },
        height: 36,
        width: 36
      },
      height: 36,
      margin: -4,
      width: 36
    },
    ...state === "NOT_VISITED_OPTIONAL" && {
      "> span": {
        color: DEFAULT_TEXT_MEDIUM24,
        font: P3_EMPHASIS14
      },
      border: `2px solid ${INTERACT_BORDER_WEAK4}`
    },
    ...state === "NOT_VISITED_REQUIRED" && {
      "> span": {
        color: DEFAULT_TEXT_MEDIUM24,
        font: P3_EMPHASIS14
      },
      border: `2px solid ${INTERACT_BORDER_WEAK4}`
    },
    alignItems: "center",
    borderRadius: RADIUS31.FULL,
    boxSizing: "border-box",
    display: "flex",
    justifyContent: "center"
  }),
  TITLE: (0, import_uik775.css)({
    display: "flex",
    flexDirection: "row",
    paddingTop: SPACING57[1]
  }),
  TITLE_TEXT: (0, import_uik775.css)(
    { all: "initial" },
    {
      color: TITLE_STATE_COLOR[state],
      font: P3_EMPHASIS14,
      marginInline: SPACING57[3],
      maxWidth: 250,
      minWidth: 125
    }
  )
}), "getStyles");
var DESCRIPTION_STATE_COLOR = {
  ACTIVE: DEFAULT_TEXT_MEDIUM24,
  COMPLETED: DEFAULT_TEXT_MEDIUM24,
  ERROR: NEGATIVE_TEXT3,
  LOADING: DEFAULT_TEXT_MEDIUM24,
  NOT_VISITED_OPTIONAL: DEFAULT_TEXT_MEDIUM24,
  NOT_VISITED_REQUIRED: DEFAULT_TEXT_WEAK5
};
var TITLE_STATE_COLOR = {
  ACTIVE: INTERACT_TEXT5,
  COMPLETED: DEFAULT_TEXT38,
  ERROR: NEGATIVE_TEXT3,
  LOADING: DEFAULT_TEXT38,
  NOT_VISITED_OPTIONAL: DEFAULT_TEXT_MEDIUM24,
  NOT_VISITED_REQUIRED: DEFAULT_TEXT_WEAK5
};

// Wizard/NavigationButton/NavigationButton.tsx
var import_jsx_runtime552 = require("react/jsx-runtime");
var iconSize = 32;
var NavigationButton = /* @__PURE__ */ __name(({ description, vertical }) => {
  const { isLast, onClick, size, state, stepIndex, title } = (0, import_react144.useContext)(CONTEXT12.NavigationButton);
  const { DESCRIPTION: DESCRIPTION3, DESCRIPTION_TEXT, DIVIDER, HOST: HOST14, STEP_CONTENT, STEP_NUM_OR_ICON, TITLE: TITLE4, TITLE_TEXT } = getStyles45(
    {
      size,
      state,
      vertical
    }
  );
  const stepNumOrIcon = {
    ACTIVE: /* @__PURE__ */ (0, import_jsx_runtime552.jsx)("span", { children: stepIndex + 1 }),
    COMPLETED: /* @__PURE__ */ (0, import_jsx_runtime552.jsx)(import_uik776.Icon.Action.Enable, {}),
    ERROR: /* @__PURE__ */ (0, import_jsx_runtime552.jsx)(import_uik776.Icon.Status.Error, { height: iconSize, width: iconSize }),
    LOADING: /* @__PURE__ */ (0, import_jsx_runtime552.jsx)(import_uik776.Spinner, { size: "SMALL" }),
    NOT_VISITED_OPTIONAL: /* @__PURE__ */ (0, import_jsx_runtime552.jsx)("span", { children: stepIndex + 1 }),
    NOT_VISITED_REQUIRED: /* @__PURE__ */ (0, import_jsx_runtime552.jsx)("span", { children: stepIndex + 1 })
  }[state];
  return /* @__PURE__ */ (0, import_jsx_runtime552.jsxs)("div", { className: HOST14, onClick, children: [
    /* @__PURE__ */ (0, import_jsx_runtime552.jsx)("div", { className: STEP_NUM_OR_ICON, children: stepNumOrIcon }),
    /* @__PURE__ */ (0, import_jsx_runtime552.jsxs)("div", { className: STEP_CONTENT, uik: "Wizard.NavigationButton.Content", children: [
      /* @__PURE__ */ (0, import_jsx_runtime552.jsxs)("div", { className: TITLE4, children: [
        /* @__PURE__ */ (0, import_jsx_runtime552.jsx)(import_uik776.Tooltip, { showOnOverflowOnly: true, value: title, children: /* @__PURE__ */ (0, import_jsx_runtime552.jsx)("div", { className: TITLE_TEXT, children: title }) }),
        !isLast && /* @__PURE__ */ (0, import_jsx_runtime552.jsx)("div", { className: DIVIDER })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime552.jsx)("div", { className: DESCRIPTION3, children: description && /* @__PURE__ */ (0, import_jsx_runtime552.jsx)(import_uik776.Tooltip, { showOnOverflowOnly: true, value: description, children: /* @__PURE__ */ (0, import_jsx_runtime552.jsx)("div", { className: DESCRIPTION_TEXT, children: description }) }) })
    ] })
  ] });
}, "NavigationButton");
NavigationButton.displayName = "Wizard.NavigationButton";

// Wizard/REDUCERS/REDUCERS.ts
var REDUCERS3 = /* @__PURE__ */ __name(({ rawRequired, rawVisited }) => ({
  $INITIAL_STATE: {
    errors: [...Array(rawVisited.length).fill(null)],
    fetching: [...Array(rawVisited.length).fill(false)],
    required: rawRequired,
    valid: [...Array(rawVisited.length).fill(false)],
    values: {},
    visited: rawVisited
  },
  ON_STEP_PROPS_CHANGE: ({ ...old }, { rawRequired: rawRequired2, rawVisited: rawVisited2 }) => ({
    ...old,
    required: rawRequired2,
    visited: rawVisited2
  }),
  SET_FETCHING: ({ fetching: oldFetching, ...old }, { fetching, stepIndex }) => ({
    ...old,
    fetching: [...oldFetching.slice(0, stepIndex), fetching, ...oldFetching.slice(stepIndex + 1)]
  }),
  SET_VALID_AND_ERRORS: ({ errors: oldErrors, valid, values: previousValues, ...old }, { errors, stepIndex, values }) => ({
    ...old,
    errors: [...oldErrors.slice(0, stepIndex), errors, ...oldErrors.slice(stepIndex + 1)],
    valid: [...valid.slice(0, stepIndex), !errors.length, ...valid.slice(stepIndex + 1)],
    values: errors.length ? previousValues : {
      ...previousValues,
      ...values
    }
  })
}), "REDUCERS");

// Wizard/Step/Step.tsx
var import_uik778 = require("@appd/uik");
var import_react145 = require("react");

// Wizard/Step/getStyles.ts
var import_uik777 = require("@appd/uik");
var { SPACING: SPACING58 } = import_uik777.MAGNETIC_TOKENS;
var getStyles46 = /* @__PURE__ */ __name((isActive) => ({
  FORM: (0, import_uik777.css)({
    // `element.focus()` can not interact with `display: "none"` or `visibility: "hidden"`
    ...!isActive && {
      left: -import_uik777.utils.CSS_MAX_NUMBER,
      opacity: 0,
      overflow: "hidden",
      pointerEvents: "none",
      position: "absolute",
      userSelect: "none"
    },
    padding: SPACING58[6]
  })
}), "getStyles");

// Wizard/Step/Step.tsx
var import_jsx_runtime553 = require("react/jsx-runtime");
var Step = import_uik778.utils.forwardRef(
  ({
    children,
    className: className2,
    name,
    onEnter,
    onLeave,
    validate: __HANDLED_IN_WIZARD__,
    visited: __HANDLED_IN_WIZARD_1__,
    ...props2
  }, maybeRef) => {
    const {
      isActive,
      stepChange: { incoming, outgoing },
      stepIndex
    } = (0, import_react145.useContext)(CONTEXT12.Step);
    const { FORM } = getStyles46(isActive);
    const ref = import_uik778.utils.useBroadcastRef(maybeRef);
    (0, import_react145.useEffect)(() => {
      if (incoming === outgoing) {
        return;
      } else if (stepIndex === incoming) {
        onEnter?.(outgoing);
      } else if (stepIndex === outgoing) {
        onLeave?.(incoming);
      }
    }, [incoming, stepIndex]);
    return /* @__PURE__ */ (0, import_jsx_runtime553.jsx)(import_uik778.Form, { className: (0, import_uik778.css)(FORM, ...import_uik778.utils.many(className2)), name, ref, uik: "Wizard.Step", ...props2, children });
  }
);
Step.displayName = "Wizard.Step";

// Wizard/validateAndIndex.ts
var import_uik779 = require("@appd/uik");
var import_react146 = require("react");
var validateAndIndex = /* @__PURE__ */ __name((rawChildren) => import_react146.Children.toArray(rawChildren).filter(import_react146.isValidElement).filter(({ type }) => type === Step).map((child, stepIndex) => {
  const rawRef = child.ref;
  const childRef = import_uik779.utils.useBroadcastRef(rawRef);
  return {
    child: (0, import_react146.cloneElement)(child, { ref: childRef }),
    ref: childRef,
    stepIndex
  };
}), "validateAndIndex");

// Wizard/Wizard.tsx
var import_jsx_runtime554 = require("react/jsx-runtime");
var Wizard = Object.assign(
  import_uik780.utils.forwardRef(
    ({
      blockOnError,
      children: rawChildren,
      className: className2,
      controlsVisible = true,
      footer,
      hideCancelButton = false,
      hideSubmitButton = false,
      onCancel,
      onStepChange,
      onSubmit,
      size = "COMPACT",
      step: maybeStep,
      vertical = true,
      ...props2
    }, ref) => {
      const { CONTROL, HOST: HOST14, NAVIGATION_BAR, NAVIGATION_BAR_BUTTON_SCROLL, VERTICAL_CONTAINER, VERTICAL_RIGHT_PANE } = getStyles44(vertical);
      const [rawStep, setRawStep] = (0, import_react147.useState)(
        /* default */
        0
      );
      const [stepChange, setStepChange] = (0, import_react147.useState)({
        incoming: 0,
        outgoing: 0
      });
      const step = maybeStep ?? rawStep;
      const children = validateAndIndex(rawChildren);
      const { rawRequired, rawValidate, rawVisited } = getStepProps(children);
      const [{ errors, fetching, required, valid, values, visited }, setState] = import_uik780.utils.useReducer(
        REDUCERS3({
          rawRequired,
          rawVisited
        })
      );
      (0, import_react147.useEffect)(() => {
        setState("ON_STEP_PROPS_CHANGE", {
          rawRequired,
          rawVisited
        });
      }, [JSON.stringify(rawRequired), JSON.stringify(rawVisited)]);
      const hasPreviousStep = step > 0;
      const hasNextStep = step < children.length - 1;
      const toStep = /* @__PURE__ */ __name(async (nextStep) => {
        const errors2 = await validateStep(step);
        if (blockOnError && errors2?.length > 0) {
          return;
        }
        onStepChange?.(nextStep, step, errors2);
        setStepChange({
          incoming: nextStep,
          outgoing: step
        });
        setRawStep(nextStep);
        children[nextStep].ref.current?.addEventListener("focusout", () => validateStep(nextStep));
        children[step].ref.current?.removeEventListener("focusout", () => validateStep(step));
        children[step].ref.current?.requestSubmit?.();
        if (children[step].ref.current instanceof HTMLFormElement) {
          import_uik780.utils.IS_DEV_MODE && console.warn("Unexpected `<Form>` found outside of `<Wizard>`, please check your implementation.");
        }
      }, "toStep");
      const validateStep = /* @__PURE__ */ __name(async (validatedStep) => {
        const child = children[validatedStep].ref.current;
        if (child == void 0) {
          return [];
        }
        const { errors: rawErrors, values: values2 } = import_uik780.Form.getSnapshot(child);
        const validateResult = rawValidate[validatedStep]?.(values2, rawErrors);
        if (validateResult instanceof Promise) {
          setState("SET_FETCHING", {
            fetching: true,
            stepIndex: validatedStep
          });
        }
        const validateValue = await validateResult;
        const errors2 = validateValue && validateValue.length > 0 ? validateValue : rawErrors;
        setState("SET_VALID_AND_ERRORS", {
          errors: errors2,
          stepIndex: validatedStep,
          values: values2
        });
        setState("SET_FETCHING", {
          fetching: false,
          stepIndex: validatedStep
        });
        return errors2;
      }, "validateStep");
      const submit = /* @__PURE__ */ __name(async () => {
        const errors2 = await validateStep(step);
        if (errors2?.length > 0) {
          return;
        }
        onSubmit?.(values, []);
      }, "submit");
      const getLastNavigatableStep = (0, import_react147.useCallback)(
        () => (
          // Find the next not visited "required" step
          visited.findIndex(
            (isVisited, stepIndex) => stepIndex === visited.length - 1 ? (
              // No steps are `required` but `invalid` and `unvisited`.
              stepIndex
            ) : (
              // Skip all previous steps and ignore all steps marked as "visited"
              stepIndex >= step && required[stepIndex] && !valid[stepIndex] && !isVisited
            )
          )
        ),
        [required, step, valid, visited]
      );
      const isStepUnblocked = /* @__PURE__ */ __name((stepNum) => (
        /**
         * Only keep those required steps which are after the last visited step.
         * For example,
         * [step 1: visited, step 2: visited, step 3: visited, step 4: required, step 5: required]
         * User should be able to navigate to step 4 without restriction.
         * But step 5 can not be navigate until step 4 is valid since it's a required step.
         */
        // No required steps
        !required.some(Boolean) || // The step is before or equal to the next required step
        stepNum <= getLastNavigatableStep()
      ), "isStepUnblocked");
      const getButtonState = /* @__PURE__ */ __name((stepIndex) => {
        if (fetching[stepIndex]) {
          return "LOADING";
        }
        if (step === stepIndex) {
          return "ACTIVE";
        }
        if (errors[stepIndex]?.length > 0) {
          return "ERROR";
        }
        if (valid[stepIndex]) {
          return "COMPLETED";
        }
        if (required[stepIndex]) {
          return "NOT_VISITED_REQUIRED";
        }
        return "NOT_VISITED_OPTIONAL";
      }, "getButtonState");
      const navigationButtons = (
        // The additional <div> is to fix a "refresh" glitch when mouse first enter `<ResizeBox>` which wrap Wizard
        /* @__PURE__ */ (0, import_jsx_runtime554.jsx)("div", { className: (0, import_uik780.css)(NAVIGATION_BAR), children: /* @__PURE__ */ (0, import_jsx_runtime554.jsx)(
          import_uik780.ButtonScroll,
          {
            className: (0, import_uik780.css)(NAVIGATION_BAR_BUTTON_SCROLL),
            onLeftClick: () => toStep(step - 1),
            onRightClick: () => toStep(step + 1),
            children: children.map(({ child: { props: props3 }, stepIndex }, i, { length }) => /* @__PURE__ */ (0, import_jsx_runtime554.jsx)(
              CONTEXT12.NavigationButton.Provider,
              {
                value: {
                  isLast: stepIndex === length - 1,
                  onClick: () => {
                    if (isStepUnblocked(stepIndex) && stepIndex !== step) {
                      toStep(stepIndex);
                    }
                  },
                  size,
                  state: getButtonState(stepIndex),
                  stepIndex,
                  title: props3?.name
                },
                children: /* @__PURE__ */ (0, import_jsx_runtime554.jsx)(NavigationButton, { vertical, ...props3 })
              },
              i
            ))
          }
        ) })
      );
      const control = controlsVisible ? /* @__PURE__ */ (0, import_jsx_runtime554.jsxs)("div", { className: (0, import_uik780.css)(CONTROL), children: [
        /* @__PURE__ */ (0, import_jsx_runtime554.jsx)(import_uik780.Button, { disabled: !hasPreviousStep, onClick: () => toStep(step - 1), type: "SECONDARY", children: footer?.previous ?? MESSAGES22.PREVIOUS() }),
        !hideCancelButton && /* @__PURE__ */ (0, import_jsx_runtime554.jsx)(import_uik780.Button, { onClick: onCancel, type: "SECONDARY", children: footer?.cancel ?? MESSAGES22.CANCEL() }),
        hasNextStep ? /* @__PURE__ */ (0, import_jsx_runtime554.jsx)(import_uik780.Button, { disabled: !isStepUnblocked(step + 1), onClick: () => toStep(step + 1), type: "PRIMARY", children: footer?.next ?? MESSAGES22.NEXT() }) : fetching.slice(-1).pop() ? /* @__PURE__ */ (0, import_jsx_runtime554.jsx)(import_uik780.Button, { disabled: true, type: "PRIMARY", children: MESSAGES22.VALIDATING() }) : !hideSubmitButton && /* @__PURE__ */ (0, import_jsx_runtime554.jsx)(import_uik780.Button, { onClick: submit, type: "PRIMARY", children: footer?.submit ?? MESSAGES22.SUBMIT() })
      ] }) : null;
      const activeOrVisitedSteps = children.map(({ child, stepIndex }, i) => /* @__PURE__ */ (0, import_jsx_runtime554.jsx)(
        CONTEXT12.Step.Provider,
        {
          value: {
            isActive: step === stepIndex,
            isVisited: visited[stepIndex],
            stepChange,
            stepIndex
          },
          children: child
        },
        i
      ));
      return /* @__PURE__ */ (0, import_jsx_runtime554.jsx)("div", { className: (0, import_uik780.css)(HOST14, ...import_uik780.utils.many(className2)), ref, uik: "Wizard", ...props2, children: vertical ? /* @__PURE__ */ (0, import_jsx_runtime554.jsxs)("div", { className: (0, import_uik780.css)(VERTICAL_CONTAINER), children: [
        navigationButtons,
        /* @__PURE__ */ (0, import_jsx_runtime554.jsxs)("div", { className: (0, import_uik780.css)(VERTICAL_RIGHT_PANE), children: [
          activeOrVisitedSteps,
          control
        ] })
      ] }) : /* @__PURE__ */ (0, import_jsx_runtime554.jsxs)(import_jsx_runtime554.Fragment, { children: [
        navigationButtons,
        activeOrVisitedSteps,
        control
      ] }) });
    }
  ),
  { Step }
);
Wizard.displayName = "Wizard";
Wizard.__DEV_METADATA__ = { status: "READY" };
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Banner,
  Button,
  ButtonScroll,
  Card,
  Cartesian,
  Checkbox,
  CodeEditor,
  CodeSnippet,
  Collapse,
  DatePicker,
  DateTimePicker,
  Dialog,
  Drawer,
  Dropdown,
  Expander,
  FEATURE_FLAG_LIGHT_THEME,
  FlowMap,
  FocusManager,
  Form,
  Grid,
  Heading,
  HealthBar,
  Icon,
  Illustration,
  Input,
  Layout,
  Legend,
  List,
  Loading,
  Lookup,
  MAGNETIC_TOKENS,
  MONACO,
  Measurer,
  Menu,
  Overlay,
  Pill,
  Popover,
  QuickFilter,
  Radio,
  Repeater,
  ResizeBox,
  ScrollBox,
  SearchBox,
  Select,
  SelectionTile,
  Slider,
  SparkGraph,
  Spinner,
  TOKENS,
  TabList,
  Tag,
  Textarea,
  ThemeSwitch,
  TimePicker,
  TimeRangeSelector,
  TimelineBar,
  Toggle,
  ToggleSwitch,
  Tooltip,
  Uik,
  Wizard,
  css,
  format,
  toast,
  utils
});
//# sourceMappingURL=uik.js.map
